var $A = function(r, e) {
  return $A = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
  }, $A(r, e);
};
function bo(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  $A(r, e);
  function t() {
    this.constructor = r;
  }
  r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var Fe = function() {
  return Fe = Object.assign || function(e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      t = arguments[n];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Fe.apply(this, arguments);
};
function Bl(r, e) {
  var t = {};
  for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}
function Il(r, e, t, n) {
  function i(a) {
    return a instanceof t ? a : new t(function(s) {
      s(a);
    });
  }
  return new (t || (t = Promise))(function(a, s) {
    function o(c) {
      try {
        u(n.next(c));
      } catch (h) {
        s(h);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (h) {
        s(h);
      }
    }
    function u(c) {
      c.done ? a(c.value) : i(c.value).then(o, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}
function Pl(r, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, s = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return s.next = o(0), s.throw = o(1), s.return = o(2), typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function o(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, u[0] && (t = 0)), t; ) try {
      if (n = 1, i && (a = u[0] & 2 ? i.return : u[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, u[1])).done) return a;
      switch (i = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
        case 0:
        case 1:
          a = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = u;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(u);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = a = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function vre(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Ys(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, a; n < i; n++)
    (a || !(n in e)) && (a || (a = Array.prototype.slice.call(e, 0, n)), a[n] = e[n]);
  return r.concat(a || Array.prototype.slice.call(e));
}
var Iv = "Invariant Violation", RC = Object.setPrototypeOf, W_ = RC === void 0 ? function(r, e) {
  return r.__proto__ = e, r;
} : RC, sF = (
  /** @class */
  (function(r) {
    bo(e, r);
    function e(t) {
      t === void 0 && (t = Iv);
      var n = r.call(this, typeof t == "number" ? Iv + ": " + t + " (see https://github.com/apollographql/invariant-packages)" : t) || this;
      return n.framesToPop = 1, n.name = Iv, W_(n, e.prototype), n;
    }
    return e;
  })(Error)
);
function Ef(r, e) {
  if (!r)
    throw new sF(e);
}
var oF = ["debug", "log", "warn", "error", "silent"], j_ = oF.indexOf("log");
function _g(r) {
  return function() {
    if (oF.indexOf(r) >= j_) {
      var e = console[r] || console.log;
      return e.apply(console, arguments);
    }
  };
}
(function(r) {
  r.debug = _g("debug"), r.log = _g("log"), r.warn = _g("warn"), r.error = _g("error");
})(Ef || (Ef = {}));
var sw = "3.14.1";
function jo(r) {
  try {
    return r();
  } catch {
  }
}
const s0 = jo(function() {
  return globalThis;
}) || jo(function() {
  return window;
}) || jo(function() {
  return self;
}) || jo(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
jo(function() {
  return jo.constructor("return this")();
});
var OC = /* @__PURE__ */ new Map();
function zA(r) {
  var e = OC.get(r) || 1;
  return OC.set(r, e + 1), "".concat(r, ":").concat(e, ":").concat(Math.random().toString(36).slice(2));
}
function q_(r, e) {
  var t = zA("stringifyForDisplay");
  return JSON.stringify(r, function(n, i) {
    return i === void 0 ? t : i;
  }, e).split(JSON.stringify(t)).join("<undefined>");
}
function Mg(r) {
  return function(e) {
    for (var t = [], n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
    if (typeof e == "number") {
      var i = e;
      e = ow(i), e || (e = lw(i, t), t = []);
    }
    r.apply(void 0, [e].concat(t));
  };
}
var _n = Object.assign(function(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++)
    n[i - 2] = arguments[i];
  e || Ef(e, ow(t, n) || lw(t, n));
}, {
  debug: Mg(Ef.debug),
  log: Mg(Ef.log),
  warn: Mg(Ef.warn),
  error: Mg(Ef.error)
});
function Ts(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  return new sF(ow(r, e) || lw(r, e));
}
var BC = /* @__PURE__ */ Symbol.for("ApolloErrorMessageHandler_" + sw);
function lF(r) {
  if (typeof r == "string")
    return r;
  try {
    return q_(r, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function ow(r, e) {
  if (e === void 0 && (e = []), !!r)
    return s0[BC] && s0[BC](r, e.map(lF));
}
function lw(r, e) {
  if (e === void 0 && (e = []), !!r)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: sw,
      message: r,
      args: e.map(lF)
    })));
}
function Om(r, e) {
  if (!!!r)
    throw new Error(e);
}
function Q_(r) {
  return typeof r == "object" && r !== null;
}
function Y_(r, e) {
  if (!!!r)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const X_ = /\r\n|[\n\r]/g;
function GA(r, e) {
  let t = 0, n = 1;
  for (const i of r.body.matchAll(X_)) {
    if (typeof i.index == "number" || Y_(!1), i.index >= e)
      break;
    t = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: e + 1 - t
  };
}
function J_(r) {
  return uF(
    r.source,
    GA(r.source, r.start)
  );
}
function uF(r, e) {
  const t = r.locationOffset.column - 1, n = "".padStart(t) + r.body, i = e.line - 1, a = r.locationOffset.line - 1, s = e.line + a, o = e.line === 1 ? t : 0, l = e.column + o, u = `${r.name}:${s}:${l}
`, c = n.split(/\r\n|[\n\r]/g), h = c[i];
  if (h.length > 120) {
    const f = Math.floor(l / 80), p = l % 80, m = [];
    for (let A = 0; A < h.length; A += 80)
      m.push(h.slice(A, A + 80));
    return u + _C([
      [`${s} |`, m[0]],
      ...m.slice(1, f + 1).map((A) => ["|", A]),
      ["|", "^".padStart(p)],
      ["|", m[f + 1]]
    ]);
  }
  return u + _C([
    // Lines specified like this: ["prefix", "string"],
    [`${s - 1} |`, c[i - 1]],
    [`${s} |`, h],
    ["|", "^".padStart(l)],
    [`${s + 1} |`, c[i + 1]]
  ]);
}
function _C(r) {
  const e = r.filter(([n, i]) => i !== void 0), t = Math.max(...e.map(([n]) => n.length));
  return e.map(([n, i]) => n.padStart(t) + (i ? " " + i : "")).join(`
`);
}
function K_(r) {
  const e = r[0];
  return e == null || "kind" in e || "length" in e ? {
    nodes: e,
    source: r[1],
    positions: r[2],
    path: r[3],
    originalError: r[4],
    extensions: r[5]
  } : e;
}
class uw extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /** An array of GraphQL AST Nodes corresponding to this error. */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /** Original error that caused this GraphQLError, if one exists. */
  /** Extension fields to add to the formatted error. */
  /**
   * Creates a GraphQLError instance.
   * @param message - Human-readable error message.
   * @param options - Error metadata such as source locations, response path, original error, and extensions.
   * This positional-arguments constructor overload is deprecated. Use the
   * `GraphQLError(message, options)` overload instead.
   * @example
   * ```ts
   * // Create an error from AST nodes and response metadata.
   * import { parse } from 'graphql/language';
   * import { GraphQLError } from 'graphql/error';
   *
   * const document = parse('{ greeting }');
   * const fieldNode = document.definitions[0].selectionSet.selections[0];
   * const error = new GraphQLError('Cannot query this field.', {
   *   nodes: fieldNode,
   *   path: ['greeting'],
   *   extensions: { code: 'FORBIDDEN' },
   * });
   *
   * error.message; // => 'Cannot query this field.'
   * error.locations; // => [{ line: 1, column: 3 }]
   * error.path; // => ['greeting']
   * error.extensions; // => { code: 'FORBIDDEN' }
   * ```
   * @example
   * ```ts
   * // This variant derives locations from source positions and preserves the original error.
   * import { Source } from 'graphql/language';
   * import { GraphQLError } from 'graphql/error';
   *
   * const source = new Source('{ greeting }');
   * const originalError = new Error('Database unavailable.');
   * const error = new GraphQLError('Resolver failed.', {
   *   source,
   *   positions: [2],
   *   path: ['greeting'],
   *   originalError,
   * });
   *
   * error.locations; // => [{ line: 1, column: 3 }]
   * error.path; // => ['greeting']
   * error.originalError; // => originalError
   * ```
   */
  /**
   * Creates a GraphQLError instance using the legacy positional constructor.
   * This deprecated overload will be removed in v17. Prefer the
   * `GraphQLErrorOptions` object overload, which keeps optional error metadata
   * in a single options bag.
   * @param message - Human-readable error message.
   * @param nodes - AST node or nodes associated with this error.
   * @param source - Source document used to derive error locations.
   * @param positions - Character offsets in the source document associated with
   * this error.
   * @param path - Response path where this error occurred during execution.
   * @param originalError - Original error that caused this GraphQLError, if one
   * exists.
   * @param extensions - Extension fields to include in the formatted error.
   * @example
   * ```ts
   * import { Source } from 'graphql/language';
   * import { GraphQLError } from 'graphql/error';
   *
   * const source = new Source('{ greeting }');
   * const originalError = new Error('Database unavailable.');
   * const error = new GraphQLError(
   *   'Resolver failed.',
   *   undefined,
   *   source,
   *   [2],
   *   ['greeting'],
   *   originalError,
   *   { code: 'INTERNAL' },
   * );
   *
   * error.locations; // => [{ line: 1, column: 3 }]
   * error.path; // => ['greeting']
   * error.originalError; // => originalError
   * error.extensions; // => { code: 'INTERNAL' }
   * ```
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(e, ...t) {
    var n, i, a;
    const { nodes: s, source: o, positions: l, path: u, originalError: c, extensions: h } = K_(t);
    super(e), this.name = "GraphQLError", this.path = u ?? void 0, this.originalError = c ?? void 0, this.nodes = MC(
      Array.isArray(s) ? s : s ? [s] : void 0
    );
    const f = MC(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((m) => m.loc).filter((m) => m != null)
    );
    this.source = o ?? (f == null || (i = f[0]) === null || i === void 0 ? void 0 : i.source), this.positions = l ?? f?.map((m) => m.start), this.locations = l && o ? l.map((m) => GA(o, m)) : f?.map((m) => GA(m.source, m.start));
    const p = Q_(
      c?.extensions
    ) ? c?.extensions : void 0;
    this.extensions = (a = h ?? p) !== null && a !== void 0 ? a : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), c != null && c.stack ? Object.defineProperty(this, "stack", {
      value: c.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, uw) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  /**
   * Returns this error as a human-readable message with source locations.
   * @returns The formatted error string.
   * @example
   * ```ts
   * import { Source } from 'graphql/language';
   * import { GraphQLError } from 'graphql/error';
   *
   * const error = new GraphQLError('Cannot query field "name".', {
   *   source: new Source('{ name }'),
   *   positions: [2],
   * });
   *
   * error.toString(); // => 'Cannot query field "name".\n\nGraphQL request:1:3\n1 | { name }\n  |   ^'
   * ```
   */
  toString() {
    let e = this.message;
    if (this.nodes)
      for (const t of this.nodes)
        t.loc && (e += `

` + J_(t.loc));
    else if (this.source && this.locations)
      for (const t of this.locations)
        e += `

` + uF(this.source, t);
    return e;
  }
  /**
   * Returns the JSON representation used when this object is serialized.
   * @returns The JSON-serializable representation.
   * @example
   * ```ts
   * import { GraphQLError } from 'graphql/error';
   *
   * const error = new GraphQLError('Resolver failed.', {
   *   path: ['viewer', 'name'],
   *   extensions: { code: 'INTERNAL' },
   * });
   *
   * error.toJSON(); // => { message: 'Resolver failed.', path: ['viewer', 'name'], extensions: { code: 'INTERNAL' } }
   * ```
   */
  toJSON() {
    const e = {
      message: this.message
    };
    return this.locations != null && (e.locations = this.locations), this.path != null && (e.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (e.extensions = this.extensions), e;
  }
}
function MC(r) {
  return r === void 0 || r.length === 0 ? void 0 : r;
}
function fa(r, e, t) {
  return new uw(`Syntax Error: ${t}`, {
    source: r,
    positions: [e]
  });
}
class Z_ {
  /** The character offset at which this Node begins. */
  /** The character offset at which this Node ends. */
  /** The Token at which this Node begins. */
  /** The Token at which this Node ends. */
  /** The Source document the AST represents. */
  /**
   * Creates a Location instance.
   * @param startToken - The start token.
   * @param endToken - The end token.
   * @param source - Source document used to derive error locations.
   * @example
   * ```ts
   * import { Location, Source, Token, TokenKind } from 'graphql/language';
   *
   * const source = new Source('{ hello }');
   * const startToken = new Token(TokenKind.BRACE_L, 0, 1, 1, 1);
   * const endToken = new Token(TokenKind.BRACE_R, 8, 9, 1, 9);
   * const location = new Location(startToken, endToken, source);
   *
   * location.start; // => 0
   * location.end; // => 9
   * location.source.body; // => '{ hello }'
   * ```
   */
  constructor(e, t, n) {
    this.start = e.start, this.end = t.end, this.startToken = e, this.endToken = t, this.source = n;
  }
  /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */
  get [Symbol.toStringTag]() {
    return "Location";
  }
  /**
   * Returns a JSON representation of this location.
   * @returns The JSON-serializable representation.
   * @example
   * ```ts
   * import { parse } from 'graphql/language';
   *
   * const document = parse('{ hello }');
   * const location = document.loc?.toJSON();
   *
   * location; // => { start: 0, end: 9 }
   * ```
   */
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
let cF = class {
  /** The kind of Token. */
  /** The character offset at which this Node begins. */
  /** The character offset at which this Node ends. */
  /** The 1-indexed line number on which this Token appears. */
  /** The 1-indexed column number at which this Token begins. */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  /** Next token in the token stream, including ignored tokens. */
  /**
   * Creates a Token instance.
   * @param kind - Token kind produced by lexical analysis.
   * @param start - Character offset where this token begins.
   * @param end - Character offset where this token ends.
   * @param line - One-indexed line number where this token begins.
   * @param column - One-indexed column number where this token begins.
   * @param value - Interpreted value for non-punctuation tokens.
   * @example
   * ```ts
   * import { Token, TokenKind } from 'graphql/language';
   *
   * const token = new Token(TokenKind.NAME, 2, 7, 1, 3, 'hello');
   *
   * token.kind; // => TokenKind.NAME
   * token.value; // => 'hello'
   * token.toJSON(); // => { kind: 'Name', value: 'hello', line: 1, column: 3 }
   * ```
   */
  constructor(e, t, n, i, a, s) {
    this.kind = e, this.start = t, this.end = n, this.line = i, this.column = a, this.value = s, this.prev = null, this.next = null;
  }
  /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */
  get [Symbol.toStringTag]() {
    return "Token";
  }
  /**
   * Returns a JSON representation of this token.
   * @returns The JSON-serializable representation.
   * @example
   * ```ts
   * import { Lexer, Source } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   * const token = lexer.advance().toJSON();
   *
   * token; // => { kind: '{', value: undefined, line: 1, column: 1 }
   * ```
   */
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
};
const fF = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "description",
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: [
    "description",
    "variable",
    "type",
    "defaultValue",
    "directives"
  ],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "description",
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: [
    "description",
    "name",
    "arguments",
    "directives",
    "locations"
  ],
  SchemaExtension: ["directives", "operationTypes"],
  DirectiveExtension: ["name", "directives"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"],
  TypeCoordinate: ["name"],
  MemberCoordinate: ["name", "memberName"],
  ArgumentCoordinate: ["name", "fieldName", "argumentName"],
  DirectiveCoordinate: ["name"],
  DirectiveArgumentCoordinate: ["name", "argumentName"]
}, eM = new Set(Object.keys(fF));
function NC(r) {
  const e = r?.kind;
  return typeof e == "string" && eM.has(e);
}
var xd;
(function(r) {
  r.QUERY = "query", r.MUTATION = "mutation", r.SUBSCRIPTION = "subscription";
})(xd || (xd = {}));
var HA;
(function(r) {
  r.QUERY = "QUERY", r.MUTATION = "MUTATION", r.SUBSCRIPTION = "SUBSCRIPTION", r.FIELD = "FIELD", r.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", r.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", r.INLINE_FRAGMENT = "INLINE_FRAGMENT", r.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", r.SCHEMA = "SCHEMA", r.SCALAR = "SCALAR", r.OBJECT = "OBJECT", r.FIELD_DEFINITION = "FIELD_DEFINITION", r.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", r.INTERFACE = "INTERFACE", r.UNION = "UNION", r.ENUM = "ENUM", r.ENUM_VALUE = "ENUM_VALUE", r.INPUT_OBJECT = "INPUT_OBJECT", r.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION", r.DIRECTIVE_DEFINITION = "DIRECTIVE_DEFINITION";
})(HA || (HA = {}));
var At;
(function(r) {
  r.NAME = "Name", r.DOCUMENT = "Document", r.OPERATION_DEFINITION = "OperationDefinition", r.VARIABLE_DEFINITION = "VariableDefinition", r.SELECTION_SET = "SelectionSet", r.FIELD = "Field", r.ARGUMENT = "Argument", r.FRAGMENT_SPREAD = "FragmentSpread", r.INLINE_FRAGMENT = "InlineFragment", r.FRAGMENT_DEFINITION = "FragmentDefinition", r.VARIABLE = "Variable", r.INT = "IntValue", r.FLOAT = "FloatValue", r.STRING = "StringValue", r.BOOLEAN = "BooleanValue", r.NULL = "NullValue", r.ENUM = "EnumValue", r.LIST = "ListValue", r.OBJECT = "ObjectValue", r.OBJECT_FIELD = "ObjectField", r.DIRECTIVE = "Directive", r.NAMED_TYPE = "NamedType", r.LIST_TYPE = "ListType", r.NON_NULL_TYPE = "NonNullType", r.SCHEMA_DEFINITION = "SchemaDefinition", r.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", r.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", r.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", r.FIELD_DEFINITION = "FieldDefinition", r.INPUT_VALUE_DEFINITION = "InputValueDefinition", r.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", r.UNION_TYPE_DEFINITION = "UnionTypeDefinition", r.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", r.ENUM_VALUE_DEFINITION = "EnumValueDefinition", r.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", r.DIRECTIVE_DEFINITION = "DirectiveDefinition", r.SCHEMA_EXTENSION = "SchemaExtension", r.DIRECTIVE_EXTENSION = "DirectiveExtension", r.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", r.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", r.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", r.UNION_TYPE_EXTENSION = "UnionTypeExtension", r.ENUM_TYPE_EXTENSION = "EnumTypeExtension", r.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension", r.TYPE_COORDINATE = "TypeCoordinate", r.MEMBER_COORDINATE = "MemberCoordinate", r.ARGUMENT_COORDINATE = "ArgumentCoordinate", r.DIRECTIVE_COORDINATE = "DirectiveCoordinate", r.DIRECTIVE_ARGUMENT_COORDINATE = "DirectiveArgumentCoordinate";
})(At || (At = {}));
function WA(r) {
  return r === 9 || r === 32;
}
function Up(r) {
  return r >= 48 && r <= 57;
}
function dF(r) {
  return r >= 97 && r <= 122 || // A-Z
  r >= 65 && r <= 90;
}
function hF(r) {
  return dF(r) || r === 95;
}
function tM(r) {
  return dF(r) || Up(r) || r === 95;
}
function rM(r) {
  var e;
  let t = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let s = 0; s < r.length; ++s) {
    var a;
    const o = r[s], l = nM(o);
    l !== o.length && (n = (a = n) !== null && a !== void 0 ? a : s, i = s, s !== 0 && l < t && (t = l));
  }
  return r.map((s, o) => o === 0 ? s : s.slice(t)).slice(
    (e = n) !== null && e !== void 0 ? e : 0,
    i + 1
  );
}
function nM(r) {
  let e = 0;
  for (; e < r.length && WA(r.charCodeAt(e)); )
    ++e;
  return e;
}
function iM(r, e) {
  const t = r.replace(/"""/g, '\\"""'), n = t.split(/\r\n|[\n\r]/g), i = n.length === 1, a = n.length > 1 && n.slice(1).every((p) => p.length === 0 || WA(p.charCodeAt(0))), s = t.endsWith('\\"""'), o = r.endsWith('"') && !s, l = r.endsWith("\\"), u = o || l, c = (
    // add leading and trailing new lines only if it improves readability
    !i || r.length > 70 || u || a || s
  );
  let h = "";
  const f = i && WA(r.charCodeAt(0));
  return (c && !f || a) && (h += `
`), h += t, (c || u) && (h += `
`), '"""' + h + '"""';
}
var Ge;
(function(r) {
  r.SOF = "<SOF>", r.EOF = "<EOF>", r.BANG = "!", r.DOLLAR = "$", r.AMP = "&", r.PAREN_L = "(", r.PAREN_R = ")", r.DOT = ".", r.SPREAD = "...", r.COLON = ":", r.EQUALS = "=", r.AT = "@", r.BRACKET_L = "[", r.BRACKET_R = "]", r.BRACE_L = "{", r.PIPE = "|", r.BRACE_R = "}", r.NAME = "Name", r.INT = "Int", r.FLOAT = "Float", r.STRING = "String", r.BLOCK_STRING = "BlockString", r.COMMENT = "Comment";
})(Ge || (Ge = {}));
class aM {
  /** Source document used to derive error locations. */
  /** Most recent non-ignored token returned by the lexer. */
  /** Current non-ignored token at the lexer cursor. */
  /** The (1-indexed) line containing the current token. */
  /** Character offset where the current line starts. */
  /**
   * Creates a Lexer instance.
   * @param source - Source document used to derive error locations.
   * @example
   * ```ts
   * import { Lexer, Source, TokenKind } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   *
   * lexer.token.kind; // => TokenKind.SOF
   * lexer.advance().kind; // => TokenKind.BRACE_L
   * lexer.advance().value; // => 'hello'
   * lexer.advance().kind; // => TokenKind.BRACE_R
   * ```
   */
  constructor(e) {
    const t = new cF(Ge.SOF, 0, 0, 0, 0);
    this.source = e, this.lastToken = t, this.token = t, this.line = 1, this.lineStart = 0;
  }
  /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   * @returns The next non-ignored token.
   * @example
   * ```ts
   * import { Lexer, Source } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   * const token = lexer.advance();
   *
   * token.kind; // => '{'
   * lexer.token; // => token
   * ```
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   * @returns The next non-ignored token without advancing the lexer.
   * @example
   * ```ts
   * import { Lexer, Source } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   * const token = lexer.lookahead();
   *
   * token.kind; // => '{'
   * lexer.token.kind; // => '<SOF>'
   * ```
   */
  lookahead() {
    let e = this.token;
    if (e.kind !== Ge.EOF)
      do
        if (e.next)
          e = e.next;
        else {
          const t = oM(this, e.end);
          e.next = t, t.prev = e, e = t;
        }
      while (e.kind === Ge.COMMENT);
    return e;
  }
}
function sM(r) {
  return r === Ge.BANG || r === Ge.DOLLAR || r === Ge.AMP || r === Ge.PAREN_L || r === Ge.PAREN_R || r === Ge.DOT || r === Ge.SPREAD || r === Ge.COLON || r === Ge.EQUALS || r === Ge.AT || r === Ge.BRACKET_L || r === Ge.BRACKET_R || r === Ge.BRACE_L || r === Ge.PIPE || r === Ge.BRACE_R;
}
function Qd(r) {
  return r >= 0 && r <= 55295 || r >= 57344 && r <= 1114111;
}
function R0(r, e) {
  return pF(r.charCodeAt(e)) && gF(r.charCodeAt(e + 1));
}
function pF(r) {
  return r >= 55296 && r <= 56319;
}
function gF(r) {
  return r >= 56320 && r <= 57343;
}
function Bf(r, e) {
  const t = r.source.body.codePointAt(e);
  if (t === void 0)
    return Ge.EOF;
  if (t >= 32 && t <= 126) {
    const n = String.fromCodePoint(t);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + t.toString(16).toUpperCase().padStart(4, "0");
}
function aa(r, e, t, n, i) {
  const a = r.line, s = 1 + t - r.lineStart;
  return new cF(e, t, n, a, s, i);
}
function oM(r, e) {
  const t = r.source.body, n = t.length;
  let i = e;
  for (; i < n; ) {
    const a = t.charCodeAt(i);
    switch (a) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 65279:
      // <BOM>
      case 9:
      // \t
      case 32:
      // <space>
      case 44:
        ++i;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"
      case 10:
        ++i, ++r.line, r.lineStart = i;
        continue;
      case 13:
        t.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++r.line, r.lineStart = i;
        continue;
      // Comment
      case 35:
        return lM(r, i);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
      case 33:
        return aa(r, Ge.BANG, i, i + 1);
      case 36:
        return aa(r, Ge.DOLLAR, i, i + 1);
      case 38:
        return aa(r, Ge.AMP, i, i + 1);
      case 40:
        return aa(r, Ge.PAREN_L, i, i + 1);
      case 41:
        return aa(r, Ge.PAREN_R, i, i + 1);
      case 46:
        if (t.charCodeAt(i + 1) === 46 && t.charCodeAt(i + 2) === 46)
          return aa(r, Ge.SPREAD, i, i + 3);
        break;
      case 58:
        return aa(r, Ge.COLON, i, i + 1);
      case 61:
        return aa(r, Ge.EQUALS, i, i + 1);
      case 64:
        return aa(r, Ge.AT, i, i + 1);
      case 91:
        return aa(r, Ge.BRACKET_L, i, i + 1);
      case 93:
        return aa(r, Ge.BRACKET_R, i, i + 1);
      case 123:
        return aa(r, Ge.BRACE_L, i, i + 1);
      case 124:
        return aa(r, Ge.PIPE, i, i + 1);
      case 125:
        return aa(r, Ge.BRACE_R, i, i + 1);
      // StringValue
      case 34:
        return t.charCodeAt(i + 1) === 34 && t.charCodeAt(i + 2) === 34 ? pM(r, i) : cM(r, i);
    }
    if (Up(a) || a === 45)
      return uM(r, i, a);
    if (hF(a))
      return gM(r, i);
    throw fa(
      r.source,
      i,
      a === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Qd(a) || R0(t, i) ? `Unexpected character: ${Bf(r, i)}.` : `Invalid character: ${Bf(r, i)}.`
    );
  }
  return aa(r, Ge.EOF, n, n);
}
function lM(r, e) {
  const t = r.source.body, n = t.length;
  let i = e + 1;
  for (; i < n; ) {
    const a = t.charCodeAt(i);
    if (a === 10 || a === 13)
      break;
    if (Qd(a))
      ++i;
    else if (R0(t, i))
      i += 2;
    else
      break;
  }
  return aa(
    r,
    Ge.COMMENT,
    e,
    i,
    t.slice(e + 1, i)
  );
}
function uM(r, e, t) {
  const n = r.source.body;
  let i = e, a = t, s = !1;
  if (a === 45 && (a = n.charCodeAt(++i)), a === 48) {
    if (a = n.charCodeAt(++i), Up(a))
      throw fa(
        r.source,
        i,
        `Invalid number, unexpected digit after 0: ${Bf(
          r,
          i
        )}.`
      );
  } else
    i = Pv(r, i, a), a = n.charCodeAt(i);
  if (a === 46 && (s = !0, a = n.charCodeAt(++i), i = Pv(r, i, a), a = n.charCodeAt(i)), (a === 69 || a === 101) && (s = !0, a = n.charCodeAt(++i), (a === 43 || a === 45) && (a = n.charCodeAt(++i)), i = Pv(r, i, a), a = n.charCodeAt(i)), a === 46 || hF(a))
    throw fa(
      r.source,
      i,
      `Invalid number, expected digit but got: ${Bf(
        r,
        i
      )}.`
    );
  return aa(
    r,
    s ? Ge.FLOAT : Ge.INT,
    e,
    i,
    n.slice(e, i)
  );
}
function Pv(r, e, t) {
  if (!Up(t))
    throw fa(
      r.source,
      e,
      `Invalid number, expected digit but got: ${Bf(
        r,
        e
      )}.`
    );
  const n = r.source.body;
  let i = e + 1;
  for (; Up(n.charCodeAt(i)); )
    ++i;
  return i;
}
function cM(r, e) {
  const t = r.source.body, n = t.length;
  let i = e + 1, a = i, s = "";
  for (; i < n; ) {
    const o = t.charCodeAt(i);
    if (o === 34)
      return s += t.slice(a, i), aa(r, Ge.STRING, e, i + 1, s);
    if (o === 92) {
      s += t.slice(a, i);
      const l = t.charCodeAt(i + 1) === 117 ? t.charCodeAt(i + 2) === 123 ? fM(r, i) : dM(r, i) : hM(r, i);
      s += l.value, i += l.size, a = i;
      continue;
    }
    if (o === 10 || o === 13)
      break;
    if (Qd(o))
      ++i;
    else if (R0(t, i))
      i += 2;
    else
      throw fa(
        r.source,
        i,
        `Invalid character within String: ${Bf(
          r,
          i
        )}.`
      );
  }
  throw fa(r.source, i, "Unterminated string.");
}
function fM(r, e) {
  const t = r.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const a = t.charCodeAt(e + i++);
    if (a === 125) {
      if (i < 5 || !Qd(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | fp(a), n < 0)
      break;
  }
  throw fa(
    r.source,
    e,
    `Invalid Unicode escape sequence: "${t.slice(
      e,
      e + i
    )}".`
  );
}
function dM(r, e) {
  const t = r.source.body, n = LC(t, e + 2);
  if (Qd(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (pF(n) && t.charCodeAt(e + 6) === 92 && t.charCodeAt(e + 7) === 117) {
    const i = LC(t, e + 8);
    if (gF(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw fa(
    r.source,
    e,
    `Invalid Unicode escape sequence: "${t.slice(e, e + 6)}".`
  );
}
function LC(r, e) {
  return fp(r.charCodeAt(e)) << 12 | fp(r.charCodeAt(e + 1)) << 8 | fp(r.charCodeAt(e + 2)) << 4 | fp(r.charCodeAt(e + 3));
}
function fp(r) {
  return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : -1;
}
function hM(r, e) {
  const t = r.source.body;
  switch (t.charCodeAt(e + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw fa(
    r.source,
    e,
    `Invalid character escape sequence: "${t.slice(
      e,
      e + 2
    )}".`
  );
}
function pM(r, e) {
  const t = r.source.body, n = t.length;
  let i = r.lineStart, a = e + 3, s = a, o = "";
  const l = [];
  for (; a < n; ) {
    const u = t.charCodeAt(a);
    if (u === 34 && t.charCodeAt(a + 1) === 34 && t.charCodeAt(a + 2) === 34) {
      o += t.slice(s, a), l.push(o);
      const c = aa(
        r,
        Ge.BLOCK_STRING,
        e,
        a + 3,
        // Return a string of the lines joined with U+000A.
        rM(l).join(`
`)
      );
      return r.line += l.length - 1, r.lineStart = i, c;
    }
    if (u === 92 && t.charCodeAt(a + 1) === 34 && t.charCodeAt(a + 2) === 34 && t.charCodeAt(a + 3) === 34) {
      o += t.slice(s, a), s = a + 1, a += 4;
      continue;
    }
    if (u === 10 || u === 13) {
      o += t.slice(s, a), l.push(o), u === 13 && t.charCodeAt(a + 1) === 10 ? a += 2 : ++a, o = "", s = a, i = a;
      continue;
    }
    if (Qd(u))
      ++a;
    else if (R0(t, a))
      a += 2;
    else
      throw fa(
        r.source,
        a,
        `Invalid character within String: ${Bf(
          r,
          a
        )}.`
      );
  }
  throw fa(r.source, a, "Unterminated string.");
}
function gM(r, e) {
  const t = r.source.body, n = t.length;
  let i = e + 1;
  for (; i < n; ) {
    const a = t.charCodeAt(i);
    if (tM(a))
      ++i;
    else
      break;
  }
  return aa(
    r,
    Ge.NAME,
    e,
    i,
    t.slice(e, i)
  );
}
const mM = 10, mF = 2;
function cw(r) {
  return O0(r, []);
}
function O0(r, e) {
  switch (typeof r) {
    case "string":
      return JSON.stringify(r);
    case "function":
      return r.name ? `[function ${r.name}]` : "[function]";
    case "object":
      return vM(r, e);
    default:
      return String(r);
  }
}
function vM(r, e) {
  if (r === null)
    return "null";
  if (e.includes(r))
    return "[Circular]";
  const t = [...e, r];
  if (yM(r)) {
    const n = r.toJSON();
    if (n !== r)
      return typeof n == "string" ? n : O0(n, t);
  } else if (Array.isArray(r))
    return wM(r, t);
  return AM(r, t);
}
function yM(r) {
  return typeof r.toJSON == "function";
}
function AM(r, e) {
  const t = Object.entries(r);
  return t.length === 0 ? "{}" : e.length > mF ? "[" + xM(r) + "]" : "{ " + t.map(
    ([i, a]) => i + ": " + O0(a, e)
  ).join(", ") + " }";
}
function wM(r, e) {
  if (r.length === 0)
    return "[]";
  if (e.length > mF)
    return "[Array]";
  const t = Math.min(mM, r.length), n = r.length - t, i = [];
  for (let a = 0; a < t; ++a)
    i.push(O0(r[a], e));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function xM(r) {
  const e = Object.prototype.toString.call(r).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof r.constructor == "function") {
    const t = r.constructor.name;
    if (typeof t == "string" && t !== "")
      return t;
  }
  return e;
}
const bM = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", CM = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  bM ? function(e, t) {
    return e instanceof t;
  } : function(e, t) {
    if (e instanceof t)
      return !0;
    if (typeof e == "object" && e !== null) {
      var n;
      const i = t.prototype[Symbol.toStringTag], a = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in e ? e[Symbol.toStringTag] : (n = e.constructor) === null || n === void 0 ? void 0 : n.name
      );
      if (i === a) {
        const s = cw(e);
        throw new Error(`Cannot use ${i} "${s}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class vF {
  /** The GraphQL source text. */
  /** Name used in diagnostics for this source, such as a file path or request name. */
  /** One-indexed line and column where this source begins. */
  /**
   * Creates a Source instance.
   * @param body - The GraphQL source text.
   * @param name - Name used in diagnostics for this source.
   * @param locationOffset - One-indexed line and column where this source begins.
   * @example
   * ```ts
   * import { Source } from 'graphql/language';
   *
   * const source = new Source(
   *   'type Query { greeting: String }',
   *   'schema.graphql',
   *   { line: 10, column: 1 },
   * );
   *
   * source.body; // => 'type Query { greeting: String }'
   * source.name; // => 'schema.graphql'
   * source.locationOffset; // => { line: 10, column: 1 }
   * ```
   */
  constructor(e, t = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof e == "string" || Om(!1, `Body must be a string. Received: ${cw(e)}.`), this.body = e, this.name = t, this.locationOffset = n, this.locationOffset.line > 0 || Om(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || Om(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function SM(r) {
  return CM(r, vF);
}
function EM(r, e) {
  const t = new kM(r, e), n = t.parseDocument();
  return Object.defineProperty(n, "tokenCount", {
    enumerable: !1,
    value: t.tokenCount
  }), n;
}
let kM = class {
  constructor(e, t = {}) {
    const { lexer: n, ...i } = t;
    if (n)
      this._lexer = n;
    else {
      const a = SM(e) ? e : new vF(e);
      this._lexer = new aM(a);
    }
    this._options = i, this._tokenCounter = 0;
  }
  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   *
   * @internal
   */
  parseName() {
    const e = this.expectToken(Ge.NAME);
    return this.node(e, {
      kind: At.NAME,
      value: e.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   *
   * @internal
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: At.DOCUMENT,
      definitions: this.many(
        Ge.SOF,
        this.parseDefinition,
        Ge.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   *
   * @internal
   */
  parseDefinition() {
    if (this.peek(Ge.BRACE_L))
      return this.parseOperationDefinition();
    const e = this.peekDescription(), t = e ? this._lexer.lookahead() : this._lexer.token;
    if (e && t.kind === Ge.BRACE_L)
      throw fa(
        this._lexer.source,
        this._lexer.token.start,
        "Unexpected description, descriptions are not supported on shorthand queries."
      );
    if (t.kind === Ge.NAME) {
      switch (t.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      switch (t.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
      }
      if (e)
        throw fa(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, only GraphQL definitions support descriptions."
        );
      if (t.value === "extend")
        return this.parseTypeSystemExtension();
    }
    throw this.unexpected(t);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   *
   * @internal
   */
  parseOperationDefinition() {
    const e = this._lexer.token;
    if (this.peek(Ge.BRACE_L))
      return this.node(e, {
        kind: At.OPERATION_DEFINITION,
        operation: xd.QUERY,
        description: void 0,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const t = this.parseDescription(), n = this.parseOperationType();
    let i;
    return this.peek(Ge.NAME) && (i = this.parseName()), this.node(e, {
      kind: At.OPERATION_DEFINITION,
      operation: n,
      description: t,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   *
   * @internal
   */
  parseOperationType() {
    const e = this.expectToken(Ge.NAME);
    switch (e.value) {
      case "query":
        return xd.QUERY;
      case "mutation":
        return xd.MUTATION;
      case "subscription":
        return xd.SUBSCRIPTION;
    }
    throw this.unexpected(e);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   *
   * @internal
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      Ge.PAREN_L,
      this.parseVariableDefinition,
      Ge.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   *
   * @internal
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: At.VARIABLE_DEFINITION,
      description: this.parseDescription(),
      variable: this.parseVariable(),
      type: (this.expectToken(Ge.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(Ge.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   *
   * @internal
   */
  parseVariable() {
    const e = this._lexer.token;
    return this.expectToken(Ge.DOLLAR), this.node(e, {
      kind: At.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   *
   * @internal
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: At.SELECTION_SET,
      selections: this.many(
        Ge.BRACE_L,
        this.parseSelection,
        Ge.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   *
   * @internal
   */
  parseSelection() {
    return this.peek(Ge.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   *
   * @internal
   */
  parseField() {
    const e = this._lexer.token, t = this.parseName();
    let n, i;
    return this.expectOptionalToken(Ge.COLON) ? (n = t, i = this.parseName()) : i = t, this.node(e, {
      kind: At.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(Ge.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   *
   * @internal
   */
  parseArguments(e) {
    const t = e ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(Ge.PAREN_L, t, Ge.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   *
   * @internal
   */
  parseArgument(e = !1) {
    const t = this._lexer.token, n = this.parseName();
    return this.expectToken(Ge.COLON), this.node(t, {
      kind: At.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(e)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   *
   * @internal
   */
  parseFragment() {
    const e = this._lexer.token;
    this.expectToken(Ge.SPREAD);
    const t = this.expectOptionalKeyword("on");
    return !t && this.peek(Ge.NAME) ? this.node(e, {
      kind: At.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(e, {
      kind: At.INLINE_FRAGMENT,
      typeCondition: t ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   *
   * @internal
   */
  parseFragmentDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(e, {
      kind: At.FRAGMENT_DEFINITION,
      description: t,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(e, {
      kind: At.FRAGMENT_DEFINITION,
      description: t,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   *
   * @internal
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   *
   * @internal
   */
  parseValueLiteral(e) {
    const t = this._lexer.token;
    switch (t.kind) {
      case Ge.BRACKET_L:
        return this.parseList(e);
      case Ge.BRACE_L:
        return this.parseObject(e);
      case Ge.INT:
        return this.advanceLexer(), this.node(t, {
          kind: At.INT,
          value: t.value
        });
      case Ge.FLOAT:
        return this.advanceLexer(), this.node(t, {
          kind: At.FLOAT,
          value: t.value
        });
      case Ge.STRING:
      case Ge.BLOCK_STRING:
        return this.parseStringLiteral();
      case Ge.NAME:
        switch (this.advanceLexer(), t.value) {
          case "true":
            return this.node(t, {
              kind: At.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(t, {
              kind: At.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(t, {
              kind: At.NULL
            });
          default:
            return this.node(t, {
              kind: At.ENUM,
              value: t.value
            });
        }
      case Ge.DOLLAR:
        if (e)
          if (this.expectToken(Ge.DOLLAR), this._lexer.token.kind === Ge.NAME) {
            const n = this._lexer.token.value;
            throw fa(
              this._lexer.source,
              t.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(t);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const e = this._lexer.token;
    return this.advanceLexer(), this.node(e, {
      kind: At.STRING,
      value: e.value,
      block: e.kind === Ge.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   *
   * @internal
   */
  parseList(e) {
    const t = () => this.parseValueLiteral(e);
    return this.node(this._lexer.token, {
      kind: At.LIST,
      values: this.any(Ge.BRACKET_L, t, Ge.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   *
   * @internal
   */
  parseObject(e) {
    const t = () => this.parseObjectField(e);
    return this.node(this._lexer.token, {
      kind: At.OBJECT,
      fields: this.any(Ge.BRACE_L, t, Ge.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   *
   * @internal
   */
  parseObjectField(e) {
    const t = this._lexer.token, n = this.parseName();
    return this.expectToken(Ge.COLON), this.node(t, {
      kind: At.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(e)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   *
   * @internal
   */
  parseDirectives(e) {
    const t = [];
    for (; this.peek(Ge.AT); )
      t.push(this.parseDirective(e));
    return t;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   *
   * @internal
   */
  parseDirective(e) {
    const t = this._lexer.token;
    return this.expectToken(Ge.AT), this.node(t, {
      kind: At.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(e)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   *
   * @internal
   */
  parseTypeReference() {
    const e = this._lexer.token;
    let t;
    if (this.expectOptionalToken(Ge.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(Ge.BRACKET_R), t = this.node(e, {
        kind: At.LIST_TYPE,
        type: n
      });
    } else
      t = this.parseNamedType();
    return this.expectOptionalToken(Ge.BANG) ? this.node(e, {
      kind: At.NON_NULL_TYPE,
      type: t
    }) : t;
  }
  /**
   * NamedType : Name
   *
   * @internal
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: At.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(Ge.STRING) || this.peek(Ge.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   *
   * @internal
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   *
   * @internal
   */
  parseSchemaDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      Ge.BRACE_L,
      this.parseOperationTypeDefinition,
      Ge.BRACE_R
    );
    return this.node(e, {
      kind: At.SCHEMA_DEFINITION,
      description: t,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   *
   * @internal
   */
  parseOperationTypeDefinition() {
    const e = this._lexer.token, t = this.parseOperationType();
    this.expectToken(Ge.COLON);
    const n = this.parseNamedType();
    return this.node(e, {
      kind: At.OPERATION_TYPE_DEFINITION,
      operation: t,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   *
   * @internal
   */
  parseScalarTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: At.SCALAR_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   *
   * @internal
   */
  parseObjectTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(e, {
      kind: At.OBJECT_TYPE_DEFINITION,
      description: t,
      name: n,
      interfaces: i,
      directives: a,
      fields: s
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   *
   * @internal
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(Ge.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   *
   * @internal
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      Ge.BRACE_L,
      this.parseFieldDefinition,
      Ge.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   *
   * @internal
   */
  parseFieldDefinition() {
    const e = this._lexer.token, t = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(Ge.COLON);
    const a = this.parseTypeReference(), s = this.parseConstDirectives();
    return this.node(e, {
      kind: At.FIELD_DEFINITION,
      description: t,
      name: n,
      arguments: i,
      type: a,
      directives: s
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   *
   * @internal
   */
  parseArgumentDefs() {
    return this.optionalMany(
      Ge.PAREN_L,
      this.parseInputValueDef,
      Ge.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   *
   * @internal
   */
  parseInputValueDef() {
    const e = this._lexer.token, t = this.parseDescription(), n = this.parseName();
    this.expectToken(Ge.COLON);
    const i = this.parseTypeReference();
    let a;
    this.expectOptionalToken(Ge.EQUALS) && (a = this.parseConstValueLiteral());
    const s = this.parseConstDirectives();
    return this.node(e, {
      kind: At.INPUT_VALUE_DEFINITION,
      description: t,
      name: n,
      type: i,
      defaultValue: a,
      directives: s
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   *
   * @internal
   */
  parseInterfaceTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(e, {
      kind: At.INTERFACE_TYPE_DEFINITION,
      description: t,
      name: n,
      interfaces: i,
      directives: a,
      fields: s
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   *
   * @internal
   */
  parseUnionTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    return this.node(e, {
      kind: At.UNION_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i,
      types: a
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   *
   * @internal
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(Ge.EQUALS) ? this.delimitedMany(Ge.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   *
   * @internal
   */
  parseEnumTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    return this.node(e, {
      kind: At.ENUM_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i,
      values: a
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   *
   * @internal
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      Ge.BRACE_L,
      this.parseEnumValueDefinition,
      Ge.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * @internal
   */
  parseEnumValueDefinition() {
    const e = this._lexer.token, t = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: At.ENUM_VALUE_DEFINITION,
      description: t,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   *
   * @internal
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw fa(
        this._lexer.source,
        this._lexer.token.start,
        `${Ng(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   *
   * @internal
   */
  parseInputObjectTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    return this.node(e, {
      kind: At.INPUT_OBJECT_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i,
      fields: a
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   *
   * @internal
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      Ge.BRACE_L,
      this.parseInputValueDef,
      Ge.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   *   - DirectiveDefinitionExtension
   *
   * @internal
   */
  parseTypeSystemExtension() {
    const e = this._lexer.lookahead();
    if (e.kind === Ge.NAME)
      switch (e.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
        case "directive":
          if (this._options.experimentalDirectivesOnDirectiveDefinitions)
            return this.parseDirectiveDefinitionExtension();
          break;
      }
    throw this.unexpected(e);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   *
   * @internal
   */
  parseSchemaExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const t = this.parseConstDirectives(), n = this.optionalMany(
      Ge.BRACE_L,
      this.parseOperationTypeDefinition,
      Ge.BRACE_R
    );
    if (t.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: At.SCHEMA_EXTENSION,
      directives: t,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   *
   * @internal
   */
  parseScalarTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const t = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: At.SCALAR_TYPE_EXTENSION,
      name: t,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   *
   * @internal
   */
  parseObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const t = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: At.OBJECT_TYPE_EXTENSION,
      name: t,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   *
   * @internal
   */
  parseInterfaceTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const t = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: At.INTERFACE_TYPE_EXTENSION,
      name: t,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   *
   * @internal
   */
  parseUnionTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const t = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: At.UNION_TYPE_EXTENSION,
      name: t,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   *
   * @internal
   */
  parseEnumTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const t = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: At.ENUM_TYPE_EXTENSION,
      name: t,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   *
   * @internal
   */
  parseInputObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const t = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: At.INPUT_OBJECT_TYPE_EXTENSION,
      name: t,
      directives: n,
      fields: i
    });
  }
  parseDirectiveDefinitionExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("directive"), this.expectToken(Ge.AT);
    const t = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: At.DIRECTIVE_EXTENSION,
      name: t,
      directives: n
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   *
   * @internal
   */
  parseDirectiveDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(Ge.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), a = this._options.experimentalDirectivesOnDirectiveDefinitions ? this.parseConstDirectives() : [], s = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const o = this.parseDirectiveLocations();
    return this.node(e, {
      kind: At.DIRECTIVE_DEFINITION,
      description: t,
      name: n,
      arguments: i,
      directives: a,
      repeatable: s,
      locations: o
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   *
   * @internal
   */
  parseDirectiveLocations() {
    return this.delimitedMany(Ge.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   *   `DIRECTIVE_DEFINITION`
   */
  parseDirectiveLocation() {
    const e = this._lexer.token, t = this.parseName();
    if (Object.prototype.hasOwnProperty.call(HA, t.value))
      return t;
    throw this.unexpected(e);
  }
  // Schema Coordinates
  /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   * @returns Parsed schema coordinate AST.
   * @example
   * ```ts
   * import { Parser, Source } from 'graphql/language';
   *
   * const typeCoordinate = new Parser(new Source('User.name')).parseSchemaCoordinate();
   * const directiveCoordinate = new Parser(new Source('@include(if:)')).parseSchemaCoordinate();
   *
   * typeCoordinate.name.value; // => 'User'
   * typeCoordinate.memberName?.value; // => 'name'
   * directiveCoordinate.name.value; // => 'deprecated'
   * directiveCoordinate.argumentName?.value; // => 'reason'
   * ```
   */
  parseSchemaCoordinate() {
    const e = this._lexer.token, t = this.expectOptionalToken(Ge.AT), n = this.parseName();
    let i;
    !t && this.expectOptionalToken(Ge.DOT) && (i = this.parseName());
    let a;
    return (t || i) && this.expectOptionalToken(Ge.PAREN_L) && (a = this.parseName(), this.expectToken(Ge.COLON), this.expectToken(Ge.PAREN_R)), t ? a ? this.node(e, {
      kind: At.DIRECTIVE_ARGUMENT_COORDINATE,
      name: n,
      argumentName: a
    }) : this.node(e, {
      kind: At.DIRECTIVE_COORDINATE,
      name: n
    }) : i ? a ? this.node(e, {
      kind: At.ARGUMENT_COORDINATE,
      name: n,
      fieldName: i,
      argumentName: a
    }) : this.node(e, {
      kind: At.MEMBER_COORDINATE,
      name: n,
      memberName: i
    }) : this.node(e, {
      kind: At.TYPE_COORDINATE,
      name: n
    });
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   *
   * @internal
   */
  node(e, t) {
    return this._options.noLocation !== !0 && (t.loc = new Z_(
      e,
      this._lexer.lastToken,
      this._lexer.source
    )), t;
  }
  /**
   * Determines if the next token is of a given kind
   *
   * @internal
   */
  peek(e) {
    return this._lexer.token.kind === e;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   *
   * @internal
   */
  expectToken(e) {
    const t = this._lexer.token;
    if (t.kind === e)
      return this.advanceLexer(), t;
    throw fa(
      this._lexer.source,
      t.start,
      `Expected ${yF(e)}, found ${Ng(t)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   *
   * @internal
   */
  expectOptionalToken(e) {
    return this._lexer.token.kind === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   *
   * @internal
   */
  expectKeyword(e) {
    const t = this._lexer.token;
    if (t.kind === Ge.NAME && t.value === e)
      this.advanceLexer();
    else
      throw fa(
        this._lexer.source,
        t.start,
        `Expected "${e}", found ${Ng(t)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   *
   * @internal
   */
  expectOptionalKeyword(e) {
    const t = this._lexer.token;
    return t.kind === Ge.NAME && t.value === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   *
   * @internal
   */
  unexpected(e) {
    const t = e ?? this._lexer.token;
    return fa(
      this._lexer.source,
      t.start,
      `Unexpected ${Ng(t)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   *
   * @internal
   */
  any(e, t, n) {
    this.expectToken(e);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(t.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   *
   * @internal
   */
  optionalMany(e, t, n) {
    if (this.expectOptionalToken(e)) {
      const i = [];
      do
        i.push(t.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   *
   * @internal
   */
  many(e, t, n) {
    this.expectToken(e);
    const i = [];
    do
      i.push(t.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   *
   * @internal
   */
  delimitedMany(e, t) {
    this.expectOptionalToken(e);
    const n = [];
    do
      n.push(t.call(this));
    while (this.expectOptionalToken(e));
    return n;
  }
  advanceLexer() {
    const { maxTokens: e } = this._options, t = this._lexer.advance();
    if (t.kind !== Ge.EOF && (++this._tokenCounter, e !== void 0 && this._tokenCounter > e))
      throw fa(
        this._lexer.source,
        t.start,
        `Document contains more that ${e} tokens. Parsing aborted.`
      );
  }
};
function Ng(r) {
  const e = r.value;
  return yF(r.kind) + (e != null ? ` "${e}"` : "");
}
function yF(r) {
  return sM(r) ? `"${r}"` : r;
}
function TM(r) {
  return `"${r.replace(FM, IM)}"`;
}
const FM = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function IM(r) {
  return PM[r.charCodeAt(0)];
}
const PM = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], fw = Object.freeze({});
function qo(r, e, t = fF) {
  const n = /* @__PURE__ */ new Map();
  for (const x of Object.values(At))
    n.set(x, DM(e, x));
  let i, a = Array.isArray(r), s = [r], o = -1, l = [], u = r, c, h;
  const f = [], p = [];
  do {
    o++;
    const x = o === s.length, E = x && l.length !== 0;
    if (x) {
      if (c = p.length === 0 ? void 0 : f[f.length - 1], u = h, h = p.pop(), E)
        if (a) {
          u = u.slice();
          let D = 0;
          for (const [F, _] of l) {
            const L = F - D;
            _ === null ? (u.splice(L, 1), D++) : u[L] = _;
          }
        } else {
          u = { ...u };
          for (const [D, F] of l)
            u[D] = F;
        }
      o = i.index, s = i.keys, l = i.edits, a = i.inArray, i = i.prev;
    } else if (h) {
      if (c = a ? o : s[o], u = h[c], u == null)
        continue;
      f.push(c);
    }
    let T;
    if (!Array.isArray(u)) {
      var m, A;
      NC(u) || Om(!1, `Invalid AST Node: ${cw(u)}.`);
      const D = x ? (m = n.get(u.kind)) === null || m === void 0 ? void 0 : m.leave : (A = n.get(u.kind)) === null || A === void 0 ? void 0 : A.enter;
      if (T = D?.call(e, u, c, h, f, p), T === fw)
        break;
      if (T === !1) {
        if (!x) {
          f.pop();
          continue;
        }
      } else if (T !== void 0 && (l.push([c, T]), !x))
        if (NC(T))
          u = T;
        else {
          f.pop();
          continue;
        }
    }
    if (T === void 0 && E && l.push([c, u]), x)
      f.pop();
    else {
      var w;
      i = {
        inArray: a,
        index: o,
        keys: s,
        edits: l,
        prev: i
      }, a = Array.isArray(u), s = a ? u : (w = t[u.kind]) !== null && w !== void 0 ? w : [], o = -1, l = [], h && p.push(h), h = u;
    }
  } while (i !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : r;
}
function DM(r, e) {
  const t = r[e];
  return typeof t == "object" ? t : typeof t == "function" ? {
    enter: t,
    leave: void 0
  } : {
    enter: r.enter,
    leave: r.leave
  };
}
function RM(r) {
  return qo(r, BM);
}
const OM = 80, BM = {
  Name: {
    leave: (r) => r.value
  },
  Variable: {
    leave: (r) => "$" + r.name
  },
  // Document
  Document: {
    leave: (r) => Ft(r.definitions, `

`)
  },
  OperationDefinition: {
    leave(r) {
      const e = Dv(r.variableDefinitions) ? Rr(`(
`, Ft(r.variableDefinitions, `
`), `
)`) : Rr("(", Ft(r.variableDefinitions, ", "), ")"), t = Rr("", r.description, `
`) + Ft(
        [
          r.operation,
          Ft([r.name, e]),
          Ft(r.directives, " ")
        ],
        " "
      );
      return (t === "query" ? "" : t + " ") + r.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: r, type: e, defaultValue: t, directives: n, description: i }) => Rr("", i, `
`) + r + ": " + e + Rr(" = ", t) + Rr(" ", Ft(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: r }) => zo(r)
  },
  Field: {
    leave({ alias: r, name: e, arguments: t, directives: n, selectionSet: i }) {
      const a = Rr("", r, ": ") + e;
      let s = a + Rr("(", Ft(t, ", "), ")");
      return s.length > OM && (s = a + Rr(`(
`, Bm(Ft(t, `
`)), `
)`)), Ft([s, Ft(n, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: r, value: e }) => r + ": " + e
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: r, directives: e }) => "..." + r + Rr(" ", Ft(e, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: r, directives: e, selectionSet: t }) => Ft(
      [
        "...",
        Rr("on ", r),
        Ft(e, " "),
        t
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({
      name: r,
      typeCondition: e,
      variableDefinitions: t,
      directives: n,
      selectionSet: i,
      description: a
    }) => Rr("", a, `
`) + // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    `fragment ${r}${Rr("(", Ft(t, ", "), ")")} on ${e} ${Rr("", Ft(n, " "), " ")}` + i
  },
  // Value
  IntValue: {
    leave: ({ value: r }) => r
  },
  FloatValue: {
    leave: ({ value: r }) => r
  },
  StringValue: {
    leave: ({ value: r, block: e }) => e ? iM(r) : TM(r)
  },
  BooleanValue: {
    leave: ({ value: r }) => r ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: r }) => r
  },
  ListValue: {
    leave: ({ values: r }) => "[" + Ft(r, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: r }) => "{" + Ft(r, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: r, value: e }) => r + ": " + e
  },
  // Directive
  Directive: {
    leave: ({ name: r, arguments: e }) => "@" + r + Rr("(", Ft(e, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: r }) => r
  },
  ListType: {
    leave: ({ type: r }) => "[" + r + "]"
  },
  NonNullType: {
    leave: ({ type: r }) => r + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: r, directives: e, operationTypes: t }) => Rr("", r, `
`) + Ft(["schema", Ft(e, " "), zo(t)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: r, type: e }) => r + ": " + e
  },
  ScalarTypeDefinition: {
    leave: ({ description: r, name: e, directives: t }) => Rr("", r, `
`) + Ft(["scalar", e, Ft(t, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: r, name: e, interfaces: t, directives: n, fields: i }) => Rr("", r, `
`) + Ft(
      [
        "type",
        e,
        Rr("implements ", Ft(t, " & ")),
        Ft(n, " "),
        zo(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: r, name: e, arguments: t, type: n, directives: i }) => Rr("", r, `
`) + e + (Dv(t) ? Rr(`(
`, Bm(Ft(t, `
`)), `
)`) : Rr("(", Ft(t, ", "), ")")) + ": " + n + Rr(" ", Ft(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: r, name: e, type: t, defaultValue: n, directives: i }) => Rr("", r, `
`) + Ft(
      [e + ": " + t, Rr("= ", n), Ft(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: r, name: e, interfaces: t, directives: n, fields: i }) => Rr("", r, `
`) + Ft(
      [
        "interface",
        e,
        Rr("implements ", Ft(t, " & ")),
        Ft(n, " "),
        zo(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, types: n }) => Rr("", r, `
`) + Ft(
      ["union", e, Ft(t, " "), Rr("= ", Ft(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, values: n }) => Rr("", r, `
`) + Ft(["enum", e, Ft(t, " "), zo(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: r, name: e, directives: t }) => Rr("", r, `
`) + Ft([e, Ft(t, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, fields: n }) => Rr("", r, `
`) + Ft(["input", e, Ft(t, " "), zo(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({
      description: r,
      name: e,
      arguments: t,
      directives: n,
      repeatable: i,
      locations: a
    }) => Rr("", r, `
`) + "directive @" + e + (Dv(t) ? Rr(`(
`, Bm(Ft(t, `
`)), `
)`) : Rr("(", Ft(t, ", "), ")")) + Rr(" ", Ft(n, " ")) + (i ? " repeatable" : "") + " on " + Ft(a, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: r, operationTypes: e }) => Ft(
      ["extend schema", Ft(r, " "), zo(e)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: r, directives: e }) => Ft(["extend scalar", r, Ft(e, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: r, interfaces: e, directives: t, fields: n }) => Ft(
      [
        "extend type",
        r,
        Rr("implements ", Ft(e, " & ")),
        Ft(t, " "),
        zo(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: r, interfaces: e, directives: t, fields: n }) => Ft(
      [
        "extend interface",
        r,
        Rr("implements ", Ft(e, " & ")),
        Ft(t, " "),
        zo(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: r, directives: e, types: t }) => Ft(
      [
        "extend union",
        r,
        Ft(e, " "),
        Rr("= ", Ft(t, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: r, directives: e, values: t }) => Ft(["extend enum", r, Ft(e, " "), zo(t)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: r, directives: e, fields: t }) => Ft(["extend input", r, Ft(e, " "), zo(t)], " ")
  },
  DirectiveExtension: {
    leave: ({ name: r, directives: e }) => Ft(["extend directive @" + r, Ft(e, " ")], " ")
  },
  // Schema Coordinates
  TypeCoordinate: {
    leave: ({ name: r }) => r
  },
  MemberCoordinate: {
    leave: ({ name: r, memberName: e }) => Ft([r, Rr(".", e)])
  },
  ArgumentCoordinate: {
    leave: ({ name: r, fieldName: e, argumentName: t }) => Ft([r, Rr(".", e), Rr("(", t, ":)")])
  },
  DirectiveCoordinate: {
    leave: ({ name: r }) => Ft(["@", r])
  },
  DirectiveArgumentCoordinate: {
    leave: ({ name: r, argumentName: e }) => Ft(["@", r, Rr("(", e, ":)")])
  }
};
function Ft(r, e = "") {
  var t;
  return (t = r?.filter((n) => n).join(e)) !== null && t !== void 0 ? t : "";
}
function zo(r) {
  return Rr(`{
`, Bm(Ft(r, `
`)), `
}`);
}
function Rr(r, e, t = "") {
  return e != null && e !== "" ? r + e + t : "";
}
function Bm(r) {
  return Rr("  ", r.replace(/\n/g, `
  `));
}
function Dv(r) {
  var e;
  return (e = r?.some((t) => t.includes(`
`))) !== null && e !== void 0 ? e : !1;
}
function UC(r) {
  return r.kind === At.FIELD || r.kind === At.FRAGMENT_SPREAD || r.kind === At.INLINE_FRAGMENT;
}
function ag(r, e) {
  var t = r.directives;
  return !t || !t.length ? !0 : NM(t).every(function(n) {
    var i = n.directive, a = n.ifArgument, s = !1;
    return a.value.kind === "Variable" ? (s = e && e[a.value.name.value], _n(s !== void 0, 105, i.name.value)) : s = a.value.value, i.name.value === "skip" ? !s : s;
  });
}
function Vp(r, e, t) {
  var n = new Set(r), i = n.size;
  return qo(e, {
    Directive: function(a) {
      if (n.delete(a.name.value) && (!t || !n.size))
        return fw;
    }
  }), t ? !n.size : n.size < i;
}
function _M(r) {
  return r && Vp(["client", "export"], r, !0);
}
function MM(r) {
  var e = r.name.value;
  return e === "skip" || e === "include";
}
function NM(r) {
  var e = [];
  return r && r.length && r.forEach(function(t) {
    if (MM(t)) {
      var n = t.arguments, i = t.name.value;
      _n(n && n.length === 1, 106, i);
      var a = n[0];
      _n(a.name && a.name.value === "if", 107, i);
      var s = a.value;
      _n(s && (s.kind === "Variable" || s.kind === "BooleanValue"), 108, i), e.push({ directive: t, ifArgument: a });
    }
  }), e;
}
function LM(r) {
  var e, t, n = (e = r.directives) === null || e === void 0 ? void 0 : e.find(function(a) {
    var s = a.name;
    return s.value === "unmask";
  });
  if (!n)
    return "mask";
  var i = (t = n.arguments) === null || t === void 0 ? void 0 : t.find(function(a) {
    var s = a.name;
    return s.value === "mode";
  });
  return i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const UM = () => /* @__PURE__ */ Object.create(null), { forEach: VM, slice: VC } = Array.prototype, { hasOwnProperty: $M } = Object.prototype;
class Fu {
  constructor(e = !0, t = UM) {
    this.weakness = e, this.makeData = t;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(e) {
    let t = this;
    return VM.call(e, (n) => t = t.getChildTrie(n)), $M.call(t, "data") ? t.data : t.data = this.makeData(VC.call(e));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(e) {
    let t = this;
    for (let n = 0, i = e.length; t && n < i; ++n) {
      const a = t.mapFor(e[n], !1);
      t = a && a.get(e[n]);
    }
    return t && t.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(e) {
    let t;
    if (e.length) {
      const n = e[0], i = this.mapFor(n, !1), a = i && i.get(n);
      a && (t = a.removeArray(VC.call(e, 1)), !a.data && !a.weak && !(a.strong && a.strong.size) && i.delete(n));
    } else
      t = this.data, delete this.data;
    return t;
  }
  getChildTrie(e) {
    const t = this.mapFor(e, !0);
    let n = t.get(e);
    return n || t.set(e, n = new Fu(this.weakness, this.makeData)), n;
  }
  mapFor(e, t) {
    return this.weakness && zM(e) ? this.weak || (t ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (t ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function zM(r) {
  switch (typeof r) {
    case "object":
      if (r === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var GM = jo(function() {
  return navigator.product;
}) == "ReactNative", Uf = typeof WeakMap == "function" && !(GM && !global.HermesInternal), dw = typeof WeakSet == "function", AF = typeof Symbol == "function" && typeof Symbol.for == "function", B0 = AF && Symbol.asyncIterator;
jo(function() {
  return window.document.createElement;
});
jo(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function da(r) {
  return r !== null && typeof r == "object";
}
function wF(r) {
  return r !== null && typeof r == "object" && (Object.getPrototypeOf(r) === Object.prototype || Object.getPrototypeOf(r) === null);
}
function HM(r, e) {
  var t = e, n = [];
  r.definitions.forEach(function(a) {
    if (a.kind === "OperationDefinition")
      throw Ts(
        112,
        a.operation,
        a.name ? " named '".concat(a.name.value, "'") : ""
      );
    a.kind === "FragmentDefinition" && n.push(a);
  }), typeof t > "u" && (_n(n.length === 1, 113, n.length), t = n[0].name.value);
  var i = Fe(Fe({}, r), { definitions: Ys([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: t
            }
          }
        ]
      }
    }
  ], r.definitions, !0) });
  return i;
}
function Yd(r) {
  r === void 0 && (r = []);
  var e = {};
  return r.forEach(function(t) {
    e[t.name.value] = t;
  }), e;
}
function _0(r, e) {
  switch (r.kind) {
    case "InlineFragment":
      return r;
    case "FragmentSpread": {
      var t = r.name.value;
      if (typeof e == "function")
        return e(t);
      var n = e && e[t];
      return _n(n, 114, t), n || null;
    }
    default:
      return null;
  }
}
function WM() {
}
class jA {
  constructor(e = 1 / 0, t = WM) {
    this.max = e, this.dispose = t, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(e) {
    return this.map.has(e);
  }
  get(e) {
    const t = this.getNode(e);
    return t && t.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(e) {
    const t = this.map.get(e);
    if (t && t !== this.newest) {
      const { older: n, newer: i } = t;
      i && (i.older = n), n && (n.newer = i), t.older = this.newest, t.older.newer = t, t.newer = null, this.newest = t, t === this.oldest && (this.oldest = i);
    }
    return t;
  }
  set(e, t) {
    let n = this.getNode(e);
    return n ? n.value = t : (n = {
      key: e,
      value: t,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(e, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(e) {
    const t = this.map.get(e);
    return t ? (t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.map.delete(e), this.dispose(t.value, e), !0) : !1;
  }
}
function qA() {
}
const jM = qA, qM = typeof WeakRef < "u" ? WeakRef : function(r) {
  return { deref: () => r };
}, QM = typeof WeakMap < "u" ? WeakMap : Map, YM = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: qA,
    unregister: qA
  };
}, XM = 10024;
class $p {
  constructor(e = 1 / 0, t = jM) {
    this.max = e, this.dispose = t, this.map = new QM(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const n = this.unfinalizedNodes.values();
      for (let i = 0; i < XM; i++) {
        const a = n.next().value;
        if (!a)
          break;
        this.unfinalizedNodes.delete(a);
        const s = a.key;
        delete a.key, a.keyRef = new qM(s), this.registry.register(s, a, a);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new YM(this.deleteNode.bind(this));
  }
  has(e) {
    return this.map.has(e);
  }
  get(e) {
    const t = this.getNode(e);
    return t && t.value;
  }
  getNode(e) {
    const t = this.map.get(e);
    if (t && t !== this.newest) {
      const { older: n, newer: i } = t;
      i && (i.older = n), n && (n.newer = i), t.older = this.newest, t.older.newer = t, t.newer = null, this.newest = t, t === this.oldest && (this.oldest = i);
    }
    return t;
  }
  set(e, t) {
    let n = this.getNode(e);
    return n ? n.value = t : (n = {
      key: e,
      value: t,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(e, n), this.size++, n.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(e) {
    e === this.newest && (this.newest = e.older), e === this.oldest && (this.oldest = e.newer), e.newer && (e.newer.older = e.older), e.older && (e.older.newer = e.newer), this.size--;
    const t = e.key || e.keyRef && e.keyRef.deref();
    this.dispose(e.value, t), e.keyRef ? this.registry.unregister(e) : this.unfinalizedNodes.delete(e), t && this.map.delete(t);
  }
  delete(e) {
    const t = this.map.get(e);
    return t ? (this.deleteNode(t), !0) : !1;
  }
  scheduleFinalization(e) {
    this.unfinalizedNodes.add(e), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var Rv = /* @__PURE__ */ new WeakSet();
function xF(r) {
  r.size <= (r.max || -1) || Rv.has(r) || (Rv.add(r), setTimeout(function() {
    r.clean(), Rv.delete(r);
  }, 100));
}
var bF = function(r, e) {
  var t = new $p(r, e);
  return t.set = function(n, i) {
    var a = $p.prototype.set.call(this, n, i);
    return xF(this), a;
  }, t;
}, JM = function(r, e) {
  var t = new jA(r, e);
  return t.set = function(n, i) {
    var a = jA.prototype.set.call(this, n, i);
    return xF(this), a;
  }, t;
}, KM = /* @__PURE__ */ Symbol.for("apollo.cacheSize"), Tu = Fe({}, s0[KM]), bc = Object.assign(function(e) {
  return JSON.stringify(e, ZM);
}, {
  reset: function() {
    dp = new JM(
      Tu.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
}), dp;
bc.reset();
function ZM(r, e) {
  if (e && typeof e == "object") {
    var t = Object.getPrototypeOf(e);
    if (t === Object.prototype || t === null) {
      var n = Object.keys(e);
      if (n.every(e5))
        return e;
      var i = JSON.stringify(n), a = dp.get(i);
      if (!a) {
        n.sort();
        var s = JSON.stringify(n);
        a = dp.get(s) || n, dp.set(i, a), dp.set(s, a);
      }
      var o = Object.create(t);
      return a.forEach(function(l) {
        o[l] = e[l];
      }), o;
    }
  }
  return e;
}
function e5(r, e, t) {
  return e === 0 || t[e - 1] <= r;
}
function Fd(r) {
  return { __ref: String(r) };
}
function Ci(r) {
  return !!(r && typeof r == "object" && typeof r.__ref == "string");
}
function t5(r) {
  return da(r) && r.kind === "Document" && Array.isArray(r.definitions);
}
function r5(r) {
  return r.kind === "StringValue";
}
function n5(r) {
  return r.kind === "BooleanValue";
}
function i5(r) {
  return r.kind === "IntValue";
}
function a5(r) {
  return r.kind === "FloatValue";
}
function s5(r) {
  return r.kind === "Variable";
}
function o5(r) {
  return r.kind === "ObjectValue";
}
function l5(r) {
  return r.kind === "ListValue";
}
function u5(r) {
  return r.kind === "EnumValue";
}
function c5(r) {
  return r.kind === "NullValue";
}
function _d(r, e, t, n) {
  if (i5(t) || a5(t))
    r[e.value] = Number(t.value);
  else if (n5(t) || r5(t))
    r[e.value] = t.value;
  else if (o5(t)) {
    var i = {};
    t.fields.map(function(s) {
      return _d(i, s.name, s.value, n);
    }), r[e.value] = i;
  } else if (s5(t)) {
    var a = (n || {})[t.name.value];
    r[e.value] = a;
  } else if (l5(t))
    r[e.value] = t.values.map(function(s) {
      var o = {};
      return _d(o, e, s, n), o[e.value];
    });
  else if (u5(t))
    r[e.value] = t.value;
  else if (c5(t))
    r[e.value] = null;
  else
    throw Ts(123, e.value, t.kind);
}
function f5(r, e) {
  var t = null;
  r.directives && (t = {}, r.directives.forEach(function(i) {
    t[i.name.value] = {}, i.arguments && i.arguments.forEach(function(a) {
      var s = a.name, o = a.value;
      return _d(t[i.name.value], s, o, e);
    });
  }));
  var n = null;
  return r.arguments && r.arguments.length && (n = {}, r.arguments.forEach(function(i) {
    var a = i.name, s = i.value;
    return _d(n, a, s, e);
  })), CF(r.name.value, n, t);
}
var d5 = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], Bh = bc, CF = Object.assign(function(r, e, t) {
  if (e && t && t.connection && t.connection.key)
    if (t.connection.filter && t.connection.filter.length > 0) {
      var n = t.connection.filter ? t.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(o) {
        i[o] = e[o];
      }), "".concat(t.connection.key, "(").concat(Bh(i), ")");
    } else
      return t.connection.key;
  var a = r;
  if (e) {
    var s = Bh(e);
    a += "(".concat(s, ")");
  }
  return t && Object.keys(t).forEach(function(o) {
    d5.indexOf(o) === -1 && (t[o] && Object.keys(t[o]).length ? a += "@".concat(o, "(").concat(Bh(t[o]), ")") : a += "@".concat(o));
  }), a;
}, {
  setStringify: function(r) {
    var e = Bh;
    return Bh = r, e;
  }
});
function M0(r, e) {
  if (r.arguments && r.arguments.length) {
    var t = {};
    return r.arguments.forEach(function(n) {
      var i = n.name, a = n.value;
      return _d(t, i, a, e);
    }), t;
  }
  return null;
}
function kc(r) {
  return r.alias ? r.alias.value : r.name.value;
}
function QA(r, e, t) {
  for (var n, i = 0, a = e.selections; i < a.length; i++) {
    var s = a[i];
    if (Tc(s)) {
      if (s.name.value === "__typename")
        return r[kc(s)];
    } else n ? n.push(s) : n = [s];
  }
  if (typeof r.__typename == "string")
    return r.__typename;
  if (n)
    for (var o = 0, l = n; o < l.length; o++) {
      var s = l[o], u = QA(r, _0(s, t).selectionSet, t);
      if (typeof u == "string")
        return u;
    }
}
function Tc(r) {
  return r.kind === "Field";
}
function h5(r) {
  return r.kind === "InlineFragment";
}
function Xd(r) {
  _n(r && r.kind === "Document", 115);
  var e = r.definitions.filter(function(t) {
    return t.kind !== "FragmentDefinition";
  }).map(function(t) {
    if (t.kind !== "OperationDefinition")
      throw Ts(116, t.kind);
    return t;
  });
  return _n(e.length <= 1, 117, e.length), r;
}
function Jd(r) {
  return Xd(r), r.definitions.filter(function(e) {
    return e.kind === "OperationDefinition";
  })[0];
}
function _m(r) {
  return r.definitions.filter(function(e) {
    return e.kind === "OperationDefinition" && !!e.name;
  }).map(function(e) {
    return e.name.value;
  })[0] || null;
}
function Kd(r) {
  return r.definitions.filter(function(e) {
    return e.kind === "FragmentDefinition";
  });
}
function p5(r) {
  var e = Jd(r);
  return _n(e && e.operation === "query", 118), e;
}
function g5(r) {
  _n(r.kind === "Document", 119), _n(r.definitions.length <= 1, 120);
  var e = r.definitions[0];
  return _n(e.kind === "FragmentDefinition", 121), e;
}
function sg(r) {
  Xd(r);
  for (var e, t = 0, n = r.definitions; t < n.length; t++) {
    var i = n[t];
    if (i.kind === "OperationDefinition") {
      var a = i.operation;
      if (a === "query" || a === "mutation" || a === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !e && (e = i);
  }
  if (e)
    return e;
  throw Ts(122);
}
function hw(r) {
  var e = /* @__PURE__ */ Object.create(null), t = r && r.variableDefinitions;
  return t && t.length && t.forEach(function(n) {
    n.defaultValue && _d(e, n.variable.name, n.defaultValue);
  }), e;
}
let _a = null;
const $C = {};
let m5 = 1;
const v5 = () => class {
  constructor() {
    this.id = [
      "slot",
      m5++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = _a; e; e = e.parent)
      if (this.id in e.slots) {
        const t = e.slots[this.id];
        if (t === $C)
          break;
        return e !== _a && (_a.slots[this.id] = t), !0;
      }
    return _a && (_a.slots[this.id] = $C), !1;
  }
  getValue() {
    if (this.hasValue())
      return _a.slots[this.id];
  }
  withValue(e, t, n, i) {
    const a = {
      __proto__: null,
      [this.id]: e
    }, s = _a;
    _a = { parent: s, slots: a };
    try {
      return t.apply(i, n);
    } finally {
      _a = s;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const t = _a;
    return function() {
      const n = _a;
      try {
        return _a = t, e.apply(this, arguments);
      } finally {
        _a = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, t, n) {
    if (_a) {
      const i = _a;
      try {
        return _a = null, e.apply(n, t);
      } finally {
        _a = i;
      }
    } else
      return e.apply(n, t);
  }
};
function zC(r) {
  try {
    return r();
  } catch {
  }
}
const Ov = "@wry/context:Slot", y5 = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  zC(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  zC(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), GC = y5, Zd = GC[Ov] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Ov] || (function(r) {
  try {
    Object.defineProperty(GC, Ov, {
      value: r,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return r;
  }
})(v5()), { bind: xre, noContext: bre } = Zd, N0 = new Zd(), { hasOwnProperty: A5 } = Object.prototype, pw = Array.from || function(r) {
  const e = [];
  return r.forEach((t) => e.push(t)), e;
};
function gw(r) {
  const { unsubscribe: e } = r;
  typeof e == "function" && (r.unsubscribe = void 0, e());
}
const zp = [], w5 = 100;
function Md(r, e) {
  if (!r)
    throw new Error(e || "assertion failure");
}
function SF(r, e) {
  const t = r.length;
  return (
    // Unknown values are not equal to each other.
    t > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    t === e.length && // The underlying value or exception must be the same.
    r[t - 1] === e[t - 1]
  );
}
function EF(r) {
  switch (r.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return r[0];
    case 2:
      throw r[1];
  }
}
function kF(r) {
  return r.slice(0);
}
class L0 {
  constructor(e) {
    this.fn = e, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++L0.count;
  }
  peek() {
    if (this.value.length === 1 && !Fc(this))
      return HC(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(e) {
    return Md(!this.recomputing, "already recomputing"), HC(this), Fc(this) ? x5(this, e) : EF(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, TF(this), gw(this));
  }
  dispose() {
    this.setDirty(), RF(this), mw(this, (e, t) => {
      e.setDirty(), OF(e, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(e) {
    e.add(this), this.deps || (this.deps = zp.pop() || /* @__PURE__ */ new Set()), this.deps.add(e);
  }
  forgetDeps() {
    this.deps && (pw(this.deps).forEach((e) => e.delete(this)), this.deps.clear(), zp.push(this.deps), this.deps = null);
  }
}
L0.count = 0;
function HC(r) {
  const e = N0.getValue();
  if (e)
    return r.parents.add(e), e.childValues.has(r) || e.childValues.set(r, []), Fc(r) ? IF(e, r) : PF(e, r), e;
}
function x5(r, e) {
  return RF(r), N0.withValue(r, b5, [r, e]), S5(r, e) && C5(r), EF(r.value);
}
function b5(r, e) {
  r.recomputing = !0;
  const { normalizeResult: t } = r;
  let n;
  t && r.value.length === 1 && (n = kF(r.value)), r.value.length = 0;
  try {
    if (r.value[0] = r.fn.apply(null, e), t && n && !SF(n, r.value))
      try {
        r.value[0] = t(r.value[0], n[0]);
      } catch {
      }
  } catch (i) {
    r.value[1] = i;
  }
  r.recomputing = !1;
}
function Fc(r) {
  return r.dirty || !!(r.dirtyChildren && r.dirtyChildren.size);
}
function C5(r) {
  r.dirty = !1, !Fc(r) && FF(r);
}
function TF(r) {
  mw(r, IF);
}
function FF(r) {
  mw(r, PF);
}
function mw(r, e) {
  const t = r.parents.size;
  if (t) {
    const n = pw(r.parents);
    for (let i = 0; i < t; ++i)
      e(n[i], r);
  }
}
function IF(r, e) {
  Md(r.childValues.has(e)), Md(Fc(e));
  const t = !Fc(r);
  if (!r.dirtyChildren)
    r.dirtyChildren = zp.pop() || /* @__PURE__ */ new Set();
  else if (r.dirtyChildren.has(e))
    return;
  r.dirtyChildren.add(e), t && TF(r);
}
function PF(r, e) {
  Md(r.childValues.has(e)), Md(!Fc(e));
  const t = r.childValues.get(e);
  t.length === 0 ? r.childValues.set(e, kF(e.value)) : SF(t, e.value) || r.setDirty(), DF(r, e), !Fc(r) && FF(r);
}
function DF(r, e) {
  const t = r.dirtyChildren;
  t && (t.delete(e), t.size === 0 && (zp.length < w5 && zp.push(t), r.dirtyChildren = null));
}
function RF(r) {
  r.childValues.size > 0 && r.childValues.forEach((e, t) => {
    OF(r, t);
  }), r.forgetDeps(), Md(r.dirtyChildren === null);
}
function OF(r, e) {
  e.parents.delete(r), r.childValues.delete(e), DF(r, e);
}
function S5(r, e) {
  if (typeof r.subscribe == "function")
    try {
      gw(r), r.unsubscribe = r.subscribe.apply(null, e);
    } catch {
      return r.setDirty(), !1;
    }
  return !0;
}
const E5 = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function BF(r) {
  const e = /* @__PURE__ */ new Map();
  function t(n) {
    const i = N0.getValue();
    if (i) {
      let a = e.get(n);
      a || e.set(n, a = /* @__PURE__ */ new Set()), i.dependOn(a);
    }
  }
  return t.dirty = function(i, a) {
    const s = e.get(i);
    if (s) {
      const o = a && A5.call(E5, a) ? a : "setDirty";
      pw(s).forEach((l) => l[o]()), e.delete(i), gw(s);
    }
  }, t;
}
let WC;
function k5(...r) {
  return (WC || (WC = new Fu(typeof WeakMap == "function"))).lookupArray(r);
}
const Bv = /* @__PURE__ */ new Set();
function Nd(r, { max: e = Math.pow(2, 16), keyArgs: t, makeCacheKey: n = k5, normalizeResult: i, subscribe: a, cache: s = jA } = /* @__PURE__ */ Object.create(null)) {
  const o = typeof s == "function" ? new s(e, (f) => f.dispose()) : s, l = function() {
    const f = n.apply(null, t ? t.apply(null, arguments) : arguments);
    if (f === void 0)
      return r.apply(null, arguments);
    let p = o.get(f);
    p || (o.set(f, p = new L0(r)), p.normalizeResult = i, p.subscribe = a, p.forget = () => o.delete(f));
    const m = p.recompute(Array.prototype.slice.call(arguments));
    return o.set(f, p), Bv.add(o), N0.hasValue() || (Bv.forEach((A) => A.clean()), Bv.clear()), m;
  };
  Object.defineProperty(l, "size", {
    get: () => o.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: e,
    keyArgs: t,
    makeCacheKey: n,
    normalizeResult: i,
    subscribe: a,
    cache: o
  });
  function u(f) {
    const p = f && o.get(f);
    p && p.setDirty();
  }
  l.dirtyKey = u, l.dirty = function() {
    u(n.apply(null, arguments));
  };
  function c(f) {
    const p = f && o.get(f);
    if (p)
      return p.peek();
  }
  l.peekKey = c, l.peek = function() {
    return c(n.apply(null, arguments));
  };
  function h(f) {
    return f ? o.delete(f) : !1;
  }
  return l.forgetKey = h, l.forget = function() {
    return h(n.apply(null, arguments));
  }, l.makeCacheKey = n, l.getKey = t ? function() {
    return n.apply(null, t.apply(null, arguments));
  } : n, Object.freeze(l);
}
function T5(r) {
  return r;
}
var _F = (
  /** @class */
  (function() {
    function r(e, t) {
      t === void 0 && (t = /* @__PURE__ */ Object.create(null)), this.resultCache = dw ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = e, t.getCacheKey && (this.getCacheKey = t.getCacheKey), this.cached = t.cache !== !1, this.resetCache();
    }
    return r.prototype.getCacheKey = function(e) {
      return [e];
    }, r.identity = function() {
      return new r(T5, { cache: !1 });
    }, r.split = function(e, t, n) {
      return n === void 0 && (n = r.identity()), Object.assign(new r(
        function(i) {
          var a = e(i) ? t : n;
          return a.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: t, right: n });
    }, r.prototype.resetCache = function() {
      var e = this;
      if (this.cached) {
        var t = new Fu(Uf);
        this.performWork = Nd(r.prototype.performWork.bind(this), {
          makeCacheKey: function(n) {
            var i = e.getCacheKey(n);
            if (i)
              return _n(Array.isArray(i), 104), t.lookupArray(i);
          },
          max: Tu["documentTransform.cache"],
          cache: $p
        });
      }
    }, r.prototype.performWork = function(e) {
      return Xd(e), this.transform(e);
    }, r.prototype.transformDocument = function(e) {
      if (this.resultCache.has(e))
        return e;
      var t = this.performWork(e);
      return this.resultCache.add(t), t;
    }, r.prototype.concat = function(e) {
      var t = this;
      return Object.assign(new r(
        function(n) {
          return e.transformDocument(t.transformDocument(n));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: e
      });
    }, r;
  })()
), _v, If = Object.assign(function(r) {
  var e = _v.get(r);
  return e || (e = RM(r), _v.set(r, e)), e;
}, {
  reset: function() {
    _v = new bF(
      Tu.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
If.reset();
var sa = Array.isArray;
function Ml(r) {
  return Array.isArray(r) && r.length > 0;
}
var jC = {
  kind: At.FIELD,
  name: {
    kind: At.NAME,
    value: "__typename"
  }
};
function MF(r, e) {
  return !r || r.selectionSet.selections.every(function(t) {
    return t.kind === At.FRAGMENT_SPREAD && MF(e[t.name.value], e);
  });
}
function F5(r) {
  return MF(Jd(r) || g5(r), Yd(Kd(r))) ? null : r;
}
function I5(r) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  return r.forEach(function(n) {
    n && (n.name ? e.set(n.name, n) : n.test && t.set(n.test, n));
  }), function(n) {
    var i = e.get(n.name.value);
    return !i && t.size && t.forEach(function(a, s) {
      s(n) && (i = a);
    }), i;
  };
}
function qC(r) {
  var e = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = r);
    var i = e.get(n);
    return i || e.set(n, i = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), i;
  };
}
function NF(r, e) {
  Xd(e);
  for (var t = qC(""), n = qC(""), i = function(x) {
    for (var E = 0, T = void 0; E < x.length && (T = x[E]); ++E)
      if (!sa(T)) {
        if (T.kind === At.OPERATION_DEFINITION)
          return t(T.name && T.name.value);
        if (T.kind === At.FRAGMENT_DEFINITION)
          return n(T.name.value);
      }
    return null;
  }, a = 0, s = e.definitions.length - 1; s >= 0; --s)
    e.definitions[s].kind === At.OPERATION_DEFINITION && ++a;
  var o = I5(r), l = function(x) {
    return Ml(x) && x.map(o).some(function(E) {
      return E && E.remove;
    });
  }, u = /* @__PURE__ */ new Map(), c = !1, h = {
    enter: function(x) {
      if (l(x.directives))
        return c = !0, null;
    }
  }, f = qo(e, {
    // These two AST node types share the same implementation, defined above.
    Field: h,
    InlineFragment: h,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(x, E, T, D, F) {
        var _ = i(F);
        _ && _.variables.add(x.name.value);
      }
    },
    FragmentSpread: {
      enter: function(x, E, T, D, F) {
        if (l(x.directives))
          return c = !0, null;
        var _ = i(F);
        _ && _.fragmentSpreads.add(x.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(x, E, T, D) {
        u.set(JSON.stringify(D), x);
      },
      leave: function(x, E, T, D) {
        var F = u.get(JSON.stringify(D));
        if (x === F)
          return x;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          a > 0 && x.selectionSet.selections.every(function(_) {
            return _.kind === At.FIELD && _.name.value === "__typename";
          })
        )
          return n(x.name.value).removed = !0, c = !0, null;
      }
    },
    Directive: {
      leave: function(x) {
        if (o(x))
          return c = !0, null;
      }
    }
  });
  if (!c)
    return e;
  var p = function(x) {
    return x.transitiveVars || (x.transitiveVars = new Set(x.variables), x.removed || x.fragmentSpreads.forEach(function(E) {
      p(n(E)).transitiveVars.forEach(function(T) {
        x.transitiveVars.add(T);
      });
    })), x;
  }, m = /* @__PURE__ */ new Set();
  f.definitions.forEach(function(x) {
    x.kind === At.OPERATION_DEFINITION ? p(t(x.name && x.name.value)).fragmentSpreads.forEach(function(E) {
      m.add(E);
    }) : x.kind === At.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    a === 0 && !n(x.name.value).removed && m.add(x.name.value);
  }), m.forEach(function(x) {
    p(n(x)).fragmentSpreads.forEach(function(E) {
      m.add(E);
    });
  });
  var A = function(x) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!m.has(x) || n(x).removed);
  }, w = {
    enter: function(x) {
      if (A(x.name.value))
        return null;
    }
  };
  return F5(qo(f, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: w,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: w,
    OperationDefinition: {
      leave: function(x) {
        if (x.variableDefinitions) {
          var E = p(
            // If an operation is anonymous, we use the empty string as its key.
            t(x.name && x.name.value)
          ).transitiveVars;
          if (E.size < x.variableDefinitions.length)
            return Fe(Fe({}, x), { variableDefinitions: x.variableDefinitions.filter(function(T) {
              return E.has(T.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var LF = Object.assign(function(r) {
  return qo(r, {
    SelectionSet: {
      enter: function(e, t, n) {
        if (!(n && n.kind === At.OPERATION_DEFINITION)) {
          var i = e.selections;
          if (i) {
            var a = i.some(function(o) {
              return Tc(o) && (o.name.value === "__typename" || o.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!a) {
              var s = n;
              if (!(Tc(s) && s.directives && s.directives.some(function(o) {
                return o.name.value === "export";
              })))
                return Fe(Fe({}, e), { selections: Ys(Ys([], i, !0), [jC], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(r) {
    return r === jC;
  }
});
function P5(r) {
  var e = sg(r), t = e.operation;
  if (t === "query")
    return r;
  var n = qo(r, {
    OperationDefinition: {
      enter: function(i) {
        return Fe(Fe({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function UF(r) {
  Xd(r);
  var e = NF([
    {
      test: function(t) {
        return t.name.value === "client";
      },
      remove: !0
    }
  ], r);
  return e;
}
function D5(r) {
  return Xd(r), qo(r, {
    FragmentSpread: function(e) {
      var t;
      if (!(!((t = e.directives) === null || t === void 0) && t.some(function(n) {
        return n.name.value === "unmask";
      })))
        return Fe(Fe({}, e), { directives: Ys(Ys([], e.directives || [], !0), [
          {
            kind: At.DIRECTIVE,
            name: { kind: At.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var R5 = Object.prototype.hasOwnProperty;
function QC() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  return U0(r);
}
function U0(r) {
  var e = r[0] || {}, t = r.length;
  if (t > 1)
    for (var n = new Ic(), i = 1; i < t; ++i)
      e = n.merge(e, r[i]);
  return e;
}
var O5 = function(r, e, t) {
  return this.merge(r[t], e[t]);
}, Ic = (
  /** @class */
  (function() {
    function r(e) {
      e === void 0 && (e = O5), this.reconciler = e, this.isObject = da, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return r.prototype.merge = function(e, t) {
      for (var n = this, i = [], a = 2; a < arguments.length; a++)
        i[a - 2] = arguments[a];
      return da(t) && da(e) ? (Object.keys(t).forEach(function(s) {
        if (R5.call(e, s)) {
          var o = e[s];
          if (t[s] !== o) {
            var l = n.reconciler.apply(n, Ys([
              e,
              t,
              s
            ], i, !1));
            l !== o && (e = n.shallowCopyForMerge(e), e[s] = l);
          }
        } else
          e = n.shallowCopyForMerge(e), e[s] = t[s];
      }), e) : t;
    }, r.prototype.shallowCopyForMerge = function(e) {
      return da(e) && (this.pastCopies.has(e) || (Array.isArray(e) ? e = e.slice(0) : e = Fe({ __proto__: Object.getPrototypeOf(e) }, e), this.pastCopies.add(e))), e;
    }, r;
  })()
);
function B5(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _5(r)) || e) {
    t && (r = t);
    var n = 0;
    return function() {
      return n >= r.length ? { done: !0 } : { done: !1, value: r[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _5(r, e) {
  if (r) {
    if (typeof r == "string") return YC(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set") return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return YC(r, e);
  }
}
function YC(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++)
    n[t] = r[t];
  return n;
}
function XC(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, n.key, n);
  }
}
function vw(r, e, t) {
  return e && XC(r.prototype, e), t && XC(r, t), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
var yw = function() {
  return typeof Symbol == "function";
}, Aw = function(r) {
  return yw() && !!Symbol[r];
}, ww = function(r) {
  return Aw(r) ? Symbol[r] : "@@" + r;
};
yw() && !Aw("observable") && (Symbol.observable = /* @__PURE__ */ Symbol("observable"));
var M5 = ww("iterator"), YA = ww("observable"), VF = ww("species");
function o0(r, e) {
  var t = r[e];
  if (t != null) {
    if (typeof t != "function") throw new TypeError(t + " is not a function");
    return t;
  }
}
function _h(r) {
  var e = r.constructor;
  return e !== void 0 && (e = e[VF], e === null && (e = void 0)), e !== void 0 ? e : ri;
}
function N5(r) {
  return r instanceof ri;
}
function Ld(r) {
  Ld.log ? Ld.log(r) : setTimeout(function() {
    throw r;
  });
}
function Mm(r) {
  Promise.resolve().then(function() {
    try {
      r();
    } catch (e) {
      Ld(e);
    }
  });
}
function $F(r) {
  var e = r._cleanup;
  if (e !== void 0 && (r._cleanup = void 0, !!e))
    try {
      if (typeof e == "function")
        e();
      else {
        var t = o0(e, "unsubscribe");
        t && t.call(e);
      }
    } catch (n) {
      Ld(n);
    }
}
function XA(r) {
  r._observer = void 0, r._queue = void 0, r._state = "closed";
}
function L5(r) {
  var e = r._queue;
  if (e) {
    r._queue = void 0, r._state = "ready";
    for (var t = 0; t < e.length && (zF(r, e[t].type, e[t].value), r._state !== "closed"); ++t)
      ;
  }
}
function zF(r, e, t) {
  r._state = "running";
  var n = r._observer;
  try {
    var i = o0(n, e);
    switch (e) {
      case "next":
        i && i.call(n, t);
        break;
      case "error":
        if (XA(r), i) i.call(n, t);
        else throw t;
        break;
      case "complete":
        XA(r), i && i.call(n);
        break;
    }
  } catch (a) {
    Ld(a);
  }
  r._state === "closed" ? $F(r) : r._state === "running" && (r._state = "ready");
}
function Mv(r, e, t) {
  if (r._state !== "closed") {
    if (r._state === "buffering") {
      r._queue.push({
        type: e,
        value: t
      });
      return;
    }
    if (r._state !== "ready") {
      r._state = "buffering", r._queue = [{
        type: e,
        value: t
      }], Mm(function() {
        return L5(r);
      });
      return;
    }
    zF(r, e, t);
  }
}
var U5 = /* @__PURE__ */ (function() {
  function r(t, n) {
    this._cleanup = void 0, this._observer = t, this._queue = void 0, this._state = "initializing";
    var i = new V5(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (a) {
      i.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var e = r.prototype;
  return e.unsubscribe = function() {
    this._state !== "closed" && (XA(this), $F(this));
  }, vw(r, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), r;
})(), V5 = /* @__PURE__ */ (function() {
  function r(t) {
    this._subscription = t;
  }
  var e = r.prototype;
  return e.next = function(n) {
    Mv(this._subscription, "next", n);
  }, e.error = function(n) {
    Mv(this._subscription, "error", n);
  }, e.complete = function() {
    Mv(this._subscription, "complete");
  }, vw(r, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), r;
})(), ri = /* @__PURE__ */ (function() {
  function r(t) {
    if (!(this instanceof r)) throw new TypeError("Observable cannot be called as a function");
    if (typeof t != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = t;
  }
  var e = r.prototype;
  return e.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new U5(n, this._subscriber);
  }, e.forEach = function(n) {
    var i = this;
    return new Promise(function(a, s) {
      if (typeof n != "function") {
        s(new TypeError(n + " is not a function"));
        return;
      }
      function o() {
        l.unsubscribe(), a();
      }
      var l = i.subscribe({
        next: function(u) {
          try {
            n(u, o);
          } catch (c) {
            s(c), l.unsubscribe();
          }
        },
        error: s,
        complete: a
      });
    });
  }, e.map = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = _h(this);
    return new a(function(s) {
      return i.subscribe({
        next: function(o) {
          try {
            o = n(o);
          } catch (l) {
            return s.error(l);
          }
          s.next(o);
        },
        error: function(o) {
          s.error(o);
        },
        complete: function() {
          s.complete();
        }
      });
    });
  }, e.filter = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = _h(this);
    return new a(function(s) {
      return i.subscribe({
        next: function(o) {
          try {
            if (!n(o)) return;
          } catch (l) {
            return s.error(l);
          }
          s.next(o);
        },
        error: function(o) {
          s.error(o);
        },
        complete: function() {
          s.complete();
        }
      });
    });
  }, e.reduce = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = _h(this), s = arguments.length > 1, o = !1, l = arguments[1], u = l;
    return new a(function(c) {
      return i.subscribe({
        next: function(h) {
          var f = !o;
          if (o = !0, !f || s)
            try {
              u = n(u, h);
            } catch (p) {
              return c.error(p);
            }
          else
            u = h;
        },
        error: function(h) {
          c.error(h);
        },
        complete: function() {
          if (!o && !s) return c.error(new TypeError("Cannot reduce an empty sequence"));
          c.next(u), c.complete();
        }
      });
    });
  }, e.concat = function() {
    for (var n = this, i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    var o = _h(this);
    return new o(function(l) {
      var u, c = 0;
      function h(f) {
        u = f.subscribe({
          next: function(p) {
            l.next(p);
          },
          error: function(p) {
            l.error(p);
          },
          complete: function() {
            c === a.length ? (u = void 0, l.complete()) : h(o.from(a[c++]));
          }
        });
      }
      return h(n), function() {
        u && (u.unsubscribe(), u = void 0);
      };
    });
  }, e.flatMap = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = _h(this);
    return new a(function(s) {
      var o = [], l = i.subscribe({
        next: function(c) {
          if (n)
            try {
              c = n(c);
            } catch (f) {
              return s.error(f);
            }
          var h = a.from(c).subscribe({
            next: function(f) {
              s.next(f);
            },
            error: function(f) {
              s.error(f);
            },
            complete: function() {
              var f = o.indexOf(h);
              f >= 0 && o.splice(f, 1), u();
            }
          });
          o.push(h);
        },
        error: function(c) {
          s.error(c);
        },
        complete: function() {
          u();
        }
      });
      function u() {
        l.closed && o.length === 0 && s.complete();
      }
      return function() {
        o.forEach(function(c) {
          return c.unsubscribe();
        }), l.unsubscribe();
      };
    });
  }, e[YA] = function() {
    return this;
  }, r.from = function(n) {
    var i = typeof this == "function" ? this : r;
    if (n == null) throw new TypeError(n + " is not an object");
    var a = o0(n, YA);
    if (a) {
      var s = a.call(n);
      if (Object(s) !== s) throw new TypeError(s + " is not an object");
      return N5(s) && s.constructor === i ? s : new i(function(o) {
        return s.subscribe(o);
      });
    }
    if (Aw("iterator") && (a = o0(n, M5), a))
      return new i(function(o) {
        Mm(function() {
          if (!o.closed) {
            for (var l = B5(a.call(n)), u; !(u = l()).done; ) {
              var c = u.value;
              if (o.next(c), o.closed) return;
            }
            o.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new i(function(o) {
        Mm(function() {
          if (!o.closed) {
            for (var l = 0; l < n.length; ++l)
              if (o.next(n[l]), o.closed) return;
            o.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, r.of = function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var s = typeof this == "function" ? this : r;
    return new s(function(o) {
      Mm(function() {
        if (!o.closed) {
          for (var l = 0; l < i.length; ++l)
            if (o.next(i[l]), o.closed) return;
          o.complete();
        }
      });
    });
  }, vw(r, null, [{
    key: VF,
    get: function() {
      return this;
    }
  }]), r;
})();
yw() && Object.defineProperty(ri, /* @__PURE__ */ Symbol("extensions"), {
  value: {
    symbol: YA,
    hostReportError: Ld
  },
  configurable: !0
});
function $5(r) {
  var e, t = r.Symbol;
  if (typeof t == "function")
    if (t.observable)
      e = t.observable;
    else {
      typeof t.for == "function" ? e = t.for("https://github.com/benlesh/symbol-observable") : e = t("https://github.com/benlesh/symbol-observable");
      try {
        t.observable = e;
      } catch {
      }
    }
  else
    e = "@@observable";
  return e;
}
var yd;
typeof self < "u" ? yd = self : typeof window < "u" ? yd = window : typeof global < "u" ? yd = global : typeof module < "u" ? yd = module : yd = Function("return this")();
$5(yd);
var JC = ri.prototype, KC = "@@observable";
JC[KC] || (JC[KC] = function() {
  return this;
});
function z5(r) {
  return r.catch(function() {
  }), r;
}
var G5 = Object.prototype.toString;
function H5(r) {
  return JA(r);
}
function JA(r, e) {
  switch (G5.call(r)) {
    case "[object Array]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(r))
        return e.get(r);
      var t = r.slice(0);
      return e.set(r, t), t.forEach(function(i, a) {
        t[a] = JA(i, e);
      }), t;
    }
    case "[object Object]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(r))
        return e.get(r);
      var n = Object.create(Object.getPrototypeOf(r));
      return e.set(r, n), Object.keys(r).forEach(function(i) {
        n[i] = JA(r[i], e);
      }), n;
    }
    default:
      return r;
  }
}
function Tp(r, e, t) {
  var n = [];
  r.forEach(function(i) {
    return i[e] && n.push(i);
  }), n.forEach(function(i) {
    return i[e](t);
  });
}
function Nv(r, e, t) {
  return new ri(function(n) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(u) {
          return u(l());
        });
      }
    };
    function a(l, u) {
      return function(c) {
        if (l) {
          var h = function() {
            return n.closed ? (
              /* will be swallowed */
              0
            ) : l(c);
          };
          i = i.then(h, h).then(function(f) {
            return n.next(f);
          }, function(f) {
            return n.error(f);
          });
        } else
          n[u](c);
      };
    }
    var s = {
      next: a(e, "next"),
      error: a(t, "error"),
      complete: function() {
        i.then(function() {
          return n.complete();
        });
      }
    }, o = r.subscribe(s);
    return function() {
      return o.unsubscribe();
    };
  });
}
function GF(r) {
  function e(t) {
    Object.defineProperty(r, t, { value: ri });
  }
  return AF && Symbol.species && e(Symbol.species), e("@@species"), r;
}
function ZC(r) {
  return r && typeof r.then == "function";
}
var Ad = (
  /** @class */
  (function(r) {
    bo(e, r);
    function e(t) {
      var n = r.call(this, function(i) {
        return n.addObserver(i), function() {
          return n.removeObserver(i);
        };
      }) || this;
      return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, a) {
        n.resolve = i, n.reject = a;
      }), n.handlers = {
        next: function(i) {
          n.sub !== null && (n.latest = ["next", i], n.notify("next", i), Tp(n.observers, "next", i));
        },
        error: function(i) {
          var a = n.sub;
          a !== null && (a && setTimeout(function() {
            return a.unsubscribe();
          }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), Tp(n.observers, "error", i));
        },
        complete: function() {
          var i = n, a = i.sub, s = i.sources, o = s === void 0 ? [] : s;
          if (a !== null) {
            var l = o.shift();
            l ? ZC(l) ? l.then(function(u) {
              return n.sub = u.subscribe(n.handlers);
            }, n.handlers.error) : n.sub = l.subscribe(n.handlers) : (a && setTimeout(function() {
              return a.unsubscribe();
            }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), Tp(n.observers, "complete"));
          }
        }
      }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
        n.reject(i), n.sources = [], n.handlers.error(i);
      }, n.promise.catch(function(i) {
      }), typeof t == "function" && (t = [new ri(t)]), ZC(t) ? t.then(function(i) {
        return n.start(i);
      }, n.handlers.error) : n.start(t), n;
    }
    return e.prototype.start = function(t) {
      this.sub === void 0 && (this.sources = Array.from(t), this.handlers.complete());
    }, e.prototype.deliverLastMessage = function(t) {
      if (this.latest) {
        var n = this.latest[0], i = t[n];
        i && i.call(t, this.latest[1]), this.sub === null && n === "next" && t.complete && t.complete();
      }
    }, e.prototype.addObserver = function(t) {
      this.observers.has(t) || (this.deliverLastMessage(t), this.observers.add(t));
    }, e.prototype.removeObserver = function(t) {
      this.observers.delete(t) && this.observers.size < 1 && this.handlers.complete();
    }, e.prototype.notify = function(t, n) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(a) {
        return a(t, n);
      }));
    }, e.prototype.beforeNext = function(t) {
      var n = !1;
      this.nextResultListeners.add(function(i, a) {
        n || (n = !0, t(i, a));
      });
    }, e;
  })(ri)
);
GF(Ad);
function Id(r) {
  return "incremental" in r;
}
function W5(r) {
  return "hasNext" in r && "data" in r;
}
function j5(r) {
  return Id(r) || W5(r);
}
function q5(r) {
  return da(r) && "payload" in r;
}
function HF(r, e) {
  var t = r, n = new Ic();
  return Id(e) && Ml(e.incremental) && e.incremental.forEach(function(i) {
    for (var a = i.data, s = i.path, o = s.length - 1; o >= 0; --o) {
      var l = s[o], u = !isNaN(+l), c = u ? [] : {};
      c[l] = a, a = c;
    }
    t = n.merge(t, a);
  }), t;
}
function Nm(r) {
  var e = KA(r);
  return Ml(e);
}
function KA(r) {
  var e = Ml(r.errors) ? r.errors.slice(0) : [];
  return Id(r) && Ml(r.incremental) && r.incremental.forEach(function(t) {
    t.errors && e.push.apply(e, t.errors);
  }), e;
}
function Ud() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  var t = /* @__PURE__ */ Object.create(null);
  return r.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var a = n[i];
      a !== void 0 && (t[i] = a);
    });
  }), t;
}
function Lv(r, e) {
  return Ud(r, e, e.variables && {
    variables: Ud(Fe(Fe({}, r && r.variables), e.variables))
  });
}
function Q5(r, e) {
  return ZA(r, e);
}
function ZA(r, e, t) {
  if (t === void 0 && (t = /* @__PURE__ */ new Map()), t.has(r))
    return t.get(r);
  var n = !1;
  if (Array.isArray(r)) {
    var i = [];
    if (t.set(r, i), r.forEach(function(s, o) {
      var l = ZA(s, e, t);
      n || (n = l !== s), i[o] = l;
    }), n)
      return i;
  } else if (wF(r)) {
    var a = Object.create(Object.getPrototypeOf(r));
    if (t.set(r, a), Object.keys(r).forEach(function(s) {
      if (s === e) {
        n = !0;
        return;
      }
      var o = ZA(r[s], e, t);
      n || (n = o !== r[s]), a[s] = o;
    }), n)
      return a;
  }
  return r;
}
function xw(r) {
  return Q5(r, "__typename");
}
var Uv, eS = /* @__PURE__ */ Symbol.for("apollo.deprecations.slot"), tS = s0, rS = (Uv = tS[eS]) !== null && Uv !== void 0 ? Uv : tS[eS] = new Zd();
function qa(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  return rS.withValue.apply(rS, Ys([Array.isArray(r) ? r : [r]], e, !1));
}
function Vv(r) {
  return new ri(function(e) {
    e.error(r);
  });
}
var WF = function(r, e, t) {
  var n = new Error(t);
  throw n.name = "ServerError", n.response = r, n.statusCode = r.status, n.result = e, n;
};
function Y5(r) {
  for (var e = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], t = 0, n = Object.keys(r); t < n.length; t++) {
    var i = n[t];
    if (e.indexOf(i) < 0)
      throw Ts(58, i);
  }
  return r;
}
function X5(r, e) {
  var t = Fe({}, r), n = function(a) {
    typeof a == "function" ? t = Fe(Fe({}, t), a(t)) : t = Fe(Fe({}, t), a);
  }, i = function() {
    return Fe({}, t);
  };
  return Object.defineProperty(e, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(e, "getContext", {
    enumerable: !1,
    value: i
  }), e;
}
function J5(r) {
  var e = {
    variables: r.variables || {},
    extensions: r.extensions || {},
    operationName: r.operationName,
    query: r.query
  };
  return e.operationName || (e.operationName = typeof e.query != "string" ? _m(e.query) || void 0 : ""), e;
}
function K5(r, e) {
  var t = Fe({}, r), n = new Set(Object.keys(r));
  return qo(e, {
    Variable: function(i, a, s) {
      s && s.kind !== "VariableDefinition" && n.delete(i.name.value);
    }
  }), n.forEach(function(i) {
    delete t[i];
  }), t;
}
function nS(r, e) {
  return e ? e(r) : ri.of();
}
function Mh(r) {
  return typeof r == "function" ? new Ko(r) : r;
}
function Lg(r) {
  return r.request.length <= 1;
}
var Ko = (
  /** @class */
  (function() {
    function r(e) {
      e && (this.request = e);
    }
    return r.empty = function() {
      return new r(function() {
        return ri.of();
      });
    }, r.from = function(e) {
      return e.length === 0 ? r.empty() : e.map(Mh).reduce(function(t, n) {
        return t.concat(n);
      });
    }, r.split = function(e, t, n) {
      var i = Mh(t), a = Mh(n || new r(nS)), s;
      return Lg(i) && Lg(a) ? s = new r(function(o) {
        return e(o) ? i.request(o) || ri.of() : a.request(o) || ri.of();
      }) : s = new r(function(o, l) {
        return e(o) ? i.request(o, l) || ri.of() : a.request(o, l) || ri.of();
      }), Object.assign(s, { left: i, right: a });
    }, r.execute = function(e, t) {
      return e.request(X5(t.context, J5(Y5(t)))) || ri.of();
    }, r.concat = function(e, t) {
      var n = Mh(e);
      if (Lg(n))
        return n;
      var i = Mh(t), a;
      return Lg(i) ? a = new r(function(s) {
        return n.request(s, function(o) {
          return i.request(o) || ri.of();
        }) || ri.of();
      }) : a = new r(function(s, o) {
        return n.request(s, function(l) {
          return i.request(l, o) || ri.of();
        }) || ri.of();
      }), Object.assign(a, { left: n, right: i });
    }, r.prototype.split = function(e, t, n) {
      return this.concat(r.split(e, t, n || new r(nS)));
    }, r.prototype.concat = function(e) {
      return r.concat(this, e);
    }, r.prototype.request = function(e, t) {
      throw Ts(48);
    }, r.prototype.onError = function(e, t) {
      if (t && t.error)
        return t.error(e), !1;
      throw e;
    }, r.prototype.setOnError = function(e) {
      return this.onError = e, this;
    }, r;
  })()
), Z5 = Ko.from, e1 = Ko.execute;
function e6(r) {
  var e, t = r[Symbol.asyncIterator]();
  return e = {
    next: function() {
      return t.next();
    }
  }, e[Symbol.asyncIterator] = function() {
    return this;
  }, e;
}
function t6(r) {
  var e = null, t = null, n = !1, i = [], a = [];
  function s(h) {
    if (!t) {
      if (a.length) {
        var f = a.shift();
        if (Array.isArray(f) && f[0])
          return f[0]({ value: h, done: !1 });
      }
      i.push(h);
    }
  }
  function o(h) {
    t = h;
    var f = a.slice();
    f.forEach(function(p) {
      p[1](h);
    }), !e || e();
  }
  function l() {
    n = !0;
    var h = a.slice();
    h.forEach(function(f) {
      f[0]({ value: void 0, done: !0 });
    }), !e || e();
  }
  e = function() {
    e = null, r.removeListener("data", s), r.removeListener("error", o), r.removeListener("end", l), r.removeListener("finish", l), r.removeListener("close", l);
  }, r.on("data", s), r.on("error", o), r.on("end", l), r.on("finish", l), r.on("close", l);
  function u() {
    return new Promise(function(h, f) {
      if (t)
        return f(t);
      if (i.length)
        return h({ value: i.shift(), done: !1 });
      if (n)
        return h({ value: void 0, done: !0 });
      a.push([h, f]);
    });
  }
  var c = {
    next: function() {
      return u();
    }
  };
  return B0 && (c[Symbol.asyncIterator] = function() {
    return this;
  }), c;
}
function r6(r) {
  var e = !1, t = {
    next: function() {
      return e ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (e = !0, new Promise(function(n, i) {
        r.then(function(a) {
          n({ value: a, done: !1 });
        }).catch(i);
      }));
    }
  };
  return B0 && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function iS(r) {
  var e = {
    next: function() {
      return r.read();
    }
  };
  return B0 && (e[Symbol.asyncIterator] = function() {
    return this;
  }), e;
}
function n6(r) {
  return !!r.body;
}
function i6(r) {
  return !!r.getReader;
}
function a6(r) {
  return !!(B0 && r[Symbol.asyncIterator]);
}
function s6(r) {
  return !!r.stream;
}
function o6(r) {
  return !!r.arrayBuffer;
}
function l6(r) {
  return !!r.pipe;
}
function u6(r) {
  var e = r;
  if (n6(r) && (e = r.body), a6(e))
    return e6(e);
  if (i6(e))
    return iS(e.getReader());
  if (s6(e))
    return iS(e.stream().getReader());
  if (o6(e))
    return r6(e.arrayBuffer());
  if (l6(e))
    return t6(e);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var og = /* @__PURE__ */ Symbol();
function bw(r) {
  return r.extensions ? Array.isArray(r.extensions[og]) : !1;
}
function jF(r) {
  return r.hasOwnProperty("graphQLErrors");
}
var c6 = function(r) {
  var e = Ys(Ys(Ys([], r.graphQLErrors, !0), r.clientErrors, !0), r.protocolErrors, !0);
  return r.networkError && e.push(r.networkError), e.map(function(t) {
    return da(t) && t.message || "Error message not found.";
  }).join(`
`);
}, hc = (
  /** @class */
  (function(r) {
    bo(e, r);
    function e(t) {
      var n = t.graphQLErrors, i = t.protocolErrors, a = t.clientErrors, s = t.networkError, o = t.errorMessage, l = t.extraInfo, u = r.call(this, o) || this;
      return u.name = "ApolloError", u.graphQLErrors = n || [], u.protocolErrors = i || [], u.clientErrors = a || [], u.networkError = s || null, u.message = o || c6(u), u.extraInfo = l, u.cause = Ys(Ys(Ys([
        s
      ], n || [], !0), i || [], !0), a || [], !0).find(function(c) {
        return !!c;
      }) || null, u.__proto__ = e.prototype, u;
    }
    return e;
  })(Error)
), aS = Object.prototype.hasOwnProperty;
function f6(r, e) {
  return Il(this, void 0, void 0, function() {
    var t, n, i, a, s, o, l, u, c, h, f, p, m, A, w, x, E, T, D, F, _, L, Z, te;
    return Pl(this, function(de) {
      switch (de.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          t = new TextDecoder("utf-8"), n = (te = r.headers) === null || te === void 0 ? void 0 : te.get("content-type"), i = "boundary=", a = n?.includes(i) ? n?.substring(n?.indexOf(i) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", s = `\r
--`.concat(a), o = "", l = u6(r), u = !0, de.label = 1;
        case 1:
          return u ? [4, l.next()] : [3, 3];
        case 2:
          for (c = de.sent(), h = c.value, f = c.done, p = typeof h == "string" ? h : t.decode(h), m = o.length - s.length + 1, u = !f, o += p, A = o.indexOf(s, m); A > -1; ) {
            if (w = void 0, L = [
              o.slice(0, A),
              o.slice(A + s.length)
            ], w = L[0], o = L[1], x = w.indexOf(`\r
\r
`), E = d6(w.slice(0, x)), T = E["content-type"], T && T.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (D = w.slice(x), D) {
              if (F = qF(r, D), Object.keys(F).length > 1 || "data" in F || "incremental" in F || "errors" in F || "payload" in F)
                if (q5(F)) {
                  if (_ = {}, "payload" in F) {
                    if (Object.keys(F).length === 1 && F.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    _ = Fe({}, F.payload);
                  }
                  "errors" in F && (_ = Fe(Fe({}, _), { extensions: Fe(Fe({}, "extensions" in _ ? _.extensions : null), (Z = {}, Z[og] = F.errors, Z)) })), e(_);
                } else
                  e(F);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(F).length === 1 && "hasNext" in F && !F.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            A = o.indexOf(s);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function d6(r) {
  var e = {};
  return r.split(`
`).forEach(function(t) {
    var n = t.indexOf(":");
    if (n > -1) {
      var i = t.slice(0, n).trim().toLowerCase(), a = t.slice(n + 1).trim();
      e[i] = a;
    }
  }), e;
}
function qF(r, e) {
  if (r.status >= 300) {
    var t = function() {
      try {
        return JSON.parse(e);
      } catch {
        return e;
      }
    };
    WF(r, t(), "Response not successful: Received status code ".concat(r.status));
  }
  try {
    return JSON.parse(e);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = r, n.statusCode = r.status, n.bodyText = e, n;
  }
}
function h6(r, e) {
  r.result && r.result.errors && r.result.data && e.next(r.result), e.error(r);
}
function p6(r) {
  return function(e) {
    return e.text().then(function(t) {
      return qF(e, t);
    }).then(function(t) {
      return !Array.isArray(t) && !aS.call(t, "data") && !aS.call(t, "errors") && WF(e, t, "Server response was missing for query '".concat(Array.isArray(r) ? r.map(function(n) {
        return n.operationName;
      }) : r.operationName, "'.")), t;
    });
  };
}
var t1 = function(r, e) {
  var t;
  try {
    t = JSON.stringify(r);
  } catch (i) {
    var n = Ts(54, e, i.message);
    throw n.parseError = i, n;
  }
  return t;
}, g6 = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, m6 = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, v6 = {
  method: "POST"
}, y6 = {
  http: g6,
  headers: m6,
  options: v6
}, A6 = function(r, e) {
  return e(r);
};
function w6(r, e) {
  for (var t = [], n = 2; n < arguments.length; n++)
    t[n - 2] = arguments[n];
  var i = {}, a = {};
  t.forEach(function(h) {
    i = Fe(Fe(Fe({}, i), h.options), { headers: Fe(Fe({}, i.headers), h.headers) }), h.credentials && (i.credentials = h.credentials), a = Fe(Fe({}, a), h.http);
  }), i.headers && (i.headers = x6(i.headers, a.preserveHeaderCase));
  var s = r.operationName, o = r.extensions, l = r.variables, u = r.query, c = { operationName: s, variables: l };
  return a.includeExtensions && (c.extensions = o), a.includeQuery && (c.query = e(u, If)), {
    options: i,
    body: c
  };
}
function x6(r, e) {
  if (!e) {
    var t = {};
    return Object.keys(Object(r)).forEach(function(a) {
      t[a.toLowerCase()] = r[a];
    }), t;
  }
  var n = {};
  Object.keys(Object(r)).forEach(function(a) {
    n[a.toLowerCase()] = {
      originalName: a,
      value: r[a]
    };
  });
  var i = {};
  return Object.keys(n).forEach(function(a) {
    i[n[a].originalName] = n[a].value;
  }), i;
}
var b6 = function(r, e) {
  var t = r.getContext(), n = t.uri;
  return n || (typeof e == "function" ? e(r) : e || "/graphql");
};
function C6(r, e) {
  var t = [], n = function(h, f) {
    t.push("".concat(h, "=").concat(encodeURIComponent(f)));
  };
  if ("query" in e && n("query", e.query), e.operationName && n("operationName", e.operationName), e.variables) {
    var i = void 0;
    try {
      i = t1(e.variables, "Variables map");
    } catch (h) {
      return { parseError: h };
    }
    n("variables", i);
  }
  if (e.extensions) {
    var a = void 0;
    try {
      a = t1(e.extensions, "Extensions map");
    } catch (h) {
      return { parseError: h };
    }
    n("extensions", a);
  }
  var s = "", o = r, l = r.indexOf("#");
  l !== -1 && (s = r.substr(l), o = r.substr(0, l));
  var u = o.indexOf("?") === -1 ? "?" : "&", c = o + u + t.join("&") + s;
  return { newURI: c };
}
var S6 = jo(function() {
  return fetch;
}), QF = function(r) {
  r === void 0 && (r = {});
  var e = r.uri, t = e === void 0 ? "/graphql" : e, n = r.fetch, i = r.print, a = i === void 0 ? A6 : i, s = r.includeExtensions, o = r.preserveHeaderCase, l = r.useGETForQueries, u = r.includeUnusedVariables, c = u === void 0 ? !1 : u, h = Bl(r, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]), f = {
    http: { includeExtensions: s, preserveHeaderCase: o },
    options: h.fetchOptions,
    credentials: h.credentials,
    headers: h.headers
  };
  return new Ko(function(p) {
    var m = b6(p, t), A = p.getContext(), w = {};
    if (A.clientAwareness) {
      var x = A.clientAwareness, E = x.name, T = x.version;
      E && (w["apollographql-client-name"] = E), T && (w["apollographql-client-version"] = T);
    }
    var D = Fe(Fe({}, w), A.headers), F = {
      http: A.http,
      options: A.fetchOptions,
      credentials: A.credentials,
      headers: D
    };
    if (Vp(["client"], p.query)) {
      var _ = UF(p.query);
      if (!_)
        return Vv(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      p.query = _;
    }
    var L = w6(p, a, y6, f, F), Z = L.options, te = L.body;
    te.variables && !c && (te.variables = K5(te.variables, p.query));
    var de;
    !Z.signal && typeof AbortController < "u" && (de = new AbortController(), Z.signal = de.signal);
    var H = function(Ve) {
      return Ve.kind === "OperationDefinition" && Ve.operation === "mutation";
    }, j = function(Ve) {
      return Ve.kind === "OperationDefinition" && Ve.operation === "subscription";
    }, q = j(sg(p.query)), re = Vp(["defer"], p.query);
    if (l && !p.query.definitions.some(H) && (Z.method = "GET"), re || q) {
      Z.headers = Z.headers || {};
      var ae = "multipart/mixed;";
      q ? ae += "boundary=graphql;subscriptionSpec=1.0,application/json" : re && (ae += "deferSpec=20220824,application/json"), Z.headers.accept = ae;
    }
    if (Z.method === "GET") {
      var ye = C6(m, te), Se = ye.newURI, Xe = ye.parseError;
      if (Xe)
        return Vv(Xe);
      m = Se;
    } else
      try {
        Z.body = t1(te, "Payload");
      } catch (Ve) {
        return Vv(Ve);
      }
    return new ri(function(Ve) {
      var He = n || jo(function() {
        return fetch;
      }) || S6, le = Ve.next.bind(Ve);
      return He(m, Z).then(function(ve) {
        var it;
        p.setContext({ response: ve });
        var mt = (it = ve.headers) === null || it === void 0 ? void 0 : it.get("content-type");
        return mt !== null && /^multipart\/mixed/i.test(mt) ? f6(ve, le) : p6(p)(ve).then(le);
      }).then(function() {
        de = void 0, Ve.complete();
      }).catch(function(ve) {
        de = void 0, h6(ve, Ve);
      }), function() {
        de && de.abort();
      };
    });
  });
}, E6 = (
  /** @class */
  (function(r) {
    bo(e, r);
    function e(t) {
      t === void 0 && (t = {});
      var n = r.call(this, QF(t).request) || this;
      return n.options = t, n;
    }
    return e;
  })(Ko)
);
const { toString: sS, hasOwnProperty: k6 } = Object.prototype, oS = Function.prototype.toString, r1 = /* @__PURE__ */ new Map();
function Ti(r, e) {
  try {
    return n1(r, e);
  } finally {
    r1.clear();
  }
}
function n1(r, e) {
  if (r === e)
    return !0;
  const t = sS.call(r), n = sS.call(e);
  if (t !== n)
    return !1;
  switch (t) {
    case "[object Array]":
      if (r.length !== e.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (uS(r, e))
        return !0;
      const i = lS(r), a = lS(e), s = i.length;
      if (s !== a.length)
        return !1;
      for (let o = 0; o < s; ++o)
        if (!k6.call(e, i[o]))
          return !1;
      for (let o = 0; o < s; ++o) {
        const l = i[o];
        if (!n1(r[l], e[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return r.name === e.name && r.message === e.message;
    case "[object Number]":
      if (r !== r)
        return e !== e;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +r == +e;
    case "[object RegExp]":
    case "[object String]":
      return r == `${e}`;
    case "[object Map]":
    case "[object Set]": {
      if (r.size !== e.size)
        return !1;
      if (uS(r, e))
        return !0;
      const i = r.entries(), a = t === "[object Map]";
      for (; ; ) {
        const s = i.next();
        if (s.done)
          break;
        const [o, l] = s.value;
        if (!e.has(o) || a && !n1(l, e.get(o)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      r = new Uint8Array(r), e = new Uint8Array(e);
    // Fall through...
    case "[object DataView]": {
      let i = r.byteLength;
      if (i === e.byteLength)
        for (; i-- && r[i] === e[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = oS.call(r);
      return i !== oS.call(e) ? !1 : !I6(i, F6);
    }
  }
  return !1;
}
function lS(r) {
  return Object.keys(r).filter(T6, r);
}
function T6(r) {
  return this[r] !== void 0;
}
const F6 = "{ [native code] }";
function I6(r, e) {
  const t = r.length - e.length;
  return t >= 0 && r.indexOf(e, t) === t;
}
function uS(r, e) {
  let t = r1.get(r);
  if (t) {
    if (t.has(e))
      return !0;
  } else
    r1.set(r, t = /* @__PURE__ */ new Set());
  return t.add(e), !1;
}
function YF(r, e, t, n) {
  var i = e.data, a = Bl(e, ["data"]), s = t.data, o = Bl(t, ["data"]);
  return Ti(a, o) && Lm(sg(r).selectionSet, i, s, {
    fragmentMap: Yd(Kd(r)),
    variables: n
  });
}
function Lm(r, e, t, n) {
  if (e === t)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return r.selections.every(function(a) {
    if (i.has(a) || (i.add(a), !ag(a, n.variables)) || cS(a))
      return !0;
    if (Tc(a)) {
      var s = kc(a), o = e && e[s], l = t && t[s], u = a.selectionSet;
      if (!u)
        return Ti(o, l);
      var c = Array.isArray(o), h = Array.isArray(l);
      if (c !== h)
        return !1;
      if (c && h) {
        var f = o.length;
        if (l.length !== f)
          return !1;
        for (var p = 0; p < f; ++p)
          if (!Lm(u, o[p], l[p], n))
            return !1;
        return !0;
      }
      return Lm(u, o, l, n);
    } else {
      var m = _0(a, n.fragmentMap);
      if (m)
        return cS(m) ? !0 : Lm(
          m.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          e,
          t,
          n
        );
    }
  });
}
function cS(r) {
  return !!r.directives && r.directives.some(P6);
}
function P6(r) {
  return r.name.value === "nonreactive";
}
var XF = Uf ? WeakMap : Map, JF = dw ? WeakSet : Set, KF = new Zd();
function ZF(r, e, t) {
  return KF.withValue(!0, function() {
    var n = hp(r, e, t, !1);
    return n;
  });
}
function D6(r, e) {
  if (e.has(r))
    return e.get(r);
  var t = Array.isArray(r) ? [] : /* @__PURE__ */ Object.create(null);
  return e.set(r, t), t;
}
function hp(r, e, t, n, i) {
  var a = t.knownChanged, s = D6(r, t.mutableTargets);
  if (Array.isArray(r)) {
    for (var o = 0, l = Array.from(r.entries()); o < l.length; o++) {
      var u = l[o], c = u[0], h = u[1];
      if (h === null) {
        s[c] = null;
        continue;
      }
      var f = hp(h, e, t, n);
      a.has(f) && a.add(s), s[c] = f;
    }
    return a.has(s) ? s : r;
  }
  for (var p = 0, m = e.selections; p < m.length; p++) {
    var A = m[p], w = void 0;
    if (n && a.add(s), A.kind === At.FIELD) {
      var x = kc(A), E = A.selectionSet;
      if (w = s[x] || r[x], w === void 0)
        continue;
      if (E && w !== null) {
        var f = hp(r[x], E, t, n);
        a.has(f) && (w = f);
      }
      s[x] = w;
    }
    if (A.kind === At.INLINE_FRAGMENT && (!A.typeCondition || t.cache.fragmentMatches(A, r.__typename)) && (w = hp(r, A.selectionSet, t, n)), A.kind === At.FRAGMENT_SPREAD) {
      var T = A.name.value, D = t.fragmentMap[T] || (t.fragmentMap[T] = t.cache.lookupFragment(T));
      _n(D, 59, T);
      var F = LM(A);
      F !== "mask" && (w = hp(r, D.selectionSet, t, F === "migrate"));
    }
    a.has(w) && a.add(s);
  }
  return "__typename" in r && !("__typename" in s) && (s.__typename = r.__typename), Object.keys(s).length !== Object.keys(r).length && a.add(s), a.has(s) ? s : r;
}
function eI(r, e, t, n) {
  if (!t.fragmentMatches)
    return r;
  var i = e.definitions.filter(function(s) {
    return s.kind === At.FRAGMENT_DEFINITION;
  });
  typeof n > "u" && (_n(i.length === 1, 61, i.length), n = i[0].name.value);
  var a = i.find(function(s) {
    return s.name.value === n;
  });
  return _n(!!a, 62, n), r == null || Ti(r, {}) ? r : ZF(r, a.selectionSet, {
    operationName: a.name.value,
    fragmentMap: Yd(Kd(e)),
    cache: t,
    mutableTargets: new XF(),
    knownChanged: new JF()
  });
}
function R6(r, e, t) {
  var n;
  if (!t.fragmentMatches)
    return r;
  var i = Jd(e);
  return _n(i, 63), r == null ? r : ZF(r, i.selectionSet, {
    operationType: i.operation,
    operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
    fragmentMap: Yd(Kd(e)),
    cache: t,
    mutableTargets: new XF(),
    knownChanged: new JF()
  });
}
var O6 = (
  /** @class */
  (function() {
    function r() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = Nd(HM, {
        max: Tu["cache.fragmentQueryDocuments"] || 1e3,
        cache: $p
      });
    }
    return r.prototype.lookupFragment = function(e) {
      return null;
    }, r.prototype.batch = function(e) {
      var t = this, n = typeof e.optimistic == "string" ? e.optimistic : e.optimistic === !1 ? null : void 0, i;
      return this.performTransaction(function() {
        return i = e.update(t);
      }, n), i;
    }, r.prototype.recordOptimisticTransaction = function(e, t) {
      this.performTransaction(e, t);
    }, r.prototype.transformDocument = function(e) {
      return e;
    }, r.prototype.transformForLink = function(e) {
      return e;
    }, r.prototype.identify = function(e) {
    }, r.prototype.gc = function() {
      return [];
    }, r.prototype.modify = function(e) {
      return !1;
    }, r.prototype.readQuery = function(e, t) {
      var n = this;
      return t === void 0 && (t = !!e.optimistic), qa("canonizeResults", function() {
        return n.read(Fe(Fe({}, e), { rootId: e.id || "ROOT_QUERY", optimistic: t }));
      });
    }, r.prototype.watchFragment = function(e) {
      var t = this, n = e.fragment, i = e.fragmentName, a = e.from, s = e.optimistic, o = s === void 0 ? !0 : s, l = Bl(e, ["fragment", "fragmentName", "from", "optimistic"]), u = this.getFragmentDoc(n, i), c = typeof a > "u" || typeof a == "string" ? a : this.identify(a), h = !!e[/* @__PURE__ */ Symbol.for("apollo.dataMasking")], f = Fe(Fe({}, l), { returnPartialData: !0, id: c, query: u, optimistic: o }), p;
      return new ri(function(m) {
        return t.watch(Fe(Fe({}, f), { immediate: !0, callback: function(A) {
          var w = h ? eI(A.result, n, t, i) : A.result;
          if (
            // Always ensure we deliver the first result
            !(p && YF(
              u,
              { data: p.result },
              { data: w },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              e.variables
            ))
          ) {
            var x = {
              data: w,
              complete: !!A.complete
            };
            A.missing && (x.missing = U0(A.missing.map(function(E) {
              return E.missing;
            }))), p = Fe(Fe({}, A), { result: w }), m.next(x);
          }
        } }));
      });
    }, r.prototype.readFragment = function(e, t) {
      var n = this;
      return t === void 0 && (t = !!e.optimistic), qa("canonizeResults", function() {
        return n.read(Fe(Fe({}, e), { query: n.getFragmentDoc(e.fragment, e.fragmentName), rootId: e.id, optimistic: t }));
      });
    }, r.prototype.writeQuery = function(e) {
      var t = e.id, n = e.data, i = Bl(e, ["id", "data"]);
      return this.write(Object.assign(i, {
        dataId: t || "ROOT_QUERY",
        result: n
      }));
    }, r.prototype.writeFragment = function(e) {
      var t = e.id, n = e.data, i = e.fragment, a = e.fragmentName, s = Bl(e, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(s, {
        query: this.getFragmentDoc(i, a),
        dataId: t,
        result: n
      }));
    }, r.prototype.updateQuery = function(e, t) {
      return this.batch({
        update: function(n) {
          var i = qa("canonizeResults", function() {
            return n.readQuery(e);
          }), a = t(i);
          return a == null ? i : (n.writeQuery(Fe(Fe({}, e), { data: a })), a);
        }
      });
    }, r.prototype.updateFragment = function(e, t) {
      return this.batch({
        update: function(n) {
          var i = qa("canonizeResults", function() {
            return n.readFragment(e);
          }), a = t(i);
          return a == null ? i : (n.writeFragment(Fe(Fe({}, e), { data: a })), a);
        }
      });
    }, r;
  })()
), tI = (
  /** @class */
  (function(r) {
    bo(e, r);
    function e(t, n, i, a) {
      var s, o = r.call(this, t) || this;
      if (o.message = t, o.path = n, o.query = i, o.variables = a, Array.isArray(o.path)) {
        o.missing = o.message;
        for (var l = o.path.length - 1; l >= 0; --l)
          o.missing = (s = {}, s[o.path[l]] = o.missing, s);
      } else
        o.missing = o.path;
      return o.__proto__ = e.prototype, o;
    }
    return e;
  })(Error)
), ba = Object.prototype.hasOwnProperty;
function Nh(r) {
  return r == null;
}
function rI(r, e) {
  var t = r.__typename, n = r.id, i = r._id;
  if (typeof t == "string" && (e && (e.keyObject = Nh(n) ? Nh(i) ? void 0 : { _id: i } : { id: n }), Nh(n) && !Nh(i) && (n = i), !Nh(n)))
    return "".concat(t, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
}
var nI = {
  dataIdFromObject: rI,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function B6(r) {
  return Ud(nI, r);
}
function iI(r) {
  var e = r.canonizeResults;
  return e === void 0 ? nI.canonizeResults : e;
}
var aI = /^[_a-z][_0-9a-z]*/i;
function Vd(r) {
  var e = r.match(aI);
  return e ? e[0] : r;
}
function i1(r, e, t) {
  return da(e) ? sa(e) ? e.every(function(n) {
    return i1(r, n, t);
  }) : r.selections.every(function(n) {
    if (Tc(n) && ag(n, t)) {
      var i = kc(n);
      return ba.call(e, i) && (!n.selectionSet || i1(n.selectionSet, e[i], t));
    }
    return !0;
  }) : !1;
}
function bd(r) {
  return da(r) && !Ci(r) && !sa(r);
}
function _6() {
  return new Ic();
}
function sI(r, e) {
  var t = Yd(Kd(r));
  return {
    fragmentMap: t,
    lookupFragment: function(n) {
      var i = t[n];
      return !i && e && (i = e.lookup(n)), i || null;
    }
  };
}
var Um = /* @__PURE__ */ Object.create(null), $v = function() {
  return Um;
}, fS = /* @__PURE__ */ Object.create(null), Gp = (
  /** @class */
  (function() {
    function r(e, t) {
      var n = this;
      this.policies = e, this.group = t, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, a) {
        return Ci(i) ? n.get(i.__ref, a) : i && i[a];
      }, this.canRead = function(i) {
        return Ci(i) ? n.has(i.__ref) : typeof i == "object";
      }, this.toReference = function(i, a) {
        if (typeof i == "string")
          return Fd(i);
        if (Ci(i))
          return i;
        var s = n.policies.identify(i)[0];
        if (s) {
          var o = Fd(s);
          return a && n.merge(s, i), o;
        }
      };
    }
    return r.prototype.toObject = function() {
      return Fe({}, this.data);
    }, r.prototype.has = function(e) {
      return this.lookup(e, !0) !== void 0;
    }, r.prototype.get = function(e, t) {
      if (this.group.depend(e, t), ba.call(this.data, e)) {
        var n = this.data[e];
        if (n && ba.call(n, t))
          return n[t];
      }
      if (t === "__typename" && ba.call(this.policies.rootTypenamesById, e))
        return this.policies.rootTypenamesById[e];
      if (this instanceof cc)
        return this.parent.get(e, t);
    }, r.prototype.lookup = function(e, t) {
      if (t && this.group.depend(e, "__exists"), ba.call(this.data, e))
        return this.data[e];
      if (this instanceof cc)
        return this.parent.lookup(e, t);
      if (this.policies.rootTypenamesById[e])
        return /* @__PURE__ */ Object.create(null);
    }, r.prototype.merge = function(e, t) {
      var n = this, i;
      Ci(e) && (e = e.__ref), Ci(t) && (t = t.__ref);
      var a = typeof e == "string" ? this.lookup(i = e) : e, s = typeof t == "string" ? this.lookup(i = t) : t;
      if (s) {
        _n(typeof i == "string", 2);
        var o = new Ic(N6).merge(a, s);
        if (this.data[i] = o, o !== a && (delete this.refs[i], this.group.caching)) {
          var l = /* @__PURE__ */ Object.create(null);
          a || (l.__exists = 1), Object.keys(s).forEach(function(u) {
            if (!a || a[u] !== o[u]) {
              l[u] = 1;
              var c = Vd(u);
              c !== u && !n.policies.hasKeyArgs(o.__typename, c) && (l[c] = 1), o[u] === void 0 && !(n instanceof cc) && delete o[u];
            }
          }), l.__typename && !(a && a.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[i] === o.__typename && delete l.__typename, Object.keys(l).forEach(function(u) {
            return n.group.dirty(i, u);
          });
        }
      }
    }, r.prototype.modify = function(e, t) {
      var n = this, i = this.lookup(e);
      if (i) {
        var a = /* @__PURE__ */ Object.create(null), s = !1, o = !0, l = {
          DELETE: Um,
          INVALIDATE: fS,
          isReference: Ci,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(u, c) {
            return n.policies.readField(typeof u == "string" ? {
              fieldName: u,
              from: c || Fd(e)
            } : u, { store: n });
          }
        };
        if (Object.keys(i).forEach(function(u) {
          var c = Vd(u), h = i[u];
          if (h !== void 0) {
            var f = typeof t == "function" ? t : t[u] || t[c];
            if (f) {
              var p = f === $v ? Um : f(h, Fe(Fe({}, l), { fieldName: c, storeFieldName: u, storage: n.getStorage(e, u) }));
              p === fS ? n.group.dirty(e, u) : (p === Um && (p = void 0), p !== h && (a[u] = p, s = !0, h = p));
            }
            h !== void 0 && (o = !1);
          }
        }), s)
          return this.merge(e, a), o && (this instanceof cc ? this.data[e] = void 0 : delete this.data[e], this.group.dirty(e, "__exists")), !0;
      }
      return !1;
    }, r.prototype.delete = function(e, t, n) {
      var i, a = this.lookup(e);
      if (a) {
        var s = this.getFieldValue(a, "__typename"), o = t && n ? this.policies.getStoreFieldName({ typename: s, fieldName: t, args: n }) : t;
        return this.modify(e, o ? (i = {}, i[o] = $v, i) : $v);
      }
      return !1;
    }, r.prototype.evict = function(e, t) {
      var n = !1;
      return e.id && (ba.call(this.data, e.id) && (n = this.delete(e.id, e.fieldName, e.args)), this instanceof cc && this !== t && (n = this.parent.evict(e, t) || n), (e.fieldName || n) && this.group.dirty(e.id, e.fieldName || "__exists")), n;
    }, r.prototype.clear = function() {
      this.replace(null);
    }, r.prototype.extract = function() {
      var e = this, t = this.toObject(), n = [];
      return this.getRootIdSet().forEach(function(i) {
        ba.call(e.policies.rootTypenamesById, i) || n.push(i);
      }), n.length && (t.__META = { extraRootIds: n.sort() }), t;
    }, r.prototype.replace = function(e) {
      var t = this;
      if (Object.keys(this.data).forEach(function(a) {
        e && ba.call(e, a) || t.delete(a);
      }), e) {
        var n = e.__META, i = Bl(e, ["__META"]);
        Object.keys(i).forEach(function(a) {
          t.merge(a, i[a]);
        }), n && n.extraRootIds.forEach(this.retain, this);
      }
    }, r.prototype.retain = function(e) {
      return this.rootIds[e] = (this.rootIds[e] || 0) + 1;
    }, r.prototype.release = function(e) {
      if (this.rootIds[e] > 0) {
        var t = --this.rootIds[e];
        return t || delete this.rootIds[e], t;
      }
      return 0;
    }, r.prototype.getRootIdSet = function(e) {
      return e === void 0 && (e = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(e.add, e), this instanceof cc ? this.parent.getRootIdSet(e) : Object.keys(this.policies.rootTypenamesById).forEach(e.add, e), e;
    }, r.prototype.gc = function() {
      var e = this, t = this.getRootIdSet(), n = this.toObject();
      t.forEach(function(s) {
        ba.call(n, s) && (Object.keys(e.findChildRefIds(s)).forEach(t.add, t), delete n[s]);
      });
      var i = Object.keys(n);
      if (i.length) {
        for (var a = this; a instanceof cc; )
          a = a.parent;
        i.forEach(function(s) {
          return a.delete(s);
        });
      }
      return i;
    }, r.prototype.findChildRefIds = function(e) {
      if (!ba.call(this.refs, e)) {
        var t = this.refs[e] = /* @__PURE__ */ Object.create(null), n = this.data[e];
        if (!n)
          return t;
        var i = /* @__PURE__ */ new Set([n]);
        i.forEach(function(a) {
          Ci(a) && (t[a.__ref] = !0), da(a) && Object.keys(a).forEach(function(s) {
            var o = a[s];
            da(o) && i.add(o);
          });
        });
      }
      return this.refs[e];
    }, r.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, r;
  })()
), oI = (
  /** @class */
  (function() {
    function r(e, t) {
      t === void 0 && (t = null), this.caching = e, this.parent = t, this.d = null, this.resetCaching();
    }
    return r.prototype.resetCaching = function() {
      this.d = this.caching ? BF() : null, this.keyMaker = new Fu(Uf);
    }, r.prototype.depend = function(e, t) {
      if (this.d) {
        this.d(zv(e, t));
        var n = Vd(t);
        n !== t && this.d(zv(e, n)), this.parent && this.parent.depend(e, t);
      }
    }, r.prototype.dirty = function(e, t) {
      this.d && this.d.dirty(
        zv(e, t),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        t === "__exists" ? "forget" : "setDirty"
      );
    }, r;
  })()
);
function zv(r, e) {
  return e + "#" + r;
}
function dS(r, e) {
  Fp(r) && r.group.depend(e, "__exists");
}
(function(r) {
  var e = (
    /** @class */
    (function(t) {
      bo(n, t);
      function n(i) {
        var a = i.policies, s = i.resultCaching, o = s === void 0 ? !0 : s, l = i.seed, u = t.call(this, a, new oI(o)) || this;
        return u.stump = new M6(u), u.storageTrie = new Fu(Uf), l && u.replace(l), u;
      }
      return n.prototype.addLayer = function(i, a) {
        return this.stump.addLayer(i, a);
      }, n.prototype.removeLayer = function() {
        return this;
      }, n.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, n;
    })(r)
  );
  r.Root = e;
})(Gp || (Gp = {}));
var cc = (
  /** @class */
  (function(r) {
    bo(e, r);
    function e(t, n, i, a) {
      var s = r.call(this, n.policies, a) || this;
      return s.id = t, s.parent = n, s.replay = i, s.group = a, i(s), s;
    }
    return e.prototype.addLayer = function(t, n) {
      return new e(t, this, n, this.group);
    }, e.prototype.removeLayer = function(t) {
      var n = this, i = this.parent.removeLayer(t);
      return t === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(a) {
        var s = n.data[a], o = i.lookup(a);
        o ? s ? s !== o && Object.keys(s).forEach(function(l) {
          Ti(s[l], o[l]) || n.group.dirty(a, l);
        }) : (n.group.dirty(a, "__exists"), Object.keys(o).forEach(function(l) {
          n.group.dirty(a, l);
        })) : n.delete(a);
      }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
    }, e.prototype.toObject = function() {
      return Fe(Fe({}, this.parent.toObject()), this.data);
    }, e.prototype.findChildRefIds = function(t) {
      var n = this.parent.findChildRefIds(t);
      return ba.call(this.data, t) ? Fe(Fe({}, n), r.prototype.findChildRefIds.call(this, t)) : n;
    }, e.prototype.getStorage = function() {
      for (var t = this.parent; t.parent; )
        t = t.parent;
      return t.getStorage.apply(
        t,
        // @ts-expect-error
        arguments
      );
    }, e;
  })(Gp)
), M6 = (
  /** @class */
  (function(r) {
    bo(e, r);
    function e(t) {
      return r.call(this, "EntityStore.Stump", t, function() {
      }, new oI(t.group.caching, t.group)) || this;
    }
    return e.prototype.removeLayer = function() {
      return this;
    }, e.prototype.merge = function(t, n) {
      return this.parent.merge(t, n);
    }, e;
  })(cc)
);
function N6(r, e, t) {
  var n = r[t], i = e[t];
  return Ti(n, i) ? n : i;
}
function Fp(r) {
  return !!(r instanceof Gp && r.group.caching);
}
var Ni = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Iu(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function L6(r) {
  return da(r) ? sa(r) ? r.slice(0) : Fe({ __proto__: Object.getPrototypeOf(r) }, r) : r;
}
var hS = (
  /** @class */
  (function() {
    function r() {
      this.known = new (dw ? WeakSet : Set)(), this.pool = new Fu(Uf), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return r.prototype.isKnown = function(e) {
      return da(e) && this.known.has(e);
    }, r.prototype.pass = function(e) {
      if (da(e)) {
        var t = L6(e);
        return this.passes.set(t, e), t;
      }
      return e;
    }, r.prototype.admit = function(e) {
      var t = this;
      if (da(e)) {
        var n = this.passes.get(e);
        if (n)
          return n;
        var i = Object.getPrototypeOf(e);
        switch (i) {
          case Array.prototype: {
            if (this.known.has(e))
              return e;
            var a = e.map(this.admit, this), s = this.pool.lookupArray(a);
            return s.array || this.known.add(s.array = a), s.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(e))
              return e;
            var o = Object.getPrototypeOf(e), l = [o], u = this.sortedKeys(e);
            l.push(u.json);
            var c = l.length;
            u.sorted.forEach(function(p) {
              l.push(t.admit(e[p]));
            });
            var s = this.pool.lookupArray(l);
            if (!s.object) {
              var h = s.object = Object.create(o);
              this.known.add(h), u.sorted.forEach(function(p, m) {
                h[p] = l[c + m];
              });
            }
            return s.object;
          }
        }
      }
      return e;
    }, r.prototype.sortedKeys = function(e) {
      var t = Object.keys(e), n = this.pool.lookupArray(t);
      if (!n.keys) {
        t.sort();
        var i = JSON.stringify(t);
        (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: t, json: i });
      }
      return n.keys;
    }, r;
  })()
);
function pS(r) {
  return [
    r.selectionSet,
    r.objectOrReference,
    r.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    r.context.canonizeResults
  ];
}
var U6 = (
  /** @class */
  (function() {
    function r(e) {
      var t = this;
      this.knownResults = new (Uf ? WeakMap : Map)(), this.config = Ud(e, {
        addTypename: e.addTypename !== !1,
        canonizeResults: iI(e)
      }), this.canon = e.canon || new hS(), this.executeSelectionSet = Nd(function(n) {
        var i, a = n.context.canonizeResults, s = pS(n);
        s[3] = !a;
        var o = (i = t.executeSelectionSet).peek.apply(i, s);
        return o ? a ? Fe(Fe({}, o), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: t.canon.admit(o.result)
        }) : o : (dS(n.context.store, n.enclosingRef.__ref), t.execSelectionSetImpl(n));
      }, {
        max: this.config.resultCacheMaxSize || Tu["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: pS,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(n, i, a, s) {
          if (Fp(a.store))
            return a.store.makeCacheKey(n, Ci(i) ? i.__ref : i, a.varString, s);
        }
      }), this.executeSubSelectedArray = Nd(function(n) {
        return dS(n.context.store, n.enclosingRef.__ref), t.execSubSelectedArrayImpl(n);
      }, {
        max: this.config.resultCacheMaxSize || Tu["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(n) {
          var i = n.field, a = n.array, s = n.context;
          if (Fp(s.store))
            return s.store.makeCacheKey(i, a, s.varString);
        }
      });
    }
    return r.prototype.resetCanon = function() {
      this.canon = new hS();
    }, r.prototype.diffQueryAgainstStore = function(e) {
      var t = e.store, n = e.query, i = e.rootId, a = i === void 0 ? "ROOT_QUERY" : i, s = e.variables, o = e.returnPartialData, l = o === void 0 ? !0 : o, u = e.canonizeResults, c = u === void 0 ? this.config.canonizeResults : u, h = this.config.cache.policies;
      s = Fe(Fe({}, hw(p5(n))), s);
      var f = Fd(a), p = this.executeSelectionSet({
        selectionSet: sg(n).selectionSet,
        objectOrReference: f,
        enclosingRef: f,
        context: Fe({ store: t, query: n, policies: h, variables: s, varString: bc(s), canonizeResults: c }, sI(n, this.config.fragments))
      }), m;
      if (p.missing && (m = [
        new tI(V6(p.missing), p.missing, n, s)
      ], !l))
        throw m[0];
      return {
        result: p.result,
        complete: !m,
        missing: m
      };
    }, r.prototype.isFresh = function(e, t, n, i) {
      if (Fp(i.store) && this.knownResults.get(e) === n) {
        var a = this.executeSelectionSet.peek(
          n,
          t,
          i,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(e)
        );
        if (a && e === a.result)
          return !0;
      }
      return !1;
    }, r.prototype.execSelectionSetImpl = function(e) {
      var t = this, n = e.selectionSet, i = e.objectOrReference, a = e.enclosingRef, s = e.context;
      if (Ci(i) && !s.policies.rootTypenamesById[i.__ref] && !s.store.has(i.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(i.__ref, " object")
        };
      var o = s.variables, l = s.policies, u = s.store, c = u.getFieldValue(i, "__typename"), h = [], f, p = new Ic();
      this.config.addTypename && typeof c == "string" && !l.rootIdsByTypename[c] && h.push({ __typename: c });
      function m(T, D) {
        var F;
        return T.missing && (f = p.merge(f, (F = {}, F[D] = T.missing, F))), T.result;
      }
      var A = new Set(n.selections);
      A.forEach(function(T) {
        var D, F;
        if (ag(T, o))
          if (Tc(T)) {
            var _ = l.readField({
              fieldName: T.name.value,
              field: T,
              variables: s.variables,
              from: i
            }, s), L = kc(T);
            _ === void 0 ? LF.added(T) || (f = p.merge(f, (D = {}, D[L] = "Can't find field '".concat(T.name.value, "' on ").concat(Ci(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), D))) : sa(_) ? _.length > 0 && (_ = m(t.executeSubSelectedArray({
              field: T,
              array: _,
              enclosingRef: a,
              context: s
            }), L)) : T.selectionSet ? _ != null && (_ = m(t.executeSelectionSet({
              selectionSet: T.selectionSet,
              objectOrReference: _,
              enclosingRef: Ci(_) ? _ : a,
              context: s
            }), L)) : s.canonizeResults && (_ = t.canon.pass(_)), _ !== void 0 && h.push((F = {}, F[L] = _, F));
          } else {
            var Z = _0(T, s.lookupFragment);
            if (!Z && T.kind === At.FRAGMENT_SPREAD)
              throw Ts(10, T.name.value);
            Z && l.fragmentMatches(Z, c) && Z.selectionSet.selections.forEach(A.add, A);
          }
      });
      var w = U0(h), x = { result: w, missing: f }, E = s.canonizeResults ? this.canon.admit(x) : x;
      return E.result && this.knownResults.set(E.result, n), E;
    }, r.prototype.execSubSelectedArrayImpl = function(e) {
      var t = this, n = e.field, i = e.array, a = e.enclosingRef, s = e.context, o, l = new Ic();
      function u(c, h) {
        var f;
        return c.missing && (o = l.merge(o, (f = {}, f[h] = c.missing, f))), c.result;
      }
      return n.selectionSet && (i = i.filter(s.store.canRead)), i = i.map(function(c, h) {
        return c === null ? null : sa(c) ? u(t.executeSubSelectedArray({
          field: n,
          array: c,
          enclosingRef: a,
          context: s
        }), h) : n.selectionSet ? u(t.executeSelectionSet({
          selectionSet: n.selectionSet,
          objectOrReference: c,
          enclosingRef: Ci(c) ? c : a,
          context: s
        }), h) : c;
      }), {
        result: s.canonizeResults ? this.canon.admit(i) : i,
        missing: o
      };
    }, r;
  })()
);
function V6(r) {
  try {
    JSON.stringify(r, function(e, t) {
      if (typeof t == "string")
        throw t;
      return t;
    });
  } catch (e) {
    return e;
  }
}
var Cw = new Zd(), gS = /* @__PURE__ */ new WeakMap();
function Ip(r) {
  var e = gS.get(r);
  return e || gS.set(r, e = {
    vars: /* @__PURE__ */ new Set(),
    dep: BF()
  }), e;
}
function mS(r) {
  Ip(r).vars.forEach(function(e) {
    return e.forgetCache(r);
  });
}
function $6(r) {
  Ip(r).vars.forEach(function(e) {
    return e.attachCache(r);
  });
}
function z6(r) {
  var e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Set(), n = function(a) {
    if (arguments.length > 0) {
      if (r !== a) {
        r = a, e.forEach(function(l) {
          Ip(l).dep.dirty(n), G6(l);
        });
        var s = Array.from(t);
        t.clear(), s.forEach(function(l) {
          return l(r);
        });
      }
    } else {
      var o = Cw.getValue();
      o && (i(o), Ip(o).dep(n));
    }
    return r;
  };
  n.onNextChange = function(a) {
    return t.add(a), function() {
      t.delete(a);
    };
  };
  var i = n.attachCache = function(a) {
    return e.add(a), Ip(a).vars.add(n), n;
  };
  return n.forgetCache = function(a) {
    return e.delete(a);
  }, n;
}
function G6(r) {
  r.broadcastWatches && r.broadcastWatches();
}
var vS = /* @__PURE__ */ Object.create(null);
function Sw(r) {
  var e = JSON.stringify(r);
  return vS[e] || (vS[e] = /* @__PURE__ */ Object.create(null));
}
function yS(r) {
  var e = Sw(r);
  return e.keyFieldsFn || (e.keyFieldsFn = function(t, n) {
    var i = function(s, o) {
      return n.readField(o, s);
    }, a = n.keyObject = Ew(r, function(s) {
      var o = Pd(
        n.storeObject,
        s,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        i
      );
      return o === void 0 && t !== n.storeObject && ba.call(t, s[0]) && (o = Pd(t, s, uI)), _n(o !== void 0, 5, s.join("."), t), o;
    });
    return "".concat(n.typename, ":").concat(JSON.stringify(a));
  });
}
function AS(r) {
  var e = Sw(r);
  return e.keyArgsFn || (e.keyArgsFn = function(t, n) {
    var i = n.field, a = n.variables, s = n.fieldName, o = Ew(r, function(u) {
      var c = u[0], h = c.charAt(0);
      if (h === "@") {
        if (i && Ml(i.directives)) {
          var f = c.slice(1), p = i.directives.find(function(x) {
            return x.name.value === f;
          }), m = p && M0(p, a);
          return m && Pd(
            m,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            u.slice(1)
          );
        }
        return;
      }
      if (h === "$") {
        var A = c.slice(1);
        if (a && ba.call(a, A)) {
          var w = u.slice(0);
          return w[0] = A, Pd(a, w);
        }
        return;
      }
      if (t)
        return Pd(t, u);
    }), l = JSON.stringify(o);
    return (t || l !== "{}") && (s += ":" + l), s;
  });
}
function Ew(r, e) {
  var t = new Ic();
  return lI(r).reduce(function(n, i) {
    var a, s = e(i);
    if (s !== void 0) {
      for (var o = i.length - 1; o >= 0; --o)
        s = (a = {}, a[i[o]] = s, a);
      n = t.merge(n, s);
    }
    return n;
  }, /* @__PURE__ */ Object.create(null));
}
function lI(r) {
  var e = Sw(r);
  if (!e.paths) {
    var t = e.paths = [], n = [];
    r.forEach(function(i, a) {
      sa(i) ? (lI(i).forEach(function(s) {
        return t.push(n.concat(s));
      }), n.length = 0) : (n.push(i), sa(r[a + 1]) || (t.push(n.slice(0)), n.length = 0));
    });
  }
  return e.paths;
}
function uI(r, e) {
  return r[e];
}
function Pd(r, e, t) {
  return t = t || uI, cI(e.reduce(function n(i, a) {
    return sa(i) ? i.map(function(s) {
      return n(s, a);
    }) : i && t(i, a);
  }, r));
}
function cI(r) {
  return da(r) ? sa(r) ? r.map(cI) : Ew(Object.keys(r).sort(), function(e) {
    return Pd(r, e);
  }) : r;
}
function a1(r) {
  return r.args !== void 0 ? r.args : r.field ? M0(r.field, r.variables) : null;
}
var H6 = function() {
}, wS = function(r, e) {
  return e.fieldName;
}, xS = function(r, e, t) {
  var n = t.mergeObjects;
  return n(r, e);
}, bS = function(r, e) {
  return e;
}, W6 = (
  /** @class */
  (function() {
    function r(e) {
      this.config = e, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = Fe({ dataIdFromObject: rI }, e), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), e.possibleTypes && this.addPossibleTypes(e.possibleTypes), e.typePolicies && this.addTypePolicies(e.typePolicies);
    }
    return r.prototype.identify = function(e, t) {
      var n, i = this, a = t && (t.typename || ((n = t.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || e.__typename;
      if (a === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var s = t && t.storeObject || e, o = Fe(Fe({}, t), { typename: a, storeObject: s, readField: t && t.readField || function() {
        var h = kw(arguments, s);
        return i.readField(h, {
          store: i.cache.data,
          variables: h.variables
        });
      } }), l, u = a && this.getTypePolicy(a), c = u && u.keyFn || this.config.dataIdFromObject;
      return KF.withValue(!0, function() {
        for (; c; ) {
          var h = c(Fe(Fe({}, e), s), o);
          if (sa(h))
            c = yS(h);
          else {
            l = h;
            break;
          }
        }
      }), l = l ? String(l) : void 0, o.keyObject ? [l, o.keyObject] : [l];
    }, r.prototype.addTypePolicies = function(e) {
      var t = this;
      Object.keys(e).forEach(function(n) {
        var i = e[n], a = i.queryType, s = i.mutationType, o = i.subscriptionType, l = Bl(i, ["queryType", "mutationType", "subscriptionType"]);
        a && t.setRootTypename("Query", n), s && t.setRootTypename("Mutation", n), o && t.setRootTypename("Subscription", n), ba.call(t.toBeAdded, n) ? t.toBeAdded[n].push(l) : t.toBeAdded[n] = [l];
      });
    }, r.prototype.updateTypePolicy = function(e, t, n) {
      var i = this.getTypePolicy(e), a = t.keyFields, s = t.fields;
      function o(l, u) {
        l.merge = typeof u == "function" ? u : u === !0 ? xS : u === !1 ? bS : l.merge;
      }
      o(i, t.merge), i.keyFn = // Pass false to disable normalization for this typename.
      a === !1 ? H6 : sa(a) ? yS(a) : typeof a == "function" ? a : i.keyFn, s && Object.keys(s).forEach(function(l) {
        var u = n[l];
        (!u || u?.typename !== e) && (u = n[l] = { typename: e });
        var c = s[l];
        if (typeof c == "function")
          u.read = c;
        else {
          var h = c.keyArgs, f = c.read, p = c.merge;
          u.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          h === !1 ? wS : sa(h) ? AS(h) : typeof h == "function" ? h : u.keyFn, typeof f == "function" && (u.read = f), o(u, p);
        }
        u.read && u.merge && (u.keyFn = u.keyFn || wS);
      });
    }, r.prototype.setRootTypename = function(e, t) {
      t === void 0 && (t = e);
      var n = "ROOT_" + e.toUpperCase(), i = this.rootTypenamesById[n];
      t !== i && (_n(!i || i === e, 6, e), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[t] = n, this.rootTypenamesById[n] = t);
    }, r.prototype.addPossibleTypes = function(e) {
      var t = this;
      this.usingPossibleTypes = !0, Object.keys(e).forEach(function(n) {
        t.getSupertypeSet(n, !0), e[n].forEach(function(i) {
          t.getSupertypeSet(i, !0).add(n);
          var a = i.match(aI);
          (!a || a[0] !== i) && t.fuzzySubtypes.set(i, new RegExp(i));
        });
      });
    }, r.prototype.getTypePolicy = function(e) {
      var t = this;
      if (!ba.call(this.typePolicies, e)) {
        var n = this.typePolicies[e] = /* @__PURE__ */ Object.create(null);
        n.fields = /* @__PURE__ */ Object.create(null);
        var i = this.supertypeMap.get(e);
        !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(e, !0), this.fuzzySubtypes.forEach(function(s, o) {
          if (s.test(e)) {
            var l = t.supertypeMap.get(o);
            l && l.forEach(function(u) {
              return i.add(u);
            });
          }
        })), i && i.size && i.forEach(function(s) {
          var o = t.getTypePolicy(s), l = o.fields, u = Bl(o, ["fields"]);
          Object.assign(n, u), Object.assign(n.fields, l);
        });
      }
      var a = this.toBeAdded[e];
      return a && a.length && a.splice(0).forEach(function(s) {
        t.updateTypePolicy(e, s, t.typePolicies[e].fields);
      }), this.typePolicies[e];
    }, r.prototype.getFieldPolicy = function(e, t) {
      if (e)
        return this.getTypePolicy(e).fields[t];
    }, r.prototype.getSupertypeSet = function(e, t) {
      var n = this.supertypeMap.get(e);
      return !n && t && this.supertypeMap.set(e, n = /* @__PURE__ */ new Set()), n;
    }, r.prototype.fragmentMatches = function(e, t, n, i) {
      var a = this;
      if (!e.typeCondition)
        return !0;
      if (!t)
        return !1;
      var s = e.typeCondition.name.value;
      if (t === s)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(s))
        for (var o = this.getSupertypeSet(t, !0), l = [o], u = function(p) {
          var m = a.getSupertypeSet(p, !1);
          m && m.size && l.indexOf(m) < 0 && l.push(m);
        }, c = !!(n && this.fuzzySubtypes.size), h = 0; h < l.length; ++h) {
          var f = l[h];
          if (f.has(s))
            return o.has(s) || o.add(s), !0;
          f.forEach(u), c && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          h === l.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          i1(e.selectionSet, n, i) && (c = !1, this.fuzzySubtypes.forEach(function(p, m) {
            var A = t.match(p);
            A && A[0] === t && u(m);
          }));
        }
      return !1;
    }, r.prototype.hasKeyArgs = function(e, t) {
      var n = this.getFieldPolicy(e, t);
      return !!(n && n.keyFn);
    }, r.prototype.getStoreFieldName = function(e) {
      var t = e.typename, n = e.fieldName, i = this.getFieldPolicy(t, n), a, s = i && i.keyFn;
      if (s && t)
        for (var o = {
          typename: t,
          fieldName: n,
          field: e.field || null,
          variables: e.variables
        }, l = a1(e); s; ) {
          var u = s(l, o);
          if (sa(u))
            s = AS(u);
          else {
            a = u || n;
            break;
          }
        }
      return a === void 0 && (a = e.field ? f5(e.field, e.variables) : CF(n, a1(e))), a === !1 ? n : n === Vd(a) ? a : n + ":" + a;
    }, r.prototype.readField = function(e, t) {
      var n = e.from;
      if (n) {
        var i = e.field || e.fieldName;
        if (i) {
          if (e.typename === void 0) {
            var a = t.store.getFieldValue(n, "__typename");
            a && (e.typename = a);
          }
          var s = this.getStoreFieldName(e), o = Vd(s), l = t.store.getFieldValue(n, s), u = this.getFieldPolicy(e.typename, o), c = u && u.read;
          if (c) {
            var h = CS(this, n, e, t, t.store.getStorage(Ci(n) ? n.__ref : n, s));
            return Cw.withValue(this.cache, c, [
              l,
              h
            ]);
          }
          return l;
        }
      }
    }, r.prototype.getReadFunction = function(e, t) {
      var n = this.getFieldPolicy(e, t);
      return n && n.read;
    }, r.prototype.getMergeFunction = function(e, t, n) {
      var i = this.getFieldPolicy(e, t), a = i && i.merge;
      return !a && n && (i = this.getTypePolicy(n), a = i && i.merge), a;
    }, r.prototype.runMergeFunction = function(e, t, n, i, a) {
      var s = n.field, o = n.typename, l = n.merge;
      return l === xS ? fI(i.store)(e, t) : l === bS ? t : (i.overwrite && (e = void 0), l(e, t, CS(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: o,
          fieldName: s.name.value,
          field: s,
          variables: i.variables
        },
        i,
        a || /* @__PURE__ */ Object.create(null)
      )));
    }, r;
  })()
);
function CS(r, e, t, n, i) {
  var a = r.getStoreFieldName(t), s = Vd(a), o = t.variables || n.variables, l = n.store, u = l.toReference, c = l.canRead;
  return {
    args: a1(t),
    field: t.field || null,
    fieldName: s,
    storeFieldName: a,
    variables: o,
    isReference: Ci,
    toReference: u,
    storage: i,
    cache: r.cache,
    canRead: c,
    readField: function() {
      return r.readField(kw(arguments, e, o), n);
    },
    mergeObjects: fI(n.store)
  };
}
function kw(r, e, t) {
  var n = r[0], i = r[1], a = r.length, s;
  return typeof n == "string" ? s = {
    fieldName: n,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: a > 1 ? i : e
  } : (s = Fe({}, n), ba.call(s, "from") || (s.from = e)), s.variables === void 0 && (s.variables = t), s;
}
function fI(r) {
  return function(t, n) {
    if (sa(t) || sa(n))
      throw Ts(9);
    if (da(t) && da(n)) {
      var i = r.getFieldValue(t, "__typename"), a = r.getFieldValue(n, "__typename"), s = i && a && i !== a;
      if (s)
        return n;
      if (Ci(t) && bd(n))
        return r.merge(t.__ref, n), t;
      if (bd(t) && Ci(n))
        return r.merge(t, n.__ref), n;
      if (bd(t) && bd(n))
        return Fe(Fe({}, t), n);
    }
    return n;
  };
}
function Gv(r, e, t) {
  var n = "".concat(e).concat(t), i = r.flavors.get(n);
  return i || r.flavors.set(n, i = r.clientOnly === e && r.deferred === t ? r : Fe(Fe({}, r), { clientOnly: e, deferred: t })), i;
}
var j6 = (
  /** @class */
  (function() {
    function r(e, t, n) {
      this.cache = e, this.reader = t, this.fragments = n;
    }
    return r.prototype.writeToStore = function(e, t) {
      var n = this, i = t.query, a = t.result, s = t.dataId, o = t.variables, l = t.overwrite, u = Jd(i), c = _6();
      o = Fe(Fe({}, hw(u)), o);
      var h = Fe(Fe({ store: e, written: /* @__PURE__ */ Object.create(null), merge: function(p, m) {
        return c.merge(p, m);
      }, variables: o, varString: bc(o) }, sI(i, this.fragments)), { overwrite: !!l, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), f = this.processSelectionSet({
        result: a || /* @__PURE__ */ Object.create(null),
        dataId: s,
        selectionSet: u.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: h
      });
      if (!Ci(f))
        throw Ts(12, a);
      return h.incomingById.forEach(function(p, m) {
        var A = p.storeObject, w = p.mergeTree;
        p.fieldNodeSet;
        var x = Fd(m);
        if (w && w.map.size) {
          var E = n.applyMerges(w, x, A, h);
          if (Ci(E))
            return;
          A = E;
        }
        e.merge(m, A);
      }), e.retain(f.__ref), f;
    }, r.prototype.processSelectionSet = function(e) {
      var t = this, n = e.dataId, i = e.result, a = e.selectionSet, s = e.context, o = e.mergeTree, l = this.cache.policies, u = /* @__PURE__ */ Object.create(null), c = n && l.rootTypenamesById[n] || QA(i, a, s.fragmentMap) || n && s.store.get(n, "__typename");
      typeof c == "string" && (u.__typename = c);
      var h = function() {
        var T = kw(arguments, u, s.variables);
        if (Ci(T.from)) {
          var D = s.incomingById.get(T.from.__ref);
          if (D) {
            var F = l.readField(Fe(Fe({}, T), { from: D.storeObject }), s);
            if (F !== void 0)
              return F;
          }
        }
        return l.readField(T, s);
      }, f = /* @__PURE__ */ new Set();
      this.flattenFields(
        a,
        i,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        s,
        c
      ).forEach(function(T, D) {
        var F, _ = kc(D), L = i[_];
        if (f.add(D), L !== void 0) {
          var Z = l.getStoreFieldName({
            typename: c,
            fieldName: D.name.value,
            field: D,
            variables: T.variables
          }), te = SS(o, Z), de = t.processFieldValue(
            L,
            D,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            D.selectionSet ? Gv(T, !1, !1) : T,
            te
          ), H = void 0;
          D.selectionSet && (Ci(de) || bd(de)) && (H = h("__typename", de));
          var j = l.getMergeFunction(c, D.name.value, H);
          j ? te.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: D,
            typename: c,
            merge: j
          } : ES(o, Z), u = T.merge(u, (F = {}, F[Z] = de, F));
        }
      });
      try {
        var p = l.identify(i, {
          typename: c,
          selectionSet: a,
          fragmentMap: s.fragmentMap,
          storeObject: u,
          readField: h
        }), m = p[0], A = p[1];
        n = n || m, A && (u = s.merge(u, A));
      } catch (T) {
        if (!n)
          throw T;
      }
      if (typeof n == "string") {
        var w = Fd(n), x = s.written[n] || (s.written[n] = []);
        if (x.indexOf(a) >= 0 || (x.push(a), this.reader && this.reader.isFresh(i, w, a, s)))
          return w;
        var E = s.incomingById.get(n);
        return E ? (E.storeObject = s.merge(E.storeObject, u), E.mergeTree = s1(E.mergeTree, o), f.forEach(function(T) {
          return E.fieldNodeSet.add(T);
        })) : s.incomingById.set(n, {
          storeObject: u,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: l0(o) ? void 0 : o,
          fieldNodeSet: f
        }), w;
      }
      return u;
    }, r.prototype.processFieldValue = function(e, t, n, i) {
      var a = this;
      return !t.selectionSet || e === null ? e : sa(e) ? e.map(function(s, o) {
        var l = a.processFieldValue(s, t, n, SS(i, o));
        return ES(i, o), l;
      }) : this.processSelectionSet({
        result: e,
        selectionSet: t.selectionSet,
        context: n,
        mergeTree: i
      });
    }, r.prototype.flattenFields = function(e, t, n, i) {
      i === void 0 && (i = QA(t, e, n.fragmentMap));
      var a = /* @__PURE__ */ new Map(), s = this.cache.policies, o = new Fu(!1);
      return (function l(u, c) {
        var h = o.lookup(
          u,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          c.clientOnly,
          c.deferred
        );
        h.visited || (h.visited = !0, u.selections.forEach(function(f) {
          if (ag(f, n.variables)) {
            var p = c.clientOnly, m = c.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(p && m) && Ml(f.directives) && f.directives.forEach(function(x) {
                var E = x.name.value;
                if (E === "client" && (p = !0), E === "defer") {
                  var T = M0(x, n.variables);
                  (!T || T.if !== !1) && (m = !0);
                }
              }), Tc(f)
            ) {
              var A = a.get(f);
              A && (p = p && A.clientOnly, m = m && A.deferred), a.set(f, Gv(n, p, m));
            } else {
              var w = _0(f, n.lookupFragment);
              if (!w && f.kind === At.FRAGMENT_SPREAD)
                throw Ts(14, f.name.value);
              w && s.fragmentMatches(w, i, t, n.variables) && l(w.selectionSet, Gv(n, p, m));
            }
          }
        }));
      })(e, n), a;
    }, r.prototype.applyMerges = function(e, t, n, i, a) {
      var s, o = this;
      if (e.map.size && !Ci(n)) {
        var l = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !sa(n) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (Ci(t) || bd(t)) ? t : void 0
        ), u = n;
        l && !a && (a = [Ci(l) ? l.__ref : l]);
        var c, h = function(f, p) {
          return sa(f) ? typeof p == "number" ? f[p] : void 0 : i.store.getFieldValue(f, String(p));
        };
        e.map.forEach(function(f, p) {
          var m = h(l, p), A = h(u, p);
          if (A !== void 0) {
            a && a.push(p);
            var w = o.applyMerges(f, m, A, i, a);
            w !== A && (c = c || /* @__PURE__ */ new Map(), c.set(p, w)), a && _n(a.pop() === p);
          }
        }), c && (n = sa(u) ? u.slice(0) : Fe({}, u), c.forEach(function(f, p) {
          n[p] = f;
        }));
      }
      return e.info ? this.cache.policies.runMergeFunction(t, n, e.info, i, a && (s = i.store).getStorage.apply(s, a)) : n;
    }, r;
  })()
), dI = [];
function SS(r, e) {
  var t = r.map;
  return t.has(e) || t.set(e, dI.pop() || { map: /* @__PURE__ */ new Map() }), t.get(e);
}
function s1(r, e) {
  if (r === e || !e || l0(e))
    return r;
  if (!r || l0(r))
    return e;
  var t = r.info && e.info ? Fe(Fe({}, r.info), e.info) : r.info || e.info, n = r.map.size && e.map.size, i = n ? /* @__PURE__ */ new Map() : r.map.size ? r.map : e.map, a = { info: t, map: i };
  if (n) {
    var s = new Set(e.map.keys());
    r.map.forEach(function(o, l) {
      a.map.set(l, s1(o, e.map.get(l))), s.delete(l);
    }), s.forEach(function(o) {
      a.map.set(o, s1(e.map.get(o), r.map.get(o)));
    });
  }
  return a;
}
function l0(r) {
  return !r || !(r.info || r.map.size);
}
function ES(r, e) {
  var t = r.map, n = t.get(e);
  n && l0(n) && (dI.push(n), t.delete(e));
}
var q6 = (
  /** @class */
  (function(r) {
    bo(e, r);
    function e(t) {
      t === void 0 && (t = {});
      var n = r.call(this) || this;
      return n.watches = /* @__PURE__ */ new Set(), n.addTypenameTransform = new _F(LF), n.assumeImmutableResults = !0, n.makeVar = z6, n.txCount = 0, n.config = B6(t), n.addTypename = !!n.config.addTypename, n.policies = new W6({
        cache: n,
        dataIdFromObject: n.config.dataIdFromObject,
        possibleTypes: n.config.possibleTypes,
        typePolicies: n.config.typePolicies
      }), n.init(), n;
    }
    return e.prototype.init = function() {
      var t = this.data = new Gp.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = t.stump, this.resetResultCache();
    }, e.prototype.resetResultCache = function(t) {
      var n = this, i = this.storeReader, a = this.config.fragments;
      this.addTypenameTransform.resetCache(), a?.resetCaches(), this.storeWriter = new j6(this, this.storeReader = new U6({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: iI(this.config),
        canon: t ? void 0 : i && i.canon,
        fragments: a
      }), a), this.maybeBroadcastWatch = Nd(function(s, o) {
        return n.broadcastWatch(s, o);
      }, {
        max: this.config.resultCacheMaxSize || Tu["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(s) {
          var o = s.optimistic ? n.optimisticData : n.data;
          if (Fp(o)) {
            var l = s.optimistic, u = s.id, c = s.variables;
            return o.makeCacheKey(
              s.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              s.callback,
              bc({ optimistic: l, id: u, variables: c })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(s) {
        return s.resetCaching();
      });
    }, e.prototype.restore = function(t) {
      return this.init(), t && this.data.replace(t), this;
    }, e.prototype.extract = function(t) {
      return t === void 0 && (t = !1), (t ? this.optimisticData : this.data).extract();
    }, e.prototype.read = function(t) {
      var n = t.returnPartialData, i = n === void 0 ? !1 : n;
      try {
        return this.storeReader.diffQueryAgainstStore(Fe(Fe({}, t), { store: t.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
      } catch (a) {
        if (a instanceof tI)
          return null;
        throw a;
      }
    }, e.prototype.write = function(t) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, t);
      } finally {
        !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
      }
    }, e.prototype.modify = function(t) {
      if (ba.call(t, "id") && !t.id)
        return !1;
      var n = t.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, n.modify(t.id || "ROOT_QUERY", t.fields);
      } finally {
        !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
      }
    }, e.prototype.diff = function(t) {
      return this.storeReader.diffQueryAgainstStore(Fe(Fe({}, t), { store: t.optimistic ? this.optimisticData : this.data, rootId: t.id || "ROOT_QUERY", config: this.config }));
    }, e.prototype.watch = function(t) {
      var n = this;
      return this.watches.size || $6(this), this.watches.add(t), t.immediate && this.maybeBroadcastWatch(t), function() {
        n.watches.delete(t) && !n.watches.size && mS(n), n.maybeBroadcastWatch.forget(t);
      };
    }, e.prototype.gc = function(t) {
      bc.reset(), If.reset();
      var n = this.optimisticData.gc();
      return t && !this.txCount && (t.resetResultCache ? this.resetResultCache(t.resetResultIdentities) : t.resetResultIdentities && this.storeReader.resetCanon()), n;
    }, e.prototype.retain = function(t, n) {
      return (n ? this.optimisticData : this.data).retain(t);
    }, e.prototype.release = function(t, n) {
      return (n ? this.optimisticData : this.data).release(t);
    }, e.prototype.identify = function(t) {
      if (Ci(t))
        return t.__ref;
      try {
        return this.policies.identify(t)[0];
      } catch {
      }
    }, e.prototype.evict = function(t) {
      if (!t.id) {
        if (ba.call(t, "id"))
          return !1;
        t = Fe(Fe({}, t), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(t, this.data);
      } finally {
        !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
      }
    }, e.prototype.reset = function(t) {
      var n = this;
      return this.init(), bc.reset(), t && t.discardWatches ? (this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch.forget(i);
      }), this.watches.clear(), mS(this)) : this.broadcastWatches(), Promise.resolve();
    }, e.prototype.removeOptimistic = function(t) {
      var n = this.optimisticData.removeLayer(t);
      n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
    }, e.prototype.batch = function(t) {
      var n = this, i = t.update, a = t.optimistic, s = a === void 0 ? !0 : a, o = t.removeOptimistic, l = t.onWatchUpdated, u, c = function(f) {
        var p = n, m = p.data, A = p.optimisticData;
        ++n.txCount, f && (n.data = n.optimisticData = f);
        try {
          return u = i(n);
        } finally {
          --n.txCount, n.data = m, n.optimisticData = A;
        }
      }, h = /* @__PURE__ */ new Set();
      return l && !this.txCount && this.broadcastWatches(Fe(Fe({}, t), { onWatchUpdated: function(f) {
        return h.add(f), !1;
      } })), typeof s == "string" ? this.optimisticData = this.optimisticData.addLayer(s, c) : s === !1 ? c(this.data) : c(), typeof o == "string" && (this.optimisticData = this.optimisticData.removeLayer(o)), l && h.size ? (this.broadcastWatches(Fe(Fe({}, t), { onWatchUpdated: function(f, p) {
        var m = l.call(this, f, p);
        return m !== !1 && h.delete(f), m;
      } })), h.size && h.forEach(function(f) {
        return n.maybeBroadcastWatch.dirty(f);
      })) : this.broadcastWatches(t), u;
    }, e.prototype.performTransaction = function(t, n) {
      return this.batch({
        update: t,
        optimistic: n || n !== null
      });
    }, e.prototype.transformDocument = function(t) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(t));
    }, e.prototype.fragmentMatches = function(t, n) {
      return this.policies.fragmentMatches(t, n);
    }, e.prototype.lookupFragment = function(t) {
      var n;
      return ((n = this.config.fragments) === null || n === void 0 ? void 0 : n.lookup(t)) || null;
    }, e.prototype.broadcastWatches = function(t) {
      var n = this;
      this.txCount || this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch(i, t);
      });
    }, e.prototype.addFragmentsToDocument = function(t) {
      var n = this.config.fragments;
      return n ? n.transform(t) : t;
    }, e.prototype.addTypenameToDocument = function(t) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(t) : t;
    }, e.prototype.broadcastWatch = function(t, n) {
      var i = this, a = t.lastDiff, s = qa("canonizeResults", function() {
        return i.diff(t);
      });
      n && (t.optimistic && typeof n.optimistic == "string" && (s.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, t, s, a) === !1) || (!a || !Ti(a.result, s.result)) && t.callback(t.lastDiff = s, a);
    }, e;
  })(O6)
), Qn;
(function(r) {
  r[r.loading = 1] = "loading", r[r.setVariables = 2] = "setVariables", r[r.fetchMore = 3] = "fetchMore", r[r.refetch = 4] = "refetch", r[r.poll = 6] = "poll", r[r.ready = 7] = "ready", r[r.error = 8] = "error";
})(Qn || (Qn = {}));
function Cd(r) {
  return r ? r < 7 : !1;
}
var kS = Object.assign, Vm = (
  /** @class */
  (function(r) {
    bo(e, r);
    function e(t) {
      var n = t.queryManager, i = t.queryInfo, a = t.options, s = this, o = e.inactiveOnCreation.getValue();
      s = r.call(this, function(x) {
        s._getOrCreateQuery();
        try {
          var E = x._subscription._observer;
          E && !E.error && (E.error = Q6);
        } catch {
        }
        var T = !s.observers.size;
        s.observers.add(x);
        var D = s.last;
        return D && D.error ? x.error && x.error(D.error) : D && D.result && x.next && x.next(s.maskResult(D.result)), T && s.reobserve().catch(function() {
        }), function() {
          s.observers.delete(x) && !s.observers.size && s.tearDownQuery();
        };
      }) || this, s.observers = /* @__PURE__ */ new Set(), s.subscriptions = /* @__PURE__ */ new Set(), s.dirty = !1, s._getOrCreateQuery = function() {
        return o && (n.queries.set(s.queryId, i), o = !1), s.queryManager.getOrCreateQuery(s.queryId);
      }, s.queryInfo = i, s.queryManager = n, s.waitForOwnResult = Hv(a.fetchPolicy), s.isTornDown = !1, s.subscribeToMore = s.subscribeToMore.bind(s), s.maskResult = s.maskResult.bind(s);
      var l = n.defaultOptions.watchQuery, u = l === void 0 ? {} : l, c = u.fetchPolicy, h = c === void 0 ? "cache-first" : c, f = a.fetchPolicy, p = f === void 0 ? h : f, m = a.initialFetchPolicy, A = m === void 0 ? p === "standby" ? h : p : m;
      s.options = Fe(Fe({}, a), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: A,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: p
      }), s.queryId = i.queryId || n.generateQueryId();
      var w = Jd(s.query);
      return s.queryName = w && w.name && w.name.value, s;
    }
    return Object.defineProperty(e.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.result = function() {
      var t = this;
      return new Promise(function(n, i) {
        var a = {
          next: function(o) {
            n(o), t.observers.delete(a), t.observers.size || t.queryManager.removeQuery(t.queryId), setTimeout(function() {
              s.unsubscribe();
            }, 0);
          },
          error: i
        }, s = t.subscribe(a);
      });
    }, e.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, e.prototype.getCurrentFullResult = function(t) {
      var n = this;
      t === void 0 && (t = !0);
      var i = qa("getLastResult", function() {
        return n.getLastResult(!0);
      }), a = this.queryInfo.networkStatus || i && i.networkStatus || Qn.ready, s = Fe(Fe({}, i), { loading: Cd(a), networkStatus: a }), o = this.options.fetchPolicy, l = o === void 0 ? "cache-first" : o;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(Hv(l) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var u = this.queryInfo.getDiff();
        (u.complete || this.options.returnPartialData) && (s.data = u.result), Ti(s.data, {}) && (s.data = void 0), u.complete ? (delete s.partial, u.complete && s.networkStatus === Qn.loading && (l === "cache-first" || l === "cache-only") && (s.networkStatus = Qn.ready, s.loading = !1)) : s.partial = !0, s.networkStatus === Qn.ready && (s.error || s.errors) && (s.networkStatus = Qn.error);
      }
      return t && this.updateLastResult(s), s;
    }, e.prototype.getCurrentResult = function(t) {
      return t === void 0 && (t = !0), this.maskResult(this.getCurrentFullResult(t));
    }, e.prototype.isDifferentFromLastResult = function(t, n) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), a = this.queryManager.dataMasking, s = a ? i.nonReactiveQuery : this.query, o = a || i.hasNonreactiveDirective ? !YF(s, this.last.result, t, this.variables) : !Ti(this.last.result, t);
      return o || n && !Ti(this.last.variables, n);
    }, e.prototype.getLast = function(t, n) {
      var i = this.last;
      if (i && i[t] && (!n || Ti(i.variables, this.variables)))
        return i[t];
    }, e.prototype.getLastResult = function(t) {
      return this.getLast("result", t);
    }, e.prototype.getLastError = function(t) {
      return this.getLast("error", t);
    }, e.prototype.resetLastResults = function() {
      delete this.last, this.isTornDown = !1;
    }, e.prototype.resetQueryStoreErrors = function() {
      this.queryManager.resetErrors(this.queryId);
    }, e.prototype.refetch = function(t) {
      var n = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, i = this.options.fetchPolicy;
      return i === "no-cache" ? n.fetchPolicy = "no-cache" : n.fetchPolicy = "network-only", t && !Ti(this.options.variables, t) && (n.variables = this.options.variables = Fe(Fe({}, this.options.variables), t)), this.queryInfo.resetLastWrite(), this.reobserve(n, Qn.refetch);
    }, e.prototype.fetchMore = function(t) {
      var n = this, i = Fe(Fe({}, t.query ? t : Fe(Fe(Fe(Fe({}, this.options), { query: this.options.query }), t), { variables: Fe(Fe({}, this.options.variables), t.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var a = this.queryManager.generateQueryId();
      this.lastQuery = t.query ? this.transformDocument(this.options.query) : i.query;
      var s = this.queryInfo, o = s.networkStatus;
      s.networkStatus = Qn.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), u = t?.updateQuery, c = this.options.fetchPolicy !== "no-cache";
      return c || _n(u, 29), this.queryManager.fetchQuery(a, i, Qn.fetchMore).then(function(h) {
        if (n.queryManager.removeQuery(a), s.networkStatus === Qn.fetchMore && (s.networkStatus = o), c)
          n.queryManager.cache.batch({
            update: function(m) {
              var A = t.updateQuery;
              A ? m.updateQuery({
                query: n.query,
                variables: n.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(w) {
                return A(w, {
                  fetchMoreResult: h.data,
                  variables: i.variables
                });
              }) : m.writeQuery({
                query: i.query,
                variables: i.variables,
                data: h.data
              });
            },
            onWatchUpdated: function(m) {
              l.add(m.query);
            }
          });
        else {
          var f = n.getLast("result"), p = u(f.data, {
            fetchMoreResult: h.data,
            variables: i.variables
          });
          n.reportResult(Fe(Fe({}, f), { networkStatus: o, loading: Cd(o), data: p }), n.variables);
        }
        return n.maskResult(h);
      }).finally(function() {
        c && !l.has(n.query) && n.reobserveCacheFirst();
      });
    }, e.prototype.subscribeToMore = function(t) {
      var n = this, i = this.queryManager.startGraphQLSubscription({
        query: t.document,
        variables: t.variables,
        context: t.context
      }).subscribe({
        next: function(a) {
          var s = t.updateQuery;
          s && n.updateQuery(function(o, l) {
            return s(o, Fe({ subscriptionData: a }, l));
          });
        },
        error: function(a) {
          if (t.onError) {
            t.onError(a);
            return;
          }
        }
      });
      return this.subscriptions.add(i), function() {
        n.subscriptions.delete(i) && i.unsubscribe();
      };
    }, e.prototype.setOptions = function(t) {
      return this.reobserve(t);
    }, e.prototype.silentSetOptions = function(t) {
      var n = Ud(this.options, t || {});
      kS(this.options, n);
    }, e.prototype.setVariables = function(t) {
      var n = this;
      return Ti(this.variables, t) ? this.observers.size ? qa("observableQuery.result", function() {
        return n.result();
      }) : Promise.resolve() : (this.options.variables = t, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: t
      }, Qn.setVariables) : Promise.resolve());
    }, e.prototype.updateQuery = function(t) {
      var n = this.queryManager, i = n.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), a = i.result, s = i.complete, o = t(a, {
        variables: this.variables,
        complete: !!s,
        previousData: a
      });
      o && (n.cache.writeQuery({
        query: this.options.query,
        data: o,
        variables: this.variables
      }), n.broadcastQueries());
    }, e.prototype.startPolling = function(t) {
      this.options.pollInterval = t, this.updatePolling();
    }, e.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, e.prototype.applyNextFetchPolicy = function(t, n) {
      if (n.nextFetchPolicy) {
        var i = n.fetchPolicy, a = i === void 0 ? "cache-first" : i, s = n.initialFetchPolicy, o = s === void 0 ? a : s;
        a === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(a, {
          reason: t,
          options: n,
          observable: this,
          initialFetchPolicy: o
        }) : t === "variables-changed" ? n.fetchPolicy = o : n.fetchPolicy = n.nextFetchPolicy);
      }
      return n.fetchPolicy;
    }, e.prototype.fetch = function(t, n, i) {
      var a = this._getOrCreateQuery();
      return a.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(a, t, n, i);
    }, e.prototype.updatePolling = function() {
      var t = this;
      if (!this.queryManager.ssrMode) {
        var n = this, i = n.pollingInfo, a = n.options.pollInterval;
        if (!a || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === a)) {
          _n(a, 32);
          var s = i || (this.pollingInfo = {});
          s.interval = a;
          var o = function() {
            var u, c;
            t.pollingInfo && (!Cd(t.queryInfo.networkStatus) && !(!((c = (u = t.options).skipPollAttempt) === null || c === void 0) && c.call(u)) ? t.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: t.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, Qn.poll).then(l, l) : l());
          }, l = function() {
            var u = t.pollingInfo;
            u && (clearTimeout(u.timeout), u.timeout = setTimeout(o, u.interval));
          };
          l();
        }
      }
    }, e.prototype.updateLastResult = function(t, n) {
      var i = this;
      n === void 0 && (n = this.variables);
      var a = qa("getLastError", function() {
        return i.getLastError();
      });
      return a && this.last && !Ti(n, this.last.variables) && (a = void 0), this.last = Fe({ result: this.queryManager.assumeImmutableResults ? t : H5(t), variables: n }, a ? { error: a } : null);
    }, e.prototype.reobserveAsConcast = function(t, n) {
      var i = this;
      this.isTornDown = !1;
      var a = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        n === Qn.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        n === Qn.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        n === Qn.poll
      ), s = this.options.variables, o = this.options.fetchPolicy, l = Ud(this.options, t || {}), u = a ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : kS(this.options, l), c = this.transformDocument(u.query);
      this.lastQuery = c, a || (this.updatePolling(), t && t.variables && !Ti(t.variables, s) && // Don't mess with the fetchPolicy if it's currently "standby".
      u.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (u.fetchPolicy === o || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof u.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", u), n === void 0 && (n = Qn.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = Hv(u.fetchPolicy));
      var h = function() {
        i.concast === m && (i.waitForOwnResult = !1);
      }, f = u.variables && Fe({}, u.variables), p = this.fetch(u, n, c), m = p.concast, A = p.fromLink, w = {
        next: function(x) {
          Ti(i.variables, f) && (h(), i.reportResult(x, f));
        },
        error: function(x) {
          Ti(i.variables, f) && (jF(x) || (x = new hc({ networkError: x })), h(), i.reportError(x, f));
        }
      };
      return !a && (A || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = m, this.observer = w), m.addObserver(w), m;
    }, e.prototype.reobserve = function(t, n) {
      return z5(this.reobserveAsConcast(t, n).promise.then(this.maskResult));
    }, e.prototype.resubscribeAfterError = function() {
      for (var t = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var a = this.last;
      qa("resetLastResults", function() {
        return t.resetLastResults();
      });
      var s = this.subscribe.apply(this, n);
      return this.last = a, s;
    }, e.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, e.prototype.reportResult = function(t, n) {
      var i = this, a = qa("getLastError", function() {
        return i.getLastError();
      }), s = this.isDifferentFromLastResult(t, n);
      (a || !t.partial || this.options.returnPartialData) && this.updateLastResult(t, n), (a || s) && Tp(this.observers, "next", this.maskResult(t));
    }, e.prototype.reportError = function(t, n) {
      var i = this, a = Fe(Fe({}, qa("getLastResult", function() {
        return i.getLastResult();
      })), { error: t, errors: t.graphQLErrors, networkStatus: Qn.error, loading: !1 });
      this.updateLastResult(a, n), Tp(this.observers, "error", this.last.error = t);
    }, e.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, e.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(t) {
        return t.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, e.prototype.transformDocument = function(t) {
      return this.queryManager.transform(t);
    }, e.prototype.maskResult = function(t) {
      return t && "data" in t ? Fe(Fe({}, t), { data: this.queryManager.maskOperation({
        document: this.query,
        data: t.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : t;
    }, e.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, e.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, e.prototype.scheduleNotify = function() {
      var t = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return t.notify();
      }, 0)));
    }, e.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !Cd(this.queryInfo.networkStatus))) {
        var t = this.queryInfo.getDiff();
        t.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, e.prototype.reobserveCacheFirst = function() {
      var t = this.options, n = t.fetchPolicy, i = t.nextFetchPolicy;
      return n === "cache-and-network" || n === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(a, s) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(a, s) : n;
        }
      }) : this.reobserve();
    }, e.inactiveOnCreation = new Zd(), e;
  })(ri)
);
GF(Vm);
function Q6(r) {
}
function Hv(r) {
  return r === "network-only" || r === "no-cache" || r === "standby";
}
var Sd = new (Uf ? WeakMap : Map)();
function Wv(r, e) {
  var t = r[e];
  typeof t == "function" && (r[e] = function() {
    return Sd.set(
      r,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (Sd.get(r) + 1) % 1e15
    ), t.apply(this, arguments);
  });
}
var jv = (
  /** @class */
  (function() {
    function r(e, t) {
      t === void 0 && (t = e.generateQueryId()), this.queryId = t, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var n = this.cache = e.cache;
      Sd.has(n) || (Sd.set(n, 0), Wv(n, "evict"), Wv(n, "modify"), Wv(n, "reset"));
    }
    return r.prototype.init = function(e) {
      var t = e.networkStatus || Qn.loading;
      return this.variables && this.networkStatus !== Qn.loading && !Ti(this.variables, e.variables) && (t = Qn.setVariables), Ti(e.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: e.document,
        variables: e.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: t
      }), e.observableQuery && this.setObservableQuery(e.observableQuery), e.lastRequestId && (this.lastRequestId = e.lastRequestId), this;
    }, r.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, r.prototype.getDiff = function() {
      var e = this, t = this.getDiffOptions();
      if (this.lastDiff && Ti(t, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var n = this.observableQuery;
      if (n && n.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = qa("canonizeResults", function() {
        return e.cache.diff(t);
      });
      return this.updateLastDiff(i, t), i;
    }, r.prototype.updateLastDiff = function(e, t) {
      this.lastDiff = e ? {
        diff: e,
        options: t || this.getDiffOptions()
      } : void 0;
    }, r.prototype.getDiffOptions = function(e) {
      var t;
      return e === void 0 && (e = this.variables), {
        query: this.document,
        variables: e,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (t = this.observableQuery) === null || t === void 0 ? void 0 : t.options.canonizeResults
      };
    }, r.prototype.setDiff = function(e) {
      var t = this, n, i = this.lastDiff && this.lastDiff.diff;
      e && !e.complete && qa("getLastError", function() {
        var a;
        return (a = t.observableQuery) === null || a === void 0 ? void 0 : a.getLastError();
      }) || (this.updateLastDiff(e), Ti(i && i.result, e && e.result) || (n = this.observableQuery) === null || n === void 0 || n.scheduleNotify());
    }, r.prototype.setObservableQuery = function(e) {
      e !== this.observableQuery && (this.observableQuery = e, e && (e.queryInfo = this));
    }, r.prototype.stop = function() {
      var e;
      if (!this.stopped) {
        this.stopped = !0, (e = this.observableQuery) === null || e === void 0 || e.resetNotifications(), this.cancel();
        var t = this.observableQuery;
        t && t.stopPolling();
      }
    }, r.prototype.cancel = function() {
      var e;
      (e = this.cancelWatch) === null || e === void 0 || e.call(this), this.cancelWatch = void 0;
    }, r.prototype.updateWatch = function(e) {
      var t = this;
      e === void 0 && (e = this.variables);
      var n = this.observableQuery;
      if (!(n && n.options.fetchPolicy === "no-cache")) {
        var i = Fe(Fe({}, this.getDiffOptions(e)), { watcher: this, callback: function(a) {
          return t.setDiff(a);
        } });
        (!this.lastWatch || !Ti(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, r.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, r.prototype.shouldWrite = function(e, t) {
      var n = this.lastWrite;
      return !(n && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      n.dmCount === Sd.get(this.cache) && Ti(t, n.variables) && Ti(e.data, n.result.data));
    }, r.prototype.markResult = function(e, t, n, i) {
      var a = this, s, o = new Ic(), l = Ml(e.errors) ? e.errors.slice(0) : [];
      if ((s = this.observableQuery) === null || s === void 0 || s.resetNotifications(), "incremental" in e && Ml(e.incremental)) {
        var u = HF(this.getDiff().result, e);
        e.data = u;
      } else if ("hasNext" in e && e.hasNext) {
        var c = this.getDiff();
        e.data = o.merge(c.result, e.data);
      }
      this.graphQLErrors = l, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: e.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (o1(e, n.errorPolicy) ? this.cache.performTransaction(function(h) {
        if (a.shouldWrite(e, n.variables))
          h.writeQuery({
            query: t,
            data: e.data,
            variables: n.variables,
            overwrite: i === 1
          }), a.lastWrite = {
            result: e,
            variables: n.variables,
            dmCount: Sd.get(a.cache)
          };
        else if (a.lastDiff && a.lastDiff.diff.complete) {
          e.data = a.lastDiff.diff.result;
          return;
        }
        var f = a.getDiffOptions(n.variables), p = qa("canonizeResults", function() {
          return h.diff(f);
        });
        !a.stopped && Ti(a.variables, n.variables) && a.updateWatch(n.variables), a.updateLastDiff(p, f), p.complete && (e.data = p.result);
      }) : this.lastWrite = void 0);
    }, r.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = Qn.ready;
    }, r.prototype.markError = function(e) {
      var t;
      return this.networkStatus = Qn.error, this.lastWrite = void 0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), e.graphQLErrors && (this.graphQLErrors = e.graphQLErrors), e.networkError && (this.networkError = e.networkError), e;
    }, r;
  })()
);
function o1(r, e) {
  e === void 0 && (e = "none");
  var t = e === "ignore" || e === "all", n = !Nm(r);
  return !n && t && r.data && (n = !0), n;
}
var Y6 = Object.prototype.hasOwnProperty, TS = /* @__PURE__ */ Object.create(null), X6 = (
  /** @class */
  (function() {
    function r(e) {
      var t = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new bF(
        Tu["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new Fu(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var n = new _F(
        function(a) {
          return t.cache.transformDocument(a);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = e.cache, this.link = e.link, this.defaultOptions = e.defaultOptions, this.queryDeduplication = e.queryDeduplication, this.clientAwareness = e.clientAwareness, this.localState = e.localState, this.ssrMode = e.ssrMode, this.assumeImmutableResults = e.assumeImmutableResults, this.dataMasking = e.dataMasking;
      var i = e.documentTransform;
      this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = e.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = e.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return r.prototype.stop = function() {
      var e = this;
      this.queries.forEach(function(t, n) {
        e.stopQueryNoBroadcast(n);
      }), this.cancelPendingFetches(Ts(35));
    }, r.prototype.cancelPendingFetches = function(e) {
      this.fetchCancelFns.forEach(function(t) {
        return t(e);
      }), this.fetchCancelFns.clear();
    }, r.prototype.mutate = function(e) {
      return Il(this, arguments, void 0, function(t) {
        var n, i, a, s, o, l, u, c = t.mutation, h = t.variables, f = t.optimisticResponse, p = t.updateQueries, m = t.refetchQueries, A = m === void 0 ? [] : m, w = t.awaitRefetchQueries, x = w === void 0 ? !1 : w, E = t.update, T = t.onQueryUpdated, D = t.fetchPolicy, F = D === void 0 ? ((l = this.defaultOptions.mutate) === null || l === void 0 ? void 0 : l.fetchPolicy) || "network-only" : D, _ = t.errorPolicy, L = _ === void 0 ? ((u = this.defaultOptions.mutate) === null || u === void 0 ? void 0 : u.errorPolicy) || "none" : _, Z = t.keepRootFields, te = t.context;
        return Pl(this, function(de) {
          switch (de.label) {
            case 0:
              return _n(c, 36), _n(F === "network-only" || F === "no-cache", 37), n = this.generateMutationId(), c = this.cache.transformForLink(this.transform(c)), i = this.getDocumentInfo(c).hasClientExports, h = this.getVariables(c, h), i ? [4, this.localState.addExportedVariables(c, h, te)] : [3, 2];
            case 1:
              h = de.sent(), de.label = 2;
            case 2:
              return a = this.mutationStore && (this.mutationStore[n] = {
                mutation: c,
                variables: h,
                loading: !0,
                error: null
              }), s = f && this.markMutationOptimistic(f, {
                mutationId: n,
                document: c,
                variables: h,
                fetchPolicy: F,
                errorPolicy: L,
                context: te,
                updateQueries: p,
                update: E,
                keepRootFields: Z
              }), this.broadcastQueries(), o = this, [2, new Promise(function(H, j) {
                return Nv(o.getObservableFromLink(c, Fe(Fe({}, te), { optimisticResponse: s ? f : void 0 }), h, {}, !1), function(q) {
                  if (Nm(q) && L === "none")
                    throw new hc({
                      graphQLErrors: KA(q)
                    });
                  a && (a.loading = !1, a.error = null);
                  var re = Fe({}, q);
                  return typeof A == "function" && (A = A(re)), L === "ignore" && Nm(re) && delete re.errors, o.markMutationResult({
                    mutationId: n,
                    result: re,
                    document: c,
                    variables: h,
                    fetchPolicy: F,
                    errorPolicy: L,
                    context: te,
                    update: E,
                    updateQueries: p,
                    awaitRefetchQueries: x,
                    refetchQueries: A,
                    removeOptimistic: s ? n : void 0,
                    onQueryUpdated: T,
                    keepRootFields: Z
                  });
                }).subscribe({
                  next: function(q) {
                    o.broadcastQueries(), (!("hasNext" in q) || q.hasNext === !1) && H(Fe(Fe({}, q), { data: o.maskOperation({
                      document: c,
                      data: q.data,
                      fetchPolicy: F,
                      id: n
                    }) }));
                  },
                  error: function(q) {
                    a && (a.loading = !1, a.error = q), s && o.cache.removeOptimistic(n), o.broadcastQueries(), j(q instanceof hc ? q : new hc({
                      networkError: q
                    }));
                  }
                });
              })];
          }
        });
      });
    }, r.prototype.markMutationResult = function(e, t) {
      var n = this;
      t === void 0 && (t = this.cache);
      var i = e.result, a = [], s = e.fetchPolicy === "no-cache";
      if (!s && o1(i, e.errorPolicy)) {
        if (Id(i) || a.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: e.document,
          variables: e.variables
        }), Id(i) && Ml(i.incremental)) {
          var o = t.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(e.document).asQuery,
            variables: e.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          o.result && (l = HF(o.result, i)), typeof l < "u" && (i.data = l, a.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: e.document,
            variables: e.variables
          }));
        }
        var u = e.updateQueries;
        u && this.queries.forEach(function(h, f) {
          var p = h.observableQuery, m = p && p.queryName;
          if (!(!m || !Y6.call(u, m))) {
            var A = u[m], w = n.queries.get(f), x = w.document, E = w.variables, T = t.diff({
              query: x,
              variables: E,
              returnPartialData: !0,
              optimistic: !1
            }), D = T.result, F = T.complete;
            if (F && D) {
              var _ = A(D, {
                mutationResult: i,
                queryName: x && _m(x) || void 0,
                queryVariables: E
              });
              _ && a.push({
                result: _,
                dataId: "ROOT_QUERY",
                query: x,
                variables: E
              });
            }
          }
        });
      }
      if (a.length > 0 || (e.refetchQueries || "").length > 0 || e.update || e.onQueryUpdated || e.removeOptimistic) {
        var c = [];
        if (this.refetchQueries({
          updateCache: function(h) {
            s || a.forEach(function(A) {
              return h.write(A);
            });
            var f = e.update, p = !j5(i) || Id(i) && !i.hasNext;
            if (f) {
              if (!s) {
                var m = h.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: n.getDocumentInfo(e.document).asQuery,
                  variables: e.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                m.complete && (i = Fe(Fe({}, i), { data: m.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              p && f(h, i, {
                context: e.context,
                variables: e.variables
              });
            }
            !s && !e.keepRootFields && p && h.modify({
              id: "ROOT_MUTATION",
              fields: function(A, w) {
                var x = w.fieldName, E = w.DELETE;
                return x === "__typename" ? A : E;
              }
            });
          },
          include: e.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: e.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: e.onQueryUpdated || null
        }).forEach(function(h) {
          return c.push(h);
        }), e.awaitRefetchQueries || e.onQueryUpdated)
          return Promise.all(c).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, r.prototype.markMutationOptimistic = function(e, t) {
      var n = this, i = typeof e == "function" ? e(t.variables, { IGNORE: TS }) : e;
      return i === TS ? !1 : (this.cache.recordOptimisticTransaction(function(a) {
        try {
          n.markMutationResult(Fe(Fe({}, t), { result: { data: i } }), a);
        } catch {
        }
      }, t.mutationId), !0);
    }, r.prototype.fetchQuery = function(e, t, n) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(e), t, n).concast.promise;
    }, r.prototype.getQueryStore = function() {
      var e = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(t, n) {
        e[n] = {
          variables: t.variables,
          networkStatus: t.networkStatus,
          networkError: t.networkError,
          graphQLErrors: t.graphQLErrors
        };
      }), e;
    }, r.prototype.resetErrors = function(e) {
      var t = this.queries.get(e);
      t && (t.networkError = void 0, t.graphQLErrors = []);
    }, r.prototype.transform = function(e) {
      return this.documentTransform.transformDocument(e);
    }, r.prototype.getDocumentInfo = function(e) {
      var t = this.transformCache;
      if (!t.has(e)) {
        var n = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: _M(e),
          hasForcedResolvers: this.localState.shouldForceResolvers(e),
          hasNonreactiveDirective: Vp(["nonreactive"], e),
          nonReactiveQuery: D5(e),
          clientQuery: this.localState.clientQuery(e),
          serverQuery: NF([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], e),
          defaultVars: hw(Jd(e)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: Fe(Fe({}, e), { definitions: e.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? Fe(Fe({}, i), { operation: "query" }) : i;
          }) })
        };
        t.set(e, n);
      }
      return t.get(e);
    }, r.prototype.getVariables = function(e, t) {
      return Fe(Fe({}, this.getDocumentInfo(e).defaultVars), t);
    }, r.prototype.watchQuery = function(e) {
      var t = this.transform(e.query);
      e = Fe(Fe({}, e), { variables: this.getVariables(t, e.variables) }), typeof e.notifyOnNetworkStatusChange > "u" && (e.notifyOnNetworkStatusChange = !1);
      var n = new jv(this), i = new Vm({
        queryManager: this,
        queryInfo: n,
        options: e
      });
      return i.lastQuery = t, Vm.inactiveOnCreation.getValue() || this.queries.set(i.queryId, n), n.init({
        document: t,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, r.prototype.query = function(e, t) {
      var n = this;
      t === void 0 && (t = this.generateQueryId()), _n(e.query, 38), _n(e.query.kind === "Document", 39), _n(!e.returnPartialData, 40), _n(!e.pollInterval, 41);
      var i = this.transform(e.query);
      return this.fetchQuery(t, Fe(Fe({}, e), { query: i })).then(function(a) {
        return a && Fe(Fe({}, a), { data: n.maskOperation({
          document: i,
          data: a.data,
          fetchPolicy: e.fetchPolicy,
          id: t
        }) });
      }).finally(function() {
        return n.stopQuery(t);
      });
    }, r.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, r.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, r.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, r.prototype.stopQueryInStore = function(e) {
      this.stopQueryInStoreNoBroadcast(e), this.broadcastQueries();
    }, r.prototype.stopQueryInStoreNoBroadcast = function(e) {
      var t = this.queries.get(e);
      t && t.stop();
    }, r.prototype.clearStore = function(e) {
      return e === void 0 && (e = {
        discardWatches: !0
      }), this.cancelPendingFetches(Ts(42)), this.queries.forEach(function(t) {
        t.observableQuery ? t.networkStatus = Qn.loading : t.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(e);
    }, r.prototype.getObservableQueries = function(e) {
      var t = this;
      e === void 0 && (e = "active");
      var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set();
      return Array.isArray(e) && e.forEach(function(o) {
        if (typeof o == "string")
          i.set(o, o), a.set(o, !1);
        else if (t5(o)) {
          var l = If(t.transform(o));
          i.set(l, _m(o)), a.set(l, !1);
        } else da(o) && o.query && s.add(o);
      }), this.queries.forEach(function(o, l) {
        var u = o.observableQuery, c = o.document;
        if (u) {
          if (e === "all") {
            n.set(l, u);
            return;
          }
          var h = u.queryName, f = u.options.fetchPolicy;
          if (f === "standby" || e === "active" && !u.hasObservers())
            return;
          (e === "active" || h && a.has(h) || c && a.has(If(c))) && (n.set(l, u), h && a.set(h, !0), c && a.set(If(c), !0));
        }
      }), s.size && s.forEach(function(o) {
        var l = zA("legacyOneTimeQuery"), u = t.getOrCreateQuery(l).init({
          document: o.query,
          variables: o.variables
        }), c = new Vm({
          queryManager: t,
          queryInfo: u,
          options: Fe(Fe({}, o), { fetchPolicy: "network-only" })
        });
        _n(c.queryId === l), u.setObservableQuery(c), n.set(l, c);
      }), n;
    }, r.prototype.reFetchObservableQueries = function(e) {
      var t = this;
      e === void 0 && (e = !1);
      var n = [];
      return this.getObservableQueries(e ? "all" : "active").forEach(function(i, a) {
        var s = i.options.fetchPolicy;
        qa("resetLastResults", function() {
          return i.resetLastResults();
        }), (e || s !== "standby" && s !== "cache-only") && n.push(i.refetch()), (t.queries.get(a) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(n);
    }, r.prototype.startGraphQLSubscription = function(e) {
      var t = this, n = e.query, i = e.variables, a = e.fetchPolicy, s = e.errorPolicy, o = s === void 0 ? "none" : s, l = e.context, u = l === void 0 ? {} : l, c = e.extensions, h = c === void 0 ? {} : c;
      n = this.transform(n), i = this.getVariables(n, i);
      var f = function(m) {
        return t.getObservableFromLink(n, u, m, h).map(function(A) {
          a !== "no-cache" && (o1(A, o) && t.cache.write({
            query: n,
            result: A.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: m
          }), t.broadcastQueries());
          var w = Nm(A), x = bw(A);
          if (w || x) {
            var E = {};
            if (w && (E.graphQLErrors = A.errors), x && (E.protocolErrors = A.extensions[og]), o === "none" || x)
              throw new hc(E);
          }
          return o === "ignore" && delete A.errors, A;
        });
      };
      if (this.getDocumentInfo(n).hasClientExports) {
        var p = this.localState.addExportedVariables(n, i, u).then(f);
        return new ri(function(m) {
          var A = null;
          return p.then(function(w) {
            return A = w.subscribe(m);
          }, m.error), function() {
            return A && A.unsubscribe();
          };
        });
      }
      return f(i);
    }, r.prototype.stopQuery = function(e) {
      this.stopQueryNoBroadcast(e), this.broadcastQueries();
    }, r.prototype.stopQueryNoBroadcast = function(e) {
      this.stopQueryInStoreNoBroadcast(e), this.removeQuery(e);
    }, r.prototype.removeQuery = function(e) {
      var t;
      this.fetchCancelFns.delete(e), this.queries.has(e) && ((t = this.queries.get(e)) === null || t === void 0 || t.stop(), this.queries.delete(e));
    }, r.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(e) {
        var t;
        return (t = e.observableQuery) === null || t === void 0 ? void 0 : t.notify();
      });
    }, r.prototype.getLocalState = function() {
      return this.localState;
    }, r.prototype.getObservableFromLink = function(e, t, n, i, a) {
      var s = this, o;
      a === void 0 && (a = (o = t?.queryDeduplication) !== null && o !== void 0 ? o : this.queryDeduplication);
      var l, u = this.getDocumentInfo(e), c = u.serverQuery, h = u.clientQuery;
      if (c) {
        var f = this, p = f.inFlightLinkObservables, m = f.link, A = {
          query: c,
          variables: n,
          operationName: _m(c) || void 0,
          context: this.prepareContext(Fe(Fe({}, t), { forceFetch: !a })),
          extensions: i
        };
        if (t = A.context, a) {
          var w = If(c), x = bc(n), E = p.lookup(w, x);
          if (l = E.observable, !l) {
            var T = new Ad([
              e1(m, A)
            ]);
            l = E.observable = T, T.beforeNext(function D(F, _) {
              F === "next" && "hasNext" in _ && _.hasNext ? T.beforeNext(D) : p.remove(w, x);
            });
          }
        } else
          l = new Ad([
            e1(m, A)
          ]);
      } else
        l = new Ad([ri.of({ data: {} })]), t = this.prepareContext(t);
      return h && (l = Nv(l, function(D) {
        return s.localState.runResolvers({
          document: h,
          remoteResult: D,
          context: t,
          variables: n
        });
      })), l;
    }, r.prototype.getResultsFromLink = function(e, t, n) {
      var i = e.lastRequestId = this.generateRequestId(), a = this.cache.transformForLink(n.query);
      return Nv(this.getObservableFromLink(a, n.context, n.variables), function(s) {
        var o = KA(s), l = o.length > 0, u = n.errorPolicy;
        if (i >= e.lastRequestId) {
          if (l && u === "none")
            throw e.markError(new hc({
              graphQLErrors: o
            }));
          e.markResult(s, a, n, t), e.markReady();
        }
        var c = {
          data: s.data,
          loading: !1,
          networkStatus: Qn.ready
        };
        return l && u === "none" && (c.data = void 0), l && u !== "ignore" && (c.errors = o, c.networkStatus = Qn.error), c;
      }, function(s) {
        var o = jF(s) ? s : new hc({ networkError: s });
        throw i >= e.lastRequestId && e.markError(o), o;
      });
    }, r.prototype.fetchConcastWithInfo = function(e, t, n, i) {
      var a = this;
      n === void 0 && (n = Qn.loading), i === void 0 && (i = t.query);
      var s = this.getVariables(i, t.variables), o = this.defaultOptions.watchQuery, l = t.fetchPolicy, u = l === void 0 ? o && o.fetchPolicy || "cache-first" : l, c = t.errorPolicy, h = c === void 0 ? o && o.errorPolicy || "none" : c, f = t.returnPartialData, p = f === void 0 ? !1 : f, m = t.notifyOnNetworkStatusChange, A = m === void 0 ? !1 : m, w = t.context, x = w === void 0 ? {} : w, E = Object.assign({}, t, {
        query: i,
        variables: s,
        fetchPolicy: u,
        errorPolicy: h,
        returnPartialData: p,
        notifyOnNetworkStatusChange: A,
        context: x
      }), T = function(Z) {
        E.variables = Z;
        var te = a.fetchQueryByPolicy(e, E, n);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          E.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          te.sources.length > 0 && e.observableQuery && e.observableQuery.applyNextFetchPolicy("after-fetch", t), te
        );
      }, D = function() {
        return a.fetchCancelFns.delete(e.queryId);
      };
      this.fetchCancelFns.set(e.queryId, function(Z) {
        D(), setTimeout(function() {
          return F.cancel(Z);
        });
      });
      var F, _;
      if (this.getDocumentInfo(E.query).hasClientExports)
        F = new Ad(this.localState.addExportedVariables(E.query, E.variables, E.context).then(T).then(function(Z) {
          return Z.sources;
        })), _ = !0;
      else {
        var L = T(E.variables);
        _ = L.fromLink, F = new Ad(L.sources);
      }
      return F.promise.then(D, D), {
        concast: F,
        fromLink: _
      };
    }, r.prototype.refetchQueries = function(e) {
      var t = this, n = e.updateCache, i = e.include, a = e.optimistic, s = a === void 0 ? !1 : a, o = e.removeOptimistic, l = o === void 0 ? s ? zA("refetchQueries") : void 0 : o, u = e.onQueryUpdated, c = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(f, p) {
        c.set(p, {
          oq: f,
          lastDiff: (t.queries.get(p) || f.queryInfo).getDiff()
        });
      });
      var h = /* @__PURE__ */ new Map();
      return n && this.cache.batch({
        update: n,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: s && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(f, p, m) {
          var A = f.watcher instanceof jv && f.watcher.observableQuery;
          if (A) {
            if (u) {
              c.delete(A.queryId);
              var w = u(A, p, m);
              return w === !0 && (w = A.refetch()), w !== !1 && h.set(A, w), w;
            }
            u !== null && c.set(A.queryId, { oq: A, lastDiff: m, diff: p });
          }
        }
      }), c.size && c.forEach(function(f, p) {
        var m = f.oq, A = f.lastDiff, w = f.diff, x;
        u && (w || (w = qa("canonizeResults", function() {
          return t.cache.diff(m.queryInfo.getDiffOptions());
        })), x = u(m, w, A)), (!u || x === !0) && (x = m.refetch()), x !== !1 && h.set(m, x), p.indexOf("legacyOneTimeQuery") >= 0 && t.stopQueryNoBroadcast(p);
      }), l && this.cache.removeOptimistic(l), h;
    }, r.prototype.maskOperation = function(e) {
      var t = e.document, n = e.data;
      return this.dataMasking ? R6(n, t, this.cache) : n;
    }, r.prototype.maskFragment = function(e) {
      var t = e.data, n = e.fragment, i = e.fragmentName;
      return this.dataMasking ? eI(t, n, this.cache, i) : t;
    }, r.prototype.fetchQueryByPolicy = function(e, t, n) {
      var i = this, a = t.query, s = t.variables, o = t.fetchPolicy, l = t.refetchWritePolicy, u = t.errorPolicy, c = t.returnPartialData, h = t.context, f = t.notifyOnNetworkStatusChange, p = e.networkStatus;
      e.init({
        document: a,
        variables: s,
        networkStatus: n
      });
      var m = function() {
        return e.getDiff();
      }, A = function(D, F) {
        F === void 0 && (F = e.networkStatus || Qn.loading);
        var _ = D.result, L = function(Z) {
          return ri.of(Fe({ data: Z, loading: Cd(F), networkStatus: F }, D.complete ? null : { partial: !0 }));
        };
        return _ && i.getDocumentInfo(a).hasForcedResolvers ? i.localState.runResolvers({
          document: a,
          remoteResult: { data: _ },
          context: h,
          variables: s,
          onlyRunForcedResolvers: !0
        }).then(function(Z) {
          return L(Z.data || void 0);
        }) : u === "none" && F === Qn.refetch && Array.isArray(D.missing) ? L(void 0) : L(_);
      }, w = o === "no-cache" ? 0 : n === Qn.refetch && l !== "merge" ? 1 : 2, x = function() {
        return i.getResultsFromLink(e, w, {
          query: a,
          variables: s,
          context: h,
          fetchPolicy: o,
          errorPolicy: u
        });
      }, E = f && typeof p == "number" && p !== n && Cd(n);
      switch (o) {
        default:
        case "cache-first": {
          var T = m();
          return T.complete ? {
            fromLink: !1,
            sources: [A(T, e.markReady())]
          } : c || E ? {
            fromLink: !0,
            sources: [A(T), x()]
          } : { fromLink: !0, sources: [x()] };
        }
        case "cache-and-network": {
          var T = m();
          return T.complete || c || E ? {
            fromLink: !0,
            sources: [A(T), x()]
          } : { fromLink: !0, sources: [x()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [A(m(), e.markReady())]
          };
        case "network-only":
          return E ? {
            fromLink: !0,
            sources: [A(m()), x()]
          } : { fromLink: !0, sources: [x()] };
        case "no-cache":
          return E ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [A(e.getDiff()), x()]
          } : { fromLink: !0, sources: [x()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, r.prototype.getOrCreateQuery = function(e) {
      return e && !this.queries.has(e) && this.queries.set(e, new jv(this, e)), this.queries.get(e);
    }, r.prototype.prepareContext = function(e) {
      e === void 0 && (e = {});
      var t = this.localState.prepareContext(e);
      return Fe(Fe(Fe({}, this.defaultContext), t), { clientAwareness: this.clientAwareness });
    }, r;
  })()
), J6 = (
  /** @class */
  (function() {
    function r(e) {
      var t = e.cache, n = e.client, i = e.resolvers, a = e.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = t, n && (this.client = n), i && this.addResolvers(i), a && this.setFragmentMatcher(a);
    }
    return r.prototype.addResolvers = function(e) {
      var t = this;
      this.resolvers = this.resolvers || {}, Array.isArray(e) ? e.forEach(function(n) {
        t.resolvers = QC(t.resolvers, n);
      }) : this.resolvers = QC(this.resolvers, e);
    }, r.prototype.setResolvers = function(e) {
      this.resolvers = {}, this.addResolvers(e);
    }, r.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, r.prototype.runResolvers = function(e) {
      return Il(this, arguments, void 0, function(t) {
        var n = t.document, i = t.remoteResult, a = t.context, s = t.variables, o = t.onlyRunForcedResolvers, l = o === void 0 ? !1 : o;
        return Pl(this, function(u) {
          return n ? [2, this.resolveDocument(n, i.data, a, s, this.fragmentMatcher, l).then(function(c) {
            return Fe(Fe({}, i), { data: c.result });
          })] : [2, i];
        });
      });
    }, r.prototype.setFragmentMatcher = function(e) {
      this.fragmentMatcher = e;
    }, r.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, r.prototype.clientQuery = function(e) {
      return Vp(["client"], e) && this.resolvers ? e : null;
    }, r.prototype.serverQuery = function(e) {
      return UF(e);
    }, r.prototype.prepareContext = function(e) {
      var t = this.cache;
      return Fe(Fe({}, e), {
        cache: t,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(n) {
          return t.identify(n);
        }
      });
    }, r.prototype.addExportedVariables = function(e) {
      return Il(this, arguments, void 0, function(t, n, i) {
        return n === void 0 && (n = {}), i === void 0 && (i = {}), Pl(this, function(a) {
          return t ? [2, this.resolveDocument(t, this.buildRootValueFromCache(t, n) || {}, this.prepareContext(i), n).then(function(s) {
            return Fe(Fe({}, n), s.exportedVariables);
          })] : [2, Fe({}, n)];
        });
      });
    }, r.prototype.shouldForceResolvers = function(e) {
      var t = !1;
      return qo(e, {
        Directive: {
          enter: function(n) {
            if (n.name.value === "client" && n.arguments && (t = n.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), t))
              return fw;
          }
        }
      }), t;
    }, r.prototype.buildRootValueFromCache = function(e, t) {
      return this.cache.diff({
        query: P5(e),
        variables: t,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, r.prototype.resolveDocument = function(e, t) {
      return Il(this, arguments, void 0, function(n, i, a, s, o, l) {
        var u, c, h, f, p, m, A, w, x, E, T;
        return a === void 0 && (a = {}), s === void 0 && (s = {}), o === void 0 && (o = function() {
          return !0;
        }), l === void 0 && (l = !1), Pl(this, function(D) {
          return u = sg(n), c = Kd(n), h = Yd(c), f = this.collectSelectionsToResolve(u, h), p = u.operation, m = p ? p.charAt(0).toUpperCase() + p.slice(1) : "Query", A = this, w = A.cache, x = A.client, E = {
            fragmentMap: h,
            context: Fe(Fe({}, a), { cache: w, client: x }),
            variables: s,
            fragmentMatcher: o,
            defaultOperationType: m,
            exportedVariables: {},
            selectionsToResolve: f,
            onlyRunForcedResolvers: l
          }, T = !1, [2, this.resolveSelectionSet(u.selectionSet, T, i, E).then(function(F) {
            return {
              result: F,
              exportedVariables: E.exportedVariables
            };
          })];
        });
      });
    }, r.prototype.resolveSelectionSet = function(e, t, n, i) {
      return Il(this, void 0, void 0, function() {
        var a, s, o, l, u, c = this;
        return Pl(this, function(h) {
          return a = i.fragmentMap, s = i.context, o = i.variables, l = [n], u = function(f) {
            return Il(c, void 0, void 0, function() {
              var p, m;
              return Pl(this, function(A) {
                return !t && !i.selectionsToResolve.has(f) ? [
                  2
                  /*return*/
                ] : ag(f, o) ? Tc(f) ? [2, this.resolveField(f, t, n, i).then(function(w) {
                  var x;
                  typeof w < "u" && l.push((x = {}, x[kc(f)] = w, x));
                })] : (h5(f) ? p = f : (p = a[f.name.value], _n(p, 21, f.name.value)), p && p.typeCondition && (m = p.typeCondition.name.value, i.fragmentMatcher(n, m, s)) ? [2, this.resolveSelectionSet(p.selectionSet, t, n, i).then(function(w) {
                  l.push(w);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(e.selections.map(u)).then(function() {
            return U0(l);
          })];
        });
      });
    }, r.prototype.resolveField = function(e, t, n, i) {
      return Il(this, void 0, void 0, function() {
        var a, s, o, l, u, c, h, f, p, m = this;
        return Pl(this, function(A) {
          return n ? (a = i.variables, s = e.name.value, o = kc(e), l = s !== o, u = n[o] || n[s], c = Promise.resolve(u), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(e)) && (h = n.__typename || i.defaultOperationType, f = this.resolvers && this.resolvers[h], f && (p = f[l ? s : o], p && (c = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            Cw.withValue(this.cache, p, [
              n,
              M0(e, a),
              i.context,
              { field: e, fragmentMap: i.fragmentMap }
            ])
          )))), [2, c.then(function(w) {
            var x, E;
            if (w === void 0 && (w = u), e.directives && e.directives.forEach(function(D) {
              D.name.value === "export" && D.arguments && D.arguments.forEach(function(F) {
                F.name.value === "as" && F.value.kind === "StringValue" && (i.exportedVariables[F.value.value] = w);
              });
            }), !e.selectionSet || w == null)
              return w;
            var T = (E = (x = e.directives) === null || x === void 0 ? void 0 : x.some(function(D) {
              return D.name.value === "client";
            })) !== null && E !== void 0 ? E : !1;
            if (Array.isArray(w))
              return m.resolveSubSelectedArray(e, t || T, w, i);
            if (e.selectionSet)
              return m.resolveSelectionSet(e.selectionSet, t || T, w, i);
          })]) : [2, null];
        });
      });
    }, r.prototype.resolveSubSelectedArray = function(e, t, n, i) {
      var a = this;
      return Promise.all(n.map(function(s) {
        if (s === null)
          return null;
        if (Array.isArray(s))
          return a.resolveSubSelectedArray(e, t, s, i);
        if (e.selectionSet)
          return a.resolveSelectionSet(e.selectionSet, t, s, i);
      }));
    }, r.prototype.collectSelectionsToResolve = function(e, t) {
      var n = function(s) {
        return !Array.isArray(s);
      }, i = this.selectionsToResolveCache;
      function a(s) {
        if (!i.has(s)) {
          var o = /* @__PURE__ */ new Set();
          i.set(s, o), qo(s, {
            Directive: function(l, u, c, h, f) {
              l.name.value === "client" && f.forEach(function(p) {
                n(p) && UC(p) && o.add(p);
              });
            },
            FragmentSpread: function(l, u, c, h, f) {
              var p = t[l.name.value];
              _n(p, 22, l.name.value);
              var m = a(p);
              m.size > 0 && (f.forEach(function(A) {
                n(A) && UC(A) && o.add(A);
              }), o.add(l), m.forEach(function(A) {
                o.add(A);
              }));
            }
          });
        }
        return i.get(s);
      }
      return a(e);
    }, r;
  })()
), K6 = (
  /** @class */
  (function() {
    function r(e) {
      var t = this, n, i, a;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !e.cache)
        throw Ts(16);
      var s = e.uri, o = e.credentials, l = e.headers, u = e.cache, c = e.documentTransform, h = e.ssrMode, f = h === void 0 ? !1 : h, p = e.ssrForceFetchDelay, m = p === void 0 ? 0 : p, A = e.connectToDevTools, w = e.queryDeduplication, x = w === void 0 ? !0 : w, E = e.defaultOptions, T = e.defaultContext, D = e.assumeImmutableResults, F = D === void 0 ? u.assumeImmutableResults : D, _ = e.resolvers, L = e.typeDefs, Z = e.fragmentMatcher, te = e.clientAwareness, de = e.name, H = e.version, j = e.devtools, q = e.dataMasking, re = e.link;
      re || (re = s ? new E6({ uri: s, credentials: o, headers: l }) : Ko.empty()), this.link = re, this.cache = u, this.disableNetworkFetches = f || m > 0, this.queryDeduplication = x, this.defaultOptions = E || /* @__PURE__ */ Object.create(null), this.typeDefs = L, this.devtoolsConfig = Fe(Fe({}, j), { enabled: (n = j?.enabled) !== null && n !== void 0 ? n : A }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = !1), m && setTimeout(function() {
        return t.disableNetworkFetches = !1;
      }, m), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = sw, this.localState = new J6({
        cache: u,
        client: this,
        resolvers: _,
        fragmentMatcher: Z
      }), this.queryManager = new X6({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: T,
        documentTransform: c,
        queryDeduplication: x,
        ssrMode: f,
        dataMasking: !!q,
        clientAwareness: {
          name: (i = te?.name) !== null && i !== void 0 ? i : de,
          version: (a = te?.version) !== null && a !== void 0 ? a : H
        },
        localState: this.localState,
        assumeImmutableResults: F,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          t.devToolsHookCb && t.devToolsHookCb({
            action: {},
            state: {
              queries: t.queryManager.getQueryStore(),
              mutations: t.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: t.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(r.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(e) {
        this.disableNetworkFetches = e;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var e = window, t = /* @__PURE__ */ Symbol.for("apollo.devtools");
        (e[t] = e[t] || []).push(this), e.__APOLLO_CLIENT__ = this;
      }
    }, Object.defineProperty(r.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.stop = function() {
      this.queryManager.stop();
    }, r.prototype.watchQuery = function(e) {
      return this.defaultOptions.watchQuery && (e = Lv(this.defaultOptions.watchQuery, e)), this.disableNetworkFetches && (e.fetchPolicy === "network-only" || e.fetchPolicy === "cache-and-network") && (e = Fe(Fe({}, e), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(e);
    }, r.prototype.query = function(e) {
      return this.defaultOptions.query && (e = Lv(this.defaultOptions.query, e)), _n(e.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && e.fetchPolicy === "network-only" && (e = Fe(Fe({}, e), { fetchPolicy: "cache-first" })), this.queryManager.query(e);
    }, r.prototype.mutate = function(e) {
      return this.defaultOptions.mutate && (e = Lv(this.defaultOptions.mutate, e)), this.queryManager.mutate(e);
    }, r.prototype.subscribe = function(e) {
      var t = this, n = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(e).map(function(i) {
        return Fe(Fe({}, i), { data: t.queryManager.maskOperation({
          document: e.query,
          data: i.data,
          fetchPolicy: e.fetchPolicy,
          id: n
        }) });
      });
    }, r.prototype.readQuery = function(e, t) {
      return t === void 0 && (t = !1), this.cache.readQuery(e, t);
    }, r.prototype.watchFragment = function(e) {
      var t;
      return this.cache.watchFragment(Fe(Fe({}, e), (t = {}, t[/* @__PURE__ */ Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, t)));
    }, r.prototype.readFragment = function(e, t) {
      return t === void 0 && (t = !1), this.cache.readFragment(e, t);
    }, r.prototype.writeQuery = function(e) {
      var t = this.cache.writeQuery(e);
      return e.broadcast !== !1 && this.queryManager.broadcastQueries(), t;
    }, r.prototype.writeFragment = function(e) {
      var t = this.cache.writeFragment(e);
      return e.broadcast !== !1 && this.queryManager.broadcastQueries(), t;
    }, r.prototype.__actionHookForDevTools = function(e) {
      this.devToolsHookCb = e;
    }, r.prototype.__requestRaw = function(e) {
      return e1(this.link, e);
    }, r.prototype.resetStore = function() {
      var e = this;
      return Promise.resolve().then(function() {
        return e.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(e.resetStoreCallbacks.map(function(t) {
          return t();
        }));
      }).then(function() {
        return e.reFetchObservableQueries();
      });
    }, r.prototype.clearStore = function() {
      var e = this;
      return Promise.resolve().then(function() {
        return e.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(e.clearStoreCallbacks.map(function(t) {
          return t();
        }));
      });
    }, r.prototype.onResetStore = function(e) {
      var t = this;
      return this.resetStoreCallbacks.push(e), function() {
        t.resetStoreCallbacks = t.resetStoreCallbacks.filter(function(n) {
          return n !== e;
        });
      };
    }, r.prototype.onClearStore = function(e) {
      var t = this;
      return this.clearStoreCallbacks.push(e), function() {
        t.clearStoreCallbacks = t.clearStoreCallbacks.filter(function(n) {
          return n !== e;
        });
      };
    }, r.prototype.reFetchObservableQueries = function(e) {
      return this.queryManager.reFetchObservableQueries(e);
    }, r.prototype.refetchQueries = function(e) {
      var t = this.queryManager.refetchQueries(e), n = [], i = [];
      t.forEach(function(s, o) {
        n.push(o), i.push(s);
      });
      var a = Promise.all(i);
      return a.queries = n, a.results = i, a.catch(function(s) {
      }), a;
    }, r.prototype.getObservableQueries = function(e) {
      return e === void 0 && (e = "active"), this.queryManager.getObservableQueries(e);
    }, r.prototype.extract = function(e) {
      return this.cache.extract(e);
    }, r.prototype.restore = function(e) {
      return this.cache.restore(e);
    }, r.prototype.addResolvers = function(e) {
      this.localState.addResolvers(e);
    }, r.prototype.setResolvers = function(e) {
      this.localState.setResolvers(e);
    }, r.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, r.prototype.setLocalStateFragmentMatcher = function(e) {
      this.localState.setFragmentMatcher(e);
    }, r.prototype.setLink = function(e) {
      this.link = this.queryManager.link = e;
    }, Object.defineProperty(r.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  })()
), $m = /* @__PURE__ */ new Map(), l1 = /* @__PURE__ */ new Map(), hI = !0, Pp = !1;
function pI(r) {
  return r.replace(/[\s,]+/g, " ").trim();
}
function Z6(r) {
  return pI(r.source.body.substring(r.start, r.end));
}
function eN(r) {
  var e = /* @__PURE__ */ new Set(), t = [];
  return r.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var i = n.name.value, a = Z6(n.loc), s = l1.get(i);
      s && !s.has(a) ? hI && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : s || l1.set(i, s = /* @__PURE__ */ new Set()), s.add(a), e.has(a) || (e.add(a), t.push(n));
    } else
      t.push(n);
  }), Fe(Fe({}, r), { definitions: t });
}
function tN(r) {
  var e = new Set(r.definitions);
  e.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
      var a = n[i];
      a && typeof a == "object" && e.add(a);
    });
  });
  var t = r.loc;
  return t && (delete t.startToken, delete t.endToken), r;
}
function rN(r) {
  var e = pI(r);
  if (!$m.has(e)) {
    var t = EM(r, {
      experimentalFragmentVariables: Pp,
      allowLegacyFragmentVariables: Pp,
      experimentalFragmentArguments: Pp
    });
    if (!t || t.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    $m.set(e, tN(eN(t)));
  }
  return $m.get(e);
}
function Oe(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  typeof r == "string" && (r = [r]);
  var n = r[0];
  return e.forEach(function(i, a) {
    i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += r[a + 1];
  }), rN(n);
}
function nN() {
  $m.clear(), l1.clear();
}
function iN() {
  hI = !1;
}
function aN() {
  Pp = !0;
}
function sN() {
  Pp = !1;
}
var Lh = {
  gql: Oe,
  resetCaches: nN,
  disableFragmentWarnings: iN,
  enableExperimentalFragmentVariables: aN,
  disableExperimentalFragmentVariables: sN
};
(function(r) {
  r.gql = Lh.gql, r.resetCaches = Lh.resetCaches, r.disableFragmentWarnings = Lh.disableFragmentWarnings, r.enableExperimentalFragmentVariables = Lh.enableExperimentalFragmentVariables, r.disableExperimentalFragmentVariables = Lh.disableExperimentalFragmentVariables;
})(Oe || (Oe = {}));
Oe.default = Oe;
var u0 = /* @__PURE__ */ ((r) => (r.Data = "Data", r.Font = "Font", r.Frame = "Frame", r.Illustration = "Illustration", r.Image = "Image", r.Model = "Model", r.Material = "Material", r.Color = "Color", r.QuestionnaireCollateral = "QuestionnaireCollateral", r.RequestCollateral = "RequestCollateral", r.SignupCollateral = "SignupCollateral", r.Video = "Video", r.ColorProfile = "ColorProfile", r.Environment = "Environment", r))(u0 || {}), gI = /* @__PURE__ */ ((r) => (r.AND = "AND", r.OR = "OR", r))(gI || {}), Ji = /* @__PURE__ */ ((r) => (r.FileUpload = "FileUpload", r.Option = "Option", r.ColorOption = "ColorOption", r.Text = "Text", r))(Ji || {}), gt = /* @__PURE__ */ ((r) => (r.Information = "Information", r.Bulk = "Bulk", r.DigitalContent = "DigitalContent", r.Finish = "Finish", r.Frame = "Frame", r.Illustration = "Illustration", r.Introduction = "Introduction", r.Material = "Material", r.Model = "Model", r.Module = "Module", r.Picture = "Picture", r.Photo = "Photo", r.Product = "Product", r.ProductOverlay = "ProductOverlay", r.Question = "Question", r.Shape = "Shape", r.SilentIllustration = "SilentIllustration", r.Text = "Text", r))(gt || {}), oN = /* @__PURE__ */ ((r) => (r.Color = "Color", r.Colors = "Colors", r.Selection = "Selection", r.Selections = "Selections", r.Text = "Text", r.Upload = "Upload", r))(oN || {}), Hp = /* @__PURE__ */ ((r) => (r.ThreeD = "ThreeD", r.FreeDesign = "FreeDesign", r.Print = "Print", r))(Hp || {}), Mr = /* @__PURE__ */ ((r) => (r.Frame = "frame", r.Group = "group", r.Image = "image", r.Pattern = "pattern", r.Illustration = "illustration", r.Textbox = "textbox", r))(Mr || {}), lN = /* @__PURE__ */ ((r) => (r.Default = "Default", r.FirstTransaction = "FirstTransaction", r.OneToOne = "OneToOne", r))(lN || {}), Tw = /* @__PURE__ */ ((r) => (r.Pending = "Pending", r.Failed = "Failed", r.Validated = "Validated", r.Overridden = "Overridden", r.Skipped = "Skipped", r))(Tw || {}), uN = /* @__PURE__ */ ((r) => (r.Hyperlink = "Hyperlink", r.Edit = "Edit", r.Approve = "Approve", r))(uN || {}), cN = /* @__PURE__ */ ((r) => (r.Hub = "Hub", r.Shopify = "Shopify", r))(cN || {}), Fw = /* @__PURE__ */ ((r) => (r.AdvancedImageManipulation = "BackgroundRemover", r.ConversionAccelerator = "Conversion Accelerator", r.ProcessBuilder = "ProcessBuilder", r))(Fw || {}), fN = /* @__PURE__ */ ((r) => (r[r.Orbit = 0] = "Orbit", r[r.Pan = 1] = "Pan", r))(fN || {}), mI = /* @__PURE__ */ ((r) => (r.Owner = "Owner", r.Approver = "Approver", r.Editor = "Editor", r.Viewer = "Viewer", r))(mI || {}), eh = /* @__PURE__ */ ((r) => (r.Autosize = "Autosize", r.Traditional = "Traditional", r))(eh || {}), Ma = /* @__PURE__ */ ((r) => (r[r.North = 0] = "North", r[r.Northeast = 1] = "Northeast", r[r.East = 2] = "East", r[r.Southeast = 3] = "Southeast", r[r.South = 4] = "South", r[r.Southwest = 5] = "Southwest", r[r.West = 6] = "West", r[r.Northwest = 7] = "Northwest", r))(Ma || {}), dN = /* @__PURE__ */ ((r) => (r.Pixel = "px", r.Millimeter = "mm", r.Centimeter = "cm", r))(dN || {}), zm = /* @__PURE__ */ ((r) => (r.Email = "Email", r.FirstName = "FirstName", r.LastName = "LastName", r.Phone = "Phone", r.Apartment = "Apartment", r.City = "City", r.Country = "Country", r.OrganizationName = "OrganizationName", r.PostCode = "PostCode", r.State = "State", r.StreetAddress = "StreetAddress", r.Custom = "Custom", r))(zm || {});
class vI extends Error {
  constructor(e) {
    super(e), this.name = this.constructor.name;
  }
}
class lg extends vI {
  constructor(e) {
    super(`ConfigurationError - ${e}`);
  }
}
class c0 extends lg {
  constructor(e) {
    super(`Option not Configured: ${e.stepTitle}`), this.optionId = e?.optionId || "N/A";
  }
}
class La extends lg {
  constructor(e) {
    super(`Panel not Found: ${e.panelId}`), this.panelId = e?.panelId || "N/A";
  }
}
class _f extends lg {
  constructor(e) {
    super(`Asset not found for variant: ${e.name}`), this.variant = e;
  }
}
class th extends lg {
  constructor(e) {
    super(`Resource not found for asset: ${e.name}`), this.asset = e;
  }
}
class Cu extends lg {
  constructor(e, t) {
    super(`Workflow Misconfiguration: ${e.stepName} - ${t}`), this.step = e;
  }
}
class V0 extends vI {
  constructor(e) {
    super(`ImplementationError - ${e}`);
  }
}
class si extends V0 {
  constructor(e) {
    super(`Unhandled Behavior Encountered: ${e}`);
  }
}
class Ed extends V0 {
  constructor(e) {
    super(`Parsing Error: ${e}`);
  }
}
class mc extends V0 {
  constructor(e) {
    super(`Client Error: ${e}`);
  }
}
class rh extends V0 {
  constructor(e) {
    super(`Resource Generation Failed: ${e}`);
  }
}
class hN {
  get(e) {
    return localStorage.getItem(e) || void 0;
  }
  set(e, t) {
    localStorage.setItem(e, t);
  }
  remove(e) {
    localStorage.removeItem(e);
  }
  getMap(e) {
    const t = this.get(e);
    if (t)
      return new Map(JSON.parse(t));
  }
  setMap(e, t) {
    const n = JSON.stringify([...t.entries()]);
    this.set(e, n);
  }
}
class FS {
  constructor() {
    this.storage = /* @__PURE__ */ new Map();
  }
  get(e) {
    return this.storage.get(e) || void 0;
  }
  set(e, t) {
    this.storage.set(e, t);
  }
  remove(e) {
    this.storage.delete(e);
  }
  getMap(e) {
    const t = this.get(e);
    if (t)
      return new Map(JSON.parse(t));
  }
  setMap(e, t) {
    const n = JSON.stringify([...t.entries()]);
    this.set(e, n);
  }
}
const pN = () => {
  try {
    return localStorage ? new hN() : new FS();
  } catch {
    return console.warn("Local storage was unavilable due to browser security settings. Using in-memory storage instead."), new FS();
  }
}, hn = pN();
function gN(r) {
  return new Ko(function(e, t) {
    var n = Bl(e, []);
    return new ri(function(i) {
      var a, s = !1;
      return Promise.resolve(n).then(function(o) {
        return r(o, e.getContext());
      }).then(e.setContext).then(function() {
        s || (a = t(e).subscribe({
          next: i.next.bind(i),
          error: i.error.bind(i),
          complete: i.complete.bind(i)
        }));
      }).catch(i.error.bind(i)), function() {
        s = !0, a && a.unsubscribe();
      };
    });
  });
}
function yI(r) {
  return new Ko(function(e, t) {
    return new ri(function(n) {
      var i, a, s;
      try {
        i = t(e).subscribe({
          next: function(o) {
            if (o.errors ? s = r({
              graphQLErrors: o.errors,
              response: o,
              operation: e,
              forward: t
            }) : bw(o) && (s = r({
              protocolErrors: o.extensions[og],
              response: o,
              operation: e,
              forward: t
            })), s) {
              a = s.subscribe({
                next: n.next.bind(n),
                error: n.error.bind(n),
                complete: n.complete.bind(n)
              });
              return;
            }
            n.next(o);
          },
          error: function(o) {
            if (s = r({
              operation: e,
              networkError: o,
              //Network errors can return GraphQL errors on for example a 403
              graphQLErrors: o && o.result && o.result.errors || void 0,
              forward: t
            }), s) {
              a = s.subscribe({
                next: n.next.bind(n),
                error: n.error.bind(n),
                complete: n.complete.bind(n)
              });
              return;
            }
            n.error(o);
          },
          complete: function() {
            s || n.complete.bind(n)();
          }
        });
      } catch (o) {
        r({ networkError: o, operation: e, forward: t }), n.error(o);
      }
      return function() {
        i && i.unsubscribe(), a && i.unsubscribe();
      };
    });
  });
}
(function(r) {
  bo(e, r);
  function e(t) {
    var n = r.call(this) || this;
    return n.link = yI(t), n;
  }
  return e.prototype.request = function(t, n) {
    return this.link.request(t, n);
  }, e;
})(Ko);
class mN {
  constructor() {
    this.defaultServerUrl = "https://moonlight.au.spiffcommerce.com", this.defaultServicesApiUrl = "https://services.au.spiffcommerce.com", this.defaultHubUrl = "https://hub.au.spiffcommerce.com", this.endpointVersion = "2026-09", this.serverUrl = this.defaultServerUrl + `/${this.endpointVersion}`, this.servicesApiUrl = this.defaultServicesApiUrl, this.hubUrl = this.defaultHubUrl, this.serverUrlCallbacks = [];
  }
  getServerUrl() {
    return this.serverUrl;
  }
  getServicesApiUrl() {
    return this.servicesApiUrl;
  }
  getHubUrl() {
    return this.hubUrl;
  }
  setServerUrl(e) {
    e.endsWith("/") && (e = e.slice(0, -1)), e.endsWith(".com") ? this.serverUrl = e + `/${this.endpointVersion}` : e.includes("spiffcommerce.com") ? (e = e.slice(0, e.lastIndexOf("/")), this.serverUrl = `${e}/${this.endpointVersion}`) : this.serverUrl = e, this.serverUrlCallbacks.forEach((t) => t());
  }
  setServicesApiUrl(e) {
    this.servicesApiUrl = e;
  }
  setHubUrl(e) {
    this.hubUrl = e;
  }
  addServerUrlCallback(e) {
    this.serverUrlCallbacks.push(e);
  }
}
const Cc = new mN();
var ac = {}, vf = {}, Ug = { exports: {} }, on = {};
var IS;
function vN() {
  if (IS) return on;
  IS = 1;
  var r = /* @__PURE__ */ Symbol.for("react.element"), e = /* @__PURE__ */ Symbol.for("react.portal"), t = /* @__PURE__ */ Symbol.for("react.fragment"), n = /* @__PURE__ */ Symbol.for("react.strict_mode"), i = /* @__PURE__ */ Symbol.for("react.profiler"), a = /* @__PURE__ */ Symbol.for("react.provider"), s = /* @__PURE__ */ Symbol.for("react.context"), o = /* @__PURE__ */ Symbol.for("react.forward_ref"), l = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.memo"), c = /* @__PURE__ */ Symbol.for("react.lazy"), h = Symbol.iterator;
  function f(le) {
    return le === null || typeof le != "object" ? null : (le = h && le[h] || le["@@iterator"], typeof le == "function" ? le : null);
  }
  var p = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, m = Object.assign, A = {};
  function w(le, ve, it) {
    this.props = le, this.context = ve, this.refs = A, this.updater = it || p;
  }
  w.prototype.isReactComponent = {}, w.prototype.setState = function(le, ve) {
    if (typeof le != "object" && typeof le != "function" && le != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, le, ve, "setState");
  }, w.prototype.forceUpdate = function(le) {
    this.updater.enqueueForceUpdate(this, le, "forceUpdate");
  };
  function x() {
  }
  x.prototype = w.prototype;
  function E(le, ve, it) {
    this.props = le, this.context = ve, this.refs = A, this.updater = it || p;
  }
  var T = E.prototype = new x();
  T.constructor = E, m(T, w.prototype), T.isPureReactComponent = !0;
  var D = Array.isArray, F = Object.prototype.hasOwnProperty, _ = { current: null }, L = { key: !0, ref: !0, __self: !0, __source: !0 };
  function Z(le, ve, it) {
    var mt, qe = {}, at = null, st = null;
    if (ve != null) for (mt in ve.ref !== void 0 && (st = ve.ref), ve.key !== void 0 && (at = "" + ve.key), ve) F.call(ve, mt) && !L.hasOwnProperty(mt) && (qe[mt] = ve[mt]);
    var lt = arguments.length - 2;
    if (lt === 1) qe.children = it;
    else if (1 < lt) {
      for (var rt = Array(lt), Rt = 0; Rt < lt; Rt++) rt[Rt] = arguments[Rt + 2];
      qe.children = rt;
    }
    if (le && le.defaultProps) for (mt in lt = le.defaultProps, lt) qe[mt] === void 0 && (qe[mt] = lt[mt]);
    return { $$typeof: r, type: le, key: at, ref: st, props: qe, _owner: _.current };
  }
  function te(le, ve) {
    return { $$typeof: r, type: le.type, key: ve, ref: le.ref, props: le.props, _owner: le._owner };
  }
  function de(le) {
    return typeof le == "object" && le !== null && le.$$typeof === r;
  }
  function H(le) {
    var ve = { "=": "=0", ":": "=2" };
    return "$" + le.replace(/[=:]/g, function(it) {
      return ve[it];
    });
  }
  var j = /\/+/g;
  function q(le, ve) {
    return typeof le == "object" && le !== null && le.key != null ? H("" + le.key) : ve.toString(36);
  }
  function re(le, ve, it, mt, qe) {
    var at = typeof le;
    (at === "undefined" || at === "boolean") && (le = null);
    var st = !1;
    if (le === null) st = !0;
    else switch (at) {
      case "string":
      case "number":
        st = !0;
        break;
      case "object":
        switch (le.$$typeof) {
          case r:
          case e:
            st = !0;
        }
    }
    if (st) return st = le, qe = qe(st), le = mt === "" ? "." + q(st, 0) : mt, D(qe) ? (it = "", le != null && (it = le.replace(j, "$&/") + "/"), re(qe, ve, it, "", function(Rt) {
      return Rt;
    })) : qe != null && (de(qe) && (qe = te(qe, it + (!qe.key || st && st.key === qe.key ? "" : ("" + qe.key).replace(j, "$&/") + "/") + le)), ve.push(qe)), 1;
    if (st = 0, mt = mt === "" ? "." : mt + ":", D(le)) for (var lt = 0; lt < le.length; lt++) {
      at = le[lt];
      var rt = mt + q(at, lt);
      st += re(at, ve, it, rt, qe);
    }
    else if (rt = f(le), typeof rt == "function") for (le = rt.call(le), lt = 0; !(at = le.next()).done; ) at = at.value, rt = mt + q(at, lt++), st += re(at, ve, it, rt, qe);
    else if (at === "object") throw ve = String(le), Error("Objects are not valid as a React child (found: " + (ve === "[object Object]" ? "object with keys {" + Object.keys(le).join(", ") + "}" : ve) + "). If you meant to render a collection of children, use an array instead.");
    return st;
  }
  function ae(le, ve, it) {
    if (le == null) return le;
    var mt = [], qe = 0;
    return re(le, mt, "", "", function(at) {
      return ve.call(it, at, qe++);
    }), mt;
  }
  function ye(le) {
    if (le._status === -1) {
      var ve = le._result;
      ve = ve(), ve.then(function(it) {
        (le._status === 0 || le._status === -1) && (le._status = 1, le._result = it);
      }, function(it) {
        (le._status === 0 || le._status === -1) && (le._status = 2, le._result = it);
      }), le._status === -1 && (le._status = 0, le._result = ve);
    }
    if (le._status === 1) return le._result.default;
    throw le._result;
  }
  var Se = { current: null }, Xe = { transition: null }, Ve = { ReactCurrentDispatcher: Se, ReactCurrentBatchConfig: Xe, ReactCurrentOwner: _ };
  function He() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return on.Children = { map: ae, forEach: function(le, ve, it) {
    ae(le, function() {
      ve.apply(this, arguments);
    }, it);
  }, count: function(le) {
    var ve = 0;
    return ae(le, function() {
      ve++;
    }), ve;
  }, toArray: function(le) {
    return ae(le, function(ve) {
      return ve;
    }) || [];
  }, only: function(le) {
    if (!de(le)) throw Error("React.Children.only expected to receive a single React element child.");
    return le;
  } }, on.Component = w, on.Fragment = t, on.Profiler = i, on.PureComponent = E, on.StrictMode = n, on.Suspense = l, on.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ve, on.act = He, on.cloneElement = function(le, ve, it) {
    if (le == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + le + ".");
    var mt = m({}, le.props), qe = le.key, at = le.ref, st = le._owner;
    if (ve != null) {
      if (ve.ref !== void 0 && (at = ve.ref, st = _.current), ve.key !== void 0 && (qe = "" + ve.key), le.type && le.type.defaultProps) var lt = le.type.defaultProps;
      for (rt in ve) F.call(ve, rt) && !L.hasOwnProperty(rt) && (mt[rt] = ve[rt] === void 0 && lt !== void 0 ? lt[rt] : ve[rt]);
    }
    var rt = arguments.length - 2;
    if (rt === 1) mt.children = it;
    else if (1 < rt) {
      lt = Array(rt);
      for (var Rt = 0; Rt < rt; Rt++) lt[Rt] = arguments[Rt + 2];
      mt.children = lt;
    }
    return { $$typeof: r, type: le.type, key: qe, ref: at, props: mt, _owner: st };
  }, on.createContext = function(le) {
    return le = { $$typeof: s, _currentValue: le, _currentValue2: le, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, le.Provider = { $$typeof: a, _context: le }, le.Consumer = le;
  }, on.createElement = Z, on.createFactory = function(le) {
    var ve = Z.bind(null, le);
    return ve.type = le, ve;
  }, on.createRef = function() {
    return { current: null };
  }, on.forwardRef = function(le) {
    return { $$typeof: o, render: le };
  }, on.isValidElement = de, on.lazy = function(le) {
    return { $$typeof: c, _payload: { _status: -1, _result: le }, _init: ye };
  }, on.memo = function(le, ve) {
    return { $$typeof: u, type: le, compare: ve === void 0 ? null : ve };
  }, on.startTransition = function(le) {
    var ve = Xe.transition;
    Xe.transition = {};
    try {
      le();
    } finally {
      Xe.transition = ve;
    }
  }, on.unstable_act = He, on.useCallback = function(le, ve) {
    return Se.current.useCallback(le, ve);
  }, on.useContext = function(le) {
    return Se.current.useContext(le);
  }, on.useDebugValue = function() {
  }, on.useDeferredValue = function(le) {
    return Se.current.useDeferredValue(le);
  }, on.useEffect = function(le, ve) {
    return Se.current.useEffect(le, ve);
  }, on.useId = function() {
    return Se.current.useId();
  }, on.useImperativeHandle = function(le, ve, it) {
    return Se.current.useImperativeHandle(le, ve, it);
  }, on.useInsertionEffect = function(le, ve) {
    return Se.current.useInsertionEffect(le, ve);
  }, on.useLayoutEffect = function(le, ve) {
    return Se.current.useLayoutEffect(le, ve);
  }, on.useMemo = function(le, ve) {
    return Se.current.useMemo(le, ve);
  }, on.useReducer = function(le, ve, it) {
    return Se.current.useReducer(le, ve, it);
  }, on.useRef = function(le) {
    return Se.current.useRef(le);
  }, on.useState = function(le) {
    return Se.current.useState(le);
  }, on.useSyncExternalStore = function(le, ve, it) {
    return Se.current.useSyncExternalStore(le, ve, it);
  }, on.useTransition = function() {
    return Se.current.useTransition();
  }, on.version = "18.3.1", on;
}
var pp = { exports: {} };
pp.exports;
var PS;
function yN() {
  return PS || (PS = 1, (function(r, e) {
    process.env.NODE_ENV !== "production" && (function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = "18.3.1", n = /* @__PURE__ */ Symbol.for("react.element"), i = /* @__PURE__ */ Symbol.for("react.portal"), a = /* @__PURE__ */ Symbol.for("react.fragment"), s = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), l = /* @__PURE__ */ Symbol.for("react.provider"), u = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), h = /* @__PURE__ */ Symbol.for("react.suspense"), f = /* @__PURE__ */ Symbol.for("react.suspense_list"), p = /* @__PURE__ */ Symbol.for("react.memo"), m = /* @__PURE__ */ Symbol.for("react.lazy"), A = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, x = "@@iterator";
      function E(N) {
        if (N === null || typeof N != "object")
          return null;
        var oe = w && N[w] || N[x];
        return typeof oe == "function" ? oe : null;
      }
      var T = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, D = {
        transition: null
      }, F = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, _ = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, L = {}, Z = null;
      function te(N) {
        Z = N;
      }
      L.setExtraStackFrame = function(N) {
        Z = N;
      }, L.getCurrentStack = null, L.getStackAddendum = function() {
        var N = "";
        Z && (N += Z);
        var oe = L.getCurrentStack;
        return oe && (N += oe() || ""), N;
      };
      var de = !1, H = !1, j = !1, q = !1, re = !1, ae = {
        ReactCurrentDispatcher: T,
        ReactCurrentBatchConfig: D,
        ReactCurrentOwner: _
      };
      ae.ReactDebugCurrentFrame = L, ae.ReactCurrentActQueue = F;
      function ye(N) {
        {
          for (var oe = arguments.length, xe = new Array(oe > 1 ? oe - 1 : 0), Ie = 1; Ie < oe; Ie++)
            xe[Ie - 1] = arguments[Ie];
          Xe("warn", N, xe);
        }
      }
      function Se(N) {
        {
          for (var oe = arguments.length, xe = new Array(oe > 1 ? oe - 1 : 0), Ie = 1; Ie < oe; Ie++)
            xe[Ie - 1] = arguments[Ie];
          Xe("error", N, xe);
        }
      }
      function Xe(N, oe, xe) {
        {
          var Ie = ae.ReactDebugCurrentFrame, We = Ie.getStackAddendum();
          We !== "" && (oe += "%s", xe = xe.concat([We]));
          var ot = xe.map(function(dt) {
            return String(dt);
          });
          ot.unshift("Warning: " + oe), Function.prototype.apply.call(console[N], console, ot);
        }
      }
      var Ve = {};
      function He(N, oe) {
        {
          var xe = N.constructor, Ie = xe && (xe.displayName || xe.name) || "ReactClass", We = Ie + "." + oe;
          if (Ve[We])
            return;
          Se("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", oe, Ie), Ve[We] = !0;
        }
      }
      var le = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(N) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(N, oe, xe) {
          He(N, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(N, oe, xe, Ie) {
          He(N, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(N, oe, xe, Ie) {
          He(N, "setState");
        }
      }, ve = Object.assign, it = {};
      Object.freeze(it);
      function mt(N, oe, xe) {
        this.props = N, this.context = oe, this.refs = it, this.updater = xe || le;
      }
      mt.prototype.isReactComponent = {}, mt.prototype.setState = function(N, oe) {
        if (typeof N != "object" && typeof N != "function" && N != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, N, oe, "setState");
      }, mt.prototype.forceUpdate = function(N) {
        this.updater.enqueueForceUpdate(this, N, "forceUpdate");
      };
      {
        var qe = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, at = function(N, oe) {
          Object.defineProperty(mt.prototype, N, {
            get: function() {
              ye("%s(...) is deprecated in plain JavaScript React classes. %s", oe[0], oe[1]);
            }
          });
        };
        for (var st in qe)
          qe.hasOwnProperty(st) && at(st, qe[st]);
      }
      function lt() {
      }
      lt.prototype = mt.prototype;
      function rt(N, oe, xe) {
        this.props = N, this.context = oe, this.refs = it, this.updater = xe || le;
      }
      var Rt = rt.prototype = new lt();
      Rt.constructor = rt, ve(Rt, mt.prototype), Rt.isPureReactComponent = !0;
      function Fr() {
        var N = {
          current: null
        };
        return Object.seal(N), N;
      }
      var an = Array.isArray;
      function ar(N) {
        return an(N);
      }
      function Ir(N) {
        {
          var oe = typeof Symbol == "function" && Symbol.toStringTag, xe = oe && N[Symbol.toStringTag] || N.constructor.name || "Object";
          return xe;
        }
      }
      function kt(N) {
        try {
          return wt(N), !1;
        } catch {
          return !0;
        }
      }
      function wt(N) {
        return "" + N;
      }
      function Mn(N) {
        if (kt(N))
          return Se("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ir(N)), wt(N);
      }
      function kr(N, oe, xe) {
        var Ie = N.displayName;
        if (Ie)
          return Ie;
        var We = oe.displayName || oe.name || "";
        return We !== "" ? xe + "(" + We + ")" : xe;
      }
      function Gr(N) {
        return N.displayName || "Context";
      }
      function Pr(N) {
        if (N == null)
          return null;
        if (typeof N.tag == "number" && Se("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof N == "function")
          return N.displayName || N.name || null;
        if (typeof N == "string")
          return N;
        switch (N) {
          case a:
            return "Fragment";
          case i:
            return "Portal";
          case o:
            return "Profiler";
          case s:
            return "StrictMode";
          case h:
            return "Suspense";
          case f:
            return "SuspenseList";
        }
        if (typeof N == "object")
          switch (N.$$typeof) {
            case u:
              var oe = N;
              return Gr(oe) + ".Consumer";
            case l:
              var xe = N;
              return Gr(xe._context) + ".Provider";
            case c:
              return kr(N, N.render, "ForwardRef");
            case p:
              var Ie = N.displayName || null;
              return Ie !== null ? Ie : Pr(N.type) || "Memo";
            case m: {
              var We = N, ot = We._payload, dt = We._init;
              try {
                return Pr(dt(ot));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Cr = Object.prototype.hasOwnProperty, qt = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, lr, It, Zr;
      Zr = {};
      function Cn(N) {
        if (Cr.call(N, "ref")) {
          var oe = Object.getOwnPropertyDescriptor(N, "ref").get;
          if (oe && oe.isReactWarning)
            return !1;
        }
        return N.ref !== void 0;
      }
      function Sn(N) {
        if (Cr.call(N, "key")) {
          var oe = Object.getOwnPropertyDescriptor(N, "key").get;
          if (oe && oe.isReactWarning)
            return !1;
        }
        return N.key !== void 0;
      }
      function vr(N, oe) {
        var xe = function() {
          lr || (lr = !0, Se("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", oe));
        };
        xe.isReactWarning = !0, Object.defineProperty(N, "key", {
          get: xe,
          configurable: !0
        });
      }
      function ln(N, oe) {
        var xe = function() {
          It || (It = !0, Se("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", oe));
        };
        xe.isReactWarning = !0, Object.defineProperty(N, "ref", {
          get: xe,
          configurable: !0
        });
      }
      function en(N) {
        if (typeof N.ref == "string" && _.current && N.__self && _.current.stateNode !== N.__self) {
          var oe = Pr(_.current.type);
          Zr[oe] || (Se('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', oe, N.ref), Zr[oe] = !0);
        }
      }
      var Fn = function(N, oe, xe, Ie, We, ot, dt) {
        var Nt = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: N,
          key: oe,
          ref: xe,
          props: dt,
          // Record the component responsible for creating this element.
          _owner: ot
        };
        return Nt._store = {}, Object.defineProperty(Nt._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Nt, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Ie
        }), Object.defineProperty(Nt, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: We
        }), Object.freeze && (Object.freeze(Nt.props), Object.freeze(Nt)), Nt;
      };
      function gn(N, oe, xe) {
        var Ie, We = {}, ot = null, dt = null, Nt = null, Yt = null;
        if (oe != null) {
          Cn(oe) && (dt = oe.ref, en(oe)), Sn(oe) && (Mn(oe.key), ot = "" + oe.key), Nt = oe.__self === void 0 ? null : oe.__self, Yt = oe.__source === void 0 ? null : oe.__source;
          for (Ie in oe)
            Cr.call(oe, Ie) && !qt.hasOwnProperty(Ie) && (We[Ie] = oe[Ie]);
        }
        var Ur = arguments.length - 2;
        if (Ur === 1)
          We.children = xe;
        else if (Ur > 1) {
          for (var qr = Array(Ur), Dr = 0; Dr < Ur; Dr++)
            qr[Dr] = arguments[Dr + 2];
          Object.freeze && Object.freeze(qr), We.children = qr;
        }
        if (N && N.defaultProps) {
          var Ar = N.defaultProps;
          for (Ie in Ar)
            We[Ie] === void 0 && (We[Ie] = Ar[Ie]);
        }
        if (ot || dt) {
          var Rn = typeof N == "function" ? N.displayName || N.name || "Unknown" : N;
          ot && vr(We, Rn), dt && ln(We, Rn);
        }
        return Fn(N, ot, dt, Nt, Yt, _.current, We);
      }
      function Gn(N, oe) {
        var xe = Fn(N.type, oe, N.ref, N._self, N._source, N._owner, N.props);
        return xe;
      }
      function Hn(N, oe, xe) {
        if (N == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + N + ".");
        var Ie, We = ve({}, N.props), ot = N.key, dt = N.ref, Nt = N._self, Yt = N._source, Ur = N._owner;
        if (oe != null) {
          Cn(oe) && (dt = oe.ref, Ur = _.current), Sn(oe) && (Mn(oe.key), ot = "" + oe.key);
          var qr;
          N.type && N.type.defaultProps && (qr = N.type.defaultProps);
          for (Ie in oe)
            Cr.call(oe, Ie) && !qt.hasOwnProperty(Ie) && (oe[Ie] === void 0 && qr !== void 0 ? We[Ie] = qr[Ie] : We[Ie] = oe[Ie]);
        }
        var Dr = arguments.length - 2;
        if (Dr === 1)
          We.children = xe;
        else if (Dr > 1) {
          for (var Ar = Array(Dr), Rn = 0; Rn < Dr; Rn++)
            Ar[Rn] = arguments[Rn + 2];
          We.children = Ar;
        }
        return Fn(N.type, ot, dt, Nt, Yt, Ur, We);
      }
      function tn(N) {
        return typeof N == "object" && N !== null && N.$$typeof === n;
      }
      var mn = ".", In = ":";
      function vn(N) {
        var oe = /[=:]/g, xe = {
          "=": "=0",
          ":": "=2"
        }, Ie = N.replace(oe, function(We) {
          return xe[We];
        });
        return "$" + Ie;
      }
      var fr = !1, Or = /\/+/g;
      function sn(N) {
        return N.replace(Or, "$&/");
      }
      function yt(N, oe) {
        return typeof N == "object" && N !== null && N.key != null ? (Mn(N.key), vn("" + N.key)) : oe.toString(36);
      }
      function yn(N, oe, xe, Ie, We) {
        var ot = typeof N;
        (ot === "undefined" || ot === "boolean") && (N = null);
        var dt = !1;
        if (N === null)
          dt = !0;
        else
          switch (ot) {
            case "string":
            case "number":
              dt = !0;
              break;
            case "object":
              switch (N.$$typeof) {
                case n:
                case i:
                  dt = !0;
              }
          }
        if (dt) {
          var Nt = N, Yt = We(Nt), Ur = Ie === "" ? mn + yt(Nt, 0) : Ie;
          if (ar(Yt)) {
            var qr = "";
            Ur != null && (qr = sn(Ur) + "/"), yn(Yt, oe, qr, "", function(os) {
              return os;
            });
          } else Yt != null && (tn(Yt) && (Yt.key && (!Nt || Nt.key !== Yt.key) && Mn(Yt.key), Yt = Gn(
            Yt,
            // Keep both the (mapped) and old keys if they differ, just as
            // traverseAllChildren used to do for objects as children
            xe + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
            (Yt.key && (!Nt || Nt.key !== Yt.key) ? (
              // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
              // eslint-disable-next-line react-internal/safe-string-coercion
              sn("" + Yt.key) + "/"
            ) : "") + Ur
          )), oe.push(Yt));
          return 1;
        }
        var Dr, Ar, Rn = 0, Jr = Ie === "" ? mn : Ie + In;
        if (ar(N))
          for (var Ya = 0; Ya < N.length; Ya++)
            Dr = N[Ya], Ar = Jr + yt(Dr, Ya), Rn += yn(Dr, oe, xe, Ar, We);
        else {
          var Xa = E(N);
          if (typeof Xa == "function") {
            var Vi = N;
            Xa === Vi.entries && (fr || ye("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), fr = !0);
            for (var pi = Xa.call(Vi), Ta, Vr = 0; !(Ta = pi.next()).done; )
              Dr = Ta.value, Ar = Jr + yt(Dr, Vr++), Rn += yn(Dr, oe, xe, Ar, We);
          } else if (ot === "object") {
            var ua = String(N);
            throw new Error("Objects are not valid as a React child (found: " + (ua === "[object Object]" ? "object with keys {" + Object.keys(N).join(", ") + "}" : ua) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return Rn;
      }
      function Nn(N, oe, xe) {
        if (N == null)
          return N;
        var Ie = [], We = 0;
        return yn(N, Ie, "", "", function(ot) {
          return oe.call(xe, ot, We++);
        }), Ie;
      }
      function Me(N) {
        var oe = 0;
        return Nn(N, function() {
          oe++;
        }), oe;
      }
      function M(N, oe, xe) {
        Nn(N, function() {
          oe.apply(this, arguments);
        }, xe);
      }
      function W(N) {
        return Nn(N, function(oe) {
          return oe;
        }) || [];
      }
      function se(N) {
        if (!tn(N))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return N;
      }
      function we(N) {
        var oe = {
          $$typeof: u,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: N,
          _currentValue2: N,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        oe.Provider = {
          $$typeof: l,
          _context: oe
        };
        var xe = !1, Ie = !1, We = !1;
        {
          var ot = {
            $$typeof: u,
            _context: oe
          };
          Object.defineProperties(ot, {
            Provider: {
              get: function() {
                return Ie || (Ie = !0, Se("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), oe.Provider;
              },
              set: function(dt) {
                oe.Provider = dt;
              }
            },
            _currentValue: {
              get: function() {
                return oe._currentValue;
              },
              set: function(dt) {
                oe._currentValue = dt;
              }
            },
            _currentValue2: {
              get: function() {
                return oe._currentValue2;
              },
              set: function(dt) {
                oe._currentValue2 = dt;
              }
            },
            _threadCount: {
              get: function() {
                return oe._threadCount;
              },
              set: function(dt) {
                oe._threadCount = dt;
              }
            },
            Consumer: {
              get: function() {
                return xe || (xe = !0, Se("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), oe.Consumer;
              }
            },
            displayName: {
              get: function() {
                return oe.displayName;
              },
              set: function(dt) {
                We || (ye("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", dt), We = !0);
              }
            }
          }), oe.Consumer = ot;
        }
        return oe._currentRenderer = null, oe._currentRenderer2 = null, oe;
      }
      var $e = -1, ut = 0, Mt = 1, Zt = 2;
      function rr(N) {
        if (N._status === $e) {
          var oe = N._result, xe = oe();
          if (xe.then(function(ot) {
            if (N._status === ut || N._status === $e) {
              var dt = N;
              dt._status = Mt, dt._result = ot;
            }
          }, function(ot) {
            if (N._status === ut || N._status === $e) {
              var dt = N;
              dt._status = Zt, dt._result = ot;
            }
          }), N._status === $e) {
            var Ie = N;
            Ie._status = ut, Ie._result = xe;
          }
        }
        if (N._status === Mt) {
          var We = N._result;
          return We === void 0 && Se(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, We), "default" in We || Se(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, We), We.default;
        } else
          throw N._result;
      }
      function Br(N) {
        var oe = {
          // We use these fields to store the result.
          _status: $e,
          _result: N
        }, xe = {
          $$typeof: m,
          _payload: oe,
          _init: rr
        };
        {
          var Ie, We;
          Object.defineProperties(xe, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return Ie;
              },
              set: function(ot) {
                Se("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Ie = ot, Object.defineProperty(xe, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return We;
              },
              set: function(ot) {
                Se("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), We = ot, Object.defineProperty(xe, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return xe;
      }
      function sr(N) {
        N != null && N.$$typeof === p ? Se("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof N != "function" ? Se("forwardRef requires a render function but was given %s.", N === null ? "null" : typeof N) : N.length !== 0 && N.length !== 2 && Se("forwardRef render functions accept exactly two parameters: props and ref. %s", N.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), N != null && (N.defaultProps != null || N.propTypes != null) && Se("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var oe = {
          $$typeof: c,
          render: N
        };
        {
          var xe;
          Object.defineProperty(oe, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return xe;
            },
            set: function(Ie) {
              xe = Ie, !N.name && !N.displayName && (N.displayName = Ie);
            }
          });
        }
        return oe;
      }
      var ue;
      ue = /* @__PURE__ */ Symbol.for("react.module.reference");
      function ze(N) {
        return !!(typeof N == "string" || typeof N == "function" || N === a || N === o || re || N === s || N === h || N === f || q || N === A || de || H || j || typeof N == "object" && N !== null && (N.$$typeof === m || N.$$typeof === p || N.$$typeof === l || N.$$typeof === u || N.$$typeof === c || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        N.$$typeof === ue || N.getModuleId !== void 0));
      }
      function ct(N, oe) {
        ze(N) || Se("memo: The first argument must be a component. Instead received: %s", N === null ? "null" : typeof N);
        var xe = {
          $$typeof: p,
          type: N,
          compare: oe === void 0 ? null : oe
        };
        {
          var Ie;
          Object.defineProperty(xe, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return Ie;
            },
            set: function(We) {
              Ie = We, !N.name && !N.displayName && (N.displayName = We);
            }
          });
        }
        return xe;
      }
      function ft() {
        var N = T.current;
        return N === null && Se(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), N;
      }
      function Vt(N) {
        var oe = ft();
        if (N._context !== void 0) {
          var xe = N._context;
          xe.Consumer === N ? Se("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : xe.Provider === N && Se("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return oe.useContext(N);
      }
      function Ot(N) {
        var oe = ft();
        return oe.useState(N);
      }
      function Qt(N, oe, xe) {
        var Ie = ft();
        return Ie.useReducer(N, oe, xe);
      }
      function zt(N) {
        var oe = ft();
        return oe.useRef(N);
      }
      function Hr(N, oe) {
        var xe = ft();
        return xe.useEffect(N, oe);
      }
      function Tr(N, oe) {
        var xe = ft();
        return xe.useInsertionEffect(N, oe);
      }
      function Nr(N, oe) {
        var xe = ft();
        return xe.useLayoutEffect(N, oe);
      }
      function dr(N, oe) {
        var xe = ft();
        return xe.useCallback(N, oe);
      }
      function vi(N, oe) {
        var xe = ft();
        return xe.useMemo(N, oe);
      }
      function Xn(N, oe, xe) {
        var Ie = ft();
        return Ie.useImperativeHandle(N, oe, xe);
      }
      function Yr(N, oe) {
        {
          var xe = ft();
          return xe.useDebugValue(N, oe);
        }
      }
      function Wr() {
        var N = ft();
        return N.useTransition();
      }
      function oi(N) {
        var oe = ft();
        return oe.useDeferredValue(N);
      }
      function An() {
        var N = ft();
        return N.useId();
      }
      function Di(N, oe, xe) {
        var Ie = ft();
        return Ie.useSyncExternalStore(N, oe, xe);
      }
      var ni = 0, En, ii, Jn, Un, Li, Hi, ai;
      function Kn() {
      }
      Kn.__reactDisabledLog = !0;
      function Vn() {
        {
          if (ni === 0) {
            En = console.log, ii = console.info, Jn = console.warn, Un = console.error, Li = console.group, Hi = console.groupCollapsed, ai = console.groupEnd;
            var N = {
              configurable: !0,
              enumerable: !0,
              value: Kn,
              writable: !0
            };
            Object.defineProperties(console, {
              info: N,
              log: N,
              warn: N,
              error: N,
              group: N,
              groupCollapsed: N,
              groupEnd: N
            });
          }
          ni++;
        }
      }
      function Pn() {
        {
          if (ni--, ni === 0) {
            var N = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: ve({}, N, {
                value: En
              }),
              info: ve({}, N, {
                value: ii
              }),
              warn: ve({}, N, {
                value: Jn
              }),
              error: ve({}, N, {
                value: Un
              }),
              group: ve({}, N, {
                value: Li
              }),
              groupCollapsed: ve({}, N, {
                value: Hi
              }),
              groupEnd: ve({}, N, {
                value: ai
              })
            });
          }
          ni < 0 && Se("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var kn = ae.ReactCurrentDispatcher, $n;
      function I(N, oe, xe) {
        {
          if ($n === void 0)
            try {
              throw Error();
            } catch (We) {
              var Ie = We.stack.trim().match(/\n( *(at )?)/);
              $n = Ie && Ie[1] || "";
            }
          return `
` + $n + N;
        }
      }
      var U = !1, Y;
      {
        var ne = typeof WeakMap == "function" ? WeakMap : Map;
        Y = new ne();
      }
      function Ee(N, oe) {
        if (!N || U)
          return "";
        {
          var xe = Y.get(N);
          if (xe !== void 0)
            return xe;
        }
        var Ie;
        U = !0;
        var We = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var ot;
        ot = kn.current, kn.current = null, Vn();
        try {
          if (oe) {
            var dt = function() {
              throw Error();
            };
            if (Object.defineProperty(dt.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(dt, []);
              } catch (Jr) {
                Ie = Jr;
              }
              Reflect.construct(N, [], dt);
            } else {
              try {
                dt.call();
              } catch (Jr) {
                Ie = Jr;
              }
              N.call(dt.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Jr) {
              Ie = Jr;
            }
            N();
          }
        } catch (Jr) {
          if (Jr && Ie && typeof Jr.stack == "string") {
            for (var Nt = Jr.stack.split(`
`), Yt = Ie.stack.split(`
`), Ur = Nt.length - 1, qr = Yt.length - 1; Ur >= 1 && qr >= 0 && Nt[Ur] !== Yt[qr]; )
              qr--;
            for (; Ur >= 1 && qr >= 0; Ur--, qr--)
              if (Nt[Ur] !== Yt[qr]) {
                if (Ur !== 1 || qr !== 1)
                  do
                    if (Ur--, qr--, qr < 0 || Nt[Ur] !== Yt[qr]) {
                      var Dr = `
` + Nt[Ur].replace(" at new ", " at ");
                      return N.displayName && Dr.includes("<anonymous>") && (Dr = Dr.replace("<anonymous>", N.displayName)), typeof N == "function" && Y.set(N, Dr), Dr;
                    }
                  while (Ur >= 1 && qr >= 0);
                break;
              }
          }
        } finally {
          U = !1, kn.current = ot, Pn(), Error.prepareStackTrace = We;
        }
        var Ar = N ? N.displayName || N.name : "", Rn = Ar ? I(Ar) : "";
        return typeof N == "function" && Y.set(N, Rn), Rn;
      }
      function be(N, oe, xe) {
        return Ee(N, !1);
      }
      function _e(N) {
        var oe = N.prototype;
        return !!(oe && oe.isReactComponent);
      }
      function Ye(N, oe, xe) {
        if (N == null)
          return "";
        if (typeof N == "function")
          return Ee(N, _e(N));
        if (typeof N == "string")
          return I(N);
        switch (N) {
          case h:
            return I("Suspense");
          case f:
            return I("SuspenseList");
        }
        if (typeof N == "object")
          switch (N.$$typeof) {
            case c:
              return be(N.render);
            case p:
              return Ye(N.type, oe, xe);
            case m: {
              var Ie = N, We = Ie._payload, ot = Ie._init;
              try {
                return Ye(ot(We), oe, xe);
              } catch {
              }
            }
          }
        return "";
      }
      var vt = {}, Et = ae.ReactDebugCurrentFrame;
      function pt(N) {
        if (N) {
          var oe = N._owner, xe = Ye(N.type, N._source, oe ? oe.type : null);
          Et.setExtraStackFrame(xe);
        } else
          Et.setExtraStackFrame(null);
      }
      function yr(N, oe, xe, Ie, We) {
        {
          var ot = Function.call.bind(Cr);
          for (var dt in N)
            if (ot(N, dt)) {
              var Nt = void 0;
              try {
                if (typeof N[dt] != "function") {
                  var Yt = Error((Ie || "React class") + ": " + xe + " type `" + dt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof N[dt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Yt.name = "Invariant Violation", Yt;
                }
                Nt = N[dt](oe, dt, Ie, xe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Ur) {
                Nt = Ur;
              }
              Nt && !(Nt instanceof Error) && (pt(We), Se("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ie || "React class", xe, dt, typeof Nt), pt(null)), Nt instanceof Error && !(Nt.message in vt) && (vt[Nt.message] = !0, pt(We), Se("Failed %s type: %s", xe, Nt.message), pt(null));
            }
        }
      }
      function jr(N) {
        if (N) {
          var oe = N._owner, xe = Ye(N.type, N._source, oe ? oe.type : null);
          te(xe);
        } else
          te(null);
      }
      var Dn;
      Dn = !1;
      function Wn() {
        if (_.current) {
          var N = Pr(_.current.type);
          if (N)
            return `

Check the render method of \`` + N + "`.";
        }
        return "";
      }
      function Ri(N) {
        if (N !== void 0) {
          var oe = N.fileName.replace(/^.*[\\\/]/, ""), xe = N.lineNumber;
          return `

Check your code at ` + oe + ":" + xe + ".";
        }
        return "";
      }
      function yi(N) {
        return N != null ? Ri(N.__source) : "";
      }
      var Zn = {};
      function wn(N) {
        var oe = Wn();
        if (!oe) {
          var xe = typeof N == "string" ? N : N.displayName || N.name;
          xe && (oe = `

Check the top-level render call using <` + xe + ">.");
        }
        return oe;
      }
      function Oi(N, oe) {
        if (!(!N._store || N._store.validated || N.key != null)) {
          N._store.validated = !0;
          var xe = wn(oe);
          if (!Zn[xe]) {
            Zn[xe] = !0;
            var Ie = "";
            N && N._owner && N._owner !== _.current && (Ie = " It was passed a child from " + Pr(N._owner.type) + "."), jr(N), Se('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', xe, Ie), jr(null);
          }
        }
      }
      function Ai(N, oe) {
        if (typeof N == "object") {
          if (ar(N))
            for (var xe = 0; xe < N.length; xe++) {
              var Ie = N[xe];
              tn(Ie) && Oi(Ie, oe);
            }
          else if (tn(N))
            N._store && (N._store.validated = !0);
          else if (N) {
            var We = E(N);
            if (typeof We == "function" && We !== N.entries)
              for (var ot = We.call(N), dt; !(dt = ot.next()).done; )
                tn(dt.value) && Oi(dt.value, oe);
          }
        }
      }
      function di(N) {
        {
          var oe = N.type;
          if (oe == null || typeof oe == "string")
            return;
          var xe;
          if (typeof oe == "function")
            xe = oe.propTypes;
          else if (typeof oe == "object" && (oe.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          oe.$$typeof === p))
            xe = oe.propTypes;
          else
            return;
          if (xe) {
            var Ie = Pr(oe);
            yr(xe, N.props, "prop", Ie, N);
          } else if (oe.PropTypes !== void 0 && !Dn) {
            Dn = !0;
            var We = Pr(oe);
            Se("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", We || "Unknown");
          }
          typeof oe.getDefaultProps == "function" && !oe.getDefaultProps.isReactClassApproved && Se("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function ka(N) {
        {
          for (var oe = Object.keys(N.props), xe = 0; xe < oe.length; xe++) {
            var Ie = oe[xe];
            if (Ie !== "children" && Ie !== "key") {
              jr(N), Se("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ie), jr(null);
              break;
            }
          }
          N.ref !== null && (jr(N), Se("Invalid attribute `ref` supplied to `React.Fragment`."), jr(null));
        }
      }
      function oa(N, oe, xe) {
        var Ie = ze(N);
        if (!Ie) {
          var We = "";
          (N === void 0 || typeof N == "object" && N !== null && Object.keys(N).length === 0) && (We += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ot = yi(oe);
          ot ? We += ot : We += Wn();
          var dt;
          N === null ? dt = "null" : ar(N) ? dt = "array" : N !== void 0 && N.$$typeof === n ? (dt = "<" + (Pr(N.type) || "Unknown") + " />", We = " Did you accidentally export a JSX literal instead of a component?") : dt = typeof N, Se("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", dt, We);
        }
        var Nt = gn.apply(this, arguments);
        if (Nt == null)
          return Nt;
        if (Ie)
          for (var Yt = 2; Yt < arguments.length; Yt++)
            Ai(arguments[Yt], N);
        return N === a ? ka(Nt) : di(Nt), Nt;
      }
      var la = !1;
      function wi(N) {
        var oe = oa.bind(null, N);
        return oe.type = N, la || (la = !0, ye("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(oe, "type", {
          enumerable: !1,
          get: function() {
            return ye("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: N
            }), N;
          }
        }), oe;
      }
      function Zi(N, oe, xe) {
        for (var Ie = Hn.apply(this, arguments), We = 2; We < arguments.length; We++)
          Ai(arguments[We], Ie.type);
        return di(Ie), Ie;
      }
      function Ei(N, oe) {
        var xe = D.transition;
        D.transition = {};
        var Ie = D.transition;
        D.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          N();
        } finally {
          if (D.transition = xe, xe === null && Ie._updatedFibers) {
            var We = Ie._updatedFibers.size;
            We > 10 && ye("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), Ie._updatedFibers.clear();
          }
        }
      }
      var li = !1, Ui = null;
      function _r(N) {
        if (Ui === null)
          try {
            var oe = ("require" + Math.random()).slice(0, 7), xe = r && r[oe];
            Ui = xe.call(r, "timers").setImmediate;
          } catch {
            Ui = function(We) {
              li === !1 && (li = !0, typeof MessageChannel > "u" && Se("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var ot = new MessageChannel();
              ot.port1.onmessage = We, ot.port2.postMessage(void 0);
            };
          }
        return Ui(N);
      }
      var hi = 0, Lr = !1;
      function R(N) {
        {
          var oe = hi;
          hi++, F.current === null && (F.current = []);
          var xe = F.isBatchingLegacy, Ie;
          try {
            if (F.isBatchingLegacy = !0, Ie = N(), !xe && F.didScheduleLegacyUpdate) {
              var We = F.current;
              We !== null && (F.didScheduleLegacyUpdate = !1, Bt(We));
            }
          } catch (Ar) {
            throw X(oe), Ar;
          } finally {
            F.isBatchingLegacy = xe;
          }
          if (Ie !== null && typeof Ie == "object" && typeof Ie.then == "function") {
            var ot = Ie, dt = !1, Nt = {
              then: function(Ar, Rn) {
                dt = !0, ot.then(function(Jr) {
                  X(oe), hi === 0 ? pe(Jr, Ar, Rn) : Ar(Jr);
                }, function(Jr) {
                  X(oe), Rn(Jr);
                });
              }
            };
            return !Lr && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              dt || (Lr = !0, Se("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), Nt;
          } else {
            var Yt = Ie;
            if (X(oe), hi === 0) {
              var Ur = F.current;
              Ur !== null && (Bt(Ur), F.current = null);
              var qr = {
                then: function(Ar, Rn) {
                  F.current === null ? (F.current = [], pe(Yt, Ar, Rn)) : Ar(Yt);
                }
              };
              return qr;
            } else {
              var Dr = {
                then: function(Ar, Rn) {
                  Ar(Yt);
                }
              };
              return Dr;
            }
          }
        }
      }
      function X(N) {
        N !== hi - 1 && Se("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), hi = N;
      }
      function pe(N, oe, xe) {
        {
          var Ie = F.current;
          if (Ie !== null)
            try {
              Bt(Ie), _r(function() {
                Ie.length === 0 ? (F.current = null, oe(N)) : pe(N, oe, xe);
              });
            } catch (We) {
              xe(We);
            }
          else
            oe(N);
        }
      }
      var Re = !1;
      function Bt(N) {
        if (!Re) {
          Re = !0;
          var oe = 0;
          try {
            for (; oe < N.length; oe++) {
              var xe = N[oe];
              do
                xe = xe(!0);
              while (xe !== null);
            }
            N.length = 0;
          } catch (Ie) {
            throw N = N.slice(oe + 1), Ie;
          } finally {
            Re = !1;
          }
        }
      }
      var Tt = oa, hr = Zi, or = wi, xn = {
        map: Nn,
        forEach: M,
        count: Me,
        toArray: W,
        only: se
      };
      e.Children = xn, e.Component = mt, e.Fragment = a, e.Profiler = o, e.PureComponent = rt, e.StrictMode = s, e.Suspense = h, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ae, e.act = R, e.cloneElement = hr, e.createContext = we, e.createElement = Tt, e.createFactory = or, e.createRef = Fr, e.forwardRef = sr, e.isValidElement = tn, e.lazy = Br, e.memo = ct, e.startTransition = Ei, e.unstable_act = R, e.useCallback = dr, e.useContext = Vt, e.useDebugValue = Yr, e.useDeferredValue = oi, e.useEffect = Hr, e.useId = An, e.useImperativeHandle = Xn, e.useInsertionEffect = Tr, e.useLayoutEffect = Nr, e.useMemo = vi, e.useReducer = Qt, e.useRef = zt, e.useState = Ot, e.useSyncExternalStore = Di, e.useTransition = Wr, e.version = t, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    })();
  })(pp, pp.exports)), pp.exports;
}
var DS;
function Vf() {
  return DS || (DS = 1, process.env.NODE_ENV === "production" ? Ug.exports = vN() : Ug.exports = yN()), Ug.exports;
}
var RS;
function AN() {
  if (RS) return vf;
  RS = 1;
  var r = Vf();
  function e(I) {
    for (var U = "https://reactjs.org/docs/error-decoder.html?invariant=" + I, Y = 1; Y < arguments.length; Y++) U += "&args[]=" + encodeURIComponent(arguments[Y]);
    return "Minified React error #" + I + "; visit " + U + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var t = Object.prototype.hasOwnProperty, n = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, i = {}, a = {};
  function s(I) {
    return t.call(a, I) ? !0 : t.call(i, I) ? !1 : n.test(I) ? a[I] = !0 : (i[I] = !0, !1);
  }
  function o(I, U, Y, ne, Ee, be, _e) {
    this.acceptsBooleans = U === 2 || U === 3 || U === 4, this.attributeName = ne, this.attributeNamespace = Ee, this.mustUseProperty = Y, this.propertyName = I, this.type = U, this.sanitizeURL = be, this.removeEmptyString = _e;
  }
  var l = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(I) {
    l[I] = new o(I, 0, !1, I, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(I) {
    var U = I[0];
    l[U] = new o(U, 1, !1, I[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(I) {
    l[I] = new o(I, 2, !1, I.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(I) {
    l[I] = new o(I, 2, !1, I, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(I) {
    l[I] = new o(I, 3, !1, I.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(I) {
    l[I] = new o(I, 3, !0, I, null, !1, !1);
  }), ["capture", "download"].forEach(function(I) {
    l[I] = new o(I, 4, !1, I, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(I) {
    l[I] = new o(I, 6, !1, I, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(I) {
    l[I] = new o(I, 5, !1, I.toLowerCase(), null, !1, !1);
  });
  var u = /[\-:]([a-z])/g;
  function c(I) {
    return I[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(I) {
    var U = I.replace(
      u,
      c
    );
    l[U] = new o(U, 1, !1, I, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(I) {
    var U = I.replace(u, c);
    l[U] = new o(U, 1, !1, I, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(I) {
    var U = I.replace(u, c);
    l[U] = new o(U, 1, !1, I, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(I) {
    l[I] = new o(I, 1, !1, I.toLowerCase(), null, !1, !1);
  }), l.xlinkHref = new o("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(I) {
    l[I] = new o(I, 1, !1, I.toLowerCase(), null, !0, !0);
  });
  var h = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, f = ["Webkit", "ms", "Moz", "O"];
  Object.keys(h).forEach(function(I) {
    f.forEach(function(U) {
      U = U + I.charAt(0).toUpperCase() + I.substring(1), h[U] = h[I];
    });
  });
  var p = /["'&<>]/;
  function m(I) {
    if (typeof I == "boolean" || typeof I == "number") return "" + I;
    I = "" + I;
    var U = p.exec(I);
    if (U) {
      var Y = "", ne, Ee = 0;
      for (ne = U.index; ne < I.length; ne++) {
        switch (I.charCodeAt(ne)) {
          case 34:
            U = "&quot;";
            break;
          case 38:
            U = "&amp;";
            break;
          case 39:
            U = "&#x27;";
            break;
          case 60:
            U = "&lt;";
            break;
          case 62:
            U = "&gt;";
            break;
          default:
            continue;
        }
        Ee !== ne && (Y += I.substring(Ee, ne)), Ee = ne + 1, Y += U;
      }
      I = Ee !== ne ? Y + I.substring(Ee, ne) : Y;
    }
    return I;
  }
  var A = /([A-Z])/g, w = /^ms-/, x = Array.isArray;
  function E(I, U) {
    return { insertionMode: I, selectedValue: U };
  }
  function T(I, U, Y) {
    switch (U) {
      case "select":
        return E(1, Y.value != null ? Y.value : Y.defaultValue);
      case "svg":
        return E(2, null);
      case "math":
        return E(3, null);
      case "foreignObject":
        return E(1, null);
      case "table":
        return E(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return E(5, null);
      case "colgroup":
        return E(7, null);
      case "tr":
        return E(6, null);
    }
    return 4 <= I.insertionMode || I.insertionMode === 0 ? E(1, null) : I;
  }
  var D = /* @__PURE__ */ new Map();
  function F(I, U, Y) {
    if (typeof Y != "object") throw Error(e(62));
    U = !0;
    for (var ne in Y) if (t.call(Y, ne)) {
      var Ee = Y[ne];
      if (Ee != null && typeof Ee != "boolean" && Ee !== "") {
        if (ne.indexOf("--") === 0) {
          var be = m(ne);
          Ee = m(("" + Ee).trim());
        } else {
          be = ne;
          var _e = D.get(be);
          _e !== void 0 || (_e = m(be.replace(A, "-$1").toLowerCase().replace(w, "-ms-")), D.set(be, _e)), be = _e, Ee = typeof Ee == "number" ? Ee === 0 || t.call(h, ne) ? "" + Ee : Ee + "px" : m(("" + Ee).trim());
        }
        U ? (U = !1, I.push(' style="', be, ":", Ee)) : I.push(";", be, ":", Ee);
      }
    }
    U || I.push('"');
  }
  function _(I, U, Y, ne) {
    switch (Y) {
      case "style":
        F(I, U, ne);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < Y.length) || Y[0] !== "o" && Y[0] !== "O" || Y[1] !== "n" && Y[1] !== "N") {
      if (U = l.hasOwnProperty(Y) ? l[Y] : null, U !== null) {
        switch (typeof ne) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!U.acceptsBooleans) return;
        }
        switch (Y = U.attributeName, U.type) {
          case 3:
            ne && I.push(" ", Y, '=""');
            break;
          case 4:
            ne === !0 ? I.push(" ", Y, '=""') : ne !== !1 && I.push(" ", Y, '="', m(ne), '"');
            break;
          case 5:
            isNaN(ne) || I.push(" ", Y, '="', m(ne), '"');
            break;
          case 6:
            !isNaN(ne) && 1 <= ne && I.push(" ", Y, '="', m(ne), '"');
            break;
          default:
            U.sanitizeURL && (ne = "" + ne), I.push(" ", Y, '="', m(ne), '"');
        }
      } else if (s(Y)) {
        switch (typeof ne) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (U = Y.toLowerCase().slice(0, 5), U !== "data-" && U !== "aria-") return;
        }
        I.push(" ", Y, '="', m(ne), '"');
      }
    }
  }
  function L(I, U, Y) {
    if (U != null) {
      if (Y != null) throw Error(e(60));
      if (typeof U != "object" || !("__html" in U)) throw Error(e(61));
      U = U.__html, U != null && I.push("" + U);
    }
  }
  function Z(I) {
    var U = "";
    return r.Children.forEach(I, function(Y) {
      Y != null && (U += Y);
    }), U;
  }
  function te(I, U, Y, ne) {
    I.push(j(Y));
    var Ee = Y = null, be;
    for (be in U) if (t.call(U, be)) {
      var _e = U[be];
      if (_e != null) switch (be) {
        case "children":
          Y = _e;
          break;
        case "dangerouslySetInnerHTML":
          Ee = _e;
          break;
        default:
          _(I, ne, be, _e);
      }
    }
    return I.push(">"), L(I, Ee, Y), typeof Y == "string" ? (I.push(m(Y)), null) : Y;
  }
  var de = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, H = /* @__PURE__ */ new Map();
  function j(I) {
    var U = H.get(I);
    if (U === void 0) {
      if (!de.test(I)) throw Error(e(65, I));
      U = "<" + I, H.set(I, U);
    }
    return U;
  }
  function q(I, U, Y, ne, Ee) {
    switch (U) {
      case "select":
        I.push(j("select"));
        var be = null, _e = null;
        for (pt in Y) if (t.call(Y, pt)) {
          var Ye = Y[pt];
          if (Ye != null) switch (pt) {
            case "children":
              be = Ye;
              break;
            case "dangerouslySetInnerHTML":
              _e = Ye;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              _(I, ne, pt, Ye);
          }
        }
        return I.push(">"), L(I, _e, be), be;
      case "option":
        _e = Ee.selectedValue, I.push(j("option"));
        var vt = Ye = null, Et = null, pt = null;
        for (be in Y) if (t.call(Y, be)) {
          var yr = Y[be];
          if (yr != null) switch (be) {
            case "children":
              Ye = yr;
              break;
            case "selected":
              Et = yr;
              break;
            case "dangerouslySetInnerHTML":
              pt = yr;
              break;
            case "value":
              vt = yr;
            default:
              _(I, ne, be, yr);
          }
        }
        if (_e != null) if (Y = vt !== null ? "" + vt : Z(Ye), x(_e)) {
          for (ne = 0; ne < _e.length; ne++)
            if ("" + _e[ne] === Y) {
              I.push(' selected=""');
              break;
            }
        } else "" + _e === Y && I.push(' selected=""');
        else Et && I.push(' selected=""');
        return I.push(">"), L(I, pt, Ye), Ye;
      case "textarea":
        I.push(j("textarea")), pt = _e = be = null;
        for (Ye in Y) if (t.call(Y, Ye) && (vt = Y[Ye], vt != null)) switch (Ye) {
          case "children":
            pt = vt;
            break;
          case "value":
            be = vt;
            break;
          case "defaultValue":
            _e = vt;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(e(91));
          default:
            _(
              I,
              ne,
              Ye,
              vt
            );
        }
        if (be === null && _e !== null && (be = _e), I.push(">"), pt != null) {
          if (be != null) throw Error(e(92));
          if (x(pt) && 1 < pt.length) throw Error(e(93));
          be = "" + pt;
        }
        return typeof be == "string" && be[0] === `
` && I.push(`
`), be !== null && I.push(m("" + be)), null;
      case "input":
        I.push(j("input")), vt = pt = Ye = be = null;
        for (_e in Y) if (t.call(Y, _e) && (Et = Y[_e], Et != null)) switch (_e) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(e(399, "input"));
          case "defaultChecked":
            vt = Et;
            break;
          case "defaultValue":
            Ye = Et;
            break;
          case "checked":
            pt = Et;
            break;
          case "value":
            be = Et;
            break;
          default:
            _(I, ne, _e, Et);
        }
        return pt !== null ? _(I, ne, "checked", pt) : vt !== null && _(I, ne, "checked", vt), be !== null ? _(I, ne, "value", be) : Ye !== null && _(I, ne, "value", Ye), I.push("/>"), null;
      case "menuitem":
        I.push(j("menuitem"));
        for (var jr in Y) if (t.call(Y, jr) && (be = Y[jr], be != null)) switch (jr) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(e(400));
          default:
            _(I, ne, jr, be);
        }
        return I.push(">"), null;
      case "title":
        I.push(j("title")), be = null;
        for (yr in Y) if (t.call(Y, yr) && (_e = Y[yr], _e != null)) switch (yr) {
          case "children":
            be = _e;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(e(434));
          default:
            _(I, ne, yr, _e);
        }
        return I.push(">"), be;
      case "listing":
      case "pre":
        I.push(j(U)), _e = be = null;
        for (vt in Y) if (t.call(Y, vt) && (Ye = Y[vt], Ye != null)) switch (vt) {
          case "children":
            be = Ye;
            break;
          case "dangerouslySetInnerHTML":
            _e = Ye;
            break;
          default:
            _(I, ne, vt, Ye);
        }
        if (I.push(">"), _e != null) {
          if (be != null) throw Error(e(60));
          if (typeof _e != "object" || !("__html" in _e)) throw Error(e(61));
          Y = _e.__html, Y != null && (typeof Y == "string" && 0 < Y.length && Y[0] === `
` ? I.push(`
`, Y) : I.push("" + Y));
        }
        return typeof be == "string" && be[0] === `
` && I.push(`
`), be;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        I.push(j(U));
        for (var Dn in Y) if (t.call(Y, Dn) && (be = Y[Dn], be != null)) switch (Dn) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(e(399, U));
          default:
            _(I, ne, Dn, be);
        }
        return I.push("/>"), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return te(
          I,
          Y,
          U,
          ne
        );
      case "html":
        return Ee.insertionMode === 0 && I.push("<!DOCTYPE html>"), te(I, Y, U, ne);
      default:
        if (U.indexOf("-") === -1 && typeof Y.is != "string") return te(I, Y, U, ne);
        I.push(j(U)), _e = be = null;
        for (Et in Y) if (t.call(Y, Et) && (Ye = Y[Et], Ye != null)) switch (Et) {
          case "children":
            be = Ye;
            break;
          case "dangerouslySetInnerHTML":
            _e = Ye;
            break;
          case "style":
            F(I, ne, Ye);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            s(Et) && typeof Ye != "function" && typeof Ye != "symbol" && I.push(" ", Et, '="', m(Ye), '"');
        }
        return I.push(">"), L(I, _e, be), be;
    }
  }
  function re(I, U, Y) {
    if (I.push('<!--$?--><template id="'), Y === null) throw Error(e(395));
    return I.push(Y), I.push('"></template>');
  }
  function ae(I, U, Y, ne) {
    switch (Y.insertionMode) {
      case 0:
      case 1:
        return I.push('<div hidden id="'), I.push(U.segmentPrefix), U = ne.toString(16), I.push(U), I.push('">');
      case 2:
        return I.push('<svg aria-hidden="true" style="display:none" id="'), I.push(U.segmentPrefix), U = ne.toString(16), I.push(U), I.push('">');
      case 3:
        return I.push('<math aria-hidden="true" style="display:none" id="'), I.push(U.segmentPrefix), U = ne.toString(16), I.push(U), I.push('">');
      case 4:
        return I.push('<table hidden id="'), I.push(U.segmentPrefix), U = ne.toString(16), I.push(U), I.push('">');
      case 5:
        return I.push('<table hidden><tbody id="'), I.push(U.segmentPrefix), U = ne.toString(16), I.push(U), I.push('">');
      case 6:
        return I.push('<table hidden><tr id="'), I.push(U.segmentPrefix), U = ne.toString(16), I.push(U), I.push('">');
      case 7:
        return I.push('<table hidden><colgroup id="'), I.push(U.segmentPrefix), U = ne.toString(16), I.push(U), I.push('">');
      default:
        throw Error(e(397));
    }
  }
  function ye(I, U) {
    switch (U.insertionMode) {
      case 0:
      case 1:
        return I.push("</div>");
      case 2:
        return I.push("</svg>");
      case 3:
        return I.push("</math>");
      case 4:
        return I.push("</table>");
      case 5:
        return I.push("</tbody></table>");
      case 6:
        return I.push("</tr></table>");
      case 7:
        return I.push("</colgroup></table>");
      default:
        throw Error(e(397));
    }
  }
  var Se = /[<\u2028\u2029]/g;
  function Xe(I) {
    return JSON.stringify(I).replace(Se, function(U) {
      switch (U) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  function Ve(I, U) {
    return U = U === void 0 ? "" : U, { bootstrapChunks: [], startInlineScript: "<script>", placeholderPrefix: U + "P:", segmentPrefix: U + "S:", boundaryPrefix: U + "B:", idPrefix: U, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1, generateStaticMarkup: I };
  }
  function He(I, U, Y, ne) {
    return Y.generateStaticMarkup ? (I.push(m(U)), !1) : (U === "" ? I = ne : (ne && I.push("<!-- -->"), I.push(m(U)), I = !0), I);
  }
  var le = Object.assign, ve = /* @__PURE__ */ Symbol.for("react.element"), it = /* @__PURE__ */ Symbol.for("react.portal"), mt = /* @__PURE__ */ Symbol.for("react.fragment"), qe = /* @__PURE__ */ Symbol.for("react.strict_mode"), at = /* @__PURE__ */ Symbol.for("react.profiler"), st = /* @__PURE__ */ Symbol.for("react.provider"), lt = /* @__PURE__ */ Symbol.for("react.context"), rt = /* @__PURE__ */ Symbol.for("react.forward_ref"), Rt = /* @__PURE__ */ Symbol.for("react.suspense"), Fr = /* @__PURE__ */ Symbol.for("react.suspense_list"), an = /* @__PURE__ */ Symbol.for("react.memo"), ar = /* @__PURE__ */ Symbol.for("react.lazy"), Ir = /* @__PURE__ */ Symbol.for("react.scope"), kt = /* @__PURE__ */ Symbol.for("react.debug_trace_mode"), wt = /* @__PURE__ */ Symbol.for("react.legacy_hidden"), Mn = /* @__PURE__ */ Symbol.for("react.default_value"), kr = Symbol.iterator;
  function Gr(I) {
    if (I == null) return null;
    if (typeof I == "function") return I.displayName || I.name || null;
    if (typeof I == "string") return I;
    switch (I) {
      case mt:
        return "Fragment";
      case it:
        return "Portal";
      case at:
        return "Profiler";
      case qe:
        return "StrictMode";
      case Rt:
        return "Suspense";
      case Fr:
        return "SuspenseList";
    }
    if (typeof I == "object") switch (I.$$typeof) {
      case lt:
        return (I.displayName || "Context") + ".Consumer";
      case st:
        return (I._context.displayName || "Context") + ".Provider";
      case rt:
        var U = I.render;
        return I = I.displayName, I || (I = U.displayName || U.name || "", I = I !== "" ? "ForwardRef(" + I + ")" : "ForwardRef"), I;
      case an:
        return U = I.displayName || null, U !== null ? U : Gr(I.type) || "Memo";
      case ar:
        U = I._payload, I = I._init;
        try {
          return Gr(I(U));
        } catch {
        }
    }
    return null;
  }
  var Pr = {};
  function Cr(I, U) {
    if (I = I.contextTypes, !I) return Pr;
    var Y = {}, ne;
    for (ne in I) Y[ne] = U[ne];
    return Y;
  }
  var qt = null;
  function lr(I, U) {
    if (I !== U) {
      I.context._currentValue2 = I.parentValue, I = I.parent;
      var Y = U.parent;
      if (I === null) {
        if (Y !== null) throw Error(e(401));
      } else {
        if (Y === null) throw Error(e(401));
        lr(I, Y);
      }
      U.context._currentValue2 = U.value;
    }
  }
  function It(I) {
    I.context._currentValue2 = I.parentValue, I = I.parent, I !== null && It(I);
  }
  function Zr(I) {
    var U = I.parent;
    U !== null && Zr(U), I.context._currentValue2 = I.value;
  }
  function Cn(I, U) {
    if (I.context._currentValue2 = I.parentValue, I = I.parent, I === null) throw Error(e(402));
    I.depth === U.depth ? lr(I, U) : Cn(I, U);
  }
  function Sn(I, U) {
    var Y = U.parent;
    if (Y === null) throw Error(e(402));
    I.depth === Y.depth ? lr(I, Y) : Sn(I, Y), U.context._currentValue2 = U.value;
  }
  function vr(I) {
    var U = qt;
    U !== I && (U === null ? Zr(I) : I === null ? It(U) : U.depth === I.depth ? lr(U, I) : U.depth > I.depth ? Cn(U, I) : Sn(U, I), qt = I);
  }
  var ln = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(I, U) {
    I = I._reactInternals, I.queue !== null && I.queue.push(U);
  }, enqueueReplaceState: function(I, U) {
    I = I._reactInternals, I.replace = !0, I.queue = [U];
  }, enqueueForceUpdate: function() {
  } };
  function en(I, U, Y, ne) {
    var Ee = I.state !== void 0 ? I.state : null;
    I.updater = ln, I.props = Y, I.state = Ee;
    var be = { queue: [], replace: !1 };
    I._reactInternals = be;
    var _e = U.contextType;
    if (I.context = typeof _e == "object" && _e !== null ? _e._currentValue2 : ne, _e = U.getDerivedStateFromProps, typeof _e == "function" && (_e = _e(Y, Ee), Ee = _e == null ? Ee : le({}, Ee, _e), I.state = Ee), typeof U.getDerivedStateFromProps != "function" && typeof I.getSnapshotBeforeUpdate != "function" && (typeof I.UNSAFE_componentWillMount == "function" || typeof I.componentWillMount == "function")) if (U = I.state, typeof I.componentWillMount == "function" && I.componentWillMount(), typeof I.UNSAFE_componentWillMount == "function" && I.UNSAFE_componentWillMount(), U !== I.state && ln.enqueueReplaceState(I, I.state, null), be.queue !== null && 0 < be.queue.length) if (U = be.queue, _e = be.replace, be.queue = null, be.replace = !1, _e && U.length === 1) I.state = U[0];
    else {
      for (be = _e ? U[0] : I.state, Ee = !0, _e = _e ? 1 : 0; _e < U.length; _e++) {
        var Ye = U[_e];
        Ye = typeof Ye == "function" ? Ye.call(I, be, Y, ne) : Ye, Ye != null && (Ee ? (Ee = !1, be = le({}, be, Ye)) : le(be, Ye));
      }
      I.state = be;
    }
    else be.queue = null;
  }
  var Fn = { id: 1, overflow: "" };
  function gn(I, U, Y) {
    var ne = I.id;
    I = I.overflow;
    var Ee = 32 - Gn(ne) - 1;
    ne &= ~(1 << Ee), Y += 1;
    var be = 32 - Gn(U) + Ee;
    if (30 < be) {
      var _e = Ee - Ee % 5;
      return be = (ne & (1 << _e) - 1).toString(32), ne >>= _e, Ee -= _e, { id: 1 << 32 - Gn(U) + Ee | Y << Ee | ne, overflow: be + I };
    }
    return { id: 1 << be | Y << Ee | ne, overflow: I };
  }
  var Gn = Math.clz32 ? Math.clz32 : mn, Hn = Math.log, tn = Math.LN2;
  function mn(I) {
    return I >>>= 0, I === 0 ? 32 : 31 - (Hn(I) / tn | 0) | 0;
  }
  function In(I, U) {
    return I === U && (I !== 0 || 1 / I === 1 / U) || I !== I && U !== U;
  }
  var vn = typeof Object.is == "function" ? Object.is : In, fr = null, Or = null, sn = null, yt = null, yn = !1, Nn = !1, Me = 0, M = null, W = 0;
  function se() {
    if (fr === null) throw Error(e(321));
    return fr;
  }
  function we() {
    if (0 < W) throw Error(e(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function $e() {
    return yt === null ? sn === null ? (yn = !1, sn = yt = we()) : (yn = !0, yt = sn) : yt.next === null ? (yn = !1, yt = yt.next = we()) : (yn = !0, yt = yt.next), yt;
  }
  function ut() {
    Or = fr = null, Nn = !1, sn = null, W = 0, yt = M = null;
  }
  function Mt(I, U) {
    return typeof U == "function" ? U(I) : U;
  }
  function Zt(I, U, Y) {
    if (fr = se(), yt = $e(), yn) {
      var ne = yt.queue;
      if (U = ne.dispatch, M !== null && (Y = M.get(ne), Y !== void 0)) {
        M.delete(ne), ne = yt.memoizedState;
        do
          ne = I(ne, Y.action), Y = Y.next;
        while (Y !== null);
        return yt.memoizedState = ne, [ne, U];
      }
      return [yt.memoizedState, U];
    }
    return I = I === Mt ? typeof U == "function" ? U() : U : Y !== void 0 ? Y(U) : U, yt.memoizedState = I, I = yt.queue = { last: null, dispatch: null }, I = I.dispatch = Br.bind(null, fr, I), [yt.memoizedState, I];
  }
  function rr(I, U) {
    if (fr = se(), yt = $e(), U = U === void 0 ? null : U, yt !== null) {
      var Y = yt.memoizedState;
      if (Y !== null && U !== null) {
        var ne = Y[1];
        e: if (ne === null) ne = !1;
        else {
          for (var Ee = 0; Ee < ne.length && Ee < U.length; Ee++) if (!vn(U[Ee], ne[Ee])) {
            ne = !1;
            break e;
          }
          ne = !0;
        }
        if (ne) return Y[0];
      }
    }
    return I = I(), yt.memoizedState = [I, U], I;
  }
  function Br(I, U, Y) {
    if (25 <= W) throw Error(e(301));
    if (I === fr) if (Nn = !0, I = { action: Y, next: null }, M === null && (M = /* @__PURE__ */ new Map()), Y = M.get(U), Y === void 0) M.set(U, I);
    else {
      for (U = Y; U.next !== null; ) U = U.next;
      U.next = I;
    }
  }
  function sr() {
    throw Error(e(394));
  }
  function ue() {
  }
  var ze = { readContext: function(I) {
    return I._currentValue2;
  }, useContext: function(I) {
    return se(), I._currentValue2;
  }, useMemo: rr, useReducer: Zt, useRef: function(I) {
    fr = se(), yt = $e();
    var U = yt.memoizedState;
    return U === null ? (I = { current: I }, yt.memoizedState = I) : U;
  }, useState: function(I) {
    return Zt(Mt, I);
  }, useInsertionEffect: ue, useLayoutEffect: function() {
  }, useCallback: function(I, U) {
    return rr(function() {
      return I;
    }, U);
  }, useImperativeHandle: ue, useEffect: ue, useDebugValue: ue, useDeferredValue: function(I) {
    return se(), I;
  }, useTransition: function() {
    return se(), [
      !1,
      sr
    ];
  }, useId: function() {
    var I = Or.treeContext, U = I.overflow;
    I = I.id, I = (I & ~(1 << 32 - Gn(I) - 1)).toString(32) + U;
    var Y = ct;
    if (Y === null) throw Error(e(404));
    return U = Me++, I = ":" + Y.idPrefix + "R" + I, 0 < U && (I += "H" + U.toString(32)), I + ":";
  }, useMutableSource: function(I, U) {
    return se(), U(I._source);
  }, useSyncExternalStore: function(I, U, Y) {
    if (Y === void 0) throw Error(e(407));
    return Y();
  } }, ct = null, ft = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function Vt(I) {
    return console.error(I), null;
  }
  function Ot() {
  }
  function Qt(I, U, Y, ne, Ee, be, _e, Ye, vt) {
    var Et = [], pt = /* @__PURE__ */ new Set();
    return U = { destination: null, responseState: U, progressiveChunkSize: ne === void 0 ? 12800 : ne, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: pt, pingedTasks: Et, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: Ee === void 0 ? Vt : Ee, onAllReady: Ot, onShellReady: _e === void 0 ? Ot : _e, onShellError: Ot, onFatalError: Ot }, Y = Hr(U, 0, null, Y, !1, !1), Y.parentFlushed = !0, I = zt(U, I, null, Y, pt, Pr, null, Fn), Et.push(I), U;
  }
  function zt(I, U, Y, ne, Ee, be, _e, Ye) {
    I.allPendingTasks++, Y === null ? I.pendingRootTasks++ : Y.pendingTasks++;
    var vt = { node: U, ping: function() {
      var Et = I.pingedTasks;
      Et.push(vt), Et.length === 1 && Jn(I);
    }, blockedBoundary: Y, blockedSegment: ne, abortSet: Ee, legacyContext: be, context: _e, treeContext: Ye };
    return Ee.add(vt), vt;
  }
  function Hr(I, U, Y, ne, Ee, be) {
    return { status: 0, id: -1, index: U, parentFlushed: !1, chunks: [], children: [], formatContext: ne, boundary: Y, lastPushedText: Ee, textEmbedded: be };
  }
  function Tr(I, U) {
    if (I = I.onError(U), I != null && typeof I != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof I + '" instead');
    return I;
  }
  function Nr(I, U) {
    var Y = I.onShellError;
    Y(U), Y = I.onFatalError, Y(U), I.destination !== null ? (I.status = 2, I.destination.destroy(U)) : (I.status = 1, I.fatalError = U);
  }
  function dr(I, U, Y, ne, Ee) {
    for (fr = {}, Or = U, Me = 0, I = Y(ne, Ee); Nn; ) Nn = !1, Me = 0, W += 1, yt = null, I = Y(ne, Ee);
    return ut(), I;
  }
  function vi(I, U, Y, ne) {
    var Ee = Y.render(), be = ne.childContextTypes;
    if (be != null) {
      var _e = U.legacyContext;
      if (typeof Y.getChildContext != "function") ne = _e;
      else {
        Y = Y.getChildContext();
        for (var Ye in Y) if (!(Ye in be)) throw Error(e(108, Gr(ne) || "Unknown", Ye));
        ne = le({}, _e, Y);
      }
      U.legacyContext = ne, Wr(I, U, Ee), U.legacyContext = _e;
    } else Wr(I, U, Ee);
  }
  function Xn(I, U) {
    if (I && I.defaultProps) {
      U = le({}, U), I = I.defaultProps;
      for (var Y in I) U[Y] === void 0 && (U[Y] = I[Y]);
      return U;
    }
    return U;
  }
  function Yr(I, U, Y, ne, Ee) {
    if (typeof Y == "function") if (Y.prototype && Y.prototype.isReactComponent) {
      Ee = Cr(Y, U.legacyContext);
      var be = Y.contextType;
      be = new Y(ne, typeof be == "object" && be !== null ? be._currentValue2 : Ee), en(be, Y, ne, Ee), vi(I, U, be, Y);
    } else {
      be = Cr(Y, U.legacyContext), Ee = dr(I, U, Y, ne, be);
      var _e = Me !== 0;
      if (typeof Ee == "object" && Ee !== null && typeof Ee.render == "function" && Ee.$$typeof === void 0) en(Ee, Y, ne, be), vi(I, U, Ee, Y);
      else if (_e) {
        ne = U.treeContext, U.treeContext = gn(ne, 1, 0);
        try {
          Wr(I, U, Ee);
        } finally {
          U.treeContext = ne;
        }
      } else Wr(I, U, Ee);
    }
    else if (typeof Y == "string") {
      switch (Ee = U.blockedSegment, be = q(Ee.chunks, Y, ne, I.responseState, Ee.formatContext), Ee.lastPushedText = !1, _e = Ee.formatContext, Ee.formatContext = T(_e, Y, ne), An(I, U, be), Ee.formatContext = _e, Y) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          Ee.chunks.push("</", Y, ">");
      }
      Ee.lastPushedText = !1;
    } else {
      switch (Y) {
        case wt:
        case kt:
        case qe:
        case at:
        case mt:
          Wr(I, U, ne.children);
          return;
        case Fr:
          Wr(I, U, ne.children);
          return;
        case Ir:
          throw Error(e(343));
        case Rt:
          e: {
            Y = U.blockedBoundary, Ee = U.blockedSegment, be = ne.fallback, ne = ne.children, _e = /* @__PURE__ */ new Set();
            var Ye = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: _e, errorDigest: null }, vt = Hr(I, Ee.chunks.length, Ye, Ee.formatContext, !1, !1);
            Ee.children.push(vt), Ee.lastPushedText = !1;
            var Et = Hr(I, 0, null, Ee.formatContext, !1, !1);
            Et.parentFlushed = !0, U.blockedBoundary = Ye, U.blockedSegment = Et;
            try {
              if (An(
                I,
                U,
                ne
              ), I.responseState.generateStaticMarkup || Et.lastPushedText && Et.textEmbedded && Et.chunks.push("<!-- -->"), Et.status = 1, En(Ye, Et), Ye.pendingTasks === 0) break e;
            } catch (pt) {
              Et.status = 4, Ye.forceClientRender = !0, Ye.errorDigest = Tr(I, pt);
            } finally {
              U.blockedBoundary = Y, U.blockedSegment = Ee;
            }
            U = zt(I, be, Y, vt, _e, U.legacyContext, U.context, U.treeContext), I.pingedTasks.push(U);
          }
          return;
      }
      if (typeof Y == "object" && Y !== null) switch (Y.$$typeof) {
        case rt:
          if (ne = dr(I, U, Y.render, ne, Ee), Me !== 0) {
            Y = U.treeContext, U.treeContext = gn(Y, 1, 0);
            try {
              Wr(I, U, ne);
            } finally {
              U.treeContext = Y;
            }
          } else Wr(I, U, ne);
          return;
        case an:
          Y = Y.type, ne = Xn(Y, ne), Yr(I, U, Y, ne, Ee);
          return;
        case st:
          if (Ee = ne.children, Y = Y._context, ne = ne.value, be = Y._currentValue2, Y._currentValue2 = ne, _e = qt, qt = ne = { parent: _e, depth: _e === null ? 0 : _e.depth + 1, context: Y, parentValue: be, value: ne }, U.context = ne, Wr(I, U, Ee), I = qt, I === null) throw Error(e(403));
          ne = I.parentValue, I.context._currentValue2 = ne === Mn ? I.context._defaultValue : ne, I = qt = I.parent, U.context = I;
          return;
        case lt:
          ne = ne.children, ne = ne(Y._currentValue2), Wr(I, U, ne);
          return;
        case ar:
          Ee = Y._init, Y = Ee(Y._payload), ne = Xn(Y, ne), Yr(
            I,
            U,
            Y,
            ne,
            void 0
          );
          return;
      }
      throw Error(e(130, Y == null ? Y : typeof Y, ""));
    }
  }
  function Wr(I, U, Y) {
    if (U.node = Y, typeof Y == "object" && Y !== null) {
      switch (Y.$$typeof) {
        case ve:
          Yr(I, U, Y.type, Y.props, Y.ref);
          return;
        case it:
          throw Error(e(257));
        case ar:
          var ne = Y._init;
          Y = ne(Y._payload), Wr(I, U, Y);
          return;
      }
      if (x(Y)) {
        oi(I, U, Y);
        return;
      }
      if (Y === null || typeof Y != "object" ? ne = null : (ne = kr && Y[kr] || Y["@@iterator"], ne = typeof ne == "function" ? ne : null), ne && (ne = ne.call(Y))) {
        if (Y = ne.next(), !Y.done) {
          var Ee = [];
          do
            Ee.push(Y.value), Y = ne.next();
          while (!Y.done);
          oi(I, U, Ee);
        }
        return;
      }
      throw I = Object.prototype.toString.call(Y), Error(e(31, I === "[object Object]" ? "object with keys {" + Object.keys(Y).join(", ") + "}" : I));
    }
    typeof Y == "string" ? (ne = U.blockedSegment, ne.lastPushedText = He(U.blockedSegment.chunks, Y, I.responseState, ne.lastPushedText)) : typeof Y == "number" && (ne = U.blockedSegment, ne.lastPushedText = He(U.blockedSegment.chunks, "" + Y, I.responseState, ne.lastPushedText));
  }
  function oi(I, U, Y) {
    for (var ne = Y.length, Ee = 0; Ee < ne; Ee++) {
      var be = U.treeContext;
      U.treeContext = gn(be, ne, Ee);
      try {
        An(I, U, Y[Ee]);
      } finally {
        U.treeContext = be;
      }
    }
  }
  function An(I, U, Y) {
    var ne = U.blockedSegment.formatContext, Ee = U.legacyContext, be = U.context;
    try {
      return Wr(I, U, Y);
    } catch (vt) {
      if (ut(), typeof vt == "object" && vt !== null && typeof vt.then == "function") {
        Y = vt;
        var _e = U.blockedSegment, Ye = Hr(I, _e.chunks.length, null, _e.formatContext, _e.lastPushedText, !0);
        _e.children.push(Ye), _e.lastPushedText = !1, I = zt(I, U.node, U.blockedBoundary, Ye, U.abortSet, U.legacyContext, U.context, U.treeContext).ping, Y.then(I, I), U.blockedSegment.formatContext = ne, U.legacyContext = Ee, U.context = be, vr(be);
      } else throw U.blockedSegment.formatContext = ne, U.legacyContext = Ee, U.context = be, vr(be), vt;
    }
  }
  function Di(I) {
    var U = I.blockedBoundary;
    I = I.blockedSegment, I.status = 3, ii(this, U, I);
  }
  function ni(I, U, Y) {
    var ne = I.blockedBoundary;
    I.blockedSegment.status = 3, ne === null ? (U.allPendingTasks--, U.status !== 2 && (U.status = 2, U.destination !== null && U.destination.push(null))) : (ne.pendingTasks--, ne.forceClientRender || (ne.forceClientRender = !0, I = Y === void 0 ? Error(e(432)) : Y, ne.errorDigest = U.onError(I), ne.parentFlushed && U.clientRenderedBoundaries.push(ne)), ne.fallbackAbortableTasks.forEach(function(Ee) {
      return ni(Ee, U, Y);
    }), ne.fallbackAbortableTasks.clear(), U.allPendingTasks--, U.allPendingTasks === 0 && (ne = U.onAllReady, ne()));
  }
  function En(I, U) {
    if (U.chunks.length === 0 && U.children.length === 1 && U.children[0].boundary === null) {
      var Y = U.children[0];
      Y.id = U.id, Y.parentFlushed = !0, Y.status === 1 && En(I, Y);
    } else I.completedSegments.push(U);
  }
  function ii(I, U, Y) {
    if (U === null) {
      if (Y.parentFlushed) {
        if (I.completedRootSegment !== null) throw Error(e(389));
        I.completedRootSegment = Y;
      }
      I.pendingRootTasks--, I.pendingRootTasks === 0 && (I.onShellError = Ot, U = I.onShellReady, U());
    } else U.pendingTasks--, U.forceClientRender || (U.pendingTasks === 0 ? (Y.parentFlushed && Y.status === 1 && En(U, Y), U.parentFlushed && I.completedBoundaries.push(U), U.fallbackAbortableTasks.forEach(Di, I), U.fallbackAbortableTasks.clear()) : Y.parentFlushed && Y.status === 1 && (En(U, Y), U.completedSegments.length === 1 && U.parentFlushed && I.partialBoundaries.push(U)));
    I.allPendingTasks--, I.allPendingTasks === 0 && (I = I.onAllReady, I());
  }
  function Jn(I) {
    if (I.status !== 2) {
      var U = qt, Y = ft.current;
      ft.current = ze;
      var ne = ct;
      ct = I.responseState;
      try {
        var Ee = I.pingedTasks, be;
        for (be = 0; be < Ee.length; be++) {
          var _e = Ee[be], Ye = I, vt = _e.blockedSegment;
          if (vt.status === 0) {
            vr(_e.context);
            try {
              Wr(Ye, _e, _e.node), Ye.responseState.generateStaticMarkup || vt.lastPushedText && vt.textEmbedded && vt.chunks.push("<!-- -->"), _e.abortSet.delete(_e), vt.status = 1, ii(Ye, _e.blockedBoundary, vt);
            } catch (Wn) {
              if (ut(), typeof Wn == "object" && Wn !== null && typeof Wn.then == "function") {
                var Et = _e.ping;
                Wn.then(Et, Et);
              } else {
                _e.abortSet.delete(_e), vt.status = 4;
                var pt = _e.blockedBoundary, yr = Wn, jr = Tr(Ye, yr);
                if (pt === null ? Nr(Ye, yr) : (pt.pendingTasks--, pt.forceClientRender || (pt.forceClientRender = !0, pt.errorDigest = jr, pt.parentFlushed && Ye.clientRenderedBoundaries.push(pt))), Ye.allPendingTasks--, Ye.allPendingTasks === 0) {
                  var Dn = Ye.onAllReady;
                  Dn();
                }
              }
            }
          }
        }
        Ee.splice(0, be), I.destination !== null && Vn(I, I.destination);
      } catch (Wn) {
        Tr(I, Wn), Nr(I, Wn);
      } finally {
        ct = ne, ft.current = Y, Y === ze && vr(U);
      }
    }
  }
  function Un(I, U, Y) {
    switch (Y.parentFlushed = !0, Y.status) {
      case 0:
        var ne = Y.id = I.nextSegmentId++;
        return Y.lastPushedText = !1, Y.textEmbedded = !1, I = I.responseState, U.push('<template id="'), U.push(I.placeholderPrefix), I = ne.toString(16), U.push(I), U.push('"></template>');
      case 1:
        Y.status = 2;
        var Ee = !0;
        ne = Y.chunks;
        var be = 0;
        Y = Y.children;
        for (var _e = 0; _e < Y.length; _e++) {
          for (Ee = Y[_e]; be < Ee.index; be++) U.push(ne[be]);
          Ee = Li(I, U, Ee);
        }
        for (; be < ne.length - 1; be++) U.push(ne[be]);
        return be < ne.length && (Ee = U.push(ne[be])), Ee;
      default:
        throw Error(e(390));
    }
  }
  function Li(I, U, Y) {
    var ne = Y.boundary;
    if (ne === null) return Un(I, U, Y);
    if (ne.parentFlushed = !0, ne.forceClientRender) return I.responseState.generateStaticMarkup || (ne = ne.errorDigest, U.push("<!--$!-->"), U.push("<template"), ne && (U.push(' data-dgst="'), ne = m(ne), U.push(ne), U.push('"')), U.push("></template>")), Un(I, U, Y), I = I.responseState.generateStaticMarkup ? !0 : U.push("<!--/$-->"), I;
    if (0 < ne.pendingTasks) {
      ne.rootSegmentID = I.nextSegmentId++, 0 < ne.completedSegments.length && I.partialBoundaries.push(ne);
      var Ee = I.responseState, be = Ee.nextSuspenseID++;
      return Ee = Ee.boundaryPrefix + be.toString(16), ne = ne.id = Ee, re(U, I.responseState, ne), Un(I, U, Y), U.push("<!--/$-->");
    }
    if (ne.byteSize > I.progressiveChunkSize) return ne.rootSegmentID = I.nextSegmentId++, I.completedBoundaries.push(ne), re(U, I.responseState, ne.id), Un(I, U, Y), U.push("<!--/$-->");
    if (I.responseState.generateStaticMarkup || U.push("<!--$-->"), Y = ne.completedSegments, Y.length !== 1) throw Error(e(391));
    return Li(I, U, Y[0]), I = I.responseState.generateStaticMarkup ? !0 : U.push("<!--/$-->"), I;
  }
  function Hi(I, U, Y) {
    return ae(U, I.responseState, Y.formatContext, Y.id), Li(I, U, Y), ye(U, Y.formatContext);
  }
  function ai(I, U, Y) {
    for (var ne = Y.completedSegments, Ee = 0; Ee < ne.length; Ee++) Kn(I, U, Y, ne[Ee]);
    if (ne.length = 0, I = I.responseState, ne = Y.id, Y = Y.rootSegmentID, U.push(I.startInlineScript), I.sentCompleteBoundaryFunction ? U.push('$RC("') : (I.sentCompleteBoundaryFunction = !0, U.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("')), ne === null) throw Error(e(395));
    return Y = Y.toString(16), U.push(ne), U.push('","'), U.push(I.segmentPrefix), U.push(Y), U.push('")<\/script>');
  }
  function Kn(I, U, Y, ne) {
    if (ne.status === 2) return !0;
    var Ee = ne.id;
    if (Ee === -1) {
      if ((ne.id = Y.rootSegmentID) === -1) throw Error(e(392));
      return Hi(I, U, ne);
    }
    return Hi(I, U, ne), I = I.responseState, U.push(I.startInlineScript), I.sentCompleteSegmentFunction ? U.push('$RS("') : (I.sentCompleteSegmentFunction = !0, U.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')), U.push(I.segmentPrefix), Ee = Ee.toString(16), U.push(Ee), U.push('","'), U.push(I.placeholderPrefix), U.push(Ee), U.push('")<\/script>');
  }
  function Vn(I, U) {
    try {
      var Y = I.completedRootSegment;
      if (Y !== null && I.pendingRootTasks === 0) {
        Li(I, U, Y), I.completedRootSegment = null;
        var ne = I.responseState.bootstrapChunks;
        for (Y = 0; Y < ne.length - 1; Y++) U.push(ne[Y]);
        Y < ne.length && U.push(ne[Y]);
      }
      var Ee = I.clientRenderedBoundaries, be;
      for (be = 0; be < Ee.length; be++) {
        var _e = Ee[be];
        ne = U;
        var Ye = I.responseState, vt = _e.id, Et = _e.errorDigest, pt = _e.errorMessage, yr = _e.errorComponentStack;
        if (ne.push(Ye.startInlineScript), Ye.sentClientRenderFunction ? ne.push('$RX("') : (Ye.sentClientRenderFunction = !0, ne.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("')), vt === null) throw Error(e(395));
        if (ne.push(vt), ne.push('"'), Et || pt || yr) {
          ne.push(",");
          var jr = Xe(Et || "");
          ne.push(jr);
        }
        if (pt || yr) {
          ne.push(",");
          var Dn = Xe(pt || "");
          ne.push(Dn);
        }
        if (yr) {
          ne.push(",");
          var Wn = Xe(yr);
          ne.push(Wn);
        }
        if (!ne.push(")<\/script>")) {
          I.destination = null, be++, Ee.splice(0, be);
          return;
        }
      }
      Ee.splice(0, be);
      var Ri = I.completedBoundaries;
      for (be = 0; be < Ri.length; be++) if (!ai(I, U, Ri[be])) {
        I.destination = null, be++, Ri.splice(0, be);
        return;
      }
      Ri.splice(0, be);
      var yi = I.partialBoundaries;
      for (be = 0; be < yi.length; be++) {
        var Zn = yi[be];
        e: {
          Ee = I, _e = U;
          var wn = Zn.completedSegments;
          for (Ye = 0; Ye < wn.length; Ye++) if (!Kn(Ee, _e, Zn, wn[Ye])) {
            Ye++, wn.splice(0, Ye);
            var Oi = !1;
            break e;
          }
          wn.splice(0, Ye), Oi = !0;
        }
        if (!Oi) {
          I.destination = null, be++, yi.splice(0, be);
          return;
        }
      }
      yi.splice(0, be);
      var Ai = I.completedBoundaries;
      for (be = 0; be < Ai.length; be++) if (!ai(I, U, Ai[be])) {
        I.destination = null, be++, Ai.splice(0, be);
        return;
      }
      Ai.splice(0, be);
    } finally {
      I.allPendingTasks === 0 && I.pingedTasks.length === 0 && I.clientRenderedBoundaries.length === 0 && I.completedBoundaries.length === 0 && U.push(null);
    }
  }
  function Pn(I, U) {
    try {
      var Y = I.abortableTasks;
      Y.forEach(function(ne) {
        return ni(ne, I, U);
      }), Y.clear(), I.destination !== null && Vn(I, I.destination);
    } catch (ne) {
      Tr(I, ne), Nr(I, ne);
    }
  }
  function kn() {
  }
  function $n(I, U, Y, ne) {
    var Ee = !1, be = null, _e = "", Ye = { push: function(Et) {
      return Et !== null && (_e += Et), !0;
    }, destroy: function(Et) {
      Ee = !0, be = Et;
    } }, vt = !1;
    if (I = Qt(I, Ve(Y, U ? U.identifierPrefix : void 0), { insertionMode: 1, selectedValue: null }, 1 / 0, kn, void 0, function() {
      vt = !0;
    }), Jn(I), Pn(I, ne), I.status === 1) I.status = 2, Ye.destroy(I.fatalError);
    else if (I.status !== 2 && I.destination === null) {
      I.destination = Ye;
      try {
        Vn(I, Ye);
      } catch (Et) {
        Tr(I, Et), Nr(I, Et);
      }
    }
    if (Ee) throw be;
    if (!vt) throw Error(e(426));
    return _e;
  }
  return vf.renderToNodeStream = function() {
    throw Error(e(207));
  }, vf.renderToStaticMarkup = function(I, U) {
    return $n(I, U, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, vf.renderToStaticNodeStream = function() {
    throw Error(e(208));
  }, vf.renderToString = function(I, U) {
    return $n(I, U, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, vf.version = "18.3.1", vf;
}
var Vg = {};
var OS;
function wN() {
  if (OS) return Vg;
  OS = 1;
  var r = Vf();
  function e(P) {
    for (var V = "https://reactjs.org/docs/error-decoder.html?invariant=" + P, Q = 1; Q < arguments.length; Q++) V += "&args[]=" + encodeURIComponent(arguments[Q]);
    return "Minified React error #" + P + "; visit " + V + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var t = null, n = 0;
  function i(P, V) {
    if (V.length !== 0) if (512 < V.length) 0 < n && (P.enqueue(new Uint8Array(t.buffer, 0, n)), t = new Uint8Array(512), n = 0), P.enqueue(V);
    else {
      var Q = t.length - n;
      Q < V.length && (Q === 0 ? P.enqueue(t) : (t.set(V.subarray(0, Q), n), P.enqueue(t), V = V.subarray(Q)), t = new Uint8Array(512), n = 0), t.set(V, n), n += V.length;
    }
  }
  function a(P, V) {
    return i(P, V), !0;
  }
  function s(P) {
    t && 0 < n && (P.enqueue(new Uint8Array(t.buffer, 0, n)), t = null, n = 0);
  }
  var o = new TextEncoder();
  function l(P) {
    return o.encode(P);
  }
  function u(P) {
    return o.encode(P);
  }
  function c(P, V) {
    typeof P.error == "function" ? P.error(V) : P.close();
  }
  var h = Object.prototype.hasOwnProperty, f = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, p = {}, m = {};
  function A(P) {
    return h.call(m, P) ? !0 : h.call(p, P) ? !1 : f.test(P) ? m[P] = !0 : (p[P] = !0, !1);
  }
  function w(P, V, Q, ie, Pe, ke, Le) {
    this.acceptsBooleans = V === 2 || V === 3 || V === 4, this.attributeName = ie, this.attributeNamespace = Pe, this.mustUseProperty = Q, this.propertyName = P, this.type = V, this.sanitizeURL = ke, this.removeEmptyString = Le;
  }
  var x = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(P) {
    x[P] = new w(P, 0, !1, P, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(P) {
    var V = P[0];
    x[V] = new w(V, 1, !1, P[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(P) {
    x[P] = new w(P, 2, !1, P.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(P) {
    x[P] = new w(P, 2, !1, P, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(P) {
    x[P] = new w(P, 3, !1, P.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(P) {
    x[P] = new w(P, 3, !0, P, null, !1, !1);
  }), ["capture", "download"].forEach(function(P) {
    x[P] = new w(P, 4, !1, P, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(P) {
    x[P] = new w(P, 6, !1, P, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(P) {
    x[P] = new w(P, 5, !1, P.toLowerCase(), null, !1, !1);
  });
  var E = /[\-:]([a-z])/g;
  function T(P) {
    return P[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(P) {
    var V = P.replace(
      E,
      T
    );
    x[V] = new w(V, 1, !1, P, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(P) {
    var V = P.replace(E, T);
    x[V] = new w(V, 1, !1, P, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(P) {
    var V = P.replace(E, T);
    x[V] = new w(V, 1, !1, P, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(P) {
    x[P] = new w(P, 1, !1, P.toLowerCase(), null, !1, !1);
  }), x.xlinkHref = new w("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(P) {
    x[P] = new w(P, 1, !1, P.toLowerCase(), null, !0, !0);
  });
  var D = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, F = ["Webkit", "ms", "Moz", "O"];
  Object.keys(D).forEach(function(P) {
    F.forEach(function(V) {
      V = V + P.charAt(0).toUpperCase() + P.substring(1), D[V] = D[P];
    });
  });
  var _ = /["'&<>]/;
  function L(P) {
    if (typeof P == "boolean" || typeof P == "number") return "" + P;
    P = "" + P;
    var V = _.exec(P);
    if (V) {
      var Q = "", ie, Pe = 0;
      for (ie = V.index; ie < P.length; ie++) {
        switch (P.charCodeAt(ie)) {
          case 34:
            V = "&quot;";
            break;
          case 38:
            V = "&amp;";
            break;
          case 39:
            V = "&#x27;";
            break;
          case 60:
            V = "&lt;";
            break;
          case 62:
            V = "&gt;";
            break;
          default:
            continue;
        }
        Pe !== ie && (Q += P.substring(Pe, ie)), Pe = ie + 1, Q += V;
      }
      P = Pe !== ie ? Q + P.substring(Pe, ie) : Q;
    }
    return P;
  }
  var Z = /([A-Z])/g, te = /^ms-/, de = Array.isArray, H = u("<script>"), j = u("<\/script>"), q = u('<script src="'), re = u('<script type="module" src="'), ae = u('" async=""><\/script>'), ye = /(<\/|<)(s)(cript)/gi;
  function Se(P, V, Q, ie) {
    return "" + V + (Q === "s" ? "\\u0073" : "\\u0053") + ie;
  }
  function Xe(P, V, Q, ie, Pe) {
    P = P === void 0 ? "" : P, V = V === void 0 ? H : u('<script nonce="' + L(V) + '">');
    var ke = [];
    if (Q !== void 0 && ke.push(V, l(("" + Q).replace(ye, Se)), j), ie !== void 0) for (Q = 0; Q < ie.length; Q++) ke.push(q, l(L(ie[Q])), ae);
    if (Pe !== void 0) for (ie = 0; ie < Pe.length; ie++) ke.push(re, l(L(Pe[ie])), ae);
    return { bootstrapChunks: ke, startInlineScript: V, placeholderPrefix: u(P + "P:"), segmentPrefix: u(P + "S:"), boundaryPrefix: P + "B:", idPrefix: P, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1 };
  }
  function Ve(P, V) {
    return { insertionMode: P, selectedValue: V };
  }
  function He(P) {
    return Ve(P === "http://www.w3.org/2000/svg" ? 2 : P === "http://www.w3.org/1998/Math/MathML" ? 3 : 0, null);
  }
  function le(P, V, Q) {
    switch (V) {
      case "select":
        return Ve(1, Q.value != null ? Q.value : Q.defaultValue);
      case "svg":
        return Ve(2, null);
      case "math":
        return Ve(3, null);
      case "foreignObject":
        return Ve(1, null);
      case "table":
        return Ve(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return Ve(5, null);
      case "colgroup":
        return Ve(7, null);
      case "tr":
        return Ve(6, null);
    }
    return 4 <= P.insertionMode || P.insertionMode === 0 ? Ve(1, null) : P;
  }
  var ve = u("<!-- -->");
  function it(P, V, Q, ie) {
    return V === "" ? ie : (ie && P.push(ve), P.push(l(L(V))), !0);
  }
  var mt = /* @__PURE__ */ new Map(), qe = u(' style="'), at = u(":"), st = u(";");
  function lt(P, V, Q) {
    if (typeof Q != "object") throw Error(e(62));
    V = !0;
    for (var ie in Q) if (h.call(Q, ie)) {
      var Pe = Q[ie];
      if (Pe != null && typeof Pe != "boolean" && Pe !== "") {
        if (ie.indexOf("--") === 0) {
          var ke = l(L(ie));
          Pe = l(L(("" + Pe).trim()));
        } else {
          ke = ie;
          var Le = mt.get(ke);
          Le !== void 0 || (Le = u(L(ke.replace(Z, "-$1").toLowerCase().replace(te, "-ms-"))), mt.set(ke, Le)), ke = Le, Pe = typeof Pe == "number" ? Pe === 0 || h.call(D, ie) ? l("" + Pe) : l(Pe + "px") : l(L(("" + Pe).trim()));
        }
        V ? (V = !1, P.push(qe, ke, at, Pe)) : P.push(st, ke, at, Pe);
      }
    }
    V || P.push(Fr);
  }
  var rt = u(" "), Rt = u('="'), Fr = u('"'), an = u('=""');
  function ar(P, V, Q, ie) {
    switch (Q) {
      case "style":
        lt(P, V, ie);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < Q.length) || Q[0] !== "o" && Q[0] !== "O" || Q[1] !== "n" && Q[1] !== "N") {
      if (V = x.hasOwnProperty(Q) ? x[Q] : null, V !== null) {
        switch (typeof ie) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!V.acceptsBooleans) return;
        }
        switch (Q = l(V.attributeName), V.type) {
          case 3:
            ie && P.push(rt, Q, an);
            break;
          case 4:
            ie === !0 ? P.push(rt, Q, an) : ie !== !1 && P.push(rt, Q, Rt, l(L(ie)), Fr);
            break;
          case 5:
            isNaN(ie) || P.push(rt, Q, Rt, l(L(ie)), Fr);
            break;
          case 6:
            !isNaN(ie) && 1 <= ie && P.push(rt, Q, Rt, l(L(ie)), Fr);
            break;
          default:
            V.sanitizeURL && (ie = "" + ie), P.push(rt, Q, Rt, l(L(ie)), Fr);
        }
      } else if (A(Q)) {
        switch (typeof ie) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (V = Q.toLowerCase().slice(0, 5), V !== "data-" && V !== "aria-") return;
        }
        P.push(rt, l(Q), Rt, l(L(ie)), Fr);
      }
    }
  }
  var Ir = u(">"), kt = u("/>");
  function wt(P, V, Q) {
    if (V != null) {
      if (Q != null) throw Error(e(60));
      if (typeof V != "object" || !("__html" in V)) throw Error(e(61));
      V = V.__html, V != null && P.push(l("" + V));
    }
  }
  function Mn(P) {
    var V = "";
    return r.Children.forEach(P, function(Q) {
      Q != null && (V += Q);
    }), V;
  }
  var kr = u(' selected=""');
  function Gr(P, V, Q, ie) {
    P.push(lr(Q));
    var Pe = Q = null, ke;
    for (ke in V) if (h.call(V, ke)) {
      var Le = V[ke];
      if (Le != null) switch (ke) {
        case "children":
          Q = Le;
          break;
        case "dangerouslySetInnerHTML":
          Pe = Le;
          break;
        default:
          ar(P, ie, ke, Le);
      }
    }
    return P.push(Ir), wt(P, Pe, Q), typeof Q == "string" ? (P.push(l(L(Q))), null) : Q;
  }
  var Pr = u(`
`), Cr = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, qt = /* @__PURE__ */ new Map();
  function lr(P) {
    var V = qt.get(P);
    if (V === void 0) {
      if (!Cr.test(P)) throw Error(e(65, P));
      V = u("<" + P), qt.set(P, V);
    }
    return V;
  }
  var It = u("<!DOCTYPE html>");
  function Zr(P, V, Q, ie, Pe) {
    switch (V) {
      case "select":
        P.push(lr("select"));
        var ke = null, Le = null;
        for (ur in Q) if (h.call(Q, ur)) {
          var nt = Q[ur];
          if (nt != null) switch (ur) {
            case "children":
              ke = nt;
              break;
            case "dangerouslySetInnerHTML":
              Le = nt;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              ar(P, ie, ur, nt);
          }
        }
        return P.push(Ir), wt(P, Le, ke), ke;
      case "option":
        Le = Pe.selectedValue, P.push(lr("option"));
        var Xt = nt = null, Wt = null, ur = null;
        for (ke in Q) if (h.call(Q, ke)) {
          var un = Q[ke];
          if (un != null) switch (ke) {
            case "children":
              nt = un;
              break;
            case "selected":
              Wt = un;
              break;
            case "dangerouslySetInnerHTML":
              ur = un;
              break;
            case "value":
              Xt = un;
            default:
              ar(P, ie, ke, un);
          }
        }
        if (Le != null) if (Q = Xt !== null ? "" + Xt : Mn(nt), de(Le)) {
          for (ie = 0; ie < Le.length; ie++)
            if ("" + Le[ie] === Q) {
              P.push(kr);
              break;
            }
        } else "" + Le === Q && P.push(kr);
        else Wt && P.push(kr);
        return P.push(Ir), wt(P, ur, nt), nt;
      case "textarea":
        P.push(lr("textarea")), ur = Le = ke = null;
        for (nt in Q) if (h.call(Q, nt) && (Xt = Q[nt], Xt != null)) switch (nt) {
          case "children":
            ur = Xt;
            break;
          case "value":
            ke = Xt;
            break;
          case "defaultValue":
            Le = Xt;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(e(91));
          default:
            ar(P, ie, nt, Xt);
        }
        if (ke === null && Le !== null && (ke = Le), P.push(Ir), ur != null) {
          if (ke != null) throw Error(e(92));
          if (de(ur) && 1 < ur.length) throw Error(e(93));
          ke = "" + ur;
        }
        return typeof ke == "string" && ke[0] === `
` && P.push(Pr), ke !== null && P.push(l(L("" + ke))), null;
      case "input":
        P.push(lr("input")), Xt = ur = nt = ke = null;
        for (Le in Q) if (h.call(Q, Le) && (Wt = Q[Le], Wt != null)) switch (Le) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(e(399, "input"));
          case "defaultChecked":
            Xt = Wt;
            break;
          case "defaultValue":
            nt = Wt;
            break;
          case "checked":
            ur = Wt;
            break;
          case "value":
            ke = Wt;
            break;
          default:
            ar(P, ie, Le, Wt);
        }
        return ur !== null ? ar(
          P,
          ie,
          "checked",
          ur
        ) : Xt !== null && ar(P, ie, "checked", Xt), ke !== null ? ar(P, ie, "value", ke) : nt !== null && ar(P, ie, "value", nt), P.push(kt), null;
      case "menuitem":
        P.push(lr("menuitem"));
        for (var z in Q) if (h.call(Q, z) && (ke = Q[z], ke != null)) switch (z) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(e(400));
          default:
            ar(P, ie, z, ke);
        }
        return P.push(Ir), null;
      case "title":
        P.push(lr("title")), ke = null;
        for (un in Q) if (h.call(Q, un) && (Le = Q[un], Le != null)) switch (un) {
          case "children":
            ke = Le;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(e(434));
          default:
            ar(P, ie, un, Le);
        }
        return P.push(Ir), ke;
      case "listing":
      case "pre":
        P.push(lr(V)), Le = ke = null;
        for (Xt in Q) if (h.call(Q, Xt) && (nt = Q[Xt], nt != null)) switch (Xt) {
          case "children":
            ke = nt;
            break;
          case "dangerouslySetInnerHTML":
            Le = nt;
            break;
          default:
            ar(P, ie, Xt, nt);
        }
        if (P.push(Ir), Le != null) {
          if (ke != null) throw Error(e(60));
          if (typeof Le != "object" || !("__html" in Le)) throw Error(e(61));
          Q = Le.__html, Q != null && (typeof Q == "string" && 0 < Q.length && Q[0] === `
` ? P.push(Pr, l(Q)) : P.push(l("" + Q)));
        }
        return typeof ke == "string" && ke[0] === `
` && P.push(Pr), ke;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        P.push(lr(V));
        for (var ce in Q) if (h.call(Q, ce) && (ke = Q[ce], ke != null)) switch (ce) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(e(399, V));
          default:
            ar(P, ie, ce, ke);
        }
        return P.push(kt), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return Gr(P, Q, V, ie);
      case "html":
        return Pe.insertionMode === 0 && P.push(It), Gr(P, Q, V, ie);
      default:
        if (V.indexOf("-") === -1 && typeof Q.is != "string") return Gr(P, Q, V, ie);
        P.push(lr(V)), Le = ke = null;
        for (Wt in Q) if (h.call(Q, Wt) && (nt = Q[Wt], nt != null)) switch (Wt) {
          case "children":
            ke = nt;
            break;
          case "dangerouslySetInnerHTML":
            Le = nt;
            break;
          case "style":
            lt(P, ie, nt);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            A(Wt) && typeof nt != "function" && typeof nt != "symbol" && P.push(rt, l(Wt), Rt, l(L(nt)), Fr);
        }
        return P.push(Ir), wt(P, Le, ke), ke;
    }
  }
  var Cn = u("</"), Sn = u(">"), vr = u('<template id="'), ln = u('"></template>'), en = u("<!--$-->"), Fn = u('<!--$?--><template id="'), gn = u('"></template>'), Gn = u("<!--$!-->"), Hn = u("<!--/$-->"), tn = u("<template"), mn = u('"'), In = u(' data-dgst="');
  u(' data-msg="'), u(' data-stck="');
  var vn = u("></template>");
  function fr(P, V, Q) {
    if (i(P, Fn), Q === null) throw Error(e(395));
    return i(P, Q), a(P, gn);
  }
  var Or = u('<div hidden id="'), sn = u('">'), yt = u("</div>"), yn = u('<svg aria-hidden="true" style="display:none" id="'), Nn = u('">'), Me = u("</svg>"), M = u('<math aria-hidden="true" style="display:none" id="'), W = u('">'), se = u("</math>"), we = u('<table hidden id="'), $e = u('">'), ut = u("</table>"), Mt = u('<table hidden><tbody id="'), Zt = u('">'), rr = u("</tbody></table>"), Br = u('<table hidden><tr id="'), sr = u('">'), ue = u("</tr></table>"), ze = u('<table hidden><colgroup id="'), ct = u('">'), ft = u("</colgroup></table>");
  function Vt(P, V, Q, ie) {
    switch (Q.insertionMode) {
      case 0:
      case 1:
        return i(P, Or), i(P, V.segmentPrefix), i(P, l(ie.toString(16))), a(P, sn);
      case 2:
        return i(P, yn), i(P, V.segmentPrefix), i(P, l(ie.toString(16))), a(P, Nn);
      case 3:
        return i(P, M), i(P, V.segmentPrefix), i(P, l(ie.toString(16))), a(P, W);
      case 4:
        return i(P, we), i(P, V.segmentPrefix), i(P, l(ie.toString(16))), a(P, $e);
      case 5:
        return i(P, Mt), i(P, V.segmentPrefix), i(P, l(ie.toString(16))), a(P, Zt);
      case 6:
        return i(P, Br), i(P, V.segmentPrefix), i(P, l(ie.toString(16))), a(P, sr);
      case 7:
        return i(
          P,
          ze
        ), i(P, V.segmentPrefix), i(P, l(ie.toString(16))), a(P, ct);
      default:
        throw Error(e(397));
    }
  }
  function Ot(P, V) {
    switch (V.insertionMode) {
      case 0:
      case 1:
        return a(P, yt);
      case 2:
        return a(P, Me);
      case 3:
        return a(P, se);
      case 4:
        return a(P, ut);
      case 5:
        return a(P, rr);
      case 6:
        return a(P, ue);
      case 7:
        return a(P, ft);
      default:
        throw Error(e(397));
    }
  }
  var Qt = u('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), zt = u('$RS("'), Hr = u('","'), Tr = u('")<\/script>'), Nr = u('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), dr = u('$RC("'), vi = u('","'), Xn = u('")<\/script>'), Yr = u('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), Wr = u('$RX("'), oi = u('"'), An = u(")<\/script>"), Di = u(","), ni = /[<\u2028\u2029]/g;
  function En(P) {
    return JSON.stringify(P).replace(ni, function(V) {
      switch (V) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var ii = Object.assign, Jn = /* @__PURE__ */ Symbol.for("react.element"), Un = /* @__PURE__ */ Symbol.for("react.portal"), Li = /* @__PURE__ */ Symbol.for("react.fragment"), Hi = /* @__PURE__ */ Symbol.for("react.strict_mode"), ai = /* @__PURE__ */ Symbol.for("react.profiler"), Kn = /* @__PURE__ */ Symbol.for("react.provider"), Vn = /* @__PURE__ */ Symbol.for("react.context"), Pn = /* @__PURE__ */ Symbol.for("react.forward_ref"), kn = /* @__PURE__ */ Symbol.for("react.suspense"), $n = /* @__PURE__ */ Symbol.for("react.suspense_list"), I = /* @__PURE__ */ Symbol.for("react.memo"), U = /* @__PURE__ */ Symbol.for("react.lazy"), Y = /* @__PURE__ */ Symbol.for("react.scope"), ne = /* @__PURE__ */ Symbol.for("react.debug_trace_mode"), Ee = /* @__PURE__ */ Symbol.for("react.legacy_hidden"), be = /* @__PURE__ */ Symbol.for("react.default_value"), _e = Symbol.iterator;
  function Ye(P) {
    if (P == null) return null;
    if (typeof P == "function") return P.displayName || P.name || null;
    if (typeof P == "string") return P;
    switch (P) {
      case Li:
        return "Fragment";
      case Un:
        return "Portal";
      case ai:
        return "Profiler";
      case Hi:
        return "StrictMode";
      case kn:
        return "Suspense";
      case $n:
        return "SuspenseList";
    }
    if (typeof P == "object") switch (P.$$typeof) {
      case Vn:
        return (P.displayName || "Context") + ".Consumer";
      case Kn:
        return (P._context.displayName || "Context") + ".Provider";
      case Pn:
        var V = P.render;
        return P = P.displayName, P || (P = V.displayName || V.name || "", P = P !== "" ? "ForwardRef(" + P + ")" : "ForwardRef"), P;
      case I:
        return V = P.displayName || null, V !== null ? V : Ye(P.type) || "Memo";
      case U:
        V = P._payload, P = P._init;
        try {
          return Ye(P(V));
        } catch {
        }
    }
    return null;
  }
  var vt = {};
  function Et(P, V) {
    if (P = P.contextTypes, !P) return vt;
    var Q = {}, ie;
    for (ie in P) Q[ie] = V[ie];
    return Q;
  }
  var pt = null;
  function yr(P, V) {
    if (P !== V) {
      P.context._currentValue = P.parentValue, P = P.parent;
      var Q = V.parent;
      if (P === null) {
        if (Q !== null) throw Error(e(401));
      } else {
        if (Q === null) throw Error(e(401));
        yr(P, Q);
      }
      V.context._currentValue = V.value;
    }
  }
  function jr(P) {
    P.context._currentValue = P.parentValue, P = P.parent, P !== null && jr(P);
  }
  function Dn(P) {
    var V = P.parent;
    V !== null && Dn(V), P.context._currentValue = P.value;
  }
  function Wn(P, V) {
    if (P.context._currentValue = P.parentValue, P = P.parent, P === null) throw Error(e(402));
    P.depth === V.depth ? yr(P, V) : Wn(P, V);
  }
  function Ri(P, V) {
    var Q = V.parent;
    if (Q === null) throw Error(e(402));
    P.depth === Q.depth ? yr(P, Q) : Ri(P, Q), V.context._currentValue = V.value;
  }
  function yi(P) {
    var V = pt;
    V !== P && (V === null ? Dn(P) : P === null ? jr(V) : V.depth === P.depth ? yr(V, P) : V.depth > P.depth ? Wn(V, P) : Ri(V, P), pt = P);
  }
  var Zn = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(P, V) {
    P = P._reactInternals, P.queue !== null && P.queue.push(V);
  }, enqueueReplaceState: function(P, V) {
    P = P._reactInternals, P.replace = !0, P.queue = [V];
  }, enqueueForceUpdate: function() {
  } };
  function wn(P, V, Q, ie) {
    var Pe = P.state !== void 0 ? P.state : null;
    P.updater = Zn, P.props = Q, P.state = Pe;
    var ke = { queue: [], replace: !1 };
    P._reactInternals = ke;
    var Le = V.contextType;
    if (P.context = typeof Le == "object" && Le !== null ? Le._currentValue : ie, Le = V.getDerivedStateFromProps, typeof Le == "function" && (Le = Le(Q, Pe), Pe = Le == null ? Pe : ii({}, Pe, Le), P.state = Pe), typeof V.getDerivedStateFromProps != "function" && typeof P.getSnapshotBeforeUpdate != "function" && (typeof P.UNSAFE_componentWillMount == "function" || typeof P.componentWillMount == "function")) if (V = P.state, typeof P.componentWillMount == "function" && P.componentWillMount(), typeof P.UNSAFE_componentWillMount == "function" && P.UNSAFE_componentWillMount(), V !== P.state && Zn.enqueueReplaceState(P, P.state, null), ke.queue !== null && 0 < ke.queue.length) if (V = ke.queue, Le = ke.replace, ke.queue = null, ke.replace = !1, Le && V.length === 1) P.state = V[0];
    else {
      for (ke = Le ? V[0] : P.state, Pe = !0, Le = Le ? 1 : 0; Le < V.length; Le++) {
        var nt = V[Le];
        nt = typeof nt == "function" ? nt.call(P, ke, Q, ie) : nt, nt != null && (Pe ? (Pe = !1, ke = ii({}, ke, nt)) : ii(ke, nt));
      }
      P.state = ke;
    }
    else ke.queue = null;
  }
  var Oi = { id: 1, overflow: "" };
  function Ai(P, V, Q) {
    var ie = P.id;
    P = P.overflow;
    var Pe = 32 - di(ie) - 1;
    ie &= ~(1 << Pe), Q += 1;
    var ke = 32 - di(V) + Pe;
    if (30 < ke) {
      var Le = Pe - Pe % 5;
      return ke = (ie & (1 << Le) - 1).toString(32), ie >>= Le, Pe -= Le, { id: 1 << 32 - di(V) + Pe | Q << Pe | ie, overflow: ke + P };
    }
    return { id: 1 << ke | Q << Pe | ie, overflow: P };
  }
  var di = Math.clz32 ? Math.clz32 : la, ka = Math.log, oa = Math.LN2;
  function la(P) {
    return P >>>= 0, P === 0 ? 32 : 31 - (ka(P) / oa | 0) | 0;
  }
  function wi(P, V) {
    return P === V && (P !== 0 || 1 / P === 1 / V) || P !== P && V !== V;
  }
  var Zi = typeof Object.is == "function" ? Object.is : wi, Ei = null, li = null, Ui = null, _r = null, hi = !1, Lr = !1, R = 0, X = null, pe = 0;
  function Re() {
    if (Ei === null) throw Error(e(321));
    return Ei;
  }
  function Bt() {
    if (0 < pe) throw Error(e(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Tt() {
    return _r === null ? Ui === null ? (hi = !1, Ui = _r = Bt()) : (hi = !0, _r = Ui) : _r.next === null ? (hi = !1, _r = _r.next = Bt()) : (hi = !0, _r = _r.next), _r;
  }
  function hr() {
    li = Ei = null, Lr = !1, Ui = null, pe = 0, _r = X = null;
  }
  function or(P, V) {
    return typeof V == "function" ? V(P) : V;
  }
  function xn(P, V, Q) {
    if (Ei = Re(), _r = Tt(), hi) {
      var ie = _r.queue;
      if (V = ie.dispatch, X !== null && (Q = X.get(ie), Q !== void 0)) {
        X.delete(ie), ie = _r.memoizedState;
        do
          ie = P(ie, Q.action), Q = Q.next;
        while (Q !== null);
        return _r.memoizedState = ie, [ie, V];
      }
      return [_r.memoizedState, V];
    }
    return P = P === or ? typeof V == "function" ? V() : V : Q !== void 0 ? Q(V) : V, _r.memoizedState = P, P = _r.queue = { last: null, dispatch: null }, P = P.dispatch = oe.bind(null, Ei, P), [_r.memoizedState, P];
  }
  function N(P, V) {
    if (Ei = Re(), _r = Tt(), V = V === void 0 ? null : V, _r !== null) {
      var Q = _r.memoizedState;
      if (Q !== null && V !== null) {
        var ie = Q[1];
        e: if (ie === null) ie = !1;
        else {
          for (var Pe = 0; Pe < ie.length && Pe < V.length; Pe++) if (!Zi(V[Pe], ie[Pe])) {
            ie = !1;
            break e;
          }
          ie = !0;
        }
        if (ie) return Q[0];
      }
    }
    return P = P(), _r.memoizedState = [P, V], P;
  }
  function oe(P, V, Q) {
    if (25 <= pe) throw Error(e(301));
    if (P === Ei) if (Lr = !0, P = { action: Q, next: null }, X === null && (X = /* @__PURE__ */ new Map()), Q = X.get(V), Q === void 0) X.set(V, P);
    else {
      for (V = Q; V.next !== null; ) V = V.next;
      V.next = P;
    }
  }
  function xe() {
    throw Error(e(394));
  }
  function Ie() {
  }
  var We = { readContext: function(P) {
    return P._currentValue;
  }, useContext: function(P) {
    return Re(), P._currentValue;
  }, useMemo: N, useReducer: xn, useRef: function(P) {
    Ei = Re(), _r = Tt();
    var V = _r.memoizedState;
    return V === null ? (P = { current: P }, _r.memoizedState = P) : V;
  }, useState: function(P) {
    return xn(or, P);
  }, useInsertionEffect: Ie, useLayoutEffect: function() {
  }, useCallback: function(P, V) {
    return N(function() {
      return P;
    }, V);
  }, useImperativeHandle: Ie, useEffect: Ie, useDebugValue: Ie, useDeferredValue: function(P) {
    return Re(), P;
  }, useTransition: function() {
    return Re(), [!1, xe];
  }, useId: function() {
    var P = li.treeContext, V = P.overflow;
    P = P.id, P = (P & ~(1 << 32 - di(P) - 1)).toString(32) + V;
    var Q = ot;
    if (Q === null) throw Error(e(404));
    return V = R++, P = ":" + Q.idPrefix + "R" + P, 0 < V && (P += "H" + V.toString(32)), P + ":";
  }, useMutableSource: function(P, V) {
    return Re(), V(P._source);
  }, useSyncExternalStore: function(P, V, Q) {
    if (Q === void 0) throw Error(e(407));
    return Q();
  } }, ot = null, dt = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function Nt(P) {
    return console.error(P), null;
  }
  function Yt() {
  }
  function Ur(P, V, Q, ie, Pe, ke, Le, nt, Xt) {
    var Wt = [], ur = /* @__PURE__ */ new Set();
    return V = { destination: null, responseState: V, progressiveChunkSize: ie === void 0 ? 12800 : ie, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: ur, pingedTasks: Wt, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: Pe === void 0 ? Nt : Pe, onAllReady: ke === void 0 ? Yt : ke, onShellReady: Le === void 0 ? Yt : Le, onShellError: nt === void 0 ? Yt : nt, onFatalError: Xt === void 0 ? Yt : Xt }, Q = Dr(V, 0, null, Q, !1, !1), Q.parentFlushed = !0, P = qr(V, P, null, Q, ur, vt, null, Oi), Wt.push(P), V;
  }
  function qr(P, V, Q, ie, Pe, ke, Le, nt) {
    P.allPendingTasks++, Q === null ? P.pendingRootTasks++ : Q.pendingTasks++;
    var Xt = { node: V, ping: function() {
      var Wt = P.pingedTasks;
      Wt.push(Xt), Wt.length === 1 && Eo(P);
    }, blockedBoundary: Q, blockedSegment: ie, abortSet: Pe, legacyContext: ke, context: Le, treeContext: nt };
    return Pe.add(Xt), Xt;
  }
  function Dr(P, V, Q, ie, Pe, ke) {
    return { status: 0, id: -1, index: V, parentFlushed: !1, chunks: [], children: [], formatContext: ie, boundary: Q, lastPushedText: Pe, textEmbedded: ke };
  }
  function Ar(P, V) {
    if (P = P.onError(V), P != null && typeof P != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof P + '" instead');
    return P;
  }
  function Rn(P, V) {
    var Q = P.onShellError;
    Q(V), Q = P.onFatalError, Q(V), P.destination !== null ? (P.status = 2, c(P.destination, V)) : (P.status = 1, P.fatalError = V);
  }
  function Jr(P, V, Q, ie, Pe) {
    for (Ei = {}, li = V, R = 0, P = Q(ie, Pe); Lr; ) Lr = !1, R = 0, pe += 1, _r = null, P = Q(ie, Pe);
    return hr(), P;
  }
  function Ya(P, V, Q, ie) {
    var Pe = Q.render(), ke = ie.childContextTypes;
    if (ke != null) {
      var Le = V.legacyContext;
      if (typeof Q.getChildContext != "function") ie = Le;
      else {
        Q = Q.getChildContext();
        for (var nt in Q) if (!(nt in ke)) throw Error(e(108, Ye(ie) || "Unknown", nt));
        ie = ii({}, Le, Q);
      }
      V.legacyContext = ie, pi(P, V, Pe), V.legacyContext = Le;
    } else pi(P, V, Pe);
  }
  function Xa(P, V) {
    if (P && P.defaultProps) {
      V = ii({}, V), P = P.defaultProps;
      for (var Q in P) V[Q] === void 0 && (V[Q] = P[Q]);
      return V;
    }
    return V;
  }
  function Vi(P, V, Q, ie, Pe) {
    if (typeof Q == "function") if (Q.prototype && Q.prototype.isReactComponent) {
      Pe = Et(Q, V.legacyContext);
      var ke = Q.contextType;
      ke = new Q(ie, typeof ke == "object" && ke !== null ? ke._currentValue : Pe), wn(ke, Q, ie, Pe), Ya(P, V, ke, Q);
    } else {
      ke = Et(Q, V.legacyContext), Pe = Jr(P, V, Q, ie, ke);
      var Le = R !== 0;
      if (typeof Pe == "object" && Pe !== null && typeof Pe.render == "function" && Pe.$$typeof === void 0) wn(Pe, Q, ie, ke), Ya(P, V, Pe, Q);
      else if (Le) {
        ie = V.treeContext, V.treeContext = Ai(ie, 1, 0);
        try {
          pi(P, V, Pe);
        } finally {
          V.treeContext = ie;
        }
      } else pi(P, V, Pe);
    }
    else if (typeof Q == "string") {
      switch (Pe = V.blockedSegment, ke = Zr(Pe.chunks, Q, ie, P.responseState, Pe.formatContext), Pe.lastPushedText = !1, Le = Pe.formatContext, Pe.formatContext = le(Le, Q, ie), Vr(P, V, ke), Pe.formatContext = Le, Q) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          Pe.chunks.push(Cn, l(Q), Sn);
      }
      Pe.lastPushedText = !1;
    } else {
      switch (Q) {
        case Ee:
        case ne:
        case Hi:
        case ai:
        case Li:
          pi(P, V, ie.children);
          return;
        case $n:
          pi(P, V, ie.children);
          return;
        case Y:
          throw Error(e(343));
        case kn:
          e: {
            Q = V.blockedBoundary, Pe = V.blockedSegment, ke = ie.fallback, ie = ie.children, Le = /* @__PURE__ */ new Set();
            var nt = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: Le, errorDigest: null }, Xt = Dr(P, Pe.chunks.length, nt, Pe.formatContext, !1, !1);
            Pe.children.push(Xt), Pe.lastPushedText = !1;
            var Wt = Dr(P, 0, null, Pe.formatContext, !1, !1);
            Wt.parentFlushed = !0, V.blockedBoundary = nt, V.blockedSegment = Wt;
            try {
              if (Vr(
                P,
                V,
                ie
              ), Wt.lastPushedText && Wt.textEmbedded && Wt.chunks.push(ve), Wt.status = 1, ls(nt, Wt), nt.pendingTasks === 0) break e;
            } catch (ur) {
              Wt.status = 4, nt.forceClientRender = !0, nt.errorDigest = Ar(P, ur);
            } finally {
              V.blockedBoundary = Q, V.blockedSegment = Pe;
            }
            V = qr(P, ke, Q, Xt, Le, V.legacyContext, V.context, V.treeContext), P.pingedTasks.push(V);
          }
          return;
      }
      if (typeof Q == "object" && Q !== null) switch (Q.$$typeof) {
        case Pn:
          if (ie = Jr(P, V, Q.render, ie, Pe), R !== 0) {
            Q = V.treeContext, V.treeContext = Ai(Q, 1, 0);
            try {
              pi(P, V, ie);
            } finally {
              V.treeContext = Q;
            }
          } else pi(P, V, ie);
          return;
        case I:
          Q = Q.type, ie = Xa(Q, ie), Vi(P, V, Q, ie, Pe);
          return;
        case Kn:
          if (Pe = ie.children, Q = Q._context, ie = ie.value, ke = Q._currentValue, Q._currentValue = ie, Le = pt, pt = ie = { parent: Le, depth: Le === null ? 0 : Le.depth + 1, context: Q, parentValue: ke, value: ie }, V.context = ie, pi(P, V, Pe), P = pt, P === null) throw Error(e(403));
          ie = P.parentValue, P.context._currentValue = ie === be ? P.context._defaultValue : ie, P = pt = P.parent, V.context = P;
          return;
        case Vn:
          ie = ie.children, ie = ie(Q._currentValue), pi(P, V, ie);
          return;
        case U:
          Pe = Q._init, Q = Pe(Q._payload), ie = Xa(Q, ie), Vi(P, V, Q, ie, void 0);
          return;
      }
      throw Error(e(
        130,
        Q == null ? Q : typeof Q,
        ""
      ));
    }
  }
  function pi(P, V, Q) {
    if (V.node = Q, typeof Q == "object" && Q !== null) {
      switch (Q.$$typeof) {
        case Jn:
          Vi(P, V, Q.type, Q.props, Q.ref);
          return;
        case Un:
          throw Error(e(257));
        case U:
          var ie = Q._init;
          Q = ie(Q._payload), pi(P, V, Q);
          return;
      }
      if (de(Q)) {
        Ta(P, V, Q);
        return;
      }
      if (Q === null || typeof Q != "object" ? ie = null : (ie = _e && Q[_e] || Q["@@iterator"], ie = typeof ie == "function" ? ie : null), ie && (ie = ie.call(Q))) {
        if (Q = ie.next(), !Q.done) {
          var Pe = [];
          do
            Pe.push(Q.value), Q = ie.next();
          while (!Q.done);
          Ta(P, V, Pe);
        }
        return;
      }
      throw P = Object.prototype.toString.call(Q), Error(e(31, P === "[object Object]" ? "object with keys {" + Object.keys(Q).join(", ") + "}" : P));
    }
    typeof Q == "string" ? (ie = V.blockedSegment, ie.lastPushedText = it(V.blockedSegment.chunks, Q, P.responseState, ie.lastPushedText)) : typeof Q == "number" && (ie = V.blockedSegment, ie.lastPushedText = it(V.blockedSegment.chunks, "" + Q, P.responseState, ie.lastPushedText));
  }
  function Ta(P, V, Q) {
    for (var ie = Q.length, Pe = 0; Pe < ie; Pe++) {
      var ke = V.treeContext;
      V.treeContext = Ai(ke, ie, Pe);
      try {
        Vr(P, V, Q[Pe]);
      } finally {
        V.treeContext = ke;
      }
    }
  }
  function Vr(P, V, Q) {
    var ie = V.blockedSegment.formatContext, Pe = V.legacyContext, ke = V.context;
    try {
      return pi(P, V, Q);
    } catch (Xt) {
      if (hr(), typeof Xt == "object" && Xt !== null && typeof Xt.then == "function") {
        Q = Xt;
        var Le = V.blockedSegment, nt = Dr(P, Le.chunks.length, null, Le.formatContext, Le.lastPushedText, !0);
        Le.children.push(nt), Le.lastPushedText = !1, P = qr(P, V.node, V.blockedBoundary, nt, V.abortSet, V.legacyContext, V.context, V.treeContext).ping, Q.then(P, P), V.blockedSegment.formatContext = ie, V.legacyContext = Pe, V.context = ke, yi(ke);
      } else throw V.blockedSegment.formatContext = ie, V.legacyContext = Pe, V.context = ke, yi(ke), Xt;
    }
  }
  function ua(P) {
    var V = P.blockedBoundary;
    P = P.blockedSegment, P.status = 3, Ds(this, V, P);
  }
  function os(P, V, Q) {
    var ie = P.blockedBoundary;
    P.blockedSegment.status = 3, ie === null ? (V.allPendingTasks--, V.status !== 2 && (V.status = 2, V.destination !== null && V.destination.close())) : (ie.pendingTasks--, ie.forceClientRender || (ie.forceClientRender = !0, P = Q === void 0 ? Error(e(432)) : Q, ie.errorDigest = V.onError(P), ie.parentFlushed && V.clientRenderedBoundaries.push(ie)), ie.fallbackAbortableTasks.forEach(function(Pe) {
      return os(Pe, V, Q);
    }), ie.fallbackAbortableTasks.clear(), V.allPendingTasks--, V.allPendingTasks === 0 && (ie = V.onAllReady, ie()));
  }
  function ls(P, V) {
    if (V.chunks.length === 0 && V.children.length === 1 && V.children[0].boundary === null) {
      var Q = V.children[0];
      Q.id = V.id, Q.parentFlushed = !0, Q.status === 1 && ls(P, Q);
    } else P.completedSegments.push(V);
  }
  function Ds(P, V, Q) {
    if (V === null) {
      if (Q.parentFlushed) {
        if (P.completedRootSegment !== null) throw Error(e(389));
        P.completedRootSegment = Q;
      }
      P.pendingRootTasks--, P.pendingRootTasks === 0 && (P.onShellError = Yt, V = P.onShellReady, V());
    } else V.pendingTasks--, V.forceClientRender || (V.pendingTasks === 0 ? (Q.parentFlushed && Q.status === 1 && ls(V, Q), V.parentFlushed && P.completedBoundaries.push(V), V.fallbackAbortableTasks.forEach(ua, P), V.fallbackAbortableTasks.clear()) : Q.parentFlushed && Q.status === 1 && (ls(V, Q), V.completedSegments.length === 1 && V.parentFlushed && P.partialBoundaries.push(V)));
    P.allPendingTasks--, P.allPendingTasks === 0 && (P = P.onAllReady, P());
  }
  function Eo(P) {
    if (P.status !== 2) {
      var V = pt, Q = dt.current;
      dt.current = We;
      var ie = ot;
      ot = P.responseState;
      try {
        var Pe = P.pingedTasks, ke;
        for (ke = 0; ke < Pe.length; ke++) {
          var Le = Pe[ke], nt = P, Xt = Le.blockedSegment;
          if (Xt.status === 0) {
            yi(Le.context);
            try {
              pi(nt, Le, Le.node), Xt.lastPushedText && Xt.textEmbedded && Xt.chunks.push(ve), Le.abortSet.delete(Le), Xt.status = 1, Ds(nt, Le.blockedBoundary, Xt);
            } catch (me) {
              if (hr(), typeof me == "object" && me !== null && typeof me.then == "function") {
                var Wt = Le.ping;
                me.then(Wt, Wt);
              } else {
                Le.abortSet.delete(Le), Xt.status = 4;
                var ur = Le.blockedBoundary, un = me, z = Ar(nt, un);
                if (ur === null ? Rn(nt, un) : (ur.pendingTasks--, ur.forceClientRender || (ur.forceClientRender = !0, ur.errorDigest = z, ur.parentFlushed && nt.clientRenderedBoundaries.push(ur))), nt.allPendingTasks--, nt.allPendingTasks === 0) {
                  var ce = nt.onAllReady;
                  ce();
                }
              }
            }
          }
        }
        Pe.splice(0, ke), P.destination !== null && cs(P, P.destination);
      } catch (me) {
        Ar(P, me), Rn(P, me);
      } finally {
        ot = ie, dt.current = Q, Q === We && yi(V);
      }
    }
  }
  function ga(P, V, Q) {
    switch (Q.parentFlushed = !0, Q.status) {
      case 0:
        var ie = Q.id = P.nextSegmentId++;
        return Q.lastPushedText = !1, Q.textEmbedded = !1, P = P.responseState, i(V, vr), i(V, P.placeholderPrefix), P = l(ie.toString(16)), i(V, P), a(V, ln);
      case 1:
        Q.status = 2;
        var Pe = !0;
        ie = Q.chunks;
        var ke = 0;
        Q = Q.children;
        for (var Le = 0; Le < Q.length; Le++) {
          for (Pe = Q[Le]; ke < Pe.index; ke++) i(V, ie[ke]);
          Pe = Zs(P, V, Pe);
        }
        for (; ke < ie.length - 1; ke++) i(V, ie[ke]);
        return ke < ie.length && (Pe = a(V, ie[ke])), Pe;
      default:
        throw Error(e(390));
    }
  }
  function Zs(P, V, Q) {
    var ie = Q.boundary;
    if (ie === null) return ga(P, V, Q);
    if (ie.parentFlushed = !0, ie.forceClientRender) ie = ie.errorDigest, a(V, Gn), i(V, tn), ie && (i(V, In), i(V, l(L(ie))), i(V, mn)), a(V, vn), ga(P, V, Q);
    else if (0 < ie.pendingTasks) {
      ie.rootSegmentID = P.nextSegmentId++, 0 < ie.completedSegments.length && P.partialBoundaries.push(ie);
      var Pe = P.responseState, ke = Pe.nextSuspenseID++;
      Pe = u(Pe.boundaryPrefix + ke.toString(16)), ie = ie.id = Pe, fr(V, P.responseState, ie), ga(P, V, Q);
    } else if (ie.byteSize > P.progressiveChunkSize) ie.rootSegmentID = P.nextSegmentId++, P.completedBoundaries.push(ie), fr(V, P.responseState, ie.id), ga(P, V, Q);
    else {
      if (a(V, en), Q = ie.completedSegments, Q.length !== 1) throw Error(e(391));
      Zs(P, V, Q[0]);
    }
    return a(V, Hn);
  }
  function eo(P, V, Q) {
    return Vt(V, P.responseState, Q.formatContext, Q.id), Zs(P, V, Q), Ot(V, Q.formatContext);
  }
  function us(P, V, Q) {
    for (var ie = Q.completedSegments, Pe = 0; Pe < ie.length; Pe++) Ua(P, V, Q, ie[Pe]);
    if (ie.length = 0, P = P.responseState, ie = Q.id, Q = Q.rootSegmentID, i(V, P.startInlineScript), P.sentCompleteBoundaryFunction ? i(V, dr) : (P.sentCompleteBoundaryFunction = !0, i(V, Nr)), ie === null) throw Error(e(395));
    return Q = l(Q.toString(16)), i(V, ie), i(V, vi), i(V, P.segmentPrefix), i(V, Q), a(V, Xn);
  }
  function Ua(P, V, Q, ie) {
    if (ie.status === 2) return !0;
    var Pe = ie.id;
    if (Pe === -1) {
      if ((ie.id = Q.rootSegmentID) === -1) throw Error(e(392));
      return eo(P, V, ie);
    }
    return eo(P, V, ie), P = P.responseState, i(V, P.startInlineScript), P.sentCompleteSegmentFunction ? i(V, zt) : (P.sentCompleteSegmentFunction = !0, i(V, Qt)), i(V, P.segmentPrefix), Pe = l(Pe.toString(16)), i(V, Pe), i(V, Hr), i(V, P.placeholderPrefix), i(V, Pe), a(V, Tr);
  }
  function cs(P, V) {
    t = new Uint8Array(512), n = 0;
    try {
      var Q = P.completedRootSegment;
      if (Q !== null && P.pendingRootTasks === 0) {
        Zs(P, V, Q), P.completedRootSegment = null;
        var ie = P.responseState.bootstrapChunks;
        for (Q = 0; Q < ie.length - 1; Q++) i(V, ie[Q]);
        Q < ie.length && a(V, ie[Q]);
      }
      var Pe = P.clientRenderedBoundaries, ke;
      for (ke = 0; ke < Pe.length; ke++) {
        var Le = Pe[ke];
        ie = V;
        var nt = P.responseState, Xt = Le.id, Wt = Le.errorDigest, ur = Le.errorMessage, un = Le.errorComponentStack;
        if (i(ie, nt.startInlineScript), nt.sentClientRenderFunction ? i(ie, Wr) : (nt.sentClientRenderFunction = !0, i(
          ie,
          Yr
        )), Xt === null) throw Error(e(395));
        i(ie, Xt), i(ie, oi), (Wt || ur || un) && (i(ie, Di), i(ie, l(En(Wt || "")))), (ur || un) && (i(ie, Di), i(ie, l(En(ur || "")))), un && (i(ie, Di), i(ie, l(En(un)))), a(ie, An);
      }
      Pe.splice(0, ke);
      var z = P.completedBoundaries;
      for (ke = 0; ke < z.length; ke++) us(P, V, z[ke]);
      z.splice(0, ke), s(V), t = new Uint8Array(512), n = 0;
      var ce = P.partialBoundaries;
      for (ke = 0; ke < ce.length; ke++) {
        var me = ce[ke];
        e: {
          Pe = P, Le = V;
          var tt = me.completedSegments;
          for (nt = 0; nt < tt.length; nt++) if (!Ua(
            Pe,
            Le,
            me,
            tt[nt]
          )) {
            nt++, tt.splice(0, nt);
            var _t = !1;
            break e;
          }
          tt.splice(0, nt), _t = !0;
        }
        if (!_t) {
          P.destination = null, ke++, ce.splice(0, ke);
          return;
        }
      }
      ce.splice(0, ke);
      var nr = P.completedBoundaries;
      for (ke = 0; ke < nr.length; ke++) us(P, V, nr[ke]);
      nr.splice(0, ke);
    } finally {
      s(V), P.allPendingTasks === 0 && P.pingedTasks.length === 0 && P.clientRenderedBoundaries.length === 0 && P.completedBoundaries.length === 0 && V.close();
    }
  }
  function Fa(P, V) {
    try {
      var Q = P.abortableTasks;
      Q.forEach(function(ie) {
        return os(ie, P, V);
      }), Q.clear(), P.destination !== null && cs(P, P.destination);
    } catch (ie) {
      Ar(P, ie), Rn(P, ie);
    }
  }
  return Vg.renderToReadableStream = function(P, V) {
    return new Promise(function(Q, ie) {
      var Pe, ke, Le = new Promise(function(ur, un) {
        ke = ur, Pe = un;
      }), nt = Ur(P, Xe(V ? V.identifierPrefix : void 0, V ? V.nonce : void 0, V ? V.bootstrapScriptContent : void 0, V ? V.bootstrapScripts : void 0, V ? V.bootstrapModules : void 0), He(V ? V.namespaceURI : void 0), V ? V.progressiveChunkSize : void 0, V ? V.onError : void 0, ke, function() {
        var ur = new ReadableStream({ type: "bytes", pull: function(un) {
          if (nt.status === 1) nt.status = 2, c(un, nt.fatalError);
          else if (nt.status !== 2 && nt.destination === null) {
            nt.destination = un;
            try {
              cs(nt, un);
            } catch (z) {
              Ar(nt, z), Rn(nt, z);
            }
          }
        }, cancel: function() {
          Fa(nt);
        } }, { highWaterMark: 0 });
        ur.allReady = Le, Q(ur);
      }, function(ur) {
        Le.catch(function() {
        }), ie(ur);
      }, Pe);
      if (V && V.signal) {
        var Xt = V.signal, Wt = function() {
          Fa(nt, Xt.reason), Xt.removeEventListener("abort", Wt);
        };
        Xt.addEventListener("abort", Wt);
      }
      Eo(nt);
    });
  }, Vg.version = "18.3.1", Vg;
}
var yf = {};
var BS;
function xN() {
  return BS || (BS = 1, process.env.NODE_ENV !== "production" && (function() {
    var r = Vf(), e = "18.3.1", t = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(g) {
      {
        for (var y = arguments.length, C = new Array(y > 1 ? y - 1 : 0), k = 1; k < y; k++)
          C[k - 1] = arguments[k];
        a("warn", g, C);
      }
    }
    function i(g) {
      {
        for (var y = arguments.length, C = new Array(y > 1 ? y - 1 : 0), k = 1; k < y; k++)
          C[k - 1] = arguments[k];
        a("error", g, C);
      }
    }
    function a(g, y, C) {
      {
        var k = t.ReactDebugCurrentFrame, B = k.getStackAddendum();
        B !== "" && (y += "%s", C = C.concat([B]));
        var $ = C.map(function(K) {
          return String(K);
        });
        $.unshift("Warning: " + y), Function.prototype.apply.call(console[g], console, $);
      }
    }
    function s(g) {
      g();
    }
    function o(g) {
    }
    function l(g, y) {
      u(g, y);
    }
    function u(g, y) {
      return g.push(y);
    }
    function c(g) {
    }
    function h(g) {
      g.push(null);
    }
    function f(g) {
      return g;
    }
    function p(g) {
      return g;
    }
    function m(g, y) {
      g.destroy(y);
    }
    function A(g) {
      {
        var y = typeof Symbol == "function" && Symbol.toStringTag, C = y && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return C;
      }
    }
    function w(g) {
      try {
        return x(g), !1;
      } catch {
        return !0;
      }
    }
    function x(g) {
      return "" + g;
    }
    function E(g, y) {
      if (w(g))
        return i("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", y, A(g)), x(g);
    }
    function T(g, y) {
      if (w(g))
        return i("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", y, A(g)), x(g);
    }
    function D(g) {
      if (w(g))
        return i("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", A(g)), x(g);
    }
    var F = Object.prototype.hasOwnProperty, _ = 0, L = 1, Z = 2, te = 3, de = 4, H = 5, j = 6, q = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", re = q + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", ae = new RegExp("^[" + q + "][" + re + "]*$"), ye = {}, Se = {};
    function Xe(g) {
      return F.call(Se, g) ? !0 : F.call(ye, g) ? !1 : ae.test(g) ? (Se[g] = !0, !0) : (ye[g] = !0, i("Invalid attribute name: `%s`", g), !1);
    }
    function Ve(g, y, C, k) {
      if (C !== null && C.type === _)
        return !1;
      switch (typeof y) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean": {
          if (C !== null)
            return !C.acceptsBooleans;
          var B = g.toLowerCase().slice(0, 5);
          return B !== "data-" && B !== "aria-";
        }
        default:
          return !1;
      }
    }
    function He(g) {
      return ve.hasOwnProperty(g) ? ve[g] : null;
    }
    function le(g, y, C, k, B, $, K) {
      this.acceptsBooleans = y === Z || y === te || y === de, this.attributeName = k, this.attributeNamespace = B, this.mustUseProperty = C, this.propertyName = g, this.type = y, this.sanitizeURL = $, this.removeEmptyString = K;
    }
    var ve = {}, it = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    it.forEach(function(g) {
      ve[g] = new le(
        g,
        _,
        !1,
        // mustUseProperty
        g,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(g) {
      var y = g[0], C = g[1];
      ve[y] = new le(
        y,
        L,
        !1,
        // mustUseProperty
        C,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(g) {
      ve[g] = new le(
        g,
        Z,
        !1,
        // mustUseProperty
        g.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(g) {
      ve[g] = new le(
        g,
        Z,
        !1,
        // mustUseProperty
        g,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(g) {
      ve[g] = new le(
        g,
        te,
        !1,
        // mustUseProperty
        g.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(g) {
      ve[g] = new le(
        g,
        te,
        !0,
        // mustUseProperty
        g,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(g) {
      ve[g] = new le(
        g,
        de,
        !1,
        // mustUseProperty
        g,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(g) {
      ve[g] = new le(
        g,
        j,
        !1,
        // mustUseProperty
        g,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(g) {
      ve[g] = new le(
        g,
        H,
        !1,
        // mustUseProperty
        g.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var mt = /[\-\:]([a-z])/g, qe = function(g) {
      return g[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(g) {
      var y = g.replace(mt, qe);
      ve[y] = new le(
        y,
        L,
        !1,
        // mustUseProperty
        g,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(g) {
      var y = g.replace(mt, qe);
      ve[y] = new le(
        y,
        L,
        !1,
        // mustUseProperty
        g,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(g) {
      var y = g.replace(mt, qe);
      ve[y] = new le(
        y,
        L,
        !1,
        // mustUseProperty
        g,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(g) {
      ve[g] = new le(
        g,
        L,
        !1,
        // mustUseProperty
        g.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var at = "xlinkHref";
    ve[at] = new le(
      "xlinkHref",
      L,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(g) {
      ve[g] = new le(
        g,
        L,
        !1,
        // mustUseProperty
        g.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var st = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function lt(g, y) {
      return g + y.charAt(0).toUpperCase() + y.substring(1);
    }
    var rt = ["Webkit", "ms", "Moz", "O"];
    Object.keys(st).forEach(function(g) {
      rt.forEach(function(y) {
        st[lt(y, g)] = st[g];
      });
    });
    var Rt = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Fr(g, y) {
      Rt[y.type] || y.onChange || y.onInput || y.readOnly || y.disabled || y.value == null || i("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), y.onChange || y.readOnly || y.disabled || y.checked == null || i("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function an(g, y) {
      if (g.indexOf("-") === -1)
        return typeof y.is == "string";
      switch (g) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var ar = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Ir = {}, kt = new RegExp("^(aria)-[" + re + "]*$"), wt = new RegExp("^(aria)[A-Z][" + re + "]*$");
    function Mn(g, y) {
      {
        if (F.call(Ir, y) && Ir[y])
          return !0;
        if (wt.test(y)) {
          var C = "aria-" + y.slice(4).toLowerCase(), k = ar.hasOwnProperty(C) ? C : null;
          if (k == null)
            return i("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", y), Ir[y] = !0, !0;
          if (y !== k)
            return i("Invalid ARIA attribute `%s`. Did you mean `%s`?", y, k), Ir[y] = !0, !0;
        }
        if (kt.test(y)) {
          var B = y.toLowerCase(), $ = ar.hasOwnProperty(B) ? B : null;
          if ($ == null)
            return Ir[y] = !0, !1;
          if (y !== $)
            return i("Unknown ARIA attribute `%s`. Did you mean `%s`?", y, $), Ir[y] = !0, !0;
        }
      }
      return !0;
    }
    function kr(g, y) {
      {
        var C = [];
        for (var k in y) {
          var B = Mn(g, k);
          B || C.push(k);
        }
        var $ = C.map(function(K) {
          return "`" + K + "`";
        }).join(", ");
        C.length === 1 ? i("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", $, g) : C.length > 1 && i("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", $, g);
      }
    }
    function Gr(g, y) {
      an(g, y) || kr(g, y);
    }
    var Pr = !1;
    function Cr(g, y) {
      {
        if (g !== "input" && g !== "textarea" && g !== "select")
          return;
        y != null && y.value === null && !Pr && (Pr = !0, g === "select" && y.multiple ? i("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", g) : i("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", g));
      }
    }
    var qt = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, lr = function() {
    };
    {
      var It = {}, Zr = /^on./, Cn = /^on[^A-Z]/, Sn = new RegExp("^(aria)-[" + re + "]*$"), vr = new RegExp("^(aria)[A-Z][" + re + "]*$");
      lr = function(g, y, C, k) {
        if (F.call(It, y) && It[y])
          return !0;
        var B = y.toLowerCase();
        if (B === "onfocusin" || B === "onfocusout")
          return i("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), It[y] = !0, !0;
        if (k != null) {
          var $ = k.registrationNameDependencies, K = k.possibleRegistrationNames;
          if ($.hasOwnProperty(y))
            return !0;
          var fe = K.hasOwnProperty(B) ? K[B] : null;
          if (fe != null)
            return i("Invalid event handler property `%s`. Did you mean `%s`?", y, fe), It[y] = !0, !0;
          if (Zr.test(y))
            return i("Unknown event handler property `%s`. It will be ignored.", y), It[y] = !0, !0;
        } else if (Zr.test(y))
          return Cn.test(y) && i("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", y), It[y] = !0, !0;
        if (Sn.test(y) || vr.test(y))
          return !0;
        if (B === "innerhtml")
          return i("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), It[y] = !0, !0;
        if (B === "aria")
          return i("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), It[y] = !0, !0;
        if (B === "is" && C !== null && C !== void 0 && typeof C != "string")
          return i("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof C), It[y] = !0, !0;
        if (typeof C == "number" && isNaN(C))
          return i("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", y), It[y] = !0, !0;
        var Te = He(y), Ue = Te !== null && Te.type === _;
        if (qt.hasOwnProperty(B)) {
          var Je = qt[B];
          if (Je !== y)
            return i("Invalid DOM property `%s`. Did you mean `%s`?", y, Je), It[y] = !0, !0;
        } else if (!Ue && y !== B)
          return i("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", y, B), It[y] = !0, !0;
        return typeof C == "boolean" && Ve(y, C, Te) ? (C ? i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', C, y, y, C, y) : i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', C, y, y, C, y, y, y), It[y] = !0, !0) : Ue ? !0 : Ve(y, C, Te) ? (It[y] = !0, !1) : ((C === "false" || C === "true") && Te !== null && Te.type === te && (i("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", C, y, C === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', y, C), It[y] = !0), !0);
      };
    }
    var ln = function(g, y, C) {
      {
        var k = [];
        for (var B in y) {
          var $ = lr(g, B, y[B], C);
          $ || k.push(B);
        }
        var K = k.map(function(fe) {
          return "`" + fe + "`";
        }).join(", ");
        k.length === 1 ? i("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", K, g) : k.length > 1 && i("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", K, g);
      }
    };
    function en(g, y, C) {
      an(g, y) || ln(g, y, C);
    }
    var Fn = function() {
    };
    {
      var gn = /^(?:webkit|moz|o)[A-Z]/, Gn = /^-ms-/, Hn = /-(.)/g, tn = /;\s*$/, mn = {}, In = {}, vn = !1, fr = !1, Or = function(g) {
        return g.replace(Hn, function(y, C) {
          return C.toUpperCase();
        });
      }, sn = function(g) {
        mn.hasOwnProperty(g) && mn[g] || (mn[g] = !0, i(
          "Unsupported style property %s. Did you mean %s?",
          g,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Or(g.replace(Gn, "ms-"))
        ));
      }, yt = function(g) {
        mn.hasOwnProperty(g) && mn[g] || (mn[g] = !0, i("Unsupported vendor-prefixed style property %s. Did you mean %s?", g, g.charAt(0).toUpperCase() + g.slice(1)));
      }, yn = function(g, y) {
        In.hasOwnProperty(y) && In[y] || (In[y] = !0, i(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, g, y.replace(tn, "")));
      }, Nn = function(g, y) {
        vn || (vn = !0, i("`NaN` is an invalid value for the `%s` css style property.", g));
      }, Me = function(g, y) {
        fr || (fr = !0, i("`Infinity` is an invalid value for the `%s` css style property.", g));
      };
      Fn = function(g, y) {
        g.indexOf("-") > -1 ? sn(g) : gn.test(g) ? yt(g) : tn.test(y) && yn(g, y), typeof y == "number" && (isNaN(y) ? Nn(g, y) : isFinite(y) || Me(g, y));
      };
    }
    var M = Fn, W = /["'&<>]/;
    function se(g) {
      D(g);
      var y = "" + g, C = W.exec(y);
      if (!C)
        return y;
      var k, B = "", $, K = 0;
      for ($ = C.index; $ < y.length; $++) {
        switch (y.charCodeAt($)) {
          case 34:
            k = "&quot;";
            break;
          case 38:
            k = "&amp;";
            break;
          case 39:
            k = "&#x27;";
            break;
          case 60:
            k = "&lt;";
            break;
          case 62:
            k = "&gt;";
            break;
          default:
            continue;
        }
        K !== $ && (B += y.substring(K, $)), K = $ + 1, B += k;
      }
      return K !== $ ? B + y.substring(K, $) : B;
    }
    function we(g) {
      return typeof g == "boolean" || typeof g == "number" ? "" + g : se(g);
    }
    var $e = /([A-Z])/g, ut = /^ms-/;
    function Mt(g) {
      return g.replace($e, "-$1").toLowerCase().replace(ut, "-ms-");
    }
    var Zt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, rr = !1;
    function Br(g) {
      !rr && Zt.test(g) && (rr = !0, i("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(g)));
    }
    var sr = Array.isArray;
    function ue(g) {
      return sr(g);
    }
    var ze = "<script>";
    function ct(g, y, C, k, B) {
      var $ = g === void 0 ? "" : g, K = ze, fe = [];
      return {
        bootstrapChunks: fe,
        startInlineScript: K,
        placeholderPrefix: $ + "P:",
        segmentPrefix: $ + "S:",
        boundaryPrefix: $ + "B:",
        idPrefix: $,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var ft = 0, Vt = 1, Ot = 2, Qt = 3, zt = 4, Hr = 5, Tr = 6, Nr = 7;
    function dr(g, y) {
      return {
        insertionMode: g,
        selectedValue: y
      };
    }
    function vi(g, y, C) {
      switch (y) {
        case "select":
          return dr(Vt, C.value != null ? C.value : C.defaultValue);
        case "svg":
          return dr(Ot, null);
        case "math":
          return dr(Qt, null);
        case "foreignObject":
          return dr(Vt, null);
        // Table parents are special in that their children can only be created at all if they're
        // wrapped in a table parent. So we need to encode that we're entering this mode.
        case "table":
          return dr(zt, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return dr(Hr, null);
        case "colgroup":
          return dr(Nr, null);
        case "tr":
          return dr(Tr, null);
      }
      return g.insertionMode >= zt || g.insertionMode === ft ? dr(Vt, null) : g;
    }
    var Xn = null;
    function Yr(g) {
      var y = g.nextSuspenseID++;
      return g.boundaryPrefix + y.toString(16);
    }
    function Wr(g, y, C) {
      var k = g.idPrefix, B = ":" + k + "R" + y;
      return C > 0 && (B += "H" + C.toString(32)), B + ":";
    }
    function oi(g) {
      return we(g);
    }
    var An = "<!-- -->";
    function Di(g, y, C, k) {
      return y === "" ? k : (k && g.push(An), g.push(oi(y)), !0);
    }
    function ni(g, y, C, k) {
      C && k && g.push(An);
    }
    var En = /* @__PURE__ */ new Map();
    function ii(g) {
      var y = En.get(g);
      if (y !== void 0)
        return y;
      var C = we(Mt(g));
      return En.set(g, C), C;
    }
    var Jn = ' style="', Un = ":", Li = ";";
    function Hi(g, y, C) {
      if (typeof C != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var k = !0;
      for (var B in C)
        if (F.call(C, B)) {
          var $ = C[B];
          if (!($ == null || typeof $ == "boolean" || $ === "")) {
            var K = void 0, fe = void 0, Te = B.indexOf("--") === 0;
            Te ? (K = we(B), T($, B), fe = we(("" + $).trim())) : (M(B, $), K = ii(B), typeof $ == "number" ? $ !== 0 && !F.call(st, B) ? fe = $ + "px" : fe = "" + $ : (T($, B), fe = we(("" + $).trim()))), k ? (k = !1, g.push(Jn, K, Un, fe)) : g.push(Li, K, Un, fe);
          }
        }
      k || g.push(Vn);
    }
    var ai = " ", Kn = '="', Vn = '"', Pn = '=""';
    function kn(g, y, C, k) {
      switch (C) {
        case "style": {
          Hi(g, y, k);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        // These shouldn't be set as attributes on generic HTML elements.
        case "innerHTML":
        // Must use dangerouslySetInnerHTML instead.
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(C.length > 2 && (C[0] === "o" || C[0] === "O") && (C[1] === "n" || C[1] === "N"))
      ) {
        var B = He(C);
        if (B !== null) {
          switch (typeof k) {
            case "function":
            // $FlowIssue symbol is perfectly valid here
            case "symbol":
              return;
            case "boolean":
              if (!B.acceptsBooleans)
                return;
          }
          var $ = B.attributeName, K = $;
          switch (B.type) {
            case te:
              k && g.push(ai, K, Pn);
              return;
            case de:
              k === !0 ? g.push(ai, K, Pn) : k === !1 || g.push(ai, K, Kn, we(k), Vn);
              return;
            case H:
              isNaN(k) || g.push(ai, K, Kn, we(k), Vn);
              break;
            case j:
              !isNaN(k) && k >= 1 && g.push(ai, K, Kn, we(k), Vn);
              break;
            default:
              B.sanitizeURL && (E(k, $), k = "" + k, Br(k)), g.push(ai, K, Kn, we(k), Vn);
          }
        } else if (Xe(C)) {
          switch (typeof k) {
            case "function":
            // $FlowIssue symbol is perfectly valid here
            case "symbol":
              return;
            case "boolean": {
              var fe = C.toLowerCase().slice(0, 5);
              if (fe !== "data-" && fe !== "aria-")
                return;
            }
          }
          g.push(ai, C, Kn, we(k), Vn);
        }
      }
    }
    var $n = ">", I = "/>";
    function U(g, y, C) {
      if (y != null) {
        if (C != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof y != "object" || !("__html" in y))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var k = y.__html;
        k != null && (D(k), g.push("" + k));
      }
    }
    var Y = !1, ne = !1, Ee = !1, be = !1, _e = !1, Ye = !1, vt = !1;
    function Et(g, y) {
      {
        var C = g[y];
        if (C != null) {
          var k = ue(C);
          g.multiple && !k ? i("The `%s` prop supplied to <select> must be an array if `multiple` is true.", y) : !g.multiple && k && i("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", y);
        }
      }
    }
    function pt(g, y, C) {
      Fr("select", y), Et(y, "value"), Et(y, "defaultValue"), y.value !== void 0 && y.defaultValue !== void 0 && !Ee && (i("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Ee = !0), g.push(wi("select"));
      var k = null, B = null;
      for (var $ in y)
        if (F.call(y, $)) {
          var K = y[$];
          if (K == null)
            continue;
          switch ($) {
            case "children":
              k = K;
              break;
            case "dangerouslySetInnerHTML":
              B = K;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              kn(g, C, $, K);
              break;
          }
        }
      return g.push($n), U(g, B, k), k;
    }
    function yr(g) {
      var y = "";
      return r.Children.forEach(g, function(C) {
        C != null && (y += C, !_e && typeof C != "string" && typeof C != "number" && (_e = !0, i("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), y;
    }
    var jr = ' selected=""';
    function Dn(g, y, C, k) {
      var B = k.selectedValue;
      g.push(wi("option"));
      var $ = null, K = null, fe = null, Te = null;
      for (var Ue in y)
        if (F.call(y, Ue)) {
          var Je = y[Ue];
          if (Je == null)
            continue;
          switch (Ue) {
            case "children":
              $ = Je;
              break;
            case "selected":
              fe = Je, vt || (i("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), vt = !0);
              break;
            case "dangerouslySetInnerHTML":
              Te = Je;
              break;
            // eslint-disable-next-line-no-fallthrough
            case "value":
              K = Je;
            // We intentionally fallthrough to also set the attribute on the node.
            // eslint-disable-next-line-no-fallthrough
            default:
              kn(g, C, Ue, Je);
              break;
          }
        }
      if (B != null) {
        var ht;
        if (K !== null ? (E(K, "value"), ht = "" + K) : (Te !== null && (Ye || (Ye = !0, i("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), ht = yr($)), ue(B))
          for (var ir = 0; ir < B.length; ir++) {
            E(B[ir], "value");
            var rn = "" + B[ir];
            if (rn === ht) {
              g.push(jr);
              break;
            }
          }
        else
          E(B, "select.value"), "" + B === ht && g.push(jr);
      } else fe && g.push(jr);
      return g.push($n), U(g, Te, $), $;
    }
    function Wn(g, y, C) {
      Fr("input", y), y.checked !== void 0 && y.defaultChecked !== void 0 && !ne && (i("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", y.type), ne = !0), y.value !== void 0 && y.defaultValue !== void 0 && !Y && (i("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", y.type), Y = !0), g.push(wi("input"));
      var k = null, B = null, $ = null, K = null;
      for (var fe in y)
        if (F.call(y, fe)) {
          var Te = y[fe];
          if (Te == null)
            continue;
          switch (fe) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            // eslint-disable-next-line-no-fallthrough
            case "defaultChecked":
              K = Te;
              break;
            case "defaultValue":
              B = Te;
              break;
            case "checked":
              $ = Te;
              break;
            case "value":
              k = Te;
              break;
            default:
              kn(g, C, fe, Te);
              break;
          }
        }
      return $ !== null ? kn(g, C, "checked", $) : K !== null && kn(g, C, "checked", K), k !== null ? kn(g, C, "value", k) : B !== null && kn(g, C, "value", B), g.push(I), null;
    }
    function Ri(g, y, C) {
      Fr("textarea", y), y.value !== void 0 && y.defaultValue !== void 0 && !be && (i("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), be = !0), g.push(wi("textarea"));
      var k = null, B = null, $ = null;
      for (var K in y)
        if (F.call(y, K)) {
          var fe = y[K];
          if (fe == null)
            continue;
          switch (K) {
            case "children":
              $ = fe;
              break;
            case "value":
              k = fe;
              break;
            case "defaultValue":
              B = fe;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            // eslint-disable-next-line-no-fallthrough
            default:
              kn(g, C, K, fe);
              break;
          }
        }
      if (k === null && B !== null && (k = B), g.push($n), $ != null) {
        if (i("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), k != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (ue($)) {
          if ($.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          D($[0]), k = "" + $[0];
        }
        D($), k = "" + $;
      }
      return typeof k == "string" && k[0] === `
` && g.push(di), k !== null && (E(k, "value"), g.push(oi("" + k))), null;
    }
    function yi(g, y, C, k) {
      g.push(wi(C));
      for (var B in y)
        if (F.call(y, B)) {
          var $ = y[B];
          if ($ == null)
            continue;
          switch (B) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(C + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            // eslint-disable-next-line-no-fallthrough
            default:
              kn(g, k, B, $);
              break;
          }
        }
      return g.push(I), null;
    }
    function Zn(g, y, C) {
      g.push(wi("menuitem"));
      for (var k in y)
        if (F.call(y, k)) {
          var B = y[k];
          if (B == null)
            continue;
          switch (k) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            // eslint-disable-next-line-no-fallthrough
            default:
              kn(g, C, k, B);
              break;
          }
        }
      return g.push($n), null;
    }
    function wn(g, y, C) {
      g.push(wi("title"));
      var k = null;
      for (var B in y)
        if (F.call(y, B)) {
          var $ = y[B];
          if ($ == null)
            continue;
          switch (B) {
            case "children":
              k = $;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            // eslint-disable-next-line-no-fallthrough
            default:
              kn(g, C, B, $);
              break;
          }
        }
      g.push($n);
      {
        var K = Array.isArray(k) && k.length < 2 ? k[0] || null : k;
        Array.isArray(k) && k.length > 1 ? i("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : K != null && K.$$typeof != null ? i("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : K != null && typeof K != "string" && typeof K != "number" && i("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return k;
    }
    function Oi(g, y, C, k) {
      g.push(wi(C));
      var B = null, $ = null;
      for (var K in y)
        if (F.call(y, K)) {
          var fe = y[K];
          if (fe == null)
            continue;
          switch (K) {
            case "children":
              B = fe;
              break;
            case "dangerouslySetInnerHTML":
              $ = fe;
              break;
            default:
              kn(g, k, K, fe);
              break;
          }
        }
      return g.push($n), U(g, $, B), typeof B == "string" ? (g.push(oi(B)), null) : B;
    }
    function Ai(g, y, C, k) {
      g.push(wi(C));
      var B = null, $ = null;
      for (var K in y)
        if (F.call(y, K)) {
          var fe = y[K];
          if (fe == null)
            continue;
          switch (K) {
            case "children":
              B = fe;
              break;
            case "dangerouslySetInnerHTML":
              $ = fe;
              break;
            case "style":
              Hi(g, k, fe);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              Xe(K) && typeof fe != "function" && typeof fe != "symbol" && g.push(ai, K, Kn, we(fe), Vn);
              break;
          }
        }
      return g.push($n), U(g, $, B), B;
    }
    var di = `
`;
    function ka(g, y, C, k) {
      g.push(wi(C));
      var B = null, $ = null;
      for (var K in y)
        if (F.call(y, K)) {
          var fe = y[K];
          if (fe == null)
            continue;
          switch (K) {
            case "children":
              B = fe;
              break;
            case "dangerouslySetInnerHTML":
              $ = fe;
              break;
            default:
              kn(g, k, K, fe);
              break;
          }
        }
      if (g.push($n), $ != null) {
        if (B != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof $ != "object" || !("__html" in $))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var Te = $.__html;
        Te != null && (typeof Te == "string" && Te.length > 0 && Te[0] === `
` ? g.push(di, Te) : (D(Te), g.push("" + Te)));
      }
      return typeof B == "string" && B[0] === `
` && g.push(di), B;
    }
    var oa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, la = /* @__PURE__ */ new Map();
    function wi(g) {
      var y = la.get(g);
      if (y === void 0) {
        if (!oa.test(g))
          throw new Error("Invalid tag: " + g);
        y = "<" + g, la.set(g, y);
      }
      return y;
    }
    var Zi = "<!DOCTYPE html>";
    function Ei(g, y, C, k, B) {
      switch (Gr(y, C), Cr(y, C), en(y, C, null), !C.suppressContentEditableWarning && C.contentEditable && C.children != null && i("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), B.insertionMode !== Ot && B.insertionMode !== Qt && y.indexOf("-") === -1 && typeof C.is != "string" && y.toLowerCase() !== y && i("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", y), y) {
        // Special tags
        case "select":
          return pt(g, C, k);
        case "option":
          return Dn(g, C, k, B);
        case "textarea":
          return Ri(g, C, k);
        case "input":
          return Wn(g, C, k);
        case "menuitem":
          return Zn(g, C, k);
        case "title":
          return wn(g, C, k);
        // Newline eating tags
        case "listing":
        case "pre":
          return ka(g, C, y, k);
        // Omitted close tags
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return yi(g, C, y, k);
        // These are reserved SVG and MathML elements, that are never custom elements.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return Oi(g, C, y, k);
        case "html":
          return B.insertionMode === ft && g.push(Zi), Oi(g, C, y, k);
        default:
          return y.indexOf("-") === -1 && typeof C.is != "string" ? Oi(g, C, y, k) : Ai(g, C, y, k);
      }
    }
    var li = "</", Ui = ">";
    function _r(g, y, C) {
      switch (y) {
        // Omitted close tags
        // TODO: Instead of repeating this switch we could try to pass a flag from above.
        // That would require returning a tuple. Which might be ok if it gets inlined.
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          g.push(li, y, Ui);
      }
    }
    function hi(g, y) {
      for (var C = y.bootstrapChunks, k = 0; k < C.length - 1; k++)
        l(g, C[k]);
      return k < C.length ? u(g, C[k]) : !0;
    }
    var Lr = '<template id="', R = '"></template>';
    function X(g, y, C) {
      l(g, Lr), l(g, y.placeholderPrefix);
      var k = C.toString(16);
      return l(g, k), u(g, R);
    }
    var pe = "<!--$-->", Re = '<!--$?--><template id="', Bt = '"></template>', Tt = "<!--$!-->", hr = "<!--/$-->", or = "<template", xn = '"', N = ' data-dgst="', oe = ' data-msg="', xe = ' data-stck="', Ie = "></template>";
    function We(g, y) {
      return u(g, pe);
    }
    function ot(g, y, C) {
      if (l(g, Re), C === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return l(g, C), u(g, Bt);
    }
    function dt(g, y, C, k, B) {
      var $;
      return $ = u(g, Tt), l(g, or), C && (l(g, N), l(g, we(C)), l(g, xn)), k && (l(g, oe), l(g, we(k)), l(g, xn)), B && (l(g, xe), l(g, we(B)), l(g, xn)), $ = u(g, Ie), $;
    }
    function Nt(g, y) {
      return u(g, hr);
    }
    function Yt(g, y) {
      return u(g, hr);
    }
    function Ur(g, y) {
      return u(g, hr);
    }
    var qr = '<div hidden id="', Dr = '">', Ar = "</div>", Rn = '<svg aria-hidden="true" style="display:none" id="', Jr = '">', Ya = "</svg>", Xa = '<math aria-hidden="true" style="display:none" id="', Vi = '">', pi = "</math>", Ta = '<table hidden id="', Vr = '">', ua = "</table>", os = '<table hidden><tbody id="', ls = '">', Ds = "</tbody></table>", Eo = '<table hidden><tr id="', ga = '">', Zs = "</tr></table>", eo = '<table hidden><colgroup id="', us = '">', Ua = "</colgroup></table>";
    function cs(g, y, C, k) {
      switch (C.insertionMode) {
        case ft:
        case Vt:
          return l(g, qr), l(g, y.segmentPrefix), l(g, k.toString(16)), u(g, Dr);
        case Ot:
          return l(g, Rn), l(g, y.segmentPrefix), l(g, k.toString(16)), u(g, Jr);
        case Qt:
          return l(g, Xa), l(g, y.segmentPrefix), l(g, k.toString(16)), u(g, Vi);
        case zt:
          return l(g, Ta), l(g, y.segmentPrefix), l(g, k.toString(16)), u(g, Vr);
        // TODO: For the rest of these, there will be extra wrapper nodes that never
        // get deleted from the document. We need to delete the table too as part
        // of the injected scripts. They are invisible though so it's not too terrible
        // and it's kind of an edge case to suspend in a table. Totally supported though.
        case Hr:
          return l(g, os), l(g, y.segmentPrefix), l(g, k.toString(16)), u(g, ls);
        case Tr:
          return l(g, Eo), l(g, y.segmentPrefix), l(g, k.toString(16)), u(g, ga);
        case Nr:
          return l(g, eo), l(g, y.segmentPrefix), l(g, k.toString(16)), u(g, us);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function Fa(g, y) {
      switch (y.insertionMode) {
        case ft:
        case Vt:
          return u(g, Ar);
        case Ot:
          return u(g, Ya);
        case Qt:
          return u(g, pi);
        case zt:
          return u(g, ua);
        case Hr:
          return u(g, Ds);
        case Tr:
          return u(g, Zs);
        case Nr:
          return u(g, Ua);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var P = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", V = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', Q = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', ie = P + ';$RS("', Pe = '$RS("', ke = '","', Le = '")<\/script>';
    function nt(g, y, C) {
      l(g, y.startInlineScript), y.sentCompleteSegmentFunction ? l(g, Pe) : (y.sentCompleteSegmentFunction = !0, l(g, ie)), l(g, y.segmentPrefix);
      var k = C.toString(16);
      return l(g, k), l(g, ke), l(g, y.placeholderPrefix), l(g, k), u(g, Le);
    }
    var Xt = V + ';$RC("', Wt = '$RC("', ur = '","', un = '")<\/script>';
    function z(g, y, C, k) {
      if (l(g, y.startInlineScript), y.sentCompleteBoundaryFunction ? l(g, Wt) : (y.sentCompleteBoundaryFunction = !0, l(g, Xt)), C === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var B = k.toString(16);
      return l(g, C), l(g, ur), l(g, y.segmentPrefix), l(g, B), u(g, un);
    }
    var ce = Q + ';$RX("', me = '$RX("', tt = '"', _t = ")<\/script>", nr = ",";
    function On(g, y, C, k, B, $) {
      if (l(g, y.startInlineScript), y.sentClientRenderFunction ? l(g, me) : (y.sentClientRenderFunction = !0, l(g, ce)), C === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return l(g, C), l(g, tt), (k || B || $) && (l(g, nr), l(g, Wi(k || ""))), (B || $) && (l(g, nr), l(g, Wi(B || ""))), $ && (l(g, nr), l(g, Wi($))), u(g, _t);
    }
    var ei = /[<\u2028\u2029]/g;
    function Wi(g) {
      var y = JSON.stringify(g);
      return y.replace(ei, function(C) {
        switch (C) {
          // santizing breaking out of strings and script tags
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    function Va(g, y) {
      var C = ct(y);
      return {
        // Keep this in sync with ReactDOMServerFormatConfig
        bootstrapChunks: C.bootstrapChunks,
        startInlineScript: C.startInlineScript,
        placeholderPrefix: C.placeholderPrefix,
        segmentPrefix: C.segmentPrefix,
        boundaryPrefix: C.boundaryPrefix,
        idPrefix: C.idPrefix,
        nextSuspenseID: C.nextSuspenseID,
        sentCompleteSegmentFunction: C.sentCompleteSegmentFunction,
        sentCompleteBoundaryFunction: C.sentCompleteBoundaryFunction,
        sentClientRenderFunction: C.sentClientRenderFunction,
        // This is an extra field for the legacy renderer
        generateStaticMarkup: g
      };
    }
    function rl() {
      return {
        insertionMode: Vt,
        // We skip the root mode because we don't want to emit the DOCTYPE in legacy mode.
        selectedValue: null
      };
    }
    function Ul(g, y, C, k) {
      return C.generateStaticMarkup ? (g.push(we(y)), !1) : Di(g, y, C, k);
    }
    function $a(g, y, C, k) {
      if (!y.generateStaticMarkup)
        return ni(g, y, C, k);
    }
    function Ia(g, y) {
      return y.generateStaticMarkup ? !0 : We(g);
    }
    function Rs(g, y, C, k, B) {
      return y.generateStaticMarkup ? !0 : dt(g, y, C, k, B);
    }
    function uh(g, y) {
      return y.generateStaticMarkup ? !0 : Nt(g);
    }
    function ch(g, y) {
      return y.generateStaticMarkup ? !0 : Ur(g);
    }
    var Bi = Object.assign, Ja = /* @__PURE__ */ Symbol.for("react.element"), Vc = /* @__PURE__ */ Symbol.for("react.portal"), Du = /* @__PURE__ */ Symbol.for("react.fragment"), Pa = /* @__PURE__ */ Symbol.for("react.strict_mode"), jf = /* @__PURE__ */ Symbol.for("react.profiler"), Ru = /* @__PURE__ */ Symbol.for("react.provider"), Ou = /* @__PURE__ */ Symbol.for("react.context"), Os = /* @__PURE__ */ Symbol.for("react.forward_ref"), Ae = /* @__PURE__ */ Symbol.for("react.suspense"), Ne = /* @__PURE__ */ Symbol.for("react.suspense_list"), De = /* @__PURE__ */ Symbol.for("react.memo"), xt = /* @__PURE__ */ Symbol.for("react.lazy"), pr = /* @__PURE__ */ Symbol.for("react.scope"), cn = /* @__PURE__ */ Symbol.for("react.debug_trace_mode"), xi = /* @__PURE__ */ Symbol.for("react.legacy_hidden"), Tn = /* @__PURE__ */ Symbol.for("react.default_value"), Bu = Symbol.iterator, fh = "@@iterator";
    function za(g) {
      if (g === null || typeof g != "object")
        return null;
      var y = Bu && g[Bu] || g[fh];
      return typeof y == "function" ? y : null;
    }
    function _u(g, y, C) {
      var k = g.displayName;
      if (k)
        return k;
      var B = y.displayName || y.name || "";
      return B !== "" ? C + "(" + B + ")" : C;
    }
    function $c(g) {
      return g.displayName || "Context";
    }
    function Bn(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && i("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case Du:
          return "Fragment";
        case Vc:
          return "Portal";
        case jf:
          return "Profiler";
        case Pa:
          return "StrictMode";
        case Ae:
          return "Suspense";
        case Ne:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case Ou:
            var y = g;
            return $c(y) + ".Consumer";
          case Ru:
            var C = g;
            return $c(C._context) + ".Provider";
          case Os:
            return _u(g, g.render, "ForwardRef");
          case De:
            var k = g.displayName || null;
            return k !== null ? k : Bn(g.type) || "Memo";
          case xt: {
            var B = g, $ = B._payload, K = B._init;
            try {
              return Bn(K($));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var to = 0, Vl, pn, ti, ko, nl, zc, Gc;
    function Hc() {
    }
    Hc.__reactDisabledLog = !0;
    function $l() {
      {
        if (to === 0) {
          Vl = console.log, pn = console.info, ti = console.warn, ko = console.error, nl = console.group, zc = console.groupCollapsed, Gc = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: Hc,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        to++;
      }
    }
    function Bs() {
      {
        if (to--, to === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Bi({}, g, {
              value: Vl
            }),
            info: Bi({}, g, {
              value: pn
            }),
            warn: Bi({}, g, {
              value: ti
            }),
            error: Bi({}, g, {
              value: ko
            }),
            group: Bi({}, g, {
              value: nl
            }),
            groupCollapsed: Bi({}, g, {
              value: zc
            }),
            groupEnd: Bi({}, g, {
              value: Gc
            })
          });
        }
        to < 0 && i("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var To = t.ReactCurrentDispatcher, zl;
    function ro(g, y, C) {
      {
        if (zl === void 0)
          try {
            throw Error();
          } catch (B) {
            var k = B.stack.trim().match(/\n( *(at )?)/);
            zl = k && k[1] || "";
          }
        return `
` + zl + g;
      }
    }
    var Mu = !1, Fo;
    {
      var il = typeof WeakMap == "function" ? WeakMap : Map;
      Fo = new il();
    }
    function no(g, y) {
      if (!g || Mu)
        return "";
      {
        var C = Fo.get(g);
        if (C !== void 0)
          return C;
      }
      var k;
      Mu = !0;
      var B = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var $;
      $ = To.current, To.current = null, $l();
      try {
        if (y) {
          var K = function() {
            throw Error();
          };
          if (Object.defineProperty(K.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(K, []);
            } catch (qi) {
              k = qi;
            }
            Reflect.construct(g, [], K);
          } else {
            try {
              K.call();
            } catch (qi) {
              k = qi;
            }
            g.call(K.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (qi) {
            k = qi;
          }
          g();
        }
      } catch (qi) {
        if (qi && k && typeof qi.stack == "string") {
          for (var fe = qi.stack.split(`
`), Te = k.stack.split(`
`), Ue = fe.length - 1, Je = Te.length - 1; Ue >= 1 && Je >= 0 && fe[Ue] !== Te[Je]; )
            Je--;
          for (; Ue >= 1 && Je >= 0; Ue--, Je--)
            if (fe[Ue] !== Te[Je]) {
              if (Ue !== 1 || Je !== 1)
                do
                  if (Ue--, Je--, Je < 0 || fe[Ue] !== Te[Je]) {
                    var ht = `
` + fe[Ue].replace(" at new ", " at ");
                    return g.displayName && ht.includes("<anonymous>") && (ht = ht.replace("<anonymous>", g.displayName)), typeof g == "function" && Fo.set(g, ht), ht;
                  }
                while (Ue >= 1 && Je >= 0);
              break;
            }
        }
      } finally {
        Mu = !1, To.current = $, Bs(), Error.prepareStackTrace = B;
      }
      var ir = g ? g.displayName || g.name : "", rn = ir ? ro(ir) : "";
      return typeof g == "function" && Fo.set(g, rn), rn;
    }
    function Io(g, y, C) {
      return no(g, !0);
    }
    function Ka(g, y, C) {
      return no(g, !1);
    }
    function Nu(g) {
      var y = g.prototype;
      return !!(y && y.isReactComponent);
    }
    function Gl(g, y, C) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return no(g, Nu(g));
      if (typeof g == "string")
        return ro(g);
      switch (g) {
        case Ae:
          return ro("Suspense");
        case Ne:
          return ro("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case Os:
            return Ka(g.render);
          case De:
            return Gl(g.type, y, C);
          case xt: {
            var k = g, B = k._payload, $ = k._init;
            try {
              return Gl($(B), y, C);
            } catch {
            }
          }
        }
      return "";
    }
    var qf = {}, Wc = t.ReactDebugCurrentFrame;
    function Po(g) {
      if (g) {
        var y = g._owner, C = Gl(g.type, g._source, y ? y.type : null);
        Wc.setExtraStackFrame(C);
      } else
        Wc.setExtraStackFrame(null);
    }
    function Do(g, y, C, k, B) {
      {
        var $ = Function.call.bind(F);
        for (var K in g)
          if ($(g, K)) {
            var fe = void 0;
            try {
              if (typeof g[K] != "function") {
                var Te = Error((k || "React class") + ": " + C + " type `" + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[K] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Te.name = "Invariant Violation", Te;
              }
              fe = g[K](y, K, k, C, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ue) {
              fe = Ue;
            }
            fe && !(fe instanceof Error) && (Po(B), i("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", C, K, typeof fe), Po(null)), fe instanceof Error && !(fe.message in qf) && (qf[fe.message] = !0, Po(B), i("Failed %s type: %s", C, fe.message), Po(null));
          }
      }
    }
    var al;
    al = {};
    var Hl = {};
    Object.freeze(Hl);
    function sl(g, y) {
      {
        var C = g.contextTypes;
        if (!C)
          return Hl;
        var k = {};
        for (var B in C)
          k[B] = y[B];
        {
          var $ = Bn(g) || "Unknown";
          Do(C, k, "context", $);
        }
        return k;
      }
    }
    function Qf(g, y, C, k) {
      {
        if (typeof g.getChildContext != "function") {
          {
            var B = Bn(y) || "Unknown";
            al[B] || (al[B] = !0, i("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", B, B));
          }
          return C;
        }
        var $ = g.getChildContext();
        for (var K in $)
          if (!(K in k))
            throw new Error((Bn(y) || "Unknown") + '.getChildContext(): key "' + K + '" is not defined in childContextTypes.');
        {
          var fe = Bn(y) || "Unknown";
          Do(k, $, "child context", fe);
        }
        return Bi({}, C, $);
      }
    }
    var Ro;
    Ro = {};
    var gi = null, ui = null;
    function jc(g) {
      g.context._currentValue2 = g.parentValue;
    }
    function Oo(g) {
      g.context._currentValue2 = g.value;
    }
    function Wl(g, y) {
      if (g !== y) {
        jc(g);
        var C = g.parent, k = y.parent;
        if (C === null) {
          if (k !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (k === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          Wl(C, k);
        }
        Oo(y);
      }
    }
    function io(g) {
      jc(g);
      var y = g.parent;
      y !== null && io(y);
    }
    function ol(g) {
      var y = g.parent;
      y !== null && ol(y), Oo(g);
    }
    function ao(g, y) {
      jc(g);
      var C = g.parent;
      if (C === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      C.depth === y.depth ? Wl(C, y) : ao(C, y);
    }
    function Bo(g, y) {
      var C = y.parent;
      if (C === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      g.depth === C.depth ? Wl(g, C) : Bo(g, C), Oo(y);
    }
    function fs(g) {
      var y = ui, C = g;
      y !== C && (y === null ? ol(C) : C === null ? io(y) : y.depth === C.depth ? Wl(y, C) : y.depth > C.depth ? ao(y, C) : Bo(y, C), ui = C);
    }
    function ll(g, y) {
      var C;
      C = g._currentValue2, g._currentValue2 = y, g._currentRenderer2 !== void 0 && g._currentRenderer2 !== null && g._currentRenderer2 !== Ro && i("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), g._currentRenderer2 = Ro;
      var k = ui, B = {
        parent: k,
        depth: k === null ? 0 : k.depth + 1,
        context: g,
        parentValue: C,
        value: y
      };
      return ui = B, B;
    }
    function ul(g) {
      var y = ui;
      if (y === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      y.context !== g && i("The parent context is not the expected context. This is probably a bug in React.");
      {
        var C = y.parentValue;
        C === Tn ? y.context._currentValue2 = y.context._defaultValue : y.context._currentValue2 = C, g._currentRenderer2 !== void 0 && g._currentRenderer2 !== null && g._currentRenderer2 !== Ro && i("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), g._currentRenderer2 = Ro;
      }
      return ui = y.parent;
    }
    function jl() {
      return ui;
    }
    function Da(g) {
      var y = g._currentValue2;
      return y;
    }
    function qc(g) {
      return g._reactInternals;
    }
    function dh(g, y) {
      g._reactInternals = y;
    }
    var Yf = {}, cl = {}, ql, fl, so, Ql, J, Za, oo, ea, $r;
    {
      ql = /* @__PURE__ */ new Set(), fl = /* @__PURE__ */ new Set(), so = /* @__PURE__ */ new Set(), oo = /* @__PURE__ */ new Set(), Ql = /* @__PURE__ */ new Set(), ea = /* @__PURE__ */ new Set(), $r = /* @__PURE__ */ new Set();
      var Yl = /* @__PURE__ */ new Set();
      Za = function(g, y) {
        if (!(g === null || typeof g == "function")) {
          var C = y + "_" + g;
          Yl.has(C) || (Yl.add(C), i("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", y, g));
        }
      }, J = function(g, y) {
        if (y === void 0) {
          var C = Bn(g) || "Component";
          Ql.has(C) || (Ql.add(C), i("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", C));
        }
      };
    }
    function Lu(g, y) {
      {
        var C = g.constructor, k = C && Bn(C) || "ReactClass", B = k + "." + y;
        if (Yf[B])
          return;
        i(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, y, y, k), Yf[B] = !0;
      }
    }
    var Uu = {
      isMounted: function(g) {
        return !1;
      },
      enqueueSetState: function(g, y, C) {
        var k = qc(g);
        k.queue === null ? Lu(g, "setState") : (k.queue.push(y), C != null && Za(C, "setState"));
      },
      enqueueReplaceState: function(g, y, C) {
        var k = qc(g);
        k.replace = !0, k.queue = [y], C != null && Za(C, "setState");
      },
      enqueueForceUpdate: function(g, y) {
        var C = qc(g);
        C.queue === null ? Lu(g, "forceUpdate") : y != null && Za(y, "setState");
      }
    };
    function _s(g, y, C, k, B) {
      var $ = C(B, k);
      J(y, $);
      var K = $ == null ? k : Bi({}, k, $);
      return K;
    }
    function Xf(g, y, C) {
      var k = Hl, B = g.contextType;
      if ("contextType" in g) {
        var $ = (
          // Allow null for conditional declaration
          B === null || B !== void 0 && B.$$typeof === Ou && B._context === void 0
        );
        if (!$ && !$r.has(g)) {
          $r.add(g);
          var K = "";
          B === void 0 ? K = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof B != "object" ? K = " However, it is set to a " + typeof B + "." : B.$$typeof === Ru ? K = " Did you accidentally pass the Context.Provider instead?" : B._context !== void 0 ? K = " Did you accidentally pass the Context.Consumer instead?" : K = " However, it is set to an object with keys {" + Object.keys(B).join(", ") + "}.", i("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Bn(g) || "Component", K);
        }
      }
      typeof B == "object" && B !== null ? k = Da(B) : k = C;
      var fe = new g(y, k);
      {
        if (typeof g.getDerivedStateFromProps == "function" && (fe.state === null || fe.state === void 0)) {
          var Te = Bn(g) || "Component";
          ql.has(Te) || (ql.add(Te), i("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Te, fe.state === null ? "null" : "undefined", Te));
        }
        if (typeof g.getDerivedStateFromProps == "function" || typeof fe.getSnapshotBeforeUpdate == "function") {
          var Ue = null, Je = null, ht = null;
          if (typeof fe.componentWillMount == "function" && fe.componentWillMount.__suppressDeprecationWarning !== !0 ? Ue = "componentWillMount" : typeof fe.UNSAFE_componentWillMount == "function" && (Ue = "UNSAFE_componentWillMount"), typeof fe.componentWillReceiveProps == "function" && fe.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Je = "componentWillReceiveProps" : typeof fe.UNSAFE_componentWillReceiveProps == "function" && (Je = "UNSAFE_componentWillReceiveProps"), typeof fe.componentWillUpdate == "function" && fe.componentWillUpdate.__suppressDeprecationWarning !== !0 ? ht = "componentWillUpdate" : typeof fe.UNSAFE_componentWillUpdate == "function" && (ht = "UNSAFE_componentWillUpdate"), Ue !== null || Je !== null || ht !== null) {
            var ir = Bn(g) || "Component", rn = typeof g.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            so.has(ir) || (so.add(ir), i(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, ir, rn, Ue !== null ? `
  ` + Ue : "", Je !== null ? `
  ` + Je : "", ht !== null ? `
  ` + ht : ""));
          }
        }
      }
      return fe;
    }
    function Jf(g, y, C) {
      {
        var k = Bn(y) || "Component", B = g.render;
        B || (y.prototype && typeof y.prototype.render == "function" ? i("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", k) : i("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", k)), g.getInitialState && !g.getInitialState.isReactClassApproved && !g.state && i("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", k), g.getDefaultProps && !g.getDefaultProps.isReactClassApproved && i("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", k), g.propTypes && i("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", k), g.contextType && i("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", k), g.contextTypes && i("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", k), y.contextType && y.contextTypes && !ea.has(y) && (ea.add(y), i("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", k)), typeof g.componentShouldUpdate == "function" && i("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", k), y.prototype && y.prototype.isPureReactComponent && typeof g.shouldComponentUpdate < "u" && i("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Bn(y) || "A pure component"), typeof g.componentDidUnmount == "function" && i("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", k), typeof g.componentDidReceiveProps == "function" && i("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", k), typeof g.componentWillRecieveProps == "function" && i("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", k), typeof g.UNSAFE_componentWillRecieveProps == "function" && i("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", k);
        var $ = g.props !== C;
        g.props !== void 0 && $ && i("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", k, k), g.defaultProps && i("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", k, k), typeof g.getSnapshotBeforeUpdate == "function" && typeof g.componentDidUpdate != "function" && !fl.has(y) && (fl.add(y), i("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Bn(y))), typeof g.getDerivedStateFromProps == "function" && i("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", k), typeof g.getDerivedStateFromError == "function" && i("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", k), typeof y.getSnapshotBeforeUpdate == "function" && i("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", k);
        var K = g.state;
        K && (typeof K != "object" || ue(K)) && i("%s.state: must be set to an object or null", k), typeof g.getChildContext == "function" && typeof y.childContextTypes != "object" && i("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", k);
      }
    }
    function Kf(g, y) {
      var C = y.state;
      if (typeof y.componentWillMount == "function") {
        if (y.componentWillMount.__suppressDeprecationWarning !== !0) {
          var k = Bn(g) || "Unknown";
          cl[k] || (n(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            k
          ), cl[k] = !0);
        }
        y.componentWillMount();
      }
      typeof y.UNSAFE_componentWillMount == "function" && y.UNSAFE_componentWillMount(), C !== y.state && (i("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Bn(g) || "Component"), Uu.enqueueReplaceState(y, y.state, null));
    }
    function hh(g, y, C, k) {
      if (g.queue !== null && g.queue.length > 0) {
        var B = g.queue, $ = g.replace;
        if (g.queue = null, g.replace = !1, $ && B.length === 1)
          y.state = B[0];
        else {
          for (var K = $ ? B[0] : y.state, fe = !0, Te = $ ? 1 : 0; Te < B.length; Te++) {
            var Ue = B[Te], Je = typeof Ue == "function" ? Ue.call(y, K, C, k) : Ue;
            Je != null && (fe ? (fe = !1, K = Bi({}, K, Je)) : Bi(K, Je));
          }
          y.state = K;
        }
      } else
        g.queue = null;
    }
    function Zf(g, y, C, k) {
      Jf(g, y, C);
      var B = g.state !== void 0 ? g.state : null;
      g.updater = Uu, g.props = C, g.state = B;
      var $ = {
        queue: [],
        replace: !1
      };
      dh(g, $);
      var K = y.contextType;
      if (typeof K == "object" && K !== null ? g.context = Da(K) : g.context = k, g.state === C) {
        var fe = Bn(y) || "Component";
        oo.has(fe) || (oo.add(fe), i("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", fe));
      }
      var Te = y.getDerivedStateFromProps;
      typeof Te == "function" && (g.state = _s(g, y, Te, B, C)), typeof y.getDerivedStateFromProps != "function" && typeof g.getSnapshotBeforeUpdate != "function" && (typeof g.UNSAFE_componentWillMount == "function" || typeof g.componentWillMount == "function") && (Kf(y, g), hh($, g, C, k));
    }
    var Ms = {
      id: 1,
      overflow: ""
    };
    function ph(g) {
      var y = g.overflow, C = g.id, k = C & ~gh(C);
      return k.toString(32) + y;
    }
    function Qc(g, y, C) {
      var k = g.id, B = g.overflow, $ = Xl(k) - 1, K = k & ~(1 << $), fe = C + 1, Te = Xl(y) + $;
      if (Te > 30) {
        var Ue = $ - $ % 5, Je = (1 << Ue) - 1, ht = (K & Je).toString(32), ir = K >> Ue, rn = $ - Ue, qi = Xl(y) + rn, go = fe << rn, ws = go | ir, xs = ht + B;
        return {
          id: 1 << qi | ws,
          overflow: xs
        };
      } else {
        var mo = fe << $, Ph = mo | K, Sg = B;
        return {
          id: 1 << Te | Ph,
          overflow: Sg
        };
      }
    }
    function Xl(g) {
      return 32 - mh(g);
    }
    function gh(g) {
      return 1 << Xl(g) - 1;
    }
    var mh = Math.clz32 ? Math.clz32 : vh, es = Math.log, Vu = Math.LN2;
    function vh(g) {
      var y = g >>> 0;
      return y === 0 ? 32 : 31 - (es(y) / Vu | 0) | 0;
    }
    function yh(g, y) {
      return g === y && (g !== 0 || 1 / g === 1 / y) || g !== g && y !== y;
    }
    var Ah = typeof Object.is == "function" ? Object.is : yh, Ns = null, Ls = null, $u = null, jn = null, ci = !1, dl = !1, _o = 0, fn = null, lo = 0, zu = 25, ma = !1, va;
    function ds() {
      if (Ns === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return ma && i("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), Ns;
    }
    function wh(g, y) {
      if (y === null)
        return i("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", va), !1;
      g.length !== y.length && i(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, va, "[" + g.join(", ") + "]", "[" + y.join(", ") + "]");
      for (var C = 0; C < y.length && C < g.length; C++)
        if (!Ah(g[C], y[C]))
          return !1;
      return !0;
    }
    function Ra() {
      if (lo > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function Ga() {
      return jn === null ? $u === null ? (ci = !1, $u = jn = Ra()) : (ci = !0, jn = $u) : jn.next === null ? (ci = !1, jn = jn.next = Ra()) : (ci = !0, jn = jn.next), jn;
    }
    function hs(g, y) {
      Ns = y, Ls = g, ma = !1, _o = 0;
    }
    function xh(g, y, C, k) {
      for (; dl; )
        dl = !1, _o = 0, lo += 1, jn = null, C = g(y, k);
      return Jl(), C;
    }
    function Gu() {
      var g = _o !== 0;
      return g;
    }
    function Jl() {
      ma = !1, Ns = null, Ls = null, dl = !1, $u = null, lo = 0, fn = null, jn = null;
    }
    function ps(g) {
      return ma && i("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), Da(g);
    }
    function Yc(g) {
      return va = "useContext", ds(), Da(g);
    }
    function gs(g, y) {
      return typeof y == "function" ? y(g) : y;
    }
    function ya(g) {
      return va = "useState", ed(
        gs,
        // useReducer has a special case to support lazy useState initializers
        g
      );
    }
    function ed(g, y, C) {
      if (g !== gs && (va = "useReducer"), Ns = ds(), jn = Ga(), ci) {
        var k = jn.queue, B = k.dispatch;
        if (fn !== null) {
          var $ = fn.get(k);
          if ($ !== void 0) {
            fn.delete(k);
            var K = jn.memoizedState, fe = $;
            do {
              var Te = fe.action;
              ma = !0, K = g(K, Te), ma = !1, fe = fe.next;
            } while (fe !== null);
            return jn.memoizedState = K, [K, B];
          }
        }
        return [jn.memoizedState, B];
      } else {
        ma = !0;
        var Ue;
        g === gs ? Ue = typeof y == "function" ? y() : y : Ue = C !== void 0 ? C(y) : y, ma = !1, jn.memoizedState = Ue;
        var Je = jn.queue = {
          last: null,
          dispatch: null
        }, ht = Je.dispatch = Us.bind(null, Ns, Je);
        return [jn.memoizedState, ht];
      }
    }
    function Xc(g, y) {
      Ns = ds(), jn = Ga();
      var C = y === void 0 ? null : y;
      if (jn !== null) {
        var k = jn.memoizedState;
        if (k !== null && C !== null) {
          var B = k[1];
          if (wh(C, B))
            return k[0];
        }
      }
      ma = !0;
      var $ = g();
      return ma = !1, jn.memoizedState = [$, C], $;
    }
    function Hu(g) {
      Ns = ds(), jn = Ga();
      var y = jn.memoizedState;
      if (y === null) {
        var C = {
          current: g
        };
        return Object.seal(C), jn.memoizedState = C, C;
      } else
        return y;
    }
    function Kl(g, y) {
      va = "useLayoutEffect", i("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function Us(g, y, C) {
      if (lo >= zu)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (g === Ns) {
        dl = !0;
        var k = {
          action: C,
          next: null
        };
        fn === null && (fn = /* @__PURE__ */ new Map());
        var B = fn.get(y);
        if (B === void 0)
          fn.set(y, k);
        else {
          for (var $ = B; $.next !== null; )
            $ = $.next;
          $.next = k;
        }
      }
    }
    function Jc(g, y) {
      return Xc(function() {
        return g;
      }, y);
    }
    function bh(g, y, C) {
      return ds(), y(g._source);
    }
    function Wu(g, y, C) {
      if (C === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return C();
    }
    function Ch(g) {
      return ds(), g;
    }
    function td() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function ji() {
      return ds(), [!1, td];
    }
    function Kc() {
      var g = Ls, y = ph(g.treeContext), C = eu;
      if (C === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var k = _o++;
      return Wr(C, y, k);
    }
    function Zl() {
    }
    var ts = {
      readContext: ps,
      useContext: Yc,
      useMemo: Xc,
      useReducer: ed,
      useRef: Hu,
      useState: ya,
      useInsertionEffect: Zl,
      useLayoutEffect: Kl,
      useCallback: Jc,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: Zl,
      // Effects are not run in the server environment.
      useEffect: Zl,
      // Debugging effect
      useDebugValue: Zl,
      useDeferredValue: Ch,
      useTransition: ji,
      useId: Kc,
      // Subscriptions are not setup in a server environment.
      useMutableSource: bh,
      useSyncExternalStore: Wu
    }, eu = null;
    function tu(g) {
      eu = g;
    }
    function ms(g) {
      try {
        var y = "", C = g;
        do {
          switch (C.tag) {
            case 0:
              y += ro(C.type, null, null);
              break;
            case 1:
              y += Ka(C.type, null, null);
              break;
            case 2:
              y += Io(C.type, null, null);
              break;
          }
          C = C.parent;
        } while (C);
        return y;
      } catch (k) {
        return `
Error generating stack: ` + k.message + `
` + k.stack;
      }
    }
    var ru = t.ReactCurrentDispatcher, _i = t.ReactDebugCurrentFrame, hl = 0, pl = 1, ju = 2, qu = 3, gl = 4, ml = 0, Mo = 1, uo = 2, rd = 12800;
    function Sh(g) {
      return console.error(g), null;
    }
    function vs() {
    }
    function vl(g, y, C, k, B, $, K, fe, Te) {
      var Ue = [], Je = /* @__PURE__ */ new Set(), ht = {
        destination: null,
        responseState: y,
        progressiveChunkSize: k === void 0 ? rd : k,
        status: ml,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: Je,
        pingedTasks: Ue,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: B === void 0 ? Sh : B,
        onAllReady: vs,
        onShellReady: K === void 0 ? vs : K,
        onShellError: vs,
        onFatalError: vs
      }, ir = Qu(
        ht,
        0,
        null,
        C,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      ir.parentFlushed = !0;
      var rn = co(ht, g, null, ir, Je, Hl, gi, Ms);
      return Ue.push(rn), ht;
    }
    function Eh(g, y) {
      var C = g.pingedTasks;
      C.push(y), C.length === 1 && s(function() {
        return As(g);
      });
    }
    function Zc(g, y) {
      return {
        id: Xn,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: y,
        errorDigest: null
      };
    }
    function co(g, y, C, k, B, $, K, fe) {
      g.allPendingTasks++, C === null ? g.pendingRootTasks++ : C.pendingTasks++;
      var Te = {
        node: y,
        ping: function() {
          return Eh(g, Te);
        },
        blockedBoundary: C,
        blockedSegment: k,
        abortSet: B,
        legacyContext: $,
        context: K,
        treeContext: fe
      };
      return Te.componentStack = null, B.add(Te), Te;
    }
    function Qu(g, y, C, k, B, $) {
      return {
        status: hl,
        id: -1,
        // lazily assigned later
        index: y,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: k,
        boundary: C,
        lastPushedText: B,
        textEmbedded: $
      };
    }
    var Vs = null;
    function ef() {
      return Vs === null || Vs.componentStack === null ? "" : ms(Vs.componentStack);
    }
    function fo(g, y) {
      g.componentStack = {
        tag: 0,
        parent: g.componentStack,
        type: y
      };
    }
    function No(g, y) {
      g.componentStack = {
        tag: 1,
        parent: g.componentStack,
        type: y
      };
    }
    function $s(g, y) {
      g.componentStack = {
        tag: 2,
        parent: g.componentStack,
        type: y
      };
    }
    function Ha(g) {
      g.componentStack === null ? i("Unexpectedly popped too many stack frames. This is a bug in React.") : g.componentStack = g.componentStack.parent;
    }
    var ys = null;
    function nu(g, y) {
      {
        var C;
        typeof y == "string" ? C = y : y && typeof y.message == "string" ? C = y.message : C = String(y);
        var k = ys || ef();
        ys = null, g.errorMessage = C, g.errorComponentStack = k;
      }
    }
    function yl(g, y) {
      var C = g.onError(y);
      if (C != null && typeof C != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof C + '" instead');
      return C;
    }
    function Aa(g, y) {
      var C = g.onShellError;
      C(y);
      var k = g.onFatalError;
      k(y), g.destination !== null ? (g.status = uo, m(g.destination, y)) : (g.status = Mo, g.fatalError = y);
    }
    function iu(g, y, C) {
      fo(y, "Suspense");
      var k = y.blockedBoundary, B = y.blockedSegment, $ = C.fallback, K = C.children, fe = /* @__PURE__ */ new Set(), Te = Zc(g, fe), Ue = B.chunks.length, Je = Qu(
        g,
        Ue,
        Te,
        B.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      B.children.push(Je), B.lastPushedText = !1;
      var ht = Qu(
        g,
        0,
        null,
        B.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      ht.parentFlushed = !0, y.blockedBoundary = Te, y.blockedSegment = ht;
      try {
        if (ta(g, y, K), $a(ht.chunks, g.responseState, ht.lastPushedText, ht.textEmbedded), ht.status = pl, ho(Te, ht), Te.pendingTasks === 0) {
          Ha(y);
          return;
        }
      } catch (rn) {
        ht.status = gl, Te.forceClientRender = !0, Te.errorDigest = yl(g, rn), nu(Te, rn);
      } finally {
        y.blockedBoundary = k, y.blockedSegment = B;
      }
      var ir = co(g, $, k, Je, fe, y.legacyContext, y.context, y.treeContext);
      ir.componentStack = y.componentStack, g.pingedTasks.push(ir), Ha(y);
    }
    function Yu(g, y, C, k) {
      fo(y, C);
      var B = y.blockedSegment, $ = Ei(B.chunks, C, k, g.responseState, B.formatContext);
      B.lastPushedText = !1;
      var K = B.formatContext;
      B.formatContext = vi(K, C, k), ta(g, y, $), B.formatContext = K, _r(B.chunks, C), B.lastPushedText = !1, Ha(y);
    }
    function Al(g) {
      return g.prototype && g.prototype.isReactComponent;
    }
    function au(g, y, C, k, B) {
      var $ = {};
      hs(y, $);
      var K = C(k, B);
      return xh(C, k, K, B);
    }
    function tf(g, y, C, k, B) {
      var $ = C.render();
      C.props !== B && (ou || i("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Bn(k) || "a component"), ou = !0);
      {
        var K = k.childContextTypes;
        if (K != null) {
          var fe = y.legacyContext, Te = Qf(C, k, fe, K);
          y.legacyContext = Te, ki(g, y, $), y.legacyContext = fe;
          return;
        }
      }
      ki(g, y, $);
    }
    function kh(g, y, C, k) {
      $s(y, C);
      var B = sl(C, y.legacyContext), $ = Xf(C, k, B);
      Zf($, C, k, B), tf(g, y, $, C, k), Ha(y);
    }
    var Xu = {}, wl = {}, su = {}, nd = {}, ou = !1, Sr = {}, rf = !1, nf = !1, Lo = !1;
    function af(g, y, C, k) {
      var B;
      if (B = sl(C, y.legacyContext), No(y, C), C.prototype && typeof C.prototype.render == "function") {
        var $ = Bn(C) || "Unknown";
        Xu[$] || (i("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", $, $), Xu[$] = !0);
      }
      var K = au(g, y, C, k, B), fe = Gu();
      if (typeof K == "object" && K !== null && typeof K.render == "function" && K.$$typeof === void 0) {
        var Te = Bn(C) || "Unknown";
        wl[Te] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Te, Te, Te), wl[Te] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof K == "object" && K !== null && typeof K.render == "function" && K.$$typeof === void 0
      ) {
        {
          var Ue = Bn(C) || "Unknown";
          wl[Ue] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Ue, Ue, Ue), wl[Ue] = !0);
        }
        Zf(K, C, k, B), tf(g, y, K, C, k);
      } else if (id(C), fe) {
        var Je = y.treeContext, ht = 1, ir = 0;
        y.treeContext = Qc(Je, ht, ir);
        try {
          ki(g, y, K);
        } finally {
          y.treeContext = Je;
        }
      } else
        ki(g, y, K);
      Ha(y);
    }
    function id(g) {
      {
        if (g && g.childContextTypes && i("%s(...): childContextTypes cannot be defined on a function component.", g.displayName || g.name || "Component"), g.defaultProps !== void 0) {
          var y = Bn(g) || "Unknown";
          Sr[y] || (i("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", y), Sr[y] = !0);
        }
        if (typeof g.getDerivedStateFromProps == "function") {
          var C = Bn(g) || "Unknown";
          nd[C] || (i("%s: Function components do not support getDerivedStateFromProps.", C), nd[C] = !0);
        }
        if (typeof g.contextType == "object" && g.contextType !== null) {
          var k = Bn(g) || "Unknown";
          su[k] || (i("%s: Function components do not support contextType.", k), su[k] = !0);
        }
      }
    }
    function sf(g, y) {
      if (g && g.defaultProps) {
        var C = Bi({}, y), k = g.defaultProps;
        for (var B in k)
          C[B] === void 0 && (C[B] = k[B]);
        return C;
      }
      return y;
    }
    function Oa(g, y, C, k, B) {
      No(y, C.render);
      var $ = au(g, y, C.render, k, B), K = Gu();
      if (K) {
        var fe = y.treeContext, Te = 1, Ue = 0;
        y.treeContext = Qc(fe, Te, Ue);
        try {
          ki(g, y, $);
        } finally {
          y.treeContext = fe;
        }
      } else
        ki(g, y, $);
      Ha(y);
    }
    function Th(g, y, C, k, B) {
      var $ = C.type, K = sf($, k);
      Zu(g, y, $, K, B);
    }
    function Ju(g, y, C, k) {
      C._context === void 0 ? C !== C.Consumer && (Lo || (Lo = !0, i("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : C = C._context;
      var B = k.children;
      typeof B != "function" && i("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var $ = Da(C), K = B($);
      ki(g, y, K);
    }
    function Ku(g, y, C, k) {
      var B = C._context, $ = k.value, K = k.children, fe;
      fe = y.context, y.context = ll(B, $), ki(g, y, K), y.context = ul(B), fe !== y.context && i("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function ad(g, y, C, k, B) {
      fo(y, "Lazy");
      var $ = C._payload, K = C._init, fe = K($), Te = sf(fe, k);
      Zu(g, y, fe, Te, B), Ha(y);
    }
    function Zu(g, y, C, k, B) {
      if (typeof C == "function")
        if (Al(C)) {
          kh(g, y, C, k);
          return;
        } else {
          af(g, y, C, k);
          return;
        }
      if (typeof C == "string") {
        Yu(g, y, C, k);
        return;
      }
      switch (C) {
        // TODO: LegacyHidden acts the same as a fragment. This only works
        // because we currently assume that every instance of LegacyHidden is
        // accompanied by a host component wrapper. In the hidden mode, the host
        // component is given a `hidden` attribute, which ensures that the
        // initial HTML is not visible. To support the use of LegacyHidden as a
        // true fragment, without an extra DOM node, we would have to hide the
        // initial HTML in some other way.
        // TODO: Add REACT_OFFSCREEN_TYPE here too with the same capability.
        case xi:
        case cn:
        case Pa:
        case jf:
        case Du: {
          ki(g, y, k.children);
          return;
        }
        case Ne: {
          fo(y, "SuspenseList"), ki(g, y, k.children), Ha(y);
          return;
        }
        case pr:
          throw new Error("ReactDOMServer does not yet support scope components.");
        // eslint-disable-next-line-no-fallthrough
        case Ae: {
          iu(g, y, k);
          return;
        }
      }
      if (typeof C == "object" && C !== null)
        switch (C.$$typeof) {
          case Os: {
            Oa(g, y, C, k, B);
            return;
          }
          case De: {
            Th(g, y, C, k, B);
            return;
          }
          case Ru: {
            Ku(g, y, C, k);
            return;
          }
          case Ou: {
            Ju(g, y, C, k);
            return;
          }
          case xt: {
            ad(g, y, C, k);
            return;
          }
        }
      var $ = "";
      throw (C === void 0 || typeof C == "object" && C !== null && Object.keys(C).length === 0) && ($ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (C == null ? C : typeof C) + "." + $));
    }
    function Ba(g, y) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      g[Symbol.toStringTag] === "Generator" && (rf || i("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), rf = !0), g.entries === y && (nf || i("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), nf = !0);
    }
    function ki(g, y, C) {
      try {
        return of(g, y, C);
      } catch (k) {
        throw typeof k == "object" && k !== null && typeof k.then == "function" || (ys = ys !== null ? ys : ef()), k;
      }
    }
    function of(g, y, C) {
      if (y.node = C, typeof C == "object" && C !== null) {
        switch (C.$$typeof) {
          case Ja: {
            var k = C, B = k.type, $ = k.props, K = k.ref;
            Zu(g, y, B, $, K);
            return;
          }
          case Vc:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          // eslint-disable-next-line-no-fallthrough
          case xt: {
            var fe = C, Te = fe._payload, Ue = fe._init, Je;
            try {
              Je = Ue(Te);
            } catch (mo) {
              throw typeof mo == "object" && mo !== null && typeof mo.then == "function" && fo(y, "Lazy"), mo;
            }
            ki(g, y, Je);
            return;
          }
        }
        if (ue(C)) {
          lu(g, y, C);
          return;
        }
        var ht = za(C);
        if (ht) {
          Ba(C, ht);
          var ir = ht.call(C);
          if (ir) {
            var rn = ir.next();
            if (!rn.done) {
              var qi = [];
              do
                qi.push(rn.value), rn = ir.next();
              while (!rn.done);
              lu(g, y, qi);
              return;
            }
            return;
          }
        }
        var go = Object.prototype.toString.call(C);
        throw new Error("Objects are not valid as a React child (found: " + (go === "[object Object]" ? "object with keys {" + Object.keys(C).join(", ") + "}" : go) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof C == "string") {
        var ws = y.blockedSegment;
        ws.lastPushedText = Ul(y.blockedSegment.chunks, C, g.responseState, ws.lastPushedText);
        return;
      }
      if (typeof C == "number") {
        var xs = y.blockedSegment;
        xs.lastPushedText = Ul(y.blockedSegment.chunks, "" + C, g.responseState, xs.lastPushedText);
        return;
      }
      typeof C == "function" && i("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function lu(g, y, C) {
      for (var k = C.length, B = 0; B < k; B++) {
        var $ = y.treeContext;
        y.treeContext = Qc($, k, B);
        try {
          ta(g, y, C[B]);
        } finally {
          y.treeContext = $;
        }
      }
    }
    function ec(g, y, C) {
      var k = y.blockedSegment, B = k.chunks.length, $ = Qu(
        g,
        B,
        null,
        k.formatContext,
        // Adopt the parent segment's leading text embed
        k.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      k.children.push($), k.lastPushedText = !1;
      var K = co(g, y.node, y.blockedBoundary, $, y.abortSet, y.legacyContext, y.context, y.treeContext);
      y.componentStack !== null && (K.componentStack = y.componentStack.parent);
      var fe = K.ping;
      C.then(fe, fe);
    }
    function ta(g, y, C) {
      var k = y.blockedSegment.formatContext, B = y.legacyContext, $ = y.context, K = null;
      K = y.componentStack;
      try {
        return ki(g, y, C);
      } catch (fe) {
        if (Jl(), typeof fe == "object" && fe !== null && typeof fe.then == "function") {
          ec(g, y, fe), y.blockedSegment.formatContext = k, y.legacyContext = B, y.context = $, fs($), y.componentStack = K;
          return;
        } else
          throw y.blockedSegment.formatContext = k, y.legacyContext = B, y.context = $, fs($), y.componentStack = K, fe;
      }
    }
    function lf(g, y, C, k) {
      var B = yl(g, k);
      if (y === null ? Aa(g, k) : (y.pendingTasks--, y.forceClientRender || (y.forceClientRender = !0, y.errorDigest = B, nu(y, k), y.parentFlushed && g.clientRenderedBoundaries.push(y))), g.allPendingTasks--, g.allPendingTasks === 0) {
        var $ = g.onAllReady;
        $();
      }
    }
    function uf(g) {
      var y = this, C = g.blockedBoundary, k = g.blockedSegment;
      k.status = qu, zs(y, C, k);
    }
    function tc(g, y, C) {
      var k = g.blockedBoundary, B = g.blockedSegment;
      if (B.status = qu, k === null)
        y.allPendingTasks--, y.status !== uo && (y.status = uo, y.destination !== null && h(y.destination));
      else {
        if (k.pendingTasks--, !k.forceClientRender) {
          k.forceClientRender = !0;
          var $ = C === void 0 ? new Error("The render was aborted by the server without a reason.") : C;
          k.errorDigest = y.onError($);
          {
            var K = "The server did not finish this Suspense boundary: ";
            $ && typeof $.message == "string" ? $ = K + $.message : $ = K + String($);
            var fe = Vs;
            Vs = g;
            try {
              nu(k, $);
            } finally {
              Vs = fe;
            }
          }
          k.parentFlushed && y.clientRenderedBoundaries.push(k);
        }
        if (k.fallbackAbortableTasks.forEach(function(Ue) {
          return tc(Ue, y, C);
        }), k.fallbackAbortableTasks.clear(), y.allPendingTasks--, y.allPendingTasks === 0) {
          var Te = y.onAllReady;
          Te();
        }
      }
    }
    function ho(g, y) {
      if (y.chunks.length === 0 && y.children.length === 1 && y.children[0].boundary === null) {
        var C = y.children[0];
        C.id = y.id, C.parentFlushed = !0, C.status === pl && ho(g, C);
      } else {
        var k = g.completedSegments;
        k.push(y);
      }
    }
    function zs(g, y, C) {
      if (y === null) {
        if (C.parentFlushed) {
          if (g.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          g.completedRootSegment = C;
        }
        if (g.pendingRootTasks--, g.pendingRootTasks === 0) {
          g.onShellError = vs;
          var k = g.onShellReady;
          k();
        }
      } else if (y.pendingTasks--, !y.forceClientRender) {
        if (y.pendingTasks === 0)
          C.parentFlushed && C.status === pl && ho(y, C), y.parentFlushed && g.completedBoundaries.push(y), y.fallbackAbortableTasks.forEach(uf, g), y.fallbackAbortableTasks.clear();
        else if (C.parentFlushed && C.status === pl) {
          ho(y, C);
          var B = y.completedSegments;
          B.length === 1 && y.parentFlushed && g.partialBoundaries.push(y);
        }
      }
      if (g.allPendingTasks--, g.allPendingTasks === 0) {
        var $ = g.onAllReady;
        $();
      }
    }
    function Fh(g, y) {
      var C = y.blockedSegment;
      if (C.status === hl) {
        fs(y.context);
        var k = null;
        k = Vs, Vs = y;
        try {
          ki(g, y, y.node), $a(C.chunks, g.responseState, C.lastPushedText, C.textEmbedded), y.abortSet.delete(y), C.status = pl, zs(g, y.blockedBoundary, C);
        } catch ($) {
          if (Jl(), typeof $ == "object" && $ !== null && typeof $.then == "function") {
            var B = y.ping;
            $.then(B, B);
          } else
            y.abortSet.delete(y), C.status = gl, lf(g, y.blockedBoundary, C, $);
        } finally {
          Vs = k;
        }
      }
    }
    function As(g) {
      if (g.status !== uo) {
        var y = jl(), C = ru.current;
        ru.current = ts;
        var k;
        k = _i.getCurrentStack, _i.getCurrentStack = ef;
        var B = eu;
        tu(g.responseState);
        try {
          var $ = g.pingedTasks, K;
          for (K = 0; K < $.length; K++) {
            var fe = $[K];
            Fh(g, fe);
          }
          $.splice(0, K), g.destination !== null && cu(g, g.destination);
        } catch (Te) {
          yl(g, Te), Aa(g, Te);
        } finally {
          tu(B), ru.current = C, _i.getCurrentStack = k, C === ts && fs(y);
        }
      }
    }
    function po(g, y, C) {
      switch (C.parentFlushed = !0, C.status) {
        case hl: {
          var k = C.id = g.nextSegmentId++;
          return C.lastPushedText = !1, C.textEmbedded = !1, X(y, g.responseState, k);
        }
        case pl: {
          C.status = ju;
          for (var B = !0, $ = C.chunks, K = 0, fe = C.children, Te = 0; Te < fe.length; Te++) {
            for (var Ue = fe[Te]; K < Ue.index; K++)
              l(y, $[K]);
            B = xl(g, y, Ue);
          }
          for (; K < $.length - 1; K++)
            l(y, $[K]);
          return K < $.length && (B = u(y, $[K])), B;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function xl(g, y, C) {
      var k = C.boundary;
      if (k === null)
        return po(g, y, C);
      if (k.parentFlushed = !0, k.forceClientRender)
        return Rs(y, g.responseState, k.errorDigest, k.errorMessage, k.errorComponentStack), po(g, y, C), ch(y, g.responseState);
      if (k.pendingTasks > 0) {
        k.rootSegmentID = g.nextSegmentId++, k.completedSegments.length > 0 && g.partialBoundaries.push(k);
        var B = k.id = Yr(g.responseState);
        return ot(y, g.responseState, B), po(g, y, C), Yt(y, g.responseState);
      } else {
        if (k.byteSize > g.progressiveChunkSize)
          return k.rootSegmentID = g.nextSegmentId++, g.completedBoundaries.push(k), ot(y, g.responseState, k.id), po(g, y, C), Yt(y, g.responseState);
        Ia(y, g.responseState);
        var $ = k.completedSegments;
        if ($.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var K = $[0];
        return xl(g, y, K), uh(y, g.responseState);
      }
    }
    function cf(g, y, C) {
      return On(y, g.responseState, C.id, C.errorDigest, C.errorMessage, C.errorComponentStack);
    }
    function ff(g, y, C) {
      return cs(y, g.responseState, C.formatContext, C.id), xl(g, y, C), Fa(y, C.formatContext);
    }
    function uu(g, y, C) {
      for (var k = C.completedSegments, B = 0; B < k.length; B++) {
        var $ = k[B];
        df(g, y, C, $);
      }
      return k.length = 0, z(y, g.responseState, C.id, C.rootSegmentID);
    }
    function rc(g, y, C) {
      for (var k = C.completedSegments, B = 0; B < k.length; B++) {
        var $ = k[B];
        if (!df(g, y, C, $))
          return B++, k.splice(0, B), !1;
      }
      return k.splice(0, B), !0;
    }
    function df(g, y, C, k) {
      if (k.status === ju)
        return !0;
      var B = k.id;
      if (B === -1) {
        var $ = k.id = C.rootSegmentID;
        if ($ === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return ff(g, y, k);
      } else
        return ff(g, y, k), nt(y, g.responseState, B);
    }
    function cu(g, y) {
      try {
        var C = g.completedRootSegment;
        C !== null && g.pendingRootTasks === 0 && (xl(g, y, C), g.completedRootSegment = null, hi(y, g.responseState));
        var k = g.clientRenderedBoundaries, B;
        for (B = 0; B < k.length; B++) {
          var $ = k[B];
          if (!cf(g, y, $)) {
            g.destination = null, B++, k.splice(0, B);
            return;
          }
        }
        k.splice(0, B);
        var K = g.completedBoundaries;
        for (B = 0; B < K.length; B++) {
          var fe = K[B];
          if (!uu(g, y, fe)) {
            g.destination = null, B++, K.splice(0, B);
            return;
          }
        }
        K.splice(0, B);
        var Te = g.partialBoundaries;
        for (B = 0; B < Te.length; B++) {
          var Ue = Te[B];
          if (!rc(g, y, Ue)) {
            g.destination = null, B++, Te.splice(0, B);
            return;
          }
        }
        Te.splice(0, B);
        var Je = g.completedBoundaries;
        for (B = 0; B < Je.length; B++) {
          var ht = Je[B];
          if (!uu(g, y, ht)) {
            g.destination = null, B++, Je.splice(0, B);
            return;
          }
        }
        Je.splice(0, B);
      } finally {
        g.allPendingTasks === 0 && g.pingedTasks.length === 0 && g.clientRenderedBoundaries.length === 0 && g.completedBoundaries.length === 0 && (g.abortableTasks.size !== 0 && i("There was still abortable task at the root when we closed. This is a bug in React."), h(y));
      }
    }
    function sd(g) {
      s(function() {
        return As(g);
      });
    }
    function od(g, y) {
      if (g.status === Mo) {
        g.status = uo, m(y, g.fatalError);
        return;
      }
      if (g.status !== uo && g.destination === null) {
        g.destination = y;
        try {
          cu(g, y);
        } catch (C) {
          yl(g, C), Aa(g, C);
        }
      }
    }
    function hf(g, y) {
      try {
        var C = g.abortableTasks;
        C.forEach(function(k) {
          return tc(k, g, y);
        }), C.clear(), g.destination !== null && cu(g, g.destination);
      } catch (k) {
        yl(g, k), Aa(g, k);
      }
    }
    function ra() {
    }
    function rs(g, y, C, k) {
      var B = !1, $ = null, K = "", fe = {
        push: function(ht) {
          return ht !== null && (K += ht), !0;
        },
        destroy: function(ht) {
          B = !0, $ = ht;
        }
      }, Te = !1;
      function Ue() {
        Te = !0;
      }
      var Je = vl(g, Va(C, y ? y.identifierPrefix : void 0), rl(), 1 / 0, ra, void 0, Ue);
      if (sd(Je), hf(Je, k), od(Je, fe), B)
        throw $;
      if (!Te)
        throw new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
      return K;
    }
    function Ih(g, y) {
      return rs(g, y, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function ld(g, y) {
      return rs(g, y, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function nc() {
      throw new Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function b() {
      throw new Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    yf.renderToNodeStream = nc, yf.renderToStaticMarkup = ld, yf.renderToStaticNodeStream = b, yf.renderToString = Ih, yf.version = e;
  })()), yf;
}
var $g = {};
var _S;
function bN() {
  return _S || (_S = 1, process.env.NODE_ENV !== "production" && (function() {
    var r = Vf(), e = "18.3.1", t = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(b) {
      {
        for (var g = arguments.length, y = new Array(g > 1 ? g - 1 : 0), C = 1; C < g; C++)
          y[C - 1] = arguments[C];
        a("warn", b, y);
      }
    }
    function i(b) {
      {
        for (var g = arguments.length, y = new Array(g > 1 ? g - 1 : 0), C = 1; C < g; C++)
          y[C - 1] = arguments[C];
        a("error", b, y);
      }
    }
    function a(b, g, y) {
      {
        var C = t.ReactDebugCurrentFrame, k = C.getStackAddendum();
        k !== "" && (g += "%s", y = y.concat([k]));
        var B = y.map(function($) {
          return String($);
        });
        B.unshift("Warning: " + g), Function.prototype.apply.call(console[b], console, B);
      }
    }
    function s(b) {
      b();
    }
    var o = 512, l = null, u = 0;
    function c(b) {
      l = new Uint8Array(o), u = 0;
    }
    function h(b, g) {
      if (g.length !== 0) {
        if (g.length > o) {
          u > 0 && (b.enqueue(new Uint8Array(l.buffer, 0, u)), l = new Uint8Array(o), u = 0), b.enqueue(g);
          return;
        }
        var y = g, C = l.length - u;
        C < y.length && (C === 0 ? b.enqueue(l) : (l.set(y.subarray(0, C), u), b.enqueue(l), y = y.subarray(C)), l = new Uint8Array(o), u = 0), l.set(y, u), u += y.length;
      }
    }
    function f(b, g) {
      return h(b, g), !0;
    }
    function p(b) {
      l && u > 0 && (b.enqueue(new Uint8Array(l.buffer, 0, u)), l = null, u = 0);
    }
    function m(b) {
      b.close();
    }
    var A = new TextEncoder();
    function w(b) {
      return A.encode(b);
    }
    function x(b) {
      return A.encode(b);
    }
    function E(b, g) {
      typeof b.error == "function" ? b.error(g) : b.close();
    }
    function T(b) {
      {
        var g = typeof Symbol == "function" && Symbol.toStringTag, y = g && b[Symbol.toStringTag] || b.constructor.name || "Object";
        return y;
      }
    }
    function D(b) {
      try {
        return F(b), !1;
      } catch {
        return !0;
      }
    }
    function F(b) {
      return "" + b;
    }
    function _(b, g) {
      if (D(b))
        return i("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", g, T(b)), F(b);
    }
    function L(b, g) {
      if (D(b))
        return i("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", g, T(b)), F(b);
    }
    function Z(b) {
      if (D(b))
        return i("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", T(b)), F(b);
    }
    var te = Object.prototype.hasOwnProperty, de = 0, H = 1, j = 2, q = 3, re = 4, ae = 5, ye = 6, Se = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Xe = Se + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Ve = new RegExp("^[" + Se + "][" + Xe + "]*$"), He = {}, le = {};
    function ve(b) {
      return te.call(le, b) ? !0 : te.call(He, b) ? !1 : Ve.test(b) ? (le[b] = !0, !0) : (He[b] = !0, i("Invalid attribute name: `%s`", b), !1);
    }
    function it(b, g, y, C) {
      if (y !== null && y.type === de)
        return !1;
      switch (typeof g) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean": {
          if (y !== null)
            return !y.acceptsBooleans;
          var k = b.toLowerCase().slice(0, 5);
          return k !== "data-" && k !== "aria-";
        }
        default:
          return !1;
      }
    }
    function mt(b) {
      return at.hasOwnProperty(b) ? at[b] : null;
    }
    function qe(b, g, y, C, k, B, $) {
      this.acceptsBooleans = g === j || g === q || g === re, this.attributeName = C, this.attributeNamespace = k, this.mustUseProperty = y, this.propertyName = b, this.type = g, this.sanitizeURL = B, this.removeEmptyString = $;
    }
    var at = {}, st = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    st.forEach(function(b) {
      at[b] = new qe(
        b,
        de,
        !1,
        // mustUseProperty
        b,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(b) {
      var g = b[0], y = b[1];
      at[g] = new qe(
        g,
        H,
        !1,
        // mustUseProperty
        y,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(b) {
      at[b] = new qe(
        b,
        j,
        !1,
        // mustUseProperty
        b.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(b) {
      at[b] = new qe(
        b,
        j,
        !1,
        // mustUseProperty
        b,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(b) {
      at[b] = new qe(
        b,
        q,
        !1,
        // mustUseProperty
        b.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(b) {
      at[b] = new qe(
        b,
        q,
        !0,
        // mustUseProperty
        b,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(b) {
      at[b] = new qe(
        b,
        re,
        !1,
        // mustUseProperty
        b,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(b) {
      at[b] = new qe(
        b,
        ye,
        !1,
        // mustUseProperty
        b,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(b) {
      at[b] = new qe(
        b,
        ae,
        !1,
        // mustUseProperty
        b.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var lt = /[\-\:]([a-z])/g, rt = function(b) {
      return b[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(b) {
      var g = b.replace(lt, rt);
      at[g] = new qe(
        g,
        H,
        !1,
        // mustUseProperty
        b,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(b) {
      var g = b.replace(lt, rt);
      at[g] = new qe(
        g,
        H,
        !1,
        // mustUseProperty
        b,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(b) {
      var g = b.replace(lt, rt);
      at[g] = new qe(
        g,
        H,
        !1,
        // mustUseProperty
        b,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(b) {
      at[b] = new qe(
        b,
        H,
        !1,
        // mustUseProperty
        b.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Rt = "xlinkHref";
    at[Rt] = new qe(
      "xlinkHref",
      H,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(b) {
      at[b] = new qe(
        b,
        H,
        !1,
        // mustUseProperty
        b.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var Fr = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function an(b, g) {
      return b + g.charAt(0).toUpperCase() + g.substring(1);
    }
    var ar = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Fr).forEach(function(b) {
      ar.forEach(function(g) {
        Fr[an(g, b)] = Fr[b];
      });
    });
    var Ir = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function kt(b, g) {
      Ir[g.type] || g.onChange || g.onInput || g.readOnly || g.disabled || g.value == null || i("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), g.onChange || g.readOnly || g.disabled || g.checked == null || i("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function wt(b, g) {
      if (b.indexOf("-") === -1)
        return typeof g.is == "string";
      switch (b) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Mn = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, kr = {}, Gr = new RegExp("^(aria)-[" + Xe + "]*$"), Pr = new RegExp("^(aria)[A-Z][" + Xe + "]*$");
    function Cr(b, g) {
      {
        if (te.call(kr, g) && kr[g])
          return !0;
        if (Pr.test(g)) {
          var y = "aria-" + g.slice(4).toLowerCase(), C = Mn.hasOwnProperty(y) ? y : null;
          if (C == null)
            return i("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", g), kr[g] = !0, !0;
          if (g !== C)
            return i("Invalid ARIA attribute `%s`. Did you mean `%s`?", g, C), kr[g] = !0, !0;
        }
        if (Gr.test(g)) {
          var k = g.toLowerCase(), B = Mn.hasOwnProperty(k) ? k : null;
          if (B == null)
            return kr[g] = !0, !1;
          if (g !== B)
            return i("Unknown ARIA attribute `%s`. Did you mean `%s`?", g, B), kr[g] = !0, !0;
        }
      }
      return !0;
    }
    function qt(b, g) {
      {
        var y = [];
        for (var C in g) {
          var k = Cr(b, C);
          k || y.push(C);
        }
        var B = y.map(function($) {
          return "`" + $ + "`";
        }).join(", ");
        y.length === 1 ? i("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", B, b) : y.length > 1 && i("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", B, b);
      }
    }
    function lr(b, g) {
      wt(b, g) || qt(b, g);
    }
    var It = !1;
    function Zr(b, g) {
      {
        if (b !== "input" && b !== "textarea" && b !== "select")
          return;
        g != null && g.value === null && !It && (It = !0, b === "select" && g.multiple ? i("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", b) : i("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", b));
      }
    }
    var Cn = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Sn = function() {
    };
    {
      var vr = {}, ln = /^on./, en = /^on[^A-Z]/, Fn = new RegExp("^(aria)-[" + Xe + "]*$"), gn = new RegExp("^(aria)[A-Z][" + Xe + "]*$");
      Sn = function(b, g, y, C) {
        if (te.call(vr, g) && vr[g])
          return !0;
        var k = g.toLowerCase();
        if (k === "onfocusin" || k === "onfocusout")
          return i("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), vr[g] = !0, !0;
        if (C != null) {
          var B = C.registrationNameDependencies, $ = C.possibleRegistrationNames;
          if (B.hasOwnProperty(g))
            return !0;
          var K = $.hasOwnProperty(k) ? $[k] : null;
          if (K != null)
            return i("Invalid event handler property `%s`. Did you mean `%s`?", g, K), vr[g] = !0, !0;
          if (ln.test(g))
            return i("Unknown event handler property `%s`. It will be ignored.", g), vr[g] = !0, !0;
        } else if (ln.test(g))
          return en.test(g) && i("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", g), vr[g] = !0, !0;
        if (Fn.test(g) || gn.test(g))
          return !0;
        if (k === "innerhtml")
          return i("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), vr[g] = !0, !0;
        if (k === "aria")
          return i("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), vr[g] = !0, !0;
        if (k === "is" && y !== null && y !== void 0 && typeof y != "string")
          return i("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof y), vr[g] = !0, !0;
        if (typeof y == "number" && isNaN(y))
          return i("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", g), vr[g] = !0, !0;
        var fe = mt(g), Te = fe !== null && fe.type === de;
        if (Cn.hasOwnProperty(k)) {
          var Ue = Cn[k];
          if (Ue !== g)
            return i("Invalid DOM property `%s`. Did you mean `%s`?", g, Ue), vr[g] = !0, !0;
        } else if (!Te && g !== k)
          return i("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", g, k), vr[g] = !0, !0;
        return typeof y == "boolean" && it(g, y, fe) ? (y ? i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', y, g, g, y, g) : i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', y, g, g, y, g, g, g), vr[g] = !0, !0) : Te ? !0 : it(g, y, fe) ? (vr[g] = !0, !1) : ((y === "false" || y === "true") && fe !== null && fe.type === q && (i("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", y, g, y === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', g, y), vr[g] = !0), !0);
      };
    }
    var Gn = function(b, g, y) {
      {
        var C = [];
        for (var k in g) {
          var B = Sn(b, k, g[k], y);
          B || C.push(k);
        }
        var $ = C.map(function(K) {
          return "`" + K + "`";
        }).join(", ");
        C.length === 1 ? i("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", $, b) : C.length > 1 && i("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", $, b);
      }
    };
    function Hn(b, g, y) {
      wt(b, g) || Gn(b, g, y);
    }
    var tn = function() {
    };
    {
      var mn = /^(?:webkit|moz|o)[A-Z]/, In = /^-ms-/, vn = /-(.)/g, fr = /;\s*$/, Or = {}, sn = {}, yt = !1, yn = !1, Nn = function(b) {
        return b.replace(vn, function(g, y) {
          return y.toUpperCase();
        });
      }, Me = function(b) {
        Or.hasOwnProperty(b) && Or[b] || (Or[b] = !0, i(
          "Unsupported style property %s. Did you mean %s?",
          b,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Nn(b.replace(In, "ms-"))
        ));
      }, M = function(b) {
        Or.hasOwnProperty(b) && Or[b] || (Or[b] = !0, i("Unsupported vendor-prefixed style property %s. Did you mean %s?", b, b.charAt(0).toUpperCase() + b.slice(1)));
      }, W = function(b, g) {
        sn.hasOwnProperty(g) && sn[g] || (sn[g] = !0, i(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, b, g.replace(fr, "")));
      }, se = function(b, g) {
        yt || (yt = !0, i("`NaN` is an invalid value for the `%s` css style property.", b));
      }, we = function(b, g) {
        yn || (yn = !0, i("`Infinity` is an invalid value for the `%s` css style property.", b));
      };
      tn = function(b, g) {
        b.indexOf("-") > -1 ? Me(b) : mn.test(b) ? M(b) : fr.test(g) && W(b, g), typeof g == "number" && (isNaN(g) ? se(b, g) : isFinite(g) || we(b, g));
      };
    }
    var $e = tn, ut = /["'&<>]/;
    function Mt(b) {
      Z(b);
      var g = "" + b, y = ut.exec(g);
      if (!y)
        return g;
      var C, k = "", B, $ = 0;
      for (B = y.index; B < g.length; B++) {
        switch (g.charCodeAt(B)) {
          case 34:
            C = "&quot;";
            break;
          case 38:
            C = "&amp;";
            break;
          case 39:
            C = "&#x27;";
            break;
          case 60:
            C = "&lt;";
            break;
          case 62:
            C = "&gt;";
            break;
          default:
            continue;
        }
        $ !== B && (k += g.substring($, B)), $ = B + 1, k += C;
      }
      return $ !== B ? k + g.substring($, B) : k;
    }
    function Zt(b) {
      return typeof b == "boolean" || typeof b == "number" ? "" + b : Mt(b);
    }
    var rr = /([A-Z])/g, Br = /^ms-/;
    function sr(b) {
      return b.replace(rr, "-$1").toLowerCase().replace(Br, "-ms-");
    }
    var ue = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, ze = !1;
    function ct(b) {
      !ze && ue.test(b) && (ze = !0, i("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(b)));
    }
    var ft = Array.isArray;
    function Vt(b) {
      return ft(b);
    }
    var Ot = x("<script>"), Qt = x("<\/script>"), zt = x('<script src="'), Hr = x('<script type="module" src="'), Tr = x('" async=""><\/script>');
    function Nr(b) {
      return Z(b), ("" + b).replace(dr, vi);
    }
    var dr = /(<\/|<)(s)(cript)/gi, vi = function(b, g, y, C) {
      return "" + g + (y === "s" ? "\\u0073" : "\\u0053") + C;
    };
    function Xn(b, g, y, C, k) {
      var B = b === void 0 ? "" : b, $ = g === void 0 ? Ot : x('<script nonce="' + Zt(g) + '">'), K = [];
      if (y !== void 0 && K.push($, w(Nr(y)), Qt), C !== void 0)
        for (var fe = 0; fe < C.length; fe++)
          K.push(zt, w(Zt(C[fe])), Tr);
      if (k !== void 0)
        for (var Te = 0; Te < k.length; Te++)
          K.push(Hr, w(Zt(k[Te])), Tr);
      return {
        bootstrapChunks: K,
        startInlineScript: $,
        placeholderPrefix: x(B + "P:"),
        segmentPrefix: x(B + "S:"),
        boundaryPrefix: B + "B:",
        idPrefix: B,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var Yr = 0, Wr = 1, oi = 2, An = 3, Di = 4, ni = 5, En = 6, ii = 7;
    function Jn(b, g) {
      return {
        insertionMode: b,
        selectedValue: g
      };
    }
    function Un(b) {
      var g = b === "http://www.w3.org/2000/svg" ? oi : b === "http://www.w3.org/1998/Math/MathML" ? An : Yr;
      return Jn(g, null);
    }
    function Li(b, g, y) {
      switch (g) {
        case "select":
          return Jn(Wr, y.value != null ? y.value : y.defaultValue);
        case "svg":
          return Jn(oi, null);
        case "math":
          return Jn(An, null);
        case "foreignObject":
          return Jn(Wr, null);
        // Table parents are special in that their children can only be created at all if they're
        // wrapped in a table parent. So we need to encode that we're entering this mode.
        case "table":
          return Jn(Di, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return Jn(ni, null);
        case "colgroup":
          return Jn(ii, null);
        case "tr":
          return Jn(En, null);
      }
      return b.insertionMode >= Di || b.insertionMode === Yr ? Jn(Wr, null) : b;
    }
    var Hi = null;
    function ai(b) {
      var g = b.nextSuspenseID++;
      return x(b.boundaryPrefix + g.toString(16));
    }
    function Kn(b, g, y) {
      var C = b.idPrefix, k = ":" + C + "R" + g;
      return y > 0 && (k += "H" + y.toString(32)), k + ":";
    }
    function Vn(b) {
      return Zt(b);
    }
    var Pn = x("<!-- -->");
    function kn(b, g, y, C) {
      return g === "" ? C : (C && b.push(Pn), b.push(w(Vn(g))), !0);
    }
    function $n(b, g, y, C) {
      y && C && b.push(Pn);
    }
    var I = /* @__PURE__ */ new Map();
    function U(b) {
      var g = I.get(b);
      if (g !== void 0)
        return g;
      var y = x(Zt(sr(b)));
      return I.set(b, y), y;
    }
    var Y = x(' style="'), ne = x(":"), Ee = x(";");
    function be(b, g, y) {
      if (typeof y != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var C = !0;
      for (var k in y)
        if (te.call(y, k)) {
          var B = y[k];
          if (!(B == null || typeof B == "boolean" || B === "")) {
            var $ = void 0, K = void 0, fe = k.indexOf("--") === 0;
            fe ? ($ = w(Zt(k)), L(B, k), K = w(Zt(("" + B).trim()))) : ($e(k, B), $ = U(k), typeof B == "number" ? B !== 0 && !te.call(Fr, k) ? K = w(B + "px") : K = w("" + B) : (L(B, k), K = w(Zt(("" + B).trim())))), C ? (C = !1, b.push(Y, $, ne, K)) : b.push(Ee, $, ne, K);
          }
        }
      C || b.push(vt);
    }
    var _e = x(" "), Ye = x('="'), vt = x('"'), Et = x('=""');
    function pt(b, g, y, C) {
      switch (y) {
        case "style": {
          be(b, g, C);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        // These shouldn't be set as attributes on generic HTML elements.
        case "innerHTML":
        // Must use dangerouslySetInnerHTML instead.
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(y.length > 2 && (y[0] === "o" || y[0] === "O") && (y[1] === "n" || y[1] === "N"))
      ) {
        var k = mt(y);
        if (k !== null) {
          switch (typeof C) {
            case "function":
            // $FlowIssue symbol is perfectly valid here
            case "symbol":
              return;
            case "boolean":
              if (!k.acceptsBooleans)
                return;
          }
          var B = k.attributeName, $ = w(B);
          switch (k.type) {
            case q:
              C && b.push(_e, $, Et);
              return;
            case re:
              C === !0 ? b.push(_e, $, Et) : C === !1 || b.push(_e, $, Ye, w(Zt(C)), vt);
              return;
            case ae:
              isNaN(C) || b.push(_e, $, Ye, w(Zt(C)), vt);
              break;
            case ye:
              !isNaN(C) && C >= 1 && b.push(_e, $, Ye, w(Zt(C)), vt);
              break;
            default:
              k.sanitizeURL && (_(C, B), C = "" + C, ct(C)), b.push(_e, $, Ye, w(Zt(C)), vt);
          }
        } else if (ve(y)) {
          switch (typeof C) {
            case "function":
            // $FlowIssue symbol is perfectly valid here
            case "symbol":
              return;
            case "boolean": {
              var K = y.toLowerCase().slice(0, 5);
              if (K !== "data-" && K !== "aria-")
                return;
            }
          }
          b.push(_e, w(y), Ye, w(Zt(C)), vt);
        }
      }
    }
    var yr = x(">"), jr = x("/>");
    function Dn(b, g, y) {
      if (g != null) {
        if (y != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof g != "object" || !("__html" in g))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var C = g.__html;
        C != null && (Z(C), b.push(w("" + C)));
      }
    }
    var Wn = !1, Ri = !1, yi = !1, Zn = !1, wn = !1, Oi = !1, Ai = !1;
    function di(b, g) {
      {
        var y = b[g];
        if (y != null) {
          var C = Vt(y);
          b.multiple && !C ? i("The `%s` prop supplied to <select> must be an array if `multiple` is true.", g) : !b.multiple && C && i("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", g);
        }
      }
    }
    function ka(b, g, y) {
      kt("select", g), di(g, "value"), di(g, "defaultValue"), g.value !== void 0 && g.defaultValue !== void 0 && !yi && (i("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), yi = !0), b.push(Bt("select"));
      var C = null, k = null;
      for (var B in g)
        if (te.call(g, B)) {
          var $ = g[B];
          if ($ == null)
            continue;
          switch (B) {
            case "children":
              C = $;
              break;
            case "dangerouslySetInnerHTML":
              k = $;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              pt(b, y, B, $);
              break;
          }
        }
      return b.push(yr), Dn(b, k, C), C;
    }
    function oa(b) {
      var g = "";
      return r.Children.forEach(b, function(y) {
        y != null && (g += y, !wn && typeof y != "string" && typeof y != "number" && (wn = !0, i("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), g;
    }
    var la = x(' selected=""');
    function wi(b, g, y, C) {
      var k = C.selectedValue;
      b.push(Bt("option"));
      var B = null, $ = null, K = null, fe = null;
      for (var Te in g)
        if (te.call(g, Te)) {
          var Ue = g[Te];
          if (Ue == null)
            continue;
          switch (Te) {
            case "children":
              B = Ue;
              break;
            case "selected":
              K = Ue, Ai || (i("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Ai = !0);
              break;
            case "dangerouslySetInnerHTML":
              fe = Ue;
              break;
            // eslint-disable-next-line-no-fallthrough
            case "value":
              $ = Ue;
            // We intentionally fallthrough to also set the attribute on the node.
            // eslint-disable-next-line-no-fallthrough
            default:
              pt(b, y, Te, Ue);
              break;
          }
        }
      if (k != null) {
        var Je;
        if ($ !== null ? (_($, "value"), Je = "" + $) : (fe !== null && (Oi || (Oi = !0, i("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), Je = oa(B)), Vt(k))
          for (var ht = 0; ht < k.length; ht++) {
            _(k[ht], "value");
            var ir = "" + k[ht];
            if (ir === Je) {
              b.push(la);
              break;
            }
          }
        else
          _(k, "select.value"), "" + k === Je && b.push(la);
      } else K && b.push(la);
      return b.push(yr), Dn(b, fe, B), B;
    }
    function Zi(b, g, y) {
      kt("input", g), g.checked !== void 0 && g.defaultChecked !== void 0 && !Ri && (i("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", g.type), Ri = !0), g.value !== void 0 && g.defaultValue !== void 0 && !Wn && (i("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", g.type), Wn = !0), b.push(Bt("input"));
      var C = null, k = null, B = null, $ = null;
      for (var K in g)
        if (te.call(g, K)) {
          var fe = g[K];
          if (fe == null)
            continue;
          switch (K) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            // eslint-disable-next-line-no-fallthrough
            case "defaultChecked":
              $ = fe;
              break;
            case "defaultValue":
              k = fe;
              break;
            case "checked":
              B = fe;
              break;
            case "value":
              C = fe;
              break;
            default:
              pt(b, y, K, fe);
              break;
          }
        }
      return B !== null ? pt(b, y, "checked", B) : $ !== null && pt(b, y, "checked", $), C !== null ? pt(b, y, "value", C) : k !== null && pt(b, y, "value", k), b.push(jr), null;
    }
    function Ei(b, g, y) {
      kt("textarea", g), g.value !== void 0 && g.defaultValue !== void 0 && !Zn && (i("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Zn = !0), b.push(Bt("textarea"));
      var C = null, k = null, B = null;
      for (var $ in g)
        if (te.call(g, $)) {
          var K = g[$];
          if (K == null)
            continue;
          switch ($) {
            case "children":
              B = K;
              break;
            case "value":
              C = K;
              break;
            case "defaultValue":
              k = K;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            // eslint-disable-next-line-no-fallthrough
            default:
              pt(b, y, $, K);
              break;
          }
        }
      if (C === null && k !== null && (C = k), b.push(yr), B != null) {
        if (i("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), C != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (Vt(B)) {
          if (B.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          Z(B[0]), C = "" + B[0];
        }
        Z(B), C = "" + B;
      }
      return typeof C == "string" && C[0] === `
` && b.push(R), C !== null && (_(C, "value"), b.push(w(Vn("" + C)))), null;
    }
    function li(b, g, y, C) {
      b.push(Bt(y));
      for (var k in g)
        if (te.call(g, k)) {
          var B = g[k];
          if (B == null)
            continue;
          switch (k) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(y + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            // eslint-disable-next-line-no-fallthrough
            default:
              pt(b, C, k, B);
              break;
          }
        }
      return b.push(jr), null;
    }
    function Ui(b, g, y) {
      b.push(Bt("menuitem"));
      for (var C in g)
        if (te.call(g, C)) {
          var k = g[C];
          if (k == null)
            continue;
          switch (C) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            // eslint-disable-next-line-no-fallthrough
            default:
              pt(b, y, C, k);
              break;
          }
        }
      return b.push(yr), null;
    }
    function _r(b, g, y) {
      b.push(Bt("title"));
      var C = null;
      for (var k in g)
        if (te.call(g, k)) {
          var B = g[k];
          if (B == null)
            continue;
          switch (k) {
            case "children":
              C = B;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            // eslint-disable-next-line-no-fallthrough
            default:
              pt(b, y, k, B);
              break;
          }
        }
      b.push(yr);
      {
        var $ = Array.isArray(C) && C.length < 2 ? C[0] || null : C;
        Array.isArray(C) && C.length > 1 ? i("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : $ != null && $.$$typeof != null ? i("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : $ != null && typeof $ != "string" && typeof $ != "number" && i("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return C;
    }
    function hi(b, g, y, C) {
      b.push(Bt(y));
      var k = null, B = null;
      for (var $ in g)
        if (te.call(g, $)) {
          var K = g[$];
          if (K == null)
            continue;
          switch ($) {
            case "children":
              k = K;
              break;
            case "dangerouslySetInnerHTML":
              B = K;
              break;
            default:
              pt(b, C, $, K);
              break;
          }
        }
      return b.push(yr), Dn(b, B, k), typeof k == "string" ? (b.push(w(Vn(k))), null) : k;
    }
    function Lr(b, g, y, C) {
      b.push(Bt(y));
      var k = null, B = null;
      for (var $ in g)
        if (te.call(g, $)) {
          var K = g[$];
          if (K == null)
            continue;
          switch ($) {
            case "children":
              k = K;
              break;
            case "dangerouslySetInnerHTML":
              B = K;
              break;
            case "style":
              be(b, C, K);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              ve($) && typeof K != "function" && typeof K != "symbol" && b.push(_e, w($), Ye, w(Zt(K)), vt);
              break;
          }
        }
      return b.push(yr), Dn(b, B, k), k;
    }
    var R = x(`
`);
    function X(b, g, y, C) {
      b.push(Bt(y));
      var k = null, B = null;
      for (var $ in g)
        if (te.call(g, $)) {
          var K = g[$];
          if (K == null)
            continue;
          switch ($) {
            case "children":
              k = K;
              break;
            case "dangerouslySetInnerHTML":
              B = K;
              break;
            default:
              pt(b, C, $, K);
              break;
          }
        }
      if (b.push(yr), B != null) {
        if (k != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof B != "object" || !("__html" in B))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var fe = B.__html;
        fe != null && (typeof fe == "string" && fe.length > 0 && fe[0] === `
` ? b.push(R, w(fe)) : (Z(fe), b.push(w("" + fe))));
      }
      return typeof k == "string" && k[0] === `
` && b.push(R), k;
    }
    var pe = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Re = /* @__PURE__ */ new Map();
    function Bt(b) {
      var g = Re.get(b);
      if (g === void 0) {
        if (!pe.test(b))
          throw new Error("Invalid tag: " + b);
        g = x("<" + b), Re.set(b, g);
      }
      return g;
    }
    var Tt = x("<!DOCTYPE html>");
    function hr(b, g, y, C, k) {
      switch (lr(g, y), Zr(g, y), Hn(g, y, null), !y.suppressContentEditableWarning && y.contentEditable && y.children != null && i("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), k.insertionMode !== oi && k.insertionMode !== An && g.indexOf("-") === -1 && typeof y.is != "string" && g.toLowerCase() !== g && i("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", g), g) {
        // Special tags
        case "select":
          return ka(b, y, C);
        case "option":
          return wi(b, y, C, k);
        case "textarea":
          return Ei(b, y, C);
        case "input":
          return Zi(b, y, C);
        case "menuitem":
          return Ui(b, y, C);
        case "title":
          return _r(b, y, C);
        // Newline eating tags
        case "listing":
        case "pre":
          return X(b, y, g, C);
        // Omitted close tags
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return li(b, y, g, C);
        // These are reserved SVG and MathML elements, that are never custom elements.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return hi(b, y, g, C);
        case "html":
          return k.insertionMode === Yr && b.push(Tt), hi(b, y, g, C);
        default:
          return g.indexOf("-") === -1 && typeof y.is != "string" ? hi(b, y, g, C) : Lr(b, y, g, C);
      }
    }
    var or = x("</"), xn = x(">");
    function N(b, g, y) {
      switch (g) {
        // Omitted close tags
        // TODO: Instead of repeating this switch we could try to pass a flag from above.
        // That would require returning a tuple. Which might be ok if it gets inlined.
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          b.push(or, w(g), xn);
      }
    }
    function oe(b, g) {
      for (var y = g.bootstrapChunks, C = 0; C < y.length - 1; C++)
        h(b, y[C]);
      return C < y.length ? f(b, y[C]) : !0;
    }
    var xe = x('<template id="'), Ie = x('"></template>');
    function We(b, g, y) {
      h(b, xe), h(b, g.placeholderPrefix);
      var C = w(y.toString(16));
      return h(b, C), f(b, Ie);
    }
    var ot = x("<!--$-->"), dt = x('<!--$?--><template id="'), Nt = x('"></template>'), Yt = x("<!--$!-->"), Ur = x("<!--/$-->"), qr = x("<template"), Dr = x('"'), Ar = x(' data-dgst="'), Rn = x(' data-msg="'), Jr = x(' data-stck="'), Ya = x("></template>");
    function Xa(b, g) {
      return f(b, ot);
    }
    function Vi(b, g, y) {
      if (h(b, dt), y === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return h(b, y), f(b, Nt);
    }
    function pi(b, g, y, C, k) {
      var B;
      return B = f(b, Yt), h(b, qr), y && (h(b, Ar), h(b, w(Zt(y))), h(b, Dr)), C && (h(b, Rn), h(b, w(Zt(C))), h(b, Dr)), k && (h(b, Jr), h(b, w(Zt(k))), h(b, Dr)), B = f(b, Ya), B;
    }
    function Ta(b, g) {
      return f(b, Ur);
    }
    function Vr(b, g) {
      return f(b, Ur);
    }
    function ua(b, g) {
      return f(b, Ur);
    }
    var os = x('<div hidden id="'), ls = x('">'), Ds = x("</div>"), Eo = x('<svg aria-hidden="true" style="display:none" id="'), ga = x('">'), Zs = x("</svg>"), eo = x('<math aria-hidden="true" style="display:none" id="'), us = x('">'), Ua = x("</math>"), cs = x('<table hidden id="'), Fa = x('">'), P = x("</table>"), V = x('<table hidden><tbody id="'), Q = x('">'), ie = x("</tbody></table>"), Pe = x('<table hidden><tr id="'), ke = x('">'), Le = x("</tr></table>"), nt = x('<table hidden><colgroup id="'), Xt = x('">'), Wt = x("</colgroup></table>");
    function ur(b, g, y, C) {
      switch (y.insertionMode) {
        case Yr:
        case Wr:
          return h(b, os), h(b, g.segmentPrefix), h(b, w(C.toString(16))), f(b, ls);
        case oi:
          return h(b, Eo), h(b, g.segmentPrefix), h(b, w(C.toString(16))), f(b, ga);
        case An:
          return h(b, eo), h(b, g.segmentPrefix), h(b, w(C.toString(16))), f(b, us);
        case Di:
          return h(b, cs), h(b, g.segmentPrefix), h(b, w(C.toString(16))), f(b, Fa);
        // TODO: For the rest of these, there will be extra wrapper nodes that never
        // get deleted from the document. We need to delete the table too as part
        // of the injected scripts. They are invisible though so it's not too terrible
        // and it's kind of an edge case to suspend in a table. Totally supported though.
        case ni:
          return h(b, V), h(b, g.segmentPrefix), h(b, w(C.toString(16))), f(b, Q);
        case En:
          return h(b, Pe), h(b, g.segmentPrefix), h(b, w(C.toString(16))), f(b, ke);
        case ii:
          return h(b, nt), h(b, g.segmentPrefix), h(b, w(C.toString(16))), f(b, Xt);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function un(b, g) {
      switch (g.insertionMode) {
        case Yr:
        case Wr:
          return f(b, Ds);
        case oi:
          return f(b, Zs);
        case An:
          return f(b, Ua);
        case Di:
          return f(b, P);
        case ni:
          return f(b, ie);
        case En:
          return f(b, Le);
        case ii:
          return f(b, Wt);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var z = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", ce = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', me = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', tt = x(z + ';$RS("'), _t = x('$RS("'), nr = x('","'), On = x('")<\/script>');
    function ei(b, g, y) {
      h(b, g.startInlineScript), g.sentCompleteSegmentFunction ? h(b, _t) : (g.sentCompleteSegmentFunction = !0, h(b, tt)), h(b, g.segmentPrefix);
      var C = w(y.toString(16));
      return h(b, C), h(b, nr), h(b, g.placeholderPrefix), h(b, C), f(b, On);
    }
    var Wi = x(ce + ';$RC("'), Va = x('$RC("'), rl = x('","'), Ul = x('")<\/script>');
    function $a(b, g, y, C) {
      if (h(b, g.startInlineScript), g.sentCompleteBoundaryFunction ? h(b, Va) : (g.sentCompleteBoundaryFunction = !0, h(b, Wi)), y === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var k = w(C.toString(16));
      return h(b, y), h(b, rl), h(b, g.segmentPrefix), h(b, k), f(b, Ul);
    }
    var Ia = x(me + ';$RX("'), Rs = x('$RX("'), uh = x('"'), ch = x(")<\/script>"), Bi = x(",");
    function Ja(b, g, y, C, k, B) {
      if (h(b, g.startInlineScript), g.sentClientRenderFunction ? h(b, Rs) : (g.sentClientRenderFunction = !0, h(b, Ia)), y === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return h(b, y), h(b, uh), (C || k || B) && (h(b, Bi), h(b, w(Du(C || "")))), (k || B) && (h(b, Bi), h(b, w(Du(k || "")))), B && (h(b, Bi), h(b, w(Du(B)))), f(b, ch);
    }
    var Vc = /[<\u2028\u2029]/g;
    function Du(b) {
      var g = JSON.stringify(b);
      return g.replace(Vc, function(y) {
        switch (y) {
          // santizing breaking out of strings and script tags
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    var Pa = Object.assign, jf = /* @__PURE__ */ Symbol.for("react.element"), Ru = /* @__PURE__ */ Symbol.for("react.portal"), Ou = /* @__PURE__ */ Symbol.for("react.fragment"), Os = /* @__PURE__ */ Symbol.for("react.strict_mode"), Ae = /* @__PURE__ */ Symbol.for("react.profiler"), Ne = /* @__PURE__ */ Symbol.for("react.provider"), De = /* @__PURE__ */ Symbol.for("react.context"), xt = /* @__PURE__ */ Symbol.for("react.forward_ref"), pr = /* @__PURE__ */ Symbol.for("react.suspense"), cn = /* @__PURE__ */ Symbol.for("react.suspense_list"), xi = /* @__PURE__ */ Symbol.for("react.memo"), Tn = /* @__PURE__ */ Symbol.for("react.lazy"), Bu = /* @__PURE__ */ Symbol.for("react.scope"), fh = /* @__PURE__ */ Symbol.for("react.debug_trace_mode"), za = /* @__PURE__ */ Symbol.for("react.legacy_hidden"), _u = /* @__PURE__ */ Symbol.for("react.default_value"), $c = Symbol.iterator, Bn = "@@iterator";
    function to(b) {
      if (b === null || typeof b != "object")
        return null;
      var g = $c && b[$c] || b[Bn];
      return typeof g == "function" ? g : null;
    }
    function Vl(b, g, y) {
      var C = b.displayName;
      if (C)
        return C;
      var k = g.displayName || g.name || "";
      return k !== "" ? y + "(" + k + ")" : y;
    }
    function pn(b) {
      return b.displayName || "Context";
    }
    function ti(b) {
      if (b == null)
        return null;
      if (typeof b.tag == "number" && i("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof b == "function")
        return b.displayName || b.name || null;
      if (typeof b == "string")
        return b;
      switch (b) {
        case Ou:
          return "Fragment";
        case Ru:
          return "Portal";
        case Ae:
          return "Profiler";
        case Os:
          return "StrictMode";
        case pr:
          return "Suspense";
        case cn:
          return "SuspenseList";
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case De:
            var g = b;
            return pn(g) + ".Consumer";
          case Ne:
            var y = b;
            return pn(y._context) + ".Provider";
          case xt:
            return Vl(b, b.render, "ForwardRef");
          case xi:
            var C = b.displayName || null;
            return C !== null ? C : ti(b.type) || "Memo";
          case Tn: {
            var k = b, B = k._payload, $ = k._init;
            try {
              return ti($(B));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ko = 0, nl, zc, Gc, Hc, $l, Bs, To;
    function zl() {
    }
    zl.__reactDisabledLog = !0;
    function ro() {
      {
        if (ko === 0) {
          nl = console.log, zc = console.info, Gc = console.warn, Hc = console.error, $l = console.group, Bs = console.groupCollapsed, To = console.groupEnd;
          var b = {
            configurable: !0,
            enumerable: !0,
            value: zl,
            writable: !0
          };
          Object.defineProperties(console, {
            info: b,
            log: b,
            warn: b,
            error: b,
            group: b,
            groupCollapsed: b,
            groupEnd: b
          });
        }
        ko++;
      }
    }
    function Mu() {
      {
        if (ko--, ko === 0) {
          var b = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Pa({}, b, {
              value: nl
            }),
            info: Pa({}, b, {
              value: zc
            }),
            warn: Pa({}, b, {
              value: Gc
            }),
            error: Pa({}, b, {
              value: Hc
            }),
            group: Pa({}, b, {
              value: $l
            }),
            groupCollapsed: Pa({}, b, {
              value: Bs
            }),
            groupEnd: Pa({}, b, {
              value: To
            })
          });
        }
        ko < 0 && i("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fo = t.ReactCurrentDispatcher, il;
    function no(b, g, y) {
      {
        if (il === void 0)
          try {
            throw Error();
          } catch (k) {
            var C = k.stack.trim().match(/\n( *(at )?)/);
            il = C && C[1] || "";
          }
        return `
` + il + b;
      }
    }
    var Io = !1, Ka;
    {
      var Nu = typeof WeakMap == "function" ? WeakMap : Map;
      Ka = new Nu();
    }
    function Gl(b, g) {
      if (!b || Io)
        return "";
      {
        var y = Ka.get(b);
        if (y !== void 0)
          return y;
      }
      var C;
      Io = !0;
      var k = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var B;
      B = Fo.current, Fo.current = null, ro();
      try {
        if (g) {
          var $ = function() {
            throw Error();
          };
          if (Object.defineProperty($.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct($, []);
            } catch (rn) {
              C = rn;
            }
            Reflect.construct(b, [], $);
          } else {
            try {
              $.call();
            } catch (rn) {
              C = rn;
            }
            b.call($.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (rn) {
            C = rn;
          }
          b();
        }
      } catch (rn) {
        if (rn && C && typeof rn.stack == "string") {
          for (var K = rn.stack.split(`
`), fe = C.stack.split(`
`), Te = K.length - 1, Ue = fe.length - 1; Te >= 1 && Ue >= 0 && K[Te] !== fe[Ue]; )
            Ue--;
          for (; Te >= 1 && Ue >= 0; Te--, Ue--)
            if (K[Te] !== fe[Ue]) {
              if (Te !== 1 || Ue !== 1)
                do
                  if (Te--, Ue--, Ue < 0 || K[Te] !== fe[Ue]) {
                    var Je = `
` + K[Te].replace(" at new ", " at ");
                    return b.displayName && Je.includes("<anonymous>") && (Je = Je.replace("<anonymous>", b.displayName)), typeof b == "function" && Ka.set(b, Je), Je;
                  }
                while (Te >= 1 && Ue >= 0);
              break;
            }
        }
      } finally {
        Io = !1, Fo.current = B, Mu(), Error.prepareStackTrace = k;
      }
      var ht = b ? b.displayName || b.name : "", ir = ht ? no(ht) : "";
      return typeof b == "function" && Ka.set(b, ir), ir;
    }
    function qf(b, g, y) {
      return Gl(b, !0);
    }
    function Wc(b, g, y) {
      return Gl(b, !1);
    }
    function Po(b) {
      var g = b.prototype;
      return !!(g && g.isReactComponent);
    }
    function Do(b, g, y) {
      if (b == null)
        return "";
      if (typeof b == "function")
        return Gl(b, Po(b));
      if (typeof b == "string")
        return no(b);
      switch (b) {
        case pr:
          return no("Suspense");
        case cn:
          return no("SuspenseList");
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case xt:
            return Wc(b.render);
          case xi:
            return Do(b.type, g, y);
          case Tn: {
            var C = b, k = C._payload, B = C._init;
            try {
              return Do(B(k), g, y);
            } catch {
            }
          }
        }
      return "";
    }
    var al = {}, Hl = t.ReactDebugCurrentFrame;
    function sl(b) {
      if (b) {
        var g = b._owner, y = Do(b.type, b._source, g ? g.type : null);
        Hl.setExtraStackFrame(y);
      } else
        Hl.setExtraStackFrame(null);
    }
    function Qf(b, g, y, C, k) {
      {
        var B = Function.call.bind(te);
        for (var $ in b)
          if (B(b, $)) {
            var K = void 0;
            try {
              if (typeof b[$] != "function") {
                var fe = Error((C || "React class") + ": " + y + " type `" + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof b[$] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw fe.name = "Invariant Violation", fe;
              }
              K = b[$](g, $, C, y, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Te) {
              K = Te;
            }
            K && !(K instanceof Error) && (sl(k), i("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", C || "React class", y, $, typeof K), sl(null)), K instanceof Error && !(K.message in al) && (al[K.message] = !0, sl(k), i("Failed %s type: %s", y, K.message), sl(null));
          }
      }
    }
    var Ro;
    Ro = {};
    var gi = {};
    Object.freeze(gi);
    function ui(b, g) {
      {
        var y = b.contextTypes;
        if (!y)
          return gi;
        var C = {};
        for (var k in y)
          C[k] = g[k];
        {
          var B = ti(b) || "Unknown";
          Qf(y, C, "context", B);
        }
        return C;
      }
    }
    function jc(b, g, y, C) {
      {
        if (typeof b.getChildContext != "function") {
          {
            var k = ti(g) || "Unknown";
            Ro[k] || (Ro[k] = !0, i("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", k, k));
          }
          return y;
        }
        var B = b.getChildContext();
        for (var $ in B)
          if (!($ in C))
            throw new Error((ti(g) || "Unknown") + '.getChildContext(): key "' + $ + '" is not defined in childContextTypes.');
        {
          var K = ti(g) || "Unknown";
          Qf(C, B, "child context", K);
        }
        return Pa({}, y, B);
      }
    }
    var Oo;
    Oo = {};
    var Wl = null, io = null;
    function ol(b) {
      b.context._currentValue = b.parentValue;
    }
    function ao(b) {
      b.context._currentValue = b.value;
    }
    function Bo(b, g) {
      if (b !== g) {
        ol(b);
        var y = b.parent, C = g.parent;
        if (y === null) {
          if (C !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (C === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          Bo(y, C);
        }
        ao(g);
      }
    }
    function fs(b) {
      ol(b);
      var g = b.parent;
      g !== null && fs(g);
    }
    function ll(b) {
      var g = b.parent;
      g !== null && ll(g), ao(b);
    }
    function ul(b, g) {
      ol(b);
      var y = b.parent;
      if (y === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      y.depth === g.depth ? Bo(y, g) : ul(y, g);
    }
    function jl(b, g) {
      var y = g.parent;
      if (y === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      b.depth === y.depth ? Bo(b, y) : jl(b, y), ao(g);
    }
    function Da(b) {
      var g = io, y = b;
      g !== y && (g === null ? ll(y) : y === null ? fs(g) : g.depth === y.depth ? Bo(g, y) : g.depth > y.depth ? ul(g, y) : jl(g, y), io = y);
    }
    function qc(b, g) {
      var y;
      y = b._currentValue, b._currentValue = g, b._currentRenderer !== void 0 && b._currentRenderer !== null && b._currentRenderer !== Oo && i("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), b._currentRenderer = Oo;
      var C = io, k = {
        parent: C,
        depth: C === null ? 0 : C.depth + 1,
        context: b,
        parentValue: y,
        value: g
      };
      return io = k, k;
    }
    function dh(b) {
      var g = io;
      if (g === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      g.context !== b && i("The parent context is not the expected context. This is probably a bug in React.");
      {
        var y = g.parentValue;
        y === _u ? g.context._currentValue = g.context._defaultValue : g.context._currentValue = y, b._currentRenderer !== void 0 && b._currentRenderer !== null && b._currentRenderer !== Oo && i("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), b._currentRenderer = Oo;
      }
      return io = g.parent;
    }
    function Yf() {
      return io;
    }
    function cl(b) {
      var g = b._currentValue;
      return g;
    }
    function ql(b) {
      return b._reactInternals;
    }
    function fl(b, g) {
      b._reactInternals = g;
    }
    var so = {}, Ql = {}, J, Za, oo, ea, $r, Yl, Lu, Uu, _s;
    {
      J = /* @__PURE__ */ new Set(), Za = /* @__PURE__ */ new Set(), oo = /* @__PURE__ */ new Set(), Lu = /* @__PURE__ */ new Set(), ea = /* @__PURE__ */ new Set(), Uu = /* @__PURE__ */ new Set(), _s = /* @__PURE__ */ new Set();
      var Xf = /* @__PURE__ */ new Set();
      Yl = function(b, g) {
        if (!(b === null || typeof b == "function")) {
          var y = g + "_" + b;
          Xf.has(y) || (Xf.add(y), i("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", g, b));
        }
      }, $r = function(b, g) {
        if (g === void 0) {
          var y = ti(b) || "Component";
          ea.has(y) || (ea.add(y), i("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", y));
        }
      };
    }
    function Jf(b, g) {
      {
        var y = b.constructor, C = y && ti(y) || "ReactClass", k = C + "." + g;
        if (so[k])
          return;
        i(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, g, g, C), so[k] = !0;
      }
    }
    var Kf = {
      isMounted: function(b) {
        return !1;
      },
      enqueueSetState: function(b, g, y) {
        var C = ql(b);
        C.queue === null ? Jf(b, "setState") : (C.queue.push(g), y != null && Yl(y, "setState"));
      },
      enqueueReplaceState: function(b, g, y) {
        var C = ql(b);
        C.replace = !0, C.queue = [g], y != null && Yl(y, "setState");
      },
      enqueueForceUpdate: function(b, g) {
        var y = ql(b);
        y.queue === null ? Jf(b, "forceUpdate") : g != null && Yl(g, "setState");
      }
    };
    function hh(b, g, y, C, k) {
      var B = y(k, C);
      $r(g, B);
      var $ = B == null ? C : Pa({}, C, B);
      return $;
    }
    function Zf(b, g, y) {
      var C = gi, k = b.contextType;
      if ("contextType" in b) {
        var B = (
          // Allow null for conditional declaration
          k === null || k !== void 0 && k.$$typeof === De && k._context === void 0
        );
        if (!B && !_s.has(b)) {
          _s.add(b);
          var $ = "";
          k === void 0 ? $ = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof k != "object" ? $ = " However, it is set to a " + typeof k + "." : k.$$typeof === Ne ? $ = " Did you accidentally pass the Context.Provider instead?" : k._context !== void 0 ? $ = " Did you accidentally pass the Context.Consumer instead?" : $ = " However, it is set to an object with keys {" + Object.keys(k).join(", ") + "}.", i("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", ti(b) || "Component", $);
        }
      }
      typeof k == "object" && k !== null ? C = cl(k) : C = y;
      var K = new b(g, C);
      {
        if (typeof b.getDerivedStateFromProps == "function" && (K.state === null || K.state === void 0)) {
          var fe = ti(b) || "Component";
          J.has(fe) || (J.add(fe), i("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", fe, K.state === null ? "null" : "undefined", fe));
        }
        if (typeof b.getDerivedStateFromProps == "function" || typeof K.getSnapshotBeforeUpdate == "function") {
          var Te = null, Ue = null, Je = null;
          if (typeof K.componentWillMount == "function" && K.componentWillMount.__suppressDeprecationWarning !== !0 ? Te = "componentWillMount" : typeof K.UNSAFE_componentWillMount == "function" && (Te = "UNSAFE_componentWillMount"), typeof K.componentWillReceiveProps == "function" && K.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Ue = "componentWillReceiveProps" : typeof K.UNSAFE_componentWillReceiveProps == "function" && (Ue = "UNSAFE_componentWillReceiveProps"), typeof K.componentWillUpdate == "function" && K.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Je = "componentWillUpdate" : typeof K.UNSAFE_componentWillUpdate == "function" && (Je = "UNSAFE_componentWillUpdate"), Te !== null || Ue !== null || Je !== null) {
            var ht = ti(b) || "Component", ir = typeof b.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            oo.has(ht) || (oo.add(ht), i(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, ht, ir, Te !== null ? `
  ` + Te : "", Ue !== null ? `
  ` + Ue : "", Je !== null ? `
  ` + Je : ""));
          }
        }
      }
      return K;
    }
    function Ms(b, g, y) {
      {
        var C = ti(g) || "Component", k = b.render;
        k || (g.prototype && typeof g.prototype.render == "function" ? i("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", C) : i("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", C)), b.getInitialState && !b.getInitialState.isReactClassApproved && !b.state && i("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", C), b.getDefaultProps && !b.getDefaultProps.isReactClassApproved && i("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", C), b.propTypes && i("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", C), b.contextType && i("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", C), b.contextTypes && i("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", C), g.contextType && g.contextTypes && !Uu.has(g) && (Uu.add(g), i("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", C)), typeof b.componentShouldUpdate == "function" && i("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", C), g.prototype && g.prototype.isPureReactComponent && typeof b.shouldComponentUpdate < "u" && i("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", ti(g) || "A pure component"), typeof b.componentDidUnmount == "function" && i("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", C), typeof b.componentDidReceiveProps == "function" && i("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", C), typeof b.componentWillRecieveProps == "function" && i("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", C), typeof b.UNSAFE_componentWillRecieveProps == "function" && i("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", C);
        var B = b.props !== y;
        b.props !== void 0 && B && i("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", C, C), b.defaultProps && i("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", C, C), typeof b.getSnapshotBeforeUpdate == "function" && typeof b.componentDidUpdate != "function" && !Za.has(g) && (Za.add(g), i("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", ti(g))), typeof b.getDerivedStateFromProps == "function" && i("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", C), typeof b.getDerivedStateFromError == "function" && i("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", C), typeof g.getSnapshotBeforeUpdate == "function" && i("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", C);
        var $ = b.state;
        $ && (typeof $ != "object" || Vt($)) && i("%s.state: must be set to an object or null", C), typeof b.getChildContext == "function" && typeof g.childContextTypes != "object" && i("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", C);
      }
    }
    function ph(b, g) {
      var y = g.state;
      if (typeof g.componentWillMount == "function") {
        if (g.componentWillMount.__suppressDeprecationWarning !== !0) {
          var C = ti(b) || "Unknown";
          Ql[C] || (n(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            C
          ), Ql[C] = !0);
        }
        g.componentWillMount();
      }
      typeof g.UNSAFE_componentWillMount == "function" && g.UNSAFE_componentWillMount(), y !== g.state && (i("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", ti(b) || "Component"), Kf.enqueueReplaceState(g, g.state, null));
    }
    function Qc(b, g, y, C) {
      if (b.queue !== null && b.queue.length > 0) {
        var k = b.queue, B = b.replace;
        if (b.queue = null, b.replace = !1, B && k.length === 1)
          g.state = k[0];
        else {
          for (var $ = B ? k[0] : g.state, K = !0, fe = B ? 1 : 0; fe < k.length; fe++) {
            var Te = k[fe], Ue = typeof Te == "function" ? Te.call(g, $, y, C) : Te;
            Ue != null && (K ? (K = !1, $ = Pa({}, $, Ue)) : Pa($, Ue));
          }
          g.state = $;
        }
      } else
        b.queue = null;
    }
    function Xl(b, g, y, C) {
      Ms(b, g, y);
      var k = b.state !== void 0 ? b.state : null;
      b.updater = Kf, b.props = y, b.state = k;
      var B = {
        queue: [],
        replace: !1
      };
      fl(b, B);
      var $ = g.contextType;
      if (typeof $ == "object" && $ !== null ? b.context = cl($) : b.context = C, b.state === y) {
        var K = ti(g) || "Component";
        Lu.has(K) || (Lu.add(K), i("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", K));
      }
      var fe = g.getDerivedStateFromProps;
      typeof fe == "function" && (b.state = hh(b, g, fe, k, y)), typeof g.getDerivedStateFromProps != "function" && typeof b.getSnapshotBeforeUpdate != "function" && (typeof b.UNSAFE_componentWillMount == "function" || typeof b.componentWillMount == "function") && (ph(g, b), Qc(B, b, y, C));
    }
    var gh = {
      id: 1,
      overflow: ""
    };
    function mh(b) {
      var g = b.overflow, y = b.id, C = y & ~vh(y);
      return C.toString(32) + g;
    }
    function es(b, g, y) {
      var C = b.id, k = b.overflow, B = Vu(C) - 1, $ = C & ~(1 << B), K = y + 1, fe = Vu(g) + B;
      if (fe > 30) {
        var Te = B - B % 5, Ue = (1 << Te) - 1, Je = ($ & Ue).toString(32), ht = $ >> Te, ir = B - Te, rn = Vu(g) + ir, qi = K << ir, go = qi | ht, ws = Je + k;
        return {
          id: 1 << rn | go,
          overflow: ws
        };
      } else {
        var xs = K << B, mo = xs | $, Ph = k;
        return {
          id: 1 << fe | mo,
          overflow: Ph
        };
      }
    }
    function Vu(b) {
      return 32 - yh(b);
    }
    function vh(b) {
      return 1 << Vu(b) - 1;
    }
    var yh = Math.clz32 ? Math.clz32 : Ls, Ah = Math.log, Ns = Math.LN2;
    function Ls(b) {
      var g = b >>> 0;
      return g === 0 ? 32 : 31 - (Ah(g) / Ns | 0) | 0;
    }
    function $u(b, g) {
      return b === g && (b !== 0 || 1 / b === 1 / g) || b !== b && g !== g;
    }
    var jn = typeof Object.is == "function" ? Object.is : $u, ci = null, dl = null, _o = null, fn = null, lo = !1, zu = !1, ma = 0, va = null, ds = 0, wh = 25, Ra = !1, Ga;
    function hs() {
      if (ci === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return Ra && i("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), ci;
    }
    function xh(b, g) {
      if (g === null)
        return i("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Ga), !1;
      b.length !== g.length && i(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Ga, "[" + b.join(", ") + "]", "[" + g.join(", ") + "]");
      for (var y = 0; y < g.length && y < b.length; y++)
        if (!jn(b[y], g[y]))
          return !1;
      return !0;
    }
    function Gu() {
      if (ds > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function Jl() {
      return fn === null ? _o === null ? (lo = !1, _o = fn = Gu()) : (lo = !0, fn = _o) : fn.next === null ? (lo = !1, fn = fn.next = Gu()) : (lo = !0, fn = fn.next), fn;
    }
    function ps(b, g) {
      ci = g, dl = b, Ra = !1, ma = 0;
    }
    function Yc(b, g, y, C) {
      for (; zu; )
        zu = !1, ma = 0, ds += 1, fn = null, y = b(g, C);
      return ya(), y;
    }
    function gs() {
      var b = ma !== 0;
      return b;
    }
    function ya() {
      Ra = !1, ci = null, dl = null, zu = !1, _o = null, ds = 0, va = null, fn = null;
    }
    function ed(b) {
      return Ra && i("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), cl(b);
    }
    function Xc(b) {
      return Ga = "useContext", hs(), cl(b);
    }
    function Hu(b, g) {
      return typeof g == "function" ? g(b) : g;
    }
    function Kl(b) {
      return Ga = "useState", Us(
        Hu,
        // useReducer has a special case to support lazy useState initializers
        b
      );
    }
    function Us(b, g, y) {
      if (b !== Hu && (Ga = "useReducer"), ci = hs(), fn = Jl(), lo) {
        var C = fn.queue, k = C.dispatch;
        if (va !== null) {
          var B = va.get(C);
          if (B !== void 0) {
            va.delete(C);
            var $ = fn.memoizedState, K = B;
            do {
              var fe = K.action;
              Ra = !0, $ = b($, fe), Ra = !1, K = K.next;
            } while (K !== null);
            return fn.memoizedState = $, [$, k];
          }
        }
        return [fn.memoizedState, k];
      } else {
        Ra = !0;
        var Te;
        b === Hu ? Te = typeof g == "function" ? g() : g : Te = y !== void 0 ? y(g) : g, Ra = !1, fn.memoizedState = Te;
        var Ue = fn.queue = {
          last: null,
          dispatch: null
        }, Je = Ue.dispatch = Ch.bind(null, ci, Ue);
        return [fn.memoizedState, Je];
      }
    }
    function Jc(b, g) {
      ci = hs(), fn = Jl();
      var y = g === void 0 ? null : g;
      if (fn !== null) {
        var C = fn.memoizedState;
        if (C !== null && y !== null) {
          var k = C[1];
          if (xh(y, k))
            return C[0];
        }
      }
      Ra = !0;
      var B = b();
      return Ra = !1, fn.memoizedState = [B, y], B;
    }
    function bh(b) {
      ci = hs(), fn = Jl();
      var g = fn.memoizedState;
      if (g === null) {
        var y = {
          current: b
        };
        return Object.seal(y), fn.memoizedState = y, y;
      } else
        return g;
    }
    function Wu(b, g) {
      Ga = "useLayoutEffect", i("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function Ch(b, g, y) {
      if (ds >= wh)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (b === ci) {
        zu = !0;
        var C = {
          action: y,
          next: null
        };
        va === null && (va = /* @__PURE__ */ new Map());
        var k = va.get(g);
        if (k === void 0)
          va.set(g, C);
        else {
          for (var B = k; B.next !== null; )
            B = B.next;
          B.next = C;
        }
      }
    }
    function td(b, g) {
      return Jc(function() {
        return b;
      }, g);
    }
    function ji(b, g, y) {
      return hs(), g(b._source);
    }
    function Kc(b, g, y) {
      if (y === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return y();
    }
    function Zl(b) {
      return hs(), b;
    }
    function ts() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function eu() {
      return hs(), [!1, ts];
    }
    function tu() {
      var b = dl, g = mh(b.treeContext), y = _i;
      if (y === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var C = ma++;
      return Kn(y, g, C);
    }
    function ms() {
    }
    var ru = {
      readContext: ed,
      useContext: Xc,
      useMemo: Jc,
      useReducer: Us,
      useRef: bh,
      useState: Kl,
      useInsertionEffect: ms,
      useLayoutEffect: Wu,
      useCallback: td,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: ms,
      // Effects are not run in the server environment.
      useEffect: ms,
      // Debugging effect
      useDebugValue: ms,
      useDeferredValue: Zl,
      useTransition: eu,
      useId: tu,
      // Subscriptions are not setup in a server environment.
      useMutableSource: ji,
      useSyncExternalStore: Kc
    }, _i = null;
    function hl(b) {
      _i = b;
    }
    function pl(b) {
      try {
        var g = "", y = b;
        do {
          switch (y.tag) {
            case 0:
              g += no(y.type, null, null);
              break;
            case 1:
              g += Wc(y.type, null, null);
              break;
            case 2:
              g += qf(y.type, null, null);
              break;
          }
          y = y.parent;
        } while (y);
        return g;
      } catch (C) {
        return `
Error generating stack: ` + C.message + `
` + C.stack;
      }
    }
    var ju = t.ReactCurrentDispatcher, qu = t.ReactDebugCurrentFrame, gl = 0, ml = 1, Mo = 2, uo = 3, rd = 4, Sh = 0, vs = 1, vl = 2, Eh = 12800;
    function Zc(b) {
      return console.error(b), null;
    }
    function co() {
    }
    function Qu(b, g, y, C, k, B, $, K, fe) {
      var Te = [], Ue = /* @__PURE__ */ new Set(), Je = {
        destination: null,
        responseState: g,
        progressiveChunkSize: C === void 0 ? Eh : C,
        status: Sh,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: Ue,
        pingedTasks: Te,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: k === void 0 ? Zc : k,
        onAllReady: B === void 0 ? co : B,
        onShellReady: $ === void 0 ? co : $,
        onShellError: K === void 0 ? co : K,
        onFatalError: fe === void 0 ? co : fe
      }, ht = No(
        Je,
        0,
        null,
        y,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      ht.parentFlushed = !0;
      var ir = fo(Je, b, null, ht, Ue, gi, Wl, gh);
      return Te.push(ir), Je;
    }
    function Vs(b, g) {
      var y = b.pingedTasks;
      y.push(g), y.length === 1 && s(function() {
        return ff(b);
      });
    }
    function ef(b, g) {
      return {
        id: Hi,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: g,
        errorDigest: null
      };
    }
    function fo(b, g, y, C, k, B, $, K) {
      b.allPendingTasks++, y === null ? b.pendingRootTasks++ : y.pendingTasks++;
      var fe = {
        node: g,
        ping: function() {
          return Vs(b, fe);
        },
        blockedBoundary: y,
        blockedSegment: C,
        abortSet: k,
        legacyContext: B,
        context: $,
        treeContext: K
      };
      return fe.componentStack = null, k.add(fe), fe;
    }
    function No(b, g, y, C, k, B) {
      return {
        status: gl,
        id: -1,
        // lazily assigned later
        index: g,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: C,
        boundary: y,
        lastPushedText: k,
        textEmbedded: B
      };
    }
    var $s = null;
    function Ha() {
      return $s === null || $s.componentStack === null ? "" : pl($s.componentStack);
    }
    function ys(b, g) {
      b.componentStack = {
        tag: 0,
        parent: b.componentStack,
        type: g
      };
    }
    function nu(b, g) {
      b.componentStack = {
        tag: 1,
        parent: b.componentStack,
        type: g
      };
    }
    function yl(b, g) {
      b.componentStack = {
        tag: 2,
        parent: b.componentStack,
        type: g
      };
    }
    function Aa(b) {
      b.componentStack === null ? i("Unexpectedly popped too many stack frames. This is a bug in React.") : b.componentStack = b.componentStack.parent;
    }
    var iu = null;
    function Yu(b, g) {
      {
        var y;
        typeof g == "string" ? y = g : g && typeof g.message == "string" ? y = g.message : y = String(g);
        var C = iu || Ha();
        iu = null, b.errorMessage = y, b.errorComponentStack = C;
      }
    }
    function Al(b, g) {
      var y = b.onError(g);
      if (y != null && typeof y != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof y + '" instead');
      return y;
    }
    function au(b, g) {
      var y = b.onShellError;
      y(g);
      var C = b.onFatalError;
      C(g), b.destination !== null ? (b.status = vl, E(b.destination, g)) : (b.status = vs, b.fatalError = g);
    }
    function tf(b, g, y) {
      ys(g, "Suspense");
      var C = g.blockedBoundary, k = g.blockedSegment, B = y.fallback, $ = y.children, K = /* @__PURE__ */ new Set(), fe = ef(b, K), Te = k.chunks.length, Ue = No(
        b,
        Te,
        fe,
        k.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      k.children.push(Ue), k.lastPushedText = !1;
      var Je = No(
        b,
        0,
        null,
        k.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      Je.parentFlushed = !0, g.blockedBoundary = fe, g.blockedSegment = Je;
      try {
        if (ho(b, g, $), $n(Je.chunks, b.responseState, Je.lastPushedText, Je.textEmbedded), Je.status = ml, po(fe, Je), fe.pendingTasks === 0) {
          Aa(g);
          return;
        }
      } catch (ir) {
        Je.status = rd, fe.forceClientRender = !0, fe.errorDigest = Al(b, ir), Yu(fe, ir);
      } finally {
        g.blockedBoundary = C, g.blockedSegment = k;
      }
      var ht = fo(b, B, C, Ue, K, g.legacyContext, g.context, g.treeContext);
      ht.componentStack = g.componentStack, b.pingedTasks.push(ht), Aa(g);
    }
    function kh(b, g, y, C) {
      ys(g, y);
      var k = g.blockedSegment, B = hr(k.chunks, y, C, b.responseState, k.formatContext);
      k.lastPushedText = !1;
      var $ = k.formatContext;
      k.formatContext = Li($, y, C), ho(b, g, B), k.formatContext = $, N(k.chunks, y), k.lastPushedText = !1, Aa(g);
    }
    function Xu(b) {
      return b.prototype && b.prototype.isReactComponent;
    }
    function wl(b, g, y, C, k) {
      var B = {};
      ps(g, B);
      var $ = y(C, k);
      return Yc(y, C, $, k);
    }
    function su(b, g, y, C, k) {
      var B = y.render();
      y.props !== k && (Lo || i("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", ti(C) || "a component"), Lo = !0);
      {
        var $ = C.childContextTypes;
        if ($ != null) {
          var K = g.legacyContext, fe = jc(y, C, K, $);
          g.legacyContext = fe, ta(b, g, B), g.legacyContext = K;
          return;
        }
      }
      ta(b, g, B);
    }
    function nd(b, g, y, C) {
      yl(g, y);
      var k = ui(y, g.legacyContext), B = Zf(y, C, k);
      Xl(B, y, C, k), su(b, g, B, y, C), Aa(g);
    }
    var ou = {}, Sr = {}, rf = {}, nf = {}, Lo = !1, af = {}, id = !1, sf = !1, Oa = !1;
    function Th(b, g, y, C) {
      var k;
      if (k = ui(y, g.legacyContext), nu(g, y), y.prototype && typeof y.prototype.render == "function") {
        var B = ti(y) || "Unknown";
        ou[B] || (i("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", B, B), ou[B] = !0);
      }
      var $ = wl(b, g, y, C, k), K = gs();
      if (typeof $ == "object" && $ !== null && typeof $.render == "function" && $.$$typeof === void 0) {
        var fe = ti(y) || "Unknown";
        Sr[fe] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", fe, fe, fe), Sr[fe] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof $ == "object" && $ !== null && typeof $.render == "function" && $.$$typeof === void 0
      ) {
        {
          var Te = ti(y) || "Unknown";
          Sr[Te] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Te, Te, Te), Sr[Te] = !0);
        }
        Xl($, y, C, k), su(b, g, $, y, C);
      } else if (Ju(y), K) {
        var Ue = g.treeContext, Je = 1, ht = 0;
        g.treeContext = es(Ue, Je, ht);
        try {
          ta(b, g, $);
        } finally {
          g.treeContext = Ue;
        }
      } else
        ta(b, g, $);
      Aa(g);
    }
    function Ju(b) {
      {
        if (b && b.childContextTypes && i("%s(...): childContextTypes cannot be defined on a function component.", b.displayName || b.name || "Component"), b.defaultProps !== void 0) {
          var g = ti(b) || "Unknown";
          af[g] || (i("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", g), af[g] = !0);
        }
        if (typeof b.getDerivedStateFromProps == "function") {
          var y = ti(b) || "Unknown";
          nf[y] || (i("%s: Function components do not support getDerivedStateFromProps.", y), nf[y] = !0);
        }
        if (typeof b.contextType == "object" && b.contextType !== null) {
          var C = ti(b) || "Unknown";
          rf[C] || (i("%s: Function components do not support contextType.", C), rf[C] = !0);
        }
      }
    }
    function Ku(b, g) {
      if (b && b.defaultProps) {
        var y = Pa({}, g), C = b.defaultProps;
        for (var k in C)
          y[k] === void 0 && (y[k] = C[k]);
        return y;
      }
      return g;
    }
    function ad(b, g, y, C, k) {
      nu(g, y.render);
      var B = wl(b, g, y.render, C, k), $ = gs();
      if ($) {
        var K = g.treeContext, fe = 1, Te = 0;
        g.treeContext = es(K, fe, Te);
        try {
          ta(b, g, B);
        } finally {
          g.treeContext = K;
        }
      } else
        ta(b, g, B);
      Aa(g);
    }
    function Zu(b, g, y, C, k) {
      var B = y.type, $ = Ku(B, C);
      lu(b, g, B, $, k);
    }
    function Ba(b, g, y, C) {
      y._context === void 0 ? y !== y.Consumer && (Oa || (Oa = !0, i("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : y = y._context;
      var k = C.children;
      typeof k != "function" && i("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var B = cl(y), $ = k(B);
      ta(b, g, $);
    }
    function ki(b, g, y, C) {
      var k = y._context, B = C.value, $ = C.children, K;
      K = g.context, g.context = qc(k, B), ta(b, g, $), g.context = dh(k), K !== g.context && i("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function of(b, g, y, C, k) {
      ys(g, "Lazy");
      var B = y._payload, $ = y._init, K = $(B), fe = Ku(K, C);
      lu(b, g, K, fe, k), Aa(g);
    }
    function lu(b, g, y, C, k) {
      if (typeof y == "function")
        if (Xu(y)) {
          nd(b, g, y, C);
          return;
        } else {
          Th(b, g, y, C);
          return;
        }
      if (typeof y == "string") {
        kh(b, g, y, C);
        return;
      }
      switch (y) {
        // TODO: LegacyHidden acts the same as a fragment. This only works
        // because we currently assume that every instance of LegacyHidden is
        // accompanied by a host component wrapper. In the hidden mode, the host
        // component is given a `hidden` attribute, which ensures that the
        // initial HTML is not visible. To support the use of LegacyHidden as a
        // true fragment, without an extra DOM node, we would have to hide the
        // initial HTML in some other way.
        // TODO: Add REACT_OFFSCREEN_TYPE here too with the same capability.
        case za:
        case fh:
        case Os:
        case Ae:
        case Ou: {
          ta(b, g, C.children);
          return;
        }
        case cn: {
          ys(g, "SuspenseList"), ta(b, g, C.children), Aa(g);
          return;
        }
        case Bu:
          throw new Error("ReactDOMServer does not yet support scope components.");
        // eslint-disable-next-line-no-fallthrough
        case pr: {
          tf(b, g, C);
          return;
        }
      }
      if (typeof y == "object" && y !== null)
        switch (y.$$typeof) {
          case xt: {
            ad(b, g, y, C, k);
            return;
          }
          case xi: {
            Zu(b, g, y, C, k);
            return;
          }
          case Ne: {
            ki(b, g, y, C);
            return;
          }
          case De: {
            Ba(b, g, y, C);
            return;
          }
          case Tn: {
            of(b, g, y, C);
            return;
          }
        }
      var B = "";
      throw (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (B += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (y == null ? y : typeof y) + "." + B));
    }
    function ec(b, g) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      b[Symbol.toStringTag] === "Generator" && (id || i("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), id = !0), b.entries === g && (sf || i("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), sf = !0);
    }
    function ta(b, g, y) {
      try {
        return lf(b, g, y);
      } catch (C) {
        throw typeof C == "object" && C !== null && typeof C.then == "function" || (iu = iu !== null ? iu : Ha()), C;
      }
    }
    function lf(b, g, y) {
      if (g.node = y, typeof y == "object" && y !== null) {
        switch (y.$$typeof) {
          case jf: {
            var C = y, k = C.type, B = C.props, $ = C.ref;
            lu(b, g, k, B, $);
            return;
          }
          case Ru:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          // eslint-disable-next-line-no-fallthrough
          case Tn: {
            var K = y, fe = K._payload, Te = K._init, Ue;
            try {
              Ue = Te(fe);
            } catch (xs) {
              throw typeof xs == "object" && xs !== null && typeof xs.then == "function" && ys(g, "Lazy"), xs;
            }
            ta(b, g, Ue);
            return;
          }
        }
        if (Vt(y)) {
          uf(b, g, y);
          return;
        }
        var Je = to(y);
        if (Je) {
          ec(y, Je);
          var ht = Je.call(y);
          if (ht) {
            var ir = ht.next();
            if (!ir.done) {
              var rn = [];
              do
                rn.push(ir.value), ir = ht.next();
              while (!ir.done);
              uf(b, g, rn);
              return;
            }
            return;
          }
        }
        var qi = Object.prototype.toString.call(y);
        throw new Error("Objects are not valid as a React child (found: " + (qi === "[object Object]" ? "object with keys {" + Object.keys(y).join(", ") + "}" : qi) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof y == "string") {
        var go = g.blockedSegment;
        go.lastPushedText = kn(g.blockedSegment.chunks, y, b.responseState, go.lastPushedText);
        return;
      }
      if (typeof y == "number") {
        var ws = g.blockedSegment;
        ws.lastPushedText = kn(g.blockedSegment.chunks, "" + y, b.responseState, ws.lastPushedText);
        return;
      }
      typeof y == "function" && i("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function uf(b, g, y) {
      for (var C = y.length, k = 0; k < C; k++) {
        var B = g.treeContext;
        g.treeContext = es(B, C, k);
        try {
          ho(b, g, y[k]);
        } finally {
          g.treeContext = B;
        }
      }
    }
    function tc(b, g, y) {
      var C = g.blockedSegment, k = C.chunks.length, B = No(
        b,
        k,
        null,
        C.formatContext,
        // Adopt the parent segment's leading text embed
        C.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      C.children.push(B), C.lastPushedText = !1;
      var $ = fo(b, g.node, g.blockedBoundary, B, g.abortSet, g.legacyContext, g.context, g.treeContext);
      g.componentStack !== null && ($.componentStack = g.componentStack.parent);
      var K = $.ping;
      y.then(K, K);
    }
    function ho(b, g, y) {
      var C = g.blockedSegment.formatContext, k = g.legacyContext, B = g.context, $ = null;
      $ = g.componentStack;
      try {
        return ta(b, g, y);
      } catch (K) {
        if (ya(), typeof K == "object" && K !== null && typeof K.then == "function") {
          tc(b, g, K), g.blockedSegment.formatContext = C, g.legacyContext = k, g.context = B, Da(B), g.componentStack = $;
          return;
        } else
          throw g.blockedSegment.formatContext = C, g.legacyContext = k, g.context = B, Da(B), g.componentStack = $, K;
      }
    }
    function zs(b, g, y, C) {
      var k = Al(b, C);
      if (g === null ? au(b, C) : (g.pendingTasks--, g.forceClientRender || (g.forceClientRender = !0, g.errorDigest = k, Yu(g, C), g.parentFlushed && b.clientRenderedBoundaries.push(g))), b.allPendingTasks--, b.allPendingTasks === 0) {
        var B = b.onAllReady;
        B();
      }
    }
    function Fh(b) {
      var g = this, y = b.blockedBoundary, C = b.blockedSegment;
      C.status = uo, xl(g, y, C);
    }
    function As(b, g, y) {
      var C = b.blockedBoundary, k = b.blockedSegment;
      if (k.status = uo, C === null)
        g.allPendingTasks--, g.status !== vl && (g.status = vl, g.destination !== null && m(g.destination));
      else {
        if (C.pendingTasks--, !C.forceClientRender) {
          C.forceClientRender = !0;
          var B = y === void 0 ? new Error("The render was aborted by the server without a reason.") : y;
          C.errorDigest = g.onError(B);
          {
            var $ = "The server did not finish this Suspense boundary: ";
            B && typeof B.message == "string" ? B = $ + B.message : B = $ + String(B);
            var K = $s;
            $s = b;
            try {
              Yu(C, B);
            } finally {
              $s = K;
            }
          }
          C.parentFlushed && g.clientRenderedBoundaries.push(C);
        }
        if (C.fallbackAbortableTasks.forEach(function(Te) {
          return As(Te, g, y);
        }), C.fallbackAbortableTasks.clear(), g.allPendingTasks--, g.allPendingTasks === 0) {
          var fe = g.onAllReady;
          fe();
        }
      }
    }
    function po(b, g) {
      if (g.chunks.length === 0 && g.children.length === 1 && g.children[0].boundary === null) {
        var y = g.children[0];
        y.id = g.id, y.parentFlushed = !0, y.status === ml && po(b, y);
      } else {
        var C = b.completedSegments;
        C.push(g);
      }
    }
    function xl(b, g, y) {
      if (g === null) {
        if (y.parentFlushed) {
          if (b.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          b.completedRootSegment = y;
        }
        if (b.pendingRootTasks--, b.pendingRootTasks === 0) {
          b.onShellError = co;
          var C = b.onShellReady;
          C();
        }
      } else if (g.pendingTasks--, !g.forceClientRender) {
        if (g.pendingTasks === 0)
          y.parentFlushed && y.status === ml && po(g, y), g.parentFlushed && b.completedBoundaries.push(g), g.fallbackAbortableTasks.forEach(Fh, b), g.fallbackAbortableTasks.clear();
        else if (y.parentFlushed && y.status === ml) {
          po(g, y);
          var k = g.completedSegments;
          k.length === 1 && g.parentFlushed && b.partialBoundaries.push(g);
        }
      }
      if (b.allPendingTasks--, b.allPendingTasks === 0) {
        var B = b.onAllReady;
        B();
      }
    }
    function cf(b, g) {
      var y = g.blockedSegment;
      if (y.status === gl) {
        Da(g.context);
        var C = null;
        C = $s, $s = g;
        try {
          ta(b, g, g.node), $n(y.chunks, b.responseState, y.lastPushedText, y.textEmbedded), g.abortSet.delete(g), y.status = ml, xl(b, g.blockedBoundary, y);
        } catch (B) {
          if (ya(), typeof B == "object" && B !== null && typeof B.then == "function") {
            var k = g.ping;
            B.then(k, k);
          } else
            g.abortSet.delete(g), y.status = rd, zs(b, g.blockedBoundary, y, B);
        } finally {
          $s = C;
        }
      }
    }
    function ff(b) {
      if (b.status !== vl) {
        var g = Yf(), y = ju.current;
        ju.current = ru;
        var C;
        C = qu.getCurrentStack, qu.getCurrentStack = Ha;
        var k = _i;
        hl(b.responseState);
        try {
          var B = b.pingedTasks, $;
          for ($ = 0; $ < B.length; $++) {
            var K = B[$];
            cf(b, K);
          }
          B.splice(0, $), b.destination !== null && ra(b, b.destination);
        } catch (fe) {
          Al(b, fe), au(b, fe);
        } finally {
          hl(k), ju.current = y, qu.getCurrentStack = C, y === ru && Da(g);
        }
      }
    }
    function uu(b, g, y) {
      switch (y.parentFlushed = !0, y.status) {
        case gl: {
          var C = y.id = b.nextSegmentId++;
          return y.lastPushedText = !1, y.textEmbedded = !1, We(g, b.responseState, C);
        }
        case ml: {
          y.status = Mo;
          for (var k = !0, B = y.chunks, $ = 0, K = y.children, fe = 0; fe < K.length; fe++) {
            for (var Te = K[fe]; $ < Te.index; $++)
              h(g, B[$]);
            k = rc(b, g, Te);
          }
          for (; $ < B.length - 1; $++)
            h(g, B[$]);
          return $ < B.length && (k = f(g, B[$])), k;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function rc(b, g, y) {
      var C = y.boundary;
      if (C === null)
        return uu(b, g, y);
      if (C.parentFlushed = !0, C.forceClientRender)
        return pi(g, b.responseState, C.errorDigest, C.errorMessage, C.errorComponentStack), uu(b, g, y), ua(g, b.responseState);
      if (C.pendingTasks > 0) {
        C.rootSegmentID = b.nextSegmentId++, C.completedSegments.length > 0 && b.partialBoundaries.push(C);
        var k = C.id = ai(b.responseState);
        return Vi(g, b.responseState, k), uu(b, g, y), Vr(g, b.responseState);
      } else {
        if (C.byteSize > b.progressiveChunkSize)
          return C.rootSegmentID = b.nextSegmentId++, b.completedBoundaries.push(C), Vi(g, b.responseState, C.id), uu(b, g, y), Vr(g, b.responseState);
        Xa(g, b.responseState);
        var B = C.completedSegments;
        if (B.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var $ = B[0];
        return rc(b, g, $), Ta(g, b.responseState);
      }
    }
    function df(b, g, y) {
      return Ja(g, b.responseState, y.id, y.errorDigest, y.errorMessage, y.errorComponentStack);
    }
    function cu(b, g, y) {
      return ur(g, b.responseState, y.formatContext, y.id), rc(b, g, y), un(g, y.formatContext);
    }
    function sd(b, g, y) {
      for (var C = y.completedSegments, k = 0; k < C.length; k++) {
        var B = C[k];
        hf(b, g, y, B);
      }
      return C.length = 0, $a(g, b.responseState, y.id, y.rootSegmentID);
    }
    function od(b, g, y) {
      for (var C = y.completedSegments, k = 0; k < C.length; k++) {
        var B = C[k];
        if (!hf(b, g, y, B))
          return k++, C.splice(0, k), !1;
      }
      return C.splice(0, k), !0;
    }
    function hf(b, g, y, C) {
      if (C.status === Mo)
        return !0;
      var k = C.id;
      if (k === -1) {
        var B = C.id = y.rootSegmentID;
        if (B === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return cu(b, g, C);
      } else
        return cu(b, g, C), ei(g, b.responseState, k);
    }
    function ra(b, g) {
      c();
      try {
        var y = b.completedRootSegment;
        y !== null && b.pendingRootTasks === 0 && (rc(b, g, y), b.completedRootSegment = null, oe(g, b.responseState));
        var C = b.clientRenderedBoundaries, k;
        for (k = 0; k < C.length; k++) {
          var B = C[k];
          df(b, g, B);
        }
        C.splice(0, k);
        var $ = b.completedBoundaries;
        for (k = 0; k < $.length; k++) {
          var K = $[k];
          sd(b, g, K);
        }
        $.splice(0, k), p(g), c(g);
        var fe = b.partialBoundaries;
        for (k = 0; k < fe.length; k++) {
          var Te = fe[k];
          if (!od(b, g, Te)) {
            b.destination = null, k++, fe.splice(0, k);
            return;
          }
        }
        fe.splice(0, k);
        var Ue = b.completedBoundaries;
        for (k = 0; k < Ue.length; k++) {
          var Je = Ue[k];
          sd(b, g, Je);
        }
        Ue.splice(0, k);
      } finally {
        p(g), b.allPendingTasks === 0 && b.pingedTasks.length === 0 && b.clientRenderedBoundaries.length === 0 && b.completedBoundaries.length === 0 && (b.abortableTasks.size !== 0 && i("There was still abortable task at the root when we closed. This is a bug in React."), m(g));
      }
    }
    function rs(b) {
      s(function() {
        return ff(b);
      });
    }
    function Ih(b, g) {
      if (b.status === vs) {
        b.status = vl, E(g, b.fatalError);
        return;
      }
      if (b.status !== vl && b.destination === null) {
        b.destination = g;
        try {
          ra(b, g);
        } catch (y) {
          Al(b, y), au(b, y);
        }
      }
    }
    function ld(b, g) {
      try {
        var y = b.abortableTasks;
        y.forEach(function(C) {
          return As(C, b, g);
        }), y.clear(), b.destination !== null && ra(b, b.destination);
      } catch (C) {
        Al(b, C), au(b, C);
      }
    }
    function nc(b, g) {
      return new Promise(function(y, C) {
        var k, B, $ = new Promise(function(ht, ir) {
          B = ht, k = ir;
        });
        function K() {
          var ht = new ReadableStream(
            {
              type: "bytes",
              pull: function(ir) {
                Ih(Te, ir);
              },
              cancel: function(ir) {
                ld(Te);
              }
            },
            // $FlowFixMe size() methods are not allowed on byte streams.
            {
              highWaterMark: 0
            }
          );
          ht.allReady = $, y(ht);
        }
        function fe(ht) {
          $.catch(function() {
          }), C(ht);
        }
        var Te = Qu(b, Xn(g ? g.identifierPrefix : void 0, g ? g.nonce : void 0, g ? g.bootstrapScriptContent : void 0, g ? g.bootstrapScripts : void 0, g ? g.bootstrapModules : void 0), Un(g ? g.namespaceURI : void 0), g ? g.progressiveChunkSize : void 0, g ? g.onError : void 0, B, K, fe, k);
        if (g && g.signal) {
          var Ue = g.signal, Je = function() {
            ld(Te, Ue.reason), Ue.removeEventListener("abort", Je);
          };
          Ue.addEventListener("abort", Je);
        }
        rs(Te);
      });
    }
    $g.renderToReadableStream = nc, $g.version = e;
  })()), $g;
}
var MS;
function CN() {
  if (MS) return ac;
  MS = 1;
  var r, e;
  return process.env.NODE_ENV === "production" ? (r = AN(), e = wN()) : (r = xN(), e = bN()), ac.version = r.version, ac.renderToString = r.renderToString, ac.renderToStaticMarkup = r.renderToStaticMarkup, ac.renderToNodeStream = r.renderToNodeStream, ac.renderToStaticNodeStream = r.renderToStaticNodeStream, ac.renderToReadableStream = e.renderToReadableStream, ac;
}
var SN = CN();
let u1, c1;
function Cre(r) {
  u1 = r;
}
function Sre(r) {
  c1 = r;
}
function ug() {
  return u1 ? new u1().window : (console.log(
    "DOM constructor is not registered. Assuming browser environment. If not, please register DOM constructor before calling this function."
  ), window);
}
function Ll(r, e) {
  if (!c1) {
    if (typeof window < "u" && window.fetch)
      return window.fetch(r, e);
    if (typeof global < "u" && global.fetch)
      return global.fetch(r, e);
    throw new Error("Fetch implementation is not registered. Please register it before calling this function.");
  }
  return c1(r, e);
}
const AI = /* @__PURE__ */ new Map(), NS = /* @__PURE__ */ new Map(), LS = /* @__PURE__ */ new Map(), wI = async (r) => {
  const e = NS.get(r);
  if (e) return e;
  const n = (async () => {
    const i = await Ll(r);
    return AI.set(r, i.headers?.get("content-type") || ""), await i.arrayBuffer();
  })();
  return NS.set(r, n), n;
}, EN = async (r) => {
  const e = LS.get(r);
  if (e) return e;
  const n = (async () => await (await Ll(r)).text())();
  return LS.set(r, n), n;
}, nh = (r) => r.every((e) => e !== "undefined"), zg = (r) => nh([typeof document]) ? document.createElement(r) : ug().document.createElement(r), kN = (r, e) => {
  if (nh([typeof document]))
    return document.createElementNS(r, e);
  const n = ug().document.createElement(e);
  return n.setAttribute("xmlns", r), n;
}, Pu = () => {
  if (nh([typeof DOMParser]))
    return new DOMParser();
  const r = ug();
  return new r.DOMParser();
}, TN = () => nh([typeof DOMParser]) ? DOMParser : ug().DOMParser, $0 = (r, e) => new Promise((t, n) => {
  e ? wI(r).then(t).catch(n) : Ll(r).then((i) => {
    i.arrayBuffer().then(t).catch(n);
  }).catch((i) => {
    n(i);
  });
}), xo = (r, e) => new Promise((t, n) => {
  e ? EN(r).then(t).catch(n) : Ll(r).then((i) => {
    i.text().then(t).catch(n);
  }).catch(n);
}), xI = (r) => SN.renderToStaticMarkup(r), qv = /* @__PURE__ */ new Map(), FN = async (r, e) => {
  if (nh([typeof FontFace])) {
    if (qv.has(e))
      return qv.get(e);
    const t = r.names.fullName.en, n = new FontFace(t, `url(${e})`);
    document.fonts.add(n);
    const i = n.load();
    return qv.set(e, i), i;
  }
}, $f = () => {
  if (nh([typeof XMLSerializer]))
    return new XMLSerializer();
  const r = ug();
  return new r.XMLSerializer();
}, US = (r) => btoa(r), z0 = (r) => {
  function e() {
    const n = new Uint8Array(r), i = 4;
    if (n.length >= i) {
      const a = new Array(i);
      for (let l = 0; l < i; l++) a[l] = new Uint8Array(r)[l].toString(16);
      const s = a.join("").toUpperCase();
      switch (s) {
        case "89504E47":
          return "image/png";
        case "47494638":
          return "image/gif";
        case "25504446":
          return "application/pdf";
        case "504B0304":
          return "application/zip";
      }
      if (s.slice(0, 4) === "FFD8")
        return "image/jpeg";
    }
    return null;
  }
  const t = e();
  return t || "image/svg+xml";
}, Ere = async (r) => {
  const e = await wI(r), t = AI.get(r) || z0(e);
  return await DN(new Blob([e], { type: t }));
}, IN = (r) => {
  let e = "";
  const t = r.byteLength;
  for (let n = 0; n < t; n++)
    e += String.fromCharCode(r[n]);
  return e;
}, PN = async (r) => {
  const e = z0(r), t = new Uint8Array(r), n = IN(t), i = btoa(n);
  return `data:${e};base64,${i}`;
}, Iw = (r) => `data:image/svg+xml;base64,${btoa(r)}`, bI = (r) => {
  const e = r.replace(/\r?\n/g, ""), t = e.indexOf(",");
  if (t === -1 || t <= 4)
    throw new TypeError("malformed data: URI");
  const n = e.substring(5, t).split(";");
  let i = !1;
  for (let s = 1; s < n.length; s++)
    n[s] === "base64" && (i = !0);
  const a = decodeURI(e.substring(t + 1));
  return i ? new Uint8Array(
    atob(a).split("").map((o) => o.charCodeAt(0))
  ).buffer : new Uint8Array(a.split("").map((o) => o.charCodeAt(0))).buffer;
}, DN = (r) => new Promise((e, t) => {
  const n = new FileReader();
  n.onload = function(i) {
    const a = i.target;
    !a || !a.result ? t() : e(a.result.toString());
  }, n.readAsDataURL(r);
});
var RN = "__KEEP";
function ON(r) {
  return r === void 0 && (r = /* @__PURE__ */ Object.create(null)), Object.assign(new Ko(function(e, t) {
    var n = r.except, i = e.query, a = e.variables;
    return a && (e.variables = n ? BN(i, a, n) : xw(a)), t(e);
  }), {});
}
function BN(r, e, t) {
  var n = _N(r);
  return Object.fromEntries(Object.entries(e).map(function(i) {
    var a = i[0], s = i[1], o = n[a], l = t[o];
    return i[1] = l ? f1(s, l) : xw(s), i;
  }));
}
function f1(r, e) {
  if (e === RN)
    return r;
  if (Array.isArray(r))
    return r.map(function(n) {
      return f1(n, e);
    });
  if (wF(r)) {
    var t = {};
    return Object.keys(r).forEach(function(n) {
      var i = r[n];
      if (n !== "__typename") {
        var a = e[n];
        t[n] = a ? f1(i, a) : xw(i);
      }
    }), t;
  }
  return r;
}
var _N = Nd(function(r) {
  var e = {};
  return qo(r, {
    VariableDefinition: function(t) {
      e[t.variable.name.value] = d1(t.type);
    }
  }), e;
}, {
  max: Tu["removeTypenameFromVariables.getVariableDefinitions"] || 2e3,
  cache: $p
});
function d1(r) {
  switch (r.kind) {
    case At.NON_NULL_TYPE:
      return d1(r.type);
    case At.LIST_TYPE:
      return d1(r.type);
    case At.NAMED_TYPE:
      return r.name.value;
  }
}
function MN(r) {
  var e = r || {}, t = e.initial, n = t === void 0 ? 300 : t, i = e.jitter, a = i === void 0 ? !0 : i, s = e.max, o = s === void 0 ? 1 / 0 : s, l = a ? n : n / 2;
  return function(c) {
    var h = Math.min(o, l * Math.pow(2, c));
    return a && (h = Math.random() * h), h;
  };
}
function NN(r) {
  var e = r || {}, t = e.retryIf, n = e.max, i = n === void 0 ? 5 : n;
  return function(s, o, l) {
    return s >= i ? !1 : t ? t(l, o) : !!l;
  };
}
var LN = (
  /** @class */
  (function() {
    function r(e, t, n, i, a) {
      var s = this;
      this.observer = e, this.operation = t, this.forward = n, this.delayFor = i, this.retryIf = a, this.retryCount = 0, this.currentSubscription = null, this.onError = function(o) {
        return Il(s, void 0, void 0, function() {
          var l;
          return Pl(this, function(u) {
            switch (u.label) {
              case 0:
                return this.retryCount += 1, [4, this.retryIf(this.retryCount, this.operation, o)];
              case 1:
                return l = u.sent(), l ? (this.scheduleRetry(this.delayFor(this.retryCount, this.operation, o)), [
                  2
                  /*return*/
                ]) : (this.observer.error(o), [
                  2
                  /*return*/
                ]);
            }
          });
        });
      }, this.try();
    }
    return r.prototype.cancel = function() {
      this.currentSubscription && this.currentSubscription.unsubscribe(), clearTimeout(this.timerId), this.timerId = void 0, this.currentSubscription = null;
    }, r.prototype.try = function() {
      var e = this;
      this.currentSubscription = this.forward(this.operation).subscribe({
        next: function(t) {
          var n;
          if (bw(t)) {
            e.onError(new hc({
              protocolErrors: t.extensions[og]
            })), (n = e.currentSubscription) === null || n === void 0 || n.unsubscribe();
            return;
          }
          e.observer.next(t);
        },
        error: this.onError,
        complete: this.observer.complete.bind(this.observer)
      });
    }, r.prototype.scheduleRetry = function(e) {
      var t = this;
      if (this.timerId)
        throw new Error("RetryLink BUG! Encountered overlapping retries");
      this.timerId = setTimeout(function() {
        t.timerId = void 0, t.try();
      }, e);
    }, r;
  })()
), UN = (
  /** @class */
  (function(r) {
    bo(e, r);
    function e(t) {
      var n = r.call(this) || this, i = t || {}, a = i.attempts, s = i.delay;
      return n.delayFor = typeof s == "function" ? s : MN(s), n.retryIf = typeof a == "function" ? a : NN(a), n;
    }
    return e.prototype.request = function(t, n) {
      var i = this;
      return new ri(function(a) {
        var s = new LN(a, t, n, i.delayFor, i.retryIf);
        return function() {
          s.cancel();
        };
      });
    }, e;
  })(Ko)
);
let CI;
const Qv = (r) => {
  CI = r;
};
let Pw;
const VN = (r) => {
  Pw = r;
}, $N = () => Pw;
let SI;
const zN = (r) => {
  SI = r;
};
let EI;
const GN = (r) => {
  EI = r;
}, HN = () => new Promise((r) => {
  const e = Cc.getHubUrl();
  if (window.parent === window) {
    r({});
    return;
  }
  const t = (n) => {
    n.origin === e && (window.removeEventListener("message", t), r(n.data || {}));
  };
  window.addEventListener("message", t, !1), window.parent.postMessage("ready", e);
}), WN = async () => {
  const r = {
    applicationKey: Pw,
    customerToken: CI,
    bearer: SI,
    partnerId: EI
  };
  if (typeof window < "u" && (window.location.href.includes("/workflows/product/") || window.location.href.includes("hub=true"))) {
    const e = await HN();
    e.bearer && (r.bearer = e.bearer), e.partnerId && (r.partnerId = e.partnerId);
  }
  return r;
}, jN = (r) => Object.fromEntries(
  Object.entries(r).map(([e, t]) => [e, t])
);
class qN {
  constructor() {
    this.shadowGraphqlClient = this.constructShadowGraphqlClient(), Cc.addServerUrlCallback(() => {
      this.shadowGraphqlClient = this.constructShadowGraphqlClient();
    });
  }
  setSpiffCommerceClient(e) {
    this.spiffClient = e, this.shadowGraphqlClient = this.constructShadowGraphqlClient();
  }
  getShadowGraphqlClient() {
    return this.shadowGraphqlClient;
  }
  constructShadowGraphqlClient() {
    const e = QF({
      uri: `${Cc.getServerUrl()}/graphql`,
      fetch: Ll
    }), t = gN(async (s, o) => {
      const { headers: l } = o, u = l || {}, c = await WN();
      let h = o.bearer ?? c.bearer, f = !1;
      if (this.spiffClient) {
        try {
          h = await this.spiffClient.loggedInBearerToken();
        } catch {
        }
        try {
          o.skipIntegrationCheck || (f = await this.spiffClient.getBetaEnabled());
        } catch {
        }
      }
      const p = o.partnerId ?? c.partnerId, m = o.activeIntegration ?? c.activeIntegration, A = o.transactionOwnerId, w = o.customerToken ?? c.customerToken, x = o.applicationKey ?? c.applicationKey, E = o.bundleOwnerId;
      try {
        if (window && window.__SENTRY__) {
          const T = window.__SENTRY__.hub;
          if (T) {
            const D = T.traceHeaders();
            Object.entries(D).forEach(([F, _]) => {
              u[F] = _;
            });
          }
        }
      } catch {
      }
      return h && (u.Authorization = `Bearer ${h}`), p && (u.partnerId = p), m && (u.activeIntegration = m), A && (u.transactionOwnerId = A), w && (u.customerToken = w), x && (u["X-Application-Key"] = x), E && (u.bundleOwnerId = E), f && (u["X-Spiff-Beta"] = "true"), u["Allow-Moonlight-Redirect"] = "true", o.logRequestHeaders && console.log(`[graphql] Request headers for ${s.operationName}.`, {
        uri: `${Cc.getServerUrl()}/graphql`,
        headers: jN(u)
      }), {
        headers: u
      };
    }), n = yI(({ operation: s, graphQLErrors: o, networkError: l }) => {
      const u = o || [], c = s.getContext();
      l && !c?.fetchOptions?.signal?.aborted && console.log("GraphQL Network error"), u.forEach(() => console.log("GraphQL Error: " + s.operationName));
    }), i = ON(), a = new UN({
      attempts: {
        max: 5,
        retryIf(s, o) {
          return !!(s && s.result && s.result.status === 429);
        }
      },
      delay: (s, o, l) => {
        const u = Math.random() * 1.5 + 0.5;
        return s * 200 * u;
      }
    });
    return new K6({
      link: Z5([i, n, t, e, a]),
      cache: new q6(),
      name: "Core"
    });
  }
}
const et = new qN();
let h1, p1;
const Pc = (r, e, t) => {
  if (h1 !== void 0)
    return h1(r, e, t);
  try {
    const n = TI(!0);
    return kI(n), n.createCanvas(r, e, t);
  } catch {
    throw new Error("Canvas module not set");
  }
}, cg = (r, e) => {
  if (p1 !== void 0)
    return p1(r, e);
  try {
    const t = TI(!0);
    return kI(t), t.loadImage(r, e);
  } catch {
    throw new Error("Canvas module not set");
  }
};
function kI(r) {
  h1 = r?.createCanvas, p1 = r?.loadImage;
}
function TI(r) {
  try {
    if (document.createElement("canvas").getContext("2d"))
      return {
        createCanvas: (t, n, i) => {
          const a = document.createElement("canvas");
          return t != null && (a.width = t), n != null && (a.height = n), a;
        },
        loadImage: (t, n) => new Promise((i, a) => {
          const s = document.createElement("img");
          n !== !1 && (s.crossOrigin = "Anonymous"), s.onload = () => {
            i(s);
          }, s.onerror = a, s.src = t;
        })
      };
  } catch (e) {
    throw e;
  }
}
let Yv;
function Dw() {
  return Yv === void 0 && (Yv = TN()), Yv;
}
var gp = { exports: {} }, QN = gp.exports, VS;
function YN() {
  return VS || (VS = 1, (function(r, e) {
    (function(t, n) {
      n(e);
    })(QN, (function(t) {
      function n(Me, M, W) {
        return M in Me ? Object.defineProperty(Me, M, { value: W, enumerable: !0, configurable: !0, writable: !0 }) : Me[M] = W, Me;
      }
      var i = typeof self < "u" ? self : Ni;
      const a = typeof navigator < "u", s = a && typeof HTMLImageElement > "u", o = !(typeof Ni > "u" || typeof process > "u" || !process.versions || !process.versions.node), l = i.Buffer, u = !!l, c = (Me) => Me !== void 0;
      function h(Me) {
        return Me === void 0 || (Me instanceof Map ? Me.size === 0 : Object.values(Me).filter(c).length === 0);
      }
      function f(Me) {
        let M = new Error(Me);
        throw delete M.stack, M;
      }
      function p(Me) {
        let M = (function(W) {
          let se = 0;
          return W.ifd0.enabled && (se += 1024), W.exif.enabled && (se += 2048), W.makerNote && (se += 2048), W.userComment && (se += 1024), W.gps.enabled && (se += 512), W.interop.enabled && (se += 100), W.ifd1.enabled && (se += 1024), se + 2048;
        })(Me);
        return Me.jfif.enabled && (M += 50), Me.xmp.enabled && (M += 2e4), Me.iptc.enabled && (M += 14e3), Me.icc.enabled && (M += 6e3), M;
      }
      const m = (Me) => String.fromCharCode.apply(null, Me), A = typeof TextDecoder < "u" ? new TextDecoder("utf-8") : void 0;
      class w {
        static from(M, W) {
          return M instanceof this && M.le === W ? M : new w(M, void 0, void 0, W);
        }
        constructor(M, W = 0, se, we) {
          if (typeof we == "boolean" && (this.le = we), Array.isArray(M) && (M = new Uint8Array(M)), M === 0) this.byteOffset = 0, this.byteLength = 0;
          else if (M instanceof ArrayBuffer) {
            se === void 0 && (se = M.byteLength - W);
            let $e = new DataView(M, W, se);
            this._swapDataView($e);
          } else if (M instanceof Uint8Array || M instanceof DataView || M instanceof w) {
            se === void 0 && (se = M.byteLength - W), (W += M.byteOffset) + se > M.byteOffset + M.byteLength && f("Creating view outside of available memory in ArrayBuffer");
            let $e = new DataView(M.buffer, W, se);
            this._swapDataView($e);
          } else if (typeof M == "number") {
            let $e = new DataView(new ArrayBuffer(M));
            this._swapDataView($e);
          } else f("Invalid input argument for BufferView: " + M);
        }
        _swapArrayBuffer(M) {
          this._swapDataView(new DataView(M));
        }
        _swapBuffer(M) {
          this._swapDataView(new DataView(M.buffer, M.byteOffset, M.byteLength));
        }
        _swapDataView(M) {
          this.dataView = M, this.buffer = M.buffer, this.byteOffset = M.byteOffset, this.byteLength = M.byteLength;
        }
        _lengthToEnd(M) {
          return this.byteLength - M;
        }
        set(M, W, se = w) {
          return M instanceof DataView || M instanceof w ? M = new Uint8Array(M.buffer, M.byteOffset, M.byteLength) : M instanceof ArrayBuffer && (M = new Uint8Array(M)), M instanceof Uint8Array || f("BufferView.set(): Invalid data argument."), this.toUint8().set(M, W), new se(this, W, M.byteLength);
        }
        subarray(M, W) {
          return W = W || this._lengthToEnd(M), new w(this, M, W);
        }
        toUint8() {
          return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
        }
        getUint8Array(M, W) {
          return new Uint8Array(this.buffer, this.byteOffset + M, W);
        }
        getString(M = 0, W = this.byteLength) {
          return we = this.getUint8Array(M, W), A ? A.decode(we) : u ? Buffer.from(we).toString("utf8") : decodeURIComponent(escape(m(we)));
          var we;
        }
        getLatin1String(M = 0, W = this.byteLength) {
          let se = this.getUint8Array(M, W);
          return m(se);
        }
        getUnicodeString(M = 0, W = this.byteLength) {
          const se = [];
          for (let we = 0; we < W && M + we < this.byteLength; we += 2) se.push(this.getUint16(M + we));
          return m(se);
        }
        getInt8(M) {
          return this.dataView.getInt8(M);
        }
        getUint8(M) {
          return this.dataView.getUint8(M);
        }
        getInt16(M, W = this.le) {
          return this.dataView.getInt16(M, W);
        }
        getInt32(M, W = this.le) {
          return this.dataView.getInt32(M, W);
        }
        getUint16(M, W = this.le) {
          return this.dataView.getUint16(M, W);
        }
        getUint32(M, W = this.le) {
          return this.dataView.getUint32(M, W);
        }
        getFloat32(M, W = this.le) {
          return this.dataView.getFloat32(M, W);
        }
        getFloat64(M, W = this.le) {
          return this.dataView.getFloat64(M, W);
        }
        getFloat(M, W = this.le) {
          return this.dataView.getFloat32(M, W);
        }
        getDouble(M, W = this.le) {
          return this.dataView.getFloat64(M, W);
        }
        getUintBytes(M, W, se) {
          switch (W) {
            case 1:
              return this.getUint8(M, se);
            case 2:
              return this.getUint16(M, se);
            case 4:
              return this.getUint32(M, se);
            case 8:
              return this.getUint64 && this.getUint64(M, se);
          }
        }
        getUint(M, W, se) {
          switch (W) {
            case 8:
              return this.getUint8(M, se);
            case 16:
              return this.getUint16(M, se);
            case 32:
              return this.getUint32(M, se);
            case 64:
              return this.getUint64 && this.getUint64(M, se);
          }
        }
        toString(M) {
          return this.dataView.toString(M, this.constructor.name);
        }
        ensureChunk() {
        }
      }
      function x(Me, M) {
        f(`${Me} '${M}' was not loaded, try using full build of exifr.`);
      }
      class E extends Map {
        constructor(M) {
          super(), this.kind = M;
        }
        get(M, W) {
          return this.has(M) || x(this.kind, M), W && (M in W || (function(se, we) {
            f(`Unknown ${se} '${we}'.`);
          })(this.kind, M), W[M].enabled || x(this.kind, M)), super.get(M);
        }
        keyList() {
          return Array.from(this.keys());
        }
      }
      var T = new E("file parser"), D = new E("segment parser"), F = new E("file reader");
      let _ = i.fetch;
      const L = "Invalid input argument";
      function Z(Me, M) {
        return (W = Me).startsWith("data:") || W.length > 1e4 ? de(Me, M, "base64") : o && Me.includes("://") ? te(Me, M, "url", H) : o ? de(Me, M, "fs") : a ? te(Me, M, "url", H) : void f(L);
        var W;
      }
      async function te(Me, M, W, se) {
        return F.has(W) ? de(Me, M, W) : se ? (async function(we, $e) {
          let ut = await $e(we);
          return new w(ut);
        })(Me, se) : void f(`Parser ${W} is not loaded`);
      }
      async function de(Me, M, W) {
        let se = new (F.get(W))(Me, M);
        return await se.read(), se;
      }
      const H = (Me) => _(Me).then(((M) => M.arrayBuffer())), j = (Me) => new Promise(((M, W) => {
        let se = new FileReader();
        se.onloadend = () => M(se.result || new ArrayBuffer()), se.onerror = W, se.readAsArrayBuffer(Me);
      }));
      class q extends Map {
        get tagKeys() {
          return this.allKeys || (this.allKeys = Array.from(this.keys())), this.allKeys;
        }
        get tagValues() {
          return this.allValues || (this.allValues = Array.from(this.values())), this.allValues;
        }
      }
      function re(Me, M, W) {
        let se = new q();
        for (let [we, $e] of W) se.set(we, $e);
        if (Array.isArray(M)) for (let we of M) Me.set(we, se);
        else Me.set(M, se);
        return se;
      }
      function ae(Me, M, W) {
        let se, we = Me.get(M);
        for (se of W) we.set(se[0], se[1]);
      }
      const ye = /* @__PURE__ */ new Map(), Se = /* @__PURE__ */ new Map(), Xe = /* @__PURE__ */ new Map(), Ve = 37500, He = 37510, le = 33723, ve = 34675, it = 34665, mt = 34853, qe = 40965, at = ["chunked", "firstChunkSize", "firstChunkSizeNode", "firstChunkSizeBrowser", "chunkSize", "chunkLimit"], st = ["jfif", "xmp", "icc", "iptc", "ihdr"], lt = ["tiff", ...st], rt = ["ifd0", "ifd1", "exif", "gps", "interop"], Rt = [...lt, ...rt], Fr = ["makerNote", "userComment"], an = ["translateKeys", "translateValues", "reviveValues", "multiSegment"], ar = [...an, "sanitize", "mergeOutput", "silentErrors"];
      class Ir {
        get translate() {
          return this.translateKeys || this.translateValues || this.reviveValues;
        }
      }
      class kt extends Ir {
        get needed() {
          return this.enabled || this.deps.size > 0;
        }
        constructor(M, W, se, we) {
          if (super(), n(this, "enabled", !1), n(this, "skip", /* @__PURE__ */ new Set()), n(this, "pick", /* @__PURE__ */ new Set()), n(this, "deps", /* @__PURE__ */ new Set()), n(this, "translateKeys", !1), n(this, "translateValues", !1), n(this, "reviveValues", !1), this.key = M, this.enabled = W, this.parse = this.enabled, this.applyInheritables(we), this.canBeFiltered = rt.includes(M), this.canBeFiltered && (this.dict = ye.get(M)), se !== void 0) if (Array.isArray(se)) this.parse = this.enabled = !0, this.canBeFiltered && se.length > 0 && this.translateTagSet(se, this.pick);
          else if (typeof se == "object") {
            if (this.enabled = !0, this.parse = se.parse !== !1, this.canBeFiltered) {
              let { pick: $e, skip: ut } = se;
              $e && $e.length > 0 && this.translateTagSet($e, this.pick), ut && ut.length > 0 && this.translateTagSet(ut, this.skip);
            }
            this.applyInheritables(se);
          } else se === !0 || se === !1 ? this.parse = this.enabled = se : f(`Invalid options argument: ${se}`);
        }
        applyInheritables(M) {
          let W, se;
          for (W of an) se = M[W], se !== void 0 && (this[W] = se);
        }
        translateTagSet(M, W) {
          if (this.dict) {
            let se, we, { tagKeys: $e, tagValues: ut } = this.dict;
            for (se of M) typeof se == "string" ? (we = ut.indexOf(se), we === -1 && (we = $e.indexOf(Number(se))), we !== -1 && W.add(Number($e[we]))) : W.add(se);
          } else for (let se of M) W.add(se);
        }
        finalizeFilters() {
          !this.enabled && this.deps.size > 0 ? (this.enabled = !0, Cr(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && Cr(this.pick, this.deps);
        }
      }
      var wt = { jfif: !1, tiff: !0, xmp: !1, icc: !1, iptc: !1, ifd0: !0, ifd1: !1, exif: !0, gps: !0, interop: !1, ihdr: void 0, makerNote: !1, userComment: !1, multiSegment: !1, skip: [], pick: [], translateKeys: !0, translateValues: !0, reviveValues: !0, sanitize: !0, mergeOutput: !0, silentErrors: !0, chunked: !0, firstChunkSize: void 0, firstChunkSizeNode: 512, firstChunkSizeBrowser: 65536, chunkSize: 65536, chunkLimit: 5 }, Mn = /* @__PURE__ */ new Map();
      class kr extends Ir {
        static useCached(M) {
          let W = Mn.get(M);
          return W !== void 0 || (W = new this(M), Mn.set(M, W)), W;
        }
        constructor(M) {
          super(), M === !0 ? this.setupFromTrue() : M === void 0 ? this.setupFromUndefined() : Array.isArray(M) ? this.setupFromArray(M) : typeof M == "object" ? this.setupFromObject(M) : f(`Invalid options argument ${M}`), this.firstChunkSize === void 0 && (this.firstChunkSize = a ? this.firstChunkSizeBrowser : this.firstChunkSizeNode), this.mergeOutput && (this.ifd1.enabled = !1), this.filterNestedSegmentTags(), this.traverseTiffDependencyTree(), this.checkLoadedPlugins();
        }
        setupFromUndefined() {
          let M;
          for (M of at) this[M] = wt[M];
          for (M of ar) this[M] = wt[M];
          for (M of Fr) this[M] = wt[M];
          for (M of Rt) this[M] = new kt(M, wt[M], void 0, this);
        }
        setupFromTrue() {
          let M;
          for (M of at) this[M] = wt[M];
          for (M of ar) this[M] = wt[M];
          for (M of Fr) this[M] = !0;
          for (M of Rt) this[M] = new kt(M, !0, void 0, this);
        }
        setupFromArray(M) {
          let W;
          for (W of at) this[W] = wt[W];
          for (W of ar) this[W] = wt[W];
          for (W of Fr) this[W] = wt[W];
          for (W of Rt) this[W] = new kt(W, !1, void 0, this);
          this.setupGlobalFilters(M, void 0, rt);
        }
        setupFromObject(M) {
          let W;
          for (W of (rt.ifd0 = rt.ifd0 || rt.image, rt.ifd1 = rt.ifd1 || rt.thumbnail, Object.assign(this, M), at)) this[W] = Pr(M[W], wt[W]);
          for (W of ar) this[W] = Pr(M[W], wt[W]);
          for (W of Fr) this[W] = Pr(M[W], wt[W]);
          for (W of lt) this[W] = new kt(W, wt[W], M[W], this);
          for (W of rt) this[W] = new kt(W, wt[W], M[W], this.tiff);
          this.setupGlobalFilters(M.pick, M.skip, rt, Rt), M.tiff === !0 ? this.batchEnableWithBool(rt, !0) : M.tiff === !1 ? this.batchEnableWithUserValue(rt, M) : Array.isArray(M.tiff) ? this.setupGlobalFilters(M.tiff, void 0, rt) : typeof M.tiff == "object" && this.setupGlobalFilters(M.tiff.pick, M.tiff.skip, rt);
        }
        batchEnableWithBool(M, W) {
          for (let se of M) this[se].enabled = W;
        }
        batchEnableWithUserValue(M, W) {
          for (let se of M) {
            let we = W[se];
            this[se].enabled = we !== !1 && we !== void 0;
          }
        }
        setupGlobalFilters(M, W, se, we = se) {
          if (M && M.length) {
            for (let ut of we) this[ut].enabled = !1;
            let $e = Gr(M, se);
            for (let [ut, Mt] of $e) Cr(this[ut].pick, Mt), this[ut].enabled = !0;
          } else if (W && W.length) {
            let $e = Gr(W, se);
            for (let [ut, Mt] of $e) Cr(this[ut].skip, Mt);
          }
        }
        filterNestedSegmentTags() {
          let { ifd0: M, exif: W, xmp: se, iptc: we, icc: $e } = this;
          this.makerNote ? W.deps.add(Ve) : W.skip.add(Ve), this.userComment ? W.deps.add(He) : W.skip.add(He), se.enabled || M.skip.add(700), we.enabled || M.skip.add(le), $e.enabled || M.skip.add(ve);
        }
        traverseTiffDependencyTree() {
          let { ifd0: M, exif: W, gps: se, interop: we } = this;
          we.needed && (W.deps.add(qe), M.deps.add(qe)), W.needed && M.deps.add(it), se.needed && M.deps.add(mt), this.tiff.enabled = rt.some((($e) => this[$e].enabled === !0)) || this.makerNote || this.userComment;
          for (let $e of rt) this[$e].finalizeFilters();
        }
        get onlyTiff() {
          return !st.map(((M) => this[M].enabled)).some(((M) => M === !0)) && this.tiff.enabled;
        }
        checkLoadedPlugins() {
          for (let M of lt) this[M].enabled && !D.has(M) && x("segment parser", M);
        }
      }
      function Gr(Me, M) {
        let W, se, we, $e, ut = [];
        for (we of M) {
          for ($e of (W = ye.get(we), se = [], W)) (Me.includes($e[0]) || Me.includes($e[1])) && se.push($e[0]);
          se.length && ut.push([we, se]);
        }
        return ut;
      }
      function Pr(Me, M) {
        return Me !== void 0 ? Me : M !== void 0 ? M : void 0;
      }
      function Cr(Me, M) {
        for (let W of M) Me.add(W);
      }
      n(kr, "default", wt);
      class qt {
        constructor(M) {
          n(this, "parsers", {}), n(this, "output", {}), n(this, "errors", []), n(this, "pushToErrors", ((W) => this.errors.push(W))), this.options = kr.useCached(M);
        }
        async read(M) {
          this.file = await (function(W, se) {
            return typeof W == "string" ? Z(W, se) : a && !s && W instanceof HTMLImageElement ? Z(W.src, se) : W instanceof Uint8Array || W instanceof ArrayBuffer || W instanceof DataView ? new w(W) : a && W instanceof Blob ? te(W, se, "blob", j) : void f(L);
          })(M, this.options);
        }
        setup() {
          if (this.fileParser) return;
          let { file: M } = this, W = M.getUint16(0);
          for (let [se, we] of T) if (we.canHandle(M, W)) return this.fileParser = new we(this.options, this.file, this.parsers), M[se] = !0;
          this.file.close && this.file.close(), f("Unknown file format");
        }
        async parse() {
          let { output: M, errors: W } = this;
          return this.setup(), this.options.silentErrors ? (await this.executeParsers().catch(this.pushToErrors), W.push(...this.fileParser.errors)) : await this.executeParsers(), this.file.close && this.file.close(), this.options.silentErrors && W.length > 0 && (M.errors = W), h(se = M) ? void 0 : se;
          var se;
        }
        async executeParsers() {
          let { output: M } = this;
          await this.fileParser.parse();
          let W = Object.values(this.parsers).map((async (se) => {
            let we = await se.parse();
            se.assignToOutput(M, we);
          }));
          this.options.silentErrors && (W = W.map(((se) => se.catch(this.pushToErrors)))), await Promise.all(W);
        }
        async extractThumbnail() {
          this.setup();
          let { options: M, file: W } = this, se = D.get("tiff", M);
          var we;
          if (W.tiff ? we = { start: 0, type: "tiff" } : W.jpeg && (we = await this.fileParser.getOrFindSegment("tiff")), we === void 0) return;
          let $e = await this.fileParser.ensureSegmentChunk(we), ut = this.parsers.tiff = new se($e, M, W), Mt = await ut.extractThumbnail();
          return W.close && W.close(), Mt;
        }
      }
      async function lr(Me, M) {
        let W = new qt(M);
        return await W.read(Me), W.parse();
      }
      var It = Object.freeze({ __proto__: null, parse: lr, Exifr: qt, fileParsers: T, segmentParsers: D, fileReaders: F, tagKeys: ye, tagValues: Se, tagRevivers: Xe, createDictionary: re, extendDictionary: ae, fetchUrlAsArrayBuffer: H, readBlobAsArrayBuffer: j, chunkedProps: at, otherSegments: st, segments: lt, tiffBlocks: rt, segmentsAndBlocks: Rt, tiffExtractables: Fr, inheritables: an, allFormatters: ar, Options: kr });
      class Zr {
        static findPosition(M, W) {
          let se = M.getUint16(W + 2) + 2, we = typeof this.headerLength == "function" ? this.headerLength(M, W, se) : this.headerLength, $e = W + we, ut = se - we;
          return { offset: W, length: se, headerLength: we, start: $e, size: ut, end: $e + ut };
        }
        static parse(M, W = {}) {
          return new this(M, new kr({ [this.type]: W }), M).parse();
        }
        normalizeInput(M) {
          return M instanceof w ? M : new w(M);
        }
        constructor(M, W = {}, se) {
          n(this, "errors", []), n(this, "raw", /* @__PURE__ */ new Map()), n(this, "handleError", ((we) => {
            if (!this.options.silentErrors) throw we;
            this.errors.push(we.message);
          })), this.chunk = this.normalizeInput(M), this.file = se, this.type = this.constructor.type, this.globalOptions = this.options = W, this.localOptions = W[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
        }
        translate() {
          this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
        }
        get output() {
          return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
        }
        translateBlock(M, W) {
          let se = Xe.get(W), we = Se.get(W), $e = ye.get(W), ut = this.options[W], Mt = ut.reviveValues && !!se, Zt = ut.translateValues && !!we, rr = ut.translateKeys && !!$e, Br = {};
          for (let [sr, ue] of M) Mt && se.has(sr) ? ue = se.get(sr)(ue) : Zt && we.has(sr) && (ue = this.translateValue(ue, we.get(sr))), rr && $e.has(sr) && (sr = $e.get(sr) || sr), Br[sr] = ue;
          return Br;
        }
        translateValue(M, W) {
          return W[M] || W.DEFAULT || M;
        }
        assignToOutput(M, W) {
          this.assignObjectToOutput(M, this.constructor.type, W);
        }
        assignObjectToOutput(M, W, se) {
          if (this.globalOptions.mergeOutput) return Object.assign(M, se);
          M[W] ? Object.assign(M[W], se) : M[W] = se;
        }
      }
      n(Zr, "headerLength", 4), n(Zr, "type", void 0), n(Zr, "multiSegment", !1), n(Zr, "canHandle", (() => !1));
      function Cn(Me) {
        return Me === 192 || Me === 194 || Me === 196 || Me === 219 || Me === 221 || Me === 218 || Me === 254;
      }
      function Sn(Me) {
        return Me >= 224 && Me <= 239;
      }
      function vr(Me, M, W) {
        for (let [se, we] of D) if (we.canHandle(Me, M, W)) return se;
      }
      class ln extends class {
        constructor(M, W, se) {
          n(this, "errors", []), n(this, "ensureSegmentChunk", (async (we) => {
            let $e = we.start, ut = we.size || 65536;
            if (this.file.chunked) if (this.file.available($e, ut)) we.chunk = this.file.subarray($e, ut);
            else try {
              we.chunk = await this.file.readChunk($e, ut);
            } catch (Mt) {
              f(`Couldn't read segment: ${JSON.stringify(we)}. ${Mt.message}`);
            }
            else this.file.byteLength > $e + ut ? we.chunk = this.file.subarray($e, ut) : we.size === void 0 ? we.chunk = this.file.subarray($e) : f("Segment unreachable: " + JSON.stringify(we));
            return we.chunk;
          })), this.extendOptions && this.extendOptions(M), this.options = M, this.file = W, this.parsers = se;
        }
        injectSegment(M, W) {
          this.options[M].enabled && this.createParser(M, W);
        }
        createParser(M, W) {
          let se = new (D.get(M))(W, this.options, this.file);
          return this.parsers[M] = se;
        }
        createParsers(M) {
          for (let W of M) {
            let { type: se, chunk: we } = W, $e = this.options[se];
            if ($e && $e.enabled) {
              let ut = this.parsers[se];
              ut && ut.append || ut || this.createParser(se, we);
            }
          }
        }
        async readSegments(M) {
          let W = M.map(this.ensureSegmentChunk);
          await Promise.all(W);
        }
      } {
        constructor(...M) {
          super(...M), n(this, "appSegments", []), n(this, "jpegSegments", []), n(this, "unknownSegments", []);
        }
        static canHandle(M, W) {
          return W === 65496;
        }
        async parse() {
          await this.findAppSegments(), await this.readSegments(this.appSegments), this.mergeMultiSegments(), this.createParsers(this.mergedAppSegments || this.appSegments);
        }
        setupSegmentFinderArgs(M) {
          M === !0 ? (this.findAll = !0, this.wanted = new Set(D.keyList())) : (M = M === void 0 ? D.keyList().filter(((W) => this.options[W].enabled)) : M.filter(((W) => this.options[W].enabled && D.has(W))), this.findAll = !1, this.remaining = new Set(M), this.wanted = new Set(M)), this.unfinishedMultiSegment = !1;
        }
        async findAppSegments(M = 0, W) {
          this.setupSegmentFinderArgs(W);
          let { file: se, findAll: we, wanted: $e, remaining: ut } = this;
          if (!we && this.file.chunked && (we = Array.from($e).some(((Mt) => {
            let Zt = D.get(Mt), rr = this.options[Mt];
            return Zt.multiSegment && rr.multiSegment;
          })), we && await this.file.readWhole()), M = this.findAppSegmentsInRange(M, se.byteLength), !this.options.onlyTiff && se.chunked) {
            let Mt = !1;
            for (; ut.size > 0 && !Mt && (se.canReadNextChunk || this.unfinishedMultiSegment); ) {
              let { nextChunkOffset: Zt } = se, rr = this.appSegments.some(((Br) => !this.file.available(Br.offset || Br.start, Br.length || Br.size)));
              if (Mt = M > Zt && !rr ? !await se.readNextChunk(M) : !await se.readNextChunk(Zt), (M = this.findAppSegmentsInRange(M, se.byteLength)) === void 0) return;
            }
          }
        }
        findAppSegmentsInRange(M, W) {
          W -= 2;
          let se, we, $e, ut, Mt, Zt, { file: rr, findAll: Br, wanted: sr, remaining: ue, options: ze } = this;
          for (; M < W; M++) if (rr.getUint8(M) === 255) {
            if (se = rr.getUint8(M + 1), Sn(se)) {
              if (we = rr.getUint16(M + 2), $e = vr(rr, M, we), $e && sr.has($e) && (ut = D.get($e), Mt = ut.findPosition(rr, M), Zt = ze[$e], Mt.type = $e, this.appSegments.push(Mt), !Br && (ut.multiSegment && Zt.multiSegment ? (this.unfinishedMultiSegment = Mt.chunkNumber < Mt.chunkCount, this.unfinishedMultiSegment || ue.delete($e)) : ue.delete($e), ue.size === 0))) break;
              ze.recordUnknownSegments && (Mt = Zr.findPosition(rr, M), Mt.marker = se, this.unknownSegments.push(Mt)), M += we + 1;
            } else if (Cn(se)) {
              if (we = rr.getUint16(M + 2), se === 218 && ze.stopAfterSos !== !1) return;
              ze.recordJpegSegments && this.jpegSegments.push({ offset: M, length: we, marker: se }), M += we + 1;
            }
          }
          return M;
        }
        mergeMultiSegments() {
          if (!this.appSegments.some(((W) => W.multiSegment))) return;
          let M = (function(W, se) {
            let we, $e, ut, Mt = /* @__PURE__ */ new Map();
            for (let Zt = 0; Zt < W.length; Zt++) we = W[Zt], $e = we[se], Mt.has($e) ? ut = Mt.get($e) : Mt.set($e, ut = []), ut.push(we);
            return Array.from(Mt);
          })(this.appSegments, "type");
          this.mergedAppSegments = M.map((([W, se]) => {
            let we = D.get(W, this.options);
            return we.handleMultiSegments ? { type: W, chunk: we.handleMultiSegments(se) } : se[0];
          }));
        }
        getSegment(M) {
          return this.appSegments.find(((W) => W.type === M));
        }
        async getOrFindSegment(M) {
          let W = this.getSegment(M);
          return W === void 0 && (await this.findAppSegments(0, [M]), W = this.getSegment(M)), W;
        }
      }
      n(ln, "type", "jpeg"), T.set("jpeg", ln);
      const en = [void 0, 1, 1, 2, 4, 8, 1, 1, 2, 4, 8, 4, 8, 4];
      class Fn extends Zr {
        parseHeader() {
          var M = this.chunk.getUint16();
          M === 18761 ? this.le = !0 : M === 19789 && (this.le = !1), this.chunk.le = this.le, this.headerParsed = !0;
        }
        parseTags(M, W, se = /* @__PURE__ */ new Map()) {
          let { pick: we, skip: $e } = this.options[W];
          we = new Set(we);
          let ut = we.size > 0, Mt = $e.size === 0, Zt = this.chunk.getUint16(M);
          M += 2;
          for (let rr = 0; rr < Zt; rr++) {
            let Br = this.chunk.getUint16(M);
            if (ut) {
              if (we.has(Br) && (se.set(Br, this.parseTag(M, Br, W)), we.delete(Br), we.size === 0)) break;
            } else !Mt && $e.has(Br) || se.set(Br, this.parseTag(M, Br, W));
            M += 12;
          }
          return se;
        }
        parseTag(M, W, se) {
          let { chunk: we } = this, $e = we.getUint16(M + 2), ut = we.getUint32(M + 4), Mt = en[$e];
          if (Mt * ut <= 4 ? M += 8 : M = we.getUint32(M + 8), ($e < 1 || $e > 13) && f(`Invalid TIFF value type. block: ${se.toUpperCase()}, tag: ${W.toString(16)}, type: ${$e}, offset ${M}`), M > we.byteLength && f(`Invalid TIFF value offset. block: ${se.toUpperCase()}, tag: ${W.toString(16)}, type: ${$e}, offset ${M} is outside of chunk size ${we.byteLength}`), $e === 1) return we.getUint8Array(M, ut);
          if ($e === 2) return (Zt = (function(rr) {
            for (; rr.endsWith("\0"); ) rr = rr.slice(0, -1);
            return rr;
          })(Zt = we.getString(M, ut)).trim()) === "" ? void 0 : Zt;
          var Zt;
          if ($e === 7) return we.getUint8Array(M, ut);
          if (ut === 1) return this.parseTagValue($e, M);
          {
            let rr = new ((function(sr) {
              switch (sr) {
                case 1:
                  return Uint8Array;
                case 3:
                  return Uint16Array;
                case 4:
                  return Uint32Array;
                case 5:
                  return Array;
                case 6:
                  return Int8Array;
                case 8:
                  return Int16Array;
                case 9:
                  return Int32Array;
                case 10:
                  return Array;
                case 11:
                  return Float32Array;
                case 12:
                  return Float64Array;
                default:
                  return Array;
              }
            })($e))(ut), Br = Mt;
            for (let sr = 0; sr < ut; sr++) rr[sr] = this.parseTagValue($e, M), M += Br;
            return rr;
          }
        }
        parseTagValue(M, W) {
          let { chunk: se } = this;
          switch (M) {
            case 1:
              return se.getUint8(W);
            case 3:
              return se.getUint16(W);
            case 4:
              return se.getUint32(W);
            case 5:
              return se.getUint32(W) / se.getUint32(W + 4);
            case 6:
              return se.getInt8(W);
            case 8:
              return se.getInt16(W);
            case 9:
              return se.getInt32(W);
            case 10:
              return se.getInt32(W) / se.getInt32(W + 4);
            case 11:
              return se.getFloat(W);
            case 12:
              return se.getDouble(W);
            case 13:
              return se.getUint32(W);
            default:
              f(`Invalid tiff type ${M}`);
          }
        }
      }
      class gn extends Fn {
        static canHandle(M, W) {
          return M.getUint8(W + 1) === 225 && M.getUint32(W + 4) === 1165519206 && M.getUint16(W + 8) === 0;
        }
        async parse() {
          this.parseHeader();
          let { options: M } = this;
          return M.ifd0.enabled && await this.parseIfd0Block(), M.exif.enabled && await this.safeParse("parseExifBlock"), M.gps.enabled && await this.safeParse("parseGpsBlock"), M.interop.enabled && await this.safeParse("parseInteropBlock"), M.ifd1.enabled && await this.safeParse("parseThumbnailBlock"), this.createOutput();
        }
        safeParse(M) {
          let W = this[M]();
          return W.catch !== void 0 && (W = W.catch(this.handleError)), W;
        }
        findIfd0Offset() {
          this.ifd0Offset === void 0 && (this.ifd0Offset = this.chunk.getUint32(4));
        }
        findIfd1Offset() {
          if (this.ifd1Offset === void 0) {
            this.findIfd0Offset();
            let M = this.chunk.getUint16(this.ifd0Offset), W = this.ifd0Offset + 2 + 12 * M;
            this.ifd1Offset = this.chunk.getUint32(W);
          }
        }
        parseBlock(M, W) {
          let se = /* @__PURE__ */ new Map();
          return this[W] = se, this.parseTags(M, W, se), se;
        }
        async parseIfd0Block() {
          if (this.ifd0) return;
          let { file: M } = this;
          this.findIfd0Offset(), this.ifd0Offset < 8 && f("Malformed EXIF data"), !M.chunked && this.ifd0Offset > M.byteLength && f(`IFD0 offset points to outside of file.
this.ifd0Offset: ${this.ifd0Offset}, file.byteLength: ${M.byteLength}`), M.tiff && await M.ensureChunk(this.ifd0Offset, p(this.options));
          let W = this.parseBlock(this.ifd0Offset, "ifd0");
          return W.size !== 0 ? (this.exifOffset = W.get(it), this.interopOffset = W.get(qe), this.gpsOffset = W.get(mt), this.xmp = W.get(700), this.iptc = W.get(le), this.icc = W.get(ve), this.options.sanitize && (W.delete(it), W.delete(qe), W.delete(mt), W.delete(700), W.delete(le), W.delete(ve)), W) : void 0;
        }
        async parseExifBlock() {
          if (this.exif || (this.ifd0 || await this.parseIfd0Block(), this.exifOffset === void 0)) return;
          this.file.tiff && await this.file.ensureChunk(this.exifOffset, p(this.options));
          let M = this.parseBlock(this.exifOffset, "exif");
          return this.interopOffset || (this.interopOffset = M.get(qe)), this.makerNote = M.get(Ve), this.userComment = M.get(He), this.options.sanitize && (M.delete(qe), M.delete(Ve), M.delete(He)), this.unpack(M, 41728), this.unpack(M, 41729), M;
        }
        unpack(M, W) {
          let se = M.get(W);
          se && se.length === 1 && M.set(W, se[0]);
        }
        async parseGpsBlock() {
          if (this.gps || (this.ifd0 || await this.parseIfd0Block(), this.gpsOffset === void 0)) return;
          let M = this.parseBlock(this.gpsOffset, "gps");
          return M && M.has(2) && M.has(4) && (M.set("latitude", Gn(...M.get(2), M.get(1))), M.set("longitude", Gn(...M.get(4), M.get(3)))), M;
        }
        async parseInteropBlock() {
          if (!this.interop && (this.ifd0 || await this.parseIfd0Block(), this.interopOffset !== void 0 || this.exif || await this.parseExifBlock(), this.interopOffset !== void 0)) return this.parseBlock(this.interopOffset, "interop");
        }
        async parseThumbnailBlock(M = !1) {
          if (!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || M)) return this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = !0), this.ifd1;
        }
        async extractThumbnail() {
          if (this.headerParsed || this.parseHeader(), this.ifd1Parsed || await this.parseThumbnailBlock(!0), this.ifd1 === void 0) return;
          let M = this.ifd1.get(513), W = this.ifd1.get(514);
          return this.chunk.getUint8Array(M, W);
        }
        get image() {
          return this.ifd0;
        }
        get thumbnail() {
          return this.ifd1;
        }
        createOutput() {
          let M, W, se, we = {};
          for (W of rt) if (M = this[W], !h(M)) if (se = this.canTranslate ? this.translateBlock(M, W) : Object.fromEntries(M), this.options.mergeOutput) {
            if (W === "ifd1") continue;
            Object.assign(we, se);
          } else we[W] = se;
          return this.makerNote && (we.makerNote = this.makerNote), this.userComment && (we.userComment = this.userComment), we;
        }
        assignToOutput(M, W) {
          if (this.globalOptions.mergeOutput) Object.assign(M, W);
          else for (let [se, we] of Object.entries(W)) this.assignObjectToOutput(M, se, we);
        }
      }
      function Gn(Me, M, W, se) {
        var we = Me + M / 60 + W / 3600;
        return se !== "S" && se !== "W" || (we *= -1), we;
      }
      n(gn, "type", "tiff"), n(gn, "headerLength", 10), D.set("tiff", gn);
      var Hn = Object.freeze({ __proto__: null, default: It, Exifr: qt, fileParsers: T, segmentParsers: D, fileReaders: F, tagKeys: ye, tagValues: Se, tagRevivers: Xe, createDictionary: re, extendDictionary: ae, fetchUrlAsArrayBuffer: H, readBlobAsArrayBuffer: j, chunkedProps: at, otherSegments: st, segments: lt, tiffBlocks: rt, segmentsAndBlocks: Rt, tiffExtractables: Fr, inheritables: an, allFormatters: ar, Options: kr, parse: lr });
      const tn = { ifd0: !1, ifd1: !1, exif: !1, gps: !1, interop: !1, sanitize: !1, reviveValues: !0, translateKeys: !1, translateValues: !1, mergeOutput: !1 }, mn = Object.assign({}, tn, { firstChunkSize: 4e4, gps: [1, 2, 3, 4] }), In = Object.assign({}, tn, { tiff: !1, ifd1: !0, mergeOutput: !1 }), vn = Object.assign({}, tn, { firstChunkSize: 4e4, ifd0: [274] });
      async function fr(Me) {
        let M = new qt(vn);
        await M.read(Me);
        let W = await M.parse();
        if (W && W.ifd0) return W.ifd0[274];
      }
      const Or = Object.freeze({ 1: { dimensionSwapped: !1, scaleX: 1, scaleY: 1, deg: 0, rad: 0 }, 2: { dimensionSwapped: !1, scaleX: -1, scaleY: 1, deg: 0, rad: 0 }, 3: { dimensionSwapped: !1, scaleX: 1, scaleY: 1, deg: 180, rad: 180 * Math.PI / 180 }, 4: { dimensionSwapped: !1, scaleX: -1, scaleY: 1, deg: 180, rad: 180 * Math.PI / 180 }, 5: { dimensionSwapped: !0, scaleX: 1, scaleY: -1, deg: 90, rad: 90 * Math.PI / 180 }, 6: { dimensionSwapped: !0, scaleX: 1, scaleY: 1, deg: 90, rad: 90 * Math.PI / 180 }, 7: { dimensionSwapped: !0, scaleX: 1, scaleY: -1, deg: 270, rad: 270 * Math.PI / 180 }, 8: { dimensionSwapped: !0, scaleX: 1, scaleY: 1, deg: 270, rad: 270 * Math.PI / 180 } });
      if (t.rotateCanvas = !0, t.rotateCss = !0, typeof navigator == "object") {
        let Me = navigator.userAgent;
        if (Me.includes("iPad") || Me.includes("iPhone")) {
          let M = Me.match(/OS (\d+)_(\d+)/);
          if (M) {
            let [, W, se] = M, we = Number(W) + 0.1 * Number(se);
            t.rotateCanvas = we < 13.4, t.rotateCss = !1;
          }
        } else if (Me.includes("OS X 10")) {
          let [, M] = Me.match(/OS X 10[_.](\d+)/);
          t.rotateCanvas = t.rotateCss = Number(M) < 15;
        }
        if (Me.includes("Chrome/")) {
          let [, M] = Me.match(/Chrome\/(\d+)/);
          t.rotateCanvas = t.rotateCss = Number(M) < 81;
        } else if (Me.includes("Firefox/")) {
          let [, M] = Me.match(/Firefox\/(\d+)/);
          t.rotateCanvas = t.rotateCss = Number(M) < 77;
        }
      }
      class sn extends w {
        constructor(...M) {
          super(...M), n(this, "ranges", new yt()), this.byteLength !== 0 && this.ranges.add(0, this.byteLength);
        }
        _tryExtend(M, W, se) {
          if (M === 0 && this.byteLength === 0 && se) {
            let we = new DataView(se.buffer || se, se.byteOffset, se.byteLength);
            this._swapDataView(we);
          } else {
            let we = M + W;
            if (we > this.byteLength) {
              let { dataView: $e } = this._extend(we);
              this._swapDataView($e);
            }
          }
        }
        _extend(M) {
          let W;
          W = u ? l.allocUnsafe(M) : new Uint8Array(M);
          let se = new DataView(W.buffer, W.byteOffset, W.byteLength);
          return W.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), { uintView: W, dataView: se };
        }
        subarray(M, W, se = !1) {
          return W = W || this._lengthToEnd(M), se && this._tryExtend(M, W), this.ranges.add(M, W), super.subarray(M, W);
        }
        set(M, W, se = !1) {
          se && this._tryExtend(W, M.byteLength, M);
          let we = super.set(M, W);
          return this.ranges.add(W, we.byteLength), we;
        }
        async ensureChunk(M, W) {
          this.chunked && (this.ranges.available(M, W) || await this.readChunk(M, W));
        }
        available(M, W) {
          return this.ranges.available(M, W);
        }
      }
      class yt {
        constructor() {
          n(this, "list", []);
        }
        get length() {
          return this.list.length;
        }
        add(M, W, se = 0) {
          let we = M + W, $e = this.list.filter(((ut) => yn(M, ut.offset, we) || yn(M, ut.end, we)));
          if ($e.length > 0) {
            M = Math.min(M, ...$e.map(((Mt) => Mt.offset))), we = Math.max(we, ...$e.map(((Mt) => Mt.end))), W = we - M;
            let ut = $e.shift();
            ut.offset = M, ut.length = W, ut.end = we, this.list = this.list.filter(((Mt) => !$e.includes(Mt)));
          } else this.list.push({ offset: M, length: W, end: we });
        }
        available(M, W) {
          let se = M + W;
          return this.list.some(((we) => we.offset <= M && se <= we.end));
        }
      }
      function yn(Me, M, W) {
        return Me <= M && M <= W;
      }
      class Nn extends sn {
        constructor(M, W) {
          super(0), n(this, "chunksRead", 0), this.input = M, this.options = W;
        }
        async readWhole() {
          this.chunked = !1, await this.readChunk(this.nextChunkOffset);
        }
        async readChunked() {
          this.chunked = !0, await this.readChunk(0, this.options.firstChunkSize);
        }
        async readNextChunk(M = this.nextChunkOffset) {
          if (this.fullyRead) return this.chunksRead++, !1;
          let W = this.options.chunkSize, se = await this.readChunk(M, W);
          return !!se && se.byteLength === W;
        }
        async readChunk(M, W) {
          if (this.chunksRead++, (W = this.safeWrapAddress(M, W)) !== 0) return this._readChunk(M, W);
        }
        safeWrapAddress(M, W) {
          return this.size !== void 0 && M + W > this.size ? Math.max(0, this.size - M) : W;
        }
        get nextChunkOffset() {
          if (this.ranges.list.length !== 0) return this.ranges.list[0].length;
        }
        get canReadNextChunk() {
          return this.chunksRead < this.options.chunkLimit;
        }
        get fullyRead() {
          return this.size !== void 0 && this.nextChunkOffset === this.size;
        }
        read() {
          return this.options.chunked ? this.readChunked() : this.readWhole();
        }
        close() {
        }
      }
      F.set("blob", class extends Nn {
        async readWhole() {
          this.chunked = !1;
          let Me = await j(this.input);
          this._swapArrayBuffer(Me);
        }
        readChunked() {
          return this.chunked = !0, this.size = this.input.size, super.readChunked();
        }
        async _readChunk(Me, M) {
          let W = M ? Me + M : void 0, se = this.input.slice(Me, W), we = await j(se);
          return this.set(we, Me, !0);
        }
      }), t.Exifr = qt, t.Options = kr, t.allFormatters = ar, t.chunkedProps = at, t.createDictionary = re, t.default = Hn, t.extendDictionary = ae, t.fetchUrlAsArrayBuffer = H, t.fileParsers = T, t.fileReaders = F, t.gps = async function(Me) {
        let M = new qt(mn);
        await M.read(Me);
        let W = await M.parse();
        if (W && W.gps) {
          let { latitude: se, longitude: we } = W.gps;
          return { latitude: se, longitude: we };
        }
      }, t.gpsOnlyOptions = mn, t.inheritables = an, t.orientation = fr, t.orientationOnlyOptions = vn, t.otherSegments = st, t.parse = lr, t.readBlobAsArrayBuffer = j, t.rotation = async function(Me) {
        let M = await fr(Me);
        return Object.assign({ canvas: t.rotateCanvas, css: t.rotateCss }, Or[M]);
      }, t.rotations = Or, t.segmentParsers = D, t.segments = lt, t.segmentsAndBlocks = Rt, t.tagKeys = ye, t.tagRevivers = Xe, t.tagValues = Se, t.thumbnail = async function(Me) {
        let M = new qt(In);
        await M.read(Me);
        let W = await M.extractThumbnail();
        return W && u ? l.from(W) : W;
      }, t.thumbnailOnlyOptions = In, t.thumbnailUrl = async function(Me) {
        let M = await this.thumbnail(Me);
        if (M !== void 0) {
          let W = new Blob([M]);
          return URL.createObjectURL(W);
        }
      }, t.tiffBlocks = rt, t.tiffExtractables = Fr, Object.defineProperty(t, "__esModule", { value: !0 });
    }));
  })(gp, gp.exports)), gp.exports;
}
var XN = YN();
let Gg = null;
const JN = (r) => new Promise((e) => {
  if (z0(r) !== "image/jpeg")
    return e(1);
  XN.orientation(r).then((n) => e(n || 1)).catch(() => e(1));
}), KN = async () => {
  if (Gg !== null)
    return !Gg;
  const e = await cg("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAIAAwMBEQACEQEDEQH/xABRAAEAAAAAAAAAAAAAAAAAAAAKEAEBAQADAQEAAAAAAAAAAAAGBQQDCAkCBwEBAAAAAAAAAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AG8T9NfSMEVMhQvoP3fFiRZ+MTHDifa/95OFSZU5OzRzxkyejv8ciEfhSceSXGjS8eSdLnZc2HDm4M3BxcXwH/9k=");
  return Gg = e.width === 2 && e.height === 3, !Gg;
}, ZN = (r) => {
  const t = r.naturalWidth / r.naturalHeight;
  return r.naturalHeight <= 8192 && r.naturalWidth <= 8192 ? [r.naturalWidth, r.naturalHeight] : r.naturalHeight > r.naturalWidth ? [t * 8192, 8192] : [8192, 8192 / t];
}, e8 = async (r) => {
  const e = await PN(r), t = await cg(e), [n, i] = ZN(t);
  if (!await KN()) {
    const h = Pc(n, i);
    return h.getContext("2d")?.drawImage(t, 0, 0, n, i), h;
  }
  const s = await JN(r), [o, l] = s > 4 ? [i, n] : [n, i], u = Pc(o, l), c = u.getContext("2d");
  switch (s) {
    case 2:
      c.translate(o, 0), c.scale(-1, 1);
      break;
    case 3:
      c.translate(o, l), c.rotate(Math.PI);
      break;
    case 4:
      c.translate(0, l), c.scale(1, -1);
      break;
    case 5:
      c.rotate(-0.5 * Math.PI), c.scale(-1, 1);
      break;
    case 6:
      c.rotate(-0.5 * Math.PI), c.translate(-o, 0);
      break;
    case 7:
      c.rotate(-0.5 * Math.PI), c.translate(-o, l), c.scale(1, -1);
      break;
    case 8:
      c.rotate(0.5 * Math.PI), c.translate(0, -l);
      break;
  }
  return c.drawImage(t, 0, 0, o, l), u;
}, G0 = async (r) => {
  const e = await e8(r);
  return z0(r) === "image/jpeg" ? {
    dataUrl: e.toDataURL("image/jpeg", 1),
    height: e.height,
    width: e.width
  } : {
    dataUrl: e.toDataURL(),
    height: e.height,
    width: e.width
  };
};
let t8 = class extends Error {
  reason;
  filename;
  line;
  column;
  source;
  constructor(e, t, n, i, a) {
    super(`${e}:${n}:${i}: ${t}`), this.reason = t, this.filename = e, this.line = n, this.column = i, this.source = a;
  }
}, r8 = class {
  start;
  end;
  source;
  constructor(e, t, n) {
    this.start = e, this.end = t, this.source = n;
  }
};
var zn;
(function(r) {
  r.stylesheet = "stylesheet", r.rule = "rule", r.declaration = "declaration", r.comment = "comment", r.atRule = "at-rule", r.container = "container", r.charset = "charset", r.counterStyle = "counter-style", r.document = "document", r.customMedia = "custom-media", r.fontFace = "font-face", r.fontFeatureValues = "font-feature-values", r.host = "host", r.import = "import", r.keyframes = "keyframes", r.keyframe = "keyframe", r.layer = "layer", r.media = "media", r.namespace = "namespace", r.page = "page", r.pageMarginBox = "page-margin-box", r.positionTry = "position-try", r.property = "property", r.scope = "scope", r.startingStyle = "starting-style", r.supports = "supports", r.viewTransition = "view-transition";
})(zn || (zn = {}));
const $S = (r, e, t) => {
  let n = t, i = 1e4;
  do {
    const a = e.map((l) => r.indexOf(l, n));
    a.push(r.indexOf("\\", n));
    const s = a.filter((l) => l !== -1);
    if (s.length === 0) return -1;
    const o = Math.min(...s);
    if (r[o] !== "\\") return o;
    n = o + 2, i--;
  } while (i > 0);
  throw new Error("Too many escaping");
}, fc = (r, e, t) => {
  let n = t, i = 1e4;
  do {
    const a = e.map((l) => r.indexOf(l, n));
    a.push(r.indexOf("(", n)), a.push(r.indexOf('"', n)), a.push(r.indexOf("'", n)), a.push(r.indexOf("\\", n));
    const s = a.filter((l) => l !== -1);
    if (s.length === 0) return -1;
    const o = Math.min(...s);
    switch (r[o]) {
      case "\\":
        n = o + 2;
        break;
      case "(":
        {
          const l = fc(r, [")"], o + 1);
          if (l === -1) return -1;
          n = l + 1;
        }
        break;
      case '"':
        {
          const l = $S(r, ['"'], o + 1);
          if (l === -1) return -1;
          n = l + 1;
        }
        break;
      case "'":
        {
          const l = $S(r, ["'"], o + 1);
          if (l === -1) return -1;
          n = l + 1;
        }
        break;
      default:
        return o;
    }
    i--;
  } while (i > 0);
  throw new Error("Too many escaping");
}, Xv = /\/\*[^]*?(?:\*\/|$)/g;
function as(r) {
  return r ? r.trim() : "";
}
function g1(r, e) {
  const t = r && typeof r.type == "string", n = t ? r : e;
  for (const i in r) {
    const a = r[i];
    Array.isArray(a) ? a.forEach((s) => {
      g1(s, n);
    }) : a && typeof a == "object" && g1(a, n);
  }
  return t && Object.defineProperty(r, "parent", { configurable: !0, writable: !0, enumerable: !1, value: e || null }), r;
}
const FI = (r, e) => {
  e = e || {};
  let t = 1, n = 1;
  function i() {
    const H = { line: t, column: n };
    return (j) => (j.position = new r8(H, { line: t, column: n }, e?.source || ""), c(), j);
  }
  const a = [];
  function s(H) {
    const j = new t8(e?.source || "", H, t, n, r);
    if (!e?.silent) throw j;
    a.push(j);
  }
  function o() {
    const H = /^{\s*/.exec(r);
    return !!H && (u(H), !0);
  }
  function l() {
    const H = /^}/.exec(r);
    return !!H && (u(H), !0);
  }
  function u(H) {
    const j = H[0];
    return (function(q) {
      const re = q.match(/\n/g);
      re && (t += re.length);
      const ae = q.lastIndexOf(`
`);
      n = ~ae ? q.length - ae : n + q.length;
    })(j), r = r.slice(j.length), H;
  }
  function c() {
    const H = /^\s*/.exec(r);
    H && u(H);
  }
  function h(H) {
    H = H || [];
    let j = f();
    for (; j; ) H.push(j), j = f();
    return H;
  }
  function f() {
    const H = i();
    if (r.charAt(0) !== "/" || r.charAt(1) !== "*") return;
    const j = /^\/\*[^]*?\*\//.exec(r);
    return j ? (u(j), H({ type: zn.comment, comment: j[0].slice(2, -2) })) : s("End of comment missing");
  }
  function p() {
    const H = fc(r, ["{"]);
    if (H === -1 || H === 0) return;
    const j = r.substring(0, H);
    return u([j]), ((q, re) => {
      const ae = [];
      let ye = 0;
      for (; ye < q.length; ) {
        const Se = fc(q, re, ye);
        if (Se === -1) return ae.push(q.substring(ye)), ae;
        ae.push(q.substring(ye, Se)), ye = Se + 1;
      }
      return ae;
    })(as(j).replace(Xv, ""), [","]).map((q) => as(q));
  }
  function m() {
    const H = i(), j = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/.exec(r);
    if (!j) return;
    u(j);
    const q = as(j[0]), re = /^:\s*/.exec(r);
    if (!re) return s("property missing ':'");
    u(re);
    let ae = "";
    const ye = fc(r, [";", "}"]);
    ye !== -1 && (ae = r.substring(0, ye), u([ae]), ae = as(ae).replace(Xv, ""));
    const Se = H({ type: zn.declaration, property: q.replace(Xv, ""), value: ae }), Xe = /^[;\s]*/.exec(r);
    return Xe && u(Xe), Se;
  }
  function A() {
    const H = [];
    if (!o()) return s("missing '{'");
    h(H);
    let j = m();
    for (; j; ) H.push(j), h(H), j = m();
    for (; e?.silent && r.length && r.charAt(0) !== "}"; ) {
      const q = r.indexOf(";"), re = r.indexOf("}");
      if (q === -1 || !(re === -1 || q < re)) break;
      for (u([r.substring(0, q + 1)]), c(), h(H), j = m(); j; ) H.push(j), h(H), j = m();
    }
    return l() ? H : s("missing '}'");
  }
  function w() {
    const H = fc(r, ["{"]);
    if (H === -1) return !1;
    const j = fc(r, [";"]), q = fc(r, ["}"]);
    return !(j !== -1 && j < H) && !(q !== -1 && q < H);
  }
  function x() {
    const H = [];
    if (!o()) return s("missing '{'");
    for (h(H); r.length && r.charAt(0) !== "}"; ) {
      if (r.charAt(0) === "@") {
        const q = te();
        if (q) {
          H.push(q), h(H);
          continue;
        }
      }
      if (w()) {
        const q = de();
        if (q) {
          H.push(q), h(H);
          continue;
        }
      }
      const j = m();
      if (!j) {
        if (e?.silent) {
          const q = r.indexOf(";"), re = r.indexOf("}");
          if (q !== -1 && (re === -1 || q < re)) {
            u([r.substring(0, q + 1)]), c(), h(H);
            continue;
          }
        }
        break;
      }
      H.push(j), h(H);
    }
    return l() ? H : s("missing '}'");
  }
  function E() {
    const H = [];
    for (c(), h(H); r.length && r.charAt(0) !== "}"; ) {
      if (r.charAt(0) === "@") {
        const q = te();
        if (q) {
          H.push(q), h(H);
          continue;
        }
      }
      if (w()) {
        const q = de();
        if (q) {
          H.push(q), h(H);
          continue;
        }
      }
      const j = m();
      if (!j) {
        if (e?.silent) {
          const q = r.indexOf(";"), re = r.indexOf("}");
          if (q !== -1 && (re === -1 || q < re)) {
            u([r.substring(0, q + 1)]), c(), h(H);
            continue;
          }
        }
        break;
      }
      H.push(j), h(H);
    }
    return H;
  }
  function T() {
    const H = [], j = i();
    let q = /^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/.exec(r);
    for (; q; ) {
      const re = u(q);
      H.push(re[1]);
      const ae = /^,\s*/.exec(r);
      ae && u(ae), q = /^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/.exec(r);
    }
    if (H.length) return j({ type: zn.keyframe, values: H, declarations: A() || [] });
  }
  const D = new RegExp(`^@(${["top-left-corner", "top-left", "top-center", "top-right", "top-right-corner", "bottom-left-corner", "bottom-left", "bottom-center", "bottom-right", "bottom-right-corner", "left-top", "left-middle", "left-bottom", "right-top", "right-middle", "right-bottom"].join("|")})(?![\\w-])\\s*`), F = Z("import"), _ = Z("charset"), L = Z("namespace");
  function Z(H) {
    const j = new RegExp("^@" + H + `\\s*((?::?[^;'"]|"(?:\\\\"|[^"])*?"|'(?:\\\\'|[^'])*?')+)(?:;|$)`);
    return () => {
      const q = i(), re = j.exec(r);
      if (!re) return;
      const ae = u(re), ye = { type: H };
      return ye[H] = ae[1].trim(), q(ye);
    };
  }
  function te() {
    if (r[0] === "@") return (function() {
      const H = i(), j = /^@([-\w]+)?keyframes\s*/.exec(r);
      if (!j) return;
      const q = u(j)[1], re = /^([-\w]+)\s*/.exec(r);
      if (!re) return s("@keyframes missing name");
      const ae = u(re)[1];
      if (!o()) return s("@keyframes missing '{'");
      let ye = h(), Se = T();
      for (; Se; ) ye.push(Se), ye = ye.concat(h()), Se = T();
      return l() ? H({ type: zn.keyframes, name: ae, vendor: q, keyframes: ye }) : s("@keyframes missing '}'");
    })() || (function() {
      const H = i(), j = /^@media *([^{]+)/.exec(r);
      if (!j) return;
      const q = as(u(j)[1]);
      if (!o()) return s("@media missing '{'");
      const re = E();
      return l() ? H({ type: zn.media, media: q, rules: re }) : s("@media missing '}'");
    })() || (function() {
      const H = i(), j = /^@custom-media\s+(--\S+)\s+([^{;\s][^{;]*);/.exec(r);
      if (!j) return;
      const q = u(j);
      return H({ type: zn.customMedia, name: as(q[1]), media: as(q[2]) });
    })() || (function() {
      const H = i(), j = /^@supports *([^{]+)/.exec(r);
      if (!j) return;
      const q = as(u(j)[1]);
      if (!o()) return s("@supports missing '{'");
      const re = E();
      return l() ? H({ type: zn.supports, supports: q, rules: re }) : s("@supports missing '}'");
    })() || F() || _() || L() || (function() {
      const H = i(), j = /^@([-\w]+)?document *([^{]+)/.exec(r);
      if (!j) return;
      const q = u(j), re = as(q[1]), ae = as(q[2]);
      if (!o()) return s("@document missing '{'");
      const ye = E();
      return l() ? H({ type: zn.document, document: ae, vendor: re, rules: ye }) : s("@document missing '}'");
    })() || (function() {
      const H = i(), j = /^@page */.exec(r);
      if (!j) return;
      u(j);
      const q = p() || [];
      if (!o()) return s("@page missing '{'");
      const re = [];
      for (h(re); r.length && r.charAt(0) !== "}"; ) {
        if (r.charAt(0) === "@") {
          const ye = te();
          if (ye) {
            re.push(ye), h(re);
            continue;
          }
        }
        const ae = m();
        if (!ae) break;
        re.push(ae), h(re);
      }
      return l() ? H({ type: zn.page, selectors: q, declarations: re }) : s("@page missing '}'");
    })() || (function() {
      const H = i(), j = /^@host\s*/.exec(r);
      if (!j) return;
      if (u(j), !o()) return s("@host missing '{'");
      const q = E();
      return l() ? H({ type: zn.host, rules: q }) : s("@host missing '}'");
    })() || (function() {
      const H = i(), j = /^@font-face\s*/.exec(r);
      if (!j) return;
      if (u(j), !o()) return s("@font-face missing '{'");
      let q = h(), re = m();
      for (; re; ) q.push(re), q = q.concat(h()), re = m();
      return l() ? H({ type: zn.fontFace, declarations: q }) : s("@font-face missing '}'");
    })() || (function() {
      const H = i(), j = /^@font-feature-values\s+([^{]+)/.exec(r);
      if (!j) return;
      const q = as(u(j)[1]);
      if (!o()) return s("@font-feature-values missing '{'");
      const re = E();
      return l() ? H({ type: zn.fontFeatureValues, fontFamily: q, rules: re }) : s("@font-feature-values missing '}'");
    })() || (function() {
      const H = i(), j = /^@container *([^{]+)/.exec(r);
      if (!j) return;
      const q = as(u(j)[1]);
      if (!o()) return s("@container missing '{'");
      const re = E();
      return l() ? H({ type: zn.container, container: q, rules: re }) : s("@container missing '}'");
    })() || (function() {
      const H = i(), j = /^@starting-style\s*/.exec(r);
      if (!j) return;
      if (u(j), !o()) return s("@starting-style missing '{'");
      const q = E();
      return l() ? H({ type: zn.startingStyle, rules: q }) : s("@starting-style missing '}'");
    })() || (function() {
      const H = i(), j = /^@layer *([^{;@]+)/.exec(r);
      if (!j) return;
      const q = as(u(j)[1]);
      if (!o()) {
        const ae = /^[;\s]*/.exec(r);
        return ae && u(ae), H({ type: zn.layer, layer: q });
      }
      const re = E();
      return l() ? H({ type: zn.layer, layer: q, rules: re }) : s("@layer missing '}'");
    })() || (function() {
      const H = i(), j = /^@property\s+(--[-\w]+)\s*/.exec(r);
      if (!j) return;
      const q = u(j)[1];
      if (!o()) return s("@property missing '{'");
      let re = h(), ae = m();
      for (; ae; ) re.push(ae), re = re.concat(h()), ae = m();
      return l() ? H({ type: zn.property, name: q, declarations: re }) : s("@property missing '}'");
    })() || (function() {
      const H = i(), j = /^@counter-style\s+([-\w]+)\s*/.exec(r);
      if (!j) return;
      const q = u(j)[1];
      if (!o()) return s("@counter-style missing '{'");
      let re = h(), ae = m();
      for (; ae; ) re.push(ae), re = re.concat(h()), ae = m();
      return l() ? H({ type: zn.counterStyle, name: q, declarations: re }) : s("@counter-style missing '}'");
    })() || (function() {
      const H = i(), j = /^@scope\s*([^{]*)/.exec(r);
      if (!j) return;
      const q = as(u(j)[1]);
      if (!o()) return s("@scope missing '{'");
      const re = E();
      return l() ? H({ type: zn.scope, scope: q, rules: re }) : s("@scope missing '}'");
    })() || (function() {
      const H = i(), j = /^@view-transition\s*/.exec(r);
      if (!j) return;
      if (u(j), !o()) return s("@view-transition missing '{'");
      let q = h(), re = m();
      for (; re; ) q.push(re), q = q.concat(h()), re = m();
      return l() ? H({ type: zn.viewTransition, declarations: q }) : s("@view-transition missing '}'");
    })() || (function() {
      const H = i(), j = /^@position-try\s+(--[-\w]+)\s*/.exec(r);
      if (!j) return;
      const q = u(j)[1];
      if (!o()) return s("@position-try missing '{'");
      let re = h(), ae = m();
      for (; ae; ) re.push(ae), re = re.concat(h()), ae = m();
      return l() ? H({ type: zn.positionTry, name: q, declarations: re }) : s("@position-try missing '}'");
    })() || (function() {
      const H = i(), j = D.exec(r);
      if (!j) return;
      const q = u(j)[1];
      if (!o()) return s(`@${q} missing '{'`);
      let re = h(), ae = m();
      for (; ae; ) re.push(ae), re = re.concat(h()), ae = m();
      return l() ? H({ type: zn.pageMarginBox, name: q, declarations: re }) : s(`@${q} missing '}'`);
    })() || (function() {
      const H = i(), j = /^@([-\w]+)\s*/.exec(r);
      if (!j) return;
      const q = u(j)[1];
      let re = "";
      const ae = fc(r, ["{", ";"]);
      if (ae !== -1 && ae > 0 && (re = as(r.substring(0, ae)), u([r.substring(0, ae)])), o()) {
        const Se = E();
        return l() ? H({ type: zn.atRule, name: q, prelude: re, rules: Se }) : s(`@${q} missing '}'`);
      }
      const ye = /^[;\s]*/.exec(r);
      return ye && u(ye), H({ type: zn.atRule, name: q, prelude: re });
    })();
  }
  function de() {
    const H = i(), j = p();
    return j ? (h(), H({ type: zn.rule, selectors: j, declarations: x() || [] })) : s("selector missing");
  }
  return g1((function() {
    const H = (function() {
      let j;
      const q = [];
      for (c(), h(q); r.length; ) {
        if (r.charAt(0) === "}") {
          if (e?.silent) {
            s("extra '}'"), u(["}"]), c(), h(q);
            continue;
          }
          break;
        }
        if (j = te() || de(), !j) {
          if (e?.silent) {
            u([r.charAt(0)]), c(), h(q);
            continue;
          }
          break;
        }
        q.push(j), h(q);
      }
      return q;
    })();
    return { type: zn.stylesheet, stylesheet: { source: e?.source, rules: H, parsingErrors: a } };
  })());
};
function Nc(r) {
  return Array.isArray ? Array.isArray(r) : PI(r) === "[object Array]";
}
function n8(r) {
  if (typeof r == "string") return r;
  if (typeof r == "bigint") return r.toString();
  const e = r + "";
  return e == "0" && 1 / r == -1 / 0 ? "-0" : e;
}
function m1(r) {
  return r == null ? "" : n8(r);
}
function ss(r) {
  return typeof r == "string";
}
function Gm(r) {
  return typeof r == "number";
}
function i8(r) {
  return r === !0 || r === !1 || a8(r) && PI(r) == "[object Boolean]";
}
function II(r) {
  return typeof r == "object";
}
function a8(r) {
  return II(r) && r !== null;
}
function Qs(r) {
  return r != null;
}
function Hg(r) {
  return !r.trim().length;
}
function PI(r) {
  return r == null ? r === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(r);
}
const s8 = "Incorrect 'index' type", v1 = "Invalid doc index: must be a non-negative integer within the bounds of the docs array", o8 = (r) => `Invalid value for key ${r}`, l8 = (r) => `Pattern length exceeds max of ${r}.`, u8 = (r) => `Missing ${r} property in key`, c8 = (r) => `Property 'weight' in key '${r}' must be a positive integer`, f8 = "Fuse.match does not support useTokenSearch: token search requires corpus-level statistics (df, fieldCount) that a one-off string comparison does not have. Use new Fuse(...).search(...) instead.", zS = Object.prototype.hasOwnProperty;
var d8 = class {
  constructor(r) {
    this._keys = [], this._keyMap = {};
    let e = 0;
    r.forEach((t) => {
      const n = DI(t);
      this._keys.push(n), this._keyMap[n.id] = n, e += n.weight;
    }), this._keys.forEach((t) => {
      t.weight /= e;
    });
  }
  get(r) {
    return this._keyMap[r];
  }
  keys() {
    return this._keys;
  }
  toJSON() {
    return JSON.stringify(this._keys);
  }
};
function DI(r) {
  let e = null, t = null, n = null, i = 1, a = null;
  if (ss(r) || Nc(r))
    n = r, e = GS(r), t = Hm(r);
  else {
    if (!zS.call(r, "name")) throw new Error(u8("name"));
    const s = r.name;
    if (n = s, zS.call(r, "weight") && r.weight !== void 0 && (i = r.weight, i <= 0))
      throw new Error(c8(Hm(s)));
    e = GS(s), t = Hm(s), a = r.getFn ?? null;
  }
  return {
    path: e,
    id: t,
    weight: i,
    src: n,
    getFn: a
  };
}
function GS(r) {
  return Nc(r) ? r : r.split(".");
}
function Hm(r) {
  return Nc(r) ? r.join(".") : r;
}
function h8(r, e) {
  const t = [];
  let n = !1;
  const i = (a, s, o, l) => {
    if (Qs(a))
      if (!s[o]) t.push(l !== void 0 ? {
        v: a,
        i: l
      } : a);
      else {
        const u = a[s[o]];
        if (!Qs(u)) return;
        if (o === s.length - 1 && (ss(u) || Gm(u) || i8(u) || typeof u == "bigint")) t.push(l !== void 0 ? {
          v: m1(u),
          i: l
        } : m1(u));
        else if (Nc(u)) {
          n = !0;
          for (let c = 0, h = u.length; c < h; c += 1) i(u[c], s, o + 1, c);
        } else s.length && i(u, s, o + 1, l);
      }
  };
  return i(r, ss(e) ? e.split(".") : e, 0), n ? t : t[0];
}
const p8 = {
  includeMatches: !1,
  findAllMatches: !1,
  minMatchCharLength: 1
}, g8 = {
  isCaseSensitive: !1,
  ignoreDiacritics: !1,
  includeScore: !1,
  keys: [],
  shouldSort: !0,
  sortFn: (r, e) => r.score === e.score ? r.idx < e.idx ? -1 : 1 : r.score < e.score ? -1 : 1
}, m8 = {
  location: 0,
  threshold: 0.6,
  distance: 100
}, v8 = {
  useExtendedSearch: !1,
  useTokenSearch: !1,
  tokenize: void 0,
  tokenMatch: "any",
  getFn: h8,
  ignoreLocation: !1,
  ignoreFieldNorm: !1,
  fieldNormWeight: 1
}, br = Object.freeze({
  ...g8,
  ...p8,
  ...m8,
  ...v8
});
function y8(r = 1, e = 3) {
  const t = /* @__PURE__ */ new Map(), n = Math.pow(10, e);
  return {
    get(i) {
      let a = 1, s = !1;
      for (let l = 0; l < i.length; l++) i.charCodeAt(l) === 32 ? s || (a++, s = !0) : s = !1;
      if (t.has(a)) return t.get(a);
      const o = Math.round(n / Math.pow(a, 0.5 * r)) / n;
      return t.set(a, o), o;
    },
    clear() {
      t.clear();
    }
  };
}
var Rw = class {
  constructor({ getFn: r = br.getFn, fieldNormWeight: e = br.fieldNormWeight } = {}) {
    this.norm = y8(e, 3), this.getFn = r, this.isCreated = !1, this.docs = [], this.keys = [], this._keysMap = {}, this.setIndexRecords();
  }
  setSources(r = []) {
    this.docs = r;
  }
  setIndexRecords(r = []) {
    this.records = r;
  }
  setKeys(r = []) {
    this.keys = r, this._keysMap = {}, r.forEach((e, t) => {
      this._keysMap[e.id] = t;
    });
  }
  create() {
    if (this.isCreated || !this.docs.length) return;
    this.isCreated = !0;
    const r = this.docs.length;
    this.records = new Array(r);
    let e = 0;
    if (ss(this.docs[0])) for (let t = 0; t < r; t++) {
      const n = this._createStringRecord(this.docs[t], t);
      n && (this.records[e++] = n);
    }
    else for (let t = 0; t < r; t++) this.records[e++] = this._createObjectRecord(this.docs[t], t);
    this.records.length = e, this.norm.clear();
  }
  add(r, e) {
    if (!Number.isInteger(e) || e < 0) throw new Error(v1);
    if (ss(r)) {
      const n = this._createStringRecord(r, e);
      return n && this.records.push(n), n;
    }
    const t = this._createObjectRecord(r, e);
    return this.records.push(t), t;
  }
  removeAt(r) {
    if (!Number.isInteger(r) || r < 0) throw new Error(v1);
    for (let e = 0, t = this.records.length; e < t; e += 1) if (this.records[e].i === r) {
      this.records.splice(e, 1);
      break;
    }
    for (let e = 0, t = this.records.length; e < t; e += 1) this.records[e].i > r && (this.records[e].i -= 1);
  }
  removeAll(r) {
    const e = /* @__PURE__ */ new Set();
    for (const n of r) Number.isInteger(n) && n >= 0 && e.add(n);
    if (e.size === 0) return;
    this.records = this.records.filter((n) => !e.has(n.i));
    const t = Array.from(e).sort((n, i) => n - i);
    for (const n of this.records) {
      let i = 0, a = t.length;
      for (; i < a; ) {
        const s = i + a >>> 1;
        t[s] < n.i ? i = s + 1 : a = s;
      }
      n.i -= i;
    }
  }
  getValueForItemAtKeyId(r, e) {
    return r[this._keysMap[e]];
  }
  size() {
    return this.records.length;
  }
  _createStringRecord(r, e) {
    return !Qs(r) || Hg(r) ? null : {
      v: r,
      i: e,
      n: this.norm.get(r)
    };
  }
  _createObjectRecord(r, e) {
    const t = {
      i: e,
      $: {}
    };
    for (let n = 0, i = this.keys.length; n < i; n++) {
      const a = this.keys[n], s = a.getFn ? a.getFn(r) : this.getFn(r, a.path);
      if (Qs(s)) {
        if (Nc(s)) {
          const o = [];
          for (let l = 0, u = s.length; l < u; l += 1) {
            const c = s[l];
            if (Qs(c)) {
              if (ss(c)) {
                if (!Hg(c)) {
                  const h = {
                    v: c,
                    i: l,
                    n: this.norm.get(c)
                  };
                  o.push(h);
                }
              } else if (Qs(c.v)) {
                const h = ss(c.v) ? c.v : m1(c.v);
                if (!Hg(h)) {
                  const f = {
                    v: h,
                    i: c.i,
                    n: this.norm.get(h)
                  };
                  o.push(f);
                }
              }
            }
          }
          t.$[n] = o;
        } else if (ss(s) && !Hg(s)) {
          const o = {
            v: s,
            n: this.norm.get(s)
          };
          t.$[n] = o;
        }
      }
    }
    return t;
  }
  toJSON() {
    return {
      keys: this.keys.map(({ getFn: r, ...e }) => e),
      records: this.records
    };
  }
};
function RI(r, e, { getFn: t = br.getFn, fieldNormWeight: n = br.fieldNormWeight } = {}) {
  const i = new Rw({
    getFn: t,
    fieldNormWeight: n
  });
  return i.setKeys(r.map(DI)), i.setSources(e), i.create(), i;
}
function A8(r, { getFn: e = br.getFn, fieldNormWeight: t = br.fieldNormWeight } = {}) {
  const { keys: n, records: i } = r, a = new Rw({
    getFn: e,
    fieldNormWeight: t
  });
  return a.setKeys(n), a.setIndexRecords(i), a;
}
function w8(r = [], e = br.minMatchCharLength) {
  const t = [];
  let n = -1, i = -1, a = 0;
  for (let s = r.length; a < s; a += 1) {
    const o = r[a];
    o && n === -1 ? n = a : !o && n !== -1 && (i = a - 1, i - n + 1 >= e && t.push([n, i]), n = -1);
  }
  return r[a - 1] && a - n >= e && t.push([n, a - 1]), t;
}
function x8(r, e, t, { location: n = br.location, distance: i = br.distance, threshold: a = br.threshold, findAllMatches: s = br.findAllMatches, minMatchCharLength: o = br.minMatchCharLength, includeMatches: l = br.includeMatches, ignoreLocation: u = br.ignoreLocation } = {}) {
  if (e.length > 32) throw new Error(l8(32));
  const c = e.length, h = r.length, f = Math.max(0, Math.min(n, h));
  let p = a, m = f;
  const A = (te, de) => {
    const H = te / c;
    if (u) return H;
    const j = Math.abs(f - de);
    return i ? H + j / i : j ? 1 : H;
  }, w = o > 1 || l, x = w ? Array(h) : [];
  let E;
  for (; (E = r.indexOf(e, m)) > -1; ) {
    const te = A(0, E);
    if (p = Math.min(te, p), m = E + c, w) {
      let de = 0;
      for (; de < c; )
        x[E + de] = 1, de += 1;
    }
  }
  m = -1;
  let T = [], D = 1, F = 0, _ = c + h;
  const L = 1 << c - 1;
  for (let te = 0; te < c; te += 1) {
    let de = 0, H = _;
    for (; de < H; )
      A(te, f + H) <= p ? de = H : _ = H, H = Math.floor((_ - de) / 2 + de);
    _ = H;
    let j = Math.max(1, f - H + 1);
    const q = s ? h : Math.min(f + H, h) + c, re = Array(q + 2);
    re[q + 1] = (1 << te) - 1;
    for (let ae = q; ae >= j; ae -= 1) {
      const ye = ae - 1, Se = t[r[ye]];
      if (re[ae] = (re[ae + 1] << 1 | 1) & Se, te && (re[ae] |= (T[ae + 1] | T[ae]) << 1 | 1 | T[ae + 1]), re[ae] & L && (D = A(te, ye), D <= p)) {
        if (p = D, m = ye, F = te, m <= f) break;
        j = Math.max(1, 2 * f - m);
      }
    }
    if (A(te + 1, f) > p) break;
    T = re;
  }
  if (w && m >= 0) {
    const te = Math.min(h - 1, m + c - 1 + F);
    for (let de = m; de <= te; de += 1) t[r[de]] && (x[de] = 1);
  }
  const Z = {
    isMatch: m >= 0,
    score: Math.max(1e-3, D)
  };
  if (w) {
    const te = w8(x, o);
    te.length ? l && (Z.indices = te) : Z.isMatch = !1;
  }
  return Z;
}
function b8(r) {
  const e = {};
  for (let t = 0, n = r.length; t < n; t += 1) {
    const i = r.charAt(t);
    e[i] = (e[i] || 0) | 1 << n - t - 1;
  }
  return e;
}
function Ow(r) {
  if (r.length <= 1) return r;
  r.sort((t, n) => t[0] - n[0] || t[1] - n[1]);
  const e = [r[0]];
  for (let t = 1, n = r.length; t < n; t += 1) {
    const i = e[e.length - 1], a = r[t];
    a[0] <= i[1] + 1 ? i[1] = Math.max(i[1], a[1]) : e.push(a);
  }
  return e;
}
const OI = {
  ł: "l",
  Ł: "L",
  đ: "d",
  Đ: "D",
  ø: "o",
  Ø: "O",
  ħ: "h",
  Ħ: "H",
  ŧ: "t",
  Ŧ: "T",
  ı: "i",
  ß: "ss"
}, C8 = new RegExp("[" + Object.keys(OI).join("") + "]", "g"), Wp = typeof String.prototype.normalize == "function" ? (r) => r.normalize("NFD").replace(/[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]/g, "").replace(C8, (e) => OI[e]) : (r) => r;
var Bw = class {
  constructor(r, { location: e = br.location, threshold: t = br.threshold, distance: n = br.distance, includeMatches: i = br.includeMatches, findAllMatches: a = br.findAllMatches, minMatchCharLength: s = br.minMatchCharLength, isCaseSensitive: o = br.isCaseSensitive, ignoreDiacritics: l = br.ignoreDiacritics, ignoreLocation: u = br.ignoreLocation } = {}) {
    if (this.options = {
      location: e,
      threshold: t,
      distance: n,
      includeMatches: i,
      findAllMatches: a,
      minMatchCharLength: s,
      isCaseSensitive: o,
      ignoreDiacritics: l,
      ignoreLocation: u
    }, r = o ? r : r.toLowerCase(), r = l ? Wp(r) : r, this.pattern = r, this.chunks = [], !this.pattern.length) return;
    const c = (f, p) => {
      this.chunks.push({
        pattern: f,
        alphabet: b8(f),
        startIndex: p
      });
    }, h = this.pattern.length;
    if (h > 32) {
      let f = 0;
      const p = h % 32, m = h - p;
      for (; f < m; )
        c(this.pattern.substr(f, 32), f), f += 32;
      if (p) {
        const A = h - 32;
        c(this.pattern.substr(A), A);
      }
    } else c(this.pattern, 0);
  }
  searchIn(r) {
    const { isCaseSensitive: e, ignoreDiacritics: t, includeMatches: n } = this.options;
    if (r = e ? r : r.toLowerCase(), r = t ? Wp(r) : r, this.pattern === r) {
      const m = {
        isMatch: !0,
        score: 0
      };
      return n && (m.indices = [[0, r.length - 1]]), m;
    }
    const { location: i, distance: a, threshold: s, findAllMatches: o, minMatchCharLength: l, ignoreLocation: u } = this.options, c = [];
    let h = 0, f = !1;
    this.chunks.forEach(({ pattern: m, alphabet: A, startIndex: w }) => {
      const { isMatch: x, score: E, indices: T } = x8(r, m, A, {
        location: i + w,
        distance: a,
        threshold: s,
        findAllMatches: o,
        minMatchCharLength: l,
        includeMatches: n,
        ignoreLocation: u
      });
      x && (f = !0), h += E, x && T && c.push(...T);
    });
    const p = {
      isMatch: f,
      score: f ? h / this.chunks.length : 1
    };
    return f && n && (p.indices = Ow(c)), p;
  }
};
const S8 = /* @__PURE__ */ new Set(["fuzzy", "include"]);
function E8(r) {
  return r.startsWith("inverse");
}
const y1 = [
  {
    type: "exact",
    multiRegex: /^="(.*)"$/,
    singleRegex: /^=(.*)$/,
    create: (r) => ({
      type: "exact",
      search(e) {
        const t = e === r;
        return {
          isMatch: t,
          score: t ? 0 : 1,
          indices: [0, r.length - 1]
        };
      }
    })
  },
  {
    type: "include",
    multiRegex: /^'"(.*)"$/,
    singleRegex: /^'(.*)$/,
    create: (r) => ({
      type: "include",
      search(e) {
        let t = 0, n;
        const i = [], a = r.length;
        for (; (n = e.indexOf(r, t)) > -1; )
          t = n + a, i.push([n, t - 1]);
        const s = !!i.length;
        return {
          isMatch: s,
          score: s ? 0 : 1,
          indices: i
        };
      }
    })
  },
  {
    type: "prefix-exact",
    multiRegex: /^\^"(.*)"$/,
    singleRegex: /^\^(.*)$/,
    create: (r) => ({
      type: "prefix-exact",
      search(e) {
        const t = e.startsWith(r);
        return {
          isMatch: t,
          score: t ? 0 : 1,
          indices: [0, r.length - 1]
        };
      }
    })
  },
  {
    type: "inverse-prefix-exact",
    multiRegex: /^!\^"(.*)"$/,
    singleRegex: /^!\^(.*)$/,
    create: (r) => ({
      type: "inverse-prefix-exact",
      search(e) {
        const t = !e.startsWith(r);
        return {
          isMatch: t,
          score: t ? 0 : 1,
          indices: [0, e.length - 1]
        };
      }
    })
  },
  {
    type: "inverse-suffix-exact",
    multiRegex: /^!"(.*)"\$$/,
    singleRegex: /^!(.*)\$$/,
    create: (r) => ({
      type: "inverse-suffix-exact",
      search(e) {
        const t = !e.endsWith(r);
        return {
          isMatch: t,
          score: t ? 0 : 1,
          indices: [0, e.length - 1]
        };
      }
    })
  },
  {
    type: "suffix-exact",
    multiRegex: /^"(.*)"\$$/,
    singleRegex: /^(.*)\$$/,
    create: (r) => ({
      type: "suffix-exact",
      search(e) {
        const t = e.endsWith(r);
        return {
          isMatch: t,
          score: t ? 0 : 1,
          indices: [e.length - r.length, e.length - 1]
        };
      }
    })
  },
  {
    type: "inverse-exact",
    multiRegex: /^!"(.*)"$/,
    singleRegex: /^!(.*)$/,
    create: (r) => ({
      type: "inverse-exact",
      search(e) {
        const t = e.indexOf(r) === -1;
        return {
          isMatch: t,
          score: t ? 0 : 1,
          indices: [0, e.length - 1]
        };
      }
    })
  },
  {
    type: "fuzzy",
    multiRegex: /^"(.*)"$/,
    singleRegex: /^(.*)$/,
    create: (r, e = {}) => {
      const t = new Bw(r, {
        location: e.location ?? br.location,
        threshold: e.threshold ?? br.threshold,
        distance: e.distance ?? br.distance,
        includeMatches: e.includeMatches ?? br.includeMatches,
        findAllMatches: e.findAllMatches ?? br.findAllMatches,
        minMatchCharLength: e.minMatchCharLength ?? br.minMatchCharLength,
        isCaseSensitive: e.isCaseSensitive ?? br.isCaseSensitive,
        ignoreDiacritics: e.ignoreDiacritics ?? br.ignoreDiacritics,
        ignoreLocation: e.ignoreLocation ?? br.ignoreLocation
      });
      return {
        type: "fuzzy",
        search(n) {
          return t.searchIn(n);
        }
      };
    }
  }
], HS = y1.length, k8 = "\0", T8 = "|";
function F8(r) {
  const e = [], t = r.length;
  let n = 0;
  for (; n < t; ) {
    for (; n < t && r[n] === " "; ) n++;
    if (n >= t) break;
    let i = n;
    for (; i < t && r[i] !== " " && r[i] !== '"'; ) i++;
    if (i < t && r[i] === '"') {
      for (i++; i < t; ) {
        if (r[i] === '"') {
          const a = i + 1;
          if (a >= t || r[a] === " ") {
            i++;
            break;
          }
          if (r[a] === "$" && (a + 1 >= t || r[a + 1] === " ")) {
            i += 2;
            break;
          }
        }
        i++;
      }
      e.push(r.substring(n, i)), n = i;
    } else {
      for (; i < t && r[i] !== " "; ) i++;
      e.push(r.substring(n, i)), n = i;
    }
  }
  return e;
}
function WS(r, e) {
  const t = r.match(e);
  return t ? t[1] : null;
}
function I8(r, e = {}) {
  return r.replace(/\\\|/g, k8).split(T8).map((t) => {
    const n = F8(t.replace(/\u0000/g, "|").trim()).filter((a) => a && !!a.trim()), i = [];
    for (let a = 0, s = n.length; a < s; a += 1) {
      const o = n[a];
      let l = !1, u = -1;
      for (; !l && ++u < HS; ) {
        const c = y1[u], h = WS(o, c.multiRegex);
        h && (i.push(c.create(h, e)), l = !0);
      }
      if (!l)
        for (u = -1; ++u < HS; ) {
          const c = y1[u], h = WS(o, c.singleRegex);
          if (h) {
            i.push(c.create(h, e));
            break;
          }
        }
    }
    return i;
  });
}
var P8 = class {
  constructor(r, { isCaseSensitive: e = br.isCaseSensitive, ignoreDiacritics: t = br.ignoreDiacritics, includeMatches: n = br.includeMatches, minMatchCharLength: i = br.minMatchCharLength, ignoreLocation: a = br.ignoreLocation, findAllMatches: s = br.findAllMatches, location: o = br.location, threshold: l = br.threshold, distance: u = br.distance } = {}) {
    this.query = null, this.options = {
      isCaseSensitive: e,
      ignoreDiacritics: t,
      includeMatches: n,
      minMatchCharLength: i,
      findAllMatches: s,
      ignoreLocation: a,
      location: o,
      threshold: l,
      distance: u
    }, r = e ? r : r.toLowerCase(), r = t ? Wp(r) : r, this.pattern = r, this.query = I8(this.pattern, this.options);
  }
  static condition(r, e) {
    return e.useExtendedSearch;
  }
  searchIn(r) {
    const e = this.query;
    if (!e) return {
      isMatch: !1,
      score: 1
    };
    const { includeMatches: t, isCaseSensitive: n, ignoreDiacritics: i } = this.options;
    r = n ? r : r.toLowerCase(), r = i ? Wp(r) : r;
    let a = 0;
    const s = [];
    let o = 0, l = !1;
    for (let u = 0, c = e.length; u < c; u += 1) {
      const h = e[u];
      s.length = 0, a = 0, l = !1;
      for (let f = 0, p = h.length; f < p; f += 1) {
        const m = h[f], { isMatch: A, indices: w, score: x } = m.search(r);
        if (A)
          a += 1, o += x, E8(m.type) && (l = !0), t && (S8.has(m.type) ? s.push(...w) : s.push(w));
        else {
          o = 0, a = 0, s.length = 0, l = !1;
          break;
        }
      }
      if (a) {
        const f = {
          isMatch: !0,
          score: o / a
        };
        return l && (f.hasInverse = !0), t && (f.indices = Ow(s)), f;
      }
    }
    return {
      isMatch: !1,
      score: 1
    };
  }
};
const A1 = [];
function _w(...r) {
  A1.push(...r);
}
function f0(r, e) {
  for (let t = 0, n = A1.length; t < n; t += 1) {
    const i = A1[t];
    if (i.condition(r, e)) return new i(r, e);
  }
  return new Bw(r, e);
}
const d0 = {
  AND: "$and",
  OR: "$or"
}, w1 = {
  PATH: "$path",
  PATTERN: "$val"
}, x1 = (r) => !!(r[d0.AND] || r[d0.OR]), D8 = (r) => !!r[w1.PATH], R8 = (r) => !Nc(r) && II(r) && !x1(r), jS = (r) => ({ [d0.AND]: Object.keys(r).map((e) => ({ [e]: r[e] })) });
function BI(r, e, { auto: t = !0 } = {}) {
  const n = (i) => {
    if (ss(i)) {
      const l = {
        keyId: null,
        pattern: i
      };
      return t && (l.searcher = f0(i, e)), l;
    }
    const a = Object.keys(i), s = D8(i);
    if (!s && a.length > 1 && !x1(i)) return n(jS(i));
    if (R8(i)) {
      const l = s ? i[w1.PATH] : a[0], u = s ? i[w1.PATTERN] : i[l];
      if (!ss(u)) throw new Error(o8(l));
      const c = {
        keyId: Hm(l),
        pattern: u
      };
      return t && (c.searcher = f0(u, e)), c;
    }
    const o = {
      children: [],
      operator: a[0]
    };
    return a.forEach((l) => {
      const u = i[l];
      Nc(u) && u.forEach((c) => {
        o.children.push(n(c));
      });
    }), o;
  };
  return x1(r) || (r = jS(r)), n(r);
}
function b1(r, { ignoreFieldNorm: e = br.ignoreFieldNorm }) {
  let t = 1;
  return r.forEach(({ key: n, norm: i, score: a }) => {
    const s = n ? n.weight : null;
    t *= Math.pow(a === 0 && s ? Number.EPSILON : a, (s || 1) * (e ? 1 : i));
  }), t;
}
function O8(r, { ignoreFieldNorm: e = br.ignoreFieldNorm }) {
  r.forEach((t) => {
    t.score = b1(t.matches, { ignoreFieldNorm: e });
  });
}
var B8 = class {
  constructor(r) {
    this.limit = r, this.heap = [];
  }
  get size() {
    return this.heap.length;
  }
  shouldInsert(r) {
    return this.size < this.limit || r < this.heap[0].score;
  }
  insert(r) {
    this.size < this.limit ? (this.heap.push(r), this._bubbleUp(this.size - 1)) : r.score < this.heap[0].score && (this.heap[0] = r, this._sinkDown(0));
  }
  extractSorted(r) {
    return this.heap.sort(r);
  }
  _bubbleUp(r) {
    const e = this.heap;
    for (; r > 0; ) {
      const t = r - 1 >> 1;
      if (e[r].score <= e[t].score) break;
      const n = e[r];
      e[r] = e[t], e[t] = n, r = t;
    }
  }
  _sinkDown(r) {
    const e = this.heap, t = e.length;
    let n = r;
    do {
      r = n;
      const i = 2 * r + 1, a = 2 * r + 2;
      if (i < t && e[i].score > e[n].score && (n = i), a < t && e[a].score > e[n].score && (n = a), n !== r) {
        const s = e[r];
        e[r] = e[n], e[n] = s;
      }
    } while (n !== r);
  }
};
function _8(r) {
  const e = [];
  return r.matches.forEach((t) => {
    if (!Qs(t.indices) || !t.indices.length) return;
    const n = {
      indices: t.indices,
      value: t.value
    };
    t.key && (n.key = t.key.id), t.idx > -1 && (n.refIndex = t.idx), e.push(n);
  }), e;
}
function M8(r, e, { includeMatches: t = br.includeMatches, includeScore: n = br.includeScore } = {}) {
  return r.map((i) => {
    const { idx: a } = i, s = {
      item: e[a],
      refIndex: a
    };
    return t && (s.matches = _8(i)), n && (s.score = i.score), s;
  });
}
const N8 = /[\p{L}\p{M}\p{N}_]+/gu, qS = /* @__PURE__ */ new WeakSet();
function L8(r) {
  qS.has(r) || (qS.add(r), console.warn(`[Fuse] tokenize regex ${r} lacks the global flag; only the first match per text will be returned. Add the 'g' flag.`));
}
function U8(r) {
  if (typeof r == "function") {
    let e = !1;
    return (t) => {
      const n = r(t);
      if (!e && (e = !0, !Array.isArray(n) || n.some((i) => typeof i != "string")))
        throw new Error(`[Fuse] tokenize function must return string[]; received ${Array.isArray(n) ? "array containing non-strings" : typeof n}.`);
      return n;
    };
  }
  return r instanceof RegExp ? (r.global || L8(r), (e) => e.match(r) || []) : (e) => e.match(N8) || [];
}
function C1({ isCaseSensitive: r = !1, ignoreDiacritics: e = !1, tokenize: t } = {}) {
  const n = U8(t);
  return { tokenize(i) {
    return r || (i = i.toLowerCase()), e && (i = Wp(i)), n(i);
  } };
}
var V8 = class {
  static condition(r, e) {
    return e.useTokenSearch;
  }
  constructor(r, e) {
    this.options = e, this.analyzer = C1({
      isCaseSensitive: e.isCaseSensitive,
      ignoreDiacritics: e.ignoreDiacritics,
      tokenize: e.tokenize
    });
    const t = this.analyzer.tokenize(r), { df: n, fieldCount: i } = e._invertedIndex;
    this.termSearchers = [], this.idfWeights = [];
    for (const a of t) {
      this.termSearchers.push(new Bw(a, {
        location: e.location,
        threshold: e.threshold,
        distance: e.distance,
        includeMatches: e.includeMatches,
        findAllMatches: e.findAllMatches,
        minMatchCharLength: e.minMatchCharLength,
        isCaseSensitive: e.isCaseSensitive,
        ignoreDiacritics: e.ignoreDiacritics,
        ignoreLocation: !0
      }));
      const s = n.get(a) || 0, o = Math.log(1 + (i - s + 0.5) / (s + 0.5));
      this.idfWeights.push(o);
    }
    this.combineAll = e.tokenMatch === "all", this.numTerms = this.termSearchers.length, this.useMask = this.numTerms <= 31;
  }
  searchIn(r) {
    if (!this.termSearchers.length) return {
      isMatch: !1,
      score: 1
    };
    const e = [];
    let t = 0, n = 0, i = 0, a = 0;
    const s = this.combineAll && !this.useMask ? /* @__PURE__ */ new Set() : null;
    for (let u = 0; u < this.termSearchers.length; u++) {
      const c = this.termSearchers[u].searchIn(r), h = this.idfWeights[u];
      n += h, c.isMatch && (i++, t += h * (1 - c.score), c.indices && e.push(...c.indices), this.combineAll && (this.useMask ? a |= 1 << u : s.add(u)));
    }
    if (i === 0) return {
      isMatch: !1,
      score: 1
    };
    const o = n > 0 ? 1 - t / n : 0, l = {
      isMatch: !0,
      score: Math.max(1e-3, o)
    };
    return this.options.includeMatches && e.length && (l.indices = Ow(e)), this.combineAll && (this.useMask ? l.matchedMask = a : l.matchedTerms = s, l.termCount = this.numTerms), l;
  }
};
function Jv(r, e, t, n) {
  const i = n.tokenize(e);
  if (!i.length) return;
  r.fieldCount++, r.docFieldCount.set(t, (r.docFieldCount.get(t) || 0) + 1);
  const a = new Set(i);
  let s = r.docTermFieldHits.get(t);
  s || (s = /* @__PURE__ */ new Map(), r.docTermFieldHits.set(t, s));
  for (const o of a)
    s.set(o, (s.get(o) || 0) + 1), r.df.set(o, (r.df.get(o) || 0) + 1);
}
function _I(r, e, t, n) {
  const { i, v: a, $: s } = e;
  if (a !== void 0) {
    Jv(r, a, i, n);
    return;
  }
  if (s)
    for (let o = 0; o < t; o++) {
      const l = s[o];
      if (l)
        if (Array.isArray(l)) for (const u of l) Jv(r, u.v, i, n);
        else Jv(r, l.v, i, n);
    }
}
function $8(r, e, t) {
  const n = {
    fieldCount: 0,
    df: /* @__PURE__ */ new Map(),
    docFieldCount: /* @__PURE__ */ new Map(),
    docTermFieldHits: /* @__PURE__ */ new Map()
  };
  for (const i of r) _I(n, i, e, t);
  return n;
}
function z8(r, e, t, n) {
  _I(r, e, t, n);
}
function G8(r, e) {
  const t = r.docFieldCount.get(e);
  if (t === void 0) return;
  r.fieldCount -= t, r.docFieldCount.delete(e);
  const n = r.docTermFieldHits.get(e);
  if (n) {
    for (const [i, a] of n) {
      const s = (r.df.get(i) || 0) - a;
      s <= 0 ? r.df.delete(i) : r.df.set(i, s);
    }
    r.docTermFieldHits.delete(e);
  }
}
function QS(r, e) {
  if (e.length === 0) return;
  const t = Array.from(new Set(e)).sort((o, l) => o - l);
  for (const o of t) G8(r, o);
  const n = (o) => {
    let l = 0, u = t.length;
    for (; l < u; ) {
      const c = l + u >>> 1;
      t[c] < o ? l = c + 1 : u = c;
    }
    return o - l;
  }, i = t[0], a = /* @__PURE__ */ new Map();
  for (const [o, l] of r.docFieldCount) a.set(o > i ? n(o) : o, l);
  r.docFieldCount = a;
  const s = /* @__PURE__ */ new Map();
  for (const [o, l] of r.docTermFieldHits) s.set(o > i ? n(o) : o, l);
  r.docTermFieldHits = s;
}
var Lc = class {
  constructor(r, e, t) {
    this.options = {
      ...br,
      ...e
    }, this.options.useExtendedSearch, this.options.useTokenSearch, this._keyStore = new d8(this.options.keys), this._docs = r, this._myIndex = null, this._invertedIndex = null, this.setCollection(r, t), this._lastQuery = null, this._lastSearcher = null;
  }
  _getSearcher(r) {
    if (this._lastQuery === r) return this._lastSearcher;
    const e = f0(r, this._invertedIndex ? {
      ...this.options,
      _invertedIndex: this._invertedIndex
    } : this.options);
    return this._lastQuery = r, this._lastSearcher = e, e;
  }
  setCollection(r, e) {
    if (this._docs = r, e && !(e instanceof Rw)) throw new Error(s8);
    if (this._myIndex = e || RI(this.options.keys, this._docs, {
      getFn: this.options.getFn,
      fieldNormWeight: this.options.fieldNormWeight
    }), this.options.useTokenSearch) {
      const t = C1({
        isCaseSensitive: this.options.isCaseSensitive,
        ignoreDiacritics: this.options.ignoreDiacritics,
        tokenize: this.options.tokenize
      });
      this._invertedIndex = $8(this._myIndex.records, this._myIndex.keys.length, t);
    }
    this._invalidateSearcherCache();
  }
  add(r) {
    if (!Qs(r)) return;
    this._docs.push(r);
    const e = this._myIndex.add(r, this._docs.length - 1);
    if (this._invertedIndex && e) {
      const t = C1({
        isCaseSensitive: this.options.isCaseSensitive,
        ignoreDiacritics: this.options.ignoreDiacritics,
        tokenize: this.options.tokenize
      });
      z8(this._invertedIndex, e, this._myIndex.keys.length, t);
    }
    this._invalidateSearcherCache();
  }
  remove(r = () => !1) {
    const e = [], t = [];
    for (let n = 0, i = this._docs.length; n < i; n += 1) r(this._docs[n], n) && (e.push(this._docs[n]), t.push(n));
    if (t.length) {
      this._invertedIndex && QS(this._invertedIndex, t);
      const n = new Set(t);
      this._docs = this._docs.filter((i, a) => !n.has(a)), this._myIndex.removeAll(t), this._invalidateSearcherCache();
    }
    return e;
  }
  removeAt(r) {
    if (!Number.isInteger(r) || r < 0 || r >= this._docs.length) throw new Error(v1);
    this._invertedIndex && QS(this._invertedIndex, [r]);
    const e = this._docs.splice(r, 1)[0];
    return this._myIndex.removeAt(r), this._invalidateSearcherCache(), e;
  }
  _invalidateSearcherCache() {
    this._lastQuery = null, this._lastSearcher = null;
  }
  getIndex() {
    return this._myIndex;
  }
  search(r, e) {
    const { limit: t = -1 } = e || {}, { includeMatches: n, includeScore: i, shouldSort: a, sortFn: s, ignoreFieldNorm: o } = this.options;
    if (ss(r) && !r.trim()) {
      let c = this._docs.map((h, f) => ({
        item: h,
        refIndex: f
      }));
      return Gm(t) && t > -1 && (c = c.slice(0, t)), c;
    }
    const l = Gm(t) && t > 0 && ss(r);
    let u;
    if (l) {
      const c = new B8(t);
      ss(this._docs[0]) ? this._searchStringList(r, {
        heap: c,
        ignoreFieldNorm: o
      }) : this._searchObjectList(r, {
        heap: c,
        ignoreFieldNorm: o
      }), u = c.extractSorted(s);
    } else
      u = ss(r) ? ss(this._docs[0]) ? this._searchStringList(r) : this._searchObjectList(r) : this._searchLogical(r), O8(u, { ignoreFieldNorm: o }), a && u.sort(s), Gm(t) && t > -1 && (u = u.slice(0, t));
    return M8(u, this._docs, {
      includeMatches: n,
      includeScore: i
    });
  }
  _searchStringList(r, { heap: e, ignoreFieldNorm: t } = {}) {
    const n = this._getSearcher(r), i = this.options.useTokenSearch && this.options.tokenMatch === "all", { records: a } = this._myIndex, s = e ? null : [];
    return a.forEach(({ v: o, i: l, n: u }) => {
      if (!Qs(o)) return;
      const c = n.searchIn(o);
      if (c.isMatch) {
        const h = {
          score: c.score,
          value: o,
          norm: u,
          indices: c.indices
        };
        i && (h.matchedMask = c.matchedMask, h.matchedTerms = c.matchedTerms, h.termCount = c.termCount);
        const f = [h];
        if (!i || this._coversAllTokens(f)) {
          const p = {
            item: o,
            idx: l,
            matches: f
          };
          e ? (p.score = b1(p.matches, { ignoreFieldNorm: t }), e.shouldInsert(p.score) && e.insert(p)) : s.push(p);
        }
      }
    }), s;
  }
  _searchLogical(r) {
    const e = BI(r, this.options), t = (s, o, l) => {
      if (!("children" in s)) {
        const { keyId: f, searcher: p } = s;
        let m;
        return f === null ? (m = [], this._myIndex.keys.forEach((A, w) => {
          m.push(...this._findMatches({
            key: A,
            value: o[w],
            searcher: p
          }));
        })) : m = this._findMatches({
          key: this._keyStore.get(f),
          value: this._myIndex.getValueForItemAtKeyId(o, f),
          searcher: p
        }), m && m.length ? [{
          idx: l,
          item: o,
          matches: m
        }] : [];
      }
      const { children: u, operator: c } = s, h = [];
      for (let f = 0, p = u.length; f < p; f += 1) {
        const m = u[f], A = t(m, o, l);
        if (A.length) h.push(...A);
        else if (c === d0.AND) return [];
      }
      return h;
    }, n = this._myIndex.records, i = /* @__PURE__ */ new Map(), a = [];
    return n.forEach(({ $: s, i: o }) => {
      if (Qs(s)) {
        const l = t(e, s, o);
        l.length && (i.has(o) || (i.set(o, {
          idx: o,
          item: s,
          matches: []
        }), a.push(i.get(o))), l.forEach(({ matches: u }) => {
          i.get(o).matches.push(...u);
        }));
      }
    }), a;
  }
  _searchObjectList(r, { heap: e, ignoreFieldNorm: t } = {}) {
    const n = this._getSearcher(r), i = this.options.useTokenSearch && this.options.tokenMatch === "all", { keys: a, records: s } = this._myIndex, o = e ? null : [];
    return s.forEach(({ $: l, i: u }) => {
      if (!Qs(l)) return;
      const c = [];
      let h = !1, f = !1;
      if (a.forEach((p, m) => {
        const A = this._findMatches({
          key: p,
          value: l[m],
          searcher: n
        });
        A.length ? (c.push(...A), A[0].hasInverse && (f = !0)) : h = !0;
      }), !(f && h) && c.length && (!i || this._coversAllTokens(c))) {
        const p = {
          idx: u,
          item: l,
          matches: c
        };
        e ? (p.score = b1(p.matches, { ignoreFieldNorm: t }), e.shouldInsert(p.score) && e.insert(p)) : o.push(p);
      }
    }), o;
  }
  _findMatches({ key: r, value: e, searcher: t }) {
    if (!Qs(e)) return [];
    const n = [];
    if (Nc(e)) e.forEach(({ v: i, i: a, n: s }) => {
      if (!Qs(i)) return;
      const o = t.searchIn(i);
      if (o.isMatch) {
        const l = {
          score: o.score,
          key: r,
          value: i,
          idx: a,
          norm: s,
          indices: o.indices,
          hasInverse: o.hasInverse
        };
        o.termCount !== void 0 && (l.matchedMask = o.matchedMask, l.matchedTerms = o.matchedTerms, l.termCount = o.termCount), n.push(l);
      }
    });
    else {
      const { v: i, n: a } = e, s = t.searchIn(i);
      if (s.isMatch) {
        const o = {
          score: s.score,
          key: r,
          value: i,
          norm: a,
          indices: s.indices,
          hasInverse: s.hasInverse
        };
        s.termCount !== void 0 && (o.matchedMask = s.matchedMask, o.matchedTerms = s.matchedTerms, o.termCount = s.termCount), n.push(o);
      }
    }
    return n;
  }
  _coversAllTokens(r) {
    const e = r.length ? r[0].termCount : void 0;
    if (e === void 0) return !0;
    if (e <= 31) {
      let n = 0;
      for (let i = 0; i < r.length; i++) n |= r[i].matchedMask || 0;
      return n === 2 ** e - 1;
    }
    const t = /* @__PURE__ */ new Set();
    for (let n = 0; n < r.length; n++) {
      const i = r[n].matchedTerms;
      if (i) for (const a of i) t.add(a);
    }
    return t.size === e;
  }
};
Lc.version = "7.4.2";
Lc.createIndex = RI;
Lc.parseIndex = A8;
Lc.config = br;
Lc.match = function(r, e, t) {
  if (t && t.useTokenSearch) throw new Error(f8);
  return f0(r, {
    ...br,
    ...t
  }).searchIn(e);
};
Lc.parseQuery = BI;
_w(P8);
_w(V8);
Lc.use = function(...r) {
  r.forEach((e) => _w(e));
};
var H8 = Lc;
const jp = [
  "White C",
  "Yellow C",
  "Yellow 012 C",
  "Orange 021 C",
  "Warm Red C",
  "Red 032 C",
  "Rubine Red C",
  "Rhodamine Red C",
  "Purple C",
  "Violet C",
  "Blue 072 C",
  "Reflex Blue C",
  "Process Blue C",
  "Green C",
  "Black C",
  "Yellow 0131 C",
  "Red 0331 C",
  "Magenta 0521 C",
  "Violet 0631 C",
  "Blue 0821 C",
  "Green 0921 C",
  "Black 0961 C",
  "801 C",
  "802 C",
  "803 C",
  "804 C",
  "805 C",
  "806 C",
  "807 C",
  "871 C",
  "872 C",
  "873 C",
  "874 C",
  "875 C",
  "876 C",
  "877 C",
  "Medium Yellow C",
  "Bright Orange C",
  "Bright Red C",
  "Strong Red C",
  "Pink C",
  "Medium Purple C",
  "Dark Blue C",
  "Medium Blue C",
  "Bright Green C",
  "Neutral Black C",
  "100 C",
  "101 C",
  "102 C",
  "103 C",
  "104 C",
  "105 C",
  "7401 C",
  "7402 C",
  "7403 C",
  "7404 C",
  "7405 C",
  "7406 C",
  "7407 C",
  "106 C",
  "107 C",
  "108 C",
  "109 C",
  "110 C",
  "111 C",
  "112 C",
  "113 C",
  "114 C",
  "115 C",
  "116 C",
  "117 C",
  "118 C",
  "119 C",
  "127 C",
  "128 C",
  "129 C",
  "130 C",
  "131 C",
  "132 C",
  "133 C",
  "1205 C",
  "1215 C",
  "1225 C",
  "1235 C",
  "1245 C",
  "1255 C",
  "1265 C",
  "120 C",
  "121 C",
  "122 C",
  "123 C",
  "124 C",
  "125 C",
  "126 C",
  "7548 C",
  "7549 C",
  "7550 C",
  "7551 C",
  "7552 C",
  "7553 C",
  "7554 C",
  "7555 C",
  "7556 C",
  "7557 C",
  "7558 C",
  "7559 C",
  "7560 C",
  "7561 C",
  "134 C",
  "135 C",
  "136 C",
  "137 C",
  "138 C",
  "139 C",
  "140 C",
  "1345 C",
  "1355 C",
  "1365 C",
  "1375 C",
  "1385 C",
  "1395 C",
  "1405 C",
  "141 C",
  "142 C",
  "143 C",
  "144 C",
  "145 C",
  "146 C",
  "147 C",
  "7408 C",
  "7409 C",
  "7410 C",
  "7411 C",
  "7412 C",
  "7413 C",
  "7414 C",
  "7562 C",
  "7563 C",
  "7564 C",
  "7565 C",
  "7566 C",
  "7567 C",
  "7568 C",
  "7569 C",
  "7570 C",
  "7571 C",
  "7572 C",
  "7573 C",
  "7574 C",
  "7575 C",
  "712 C",
  "713 C",
  "714 C",
  "715 C",
  "716 C",
  "717 C",
  "718 C",
  "148 C",
  "149 C",
  "150 C",
  "151 C",
  "152 C",
  "153 C",
  "154 C",
  "155 C",
  "156 C",
  "157 C",
  "158 C",
  "159 C",
  "160 C",
  "161 C",
  "1485 C",
  "1495 C",
  "1505 C",
  "1525 C",
  "1535 C",
  "1545 C",
  "1555 C",
  "1565 C",
  "1575 C",
  "1585 C",
  "1595 C",
  "1605 C",
  "1615 C",
  "162 C",
  "163 C",
  "164 C",
  "165 C",
  "166 C",
  "167 C",
  "168 C",
  "7576 C",
  "7577 C",
  "7578 C",
  "7579 C",
  "7580 C",
  "7581 C",
  "7582 C",
  "1625 C",
  "1635 C",
  "1645 C",
  "1655 C",
  "1665 C",
  "1675 C",
  "1685 C",
  "169 C",
  "170 C",
  "171 C",
  "172 C",
  "173 C",
  "174 C",
  "175 C",
  "7583 C",
  "7584 C",
  "7585 C",
  "7586 C",
  "7587 C",
  "7588 C",
  "7589 C",
  "7590 C",
  "7591 C",
  "7592 C",
  "7593 C",
  "7594 C",
  "7595 C",
  "7596 C",
  "7597 C",
  "7598 C",
  "7599 C",
  "7600 C",
  "7601 C",
  "7602 C",
  "7603 C",
  "7604 C",
  "7605 C",
  "7606 C",
  "7607 C",
  "7608 C",
  "7609 C",
  "7610 C",
  "7611 C",
  "7612 C",
  "7613 C",
  "7614 C",
  "7615 C",
  "7616 C",
  "7617 C",
  "7520 C",
  "7521 C",
  "7522 C",
  "7523 C",
  "7524 C",
  "7525 C",
  "7526 C",
  "489 C",
  "488 C",
  "487 C",
  "486 C",
  "485 C",
  "484 C",
  "483 C",
  "176 C",
  "177 C",
  "178 C",
  "179 C",
  "180 C",
  "181 C",
  "1765 C",
  "1775 C",
  "1785 C",
  "1788 C",
  "1795 C",
  "1805 C",
  "1815 C",
  "1767 C",
  "1777 C",
  "1787 C",
  "1797 C",
  "1807 C",
  "1817 C",
  "7618 C",
  "7619 C",
  "7620 C",
  "7621 C",
  "7622 C",
  "7623 C",
  "7624 C",
  "7625 C",
  "7626 C",
  "7627 C",
  "7628 C",
  "7629 C",
  "7630 C",
  "7631 C",
  "7415 C",
  "7416 C",
  "7417 C",
  "7418 C",
  "7419 C",
  "7420 C",
  "7421 C",
  "182 C",
  "183 C",
  "184 C",
  "185 C",
  "186 C",
  "187 C",
  "188 C",
  "196 C",
  "197 C",
  "198 C",
  "199 C",
  "200 C",
  "201 C",
  "202 C",
  "189 C",
  "190 C",
  "191 C",
  "192 C",
  "193 C",
  "194 C",
  "195 C",
  "1895 C",
  "1905 C",
  "1915 C",
  "1925 C",
  "1935 C",
  "1945 C",
  "1955 C",
  "705 C",
  "706 C",
  "707 C",
  "708 C",
  "709 C",
  "710 C",
  "711 C",
  "698 C",
  "699 C",
  "700 C",
  "701 C",
  "702 C",
  "703 C",
  "704 C",
  "203 C",
  "204 C",
  "205 C",
  "206 C",
  "207 C",
  "208 C",
  "209 C",
  "210 C",
  "211 C",
  "212 C",
  "213 C",
  "214 C",
  "215 C",
  "216 C",
  "7422 C",
  "7423 C",
  "7424 C",
  "7425 C",
  "7426 C",
  "7427 C",
  "7428 C",
  "7632 C",
  "7633 C",
  "7634 C",
  "7635 C",
  "7636 C",
  "7637 C",
  "7638 C",
  "217 C",
  "218 C",
  "219 C",
  "220 C",
  "221 C",
  "222 C",
  "7639 C",
  "7640 C",
  "7641 C",
  "7642 C",
  "7643 C",
  "7644 C",
  "7645 C",
  "223 C",
  "224 C",
  "225 C",
  "226 C",
  "227 C",
  "228 C",
  "229 C",
  "230 C",
  "231 C",
  "232 C",
  "233 C",
  "234 C",
  "235 C",
  "670 C",
  "671 C",
  "672 C",
  "673 C",
  "674 C",
  "675 C",
  "676 C",
  "677 C",
  "678 C",
  "679 C",
  "680 C",
  "681 C",
  "682 C",
  "683 C",
  "684 C",
  "685 C",
  "686 C",
  "687 C",
  "688 C",
  "689 C",
  "690 C",
  "510 C",
  "509 C",
  "508 C",
  "507 C",
  "506 C",
  "505 C",
  "504 C",
  "7429 C",
  "7430 C",
  "7431 C",
  "7432 C",
  "7433 C",
  "7434 C",
  "7435 C",
  "691 C",
  "692 C",
  "693 C",
  "694 C",
  "695 C",
  "696 C",
  "697 C",
  "496 C",
  "495 C",
  "494 C",
  "493 C",
  "492 C",
  "491 C",
  "490 C",
  "503 C",
  "502 C",
  "501 C",
  "500 C",
  "499 C",
  "498 C",
  "497 C",
  "5035 C",
  "5025 C",
  "5015 C",
  "5005 C",
  "4995 C",
  "4985 C",
  "4975 C",
  "236 C",
  "237 C",
  "238 C",
  "239 C",
  "240 C",
  "241 C",
  "242 C",
  "2365 C",
  "2375 C",
  "2385 C",
  "2395 C",
  "2405 C",
  "2415 C",
  "2425 C",
  "243 C",
  "244 C",
  "245 C",
  "246 C",
  "247 C",
  "248 C",
  "249 C",
  "7646 C",
  "7647 C",
  "7648 C",
  "7649 C",
  "7650 C",
  "7651 C",
  "7652 C",
  "250 C",
  "251 C",
  "252 C",
  "253 C",
  "254 C",
  "255 C",
  "517 C",
  "516 C",
  "515 C",
  "514 C",
  "513 C",
  "512 C",
  "511 C",
  "7436 C",
  "7437 C",
  "7438 C",
  "7439 C",
  "7440 C",
  "7441 C",
  "7442 C",
  "2562 C",
  "2572 C",
  "2582 C",
  "2592 C",
  "2602 C",
  "2612 C",
  "2622 C",
  "7653 C",
  "7654 C",
  "7655 C",
  "7656 C",
  "7657 C",
  "7658 C",
  "7659 C",
  "524 C",
  "523 C",
  "522 C",
  "521 C",
  "520 C",
  "519 C",
  "518 C",
  "5245 C",
  "5235 C",
  "5225 C",
  "5215 C",
  "5205 C",
  "5195 C",
  "5185 C",
  "5175 C",
  "5165 C",
  "5155 C",
  "5145 C",
  "5135 C",
  "5125 C",
  "5115 C",
  "531 C",
  "530 C",
  "529 C",
  "528 C",
  "527 C",
  "526 C",
  "525 C",
  "256 C",
  "257 C",
  "258 C",
  "259 C",
  "260 C",
  "261 C",
  "262 C",
  "2563 C",
  "2573 C",
  "2583 C",
  "2593 C",
  "2603 C",
  "2613 C",
  "2623 C",
  "7660 C",
  "7661 C",
  "7662 C",
  "7663 C",
  "7664 C",
  "7665 C",
  "7666 C",
  "2567 C",
  "2577 C",
  "2587 C",
  "2597 C",
  "2607 C",
  "2617 C",
  "2627 C",
  "263 C",
  "264 C",
  "265 C",
  "266 C",
  "267 C",
  "268 C",
  "269 C",
  "2635 C",
  "2645 C",
  "2655 C",
  "2665 C",
  "2685 C",
  "2695 C",
  "270 C",
  "271 C",
  "272 C",
  "273 C",
  "274 C",
  "275 C",
  "276 C",
  "2705 C",
  "2715 C",
  "2725 C",
  "2735 C",
  "2745 C",
  "2755 C",
  "2765 C",
  "7667 C",
  "7668 C",
  "7669 C",
  "7670 C",
  "7671 C",
  "7672 C",
  "7673 C",
  "7443 C",
  "7444 C",
  "7445 C",
  "7446 C",
  "7447 C",
  "7448 C",
  "7449 C",
  "7674 C",
  "7675 C",
  "7676 C",
  "7677 C",
  "7678 C",
  "7679 C",
  "7680 C",
  "663 C",
  "664 C",
  "665 C",
  "666 C",
  "667 C",
  "668 C",
  "669 C",
  "5315 C",
  "5305 C",
  "5295 C",
  "5285 C",
  "5275 C",
  "5265 C",
  "5255 C",
  "538 C",
  "537 C",
  "536 C",
  "535 C",
  "534 C",
  "533 C",
  "532 C",
  "7541 C",
  "7542 C",
  "7543 C",
  "7544 C",
  "7545 C",
  "7546 C",
  "7547 C",
  "552 C",
  "551 C",
  "550 C",
  "549 C",
  "548 C",
  "547 C",
  "546 C",
  "5455 C",
  "5445 C",
  "5435 C",
  "5425 C",
  "5415 C",
  "5405 C",
  "5395 C",
  "642 C",
  "643 C",
  "644 C",
  "645 C",
  "646 C",
  "647 C",
  "648 C",
  "649 C",
  "650 C",
  "651 C",
  "652 C",
  "653 C",
  "654 C",
  "655 C",
  "656 C",
  "657 C",
  "658 C",
  "659 C",
  "660 C",
  "661 C",
  "662 C",
  "7450 C",
  "7451 C",
  "7452 C",
  "7453 C",
  "7454 C",
  "7455 C",
  "7456 C",
  "2706 C",
  "2716 C",
  "2726 C",
  "2736 C",
  "2746 C",
  "2756 C",
  "2766 C",
  "2708 C",
  "2718 C",
  "2728 C",
  "2738 C",
  "2748 C",
  "2758 C",
  "2768 C",
  "2707 C",
  "2717 C",
  "2727 C",
  "2747 C",
  "2757 C",
  "2767 C",
  "277 C",
  "278 C",
  "279 C",
  "280 C",
  "281 C",
  "282 C",
  "283 C",
  "284 C",
  "285 C",
  "286 C",
  "287 C",
  "288 C",
  "289 C",
  "7681 C",
  "7682 C",
  "7683 C",
  "7684 C",
  "7685 C",
  "7686 C",
  "7687 C",
  "545 C",
  "544 C",
  "543 C",
  "542 C",
  "541 C",
  "540 C",
  "539 C",
  "290 C",
  "291 C",
  "292 C",
  "293 C",
  "294 C",
  "295 C",
  "296 C",
  "2905 C",
  "2915 C",
  "2925 C",
  "2935 C",
  "2945 C",
  "2955 C",
  "2965 C",
  "297 C",
  "298 C",
  "299 C",
  "300 C",
  "301 C",
  "302 C",
  "303 C",
  "7688 C",
  "7689 C",
  "7690 C",
  "7691 C",
  "7692 C",
  "7693 C",
  "7694 C",
  "2975 C",
  "2985 C",
  "2995 C",
  "3005 C",
  "3015 C",
  "3025 C",
  "3035 C",
  "7695 C",
  "7696 C",
  "7697 C",
  "7698 C",
  "7699 C",
  "7700 C",
  "7701 C",
  "7457 C",
  "7458 C",
  "7459 C",
  "7460 C",
  "7461 C",
  "7462 C",
  "7463 C",
  "304 C",
  "305 C",
  "306 C",
  "307 C",
  "308 C",
  "309 C",
  "635 C",
  "636 C",
  "637 C",
  "638 C",
  "639 C",
  "640 C",
  "641 C",
  "7702 C",
  "7703 C",
  "7704 C",
  "7705 C",
  "7706 C",
  "7707 C",
  "7708 C",
  "628 C",
  "629 C",
  "630 C",
  "631 C",
  "632 C",
  "633 C",
  "634 C",
  "310 C",
  "311 C",
  "312 C",
  "313 C",
  "314 C",
  "315 C",
  "316 C",
  "3105 C",
  "3115 C",
  "3125 C",
  "3135 C",
  "3145 C",
  "3155 C",
  "3165 C",
  "7709 C",
  "7710 C",
  "7711 C",
  "7712 C",
  "7713 C",
  "7714 C",
  "7715 C",
  "317 C",
  "318 C",
  "319 C",
  "320 C",
  "321 C",
  "322 C",
  "323 C",
  "7464 C",
  "7465 C",
  "7466 C",
  "7467 C",
  "7468 C",
  "7469 C",
  "7470 C",
  "7471 C",
  "7472 C",
  "7473 C",
  "7474 C",
  "7475 C",
  "7476 C",
  "7477 C",
  "5523 C",
  "5513 C",
  "5503 C",
  "5493 C",
  "5483 C",
  "5473 C",
  "5463 C",
  "7716 C",
  "7717 C",
  "7718 C",
  "7719 C",
  "7720 C",
  "7721 C",
  "7722 C",
  "324 C",
  "325 C",
  "326 C",
  "327 C",
  "328 C",
  "329 C",
  "330 C",
  "3242 C",
  "3252 C",
  "3262 C",
  "3272 C",
  "3282 C",
  "3292 C",
  "3302 C",
  "3245 C",
  "3255 C",
  "3265 C",
  "3275 C",
  "3285 C",
  "3295 C",
  "3305 C",
  "3248 C",
  "3258 C",
  "3268 C",
  "3278 C",
  "3288 C",
  "3298 C",
  "3308 C",
  "566 C",
  "565 C",
  "564 C",
  "563 C",
  "562 C",
  "561 C",
  "560 C",
  "573 C",
  "572 C",
  "571 C",
  "570 C",
  "569 C",
  "568 C",
  "567 C",
  "559 C",
  "558 C",
  "557 C",
  "556 C",
  "555 C",
  "554 C",
  "553 C",
  "5595 C",
  "5585 C",
  "5575 C",
  "5565 C",
  "5555 C",
  "5545 C",
  "5535 C",
  "5665 C",
  "5655 C",
  "5645 C",
  "5635 C",
  "5625 C",
  "5615 C",
  "5605 C",
  "5527 C",
  "5517 C",
  "5507 C",
  "5497 C",
  "5487 C",
  "5477 C",
  "5467 C",
  "621 C",
  "622 C",
  "623 C",
  "624 C",
  "625 C",
  "626 C",
  "627 C",
  "331 C",
  "332 C",
  "333 C",
  "334 C",
  "335 C",
  "336 C",
  "337 C",
  "338 C",
  "339 C",
  "340 C",
  "341 C",
  "342 C",
  "343 C",
  "7723 C",
  "7724 C",
  "7725 C",
  "7726 C",
  "7727 C",
  "7728 C",
  "7729 C",
  "3375 C",
  "3385 C",
  "3395 C",
  "3405 C",
  "3415 C",
  "3425 C",
  "3435 C",
  "344 C",
  "345 C",
  "346 C",
  "347 C",
  "348 C",
  "349 C",
  "350 C",
  "351 C",
  "352 C",
  "353 C",
  "354 C",
  "355 C",
  "356 C",
  "357 C",
  "7478 C",
  "7479 C",
  "7480 C",
  "7481 C",
  "7482 C",
  "7483 C",
  "7484 C",
  "7730 C",
  "7731 C",
  "7732 C",
  "7733 C",
  "7734 C",
  "7735 C",
  "7736 C",
  "7737 C",
  "7738 C",
  "7739 C",
  "7740 C",
  "7741 C",
  "7742 C",
  "7743 C",
  "358 C",
  "359 C",
  "360 C",
  "361 C",
  "362 C",
  "363 C",
  "364 C",
  "7485 C",
  "7486 C",
  "7487 C",
  "7488 C",
  "7489 C",
  "7490 C",
  "7491 C",
  "365 C",
  "366 C",
  "367 C",
  "368 C",
  "369 C",
  "370 C",
  "371 C",
  "372 C",
  "373 C",
  "374 C",
  "375 C",
  "376 C",
  "377 C",
  "378 C",
  "580 C",
  "579 C",
  "578 C",
  "577 C",
  "576 C",
  "575 C",
  "574 C",
  "5807 C",
  "5797 C",
  "5787 C",
  "5777 C",
  "5767 C",
  "5757 C",
  "5747 C",
  "5875 C",
  "5865 C",
  "5855 C",
  "5845 C",
  "5835 C",
  "5825 C",
  "5815 C",
  "5803 C",
  "5793 C",
  "5783 C",
  "5773 C",
  "5763 C",
  "5753 C",
  "5743 C",
  "7492 C",
  "7493 C",
  "7494 C",
  "7495 C",
  "7496 C",
  "7497 C",
  "7498 C",
  "7744 C",
  "7745 C",
  "7746 C",
  "7747 C",
  "7748 C",
  "7749 C",
  "7750 C",
  "379 C",
  "380 C",
  "381 C",
  "382 C",
  "383 C",
  "384 C",
  "385 C",
  "386 C",
  "387 C",
  "388 C",
  "389 C",
  "390 C",
  "391 C",
  "392 C",
  "587 C",
  "586 C",
  "585 C",
  "584 C",
  "583 C",
  "582 C",
  "581 C",
  "393 C",
  "394 C",
  "395 C",
  "396 C",
  "397 C",
  "398 C",
  "399 C",
  "3935 C",
  "3945 C",
  "3955 C",
  "3965 C",
  "3975 C",
  "3985 C",
  "3995 C",
  "600 C",
  "601 C",
  "602 C",
  "603 C",
  "604 C",
  "605 C",
  "606 C",
  "607 C",
  "608 C",
  "609 C",
  "610 C",
  "611 C",
  "612 C",
  "613 C",
  "461 C",
  "460 C",
  "459 C",
  "458 C",
  "457 C",
  "456 C",
  "455 C",
  "614 C",
  "615 C",
  "616 C",
  "617 C",
  "618 C",
  "619 C",
  "620 C",
  "7751 C",
  "7752 C",
  "7753 C",
  "7754 C",
  "7755 C",
  "7756 C",
  "7757 C",
  "7758 C",
  "7759 C",
  "7760 C",
  "7761 C",
  "7762 C",
  "7763 C",
  "7764 C",
  "7765 C",
  "7766 C",
  "7767 C",
  "7768 C",
  "7769 C",
  "7770 C",
  "7771 C",
  "4545 C",
  "4535 C",
  "4525 C",
  "4515 C",
  "4505 C",
  "4495 C",
  "4485 C",
  "454 C",
  "453 C",
  "452 C",
  "451 C",
  "450 C",
  "449 C",
  "448 C",
  "7499 C",
  "7500 C",
  "7501 C",
  "7502 C",
  "7503 C",
  "7504 C",
  "7505 C",
  "468 C",
  "467 C",
  "466 C",
  "465 C",
  "464 C",
  "463 C",
  "462 C",
  "7506 C",
  "7507 C",
  "7508 C",
  "7509 C",
  "7510 C",
  "7511 C",
  "7512 C",
  "719 C",
  "720 C",
  "721 C",
  "722 C",
  "723 C",
  "724 C",
  "725 C",
  "475 C",
  "474 C",
  "473 C",
  "472 C",
  "471 C",
  "470 C",
  "469 C",
  "726 C",
  "727 C",
  "728 C",
  "729 C",
  "730 C",
  "731 C",
  "732 C",
  "4685 C",
  "4675 C",
  "4665 C",
  "4655 C",
  "4645 C",
  "4635 C",
  "4625 C",
  "7513 C",
  "7514 C",
  "7515 C",
  "7516 C",
  "7517 C",
  "7518 C",
  "7519 C",
  "4755 C",
  "4745 C",
  "4735 C",
  "4725 C",
  "4715 C",
  "4705 C",
  "4695 C",
  "482 C",
  "481 C",
  "480 C",
  "479 C",
  "478 C",
  "477 C",
  "476 C",
  "7527 C",
  "7528 C",
  "7529 C",
  "7530 C",
  "7531 C",
  "7532 C",
  "7533 C",
  "7534 C",
  "7535 C",
  "7536 C",
  "7537 C",
  "7538 C",
  "7539 C",
  "7540 C",
  "427 C",
  "428 C",
  "429 C",
  "430 C",
  "431 C",
  "432 C",
  "433 C",
  "420 C",
  "421 C",
  "422 C",
  "423 C",
  "424 C",
  "425 C",
  "426 C",
  "441 C",
  "442 C",
  "443 C",
  "444 C",
  "445 C",
  "446 C",
  "447 C",
  "413 C",
  "414 C",
  "415 C",
  "416 C",
  "417 C",
  "418 C",
  "419 C",
  "400 C",
  "401 C",
  "402 C",
  "403 C",
  "404 C",
  "405 C",
  "406 C",
  "407 C",
  "408 C",
  "409 C",
  "410 C",
  "411 C",
  "412 C",
  "434 C",
  "435 C",
  "436 C",
  "437 C",
  "438 C",
  "439 C",
  "440 C",
  "Warm Gray 1 C",
  "Warm Gray 2 C",
  "Warm Gray 3 C",
  "Warm Gray 4 C",
  "Warm Gray 5 C",
  "Warm Gray 6 C",
  "Warm Gray 7 C",
  "Warm Gray 8 C",
  "Warm Gray 9 C",
  "Warm Gray 10 C",
  "Warm Gray 11 C",
  "Cool Gray 1 C",
  "Cool Gray 2 C",
  "Cool Gray 3 C",
  "Cool Gray 4 C",
  "Cool Gray 5 C",
  "Cool Gray 6 C",
  "Cool Gray 7 C",
  "Cool Gray 8 C",
  "Cool Gray 9 C",
  "Cool Gray 10 C",
  "Cool Gray 11 C",
  "Black 2 C",
  "Black 3 C",
  "Black 4 C",
  "Black 5 C",
  "Black 6 C",
  "Black 7 C"
], $d = [
  "FFFFFF",
  "FEDD00",
  "FFD700",
  "FE5000",
  "F9423A",
  "EF3340",
  "CE0058",
  "E10098",
  "BB29BB",
  "440099",
  "10069F",
  "001489",
  "0085CA",
  "00AB84",
  "2D2926",
  "F2F0A1",
  "FCAEBB",
  "F1B2DC",
  "BF9BDE",
  "74D1EA",
  "9DE7D7",
  "9E978E",
  "009ACE",
  "44D62C",
  "FFE900",
  "FFAA4D",
  "FF7276",
  "FF3EB5",
  "EA27C2",
  "84754E",
  "85714D",
  "866D4B",
  "8B6F4E",
  "87674F",
  "8B634B",
  "8A8D8F",
  "FFD900",
  "FF5E00",
  "F93822",
  "CE0056",
  "D62598",
  "4E008E",
  "00239C",
  "0084CA",
  "00B08B",
  "222223",
  "F6EB61",
  "F7EA48",
  "FCE300",
  "C5A900",
  "AF9800",
  "897A27",
  "F5E1A4",
  "ECD898",
  "EED484",
  "F4DA40",
  "F2CD00",
  "F1C400",
  "CBA052",
  "F9E547",
  "FBE122",
  "FEDB00",
  "FFD100",
  "DAAA00",
  "AA8A00",
  "9C8412",
  "FAE053",
  "FBDD40",
  "FDDA24",
  "FFCD00",
  "C99700",
  "AC8400",
  "897322",
  "F3DD6D",
  "F3D54E",
  "F3D03E",
  "F2A900",
  "CC8A00",
  "A07400",
  "6C571B",
  "F8E08E",
  "FBD872",
  "FFC845",
  "FFB81C",
  "C69214",
  "AD841F",
  "886B25",
  "FBDB65",
  "FDD757",
  "FED141",
  "FFC72C",
  "EAAA00",
  "B58500",
  "9A7611",
  "FFC600",
  "FFB500",
  "D19000",
  "B47E00",
  "73531D",
  "5A4522",
  "4B3D2A",
  "D29F13",
  "B78B20",
  "9F7D23",
  "967126",
  "8F6A2A",
  "7D622E",
  "6C5D34",
  "FDD26E",
  "FFC658",
  "FFBF3F",
  "FFA300",
  "DE7C00",
  "AF6D04",
  "74531C",
  "FDD086",
  "FFC56E",
  "FFB549",
  "FF9E1B",
  "D57800",
  "996017",
  "6E4C1E",
  "F2C75C",
  "F1BE48",
  "F1B434",
  "ED8B00",
  "CF7F00",
  "A76D11",
  "715C2A",
  "F6BE00",
  "F0B323",
  "FEAD77",
  "E6A65D",
  "D38235",
  "DC8633",
  "C16C18",
  "BD9B60",
  "D69A2D",
  "DB8A06",
  "CD7925",
  "AD6433",
  "89532F",
  "775135",
  "D78825",
  "D3832B",
  "C67D30",
  "B67233",
  "A7662B",
  "9E6A38",
  "835D32",
  "FCC89B",
  "FDBE87",
  "FDAA63",
  "F68D2E",
  "EA7600",
  "D45D00",
  "BE4D00",
  "FECB8B",
  "FFC27B",
  "FFB25B",
  "FF8200",
  "E57200",
  "BE6A14",
  "9B5A1A",
  "EFD19F",
  "EFBE7D",
  "ECA154",
  "E87722",
  "CB6015",
  "A1561C",
  "603D20",
  "FFAE62",
  "FF8F1C",
  "FF6900",
  "B94700",
  "94450B",
  "653819",
  "FFB990",
  "FFA06A",
  "FF7F32",
  "FF6A13",
  "D86018",
  "A65523",
  "8B4720",
  "FFBE9F",
  "FF9D6E",
  "FF7F41",
  "FF671F",
  "E35205",
  "BE531C",
  "73381D",
  "DB864E",
  "E07E3C",
  "DC6B2F",
  "DC582A",
  "C05131",
  "864A33",
  "674736",
  "FFA38B",
  "FF8D6D",
  "FF6A39",
  "FC4C02",
  "DC4405",
  "A9431E",
  "833921",
  "FFB3AB",
  "FF8674",
  "FF5C39",
  "FA4616",
  "CF4520",
  "963821",
  "6B3529",
  "C4622D",
  "BA5826",
  "AF5C37",
  "9E5330",
  "924C2E",
  "7B4D35",
  "5C4738",
  "D4B59E",
  "C07D59",
  "B15533",
  "9D432C",
  "7C3A2D",
  "6B3D2E",
  "5C3D31",
  "D14124",
  "BD472A",
  "B33D26",
  "8D3F2B",
  "83412C",
  "7B4931",
  "674230",
  "E4D5D3",
  "E1BBB4",
  "D6938A",
  "C26E60",
  "A4493D",
  "823B34",
  "683431",
  "DDBCB0",
  "CA9A8E",
  "BC8A7E",
  "A37F74",
  "866761",
  "6B4C4C",
  "583D3E",
  "EABEB0",
  "C09C83",
  "B46A55",
  "AB5C57",
  "A45248",
  "9A6A4F",
  "8A391B",
  "ECC3B2",
  "ECBAA8",
  "EAA794",
  "E8927C",
  "DA291C",
  "9A3324",
  "653024",
  "FFB1BB",
  "FF808B",
  "FF585D",
  "E03C31",
  "BE3A34",
  "81312F",
  "FFA3B5",
  "FF8DA1",
  "F8485E",
  "EE2737",
  "D22630",
  "AF272F",
  "7C2529",
  "FCAFC0",
  "FB637E",
  "F4364C",
  "CB333B",
  "A4343A",
  "643335",
  "C66E4E",
  "C04C36",
  "B7312C",
  "AB2328",
  "93272C",
  "8A2A2B",
  "802F2D",
  "E1523D",
  "C63527",
  "A72B2A",
  "9E2A2B",
  "6D3332",
  "633231",
  "572D2D",
  "E6BAA8",
  "E56A54",
  "E04E39",
  "CD545B",
  "B04A5A",
  "9B2242",
  "651D32",
  "FABBCB",
  "FC9BB3",
  "F65275",
  "E4002B",
  "C8102E",
  "A6192E",
  "76232F",
  "ECC7CD",
  "E89CAE",
  "DF4661",
  "D50032",
  "BA0C2F",
  "9D2235",
  "862633",
  "F8A3BC",
  "F67599",
  "EF426F",
  "E40046",
  "BF0D3E",
  "9B2743",
  "782F40",
  "F5B6CD",
  "F59BBB",
  "EF4A81",
  "E0004D",
  "C5003E",
  "A6093D",
  "8A1538",
  "F5DADF",
  "F7CED7",
  "F9B5C4",
  "F890A5",
  "EF6079",
  "E03E52",
  "CB2C30",
  "F2D4D7",
  "F4C3CC",
  "F2ACB9",
  "E68699",
  "D25B73",
  "B83A4B",
  "9E2A2F",
  "ECB3CB",
  "E782A9",
  "E0457B",
  "CE0037",
  "A50034",
  "861F41",
  "6F263D",
  "F99FC9",
  "F57EB6",
  "F04E98",
  "E31C79",
  "CE0F69",
  "AC145A",
  "7D2248",
  "F4CDD4",
  "E06287",
  "E24585",
  "B52555",
  "A4123F",
  "971B2F",
  "6A2C3E",
  "D6C9CA",
  "C4A4A7",
  "C16784",
  "C63663",
  "BC204B",
  "912F46",
  "7E2D40",
  "EABEDB",
  "E56DB1",
  "DA1884",
  "A50050",
  "910048",
  "6C1D45",
  "936D73",
  "934054",
  "8E2C48",
  "732E4A",
  "672E45",
  "582D40",
  "502B3A",
  "EF95CF",
  "EB6FBD",
  "DF1995",
  "D0006F",
  "AA0061",
  "890C58",
  "672146",
  "F4A6D7",
  "F277C6",
  "E93CAC",
  "C6007E",
  "A20067",
  "840B55",
  "EAD3E2",
  "E6BCD8",
  "DFA0C9",
  "D986BA",
  "C6579A",
  "AE2573",
  "960051",
  "E5CEDB",
  "E3C8D8",
  "DEBED2",
  "C996B6",
  "B06C96",
  "994878",
  "7C2855",
  "E4C6D4",
  "DCB6C9",
  "D0A1BA",
  "BE84A3",
  "A76389",
  "893B67",
  "612141",
  "EBBECB",
  "E8B3C3",
  "E4A9BB",
  "D592AA",
  "84344E",
  "6F2C3F",
  "572932",
  "E2BCCB",
  "DCA9BF",
  "C9809E",
  "B55C80",
  "A73A64",
  "9B3259",
  "872651",
  "E9CDD0",
  "E4BEC3",
  "D7A3AB",
  "C48490",
  "B46B7A",
  "984856",
  "893C47",
  "F2C6CF",
  "F1BDC8",
  "E9A2B2",
  "DC8699",
  "8F3237",
  "7F3035",
  "5D2A2C",
  "E9C4C7",
  "E5BAC1",
  "DAA5AD",
  "C6858F",
  "7A3E3A",
  "6A3735",
  "512F2E",
  "DFC2C3",
  "DBB7BB",
  "CCA1A6",
  "B07C83",
  "9C6169",
  "874B52",
  "3F2021",
  "F1A7DC",
  "EC86D0",
  "E45DBF",
  "DB3EB1",
  "C5299B",
  "AF1685",
  "80225F",
  "EFBAE1",
  "E277CD",
  "D539B5",
  "C800A1",
  "B0008E",
  "9E007E",
  "830065",
  "EAB8E4",
  "E59BDC",
  "DD7FD3",
  "C724B1",
  "BB16A3",
  "A51890",
  "80276C",
  "A56E87",
  "A83D72",
  "991E66",
  "8A1B61",
  "722257",
  "6A2A5B",
  "5E2751",
  "E7BAE4",
  "DD9CDF",
  "C964CF",
  "AD1AAC",
  "981D97",
  "72246C",
  "EBC6DF",
  "E6BEDD",
  "E2ACD7",
  "D48BC8",
  "93328E",
  "833177",
  "612C51",
  "EEDAEA",
  "CCAED0",
  "D59ED7",
  "B288B9",
  "A277A6",
  "9F5CC0",
  "963CBD",
  "D7A9E3",
  "C98BDB",
  "AC4FC6",
  "9B26B6",
  "87189D",
  "772583",
  "653165",
  "948794",
  "A2789C",
  "A15A95",
  "8E3A80",
  "6E2B62",
  "6A3460",
  "5D3754",
  "D5C2D8",
  "C9B1D0",
  "BA9CC5",
  "A57FB2",
  "642F6C",
  "59315F",
  "4B3048",
  "DBCDD3",
  "D0BEC7",
  "C6B0BC",
  "AF95A6",
  "86647A",
  "66435A",
  "4A3041",
  "D8C8D1",
  "D3C0CD",
  "BFA5B8",
  "9B7793",
  "7E5475",
  "693C5E",
  "512A44",
  "DFC8E7",
  "D7B9E4",
  "CAA2DD",
  "B580D1",
  "8031A7",
  "702F8A",
  "572C5F",
  "D6BFDD",
  "C6A1CF",
  "8C4799",
  "6D2077",
  "642667",
  "5D285F",
  "51284F",
  "CBA3D8",
  "B884CB",
  "A05EB5",
  "84329B",
  "702082",
  "671E75",
  "5F2167",
  "9991A4",
  "8D6E97",
  "7A4183",
  "6B3077",
  "653279",
  "5E366E",
  "5C4E63",
  "C1A0DA",
  "A77BCA",
  "8246AF",
  "5C068C",
  "500778",
  "470A68",
  "3C1053",
  "D7C6E6",
  "C1A7E2",
  "9063CD",
  "753BBD",
  "5F259F",
  "582C83",
  "512D6D",
  "C5B4E3",
  "AD96DC",
  "9678D3",
  "7D55C7",
  "330072",
  "2E1A47",
  "B4B5DF",
  "9595D2",
  "7474C1",
  "24135F",
  "211551",
  "201747",
  "221C35",
  "A7A4E0",
  "8B84D7",
  "685BC7",
  "2E008B",
  "280071",
  "250E62",
  "201547",
  "6E7CA0",
  "686E9F",
  "615E9B",
  "565294",
  "514689",
  "4C4184",
  "535486",
  "DDDAE8",
  "B6B8DC",
  "A7A2C3",
  "8986CA",
  "5D4777",
  "4B384C",
  "41273B",
  "878CB4",
  "7C7FAB",
  "7566A0",
  "6F5091",
  "68478D",
  "563D82",
  "523178",
  "E5E1E6",
  "E0DBE3",
  "C6BCD0",
  "A192B2",
  "7C6992",
  "614B79",
  "3F2A56",
  "D8D7DF",
  "C6C4D2",
  "B3B0C4",
  "8D89A5",
  "595478",
  "403A60",
  "1E1A34",
  "C5CFDA",
  "BBC7D6",
  "A2B2C8",
  "8E9FBC",
  "1B365D",
  "1F2A44",
  "1C1F2A",
  "D9E1E2",
  "A4BCC2",
  "98A4AE",
  "768692",
  "425563",
  "253746",
  "131E29",
  "B9D3DC",
  "A3C7D2",
  "8DB9CA",
  "6BA4B8",
  "003D4C",
  "00313C",
  "072B31",
  "BFCED6",
  "B7C9D3",
  "A6BBC8",
  "7A99AC",
  "5B7F95",
  "4F758B",
  "081F2C",
  "D1DDE6",
  "C6D6E3",
  "9BB8D3",
  "7DA1C4",
  "5E8AB4",
  "236192",
  "002E5D",
  "DBE2E9",
  "CED9E5",
  "A7BCD6",
  "7D9BC1",
  "326295",
  "003A70",
  "002554",
  "DDE5ED",
  "C8D8EB",
  "B1C9E8",
  "7BA4DB",
  "407EC9",
  "003594",
  "001A70",
  "BDC5DB",
  "89ABE3",
  "8094DD",
  "7BA6DE",
  "5F8FB4",
  "3A5DAE",
  "606EB2",
  "CBD3EB",
  "9FAEE5",
  "485CC7",
  "1E22AA",
  "171C8F",
  "151F6D",
  "141B4D",
  "B8CCEA",
  "5C88DA",
  "0047BB",
  "06038D",
  "001871",
  "001E62",
  "071D49",
  "C3D7EE",
  "A7C6ED",
  "307FE2",
  "001A72",
  "001E60",
  "13294B",
  "ABCAE9",
  "8BB8E8",
  "418FDE",
  "012169",
  "00205B",
  "041E42",
  "92C1E9",
  "6CACE4",
  "0072CE",
  "0033A0",
  "003087",
  "002D72",
  "0C2340",
  "94A9CB",
  "6787B7",
  "426DA9",
  "385E9D",
  "2C5697",
  "1D4F91",
  "1D428A",
  "C6DAE7",
  "BDD6E6",
  "A4C8E1",
  "7BAFD4",
  "003C71",
  "003057",
  "00263A",
  "B9D9EB",
  "9BCBEB",
  "69B3E7",
  "003DA5",
  "002F6C",
  "002855",
  "041C2C",
  "8DC8E8",
  "62B5E5",
  "009CDE",
  "0057B8",
  "004C97",
  "003865",
  "00263E",
  "71C5E8",
  "41B6E6",
  "00A3E0",
  "005EB8",
  "004B87",
  "003B5C",
  "002A3A",
  "4698CB",
  "298FC2",
  "0076A8",
  "006298",
  "005587",
  "004976",
  "01426A",
  "99D6EA",
  "5BC2E7",
  "00A9E0",
  "0077C8",
  "00629B",
  "004F71",
  "003E51",
  "7BA7BC",
  "6399AE",
  "4E87A0",
  "41748D",
  "34657F",
  "165C7D",
  "005776",
  "BBDDE6",
  "71B2C9",
  "4298B5",
  "0086BF",
  "007DBA",
  "00558C",
  "002B49",
  "9ADBE8",
  "59CBE8",
  "00B5E2",
  "006BA6",
  "00587C",
  "003B49",
  "A4DBE8",
  "8BD3E6",
  "4EC3E0",
  "00AFD7",
  "0095C8",
  "0082BA",
  "0067A0",
  "48A9C5",
  "009CBD",
  "0085AD",
  "007096",
  "006A8E",
  "00617F",
  "005670",
  "B8DDE1",
  "9BD3DD",
  "77C5D5",
  "3EB1C8",
  "0093B2",
  "007396",
  "005F83",
  "6AD1E3",
  "05C3DE",
  "00A9CE",
  "0092BC",
  "007FA3",
  "00677F",
  "004851",
  "68D2DF",
  "00C1D5",
  "00AEC7",
  "008EAA",
  "00778B",
  "006272",
  "004F59",
  "63B1BC",
  "00A7B5",
  "0097A9",
  "00859B",
  "007D8A",
  "007680",
  "006269",
  "B1E4E3",
  "88DBDF",
  "2DCCD3",
  "009CA6",
  "008C95",
  "007377",
  "005F61",
  "A0D1CA",
  "40C1AC",
  "00B0B9",
  "00A3AD",
  "007398",
  "005F86",
  "005A70",
  "7EDDD3",
  "5CB8B2",
  "279989",
  "007681",
  "487A7B",
  "0D5257",
  "244C5A",
  "B6CFD0",
  "ABC7CA",
  "94B7BB",
  "7FA9AE",
  "4F868E",
  "115E67",
  "07272D",
  "00968F",
  "00857D",
  "007672",
  "006D68",
  "00635B",
  "005E5D",
  "005151",
  "9CDBD9",
  "64CCC9",
  "00B2A9",
  "008675",
  "007367",
  "00685E",
  "00534C",
  "71DBD4",
  "2AD2C9",
  "00BFB3",
  "00A499",
  "008578",
  "00594F",
  "004C45",
  "7CE0D3",
  "2CD5C4",
  "00C7B1",
  "00B398",
  "009681",
  "007864",
  "004E42",
  "6DCDB8",
  "49C5B1",
  "00AB8E",
  "009B77",
  "008264",
  "006A52",
  "034638",
  "B9DCD2",
  "A1D6CA",
  "86C8BC",
  "6BBBAE",
  "006F62",
  "00594C",
  "1D3C34",
  "B5E3D8",
  "A5DFD3",
  "98DBCE",
  "6BCABA",
  "00816D",
  "006C5B",
  "173F35",
  "ADCAB8",
  "9ABEAA",
  "85B09A",
  "6FA287",
  "28724F",
  "205C40",
  "284734",
  "BFCEC2",
  "A7BDB1",
  "92ACA0",
  "7F9C90",
  "5C7F71",
  "43695B",
  "183028",
  "BAC5B9",
  "B0BDB0",
  "A3B2A4",
  "94A596",
  "708573",
  "5E7461",
  "22372B",
  "BCC9C5",
  "B1C0BC",
  "9DB0AC",
  "829995",
  "5D7975",
  "3E5D58",
  "18332F",
  "D1E0D7",
  "B7CDC2",
  "9AB9AD",
  "789F90",
  "507F70",
  "285C4D",
  "13322B",
  "A7E6D7",
  "8CE2D0",
  "3CDBC0",
  "009775",
  "007B5F",
  "00664F",
  "8FD6BD",
  "6ECEB2",
  "00B388",
  "00965E",
  "007A53",
  "006747",
  "115740",
  "50A684",
  "00966C",
  "008755",
  "007B4B",
  "006F44",
  "006845",
  "005844",
  "7AE1BF",
  "47D7AC",
  "00C389",
  "00AF66",
  "007749",
  "006341",
  "154734",
  "A0DAB3",
  "91D6AC",
  "71CC98",
  "009A44",
  "00843D",
  "046A38",
  "2C5234",
  "A2E4B8",
  "8FE2B0",
  "80E0A7",
  "00B140",
  "009639",
  "007A33",
  "215732",
  "9BE3BF",
  "26D07C",
  "00BF6F",
  "00B74F",
  "009F4D",
  "275D38",
  "00573F",
  "4B9560",
  "228848",
  "007A3E",
  "007041",
  "286140",
  "36573B",
  "395542",
  "6BA539",
  "48A23F",
  "319B42",
  "3A913F",
  "44883E",
  "4A773C",
  "44693D",
  "ADDC91",
  "A1D884",
  "6CC24A",
  "43B02A",
  "509E2F",
  "4C8C2B",
  "4A7729",
  "D0DEBB",
  "BCE194",
  "8EDD65",
  "78D64B",
  "74AA50",
  "719949",
  "79863C",
  "C2E189",
  "B7DD79",
  "A4D65E",
  "78BE20",
  "64A70B",
  "658D1B",
  "546223",
  "D4EB8E",
  "CDEA80",
  "C5E86C",
  "97D700",
  "84BD00",
  "7A9A01",
  "59621D",
  "C4D6A4",
  "BCD19B",
  "B7CE95",
  "A9C47F",
  "789D4A",
  "67823A",
  "4E5B31",
  "D0D1AB",
  "C6C89B",
  "BABD8B",
  "A2A569",
  "8A8D4A",
  "6D712E",
  "3D441E",
  "D2CE9E",
  "CBC793",
  "C0BB87",
  "AFA96E",
  "A09958",
  "89813D",
  "555025",
  "C3C6A8",
  "B3B995",
  "A3AA83",
  "899064",
  "737B4C",
  "5E6738",
  "3E4827",
  "BFCC80",
  "BBC592",
  "9CAF88",
  "8F993E",
  "76881D",
  "7A7256",
  "5B6236",
  "BABC16",
  "ABAD23",
  "999B30",
  "888D30",
  "7C8034",
  "727337",
  "656635",
  "E2E868",
  "DBE442",
  "CEDC00",
  "C4D600",
  "A8AD00",
  "949300",
  "787121",
  "E9EC6B",
  "E3E935",
  "E0E721",
  "D0DF00",
  "B5BD00",
  "9A9500",
  "827A04",
  "E3E48D",
  "E0E27C",
  "DBDE70",
  "D2D755",
  "B7BF10",
  "8E8C13",
  "625D20",
  "F0EC74",
  "EDE939",
  "ECE81A",
  "E1E000",
  "BFB800",
  "ADA400",
  "A09200",
  "F3EA5D",
  "F3E500",
  "EFDF00",
  "EEDC00",
  "BBA600",
  "9A8700",
  "685C20",
  "F1EB9C",
  "F0E991",
  "F0E87B",
  "EDE04B",
  "EADA24",
  "E1CD00",
  "CFB500",
  "EBE49A",
  "E9E186",
  "E6DE77",
  "E1D555",
  "D7C826",
  "C4B000",
  "B39B00",
  "E9DF97",
  "E4D77E",
  "DECD63",
  "D9C756",
  "B89D18",
  "A28E2A",
  "695B24",
  "DCD59A",
  "D6CF8D",
  "D0C883",
  "C0B561",
  "AC9F3C",
  "9F912A",
  "8A7B19",
  "CAB64B",
  "CFB023",
  "C1A01E",
  "A08629",
  "897630",
  "736635",
  "675E33",
  "D4C304",
  "C4B200",
  "91852C",
  "747136",
  "5D6439",
  "585C3B",
  "535435",
  "BBB323",
  "B4A91F",
  "AA9D2E",
  "8F7E35",
  "716135",
  "635939",
  "4E4934",
  "D5CB9F",
  "CFC493",
  "C5B783",
  "B3A369",
  "998542",
  "8C7732",
  "614F25",
  "CAC7A7",
  "BFBB98",
  "B0AA7E",
  "9B945F",
  "594A25",
  "524727",
  "4A412A",
  "F1E6B2",
  "DFD1A7",
  "D9C89E",
  "CEB888",
  "A89968",
  "94795D",
  "816040",
  "DDCBA4",
  "D3BC8D",
  "C6AA76",
  "B9975B",
  "8B5B29",
  "744F28",
  "5C462B",
  "EFDBB2",
  "FCD299",
  "E1B87F",
  "D6A461",
  "C6893F",
  "B77729",
  "A6631B",
  "EDC8A3",
  "E7B78A",
  "DDA46F",
  "C88242",
  "B36924",
  "934D11",
  "7D3F16",
  "F3CFB3",
  "F1C6A7",
  "F0BF9B",
  "E59E6D",
  "B86125",
  "A45A2A",
  "693F23",
  "E0C09F",
  "D9B48F",
  "CDA077",
  "B58150",
  "9E652E",
  "774212",
  "623412",
  "E0C6AD",
  "DCBFA6",
  "CDA788",
  "BF9474",
  "AD7C59",
  "946037",
  "4F2C1D",
  "E1B7A7",
  "D5A286",
  "C58B68",
  "99552B",
  "85431E",
  "6D4F47",
  "5E4B3C",
  "D7C4B7",
  "CDB5A7",
  "C0A392",
  "AE8A79",
  "956C58",
  "7C4D3A",
  "5B3427",
  "DBC8B6",
  "D3BBA8",
  "C6A992",
  "AA8066",
  "703F2A",
  "623B2A",
  "4E3629",
  "D6D2C4",
  "C5B9AC",
  "B7A99A",
  "A39382",
  "7A6855",
  "63513D",
  "473729",
  "D1CCBD",
  "B7B09C",
  "A69F88",
  "A7ACA2",
  "949A90",
  "8E9089",
  "4B4F54",
  "D0D3D4",
  "C1C6C8",
  "A2AAAD",
  "7C878E",
  "5B6770",
  "333F48",
  "1D252D",
  "C7C9C7",
  "B2B4B2",
  "9EA2A2",
  "898D8D",
  "707372",
  "54585A",
  "25282A",
  "BEC6C4",
  "A2ACAB",
  "919D9D",
  "717C7D",
  "505759",
  "3F4444",
  "373A36",
  "BABBB1",
  "A8A99E",
  "919388",
  "7E7F74",
  "65665C",
  "51534A",
  "212322",
  "C4BFB6",
  "AFA9A0",
  "9D968D",
  "8C857B",
  "776E64",
  "696158",
  "C4BCB7",
  "B2A8A2",
  "978C87",
  "857874",
  "746661",
  "5E514D",
  "382F2D",
  "D0C4C5",
  "C1B2B6",
  "AB989D",
  "7B6469",
  "584446",
  "453536",
  "382E2C",
  "D7D2CB",
  "CBC4BC",
  "BFB8AF",
  "B6ADA5",
  "ACA39A",
  "A59C94",
  "968C83",
  "8C8279",
  "83786F",
  "796E65",
  "6E6259",
  "D9D9D6",
  "D0D0CE",
  "C8C9C7",
  "BBBCBC",
  "B1B3B3",
  "A7A8AA",
  "97999B",
  "888B8D",
  "75787B",
  "63666A",
  "53565A",
  "332F21",
  "212721",
  "31261D",
  "3E2B2E",
  "101820",
  "3D3935"
], Kv = $d.map((r) => [
  parseInt(r.substring(0, 2), 16),
  parseInt(r.substring(2, 4), 16),
  parseInt(r.substring(4, 6), 16)
]);
function Fre(r) {
  const e = jp.indexOf(r);
  return e >= 0 ? $d[e] : "";
}
function W8(r) {
  const e = $d.indexOf(r);
  return e >= 0 ? jp[e] : "";
}
function Ire(r, e = 64) {
  const t = [], n = [], i = W8(r);
  i && t.push({
    pms: i,
    hex: r,
    distance: 0
  });
  const a = parseInt(r.substring(0, 2), 16), s = parseInt(r.substring(2, 4), 16), o = parseInt(r.substring(4, 6), 16);
  let l, u, c;
  for (let h = 0; h < $d.length; h++) {
    l = Kv[h][0], u = Kv[h][1], c = Kv[h][2];
    const f = Math.sqrt(Math.pow(a - l, 2) + Math.pow(s - u, 2) + Math.pow(o - c, 2));
    n.push(f);
  }
  for (let h = 0; h < n.length; h++)
    n[h] <= e && !t.some((f) => f.pms === jp[h]) && t.push({ pms: jp[h], hex: $d[h], distance: n[h] });
  return t.sort((h, f) => h.distance - f.distance);
}
const j8 = jp.map((r, e) => ({ pms: r, hex: $d[e] })), q8 = new H8(j8, { keys: ["pms"] });
function Pre(r, e) {
  return q8.search(r, e ? { limit: e } : void 0);
}
function Q8(r) {
  const e = r.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (!e)
    return "";
  const t = parseInt(e[1], 10), n = parseInt(e[2], 10), i = parseInt(e[3], 10);
  return [t, n, i].map((a) => a.toString(16).padStart(2, "0")).join("").toUpperCase();
}
let Uh = null;
function Y8(r) {
  if (r.startsWith("#"))
    return YS(r);
  if (r.startsWith("rgba") || r.startsWith("rgb")) {
    const t = Q8(r);
    if (t)
      return t;
  }
  if (!document)
    throw new Error("browserColorToHex is only supported on browsers");
  if (Uh || (Uh = document.createElement("canvas").getContext("2d")), !Uh)
    throw new Error("Failed to create canvas context required to convert colors");
  Uh.fillStyle = r;
  const e = YS(Uh.fillStyle);
  return e || console.error(`Unknown browser color ${r}`), e;
}
function YS(r) {
  const e = r.substring(1).toUpperCase();
  return e.length === 6 ? e : e.length === 3 ? `${e[0]}${e[0]}${e[1]}${e[1]}${e[2]}${e[2]}` : "";
}
const Wg = (r) => {
  const e = MI(r.spotColor);
  return e ? `${r.browserValue} ${e}` : r.browserValue;
}, MI = (r) => {
  if (!r)
    return "";
  if (r.profileName.includes("/") && r.profileName.includes(".icc")) {
    const e = r.profileName.replace(/\s/g, "-"), t = e.lastIndexOf("/");
    return `icc-named-color(${e.slice(t + 1).slice(0, -4)}, ${r.namedColor})`;
  }
  return `icc-named-color(${r.profileName}, ${r.namedColor})`;
}, XS = (r) => {
  const e = r.split(/[ ](?=[^)]*?(?:\(|$))/);
  if (e.length === 0)
    return { browserValue: "#000000" };
  if (e.length === 1)
    return { browserValue: e[0] };
  const t = e[1].match(/\(([^)]+)\)/gm);
  if (!t)
    throw new Error("Unhandled state of color value in SVG");
  const n = t[0].replace(/[() ]/g, "").split(",");
  return {
    browserValue: e[0],
    spotColor: { profileName: n[0], namedColor: n[1] }
  };
}, X8 = [
  "altGlyph",
  "circle",
  "ellipse",
  "path",
  "polygon",
  "polyline",
  "rect",
  "text",
  "textPath",
  "tref",
  "tspan"
], J8 = ["fill", "stroke"], Mf = (r, e) => {
  e(r), r.children.length > 0 && Array.from(r.children).forEach((t) => Mf(t, e));
}, NI = (r, e) => {
  const t = e(r);
  if (t)
    return t;
  const n = r.parentElement;
  if (n)
    return NI(n, e);
}, K8 = (r, e) => {
  try {
    return r.matches(e);
  } catch {
    return r.classList.contains(e.substring(1));
  }
}, Mw = (r, e = !1) => {
  !e && r.setAttribute("preserveAspectRatio", "none");
  const t = [];
  Mf(r, (n) => {
    if (n.tagName === "script") {
      n.remove();
      return;
    }
    if (n.tagName === "style") {
      try {
        FI(n.innerHTML).stylesheet?.rules.forEach((s) => {
          s.type === zn.rule && t.push(s);
        }), n.remove();
      } catch (a) {
        console.error(a);
      }
      return;
    }
    const i = n.attributes.getNamedItem("style")?.value?.trim();
    if (i) {
      const a = [];
      i.split(";").forEach((o) => {
        const l = o.trim();
        if (l) {
          const [u, c] = l.split(":"), h = u.toLowerCase();
          J8.indexOf(h) > -1 ? n.setAttribute(h, c.trim()) : a.push(l);
        }
      }), a.length > 0 ? n.setAttribute("style", a.join(";")) : n.removeAttribute("style");
    }
  }), Mf(r, (n) => {
    t.forEach((i) => {
      i.selectors?.forEach((a) => {
        K8(n, a) && i.declarations?.forEach((s) => {
          s.type === zn.declaration && s.property && s.value && n.setAttribute(s.property, s.value);
        });
      });
    });
  });
}, Z8 = (r) => {
  const e = /pt|pc|mm|cm|in/gm, t = r.getAttribute("viewBox"), n = r.getAttribute("width"), i = r.getAttribute("height");
  if (!t) throw new Error("viewBox not specified on SVG!");
  n && r.setAttribute("width", n.replace(e, "")), i && r.setAttribute("height", i.replace(e, ""));
}, Nw = (r) => Pu().parseFromString(r, "image/svg+xml").firstElementChild, eL = (r, e, t) => {
  r.setAttribute("height", `${t}px`), r.setAttribute("width", `${e}px`);
}, LI = (r, e, t) => {
  Mf(r, (n) => {
    const i = n.attributes.getNamedItem("fill");
    i && i.value !== "none" && n.classList.forEach((s) => {
      if (s.startsWith("spiff-fill")) {
        const o = e[s.replace("spiff-fill-", "")];
        if (o)
          n.setAttribute(
            "fill",
            t ? Wg(o) : o.browserValue
          );
        else {
          const l = e[s];
          l && n.setAttribute(
            "fill",
            t ? Wg(l) : l.browserValue
          );
        }
      }
    });
    const a = n.attributes.getNamedItem("stroke");
    a && a.value !== "none" && n.classList.forEach((s) => {
      if (s.startsWith("spiff-stroke")) {
        const o = e[s.replace("spiff-stroke-", "")];
        if (o)
          n.setAttribute(
            "stroke",
            t ? Wg(o) : o.browserValue
          );
        else {
          const l = e[s];
          l && n.setAttribute(
            "fill",
            // Should this be "stroke"? Is this code still relevant anyway?
            t ? Wg(l) : l.browserValue
          );
        }
      }
    });
  });
}, Lw = (r) => $f().serializeToString(r), Uw = (r, e, t, n, i) => {
  const a = Nw(r);
  if (!a)
    throw new Error("Failed to read SVG.");
  return eL(a, e, t), LI(a, n, i), Lw(a);
}, Vw = (r, e, t) => {
  const n = Nw(r);
  if (!n)
    throw new Error("Failed to read SVG.");
  return LI(n, e, t), Lw(n);
}, tL = (r) => {
  const e = /<svg.*<\/svg>/s, t = r.match(e) || [], n = t?.length > 0 ? t[0] : "";
  return Pu().parseFromString(n, "image/svg+xml");
}, Nl = async (r) => {
  const t = tL(r).firstElementChild;
  if (!t)
    throw new Error("Failed to read SVG.");
  Mw(t);
  const n = {};
  Mf(t, (s) => {
    if (X8.includes(s.tagName) && !s.attributes.getNamedItem("fill")) {
      let u = "black";
      const c = s.parentElement;
      if (c) {
        const h = NI(c, (f) => {
          const m = f.style.fill;
          if (m)
            return m;
          const A = f.getAttribute("fill");
          if (A)
            return A;
        });
        h && (u = h);
      }
      s.setAttribute("fill", u);
    }
    const o = s.attributes.getNamedItem("fill");
    if (o && o.value !== "none" && !o.value.startsWith("url(")) {
      const u = XS(o.value), c = u.browserValue.replace(/\W/g, ""), h = `spiff-fill-${c}`;
      s.setAttribute("fill", u.browserValue), s.classList.add(h), n[c] = u;
    }
    const l = s.attributes.getNamedItem("stroke");
    if (l && l.value !== "none" && !l.value.startsWith("url(")) {
      const u = XS(l.value), c = u.browserValue.replace(/\W/g, ""), h = `spiff-stroke-${c}`;
      s.classList.add(h), s.setAttribute("stroke", u.browserValue), n[c] = u;
    }
  });
  const a = $f().serializeToString(t);
  return {
    colors: n,
    svg: a
  };
}, rL = (r, e, t, n, i) => {
  const a = Nw(r);
  if (!a)
    throw new Error("Failed to parse SVG for color merging");
  Mf(a, (o) => {
    let l = !1, u = !1;
    t.forEach((c) => {
      const h = `spiff-fill-${c}`, f = `spiff-stroke-${c}`;
      o.classList.contains(h) && (o.classList.remove(h), l = !0), o.classList.contains(f) && (o.classList.remove(f), u = !0);
    }), l && (o.classList.add(`spiff-fill-${n}`), o.setAttribute("fill", i.browserValue)), u && (o.classList.add(`spiff-stroke-${n}`), o.setAttribute("stroke", i.browserValue));
  });
  const s = { ...e };
  return t.forEach((o) => {
    o !== n && delete s[o];
  }), s[n] = i, {
    svg: Lw(a),
    colors: s
  };
}, nL = Oe`
    fragment AssetMetadataFields on Asset {
        metadata {
            key
            value
        }
    }
`, iL = Oe`
    fragment AssetVersionsFields on Asset {
        versions {
            name
            link
        }
    }
`, ih = (r, e) => Oe`
        ${r && nL || ""}
        ${e && iL || ""}
        fragment AssetFields on Asset {
            name
            key
            type
            createdAt
            mimeType
            fileLink
            assetConfiguration {
                assetKey
                colorOption {
                    id
                    name
                    variants {
                        id
                        name
                        enabled
                        namedColor
                        color
                    }
                }
                channelNumbers {
                    id
                    number
                }
                defaultColorVariants {
                    channelNumber
                    variant {
                        id
                        name
                        enabled
                        namedColor
                        color
                    }
                }
            }
            ${e && "...AssetVersionsFields" || ""}
            ${r && "...AssetMetadataFields" || ""}
           
        }
    `, UI = Oe`
    fragment MaterialFields on Material {
        id
        name
        createdAt
        clearCoat
        clearCoatIor
        refractionIntensity
        reflectionIntensity
        reflectionRotation
        albedoMap {
            key
            fileLink
        }
        alphaMap {
            key
            fileLink
        }
        ambientMap {
            key
            fileLink
        }
        emissionMap {
            key
            fileLink
        }
        metallicMap {
            key
            fileLink
        }
        normalMap {
            key
            fileLink
        }
        refractionMap {
            key
            fileLink
        }
        reflectionMap {
            key
            fileLink
        }
        roughnessMap {
            key
            fileLink
        }
    }
`, aL = Oe`
    ${UI}
    query GetMaterials($ids: [String]) {
        materials(id: $ids) {
            ...MaterialFields
        }
    }
`, sL = Oe`
    mutation CreateAsset($name: String!, $type: String!, $mimeType: String!, $anonymous: Boolean, $temporary: Boolean) {
        assetCreate(name: $name, type: $type, mimeType: $mimeType, anonymous: $anonymous, temporary: $temporary) {
            uploadUrl
            asset {
                name
                key
                type
                createdAt
                mimeType
                fileLink
            }
        }
    }
`, oL = Oe`
    mutation SetAssetMime($assetKey: String!, $mimeType: String!) {
        assetSetMime(assetKey: $assetKey, mimeType: $mimeType) {
            uploadUrl
            asset {
                name
                key
                type
                createdAt
                mimeType
                fileLink
            }
        }
    }
`, lL = Oe`
    ${ih(!1, !1)}
    mutation RemoveBackgroundFromAsset($key: String!) {
        assetRemoveBackground(key: $key) {
            ...AssetFields
        }
    }
`, uL = Oe`
    ${ih(!1, !1)}
    mutation VectorizeAsset($key: String!, $options: AssetVectorizeOptions) {
        assetVectorize(key: $key, options: $options) {
            ...AssetFields
        }
    }
`, cL = Oe`
    ${ih(!1, !1)}
    mutation EnhanceWithAI($key: String!, $options: AssetEnhanceOptions) {
        assetEnhanceWithAI(key: $key, options: $options) {
            ...AssetFields
        }
    }
`, h0 = async (r, e = !0) => (await et.getShadowGraphqlClient().query({
  query: Oe`
            ${ih(!1, e)}
            query GetAssets($keys: [String]!) {
                assets(keys: $keys) {
                    ...AssetFields
                }
            }
        `,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    keys: r
  }
})).data.assets, fL = async (r) => (await et.getShadowGraphqlClient().query({
  query: aL,
  errorPolicy: "all",
  variables: {
    ids: r
  }
})).data.materials, JS = async (r, e, t, n, i) => (await et.getShadowGraphqlClient().mutate({
  mutation: sL,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    name: r,
    type: e,
    mimeType: t,
    anonymous: n,
    temporary: i
  }
})).data?.assetCreate, dL = async (r, e) => (await et.getShadowGraphqlClient().mutate({
  mutation: oL,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    assetKey: r,
    mimeType: e
  }
})).data?.assetSetMime;
class hL {
  constructor() {
    this.cache = /* @__PURE__ */ new Map(), this.bgrmProcessCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map(), this.loadImageAsFileInfo = async (e) => {
      const t = await e.arrayBuffer(), n = await G0(t), i = (a, s) => {
        const o = atob(a.split(",")[1]), l = [];
        for (let u = 0; u < o.length; u++)
          l.push(o.charCodeAt(u));
        return new Blob([new Uint8Array(l)], { type: s });
      };
      return {
        name: e.name.substring(e.name.lastIndexOf("/") + 1),
        blob: i(n.dataUrl, e.type)
      };
    };
  }
  /**
   * Allows for retrieving an asset, returns the option from a cache if possible.
   */
  async getLocalOrFromServer(e) {
    if (this.cache.has(e)) {
      const i = this.cache.get(e);
      if (!i) throw new si("Failed to get asset from cache!");
      return i;
    }
    const n = (async () => (await h0([e]))[0])();
    return this.cache.set(e, n), n;
  }
  /**
   * Retrieves the asset from the server, bypassing cache (but still writing the result to cache)
   */
  async getFromServer(e) {
    const n = (async () => (await h0([e]))[0])();
    return this.cache.set(e, n), n;
  }
  keyFromURL(e) {
    let t;
    try {
      t = new URL(e).pathname;
    } catch {
      t = void 0;
    }
    return t !== void 0 && t.startsWith("/") && (t = t.replace("/", "")), t?.split("?")[0];
  }
  /**
   * Caches an asset if it doesn't already exist.
   */
  cacheAsset(e) {
    if (!e.key) throw new si("Asset has no key!");
    this.cache.has(e.key) || this.cache.set(e.key, Promise.resolve(e));
  }
  /**
   * Caches a material if it doesn't already exist.
   */
  cacheMaterial(e) {
    if (!e.id) throw new si("Material has no id!");
    this.materialCache.has(e.id) || this.materialCache.set(e.id, Promise.resolve(e));
  }
  /**
   * Allows for retrieving a material, returns the option from a cache if possible.
   * @param id The option ID to be retrieved.
   */
  async getMaterialLocalOrFromServer(e) {
    if (this.materialCache.has(e))
      return this.materialCache.get(e);
    const n = (async () => (await fL([e]))[0])();
    return this.materialCache.set(e, n), n;
  }
  /**
   * Upload a user asset to the server. Using callbacks to notify important events.
   * The asset will be stored via the persistence service for future access, if available.
   */
  async uploadAssetWithProgress(e, t, n, i, a) {
    const s = await this.dispatchCreateAssetRequest(e, t, i, a);
    if (!s)
      throw new Error("Failed to create asset.");
    return await new Promise((o, l) => {
      const u = new XMLHttpRequest();
      u.open("PUT", s.assetResponse.uploadUrl, !0), u.setRequestHeader("Content-Type", s.mimeType), u.setRequestHeader("Cache-Control", "public,max-age=31536000,immutable"), u.upload.onprogress = (c) => {
        c.lengthComputable && n(c.loaded * 100 / c.total);
      }, u.onload = () => {
        const c = s.assetResponse.asset;
        Tl.add(s.assetResponse.asset), o(c);
      }, u.onerror = l, this.postProcessFileUpload(e, s.mimeType).then((c) => u.send(c.blob)).catch(l);
    }), this.cacheAsset(s.assetResponse.asset), s.assetResponse.asset;
  }
  async uploadAsset(e, t, n, i) {
    return this.uploadAssetWithProgress(e, t, () => {
    }, n, i);
  }
  async uploadFile(e, t) {
    const i = this.isRaster(e) ? u0.Image : u0.Illustration, a = await this.loadImageAsFileInfo(e);
    return await this.uploadAssetWithProgress(a, i, t, !0);
  }
  async setAssetMime(e, t) {
    const n = await dL(e, t);
    if (!n)
      throw new Error("Failed to set asset mime type.");
    return this.cacheAsset(n.asset), n;
  }
  async createAssetWithoutUpload(e, t, n, i) {
    const a = await JS(e, t, "", n, i);
    if (!a)
      throw new Error("Failed to create asset.");
    return this.cacheAsset(a.asset), a.asset;
  }
  async removeBackgroundFromAsset(e) {
    const t = e.key;
    if (this.bgrmProcessCache.has(t))
      return this.bgrmProcessCache.get(t);
    if (mi.has($h, t)) {
      const a = this.getLocalOrFromServer(
        mi.get($h, t)
      );
      return this.bgrmProcessCache.set(t, a), a;
    }
    const i = (async () => {
      const a = await et.getShadowGraphqlClient().mutate({
        mutation: lL,
        fetchPolicy: "no-cache",
        errorPolicy: "all",
        variables: {
          key: t
        }
      });
      if (this.bgrmProcessCache.delete(t), console.log(a), !a.data?.assetRemoveBackground?.key)
        throw new Error("Failed to remove background from image");
      return Tl.add(a.data.assetRemoveBackground), mi.add(
        $h,
        t,
        a.data.assetRemoveBackground.key
      ), this.cache.set(
        a.data.assetRemoveBackground.key,
        Promise.resolve(a.data.assetRemoveBackground)
      ), a.data.assetRemoveBackground;
    })();
    return this.bgrmProcessCache.set(t, i), i;
  }
  async vectorizeAsset(e, t = void 0) {
    const n = e.key;
    if (this.bgrmProcessCache.has(n))
      return this.bgrmProcessCache.get(n);
    if (mi.has(zh, n)) {
      const s = this.getLocalOrFromServer(
        mi.get(zh, n)
      );
      return this.bgrmProcessCache.set(n, s), s;
    }
    const a = (async () => {
      const s = await et.getShadowGraphqlClient().mutate({
        mutation: uL,
        fetchPolicy: "no-cache",
        errorPolicy: "all",
        variables: {
          key: n,
          options: {
            maxColorCount: t
          }
        }
      });
      if (this.bgrmProcessCache.delete(n), !s.data?.assetVectorize?.key)
        throw new Error("Failed to vectorize image");
      return Tl.add(s.data.assetVectorize), mi.add(
        zh,
        n,
        s.data.assetVectorize.key
      ), this.cache.set(
        s.data.assetVectorize.key,
        Promise.resolve(s.data.assetVectorize)
      ), s.data.assetVectorize;
    })();
    return this.bgrmProcessCache.set(n, a), a;
  }
  async enhanceWithAI(e, t) {
    const n = e.key;
    if (this.bgrmProcessCache.has(n))
      return this.bgrmProcessCache.get(n);
    if (mi.has(Gh, n)) {
      const s = this.getLocalOrFromServer(
        mi.get(Gh, n)
      );
      return this.bgrmProcessCache.set(n, s), s;
    }
    const a = (async () => {
      const s = await et.getShadowGraphqlClient().mutate({
        mutation: cL,
        fetchPolicy: "no-cache",
        errorPolicy: "all",
        variables: {
          key: n,
          options: t || {}
        }
      });
      if (this.bgrmProcessCache.delete(n), !s.data?.assetEnhanceWithAI?.key)
        throw new Error("Failed to enhance image with AI");
      return Tl.add(s.data.assetEnhanceWithAI), mi.add(
        Gh,
        n,
        s.data.assetEnhanceWithAI.key
      ), this.cache.set(
        s.data.assetEnhanceWithAI.key,
        Promise.resolve(s.data.assetEnhanceWithAI)
      ), s.data.assetEnhanceWithAI;
    })();
    return this.bgrmProcessCache.set(n, a), a;
  }
  removePersistedAsset(e) {
    Tl.remove(e), mi.delete($h, e), mi.delete(zh, e), mi.delete(Gh, e), mi.deleteForTransformedKey($h, e), mi.deleteForTransformedKey(zh, e), mi.deleteForTransformedKey(Gh, e);
  }
  getPersistedAssets() {
    return Tl.list();
  }
  registerPersistedAssetListener(e) {
    Tl.addCallback(e);
  }
  unRegisterPersistedAssetListener(e) {
    Tl.removeCallback(e);
  }
  isRaster(e) {
    return !(e.type === "image/svg+xml" || e.type === "application/pdf" || e.type === "application/postscript");
  }
  async postProcessFileUpload(e, t) {
    if (t === "image/svg+xml") {
      const n = await e.blob.text(), s = new window.DOMParser().parseFromString(n, "image/svg+xml").documentElement;
      if (!s) throw new Ed("Failed to read SVG.");
      Z8(s);
      const l = $f().serializeToString(s);
      return {
        name: e.name,
        blob: new Blob([l], { type: "image/svg+xml" })
      };
    }
    return e;
  }
  /**
   * Handles mimeType resolution & asset creation request
   * @param file A file info object containing data about the file and its name
   * @param assetType The type of asset we're expecting to upload
   */
  async dispatchCreateAssetRequest(e, t, n, i) {
    const a = e.blob.type ? e.blob.type : this.guessMIME(e.name), s = await JS(e.name, t, a, n, i);
    if (s)
      return {
        assetResponse: s,
        mimeType: a
      };
  }
  guessMIME(e) {
    const t = e.split(".").pop();
    switch (t) {
      case "glb":
        return "model/gltf-binary";
      case "ttf":
        return "font/ttf";
      case "mkv":
        return "video/x-matroska";
      default:
        throw new si("Unexpected mimetype: " + t);
    }
  }
}
const Vh = "persistentAssets", xu = class xu {
  /**
   * Add a new asset to persistence
   * @param asset The asset to add.
   */
  static add(e) {
    if (!e.fileLink) {
      console.error("Failed to find cdn link on asset, cannot persist!");
      return;
    }
    const t = /* @__PURE__ */ new Map();
    t.set(e.key || "", e.fileLink);
    const n = hn.getMap(Vh);
    n && n.forEach((i, a) => {
      t.set(a, i);
    }), hn.setMap(Vh, t), xu.executeCallbacks();
  }
  /**
   * Remove an existing asset from persistence. Noop if the asset doesn't exist.
   * @param assetKey The key to remove.
   */
  static remove(e) {
    const t = hn.getMap(Vh);
    if (!t) return;
    const n = Array.from(t.entries()).find((i) => i[0] === e);
    n && (t.delete(n[0]), hn.setMap(Vh, t), xu.executeCallbacks());
  }
  /**
   * Get a list of all persisted assets.
   */
  static list() {
    const e = hn.getMap(Vh);
    return e ? Array.from(e.entries()).map((t) => ({ assetKey: t[0], src: t[1] })) : [];
  }
  /**
   * Adds a callback that will be called whenever assets are added/removed from persistence.
   */
  static addCallback(e) {
    xu.callbacks.push(e);
  }
  /**
   * Removes an existing callback.
   */
  static removeCallback(e) {
    xu.callbacks = xu.callbacks.filter((t) => t !== e);
  }
  static executeCallbacks() {
    xu.callbacks.forEach((e) => e());
  }
};
xu.callbacks = [];
let Tl = xu;
const $h = "bgrmPersistentAssets", zh = "vectorizePersistentAssets", Gh = "enhanceAIPersistentAssets";
class mi {
  static has(e, t) {
    return mi.getMap(e).has(t);
  }
  static get(e, t) {
    return mi.getMap(e).get(t);
  }
  static keys(e) {
    return mi.getMap(e).keys();
  }
  static values(e) {
    return mi.getMap(e).values();
  }
  static add(e, t, n) {
    const i = mi.getMap(e);
    i.set(t, n), mi.setMap(e, i);
  }
  static delete(e, t) {
    const n = mi.getMap(e);
    n.delete(t), mi.setMap(e, n);
  }
  static deleteForTransformedKey(e, t) {
    const n = mi.getMap(e), i = Array.from(n.keys()).find((a) => n.get(a) === t);
    i && (n.delete(i), mi.setMap(e, n));
  }
  static getMap(e) {
    return hn.getMap(e) || /* @__PURE__ */ new Map();
  }
  static setMap(e, t) {
    hn.setMap(e, t);
  }
}
const Si = new hL();
class pL {
  constructor() {
    this.cache = {}, this.disabled = !1;
  }
  /**
   * Gets a promise from the cache, or undefined if it doesn't exist.
   */
  get(e) {
    if (this.disabled) return;
    const t = JSON.stringify(e);
    return this.cache[t];
  }
  /**
   * Sets a promise in the cache and returns it.
   */
  set(e, t) {
    if (this.disabled) return t;
    const n = JSON.stringify(e);
    return this.cache[n] = t, t;
  }
  /**
   * Some environments don't want workflows to be cached. An example is a server
   * that doesn't launch a fresh instance per request. This method allows disabling
   * caching in a transparent way.
   */
  disable(e) {
    this.disabled = e;
  }
}
const p0 = new pL(), $w = (r, e = 512, t, n) => {
  const i = typeof r == "string" ? r : r.fileLink;
  if (!i)
    return;
  const a = i.includes("?") ? "&" : "?", s = [`w=${e}`, `h=${e}`];
  return n !== void 0 && s.push(`q=${n}`), t && s.push(`format=${t}`), `${i}${a}${s.join("&")}`;
}, Dc = (r) => {
  let e;
  try {
    e = new URL(r);
  } catch {
    return;
  }
  const t = e.pathname.split("/"), n = t[t.length - 1].split(".");
  if (n.length !== 1)
    return n[n.length - 1] || void 0;
}, gL = Oe`
    fragment OptionMinimalFields on Option {
        id
        defaultVariant {
            id
        }
    }
`, mL = Oe`
    fragment OptionFields on Option {
        id
        name
        public
        currencyCode
        type
        workflowId
        displayType
        integrationOptions {
            id
            integrationId
        }
        variants {
            id
            name
            enabled
            color
            namedColor
            priceModifier
            asset {
                ...AssetFields
            }
            thumbnail {
                ...AssetFields
            }
            material {
                ...MaterialFields
            }
            category
            product {
                id
                name
                basePrice
                workflows {
                    id
                    workflowName
                }
                integrationProducts {
                    id
                    integration {
                        id
                    }
                }
            }
        }
        defaultVariant {
            id
        }
        colorProfile {
            ...AssetFields
        }
    }
`, vL = Oe`
    query GetTagsMany($ids: [String!]!) {
        tagsMany(entityIds: $ids) {
            id
            entityId
            name
        }
    }
`, yL = async (r) => {
  const e = await et.getShadowGraphqlClient().query({
    query: Oe`
            ${ih(!1, !1)}
            ${UI}
            ${mL}
            query GetOptions($ids: [String]!) {
                options(ids: $ids) {
                    ...OptionFields
                }
            }
        `,
    errorPolicy: "all",
    variables: {
      ids: r
    }
  });
  return e.data.options.forEach((t) => {
    t.colorProfile && Si.cacheAsset(t.colorProfile), t.variants?.forEach((n) => {
      n.asset && Si.cacheAsset(n.asset), n.thumbnail && Si.cacheAsset(n.thumbnail), n.material && Si.cacheMaterial(n.material);
    });
  }), e.data.options;
}, AL = async (r, e) => (await e).find((n) => n.id === r), Zv = async (r) => {
  const e = new Map(r.map((i) => [i, p0.get({ id: i })])), t = r.filter((i) => e.get(i) === void 0);
  if (t.length > 0) {
    const i = yL(t);
    t.forEach(
      (a) => e.set(a, p0.set({ id: a }, AL(a, i)))
    );
  }
  return (await Promise.all(r.map((i) => e.get(i)))).filter((i) => i !== void 0);
}, KS = (r) => {
  if (!(!r || !r.fileLink))
    return $w(r, 512, "webp");
}, ZS = (r, e, t) => {
  if (r.length === 1)
    return r[0];
  if (t) {
    const n = r.find((i) => i.id === t);
    if (n)
      return n;
  }
  if (e.defaultVariant !== void 0)
    return r.find((n) => n.id === e.defaultVariant?.id);
};
class wL {
  constructor() {
    this.getDefaultVariant = async (e, t) => {
      const n = e?.variants;
      if (n)
        return ZS(n, e, t);
      const a = (await this.getOption(e.id))?.variants;
      if (a)
        return ZS(a, e, t);
    }, this.getTagsForAssets = async (e) => {
      const t = e?.map((s) => s.asset?.key) || [], n = e?.map((s) => s.material?.id) || [], i = [...t, ...n].filter((s) => !!s);
      return i.length === 0 ? [] : (await et.getShadowGraphqlClient().query({
        query: vL,
        errorPolicy: "all",
        variables: {
          ids: i
        }
      })).data.tagsMany;
    };
  }
  /**
   * Allows for retrieving an option, returns the option from a cache if possible.
   * @param id The option ID to be retrieved.
   */
  async getOption(e) {
    return e ? (await Zv([e]))[0] : void 0;
  }
  async getOptions(e) {
    return Zv(e);
  }
  async getOptionForStep(e) {
    return this.ensureFullOption(e.option);
  }
  /**
   * Utility function to get the full option from either the network or return the existing option if it can be considered to have the "full" state.
   *
   * @returns The full option resource, or `undefined` if invalid.
   */
  async ensureFullOption(e) {
    return e?.variants ? e : e?.id ? (await Zv([e.id]))[0] : void 0;
  }
  /**
   * Returns the URL of the image to be used for a given variant. The priority is:
   * 1. The variant's thumbnail (if it exists)
   * 2. The variant's asset (if it exists)
   * 3. The variant's material ID (if it exists) // TODO: Does this really make sense?
   * 4. An empty string if none of the above exist
   * @param variant The variant for which to retrieve the image URL.
   * @returns A promise that resolves to the URL of the image to be used for the given variant, or an empty string if no image is available.
   */
  async getAssetTileImageForVariant(e) {
    const t = KS(e.thumbnail) ?? KS(e.asset);
    return t || (e.material ? e.material.id : "");
  }
}
const Pt = new wL(), VI = Oe`
    fragment ActiveIntegrationFields on Integration {
        id
        logo
        name
        theme {
            id
            configuration
            primaryColor
            secondaryColor
            textColor
        }
        partner {
            id
            name
            activeAddons
            currencyCode
            beta
        }
    }
`, fg = Oe`
    fragment AdditionalIntegrationProductFields on IntegrationProduct {
        id
        product {
            id
            basePrice
            enabled
            name
            description
            sku
            skuCode
            weight
            imageUrl
            modelUrl
            overlayImageUrl
            preloadImageUrl
        }
    }
`, $I = Oe`
    fragment RecipientFields on Recipient {
        id
        firstName
        lastName
        address
        suburb
        state
        email
        postalCode
        country
        mobile
        company
        apartment
        customField1
        customField2
        customField3
        customField4
        customField5
        conversionConfigurationId
    }
`, dg = Oe`
    fragment ConversionConfigurationFields on ConversionConfiguration {
        id
        partnerId
        name
        locations
        mandatory
        requestedData
        requestedDataItems {
            type
            mandatory
            title
            uniqueIdentifier
            customFieldIndex
            optionId
            option {
                id
                name
                variants {
                    id
                    name
                    enabled
                }
                defaultVariant {
                    id
                }
            }
        }
    }
`, xL = Oe`
    ${$I}
    mutation CreateTransactions(
        $inputs: [TransactionCreateInput]!
        $marketplaceThemeInstallId: String
        $marketplaceThemeInstallConfigurationId: String
    ) {
        transactionCreateMany(
            inputs: $inputs
            marketplaceThemeInstallId: $marketplaceThemeInstallId
            marketplaceThemeInstallConfigurationId: $marketplaceThemeInstallConfigurationId
        ) {
            id
            designName
            transactionOwnerId
            workflowId
            customLogoLink
            quantity
            workflowFooterLogoLink
            restApiIntegrationLink
            workflowState
            workflowViewerLink
            workflowViewerReadOnlyLink
            recipient {
                ...RecipientFields
            }
            parentTransaction {
                id
            }
            integrationProductId
        }
    }
`, zI = Oe`
    fragment StakeholderFields on Stakeholder {
        id
        type
        authorizationDate
        authorizationNote
        authorizationStatus
    }
`, GI = Oe`
    fragment TransactionShareActionFields on TransactionShareAction {
        id
        title
        type
        stakeholderType
        precedence
        url
    }
`, HI = Oe`
    ${fg}
    ${dg}
    ${VI}
    query ReadIntegrationProducts($ids: [String!]!) {
        integrationProducts(ids: $ids) {
            id
            externalProductId
            externalVariantId
            additionalExternalProductId
            additionalExternalVariantId
            additionalIntegrationProduct {
                ...AdditionalIntegrationProductFields
            }
            product {
                id
                basePrice
                enabled
                minimumOrderQuantity
                name
                description
                partner {
                    id
                    name
                    currencyCode
                    customerDetailsPromptMarkdown
                }
                productImages {
                    id
                    precedence
                    asset {
                        key
                        fileLink
                        name
                        type
                    }
                }
                integrationProducts {
                    id
                    integration {
                        id
                        type
                    }
                    externalProductId
                    externalVariantId
                    additionalExternalProductId
                    additionalExternalVariantId
                    additionalIntegrationProduct {
                        ...AdditionalIntegrationProductFields
                    }
                }
                profanities {
                    id
                    word
                }
                sku
                skuCode
                weight
                workflows {
                    id
                    friendlyName
                    isPresent
                    workflowName
                    imageUrl
                    panelPreviews {
                        panelId
                        imageUrl
                        region {
                            width
                            height
                            top
                            left
                            rotation
                        }
                    }
                }
                imageUrl
                modelUrl
                overlayImageUrl
                preloadImageUrl
                promptForCustomerDetails
                conversionConfiguration {
                    ...ConversionConfigurationFields
                }
                productTags {
                    id
                    name
                }
                priceBreaks {
                    id
                    minQty
                    percentage
                }
            }
            integration {
                ...ActiveIntegrationFields
            }
        }
    }
`, bL = Oe`
    ${zI}
    ${GI}
    ${$I}
    query ReadTransactions($ids: [String]!) {
        transactions(ids: $ids) {
            customLogoLink
            designName
            externalDesignProductId
            externalDesignProductVariantId
            externalCartProductId
            externalCartProductVariantId
            id
            completed
            lastSyncedAt
            priceModifierTotal
            restApiIntegrationLink
            workflowFooterLogoLink
            workflowId
            workflowState
            workflowViewerLink
            workflowViewerReadOnlyLink
            previewImageLink
            isOrdered
            quantity
            printFileUrl1
            printFileUrl2
            printFileUrl3
            printFileUrl4
            printFileUrl5
            printFileName1
            printFileName2
            printFileName3
            printFileName4
            printFileName5
            stakeholders {
                ...StakeholderFields
            }
            currentStakeholder {
                ...StakeholderFields
            }
            hasAuthenticatedActions
            transactionShareActions {
                ...TransactionShareActionFields
            }
            addressValidationStatus
            recipient {
                ...RecipientFields
            }
            parentTransaction {
                id
            }
            integrationProductId
        }
    }
`, CL = Oe`
    mutation UpdateTransactionWorkflowState($id: String!, $workflowState: String!) {
        transactionUpdate(id: $id, workflowState: $workflowState) {
            id
        }
    }
`, SL = Oe`
    mutation UpdateTransactionQuantity($id: String!, $quantity: Int) {
        transactionUpdate(id: $id, quantity: $quantity) {
            id
        }
    }
`, EL = Oe`
    mutation UpdateTransactionWorkflow($id: String!, $workflowId: String!) {
        transactionUpdate(id: $id, workflowId: $workflowId) {
            id
        }
    }
`, kL = Oe`
    ${dg}
    query ReadConversionConfigurationQuery($id: String!) {
        conversionConfiguration(id: $id) {
            ...ConversionConfigurationFields
        }
    }
`, TL = Oe`
    ${dg}
    query ReadTransactionForDesignCreation($id: String!) {
        transactions(ids: [$id]) {
            id
            completed
            createdAt
            designName
            product {
                name
                sku
                basePrice
                minimumOrderQuantity
                promptForCustomerDetails
                partner {
                    id
                    name
                    customerDetailsPromptMarkdown
                }
                conversionConfiguration {
                    ...ConversionConfigurationFields
                }
                productTags {
                    id
                    name
                }
                priceBreaks {
                    id
                    minQty
                    percentage
                }
            }
            bundle {
                id
                metadata {
                    key
                    value
                }
                bundleStakeholders {
                    type
                    customer {
                        emailAddress
                    }
                }
            }
            externalCartProductId
            externalCartProductVariantId
            externalDesignProductId
            externalDesignProductVariantId
            lastSyncedAt
            previewImageLink
            priceModifierTotal
            quantity
            workflowId
            workflowState
            workflowViewerLink
            workflowViewerReadOnlyLink
        }
    }
`, FL = Oe`
    ${GI}
    query ReadTransactionForShareActions($id: String!) {
        transactions(ids: [$id]) {
            id
            hasAuthenticatedActions
            transactionShareActions {
                ...TransactionShareActionFields
            }
        }
    }
`, IL = Oe`
    query ConfirmWorkflowStates($transactions: [TransactionConfirmInput!]!) {
        transactionConfirmWorkflowStates(transactions: $transactions)
    }
`, WI = (r) => Oe`
    ${fg}
    fragment IntegrationProductFields on IntegrationProduct {
        id
        externalProductId
        externalVariantId
        additionalExternalProductId
        additionalExternalVariantId
        additionalIntegrationProduct {
            ...AdditionalIntegrationProductFields
        }
        integration {
            id
            enabled
            externalIntegrationId
            type
            isCurrent
        }
        product {
            id
            basePrice
            enabled
            minimumOrderQuantity
            imageUrl
            modelUrl
            name
            description
            overlayImageUrl
            preloadImageUrl
            sku
            skuCode
            workflows {
                id
                index
                friendlyName
                isPresent
                workflowName
                imageUrl
                panelPreviews {
                    panelId
                    imageUrl
                    region {
                        width
                        height
                        top
                        left
                        rotation
                    }
                }
            }
            productTags {
                id
                name
            }
            productImages {
                id
                precedence
                asset {
                    key
                    fileLink
                    name
                    type
                }
            }
            priceBreaks {
                id
                minQty
                percentage
            }
            ${r ? `
                integrationProducts {
                    id
                    externalProductId
                    externalVariantId
                    additionalExternalProductId
                    additionalExternalVariantId
                    additionalIntegrationProduct {
                        ...AdditionalIntegrationProductFields
                    }
                    integration {
                        id
                        enabled
                        externalIntegrationId
                        type
                        isCurrent
                    }
                }
            ` : ""}
        }
    }
`, PL = (r) => Oe`
    ${WI(r)}
    query GetIntegrationProducts($ids: [String!]!) {
        integrationProducts(ids: $ids) {
            ...IntegrationProductFields
        }
    }
`, DL = (r) => Oe`
    ${WI(r)}
    query GetIntegrationProductFromExternalIds($externalIntegrationId: String!, $externalProductId: String!) {
        integrationProductFromExternalIds(
            externalIntegrationId: $externalIntegrationId
            externalProductId: $externalProductId
        ) {
            ...IntegrationProductFields
        }
    }
`, RL = Oe`
    ${zI}
    query ReadTransactionForStakeholders($id: String!) {
        transactions(ids: [$id]) {
            stakeholders {
                ...StakeholderFields
            }
            currentStakeholder {
                ...StakeholderFields
            }
        }
    }
`, OL = Oe`
    mutation FinalizeUpdateTransaction($transactionId: String!) {
        transactionFinalizeUpdate(transactionId: $transactionId)
    }
`, BL = Oe`
    fragment RegionFields on Region {
        width
        top
        left
        height
        layer
        layerIndex
        rotation
        panelId
        immutable
        adjustmentBoundary {
            width
            x
            y
            height
        }
    }
`, _L = Oe`
    fragment LookAtAnimationFields on LookAtAnimation {
        latDeg
        lonDeg
        radius
        target {
            x
            y
            z
        }
    }
`, ML = Oe`
    fragment RenderingPipelineConfigurationFields on RenderingPipelineConfiguration {
        antiAliasing {
            samples
            fxaaEnabled
        }
        bloom {
            enabled
            kernel
            scale
            threshold
            weight
        }
        chromaticAberration {
            enabled
            aberrationAmount
            direction {
                x
                y
            }
            radialIntensity
        }
        colorCurves {
            enabled
            globalDensity
            globalExposure
            globalHue
            globalSaturation
            highlightsDensity
            highlightsExposure
            highlightsHue
            highlightsSaturation
            midtonesDensity
            midtonesExposure
            midtonesHue
            midtonesSaturation
            shadowsDensity
            shadowsExposure
            shadowsHue
            shadowsSaturation
        }
        depthOfField {
            enabled
            blurLevel
            focusDistance
            focalLength
            fStop
            lensSize
        }
        grain {
            enabled
            animated
            intensity
        }
        misc {
            contrast
            exposure
            toneMappingEnabled
            toneMappingType
        }
        sharpen {
            enabled
            colorAmount
            edgeAmount
        }
        vignette {
            enabled
            blendMode
            cameraFov
            center {
                x
                y
            }
            colorRgba {
                r
                g
                b
                a
            }
            colorHex
            stretch
            weight
        }
    }
`, NL = Oe`
    fragment ModelAnimationFields on ModelAnimation {
        from
        to
        loop
        name
    }
`, LL = (r) => Oe`
        ${ih(r, !1)}
        ${gL}
        ${BL}
        ${_L}
        ${ML}
        ${NL}
        query GetWorkflows($ids: [String!]!) {
            workflows(ids: $ids) {
                partner {
                    termsMarkdown
                }
                allowProofDownload
                defaultPreviewPanelIndex
                finalizeStepConfig {
                    termsMarkdown
                    lookAtAnimation {
                        ...LookAtAnimationFields
                    }
                    modelAnimation {
                        ...ModelAnimationFields
                    }
                }
                globalPreviewConfig {
                    autoRotation
                    backgroundColor
                    backgroundImage
                    clearColor
                    disableActionBar
                    disableAutomaticOrientation
                    emissiveGlowIntensity
                    enableAR
                    environmentFile
                    environmentIntensity
                    environmentRotationY
                    idleTimeBeforeRotation
                    lowerAlphaLimitDeg
                    lowerBetaLimitDeg
                    maxZoomOverride
                    minZoomOverride
                    noPan
                    upperAlphaLimitDeg
                    upperBetaLimitDeg
                    renderingPipelineConfiguration {
                        ...RenderingPipelineConfigurationFields
                    }
                }
                id
                name
                panels {
                    editableArea {
                        height
                        width
                        x
                        y
                    }
                    id
                    height
                    width
                    index
                    name
                    title
                    useEditableArea
                    transparentBackground
                    previewRegion {
                        ...RegionFields
                    }
                }
                previewAsset {
                    ...AssetFields
                }
                showModelOnFinishStep
                showPlusInVariantPrices
                showPricing
                skuCode
                stepGroups {
                    name
                    stepNames
                }
                steps {
                    stepName
                    type
                    tags
                    globalPropertyAspectConfigurations {
                        aspectName
                        globalPropertyConfigurationId
                    }
                    conversionConfigurationFieldLinks {
                        identifier
                        conversionConfigurationId
                    }
                    overrideDefaultVariantId
                    option {
                        ...OptionMinimalFields
                    }
                    stepTitle
                    helpText
                    mandatory
                    relevantPanelName
                    silent
                    conditions {
                        requiredVariantMetafields {
                            variantMetafieldConfigurationId
                            variantMetafieldValue
                        }
                        requiredVariantSelections
                        targetStepName
                        action
                        type
                    }
                    data {
                        __typename
                        ... on InformationStepData {
                            content
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                        }
                        ... on DigitalContentStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            baseUrl
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on FrameStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            colorOption {
                                ...OptionMinimalFields
                            }
                            colorPickerEnabled
                            initialZoomLevel
                            disablePlaceholder
                            displayImageOnFinishStep
                            displaySelectionOnFinishStep
                            enableVariantCategories
                            forceImageCover
                            hideImageInCart
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            shouldVectorize
                            vectorizeMaxColors
                            vectorizationMinimumPixelThreshold
                            maxColors
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            overlayImageKey
                            overlayImageUrl
                            placeholderImageKey
                            placeholderImageUrl
                            regions {
                                ...RegionFields
                            }
                            whitelistedExtensions
                        }
                        ... on IllustrationStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            colorOption {
                                ...OptionMinimalFields
                            }
                            colorPickerEnabled
                            pmsPickerEnabled
                            displayColorsOnFinishStep
                            displaySelectionOnFinishStep
                            enableVariantCategories
                            enableVariantSearch
                            hideColorsInCart
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on MaterialStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displaySelectionOnFinishStep
                            enableVariantCategories
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            targetMaterials
                        }
                        ... on ModelStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displaySelectionOnFinishStep
                            enableVariantCategories
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            replaceProductModel
                        }
                        ... on ModuleStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displayTextOnFinishStep
                            hideTextInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            maxLength
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            module
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on PictureStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displaySelectionOnFinishStep
                            enableVariantCategories
                            enableVariantSearch
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on ProductOverlayStepData {
                            regions {
                                ...RegionFields
                            }
                            overlayType
                        }
                        ... on ProductStepData {
                            baseContents
                            categoryFilterEnabled
                            lockedAddOns {
                                lockedQty
                                variantId
                            }
                            max
                            min
                            pricing
                            searchBarEnabled
                            workflows
                        }
                        ... on QuestionStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            allowMultipleSelections
                            displaySelectionsOnFinishStep
                            displayType
                            hideSelectionsInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                        }
                        ... on ShapeStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displaySelectionOnFinishStep
                            enableVariantCategories
                            excludeFromPrint
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on SilentIllustrationStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            asset {
                                ...AssetFields
                            }
                            excludeFromPrint
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on TextStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            allowNewlines
                            colorOption {
                                ...OptionMinimalFields
                            }
                            colorPickerEnabled
                            curved
                            defaultText
                            deleteDefaultOnFocus
                            displayColorOnFinishStep
                            displayImageFillOnFinishStep
                            displayStrokeOnFinishStep
                            displayTextOnFinishStep
                            enableVariantCategories
                            hideColorInCart
                            hideImageFillInCart
                            hideSelectionInCart
                            hideStrokeInCart
                            hideTextInCart
                            imageFillOption {
                                ...OptionMinimalFields
                            }
                            imageFillScale
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            maxLength
                            maxSize
                            minSize
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            paths
                            regions {
                                ...RegionFields
                            }
                            replaceableText
                            size
                            strokeEnabled
                            strokeOption {
                                ...OptionMinimalFields
                            }
                            strokeThickness
                            textAlign
                            uppercase
                            userCanReplaceText
                            vertical
                            verticalAlign
                        }
                    }
                }
            }
        }
    `, hg = Oe`
    ${dg}
    fragment MarketplaceThemeInstallConfigurationFields on MarketplaceThemeInstallConfiguration {
        id
        themeInstallId
        fields {
            type
            key
            value
            asset {
                key
                name
                fileLink
                type
            }
            conversionConfiguration {
                ...ConversionConfigurationFields
            }
            metafieldConfiguration {
                id
                name
                description
                metafieldType
            }
            productCollection {
                id
                name
                description
                image {
                    key
                    name
                    fileLink
                    type
                }
            }
            listValues
            objectValues
            schema
            root
        }
        themeVersion {
            id
            version
            status
            createdAt
            updatedAt
            launchData {
                targetFiles {
                    filename
                    type
                    mimeType
                    fileLink
                    preload
                }
            }
            configurationSchema {
                customSchemas {
                    name
                    type
                    title
                    fields
                    extends
                    schemas
                }
                fields {
                    key
                    type
                    title
                    required
                    defaultValue
                    options {
                        key
                        value
                    }
                    assetType
                    multiLine
                    limit
                    items
                    fields
                    schema
                    root
                }
            }
        }
    }
`, UL = Oe`
    ${hg}
    query GetMarketplaceThemeInstallConfiguration($themeConfigurationId: String!, $themeInstallId: String!) {
        marketplaceThemeInstallConfiguration(id: $themeConfigurationId, themeInstallId: $themeInstallId, raw: false) {
            ...MarketplaceThemeInstallConfigurationFields
        }
    }
`, VL = Oe`
    ${VI}
    ${hg}
    query GetCurrentIntegration($themeConfigurationId: String) {
        currentIntegration {
            id
            type
            marketplaceThemeInstallConfiguration(id: $themeConfigurationId, raw: false) {
                ...MarketplaceThemeInstallConfigurationFields
            }
            ...ActiveIntegrationFields
        }
    }
`, $L = Oe`
    ${hg}
    query ReadTransactionForMarketplaceTheme($id: String!) {
        transactions(ids: [$id]) {
            marketplaceThemeInstallConfiguration(raw: false) {
                ...MarketplaceThemeInstallConfigurationFields
            }
        }
    }
`, zL = Oe`
    ${hg}
    query ReadBundleForMarketplaceTheme($id: String!) {
        bundles(ids: [$id]) {
            marketplaceThemeInstallConfiguration(raw: false) {
                ...MarketplaceThemeInstallConfigurationFields
            }
        }
    }
`, GL = Oe`
    mutation CreateOrder($orderItems: [OrderItemInput]!) {
        orderCreate(orderItems: $orderItems, paid: false, generateInternalId: true) {
            id
            internalId
        }
    }
`, HL = Oe`
    query CurrencyConversion($from: String!, $to: String!) {
        currencyConversion(from: $from, to: $to) {
            rateFrom
            rateTo
            timestamp
        }
    }
`, Dre = Oe`
    query AssetConfigurations {
        assetConfigurations {
            id
            assetKey
            colorOption {
                id
                name
            }
            channelNumbers {
                id
                number
            }
            defaultColorVariants {
                channelNumber
                variant {
                    id
                    name
                }
            }
            template
            customerId
        }
    }
`, Rre = Oe`
    mutation AssetConfigurationUpdate(
        $assetKey: String!
        $colorOptionId: String
        $channelNumbers: [AssetConfigurationChannelNumberInput]
        $defaultColorVariants: [AssetConfigurationDefaultColorVariantInput]
        $template: Boolean
        $customerId: String
    ) {
        assetConfigurationUpdate(
            assetKey: $assetKey
            colorOptionId: $colorOptionId
            channelNumbers: $channelNumbers
            defaultColorVariants: $defaultColorVariants
            template: $template
            customerId: $customerId
        ) {
            assetKey
            colorOption {
                id
                name
            }
            channelNumbers {
                id
                number
            }
            defaultColorVariants {
                channelNumber
                variant {
                    id
                    name
                }
            }
            template
            customerId
        }
    }
`, Ore = Oe`
    mutation AssetConfigurationDelete($id: String!) {
        assetConfigurationDelete(id: $id)
    }
`, Bre = Oe`
    query GetAssetsForProductImages($keys: [String!]!) {
        assets(keys: $keys) {
            key
            fileLink
            versions {
                name
                link
            }
        }
    }
`, WL = Oe`
    ${fg}
    fragment WorkflowProductFields on WorkflowProduct {
        id
        index
        friendlyName
        isPresent
        workflowName
        imageUrl
        panelPreviews {
            panelId
            imageUrl
            region {
                width
                height
                top
                left
                rotation
            }
        }
    }
    fragment ProductFields on Product {
        id
        basePrice
        enabled
        imageUrl
        minimumOrderQuantity
        integrationProducts {
            id
            externalProductId
            externalVariantId
            additionalExternalProductId
            additionalExternalVariantId
            additionalIntegrationProduct {
                ...AdditionalIntegrationProductFields
            }
            integration {
                id
                enabled
                externalIntegrationId
                type
                isCurrent
            }
        }
        modelUrl
        name
        description
        overlayImageUrl
        preloadImageUrl
        sku
        skuCode
        workflows {
            ...WorkflowProductFields
        }
        productTags {
            id
            name
        }
        productImages {
            id
            precedence
            asset {
                key
                fileLink
                name
                type
            }
        }
    }
`, jL = (r) => Oe`
    ${WL}
    fragment ProductCollectionProductFields on ProductCollectionProduct {
        id
        productId
        workflowId
        product {
            ...ProductFields
        }
        workflows {
            workflowProduct {
                ...WorkflowProductFields
            }
        }
    }
`, qL = (r) => Oe`
    ${hg}
    ${r ? jL() : ""}
    query GetActivation(
        $id: String!
        ${r ? "$productIds: [String!]" : ""}
    ) {
        activation(id: $id) {
            id
            name
            singleProductMode
            marketplaceThemeInstallConfiguration {
                ...MarketplaceThemeInstallConfigurationFields
            }
            activationProductCollections {
                id
                productCollection {
                    id
                    ${r ? `
                    productCollectionProducts(productIds: $productIds) {
                        ...ProductCollectionProductFields
                    }
                    ` : ""}
                }
            }
        }
    }
`;
var Hh = { exports: {} }, Cf = { exports: {} }, QL = Cf.exports, eE;
function YL() {
  return eE || (eE = 1, (function() {
    var r, e, t, n, i, a;
    typeof performance < "u" && performance !== null && performance.now ? Cf.exports = function() {
      return performance.now();
    } : typeof process < "u" && process !== null && process.hrtime ? (Cf.exports = function() {
      return (r() - i) / 1e6;
    }, e = process.hrtime, r = function() {
      var s;
      return s = e(), s[0] * 1e9 + s[1];
    }, n = r(), a = process.uptime() * 1e9, i = n - a) : Date.now ? (Cf.exports = function() {
      return Date.now() - t;
    }, t = Date.now()) : (Cf.exports = function() {
      return (/* @__PURE__ */ new Date()).getTime() - t;
    }, t = (/* @__PURE__ */ new Date()).getTime());
  }).call(QL)), Cf.exports;
}
var tE;
function XL() {
  if (tE) return Hh.exports;
  tE = 1;
  for (var r = YL(), e = typeof window > "u" ? Ni : window, t = ["moz", "webkit"], n = "AnimationFrame", i = e["request" + n], a = e["cancel" + n] || e["cancelRequest" + n], s = 0; !i && s < t.length; s++)
    i = e[t[s] + "Request" + n], a = e[t[s] + "Cancel" + n] || e[t[s] + "CancelRequest" + n];
  if (!i || !a) {
    var o = 0, l = 0, u = [], c = 1e3 / 60;
    i = function(h) {
      if (u.length === 0) {
        var f = r(), p = Math.max(0, c - (f - o));
        o = p + f, setTimeout(function() {
          var m = u.slice(0);
          u.length = 0;
          for (var A = 0; A < m.length; A++)
            if (!m[A].cancelled)
              try {
                m[A].callback(o);
              } catch (w) {
                setTimeout(function() {
                  throw w;
                }, 0);
              }
        }, Math.round(p));
      }
      return u.push({
        handle: ++l,
        callback: h,
        cancelled: !1
      }), l;
    }, a = function(h) {
      for (var f = 0; f < u.length; f++)
        u[f].handle === h && (u[f].cancelled = !0);
    };
  }
  return Hh.exports = function(h) {
    return i.call(e, h);
  }, Hh.exports.cancel = function() {
    a.apply(e, arguments);
  }, Hh.exports.polyfill = function(h) {
    h || (h = e), h.requestAnimationFrame = i, h.cancelAnimationFrame = a;
  }, Hh.exports;
}
var JL = XL();
const ey = /* @__PURE__ */ Iu(JL);
var ty, rE;
function KL() {
  return rE || (rE = 1, ty = function(r) {
    this.ok = !1, this.alpha = 1, r.charAt(0) == "#" && (r = r.substr(1, 6)), r = r.replace(/ /g, ""), r = r.toLowerCase();
    var e = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "00ffff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000000",
      blanchedalmond: "ffebcd",
      blue: "0000ff",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "00ffff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dodgerblue: "1e90ff",
      feldspar: "d19275",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "ff00ff",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgrey: "d3d3d3",
      lightgreen: "90ee90",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslateblue: "8470ff",
      lightslategray: "778899",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "00ff00",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "ff00ff",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370d8",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "d87093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "ff0000",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      violetred: "d02090",
      wheat: "f5deb3",
      white: "ffffff",
      whitesmoke: "f5f5f5",
      yellow: "ffff00",
      yellowgreen: "9acd32"
    };
    r = e[r] || r;
    for (var t = [
      {
        re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
        example: ["rgba(123, 234, 45, 0.8)", "rgba(255,234,245,1.0)"],
        process: function(l) {
          return [
            parseInt(l[1]),
            parseInt(l[2]),
            parseInt(l[3]),
            parseFloat(l[4])
          ];
        }
      },
      {
        re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
        example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
        process: function(l) {
          return [
            parseInt(l[1]),
            parseInt(l[2]),
            parseInt(l[3])
          ];
        }
      },
      {
        re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        example: ["#00ff00", "336699"],
        process: function(l) {
          return [
            parseInt(l[1], 16),
            parseInt(l[2], 16),
            parseInt(l[3], 16)
          ];
        }
      },
      {
        re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        example: ["#fb0", "f0f"],
        process: function(l) {
          return [
            parseInt(l[1] + l[1], 16),
            parseInt(l[2] + l[2], 16),
            parseInt(l[3] + l[3], 16)
          ];
        }
      }
    ], n = 0; n < t.length; n++) {
      var i = t[n].re, a = t[n].process, s = i.exec(r);
      if (s) {
        var o = a(s);
        this.r = o[0], this.g = o[1], this.b = o[2], o.length > 3 && (this.alpha = o[3]), this.ok = !0;
      }
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.alpha = this.alpha < 0 ? 0 : this.alpha > 1 || isNaN(this.alpha) ? 1 : this.alpha, this.toRGB = function() {
      return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toRGBA = function() {
      return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.alpha + ")";
    }, this.toHex = function() {
      var l = this.r.toString(16), u = this.g.toString(16), c = this.b.toString(16);
      return l.length == 1 && (l = "0" + l), u.length == 1 && (u = "0" + u), c.length == 1 && (c = "0" + c), "#" + l + u + c;
    }, this.getHelpXML = function() {
      for (var l = new Array(), u = 0; u < t.length; u++)
        for (var c = t[u].example, h = 0; h < c.length; h++)
          l[l.length] = c[h];
      for (var f in e)
        l[l.length] = f;
      var p = document.createElement("ul");
      p.setAttribute("id", "rgbcolor-examples");
      for (var u = 0; u < l.length; u++)
        try {
          var m = document.createElement("li"), A = new RGBColor(l[u]), w = document.createElement("div");
          w.style.cssText = "margin: 3px; border: 1px solid black; background:" + A.toHex() + "; color:" + A.toHex(), w.appendChild(document.createTextNode("test"));
          var x = document.createTextNode(
            " " + l[u] + " -> " + A.toRGB() + " -> " + A.toHex()
          );
          m.appendChild(w), m.appendChild(x), p.appendChild(m);
        } catch {
        }
      return p;
    };
  }), ty;
}
var ZL = KL();
const S1 = /* @__PURE__ */ Iu(ZL);
var jI = function(r, e) {
  return (jI = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
  })(r, e);
};
function qI(r, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  function t() {
    this.constructor = r;
  }
  jI(r, e), r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
function e7(r) {
  var e = "";
  Array.isArray(r) || (r = [r]);
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    if (n.type === Ze.CLOSE_PATH) e += "z";
    else if (n.type === Ze.HORIZ_LINE_TO) e += (n.relative ? "h" : "H") + n.x;
    else if (n.type === Ze.VERT_LINE_TO) e += (n.relative ? "v" : "V") + n.y;
    else if (n.type === Ze.MOVE_TO) e += (n.relative ? "m" : "M") + n.x + " " + n.y;
    else if (n.type === Ze.LINE_TO) e += (n.relative ? "l" : "L") + n.x + " " + n.y;
    else if (n.type === Ze.CURVE_TO) e += (n.relative ? "c" : "C") + n.x1 + " " + n.y1 + " " + n.x2 + " " + n.y2 + " " + n.x + " " + n.y;
    else if (n.type === Ze.SMOOTH_CURVE_TO) e += (n.relative ? "s" : "S") + n.x2 + " " + n.y2 + " " + n.x + " " + n.y;
    else if (n.type === Ze.QUAD_TO) e += (n.relative ? "q" : "Q") + n.x1 + " " + n.y1 + " " + n.x + " " + n.y;
    else if (n.type === Ze.SMOOTH_QUAD_TO) e += (n.relative ? "t" : "T") + n.x + " " + n.y;
    else {
      if (n.type !== Ze.ARC) throw new Error('Unexpected command type "' + n.type + '" at index ' + t + ".");
      e += (n.relative ? "a" : "A") + n.rX + " " + n.rY + " " + n.xRot + " " + +n.lArcFlag + " " + +n.sweepFlag + " " + n.x + " " + n.y;
    }
  }
  return e;
}
function E1(r, e) {
  var t = r[0], n = r[1];
  return [t * Math.cos(e) - n * Math.sin(e), t * Math.sin(e) + n * Math.cos(e)];
}
function Wo() {
  for (var r = [], e = 0; e < arguments.length; e++) r[e] = arguments[e];
  for (var t = 0; t < r.length; t++) if (typeof r[t] != "number") throw new Error("assertNumbers arguments[" + t + "] is not a number. " + typeof r[t] + " == typeof " + r[t]);
  return !0;
}
var pc = Math.PI;
function ry(r, e, t) {
  r.lArcFlag = r.lArcFlag === 0 ? 0 : 1, r.sweepFlag = r.sweepFlag === 0 ? 0 : 1;
  var n = r.rX, i = r.rY, a = r.x, s = r.y;
  n = Math.abs(r.rX), i = Math.abs(r.rY);
  var o = E1([(e - a) / 2, (t - s) / 2], -r.xRot / 180 * pc), l = o[0], u = o[1], c = Math.pow(l, 2) / Math.pow(n, 2) + Math.pow(u, 2) / Math.pow(i, 2);
  1 < c && (n *= Math.sqrt(c), i *= Math.sqrt(c)), r.rX = n, r.rY = i;
  var h = Math.pow(n, 2) * Math.pow(u, 2) + Math.pow(i, 2) * Math.pow(l, 2), f = (r.lArcFlag !== r.sweepFlag ? 1 : -1) * Math.sqrt(Math.max(0, (Math.pow(n, 2) * Math.pow(i, 2) - h) / h)), p = n * u / i * f, m = -i * l / n * f, A = E1([p, m], r.xRot / 180 * pc);
  r.cX = A[0] + (e + a) / 2, r.cY = A[1] + (t + s) / 2, r.phi1 = Math.atan2((u - m) / i, (l - p) / n), r.phi2 = Math.atan2((-u - m) / i, (-l - p) / n), r.sweepFlag === 0 && r.phi2 > r.phi1 && (r.phi2 -= 2 * pc), r.sweepFlag === 1 && r.phi2 < r.phi1 && (r.phi2 += 2 * pc), r.phi1 *= 180 / pc, r.phi2 *= 180 / pc;
}
function nE(r, e, t) {
  Wo(r, e, t);
  var n = r * r + e * e - t * t;
  if (0 > n) return [];
  if (n === 0) return [[r * t / (r * r + e * e), e * t / (r * r + e * e)]];
  var i = Math.sqrt(n);
  return [[(r * t + e * i) / (r * r + e * e), (e * t - r * i) / (r * r + e * e)], [(r * t - e * i) / (r * r + e * e), (e * t + r * i) / (r * r + e * e)]];
}
var ia, vu = Math.PI / 180;
function iE(r, e, t) {
  return (1 - t) * r + t * e;
}
function aE(r, e, t, n) {
  return r + Math.cos(n / 180 * pc) * e + Math.sin(n / 180 * pc) * t;
}
function sE(r, e, t, n) {
  var i = 1e-6, a = e - r, s = t - e, o = 3 * a + 3 * (n - t) - 6 * s, l = 6 * (s - a), u = 3 * a;
  return Math.abs(o) < i ? [-u / l] : (function(c, h, f) {
    var p = c * c / 4 - h;
    if (p < -f) return [];
    if (p <= f) return [-c / 2];
    var m = Math.sqrt(p);
    return [-c / 2 - m, -c / 2 + m];
  })(l / o, u / o, i);
}
function oE(r, e, t, n, i) {
  var a = 1 - i;
  return r * (a * a * a) + e * (3 * a * a * i) + t * (3 * a * i * i) + n * (i * i * i);
}
(function(r) {
  function e() {
    return i((function(o, l, u) {
      return o.relative && (o.x1 !== void 0 && (o.x1 += l), o.y1 !== void 0 && (o.y1 += u), o.x2 !== void 0 && (o.x2 += l), o.y2 !== void 0 && (o.y2 += u), o.x !== void 0 && (o.x += l), o.y !== void 0 && (o.y += u), o.relative = !1), o;
    }));
  }
  function t() {
    var o = NaN, l = NaN, u = NaN, c = NaN;
    return i((function(h, f, p) {
      return h.type & Ze.SMOOTH_CURVE_TO && (h.type = Ze.CURVE_TO, o = isNaN(o) ? f : o, l = isNaN(l) ? p : l, h.x1 = h.relative ? f - o : 2 * f - o, h.y1 = h.relative ? p - l : 2 * p - l), h.type & Ze.CURVE_TO ? (o = h.relative ? f + h.x2 : h.x2, l = h.relative ? p + h.y2 : h.y2) : (o = NaN, l = NaN), h.type & Ze.SMOOTH_QUAD_TO && (h.type = Ze.QUAD_TO, u = isNaN(u) ? f : u, c = isNaN(c) ? p : c, h.x1 = h.relative ? f - u : 2 * f - u, h.y1 = h.relative ? p - c : 2 * p - c), h.type & Ze.QUAD_TO ? (u = h.relative ? f + h.x1 : h.x1, c = h.relative ? p + h.y1 : h.y1) : (u = NaN, c = NaN), h;
    }));
  }
  function n() {
    var o = NaN, l = NaN;
    return i((function(u, c, h) {
      if (u.type & Ze.SMOOTH_QUAD_TO && (u.type = Ze.QUAD_TO, o = isNaN(o) ? c : o, l = isNaN(l) ? h : l, u.x1 = u.relative ? c - o : 2 * c - o, u.y1 = u.relative ? h - l : 2 * h - l), u.type & Ze.QUAD_TO) {
        o = u.relative ? c + u.x1 : u.x1, l = u.relative ? h + u.y1 : u.y1;
        var f = u.x1, p = u.y1;
        u.type = Ze.CURVE_TO, u.x1 = ((u.relative ? 0 : c) + 2 * f) / 3, u.y1 = ((u.relative ? 0 : h) + 2 * p) / 3, u.x2 = (u.x + 2 * f) / 3, u.y2 = (u.y + 2 * p) / 3;
      } else o = NaN, l = NaN;
      return u;
    }));
  }
  function i(o) {
    var l = 0, u = 0, c = NaN, h = NaN;
    return function(f) {
      if (isNaN(c) && !(f.type & Ze.MOVE_TO)) throw new Error("path must start with moveto");
      var p = o(f, l, u, c, h);
      return f.type & Ze.CLOSE_PATH && (l = c, u = h), f.x !== void 0 && (l = f.relative ? l + f.x : f.x), f.y !== void 0 && (u = f.relative ? u + f.y : f.y), f.type & Ze.MOVE_TO && (c = l, h = u), p;
    };
  }
  function a(o, l, u, c, h, f) {
    return Wo(o, l, u, c, h, f), i((function(p, m, A, w) {
      var x = p.x1, E = p.x2, T = p.relative && !isNaN(w), D = p.x !== void 0 ? p.x : T ? 0 : m, F = p.y !== void 0 ? p.y : T ? 0 : A;
      function _(ve) {
        return ve * ve;
      }
      p.type & Ze.HORIZ_LINE_TO && l !== 0 && (p.type = Ze.LINE_TO, p.y = p.relative ? 0 : A), p.type & Ze.VERT_LINE_TO && u !== 0 && (p.type = Ze.LINE_TO, p.x = p.relative ? 0 : m), p.x !== void 0 && (p.x = p.x * o + F * u + (T ? 0 : h)), p.y !== void 0 && (p.y = D * l + p.y * c + (T ? 0 : f)), p.x1 !== void 0 && (p.x1 = p.x1 * o + p.y1 * u + (T ? 0 : h)), p.y1 !== void 0 && (p.y1 = x * l + p.y1 * c + (T ? 0 : f)), p.x2 !== void 0 && (p.x2 = p.x2 * o + p.y2 * u + (T ? 0 : h)), p.y2 !== void 0 && (p.y2 = E * l + p.y2 * c + (T ? 0 : f));
      var L = o * c - l * u;
      if (p.xRot !== void 0 && (o !== 1 || l !== 0 || u !== 0 || c !== 1)) if (L === 0) delete p.rX, delete p.rY, delete p.xRot, delete p.lArcFlag, delete p.sweepFlag, p.type = Ze.LINE_TO;
      else {
        var Z = p.xRot * Math.PI / 180, te = Math.sin(Z), de = Math.cos(Z), H = 1 / _(p.rX), j = 1 / _(p.rY), q = _(de) * H + _(te) * j, re = 2 * te * de * (H - j), ae = _(te) * H + _(de) * j, ye = q * c * c - re * l * c + ae * l * l, Se = re * (o * c + l * u) - 2 * (q * u * c + ae * o * l), Xe = q * u * u - re * o * u + ae * o * o, Ve = (Math.atan2(Se, ye - Xe) + Math.PI) % Math.PI / 2, He = Math.sin(Ve), le = Math.cos(Ve);
        p.rX = Math.abs(L) / Math.sqrt(ye * _(le) + Se * He * le + Xe * _(He)), p.rY = Math.abs(L) / Math.sqrt(ye * _(He) - Se * He * le + Xe * _(le)), p.xRot = 180 * Ve / Math.PI;
      }
      return p.sweepFlag !== void 0 && 0 > L && (p.sweepFlag = +!p.sweepFlag), p;
    }));
  }
  function s() {
    return function(o) {
      var l = {};
      for (var u in o) l[u] = o[u];
      return l;
    };
  }
  r.ROUND = function(o) {
    function l(u) {
      return Math.round(u * o) / o;
    }
    return o === void 0 && (o = 1e13), Wo(o), function(u) {
      return u.x1 !== void 0 && (u.x1 = l(u.x1)), u.y1 !== void 0 && (u.y1 = l(u.y1)), u.x2 !== void 0 && (u.x2 = l(u.x2)), u.y2 !== void 0 && (u.y2 = l(u.y2)), u.x !== void 0 && (u.x = l(u.x)), u.y !== void 0 && (u.y = l(u.y)), u.rX !== void 0 && (u.rX = l(u.rX)), u.rY !== void 0 && (u.rY = l(u.rY)), u;
    };
  }, r.TO_ABS = e, r.TO_REL = function() {
    return i((function(o, l, u) {
      return o.relative || (o.x1 !== void 0 && (o.x1 -= l), o.y1 !== void 0 && (o.y1 -= u), o.x2 !== void 0 && (o.x2 -= l), o.y2 !== void 0 && (o.y2 -= u), o.x !== void 0 && (o.x -= l), o.y !== void 0 && (o.y -= u), o.relative = !0), o;
    }));
  }, r.NORMALIZE_HVZ = function(o, l, u) {
    return o === void 0 && (o = !0), l === void 0 && (l = !0), u === void 0 && (u = !0), i((function(c, h, f, p, m) {
      if (isNaN(p) && !(c.type & Ze.MOVE_TO)) throw new Error("path must start with moveto");
      return l && c.type & Ze.HORIZ_LINE_TO && (c.type = Ze.LINE_TO, c.y = c.relative ? 0 : f), u && c.type & Ze.VERT_LINE_TO && (c.type = Ze.LINE_TO, c.x = c.relative ? 0 : h), o && c.type & Ze.CLOSE_PATH && (c.type = Ze.LINE_TO, c.x = c.relative ? p - h : p, c.y = c.relative ? m - f : m), c.type & Ze.ARC && (c.rX === 0 || c.rY === 0) && (c.type = Ze.LINE_TO, delete c.rX, delete c.rY, delete c.xRot, delete c.lArcFlag, delete c.sweepFlag), c;
    }));
  }, r.NORMALIZE_ST = t, r.QT_TO_C = n, r.INFO = i, r.SANITIZE = function(o) {
    o === void 0 && (o = 0), Wo(o);
    var l = NaN, u = NaN, c = NaN, h = NaN;
    return i((function(f, p, m, A, w) {
      var x = Math.abs, E = !1, T = 0, D = 0;
      if (f.type & Ze.SMOOTH_CURVE_TO && (T = isNaN(l) ? 0 : p - l, D = isNaN(u) ? 0 : m - u), f.type & (Ze.CURVE_TO | Ze.SMOOTH_CURVE_TO) ? (l = f.relative ? p + f.x2 : f.x2, u = f.relative ? m + f.y2 : f.y2) : (l = NaN, u = NaN), f.type & Ze.SMOOTH_QUAD_TO ? (c = isNaN(c) ? p : 2 * p - c, h = isNaN(h) ? m : 2 * m - h) : f.type & Ze.QUAD_TO ? (c = f.relative ? p + f.x1 : f.x1, h = f.relative ? m + f.y1 : f.y2) : (c = NaN, h = NaN), f.type & Ze.LINE_COMMANDS || f.type & Ze.ARC && (f.rX === 0 || f.rY === 0 || !f.lArcFlag) || f.type & Ze.CURVE_TO || f.type & Ze.SMOOTH_CURVE_TO || f.type & Ze.QUAD_TO || f.type & Ze.SMOOTH_QUAD_TO) {
        var F = f.x === void 0 ? 0 : f.relative ? f.x : f.x - p, _ = f.y === void 0 ? 0 : f.relative ? f.y : f.y - m;
        T = isNaN(c) ? f.x1 === void 0 ? T : f.relative ? f.x : f.x1 - p : c - p, D = isNaN(h) ? f.y1 === void 0 ? D : f.relative ? f.y : f.y1 - m : h - m;
        var L = f.x2 === void 0 ? 0 : f.relative ? f.x : f.x2 - p, Z = f.y2 === void 0 ? 0 : f.relative ? f.y : f.y2 - m;
        x(F) <= o && x(_) <= o && x(T) <= o && x(D) <= o && x(L) <= o && x(Z) <= o && (E = !0);
      }
      return f.type & Ze.CLOSE_PATH && x(p - A) <= o && x(m - w) <= o && (E = !0), E ? [] : f;
    }));
  }, r.MATRIX = a, r.ROTATE = function(o, l, u) {
    l === void 0 && (l = 0), u === void 0 && (u = 0), Wo(o, l, u);
    var c = Math.sin(o), h = Math.cos(o);
    return a(h, c, -c, h, l - l * h + u * c, u - l * c - u * h);
  }, r.TRANSLATE = function(o, l) {
    return l === void 0 && (l = 0), Wo(o, l), a(1, 0, 0, 1, o, l);
  }, r.SCALE = function(o, l) {
    return l === void 0 && (l = o), Wo(o, l), a(o, 0, 0, l, 0, 0);
  }, r.SKEW_X = function(o) {
    return Wo(o), a(1, 0, Math.atan(o), 1, 0, 0);
  }, r.SKEW_Y = function(o) {
    return Wo(o), a(1, Math.atan(o), 0, 1, 0, 0);
  }, r.X_AXIS_SYMMETRY = function(o) {
    return o === void 0 && (o = 0), Wo(o), a(-1, 0, 0, 1, o, 0);
  }, r.Y_AXIS_SYMMETRY = function(o) {
    return o === void 0 && (o = 0), Wo(o), a(1, 0, 0, -1, 0, o);
  }, r.A_TO_C = function() {
    return i((function(o, l, u) {
      return Ze.ARC === o.type ? (function(c, h, f) {
        var p, m, A, w;
        c.cX || ry(c, h, f);
        for (var x = Math.min(c.phi1, c.phi2), E = Math.max(c.phi1, c.phi2) - x, T = Math.ceil(E / 90), D = new Array(T), F = h, _ = f, L = 0; L < T; L++) {
          var Z = iE(c.phi1, c.phi2, L / T), te = iE(c.phi1, c.phi2, (L + 1) / T), de = te - Z, H = 4 / 3 * Math.tan(de * vu / 4), j = [Math.cos(Z * vu) - H * Math.sin(Z * vu), Math.sin(Z * vu) + H * Math.cos(Z * vu)], q = j[0], re = j[1], ae = [Math.cos(te * vu), Math.sin(te * vu)], ye = ae[0], Se = ae[1], Xe = [ye + H * Math.sin(te * vu), Se - H * Math.cos(te * vu)], Ve = Xe[0], He = Xe[1];
          D[L] = { relative: c.relative, type: Ze.CURVE_TO };
          var le = function(ve, it) {
            var mt = E1([ve * c.rX, it * c.rY], c.xRot), qe = mt[0], at = mt[1];
            return [c.cX + qe, c.cY + at];
          };
          p = le(q, re), D[L].x1 = p[0], D[L].y1 = p[1], m = le(Ve, He), D[L].x2 = m[0], D[L].y2 = m[1], A = le(ye, Se), D[L].x = A[0], D[L].y = A[1], c.relative && (D[L].x1 -= F, D[L].y1 -= _, D[L].x2 -= F, D[L].y2 -= _, D[L].x -= F, D[L].y -= _), F = (w = [D[L].x, D[L].y])[0], _ = w[1];
        }
        return D;
      })(o, o.relative ? 0 : l, o.relative ? 0 : u) : o;
    }));
  }, r.ANNOTATE_ARCS = function() {
    return i((function(o, l, u) {
      return o.relative && (l = 0, u = 0), Ze.ARC === o.type && ry(o, l, u), o;
    }));
  }, r.CLONE = s, r.CALCULATE_BOUNDS = function() {
    var o = function(f) {
      var p = {};
      for (var m in f) p[m] = f[m];
      return p;
    }, l = e(), u = n(), c = t(), h = i((function(f, p, m) {
      var A = c(u(l(o(f))));
      function w(He) {
        He > h.maxX && (h.maxX = He), He < h.minX && (h.minX = He);
      }
      function x(He) {
        He > h.maxY && (h.maxY = He), He < h.minY && (h.minY = He);
      }
      if (A.type & Ze.DRAWING_COMMANDS && (w(p), x(m)), A.type & Ze.HORIZ_LINE_TO && w(A.x), A.type & Ze.VERT_LINE_TO && x(A.y), A.type & Ze.LINE_TO && (w(A.x), x(A.y)), A.type & Ze.CURVE_TO) {
        w(A.x), x(A.y);
        for (var E = 0, T = sE(p, A.x1, A.x2, A.x); E < T.length; E++)
          0 < (Ve = T[E]) && 1 > Ve && w(oE(p, A.x1, A.x2, A.x, Ve));
        for (var D = 0, F = sE(m, A.y1, A.y2, A.y); D < F.length; D++)
          0 < (Ve = F[D]) && 1 > Ve && x(oE(m, A.y1, A.y2, A.y, Ve));
      }
      if (A.type & Ze.ARC) {
        w(A.x), x(A.y), ry(A, p, m);
        for (var _ = A.xRot / 180 * Math.PI, L = Math.cos(_) * A.rX, Z = Math.sin(_) * A.rX, te = -Math.sin(_) * A.rY, de = Math.cos(_) * A.rY, H = A.phi1 < A.phi2 ? [A.phi1, A.phi2] : -180 > A.phi2 ? [A.phi2 + 360, A.phi1 + 360] : [A.phi2, A.phi1], j = H[0], q = H[1], re = function(He) {
          var le = He[0], ve = He[1], it = 180 * Math.atan2(ve, le) / Math.PI;
          return it < j ? it + 360 : it;
        }, ae = 0, ye = nE(te, -L, 0).map(re); ae < ye.length; ae++)
          (Ve = ye[ae]) > j && Ve < q && w(aE(A.cX, L, te, Ve));
        for (var Se = 0, Xe = nE(de, -Z, 0).map(re); Se < Xe.length; Se++) {
          var Ve;
          (Ve = Xe[Se]) > j && Ve < q && x(aE(A.cY, Z, de, Ve));
        }
      }
      return f;
    }));
    return h.minX = 1 / 0, h.maxX = -1 / 0, h.minY = 1 / 0, h.maxY = -1 / 0, h;
  };
})(ia || (ia = {}));
var Go, QI = (function() {
  function r() {
  }
  return r.prototype.round = function(e) {
    return this.transform(ia.ROUND(e));
  }, r.prototype.toAbs = function() {
    return this.transform(ia.TO_ABS());
  }, r.prototype.toRel = function() {
    return this.transform(ia.TO_REL());
  }, r.prototype.normalizeHVZ = function(e, t, n) {
    return this.transform(ia.NORMALIZE_HVZ(e, t, n));
  }, r.prototype.normalizeST = function() {
    return this.transform(ia.NORMALIZE_ST());
  }, r.prototype.qtToC = function() {
    return this.transform(ia.QT_TO_C());
  }, r.prototype.aToC = function() {
    return this.transform(ia.A_TO_C());
  }, r.prototype.sanitize = function(e) {
    return this.transform(ia.SANITIZE(e));
  }, r.prototype.translate = function(e, t) {
    return this.transform(ia.TRANSLATE(e, t));
  }, r.prototype.scale = function(e, t) {
    return this.transform(ia.SCALE(e, t));
  }, r.prototype.rotate = function(e, t, n) {
    return this.transform(ia.ROTATE(e, t, n));
  }, r.prototype.matrix = function(e, t, n, i, a, s) {
    return this.transform(ia.MATRIX(e, t, n, i, a, s));
  }, r.prototype.skewX = function(e) {
    return this.transform(ia.SKEW_X(e));
  }, r.prototype.skewY = function(e) {
    return this.transform(ia.SKEW_Y(e));
  }, r.prototype.xSymmetry = function(e) {
    return this.transform(ia.X_AXIS_SYMMETRY(e));
  }, r.prototype.ySymmetry = function(e) {
    return this.transform(ia.Y_AXIS_SYMMETRY(e));
  }, r.prototype.annotateArcs = function() {
    return this.transform(ia.ANNOTATE_ARCS());
  }, r;
})(), t7 = function(r) {
  return r === " " || r === "	" || r === "\r" || r === `
`;
}, lE = function(r) {
  return 48 <= r.charCodeAt(0) && r.charCodeAt(0) <= 57;
}, r7 = (function(r) {
  function e() {
    var t = r.call(this) || this;
    return t.curNumber = "", t.curCommandType = -1, t.curCommandRelative = !1, t.canParseCommandOrComma = !0, t.curNumberHasExp = !1, t.curNumberHasExpDigits = !1, t.curNumberHasDecimal = !1, t.curArgs = [], t;
  }
  return qI(e, r), e.prototype.finish = function(t) {
    if (t === void 0 && (t = []), this.parse(" ", t), this.curArgs.length !== 0 || !this.canParseCommandOrComma) throw new SyntaxError("Unterminated command at the path end.");
    return t;
  }, e.prototype.parse = function(t, n) {
    var i = this;
    n === void 0 && (n = []);
    for (var a = function(h) {
      n.push(h), i.curArgs.length = 0, i.canParseCommandOrComma = !0;
    }, s = 0; s < t.length; s++) {
      var o = t[s], l = !(this.curCommandType !== Ze.ARC || this.curArgs.length !== 3 && this.curArgs.length !== 4 || this.curNumber.length !== 1 || this.curNumber !== "0" && this.curNumber !== "1"), u = lE(o) && (this.curNumber === "0" && o === "0" || l);
      if (!lE(o) || u) if (o !== "e" && o !== "E") if (o !== "-" && o !== "+" || !this.curNumberHasExp || this.curNumberHasExpDigits) if (o !== "." || this.curNumberHasExp || this.curNumberHasDecimal || l) {
        if (this.curNumber && this.curCommandType !== -1) {
          var c = Number(this.curNumber);
          if (isNaN(c)) throw new SyntaxError("Invalid number ending at " + s);
          if (this.curCommandType === Ze.ARC) {
            if (this.curArgs.length === 0 || this.curArgs.length === 1) {
              if (0 > c) throw new SyntaxError('Expected positive number, got "' + c + '" at index "' + s + '"');
            } else if ((this.curArgs.length === 3 || this.curArgs.length === 4) && this.curNumber !== "0" && this.curNumber !== "1") throw new SyntaxError('Expected a flag, got "' + this.curNumber + '" at index "' + s + '"');
          }
          this.curArgs.push(c), this.curArgs.length === n7[this.curCommandType] && (Ze.HORIZ_LINE_TO === this.curCommandType ? a({ type: Ze.HORIZ_LINE_TO, relative: this.curCommandRelative, x: c }) : Ze.VERT_LINE_TO === this.curCommandType ? a({ type: Ze.VERT_LINE_TO, relative: this.curCommandRelative, y: c }) : this.curCommandType === Ze.MOVE_TO || this.curCommandType === Ze.LINE_TO || this.curCommandType === Ze.SMOOTH_QUAD_TO ? (a({ type: this.curCommandType, relative: this.curCommandRelative, x: this.curArgs[0], y: this.curArgs[1] }), Ze.MOVE_TO === this.curCommandType && (this.curCommandType = Ze.LINE_TO)) : this.curCommandType === Ze.CURVE_TO ? a({ type: Ze.CURVE_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x2: this.curArgs[2], y2: this.curArgs[3], x: this.curArgs[4], y: this.curArgs[5] }) : this.curCommandType === Ze.SMOOTH_CURVE_TO ? a({ type: Ze.SMOOTH_CURVE_TO, relative: this.curCommandRelative, x2: this.curArgs[0], y2: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === Ze.QUAD_TO ? a({ type: Ze.QUAD_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === Ze.ARC && a({ type: Ze.ARC, relative: this.curCommandRelative, rX: this.curArgs[0], rY: this.curArgs[1], xRot: this.curArgs[2], lArcFlag: this.curArgs[3], sweepFlag: this.curArgs[4], x: this.curArgs[5], y: this.curArgs[6] })), this.curNumber = "", this.curNumberHasExpDigits = !1, this.curNumberHasExp = !1, this.curNumberHasDecimal = !1, this.canParseCommandOrComma = !0;
        }
        if (!t7(o)) if (o === "," && this.canParseCommandOrComma) this.canParseCommandOrComma = !1;
        else if (o !== "+" && o !== "-" && o !== ".") if (u) this.curNumber = o, this.curNumberHasDecimal = !1;
        else {
          if (this.curArgs.length !== 0) throw new SyntaxError("Unterminated command at index " + s + ".");
          if (!this.canParseCommandOrComma) throw new SyntaxError('Unexpected character "' + o + '" at index ' + s + ". Command cannot follow comma");
          if (this.canParseCommandOrComma = !1, o !== "z" && o !== "Z") if (o === "h" || o === "H") this.curCommandType = Ze.HORIZ_LINE_TO, this.curCommandRelative = o === "h";
          else if (o === "v" || o === "V") this.curCommandType = Ze.VERT_LINE_TO, this.curCommandRelative = o === "v";
          else if (o === "m" || o === "M") this.curCommandType = Ze.MOVE_TO, this.curCommandRelative = o === "m";
          else if (o === "l" || o === "L") this.curCommandType = Ze.LINE_TO, this.curCommandRelative = o === "l";
          else if (o === "c" || o === "C") this.curCommandType = Ze.CURVE_TO, this.curCommandRelative = o === "c";
          else if (o === "s" || o === "S") this.curCommandType = Ze.SMOOTH_CURVE_TO, this.curCommandRelative = o === "s";
          else if (o === "q" || o === "Q") this.curCommandType = Ze.QUAD_TO, this.curCommandRelative = o === "q";
          else if (o === "t" || o === "T") this.curCommandType = Ze.SMOOTH_QUAD_TO, this.curCommandRelative = o === "t";
          else {
            if (o !== "a" && o !== "A") throw new SyntaxError('Unexpected character "' + o + '" at index ' + s + ".");
            this.curCommandType = Ze.ARC, this.curCommandRelative = o === "a";
          }
          else n.push({ type: Ze.CLOSE_PATH }), this.canParseCommandOrComma = !0, this.curCommandType = -1;
        }
        else this.curNumber = o, this.curNumberHasDecimal = o === ".";
      } else this.curNumber += o, this.curNumberHasDecimal = !0;
      else this.curNumber += o;
      else this.curNumber += o, this.curNumberHasExp = !0;
      else this.curNumber += o, this.curNumberHasExpDigits = this.curNumberHasExp;
    }
    return n;
  }, e.prototype.transform = function(t) {
    return Object.create(this, { parse: { value: function(n, i) {
      i === void 0 && (i = []);
      for (var a = 0, s = Object.getPrototypeOf(this).parse.call(this, n); a < s.length; a++) {
        var o = s[a], l = t(o);
        Array.isArray(l) ? i.push.apply(i, l) : i.push(l);
      }
      return i;
    } } });
  }, e;
})(QI), Ze = (function(r) {
  function e(t) {
    var n = r.call(this) || this;
    return n.commands = typeof t == "string" ? e.parse(t) : t, n;
  }
  return qI(e, r), e.prototype.encode = function() {
    return e.encode(this.commands);
  }, e.prototype.getBounds = function() {
    var t = ia.CALCULATE_BOUNDS();
    return this.transform(t), t;
  }, e.prototype.transform = function(t) {
    for (var n = [], i = 0, a = this.commands; i < a.length; i++) {
      var s = t(a[i]);
      Array.isArray(s) ? n.push.apply(n, s) : n.push(s);
    }
    return this.commands = n, this;
  }, e.encode = function(t) {
    return e7(t);
  }, e.parse = function(t) {
    var n = new r7(), i = [];
    return n.parse(t, i), n.finish(i), i;
  }, e.CLOSE_PATH = 1, e.MOVE_TO = 2, e.HORIZ_LINE_TO = 4, e.VERT_LINE_TO = 8, e.LINE_TO = 16, e.CURVE_TO = 32, e.SMOOTH_CURVE_TO = 64, e.QUAD_TO = 128, e.SMOOTH_QUAD_TO = 256, e.ARC = 512, e.LINE_COMMANDS = e.LINE_TO | e.HORIZ_LINE_TO | e.VERT_LINE_TO, e.DRAWING_COMMANDS = e.HORIZ_LINE_TO | e.VERT_LINE_TO | e.LINE_TO | e.CURVE_TO | e.SMOOTH_CURVE_TO | e.QUAD_TO | e.SMOOTH_QUAD_TO | e.ARC, e;
})(QI), n7 = ((Go = {})[Ze.MOVE_TO] = 2, Go[Ze.LINE_TO] = 2, Go[Ze.HORIZ_LINE_TO] = 1, Go[Ze.VERT_LINE_TO] = 1, Go[Ze.CLOSE_PATH] = 0, Go[Ze.QUAD_TO] = 4, Go[Ze.SMOOTH_QUAD_TO] = 2, Go[Ze.CURVE_TO] = 6, Go[Ze.SMOOTH_CURVE_TO] = 4, Go[Ze.ARC] = 7, Go);
function Wm(r) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Wm = function(e) {
    return typeof e;
  } : Wm = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Wm(r);
}
function i7(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var a7 = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259], s7 = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
function o7(r, e, t, n, i) {
  if (typeof r == "string" && (r = document.getElementById(r)), !r || Wm(r) !== "object" || !("getContext" in r))
    throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
  var a = r.getContext("2d");
  try {
    return a.getImageData(e, t, n, i);
  } catch (s) {
    throw new Error("unable to access image data: " + s);
  }
}
function l7(r, e, t, n, i, a) {
  if (!(isNaN(a) || a < 1)) {
    a |= 0;
    var s = o7(r, e, t, n, i);
    s = u7(s, e, t, n, i, a), r.getContext("2d").putImageData(s, e, t);
  }
}
function u7(r, e, t, n, i, a) {
  for (var s = r.data, o = 2 * a + 1, l = n - 1, u = i - 1, c = a + 1, h = c * (c + 1) / 2, f = new uE(), p = f, m, A = 1; A < o; A++)
    p = p.next = new uE(), A === c && (m = p);
  p.next = f;
  for (var w = null, x = null, E = 0, T = 0, D = a7[a], F = s7[a], _ = 0; _ < i; _++) {
    p = f;
    for (var L = s[T], Z = s[T + 1], te = s[T + 2], de = s[T + 3], H = 0; H < c; H++)
      p.r = L, p.g = Z, p.b = te, p.a = de, p = p.next;
    for (var j = 0, q = 0, re = 0, ae = 0, ye = c * L, Se = c * Z, Xe = c * te, Ve = c * de, He = h * L, le = h * Z, ve = h * te, it = h * de, mt = 1; mt < c; mt++) {
      var qe = T + ((l < mt ? l : mt) << 2), at = s[qe], st = s[qe + 1], lt = s[qe + 2], rt = s[qe + 3], Rt = c - mt;
      He += (p.r = at) * Rt, le += (p.g = st) * Rt, ve += (p.b = lt) * Rt, it += (p.a = rt) * Rt, j += at, q += st, re += lt, ae += rt, p = p.next;
    }
    w = f, x = m;
    for (var Fr = 0; Fr < n; Fr++) {
      var an = it * D >>> F;
      if (s[T + 3] = an, an !== 0) {
        var ar = 255 / an;
        s[T] = (He * D >>> F) * ar, s[T + 1] = (le * D >>> F) * ar, s[T + 2] = (ve * D >>> F) * ar;
      } else
        s[T] = s[T + 1] = s[T + 2] = 0;
      He -= ye, le -= Se, ve -= Xe, it -= Ve, ye -= w.r, Se -= w.g, Xe -= w.b, Ve -= w.a;
      var Ir = Fr + a + 1;
      Ir = E + (Ir < l ? Ir : l) << 2, j += w.r = s[Ir], q += w.g = s[Ir + 1], re += w.b = s[Ir + 2], ae += w.a = s[Ir + 3], He += j, le += q, ve += re, it += ae, w = w.next;
      var kt = x, wt = kt.r, Mn = kt.g, kr = kt.b, Gr = kt.a;
      ye += wt, Se += Mn, Xe += kr, Ve += Gr, j -= wt, q -= Mn, re -= kr, ae -= Gr, x = x.next, T += 4;
    }
    E += n;
  }
  for (var Pr = 0; Pr < n; Pr++) {
    T = Pr << 2;
    var Cr = s[T], qt = s[T + 1], lr = s[T + 2], It = s[T + 3], Zr = c * Cr, Cn = c * qt, Sn = c * lr, vr = c * It, ln = h * Cr, en = h * qt, Fn = h * lr, gn = h * It;
    p = f;
    for (var Gn = 0; Gn < c; Gn++)
      p.r = Cr, p.g = qt, p.b = lr, p.a = It, p = p.next;
    for (var Hn = n, tn = 0, mn = 0, In = 0, vn = 0, fr = 1; fr <= a; fr++) {
      T = Hn + Pr << 2;
      var Or = c - fr;
      ln += (p.r = Cr = s[T]) * Or, en += (p.g = qt = s[T + 1]) * Or, Fn += (p.b = lr = s[T + 2]) * Or, gn += (p.a = It = s[T + 3]) * Or, vn += Cr, tn += qt, mn += lr, In += It, p = p.next, fr < u && (Hn += n);
    }
    T = Pr, w = f, x = m;
    for (var sn = 0; sn < i; sn++) {
      var yt = T << 2;
      s[yt + 3] = It = gn * D >>> F, It > 0 ? (It = 255 / It, s[yt] = (ln * D >>> F) * It, s[yt + 1] = (en * D >>> F) * It, s[yt + 2] = (Fn * D >>> F) * It) : s[yt] = s[yt + 1] = s[yt + 2] = 0, ln -= Zr, en -= Cn, Fn -= Sn, gn -= vr, Zr -= w.r, Cn -= w.g, Sn -= w.b, vr -= w.a, yt = Pr + ((yt = sn + c) < u ? yt : u) * n << 2, ln += vn += w.r = s[yt], en += tn += w.g = s[yt + 1], Fn += mn += w.b = s[yt + 2], gn += In += w.a = s[yt + 3], w = w.next, Zr += Cr = x.r, Cn += qt = x.g, Sn += lr = x.b, vr += It = x.a, vn -= Cr, tn -= qt, mn -= lr, In -= It, x = x.next, T += n;
    }
  }
  return r;
}
var uE = (
  /**
   * Set properties.
   */
  function r() {
    i7(this, r), this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
);
function Pf(r, e, t, n, i, a) {
  return r[t * n * 4 + e * 4 + a];
}
function Df(r, e, t, n, i, a, s) {
  r[t * n * 4 + e * 4 + a] = s;
}
function pg(r) {
  return r.replace(/(?!\u3000)\s+/gm, " ");
}
function ks(r) {
  const e = r.match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm);
  return e ? e.map(parseFloat) : [];
}
function c7(r) {
  const e = ks(r);
  return [
    e[0] || 0,
    e[1] || 0,
    e[2] || 0,
    e[3] || 0,
    e[4] || 0,
    e[5] || 0
  ];
}
const f7 = /^[A-Z-]+$/;
function d7(r) {
  return f7.test(r) ? r.toLowerCase() : r;
}
function YI(r) {
  const e = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(r);
  return e && (e[2] || e[3] || e[4]) || "";
}
function h7(r) {
  if (!r.startsWith("rgb"))
    return r;
  let e = 3;
  return r.replace(
    /\d+(\.\d+)?/g,
    (t, n) => e-- && n ? String(Math.round(parseFloat(t))) : t
  );
}
const p7 = /(\[[^\]]+\])/g, g7 = /(#[^\s+>~.[:]+)/g, m7 = /(\.[^\s+>~.[:]+)/g, v7 = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi, y7 = /(:[\w-]+\([^)]*\))/gi, A7 = /(:[^\s+>~.[:]+)/g, w7 = /([^\s+>~.[:]+)/g;
function Af(r, e) {
  const t = e.exec(r);
  return t ? [r.replace(e, " "), t.length] : [r, 0];
}
function x7(r) {
  const e = [0, 0, 0];
  let t = r.replace(/:not\(([^)]*)\)/g, "     $1 ").replace(/{[\s\S]*/gm, " "), n = 0;
  return [t, n] = Af(t, p7), e[1] += n, [t, n] = Af(t, g7), e[0] += n, [t, n] = Af(t, m7), e[1] += n, [t, n] = Af(t, v7), e[2] += n, [t, n] = Af(t, y7), e[1] += n, [t, n] = Af(t, A7), e[1] += n, t = t.replace(/[*\s+>~]/g, " ").replace(/[#.]/g, " "), [t, n] = Af(t, w7), e[2] += n, e.join("");
}
const Dd = 1e-8;
function cE(r) {
  return Math.sqrt(Math.pow(r[0], 2) + Math.pow(r[1], 2));
}
function k1(r, e) {
  return (r[0] * e[0] + r[1] * e[1]) / (cE(r) * cE(e));
}
function fE(r, e) {
  return (r[0] * e[1] < r[1] * e[0] ? -1 : 1) * Math.acos(k1(r, e));
}
function dE(r) {
  return r * r * r;
}
function hE(r) {
  return 3 * r * r * (1 - r);
}
function pE(r) {
  return 3 * r * (1 - r) * (1 - r);
}
function gE(r) {
  return (1 - r) * (1 - r) * (1 - r);
}
function mE(r) {
  return r * r;
}
function vE(r) {
  return 2 * r * (1 - r);
}
function yE(r) {
  return (1 - r) * (1 - r);
}
const XI = class mp {
  constructor(e, t, n) {
    this.document = e, this.name = t, this.value = n, this.isNormalizedColor = !1;
  }
  static empty(e) {
    return new mp(e, "EMPTY", "");
  }
  split(e = " ") {
    const { document: t, name: n } = this;
    return pg(this.getString()).trim().split(e).map((i) => new mp(t, n, i));
  }
  hasValue(e) {
    const t = this.value;
    return t !== null && t !== "" && (e || t !== 0) && typeof t < "u";
  }
  isString(e) {
    const { value: t } = this, n = typeof t == "string";
    return !n || !e ? n : e.test(t);
  }
  isUrlDefinition() {
    return this.isString(/^url\(/);
  }
  isPixels() {
    if (!this.hasValue())
      return !1;
    const e = this.getString();
    switch (!0) {
      case e.endsWith("px"):
      case /^[0-9]+$/.test(e):
        return !0;
      default:
        return !1;
    }
  }
  setValue(e) {
    return this.value = e, this;
  }
  getValue(e) {
    return typeof e > "u" || this.hasValue() ? this.value : e;
  }
  getNumber(e) {
    if (!this.hasValue())
      return typeof e > "u" ? 0 : parseFloat(e);
    const { value: t } = this;
    let n = parseFloat(t);
    return this.isString(/%$/) && (n /= 100), n;
  }
  getString(e) {
    return typeof e > "u" || this.hasValue() ? typeof this.value > "u" ? "" : String(this.value) : String(e);
  }
  getColor(e) {
    let t = this.getString(e);
    return this.isNormalizedColor || (this.isNormalizedColor = !0, t = h7(t), this.value = t), t;
  }
  getDpi() {
    return 96;
  }
  getRem() {
    return this.document.rootEmSize;
  }
  getEm() {
    return this.document.emSize;
  }
  getUnits() {
    return this.getString().replace(/[0-9.-]/g, "");
  }
  getPixels(e, t = !1) {
    if (!this.hasValue())
      return 0;
    const [n, i] = typeof e == "boolean" ? [void 0, e] : [e], { viewPort: a } = this.document.screen;
    switch (!0) {
      case this.isString(/vmin$/):
        return this.getNumber() / 100 * Math.min(a.computeSize("x"), a.computeSize("y"));
      case this.isString(/vmax$/):
        return this.getNumber() / 100 * Math.max(a.computeSize("x"), a.computeSize("y"));
      case this.isString(/vw$/):
        return this.getNumber() / 100 * a.computeSize("x");
      case this.isString(/vh$/):
        return this.getNumber() / 100 * a.computeSize("y");
      case this.isString(/rem$/):
        return this.getNumber() * this.getRem(
          /* viewPort */
        );
      case this.isString(/em$/):
        return this.getNumber() * this.getEm(
          /* viewPort */
        );
      case this.isString(/ex$/):
        return this.getNumber() * this.getEm(
          /* viewPort */
        ) / 2;
      case this.isString(/px$/):
        return this.getNumber();
      case this.isString(/pt$/):
        return this.getNumber() * this.getDpi(
          /* viewPort */
        ) * (1 / 72);
      case this.isString(/pc$/):
        return this.getNumber() * 15;
      case this.isString(/cm$/):
        return this.getNumber() * this.getDpi(
          /* viewPort */
        ) / 2.54;
      case this.isString(/mm$/):
        return this.getNumber() * this.getDpi(
          /* viewPort */
        ) / 25.4;
      case this.isString(/in$/):
        return this.getNumber() * this.getDpi(
          /* viewPort */
        );
      case (this.isString(/%$/) && i):
        return this.getNumber() * this.getEm(
          /* viewPort */
        );
      case this.isString(/%$/):
        return this.getNumber() * a.computeSize(n);
      default: {
        const s = this.getNumber();
        return t && s < 1 ? s * a.computeSize(n) : s;
      }
    }
  }
  getMilliseconds() {
    return this.hasValue() ? this.isString(/ms$/) ? this.getNumber() : this.getNumber() * 1e3 : 0;
  }
  getRadians() {
    if (!this.hasValue())
      return 0;
    switch (!0) {
      case this.isString(/deg$/):
        return this.getNumber() * (Math.PI / 180);
      case this.isString(/grad$/):
        return this.getNumber() * (Math.PI / 200);
      case this.isString(/rad$/):
        return this.getNumber();
      default:
        return this.getNumber() * (Math.PI / 180);
    }
  }
  getDefinition() {
    const e = this.getString(), t = /#([^)'"]+)/.exec(e)?.[1] || e;
    return this.document.definitions[t];
  }
  getFillStyleDefinition(e, t) {
    let n = this.getDefinition();
    if (!n)
      return null;
    if (typeof n.createGradient == "function" && "getBoundingBox" in e)
      return n.createGradient(this.document.ctx, e, t);
    if (typeof n.createPattern == "function") {
      if (n.getHrefAttribute().hasValue()) {
        const i = n.getAttribute("patternTransform");
        n = n.getHrefAttribute().getDefinition(), n && i.hasValue() && n.getAttribute("patternTransform", !0).setValue(i.value);
      }
      if (n)
        return n.createPattern(this.document.ctx, e, t);
    }
    return null;
  }
  getTextBaseline() {
    if (!this.hasValue())
      return null;
    const e = this.getString();
    return mp.textBaselineMapping[e] || null;
  }
  addOpacity(e) {
    let t = this.getColor();
    const n = t.length;
    let i = 0;
    for (let a = 0; a < n && (t[a] === "," && i++, i !== 3); a++)
      ;
    if (e.hasValue() && this.isString() && i !== 3) {
      const a = new S1(t);
      a.ok && (a.alpha = e.getNumber(), t = a.toRGBA());
    }
    return new mp(this.document, this.name, t);
  }
};
XI.textBaselineMapping = {
  baseline: "alphabetic",
  "before-edge": "top",
  "text-before-edge": "top",
  middle: "middle",
  central: "middle",
  "after-edge": "bottom",
  "text-after-edge": "bottom",
  ideographic: "ideographic",
  alphabetic: "alphabetic",
  hanging: "hanging",
  mathematical: "alphabetic"
};
let wr = XI;
const T1 = class {
  constructor() {
    this.viewPorts = [];
  }
  clear() {
    this.viewPorts = [];
  }
  setCurrent(e, t) {
    this.viewPorts.push({
      width: e,
      height: t
    });
  }
  removeCurrent() {
    this.viewPorts.pop();
  }
  getRoot() {
    const [e] = this.viewPorts;
    return e || AE();
  }
  getCurrent() {
    const { viewPorts: e } = this;
    return e[e.length - 1] || AE();
  }
  get width() {
    return this.getCurrent().width;
  }
  get height() {
    return this.getCurrent().height;
  }
  computeSize(e) {
    return typeof e == "number" ? e : e === "x" ? this.width : e === "y" ? this.height : Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
  }
};
T1.DEFAULT_VIEWPORT_WIDTH = 800, T1.DEFAULT_VIEWPORT_HEIGHT = 600;
let F1 = T1;
function AE() {
  return {
    width: F1.DEFAULT_VIEWPORT_WIDTH,
    height: F1.DEFAULT_VIEWPORT_HEIGHT
  };
}
class Fi {
  constructor(e, t) {
    this.x = e, this.y = t;
  }
  static parse(e, t = 0) {
    const [n = t, i = t] = ks(e);
    return new Fi(n, i);
  }
  static parseScale(e, t = 1) {
    const [n = t, i = n] = ks(e);
    return new Fi(n, i);
  }
  static parsePath(e) {
    const t = ks(e), n = t.length, i = [];
    for (let a = 0; a < n; a += 2)
      i.push(new Fi(t[a], t[a + 1]));
    return i;
  }
  angleTo(e) {
    return Math.atan2(e.y - this.y, e.x - this.x);
  }
  applyTransform(e) {
    const { x: t, y: n } = this, i = t * e[0] + n * e[2] + e[4], a = t * e[1] + n * e[3] + e[5];
    this.x = i, this.y = a;
  }
}
class b7 {
  constructor(e) {
    this.screen = e, this.working = !1, this.events = [], this.eventElements = [], this.onClick = this.onClick.bind(this), this.onMouseMove = this.onMouseMove.bind(this);
  }
  isWorking() {
    return this.working;
  }
  start() {
    if (this.working)
      return;
    const { screen: e, onClick: t, onMouseMove: n } = this, i = e.ctx.canvas;
    i.onclick = t, i.onmousemove = n, this.working = !0;
  }
  stop() {
    if (!this.working)
      return;
    const e = this.screen.ctx.canvas;
    this.working = !1, e.onclick = null, e.onmousemove = null;
  }
  hasEvents() {
    return this.working && this.events.length > 0;
  }
  runEvents() {
    if (!this.working)
      return;
    const { screen: e, events: t, eventElements: n } = this, { style: i } = e.ctx.canvas;
    let a;
    i && (i.cursor = ""), t.forEach(({ run: s }, o) => {
      for (a = n[o]; a; )
        s(a), a = a.parent;
    }), this.events = [], this.eventElements = [];
  }
  checkPath(e, t) {
    if (!this.working || !t)
      return;
    const { events: n, eventElements: i } = this;
    n.forEach(({ x: a, y: s }, o) => {
      !i[o] && t.isPointInPath && t.isPointInPath(a, s) && (i[o] = e);
    });
  }
  checkBoundingBox(e, t) {
    if (!this.working || !t)
      return;
    const { events: n, eventElements: i } = this;
    n.forEach(({ x: a, y: s }, o) => {
      !i[o] && t.isPointInBox(a, s) && (i[o] = e);
    });
  }
  mapXY(e, t) {
    const { window: n, ctx: i } = this.screen, a = new Fi(e, t);
    let s = i.canvas;
    for (; s; )
      a.x -= s.offsetLeft, a.y -= s.offsetTop, s = s.offsetParent;
    return n?.scrollX && (a.x += n.scrollX), n?.scrollY && (a.y += n.scrollY), a;
  }
  onClick(e) {
    const { x: t, y: n } = this.mapXY(e.clientX, e.clientY);
    this.events.push({
      type: "onclick",
      x: t,
      y: n,
      run(i) {
        i.onClick && i.onClick();
      }
    });
  }
  onMouseMove(e) {
    const { x: t, y: n } = this.mapXY(e.clientX, e.clientY);
    this.events.push({
      type: "onmousemove",
      x: t,
      y: n,
      run(i) {
        i.onMouseMove && i.onMouseMove();
      }
    });
  }
}
const JI = typeof window < "u" ? window : null, KI = typeof fetch < "u" ? fetch.bind(void 0) : void 0, vp = class ZI {
  constructor(e, { fetch: t = KI, window: n = JI } = {}) {
    if (this.ctx = e, this.viewPort = new F1(), this.mouse = new b7(this), this.animations = [], this.waits = [], this.frameDuration = 0, this.isReadyLock = !1, this.isFirstRender = !0, this.intervalId = null, this.window = n, !t)
      throw new Error("Can't find 'fetch' in 'globalThis', please provide it via options");
    this.fetch = t;
  }
  wait(e) {
    this.waits.push(e);
  }
  ready() {
    return this.readyPromise ? this.readyPromise : Promise.resolve();
  }
  isReady() {
    if (this.isReadyLock)
      return !0;
    const e = this.waits.every((t) => t());
    return e && (this.waits = [], this.resolveReady && this.resolveReady()), this.isReadyLock = e, e;
  }
  setDefaults(e) {
    e.strokeStyle = "rgba(0,0,0,0)", e.lineCap = "butt", e.lineJoin = "miter", e.miterLimit = 4;
  }
  setViewBox({
    document: e,
    ctx: t,
    aspectRatio: n,
    width: i,
    desiredWidth: a,
    height: s,
    desiredHeight: o,
    minX: l = 0,
    minY: u = 0,
    refX: c,
    refY: h,
    clip: f = !1,
    clipX: p = 0,
    clipY: m = 0
  }) {
    const A = pg(n).replace(/^defer\s/, ""), [w, x] = A.split(" "), E = w || "xMidYMid", T = x || "meet", D = i / a, F = s / o, _ = Math.min(D, F), L = Math.max(D, F);
    let Z = a, te = o;
    T === "meet" && (Z *= _, te *= _), T === "slice" && (Z *= L, te *= L);
    const de = new wr(e, "refX", c), H = new wr(e, "refY", h), j = de.hasValue() && H.hasValue();
    if (j && t.translate(-_ * de.getPixels("x"), -_ * H.getPixels("y")), f) {
      const q = _ * p, re = _ * m;
      t.beginPath(), t.moveTo(q, re), t.lineTo(i, re), t.lineTo(i, s), t.lineTo(q, s), t.closePath(), t.clip();
    }
    if (!j) {
      const q = T === "meet" && _ === F, re = T === "slice" && L === F, ae = T === "meet" && _ === D, ye = T === "slice" && L === D;
      E.startsWith("xMid") && (q || re) && t.translate(i / 2 - Z / 2, 0), E.endsWith("YMid") && (ae || ye) && t.translate(0, s / 2 - te / 2), E.startsWith("xMax") && (q || re) && t.translate(i - Z, 0), E.endsWith("YMax") && (ae || ye) && t.translate(0, s - te);
    }
    switch (!0) {
      case E === "none":
        t.scale(D, F);
        break;
      case T === "meet":
        t.scale(_, _);
        break;
      case T === "slice":
        t.scale(L, L);
        break;
    }
    t.translate(-l, -u);
  }
  start(e, {
    enableRedraw: t = !1,
    ignoreMouse: n = !1,
    ignoreAnimation: i = !1,
    ignoreDimensions: a = !1,
    ignoreClear: s = !1,
    forceRedraw: o,
    scaleWidth: l,
    scaleHeight: u,
    offsetX: c,
    offsetY: h
  } = {}) {
    const { mouse: f } = this, p = 1e3 / ZI.FRAMERATE;
    if (this.isReadyLock = !1, this.frameDuration = p, this.readyPromise = new Promise((E) => {
      this.resolveReady = E;
    }), this.isReady() && this.render(e, a, s, l, u, c, h), !t)
      return;
    let m = Date.now(), A = m, w = 0;
    const x = () => {
      m = Date.now(), w = m - A, w >= p && (A = m - w % p, this.shouldUpdate(i, o) && (this.render(e, a, s, l, u, c, h), f.runEvents())), this.intervalId = ey(x);
    };
    n || f.start(), this.intervalId = ey(x);
  }
  stop() {
    this.intervalId && (ey.cancel(this.intervalId), this.intervalId = null), this.mouse.stop();
  }
  shouldUpdate(e, t) {
    if (!e) {
      const { frameDuration: n } = this;
      if (this.animations.reduce(
        (i, a) => a.update(n) || i,
        !1
      ))
        return !0;
    }
    return !!(typeof t == "function" && t() || !this.isReadyLock && this.isReady() || this.mouse.hasEvents());
  }
  render(e, t, n, i, a, s, o) {
    const { viewPort: l, ctx: u, isFirstRender: c } = this, h = u.canvas;
    l.clear(), h.width && h.height && l.setCurrent(h.width, h.height);
    const f = e.getStyle("width"), p = e.getStyle("height");
    !t && (c || typeof i != "number" && typeof a != "number") && (f.hasValue() && (h.width = f.getPixels("x"), h.style && (h.style.width = `${h.width}px`)), p.hasValue() && (h.height = p.getPixels("y"), h.style && (h.style.height = `${h.height}px`)));
    let m = h.clientWidth || h.width, A = h.clientHeight || h.height;
    if (t && f.hasValue() && p.hasValue() && (m = f.getPixels("x"), A = p.getPixels("y")), l.setCurrent(m, A), typeof s == "number" && e.getAttribute("x", !0).setValue(s), typeof o == "number" && e.getAttribute("y", !0).setValue(o), typeof i == "number" || typeof a == "number") {
      const w = ks(e.getAttribute("viewBox").getString());
      let x = 0, E = 0;
      if (typeof i == "number") {
        const D = e.getStyle("width");
        D.hasValue() ? x = D.getPixels("x") / i : w[2] && !isNaN(w[2]) && (x = w[2] / i);
      }
      if (typeof a == "number") {
        const D = e.getStyle("height");
        D.hasValue() ? E = D.getPixels("y") / a : w[3] && !isNaN(w[3]) && (E = w[3] / a);
      }
      x || (x = E), E || (E = x), e.getAttribute("width", !0).setValue(i), e.getAttribute("height", !0).setValue(a);
      const T = e.getStyle("transform", !0, !0);
      T.setValue(`${T.getString()} scale(${1 / x}, ${1 / E})`);
    }
    n || u.clearRect(0, 0, m, A), e.render(u), c && (this.isFirstRender = !1);
  }
};
vp.defaultWindow = JI, vp.defaultFetch = KI, vp.FRAMERATE = 30, vp.MAX_VIRTUAL_PIXELS = 3e4;
let zw = vp;
const { defaultFetch: C7 } = zw, S7 = typeof DOMParser < "u" ? DOMParser : void 0;
class ny {
  constructor({ fetch: e = C7, DOMParser: t = S7 } = {}) {
    if (!e)
      throw new Error("Can't find 'fetch' in 'globalThis', please provide it via options");
    if (!t)
      throw new Error("Can't find 'DOMParser' in 'globalThis', please provide it via options");
    this.fetch = e, this.DOMParser = t;
  }
  async parse(e) {
    return e.startsWith("<") ? this.parseFromString(e) : this.load(e);
  }
  parseFromString(e) {
    const t = new this.DOMParser();
    try {
      return this.checkDocument(t.parseFromString(e, "image/svg+xml"));
    } catch {
      return this.checkDocument(t.parseFromString(e, "text/xml"));
    }
  }
  checkDocument(e) {
    const t = e.getElementsByTagName("parsererror")[0];
    if (t)
      throw new Error(t.textContent || "Unknown parse error");
    return e;
  }
  async load(e) {
    const t = await (await this.fetch(e)).text();
    return this.parseFromString(t);
  }
}
class E7 {
  constructor(e, t) {
    this.type = "translate", this.point = Fi.parse(t);
  }
  apply(e) {
    const { x: t, y: n } = this.point;
    e.translate(t || 0, n || 0);
  }
  unapply(e) {
    const { x: t, y: n } = this.point;
    e.translate(-1 * t || 0, -1 * n || 0);
  }
  applyToPoint(e) {
    const { x: t, y: n } = this.point;
    e.applyTransform([1, 0, 0, 1, t || 0, n || 0]);
  }
}
class k7 {
  constructor(e, t, n) {
    this.type = "rotate";
    const i = ks(t);
    this.angle = new wr(e, "angle", i[0]), this.originX = n[0], this.originY = n[1], this.cx = i[1] || 0, this.cy = i[2] || 0;
  }
  apply(e) {
    const { cx: t, cy: n, originX: i, originY: a, angle: s } = this, o = t + i.getPixels("x"), l = n + a.getPixels("y");
    e.translate(o, l), e.rotate(s.getRadians()), e.translate(-o, -l);
  }
  unapply(e) {
    const { cx: t, cy: n, originX: i, originY: a, angle: s } = this, o = t + i.getPixels("x"), l = n + a.getPixels("y");
    e.translate(o, l), e.rotate(-1 * s.getRadians()), e.translate(-o, -l);
  }
  applyToPoint(e) {
    const { cx: t, cy: n, angle: i } = this, a = i.getRadians();
    e.applyTransform([
      1,
      0,
      0,
      1,
      t || 0,
      // this.p.x
      n || 0
      // this.p.y
    ]), e.applyTransform([Math.cos(a), Math.sin(a), -Math.sin(a), Math.cos(a), 0, 0]), e.applyTransform([
      1,
      0,
      0,
      1,
      -t || 0,
      // -this.p.x
      -n || 0
      // -this.p.y
    ]);
  }
}
class T7 {
  constructor(e, t, n) {
    this.type = "scale";
    const i = Fi.parseScale(t);
    (i.x === 0 || i.y === 0) && (i.x = Dd, i.y = Dd), this.scale = i, this.originX = n[0], this.originY = n[1];
  }
  apply(e) {
    const {
      scale: { x: t, y: n },
      originX: i,
      originY: a
    } = this, s = i.getPixels("x"), o = a.getPixels("y");
    e.translate(s, o), e.scale(t, n || t), e.translate(-s, -o);
  }
  unapply(e) {
    const {
      scale: { x: t, y: n },
      originX: i,
      originY: a
    } = this, s = i.getPixels("x"), o = a.getPixels("y");
    e.translate(s, o), e.scale(1 / t, 1 / n || t), e.translate(-s, -o);
  }
  applyToPoint(e) {
    const { x: t, y: n } = this.scale;
    e.applyTransform([t || 0, 0, 0, n || 0, 0, 0]);
  }
}
class eP {
  constructor(e, t, n) {
    this.type = "matrix", this.matrix = c7(t), this.originX = n[0], this.originY = n[1];
  }
  apply(e) {
    const { originX: t, originY: n, matrix: i } = this, a = t.getPixels("x"), s = n.getPixels("y");
    e.translate(a, s), e.transform(i[0], i[1], i[2], i[3], i[4], i[5]), e.translate(-a, -s);
  }
  unapply(e) {
    const { originX: t, originY: n, matrix: i } = this, a = i[0], s = i[2], o = i[4], l = i[1], u = i[3], c = i[5], h = 0, f = 0, p = 1, m = 1 / (a * (u * p - c * f) - s * (l * p - c * h) + o * (l * f - u * h)), A = t.getPixels("x"), w = n.getPixels("y");
    e.translate(A, w), e.transform(
      m * (u * p - c * f),
      m * (c * h - l * p),
      m * (o * f - s * p),
      m * (a * p - o * h),
      m * (s * c - o * u),
      m * (o * l - a * c)
    ), e.translate(-A, -w);
  }
  applyToPoint(e) {
    e.applyTransform(this.matrix);
  }
}
class tP extends eP {
  constructor(e, t, n) {
    super(e, t, n), this.type = "skew", this.angle = new wr(e, "angle", t);
  }
}
class F7 extends tP {
  constructor(e, t, n) {
    super(e, t, n), this.type = "skewX", this.matrix = [1, 0, Math.tan(this.angle.getRadians()), 1, 0, 0];
  }
}
class I7 extends tP {
  constructor(e, t, n) {
    super(e, t, n), this.type = "skewY", this.matrix = [1, Math.tan(this.angle.getRadians()), 0, 1, 0, 0];
  }
}
function P7(r) {
  return pg(r).trim().replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/);
}
function D7(r) {
  const [e = "", t = ""] = r.split("(");
  return [e.trim(), t.trim().replace(")", "")];
}
const rP = class I1 {
  constructor(e, t, n) {
    this.document = e, this.transforms = [], P7(t).forEach((i) => {
      if (i === "none")
        return;
      const [a, s] = D7(i), o = I1.transformTypes[a];
      o && this.transforms.push(new o(this.document, s, n));
    });
  }
  static fromElement(e, t) {
    const n = t.getStyle("transform", !1, !0);
    if (n.hasValue()) {
      const [i, a = i] = t.getStyle("transform-origin", !1, !0).split();
      if (i && a) {
        const s = [i, a];
        return new I1(e, n.getString(), s);
      }
    }
    return null;
  }
  apply(e) {
    this.transforms.forEach((t) => t.apply(e));
  }
  unapply(e) {
    this.transforms.forEach((t) => t.unapply(e));
  }
  // TODO: applyToPoint unused ... remove?
  applyToPoint(e) {
    this.transforms.forEach((t) => t.applyToPoint(e));
  }
};
rP.transformTypes = {
  translate: E7,
  rotate: k7,
  scale: T7,
  matrix: eP,
  skewX: F7,
  skewY: I7
};
let Gw = rP;
const nP = class P1 {
  constructor(e, t, n = !1) {
    if (this.document = e, this.node = t, this.captureTextNodes = n, this.type = "", this.attributes = {}, this.styles = {}, this.stylesSpecificity = {}, this.animationFrozen = !1, this.animationFrozenValue = "", this.parent = null, this.children = [], !t || t.nodeType !== 1)
      return;
    Array.from(t.attributes).forEach((s) => {
      const o = d7(s.nodeName);
      this.attributes[o] = new wr(e, o, s.value);
    }), this.addStylesFromStyleDefinition(), this.getAttribute("style").hasValue() && this.getAttribute("style").getString().split(";").map((s) => s.trim()).forEach((s) => {
      if (!s)
        return;
      const [o, l] = s.split(":").map((u) => u.trim());
      o && (this.styles[o] = new wr(e, o, l));
    });
    const { definitions: i } = e, a = this.getAttribute("id");
    a.hasValue() && (i[a.getString()] || (i[a.getString()] = this)), Array.from(t.childNodes).forEach((s) => {
      if (s.nodeType === 1)
        this.addChild(s);
      else if (n && (s.nodeType === 3 || s.nodeType === 4)) {
        const o = e.createTextNode(s);
        o.getText().length > 0 && this.addChild(o);
      }
    });
  }
  getAttribute(e, t = !1) {
    const n = this.attributes[e];
    if (!n && t) {
      const i = new wr(this.document, e, "");
      return this.attributes[e] = i, i;
    }
    return n || wr.empty(this.document);
  }
  getHrefAttribute() {
    let e;
    for (const t in this.attributes)
      if (t === "href" || t.endsWith(":href")) {
        e = this.attributes[t];
        break;
      }
    return e || wr.empty(this.document);
  }
  getStyle(e, t = !1, n = !1) {
    const i = this.styles[e];
    if (i)
      return i;
    const a = this.getAttribute(e);
    if (a.hasValue())
      return this.styles[e] = a, a;
    if (!n) {
      const { parent: s } = this;
      if (s) {
        const o = s.getStyle(e);
        if (o.hasValue())
          return o;
      }
    }
    if (t) {
      const s = new wr(this.document, e, "");
      return this.styles[e] = s, s;
    }
    return wr.empty(this.document);
  }
  render(e) {
    if (!(this.getStyle("display").getString() === "none" || this.getStyle("visibility").getString() === "hidden")) {
      if (e.save(), this.getStyle("mask").hasValue()) {
        const t = this.getStyle("mask").getDefinition();
        t && (this.applyEffects(e), t.apply(e, this));
      } else if (this.getStyle("filter").getValue("none") !== "none") {
        const t = this.getStyle("filter").getDefinition();
        t && (this.applyEffects(e), t.apply(e, this));
      } else
        this.setContext(e), this.renderChildren(e), this.clearContext(e);
      e.restore();
    }
  }
  setContext(e) {
  }
  applyEffects(e) {
    const t = Gw.fromElement(this.document, this);
    t && t.apply(e);
    const n = this.getStyle("clip-path", !1, !0);
    if (n.hasValue()) {
      const i = n.getDefinition();
      i && i.apply(e);
    }
  }
  clearContext(e) {
  }
  renderChildren(e) {
    this.children.forEach((t) => {
      t.render(e);
    });
  }
  addChild(e) {
    const t = e instanceof P1 ? e : this.document.createElement(e);
    t.parent = this, P1.ignoreChildTypes.includes(t.type) || this.children.push(t);
  }
  matchesSelector(e) {
    const { node: t } = this;
    if (!t)
      return !1;
    if (typeof t.matches == "function")
      return t.matches(e);
    const n = t.getAttribute?.("class");
    return !n || n === "" ? !1 : n.split(" ").some((i) => `.${i}` === e);
  }
  addStylesFromStyleDefinition() {
    const { styles: e, stylesSpecificity: t } = this.document;
    let n;
    for (const i in e)
      if (!i.startsWith("@") && this.matchesSelector(i)) {
        const a = e[i], s = t[i];
        if (a)
          for (const o in a) {
            let l = this.stylesSpecificity[o];
            typeof l > "u" && (l = "000"), s && s >= l && (n = a[o], n && (this.styles[o] = n), this.stylesSpecificity[o] = s);
          }
      }
  }
  removeStyles(e, t) {
    return t.reduce((n, i) => {
      const a = e.getStyle(i);
      if (!a.hasValue())
        return n;
      const s = a.getString();
      return a.setValue(""), [...n, [i, s]];
    }, []);
  }
  restoreStyles(e, t) {
    t.forEach(([n, i]) => {
      e.getStyle(n, !0).setValue(i);
    });
  }
  isFirstChild() {
    return this.parent?.children.indexOf(this) === 0;
  }
};
nP.ignoreChildTypes = ["title"];
let Ea = nP;
class zf extends Ea {
}
class R7 extends Ea {
  constructor(e, t, n) {
    super(e, t, n);
  }
}
function O7(r) {
  const e = r.trim();
  return /^('|")/.test(e) ? e : `"${e}"`;
}
function B7(r) {
  return typeof process > "u" ? r : r.trim().split(",").map(O7).join(",");
}
function _7(r) {
  if (!r)
    return "";
  const e = r.trim().toLowerCase();
  switch (e) {
    case "normal":
    case "italic":
    case "oblique":
    case "inherit":
    case "initial":
    case "unset":
      return e;
    default:
      return /^oblique\s+(-|)\d+deg$/.test(e) ? e : "";
  }
}
function M7(r) {
  if (!r)
    return "";
  const e = r.trim().toLowerCase();
  switch (e) {
    case "normal":
    case "bold":
    case "lighter":
    case "bolder":
    case "inherit":
    case "initial":
    case "unset":
      return e;
    default:
      return /^[\d.]+$/.test(e) ? e : "";
  }
}
const jm = class wd {
  static parse(e = "", t) {
    let n = "", i = "", a = "", s = "", o = "";
    const l = pg(e).trim().split(" "), u = {
      fontSize: !1,
      fontStyle: !1,
      fontWeight: !1,
      fontVariant: !1
    };
    return l.forEach((c) => {
      switch (!0) {
        case (!u.fontStyle && wd.styles.includes(c)):
          c !== "inherit" && (n = c), u.fontStyle = !0;
          break;
        case (!u.fontVariant && wd.variants.includes(c)):
          c !== "inherit" && (i = c), u.fontStyle = !0, u.fontVariant = !0;
          break;
        case (!u.fontWeight && wd.weights.includes(c)):
          c !== "inherit" && (a = c), u.fontStyle = !0, u.fontVariant = !0, u.fontWeight = !0;
          break;
        case !u.fontSize:
          c !== "inherit" && (s = c.split("/")[0] || ""), u.fontStyle = !0, u.fontVariant = !0, u.fontWeight = !0, u.fontSize = !0;
          break;
        default:
          c !== "inherit" && (o += c);
      }
    }), new wd(n, i, a, s, o, t);
  }
  constructor(e, t, n, i, a, s) {
    const o = s ? typeof s == "string" ? wd.parse(s) : s : {};
    this.fontFamily = a || o.fontFamily, this.fontSize = i || o.fontSize, this.fontStyle = e || o.fontStyle, this.fontWeight = n || o.fontWeight, this.fontVariant = t || o.fontVariant;
  }
  toString() {
    return [
      _7(this.fontStyle),
      this.fontVariant,
      M7(this.fontWeight),
      this.fontSize,
      // Wrap fontFamily only on nodejs and only for canvas.ctx
      B7(this.fontFamily)
    ].join(" ").trim();
  }
};
jm.styles = "normal|italic|oblique|inherit", jm.variants = "normal|small-caps|inherit", jm.weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit";
let zd = jm, Zo = class {
  constructor(e = Number.NaN, t = Number.NaN, n = Number.NaN, i = Number.NaN) {
    this.x1 = e, this.y1 = t, this.x2 = n, this.y2 = i, this.addPoint(e, t), this.addPoint(n, i);
  }
  get x() {
    return this.x1;
  }
  get y() {
    return this.y1;
  }
  get width() {
    return this.x2 - this.x1;
  }
  get height() {
    return this.y2 - this.y1;
  }
  addPoint(e, t) {
    typeof e < "u" && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = e, this.x2 = e), e < this.x1 && (this.x1 = e), e > this.x2 && (this.x2 = e)), typeof t < "u" && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = t, this.y2 = t), t < this.y1 && (this.y1 = t), t > this.y2 && (this.y2 = t));
  }
  addX(e) {
    this.addPoint(e, 0);
  }
  addY(e) {
    this.addPoint(0, e);
  }
  addBoundingBox(e) {
    if (!e)
      return;
    const { x1: t, y1: n, x2: i, y2: a } = e;
    this.addPoint(t, n), this.addPoint(i, a);
  }
  sumCubic(e, t, n, i, a) {
    return Math.pow(1 - e, 3) * t + 3 * Math.pow(1 - e, 2) * e * n + 3 * (1 - e) * Math.pow(e, 2) * i + Math.pow(e, 3) * a;
  }
  bezierCurveAdd(e, t, n, i, a) {
    const s = 6 * t - 12 * n + 6 * i, o = -3 * t + 9 * n - 9 * i + 3 * a, l = 3 * n - 3 * t;
    if (o === 0) {
      if (s === 0)
        return;
      const f = -l / s;
      0 < f && f < 1 && (e ? this.addX(this.sumCubic(f, t, n, i, a)) : this.addY(this.sumCubic(f, t, n, i, a)));
      return;
    }
    const u = Math.pow(s, 2) - 4 * l * o;
    if (u < 0)
      return;
    const c = (-s + Math.sqrt(u)) / (2 * o);
    0 < c && c < 1 && (e ? this.addX(this.sumCubic(c, t, n, i, a)) : this.addY(this.sumCubic(c, t, n, i, a)));
    const h = (-s - Math.sqrt(u)) / (2 * o);
    0 < h && h < 1 && (e ? this.addX(this.sumCubic(h, t, n, i, a)) : this.addY(this.sumCubic(h, t, n, i, a)));
  }
  // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
  addBezierCurve(e, t, n, i, a, s, o, l) {
    this.addPoint(e, t), this.addPoint(o, l), this.bezierCurveAdd(!0, e, n, a, o), this.bezierCurveAdd(!1, t, i, s, l);
  }
  addQuadraticCurve(e, t, n, i, a, s) {
    const o = e + 0.6666666666666666 * (n - e), l = t + 2 / 3 * (i - t), u = o + 1 / 3 * (a - e), c = l + 1 / 3 * (s - t);
    this.addBezierCurve(e, t, o, u, l, c, a, s);
  }
  isPointInBox(e, t) {
    const { x1: n, y1: i, x2: a, y2: s } = this;
    return n <= e && e <= a && i <= t && t <= s;
  }
};
class Gf extends Ea {
  constructor() {
    super(...arguments), this.modifiedEmSizeStack = !1;
  }
  calculateOpacity() {
    let e = 1, t = this;
    for (; t; ) {
      const n = t.getStyle("opacity", !1, !0);
      n.hasValue(!0) && (e *= n.getNumber()), t = t.parent;
    }
    return e;
  }
  setContext(e, t = !1) {
    if (!t) {
      const n = this.getStyle("fill"), i = this.getStyle("fill-opacity"), a = this.getStyle("stroke"), s = this.getStyle("stroke-opacity");
      if (n.isUrlDefinition()) {
        const p = n.getFillStyleDefinition(this, i);
        p && (e.fillStyle = p);
      } else if (n.hasValue()) {
        n.getString() === "currentColor" && n.setValue(this.getStyle("color").getColor());
        const p = n.getColor();
        p !== "inherit" && (e.fillStyle = p === "none" ? "rgba(0,0,0,0)" : p);
      }
      if (i.hasValue()) {
        const p = new wr(this.document, "fill", e.fillStyle).addOpacity(i).getColor();
        e.fillStyle = p;
      }
      if (a.isUrlDefinition()) {
        const p = a.getFillStyleDefinition(this, s);
        p && (e.strokeStyle = p);
      } else if (a.hasValue()) {
        a.getString() === "currentColor" && a.setValue(this.getStyle("color").getColor());
        const p = a.getString();
        p !== "inherit" && (e.strokeStyle = p === "none" ? "rgba(0,0,0,0)" : p);
      }
      if (s.hasValue()) {
        const p = new wr(this.document, "stroke", e.strokeStyle).addOpacity(s).getString();
        e.strokeStyle = p;
      }
      const o = this.getStyle("stroke-width");
      if (o.hasValue()) {
        const p = o.getPixels();
        e.lineWidth = p || Dd;
      }
      const l = this.getStyle("stroke-linecap"), u = this.getStyle("stroke-linejoin"), c = this.getStyle("stroke-miterlimit"), h = this.getStyle("stroke-dasharray"), f = this.getStyle("stroke-dashoffset");
      if (l.hasValue() && (e.lineCap = l.getString()), u.hasValue() && (e.lineJoin = u.getString()), c.hasValue() && (e.miterLimit = c.getNumber()), h.hasValue() && h.getString() !== "none") {
        const p = ks(h.getString());
        typeof e.setLineDash < "u" ? e.setLineDash(p) : typeof e.webkitLineDash < "u" ? e.webkitLineDash = p : typeof e.mozDash < "u" && !(p.length === 1 && p[0] === 0) && (e.mozDash = p);
        const m = f.getPixels();
        typeof e.lineDashOffset < "u" ? e.lineDashOffset = m : typeof e.webkitLineDashOffset < "u" ? e.webkitLineDashOffset = m : typeof e.mozDashOffset < "u" && (e.mozDashOffset = m);
      }
    }
    if (this.modifiedEmSizeStack = !1, typeof e.font < "u") {
      const n = this.getStyle("font"), i = this.getStyle("font-style"), a = this.getStyle("font-variant"), s = this.getStyle("font-weight"), o = this.getStyle("font-size"), l = this.getStyle("font-family"), u = new zd(
        i.getString(),
        a.getString(),
        s.getString(),
        o.hasValue() ? `${o.getPixels(!0)}px` : "",
        l.getString(),
        zd.parse(n.getString(), e.font)
      );
      i.setValue(u.fontStyle), a.setValue(u.fontVariant), s.setValue(u.fontWeight), o.setValue(u.fontSize), l.setValue(u.fontFamily), e.font = u.toString(), o.isPixels() && (this.document.emSize = o.getPixels(), this.modifiedEmSizeStack = !0);
    }
    t || (this.applyEffects(e), e.globalAlpha = this.calculateOpacity());
  }
  clearContext(e) {
    super.clearContext(e), this.modifiedEmSizeStack && this.document.popEmSize();
  }
}
class Rc extends Gf {
  constructor(e, t, n) {
    super(e, t, new.target === Rc ? !0 : n), this.type = "text", this.x = 0, this.y = 0, this.leafTexts = [], this.textChunkStart = 0, this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY, this.measureCache = -1;
  }
  setContext(e, t = !1) {
    super.setContext(e, t);
    const n = this.getStyle("dominant-baseline").getTextBaseline() || this.getStyle("alignment-baseline").getTextBaseline();
    n && (e.textBaseline = n);
  }
  initializeCoordinates() {
    this.x = 0, this.y = 0, this.leafTexts = [], this.textChunkStart = 0, this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY;
  }
  getBoundingBox(e) {
    if (this.type !== "text")
      return this.getTElementBoundingBox(e);
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(e);
    let t = null;
    return this.children.forEach((n, i) => {
      const a = this.getChildBoundingBox(e, this, this, i);
      t ? t.addBoundingBox(a) : t = a;
    }), t;
  }
  getFontSize() {
    const { document: e, parent: t } = this, n = zd.parse(e.ctx.font).fontSize;
    return t.getStyle("font-size").getNumber(n);
  }
  getTElementBoundingBox(e) {
    const t = this.getFontSize();
    return new Zo(this.x, this.y - t, this.x + this.measureText(e), this.y);
  }
  getGlyph(e, t, n) {
    const i = t[n];
    let a;
    if (e.isArabic) {
      const s = t.length, o = t[n - 1], l = t[n + 1];
      let u = "isolated";
      (n === 0 || o === " ") && n < s - 1 && l !== " " && (u = "terminal"), n > 0 && o !== " " && n < s - 1 && l !== " " && (u = "medial"), n > 0 && o !== " " && (n === s - 1 || l === " ") && (u = "initial"), a = e.arabicGlyphs[i]?.[u] || e.glyphs[i];
    } else
      a = e.glyphs[i];
    return a || (a = e.missingGlyph), a;
  }
  getText() {
    return "";
  }
  getTextFromNode(e) {
    return (e || this.node).textContent;
  }
  renderChildren(e) {
    if (this.type !== "text") {
      this.renderTElementChildren(e);
      return;
    }
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(e), this.children.forEach((n, i) => {
      this.renderChild(e, this, this, i);
    });
    const { mouse: t } = this.document.screen;
    t.isWorking() && t.checkBoundingBox(this, this.getBoundingBox(e));
  }
  renderTElementChildren(e) {
    const { document: t, parent: n } = this, i = this.getText(), a = n.getStyle("font-family").getDefinition();
    if (a?.fontFace) {
      const { unitsPerEm: l } = a.fontFace, u = zd.parse(t.ctx.font), c = n.getStyle("font-size").getNumber(u.fontSize), h = n.getStyle("font-style").getString(u.fontStyle), f = c / l, p = a.isRTL ? i.split("").reverse().join("") : i, m = ks(n.getAttribute("dx").getString()), A = p.length;
      for (let w = 0; w < A; w++) {
        const x = this.getGlyph(a, p, w);
        e.translate(this.x, this.y), e.scale(f, -f);
        const E = e.lineWidth;
        e.lineWidth = e.lineWidth * l / c, h === "italic" && e.transform(1, 0, 0.4, 1, 0, 0), x.render(e), h === "italic" && e.transform(1, 0, -0.4, 1, 0, 0), e.lineWidth = E, e.scale(1 / f, -1 / f), e.translate(-this.x, -this.y), this.x += c * (x.horizAdvX || a.horizAdvX) / l, typeof m[w] < "u" && !isNaN(m[w]) && (this.x += m[w]);
      }
      return;
    }
    const { x: s, y: o } = this;
    e.fillStyle && e.fillText(i, s, o), e.strokeStyle && e.strokeText(i, s, o);
  }
  applyAnchoring() {
    if (this.textChunkStart >= this.leafTexts.length)
      return;
    const e = this.leafTexts[this.textChunkStart], t = e.getStyle("text-anchor").getString("start"), n = !1;
    let i = 0;
    t === "start" && !n || t === "end" && n ? i = e.x - this.minX : t === "end" && !n || t === "start" && n ? i = e.x - this.maxX : i = e.x - (this.minX + this.maxX) / 2;
    for (let a = this.textChunkStart; a < this.leafTexts.length; a++)
      this.leafTexts[a].x += i;
    this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY, this.textChunkStart = this.leafTexts.length;
  }
  adjustChildCoordinatesRecursive(e) {
    this.children.forEach((t, n) => {
      this.adjustChildCoordinatesRecursiveCore(e, this, this, n);
    }), this.applyAnchoring();
  }
  adjustChildCoordinatesRecursiveCore(e, t, n, i) {
    const a = n.children[i];
    a.children.length > 0 ? a.children.forEach((s, o) => {
      t.adjustChildCoordinatesRecursiveCore(e, t, a, o);
    }) : this.adjustChildCoordinates(e, t, n, i);
  }
  adjustChildCoordinates(e, t, n, i) {
    const a = n.children[i];
    if (typeof a.measureText != "function")
      return a;
    e.save(), a.setContext(e, !0);
    const s = a.getAttribute("x"), o = a.getAttribute("y"), l = a.getAttribute("dx"), u = a.getAttribute("dy"), c = !!a.getStyle("font-family").getDefinition()?.isRTL;
    i === 0 && (s.hasValue() || s.setValue(a.getInheritedAttribute("x")), o.hasValue() || o.setValue(a.getInheritedAttribute("y")), l.hasValue() || l.setValue(a.getInheritedAttribute("dx")), u.hasValue() || u.setValue(a.getInheritedAttribute("dy")));
    const h = a.measureText(e);
    return c && (t.x -= h), s.hasValue() ? (t.applyAnchoring(), a.x = s.getPixels("x"), l.hasValue() && (a.x += l.getPixels("x"))) : (l.hasValue() && (t.x += l.getPixels("x")), a.x = t.x), t.x = a.x, c || (t.x += h), o.hasValue() ? (a.y = o.getPixels("y"), u.hasValue() && (a.y += u.getPixels("y"))) : (u.hasValue() && (t.y += u.getPixels("y")), a.y = t.y), t.y = a.y, t.leafTexts.push(a), t.minX = Math.min(t.minX, a.x, a.x + h), t.maxX = Math.max(t.maxX, a.x, a.x + h), a.clearContext(e), e.restore(), a;
  }
  getChildBoundingBox(e, t, n, i) {
    const a = n.children[i];
    if (typeof a.getBoundingBox != "function")
      return null;
    const s = a.getBoundingBox(e);
    return s && a.children.forEach((o, l) => {
      const u = t.getChildBoundingBox(e, t, a, l);
      s.addBoundingBox(u);
    }), s;
  }
  renderChild(e, t, n, i) {
    const a = n.children[i];
    a.render(e), a.children.forEach((s, o) => {
      t.renderChild(e, t, a, o);
    });
  }
  measureText(e) {
    const { measureCache: t } = this;
    if (~t)
      return t;
    const n = this.getText(), i = this.measureTargetText(e, n);
    return this.measureCache = i, i;
  }
  measureTargetText(e, t) {
    if (!t.length)
      return 0;
    const { parent: n } = this, i = n.getStyle("font-family").getDefinition();
    if (i) {
      const s = this.getFontSize(), o = i.isRTL ? t.split("").reverse().join("") : t, l = ks(n.getAttribute("dx").getString()), u = o.length;
      let c = 0;
      for (let h = 0; h < u; h++) {
        const f = this.getGlyph(i, o, h);
        c += (f.horizAdvX || i.horizAdvX) * s / i.fontFace.unitsPerEm, typeof l[h] < "u" && !isNaN(l[h]) && (c += l[h]);
      }
      return c;
    }
    if (!e.measureText)
      return t.length * 10;
    e.save(), this.setContext(e, !0);
    const { width: a } = e.measureText(t);
    return this.clearContext(e), e.restore(), a;
  }
  /**
   * Inherits positional attributes from {@link TextElement} parent(s). Attributes
   * are only inherited from a parent to its first child.
   * @param name - The attribute name.
   * @returns The attribute value or null.
   */
  getInheritedAttribute(e) {
    let t = this;
    for (; t instanceof Rc && t.isFirstChild() && t.parent; ) {
      const n = t.parent.getAttribute(e);
      if (n.hasValue(!0))
        return n.getString("0");
      t = t.parent;
    }
    return null;
  }
}
class H0 extends Rc {
  constructor(e, t, n) {
    super(e, t, new.target === H0 ? !0 : n), this.type = "tspan", this.text = this.children.length > 0 ? "" : this.getTextFromNode();
  }
  getText() {
    return this.text;
  }
}
class N7 extends H0 {
  constructor() {
    super(...arguments), this.type = "textNode";
  }
}
class Qr extends Ze {
  constructor(e) {
    super(
      e.replace(/([+\-.])\s+/gm, "$1").replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, "")
    ), this.control = new Fi(0, 0), this.start = new Fi(0, 0), this.current = new Fi(0, 0), this.command = null, this.i = -1, this.previousCommand = null, this.points = [], this.angles = [];
  }
  reset() {
    this.i = -1, this.command = null, this.previousCommand = null, this.start = new Fi(0, 0), this.control = new Fi(0, 0), this.current = new Fi(0, 0), this.points = [], this.angles = [];
  }
  isEnd() {
    const { i: e, commands: t } = this;
    return e >= t.length - 1;
  }
  next() {
    const e = this.commands[++this.i];
    return this.previousCommand = this.command, this.command = e, e;
  }
  getPoint(e = "x", t = "y") {
    const n = new Fi(this.command[e], this.command[t]);
    return this.makeAbsolute(n);
  }
  getAsControlPoint(e, t) {
    const n = this.getPoint(e, t);
    return this.control = n, n;
  }
  getAsCurrentPoint(e, t) {
    const n = this.getPoint(e, t);
    return this.current = n, n;
  }
  getReflectedControlPoint() {
    const e = this.previousCommand.type;
    if (e !== Ze.CURVE_TO && e !== Ze.SMOOTH_CURVE_TO && e !== Ze.QUAD_TO && e !== Ze.SMOOTH_QUAD_TO)
      return this.current;
    const {
      current: { x: t, y: n },
      control: { x: i, y: a }
    } = this;
    return new Fi(2 * t - i, 2 * n - a);
  }
  makeAbsolute(e) {
    if (this.command.relative) {
      const { x: t, y: n } = this.current;
      e.x += t, e.y += n;
    }
    return e;
  }
  addMarker(e, t, n) {
    const { points: i, angles: a } = this;
    n && a.length > 0 && !a[a.length - 1] && (a[a.length - 1] = i[i.length - 1].angleTo(n)), this.addMarkerAngle(e, t ? t.angleTo(e) : null);
  }
  addMarkerAngle(e, t) {
    this.points.push(e), this.angles.push(t);
  }
  getMarkerPoints() {
    return this.points;
  }
  getMarkerAngles() {
    const { angles: e } = this, t = e.length;
    for (let n = 0; n < t; n++)
      if (!e[n]) {
        for (let i = n + 1; i < t; i++)
          if (e[i]) {
            e[n] = e[i];
            break;
          }
      }
    return e;
  }
}
class Yn extends Gf {
  constructor(e, t, n) {
    super(e, t, n), this.type = "path", this.pathParser = new Qr(this.getAttribute("d").getString());
  }
  path(e) {
    const { pathParser: t } = this, n = new Zo();
    for (t.reset(), e && e.beginPath(); !t.isEnd(); )
      switch (t.next().type) {
        case Qr.MOVE_TO:
          this.pathM(e, n);
          break;
        case Qr.LINE_TO:
          this.pathL(e, n);
          break;
        case Qr.HORIZ_LINE_TO:
          this.pathH(e, n);
          break;
        case Qr.VERT_LINE_TO:
          this.pathV(e, n);
          break;
        case Qr.CURVE_TO:
          this.pathC(e, n);
          break;
        case Qr.SMOOTH_CURVE_TO:
          this.pathS(e, n);
          break;
        case Qr.QUAD_TO:
          this.pathQ(e, n);
          break;
        case Qr.SMOOTH_QUAD_TO:
          this.pathT(e, n);
          break;
        case Qr.ARC:
          this.pathA(e, n);
          break;
        case Qr.CLOSE_PATH:
          this.pathZ(e, n);
          break;
      }
    return n;
  }
  getBoundingBox(e) {
    return this.path();
  }
  getMarkers() {
    const { pathParser: e } = this, t = e.getMarkerPoints(), n = e.getMarkerAngles();
    return !t || !n ? null : t.map((i, a) => [i, n[a]]);
  }
  renderChildren(e) {
    this.path(e), this.document.screen.mouse.checkPath(this, e);
    const t = this.getStyle("fill-rule");
    e.fillStyle !== "" && (t.getString("inherit") !== "inherit" ? e.fill(t.getString()) : e.fill()), e.strokeStyle !== "" && (this.getAttribute("vector-effect").getString() === "non-scaling-stroke" ? (e.save(), e.setTransform(1, 0, 0, 1, 0, 0), e.stroke(), e.restore()) : e.stroke());
    const n = this.getMarkers();
    if (n) {
      const i = n.length - 1, a = this.getStyle("marker-start"), s = this.getStyle("marker-mid"), o = this.getStyle("marker-end");
      if (a.isUrlDefinition()) {
        const l = a.getDefinition(), [u, c] = n[0];
        l && l.render(e, u, c === null ? void 0 : c);
      }
      if (s.isUrlDefinition()) {
        const l = s.getDefinition();
        for (let u = 1; u < i; u++) {
          const [c, h] = n[u];
          l && l.render(e, c, h === null ? void 0 : h);
        }
      }
      if (o.isUrlDefinition()) {
        const l = o.getDefinition(), [u, c] = n[i];
        l && l.render(e, u, c === null ? void 0 : c);
      }
    }
  }
  static pathM(e) {
    const t = e.getAsCurrentPoint();
    return e.start = e.current, {
      point: t
    };
  }
  pathM(e, t) {
    const { pathParser: n } = this, { point: i } = Yn.pathM(n), { x: a, y: s } = i;
    n.addMarker(i), t.addPoint(a, s), e && e.moveTo(a, s);
  }
  static pathL(e) {
    const { current: t } = e, n = e.getAsCurrentPoint();
    return {
      current: t,
      point: n
    };
  }
  pathL(e, t) {
    const { pathParser: n } = this, { current: i, point: a } = Yn.pathL(n), { x: s, y: o } = a;
    n.addMarker(a, i), t.addPoint(s, o), e && e.lineTo(s, o);
  }
  static pathH(e) {
    const { current: t, command: n } = e, i = new Fi((n?.relative ? t.x : 0) + n.x, t.y);
    return e.current = i, {
      current: t,
      point: i
    };
  }
  pathH(e, t) {
    const { pathParser: n } = this, { current: i, point: a } = Yn.pathH(n), { x: s, y: o } = a;
    n.addMarker(a, i), t.addPoint(s, o), e && e.lineTo(s, o);
  }
  static pathV(e) {
    const { current: t, command: n } = e, i = new Fi(t.x, (n.relative ? t.y : 0) + n.y);
    return e.current = i, {
      current: t,
      point: i
    };
  }
  pathV(e, t) {
    const { pathParser: n } = this, { current: i, point: a } = Yn.pathV(n), { x: s, y: o } = a;
    n.addMarker(a, i), t.addPoint(s, o), e && e.lineTo(s, o);
  }
  static pathC(e) {
    const { current: t } = e, n = e.getPoint("x1", "y1"), i = e.getAsControlPoint("x2", "y2"), a = e.getAsCurrentPoint();
    return {
      current: t,
      point: n,
      controlPoint: i,
      currentPoint: a
    };
  }
  pathC(e, t) {
    const { pathParser: n } = this, { current: i, point: a, controlPoint: s, currentPoint: o } = Yn.pathC(n);
    n.addMarker(o, s, a), t.addBezierCurve(
      i.x,
      i.y,
      a.x,
      a.y,
      s.x,
      s.y,
      o.x,
      o.y
    ), e && e.bezierCurveTo(a.x, a.y, s.x, s.y, o.x, o.y);
  }
  static pathS(e) {
    const { current: t } = e, n = e.getReflectedControlPoint(), i = e.getAsControlPoint("x2", "y2"), a = e.getAsCurrentPoint();
    return {
      current: t,
      point: n,
      controlPoint: i,
      currentPoint: a
    };
  }
  pathS(e, t) {
    const { pathParser: n } = this, { current: i, point: a, controlPoint: s, currentPoint: o } = Yn.pathS(n);
    n.addMarker(o, s, a), t.addBezierCurve(
      i.x,
      i.y,
      a.x,
      a.y,
      s.x,
      s.y,
      o.x,
      o.y
    ), e && e.bezierCurveTo(a.x, a.y, s.x, s.y, o.x, o.y);
  }
  static pathQ(e) {
    const { current: t } = e, n = e.getAsControlPoint("x1", "y1"), i = e.getAsCurrentPoint();
    return {
      current: t,
      controlPoint: n,
      currentPoint: i
    };
  }
  pathQ(e, t) {
    const { pathParser: n } = this, { current: i, controlPoint: a, currentPoint: s } = Yn.pathQ(n);
    n.addMarker(s, a, a), t.addQuadraticCurve(
      i.x,
      i.y,
      a.x,
      a.y,
      s.x,
      s.y
    ), e && e.quadraticCurveTo(a.x, a.y, s.x, s.y);
  }
  static pathT(e) {
    const { current: t } = e, n = e.getReflectedControlPoint();
    e.control = n;
    const i = e.getAsCurrentPoint();
    return {
      current: t,
      controlPoint: n,
      currentPoint: i
    };
  }
  pathT(e, t) {
    const { pathParser: n } = this, { current: i, controlPoint: a, currentPoint: s } = Yn.pathT(n);
    n.addMarker(s, a, a), t.addQuadraticCurve(
      i.x,
      i.y,
      a.x,
      a.y,
      s.x,
      s.y
    ), e && e.quadraticCurveTo(a.x, a.y, s.x, s.y);
  }
  static pathA(e) {
    const { current: t, command: n } = e;
    let { rX: i, rY: a, xRot: s, lArcFlag: o, sweepFlag: l } = n;
    const u = s * (Math.PI / 180), c = e.getAsCurrentPoint(), h = new Fi(
      Math.cos(u) * (t.x - c.x) / 2 + Math.sin(u) * (t.y - c.y) / 2,
      -Math.sin(u) * (t.x - c.x) / 2 + Math.cos(u) * (t.y - c.y) / 2
    ), f = Math.pow(h.x, 2) / Math.pow(i, 2) + Math.pow(h.y, 2) / Math.pow(a, 2);
    f > 1 && (i *= Math.sqrt(f), a *= Math.sqrt(f));
    let p = (o === l ? -1 : 1) * Math.sqrt(
      (Math.pow(i, 2) * Math.pow(a, 2) - Math.pow(i, 2) * Math.pow(h.y, 2) - Math.pow(a, 2) * Math.pow(h.x, 2)) / (Math.pow(i, 2) * Math.pow(h.y, 2) + Math.pow(a, 2) * Math.pow(h.x, 2))
    );
    isNaN(p) && (p = 0);
    const m = new Fi(p * i * h.y / a, p * -a * h.x / i), A = new Fi(
      (t.x + c.x) / 2 + Math.cos(u) * m.x - Math.sin(u) * m.y,
      (t.y + c.y) / 2 + Math.sin(u) * m.x + Math.cos(u) * m.y
    ), w = fE([1, 0], [(h.x - m.x) / i, (h.y - m.y) / a]), x = [(h.x - m.x) / i, (h.y - m.y) / a], E = [(-h.x - m.x) / i, (-h.y - m.y) / a];
    let T = fE(x, E);
    return k1(x, E) <= -1 && (T = Math.PI), k1(x, E) >= 1 && (T = 0), {
      currentPoint: c,
      rX: i,
      rY: a,
      sweepFlag: l,
      xAxisRotation: u,
      centp: A,
      a1: w,
      ad: T
    };
  }
  pathA(e, t) {
    const { pathParser: n } = this, { currentPoint: i, rX: a, rY: s, sweepFlag: o, xAxisRotation: l, centp: u, a1: c, ad: h } = Yn.pathA(n), f = 1 - o ? 1 : -1, p = c + f * (h / 2), m = new Fi(u.x + a * Math.cos(p), u.y + s * Math.sin(p));
    if (n.addMarkerAngle(m, p - f * Math.PI / 2), n.addMarkerAngle(i, p - f * Math.PI), t.addPoint(i.x, i.y), e && !isNaN(c) && !isNaN(h)) {
      const A = a > s ? a : s, w = a > s ? 1 : a / s, x = a > s ? s / a : 1;
      e.translate(u.x, u.y), e.rotate(l), e.scale(w, x), e.arc(0, 0, A, c, c + h, !!(1 - o)), e.scale(1 / w, 1 / x), e.rotate(-l), e.translate(-u.x, -u.y);
    }
  }
  static pathZ(e) {
    e.current = e.start;
  }
  pathZ(e, t) {
    Yn.pathZ(this.pathParser), e && t.x1 !== t.x2 && t.y1 !== t.y2 && e.closePath();
  }
}
class gg extends Gf {
  constructor() {
    super(...arguments), this.type = "svg", this.root = !1;
  }
  setContext(e) {
    const { document: t } = this, { screen: n, window: i } = t, a = e.canvas;
    if (n.setDefaults(e), "style" in a && typeof e.font < "u" && i && typeof i.getComputedStyle < "u") {
      e.font = i.getComputedStyle(a).getPropertyValue("font");
      const x = new wr(t, "fontSize", zd.parse(e.font).fontSize);
      x.hasValue() && (t.rootEmSize = x.getPixels("y"), t.emSize = t.rootEmSize);
    }
    this.getAttribute("x").hasValue() || this.getAttribute("x", !0).setValue(0), this.getAttribute("y").hasValue() || this.getAttribute("y", !0).setValue(0);
    let { width: s, height: o } = n.viewPort;
    this.getStyle("width").hasValue() || this.getStyle("width", !0).setValue("100%"), this.getStyle("height").hasValue() || this.getStyle("height", !0).setValue("100%"), this.getStyle("color").hasValue() || this.getStyle("color", !0).setValue("black");
    const l = this.getAttribute("refX"), u = this.getAttribute("refY"), c = this.getAttribute("viewBox"), h = c.hasValue() ? ks(c.getString()) : null, f = !this.root && this.getStyle("overflow").getValue("hidden") !== "visible";
    let p = 0, m = 0, A = 0, w = 0;
    h && (p = h[0], m = h[1]), this.root || (s = this.getStyle("width").getPixels("x"), o = this.getStyle("height").getPixels("y"), this.type === "marker" && (A = p, w = m, p = 0, m = 0)), n.viewPort.setCurrent(s, o), this.node && // is not temporary SVGElement
    (!this.parent || this.node.parentNode?.nodeName === "foreignObject") && this.getStyle("transform", !1, !0).hasValue() && !this.getStyle("transform-origin", !1, !0).hasValue() && this.getStyle("transform-origin", !0, !0).setValue("50% 50%"), super.setContext(e), e.translate(this.getAttribute("x").getPixels("x"), this.getAttribute("y").getPixels("y")), h && (s = h[2], o = h[3]), t.setViewBox({
      ctx: e,
      aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
      width: n.viewPort.width,
      desiredWidth: s,
      height: n.viewPort.height,
      desiredHeight: o,
      minX: p,
      minY: m,
      refX: l.getValue(),
      refY: u.getValue(),
      clip: f,
      clipX: A,
      clipY: w
    }), h && (n.viewPort.removeCurrent(), n.viewPort.setCurrent(s, o));
  }
  clearContext(e) {
    super.clearContext(e), this.document.screen.viewPort.removeCurrent();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(e, t = e, n = !1) {
    const i = this.getAttribute("width", !0), a = this.getAttribute("height", !0), s = this.getAttribute("viewBox"), o = this.getAttribute("style"), l = i.getNumber(0), u = a.getNumber(0);
    if (n)
      if (typeof n == "string")
        this.getAttribute("preserveAspectRatio", !0).setValue(n);
      else {
        const c = this.getAttribute("preserveAspectRatio");
        c.hasValue() && c.setValue(
          c.getString().replace(/^\s*(\S.*\S)\s*$/, "$1")
        );
      }
    if (i.setValue(e), a.setValue(t), s.hasValue() || s.setValue(`0 0 ${l || e} ${u || t}`), o.hasValue()) {
      const c = this.getStyle("width"), h = this.getStyle("height");
      c.hasValue() && c.setValue(`${e}px`), h.hasValue() && h.setValue(`${t}px`);
    }
  }
}
class iP extends Yn {
  constructor() {
    super(...arguments), this.type = "rect";
  }
  path(e) {
    const t = this.getAttribute("x").getPixels("x"), n = this.getAttribute("y").getPixels("y"), i = this.getStyle("width", !1, !0).getPixels("x"), a = this.getStyle("height", !1, !0).getPixels("y"), s = this.getAttribute("rx"), o = this.getAttribute("ry");
    let l = s.getPixels("x"), u = o.getPixels("y");
    if (s.hasValue() && !o.hasValue() && (u = l), o.hasValue() && !s.hasValue() && (l = u), l = Math.min(l, i / 2), u = Math.min(u, a / 2), e) {
      const c = 4 * ((Math.sqrt(2) - 1) / 3);
      e.beginPath(), a > 0 && i > 0 && (e.moveTo(t + l, n), e.lineTo(t + i - l, n), e.bezierCurveTo(t + i - l + c * l, n, t + i, n + u - c * u, t + i, n + u), e.lineTo(t + i, n + a - u), e.bezierCurveTo(
        t + i,
        n + a - u + c * u,
        t + i - l + c * l,
        n + a,
        t + i - l,
        n + a
      ), e.lineTo(t + l, n + a), e.bezierCurveTo(t + l - c * l, n + a, t, n + a - u + c * u, t, n + a - u), e.lineTo(t, n + u), e.bezierCurveTo(t, n + u - c * u, t + l - c * l, n, t + l, n), e.closePath());
    }
    return new Zo(t, n, t + i, n + a);
  }
  getMarkers() {
    return null;
  }
}
class L7 extends Yn {
  constructor() {
    super(...arguments), this.type = "circle";
  }
  path(e) {
    const t = this.getAttribute("cx").getPixels("x"), n = this.getAttribute("cy").getPixels("y"), i = this.getAttribute("r").getPixels();
    return e && i > 0 && (e.beginPath(), e.arc(t, n, i, 0, Math.PI * 2, !1), e.closePath()), new Zo(t - i, n - i, t + i, n + i);
  }
  getMarkers() {
    return null;
  }
}
class U7 extends Yn {
  constructor() {
    super(...arguments), this.type = "ellipse";
  }
  path(e) {
    const t = 4 * ((Math.sqrt(2) - 1) / 3), n = this.getAttribute("rx").getPixels("x"), i = this.getAttribute("ry").getPixels("y"), a = this.getAttribute("cx").getPixels("x"), s = this.getAttribute("cy").getPixels("y");
    return e && n > 0 && i > 0 && (e.beginPath(), e.moveTo(a + n, s), e.bezierCurveTo(a + n, s + t * i, a + t * n, s + i, a, s + i), e.bezierCurveTo(a - t * n, s + i, a - n, s + t * i, a - n, s), e.bezierCurveTo(a - n, s - t * i, a - t * n, s - i, a, s - i), e.bezierCurveTo(a + t * n, s - i, a + n, s - t * i, a + n, s), e.closePath()), new Zo(a - n, s - i, a + n, s + i);
  }
  getMarkers() {
    return null;
  }
}
class V7 extends Yn {
  constructor() {
    super(...arguments), this.type = "line";
  }
  getPoints() {
    return [
      new Fi(this.getAttribute("x1").getPixels("x"), this.getAttribute("y1").getPixels("y")),
      new Fi(this.getAttribute("x2").getPixels("x"), this.getAttribute("y2").getPixels("y"))
    ];
  }
  path(e) {
    const [{ x: t, y: n }, { x: i, y: a }] = this.getPoints();
    return e && (e.beginPath(), e.moveTo(t, n), e.lineTo(i, a)), new Zo(t, n, i, a);
  }
  getMarkers() {
    const [e, t] = this.getPoints(), n = e.angleTo(t);
    return [
      [e, n],
      [t, n]
    ];
  }
}
class aP extends Yn {
  constructor(e, t, n) {
    super(e, t, n), this.type = "polyline", this.points = [], this.points = Fi.parsePath(this.getAttribute("points").getString());
  }
  path(e) {
    const { points: t } = this, [{ x: n, y: i }] = t, a = new Zo(n, i);
    return e && (e.beginPath(), e.moveTo(n, i)), t.forEach(({ x: s, y: o }) => {
      a.addPoint(s, o), e && e.lineTo(s, o);
    }), a;
  }
  getMarkers() {
    const { points: e } = this, t = e.length - 1, n = [];
    return e.forEach((i, a) => {
      a !== t && n.push([i, i.angleTo(e[a + 1])]);
    }), n.length > 0 && n.push([e[e.length - 1], n[n.length - 1][1]]), n;
  }
}
class $7 extends aP {
  constructor() {
    super(...arguments), this.type = "polygon";
  }
  path(e) {
    const t = super.path(e), [{ x: n, y: i }] = this.points;
    return e && (e.lineTo(n, i), e.closePath()), t;
  }
}
class z7 extends Ea {
  constructor() {
    super(...arguments), this.type = "pattern";
  }
  createPattern(e, t, n) {
    const i = this.getStyle("width").getPixels("x", !0), a = this.getStyle("height").getPixels("y", !0), s = this.getAttribute("data-frame-width"), o = this.getAttribute("data-frame-height"), l = s.hasValue() ? s.getPixels("x", !0) : i, u = o.hasValue() ? o.getPixels("y", !0) : a, c = s.hasValue() && o.hasValue(), h = new gg(this.document, void 0);
    h.attributes.viewBox = new wr(this.document, "viewBox", this.getAttribute("viewBox").getValue()), h.attributes.width = new wr(this.document, "width", `${l}px`), h.attributes.height = new wr(this.document, "height", `${u}px`), h.attributes.transform = new wr(
      this.document,
      "transform",
      this.getAttribute("patternTransform").getValue()
    ), h.children = this.children;
    const f = this.document.createCanvas(l, u), p = f.getContext("2d");
    p.imageSmoothingEnabled = !0, p.imageSmoothingQuality = "high";
    const m = this.getAttribute("x"), A = this.getAttribute("y");
    m.hasValue() && A.hasValue() && p.translate(m.getPixels("x", !0), A.getPixels("y", !0)), n.hasValue() ? this.styles["fill-opacity"] = n : Reflect.deleteProperty(this.styles, "fill-opacity");
    for (let w = -1; w <= 1; w++)
      for (let x = -1; x <= 1; x++)
        p.save(), h.attributes.x = new wr(this.document, "x", w * f.width), h.attributes.y = new wr(this.document, "y", x * f.height), h.render(p), p.restore();
    return e.createPattern(f, c ? "no-repeat" : "repeat");
  }
}
class G7 extends Ea {
  constructor() {
    super(...arguments), this.type = "marker";
  }
  render(e, t, n) {
    if (!t)
      return;
    const { x: i, y: a } = t, s = this.getAttribute("orient").getString("auto"), o = this.getAttribute("markerUnits").getString("strokeWidth");
    e.translate(i, a), s === "auto" && n && e.rotate(n), o === "strokeWidth" && e.scale(e.lineWidth, e.lineWidth), e.save();
    const l = new gg(this.document);
    l.type = this.type, l.attributes.viewBox = new wr(this.document, "viewBox", this.getAttribute("viewBox").getValue()), l.attributes.refX = new wr(this.document, "refX", this.getAttribute("refX").getValue()), l.attributes.refY = new wr(this.document, "refY", this.getAttribute("refY").getValue()), l.attributes.width = new wr(this.document, "width", this.getAttribute("markerWidth").getValue()), l.attributes.height = new wr(
      this.document,
      "height",
      this.getAttribute("markerHeight").getValue()
    ), l.attributes.overflow = new wr(
      this.document,
      "overflow",
      this.getAttribute("overflow").getValue()
    ), l.attributes.fill = new wr(this.document, "fill", this.getAttribute("fill").getColor("black")), l.attributes.stroke = new wr(
      this.document,
      "stroke",
      this.getAttribute("stroke").getValue("none")
    ), l.children = this.children, l.render(e), e.restore(), o === "strokeWidth" && e.scale(1 / e.lineWidth, 1 / e.lineWidth), s === "auto" && n && e.rotate(-n), e.translate(-i, -a);
  }
}
class H7 extends Ea {
  constructor() {
    super(...arguments), this.type = "defs";
  }
  render() {
  }
}
class Hw extends Gf {
  constructor() {
    super(...arguments), this.type = "g";
  }
  getBoundingBox(e) {
    const t = new Zo();
    return this.children.forEach((n) => {
      n instanceof Yn && t.addBoundingBox(n.getBoundingBox(e));
    }), t;
  }
}
class sP extends Ea {
  constructor(e, t, n) {
    super(e, t, n), this.attributesToInherit = ["gradientUnits"], this.stops = [];
    const { stops: i, children: a } = this;
    a.forEach((s) => {
      s.type === "stop" && i.push(s);
    });
  }
  getGradientUnits() {
    return this.getAttribute("gradientUnits").getString("objectBoundingBox");
  }
  createGradient(e, t, n) {
    let i = this;
    this.getHrefAttribute().hasValue() && (i = this.getHrefAttribute().getDefinition(), this.inheritStopContainer(i));
    const { stops: a } = i, s = this.getGradient(e, t);
    if (!s)
      return this.addParentOpacity(n, a[a.length - 1].color);
    if (a.forEach((o) => {
      s.addColorStop(o.offset, this.addParentOpacity(n, o.color));
    }), this.getAttribute("gradientTransform").hasValue()) {
      const { document: o } = this, { MAX_VIRTUAL_PIXELS: l } = zw, { viewPort: u } = o.screen, c = u.getRoot(), h = new iP(o);
      h.attributes.x = new wr(o, "x", -l / 3), h.attributes.y = new wr(o, "y", -l / 3), h.attributes.width = new wr(o, "width", l), h.attributes.height = new wr(o, "height", l);
      const f = new Hw(o);
      f.attributes.transform = new wr(
        o,
        "transform",
        this.getAttribute("gradientTransform").getValue()
      ), f.children = [h];
      const p = new gg(o);
      p.attributes.x = new wr(o, "x", 0), p.attributes.y = new wr(o, "y", 0), p.attributes.width = new wr(o, "width", c.width), p.attributes.height = new wr(o, "height", c.height), p.children = [f];
      const m = o.createCanvas(c.width, c.height), A = m.getContext("2d");
      return A.fillStyle = s, p.render(A), A.createPattern(m, "no-repeat");
    }
    return s;
  }
  inheritStopContainer(e) {
    this.attributesToInherit.forEach((t) => {
      !this.getAttribute(t).hasValue() && e.getAttribute(t).hasValue() && this.getAttribute(t, !0).setValue(
        e.getAttribute(t).getValue()
      );
    });
  }
  addParentOpacity(e, t) {
    return e.hasValue() ? new wr(this.document, "color", t).addOpacity(e).getColor() : t;
  }
}
class W7 extends sP {
  constructor(e, t, n) {
    super(e, t, n), this.type = "linearGradient", this.attributesToInherit.push("x1", "y1", "x2", "y2");
  }
  getGradient(e, t) {
    const n = this.getGradientUnits() === "objectBoundingBox", i = n ? t.getBoundingBox(e) : null;
    if (n || !i)
      return null;
    !this.getAttribute("x1").hasValue() && !this.getAttribute("y1").hasValue() && !this.getAttribute("x2").hasValue() && !this.getAttribute("y2").hasValue() && (this.getAttribute("x1", !0).setValue(0), this.getAttribute("y1", !0).setValue(0), this.getAttribute("x2", !0).setValue(1), this.getAttribute("y2", !0).setValue(0));
    const a = n ? i.x + i.width * this.getAttribute("x1").getNumber() : this.getAttribute("x1").getPixels("x"), s = n ? i.y + i.height * this.getAttribute("y1").getNumber() : this.getAttribute("y1").getPixels("y"), o = n ? i.x + i.width * this.getAttribute("x2").getNumber() : this.getAttribute("x2").getPixels("x"), l = n ? i.y + i.height * this.getAttribute("y2").getNumber() : this.getAttribute("y2").getPixels("y");
    return a === o && s === l ? null : e.createLinearGradient(a, s, o, l);
  }
}
class j7 extends sP {
  constructor(e, t, n) {
    super(e, t, n), this.type = "radialGradient", this.attributesToInherit.push("cx", "cy", "r", "fx", "fy", "fr");
  }
  getGradient(e, t) {
    const n = this.getGradientUnits() === "objectBoundingBox", i = t.getBoundingBox(e);
    if (n && !i)
      return null;
    this.getAttribute("cx").hasValue() || this.getAttribute("cx", !0).setValue("50%"), this.getAttribute("cy").hasValue() || this.getAttribute("cy", !0).setValue("50%"), this.getAttribute("r").hasValue() || this.getAttribute("r", !0).setValue("50%");
    const a = n ? i.x + i.width * this.getAttribute("cx").getNumber() : this.getAttribute("cx").getPixels("x"), s = n ? i.y + i.height * this.getAttribute("cy").getNumber() : this.getAttribute("cy").getPixels("y");
    let o = a, l = s;
    this.getAttribute("fx").hasValue() && (o = n ? i.x + i.width * this.getAttribute("fx").getNumber() : this.getAttribute("fx").getPixels("x")), this.getAttribute("fy").hasValue() && (l = n ? i.y + i.height * this.getAttribute("fy").getNumber() : this.getAttribute("fy").getPixels("y"));
    const u = n ? (i.width + i.height) / 2 * this.getAttribute("r").getNumber() : this.getAttribute("r").getPixels(), c = this.getAttribute("fr").getPixels();
    return e.createRadialGradient(o, l, c, a, s, u);
  }
}
class q7 extends Ea {
  constructor(e, t, n) {
    super(e, t, n), this.type = "stop";
    const i = Math.max(0, Math.min(1, this.getAttribute("offset").getNumber())), a = this.getStyle("stop-opacity");
    let s = this.getStyle("stop-color", !0);
    s.getString() === "" && s.setValue("#000"), a.hasValue() && (s = s.addOpacity(a)), this.offset = i, this.color = s.getColor();
  }
}
class Ww extends Ea {
  constructor(e, t, n) {
    super(e, t, n), this.type = "animate", this.duration = 0, this.initialUnits = "", this.removed = !1, this.frozen = !1, e.screen.animations.push(this), this.begin = this.getAttribute("begin").getMilliseconds(), this.maxDuration = this.begin + this.getAttribute("dur").getMilliseconds(), this.from = this.getAttribute("from"), this.to = this.getAttribute("to"), this.values = new wr(e, "values", null);
    const i = this.getAttribute("values");
    i.hasValue() && this.values.setValue(i.getString().split(";"));
  }
  getProperty() {
    const e = this.getAttribute("attributeType").getString(), t = this.getAttribute("attributeName").getString();
    return e === "CSS" ? this.parent?.getStyle(t, !0) : this.parent?.getAttribute(t, !0);
  }
  calcValue() {
    const { initialUnits: e } = this, { progress: t, from: n, to: i } = this.getProgress();
    let a = n.getNumber() + (i.getNumber() - n.getNumber()) * t;
    return e === "%" && (a *= 100), `${a}${e}`;
  }
  update(e) {
    const { parent: t } = this, n = this.getProperty();
    if (!n)
      return !1;
    if (this.initialValue || (this.initialValue = n.getString(), this.initialUnits = n.getUnits()), this.duration > this.maxDuration) {
      const a = this.getAttribute("fill").getString("remove");
      if (this.getAttribute("repeatCount").getString() === "indefinite" || this.getAttribute("repeatDur").getString() === "indefinite")
        this.duration = 0;
      else if (a === "freeze" && !this.frozen)
        this.frozen = !0, t && n && (t.animationFrozen = !0, t.animationFrozenValue = n.getString());
      else if (a === "remove" && !this.removed)
        return this.removed = !0, t && n && n.setValue(t.animationFrozen ? t.animationFrozenValue : this.initialValue), !0;
      return !1;
    }
    this.duration += e;
    let i = !1;
    if (this.begin < this.duration) {
      let a = this.calcValue();
      const s = this.getAttribute("type");
      s.hasValue() && (a = `${s.getString()}(${a})`), n.setValue(a), i = !0;
    }
    return i;
  }
  getProgress() {
    const { document: e, values: t } = this;
    let n = (this.duration - this.begin) / (this.maxDuration - this.begin), i, a;
    if (t.hasValue()) {
      const s = n * (t.getValue().length - 1), o = Math.floor(s), l = Math.ceil(s);
      let u;
      u = t.getValue()[o], i = new wr(e, "from", u ? parseFloat(u) : 0), u = t.getValue()[l], a = new wr(e, "to", u ? parseFloat(u) : 0), n = (s - o) / (l - o);
    } else
      i = this.from, a = this.to;
    return {
      progress: n,
      from: i,
      to: a
    };
  }
}
class Q7 extends Ww {
  constructor() {
    super(...arguments), this.type = "animateColor";
  }
  calcValue() {
    const { progress: e, from: t, to: n } = this.getProgress(), i = new S1(t.getColor()), a = new S1(n.getColor());
    if (i.ok && a.ok) {
      const s = i.r + (a.r - i.r) * e, o = i.g + (a.g - i.g) * e, l = i.b + (a.b - i.b) * e;
      return `rgb(${Math.floor(s)}, ${Math.floor(o)}, ${Math.floor(l)})`;
    }
    return this.getAttribute("from").getColor();
  }
}
class Y7 extends Ww {
  constructor() {
    super(...arguments), this.type = "animateTransform";
  }
  calcValue() {
    const { progress: e, from: t, to: n } = this.getProgress(), i = ks(t.getString()), a = ks(n.getString());
    return i.map((s, o) => {
      const l = a[o];
      return s + (l - s) * e;
    }).join(" ");
  }
}
class oP extends Ea {
  constructor(e, t, n) {
    super(e, t, n), this.type = "font-face", this.ascent = this.getAttribute("ascent").getNumber(), this.descent = this.getAttribute("descent").getNumber(), this.unitsPerEm = this.getAttribute("units-per-em").getNumber();
  }
}
class jw extends Yn {
  constructor(e, t, n) {
    super(e, t, n), this.type = "glyph", this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber(), this.unicode = this.getAttribute("unicode").getString(), this.arabicForm = this.getAttribute("arabic-form").getString();
  }
}
class lP extends jw {
  constructor() {
    super(...arguments), this.type = "missing-glyph", this.horizAdvX = 0;
  }
}
let X7 = class extends Ea {
  constructor(e, t, n) {
    super(e, t, n), this.type = "font", this.isArabic = !1, this.glyphs = {}, this.arabicGlyphs = {}, this.isRTL = !1, this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
    const { definitions: i } = e, { children: a } = this;
    for (const s of a)
      if (s instanceof oP) {
        this.fontFace = s;
        const o = s.getStyle("font-family");
        o.hasValue() && (i[o.getString()] = this);
      } else if (s instanceof lP)
        this.missingGlyph = s;
      else if (s instanceof jw)
        if (s.arabicForm) {
          this.isRTL = !0, this.isArabic = !0;
          const o = this.arabicGlyphs[s.unicode];
          typeof o > "u" ? this.arabicGlyphs[s.unicode] = {
            [s.arabicForm]: s
          } : o[s.arabicForm] = s;
        } else
          this.glyphs[s.unicode] = s;
  }
  render() {
  }
};
class J7 extends Rc {
  constructor() {
    super(...arguments), this.type = "tref";
  }
  getText() {
    const e = this.getHrefAttribute().getDefinition();
    if (e) {
      const t = e.children[0];
      if (t)
        return t.getText();
    }
    return "";
  }
}
class K7 extends Rc {
  constructor(e, t, n) {
    super(e, t, n), this.type = "a";
    const { childNodes: i } = t, a = i[0], s = i.length > 0 && Array.from(i).every((o) => o.nodeType === 3);
    this.hasText = s, this.text = s ? this.getTextFromNode(a) : "";
  }
  getText() {
    return this.text;
  }
  renderChildren(e) {
    if (this.hasText) {
      super.renderChildren(e);
      const { document: t, x: n, y: i } = this, { mouse: a } = t.screen, s = new wr(t, "fontSize", zd.parse(t.ctx.font).fontSize);
      a.isWorking() && a.checkBoundingBox(
        this,
        new Zo(n, i - s.getPixels("y"), n + this.measureText(e), i)
      );
    } else if (this.children.length > 0) {
      const t = new Hw(this.document);
      t.children = this.children, t.parent = this, t.render(e);
    }
  }
  onClick() {
    const { window: e } = this.document;
    e && e.open(this.getHrefAttribute().getString());
  }
  onMouseMove() {
    const e = this.document.ctx;
    e.canvas.style.cursor = "pointer";
  }
}
class Z7 extends Rc {
  constructor(e, t, n) {
    super(e, t, n), this.type = "textPath", this.textWidth = 0, this.textHeight = 0, this.pathLength = -1, this.glyphInfo = null, this.letterSpacingCache = [], this.equidistantCache = null, this.measuresCache = /* @__PURE__ */ new Map([["", 0]]);
    const i = this.getHrefAttribute().getDefinition();
    this.text = this.getTextFromNode(), this.dataArray = this.parsePathData(i);
  }
  getText() {
    return this.text;
  }
  path(e) {
    const { dataArray: t } = this;
    e && e.beginPath(), t.forEach(({ type: n, points: i }) => {
      switch (n) {
        case Qr.LINE_TO:
          e && e.lineTo(i[0], i[1]);
          break;
        case Qr.MOVE_TO:
          e && e.moveTo(i[0], i[1]);
          break;
        case Qr.CURVE_TO:
          e && e.bezierCurveTo(i[0], i[1], i[2], i[3], i[4], i[5]);
          break;
        case Qr.QUAD_TO:
          e && e.quadraticCurveTo(i[0], i[1], i[2], i[3]);
          break;
        case Qr.ARC: {
          const [a, s, o, l, u, c, h, f] = i, p = o > l ? o : l, m = o > l ? 1 : o / l, A = o > l ? l / o : 1;
          e && (e.translate(a, s), e.rotate(h), e.scale(m, A), e.arc(0, 0, p, u, u + c, !!(1 - f)), e.scale(1 / m, 1 / A), e.rotate(-h), e.translate(-a, -s));
          break;
        }
        case Qr.CLOSE_PATH:
          e && e.closePath();
          break;
      }
    });
  }
  renderChildren(e) {
    this.setTextData(e), e.save();
    const t = this.parent?.getStyle("text-decoration").getString(), n = this.getFontSize(), { glyphInfo: i } = this, a = e.fillStyle;
    t === "underline" && e.beginPath(), i.forEach((s, o) => {
      const { p0: l, p1: u, rotation: c, text: h } = s;
      e.save(), e.translate(l.x, l.y), e.rotate(c), e.fillStyle && e.fillText(h, 0, 0), e.strokeStyle && e.strokeText(h, 0, 0), e.restore(), t === "underline" && (o === 0 && e.moveTo(l.x, l.y + n / 8), e.lineTo(u.x, u.y + n / 5));
    }), t === "underline" && (e.lineWidth = n / 20, e.strokeStyle = a, e.stroke(), e.closePath()), e.restore();
  }
  getLetterSpacingAt(e = 0) {
    return this.letterSpacingCache[e] || 0;
  }
  findSegmentToFitChar(e, t, n, i, a, s, o, l, u) {
    let c = s, h = this.measureText(e, l);
    l === " " && t === "justify" && n < i && (h += (i - n) / a), u > -1 && (c += this.getLetterSpacingAt(u));
    const f = this.textHeight / 20, p = this.getEquidistantPointOnPath(c, f, 0), m = this.getEquidistantPointOnPath(c + h, f, 0), A = {
      p0: p,
      p1: m
    }, w = p && m ? Math.atan2(m.y - p.y, m.x - p.x) : 0;
    if (o) {
      const x = Math.cos(Math.PI / 2 + w) * o, E = Math.cos(-w) * o;
      A.p0 = {
        ...p,
        distance: p.distance || 0,
        x: p.x + x,
        y: p.y + E
      }, A.p1 = {
        ...m,
        distance: m.distance || 0,
        x: m.x + x,
        y: m.y + E
      };
    }
    return c += h, {
      offset: c,
      segment: A,
      rotation: w
    };
  }
  measureText(e, t) {
    const { measuresCache: n } = this, i = t || this.getText();
    if (n.has(i))
      return n.get(i);
    const a = this.measureTargetText(e, i);
    return n.set(i, a), a;
  }
  // This method supposes what all custom fonts already loaded.
  // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
  // You need to call this method manually to update glyphs cache.
  setTextData(e) {
    if (this.glyphInfo)
      return;
    const t = this.getText(), n = t.split(""), i = t.split(" ").length - 1, a = this.parent?.getAttribute("dx").split().map((T) => T.getPixels("x")), s = this.parent?.getAttribute("dy").getPixels("y"), o = this.getAttribute("text-anchor").getString("start"), l = this.getStyle("letter-spacing"), u = this.parent?.getStyle("letter-spacing");
    let c = 0;
    !l.hasValue() || l.getValue() === "inherit" ? c = u.getPixels() : l.hasValue() && l.getValue() !== "initial" && l.getValue() !== "unset" && (c = l.getPixels());
    const h = [], f = t.length;
    this.letterSpacingCache = h;
    for (let T = 0; T < f; T++)
      h.push(typeof a[T] < "u" ? a[T] : c);
    const p = h.reduce((T, D, F) => F === 0 ? 0 : T + D || 0, 0), m = this.measureText(e), A = Math.max(m + p, 0);
    this.textWidth = m, this.textHeight = this.getFontSize(), this.glyphInfo = [];
    const w = this.getPathLength(), x = this.getAttribute("startOffset").getNumber(0) * w;
    let E = 0;
    (o === "middle" || o === "center") && (E = -A / 2), (o === "end" || o === "right") && (E = -A), E += x, n.forEach((T, D) => {
      const {
        offset: F,
        segment: _,
        rotation: L
      } = this.findSegmentToFitChar(e, o, A, w, i, E, s, T, D);
      E = F, !(!_.p0 || !_.p1) && this.glyphInfo.push({
        // transposeX: midpoint.x,
        // transposeY: midpoint.y,
        text: n[D],
        p0: _.p0,
        p1: _.p1,
        rotation: L
      });
    });
  }
  parsePathData(e) {
    if (this.pathLength = -1, !e)
      return [];
    const t = [], { pathParser: n } = e;
    for (n.reset(); !n.isEnd(); ) {
      const { current: i } = n, a = i ? i.x : 0, s = i ? i.y : 0, o = n.next();
      let l = o.type, u = [];
      switch (o.type) {
        case Qr.MOVE_TO:
          this.pathM(n, u);
          break;
        case Qr.LINE_TO:
          l = this.pathL(n, u);
          break;
        case Qr.HORIZ_LINE_TO:
          l = this.pathH(n, u);
          break;
        case Qr.VERT_LINE_TO:
          l = this.pathV(n, u);
          break;
        case Qr.CURVE_TO:
          this.pathC(n, u);
          break;
        case Qr.SMOOTH_CURVE_TO:
          l = this.pathS(n, u);
          break;
        case Qr.QUAD_TO:
          this.pathQ(n, u);
          break;
        case Qr.SMOOTH_QUAD_TO:
          l = this.pathT(n, u);
          break;
        case Qr.ARC:
          u = this.pathA(n);
          break;
        case Qr.CLOSE_PATH:
          Yn.pathZ(n);
          break;
      }
      o.type !== Qr.CLOSE_PATH ? t.push({
        type: l,
        points: u,
        start: {
          x: a,
          y: s
        },
        pathLength: this.calcLength(a, s, l, u)
      }) : t.push({
        type: Qr.CLOSE_PATH,
        points: [],
        pathLength: 0
      });
    }
    return t;
  }
  pathM(e, t) {
    const { x: n, y: i } = Yn.pathM(e).point;
    t.push(n, i);
  }
  pathL(e, t) {
    const { x: n, y: i } = Yn.pathL(e).point;
    return t.push(n, i), Qr.LINE_TO;
  }
  pathH(e, t) {
    const { x: n, y: i } = Yn.pathH(e).point;
    return t.push(n, i), Qr.LINE_TO;
  }
  pathV(e, t) {
    const { x: n, y: i } = Yn.pathV(e).point;
    return t.push(n, i), Qr.LINE_TO;
  }
  pathC(e, t) {
    const { point: n, controlPoint: i, currentPoint: a } = Yn.pathC(e);
    t.push(n.x, n.y, i.x, i.y, a.x, a.y);
  }
  pathS(e, t) {
    const { point: n, controlPoint: i, currentPoint: a } = Yn.pathS(e);
    return t.push(n.x, n.y, i.x, i.y, a.x, a.y), Qr.CURVE_TO;
  }
  pathQ(e, t) {
    const { controlPoint: n, currentPoint: i } = Yn.pathQ(e);
    t.push(n.x, n.y, i.x, i.y);
  }
  pathT(e, t) {
    const { controlPoint: n, currentPoint: i } = Yn.pathT(e);
    return t.push(n.x, n.y, i.x, i.y), Qr.QUAD_TO;
  }
  pathA(e) {
    let { rX: t, rY: n, sweepFlag: i, xAxisRotation: a, centp: s, a1: o, ad: l } = Yn.pathA(e);
    return i === 0 && l > 0 && (l -= 2 * Math.PI), i === 1 && l < 0 && (l += 2 * Math.PI), [s.x, s.y, t, n, o, l, a, i];
  }
  calcLength(e, t, n, i) {
    let a = 0, s = null, o = null, l = 0;
    switch (n) {
      case Qr.LINE_TO:
        return this.getLineLength(e, t, i[0], i[1]);
      case Qr.CURVE_TO:
        for (a = 0, s = this.getPointOnCubicBezier(
          0,
          e,
          t,
          i[0],
          i[1],
          i[2],
          i[3],
          i[4],
          i[5]
        ), l = 0.01; l <= 1; l += 0.01)
          o = this.getPointOnCubicBezier(
            l,
            e,
            t,
            i[0],
            i[1],
            i[2],
            i[3],
            i[4],
            i[5]
          ), a += this.getLineLength(s.x, s.y, o.x, o.y), s = o;
        return a;
      case Qr.QUAD_TO:
        for (a = 0, s = this.getPointOnQuadraticBezier(0, e, t, i[0], i[1], i[2], i[3]), l = 0.01; l <= 1; l += 0.01)
          o = this.getPointOnQuadraticBezier(l, e, t, i[0], i[1], i[2], i[3]), a += this.getLineLength(s.x, s.y, o.x, o.y), s = o;
        return a;
      case Qr.ARC: {
        a = 0;
        const u = i[4], c = i[5], h = i[4] + c;
        let f = Math.PI / 180;
        if (Math.abs(u - h) < f && (f = Math.abs(u - h)), s = this.getPointOnEllipticalArc(i[0], i[1], i[2], i[3], u, 0), c < 0)
          for (l = u - f; l > h; l -= f)
            o = this.getPointOnEllipticalArc(i[0], i[1], i[2], i[3], l, 0), a += this.getLineLength(s.x, s.y, o.x, o.y), s = o;
        else
          for (l = u + f; l < h; l += f)
            o = this.getPointOnEllipticalArc(i[0], i[1], i[2], i[3], l, 0), a += this.getLineLength(s.x, s.y, o.x, o.y), s = o;
        return o = this.getPointOnEllipticalArc(i[0], i[1], i[2], i[3], h, 0), a += this.getLineLength(s.x, s.y, o.x, o.y), a;
      }
    }
    return 0;
  }
  getPointOnLine(e, t, n, i, a, s = t, o = n) {
    const l = (a - n) / (i - t + Dd);
    let u = Math.sqrt(e * e / (1 + l * l));
    i < t && (u *= -1);
    let c = l * u, h = null;
    if (i === t)
      h = {
        x: s,
        y: o + c
      };
    else if ((o - n) / (s - t + Dd) === l)
      h = {
        x: s + u,
        y: o + c
      };
    else {
      let f = 0, p = 0;
      const m = this.getLineLength(t, n, i, a);
      if (m < Dd)
        return null;
      let A = (s - t) * (i - t) + (o - n) * (a - n);
      A /= m * m, f = t + A * (i - t), p = n + A * (a - n);
      const w = this.getLineLength(s, o, f, p), x = Math.sqrt(e * e - w * w);
      u = Math.sqrt(x * x / (1 + l * l)), i < t && (u *= -1), c = l * u, h = {
        x: f + u,
        y: p + c
      };
    }
    return h;
  }
  getPointOnPath(e) {
    const t = this.getPathLength();
    let n = 0, i = null;
    if (e < -5e-5 || e - 5e-5 > t)
      return null;
    const { dataArray: a } = this;
    for (const s of a) {
      if (s && (s.pathLength < 5e-5 || n + s.pathLength + 5e-5 < e)) {
        n += s.pathLength;
        continue;
      }
      const o = e - n;
      let l = 0;
      switch (s.type) {
        case Qr.LINE_TO:
          i = this.getPointOnLine(
            o,
            s.start.x,
            s.start.y,
            s.points[0],
            s.points[1],
            s.start.x,
            s.start.y
          );
          break;
        case Qr.ARC: {
          const u = s.points[4], c = s.points[5], h = s.points[4] + c;
          if (l = u + o / s.pathLength * c, c < 0 && l < h || c >= 0 && l > h)
            break;
          i = this.getPointOnEllipticalArc(
            s.points[0],
            s.points[1],
            s.points[2],
            s.points[3],
            l,
            s.points[6]
          );
          break;
        }
        case Qr.CURVE_TO:
          l = o / s.pathLength, l > 1 && (l = 1), i = this.getPointOnCubicBezier(
            l,
            s.start.x,
            s.start.y,
            s.points[0],
            s.points[1],
            s.points[2],
            s.points[3],
            s.points[4],
            s.points[5]
          );
          break;
        case Qr.QUAD_TO:
          l = o / s.pathLength, l > 1 && (l = 1), i = this.getPointOnQuadraticBezier(
            l,
            s.start.x,
            s.start.y,
            s.points[0],
            s.points[1],
            s.points[2],
            s.points[3]
          );
          break;
      }
      if (i)
        return i;
      break;
    }
    return null;
  }
  getLineLength(e, t, n, i) {
    return Math.sqrt((n - e) * (n - e) + (i - t) * (i - t));
  }
  getPathLength() {
    return this.pathLength === -1 && (this.pathLength = this.dataArray.reduce(
      (e, t) => t.pathLength > 0 ? e + t.pathLength : e,
      0
    )), this.pathLength;
  }
  getPointOnCubicBezier(e, t, n, i, a, s, o, l, u) {
    const c = l * dE(e) + s * hE(e) + i * pE(e) + t * gE(e), h = u * dE(e) + o * hE(e) + a * pE(e) + n * gE(e);
    return {
      x: c,
      y: h
    };
  }
  getPointOnQuadraticBezier(e, t, n, i, a, s, o) {
    const l = s * mE(e) + i * vE(e) + t * yE(e), u = o * mE(e) + a * vE(e) + n * yE(e);
    return {
      x: l,
      y: u
    };
  }
  getPointOnEllipticalArc(e, t, n, i, a, s) {
    const o = Math.cos(s), l = Math.sin(s), u = {
      x: n * Math.cos(a),
      y: i * Math.sin(a)
    };
    return {
      x: e + (u.x * o - u.y * l),
      y: t + (u.x * l + u.y * o)
    };
  }
  // TODO need some optimisations. possibly build cache only for curved segments?
  buildEquidistantCache(e, t) {
    const n = this.getPathLength(), i = t || 0.25, a = e || n / 100;
    if (!this.equidistantCache || this.equidistantCache.step !== a || this.equidistantCache.precision !== i) {
      this.equidistantCache = {
        step: a,
        precision: i,
        points: []
      };
      let s = 0;
      for (let o = 0; o <= n; o += i) {
        const l = this.getPointOnPath(o), u = this.getPointOnPath(o + i);
        !l || !u || (s += this.getLineLength(l.x, l.y, u.x, u.y), s >= a && (this.equidistantCache.points.push({
          x: l.x,
          y: l.y,
          distance: o
        }), s -= a));
      }
    }
  }
  getEquidistantPointOnPath(e, t, n) {
    if (this.buildEquidistantCache(t, n), e < 0 || e - this.getPathLength() > 5e-5)
      return null;
    const i = Math.round(e / this.getPathLength() * (this.equidistantCache.points.length - 1));
    return this.equidistantCache.points[i] || null;
  }
}
const eU = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
class tU extends Gf {
  constructor(e, t, n) {
    super(e, t, n), this.type = "image", this.loaded = !1;
    const i = this.getHrefAttribute().getString();
    if (!i)
      return;
    const a = i.endsWith(".svg") || /^\s*data:image\/svg\+xml/i.test(i);
    e.images.push(this), a ? this.loadSvg(i) : this.loadImage(i);
  }
  async loadImage(e) {
    try {
      const t = await this.document.createImage(e, !0);
      this.image = t;
    } catch (t) {
      console.error(`Error while loading image "${e}":`, t);
    }
    this.loaded = !0;
  }
  async loadSvg(e) {
    const t = eU.exec(e);
    if (t) {
      const n = t[5];
      n && (t[4] === "base64" ? this.image = atob(n) : this.image = decodeURIComponent(n));
    } else
      try {
        const n = await (await this.document.fetch(e)).text();
        this.image = n;
      } catch (n) {
        console.error(`Error while loading image "${e}":`, n);
      }
    this.loaded = !0;
  }
  renderChildren(e) {
    const { document: t, image: n, loaded: i } = this, a = this.getAttribute("x").getPixels("x"), s = this.getAttribute("y").getPixels("y"), o = this.getStyle("width").getPixels("x"), l = this.getStyle("height").getPixels("y");
    if (!(!i || !n || !o || !l)) {
      if (e.save(), e.translate(a, s), typeof n == "string") {
        const u = t.pith.forkString(e, n, {
          ignoreMouse: !0,
          ignoreAnimation: !0,
          ignoreDimensions: !0,
          ignoreClear: !0,
          offsetX: 0,
          offsetY: 0,
          scaleWidth: o,
          scaleHeight: l
        }), { documentElement: c } = u.document;
        c && (c.parent = this), u.resize(o, l, this.getAttribute("preserveAspectRatio").getString()), u.render();
      } else
        t.setViewBox({
          ctx: e,
          aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
          width: o,
          desiredWidth: n.width,
          height: l,
          desiredHeight: n.height
        }), this.loaded && (!("complete" in n) || n.complete) && e.drawImage(n, 0, 0);
      e.restore();
    }
  }
  getBoundingBox() {
    const e = this.getAttribute("x").getPixels("x"), t = this.getAttribute("y").getPixels("y"), n = this.getStyle("width").getPixels("x"), i = this.getStyle("height").getPixels("y");
    return new Zo(e, t, e + n, t + i);
  }
}
class rU extends Gf {
  constructor() {
    super(...arguments), this.type = "symbol";
  }
  render(e) {
  }
}
class nU {
  constructor(e) {
    this.document = e, this.loaded = !1, e.fonts.push(this);
  }
  async load(e, t) {
    try {
      const { document: n } = this, i = (await n.pith.parser.load(t)).getElementsByTagName("font");
      Array.from(i).forEach((a) => {
        const s = n.createElement(a);
        n.definitions[e] = s;
      });
    } catch (n) {
      console.error(`Error while loading font "${t}":`, n);
    }
    this.loaded = !0;
  }
}
const uP = class extends Ea {
  constructor(e, t, n) {
    super(e, t, n), this.type = "style", pg(
      Array.from(t.childNodes).map((i) => i.textContent).join("").replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "").replace(/@import.*;/g, "")
      // remove imports
    ).split("}").forEach((i) => {
      const a = i.trim();
      if (!a)
        return;
      const s = a.split("{"), o = s[0].split(","), l = s[1].split(";");
      o.forEach((u) => {
        const c = u.trim();
        if (!c)
          return;
        const h = e.styles[c] || {};
        if (l.forEach((f) => {
          const p = f.indexOf(":"), m = f.substr(0, p).trim(), A = f.substr(p + 1, f.length - p).trim();
          m && A && (h[m] = new wr(e, m, A));
        }), e.styles[c] = h, e.stylesSpecificity[c] = x7(c), c === "@font-face") {
          const f = h["font-family"].getString().replace(/"|'/g, "");
          h.src.getString().split(",").forEach((p) => {
            if (p.indexOf('format("svg")') > 0) {
              const m = YI(p);
              m && new nU(e).load(f, m);
            }
          });
        }
      });
    });
  }
};
uP.parseExternalUrl = YI;
let iU = uP;
class aU extends Gf {
  constructor() {
    super(...arguments), this.type = "use";
  }
  setContext(e) {
    super.setContext(e);
    const t = this.getAttribute("x"), n = this.getAttribute("y");
    t.hasValue() && e.translate(t.getPixels("x"), 0), n.hasValue() && e.translate(0, n.getPixels("y"));
  }
  path(e) {
    const { element: t } = this;
    t && t.path(e);
  }
  renderChildren(e) {
    const { document: t, element: n } = this;
    if (n) {
      let i = n;
      if (n.type === "symbol" && (i = new gg(t), i.attributes.viewBox = new wr(
        t,
        "viewBox",
        n.getAttribute("viewBox").getString()
      ), i.attributes.preserveAspectRatio = new wr(
        t,
        "preserveAspectRatio",
        n.getAttribute("preserveAspectRatio").getString()
      ), i.attributes.overflow = new wr(
        t,
        "overflow",
        n.getAttribute("overflow").getString()
      ), i.children = n.children, n.styles.opacity = new wr(t, "opacity", this.calculateOpacity())), i.type === "svg") {
        const s = this.getStyle("width", !1, !0), o = this.getStyle("height", !1, !0);
        s.hasValue() && (i.attributes.width = new wr(t, "width", s.getString())), o.hasValue() && (i.attributes.height = new wr(t, "height", o.getString()));
      }
      const a = i.parent;
      i.parent = this, i.render(e), i.parent = a;
    }
  }
  getBoundingBox(e) {
    const { element: t } = this;
    return t ? t.getBoundingBox(e) : null;
  }
  elementTransform() {
    const { document: e, element: t } = this;
    return t ? Gw.fromElement(e, t) : null;
  }
  get element() {
    return this.cachedElement || (this.cachedElement = this.getHrefAttribute().getDefinition()), this.cachedElement;
  }
}
function na(r, e, t) {
  return r[e] * t;
}
function yu(r, e, t, n) {
  return e + Math.cos(r) * t + Math.sin(r) * n;
}
class cP extends zf {
  constructor(e, t, n) {
    super(e, t, n), this.type = "feColorMatrix";
    let i = ks(this.getAttribute("values").getString());
    switch (this.getAttribute("type").getString("matrix")) {
      case "saturate": {
        const a = i[0];
        i = [
          0.213 + 0.787 * a,
          0.715 - 0.715 * a,
          0.072 - 0.072 * a,
          0,
          0,
          0.213 - 0.213 * a,
          0.715 + 0.285 * a,
          0.072 - 0.072 * a,
          0,
          0,
          0.213 - 0.213 * a,
          0.715 - 0.715 * a,
          0.072 + 0.928 * a,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1
        ];
        break;
      }
      case "hueRotate": {
        const a = i[0] * Math.PI / 180;
        i = [
          yu(a, 0.213, 0.787, -0.213),
          yu(a, 0.715, -0.715, -0.715),
          yu(a, 0.072, -0.072, 0.928),
          0,
          0,
          yu(a, 0.213, -0.213, 0.143),
          yu(a, 0.715, 0.285, 0.14),
          yu(a, 0.072, -0.072, -0.283),
          0,
          0,
          yu(a, 0.213, -0.213, -0.787),
          yu(a, 0.715, -0.715, 0.715),
          yu(a, 0.072, 0.928, 0.072),
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1
        ];
        break;
      }
      case "luminanceToAlpha":
        i = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2125, 0.7154, 0.0721, 0, 0, 0, 0, 0, 0, 1];
        break;
    }
    this.matrix = i, this.includeOpacity = this.getAttribute("includeOpacity").hasValue();
  }
  apply(e, t, n, i, a) {
    const { includeOpacity: s, matrix: o } = this, l = e.getImageData(0, 0, i, a);
    for (let u = 0; u < a; u++)
      for (let c = 0; c < i; c++) {
        const h = Pf(l.data, c, u, i, a, 0), f = Pf(l.data, c, u, i, a, 1), p = Pf(l.data, c, u, i, a, 2), m = Pf(l.data, c, u, i, a, 3);
        let A = na(o, 0, h) + na(o, 1, f) + na(o, 2, p) + na(o, 3, m) + na(o, 4, 1), w = na(o, 5, h) + na(o, 6, f) + na(o, 7, p) + na(o, 8, m) + na(o, 9, 1), x = na(o, 10, h) + na(o, 11, f) + na(o, 12, p) + na(o, 13, m) + na(o, 14, 1), E = na(o, 15, h) + na(o, 16, f) + na(o, 17, p) + na(o, 18, m) + na(o, 19, 1);
        s && (A = 0, w = 0, x = 0, E *= m / 255), Df(l.data, c, u, i, a, 0, A), Df(l.data, c, u, i, a, 1, w), Df(l.data, c, u, i, a, 2, x), Df(l.data, c, u, i, a, 3, E);
      }
    e.clearRect(0, 0, i, a), e.putImageData(l, 0, 0);
  }
}
const fP = class dP extends Ea {
  constructor() {
    super(...arguments), this.type = "mask";
  }
  apply(e, t) {
    const { document: n } = this;
    let i = this.getAttribute("x").getPixels("x"), a = this.getAttribute("y").getPixels("y"), s = this.getStyle("width").getPixels("x"), o = this.getStyle("height").getPixels("y");
    if (!s && !o) {
      const p = new Zo();
      this.children.forEach((m) => {
        m instanceof Yn && p.addBoundingBox(m.getBoundingBox(e));
      }), i = Math.floor(p.x1), a = Math.floor(p.y1), s = Math.floor(p.width), o = Math.floor(p.height);
    }
    const l = this.removeStyles(t, dP.ignoreStyles), u = n.createCanvas(i + s, a + o), c = u.getContext("2d");
    n.screen.setDefaults(c), this.renderChildren(c), new cP(n, {
      nodeType: 1,
      childNodes: [],
      attributes: [
        {
          nodeName: "type",
          value: "luminanceToAlpha"
        },
        {
          nodeName: "includeOpacity",
          value: "true"
        }
      ]
    }).apply(c, 0, 0, i + s, a + o);
    const h = n.createCanvas(i + s, a + o), f = h.getContext("2d");
    n.screen.setDefaults(f), t.render(f), f.globalCompositeOperation = "destination-in", f.fillStyle = c.createPattern(u, "no-repeat"), f.fillRect(0, 0, i + s, a + o), e.fillStyle = f.createPattern(h, "no-repeat"), e.fillRect(0, 0, i + s, a + o), this.restoreStyles(t, l);
  }
  render(e) {
  }
};
fP.ignoreStyles = ["mask", "transform", "clip-path"];
let sU = fP;
const wE = () => {
};
class oU extends Ea {
  constructor() {
    super(...arguments), this.type = "clipPath";
  }
  apply(e) {
    const { document: t } = this, n = Reflect.getPrototypeOf(e), { beginPath: i, closePath: a } = e;
    n && (n.beginPath = wE, n.closePath = wE), Reflect.apply(i, e, []), this.children.forEach((s) => {
      if (!("path" in s))
        return;
      let o = "elementTransform" in s ? s.elementTransform() : null;
      o || (o = Gw.fromElement(t, s)), o && o.apply(e), s.path(e), n && (n.closePath = a), o && o.unapply(e);
    }), Reflect.apply(a, e, []), e.clip(), n && (n.beginPath = i, n.closePath = a);
  }
  render(e) {
  }
}
class hP extends zf {
  constructor(e, t, n) {
    super(e, t, n), this.type = "feGaussianBlur", this.blurRadius = Math.floor(this.getAttribute("stdDeviation").getNumber()), this.extraFilterDistance = this.blurRadius;
  }
  apply(e, t, n, i, a) {
    const { document: s, blurRadius: o } = this, l = s.window ? s.window.document.body : null, u = e.canvas;
    u.id = s.getUniqueId(), l && (u.style.display = "none", l.appendChild(u)), l7(u, t, n, i, a, o), l && l.removeChild(u);
  }
}
const pP = class gP extends Ea {
  constructor() {
    super(...arguments), this.type = "filter";
  }
  apply(e, t) {
    const { document: n, children: i } = this, a = "getBoundingBox" in t ? t.getBoundingBox(e) : null;
    if (!a)
      return;
    let s = 0, o = 0;
    i.forEach((x) => {
      if (!(x instanceof hP))
        return;
      const E = x.extraFilterDistance || 0;
      s = Math.max(s, E), o = Math.max(o, E);
    });
    const l = Math.floor(a.width), u = Math.floor(a.height), c = l + 2 * s, h = u + 2 * o;
    if (Number.isNaN(c) || Number.isNaN(h) || c < 1 || h < 1)
      return;
    const f = Math.floor(a.x), p = Math.floor(a.y), m = this.removeStyles(t, gP.ignoreStyles), A = n.createCanvas(c, h), w = A.getContext("2d");
    n.screen.setDefaults(w), w.translate(-f + s, -p + o), t.render(w), i.forEach((x) => {
      x instanceof zf && x.apply(w, 0, 0, c, h);
    }), e.drawImage(
      A,
      0,
      0,
      c,
      h,
      f - s,
      p - o,
      c,
      h
    ), this.restoreStyles(t, m);
  }
  render(e) {
  }
};
pP.ignoreStyles = ["filter", "transform", "clip-path"];
let lU = pP;
class uU extends zf {
  constructor(e, t, n) {
    super(e, t, n), this.type = "feDropShadow", this.addStylesFromStyleDefinition();
  }
  apply(e, t, n, i, a) {
  }
}
class cU extends zf {
  constructor() {
    super(...arguments), this.type = "feMorphology";
  }
  apply(e, t, n, i, a) {
  }
}
class fU extends zf {
  constructor() {
    super(...arguments), this.type = "feComposite";
  }
  apply(e, t, n, i, a) {
  }
}
class dU extends Ea {
  constructor() {
    super(...arguments), this.type = "title";
  }
}
class hU extends Ea {
  constructor() {
    super(...arguments), this.type = "desc";
  }
}
class qw extends Ea {
  constructor(e, t, n) {
    super(e, t, n), this.tableValues = ks(this.getAttribute("tableValues").getString());
  }
}
class mP extends qw {
  constructor() {
    super(...arguments), this.type = "feFuncR";
  }
}
class vP extends qw {
  constructor() {
    super(...arguments), this.type = "feFuncG";
  }
}
class yP extends qw {
  constructor() {
    super(...arguments), this.type = "feFuncB";
  }
}
class pU extends zf {
  constructor(e, t, n) {
    super(e, t, n), this.type = "feComponentTransfer";
  }
  // New pixel value in accordance with the logic in the spec.
  // https://www.w3.org/TR/SVG11/filters.html#feComponentTransferElement
  // At the time of writing, assume the func elements are always the discrete type.
  calculateDiscrete(e, t) {
    const n = e / 255, i = t.tableValues.length;
    if (n === 1)
      return 255 * t.tableValues[i - 1];
    for (let a = 0; a < i; a++)
      if (a / i <= n && n < (a + 1) / i)
        return 255 * t.tableValues[a];
    return 255 * t.tableValues[0];
  }
  apply(e, t, n, i, a) {
    const { children: s } = this;
    let o, l, u;
    s.forEach((h) => {
      h instanceof mP ? o = h : h instanceof vP ? l = h : h instanceof yP && (u = h);
    });
    const c = e.getImageData(0, 0, i, a);
    for (let h = 0; h < a; h++)
      for (let f = 0; f < i; f++) {
        const p = Pf(c.data, f, h, i, a, 0), m = Pf(c.data, f, h, i, a, 1), A = Pf(c.data, f, h, i, a, 2), w = this.calculateDiscrete(p, o), x = this.calculateDiscrete(m, l), E = this.calculateDiscrete(A, u);
        Df(c.data, f, h, i, a, 0, w), Df(c.data, f, h, i, a, 1, x), Df(c.data, f, h, i, a, 2, E);
      }
    e.clearRect(0, 0, i, a), e.putImageData(c, 0, 0);
  }
}
const gU = {
  svg: gg,
  rect: iP,
  circle: L7,
  ellipse: U7,
  line: V7,
  polyline: aP,
  polygon: $7,
  path: Yn,
  pattern: z7,
  marker: G7,
  defs: H7,
  linearGradient: W7,
  radialGradient: j7,
  stop: q7,
  animate: Ww,
  animateColor: Q7,
  animateTransform: Y7,
  font: X7,
  "font-face": oP,
  "missing-glyph": lP,
  glyph: jw,
  text: Rc,
  tspan: H0,
  tref: J7,
  a: K7,
  textPath: Z7,
  image: tU,
  g: Hw,
  symbol: rU,
  style: iU,
  use: aU,
  mask: sU,
  clipPath: oU,
  filter: lU,
  feDropShadow: uU,
  feFuncR: mP,
  feFuncG: vP,
  feFuncB: yP,
  feMorphology: cU,
  feComponentTransfer: pU,
  feComposite: fU,
  feColorMatrix: cP,
  feGaussianBlur: hP,
  title: dU,
  desc: hU
};
function mU(r, e) {
  const t = document.createElement("canvas");
  return t.width = r, t.height = e, t;
}
async function vU(r, e = !1) {
  const t = document.createElement("img");
  return e && (t.crossOrigin = "Anonymous"), new Promise((n, i) => {
    t.onload = () => {
      n(t);
    }, t.onerror = (a, s, o, l, u) => {
      i(u);
    }, t.src = r;
  });
}
const iy = 12, qm = class Qm {
  constructor(e, {
    rootEmSize: t = iy,
    emSize: n = iy,
    createCanvas: i = Qm.createCanvas,
    createImage: a = Qm.createImage,
    anonymousCrossOrigin: s
  } = {}) {
    this.pith = e, this.definitions = {}, this.styles = {}, this.stylesSpecificity = {}, this.images = [], this.fonts = [], this.emSizeStack = [], this.uniqueId = 0, this.screen = e.screen, this.rootEmSize = t, this.emSize = n, this.createCanvas = i, this.createImage = this.bindCreateImage(a, s), this.screen.wait(() => this.isImagesLoaded()), this.screen.wait(() => this.isFontsLoaded());
  }
  bindCreateImage(e, t) {
    return typeof t == "boolean" ? (n, i) => e(
      n,
      typeof i == "boolean" ? i : t
    ) : e;
  }
  get window() {
    return this.screen.window;
  }
  get fetch() {
    return this.screen.fetch;
  }
  get ctx() {
    return this.screen.ctx;
  }
  get emSize() {
    const { emSizeStack: e } = this;
    return e[e.length - 1] || iy;
  }
  set emSize(e) {
    const { emSizeStack: t } = this;
    t.push(e);
  }
  popEmSize() {
    const { emSizeStack: e } = this;
    e.pop();
  }
  getUniqueId() {
    return `pith${++this.uniqueId}`;
  }
  isImagesLoaded() {
    return this.images.every((e) => e.loaded);
  }
  isFontsLoaded() {
    return this.fonts.every((e) => e.loaded);
  }
  createDocumentElement(e) {
    const t = this.createElement(e.documentElement, "svg");
    return t.root = !0, t.addStylesFromStyleDefinition(), this.documentElement = t, t;
  }
  createElement(e, t) {
    const n = t || e.nodeName.replace(/^[^:]+:/, ""), i = Qm.elementTypes[n];
    return i ? new i(this, e) : new R7(this, e);
  }
  createTextNode(e) {
    return new N7(this, e);
  }
  setViewBox(e) {
    this.screen.setViewBox({
      document: this,
      ...e
    });
  }
};
qm.createCanvas = mU, qm.createImage = vU, qm.elementTypes = gU;
let yU = qm;
class vc {
  /**
   * Create Pith instance from SVG source string or URL.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Pith instance.
   */
  static async from(e, t, n = {}) {
    const i = await new ny(n).parse(t);
    return new vc(e, i, n);
  }
  /**
   * Create Pith instance from SVG source string.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Pith instance.
   */
  static fromString(e, t, n = {}) {
    const i = new ny(n).parseFromString(t);
    return new vc(e, i, n);
  }
  /**
   * Main constructor.
   * @param ctx - Rendering context.
   * @param svg - SVG Document.
   * @param options - Rendering options.
   */
  constructor(e, t, n = {}) {
    this.parser = new ny(n), this.screen = new zw(e, n), this.options = n;
    const i = new yU(this, n), a = i.createDocumentElement(t);
    this.document = i, this.documentElement = a;
  }
  /**
   * Create new Pith instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Pith instance.
   */
  fork(e, t, n = {}) {
    return vc.from(e, t, {
      ...this.options,
      ...n
    });
  }
  /**
   * Create new Pith instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Pith instance.
   */
  forkString(e, t, n = {}) {
    return vc.fromString(e, t, {
      ...this.options,
      ...n
    });
  }
  /**
   * Document is ready promise.
   * @returns Ready promise.
   */
  ready() {
    return this.screen.ready();
  }
  /**
   * Document is ready value.
   * @returns Is ready or not.
   */
  isReady() {
    return this.screen.isReady();
  }
  /**
   * Render only first frame, ignoring animations and mouse.
   * @param options - Rendering options.
   */
  async render(e = {}) {
    this.start({
      enableRedraw: !0,
      ignoreAnimation: !0,
      ignoreMouse: !0,
      ...e
    }), await this.ready(), this.stop();
  }
  /**
   * Start rendering.
   * @param options - Render options.
   */
  start(e = {}) {
    const { documentElement: t, screen: n, options: i } = this;
    n.start(t, {
      enableRedraw: !0,
      ...i,
      ...e
    });
  }
  /**
   * Stop rendering.
   */
  stop() {
    this.screen.stop();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(e, t = e, n = !1) {
    this.documentElement.resize(e, t, n);
  }
}
const ay = [gt.SilentIllustration, gt.ProductOverlay], sy = (r) => {
  const e = [];
  for (const n of r.steps) {
    const i = AU(n.stepName, r.stepGroups);
    if (!i)
      throw new Error(
        "Workflow step does not belong to a group, all steps must belong to a group. Step: " + n.stepName
      );
    const a = e.find((s) => s.name === i.name);
    a ? ay.includes(n.type) ? a.silentSteps.push(n) : a.renderableSteps.push(n) : e.push({
      name: i.name,
      title: i.name,
      renderableSteps: ay.includes(n.type) ? [] : [n],
      silentSteps: ay.includes(n.type) ? [n] : []
    });
  }
  const t = "workflow.steps.finish.confirmDesign";
  return e.push({
    name: "Finish",
    title: t,
    renderableSteps: [
      {
        type: gt.Finish,
        stepName: "Finish",
        stepTitle: t,
        helpText: "",
        data: {
          modelAnimation: r.finalizeStepConfig ? r.finalizeStepConfig.modelAnimation : void 0,
          lookAtAnimation: r.finalizeStepConfig ? r.finalizeStepConfig.lookAtAnimation : void 0
        },
        conditions: []
      }
    ],
    silentSteps: []
  }), e;
}, AU = (r, e) => e.find((t) => t.stepNames.includes(r)), yc = async (r, e) => {
  const t = r.conditions || [];
  return (await Promise.all(
    t.map(async (a, s) => {
      const o = e[a.targetStepName];
      if (o && o.selectedVariants) {
        const l = o.selectedVariants;
        return a.type === "VariantMetafield" ? (await J1.ensureIdsArePresent(l.map((c) => c.id)), a.requiredVariantMetafields?.some((c) => l.find((h) => J1.requestIfAvailable(
          h.id,
          c.variantMetafieldConfigurationId || ""
        )?.value === c.variantMetafieldValue))) : a.requiredVariantSelections.some(
          (c) => l.find((h) => h.id === c) !== void 0
        );
      }
      return !1;
    })
  )).every((a) => a);
}, wU = async (r, e) => {
  const t = await Promise.all(
    r.renderableSteps.map((o) => yc(o, e))
  ), n = r.renderableSteps.filter((o, l) => t[l]), i = await Promise.all(
    r.silentSteps.map((o) => yc(o, e))
  ), a = r.silentSteps.filter((o, l) => i[l]), s = {
    name: r.name,
    title: r.title,
    renderableSteps: n,
    silentSteps: a
  };
  return s.silentSteps.length === 0 && s.renderableSteps.length === 0 ? null : s;
}, kl = async (r, e) => (await Promise.all(r.map((n) => wU(n, e)))).filter((n) => n !== null), xU = async (r, e, t = !1) => {
  const n = await kl(r, e), i = [];
  for (const s of n)
    for (const o of s.renderableSteps) {
      let l = 0;
      if (o.type !== "Finish" && o.type !== "Module") {
        let u;
        o.option?.variants ? (u = o.option, l = u?.variants?.length || 0) : (u = await Pt.getOption(o.option?.id), l = u?.variants?.length || 0);
      }
      o.silent || (o.type === gt.Model || o.type === gt.Material || o.type === gt.Picture || o.type === gt.Shape ? (l > 1 || t) && i.push(o.stepName) : i.push(o.stepName));
    }
  const a = n.filter((s) => s.renderableSteps.filter(
    (l) => i.includes(l.stepName)
  ).length > 0);
  for (const s of a)
    s.renderableSteps = s.renderableSteps.filter(
      (o) => i.includes(o.stepName)
    );
  return a;
};
class Qw {
  constructor() {
    this.timestamp = Date.now();
  }
}
class Yw {
  /**
   * Constructs a new promise queue.
   * @param queueMaxSize An optional maximum size, when the max size is hit.
   *                     The older promises will be discarded.
   * @param enabled When false, the queue will not process any jobs. Assign `enabled` to true to start processing.
   */
  constructor(e, t = !0) {
    this.queue = [], this.activePromise = void 0, this.queueMaxSize = void 0, this.queueMaxSize = e, this.isEnabled = t;
  }
  /**
   * Enqueue a new promise.
   * @param promise A new promise to add to the queue.
   */
  enqueue(e) {
    if (this.queue.push(e), this.queueMaxSize !== void 0 && this.queue.length > this.queueMaxSize) {
      const t = this.queue.length - 1;
      for (let n = 0; n < t; ++n)
        this.queue.shift();
    }
    this.isEnabled && (this.activePromise || (this.activePromise = this.dequeue()));
  }
  get enabled() {
    return this.isEnabled;
  }
  /**
   * Enable or disable the queue. When disabled, the queue will not process any jobs.
   * Disabling processing will not cancel any active promises.
   */
  set enabled(e) {
    !this.isEnabled && e && !this.activePromise && this.getRemainingQueueSize() > 0 && (this.activePromise = this.dequeue()), this.isEnabled = e;
  }
  /**
   * @returns Returns true when work is being actively processed by this queue.
   */
  hasActivePromise() {
    return !!this.activePromise;
  }
  /**
   * @returns The number of unexecuted jobs remaining in the queue. Not including the active job.
   */
  getRemainingQueueSize() {
    return this.queue.length;
  }
  /**
   * Finalize the queue, any jobs that come in while this is in progress will result
   * in the promise being extended.
   */
  async finalize() {
    return this.activePromise ? this.activePromise : Promise.resolve();
  }
  /**
   * Once called will recursively resolve the jobs in the
   * queue until no more are available.
   */
  async dequeue() {
    const e = this.queue.shift();
    if (!e) {
      this.activePromise = void 0;
      return;
    }
    try {
      await e.execute();
    } catch (t) {
      console.log(t);
    } finally {
      await this.dequeue();
    }
  }
}
var yp = { exports: {} };
yp.exports;
var xE;
function bU() {
  return xE || (xE = 1, (function(r, e) {
    var t = 200, n = "__lodash_hash_undefined__", i = 9007199254740991, a = "[object Arguments]", s = "[object Array]", o = "[object Boolean]", l = "[object Date]", u = "[object Error]", c = "[object Function]", h = "[object GeneratorFunction]", f = "[object Map]", p = "[object Number]", m = "[object Object]", A = "[object Promise]", w = "[object RegExp]", x = "[object Set]", E = "[object String]", T = "[object Symbol]", D = "[object WeakMap]", F = "[object ArrayBuffer]", _ = "[object DataView]", L = "[object Float32Array]", Z = "[object Float64Array]", te = "[object Int8Array]", de = "[object Int16Array]", H = "[object Int32Array]", j = "[object Uint8Array]", q = "[object Uint8ClampedArray]", re = "[object Uint16Array]", ae = "[object Uint32Array]", ye = /[\\^$.*+?()[\]{}|]/g, Se = /\w*$/, Xe = /^\[object .+?Constructor\]$/, Ve = /^(?:0|[1-9]\d*)$/, He = {};
    He[a] = He[s] = He[F] = He[_] = He[o] = He[l] = He[L] = He[Z] = He[te] = He[de] = He[H] = He[f] = He[p] = He[m] = He[w] = He[x] = He[E] = He[T] = He[j] = He[q] = He[re] = He[ae] = !0, He[u] = He[c] = He[D] = !1;
    var le = typeof Ni == "object" && Ni && Ni.Object === Object && Ni, ve = typeof self == "object" && self && self.Object === Object && self, it = le || ve || Function("return this")(), mt = e && !e.nodeType && e, qe = mt && !0 && r && !r.nodeType && r, at = qe && qe.exports === mt;
    function st(R, X) {
      return R.set(X[0], X[1]), R;
    }
    function lt(R, X) {
      return R.add(X), R;
    }
    function rt(R, X) {
      for (var pe = -1, Re = R ? R.length : 0; ++pe < Re && X(R[pe], pe, R) !== !1; )
        ;
      return R;
    }
    function Rt(R, X) {
      for (var pe = -1, Re = X.length, Bt = R.length; ++pe < Re; )
        R[Bt + pe] = X[pe];
      return R;
    }
    function Fr(R, X, pe, Re) {
      for (var Bt = -1, Tt = R ? R.length : 0; ++Bt < Tt; )
        pe = X(pe, R[Bt], Bt, R);
      return pe;
    }
    function an(R, X) {
      for (var pe = -1, Re = Array(R); ++pe < R; )
        Re[pe] = X(pe);
      return Re;
    }
    function ar(R, X) {
      return R?.[X];
    }
    function Ir(R) {
      var X = !1;
      if (R != null && typeof R.toString != "function")
        try {
          X = !!(R + "");
        } catch {
        }
      return X;
    }
    function kt(R) {
      var X = -1, pe = Array(R.size);
      return R.forEach(function(Re, Bt) {
        pe[++X] = [Bt, Re];
      }), pe;
    }
    function wt(R, X) {
      return function(pe) {
        return R(X(pe));
      };
    }
    function Mn(R) {
      var X = -1, pe = Array(R.size);
      return R.forEach(function(Re) {
        pe[++X] = Re;
      }), pe;
    }
    var kr = Array.prototype, Gr = Function.prototype, Pr = Object.prototype, Cr = it["__core-js_shared__"], qt = (function() {
      var R = /[^.]+$/.exec(Cr && Cr.keys && Cr.keys.IE_PROTO || "");
      return R ? "Symbol(src)_1." + R : "";
    })(), lr = Gr.toString, It = Pr.hasOwnProperty, Zr = Pr.toString, Cn = RegExp(
      "^" + lr.call(It).replace(ye, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Sn = at ? it.Buffer : void 0, vr = it.Symbol, ln = it.Uint8Array, en = wt(Object.getPrototypeOf, Object), Fn = Object.create, gn = Pr.propertyIsEnumerable, Gn = kr.splice, Hn = Object.getOwnPropertySymbols, tn = Sn ? Sn.isBuffer : void 0, mn = wt(Object.keys, Object), In = vt(it, "DataView"), vn = vt(it, "Map"), fr = vt(it, "Promise"), Or = vt(it, "Set"), sn = vt(it, "WeakMap"), yt = vt(Object, "create"), yn = wn(In), Nn = wn(vn), Me = wn(fr), M = wn(Or), W = wn(sn), se = vr ? vr.prototype : void 0, we = se ? se.valueOf : void 0;
    function $e(R) {
      var X = -1, pe = R ? R.length : 0;
      for (this.clear(); ++X < pe; ) {
        var Re = R[X];
        this.set(Re[0], Re[1]);
      }
    }
    function ut() {
      this.__data__ = yt ? yt(null) : {};
    }
    function Mt(R) {
      return this.has(R) && delete this.__data__[R];
    }
    function Zt(R) {
      var X = this.__data__;
      if (yt) {
        var pe = X[R];
        return pe === n ? void 0 : pe;
      }
      return It.call(X, R) ? X[R] : void 0;
    }
    function rr(R) {
      var X = this.__data__;
      return yt ? X[R] !== void 0 : It.call(X, R);
    }
    function Br(R, X) {
      var pe = this.__data__;
      return pe[R] = yt && X === void 0 ? n : X, this;
    }
    $e.prototype.clear = ut, $e.prototype.delete = Mt, $e.prototype.get = Zt, $e.prototype.has = rr, $e.prototype.set = Br;
    function sr(R) {
      var X = -1, pe = R ? R.length : 0;
      for (this.clear(); ++X < pe; ) {
        var Re = R[X];
        this.set(Re[0], Re[1]);
      }
    }
    function ue() {
      this.__data__ = [];
    }
    function ze(R) {
      var X = this.__data__, pe = ni(X, R);
      if (pe < 0)
        return !1;
      var Re = X.length - 1;
      return pe == Re ? X.pop() : Gn.call(X, pe, 1), !0;
    }
    function ct(R) {
      var X = this.__data__, pe = ni(X, R);
      return pe < 0 ? void 0 : X[pe][1];
    }
    function ft(R) {
      return ni(this.__data__, R) > -1;
    }
    function Vt(R, X) {
      var pe = this.__data__, Re = ni(pe, R);
      return Re < 0 ? pe.push([R, X]) : pe[Re][1] = X, this;
    }
    sr.prototype.clear = ue, sr.prototype.delete = ze, sr.prototype.get = ct, sr.prototype.has = ft, sr.prototype.set = Vt;
    function Ot(R) {
      var X = -1, pe = R ? R.length : 0;
      for (this.clear(); ++X < pe; ) {
        var Re = R[X];
        this.set(Re[0], Re[1]);
      }
    }
    function Qt() {
      this.__data__ = {
        hash: new $e(),
        map: new (vn || sr)(),
        string: new $e()
      };
    }
    function zt(R) {
      return Ye(this, R).delete(R);
    }
    function Hr(R) {
      return Ye(this, R).get(R);
    }
    function Tr(R) {
      return Ye(this, R).has(R);
    }
    function Nr(R, X) {
      return Ye(this, R).set(R, X), this;
    }
    Ot.prototype.clear = Qt, Ot.prototype.delete = zt, Ot.prototype.get = Hr, Ot.prototype.has = Tr, Ot.prototype.set = Nr;
    function dr(R) {
      this.__data__ = new sr(R);
    }
    function vi() {
      this.__data__ = new sr();
    }
    function Xn(R) {
      return this.__data__.delete(R);
    }
    function Yr(R) {
      return this.__data__.get(R);
    }
    function Wr(R) {
      return this.__data__.has(R);
    }
    function oi(R, X) {
      var pe = this.__data__;
      if (pe instanceof sr) {
        var Re = pe.__data__;
        if (!vn || Re.length < t - 1)
          return Re.push([R, X]), this;
        pe = this.__data__ = new Ot(Re);
      }
      return pe.set(R, X), this;
    }
    dr.prototype.clear = vi, dr.prototype.delete = Xn, dr.prototype.get = Yr, dr.prototype.has = Wr, dr.prototype.set = oi;
    function An(R, X) {
      var pe = ka(R) || di(R) ? an(R.length, String) : [], Re = pe.length, Bt = !!Re;
      for (var Tt in R)
        It.call(R, Tt) && !(Bt && (Tt == "length" || Wn(Tt, Re))) && pe.push(Tt);
      return pe;
    }
    function Di(R, X, pe) {
      var Re = R[X];
      (!(It.call(R, X) && Ai(Re, pe)) || pe === void 0 && !(X in R)) && (R[X] = pe);
    }
    function ni(R, X) {
      for (var pe = R.length; pe--; )
        if (Ai(R[pe][0], X))
          return pe;
      return -1;
    }
    function En(R, X) {
      return R && Ee(X, _r(X), R);
    }
    function ii(R, X, pe, Re, Bt, Tt, hr) {
      var or;
      if (Re && (or = Tt ? Re(R, Bt, Tt, hr) : Re(R)), or !== void 0)
        return or;
      if (!li(R))
        return R;
      var xn = ka(R);
      if (xn) {
        if (or = yr(R), !X)
          return ne(R, or);
      } else {
        var N = pt(R), oe = N == c || N == h;
        if (wi(R))
          return Kn(R, X);
        if (N == m || N == a || oe && !Tt) {
          if (Ir(R))
            return Tt ? R : {};
          if (or = jr(oe ? {} : R), !X)
            return be(R, En(or, R));
        } else {
          if (!He[N])
            return Tt ? R : {};
          or = Dn(R, N, ii, X);
        }
      }
      hr || (hr = new dr());
      var xe = hr.get(R);
      if (xe)
        return xe;
      if (hr.set(R, or), !xn)
        var Ie = pe ? _e(R) : _r(R);
      return rt(Ie || R, function(We, ot) {
        Ie && (ot = We, We = R[ot]), Di(or, ot, ii(We, X, pe, Re, ot, R, hr));
      }), or;
    }
    function Jn(R) {
      return li(R) ? Fn(R) : {};
    }
    function Un(R, X, pe) {
      var Re = X(R);
      return ka(R) ? Re : Rt(Re, pe(R));
    }
    function Li(R) {
      return Zr.call(R);
    }
    function Hi(R) {
      if (!li(R) || yi(R))
        return !1;
      var X = Zi(R) || Ir(R) ? Cn : Xe;
      return X.test(wn(R));
    }
    function ai(R) {
      if (!Zn(R))
        return mn(R);
      var X = [];
      for (var pe in Object(R))
        It.call(R, pe) && pe != "constructor" && X.push(pe);
      return X;
    }
    function Kn(R, X) {
      if (X)
        return R.slice();
      var pe = new R.constructor(R.length);
      return R.copy(pe), pe;
    }
    function Vn(R) {
      var X = new R.constructor(R.byteLength);
      return new ln(X).set(new ln(R)), X;
    }
    function Pn(R, X) {
      var pe = X ? Vn(R.buffer) : R.buffer;
      return new R.constructor(pe, R.byteOffset, R.byteLength);
    }
    function kn(R, X, pe) {
      var Re = X ? pe(kt(R), !0) : kt(R);
      return Fr(Re, st, new R.constructor());
    }
    function $n(R) {
      var X = new R.constructor(R.source, Se.exec(R));
      return X.lastIndex = R.lastIndex, X;
    }
    function I(R, X, pe) {
      var Re = X ? pe(Mn(R), !0) : Mn(R);
      return Fr(Re, lt, new R.constructor());
    }
    function U(R) {
      return we ? Object(we.call(R)) : {};
    }
    function Y(R, X) {
      var pe = X ? Vn(R.buffer) : R.buffer;
      return new R.constructor(pe, R.byteOffset, R.length);
    }
    function ne(R, X) {
      var pe = -1, Re = R.length;
      for (X || (X = Array(Re)); ++pe < Re; )
        X[pe] = R[pe];
      return X;
    }
    function Ee(R, X, pe, Re) {
      pe || (pe = {});
      for (var Bt = -1, Tt = X.length; ++Bt < Tt; ) {
        var hr = X[Bt], or = void 0;
        Di(pe, hr, or === void 0 ? R[hr] : or);
      }
      return pe;
    }
    function be(R, X) {
      return Ee(R, Et(R), X);
    }
    function _e(R) {
      return Un(R, _r, Et);
    }
    function Ye(R, X) {
      var pe = R.__data__;
      return Ri(X) ? pe[typeof X == "string" ? "string" : "hash"] : pe.map;
    }
    function vt(R, X) {
      var pe = ar(R, X);
      return Hi(pe) ? pe : void 0;
    }
    var Et = Hn ? wt(Hn, Object) : hi, pt = Li;
    (In && pt(new In(new ArrayBuffer(1))) != _ || vn && pt(new vn()) != f || fr && pt(fr.resolve()) != A || Or && pt(new Or()) != x || sn && pt(new sn()) != D) && (pt = function(R) {
      var X = Zr.call(R), pe = X == m ? R.constructor : void 0, Re = pe ? wn(pe) : void 0;
      if (Re)
        switch (Re) {
          case yn:
            return _;
          case Nn:
            return f;
          case Me:
            return A;
          case M:
            return x;
          case W:
            return D;
        }
      return X;
    });
    function yr(R) {
      var X = R.length, pe = R.constructor(X);
      return X && typeof R[0] == "string" && It.call(R, "index") && (pe.index = R.index, pe.input = R.input), pe;
    }
    function jr(R) {
      return typeof R.constructor == "function" && !Zn(R) ? Jn(en(R)) : {};
    }
    function Dn(R, X, pe, Re) {
      var Bt = R.constructor;
      switch (X) {
        case F:
          return Vn(R);
        case o:
        case l:
          return new Bt(+R);
        case _:
          return Pn(R, Re);
        case L:
        case Z:
        case te:
        case de:
        case H:
        case j:
        case q:
        case re:
        case ae:
          return Y(R, Re);
        case f:
          return kn(R, Re, pe);
        case p:
        case E:
          return new Bt(R);
        case w:
          return $n(R);
        case x:
          return I(R, Re, pe);
        case T:
          return U(R);
      }
    }
    function Wn(R, X) {
      return X = X ?? i, !!X && (typeof R == "number" || Ve.test(R)) && R > -1 && R % 1 == 0 && R < X;
    }
    function Ri(R) {
      var X = typeof R;
      return X == "string" || X == "number" || X == "symbol" || X == "boolean" ? R !== "__proto__" : R === null;
    }
    function yi(R) {
      return !!qt && qt in R;
    }
    function Zn(R) {
      var X = R && R.constructor, pe = typeof X == "function" && X.prototype || Pr;
      return R === pe;
    }
    function wn(R) {
      if (R != null) {
        try {
          return lr.call(R);
        } catch {
        }
        try {
          return R + "";
        } catch {
        }
      }
      return "";
    }
    function Oi(R) {
      return ii(R, !0, !0);
    }
    function Ai(R, X) {
      return R === X || R !== R && X !== X;
    }
    function di(R) {
      return la(R) && It.call(R, "callee") && (!gn.call(R, "callee") || Zr.call(R) == a);
    }
    var ka = Array.isArray;
    function oa(R) {
      return R != null && Ei(R.length) && !Zi(R);
    }
    function la(R) {
      return Ui(R) && oa(R);
    }
    var wi = tn || Lr;
    function Zi(R) {
      var X = li(R) ? Zr.call(R) : "";
      return X == c || X == h;
    }
    function Ei(R) {
      return typeof R == "number" && R > -1 && R % 1 == 0 && R <= i;
    }
    function li(R) {
      var X = typeof R;
      return !!R && (X == "object" || X == "function");
    }
    function Ui(R) {
      return !!R && typeof R == "object";
    }
    function _r(R) {
      return oa(R) ? An(R) : ai(R);
    }
    function hi() {
      return [];
    }
    function Lr() {
      return !1;
    }
    r.exports = Oi;
  })(yp, yp.exports)), yp.exports;
}
var CU = bU();
const Su = /* @__PURE__ */ Iu(CU);
var oy, bE;
function SU() {
  if (bE) return oy;
  bE = 1;
  var r = "Expected a function", e = NaN, t = "[object Symbol]", n = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, s = /^0o[0-7]+$/i, o = parseInt, l = typeof Ni == "object" && Ni && Ni.Object === Object && Ni, u = typeof self == "object" && self && self.Object === Object && self, c = l || u || Function("return this")(), h = Object.prototype, f = h.toString, p = Math.max, m = Math.min, A = function() {
    return c.Date.now();
  };
  function w(F, _, L) {
    var Z, te, de, H, j, q, re = 0, ae = !1, ye = !1, Se = !0;
    if (typeof F != "function")
      throw new TypeError(r);
    _ = D(_) || 0, x(L) && (ae = !!L.leading, ye = "maxWait" in L, de = ye ? p(D(L.maxWait) || 0, _) : de, Se = "trailing" in L ? !!L.trailing : Se);
    function Xe(st) {
      var lt = Z, rt = te;
      return Z = te = void 0, re = st, H = F.apply(rt, lt), H;
    }
    function Ve(st) {
      return re = st, j = setTimeout(ve, _), ae ? Xe(st) : H;
    }
    function He(st) {
      var lt = st - q, rt = st - re, Rt = _ - lt;
      return ye ? m(Rt, de - rt) : Rt;
    }
    function le(st) {
      var lt = st - q, rt = st - re;
      return q === void 0 || lt >= _ || lt < 0 || ye && rt >= de;
    }
    function ve() {
      var st = A();
      if (le(st))
        return it(st);
      j = setTimeout(ve, He(st));
    }
    function it(st) {
      return j = void 0, Se && Z ? Xe(st) : (Z = te = void 0, H);
    }
    function mt() {
      j !== void 0 && clearTimeout(j), re = 0, Z = q = te = j = void 0;
    }
    function qe() {
      return j === void 0 ? H : it(A());
    }
    function at() {
      var st = A(), lt = le(st);
      if (Z = arguments, te = this, q = st, lt) {
        if (j === void 0)
          return Ve(q);
        if (ye)
          return j = setTimeout(ve, _), Xe(q);
      }
      return j === void 0 && (j = setTimeout(ve, _)), H;
    }
    return at.cancel = mt, at.flush = qe, at;
  }
  function x(F) {
    var _ = typeof F;
    return !!F && (_ == "object" || _ == "function");
  }
  function E(F) {
    return !!F && typeof F == "object";
  }
  function T(F) {
    return typeof F == "symbol" || E(F) && f.call(F) == t;
  }
  function D(F) {
    if (typeof F == "number")
      return F;
    if (T(F))
      return e;
    if (x(F)) {
      var _ = typeof F.valueOf == "function" ? F.valueOf() : F;
      F = x(_) ? _ + "" : _;
    }
    if (typeof F != "string")
      return F === 0 ? F : +F;
    F = F.replace(n, "");
    var L = a.test(F);
    return L || s.test(F) ? o(F.slice(2), L ? 2 : 8) : i.test(F) ? e : +F;
  }
  return oy = w, oy;
}
var EU = SU();
const W0 = /* @__PURE__ */ Iu(EU);
var Ap = { exports: {} };
Ap.exports;
var CE;
function kU() {
  return CE || (CE = 1, (function(r, e) {
    var t = 200, n = "__lodash_hash_undefined__", i = 1, a = 2, s = 9007199254740991, o = "[object Arguments]", l = "[object Array]", u = "[object AsyncFunction]", c = "[object Boolean]", h = "[object Date]", f = "[object Error]", p = "[object Function]", m = "[object GeneratorFunction]", A = "[object Map]", w = "[object Number]", x = "[object Null]", E = "[object Object]", T = "[object Promise]", D = "[object Proxy]", F = "[object RegExp]", _ = "[object Set]", L = "[object String]", Z = "[object Symbol]", te = "[object Undefined]", de = "[object WeakMap]", H = "[object ArrayBuffer]", j = "[object DataView]", q = "[object Float32Array]", re = "[object Float64Array]", ae = "[object Int8Array]", ye = "[object Int16Array]", Se = "[object Int32Array]", Xe = "[object Uint8Array]", Ve = "[object Uint8ClampedArray]", He = "[object Uint16Array]", le = "[object Uint32Array]", ve = /[\\^$.*+?()[\]{}|]/g, it = /^\[object .+?Constructor\]$/, mt = /^(?:0|[1-9]\d*)$/, qe = {};
    qe[q] = qe[re] = qe[ae] = qe[ye] = qe[Se] = qe[Xe] = qe[Ve] = qe[He] = qe[le] = !0, qe[o] = qe[l] = qe[H] = qe[c] = qe[j] = qe[h] = qe[f] = qe[p] = qe[A] = qe[w] = qe[E] = qe[F] = qe[_] = qe[L] = qe[de] = !1;
    var at = typeof Ni == "object" && Ni && Ni.Object === Object && Ni, st = typeof self == "object" && self && self.Object === Object && self, lt = at || st || Function("return this")(), rt = e && !e.nodeType && e, Rt = rt && !0 && r && !r.nodeType && r, Fr = Rt && Rt.exports === rt, an = Fr && at.process, ar = (function() {
      try {
        return an && an.binding && an.binding("util");
      } catch {
      }
    })(), Ir = ar && ar.isTypedArray;
    function kt(R, X) {
      for (var pe = -1, Re = R == null ? 0 : R.length, Bt = 0, Tt = []; ++pe < Re; ) {
        var hr = R[pe];
        X(hr, pe, R) && (Tt[Bt++] = hr);
      }
      return Tt;
    }
    function wt(R, X) {
      for (var pe = -1, Re = X.length, Bt = R.length; ++pe < Re; )
        R[Bt + pe] = X[pe];
      return R;
    }
    function Mn(R, X) {
      for (var pe = -1, Re = R == null ? 0 : R.length; ++pe < Re; )
        if (X(R[pe], pe, R))
          return !0;
      return !1;
    }
    function kr(R, X) {
      for (var pe = -1, Re = Array(R); ++pe < R; )
        Re[pe] = X(pe);
      return Re;
    }
    function Gr(R) {
      return function(X) {
        return R(X);
      };
    }
    function Pr(R, X) {
      return R.has(X);
    }
    function Cr(R, X) {
      return R?.[X];
    }
    function qt(R) {
      var X = -1, pe = Array(R.size);
      return R.forEach(function(Re, Bt) {
        pe[++X] = [Bt, Re];
      }), pe;
    }
    function lr(R, X) {
      return function(pe) {
        return R(X(pe));
      };
    }
    function It(R) {
      var X = -1, pe = Array(R.size);
      return R.forEach(function(Re) {
        pe[++X] = Re;
      }), pe;
    }
    var Zr = Array.prototype, Cn = Function.prototype, Sn = Object.prototype, vr = lt["__core-js_shared__"], ln = Cn.toString, en = Sn.hasOwnProperty, Fn = (function() {
      var R = /[^.]+$/.exec(vr && vr.keys && vr.keys.IE_PROTO || "");
      return R ? "Symbol(src)_1." + R : "";
    })(), gn = Sn.toString, Gn = RegExp(
      "^" + ln.call(en).replace(ve, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Hn = Fr ? lt.Buffer : void 0, tn = lt.Symbol, mn = lt.Uint8Array, In = Sn.propertyIsEnumerable, vn = Zr.splice, fr = tn ? tn.toStringTag : void 0, Or = Object.getOwnPropertySymbols, sn = Hn ? Hn.isBuffer : void 0, yt = lr(Object.keys, Object), yn = Et(lt, "DataView"), Nn = Et(lt, "Map"), Me = Et(lt, "Promise"), M = Et(lt, "Set"), W = Et(lt, "WeakMap"), se = Et(Object, "create"), we = wn(yn), $e = wn(Nn), ut = wn(Me), Mt = wn(M), Zt = wn(W), rr = tn ? tn.prototype : void 0, Br = rr ? rr.valueOf : void 0;
    function sr(R) {
      var X = -1, pe = R == null ? 0 : R.length;
      for (this.clear(); ++X < pe; ) {
        var Re = R[X];
        this.set(Re[0], Re[1]);
      }
    }
    function ue() {
      this.__data__ = se ? se(null) : {}, this.size = 0;
    }
    function ze(R) {
      var X = this.has(R) && delete this.__data__[R];
      return this.size -= X ? 1 : 0, X;
    }
    function ct(R) {
      var X = this.__data__;
      if (se) {
        var pe = X[R];
        return pe === n ? void 0 : pe;
      }
      return en.call(X, R) ? X[R] : void 0;
    }
    function ft(R) {
      var X = this.__data__;
      return se ? X[R] !== void 0 : en.call(X, R);
    }
    function Vt(R, X) {
      var pe = this.__data__;
      return this.size += this.has(R) ? 0 : 1, pe[R] = se && X === void 0 ? n : X, this;
    }
    sr.prototype.clear = ue, sr.prototype.delete = ze, sr.prototype.get = ct, sr.prototype.has = ft, sr.prototype.set = Vt;
    function Ot(R) {
      var X = -1, pe = R == null ? 0 : R.length;
      for (this.clear(); ++X < pe; ) {
        var Re = R[X];
        this.set(Re[0], Re[1]);
      }
    }
    function Qt() {
      this.__data__ = [], this.size = 0;
    }
    function zt(R) {
      var X = this.__data__, pe = Kn(X, R);
      if (pe < 0)
        return !1;
      var Re = X.length - 1;
      return pe == Re ? X.pop() : vn.call(X, pe, 1), --this.size, !0;
    }
    function Hr(R) {
      var X = this.__data__, pe = Kn(X, R);
      return pe < 0 ? void 0 : X[pe][1];
    }
    function Tr(R) {
      return Kn(this.__data__, R) > -1;
    }
    function Nr(R, X) {
      var pe = this.__data__, Re = Kn(pe, R);
      return Re < 0 ? (++this.size, pe.push([R, X])) : pe[Re][1] = X, this;
    }
    Ot.prototype.clear = Qt, Ot.prototype.delete = zt, Ot.prototype.get = Hr, Ot.prototype.has = Tr, Ot.prototype.set = Nr;
    function dr(R) {
      var X = -1, pe = R == null ? 0 : R.length;
      for (this.clear(); ++X < pe; ) {
        var Re = R[X];
        this.set(Re[0], Re[1]);
      }
    }
    function vi() {
      this.size = 0, this.__data__ = {
        hash: new sr(),
        map: new (Nn || Ot)(),
        string: new sr()
      };
    }
    function Xn(R) {
      var X = vt(this, R).delete(R);
      return this.size -= X ? 1 : 0, X;
    }
    function Yr(R) {
      return vt(this, R).get(R);
    }
    function Wr(R) {
      return vt(this, R).has(R);
    }
    function oi(R, X) {
      var pe = vt(this, R), Re = pe.size;
      return pe.set(R, X), this.size += pe.size == Re ? 0 : 1, this;
    }
    dr.prototype.clear = vi, dr.prototype.delete = Xn, dr.prototype.get = Yr, dr.prototype.has = Wr, dr.prototype.set = oi;
    function An(R) {
      var X = -1, pe = R == null ? 0 : R.length;
      for (this.__data__ = new dr(); ++X < pe; )
        this.add(R[X]);
    }
    function Di(R) {
      return this.__data__.set(R, n), this;
    }
    function ni(R) {
      return this.__data__.has(R);
    }
    An.prototype.add = An.prototype.push = Di, An.prototype.has = ni;
    function En(R) {
      var X = this.__data__ = new Ot(R);
      this.size = X.size;
    }
    function ii() {
      this.__data__ = new Ot(), this.size = 0;
    }
    function Jn(R) {
      var X = this.__data__, pe = X.delete(R);
      return this.size = X.size, pe;
    }
    function Un(R) {
      return this.__data__.get(R);
    }
    function Li(R) {
      return this.__data__.has(R);
    }
    function Hi(R, X) {
      var pe = this.__data__;
      if (pe instanceof Ot) {
        var Re = pe.__data__;
        if (!Nn || Re.length < t - 1)
          return Re.push([R, X]), this.size = ++pe.size, this;
        pe = this.__data__ = new dr(Re);
      }
      return pe.set(R, X), this.size = pe.size, this;
    }
    En.prototype.clear = ii, En.prototype.delete = Jn, En.prototype.get = Un, En.prototype.has = Li, En.prototype.set = Hi;
    function ai(R, X) {
      var pe = di(R), Re = !pe && Ai(R), Bt = !pe && !Re && oa(R), Tt = !pe && !Re && !Bt && Ui(R), hr = pe || Re || Bt || Tt, or = hr ? kr(R.length, String) : [], xn = or.length;
      for (var N in R)
        en.call(R, N) && !(hr && // Safari 9 has enumerable `arguments.length` in strict mode.
        (N == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        Bt && (N == "offset" || N == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        Tt && (N == "buffer" || N == "byteLength" || N == "byteOffset") || // Skip index properties.
        Dn(N, xn))) && or.push(N);
      return or;
    }
    function Kn(R, X) {
      for (var pe = R.length; pe--; )
        if (Oi(R[pe][0], X))
          return pe;
      return -1;
    }
    function Vn(R, X, pe) {
      var Re = X(R);
      return di(R) ? Re : wt(Re, pe(R));
    }
    function Pn(R) {
      return R == null ? R === void 0 ? te : x : fr && fr in Object(R) ? pt(R) : Zn(R);
    }
    function kn(R) {
      return li(R) && Pn(R) == o;
    }
    function $n(R, X, pe, Re, Bt) {
      return R === X ? !0 : R == null || X == null || !li(R) && !li(X) ? R !== R && X !== X : I(R, X, pe, Re, $n, Bt);
    }
    function I(R, X, pe, Re, Bt, Tt) {
      var hr = di(R), or = di(X), xn = hr ? l : jr(R), N = or ? l : jr(X);
      xn = xn == o ? E : xn, N = N == o ? E : N;
      var oe = xn == E, xe = N == E, Ie = xn == N;
      if (Ie && oa(R)) {
        if (!oa(X))
          return !1;
        hr = !0, oe = !1;
      }
      if (Ie && !oe)
        return Tt || (Tt = new En()), hr || Ui(R) ? Ee(R, X, pe, Re, Bt, Tt) : be(R, X, xn, pe, Re, Bt, Tt);
      if (!(pe & i)) {
        var We = oe && en.call(R, "__wrapped__"), ot = xe && en.call(X, "__wrapped__");
        if (We || ot) {
          var dt = We ? R.value() : R, Nt = ot ? X.value() : X;
          return Tt || (Tt = new En()), Bt(dt, Nt, pe, Re, Tt);
        }
      }
      return Ie ? (Tt || (Tt = new En()), _e(R, X, pe, Re, Bt, Tt)) : !1;
    }
    function U(R) {
      if (!Ei(R) || Ri(R))
        return !1;
      var X = wi(R) ? Gn : it;
      return X.test(wn(R));
    }
    function Y(R) {
      return li(R) && Zi(R.length) && !!qe[Pn(R)];
    }
    function ne(R) {
      if (!yi(R))
        return yt(R);
      var X = [];
      for (var pe in Object(R))
        en.call(R, pe) && pe != "constructor" && X.push(pe);
      return X;
    }
    function Ee(R, X, pe, Re, Bt, Tt) {
      var hr = pe & i, or = R.length, xn = X.length;
      if (or != xn && !(hr && xn > or))
        return !1;
      var N = Tt.get(R);
      if (N && Tt.get(X))
        return N == X;
      var oe = -1, xe = !0, Ie = pe & a ? new An() : void 0;
      for (Tt.set(R, X), Tt.set(X, R); ++oe < or; ) {
        var We = R[oe], ot = X[oe];
        if (Re)
          var dt = hr ? Re(ot, We, oe, X, R, Tt) : Re(We, ot, oe, R, X, Tt);
        if (dt !== void 0) {
          if (dt)
            continue;
          xe = !1;
          break;
        }
        if (Ie) {
          if (!Mn(X, function(Nt, Yt) {
            if (!Pr(Ie, Yt) && (We === Nt || Bt(We, Nt, pe, Re, Tt)))
              return Ie.push(Yt);
          })) {
            xe = !1;
            break;
          }
        } else if (!(We === ot || Bt(We, ot, pe, Re, Tt))) {
          xe = !1;
          break;
        }
      }
      return Tt.delete(R), Tt.delete(X), xe;
    }
    function be(R, X, pe, Re, Bt, Tt, hr) {
      switch (pe) {
        case j:
          if (R.byteLength != X.byteLength || R.byteOffset != X.byteOffset)
            return !1;
          R = R.buffer, X = X.buffer;
        case H:
          return !(R.byteLength != X.byteLength || !Tt(new mn(R), new mn(X)));
        case c:
        case h:
        case w:
          return Oi(+R, +X);
        case f:
          return R.name == X.name && R.message == X.message;
        case F:
        case L:
          return R == X + "";
        case A:
          var or = qt;
        case _:
          var xn = Re & i;
          if (or || (or = It), R.size != X.size && !xn)
            return !1;
          var N = hr.get(R);
          if (N)
            return N == X;
          Re |= a, hr.set(R, X);
          var oe = Ee(or(R), or(X), Re, Bt, Tt, hr);
          return hr.delete(R), oe;
        case Z:
          if (Br)
            return Br.call(R) == Br.call(X);
      }
      return !1;
    }
    function _e(R, X, pe, Re, Bt, Tt) {
      var hr = pe & i, or = Ye(R), xn = or.length, N = Ye(X), oe = N.length;
      if (xn != oe && !hr)
        return !1;
      for (var xe = xn; xe--; ) {
        var Ie = or[xe];
        if (!(hr ? Ie in X : en.call(X, Ie)))
          return !1;
      }
      var We = Tt.get(R);
      if (We && Tt.get(X))
        return We == X;
      var ot = !0;
      Tt.set(R, X), Tt.set(X, R);
      for (var dt = hr; ++xe < xn; ) {
        Ie = or[xe];
        var Nt = R[Ie], Yt = X[Ie];
        if (Re)
          var Ur = hr ? Re(Yt, Nt, Ie, X, R, Tt) : Re(Nt, Yt, Ie, R, X, Tt);
        if (!(Ur === void 0 ? Nt === Yt || Bt(Nt, Yt, pe, Re, Tt) : Ur)) {
          ot = !1;
          break;
        }
        dt || (dt = Ie == "constructor");
      }
      if (ot && !dt) {
        var qr = R.constructor, Dr = X.constructor;
        qr != Dr && "constructor" in R && "constructor" in X && !(typeof qr == "function" && qr instanceof qr && typeof Dr == "function" && Dr instanceof Dr) && (ot = !1);
      }
      return Tt.delete(R), Tt.delete(X), ot;
    }
    function Ye(R) {
      return Vn(R, _r, yr);
    }
    function vt(R, X) {
      var pe = R.__data__;
      return Wn(X) ? pe[typeof X == "string" ? "string" : "hash"] : pe.map;
    }
    function Et(R, X) {
      var pe = Cr(R, X);
      return U(pe) ? pe : void 0;
    }
    function pt(R) {
      var X = en.call(R, fr), pe = R[fr];
      try {
        R[fr] = void 0;
        var Re = !0;
      } catch {
      }
      var Bt = gn.call(R);
      return Re && (X ? R[fr] = pe : delete R[fr]), Bt;
    }
    var yr = Or ? function(R) {
      return R == null ? [] : (R = Object(R), kt(Or(R), function(X) {
        return In.call(R, X);
      }));
    } : hi, jr = Pn;
    (yn && jr(new yn(new ArrayBuffer(1))) != j || Nn && jr(new Nn()) != A || Me && jr(Me.resolve()) != T || M && jr(new M()) != _ || W && jr(new W()) != de) && (jr = function(R) {
      var X = Pn(R), pe = X == E ? R.constructor : void 0, Re = pe ? wn(pe) : "";
      if (Re)
        switch (Re) {
          case we:
            return j;
          case $e:
            return A;
          case ut:
            return T;
          case Mt:
            return _;
          case Zt:
            return de;
        }
      return X;
    });
    function Dn(R, X) {
      return X = X ?? s, !!X && (typeof R == "number" || mt.test(R)) && R > -1 && R % 1 == 0 && R < X;
    }
    function Wn(R) {
      var X = typeof R;
      return X == "string" || X == "number" || X == "symbol" || X == "boolean" ? R !== "__proto__" : R === null;
    }
    function Ri(R) {
      return !!Fn && Fn in R;
    }
    function yi(R) {
      var X = R && R.constructor, pe = typeof X == "function" && X.prototype || Sn;
      return R === pe;
    }
    function Zn(R) {
      return gn.call(R);
    }
    function wn(R) {
      if (R != null) {
        try {
          return ln.call(R);
        } catch {
        }
        try {
          return R + "";
        } catch {
        }
      }
      return "";
    }
    function Oi(R, X) {
      return R === X || R !== R && X !== X;
    }
    var Ai = kn(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? kn : function(R) {
      return li(R) && en.call(R, "callee") && !In.call(R, "callee");
    }, di = Array.isArray;
    function ka(R) {
      return R != null && Zi(R.length) && !wi(R);
    }
    var oa = sn || Lr;
    function la(R, X) {
      return $n(R, X);
    }
    function wi(R) {
      if (!Ei(R))
        return !1;
      var X = Pn(R);
      return X == p || X == m || X == u || X == D;
    }
    function Zi(R) {
      return typeof R == "number" && R > -1 && R % 1 == 0 && R <= s;
    }
    function Ei(R) {
      var X = typeof R;
      return R != null && (X == "object" || X == "function");
    }
    function li(R) {
      return R != null && typeof R == "object";
    }
    var Ui = Ir ? Gr(Ir) : Y;
    function _r(R) {
      return ka(R) ? ai(R) : ne(R);
    }
    function hi() {
      return [];
    }
    function Lr() {
      return !1;
    }
    r.exports = la;
  })(Ap, Ap.exports)), Ap.exports;
}
var TU = kU();
const g0 = /* @__PURE__ */ Iu(TU);
var jg = { exports: {} }, Wh = {};
var SE;
function FU() {
  if (SE) return Wh;
  SE = 1;
  var r = Vf(), e = /* @__PURE__ */ Symbol.for("react.element"), t = /* @__PURE__ */ Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(o, l, u) {
    var c, h = {}, f = null, p = null;
    u !== void 0 && (f = "" + u), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (c in l) n.call(l, c) && !a.hasOwnProperty(c) && (h[c] = l[c]);
    if (o && o.defaultProps) for (c in l = o.defaultProps, l) h[c] === void 0 && (h[c] = l[c]);
    return { $$typeof: e, type: o, key: f, ref: p, props: h, _owner: i.current };
  }
  return Wh.Fragment = t, Wh.jsx = s, Wh.jsxs = s, Wh;
}
var jh = {};
var EE;
function IU() {
  return EE || (EE = 1, process.env.NODE_ENV !== "production" && (function() {
    var r = Vf(), e = /* @__PURE__ */ Symbol.for("react.element"), t = /* @__PURE__ */ Symbol.for("react.portal"), n = /* @__PURE__ */ Symbol.for("react.fragment"), i = /* @__PURE__ */ Symbol.for("react.strict_mode"), a = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), o = /* @__PURE__ */ Symbol.for("react.context"), l = /* @__PURE__ */ Symbol.for("react.forward_ref"), u = /* @__PURE__ */ Symbol.for("react.suspense"), c = /* @__PURE__ */ Symbol.for("react.suspense_list"), h = /* @__PURE__ */ Symbol.for("react.memo"), f = /* @__PURE__ */ Symbol.for("react.lazy"), p = /* @__PURE__ */ Symbol.for("react.offscreen"), m = Symbol.iterator, A = "@@iterator";
    function w(ue) {
      if (ue === null || typeof ue != "object")
        return null;
      var ze = m && ue[m] || ue[A];
      return typeof ze == "function" ? ze : null;
    }
    var x = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(ue) {
      {
        for (var ze = arguments.length, ct = new Array(ze > 1 ? ze - 1 : 0), ft = 1; ft < ze; ft++)
          ct[ft - 1] = arguments[ft];
        T("error", ue, ct);
      }
    }
    function T(ue, ze, ct) {
      {
        var ft = x.ReactDebugCurrentFrame, Vt = ft.getStackAddendum();
        Vt !== "" && (ze += "%s", ct = ct.concat([Vt]));
        var Ot = ct.map(function(Qt) {
          return String(Qt);
        });
        Ot.unshift("Warning: " + ze), Function.prototype.apply.call(console[ue], console, Ot);
      }
    }
    var D = !1, F = !1, _ = !1, L = !1, Z = !1, te;
    te = /* @__PURE__ */ Symbol.for("react.module.reference");
    function de(ue) {
      return !!(typeof ue == "string" || typeof ue == "function" || ue === n || ue === a || Z || ue === i || ue === u || ue === c || L || ue === p || D || F || _ || typeof ue == "object" && ue !== null && (ue.$$typeof === f || ue.$$typeof === h || ue.$$typeof === s || ue.$$typeof === o || ue.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ue.$$typeof === te || ue.getModuleId !== void 0));
    }
    function H(ue, ze, ct) {
      var ft = ue.displayName;
      if (ft)
        return ft;
      var Vt = ze.displayName || ze.name || "";
      return Vt !== "" ? ct + "(" + Vt + ")" : ct;
    }
    function j(ue) {
      return ue.displayName || "Context";
    }
    function q(ue) {
      if (ue == null)
        return null;
      if (typeof ue.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof ue == "function")
        return ue.displayName || ue.name || null;
      if (typeof ue == "string")
        return ue;
      switch (ue) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof ue == "object")
        switch (ue.$$typeof) {
          case o:
            var ze = ue;
            return j(ze) + ".Consumer";
          case s:
            var ct = ue;
            return j(ct._context) + ".Provider";
          case l:
            return H(ue, ue.render, "ForwardRef");
          case h:
            var ft = ue.displayName || null;
            return ft !== null ? ft : q(ue.type) || "Memo";
          case f: {
            var Vt = ue, Ot = Vt._payload, Qt = Vt._init;
            try {
              return q(Qt(Ot));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var re = Object.assign, ae = 0, ye, Se, Xe, Ve, He, le, ve;
    function it() {
    }
    it.__reactDisabledLog = !0;
    function mt() {
      {
        if (ae === 0) {
          ye = console.log, Se = console.info, Xe = console.warn, Ve = console.error, He = console.group, le = console.groupCollapsed, ve = console.groupEnd;
          var ue = {
            configurable: !0,
            enumerable: !0,
            value: it,
            writable: !0
          };
          Object.defineProperties(console, {
            info: ue,
            log: ue,
            warn: ue,
            error: ue,
            group: ue,
            groupCollapsed: ue,
            groupEnd: ue
          });
        }
        ae++;
      }
    }
    function qe() {
      {
        if (ae--, ae === 0) {
          var ue = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: re({}, ue, {
              value: ye
            }),
            info: re({}, ue, {
              value: Se
            }),
            warn: re({}, ue, {
              value: Xe
            }),
            error: re({}, ue, {
              value: Ve
            }),
            group: re({}, ue, {
              value: He
            }),
            groupCollapsed: re({}, ue, {
              value: le
            }),
            groupEnd: re({}, ue, {
              value: ve
            })
          });
        }
        ae < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var at = x.ReactCurrentDispatcher, st;
    function lt(ue, ze, ct) {
      {
        if (st === void 0)
          try {
            throw Error();
          } catch (Vt) {
            var ft = Vt.stack.trim().match(/\n( *(at )?)/);
            st = ft && ft[1] || "";
          }
        return `
` + st + ue;
      }
    }
    var rt = !1, Rt;
    {
      var Fr = typeof WeakMap == "function" ? WeakMap : Map;
      Rt = new Fr();
    }
    function an(ue, ze) {
      if (!ue || rt)
        return "";
      {
        var ct = Rt.get(ue);
        if (ct !== void 0)
          return ct;
      }
      var ft;
      rt = !0;
      var Vt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ot;
      Ot = at.current, at.current = null, mt();
      try {
        if (ze) {
          var Qt = function() {
            throw Error();
          };
          if (Object.defineProperty(Qt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Qt, []);
            } catch (Yr) {
              ft = Yr;
            }
            Reflect.construct(ue, [], Qt);
          } else {
            try {
              Qt.call();
            } catch (Yr) {
              ft = Yr;
            }
            ue.call(Qt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Yr) {
            ft = Yr;
          }
          ue();
        }
      } catch (Yr) {
        if (Yr && ft && typeof Yr.stack == "string") {
          for (var zt = Yr.stack.split(`
`), Hr = ft.stack.split(`
`), Tr = zt.length - 1, Nr = Hr.length - 1; Tr >= 1 && Nr >= 0 && zt[Tr] !== Hr[Nr]; )
            Nr--;
          for (; Tr >= 1 && Nr >= 0; Tr--, Nr--)
            if (zt[Tr] !== Hr[Nr]) {
              if (Tr !== 1 || Nr !== 1)
                do
                  if (Tr--, Nr--, Nr < 0 || zt[Tr] !== Hr[Nr]) {
                    var dr = `
` + zt[Tr].replace(" at new ", " at ");
                    return ue.displayName && dr.includes("<anonymous>") && (dr = dr.replace("<anonymous>", ue.displayName)), typeof ue == "function" && Rt.set(ue, dr), dr;
                  }
                while (Tr >= 1 && Nr >= 0);
              break;
            }
        }
      } finally {
        rt = !1, at.current = Ot, qe(), Error.prepareStackTrace = Vt;
      }
      var vi = ue ? ue.displayName || ue.name : "", Xn = vi ? lt(vi) : "";
      return typeof ue == "function" && Rt.set(ue, Xn), Xn;
    }
    function ar(ue, ze, ct) {
      return an(ue, !1);
    }
    function Ir(ue) {
      var ze = ue.prototype;
      return !!(ze && ze.isReactComponent);
    }
    function kt(ue, ze, ct) {
      if (ue == null)
        return "";
      if (typeof ue == "function")
        return an(ue, Ir(ue));
      if (typeof ue == "string")
        return lt(ue);
      switch (ue) {
        case u:
          return lt("Suspense");
        case c:
          return lt("SuspenseList");
      }
      if (typeof ue == "object")
        switch (ue.$$typeof) {
          case l:
            return ar(ue.render);
          case h:
            return kt(ue.type, ze, ct);
          case f: {
            var ft = ue, Vt = ft._payload, Ot = ft._init;
            try {
              return kt(Ot(Vt), ze, ct);
            } catch {
            }
          }
        }
      return "";
    }
    var wt = Object.prototype.hasOwnProperty, Mn = {}, kr = x.ReactDebugCurrentFrame;
    function Gr(ue) {
      if (ue) {
        var ze = ue._owner, ct = kt(ue.type, ue._source, ze ? ze.type : null);
        kr.setExtraStackFrame(ct);
      } else
        kr.setExtraStackFrame(null);
    }
    function Pr(ue, ze, ct, ft, Vt) {
      {
        var Ot = Function.call.bind(wt);
        for (var Qt in ue)
          if (Ot(ue, Qt)) {
            var zt = void 0;
            try {
              if (typeof ue[Qt] != "function") {
                var Hr = Error((ft || "React class") + ": " + ct + " type `" + Qt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ue[Qt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Hr.name = "Invariant Violation", Hr;
              }
              zt = ue[Qt](ze, Qt, ft, ct, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Tr) {
              zt = Tr;
            }
            zt && !(zt instanceof Error) && (Gr(Vt), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ft || "React class", ct, Qt, typeof zt), Gr(null)), zt instanceof Error && !(zt.message in Mn) && (Mn[zt.message] = !0, Gr(Vt), E("Failed %s type: %s", ct, zt.message), Gr(null));
          }
      }
    }
    var Cr = Array.isArray;
    function qt(ue) {
      return Cr(ue);
    }
    function lr(ue) {
      {
        var ze = typeof Symbol == "function" && Symbol.toStringTag, ct = ze && ue[Symbol.toStringTag] || ue.constructor.name || "Object";
        return ct;
      }
    }
    function It(ue) {
      try {
        return Zr(ue), !1;
      } catch {
        return !0;
      }
    }
    function Zr(ue) {
      return "" + ue;
    }
    function Cn(ue) {
      if (It(ue))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", lr(ue)), Zr(ue);
    }
    var Sn = x.ReactCurrentOwner, vr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ln, en;
    function Fn(ue) {
      if (wt.call(ue, "ref")) {
        var ze = Object.getOwnPropertyDescriptor(ue, "ref").get;
        if (ze && ze.isReactWarning)
          return !1;
      }
      return ue.ref !== void 0;
    }
    function gn(ue) {
      if (wt.call(ue, "key")) {
        var ze = Object.getOwnPropertyDescriptor(ue, "key").get;
        if (ze && ze.isReactWarning)
          return !1;
      }
      return ue.key !== void 0;
    }
    function Gn(ue, ze) {
      typeof ue.ref == "string" && Sn.current;
    }
    function Hn(ue, ze) {
      {
        var ct = function() {
          ln || (ln = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ze));
        };
        ct.isReactWarning = !0, Object.defineProperty(ue, "key", {
          get: ct,
          configurable: !0
        });
      }
    }
    function tn(ue, ze) {
      {
        var ct = function() {
          en || (en = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ze));
        };
        ct.isReactWarning = !0, Object.defineProperty(ue, "ref", {
          get: ct,
          configurable: !0
        });
      }
    }
    var mn = function(ue, ze, ct, ft, Vt, Ot, Qt) {
      var zt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: ue,
        key: ze,
        ref: ct,
        props: Qt,
        // Record the component responsible for creating this element.
        _owner: Ot
      };
      return zt._store = {}, Object.defineProperty(zt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(zt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ft
      }), Object.defineProperty(zt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Vt
      }), Object.freeze && (Object.freeze(zt.props), Object.freeze(zt)), zt;
    };
    function In(ue, ze, ct, ft, Vt) {
      {
        var Ot, Qt = {}, zt = null, Hr = null;
        ct !== void 0 && (Cn(ct), zt = "" + ct), gn(ze) && (Cn(ze.key), zt = "" + ze.key), Fn(ze) && (Hr = ze.ref, Gn(ze, Vt));
        for (Ot in ze)
          wt.call(ze, Ot) && !vr.hasOwnProperty(Ot) && (Qt[Ot] = ze[Ot]);
        if (ue && ue.defaultProps) {
          var Tr = ue.defaultProps;
          for (Ot in Tr)
            Qt[Ot] === void 0 && (Qt[Ot] = Tr[Ot]);
        }
        if (zt || Hr) {
          var Nr = typeof ue == "function" ? ue.displayName || ue.name || "Unknown" : ue;
          zt && Hn(Qt, Nr), Hr && tn(Qt, Nr);
        }
        return mn(ue, zt, Hr, Vt, ft, Sn.current, Qt);
      }
    }
    var vn = x.ReactCurrentOwner, fr = x.ReactDebugCurrentFrame;
    function Or(ue) {
      if (ue) {
        var ze = ue._owner, ct = kt(ue.type, ue._source, ze ? ze.type : null);
        fr.setExtraStackFrame(ct);
      } else
        fr.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function yt(ue) {
      return typeof ue == "object" && ue !== null && ue.$$typeof === e;
    }
    function yn() {
      {
        if (vn.current) {
          var ue = q(vn.current.type);
          if (ue)
            return `

Check the render method of \`` + ue + "`.";
        }
        return "";
      }
    }
    function Nn(ue) {
      return "";
    }
    var Me = {};
    function M(ue) {
      {
        var ze = yn();
        if (!ze) {
          var ct = typeof ue == "string" ? ue : ue.displayName || ue.name;
          ct && (ze = `

Check the top-level render call using <` + ct + ">.");
        }
        return ze;
      }
    }
    function W(ue, ze) {
      {
        if (!ue._store || ue._store.validated || ue.key != null)
          return;
        ue._store.validated = !0;
        var ct = M(ze);
        if (Me[ct])
          return;
        Me[ct] = !0;
        var ft = "";
        ue && ue._owner && ue._owner !== vn.current && (ft = " It was passed a child from " + q(ue._owner.type) + "."), Or(ue), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ct, ft), Or(null);
      }
    }
    function se(ue, ze) {
      {
        if (typeof ue != "object")
          return;
        if (qt(ue))
          for (var ct = 0; ct < ue.length; ct++) {
            var ft = ue[ct];
            yt(ft) && W(ft, ze);
          }
        else if (yt(ue))
          ue._store && (ue._store.validated = !0);
        else if (ue) {
          var Vt = w(ue);
          if (typeof Vt == "function" && Vt !== ue.entries)
            for (var Ot = Vt.call(ue), Qt; !(Qt = Ot.next()).done; )
              yt(Qt.value) && W(Qt.value, ze);
        }
      }
    }
    function we(ue) {
      {
        var ze = ue.type;
        if (ze == null || typeof ze == "string")
          return;
        var ct;
        if (typeof ze == "function")
          ct = ze.propTypes;
        else if (typeof ze == "object" && (ze.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ze.$$typeof === h))
          ct = ze.propTypes;
        else
          return;
        if (ct) {
          var ft = q(ze);
          Pr(ct, ue.props, "prop", ft, ue);
        } else if (ze.PropTypes !== void 0 && !sn) {
          sn = !0;
          var Vt = q(ze);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Vt || "Unknown");
        }
        typeof ze.getDefaultProps == "function" && !ze.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function $e(ue) {
      {
        for (var ze = Object.keys(ue.props), ct = 0; ct < ze.length; ct++) {
          var ft = ze[ct];
          if (ft !== "children" && ft !== "key") {
            Or(ue), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ft), Or(null);
            break;
          }
        }
        ue.ref !== null && (Or(ue), E("Invalid attribute `ref` supplied to `React.Fragment`."), Or(null));
      }
    }
    var ut = {};
    function Mt(ue, ze, ct, ft, Vt, Ot) {
      {
        var Qt = de(ue);
        if (!Qt) {
          var zt = "";
          (ue === void 0 || typeof ue == "object" && ue !== null && Object.keys(ue).length === 0) && (zt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Hr = Nn();
          Hr ? zt += Hr : zt += yn();
          var Tr;
          ue === null ? Tr = "null" : qt(ue) ? Tr = "array" : ue !== void 0 && ue.$$typeof === e ? (Tr = "<" + (q(ue.type) || "Unknown") + " />", zt = " Did you accidentally export a JSX literal instead of a component?") : Tr = typeof ue, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Tr, zt);
        }
        var Nr = In(ue, ze, ct, Vt, Ot);
        if (Nr == null)
          return Nr;
        if (Qt) {
          var dr = ze.children;
          if (dr !== void 0)
            if (ft)
              if (qt(dr)) {
                for (var vi = 0; vi < dr.length; vi++)
                  se(dr[vi], ue);
                Object.freeze && Object.freeze(dr);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              se(dr, ue);
        }
        if (wt.call(ze, "key")) {
          var Xn = q(ue), Yr = Object.keys(ze).filter(function(An) {
            return An !== "key";
          }), Wr = Yr.length > 0 ? "{key: someKey, " + Yr.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ut[Xn + Wr]) {
            var oi = Yr.length > 0 ? "{" + Yr.join(": ..., ") + ": ...}" : "{}";
            E(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Wr, Xn, oi, Xn), ut[Xn + Wr] = !0;
          }
        }
        return ue === n ? $e(Nr) : we(Nr), Nr;
      }
    }
    function Zt(ue, ze, ct) {
      return Mt(ue, ze, ct, !0);
    }
    function rr(ue, ze, ct) {
      return Mt(ue, ze, ct, !1);
    }
    var Br = rr, sr = Zt;
    jh.Fragment = n, jh.jsx = Br, jh.jsxs = sr;
  })()), jh;
}
var kE;
function PU() {
  return kE || (kE = 1, process.env.NODE_ENV === "production" ? jg.exports = FU() : jg.exports = IU()), jg.exports;
}
var $t = PU();
const nn = () => {
  const r = () => Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
  return r() + r() + "-" + r() + "-" + r() + "-" + r() + "-" + r() + r() + r();
}, AP = ({
  backgroundColor: r,
  outlineColor: e,
  borderRadius: t,
  configuration: n,
  elements: i,
  height: a,
  maxHeight: s,
  maxWidth: o,
  outlineArea: l,
  position: u,
  preserveAspectRatio: c,
  viewBox: h,
  width: f
}) => {
  const p = t || 0, m = 2 * (l?.scale || 1), A = h || { x: 0, y: 0, width: f, height: a }, w = `${A.x} ${A.y} ${A.width} ${A.height}`, x = nn(), E = n.purpose === Hp.FreeDesign && /* @__PURE__ */ $t.jsx("defs", { children: /* @__PURE__ */ $t.jsx("clipPath", { id: "viewboxClip", children: /* @__PURE__ */ $t.jsx("rect", { width: A.width, height: A.height, rx: p }) }) }), T = n.colorProfiles?.map((_, L) => (
    /* @ts-ignore */
    /* @__PURE__ */ $t.jsx("color-profile", { name: _.name, xlinkHref: _.key, children: " " }, L)
  )), D = i.map((_) => ({
    ..._,
    _renderingConfiguration: n,
    mask: l ? `url(#viewmask-${x})` : void 0
  })), F = cx(D);
  return /* @__PURE__ */ $t.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      xmlSpace: "preserve",
      version: "1.1",
      preserveAspectRatio: c,
      width: f,
      height: a,
      style: {
        gridColumn: 1,
        gridRow: 1,
        maxWidth: o,
        maxHeight: s,
        position: u
      },
      viewBox: w,
      children: [
        T,
        E,
        !!r && /* @__PURE__ */ $t.jsx(
          "rect",
          {
            id: "layout-background",
            width: A.width,
            height: A.height,
            fill: r,
            rx: p
          }
        ),
        /* @__PURE__ */ $t.jsx(
          "g",
          {
            id: "element-group",
            clipPath: n.purpose === Hp.FreeDesign ? "url(#viewboxClip)" : void 0,
            children: F.map((_) => ID(_)).filter((_) => !!_)
          }
        ),
        l && /* @__PURE__ */ $t.jsx(
          "rect",
          {
            x: l.x,
            y: l.y,
            width: l.width,
            height: l.height,
            fill: "none",
            stroke: l.hidden ? "none" : e || "#aaaaaa",
            strokeWidth: m / 2,
            strokeDasharray: `${m * 2} ${m}`
          }
        ),
        l && /* @__PURE__ */ $t.jsxs("mask", { id: `viewmask-${x}`, children: [
          /* @__PURE__ */ $t.jsx(
            "rect",
            {
              x: A.x,
              y: A.y,
              width: A.width,
              height: A.height,
              fill: "black"
            }
          ),
          /* @__PURE__ */ $t.jsx(
            "rect",
            {
              x: l.x,
              y: l.y,
              width: l.width,
              height: l.height,
              fill: "white"
            }
          )
        ] })
      ]
    }
  );
}, Ure = (r, e, t, n, i) => {
  const a = Oc(i), s = t / 2, o = n / 2, l = r + s, u = e + o, c = Math.sin(a), h = Math.cos(a), f = s, p = s, m = -o, A = o, w = f * h - m * c, x = p * h - A * c, E = f * c + m * h, T = p * c + A * h, D = Math.max(Math.abs(w), Math.abs(x)), F = Math.max(Math.abs(E), Math.abs(T));
  return {
    minX: l - D,
    maxX: l + D,
    minY: u - F,
    maxY: u + F
  };
}, Vre = (r, e, t) => {
  const n = Math.sqrt(Math.pow(e.x - r.x, 2) + Math.pow(e.y - r.y, 2)), i = Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2)), a = Math.sqrt(Math.pow(t.x - r.x, 2) + Math.pow(t.y - r.y, 2));
  return Math.acos((i * i + n * n - a * a) / (2 * i * n)) * (180 / Math.PI);
}, Oc = (r) => r * (Math.PI / 180), $re = (r, e, t) => Math.abs(r - e) < t, zre = (r, e, t) => {
  const n = Math.sin(Oc(t)), i = Math.cos(Oc(t));
  return {
    x: (r.x - e.x) * i - (r.y - e.y) * n + e.x,
    y: (r.x - e.x) * n + (r.y - e.y) * i + e.y
  };
}, Gre = (r, e) => ({
  x: (r.x + e.x) / 2,
  y: (r.y + e.y) / 2
}), Hre = (r, e, t, n) => ({
  x: r.x + e?.x * t,
  y: r.y + e?.y * n
}), Wre = (r, e, t, n) => ({
  x: r.x + (e?.x + e?.width) * t,
  y: r.y + e?.y * n
}), jre = (r, e, t, n) => ({
  x: r.x + (e?.x + e?.width) * t,
  y: r.y + (e?.y + e?.height) * n
}), dd = (r) => {
  switch (r) {
    case Ma.North:
      return Ma.East;
    case Ma.East:
      return Ma.South;
    case Ma.South:
      return Ma.West;
    case Ma.West:
      return Ma.North;
    case Ma.Northwest:
      return Ma.Northeast;
    case Ma.Northeast:
      return Ma.Southeast;
    case Ma.Southeast:
      return Ma.Southwest;
    case Ma.Southwest:
      return Ma.Northwest;
  }
}, qre = (r, e) => e > 45 && e <= 135 ? dd(r) : e > 135 && e <= 225 ? dd(dd(r)) : e > 225 && e <= 315 ? dd(dd(dd(r))) : r, Qre = (r, e = { x: 0, y: 0 }, t = { x: 1, y: 1 }) => {
  const n = Oc(r.rotation), i = {
    x: e.x + r.x * t.x,
    y: e.x + r.y * t.y
  }, a = {
    x: r.x + r.width,
    y: r.y
  }, s = {
    x: e.x + (r.x + r.width) * t.x,
    y: e.y + (r.height + r.y) * t.y
  }, o = {
    x: e.x + r.x * t.x,
    y: e.y + (r.height + r.y) * t.y
  }, l = {
    x: (o.x + s.x) / 2,
    y: o.y - r.height * t.y / 2
  };
  return {
    a: qg(i, l, n),
    b: qg(a, l, n),
    c: qg(s, l, n),
    d: qg(o, l, n),
    center: l
  };
}, qg = (r, e, t) => {
  const n = Math.sin(t), i = Math.cos(t);
  return {
    x: (r.x - e.x) * i - (r.y - e.y) * n + e.x,
    y: (r.x - e.x) * n + (r.y - e.y) * i + e.y
  };
}, Yre = 0.352778, Xre = 0.035277, wP = (r) => {
  const e = r.rotation || 0, t = Oc(e), n = Math.cos(t), i = -Math.sin(t);
  return /* @__PURE__ */ $t.jsx("g", { mask: r.stepName || r.productOverlay ? void 0 : r.mask, children: /* @__PURE__ */ $t.jsx(
    "g",
    {
      transform: `
                matrix(1, 0, 0, 1, ${r.x}, ${r.y})
                matrix(1, 0, 0, 1, ${r.width / 2}, ${r.height / 2})
                matrix(${n}, ${-i}, ${i}, ${n}, 0, 0)
                matrix(1, 0, 0, 1, ${-r.width / 2}, ${-r.height / 2})
                `,
      children: /* @__PURE__ */ $t.jsx(
        "image",
        {
          xlinkHref: r.src,
          preserveAspectRatio: r.preserveAspectRatio,
          width: r.width,
          height: r.height
        }
      )
    }
  ) });
}, xP = (r) => {
  const e = `spiff-group-clip-${r.id}`, t = r.rotation || 0, n = Oc(t), i = Math.cos(n), a = -Math.sin(n), s = cx(r.children), o = () => /* @__PURE__ */ $t.jsx("clipPath", { id: e, preserveAspectRatio: "none", children: r.clipPath ? /* @__PURE__ */ $t.jsx("path", { d: r.clipPath }) : /* @__PURE__ */ $t.jsx("rect", { x: 0, y: 0, width: r.width, height: r.height }) });
  return /* @__PURE__ */ $t.jsxs($t.Fragment, { children: [
    /* @__PURE__ */ $t.jsx("defs", { children: o() }),
    /* @__PURE__ */ $t.jsxs(
      "g",
      {
        transform: `
                matrix(1, 0, 0, 1, ${r.x}, ${r.y})
                matrix(1, 0, 0, 1, ${r.width / 2}, ${r.height / 2})
                matrix(${i}, ${-a}, ${a}, ${i}, 0, 0)
                matrix(1, 0, 0, 1, ${-r.width / 2}, ${-r.height / 2})
                `,
        children: [
          r._renderingConfiguration?.debug ? /* @__PURE__ */ $t.jsx(
            "rect",
            {
              stroke: "red",
              opacity: 0.3,
              fill: "none",
              x: 0,
              y: 0,
              width: r.width,
              height: r.height
            }
          ) : void 0,
          s.map((l) => ID(l)).filter((l) => !!l).map((l) => /* @__PURE__ */ $t.jsx("g", { clipPath: `url(#${e})`, children: l }, e))
        ]
      }
    )
  ] });
};
var DU = Vf();
const RU = (r) => {
  const e = `spiff-frame-${r.id}`, t = `spiff-frame-threshold-${r.id}`, n = () => {
    if (!r.pattern)
      return "";
    if (r.pattern.svg) {
      const h = Vw(r.pattern.svg, r.pattern.colors || {}, !1);
      return Iw(h);
    }
    return r.pattern.src;
  };
  if (!n())
    return /* @__PURE__ */ $t.jsx(DU.Fragment, {});
  const i = () => r.threshold ? r.invertThreshold ? "1 ".repeat(r.threshold) + "0 ".repeat(256 - r.threshold) : "0 ".repeat(r.threshold) + "1 ".repeat(256 - r.threshold) : "", a = () => /* @__PURE__ */ $t.jsx($t.Fragment, { children: r.useThreshold && /* @__PURE__ */ $t.jsx("defs", { children: /* @__PURE__ */ $t.jsxs("filter", { id: t, "color-interpolation-filters": "sRGB", children: [
    /* @__PURE__ */ $t.jsx(
      "feColorMatrix",
      {
        type: "matrix",
        values: `
                            ${r.thresholdSaturation} ${r.thresholdSaturation} ${r.thresholdSaturation} 0 0
                            ${r.thresholdSaturation} ${r.thresholdSaturation} ${r.thresholdSaturation} 0 0
                            ${r.thresholdSaturation} ${r.thresholdSaturation} ${r.thresholdSaturation} 0 0
                            0 0 0 1 0
                        `,
        result: "greyscale"
      }
    ),
    /* @__PURE__ */ $t.jsxs("feComponentTransfer", { in: "greyscale", children: [
      /* @__PURE__ */ $t.jsx("feFuncR", { type: "discrete", tableValues: i() }),
      /* @__PURE__ */ $t.jsx("feFuncG", { type: "discrete", tableValues: i() }),
      /* @__PURE__ */ $t.jsx("feFuncB", { type: "discrete", tableValues: i() })
    ] })
  ] }) }) }), s = r.rotation || 0, o = Oc(s), l = Math.cos(o), u = -Math.sin(o), c = () => {
    const h = r.pattern?.x || 0, f = r.pattern?.y || 0, p = r.pattern?.width || 0, m = r.pattern?.height || 0, A = r.pattern?.scaleX || 1, w = r.pattern?.scaleY || 1, x = r.pattern?.rotation || 0;
    return [r.pattern?.svg ? {
      id: `${e}-contents`,
      type: Mr.Illustration,
      x: h,
      y: f,
      rotation: x,
      width: p * A,
      height: m * w,
      src: n(),
      svg: r.pattern?.svg,
      colors: r.pattern?.colors
    } : {
      id: `${e}-contents`,
      type: Mr.Image,
      x: h,
      y: f,
      rotation: x,
      width: p * A,
      height: m * w,
      src: n()
    }];
  };
  return /* @__PURE__ */ $t.jsxs($t.Fragment, { children: [
    a(),
    /* @__PURE__ */ $t.jsx(
      "g",
      {
        opacity: r.opacity,
        mask: r.stepName ? void 0 : r.mask,
        filter: r.useThreshold ? `url(#${t})` : void 0,
        children: /* @__PURE__ */ $t.jsx(
          "g",
          {
            transform: `
                matrix(1, 0, 0, 1, ${r.x}, ${r.y})
                matrix(1, 0, 0, 1, ${r.width / 2}, ${r.height / 2})
                matrix(${l}, ${-u}, ${u}, ${l}, 0, 0)
                matrix(1, 0, 0, 1, ${-r.width / 2}, ${-r.height / 2})
                matrix(${r.scaleX}, 0, 0, ${r.scaleY}, 0, 0)
                `,
            children: /* @__PURE__ */ $t.jsx(
              xP,
              {
                id: e,
                x: 0,
                y: 0,
                rotation: 0,
                width: r.width,
                height: r.height,
                clipPath: r.path,
                children: c()
              }
            )
          }
        )
      }
    )
  ] });
};
String.prototype.codePointAt || (function() {
  var r = (function() {
    try {
      var t = {}, n = Object.defineProperty, i = n(t, t, t) && n;
    } catch {
    }
    return i;
  })(), e = function(t) {
    if (this == null)
      throw TypeError();
    var n = String(this), i = n.length, a = t ? Number(t) : 0;
    if (a != a && (a = 0), !(a < 0 || a >= i)) {
      var s = n.charCodeAt(a), o;
      return (
        // check if it’s the start of a surrogate pair
        s >= 55296 && s <= 56319 && // high surrogate
        i > a + 1 && (o = n.charCodeAt(a + 1), o >= 56320 && o <= 57343) ? (s - 55296) * 1024 + o - 56320 + 65536 : s
      );
    }
  };
  r ? r(String.prototype, "codePointAt", {
    value: e,
    configurable: !0,
    writable: !0
  }) : String.prototype.codePointAt = e;
})();
var Xw = 0, bP = -3;
function qp() {
  this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
}
function OU(r, e) {
  this.source = r, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = e, this.destLen = 0, this.ltree = new qp(), this.dtree = new qp();
}
var CP = new qp(), SP = new qp(), Jw = new Uint8Array(30), Kw = new Uint16Array(30), EP = new Uint8Array(30), kP = new Uint16Array(30), BU = new Uint8Array([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]), TE = new qp(), bl = new Uint8Array(320);
function TP(r, e, t, n) {
  var i, a;
  for (i = 0; i < t; ++i)
    r[i] = 0;
  for (i = 0; i < 30 - t; ++i)
    r[i + t] = i / t | 0;
  for (a = n, i = 0; i < 30; ++i)
    e[i] = a, a += 1 << r[i];
}
function _U(r, e) {
  var t;
  for (t = 0; t < 7; ++t)
    r.table[t] = 0;
  for (r.table[7] = 24, r.table[8] = 152, r.table[9] = 112, t = 0; t < 24; ++t)
    r.trans[t] = 256 + t;
  for (t = 0; t < 144; ++t)
    r.trans[24 + t] = t;
  for (t = 0; t < 8; ++t)
    r.trans[168 + t] = 280 + t;
  for (t = 0; t < 112; ++t)
    r.trans[176 + t] = 144 + t;
  for (t = 0; t < 5; ++t)
    e.table[t] = 0;
  for (e.table[5] = 32, t = 0; t < 32; ++t)
    e.trans[t] = t;
}
var FE = new Uint16Array(16);
function ly(r, e, t, n) {
  var i, a;
  for (i = 0; i < 16; ++i)
    r.table[i] = 0;
  for (i = 0; i < n; ++i)
    r.table[e[t + i]]++;
  for (r.table[0] = 0, a = 0, i = 0; i < 16; ++i)
    FE[i] = a, a += r.table[i];
  for (i = 0; i < n; ++i)
    e[t + i] && (r.trans[FE[e[t + i]]++] = i);
}
function MU(r) {
  r.bitcount-- || (r.tag = r.source[r.sourceIndex++], r.bitcount = 7);
  var e = r.tag & 1;
  return r.tag >>>= 1, e;
}
function Fl(r, e, t) {
  if (!e)
    return t;
  for (; r.bitcount < 24; )
    r.tag |= r.source[r.sourceIndex++] << r.bitcount, r.bitcount += 8;
  var n = r.tag & 65535 >>> 16 - e;
  return r.tag >>>= e, r.bitcount -= e, n + t;
}
function D1(r, e) {
  for (; r.bitcount < 24; )
    r.tag |= r.source[r.sourceIndex++] << r.bitcount, r.bitcount += 8;
  var t = 0, n = 0, i = 0, a = r.tag;
  do
    n = 2 * n + (a & 1), a >>>= 1, ++i, t += e.table[i], n -= e.table[i];
  while (n >= 0);
  return r.tag = a, r.bitcount -= i, e.trans[t + n];
}
function NU(r, e, t) {
  var n, i, a, s, o, l;
  for (n = Fl(r, 5, 257), i = Fl(r, 5, 1), a = Fl(r, 4, 4), s = 0; s < 19; ++s)
    bl[s] = 0;
  for (s = 0; s < a; ++s) {
    var u = Fl(r, 3, 0);
    bl[BU[s]] = u;
  }
  for (ly(TE, bl, 0, 19), o = 0; o < n + i; ) {
    var c = D1(r, TE);
    switch (c) {
      case 16:
        var h = bl[o - 1];
        for (l = Fl(r, 2, 3); l; --l)
          bl[o++] = h;
        break;
      case 17:
        for (l = Fl(r, 3, 3); l; --l)
          bl[o++] = 0;
        break;
      case 18:
        for (l = Fl(r, 7, 11); l; --l)
          bl[o++] = 0;
        break;
      default:
        bl[o++] = c;
        break;
    }
  }
  ly(e, bl, 0, n), ly(t, bl, n, i);
}
function IE(r, e, t) {
  for (; ; ) {
    var n = D1(r, e);
    if (n === 256)
      return Xw;
    if (n < 256)
      r.dest[r.destLen++] = n;
    else {
      var i, a, s, o;
      for (n -= 257, i = Fl(r, Jw[n], Kw[n]), a = D1(r, t), s = r.destLen - Fl(r, EP[a], kP[a]), o = s; o < s + i; ++o)
        r.dest[r.destLen++] = r.dest[o];
    }
  }
}
function LU(r) {
  for (var e, t, n; r.bitcount > 8; )
    r.sourceIndex--, r.bitcount -= 8;
  if (e = r.source[r.sourceIndex + 1], e = 256 * e + r.source[r.sourceIndex], t = r.source[r.sourceIndex + 3], t = 256 * t + r.source[r.sourceIndex + 2], e !== (~t & 65535))
    return bP;
  for (r.sourceIndex += 4, n = e; n; --n)
    r.dest[r.destLen++] = r.source[r.sourceIndex++];
  return r.bitcount = 0, Xw;
}
function UU(r, e) {
  var t = new OU(r, e), n, i, a;
  do {
    switch (n = MU(t), i = Fl(t, 2, 0), i) {
      case 0:
        a = LU(t);
        break;
      case 1:
        a = IE(t, CP, SP);
        break;
      case 2:
        NU(t, t.ltree, t.dtree), a = IE(t, t.ltree, t.dtree);
        break;
      default:
        a = bP;
    }
    if (a !== Xw)
      throw new Error("Data error");
  } while (!n);
  return t.destLen < t.dest.length ? typeof t.dest.slice == "function" ? t.dest.slice(0, t.destLen) : t.dest.subarray(0, t.destLen) : t.dest;
}
_U(CP, SP);
TP(Jw, Kw, 4, 3);
TP(EP, kP, 2, 1);
Jw[28] = 0;
Kw[28] = 258;
var VU = UU;
function hd(r, e, t, n, i) {
  return Math.pow(1 - i, 3) * r + 3 * Math.pow(1 - i, 2) * i * e + 3 * (1 - i) * Math.pow(i, 2) * t + Math.pow(i, 3) * n;
}
function Uc() {
  this.x1 = Number.NaN, this.y1 = Number.NaN, this.x2 = Number.NaN, this.y2 = Number.NaN;
}
Uc.prototype.isEmpty = function() {
  return isNaN(this.x1) || isNaN(this.y1) || isNaN(this.x2) || isNaN(this.y2);
};
Uc.prototype.addPoint = function(r, e) {
  typeof r == "number" && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = r, this.x2 = r), r < this.x1 && (this.x1 = r), r > this.x2 && (this.x2 = r)), typeof e == "number" && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = e, this.y2 = e), e < this.y1 && (this.y1 = e), e > this.y2 && (this.y2 = e));
};
Uc.prototype.addX = function(r) {
  this.addPoint(r, null);
};
Uc.prototype.addY = function(r) {
  this.addPoint(null, r);
};
Uc.prototype.addBezier = function(r, e, t, n, i, a, s, o) {
  var l = [r, e], u = [t, n], c = [i, a], h = [s, o];
  this.addPoint(r, e), this.addPoint(s, o);
  for (var f = 0; f <= 1; f++) {
    var p = 6 * l[f] - 12 * u[f] + 6 * c[f], m = -3 * l[f] + 9 * u[f] - 9 * c[f] + 3 * h[f], A = 3 * u[f] - 3 * l[f];
    if (m === 0) {
      if (p === 0)
        continue;
      var w = -A / p;
      0 < w && w < 1 && (f === 0 && this.addX(hd(l[f], u[f], c[f], h[f], w)), f === 1 && this.addY(hd(l[f], u[f], c[f], h[f], w)));
      continue;
    }
    var x = Math.pow(p, 2) - 4 * A * m;
    if (!(x < 0)) {
      var E = (-p + Math.sqrt(x)) / (2 * m);
      0 < E && E < 1 && (f === 0 && this.addX(hd(l[f], u[f], c[f], h[f], E)), f === 1 && this.addY(hd(l[f], u[f], c[f], h[f], E)));
      var T = (-p - Math.sqrt(x)) / (2 * m);
      0 < T && T < 1 && (f === 0 && this.addX(hd(l[f], u[f], c[f], h[f], T)), f === 1 && this.addY(hd(l[f], u[f], c[f], h[f], T)));
    }
  }
};
Uc.prototype.addQuad = function(r, e, t, n, i, a) {
  var s = r + 0.6666666666666666 * (t - r), o = e + 2 / 3 * (n - e), l = s + 1 / 3 * (i - r), u = o + 1 / 3 * (a - e);
  this.addBezier(r, e, s, o, l, u, i, a);
};
function ha() {
  this.commands = [], this.fill = "black", this.stroke = null, this.strokeWidth = 1;
}
ha.prototype.moveTo = function(r, e) {
  this.commands.push({
    type: "M",
    x: r,
    y: e
  });
};
ha.prototype.lineTo = function(r, e) {
  this.commands.push({
    type: "L",
    x: r,
    y: e
  });
};
ha.prototype.curveTo = ha.prototype.bezierCurveTo = function(r, e, t, n, i, a) {
  this.commands.push({
    type: "C",
    x1: r,
    y1: e,
    x2: t,
    y2: n,
    x: i,
    y: a
  });
};
ha.prototype.quadTo = ha.prototype.quadraticCurveTo = function(r, e, t, n) {
  this.commands.push({
    type: "Q",
    x1: r,
    y1: e,
    x: t,
    y: n
  });
};
ha.prototype.close = ha.prototype.closePath = function() {
  this.commands.push({
    type: "Z"
  });
};
ha.prototype.extend = function(r) {
  if (r.commands)
    r = r.commands;
  else if (r instanceof Uc) {
    var e = r;
    this.moveTo(e.x1, e.y1), this.lineTo(e.x2, e.y1), this.lineTo(e.x2, e.y2), this.lineTo(e.x1, e.y2), this.close();
    return;
  }
  Array.prototype.push.apply(this.commands, r);
};
ha.prototype.getBoundingBox = function() {
  for (var r = new Uc(), e = 0, t = 0, n = 0, i = 0, a = 0; a < this.commands.length; a++) {
    var s = this.commands[a];
    switch (s.type) {
      case "M":
        r.addPoint(s.x, s.y), e = n = s.x, t = i = s.y;
        break;
      case "L":
        r.addPoint(s.x, s.y), n = s.x, i = s.y;
        break;
      case "Q":
        r.addQuad(n, i, s.x1, s.y1, s.x, s.y), n = s.x, i = s.y;
        break;
      case "C":
        r.addBezier(n, i, s.x1, s.y1, s.x2, s.y2, s.x, s.y), n = s.x, i = s.y;
        break;
      case "Z":
        n = e, i = t;
        break;
      default:
        throw new Error("Unexpected path command " + s.type);
    }
  }
  return r.isEmpty() && r.addPoint(0, 0), r;
};
ha.prototype.draw = function(r) {
  r.beginPath();
  for (var e = 0; e < this.commands.length; e += 1) {
    var t = this.commands[e];
    t.type === "M" ? r.moveTo(t.x, t.y) : t.type === "L" ? r.lineTo(t.x, t.y) : t.type === "C" ? r.bezierCurveTo(t.x1, t.y1, t.x2, t.y2, t.x, t.y) : t.type === "Q" ? r.quadraticCurveTo(t.x1, t.y1, t.x, t.y) : t.type === "Z" && r.closePath();
  }
  this.fill && (r.fillStyle = this.fill, r.fill()), this.stroke && (r.strokeStyle = this.stroke, r.lineWidth = this.strokeWidth, r.stroke());
};
ha.prototype.toPathData = function(r) {
  r = r !== void 0 ? r : 2;
  function e(s) {
    return Math.round(s) === s ? "" + Math.round(s) : s.toFixed(r);
  }
  function t() {
    for (var s = arguments, o = "", l = 0; l < arguments.length; l += 1) {
      var u = s[l];
      u >= 0 && l > 0 && (o += " "), o += e(u);
    }
    return o;
  }
  for (var n = "", i = 0; i < this.commands.length; i += 1) {
    var a = this.commands[i];
    a.type === "M" ? n += "M" + t(a.x, a.y) : a.type === "L" ? n += "L" + t(a.x, a.y) : a.type === "C" ? n += "C" + t(a.x1, a.y1, a.x2, a.y2, a.x, a.y) : a.type === "Q" ? n += "Q" + t(a.x1, a.y1, a.x, a.y) : a.type === "Z" && (n += "Z");
  }
  return n;
};
ha.prototype.toSVG = function(r) {
  var e = '<path d="';
  return e += this.toPathData(r), e += '"', this.fill && this.fill !== "black" && (this.fill === null ? e += ' fill="none"' : e += ' fill="' + this.fill + '"'), this.stroke && (e += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"'), e += "/>", e;
};
ha.prototype.toDOMElement = function(r) {
  var e = this.toPathData(r), t = document.createElementNS("http://www.w3.org/2000/svg", "path");
  return t.setAttribute("d", e), t;
};
function FP(r) {
  throw new Error(r);
}
function PE(r, e) {
  r || FP(e);
}
var xr = { fail: FP, argument: PE, assert: PE }, DE = 32768, RE = 2147483648, Gd = {}, bt = {}, Er = {};
function el(r) {
  return function() {
    return r;
  };
}
bt.BYTE = function(r) {
  return xr.argument(r >= 0 && r <= 255, "Byte value should be between 0 and 255."), [r];
};
Er.BYTE = el(1);
bt.CHAR = function(r) {
  return [r.charCodeAt(0)];
};
Er.CHAR = el(1);
bt.CHARARRAY = function(r) {
  typeof r > "u" && (r = "", console.warn("Undefined CHARARRAY encountered and treated as an empty string. This is probably caused by a missing glyph name."));
  for (var e = [], t = 0; t < r.length; t += 1)
    e[t] = r.charCodeAt(t);
  return e;
};
Er.CHARARRAY = function(r) {
  return typeof r > "u" ? 0 : r.length;
};
bt.USHORT = function(r) {
  return [r >> 8 & 255, r & 255];
};
Er.USHORT = el(2);
bt.SHORT = function(r) {
  return r >= DE && (r = -(2 * DE - r)), [r >> 8 & 255, r & 255];
};
Er.SHORT = el(2);
bt.UINT24 = function(r) {
  return [r >> 16 & 255, r >> 8 & 255, r & 255];
};
Er.UINT24 = el(3);
bt.ULONG = function(r) {
  return [r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, r & 255];
};
Er.ULONG = el(4);
bt.LONG = function(r) {
  return r >= RE && (r = -(2 * RE - r)), [r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, r & 255];
};
Er.LONG = el(4);
bt.FIXED = bt.ULONG;
Er.FIXED = Er.ULONG;
bt.FWORD = bt.SHORT;
Er.FWORD = Er.SHORT;
bt.UFWORD = bt.USHORT;
Er.UFWORD = Er.USHORT;
bt.LONGDATETIME = function(r) {
  return [0, 0, 0, 0, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, r & 255];
};
Er.LONGDATETIME = el(8);
bt.TAG = function(r) {
  return xr.argument(r.length === 4, "Tag should be exactly 4 ASCII characters."), [
    r.charCodeAt(0),
    r.charCodeAt(1),
    r.charCodeAt(2),
    r.charCodeAt(3)
  ];
};
Er.TAG = el(4);
bt.Card8 = bt.BYTE;
Er.Card8 = Er.BYTE;
bt.Card16 = bt.USHORT;
Er.Card16 = Er.USHORT;
bt.OffSize = bt.BYTE;
Er.OffSize = Er.BYTE;
bt.SID = bt.USHORT;
Er.SID = Er.USHORT;
bt.NUMBER = function(r) {
  return r >= -107 && r <= 107 ? [r + 139] : r >= 108 && r <= 1131 ? (r = r - 108, [(r >> 8) + 247, r & 255]) : r >= -1131 && r <= -108 ? (r = -r - 108, [(r >> 8) + 251, r & 255]) : r >= -32768 && r <= 32767 ? bt.NUMBER16(r) : bt.NUMBER32(r);
};
Er.NUMBER = function(r) {
  return bt.NUMBER(r).length;
};
bt.NUMBER16 = function(r) {
  return [28, r >> 8 & 255, r & 255];
};
Er.NUMBER16 = el(3);
bt.NUMBER32 = function(r) {
  return [29, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, r & 255];
};
Er.NUMBER32 = el(5);
bt.REAL = function(r) {
  var e = r.toString(), t = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(e);
  if (t) {
    var n = parseFloat("1e" + ((t[2] ? +t[2] : 0) + t[1].length));
    e = (Math.round(r * n) / n).toString();
  }
  for (var i = "", a = 0, s = e.length; a < s; a += 1) {
    var o = e[a];
    o === "e" ? i += e[++a] === "-" ? "c" : "b" : o === "." ? i += "a" : o === "-" ? i += "e" : i += o;
  }
  i += i.length & 1 ? "f" : "ff";
  for (var l = [30], u = 0, c = i.length; u < c; u += 2)
    l.push(parseInt(i.substr(u, 2), 16));
  return l;
};
Er.REAL = function(r) {
  return bt.REAL(r).length;
};
bt.NAME = bt.CHARARRAY;
Er.NAME = Er.CHARARRAY;
bt.STRING = bt.CHARARRAY;
Er.STRING = Er.CHARARRAY;
Gd.UTF8 = function(r, e, t) {
  for (var n = [], i = t, a = 0; a < i; a++, e += 1)
    n[a] = r.getUint8(e);
  return String.fromCharCode.apply(null, n);
};
Gd.UTF16 = function(r, e, t) {
  for (var n = [], i = t / 2, a = 0; a < i; a++, e += 2)
    n[a] = r.getUint16(e);
  return String.fromCharCode.apply(null, n);
};
bt.UTF16 = function(r) {
  for (var e = [], t = 0; t < r.length; t += 1) {
    var n = r.charCodeAt(t);
    e[e.length] = n >> 8 & 255, e[e.length] = n & 255;
  }
  return e;
};
Er.UTF16 = function(r) {
  return r.length * 2;
};
var R1 = {
  "x-mac-croatian": (
    // Python: 'mac_croatian'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ"
  ),
  "x-mac-cyrillic": (
    // Python: 'mac_cyrillic'
    "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю"
  ),
  "x-mac-gaelic": (
    // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/GAELIC.TXT
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæøṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ"
  ),
  "x-mac-greek": (
    // Python: 'mac_greek'
    "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ­"
  ),
  "x-mac-icelandic": (
    // Python: 'mac_iceland'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  ),
  "x-mac-inuit": (
    // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/INUIT.TXT
    "ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł"
  ),
  "x-mac-ce": (
    // Python: 'mac_latin2'
    "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ"
  ),
  macintosh: (
    // Python: 'mac_roman'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  ),
  "x-mac-romanian": (
    // Python: 'mac_romanian'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  ),
  "x-mac-turkish": (
    // Python: 'mac_turkish'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ"
  )
};
Gd.MACSTRING = function(r, e, t, n) {
  var i = R1[n];
  if (i !== void 0) {
    for (var a = "", s = 0; s < t; s++) {
      var o = r.getUint8(e + s);
      o <= 127 ? a += String.fromCharCode(o) : a += i[o & 127];
    }
    return a;
  }
};
var Qg = typeof WeakMap == "function" && /* @__PURE__ */ new WeakMap(), Yg, $U = function(r) {
  if (!Yg) {
    Yg = {};
    for (var e in R1)
      Yg[e] = new String(e);
  }
  var t = Yg[r];
  if (t !== void 0) {
    if (Qg) {
      var n = Qg.get(t);
      if (n !== void 0)
        return n;
    }
    var i = R1[r];
    if (i !== void 0) {
      for (var a = {}, s = 0; s < i.length; s++)
        a[i.charCodeAt(s)] = s + 128;
      return Qg && Qg.set(t, a), a;
    }
  }
};
bt.MACSTRING = function(r, e) {
  var t = $U(e);
  if (t !== void 0) {
    for (var n = [], i = 0; i < r.length; i++) {
      var a = r.charCodeAt(i);
      if (a >= 128 && (a = t[a], a === void 0))
        return;
      n[i] = a;
    }
    return n;
  }
};
Er.MACSTRING = function(r, e) {
  var t = bt.MACSTRING(r, e);
  return t !== void 0 ? t.length : 0;
};
function O1(r) {
  return r >= -128 && r <= 127;
}
function zU(r, e, t) {
  for (var n = 0, i = r.length; e < i && n < 64 && r[e] === 0; )
    ++e, ++n;
  return t.push(128 | n - 1), e;
}
function GU(r, e, t) {
  for (var n = 0, i = r.length, a = e; a < i && n < 64; ) {
    var s = r[a];
    if (!O1(s) || s === 0 && a + 1 < i && r[a + 1] === 0)
      break;
    ++a, ++n;
  }
  t.push(n - 1);
  for (var o = e; o < a; ++o)
    t.push(r[o] + 256 & 255);
  return a;
}
function HU(r, e, t) {
  for (var n = 0, i = r.length, a = e; a < i && n < 64; ) {
    var s = r[a];
    if (s === 0 || O1(s) && a + 1 < i && O1(r[a + 1]))
      break;
    ++a, ++n;
  }
  t.push(64 | n - 1);
  for (var o = e; o < a; ++o) {
    var l = r[o];
    t.push(l + 65536 >> 8 & 255, l + 256 & 255);
  }
  return a;
}
bt.VARDELTAS = function(r) {
  for (var e = 0, t = []; e < r.length; ) {
    var n = r[e];
    n === 0 ? e = zU(r, e, t) : n >= -128 && n <= 127 ? e = GU(r, e, t) : e = HU(r, e, t);
  }
  return t;
};
bt.INDEX = function(r) {
  for (var e = 1, t = [e], n = [], i = 0; i < r.length; i += 1) {
    var a = bt.OBJECT(r[i]);
    Array.prototype.push.apply(n, a), e += a.length, t.push(e);
  }
  if (n.length === 0)
    return [0, 0];
  for (var s = [], o = 1 + Math.floor(Math.log(e) / Math.log(2)) / 8 | 0, l = [void 0, bt.BYTE, bt.USHORT, bt.UINT24, bt.ULONG][o], u = 0; u < t.length; u += 1) {
    var c = l(t[u]);
    Array.prototype.push.apply(s, c);
  }
  return Array.prototype.concat(
    bt.Card16(r.length),
    bt.OffSize(o),
    s,
    n
  );
};
Er.INDEX = function(r) {
  return bt.INDEX(r).length;
};
bt.DICT = function(r) {
  for (var e = [], t = Object.keys(r), n = t.length, i = 0; i < n; i += 1) {
    var a = parseInt(t[i], 0), s = r[a];
    e = e.concat(bt.OPERAND(s.value, s.type)), e = e.concat(bt.OPERATOR(a));
  }
  return e;
};
Er.DICT = function(r) {
  return bt.DICT(r).length;
};
bt.OPERATOR = function(r) {
  return r < 1200 ? [r] : [12, r - 1200];
};
bt.OPERAND = function(r, e) {
  var t = [];
  if (Array.isArray(e))
    for (var n = 0; n < e.length; n += 1)
      xr.argument(r.length === e.length, "Not enough arguments given for type" + e), t = t.concat(bt.OPERAND(r[n], e[n]));
  else if (e === "SID")
    t = t.concat(bt.NUMBER(r));
  else if (e === "offset")
    t = t.concat(bt.NUMBER32(r));
  else if (e === "number")
    t = t.concat(bt.NUMBER(r));
  else if (e === "real")
    t = t.concat(bt.REAL(r));
  else
    throw new Error("Unknown operand type " + e);
  return t;
};
bt.OP = bt.BYTE;
Er.OP = Er.BYTE;
var Xg = typeof WeakMap == "function" && /* @__PURE__ */ new WeakMap();
bt.CHARSTRING = function(r) {
  if (Xg) {
    var e = Xg.get(r);
    if (e !== void 0)
      return e;
  }
  for (var t = [], n = r.length, i = 0; i < n; i += 1) {
    var a = r[i];
    t = t.concat(bt[a.type](a.value));
  }
  return Xg && Xg.set(r, t), t;
};
Er.CHARSTRING = function(r) {
  return bt.CHARSTRING(r).length;
};
bt.OBJECT = function(r) {
  var e = bt[r.type];
  return xr.argument(e !== void 0, "No encoding function for type " + r.type), e(r.value);
};
Er.OBJECT = function(r) {
  var e = Er[r.type];
  return xr.argument(e !== void 0, "No sizeOf function for type " + r.type), e(r.value);
};
bt.TABLE = function(r) {
  for (var e = [], t = r.fields.length, n = [], i = [], a = 0; a < t; a += 1) {
    var s = r.fields[a], o = bt[s.type];
    xr.argument(o !== void 0, "No encoding function for field type " + s.type + " (" + s.name + ")");
    var l = r[s.name];
    l === void 0 && (l = s.value);
    var u = o(l);
    s.type === "TABLE" ? (i.push(e.length), e = e.concat([0, 0]), n.push(u)) : e = e.concat(u);
  }
  for (var c = 0; c < n.length; c += 1) {
    var h = i[c], f = e.length;
    xr.argument(f < 65536, "Table " + r.tableName + " too big."), e[h] = f >> 8, e[h + 1] = f & 255, e = e.concat(n[c]);
  }
  return e;
};
Er.TABLE = function(r) {
  for (var e = 0, t = r.fields.length, n = 0; n < t; n += 1) {
    var i = r.fields[n], a = Er[i.type];
    xr.argument(a !== void 0, "No sizeOf function for field type " + i.type + " (" + i.name + ")");
    var s = r[i.name];
    s === void 0 && (s = i.value), e += a(s), i.type === "TABLE" && (e += 2);
  }
  return e;
};
bt.RECORD = bt.TABLE;
Er.RECORD = Er.TABLE;
bt.LITERAL = function(r) {
  return r;
};
Er.LITERAL = function(r) {
  return r.length;
};
function Sa(r, e, t) {
  if (e.length && (e[0].name !== "coverageFormat" || e[0].value === 1))
    for (var n = 0; n < e.length; n += 1) {
      var i = e[n];
      this[i.name] = i.value;
    }
  if (this.tableName = r, this.fields = e, t)
    for (var a = Object.keys(t), s = 0; s < a.length; s += 1) {
      var o = a[s], l = t[o];
      this[o] !== void 0 && (this[o] = l);
    }
}
Sa.prototype.encode = function() {
  return bt.TABLE(this);
};
Sa.prototype.sizeOf = function() {
  return Er.TABLE(this);
};
function Qp(r, e, t) {
  t === void 0 && (t = e.length);
  var n = new Array(e.length + 1);
  n[0] = { name: r + "Count", type: "USHORT", value: t };
  for (var i = 0; i < e.length; i++)
    n[i + 1] = { name: r + i, type: "USHORT", value: e[i] };
  return n;
}
function B1(r, e, t) {
  var n = e.length, i = new Array(n + 1);
  i[0] = { name: r + "Count", type: "USHORT", value: n };
  for (var a = 0; a < n; a++)
    i[a + 1] = { name: r + a, type: "TABLE", value: t(e[a], a) };
  return i;
}
function Yp(r, e, t) {
  var n = e.length, i = [];
  i[0] = { name: r + "Count", type: "USHORT", value: n };
  for (var a = 0; a < n; a++)
    i = i.concat(t(e[a], a));
  return i;
}
function m0(r) {
  r.format === 1 ? Sa.call(
    this,
    "coverageTable",
    [{ name: "coverageFormat", type: "USHORT", value: 1 }].concat(Qp("glyph", r.glyphs))
  ) : r.format === 2 ? Sa.call(
    this,
    "coverageTable",
    [{ name: "coverageFormat", type: "USHORT", value: 2 }].concat(Yp("rangeRecord", r.ranges, function(e) {
      return [
        { name: "startGlyphID", type: "USHORT", value: e.start },
        { name: "endGlyphID", type: "USHORT", value: e.end },
        { name: "startCoverageIndex", type: "USHORT", value: e.index }
      ];
    }))
  ) : xr.assert(!1, "Coverage format must be 1 or 2.");
}
m0.prototype = Object.create(Sa.prototype);
m0.prototype.constructor = m0;
function v0(r) {
  Sa.call(
    this,
    "scriptListTable",
    Yp("scriptRecord", r, function(e, t) {
      var n = e.script, i = n.defaultLangSys;
      return xr.assert(!!i, "Unable to write GSUB: script " + e.tag + " has no default language system."), [
        { name: "scriptTag" + t, type: "TAG", value: e.tag },
        { name: "script" + t, type: "TABLE", value: new Sa("scriptTable", [
          { name: "defaultLangSys", type: "TABLE", value: new Sa("defaultLangSys", [
            { name: "lookupOrder", type: "USHORT", value: 0 },
            { name: "reqFeatureIndex", type: "USHORT", value: i.reqFeatureIndex }
          ].concat(Qp("featureIndex", i.featureIndexes))) }
        ].concat(Yp("langSys", n.langSysRecords, function(a, s) {
          var o = a.langSys;
          return [
            { name: "langSysTag" + s, type: "TAG", value: a.tag },
            { name: "langSys" + s, type: "TABLE", value: new Sa("langSys", [
              { name: "lookupOrder", type: "USHORT", value: 0 },
              { name: "reqFeatureIndex", type: "USHORT", value: o.reqFeatureIndex }
            ].concat(Qp("featureIndex", o.featureIndexes))) }
          ];
        }))) }
      ];
    })
  );
}
v0.prototype = Object.create(Sa.prototype);
v0.prototype.constructor = v0;
function y0(r) {
  Sa.call(
    this,
    "featureListTable",
    Yp("featureRecord", r, function(e, t) {
      var n = e.feature;
      return [
        { name: "featureTag" + t, type: "TAG", value: e.tag },
        { name: "feature" + t, type: "TABLE", value: new Sa("featureTable", [
          { name: "featureParams", type: "USHORT", value: n.featureParams }
        ].concat(Qp("lookupListIndex", n.lookupListIndexes))) }
      ];
    })
  );
}
y0.prototype = Object.create(Sa.prototype);
y0.prototype.constructor = y0;
function A0(r, e) {
  Sa.call(this, "lookupListTable", B1("lookup", r, function(t) {
    var n = e[t.lookupType];
    return xr.assert(!!n, "Unable to write GSUB lookup type " + t.lookupType + " tables."), new Sa("lookupTable", [
      { name: "lookupType", type: "USHORT", value: t.lookupType },
      { name: "lookupFlag", type: "USHORT", value: t.lookupFlag }
    ].concat(B1("subtable", t.subtables, n)));
  }));
}
A0.prototype = Object.create(Sa.prototype);
A0.prototype.constructor = A0;
var Dt = {
  Table: Sa,
  Record: Sa,
  Coverage: m0,
  ScriptList: v0,
  FeatureList: y0,
  LookupList: A0,
  ushortList: Qp,
  tableList: B1,
  recordList: Yp
};
function OE(r, e) {
  return r.getUint8(e);
}
function w0(r, e) {
  return r.getUint16(e, !1);
}
function WU(r, e) {
  return r.getInt16(e, !1);
}
function Zw(r, e) {
  return r.getUint32(e, !1);
}
function IP(r, e) {
  var t = r.getInt16(e, !1), n = r.getUint16(e + 2, !1);
  return t + n / 65535;
}
function jU(r, e) {
  for (var t = "", n = e; n < e + 4; n += 1)
    t += String.fromCharCode(r.getInt8(n));
  return t;
}
function qU(r, e, t) {
  for (var n = 0, i = 0; i < t; i += 1)
    n <<= 8, n += r.getUint8(e + i);
  return n;
}
function QU(r, e, t) {
  for (var n = [], i = e; i < t; i += 1)
    n.push(r.getUint8(i));
  return n;
}
function YU(r) {
  for (var e = "", t = 0; t < r.length; t += 1)
    e += String.fromCharCode(r[t]);
  return e;
}
var XU = {
  byte: 1,
  uShort: 2,
  short: 2,
  uLong: 4,
  fixed: 4,
  longDateTime: 8,
  tag: 4
};
function Be(r, e) {
  this.data = r, this.offset = e, this.relativeOffset = 0;
}
Be.prototype.parseByte = function() {
  var r = this.data.getUint8(this.offset + this.relativeOffset);
  return this.relativeOffset += 1, r;
};
Be.prototype.parseChar = function() {
  var r = this.data.getInt8(this.offset + this.relativeOffset);
  return this.relativeOffset += 1, r;
};
Be.prototype.parseCard8 = Be.prototype.parseByte;
Be.prototype.parseUShort = function() {
  var r = this.data.getUint16(this.offset + this.relativeOffset);
  return this.relativeOffset += 2, r;
};
Be.prototype.parseCard16 = Be.prototype.parseUShort;
Be.prototype.parseSID = Be.prototype.parseUShort;
Be.prototype.parseOffset16 = Be.prototype.parseUShort;
Be.prototype.parseShort = function() {
  var r = this.data.getInt16(this.offset + this.relativeOffset);
  return this.relativeOffset += 2, r;
};
Be.prototype.parseF2Dot14 = function() {
  var r = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
  return this.relativeOffset += 2, r;
};
Be.prototype.parseULong = function() {
  var r = Zw(this.data, this.offset + this.relativeOffset);
  return this.relativeOffset += 4, r;
};
Be.prototype.parseOffset32 = Be.prototype.parseULong;
Be.prototype.parseFixed = function() {
  var r = IP(this.data, this.offset + this.relativeOffset);
  return this.relativeOffset += 4, r;
};
Be.prototype.parseString = function(r) {
  var e = this.data, t = this.offset + this.relativeOffset, n = "";
  this.relativeOffset += r;
  for (var i = 0; i < r; i++)
    n += String.fromCharCode(e.getUint8(t + i));
  return n;
};
Be.prototype.parseTag = function() {
  return this.parseString(4);
};
Be.prototype.parseLongDateTime = function() {
  var r = Zw(this.data, this.offset + this.relativeOffset + 4);
  return r -= 2082844800, this.relativeOffset += 8, r;
};
Be.prototype.parseVersion = function(r) {
  var e = w0(this.data, this.offset + this.relativeOffset), t = w0(this.data, this.offset + this.relativeOffset + 2);
  return this.relativeOffset += 4, r === void 0 && (r = 4096), e + t / r / 10;
};
Be.prototype.skip = function(r, e) {
  e === void 0 && (e = 1), this.relativeOffset += XU[r] * e;
};
Be.prototype.parseULongList = function(r) {
  r === void 0 && (r = this.parseULong());
  for (var e = new Array(r), t = this.data, n = this.offset + this.relativeOffset, i = 0; i < r; i++)
    e[i] = t.getUint32(n), n += 4;
  return this.relativeOffset += r * 4, e;
};
Be.prototype.parseOffset16List = Be.prototype.parseUShortList = function(r) {
  r === void 0 && (r = this.parseUShort());
  for (var e = new Array(r), t = this.data, n = this.offset + this.relativeOffset, i = 0; i < r; i++)
    e[i] = t.getUint16(n), n += 2;
  return this.relativeOffset += r * 2, e;
};
Be.prototype.parseShortList = function(r) {
  for (var e = new Array(r), t = this.data, n = this.offset + this.relativeOffset, i = 0; i < r; i++)
    e[i] = t.getInt16(n), n += 2;
  return this.relativeOffset += r * 2, e;
};
Be.prototype.parseByteList = function(r) {
  for (var e = new Array(r), t = this.data, n = this.offset + this.relativeOffset, i = 0; i < r; i++)
    e[i] = t.getUint8(n++);
  return this.relativeOffset += r, e;
};
Be.prototype.parseList = function(r, e) {
  e || (e = r, r = this.parseUShort());
  for (var t = new Array(r), n = 0; n < r; n++)
    t[n] = e.call(this);
  return t;
};
Be.prototype.parseList32 = function(r, e) {
  e || (e = r, r = this.parseULong());
  for (var t = new Array(r), n = 0; n < r; n++)
    t[n] = e.call(this);
  return t;
};
Be.prototype.parseRecordList = function(r, e) {
  e || (e = r, r = this.parseUShort());
  for (var t = new Array(r), n = Object.keys(e), i = 0; i < r; i++) {
    for (var a = {}, s = 0; s < n.length; s++) {
      var o = n[s], l = e[o];
      a[o] = l.call(this);
    }
    t[i] = a;
  }
  return t;
};
Be.prototype.parseRecordList32 = function(r, e) {
  e || (e = r, r = this.parseULong());
  for (var t = new Array(r), n = Object.keys(e), i = 0; i < r; i++) {
    for (var a = {}, s = 0; s < n.length; s++) {
      var o = n[s], l = e[o];
      a[o] = l.call(this);
    }
    t[i] = a;
  }
  return t;
};
Be.prototype.parseStruct = function(r) {
  if (typeof r == "function")
    return r.call(this);
  for (var e = Object.keys(r), t = {}, n = 0; n < e.length; n++) {
    var i = e[n], a = r[i];
    t[i] = a.call(this);
  }
  return t;
};
Be.prototype.parseValueRecord = function(r) {
  if (r === void 0 && (r = this.parseUShort()), r !== 0) {
    var e = {};
    return r & 1 && (e.xPlacement = this.parseShort()), r & 2 && (e.yPlacement = this.parseShort()), r & 4 && (e.xAdvance = this.parseShort()), r & 8 && (e.yAdvance = this.parseShort()), r & 16 && (e.xPlaDevice = void 0, this.parseShort()), r & 32 && (e.yPlaDevice = void 0, this.parseShort()), r & 64 && (e.xAdvDevice = void 0, this.parseShort()), r & 128 && (e.yAdvDevice = void 0, this.parseShort()), e;
  }
};
Be.prototype.parseValueRecordList = function() {
  for (var r = this.parseUShort(), e = this.parseUShort(), t = new Array(e), n = 0; n < e; n++)
    t[n] = this.parseValueRecord(r);
  return t;
};
Be.prototype.parsePointer = function(r) {
  var e = this.parseOffset16();
  if (e > 0)
    return new Be(this.data, this.offset + e).parseStruct(r);
};
Be.prototype.parsePointer32 = function(r) {
  var e = this.parseOffset32();
  if (e > 0)
    return new Be(this.data, this.offset + e).parseStruct(r);
};
Be.prototype.parseListOfLists = function(r) {
  for (var e = this.parseOffset16List(), t = e.length, n = this.relativeOffset, i = new Array(t), a = 0; a < t; a++) {
    var s = e[a];
    if (s === 0) {
      i[a] = void 0;
      continue;
    }
    if (this.relativeOffset = s, r) {
      for (var o = this.parseOffset16List(), l = new Array(o.length), u = 0; u < o.length; u++)
        this.relativeOffset = s + o[u], l[u] = r.call(this);
      i[a] = l;
    } else
      i[a] = this.parseUShortList();
  }
  return this.relativeOffset = n, i;
};
Be.prototype.parseCoverage = function() {
  var r = this.offset + this.relativeOffset, e = this.parseUShort(), t = this.parseUShort();
  if (e === 1)
    return {
      format: 1,
      glyphs: this.parseUShortList(t)
    };
  if (e === 2) {
    for (var n = new Array(t), i = 0; i < t; i++)
      n[i] = {
        start: this.parseUShort(),
        end: this.parseUShort(),
        index: this.parseUShort()
      };
    return {
      format: 2,
      ranges: n
    };
  }
  throw new Error("0x" + r.toString(16) + ": Coverage format must be 1 or 2.");
};
Be.prototype.parseClassDef = function() {
  var r = this.offset + this.relativeOffset, e = this.parseUShort();
  if (e === 1)
    return {
      format: 1,
      startGlyph: this.parseUShort(),
      classes: this.parseUShortList()
    };
  if (e === 2)
    return {
      format: 2,
      ranges: this.parseRecordList({
        start: Be.uShort,
        end: Be.uShort,
        classId: Be.uShort
      })
    };
  throw new Error("0x" + r.toString(16) + ": ClassDef format must be 1 or 2.");
};
Be.list = function(r, e) {
  return function() {
    return this.parseList(r, e);
  };
};
Be.list32 = function(r, e) {
  return function() {
    return this.parseList32(r, e);
  };
};
Be.recordList = function(r, e) {
  return function() {
    return this.parseRecordList(r, e);
  };
};
Be.recordList32 = function(r, e) {
  return function() {
    return this.parseRecordList32(r, e);
  };
};
Be.pointer = function(r) {
  return function() {
    return this.parsePointer(r);
  };
};
Be.pointer32 = function(r) {
  return function() {
    return this.parsePointer32(r);
  };
};
Be.tag = Be.prototype.parseTag;
Be.byte = Be.prototype.parseByte;
Be.uShort = Be.offset16 = Be.prototype.parseUShort;
Be.uShortList = Be.prototype.parseUShortList;
Be.uLong = Be.offset32 = Be.prototype.parseULong;
Be.uLongList = Be.prototype.parseULongList;
Be.struct = Be.prototype.parseStruct;
Be.coverage = Be.prototype.parseCoverage;
Be.classDef = Be.prototype.parseClassDef;
var BE = {
  reserved: Be.uShort,
  reqFeatureIndex: Be.uShort,
  featureIndexes: Be.uShortList
};
Be.prototype.parseScriptList = function() {
  return this.parsePointer(Be.recordList({
    tag: Be.tag,
    script: Be.pointer({
      defaultLangSys: Be.pointer(BE),
      langSysRecords: Be.recordList({
        tag: Be.tag,
        langSys: Be.pointer(BE)
      })
    })
  })) || [];
};
Be.prototype.parseFeatureList = function() {
  return this.parsePointer(Be.recordList({
    tag: Be.tag,
    feature: Be.pointer({
      featureParams: Be.offset16,
      lookupListIndexes: Be.uShortList
    })
  })) || [];
};
Be.prototype.parseLookupList = function(r) {
  return this.parsePointer(Be.list(Be.pointer(function() {
    var e = this.parseUShort();
    xr.argument(1 <= e && e <= 9, "GPOS/GSUB lookup type " + e + " unknown.");
    var t = this.parseUShort(), n = t & 16;
    return {
      lookupType: e,
      lookupFlag: t,
      subtables: this.parseList(Be.pointer(r[e])),
      markFilteringSet: n ? this.parseUShort() : void 0
    };
  }))) || [];
};
Be.prototype.parseFeatureVariationsList = function() {
  return this.parsePointer32(function() {
    var r = this.parseUShort(), e = this.parseUShort();
    xr.argument(r === 1 && e < 1, "GPOS/GSUB feature variations table unknown.");
    var t = this.parseRecordList32({
      conditionSetOffset: Be.offset32,
      featureTableSubstitutionOffset: Be.offset32
    });
    return t;
  }) || [];
};
var Ut = {
  getByte: OE,
  getCard8: OE,
  getUShort: w0,
  getCard16: w0,
  getShort: WU,
  getULong: Zw,
  getFixed: IP,
  getTag: jU,
  getOffset: qU,
  getBytes: QU,
  bytesToString: YU,
  Parser: Be
};
function JU(r, e) {
  e.parseUShort(), r.length = e.parseULong(), r.language = e.parseULong();
  var t;
  r.groupCount = t = e.parseULong(), r.glyphIndexMap = {};
  for (var n = 0; n < t; n += 1)
    for (var i = e.parseULong(), a = e.parseULong(), s = e.parseULong(), o = i; o <= a; o += 1)
      r.glyphIndexMap[o] = s, s++;
}
function KU(r, e, t, n, i) {
  r.length = e.parseUShort(), r.language = e.parseUShort();
  var a;
  r.segCount = a = e.parseUShort() >> 1, e.skip("uShort", 3), r.glyphIndexMap = {};
  for (var s = new Ut.Parser(t, n + i + 14), o = new Ut.Parser(t, n + i + 16 + a * 2), l = new Ut.Parser(t, n + i + 16 + a * 4), u = new Ut.Parser(t, n + i + 16 + a * 6), c = n + i + 16 + a * 8, h = 0; h < a - 1; h += 1)
    for (var f = void 0, p = s.parseUShort(), m = o.parseUShort(), A = l.parseShort(), w = u.parseUShort(), x = m; x <= p; x += 1)
      w !== 0 ? (c = u.offset + u.relativeOffset - 2, c += w, c += (x - m) * 2, f = Ut.getUShort(t, c), f !== 0 && (f = f + A & 65535)) : f = x + A & 65535, r.glyphIndexMap[x] = f;
}
function ZU(r, e) {
  var t = {};
  t.version = Ut.getUShort(r, e), xr.argument(t.version === 0, "cmap table version should be 0."), t.numTables = Ut.getUShort(r, e + 2);
  for (var n = -1, i = t.numTables - 1; i >= 0; i -= 1) {
    var a = Ut.getUShort(r, e + 4 + i * 8), s = Ut.getUShort(r, e + 4 + i * 8 + 2);
    if (a === 3 && (s === 0 || s === 1 || s === 10) || a === 0 && (s === 0 || s === 1 || s === 2 || s === 3 || s === 4)) {
      n = Ut.getULong(r, e + 4 + i * 8 + 4);
      break;
    }
  }
  if (n === -1)
    throw new Error("No valid cmap sub-tables found.");
  var o = new Ut.Parser(r, e + n);
  if (t.format = o.parseUShort(), t.format === 12)
    JU(t, o);
  else if (t.format === 4)
    KU(t, o, r, e, n);
  else
    throw new Error("Only format 4 and 12 cmap tables are supported (found format " + t.format + ").");
  return t;
}
function e9(r, e, t) {
  r.segments.push({
    end: e,
    start: e,
    delta: -(e - t),
    offset: 0,
    glyphIndex: t
  });
}
function t9(r) {
  r.segments.push({
    end: 65535,
    start: 65535,
    delta: 1,
    offset: 0
  });
}
function r9(r) {
  var e = !0, t;
  for (t = r.length - 1; t > 0; t -= 1) {
    var n = r.get(t);
    if (n.unicode > 65535) {
      console.log("Adding CMAP format 12 (needed!)"), e = !1;
      break;
    }
  }
  var i = [
    { name: "version", type: "USHORT", value: 0 },
    { name: "numTables", type: "USHORT", value: e ? 1 : 2 },
    // CMAP 4 header
    { name: "platformID", type: "USHORT", value: 3 },
    { name: "encodingID", type: "USHORT", value: 1 },
    { name: "offset", type: "ULONG", value: e ? 12 : 20 }
  ];
  e || (i = i.concat([
    // CMAP 12 header
    { name: "cmap12PlatformID", type: "USHORT", value: 3 },
    // We encode only for PlatformID = 3 (Windows) because it is supported everywhere
    { name: "cmap12EncodingID", type: "USHORT", value: 10 },
    { name: "cmap12Offset", type: "ULONG", value: 0 }
  ])), i = i.concat([
    // CMAP 4 Subtable
    { name: "format", type: "USHORT", value: 4 },
    { name: "cmap4Length", type: "USHORT", value: 0 },
    { name: "language", type: "USHORT", value: 0 },
    { name: "segCountX2", type: "USHORT", value: 0 },
    { name: "searchRange", type: "USHORT", value: 0 },
    { name: "entrySelector", type: "USHORT", value: 0 },
    { name: "rangeShift", type: "USHORT", value: 0 }
  ]);
  var a = new Dt.Table("cmap", i);
  for (a.segments = [], t = 0; t < r.length; t += 1) {
    for (var s = r.get(t), o = 0; o < s.unicodes.length; o += 1)
      e9(a, s.unicodes[o], t);
    a.segments = a.segments.sort(function(E, T) {
      return E.start - T.start;
    });
  }
  t9(a);
  var l = a.segments.length, u = 0, c = [], h = [], f = [], p = [], m = [], A = [];
  for (t = 0; t < l; t += 1) {
    var w = a.segments[t];
    w.end <= 65535 && w.start <= 65535 ? (c = c.concat({ name: "end_" + t, type: "USHORT", value: w.end }), h = h.concat({ name: "start_" + t, type: "USHORT", value: w.start }), f = f.concat({ name: "idDelta_" + t, type: "SHORT", value: w.delta }), p = p.concat({ name: "idRangeOffset_" + t, type: "USHORT", value: w.offset }), w.glyphId !== void 0 && (m = m.concat({ name: "glyph_" + t, type: "USHORT", value: w.glyphId }))) : u += 1, !e && w.glyphIndex !== void 0 && (A = A.concat({ name: "cmap12Start_" + t, type: "ULONG", value: w.start }), A = A.concat({ name: "cmap12End_" + t, type: "ULONG", value: w.end }), A = A.concat({ name: "cmap12Glyph_" + t, type: "ULONG", value: w.glyphIndex }));
  }
  if (a.segCountX2 = (l - u) * 2, a.searchRange = Math.pow(2, Math.floor(Math.log(l - u) / Math.log(2))) * 2, a.entrySelector = Math.log(a.searchRange / 2) / Math.log(2), a.rangeShift = a.segCountX2 - a.searchRange, a.fields = a.fields.concat(c), a.fields.push({ name: "reservedPad", type: "USHORT", value: 0 }), a.fields = a.fields.concat(h), a.fields = a.fields.concat(f), a.fields = a.fields.concat(p), a.fields = a.fields.concat(m), a.cmap4Length = 14 + // Subtable header
  c.length * 2 + 2 + // reservedPad
  h.length * 2 + f.length * 2 + p.length * 2 + m.length * 2, !e) {
    var x = 16 + // Subtable header
    A.length * 4;
    a.cmap12Offset = 20 + a.cmap4Length, a.fields = a.fields.concat([
      { name: "cmap12Format", type: "USHORT", value: 12 },
      { name: "cmap12Reserved", type: "USHORT", value: 0 },
      { name: "cmap12Length", type: "ULONG", value: x },
      { name: "cmap12Language", type: "ULONG", value: 0 },
      { name: "cmap12nGroups", type: "ULONG", value: A.length / 3 }
    ]), a.fields = a.fields.concat(A);
  }
  return a;
}
var PP = { parse: ZU, make: r9 }, Ym = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "266 ff",
  "onedotenleader",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall",
  "001.000",
  "001.001",
  "001.002",
  "001.003",
  "Black",
  "Bold",
  "Book",
  "Light",
  "Medium",
  "Regular",
  "Roman",
  "Semibold"
], n9 = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "",
  "questiondown",
  "",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "",
  "ring",
  "cedilla",
  "",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "AE",
  "",
  "ordfeminine",
  "",
  "",
  "",
  "",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "",
  "",
  "",
  "",
  "",
  "ae",
  "",
  "",
  "",
  "dotlessi",
  "",
  "",
  "lslash",
  "oslash",
  "oe",
  "germandbls"
], i9 = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "",
  "",
  "isuperior",
  "",
  "",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "",
  "",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "",
  "",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "",
  "Dotaccentsmall",
  "",
  "",
  "Macronsmall",
  "",
  "",
  "figuredash",
  "hypheninferior",
  "",
  "",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "",
  "",
  "",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "",
  "",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], kf = [
  ".notdef",
  ".null",
  "nonmarkingreturn",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quotesingle",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "grave",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "Adieresis",
  "Aring",
  "Ccedilla",
  "Eacute",
  "Ntilde",
  "Odieresis",
  "Udieresis",
  "aacute",
  "agrave",
  "acircumflex",
  "adieresis",
  "atilde",
  "aring",
  "ccedilla",
  "eacute",
  "egrave",
  "ecircumflex",
  "edieresis",
  "iacute",
  "igrave",
  "icircumflex",
  "idieresis",
  "ntilde",
  "oacute",
  "ograve",
  "ocircumflex",
  "odieresis",
  "otilde",
  "uacute",
  "ugrave",
  "ucircumflex",
  "udieresis",
  "dagger",
  "degree",
  "cent",
  "sterling",
  "section",
  "bullet",
  "paragraph",
  "germandbls",
  "registered",
  "copyright",
  "trademark",
  "acute",
  "dieresis",
  "notequal",
  "AE",
  "Oslash",
  "infinity",
  "plusminus",
  "lessequal",
  "greaterequal",
  "yen",
  "mu",
  "partialdiff",
  "summation",
  "product",
  "pi",
  "integral",
  "ordfeminine",
  "ordmasculine",
  "Omega",
  "ae",
  "oslash",
  "questiondown",
  "exclamdown",
  "logicalnot",
  "radical",
  "florin",
  "approxequal",
  "Delta",
  "guillemotleft",
  "guillemotright",
  "ellipsis",
  "nonbreakingspace",
  "Agrave",
  "Atilde",
  "Otilde",
  "OE",
  "oe",
  "endash",
  "emdash",
  "quotedblleft",
  "quotedblright",
  "quoteleft",
  "quoteright",
  "divide",
  "lozenge",
  "ydieresis",
  "Ydieresis",
  "fraction",
  "currency",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "daggerdbl",
  "periodcentered",
  "quotesinglbase",
  "quotedblbase",
  "perthousand",
  "Acircumflex",
  "Ecircumflex",
  "Aacute",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Oacute",
  "Ocircumflex",
  "apple",
  "Ograve",
  "Uacute",
  "Ucircumflex",
  "Ugrave",
  "dotlessi",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "Lslash",
  "lslash",
  "Scaron",
  "scaron",
  "Zcaron",
  "zcaron",
  "brokenbar",
  "Eth",
  "eth",
  "Yacute",
  "yacute",
  "Thorn",
  "thorn",
  "minus",
  "multiply",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "onehalf",
  "onequarter",
  "threequarters",
  "franc",
  "Gbreve",
  "gbreve",
  "Idotaccent",
  "Scedilla",
  "scedilla",
  "Cacute",
  "cacute",
  "Ccaron",
  "ccaron",
  "dcroat"
];
function DP(r) {
  this.font = r;
}
DP.prototype.charToGlyphIndex = function(r) {
  var e = r.codePointAt(0), t = this.font.glyphs;
  if (t) {
    for (var n = 0; n < t.length; n += 1)
      for (var i = t.get(n), a = 0; a < i.unicodes.length; a += 1)
        if (i.unicodes[a] === e)
          return n;
  }
  return null;
};
function RP(r) {
  this.cmap = r;
}
RP.prototype.charToGlyphIndex = function(r) {
  return this.cmap.glyphIndexMap[r.codePointAt(0)] || 0;
};
function x0(r, e) {
  this.encoding = r, this.charset = e;
}
x0.prototype.charToGlyphIndex = function(r) {
  var e = r.codePointAt(0), t = this.encoding[e];
  return this.charset.indexOf(t);
};
function ex(r) {
  switch (r.version) {
    case 1:
      this.names = kf.slice();
      break;
    case 2:
      this.names = new Array(r.numberOfGlyphs);
      for (var e = 0; e < r.numberOfGlyphs; e++)
        r.glyphNameIndex[e] < kf.length ? this.names[e] = kf[r.glyphNameIndex[e]] : this.names[e] = r.names[r.glyphNameIndex[e] - kf.length];
      break;
    case 2.5:
      this.names = new Array(r.numberOfGlyphs);
      for (var t = 0; t < r.numberOfGlyphs; t++)
        this.names[t] = kf[t + r.glyphNameIndex[t]];
      break;
    case 3:
      this.names = [];
      break;
    default:
      this.names = [];
      break;
  }
}
ex.prototype.nameToGlyphIndex = function(r) {
  return this.names.indexOf(r);
};
ex.prototype.glyphIndexToName = function(r) {
  return this.names[r];
};
function a9(r) {
  for (var e, t = r.tables.cmap.glyphIndexMap, n = Object.keys(t), i = 0; i < n.length; i += 1) {
    var a = n[i], s = t[a];
    e = r.glyphs.get(s), e.addUnicode(parseInt(a));
  }
  for (var o = 0; o < r.glyphs.length; o += 1)
    e = r.glyphs.get(o), r.cffEncoding ? r.isCIDFont ? e.name = "gid" + o : e.name = r.cffEncoding.charset[o] : r.glyphNames.names && (e.name = r.glyphNames.glyphIndexToName(o));
}
function s9(r) {
  r._IndexToUnicodeMap = {};
  for (var e = r.tables.cmap.glyphIndexMap, t = Object.keys(e), n = 0; n < t.length; n += 1) {
    var i = t[n], a = e[i];
    r._IndexToUnicodeMap[a] === void 0 ? r._IndexToUnicodeMap[a] = {
      unicodes: [parseInt(i)]
    } : r._IndexToUnicodeMap[a].unicodes.push(parseInt(i));
  }
}
function o9(r, e) {
  e.lowMemory ? s9(r) : a9(r);
}
function l9(r, e, t, n, i) {
  r.beginPath(), r.moveTo(e, t), r.lineTo(n, i), r.stroke();
}
var wf = { line: l9 };
function u9(r, e) {
  var t = e || new ha();
  return {
    configurable: !0,
    get: function() {
      return typeof t == "function" && (t = t()), t;
    },
    set: function(n) {
      t = n;
    }
  };
}
function Co(r) {
  this.bindConstructorValues(r);
}
Co.prototype.bindConstructorValues = function(r) {
  this.index = r.index || 0, this.name = r.name || null, this.unicode = r.unicode || void 0, this.unicodes = r.unicodes || r.unicode !== void 0 ? [r.unicode] : [], "xMin" in r && (this.xMin = r.xMin), "yMin" in r && (this.yMin = r.yMin), "xMax" in r && (this.xMax = r.xMax), "yMax" in r && (this.yMax = r.yMax), "advanceWidth" in r && (this.advanceWidth = r.advanceWidth), Object.defineProperty(this, "path", u9(this, r.path));
};
Co.prototype.addUnicode = function(r) {
  this.unicodes.length === 0 && (this.unicode = r), this.unicodes.push(r);
};
Co.prototype.getBoundingBox = function() {
  return this.path.getBoundingBox();
};
Co.prototype.getPath = function(r, e, t, n, i) {
  r = r !== void 0 ? r : 0, e = e !== void 0 ? e : 0, t = t !== void 0 ? t : 72;
  var a, s;
  n || (n = {});
  var o = n.xScale, l = n.yScale;
  if (n.hinting && i && i.hinting && (s = this.path && i.hinting.exec(this, t)), s)
    a = i.hinting.getCommands(s), r = Math.round(r), e = Math.round(e), o = l = 1;
  else {
    a = this.path.commands;
    var u = 1 / (this.path.unitsPerEm || 1e3) * t;
    o === void 0 && (o = u), l === void 0 && (l = u);
  }
  for (var c = new ha(), h = 0; h < a.length; h += 1) {
    var f = a[h];
    f.type === "M" ? c.moveTo(r + f.x * o, e + -f.y * l) : f.type === "L" ? c.lineTo(r + f.x * o, e + -f.y * l) : f.type === "Q" ? c.quadraticCurveTo(
      r + f.x1 * o,
      e + -f.y1 * l,
      r + f.x * o,
      e + -f.y * l
    ) : f.type === "C" ? c.curveTo(
      r + f.x1 * o,
      e + -f.y1 * l,
      r + f.x2 * o,
      e + -f.y2 * l,
      r + f.x * o,
      e + -f.y * l
    ) : f.type === "Z" && c.closePath();
  }
  return c;
};
Co.prototype.getContours = function() {
  if (this.points === void 0)
    return [];
  for (var r = [], e = [], t = 0; t < this.points.length; t += 1) {
    var n = this.points[t];
    e.push(n), n.lastPointOfContour && (r.push(e), e = []);
  }
  return xr.argument(e.length === 0, "There are still points left in the current contour."), r;
};
Co.prototype.getMetrics = function() {
  for (var r = this.path.commands, e = [], t = [], n = 0; n < r.length; n += 1) {
    var i = r[n];
    i.type !== "Z" && (e.push(i.x), t.push(i.y)), (i.type === "Q" || i.type === "C") && (e.push(i.x1), t.push(i.y1)), i.type === "C" && (e.push(i.x2), t.push(i.y2));
  }
  var a = {
    xMin: Math.min.apply(null, e),
    yMin: Math.min.apply(null, t),
    xMax: Math.max.apply(null, e),
    yMax: Math.max.apply(null, t),
    leftSideBearing: this.leftSideBearing
  };
  return isFinite(a.xMin) || (a.xMin = 0), isFinite(a.xMax) || (a.xMax = this.advanceWidth), isFinite(a.yMin) || (a.yMin = 0), isFinite(a.yMax) || (a.yMax = 0), a.rightSideBearing = this.advanceWidth - a.leftSideBearing - (a.xMax - a.xMin), a;
};
Co.prototype.draw = function(r, e, t, n, i) {
  this.getPath(e, t, n, i).draw(r);
};
Co.prototype.drawPoints = function(r, e, t, n) {
  function i(h, f, p, m) {
    r.beginPath();
    for (var A = 0; A < h.length; A += 1)
      r.moveTo(f + h[A].x * m, p + h[A].y * m), r.arc(f + h[A].x * m, p + h[A].y * m, 2, 0, Math.PI * 2, !1);
    r.closePath(), r.fill();
  }
  e = e !== void 0 ? e : 0, t = t !== void 0 ? t : 0, n = n !== void 0 ? n : 24;
  for (var a = 1 / this.path.unitsPerEm * n, s = [], o = [], l = this.path, u = 0; u < l.commands.length; u += 1) {
    var c = l.commands[u];
    c.x !== void 0 && s.push({ x: c.x, y: -c.y }), c.x1 !== void 0 && o.push({ x: c.x1, y: -c.y1 }), c.x2 !== void 0 && o.push({ x: c.x2, y: -c.y2 });
  }
  r.fillStyle = "blue", i(s, e, t, a), r.fillStyle = "red", i(o, e, t, a);
};
Co.prototype.drawMetrics = function(r, e, t, n) {
  var i;
  e = e !== void 0 ? e : 0, t = t !== void 0 ? t : 0, n = n !== void 0 ? n : 24, i = 1 / this.path.unitsPerEm * n, r.lineWidth = 1, r.strokeStyle = "black", wf.line(r, e, -1e4, e, 1e4), wf.line(r, -1e4, t, 1e4, t);
  var a = this.xMin || 0, s = this.yMin || 0, o = this.xMax || 0, l = this.yMax || 0, u = this.advanceWidth || 0;
  r.strokeStyle = "blue", wf.line(r, e + a * i, -1e4, e + a * i, 1e4), wf.line(r, e + o * i, -1e4, e + o * i, 1e4), wf.line(r, -1e4, t + -s * i, 1e4, t + -s * i), wf.line(r, -1e4, t + -l * i, 1e4, t + -l * i), r.strokeStyle = "green", wf.line(r, e + u * i, -1e4, e + u * i, 1e4);
};
function Jg(r, e, t) {
  Object.defineProperty(r, e, {
    get: function() {
      return r.path, r[t];
    },
    set: function(n) {
      r[t] = n;
    },
    enumerable: !0,
    configurable: !0
  });
}
function tx(r, e) {
  if (this.font = r, this.glyphs = {}, Array.isArray(e))
    for (var t = 0; t < e.length; t++) {
      var n = e[t];
      n.path.unitsPerEm = r.unitsPerEm, this.glyphs[t] = n;
    }
  this.length = e && e.length || 0;
}
tx.prototype.get = function(r) {
  if (this.glyphs[r] === void 0) {
    this.font._push(r), typeof this.glyphs[r] == "function" && (this.glyphs[r] = this.glyphs[r]());
    var e = this.glyphs[r], t = this.font._IndexToUnicodeMap[r];
    if (t)
      for (var n = 0; n < t.unicodes.length; n++)
        e.addUnicode(t.unicodes[n]);
    this.font.cffEncoding ? this.font.isCIDFont ? e.name = "gid" + r : e.name = this.font.cffEncoding.charset[r] : this.font.glyphNames.names && (e.name = this.font.glyphNames.glyphIndexToName(r)), this.glyphs[r].advanceWidth = this.font._hmtxTableData[r].advanceWidth, this.glyphs[r].leftSideBearing = this.font._hmtxTableData[r].leftSideBearing;
  } else
    typeof this.glyphs[r] == "function" && (this.glyphs[r] = this.glyphs[r]());
  return this.glyphs[r];
};
tx.prototype.push = function(r, e) {
  this.glyphs[r] = e, this.length++;
};
function c9(r, e) {
  return new Co({ index: e, font: r });
}
function f9(r, e, t, n, i, a) {
  return function() {
    var s = new Co({ index: e, font: r });
    return s.path = function() {
      t(s, n, i);
      var o = a(r.glyphs, s);
      return o.unitsPerEm = r.unitsPerEm, o;
    }, Jg(s, "xMin", "_xMin"), Jg(s, "xMax", "_xMax"), Jg(s, "yMin", "_yMin"), Jg(s, "yMax", "_yMax"), s;
  };
}
function d9(r, e, t, n) {
  return function() {
    var i = new Co({ index: e, font: r });
    return i.path = function() {
      var a = t(r, i, n);
      return a.unitsPerEm = r.unitsPerEm, a;
    }, i;
  };
}
var _l = { GlyphSet: tx, glyphLoader: c9, ttfGlyphLoader: f9, cffGlyphLoader: d9 };
function OP(r, e) {
  if (r === e)
    return !0;
  if (Array.isArray(r) && Array.isArray(e)) {
    if (r.length !== e.length)
      return !1;
    for (var t = 0; t < r.length; t += 1)
      if (!OP(r[t], e[t]))
        return !1;
    return !0;
  } else
    return !1;
}
function _1(r) {
  var e;
  return r.length < 1240 ? e = 107 : r.length < 33900 ? e = 1131 : e = 32768, e;
}
function dc(r, e, t) {
  var n = [], i = [], a = Ut.getCard16(r, e), s, o;
  if (a !== 0) {
    var l = Ut.getByte(r, e + 2);
    s = e + (a + 1) * l + 2;
    for (var u = e + 3, c = 0; c < a + 1; c += 1)
      n.push(Ut.getOffset(r, u, l)), u += l;
    o = s + n[a];
  } else
    o = e + 2;
  for (var h = 0; h < n.length - 1; h += 1) {
    var f = Ut.getBytes(r, s + n[h], s + n[h + 1]);
    t && (f = t(f)), i.push(f);
  }
  return { objects: i, startOffset: e, endOffset: o };
}
function h9(r, e) {
  var t = [], n = Ut.getCard16(r, e), i, a;
  if (n !== 0) {
    var s = Ut.getByte(r, e + 2);
    i = e + (n + 1) * s + 2;
    for (var o = e + 3, l = 0; l < n + 1; l += 1)
      t.push(Ut.getOffset(r, o, s)), o += s;
    a = i + t[n];
  } else
    a = e + 2;
  return { offsets: t, startOffset: e, endOffset: a };
}
function p9(r, e, t, n, i) {
  var a = Ut.getCard16(t, n), s = 0;
  if (a !== 0) {
    var o = Ut.getByte(t, n + 2);
    s = n + (a + 1) * o + 2;
  }
  var l = Ut.getBytes(t, s + e[r], s + e[r + 1]);
  return l;
}
function g9(r) {
  for (var e = "", t = 15, n = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"]; ; ) {
    var i = r.parseByte(), a = i >> 4, s = i & 15;
    if (a === t || (e += n[a], s === t))
      break;
    e += n[s];
  }
  return parseFloat(e);
}
function m9(r, e) {
  var t, n, i, a;
  if (e === 28)
    return t = r.parseByte(), n = r.parseByte(), t << 8 | n;
  if (e === 29)
    return t = r.parseByte(), n = r.parseByte(), i = r.parseByte(), a = r.parseByte(), t << 24 | n << 16 | i << 8 | a;
  if (e === 30)
    return g9(r);
  if (e >= 32 && e <= 246)
    return e - 139;
  if (e >= 247 && e <= 250)
    return t = r.parseByte(), (e - 247) * 256 + t + 108;
  if (e >= 251 && e <= 254)
    return t = r.parseByte(), -(e - 251) * 256 - t - 108;
  throw new Error("Invalid b0 " + e);
}
function v9(r) {
  for (var e = {}, t = 0; t < r.length; t += 1) {
    var n = r[t][0], i = r[t][1], a = void 0;
    if (i.length === 1 ? a = i[0] : a = i, e.hasOwnProperty(n) && !isNaN(e[n]))
      throw new Error("Object " + e + " already has key " + n);
    e[n] = a;
  }
  return e;
}
function BP(r, e, t) {
  e = e !== void 0 ? e : 0;
  var n = new Ut.Parser(r, e), i = [], a = [];
  for (t = t !== void 0 ? t : r.length; n.relativeOffset < t; ) {
    var s = n.parseByte();
    s <= 21 ? (s === 12 && (s = 1200 + n.parseByte()), i.push([s, a]), a = []) : a.push(m9(n, s));
  }
  return v9(i);
}
function Dp(r, e) {
  return e <= 390 ? e = Ym[e] : e = r[e - 391], e;
}
function _P(r, e, t) {
  for (var n = {}, i, a = 0; a < e.length; a += 1) {
    var s = e[a];
    if (Array.isArray(s.type)) {
      var o = [];
      o.length = s.type.length;
      for (var l = 0; l < s.type.length; l++)
        i = r[s.op] !== void 0 ? r[s.op][l] : void 0, i === void 0 && (i = s.value !== void 0 && s.value[l] !== void 0 ? s.value[l] : null), s.type[l] === "SID" && (i = Dp(t, i)), o[l] = i;
      n[s.name] = o;
    } else
      i = r[s.op], i === void 0 && (i = s.value !== void 0 ? s.value : null), s.type === "SID" && (i = Dp(t, i)), n[s.name] = i;
  }
  return n;
}
function y9(r, e) {
  var t = {};
  return t.formatMajor = Ut.getCard8(r, e), t.formatMinor = Ut.getCard8(r, e + 1), t.size = Ut.getCard8(r, e + 2), t.offsetSize = Ut.getCard8(r, e + 3), t.startOffset = e, t.endOffset = e + 4, t;
}
var MP = [
  { name: "version", op: 0, type: "SID" },
  { name: "notice", op: 1, type: "SID" },
  { name: "copyright", op: 1200, type: "SID" },
  { name: "fullName", op: 2, type: "SID" },
  { name: "familyName", op: 3, type: "SID" },
  { name: "weight", op: 4, type: "SID" },
  { name: "isFixedPitch", op: 1201, type: "number", value: 0 },
  { name: "italicAngle", op: 1202, type: "number", value: 0 },
  { name: "underlinePosition", op: 1203, type: "number", value: -100 },
  { name: "underlineThickness", op: 1204, type: "number", value: 50 },
  { name: "paintType", op: 1205, type: "number", value: 0 },
  { name: "charstringType", op: 1206, type: "number", value: 2 },
  {
    name: "fontMatrix",
    op: 1207,
    type: ["real", "real", "real", "real", "real", "real"],
    value: [1e-3, 0, 0, 1e-3, 0, 0]
  },
  { name: "uniqueId", op: 13, type: "number" },
  { name: "fontBBox", op: 5, type: ["number", "number", "number", "number"], value: [0, 0, 0, 0] },
  { name: "strokeWidth", op: 1208, type: "number", value: 0 },
  { name: "xuid", op: 14, type: [], value: null },
  { name: "charset", op: 15, type: "offset", value: 0 },
  { name: "encoding", op: 16, type: "offset", value: 0 },
  { name: "charStrings", op: 17, type: "offset", value: 0 },
  { name: "private", op: 18, type: ["number", "offset"], value: [0, 0] },
  { name: "ros", op: 1230, type: ["SID", "SID", "number"] },
  { name: "cidFontVersion", op: 1231, type: "number", value: 0 },
  { name: "cidFontRevision", op: 1232, type: "number", value: 0 },
  { name: "cidFontType", op: 1233, type: "number", value: 0 },
  { name: "cidCount", op: 1234, type: "number", value: 8720 },
  { name: "uidBase", op: 1235, type: "number" },
  { name: "fdArray", op: 1236, type: "offset" },
  { name: "fdSelect", op: 1237, type: "offset" },
  { name: "fontName", op: 1238, type: "SID" }
], NP = [
  { name: "subrs", op: 19, type: "offset", value: 0 },
  { name: "defaultWidthX", op: 20, type: "number", value: 0 },
  { name: "nominalWidthX", op: 21, type: "number", value: 0 }
];
function A9(r, e) {
  var t = BP(r, 0, r.byteLength);
  return _P(t, MP, e);
}
function LP(r, e, t, n) {
  var i = BP(r, e, t);
  return _P(i, NP, n);
}
function _E(r, e, t, n) {
  for (var i = [], a = 0; a < t.length; a += 1) {
    var s = new DataView(new Uint8Array(t[a]).buffer), o = A9(s, n);
    o._subrs = [], o._subrsBias = 0, o._defaultWidthX = 0, o._nominalWidthX = 0;
    var l = o.private[0], u = o.private[1];
    if (l !== 0 && u !== 0) {
      var c = LP(r, u + e, l, n);
      if (o._defaultWidthX = c.defaultWidthX, o._nominalWidthX = c.nominalWidthX, c.subrs !== 0) {
        var h = u + c.subrs, f = dc(r, h + e);
        o._subrs = f.objects, o._subrsBias = _1(o._subrs);
      }
      o._privateDict = c;
    }
    i.push(o);
  }
  return i;
}
function w9(r, e, t, n) {
  var i, a, s = new Ut.Parser(r, e);
  t -= 1;
  var o = [".notdef"], l = s.parseCard8();
  if (l === 0)
    for (var u = 0; u < t; u += 1)
      i = s.parseSID(), o.push(Dp(n, i));
  else if (l === 1)
    for (; o.length <= t; ) {
      i = s.parseSID(), a = s.parseCard8();
      for (var c = 0; c <= a; c += 1)
        o.push(Dp(n, i)), i += 1;
    }
  else if (l === 2)
    for (; o.length <= t; ) {
      i = s.parseSID(), a = s.parseCard16();
      for (var h = 0; h <= a; h += 1)
        o.push(Dp(n, i)), i += 1;
    }
  else
    throw new Error("Unknown charset format " + l);
  return o;
}
function x9(r, e, t) {
  var n, i = {}, a = new Ut.Parser(r, e), s = a.parseCard8();
  if (s === 0)
    for (var o = a.parseCard8(), l = 0; l < o; l += 1)
      n = a.parseCard8(), i[n] = l;
  else if (s === 1) {
    var u = a.parseCard8();
    n = 1;
    for (var c = 0; c < u; c += 1)
      for (var h = a.parseCard8(), f = a.parseCard8(), p = h; p <= h + f; p += 1)
        i[p] = n, n += 1;
  } else
    throw new Error("Unknown encoding format " + s);
  return new x0(i, t);
}
function ME(r, e, t) {
  var n, i, a, s, o = new ha(), l = [], u = 0, c = !1, h = !1, f = 0, p = 0, m, A, w, x;
  if (r.isCIDFont) {
    var E = r.tables.cff.topDict._fdSelect[e.index], T = r.tables.cff.topDict._fdArray[E];
    m = T._subrs, A = T._subrsBias, w = T._defaultWidthX, x = T._nominalWidthX;
  } else
    m = r.tables.cff.topDict._subrs, A = r.tables.cff.topDict._subrsBias, w = r.tables.cff.topDict._defaultWidthX, x = r.tables.cff.topDict._nominalWidthX;
  var D = w;
  function F(Z, te) {
    h && o.closePath(), o.moveTo(Z, te), h = !0;
  }
  function _() {
    var Z;
    Z = l.length % 2 !== 0, Z && !c && (D = l.shift() + x), u += l.length >> 1, l.length = 0, c = !0;
  }
  function L(Z) {
    for (var te, de, H, j, q, re, ae, ye, Se, Xe, Ve, He, le = 0; le < Z.length; ) {
      var ve = Z[le];
      switch (le += 1, ve) {
        case 1:
          _();
          break;
        case 3:
          _();
          break;
        case 4:
          l.length > 1 && !c && (D = l.shift() + x, c = !0), p += l.pop(), F(f, p);
          break;
        case 5:
          for (; l.length > 0; )
            f += l.shift(), p += l.shift(), o.lineTo(f, p);
          break;
        case 6:
          for (; l.length > 0 && (f += l.shift(), o.lineTo(f, p), l.length !== 0); )
            p += l.shift(), o.lineTo(f, p);
          break;
        case 7:
          for (; l.length > 0 && (p += l.shift(), o.lineTo(f, p), l.length !== 0); )
            f += l.shift(), o.lineTo(f, p);
          break;
        case 8:
          for (; l.length > 0; )
            n = f + l.shift(), i = p + l.shift(), a = n + l.shift(), s = i + l.shift(), f = a + l.shift(), p = s + l.shift(), o.curveTo(n, i, a, s, f, p);
          break;
        case 10:
          q = l.pop() + A, re = m[q], re && L(re);
          break;
        case 11:
          return;
        case 12:
          switch (ve = Z[le], le += 1, ve) {
            case 35:
              n = f + l.shift(), i = p + l.shift(), a = n + l.shift(), s = i + l.shift(), ae = a + l.shift(), ye = s + l.shift(), Se = ae + l.shift(), Xe = ye + l.shift(), Ve = Se + l.shift(), He = Xe + l.shift(), f = Ve + l.shift(), p = He + l.shift(), l.shift(), o.curveTo(n, i, a, s, ae, ye), o.curveTo(Se, Xe, Ve, He, f, p);
              break;
            case 34:
              n = f + l.shift(), i = p, a = n + l.shift(), s = i + l.shift(), ae = a + l.shift(), ye = s, Se = ae + l.shift(), Xe = s, Ve = Se + l.shift(), He = p, f = Ve + l.shift(), o.curveTo(n, i, a, s, ae, ye), o.curveTo(Se, Xe, Ve, He, f, p);
              break;
            case 36:
              n = f + l.shift(), i = p + l.shift(), a = n + l.shift(), s = i + l.shift(), ae = a + l.shift(), ye = s, Se = ae + l.shift(), Xe = s, Ve = Se + l.shift(), He = Xe + l.shift(), f = Ve + l.shift(), o.curveTo(n, i, a, s, ae, ye), o.curveTo(Se, Xe, Ve, He, f, p);
              break;
            case 37:
              n = f + l.shift(), i = p + l.shift(), a = n + l.shift(), s = i + l.shift(), ae = a + l.shift(), ye = s + l.shift(), Se = ae + l.shift(), Xe = ye + l.shift(), Ve = Se + l.shift(), He = Xe + l.shift(), Math.abs(Ve - f) > Math.abs(He - p) ? f = Ve + l.shift() : p = He + l.shift(), o.curveTo(n, i, a, s, ae, ye), o.curveTo(Se, Xe, Ve, He, f, p);
              break;
            default:
              console.log("Glyph " + e.index + ": unknown operator 1200" + ve), l.length = 0;
          }
          break;
        case 14:
          l.length > 0 && !c && (D = l.shift() + x, c = !0), h && (o.closePath(), h = !1);
          break;
        case 18:
          _();
          break;
        case 19:
        // hintmask
        case 20:
          _(), le += u + 7 >> 3;
          break;
        case 21:
          l.length > 2 && !c && (D = l.shift() + x, c = !0), p += l.pop(), f += l.pop(), F(f, p);
          break;
        case 22:
          l.length > 1 && !c && (D = l.shift() + x, c = !0), f += l.pop(), F(f, p);
          break;
        case 23:
          _();
          break;
        case 24:
          for (; l.length > 2; )
            n = f + l.shift(), i = p + l.shift(), a = n + l.shift(), s = i + l.shift(), f = a + l.shift(), p = s + l.shift(), o.curveTo(n, i, a, s, f, p);
          f += l.shift(), p += l.shift(), o.lineTo(f, p);
          break;
        case 25:
          for (; l.length > 6; )
            f += l.shift(), p += l.shift(), o.lineTo(f, p);
          n = f + l.shift(), i = p + l.shift(), a = n + l.shift(), s = i + l.shift(), f = a + l.shift(), p = s + l.shift(), o.curveTo(n, i, a, s, f, p);
          break;
        case 26:
          for (l.length % 2 && (f += l.shift()); l.length > 0; )
            n = f, i = p + l.shift(), a = n + l.shift(), s = i + l.shift(), f = a, p = s + l.shift(), o.curveTo(n, i, a, s, f, p);
          break;
        case 27:
          for (l.length % 2 && (p += l.shift()); l.length > 0; )
            n = f + l.shift(), i = p, a = n + l.shift(), s = i + l.shift(), f = a + l.shift(), p = s, o.curveTo(n, i, a, s, f, p);
          break;
        case 28:
          te = Z[le], de = Z[le + 1], l.push((te << 24 | de << 16) >> 16), le += 2;
          break;
        case 29:
          q = l.pop() + r.gsubrsBias, re = r.gsubrs[q], re && L(re);
          break;
        case 30:
          for (; l.length > 0 && (n = f, i = p + l.shift(), a = n + l.shift(), s = i + l.shift(), f = a + l.shift(), p = s + (l.length === 1 ? l.shift() : 0), o.curveTo(n, i, a, s, f, p), l.length !== 0); )
            n = f + l.shift(), i = p, a = n + l.shift(), s = i + l.shift(), p = s + l.shift(), f = a + (l.length === 1 ? l.shift() : 0), o.curveTo(n, i, a, s, f, p);
          break;
        case 31:
          for (; l.length > 0 && (n = f + l.shift(), i = p, a = n + l.shift(), s = i + l.shift(), p = s + l.shift(), f = a + (l.length === 1 ? l.shift() : 0), o.curveTo(n, i, a, s, f, p), l.length !== 0); )
            n = f, i = p + l.shift(), a = n + l.shift(), s = i + l.shift(), f = a + l.shift(), p = s + (l.length === 1 ? l.shift() : 0), o.curveTo(n, i, a, s, f, p);
          break;
        default:
          ve < 32 ? console.log("Glyph " + e.index + ": unknown operator " + ve) : ve < 247 ? l.push(ve - 139) : ve < 251 ? (te = Z[le], le += 1, l.push((ve - 247) * 256 + te + 108)) : ve < 255 ? (te = Z[le], le += 1, l.push(-(ve - 251) * 256 - te - 108)) : (te = Z[le], de = Z[le + 1], H = Z[le + 2], j = Z[le + 3], le += 4, l.push((te << 24 | de << 16 | H << 8 | j) / 65536));
      }
    }
  }
  return L(t), e.advanceWidth = D, o;
}
function b9(r, e, t, n) {
  var i = [], a, s = new Ut.Parser(r, e), o = s.parseCard8();
  if (o === 0)
    for (var l = 0; l < t; l++) {
      if (a = s.parseCard8(), a >= n)
        throw new Error("CFF table CID Font FDSelect has bad FD index value " + a + " (FD count " + n + ")");
      i.push(a);
    }
  else if (o === 3) {
    var u = s.parseCard16(), c = s.parseCard16();
    if (c !== 0)
      throw new Error("CFF Table CID Font FDSelect format 3 range has bad initial GID " + c);
    for (var h, f = 0; f < u; f++) {
      if (a = s.parseCard8(), h = s.parseCard16(), a >= n)
        throw new Error("CFF table CID Font FDSelect has bad FD index value " + a + " (FD count " + n + ")");
      if (h > t)
        throw new Error("CFF Table CID Font FDSelect format 3 range has bad GID " + h);
      for (; c < h; c++)
        i.push(a);
      c = h;
    }
    if (h !== t)
      throw new Error("CFF Table CID Font FDSelect format 3 range has bad final GID " + h);
  } else
    throw new Error("CFF Table CID Font FDSelect table has unsupported format " + o);
  return i;
}
function C9(r, e, t, n) {
  t.tables.cff = {};
  var i = y9(r, e), a = dc(r, i.endOffset, Ut.bytesToString), s = dc(r, a.endOffset), o = dc(r, s.endOffset, Ut.bytesToString), l = dc(r, o.endOffset);
  t.gsubrs = l.objects, t.gsubrsBias = _1(t.gsubrs);
  var u = _E(r, e, s.objects, o.objects);
  if (u.length !== 1)
    throw new Error("CFF table has too many fonts in 'FontSet' - count of fonts NameIndex.length = " + u.length);
  var c = u[0];
  if (t.tables.cff.topDict = c, c._privateDict && (t.defaultWidthX = c._privateDict.defaultWidthX, t.nominalWidthX = c._privateDict.nominalWidthX), c.ros[0] !== void 0 && c.ros[1] !== void 0 && (t.isCIDFont = !0), t.isCIDFont) {
    var h = c.fdArray, f = c.fdSelect;
    if (h === 0 || f === 0)
      throw new Error("Font is marked as a CID font, but FDArray and/or FDSelect information is missing");
    h += e;
    var p = dc(r, h), m = _E(r, e, p.objects, o.objects);
    c._fdArray = m, f += e, c._fdSelect = b9(r, f, t.numGlyphs, m.length);
  }
  var A = e + c.private[1], w = LP(r, A, c.private[0], o.objects);
  if (t.defaultWidthX = w.defaultWidthX, t.nominalWidthX = w.nominalWidthX, w.subrs !== 0) {
    var x = A + w.subrs, E = dc(r, x);
    t.subrs = E.objects, t.subrsBias = _1(t.subrs);
  } else
    t.subrs = [], t.subrsBias = 0;
  var T;
  n.lowMemory ? (T = h9(r, e + c.charStrings), t.nGlyphs = T.offsets.length) : (T = dc(r, e + c.charStrings), t.nGlyphs = T.objects.length);
  var D = w9(r, e + c.charset, t.nGlyphs, o.objects);
  if (c.encoding === 0 ? t.cffEncoding = new x0(n9, D) : c.encoding === 1 ? t.cffEncoding = new x0(i9, D) : t.cffEncoding = x9(r, e + c.encoding, D), t.encoding = t.encoding || t.cffEncoding, t.glyphs = new _l.GlyphSet(t), n.lowMemory)
    t._push = function(L) {
      var Z = p9(L, T.offsets, r, e + c.charStrings);
      t.glyphs.push(L, _l.cffGlyphLoader(t, L, ME, Z));
    };
  else
    for (var F = 0; F < t.nGlyphs; F += 1) {
      var _ = T.objects[F];
      t.glyphs.push(F, _l.cffGlyphLoader(t, F, ME, _));
    }
}
function UP(r, e) {
  var t, n = Ym.indexOf(r);
  return n >= 0 && (t = n), n = e.indexOf(r), n >= 0 ? t = n + Ym.length : (t = Ym.length + e.length, e.push(r)), t;
}
function S9() {
  return new Dt.Record("Header", [
    { name: "major", type: "Card8", value: 1 },
    { name: "minor", type: "Card8", value: 0 },
    { name: "hdrSize", type: "Card8", value: 4 },
    { name: "major", type: "Card8", value: 1 }
  ]);
}
function E9(r) {
  var e = new Dt.Record("Name INDEX", [
    { name: "names", type: "INDEX", value: [] }
  ]);
  e.names = [];
  for (var t = 0; t < r.length; t += 1)
    e.names.push({ name: "name_" + t, type: "NAME", value: r[t] });
  return e;
}
function VP(r, e, t) {
  for (var n = {}, i = 0; i < r.length; i += 1) {
    var a = r[i], s = e[a.name];
    s !== void 0 && !OP(s, a.value) && (a.type === "SID" && (s = UP(s, t)), n[a.op] = { name: a.name, type: a.type, value: s });
  }
  return n;
}
function NE(r, e) {
  var t = new Dt.Record("Top DICT", [
    { name: "dict", type: "DICT", value: {} }
  ]);
  return t.dict = VP(MP, r, e), t;
}
function LE(r) {
  var e = new Dt.Record("Top DICT INDEX", [
    { name: "topDicts", type: "INDEX", value: [] }
  ]);
  return e.topDicts = [{ name: "topDict_0", type: "TABLE", value: r }], e;
}
function k9(r) {
  var e = new Dt.Record("String INDEX", [
    { name: "strings", type: "INDEX", value: [] }
  ]);
  e.strings = [];
  for (var t = 0; t < r.length; t += 1)
    e.strings.push({ name: "string_" + t, type: "STRING", value: r[t] });
  return e;
}
function T9() {
  return new Dt.Record("Global Subr INDEX", [
    { name: "subrs", type: "INDEX", value: [] }
  ]);
}
function F9(r, e) {
  for (var t = new Dt.Record("Charsets", [
    { name: "format", type: "Card8", value: 0 }
  ]), n = 0; n < r.length; n += 1) {
    var i = r[n], a = UP(i, e);
    t.fields.push({ name: "glyph_" + n, type: "SID", value: a });
  }
  return t;
}
function I9(r) {
  var e = [], t = r.path;
  e.push({ name: "width", type: "NUMBER", value: r.advanceWidth });
  for (var n = 0, i = 0, a = 0; a < t.commands.length; a += 1) {
    var s = void 0, o = void 0, l = t.commands[a];
    if (l.type === "Q") {
      var u = 0.3333333333333333, c = 2 / 3;
      l = {
        type: "C",
        x: l.x,
        y: l.y,
        x1: Math.round(u * n + c * l.x1),
        y1: Math.round(u * i + c * l.y1),
        x2: Math.round(u * l.x + c * l.x1),
        y2: Math.round(u * l.y + c * l.y1)
      };
    }
    if (l.type === "M")
      s = Math.round(l.x - n), o = Math.round(l.y - i), e.push({ name: "dx", type: "NUMBER", value: s }), e.push({ name: "dy", type: "NUMBER", value: o }), e.push({ name: "rmoveto", type: "OP", value: 21 }), n = Math.round(l.x), i = Math.round(l.y);
    else if (l.type === "L")
      s = Math.round(l.x - n), o = Math.round(l.y - i), e.push({ name: "dx", type: "NUMBER", value: s }), e.push({ name: "dy", type: "NUMBER", value: o }), e.push({ name: "rlineto", type: "OP", value: 5 }), n = Math.round(l.x), i = Math.round(l.y);
    else if (l.type === "C") {
      var h = Math.round(l.x1 - n), f = Math.round(l.y1 - i), p = Math.round(l.x2 - l.x1), m = Math.round(l.y2 - l.y1);
      s = Math.round(l.x - l.x2), o = Math.round(l.y - l.y2), e.push({ name: "dx1", type: "NUMBER", value: h }), e.push({ name: "dy1", type: "NUMBER", value: f }), e.push({ name: "dx2", type: "NUMBER", value: p }), e.push({ name: "dy2", type: "NUMBER", value: m }), e.push({ name: "dx", type: "NUMBER", value: s }), e.push({ name: "dy", type: "NUMBER", value: o }), e.push({ name: "rrcurveto", type: "OP", value: 8 }), n = Math.round(l.x), i = Math.round(l.y);
    }
  }
  return e.push({ name: "endchar", type: "OP", value: 14 }), e;
}
function P9(r) {
  for (var e = new Dt.Record("CharStrings INDEX", [
    { name: "charStrings", type: "INDEX", value: [] }
  ]), t = 0; t < r.length; t += 1) {
    var n = r.get(t), i = I9(n);
    e.charStrings.push({ name: n.name, type: "CHARSTRING", value: i });
  }
  return e;
}
function D9(r, e) {
  var t = new Dt.Record("Private DICT", [
    { name: "dict", type: "DICT", value: {} }
  ]);
  return t.dict = VP(NP, r, e), t;
}
function R9(r, e) {
  for (var t = new Dt.Table("CFF ", [
    { name: "header", type: "RECORD" },
    { name: "nameIndex", type: "RECORD" },
    { name: "topDictIndex", type: "RECORD" },
    { name: "stringIndex", type: "RECORD" },
    { name: "globalSubrIndex", type: "RECORD" },
    { name: "charsets", type: "RECORD" },
    { name: "charStringsIndex", type: "RECORD" },
    { name: "privateDict", type: "RECORD" }
  ]), n = 1 / e.unitsPerEm, i = {
    version: e.version,
    fullName: e.fullName,
    familyName: e.familyName,
    weight: e.weightName,
    fontBBox: e.fontBBox || [0, 0, 0, 0],
    fontMatrix: [n, 0, 0, n, 0, 0],
    charset: 999,
    encoding: 0,
    charStrings: 999,
    private: [0, 999]
  }, a = {}, s = [], o, l = 1; l < r.length; l += 1)
    o = r.get(l), s.push(o.name);
  var u = [];
  t.header = S9(), t.nameIndex = E9([e.postScriptName]);
  var c = NE(i, u);
  t.topDictIndex = LE(c), t.globalSubrIndex = T9(), t.charsets = F9(s, u), t.charStringsIndex = P9(r), t.privateDict = D9(a, u), t.stringIndex = k9(u);
  var h = t.header.sizeOf() + t.nameIndex.sizeOf() + t.topDictIndex.sizeOf() + t.stringIndex.sizeOf() + t.globalSubrIndex.sizeOf();
  return i.charset = h, i.encoding = 0, i.charStrings = i.charset + t.charsets.sizeOf(), i.private[1] = i.charStrings + t.charStringsIndex.sizeOf(), c = NE(i, u), t.topDictIndex = LE(c), t;
}
var $P = { parse: C9, make: R9 };
function O9(r, e) {
  var t = {}, n = new Ut.Parser(r, e);
  return t.version = n.parseVersion(), t.fontRevision = Math.round(n.parseFixed() * 1e3) / 1e3, t.checkSumAdjustment = n.parseULong(), t.magicNumber = n.parseULong(), xr.argument(t.magicNumber === 1594834165, "Font header has wrong magic number."), t.flags = n.parseUShort(), t.unitsPerEm = n.parseUShort(), t.created = n.parseLongDateTime(), t.modified = n.parseLongDateTime(), t.xMin = n.parseShort(), t.yMin = n.parseShort(), t.xMax = n.parseShort(), t.yMax = n.parseShort(), t.macStyle = n.parseUShort(), t.lowestRecPPEM = n.parseUShort(), t.fontDirectionHint = n.parseShort(), t.indexToLocFormat = n.parseShort(), t.glyphDataFormat = n.parseShort(), t;
}
function B9(r) {
  var e = Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3) + 2082844800, t = e;
  return r.createdTimestamp && (t = r.createdTimestamp + 2082844800), new Dt.Table("head", [
    { name: "version", type: "FIXED", value: 65536 },
    { name: "fontRevision", type: "FIXED", value: 65536 },
    { name: "checkSumAdjustment", type: "ULONG", value: 0 },
    { name: "magicNumber", type: "ULONG", value: 1594834165 },
    { name: "flags", type: "USHORT", value: 0 },
    { name: "unitsPerEm", type: "USHORT", value: 1e3 },
    { name: "created", type: "LONGDATETIME", value: t },
    { name: "modified", type: "LONGDATETIME", value: e },
    { name: "xMin", type: "SHORT", value: 0 },
    { name: "yMin", type: "SHORT", value: 0 },
    { name: "xMax", type: "SHORT", value: 0 },
    { name: "yMax", type: "SHORT", value: 0 },
    { name: "macStyle", type: "USHORT", value: 0 },
    { name: "lowestRecPPEM", type: "USHORT", value: 0 },
    { name: "fontDirectionHint", type: "SHORT", value: 2 },
    { name: "indexToLocFormat", type: "SHORT", value: 0 },
    { name: "glyphDataFormat", type: "SHORT", value: 0 }
  ], r);
}
var zP = { parse: O9, make: B9 };
function _9(r, e) {
  var t = {}, n = new Ut.Parser(r, e);
  return t.version = n.parseVersion(), t.ascender = n.parseShort(), t.descender = n.parseShort(), t.lineGap = n.parseShort(), t.advanceWidthMax = n.parseUShort(), t.minLeftSideBearing = n.parseShort(), t.minRightSideBearing = n.parseShort(), t.xMaxExtent = n.parseShort(), t.caretSlopeRise = n.parseShort(), t.caretSlopeRun = n.parseShort(), t.caretOffset = n.parseShort(), n.relativeOffset += 8, t.metricDataFormat = n.parseShort(), t.numberOfHMetrics = n.parseUShort(), t;
}
function M9(r) {
  return new Dt.Table("hhea", [
    { name: "version", type: "FIXED", value: 65536 },
    { name: "ascender", type: "FWORD", value: 0 },
    { name: "descender", type: "FWORD", value: 0 },
    { name: "lineGap", type: "FWORD", value: 0 },
    { name: "advanceWidthMax", type: "UFWORD", value: 0 },
    { name: "minLeftSideBearing", type: "FWORD", value: 0 },
    { name: "minRightSideBearing", type: "FWORD", value: 0 },
    { name: "xMaxExtent", type: "FWORD", value: 0 },
    { name: "caretSlopeRise", type: "SHORT", value: 1 },
    { name: "caretSlopeRun", type: "SHORT", value: 0 },
    { name: "caretOffset", type: "SHORT", value: 0 },
    { name: "reserved1", type: "SHORT", value: 0 },
    { name: "reserved2", type: "SHORT", value: 0 },
    { name: "reserved3", type: "SHORT", value: 0 },
    { name: "reserved4", type: "SHORT", value: 0 },
    { name: "metricDataFormat", type: "SHORT", value: 0 },
    { name: "numberOfHMetrics", type: "USHORT", value: 0 }
  ], r);
}
var GP = { parse: _9, make: M9 };
function N9(r, e, t, n, i) {
  for (var a, s, o = new Ut.Parser(r, e), l = 0; l < n; l += 1) {
    l < t && (a = o.parseUShort(), s = o.parseShort());
    var u = i.get(l);
    u.advanceWidth = a, u.leftSideBearing = s;
  }
}
function L9(r, e, t, n, i) {
  r._hmtxTableData = {};
  for (var a, s, o = new Ut.Parser(e, t), l = 0; l < i; l += 1)
    l < n && (a = o.parseUShort(), s = o.parseShort()), r._hmtxTableData[l] = {
      advanceWidth: a,
      leftSideBearing: s
    };
}
function U9(r, e, t, n, i, a, s) {
  s.lowMemory ? L9(r, e, t, n, i) : N9(e, t, n, i, a);
}
function V9(r) {
  for (var e = new Dt.Table("hmtx", []), t = 0; t < r.length; t += 1) {
    var n = r.get(t), i = n.advanceWidth || 0, a = n.leftSideBearing || 0;
    e.fields.push({ name: "advanceWidth_" + t, type: "USHORT", value: i }), e.fields.push({ name: "leftSideBearing_" + t, type: "SHORT", value: a });
  }
  return e;
}
var HP = { parse: U9, make: V9 };
function $9(r) {
  for (var e = new Dt.Table("ltag", [
    { name: "version", type: "ULONG", value: 1 },
    { name: "flags", type: "ULONG", value: 0 },
    { name: "numTags", type: "ULONG", value: r.length }
  ]), t = "", n = 12 + r.length * 4, i = 0; i < r.length; ++i) {
    var a = t.indexOf(r[i]);
    a < 0 && (a = t.length, t += r[i]), e.fields.push({ name: "offset " + i, type: "USHORT", value: n + a }), e.fields.push({ name: "length " + i, type: "USHORT", value: r[i].length });
  }
  return e.fields.push({ name: "stringPool", type: "CHARARRAY", value: t }), e;
}
function z9(r, e) {
  var t = new Ut.Parser(r, e), n = t.parseULong();
  xr.argument(n === 1, "Unsupported ltag table version."), t.skip("uLong", 1);
  for (var i = t.parseULong(), a = [], s = 0; s < i; s++) {
    for (var o = "", l = e + t.parseUShort(), u = t.parseUShort(), c = l; c < l + u; ++c)
      o += String.fromCharCode(r.getInt8(c));
    a.push(o);
  }
  return a;
}
var WP = { make: $9, parse: z9 };
function G9(r, e) {
  var t = {}, n = new Ut.Parser(r, e);
  return t.version = n.parseVersion(), t.numGlyphs = n.parseUShort(), t.version === 1 && (t.maxPoints = n.parseUShort(), t.maxContours = n.parseUShort(), t.maxCompositePoints = n.parseUShort(), t.maxCompositeContours = n.parseUShort(), t.maxZones = n.parseUShort(), t.maxTwilightPoints = n.parseUShort(), t.maxStorage = n.parseUShort(), t.maxFunctionDefs = n.parseUShort(), t.maxInstructionDefs = n.parseUShort(), t.maxStackElements = n.parseUShort(), t.maxSizeOfInstructions = n.parseUShort(), t.maxComponentElements = n.parseUShort(), t.maxComponentDepth = n.parseUShort()), t;
}
function H9(r) {
  return new Dt.Table("maxp", [
    { name: "version", type: "FIXED", value: 20480 },
    { name: "numGlyphs", type: "USHORT", value: r }
  ]);
}
var jP = { parse: G9, make: H9 }, qP = [
  "copyright",
  // 0
  "fontFamily",
  // 1
  "fontSubfamily",
  // 2
  "uniqueID",
  // 3
  "fullName",
  // 4
  "version",
  // 5
  "postScriptName",
  // 6
  "trademark",
  // 7
  "manufacturer",
  // 8
  "designer",
  // 9
  "description",
  // 10
  "manufacturerURL",
  // 11
  "designerURL",
  // 12
  "license",
  // 13
  "licenseURL",
  // 14
  "reserved",
  // 15
  "preferredFamily",
  // 16
  "preferredSubfamily",
  // 17
  "compatibleFullName",
  // 18
  "sampleText",
  // 19
  "postScriptFindFontName",
  // 20
  "wwsFamily",
  // 21
  "wwsSubfamily"
  // 22
], QP = {
  0: "en",
  1: "fr",
  2: "de",
  3: "it",
  4: "nl",
  5: "sv",
  6: "es",
  7: "da",
  8: "pt",
  9: "no",
  10: "he",
  11: "ja",
  12: "ar",
  13: "fi",
  14: "el",
  15: "is",
  16: "mt",
  17: "tr",
  18: "hr",
  19: "zh-Hant",
  20: "ur",
  21: "hi",
  22: "th",
  23: "ko",
  24: "lt",
  25: "pl",
  26: "hu",
  27: "es",
  28: "lv",
  29: "se",
  30: "fo",
  31: "fa",
  32: "ru",
  33: "zh",
  34: "nl-BE",
  35: "ga",
  36: "sq",
  37: "ro",
  38: "cz",
  39: "sk",
  40: "si",
  41: "yi",
  42: "sr",
  43: "mk",
  44: "bg",
  45: "uk",
  46: "be",
  47: "uz",
  48: "kk",
  49: "az-Cyrl",
  50: "az-Arab",
  51: "hy",
  52: "ka",
  53: "mo",
  54: "ky",
  55: "tg",
  56: "tk",
  57: "mn-CN",
  58: "mn",
  59: "ps",
  60: "ks",
  61: "ku",
  62: "sd",
  63: "bo",
  64: "ne",
  65: "sa",
  66: "mr",
  67: "bn",
  68: "as",
  69: "gu",
  70: "pa",
  71: "or",
  72: "ml",
  73: "kn",
  74: "ta",
  75: "te",
  76: "si",
  77: "my",
  78: "km",
  79: "lo",
  80: "vi",
  81: "id",
  82: "tl",
  83: "ms",
  84: "ms-Arab",
  85: "am",
  86: "ti",
  87: "om",
  88: "so",
  89: "sw",
  90: "rw",
  91: "rn",
  92: "ny",
  93: "mg",
  94: "eo",
  128: "cy",
  129: "eu",
  130: "ca",
  131: "la",
  132: "qu",
  133: "gn",
  134: "ay",
  135: "tt",
  136: "ug",
  137: "dz",
  138: "jv",
  139: "su",
  140: "gl",
  141: "af",
  142: "br",
  143: "iu",
  144: "gd",
  145: "gv",
  146: "ga",
  147: "to",
  148: "el-polyton",
  149: "kl",
  150: "az",
  151: "nn"
}, W9 = {
  0: 0,
  // langEnglish → smRoman
  1: 0,
  // langFrench → smRoman
  2: 0,
  // langGerman → smRoman
  3: 0,
  // langItalian → smRoman
  4: 0,
  // langDutch → smRoman
  5: 0,
  // langSwedish → smRoman
  6: 0,
  // langSpanish → smRoman
  7: 0,
  // langDanish → smRoman
  8: 0,
  // langPortuguese → smRoman
  9: 0,
  // langNorwegian → smRoman
  10: 5,
  // langHebrew → smHebrew
  11: 1,
  // langJapanese → smJapanese
  12: 4,
  // langArabic → smArabic
  13: 0,
  // langFinnish → smRoman
  14: 6,
  // langGreek → smGreek
  15: 0,
  // langIcelandic → smRoman (modified)
  16: 0,
  // langMaltese → smRoman
  17: 0,
  // langTurkish → smRoman (modified)
  18: 0,
  // langCroatian → smRoman (modified)
  19: 2,
  // langTradChinese → smTradChinese
  20: 4,
  // langUrdu → smArabic
  21: 9,
  // langHindi → smDevanagari
  22: 21,
  // langThai → smThai
  23: 3,
  // langKorean → smKorean
  24: 29,
  // langLithuanian → smCentralEuroRoman
  25: 29,
  // langPolish → smCentralEuroRoman
  26: 29,
  // langHungarian → smCentralEuroRoman
  27: 29,
  // langEstonian → smCentralEuroRoman
  28: 29,
  // langLatvian → smCentralEuroRoman
  29: 0,
  // langSami → smRoman
  30: 0,
  // langFaroese → smRoman (modified)
  31: 4,
  // langFarsi → smArabic (modified)
  32: 7,
  // langRussian → smCyrillic
  33: 25,
  // langSimpChinese → smSimpChinese
  34: 0,
  // langFlemish → smRoman
  35: 0,
  // langIrishGaelic → smRoman (modified)
  36: 0,
  // langAlbanian → smRoman
  37: 0,
  // langRomanian → smRoman (modified)
  38: 29,
  // langCzech → smCentralEuroRoman
  39: 29,
  // langSlovak → smCentralEuroRoman
  40: 0,
  // langSlovenian → smRoman (modified)
  41: 5,
  // langYiddish → smHebrew
  42: 7,
  // langSerbian → smCyrillic
  43: 7,
  // langMacedonian → smCyrillic
  44: 7,
  // langBulgarian → smCyrillic
  45: 7,
  // langUkrainian → smCyrillic (modified)
  46: 7,
  // langByelorussian → smCyrillic
  47: 7,
  // langUzbek → smCyrillic
  48: 7,
  // langKazakh → smCyrillic
  49: 7,
  // langAzerbaijani → smCyrillic
  50: 4,
  // langAzerbaijanAr → smArabic
  51: 24,
  // langArmenian → smArmenian
  52: 23,
  // langGeorgian → smGeorgian
  53: 7,
  // langMoldavian → smCyrillic
  54: 7,
  // langKirghiz → smCyrillic
  55: 7,
  // langTajiki → smCyrillic
  56: 7,
  // langTurkmen → smCyrillic
  57: 27,
  // langMongolian → smMongolian
  58: 7,
  // langMongolianCyr → smCyrillic
  59: 4,
  // langPashto → smArabic
  60: 4,
  // langKurdish → smArabic
  61: 4,
  // langKashmiri → smArabic
  62: 4,
  // langSindhi → smArabic
  63: 26,
  // langTibetan → smTibetan
  64: 9,
  // langNepali → smDevanagari
  65: 9,
  // langSanskrit → smDevanagari
  66: 9,
  // langMarathi → smDevanagari
  67: 13,
  // langBengali → smBengali
  68: 13,
  // langAssamese → smBengali
  69: 11,
  // langGujarati → smGujarati
  70: 10,
  // langPunjabi → smGurmukhi
  71: 12,
  // langOriya → smOriya
  72: 17,
  // langMalayalam → smMalayalam
  73: 16,
  // langKannada → smKannada
  74: 14,
  // langTamil → smTamil
  75: 15,
  // langTelugu → smTelugu
  76: 18,
  // langSinhalese → smSinhalese
  77: 19,
  // langBurmese → smBurmese
  78: 20,
  // langKhmer → smKhmer
  79: 22,
  // langLao → smLao
  80: 30,
  // langVietnamese → smVietnamese
  81: 0,
  // langIndonesian → smRoman
  82: 0,
  // langTagalog → smRoman
  83: 0,
  // langMalayRoman → smRoman
  84: 4,
  // langMalayArabic → smArabic
  85: 28,
  // langAmharic → smEthiopic
  86: 28,
  // langTigrinya → smEthiopic
  87: 28,
  // langOromo → smEthiopic
  88: 0,
  // langSomali → smRoman
  89: 0,
  // langSwahili → smRoman
  90: 0,
  // langKinyarwanda → smRoman
  91: 0,
  // langRundi → smRoman
  92: 0,
  // langNyanja → smRoman
  93: 0,
  // langMalagasy → smRoman
  94: 0,
  // langEsperanto → smRoman
  128: 0,
  // langWelsh → smRoman (modified)
  129: 0,
  // langBasque → smRoman
  130: 0,
  // langCatalan → smRoman
  131: 0,
  // langLatin → smRoman
  132: 0,
  // langQuechua → smRoman
  133: 0,
  // langGuarani → smRoman
  134: 0,
  // langAymara → smRoman
  135: 7,
  // langTatar → smCyrillic
  136: 4,
  // langUighur → smArabic
  137: 26,
  // langDzongkha → smTibetan
  138: 0,
  // langJavaneseRom → smRoman
  139: 0,
  // langSundaneseRom → smRoman
  140: 0,
  // langGalician → smRoman
  141: 0,
  // langAfrikaans → smRoman
  142: 0,
  // langBreton → smRoman (modified)
  143: 28,
  // langInuktitut → smEthiopic (modified)
  144: 0,
  // langScottishGaelic → smRoman (modified)
  145: 0,
  // langManxGaelic → smRoman (modified)
  146: 0,
  // langIrishGaelicScript → smRoman (modified)
  147: 0,
  // langTongan → smRoman
  148: 6,
  // langGreekAncient → smRoman
  149: 0,
  // langGreenlandic → smRoman
  150: 0,
  // langAzerbaijanRoman → smRoman
  151: 0
  // langNynorsk → smRoman
}, YP = {
  1078: "af",
  1052: "sq",
  1156: "gsw",
  1118: "am",
  5121: "ar-DZ",
  15361: "ar-BH",
  3073: "ar",
  2049: "ar-IQ",
  11265: "ar-JO",
  13313: "ar-KW",
  12289: "ar-LB",
  4097: "ar-LY",
  6145: "ary",
  8193: "ar-OM",
  16385: "ar-QA",
  1025: "ar-SA",
  10241: "ar-SY",
  7169: "aeb",
  14337: "ar-AE",
  9217: "ar-YE",
  1067: "hy",
  1101: "as",
  2092: "az-Cyrl",
  1068: "az",
  1133: "ba",
  1069: "eu",
  1059: "be",
  2117: "bn",
  1093: "bn-IN",
  8218: "bs-Cyrl",
  5146: "bs",
  1150: "br",
  1026: "bg",
  1027: "ca",
  3076: "zh-HK",
  5124: "zh-MO",
  2052: "zh",
  4100: "zh-SG",
  1028: "zh-TW",
  1155: "co",
  1050: "hr",
  4122: "hr-BA",
  1029: "cs",
  1030: "da",
  1164: "prs",
  1125: "dv",
  2067: "nl-BE",
  1043: "nl",
  3081: "en-AU",
  10249: "en-BZ",
  4105: "en-CA",
  9225: "en-029",
  16393: "en-IN",
  6153: "en-IE",
  8201: "en-JM",
  17417: "en-MY",
  5129: "en-NZ",
  13321: "en-PH",
  18441: "en-SG",
  7177: "en-ZA",
  11273: "en-TT",
  2057: "en-GB",
  1033: "en",
  12297: "en-ZW",
  1061: "et",
  1080: "fo",
  1124: "fil",
  1035: "fi",
  2060: "fr-BE",
  3084: "fr-CA",
  1036: "fr",
  5132: "fr-LU",
  6156: "fr-MC",
  4108: "fr-CH",
  1122: "fy",
  1110: "gl",
  1079: "ka",
  3079: "de-AT",
  1031: "de",
  5127: "de-LI",
  4103: "de-LU",
  2055: "de-CH",
  1032: "el",
  1135: "kl",
  1095: "gu",
  1128: "ha",
  1037: "he",
  1081: "hi",
  1038: "hu",
  1039: "is",
  1136: "ig",
  1057: "id",
  1117: "iu",
  2141: "iu-Latn",
  2108: "ga",
  1076: "xh",
  1077: "zu",
  1040: "it",
  2064: "it-CH",
  1041: "ja",
  1099: "kn",
  1087: "kk",
  1107: "km",
  1158: "quc",
  1159: "rw",
  1089: "sw",
  1111: "kok",
  1042: "ko",
  1088: "ky",
  1108: "lo",
  1062: "lv",
  1063: "lt",
  2094: "dsb",
  1134: "lb",
  1071: "mk",
  2110: "ms-BN",
  1086: "ms",
  1100: "ml",
  1082: "mt",
  1153: "mi",
  1146: "arn",
  1102: "mr",
  1148: "moh",
  1104: "mn",
  2128: "mn-CN",
  1121: "ne",
  1044: "nb",
  2068: "nn",
  1154: "oc",
  1096: "or",
  1123: "ps",
  1045: "pl",
  1046: "pt",
  2070: "pt-PT",
  1094: "pa",
  1131: "qu-BO",
  2155: "qu-EC",
  3179: "qu",
  1048: "ro",
  1047: "rm",
  1049: "ru",
  9275: "smn",
  4155: "smj-NO",
  5179: "smj",
  3131: "se-FI",
  1083: "se",
  2107: "se-SE",
  8251: "sms",
  6203: "sma-NO",
  7227: "sms",
  1103: "sa",
  7194: "sr-Cyrl-BA",
  3098: "sr",
  6170: "sr-Latn-BA",
  2074: "sr-Latn",
  1132: "nso",
  1074: "tn",
  1115: "si",
  1051: "sk",
  1060: "sl",
  11274: "es-AR",
  16394: "es-BO",
  13322: "es-CL",
  9226: "es-CO",
  5130: "es-CR",
  7178: "es-DO",
  12298: "es-EC",
  17418: "es-SV",
  4106: "es-GT",
  18442: "es-HN",
  2058: "es-MX",
  19466: "es-NI",
  6154: "es-PA",
  15370: "es-PY",
  10250: "es-PE",
  20490: "es-PR",
  // Microsoft has defined two different language codes for
  // “Spanish with modern sorting” and “Spanish with traditional
  // sorting”. This makes sense for collation APIs, and it would be
  // possible to express this in BCP 47 language tags via Unicode
  // extensions (eg., es-u-co-trad is Spanish with traditional
  // sorting). However, for storing names in fonts, the distinction
  // does not make sense, so we give “es” in both cases.
  3082: "es",
  1034: "es",
  21514: "es-US",
  14346: "es-UY",
  8202: "es-VE",
  2077: "sv-FI",
  1053: "sv",
  1114: "syr",
  1064: "tg",
  2143: "tzm",
  1097: "ta",
  1092: "tt",
  1098: "te",
  1054: "th",
  1105: "bo",
  1055: "tr",
  1090: "tk",
  1152: "ug",
  1058: "uk",
  1070: "hsb",
  1056: "ur",
  2115: "uz-Cyrl",
  1091: "uz",
  1066: "vi",
  1106: "cy",
  1160: "wo",
  1157: "sah",
  1144: "ii",
  1130: "yo"
};
function j9(r, e, t) {
  switch (r) {
    case 0:
      if (e === 65535)
        return "und";
      if (t)
        return t[e];
      break;
    case 1:
      return QP[e];
    case 3:
      return YP[e];
  }
}
var M1 = "utf-16", q9 = {
  0: "macintosh",
  // smRoman
  1: "x-mac-japanese",
  // smJapanese
  2: "x-mac-chinesetrad",
  // smTradChinese
  3: "x-mac-korean",
  // smKorean
  6: "x-mac-greek",
  // smGreek
  7: "x-mac-cyrillic",
  // smCyrillic
  9: "x-mac-devanagai",
  // smDevanagari
  10: "x-mac-gurmukhi",
  // smGurmukhi
  11: "x-mac-gujarati",
  // smGujarati
  12: "x-mac-oriya",
  // smOriya
  13: "x-mac-bengali",
  // smBengali
  14: "x-mac-tamil",
  // smTamil
  15: "x-mac-telugu",
  // smTelugu
  16: "x-mac-kannada",
  // smKannada
  17: "x-mac-malayalam",
  // smMalayalam
  18: "x-mac-sinhalese",
  // smSinhalese
  19: "x-mac-burmese",
  // smBurmese
  20: "x-mac-khmer",
  // smKhmer
  21: "x-mac-thai",
  // smThai
  22: "x-mac-lao",
  // smLao
  23: "x-mac-georgian",
  // smGeorgian
  24: "x-mac-armenian",
  // smArmenian
  25: "x-mac-chinesesimp",
  // smSimpChinese
  26: "x-mac-tibetan",
  // smTibetan
  27: "x-mac-mongolian",
  // smMongolian
  28: "x-mac-ethiopic",
  // smEthiopic
  29: "x-mac-ce",
  // smCentralEuroRoman
  30: "x-mac-vietnamese",
  // smVietnamese
  31: "x-mac-extarabic"
  // smExtArabic
}, Q9 = {
  15: "x-mac-icelandic",
  // langIcelandic
  17: "x-mac-turkish",
  // langTurkish
  18: "x-mac-croatian",
  // langCroatian
  24: "x-mac-ce",
  // langLithuanian
  25: "x-mac-ce",
  // langPolish
  26: "x-mac-ce",
  // langHungarian
  27: "x-mac-ce",
  // langEstonian
  28: "x-mac-ce",
  // langLatvian
  30: "x-mac-icelandic",
  // langFaroese
  37: "x-mac-romanian",
  // langRomanian
  38: "x-mac-ce",
  // langCzech
  39: "x-mac-ce",
  // langSlovak
  40: "x-mac-ce",
  // langSlovenian
  143: "x-mac-inuit",
  // langInuktitut
  146: "x-mac-gaelic"
  // langIrishGaelicScript
};
function XP(r, e, t) {
  switch (r) {
    case 0:
      return M1;
    case 1:
      return Q9[t] || q9[e];
    case 3:
      if (e === 1 || e === 10)
        return M1;
      break;
  }
}
function Y9(r, e, t) {
  for (var n = {}, i = new Ut.Parser(r, e), a = i.parseUShort(), s = i.parseUShort(), o = i.offset + i.parseUShort(), l = 0; l < s; l++) {
    var u = i.parseUShort(), c = i.parseUShort(), h = i.parseUShort(), f = i.parseUShort(), p = qP[f] || f, m = i.parseUShort(), A = i.parseUShort(), w = j9(u, h, t), x = XP(u, c, h);
    if (x !== void 0 && w !== void 0) {
      var E = void 0;
      if (x === M1 ? E = Gd.UTF16(r, o + A, m) : E = Gd.MACSTRING(r, o + A, m, x), E) {
        var T = n[p];
        T === void 0 && (T = n[p] = {}), T[w] = E;
      }
    }
  }
  return a === 1 && i.parseUShort(), n;
}
function uy(r) {
  var e = {};
  for (var t in r)
    e[r[t]] = parseInt(t);
  return e;
}
function UE(r, e, t, n, i, a) {
  return new Dt.Record("NameRecord", [
    { name: "platformID", type: "USHORT", value: r },
    { name: "encodingID", type: "USHORT", value: e },
    { name: "languageID", type: "USHORT", value: t },
    { name: "nameID", type: "USHORT", value: n },
    { name: "length", type: "USHORT", value: i },
    { name: "offset", type: "USHORT", value: a }
  ]);
}
function X9(r, e) {
  var t = r.length, n = e.length - t + 1;
  e:
    for (var i = 0; i < n; i++)
      for (; i < n; i++) {
        for (var a = 0; a < t; a++)
          if (e[i + a] !== r[a])
            continue e;
        return i;
      }
  return -1;
}
function VE(r, e) {
  var t = X9(r, e);
  if (t < 0) {
    t = e.length;
    for (var n = 0, i = r.length; n < i; ++n)
      e.push(r[n]);
  }
  return t;
}
function J9(r, e) {
  var t, n = [], i = {}, a = uy(qP);
  for (var s in r) {
    var o = a[s];
    if (o === void 0 && (o = s), t = parseInt(o), isNaN(t))
      throw new Error('Name table entry "' + s + '" does not exist, see nameTableNames for complete list.');
    i[t] = r[s], n.push(t);
  }
  for (var l = uy(QP), u = uy(YP), c = [], h = [], f = 0; f < n.length; f++) {
    t = n[f];
    var p = i[t];
    for (var m in p) {
      var A = p[m], w = 1, x = l[m], E = W9[x], T = XP(w, E, x), D = bt.MACSTRING(A, T);
      D === void 0 && (w = 0, x = e.indexOf(m), x < 0 && (x = e.length, e.push(m)), E = 4, D = bt.UTF16(A));
      var F = VE(D, h);
      c.push(UE(
        w,
        E,
        x,
        t,
        D.length,
        F
      ));
      var _ = u[m];
      if (_ !== void 0) {
        var L = bt.UTF16(A), Z = VE(L, h);
        c.push(UE(
          3,
          1,
          _,
          t,
          L.length,
          Z
        ));
      }
    }
  }
  c.sort(function(H, j) {
    return H.platformID - j.platformID || H.encodingID - j.encodingID || H.languageID - j.languageID || H.nameID - j.nameID;
  });
  for (var te = new Dt.Table("name", [
    { name: "format", type: "USHORT", value: 0 },
    { name: "count", type: "USHORT", value: c.length },
    { name: "stringOffset", type: "USHORT", value: 6 + c.length * 12 }
  ]), de = 0; de < c.length; de++)
    te.fields.push({ name: "record_" + de, type: "RECORD", value: c[de] });
  return te.fields.push({ name: "strings", type: "LITERAL", value: h }), te;
}
var JP = { parse: Y9, make: J9 }, N1 = [
  { begin: 0, end: 127 },
  // Basic Latin
  { begin: 128, end: 255 },
  // Latin-1 Supplement
  { begin: 256, end: 383 },
  // Latin Extended-A
  { begin: 384, end: 591 },
  // Latin Extended-B
  { begin: 592, end: 687 },
  // IPA Extensions
  { begin: 688, end: 767 },
  // Spacing Modifier Letters
  { begin: 768, end: 879 },
  // Combining Diacritical Marks
  { begin: 880, end: 1023 },
  // Greek and Coptic
  { begin: 11392, end: 11519 },
  // Coptic
  { begin: 1024, end: 1279 },
  // Cyrillic
  { begin: 1328, end: 1423 },
  // Armenian
  { begin: 1424, end: 1535 },
  // Hebrew
  { begin: 42240, end: 42559 },
  // Vai
  { begin: 1536, end: 1791 },
  // Arabic
  { begin: 1984, end: 2047 },
  // NKo
  { begin: 2304, end: 2431 },
  // Devanagari
  { begin: 2432, end: 2559 },
  // Bengali
  { begin: 2560, end: 2687 },
  // Gurmukhi
  { begin: 2688, end: 2815 },
  // Gujarati
  { begin: 2816, end: 2943 },
  // Oriya
  { begin: 2944, end: 3071 },
  // Tamil
  { begin: 3072, end: 3199 },
  // Telugu
  { begin: 3200, end: 3327 },
  // Kannada
  { begin: 3328, end: 3455 },
  // Malayalam
  { begin: 3584, end: 3711 },
  // Thai
  { begin: 3712, end: 3839 },
  // Lao
  { begin: 4256, end: 4351 },
  // Georgian
  { begin: 6912, end: 7039 },
  // Balinese
  { begin: 4352, end: 4607 },
  // Hangul Jamo
  { begin: 7680, end: 7935 },
  // Latin Extended Additional
  { begin: 7936, end: 8191 },
  // Greek Extended
  { begin: 8192, end: 8303 },
  // General Punctuation
  { begin: 8304, end: 8351 },
  // Superscripts And Subscripts
  { begin: 8352, end: 8399 },
  // Currency Symbol
  { begin: 8400, end: 8447 },
  // Combining Diacritical Marks For Symbols
  { begin: 8448, end: 8527 },
  // Letterlike Symbols
  { begin: 8528, end: 8591 },
  // Number Forms
  { begin: 8592, end: 8703 },
  // Arrows
  { begin: 8704, end: 8959 },
  // Mathematical Operators
  { begin: 8960, end: 9215 },
  // Miscellaneous Technical
  { begin: 9216, end: 9279 },
  // Control Pictures
  { begin: 9280, end: 9311 },
  // Optical Character Recognition
  { begin: 9312, end: 9471 },
  // Enclosed Alphanumerics
  { begin: 9472, end: 9599 },
  // Box Drawing
  { begin: 9600, end: 9631 },
  // Block Elements
  { begin: 9632, end: 9727 },
  // Geometric Shapes
  { begin: 9728, end: 9983 },
  // Miscellaneous Symbols
  { begin: 9984, end: 10175 },
  // Dingbats
  { begin: 12288, end: 12351 },
  // CJK Symbols And Punctuation
  { begin: 12352, end: 12447 },
  // Hiragana
  { begin: 12448, end: 12543 },
  // Katakana
  { begin: 12544, end: 12591 },
  // Bopomofo
  { begin: 12592, end: 12687 },
  // Hangul Compatibility Jamo
  { begin: 43072, end: 43135 },
  // Phags-pa
  { begin: 12800, end: 13055 },
  // Enclosed CJK Letters And Months
  { begin: 13056, end: 13311 },
  // CJK Compatibility
  { begin: 44032, end: 55215 },
  // Hangul Syllables
  { begin: 55296, end: 57343 },
  // Non-Plane 0 *
  { begin: 67840, end: 67871 },
  // Phoenicia
  { begin: 19968, end: 40959 },
  // CJK Unified Ideographs
  { begin: 57344, end: 63743 },
  // Private Use Area (plane 0)
  { begin: 12736, end: 12783 },
  // CJK Strokes
  { begin: 64256, end: 64335 },
  // Alphabetic Presentation Forms
  { begin: 64336, end: 65023 },
  // Arabic Presentation Forms-A
  { begin: 65056, end: 65071 },
  // Combining Half Marks
  { begin: 65040, end: 65055 },
  // Vertical Forms
  { begin: 65104, end: 65135 },
  // Small Form Variants
  { begin: 65136, end: 65279 },
  // Arabic Presentation Forms-B
  { begin: 65280, end: 65519 },
  // Halfwidth And Fullwidth Forms
  { begin: 65520, end: 65535 },
  // Specials
  { begin: 3840, end: 4095 },
  // Tibetan
  { begin: 1792, end: 1871 },
  // Syriac
  { begin: 1920, end: 1983 },
  // Thaana
  { begin: 3456, end: 3583 },
  // Sinhala
  { begin: 4096, end: 4255 },
  // Myanmar
  { begin: 4608, end: 4991 },
  // Ethiopic
  { begin: 5024, end: 5119 },
  // Cherokee
  { begin: 5120, end: 5759 },
  // Unified Canadian Aboriginal Syllabics
  { begin: 5760, end: 5791 },
  // Ogham
  { begin: 5792, end: 5887 },
  // Runic
  { begin: 6016, end: 6143 },
  // Khmer
  { begin: 6144, end: 6319 },
  // Mongolian
  { begin: 10240, end: 10495 },
  // Braille Patterns
  { begin: 40960, end: 42127 },
  // Yi Syllables
  { begin: 5888, end: 5919 },
  // Tagalog
  { begin: 66304, end: 66351 },
  // Old Italic
  { begin: 66352, end: 66383 },
  // Gothic
  { begin: 66560, end: 66639 },
  // Deseret
  { begin: 118784, end: 119039 },
  // Byzantine Musical Symbols
  { begin: 119808, end: 120831 },
  // Mathematical Alphanumeric Symbols
  { begin: 1044480, end: 1048573 },
  // Private Use (plane 15)
  { begin: 65024, end: 65039 },
  // Variation Selectors
  { begin: 917504, end: 917631 },
  // Tags
  { begin: 6400, end: 6479 },
  // Limbu
  { begin: 6480, end: 6527 },
  // Tai Le
  { begin: 6528, end: 6623 },
  // New Tai Lue
  { begin: 6656, end: 6687 },
  // Buginese
  { begin: 11264, end: 11359 },
  // Glagolitic
  { begin: 11568, end: 11647 },
  // Tifinagh
  { begin: 19904, end: 19967 },
  // Yijing Hexagram Symbols
  { begin: 43008, end: 43055 },
  // Syloti Nagri
  { begin: 65536, end: 65663 },
  // Linear B Syllabary
  { begin: 65856, end: 65935 },
  // Ancient Greek Numbers
  { begin: 66432, end: 66463 },
  // Ugaritic
  { begin: 66464, end: 66527 },
  // Old Persian
  { begin: 66640, end: 66687 },
  // Shavian
  { begin: 66688, end: 66735 },
  // Osmanya
  { begin: 67584, end: 67647 },
  // Cypriot Syllabary
  { begin: 68096, end: 68191 },
  // Kharoshthi
  { begin: 119552, end: 119647 },
  // Tai Xuan Jing Symbols
  { begin: 73728, end: 74751 },
  // Cuneiform
  { begin: 119648, end: 119679 },
  // Counting Rod Numerals
  { begin: 7040, end: 7103 },
  // Sundanese
  { begin: 7168, end: 7247 },
  // Lepcha
  { begin: 7248, end: 7295 },
  // Ol Chiki
  { begin: 43136, end: 43231 },
  // Saurashtra
  { begin: 43264, end: 43311 },
  // Kayah Li
  { begin: 43312, end: 43359 },
  // Rejang
  { begin: 43520, end: 43615 },
  // Cham
  { begin: 65936, end: 65999 },
  // Ancient Symbols
  { begin: 66e3, end: 66047 },
  // Phaistos Disc
  { begin: 66208, end: 66271 },
  // Carian
  { begin: 127024, end: 127135 }
  // Domino Tiles
];
function K9(r) {
  for (var e = 0; e < N1.length; e += 1) {
    var t = N1[e];
    if (r >= t.begin && r < t.end)
      return e;
  }
  return -1;
}
function Z9(r, e) {
  var t = {}, n = new Ut.Parser(r, e);
  t.version = n.parseUShort(), t.xAvgCharWidth = n.parseShort(), t.usWeightClass = n.parseUShort(), t.usWidthClass = n.parseUShort(), t.fsType = n.parseUShort(), t.ySubscriptXSize = n.parseShort(), t.ySubscriptYSize = n.parseShort(), t.ySubscriptXOffset = n.parseShort(), t.ySubscriptYOffset = n.parseShort(), t.ySuperscriptXSize = n.parseShort(), t.ySuperscriptYSize = n.parseShort(), t.ySuperscriptXOffset = n.parseShort(), t.ySuperscriptYOffset = n.parseShort(), t.yStrikeoutSize = n.parseShort(), t.yStrikeoutPosition = n.parseShort(), t.sFamilyClass = n.parseShort(), t.panose = [];
  for (var i = 0; i < 10; i++)
    t.panose[i] = n.parseByte();
  return t.ulUnicodeRange1 = n.parseULong(), t.ulUnicodeRange2 = n.parseULong(), t.ulUnicodeRange3 = n.parseULong(), t.ulUnicodeRange4 = n.parseULong(), t.achVendID = String.fromCharCode(n.parseByte(), n.parseByte(), n.parseByte(), n.parseByte()), t.fsSelection = n.parseUShort(), t.usFirstCharIndex = n.parseUShort(), t.usLastCharIndex = n.parseUShort(), t.sTypoAscender = n.parseShort(), t.sTypoDescender = n.parseShort(), t.sTypoLineGap = n.parseShort(), t.usWinAscent = n.parseUShort(), t.usWinDescent = n.parseUShort(), t.version >= 1 && (t.ulCodePageRange1 = n.parseULong(), t.ulCodePageRange2 = n.parseULong()), t.version >= 2 && (t.sxHeight = n.parseShort(), t.sCapHeight = n.parseShort(), t.usDefaultChar = n.parseUShort(), t.usBreakChar = n.parseUShort(), t.usMaxContent = n.parseUShort()), t;
}
function eV(r) {
  return new Dt.Table("OS/2", [
    { name: "version", type: "USHORT", value: 3 },
    { name: "xAvgCharWidth", type: "SHORT", value: 0 },
    { name: "usWeightClass", type: "USHORT", value: 0 },
    { name: "usWidthClass", type: "USHORT", value: 0 },
    { name: "fsType", type: "USHORT", value: 0 },
    { name: "ySubscriptXSize", type: "SHORT", value: 650 },
    { name: "ySubscriptYSize", type: "SHORT", value: 699 },
    { name: "ySubscriptXOffset", type: "SHORT", value: 0 },
    { name: "ySubscriptYOffset", type: "SHORT", value: 140 },
    { name: "ySuperscriptXSize", type: "SHORT", value: 650 },
    { name: "ySuperscriptYSize", type: "SHORT", value: 699 },
    { name: "ySuperscriptXOffset", type: "SHORT", value: 0 },
    { name: "ySuperscriptYOffset", type: "SHORT", value: 479 },
    { name: "yStrikeoutSize", type: "SHORT", value: 49 },
    { name: "yStrikeoutPosition", type: "SHORT", value: 258 },
    { name: "sFamilyClass", type: "SHORT", value: 0 },
    { name: "bFamilyType", type: "BYTE", value: 0 },
    { name: "bSerifStyle", type: "BYTE", value: 0 },
    { name: "bWeight", type: "BYTE", value: 0 },
    { name: "bProportion", type: "BYTE", value: 0 },
    { name: "bContrast", type: "BYTE", value: 0 },
    { name: "bStrokeVariation", type: "BYTE", value: 0 },
    { name: "bArmStyle", type: "BYTE", value: 0 },
    { name: "bLetterform", type: "BYTE", value: 0 },
    { name: "bMidline", type: "BYTE", value: 0 },
    { name: "bXHeight", type: "BYTE", value: 0 },
    { name: "ulUnicodeRange1", type: "ULONG", value: 0 },
    { name: "ulUnicodeRange2", type: "ULONG", value: 0 },
    { name: "ulUnicodeRange3", type: "ULONG", value: 0 },
    { name: "ulUnicodeRange4", type: "ULONG", value: 0 },
    { name: "achVendID", type: "CHARARRAY", value: "XXXX" },
    { name: "fsSelection", type: "USHORT", value: 0 },
    { name: "usFirstCharIndex", type: "USHORT", value: 0 },
    { name: "usLastCharIndex", type: "USHORT", value: 0 },
    { name: "sTypoAscender", type: "SHORT", value: 0 },
    { name: "sTypoDescender", type: "SHORT", value: 0 },
    { name: "sTypoLineGap", type: "SHORT", value: 0 },
    { name: "usWinAscent", type: "USHORT", value: 0 },
    { name: "usWinDescent", type: "USHORT", value: 0 },
    { name: "ulCodePageRange1", type: "ULONG", value: 0 },
    { name: "ulCodePageRange2", type: "ULONG", value: 0 },
    { name: "sxHeight", type: "SHORT", value: 0 },
    { name: "sCapHeight", type: "SHORT", value: 0 },
    { name: "usDefaultChar", type: "USHORT", value: 0 },
    { name: "usBreakChar", type: "USHORT", value: 0 },
    { name: "usMaxContext", type: "USHORT", value: 0 }
  ], r);
}
var L1 = { parse: Z9, make: eV, unicodeRanges: N1, getUnicodeRange: K9 };
function tV(r, e) {
  var t = {}, n = new Ut.Parser(r, e);
  switch (t.version = n.parseVersion(), t.italicAngle = n.parseFixed(), t.underlinePosition = n.parseShort(), t.underlineThickness = n.parseShort(), t.isFixedPitch = n.parseULong(), t.minMemType42 = n.parseULong(), t.maxMemType42 = n.parseULong(), t.minMemType1 = n.parseULong(), t.maxMemType1 = n.parseULong(), t.version) {
    case 1:
      t.names = kf.slice();
      break;
    case 2:
      t.numberOfGlyphs = n.parseUShort(), t.glyphNameIndex = new Array(t.numberOfGlyphs);
      for (var i = 0; i < t.numberOfGlyphs; i++)
        t.glyphNameIndex[i] = n.parseUShort();
      t.names = [];
      for (var a = 0; a < t.numberOfGlyphs; a++)
        if (t.glyphNameIndex[a] >= kf.length) {
          var s = n.parseChar();
          t.names.push(n.parseString(s));
        }
      break;
    case 2.5:
      t.numberOfGlyphs = n.parseUShort(), t.offset = new Array(t.numberOfGlyphs);
      for (var o = 0; o < t.numberOfGlyphs; o++)
        t.offset[o] = n.parseChar();
      break;
  }
  return t;
}
function rV() {
  return new Dt.Table("post", [
    { name: "version", type: "FIXED", value: 196608 },
    { name: "italicAngle", type: "FIXED", value: 0 },
    { name: "underlinePosition", type: "FWORD", value: 0 },
    { name: "underlineThickness", type: "FWORD", value: 0 },
    { name: "isFixedPitch", type: "ULONG", value: 0 },
    { name: "minMemType42", type: "ULONG", value: 0 },
    { name: "maxMemType42", type: "ULONG", value: 0 },
    { name: "minMemType1", type: "ULONG", value: 0 },
    { name: "maxMemType1", type: "ULONG", value: 0 }
  ]);
}
var KP = { parse: tV, make: rV }, Qo = new Array(9);
Qo[1] = function() {
  var e = this.offset + this.relativeOffset, t = this.parseUShort();
  if (t === 1)
    return {
      substFormat: 1,
      coverage: this.parsePointer(Be.coverage),
      deltaGlyphId: this.parseUShort()
    };
  if (t === 2)
    return {
      substFormat: 2,
      coverage: this.parsePointer(Be.coverage),
      substitute: this.parseOffset16List()
    };
  xr.assert(!1, "0x" + e.toString(16) + ": lookup type 1 format must be 1 or 2.");
};
Qo[2] = function() {
  var e = this.parseUShort();
  return xr.argument(e === 1, "GSUB Multiple Substitution Subtable identifier-format must be 1"), {
    substFormat: e,
    coverage: this.parsePointer(Be.coverage),
    sequences: this.parseListOfLists()
  };
};
Qo[3] = function() {
  var e = this.parseUShort();
  return xr.argument(e === 1, "GSUB Alternate Substitution Subtable identifier-format must be 1"), {
    substFormat: e,
    coverage: this.parsePointer(Be.coverage),
    alternateSets: this.parseListOfLists()
  };
};
Qo[4] = function() {
  var e = this.parseUShort();
  return xr.argument(e === 1, "GSUB ligature table identifier-format must be 1"), {
    substFormat: e,
    coverage: this.parsePointer(Be.coverage),
    ligatureSets: this.parseListOfLists(function() {
      return {
        ligGlyph: this.parseUShort(),
        components: this.parseUShortList(this.parseUShort() - 1)
      };
    })
  };
};
var Rd = {
  sequenceIndex: Be.uShort,
  lookupListIndex: Be.uShort
};
Qo[5] = function() {
  var e = this.offset + this.relativeOffset, t = this.parseUShort();
  if (t === 1)
    return {
      substFormat: t,
      coverage: this.parsePointer(Be.coverage),
      ruleSets: this.parseListOfLists(function() {
        var a = this.parseUShort(), s = this.parseUShort();
        return {
          input: this.parseUShortList(a - 1),
          lookupRecords: this.parseRecordList(s, Rd)
        };
      })
    };
  if (t === 2)
    return {
      substFormat: t,
      coverage: this.parsePointer(Be.coverage),
      classDef: this.parsePointer(Be.classDef),
      classSets: this.parseListOfLists(function() {
        var a = this.parseUShort(), s = this.parseUShort();
        return {
          classes: this.parseUShortList(a - 1),
          lookupRecords: this.parseRecordList(s, Rd)
        };
      })
    };
  if (t === 3) {
    var n = this.parseUShort(), i = this.parseUShort();
    return {
      substFormat: t,
      coverages: this.parseList(n, Be.pointer(Be.coverage)),
      lookupRecords: this.parseRecordList(i, Rd)
    };
  }
  xr.assert(!1, "0x" + e.toString(16) + ": lookup type 5 format must be 1, 2 or 3.");
};
Qo[6] = function() {
  var e = this.offset + this.relativeOffset, t = this.parseUShort();
  if (t === 1)
    return {
      substFormat: 1,
      coverage: this.parsePointer(Be.coverage),
      chainRuleSets: this.parseListOfLists(function() {
        return {
          backtrack: this.parseUShortList(),
          input: this.parseUShortList(this.parseShort() - 1),
          lookahead: this.parseUShortList(),
          lookupRecords: this.parseRecordList(Rd)
        };
      })
    };
  if (t === 2)
    return {
      substFormat: 2,
      coverage: this.parsePointer(Be.coverage),
      backtrackClassDef: this.parsePointer(Be.classDef),
      inputClassDef: this.parsePointer(Be.classDef),
      lookaheadClassDef: this.parsePointer(Be.classDef),
      chainClassSet: this.parseListOfLists(function() {
        return {
          backtrack: this.parseUShortList(),
          input: this.parseUShortList(this.parseShort() - 1),
          lookahead: this.parseUShortList(),
          lookupRecords: this.parseRecordList(Rd)
        };
      })
    };
  if (t === 3)
    return {
      substFormat: 3,
      backtrackCoverage: this.parseList(Be.pointer(Be.coverage)),
      inputCoverage: this.parseList(Be.pointer(Be.coverage)),
      lookaheadCoverage: this.parseList(Be.pointer(Be.coverage)),
      lookupRecords: this.parseRecordList(Rd)
    };
  xr.assert(!1, "0x" + e.toString(16) + ": lookup type 6 format must be 1, 2 or 3.");
};
Qo[7] = function() {
  var e = this.parseUShort();
  xr.argument(e === 1, "GSUB Extension Substitution subtable identifier-format must be 1");
  var t = this.parseUShort(), n = new Be(this.data, this.offset + this.parseULong());
  return {
    substFormat: 1,
    lookupType: t,
    extension: Qo[t].call(n)
  };
};
Qo[8] = function() {
  var e = this.parseUShort();
  return xr.argument(e === 1, "GSUB Reverse Chaining Contextual Single Substitution Subtable identifier-format must be 1"), {
    substFormat: e,
    coverage: this.parsePointer(Be.coverage),
    backtrackCoverage: this.parseList(Be.pointer(Be.coverage)),
    lookaheadCoverage: this.parseList(Be.pointer(Be.coverage)),
    substitutes: this.parseUShortList()
  };
};
function nV(r, e) {
  e = e || 0;
  var t = new Be(r, e), n = t.parseVersion(1);
  return xr.argument(n === 1 || n === 1.1, "Unsupported GSUB table version."), n === 1 ? {
    version: n,
    scripts: t.parseScriptList(),
    features: t.parseFeatureList(),
    lookups: t.parseLookupList(Qo)
  } : {
    version: n,
    scripts: t.parseScriptList(),
    features: t.parseFeatureList(),
    lookups: t.parseLookupList(Qo),
    variations: t.parseFeatureVariationsList()
  };
}
var ah = new Array(9);
ah[1] = function(e) {
  return e.substFormat === 1 ? new Dt.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 1 },
    { name: "coverage", type: "TABLE", value: new Dt.Coverage(e.coverage) },
    { name: "deltaGlyphID", type: "USHORT", value: e.deltaGlyphId }
  ]) : new Dt.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 2 },
    { name: "coverage", type: "TABLE", value: new Dt.Coverage(e.coverage) }
  ].concat(Dt.ushortList("substitute", e.substitute)));
};
ah[2] = function(e) {
  return xr.assert(e.substFormat === 1, "Lookup type 2 substFormat must be 1."), new Dt.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 1 },
    { name: "coverage", type: "TABLE", value: new Dt.Coverage(e.coverage) }
  ].concat(Dt.tableList("seqSet", e.sequences, function(t) {
    return new Dt.Table("sequenceSetTable", Dt.ushortList("sequence", t));
  })));
};
ah[3] = function(e) {
  return xr.assert(e.substFormat === 1, "Lookup type 3 substFormat must be 1."), new Dt.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 1 },
    { name: "coverage", type: "TABLE", value: new Dt.Coverage(e.coverage) }
  ].concat(Dt.tableList("altSet", e.alternateSets, function(t) {
    return new Dt.Table("alternateSetTable", Dt.ushortList("alternate", t));
  })));
};
ah[4] = function(e) {
  return xr.assert(e.substFormat === 1, "Lookup type 4 substFormat must be 1."), new Dt.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 1 },
    { name: "coverage", type: "TABLE", value: new Dt.Coverage(e.coverage) }
  ].concat(Dt.tableList("ligSet", e.ligatureSets, function(t) {
    return new Dt.Table("ligatureSetTable", Dt.tableList("ligature", t, function(n) {
      return new Dt.Table(
        "ligatureTable",
        [{ name: "ligGlyph", type: "USHORT", value: n.ligGlyph }].concat(Dt.ushortList("component", n.components, n.components.length + 1))
      );
    }));
  })));
};
ah[6] = function(e) {
  if (e.substFormat === 1) {
    var t = new Dt.Table("chainContextTable", [
      { name: "substFormat", type: "USHORT", value: e.substFormat },
      { name: "coverage", type: "TABLE", value: new Dt.Coverage(e.coverage) }
    ].concat(Dt.tableList("chainRuleSet", e.chainRuleSets, function(a) {
      return new Dt.Table("chainRuleSetTable", Dt.tableList("chainRule", a, function(s) {
        var o = Dt.ushortList("backtrackGlyph", s.backtrack, s.backtrack.length).concat(Dt.ushortList("inputGlyph", s.input, s.input.length + 1)).concat(Dt.ushortList("lookaheadGlyph", s.lookahead, s.lookahead.length)).concat(Dt.ushortList("substitution", [], s.lookupRecords.length));
        return s.lookupRecords.forEach(function(l, u) {
          o = o.concat({ name: "sequenceIndex" + u, type: "USHORT", value: l.sequenceIndex }).concat({ name: "lookupListIndex" + u, type: "USHORT", value: l.lookupListIndex });
        }), new Dt.Table("chainRuleTable", o);
      }));
    })));
    return t;
  } else if (e.substFormat === 2)
    xr.assert(!1, "lookup type 6 format 2 is not yet supported.");
  else if (e.substFormat === 3) {
    var n = [
      { name: "substFormat", type: "USHORT", value: e.substFormat }
    ];
    n.push({ name: "backtrackGlyphCount", type: "USHORT", value: e.backtrackCoverage.length }), e.backtrackCoverage.forEach(function(a, s) {
      n.push({ name: "backtrackCoverage" + s, type: "TABLE", value: new Dt.Coverage(a) });
    }), n.push({ name: "inputGlyphCount", type: "USHORT", value: e.inputCoverage.length }), e.inputCoverage.forEach(function(a, s) {
      n.push({ name: "inputCoverage" + s, type: "TABLE", value: new Dt.Coverage(a) });
    }), n.push({ name: "lookaheadGlyphCount", type: "USHORT", value: e.lookaheadCoverage.length }), e.lookaheadCoverage.forEach(function(a, s) {
      n.push({ name: "lookaheadCoverage" + s, type: "TABLE", value: new Dt.Coverage(a) });
    }), n.push({ name: "substitutionCount", type: "USHORT", value: e.lookupRecords.length }), e.lookupRecords.forEach(function(a, s) {
      n = n.concat({ name: "sequenceIndex" + s, type: "USHORT", value: a.sequenceIndex }).concat({ name: "lookupListIndex" + s, type: "USHORT", value: a.lookupListIndex });
    });
    var i = new Dt.Table("chainContextTable", n);
    return i;
  }
  xr.assert(!1, "lookup type 6 format must be 1, 2 or 3.");
};
function iV(r) {
  return new Dt.Table("GSUB", [
    { name: "version", type: "ULONG", value: 65536 },
    { name: "scripts", type: "TABLE", value: new Dt.ScriptList(r.scripts) },
    { name: "features", type: "TABLE", value: new Dt.FeatureList(r.features) },
    { name: "lookups", type: "TABLE", value: new Dt.LookupList(r.lookups, ah) }
  ]);
}
var ZP = { parse: nV, make: iV };
function aV(r, e) {
  var t = new Ut.Parser(r, e), n = t.parseULong();
  xr.argument(n === 1, "Unsupported META table version."), t.parseULong(), t.parseULong();
  for (var i = t.parseULong(), a = {}, s = 0; s < i; s++) {
    var o = t.parseTag(), l = t.parseULong(), u = t.parseULong(), c = Gd.UTF8(r, e + l, u);
    a[o] = c;
  }
  return a;
}
function sV(r) {
  var e = Object.keys(r).length, t = "", n = 16 + e * 12, i = new Dt.Table("meta", [
    { name: "version", type: "ULONG", value: 1 },
    { name: "flags", type: "ULONG", value: 0 },
    { name: "offset", type: "ULONG", value: n },
    { name: "numTags", type: "ULONG", value: e }
  ]);
  for (var a in r) {
    var s = t.length;
    t += r[a], i.fields.push({ name: "tag " + a, type: "TAG", value: a }), i.fields.push({ name: "offset " + a, type: "ULONG", value: n + s }), i.fields.push({ name: "length " + a, type: "ULONG", value: r[a].length });
  }
  return i.fields.push({ name: "stringPool", type: "CHARARRAY", value: t }), i;
}
var eD = { parse: aV, make: sV };
function $E(r) {
  return Math.log(r) / Math.log(2) | 0;
}
function rx(r) {
  for (; r.length % 4 !== 0; )
    r.push(0);
  for (var e = 0, t = 0; t < r.length; t += 4)
    e += (r[t] << 24) + (r[t + 1] << 16) + (r[t + 2] << 8) + r[t + 3];
  return e %= Math.pow(2, 32), e;
}
function zE(r, e, t, n) {
  return new Dt.Record("Table Record", [
    { name: "tag", type: "TAG", value: r !== void 0 ? r : "" },
    { name: "checkSum", type: "ULONG", value: e !== void 0 ? e : 0 },
    { name: "offset", type: "ULONG", value: t !== void 0 ? t : 0 },
    { name: "length", type: "ULONG", value: n !== void 0 ? n : 0 }
  ]);
}
function tD(r) {
  var e = new Dt.Table("sfnt", [
    { name: "version", type: "TAG", value: "OTTO" },
    { name: "numTables", type: "USHORT", value: 0 },
    { name: "searchRange", type: "USHORT", value: 0 },
    { name: "entrySelector", type: "USHORT", value: 0 },
    { name: "rangeShift", type: "USHORT", value: 0 }
  ]);
  e.tables = r, e.numTables = r.length;
  var t = Math.pow(2, $E(e.numTables));
  e.searchRange = 16 * t, e.entrySelector = $E(t), e.rangeShift = e.numTables * 16 - e.searchRange;
  for (var n = [], i = [], a = e.sizeOf() + zE().sizeOf() * e.numTables; a % 4 !== 0; )
    a += 1, i.push({ name: "padding", type: "BYTE", value: 0 });
  for (var s = 0; s < r.length; s += 1) {
    var o = r[s];
    xr.argument(o.tableName.length === 4, "Table name" + o.tableName + " is invalid.");
    var l = o.sizeOf(), u = zE(o.tableName, rx(o.encode()), a, l);
    for (n.push({ name: u.tag + " Table Record", type: "RECORD", value: u }), i.push({ name: o.tableName + " table", type: "RECORD", value: o }), a += l, xr.argument(!isNaN(a), "Something went wrong calculating the offset."); a % 4 !== 0; )
      a += 1, i.push({ name: "padding", type: "BYTE", value: 0 });
  }
  return n.sort(function(c, h) {
    return c.value.tag > h.value.tag ? 1 : -1;
  }), e.fields = e.fields.concat(n), e.fields = e.fields.concat(i), e;
}
function GE(r, e, t) {
  for (var n = 0; n < e.length; n += 1) {
    var i = r.charToGlyphIndex(e[n]);
    if (i > 0) {
      var a = r.glyphs.get(i);
      return a.getMetrics();
    }
  }
  return t;
}
function oV(r) {
  for (var e = 0, t = 0; t < r.length; t += 1)
    e += r[t];
  return e / r.length;
}
function lV(r) {
  for (var e = [], t = [], n = [], i = [], a = [], s = [], o = [], l, u = 0, c = 0, h = 0, f = 0, p = 0, m = 0; m < r.glyphs.length; m += 1) {
    var A = r.glyphs.get(m), w = A.unicode | 0;
    if (isNaN(A.advanceWidth))
      throw new Error("Glyph " + A.name + " (" + m + "): advanceWidth is not a number.");
    (l > w || l === void 0) && w > 0 && (l = w), u < w && (u = w);
    var x = L1.getUnicodeRange(w);
    if (x < 32)
      c |= 1 << x;
    else if (x < 64)
      h |= 1 << x - 32;
    else if (x < 96)
      f |= 1 << x - 64;
    else if (x < 123)
      p |= 1 << x - 96;
    else
      throw new Error("Unicode ranges bits > 123 are reserved for internal usage");
    if (A.name !== ".notdef") {
      var E = A.getMetrics();
      e.push(E.xMin), t.push(E.yMin), n.push(E.xMax), i.push(E.yMax), s.push(E.leftSideBearing), o.push(E.rightSideBearing), a.push(A.advanceWidth);
    }
  }
  var T = {
    xMin: Math.min.apply(null, e),
    yMin: Math.min.apply(null, t),
    xMax: Math.max.apply(null, n),
    yMax: Math.max.apply(null, i),
    advanceWidthMax: Math.max.apply(null, a),
    advanceWidthAvg: oV(a),
    minLeftSideBearing: Math.min.apply(null, s),
    maxLeftSideBearing: Math.max.apply(null, s),
    minRightSideBearing: Math.min.apply(null, o)
  };
  T.ascender = r.ascender, T.descender = r.descender;
  var D = zP.make({
    flags: 3,
    // 00000011 (baseline for font at y=0; left sidebearing point at x=0)
    unitsPerEm: r.unitsPerEm,
    xMin: T.xMin,
    yMin: T.yMin,
    xMax: T.xMax,
    yMax: T.yMax,
    lowestRecPPEM: 3,
    createdTimestamp: r.createdTimestamp
  }), F = GP.make({
    ascender: T.ascender,
    descender: T.descender,
    advanceWidthMax: T.advanceWidthMax,
    minLeftSideBearing: T.minLeftSideBearing,
    minRightSideBearing: T.minRightSideBearing,
    xMaxExtent: T.maxLeftSideBearing + (T.xMax - T.xMin),
    numberOfHMetrics: r.glyphs.length
  }), _ = jP.make(r.glyphs.length), L = L1.make(Object.assign({
    xAvgCharWidth: Math.round(T.advanceWidthAvg),
    usFirstCharIndex: l,
    usLastCharIndex: u,
    ulUnicodeRange1: c,
    ulUnicodeRange2: h,
    ulUnicodeRange3: f,
    ulUnicodeRange4: p,
    // See http://typophile.com/node/13081 for more info on vertical metrics.
    // We get metrics for typical characters (such as "x" for xHeight).
    // We provide some fallback characters if characters are unavailable: their
    // ordering was chosen experimentally.
    sTypoAscender: T.ascender,
    sTypoDescender: T.descender,
    sTypoLineGap: 0,
    usWinAscent: T.yMax,
    usWinDescent: Math.abs(T.yMin),
    ulCodePageRange1: 1,
    // FIXME: hard-code Latin 1 support for now
    sxHeight: GE(r, "xyvw", { yMax: Math.round(T.ascender / 2) }).yMax,
    sCapHeight: GE(r, "HIKLEFJMNTZBDPRAGOQSUVWXY", T).yMax,
    usDefaultChar: r.hasChar(" ") ? 32 : 0,
    // Use space as the default character, if available.
    usBreakChar: r.hasChar(" ") ? 32 : 0
    // Use space as the break character, if available.
  }, r.tables.os2)), Z = HP.make(r.glyphs), te = PP.make(r.glyphs), de = r.getEnglishName("fontFamily"), H = r.getEnglishName("fontSubfamily"), j = de + " " + H, q = r.getEnglishName("postScriptName");
  q || (q = de.replace(/\s/g, "") + "-" + H);
  var re = {};
  for (var ae in r.names)
    re[ae] = r.names[ae];
  re.uniqueID || (re.uniqueID = { en: r.getEnglishName("manufacturer") + ":" + j }), re.postScriptName || (re.postScriptName = { en: q }), re.preferredFamily || (re.preferredFamily = r.names.fontFamily), re.preferredSubfamily || (re.preferredSubfamily = r.names.fontSubfamily);
  var ye = [], Se = JP.make(re, ye), Xe = ye.length > 0 ? WP.make(ye) : void 0, Ve = KP.make(), He = $P.make(r.glyphs, {
    version: r.getEnglishName("version"),
    fullName: j,
    familyName: de,
    weightName: H,
    postScriptName: q,
    unitsPerEm: r.unitsPerEm,
    fontBBox: [0, T.yMin, T.ascender, T.advanceWidthMax]
  }), le = r.metas && Object.keys(r.metas).length > 0 ? eD.make(r.metas) : void 0, ve = [D, F, _, L, Se, te, Ve, He, Z];
  Xe && ve.push(Xe), r.tables.gsub && ve.push(ZP.make(r.tables.gsub)), le && ve.push(le);
  for (var it = tD(ve), mt = it.encode(), qe = rx(mt), at = it.fields, st = !1, lt = 0; lt < at.length; lt += 1)
    if (at[lt].name === "head table") {
      at[lt].value.checkSumAdjustment = 2981146554 - qe, st = !0;
      break;
    }
  if (!st)
    throw new Error("Could not find head table with checkSum to adjust.");
  return it;
}
var uV = { make: tD, fontToTable: lV, computeCheckSum: rx };
function cy(r, e) {
  for (var t = 0, n = r.length - 1; t <= n; ) {
    var i = t + n >>> 1, a = r[i].tag;
    if (a === e)
      return i;
    a < e ? t = i + 1 : n = i - 1;
  }
  return -t - 1;
}
function HE(r, e) {
  for (var t = 0, n = r.length - 1; t <= n; ) {
    var i = t + n >>> 1, a = r[i];
    if (a === e)
      return i;
    a < e ? t = i + 1 : n = i - 1;
  }
  return -t - 1;
}
function WE(r, e) {
  for (var t, n = 0, i = r.length - 1; n <= i; ) {
    var a = n + i >>> 1;
    t = r[a];
    var s = t.start;
    if (s === e)
      return t;
    s < e ? n = a + 1 : i = a - 1;
  }
  if (n > 0)
    return t = r[n - 1], e > t.end ? 0 : t;
}
function mg(r, e) {
  this.font = r, this.tableName = e;
}
mg.prototype = {
  /**
   * Binary search an object by "tag" property
   * @instance
   * @function searchTag
   * @memberof opentype.Layout
   * @param  {Array} arr
   * @param  {string} tag
   * @return {number}
   */
  searchTag: cy,
  /**
   * Binary search in a list of numbers
   * @instance
   * @function binSearch
   * @memberof opentype.Layout
   * @param  {Array} arr
   * @param  {number} value
   * @return {number}
   */
  binSearch: HE,
  /**
   * Get or create the Layout table (GSUB, GPOS etc).
   * @param  {boolean} create - Whether to create a new one.
   * @return {Object} The GSUB or GPOS table.
   */
  getTable: function(r) {
    var e = this.font.tables[this.tableName];
    return !e && r && (e = this.font.tables[this.tableName] = this.createDefaultTable()), e;
  },
  /**
   * Returns all scripts in the substitution table.
   * @instance
   * @return {Array}
   */
  getScriptNames: function() {
    var r = this.getTable();
    return r ? r.scripts.map(function(e) {
      return e.tag;
    }) : [];
  },
  /**
   * Returns the best bet for a script name.
   * Returns 'DFLT' if it exists.
   * If not, returns 'latn' if it exists.
   * If neither exist, returns undefined.
   */
  getDefaultScriptName: function() {
    var r = this.getTable();
    if (r) {
      for (var e = !1, t = 0; t < r.scripts.length; t++) {
        var n = r.scripts[t].tag;
        if (n === "DFLT")
          return n;
        n === "latn" && (e = !0);
      }
      if (e)
        return "latn";
    }
  },
  /**
   * Returns all LangSysRecords in the given script.
   * @instance
   * @param {string} [script='DFLT']
   * @param {boolean} create - forces the creation of this script table if it doesn't exist.
   * @return {Object} An object with tag and script properties.
   */
  getScriptTable: function(r, e) {
    var t = this.getTable(e);
    if (t) {
      r = r || "DFLT";
      var n = t.scripts, i = cy(t.scripts, r);
      if (i >= 0)
        return n[i].script;
      if (e) {
        var a = {
          tag: r,
          script: {
            defaultLangSys: { reserved: 0, reqFeatureIndex: 65535, featureIndexes: [] },
            langSysRecords: []
          }
        };
        return n.splice(-1 - i, 0, a), a.script;
      }
    }
  },
  /**
   * Returns a language system table
   * @instance
   * @param {string} [script='DFLT']
   * @param {string} [language='dlft']
   * @param {boolean} create - forces the creation of this langSysTable if it doesn't exist.
   * @return {Object}
   */
  getLangSysTable: function(r, e, t) {
    var n = this.getScriptTable(r, t);
    if (n) {
      if (!e || e === "dflt" || e === "DFLT")
        return n.defaultLangSys;
      var i = cy(n.langSysRecords, e);
      if (i >= 0)
        return n.langSysRecords[i].langSys;
      if (t) {
        var a = {
          tag: e,
          langSys: { reserved: 0, reqFeatureIndex: 65535, featureIndexes: [] }
        };
        return n.langSysRecords.splice(-1 - i, 0, a), a.langSys;
      }
    }
  },
  /**
   * Get a specific feature table.
   * @instance
   * @param {string} [script='DFLT']
   * @param {string} [language='dlft']
   * @param {string} feature - One of the codes listed at https://www.microsoft.com/typography/OTSPEC/featurelist.htm
   * @param {boolean} create - forces the creation of the feature table if it doesn't exist.
   * @return {Object}
   */
  getFeatureTable: function(r, e, t, n) {
    var i = this.getLangSysTable(r, e, n);
    if (i) {
      for (var a, s = i.featureIndexes, o = this.font.tables[this.tableName].features, l = 0; l < s.length; l++)
        if (a = o[s[l]], a.tag === t)
          return a.feature;
      if (n) {
        var u = o.length;
        return xr.assert(u === 0 || t >= o[u - 1].tag, "Features must be added in alphabetical order."), a = {
          tag: t,
          feature: { params: 0, lookupListIndexes: [] }
        }, o.push(a), s.push(u), a.feature;
      }
    }
  },
  /**
   * Get the lookup tables of a given type for a script/language/feature.
   * @instance
   * @param {string} [script='DFLT']
   * @param {string} [language='dlft']
   * @param {string} feature - 4-letter feature code
   * @param {number} lookupType - 1 to 9
   * @param {boolean} create - forces the creation of the lookup table if it doesn't exist, with no subtables.
   * @return {Object[]}
   */
  getLookupTables: function(r, e, t, n, i) {
    var a = this.getFeatureTable(r, e, t, i), s = [];
    if (a) {
      for (var o, l = a.lookupListIndexes, u = this.font.tables[this.tableName].lookups, c = 0; c < l.length; c++)
        o = u[l[c]], o.lookupType === n && s.push(o);
      if (s.length === 0 && i) {
        o = {
          lookupType: n,
          lookupFlag: 0,
          subtables: [],
          markFilteringSet: void 0
        };
        var h = u.length;
        return u.push(o), l.push(h), [o];
      }
    }
    return s;
  },
  /**
   * Find a glyph in a class definition table
   * https://docs.microsoft.com/en-us/typography/opentype/spec/chapter2#class-definition-table
   * @param {object} classDefTable - an OpenType Layout class definition table
   * @param {number} glyphIndex - the index of the glyph to find
   * @returns {number} -1 if not found
   */
  getGlyphClass: function(r, e) {
    switch (r.format) {
      case 1:
        return r.startGlyph <= e && e < r.startGlyph + r.classes.length ? r.classes[e - r.startGlyph] : 0;
      case 2:
        var t = WE(r.ranges, e);
        return t ? t.classId : 0;
    }
  },
  /**
   * Find a glyph in a coverage table
   * https://docs.microsoft.com/en-us/typography/opentype/spec/chapter2#coverage-table
   * @param {object} coverageTable - an OpenType Layout coverage table
   * @param {number} glyphIndex - the index of the glyph to find
   * @returns {number} -1 if not found
   */
  getCoverageIndex: function(r, e) {
    switch (r.format) {
      case 1:
        var t = HE(r.glyphs, e);
        return t >= 0 ? t : -1;
      case 2:
        var n = WE(r.ranges, e);
        return n ? n.index + e - n.start : -1;
    }
  },
  /**
   * Returns the list of glyph indexes of a coverage table.
   * Format 1: the list is stored raw
   * Format 2: compact list as range records.
   * @instance
   * @param  {Object} coverageTable
   * @return {Array}
   */
  expandCoverage: function(r) {
    if (r.format === 1)
      return r.glyphs;
    for (var e = [], t = r.ranges, n = 0; n < t.length; n++)
      for (var i = t[n], a = i.start, s = i.end, o = a; o <= s; o++)
        e.push(o);
    return e;
  }
};
function vg(r) {
  mg.call(this, r, "gpos");
}
vg.prototype = mg.prototype;
vg.prototype.init = function() {
  var r = this.getDefaultScriptName();
  this.defaultKerningTables = this.getKerningTables(r);
};
vg.prototype.getKerningValue = function(r, e, t) {
  for (var n = 0; n < r.length; n++)
    for (var i = r[n].subtables, a = 0; a < i.length; a++) {
      var s = i[a], o = this.getCoverageIndex(s.coverage, e);
      if (!(o < 0))
        switch (s.posFormat) {
          case 1:
            for (var l = s.pairSets[o], u = 0; u < l.length; u++) {
              var c = l[u];
              if (c.secondGlyph === t)
                return c.value1 && c.value1.xAdvance || 0;
            }
            break;
          // left glyph found, not right glyph - try next subtable
          case 2:
            var h = this.getGlyphClass(s.classDef1, e), f = this.getGlyphClass(s.classDef2, t), p = s.classRecords[h][f];
            return p.value1 && p.value1.xAdvance || 0;
        }
    }
  return 0;
};
vg.prototype.getKerningTables = function(r, e) {
  if (this.font.tables.gpos)
    return this.getLookupTables(r, e, "kern", 2);
};
function Js(r) {
  mg.call(this, r, "gsub");
}
function cV(r, e) {
  var t = r.length;
  if (t !== e.length)
    return !1;
  for (var n = 0; n < t; n++)
    if (r[n] !== e[n])
      return !1;
  return !0;
}
function nx(r, e, t) {
  for (var n = r.subtables, i = 0; i < n.length; i++) {
    var a = n[i];
    if (a.substFormat === e)
      return a;
  }
  if (t)
    return n.push(t), t;
}
Js.prototype = mg.prototype;
Js.prototype.createDefaultTable = function() {
  return {
    version: 1,
    scripts: [{
      tag: "DFLT",
      script: {
        defaultLangSys: { reserved: 0, reqFeatureIndex: 65535, featureIndexes: [] },
        langSysRecords: []
      }
    }],
    features: [],
    lookups: []
  };
};
Js.prototype.getSingle = function(r, e, t) {
  for (var n = [], i = this.getLookupTables(e, t, r, 1), a = 0; a < i.length; a++)
    for (var s = i[a].subtables, o = 0; o < s.length; o++) {
      var l = s[o], u = this.expandCoverage(l.coverage), c = void 0;
      if (l.substFormat === 1) {
        var h = l.deltaGlyphId;
        for (c = 0; c < u.length; c++) {
          var f = u[c];
          n.push({ sub: f, by: f + h });
        }
      } else {
        var p = l.substitute;
        for (c = 0; c < u.length; c++)
          n.push({ sub: u[c], by: p[c] });
      }
    }
  return n;
};
Js.prototype.getMultiple = function(r, e, t) {
  for (var n = [], i = this.getLookupTables(e, t, r, 2), a = 0; a < i.length; a++)
    for (var s = i[a].subtables, o = 0; o < s.length; o++) {
      var l = s[o], u = this.expandCoverage(l.coverage), c = void 0;
      for (c = 0; c < u.length; c++) {
        var h = u[c], f = l.sequences[c];
        n.push({ sub: h, by: f });
      }
    }
  return n;
};
Js.prototype.getAlternates = function(r, e, t) {
  for (var n = [], i = this.getLookupTables(e, t, r, 3), a = 0; a < i.length; a++)
    for (var s = i[a].subtables, o = 0; o < s.length; o++)
      for (var l = s[o], u = this.expandCoverage(l.coverage), c = l.alternateSets, h = 0; h < u.length; h++)
        n.push({ sub: u[h], by: c[h] });
  return n;
};
Js.prototype.getLigatures = function(r, e, t) {
  for (var n = [], i = this.getLookupTables(e, t, r, 4), a = 0; a < i.length; a++)
    for (var s = i[a].subtables, o = 0; o < s.length; o++)
      for (var l = s[o], u = this.expandCoverage(l.coverage), c = l.ligatureSets, h = 0; h < u.length; h++)
        for (var f = u[h], p = c[h], m = 0; m < p.length; m++) {
          var A = p[m];
          n.push({
            sub: [f].concat(A.components),
            by: A.ligGlyph
          });
        }
  return n;
};
Js.prototype.addSingle = function(r, e, t, n) {
  var i = this.getLookupTables(t, n, r, 1, !0)[0], a = nx(i, 2, {
    // lookup type 1 subtable, format 2, coverage format 1
    substFormat: 2,
    coverage: { format: 1, glyphs: [] },
    substitute: []
  });
  xr.assert(a.coverage.format === 1, "Single: unable to modify coverage table format " + a.coverage.format);
  var s = e.sub, o = this.binSearch(a.coverage.glyphs, s);
  o < 0 && (o = -1 - o, a.coverage.glyphs.splice(o, 0, s), a.substitute.splice(o, 0, 0)), a.substitute[o] = e.by;
};
Js.prototype.addMultiple = function(r, e, t, n) {
  xr.assert(e.by instanceof Array && e.by.length > 1, 'Multiple: "by" must be an array of two or more ids');
  var i = this.getLookupTables(t, n, r, 2, !0)[0], a = nx(i, 1, {
    // lookup type 2 subtable, format 1, coverage format 1
    substFormat: 1,
    coverage: { format: 1, glyphs: [] },
    sequences: []
  });
  xr.assert(a.coverage.format === 1, "Multiple: unable to modify coverage table format " + a.coverage.format);
  var s = e.sub, o = this.binSearch(a.coverage.glyphs, s);
  o < 0 && (o = -1 - o, a.coverage.glyphs.splice(o, 0, s), a.sequences.splice(o, 0, 0)), a.sequences[o] = e.by;
};
Js.prototype.addAlternate = function(r, e, t, n) {
  var i = this.getLookupTables(t, n, r, 3, !0)[0], a = nx(i, 1, {
    // lookup type 3 subtable, format 1, coverage format 1
    substFormat: 1,
    coverage: { format: 1, glyphs: [] },
    alternateSets: []
  });
  xr.assert(a.coverage.format === 1, "Alternate: unable to modify coverage table format " + a.coverage.format);
  var s = e.sub, o = this.binSearch(a.coverage.glyphs, s);
  o < 0 && (o = -1 - o, a.coverage.glyphs.splice(o, 0, s), a.alternateSets.splice(o, 0, 0)), a.alternateSets[o] = e.by;
};
Js.prototype.addLigature = function(r, e, t, n) {
  var i = this.getLookupTables(t, n, r, 4, !0)[0], a = i.subtables[0];
  a || (a = {
    // lookup type 4 subtable, format 1, coverage format 1
    substFormat: 1,
    coverage: { format: 1, glyphs: [] },
    ligatureSets: []
  }, i.subtables[0] = a), xr.assert(a.coverage.format === 1, "Ligature: unable to modify coverage table format " + a.coverage.format);
  var s = e.sub[0], o = e.sub.slice(1), l = {
    ligGlyph: e.by,
    components: o
  }, u = this.binSearch(a.coverage.glyphs, s);
  if (u >= 0) {
    for (var c = a.ligatureSets[u], h = 0; h < c.length; h++)
      if (cV(c[h].components, o))
        return;
    c.push(l);
  } else
    u = -1 - u, a.coverage.glyphs.splice(u, 0, s), a.ligatureSets.splice(u, 0, [l]);
};
Js.prototype.getFeature = function(r, e, t) {
  if (/ss\d\d/.test(r))
    return this.getSingle(r, e, t);
  switch (r) {
    case "aalt":
    case "salt":
      return this.getSingle(r, e, t).concat(this.getAlternates(r, e, t));
    case "dlig":
    case "liga":
    case "rlig":
      return this.getLigatures(r, e, t);
    case "ccmp":
      return this.getMultiple(r, e, t).concat(this.getLigatures(r, e, t));
    case "stch":
      return this.getMultiple(r, e, t);
  }
};
Js.prototype.add = function(r, e, t, n) {
  if (/ss\d\d/.test(r))
    return this.addSingle(r, e, t, n);
  switch (r) {
    case "aalt":
    case "salt":
      return typeof e.by == "number" ? this.addSingle(r, e, t, n) : this.addAlternate(r, e, t, n);
    case "dlig":
    case "liga":
    case "rlig":
      return this.addLigature(r, e, t, n);
    case "ccmp":
      return e.by instanceof Array ? this.addMultiple(r, e, t, n) : this.addLigature(r, e, t, n);
  }
};
function fV() {
  return typeof window < "u";
}
function dV(r) {
  for (var e = new Buffer(r.byteLength), t = new Uint8Array(r), n = 0; n < e.length; ++n)
    e[n] = t[n];
  return e;
}
function qh(r, e) {
  if (!r)
    throw e;
}
function jE(r, e, t, n, i) {
  var a;
  return (e & n) > 0 ? (a = r.parseByte(), (e & i) === 0 && (a = -a), a = t + a) : (e & i) > 0 ? a = t : a = t + r.parseShort(), a;
}
function rD(r, e, t) {
  var n = new Ut.Parser(e, t);
  r.numberOfContours = n.parseShort(), r._xMin = n.parseShort(), r._yMin = n.parseShort(), r._xMax = n.parseShort(), r._yMax = n.parseShort();
  var i, a;
  if (r.numberOfContours > 0) {
    for (var s = r.endPointIndices = [], o = 0; o < r.numberOfContours; o += 1)
      s.push(n.parseUShort());
    r.instructionLength = n.parseUShort(), r.instructions = [];
    for (var l = 0; l < r.instructionLength; l += 1)
      r.instructions.push(n.parseByte());
    var u = s[s.length - 1] + 1;
    i = [];
    for (var c = 0; c < u; c += 1)
      if (a = n.parseByte(), i.push(a), (a & 8) > 0)
        for (var h = n.parseByte(), f = 0; f < h; f += 1)
          i.push(a), c += 1;
    if (xr.argument(i.length === u, "Bad flags."), s.length > 0) {
      var p = [], m;
      if (u > 0) {
        for (var A = 0; A < u; A += 1)
          a = i[A], m = {}, m.onCurve = !!(a & 1), m.lastPointOfContour = s.indexOf(A) >= 0, p.push(m);
        for (var w = 0, x = 0; x < u; x += 1)
          a = i[x], m = p[x], m.x = jE(n, a, w, 2, 16), w = m.x;
        for (var E = 0, T = 0; T < u; T += 1)
          a = i[T], m = p[T], m.y = jE(n, a, E, 4, 32), E = m.y;
      }
      r.points = p;
    } else
      r.points = [];
  } else if (r.numberOfContours === 0)
    r.points = [];
  else {
    r.isComposite = !0, r.points = [], r.components = [];
    for (var D = !0; D; ) {
      i = n.parseUShort();
      var F = {
        glyphIndex: n.parseUShort(),
        xScale: 1,
        scale01: 0,
        scale10: 0,
        yScale: 1,
        dx: 0,
        dy: 0
      };
      (i & 1) > 0 ? (i & 2) > 0 ? (F.dx = n.parseShort(), F.dy = n.parseShort()) : F.matchedPoints = [n.parseUShort(), n.parseUShort()] : (i & 2) > 0 ? (F.dx = n.parseChar(), F.dy = n.parseChar()) : F.matchedPoints = [n.parseByte(), n.parseByte()], (i & 8) > 0 ? F.xScale = F.yScale = n.parseF2Dot14() : (i & 64) > 0 ? (F.xScale = n.parseF2Dot14(), F.yScale = n.parseF2Dot14()) : (i & 128) > 0 && (F.xScale = n.parseF2Dot14(), F.scale01 = n.parseF2Dot14(), F.scale10 = n.parseF2Dot14(), F.yScale = n.parseF2Dot14()), r.components.push(F), D = !!(i & 32);
    }
    if (i & 256) {
      r.instructionLength = n.parseUShort(), r.instructions = [];
      for (var _ = 0; _ < r.instructionLength; _ += 1)
        r.instructions.push(n.parseByte());
    }
  }
}
function fy(r, e) {
  for (var t = [], n = 0; n < r.length; n += 1) {
    var i = r[n], a = {
      x: e.xScale * i.x + e.scale01 * i.y + e.dx,
      y: e.scale10 * i.x + e.yScale * i.y + e.dy,
      onCurve: i.onCurve,
      lastPointOfContour: i.lastPointOfContour
    };
    t.push(a);
  }
  return t;
}
function hV(r) {
  for (var e = [], t = [], n = 0; n < r.length; n += 1) {
    var i = r[n];
    t.push(i), i.lastPointOfContour && (e.push(t), t = []);
  }
  return xr.argument(t.length === 0, "There are still points left in the current contour."), e;
}
function nD(r) {
  var e = new ha();
  if (!r)
    return e;
  for (var t = hV(r), n = 0; n < t.length; ++n) {
    var i = t[n], a = null, s = i[i.length - 1], o = i[0];
    if (s.onCurve)
      e.moveTo(s.x, s.y);
    else if (o.onCurve)
      e.moveTo(o.x, o.y);
    else {
      var l = { x: (s.x + o.x) * 0.5, y: (s.y + o.y) * 0.5 };
      e.moveTo(l.x, l.y);
    }
    for (var u = 0; u < i.length; ++u)
      if (a = s, s = o, o = i[(u + 1) % i.length], s.onCurve)
        e.lineTo(s.x, s.y);
      else {
        var c = o;
        a.onCurve || ((s.x + a.x) * 0.5, (s.y + a.y) * 0.5), o.onCurve || (c = { x: (s.x + o.x) * 0.5, y: (s.y + o.y) * 0.5 }), e.quadraticCurveTo(s.x, s.y, c.x, c.y);
      }
    e.closePath();
  }
  return e;
}
function iD(r, e) {
  if (e.isComposite)
    for (var t = 0; t < e.components.length; t += 1) {
      var n = e.components[t], i = r.get(n.glyphIndex);
      if (i.getPath(), i.points) {
        var a = void 0;
        if (n.matchedPoints === void 0)
          a = fy(i.points, n);
        else {
          if (n.matchedPoints[0] > e.points.length - 1 || n.matchedPoints[1] > i.points.length - 1)
            throw Error("Matched points out of range in " + e.name);
          var s = e.points[n.matchedPoints[0]], o = i.points[n.matchedPoints[1]], l = {
            xScale: n.xScale,
            scale01: n.scale01,
            scale10: n.scale10,
            yScale: n.yScale,
            dx: 0,
            dy: 0
          };
          o = fy([o], l)[0], l.dx = s.x - o.x, l.dy = s.y - o.y, a = fy(i.points, l);
        }
        e.points = e.points.concat(a);
      }
    }
  return nD(e.points);
}
function pV(r, e, t, n) {
  for (var i = new _l.GlyphSet(n), a = 0; a < t.length - 1; a += 1) {
    var s = t[a], o = t[a + 1];
    s !== o ? i.push(a, _l.ttfGlyphLoader(n, a, rD, r, e + s, iD)) : i.push(a, _l.glyphLoader(n, a));
  }
  return i;
}
function gV(r, e, t, n) {
  var i = new _l.GlyphSet(n);
  return n._push = function(a) {
    var s = t[a], o = t[a + 1];
    s !== o ? i.push(a, _l.ttfGlyphLoader(n, a, rD, r, e + s, iD)) : i.push(a, _l.glyphLoader(n, a));
  }, i;
}
function mV(r, e, t, n, i) {
  return i.lowMemory ? gV(r, e, t, n) : pV(r, e, t, n);
}
var aD = { getPath: nD, parse: mV }, sD, Nf, oD, U1;
function lD(r) {
  this.font = r, this.getCommands = function(e) {
    return aD.getPath(e).commands;
  }, this._fpgmState = this._prepState = void 0, this._errorState = 0;
}
function vV(r) {
  return r;
}
function uD(r) {
  return Math.sign(r) * Math.round(Math.abs(r));
}
function yV(r) {
  return Math.sign(r) * Math.round(Math.abs(r * 2)) / 2;
}
function AV(r) {
  return Math.sign(r) * (Math.round(Math.abs(r) + 0.5) - 0.5);
}
function wV(r) {
  return Math.sign(r) * Math.ceil(Math.abs(r));
}
function xV(r) {
  return Math.sign(r) * Math.floor(Math.abs(r));
}
var cD = function(r) {
  var e = this.srPeriod, t = this.srPhase, n = this.srThreshold, i = 1;
  return r < 0 && (r = -r, i = -1), r += n - t, r = Math.trunc(r / e) * e, r += t, r < 0 ? t * i : r * i;
}, Rl = {
  x: 1,
  y: 0,
  axis: "x",
  // Gets the projected distance between two points.
  // o1/o2 ... if true, respective original position is used.
  distance: function(r, e, t, n) {
    return (t ? r.xo : r.x) - (n ? e.xo : e.x);
  },
  // Moves point p so the moved position has the same relative
  // position to the moved positions of rp1 and rp2 than the
  // original positions had.
  //
  // See APPENDIX on INTERPOLATE at the bottom of this file.
  interpolate: function(r, e, t, n) {
    var i, a, s, o, l, u, c;
    if (!n || n === this) {
      if (i = r.xo - e.xo, a = r.xo - t.xo, l = e.x - e.xo, u = t.x - t.xo, s = Math.abs(i), o = Math.abs(a), c = s + o, c === 0) {
        r.x = r.xo + (l + u) / 2;
        return;
      }
      r.x = r.xo + (l * o + u * s) / c;
      return;
    }
    if (i = n.distance(r, e, !0, !0), a = n.distance(r, t, !0, !0), l = n.distance(e, e, !1, !0), u = n.distance(t, t, !1, !0), s = Math.abs(i), o = Math.abs(a), c = s + o, c === 0) {
      Rl.setRelative(r, r, (l + u) / 2, n, !0);
      return;
    }
    Rl.setRelative(r, r, (l * o + u * s) / c, n, !0);
  },
  // Slope of line normal to this
  normalSlope: Number.NEGATIVE_INFINITY,
  // Sets the point 'p' relative to point 'rp'
  // by the distance 'd'.
  //
  // See APPENDIX on SETRELATIVE at the bottom of this file.
  //
  // p   ... point to set
  // rp  ... reference point
  // d   ... distance on projection vector
  // pv  ... projection vector (undefined = this)
  // org ... if true, uses the original position of rp as reference.
  setRelative: function(r, e, t, n, i) {
    if (!n || n === this) {
      r.x = (i ? e.xo : e.x) + t;
      return;
    }
    var a = i ? e.xo : e.x, s = i ? e.yo : e.y, o = a + t * n.x, l = s + t * n.y;
    r.x = o + (r.y - l) / n.normalSlope;
  },
  // Slope of vector line.
  slope: 0,
  // Touches the point p.
  touch: function(r) {
    r.xTouched = !0;
  },
  // Tests if a point p is touched.
  touched: function(r) {
    return r.xTouched;
  },
  // Untouches the point p.
  untouch: function(r) {
    r.xTouched = !1;
  }
}, bu = {
  x: 0,
  y: 1,
  axis: "y",
  // Gets the projected distance between two points.
  // o1/o2 ... if true, respective original position is used.
  distance: function(r, e, t, n) {
    return (t ? r.yo : r.y) - (n ? e.yo : e.y);
  },
  // Moves point p so the moved position has the same relative
  // position to the moved positions of rp1 and rp2 than the
  // original positions had.
  //
  // See APPENDIX on INTERPOLATE at the bottom of this file.
  interpolate: function(r, e, t, n) {
    var i, a, s, o, l, u, c;
    if (!n || n === this) {
      if (i = r.yo - e.yo, a = r.yo - t.yo, l = e.y - e.yo, u = t.y - t.yo, s = Math.abs(i), o = Math.abs(a), c = s + o, c === 0) {
        r.y = r.yo + (l + u) / 2;
        return;
      }
      r.y = r.yo + (l * o + u * s) / c;
      return;
    }
    if (i = n.distance(r, e, !0, !0), a = n.distance(r, t, !0, !0), l = n.distance(e, e, !1, !0), u = n.distance(t, t, !1, !0), s = Math.abs(i), o = Math.abs(a), c = s + o, c === 0) {
      bu.setRelative(r, r, (l + u) / 2, n, !0);
      return;
    }
    bu.setRelative(r, r, (l * o + u * s) / c, n, !0);
  },
  // Slope of line normal to this.
  normalSlope: 0,
  // Sets the point 'p' relative to point 'rp'
  // by the distance 'd'
  //
  // See APPENDIX on SETRELATIVE at the bottom of this file.
  //
  // p   ... point to set
  // rp  ... reference point
  // d   ... distance on projection vector
  // pv  ... projection vector (undefined = this)
  // org ... if true, uses the original position of rp as reference.
  setRelative: function(r, e, t, n, i) {
    if (!n || n === this) {
      r.y = (i ? e.yo : e.y) + t;
      return;
    }
    var a = i ? e.xo : e.x, s = i ? e.yo : e.y, o = a + t * n.x, l = s + t * n.y;
    r.y = l + n.normalSlope * (r.x - o);
  },
  // Slope of vector line.
  slope: Number.POSITIVE_INFINITY,
  // Touches the point p.
  touch: function(r) {
    r.yTouched = !0;
  },
  // Tests if a point p is touched.
  touched: function(r) {
    return r.yTouched;
  },
  // Untouches the point p.
  untouch: function(r) {
    r.yTouched = !1;
  }
};
Object.freeze(Rl);
Object.freeze(bu);
function yg(r, e) {
  this.x = r, this.y = e, this.axis = void 0, this.slope = e / r, this.normalSlope = -r / e, Object.freeze(this);
}
yg.prototype.distance = function(r, e, t, n) {
  return this.x * Rl.distance(r, e, t, n) + this.y * bu.distance(r, e, t, n);
};
yg.prototype.interpolate = function(r, e, t, n) {
  var i, a, s, o, l, u, c;
  if (s = n.distance(r, e, !0, !0), o = n.distance(r, t, !0, !0), i = n.distance(e, e, !1, !0), a = n.distance(t, t, !1, !0), l = Math.abs(s), u = Math.abs(o), c = l + u, c === 0) {
    this.setRelative(r, r, (i + a) / 2, n, !0);
    return;
  }
  this.setRelative(r, r, (i * u + a * l) / c, n, !0);
};
yg.prototype.setRelative = function(r, e, t, n, i) {
  n = n || this;
  var a = i ? e.xo : e.x, s = i ? e.yo : e.y, o = a + t * n.x, l = s + t * n.y, u = n.normalSlope, c = this.slope, h = r.x, f = r.y;
  r.x = (c * h - u * o + l - f) / (c - u), r.y = c * (r.x - h) + f;
};
yg.prototype.touch = function(r) {
  r.xTouched = !0, r.yTouched = !0;
};
function Ag(r, e) {
  var t = Math.sqrt(r * r + e * e);
  return r /= t, e /= t, r === 1 && e === 0 ? Rl : r === 0 && e === 1 ? bu : new yg(r, e);
}
function Eu(r, e, t, n) {
  this.x = this.xo = Math.round(r * 64) / 64, this.y = this.yo = Math.round(e * 64) / 64, this.lastPointOfContour = t, this.onCurve = n, this.prevPointOnContour = void 0, this.nextPointOnContour = void 0, this.xTouched = !1, this.yTouched = !1, Object.preventExtensions(this);
}
Eu.prototype.nextTouched = function(r) {
  for (var e = this.nextPointOnContour; !r.touched(e) && e !== this; )
    e = e.nextPointOnContour;
  return e;
};
Eu.prototype.prevTouched = function(r) {
  for (var e = this.prevPointOnContour; !r.touched(e) && e !== this; )
    e = e.prevPointOnContour;
  return e;
};
var Xp = Object.freeze(new Eu(0, 0)), bV = {
  cvCutIn: 17 / 16,
  // control value cut in
  deltaBase: 9,
  deltaShift: 0.125,
  loop: 1,
  // loops some instructions
  minDis: 1,
  // minimum distance
  autoFlip: !0
};
function Ac(r, e) {
  switch (this.env = r, this.stack = [], this.prog = e, r) {
    case "glyf":
      this.zp0 = this.zp1 = this.zp2 = 1, this.rp0 = this.rp1 = this.rp2 = 0;
    /* fall through */
    case "prep":
      this.fv = this.pv = this.dpv = Rl, this.round = uD;
  }
}
lD.prototype.exec = function(r, e) {
  if (typeof e != "number")
    throw new Error("Point size is not a number!");
  if (!(this._errorState > 2)) {
    var t = this.font, n = this._prepState;
    if (!n || n.ppem !== e) {
      var i = this._fpgmState;
      if (!i) {
        Ac.prototype = bV, i = this._fpgmState = new Ac("fpgm", t.tables.fpgm), i.funcs = [], i.font = t, exports.DEBUG && (console.log("---EXEC FPGM---"), i.step = -1);
        try {
          Nf(i);
        } catch (u) {
          console.log("Hinting error in FPGM:" + u), this._errorState = 3;
          return;
        }
      }
      Ac.prototype = i, n = this._prepState = new Ac("prep", t.tables.prep), n.ppem = e;
      var a = t.tables.cvt;
      if (a)
        for (var s = n.cvt = new Array(a.length), o = e / t.unitsPerEm, l = 0; l < a.length; l++)
          s[l] = a[l] * o;
      else
        n.cvt = [];
      exports.DEBUG && (console.log("---EXEC PREP---"), n.step = -1);
      try {
        Nf(n);
      } catch (u) {
        this._errorState < 2 && console.log("Hinting error in PREP:" + u), this._errorState = 2;
      }
    }
    if (!(this._errorState > 1))
      try {
        return oD(r, n);
      } catch (u) {
        this._errorState < 1 && (console.log("Hinting error:" + u), console.log("Note: further hinting errors are silenced")), this._errorState = 1;
        return;
      }
  }
};
oD = function(r, e) {
  var t = e.ppem / e.font.unitsPerEm, n = t, i = r.components, a, s, o;
  if (Ac.prototype = e, !i)
    o = new Ac("glyf", r.instructions), exports.DEBUG && (console.log("---EXEC GLYPH---"), o.step = -1), U1(r, o, t, n), s = o.gZone;
  else {
    var l = e.font;
    s = [], a = [];
    for (var u = 0; u < i.length; u++) {
      var c = i[u], h = l.glyphs.get(c.glyphIndex);
      o = new Ac("glyf", h.instructions), exports.DEBUG && (console.log("---EXEC COMP " + u + "---"), o.step = -1), U1(h, o, t, n);
      for (var f = Math.round(c.dx * t), p = Math.round(c.dy * n), m = o.gZone, A = o.contours, w = 0; w < m.length; w++) {
        var x = m[w];
        x.xTouched = x.yTouched = !1, x.xo = x.x = x.x + f, x.yo = x.y = x.y + p;
      }
      var E = s.length;
      s.push.apply(s, m);
      for (var T = 0; T < A.length; T++)
        a.push(A[T] + E);
    }
    r.instructions && !o.inhibitGridFit && (o = new Ac("glyf", r.instructions), o.gZone = o.z0 = o.z1 = o.z2 = s, o.contours = a, s.push(
      new Eu(0, 0),
      new Eu(Math.round(r.advanceWidth * t), 0)
    ), exports.DEBUG && (console.log("---EXEC COMPOSITE---"), o.step = -1), Nf(o), s.length -= 2);
  }
  return s;
};
U1 = function(r, e, t, n) {
  for (var i = r.points || [], a = i.length, s = e.gZone = e.z0 = e.z1 = e.z2 = [], o = e.contours = [], l, u = 0; u < a; u++)
    l = i[u], s[u] = new Eu(
      l.x * t,
      l.y * n,
      l.lastPointOfContour,
      l.onCurve
    );
  for (var c, h, f = 0; f < a; f++)
    l = s[f], c || (c = l, o.push(f)), l.lastPointOfContour ? (l.nextPointOnContour = c, c.prevPointOnContour = l, c = void 0) : (h = s[f + 1], l.nextPointOnContour = h, h.prevPointOnContour = l);
  if (!e.inhibitGridFit) {
    if (exports.DEBUG) {
      console.log("PROCESSING GLYPH", e.stack);
      for (var p = 0; p < a; p++)
        console.log(p, s[p].x, s[p].y);
    }
    if (s.push(
      new Eu(0, 0),
      new Eu(Math.round(r.advanceWidth * t), 0)
    ), Nf(e), s.length -= 2, exports.DEBUG) {
      console.log("FINISHED GLYPH", e.stack);
      for (var m = 0; m < a; m++)
        console.log(m, s[m].x, s[m].y);
    }
  }
};
Nf = function(r) {
  var e = r.prog;
  if (e) {
    var t = e.length, n;
    for (r.ip = 0; r.ip < t; r.ip++) {
      if (exports.DEBUG && r.step++, n = sD[e[r.ip]], !n)
        throw new Error(
          "unknown instruction: 0x" + Number(e[r.ip]).toString(16)
        );
      n(r);
    }
  }
};
function j0(r) {
  for (var e = r.tZone = new Array(r.gZone.length), t = 0; t < e.length; t++)
    e[t] = new Eu(0, 0);
}
function fD(r, e) {
  var t = r.prog, n = r.ip, i = 1, a;
  do
    if (a = t[++n], a === 88)
      i++;
    else if (a === 89)
      i--;
    else if (a === 64)
      n += t[n + 1] + 1;
    else if (a === 65)
      n += 2 * t[n + 1] + 1;
    else if (a >= 176 && a <= 183)
      n += a - 176 + 1;
    else if (a >= 184 && a <= 191)
      n += (a - 184 + 1) * 2;
    else if (e && i === 1 && a === 27)
      break;
  while (i > 0);
  r.ip = n;
}
function qE(r, e) {
  exports.DEBUG && console.log(e.step, "SVTCA[" + r.axis + "]"), e.fv = e.pv = e.dpv = r;
}
function QE(r, e) {
  exports.DEBUG && console.log(e.step, "SPVTCA[" + r.axis + "]"), e.pv = e.dpv = r;
}
function YE(r, e) {
  exports.DEBUG && console.log(e.step, "SFVTCA[" + r.axis + "]"), e.fv = r;
}
function XE(r, e) {
  var t = e.stack, n = t.pop(), i = t.pop(), a = e.z2[n], s = e.z1[i];
  exports.DEBUG && console.log("SPVTL[" + r + "]", n, i);
  var o, l;
  r ? (o = a.y - s.y, l = s.x - a.x) : (o = s.x - a.x, l = s.y - a.y), e.pv = e.dpv = Ag(o, l);
}
function JE(r, e) {
  var t = e.stack, n = t.pop(), i = t.pop(), a = e.z2[n], s = e.z1[i];
  exports.DEBUG && console.log("SFVTL[" + r + "]", n, i);
  var o, l;
  r ? (o = a.y - s.y, l = s.x - a.x) : (o = s.x - a.x, l = s.y - a.y), e.fv = Ag(o, l);
}
function CV(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "SPVFS[]", t, n), r.pv = r.dpv = Ag(n, t);
}
function SV(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "SPVFS[]", t, n), r.fv = Ag(n, t);
}
function EV(r) {
  var e = r.stack, t = r.pv;
  exports.DEBUG && console.log(r.step, "GPV[]"), e.push(t.x * 16384), e.push(t.y * 16384);
}
function kV(r) {
  var e = r.stack, t = r.fv;
  exports.DEBUG && console.log(r.step, "GFV[]"), e.push(t.x * 16384), e.push(t.y * 16384);
}
function TV(r) {
  r.fv = r.pv, exports.DEBUG && console.log(r.step, "SFVTPV[]");
}
function FV(r) {
  var e = r.stack, t = e.pop(), n = e.pop(), i = e.pop(), a = e.pop(), s = e.pop(), o = r.z0, l = r.z1, u = o[t], c = o[n], h = l[i], f = l[a], p = r.z2[s];
  exports.DEBUG && console.log("ISECT[], ", t, n, i, a, s);
  var m = u.x, A = u.y, w = c.x, x = c.y, E = h.x, T = h.y, D = f.x, F = f.y, _ = (m - w) * (T - F) - (A - x) * (E - D), L = m * x - A * w, Z = E * F - T * D;
  p.x = (L * (E - D) - Z * (m - w)) / _, p.y = (L * (T - F) - Z * (A - x)) / _;
}
function IV(r) {
  r.rp0 = r.stack.pop(), exports.DEBUG && console.log(r.step, "SRP0[]", r.rp0);
}
function PV(r) {
  r.rp1 = r.stack.pop(), exports.DEBUG && console.log(r.step, "SRP1[]", r.rp1);
}
function DV(r) {
  r.rp2 = r.stack.pop(), exports.DEBUG && console.log(r.step, "SRP2[]", r.rp2);
}
function RV(r) {
  var e = r.stack.pop();
  switch (exports.DEBUG && console.log(r.step, "SZP0[]", e), r.zp0 = e, e) {
    case 0:
      r.tZone || j0(r), r.z0 = r.tZone;
      break;
    case 1:
      r.z0 = r.gZone;
      break;
    default:
      throw new Error("Invalid zone pointer");
  }
}
function OV(r) {
  var e = r.stack.pop();
  switch (exports.DEBUG && console.log(r.step, "SZP1[]", e), r.zp1 = e, e) {
    case 0:
      r.tZone || j0(r), r.z1 = r.tZone;
      break;
    case 1:
      r.z1 = r.gZone;
      break;
    default:
      throw new Error("Invalid zone pointer");
  }
}
function BV(r) {
  var e = r.stack.pop();
  switch (exports.DEBUG && console.log(r.step, "SZP2[]", e), r.zp2 = e, e) {
    case 0:
      r.tZone || j0(r), r.z2 = r.tZone;
      break;
    case 1:
      r.z2 = r.gZone;
      break;
    default:
      throw new Error("Invalid zone pointer");
  }
}
function _V(r) {
  var e = r.stack.pop();
  switch (exports.DEBUG && console.log(r.step, "SZPS[]", e), r.zp0 = r.zp1 = r.zp2 = e, e) {
    case 0:
      r.tZone || j0(r), r.z0 = r.z1 = r.z2 = r.tZone;
      break;
    case 1:
      r.z0 = r.z1 = r.z2 = r.gZone;
      break;
    default:
      throw new Error("Invalid zone pointer");
  }
}
function MV(r) {
  r.loop = r.stack.pop(), exports.DEBUG && console.log(r.step, "SLOOP[]", r.loop);
}
function NV(r) {
  exports.DEBUG && console.log(r.step, "RTG[]"), r.round = uD;
}
function LV(r) {
  exports.DEBUG && console.log(r.step, "RTHG[]"), r.round = AV;
}
function UV(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "SMD[]", e), r.minDis = e / 64;
}
function VV(r) {
  exports.DEBUG && console.log(r.step, "ELSE[]"), fD(r, !1);
}
function $V(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "JMPR[]", e), r.ip += e - 1;
}
function zV(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "SCVTCI[]", e), r.cvCutIn = e / 64;
}
function GV(r) {
  var e = r.stack;
  exports.DEBUG && console.log(r.step, "DUP[]"), e.push(e[e.length - 1]);
}
function dy(r) {
  exports.DEBUG && console.log(r.step, "POP[]"), r.stack.pop();
}
function HV(r) {
  exports.DEBUG && console.log(r.step, "CLEAR[]"), r.stack.length = 0;
}
function WV(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "SWAP[]"), e.push(t), e.push(n);
}
function jV(r) {
  var e = r.stack;
  exports.DEBUG && console.log(r.step, "DEPTH[]"), e.push(e.length);
}
function qV(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "LOOPCALL[]", t, n);
  var i = r.ip, a = r.prog;
  r.prog = r.funcs[t];
  for (var s = 0; s < n; s++)
    Nf(r), exports.DEBUG && console.log(
      ++r.step,
      s + 1 < n ? "next loopcall" : "done loopcall",
      s
    );
  r.ip = i, r.prog = a;
}
function QV(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "CALL[]", e);
  var t = r.ip, n = r.prog;
  r.prog = r.funcs[e], Nf(r), r.ip = t, r.prog = n, exports.DEBUG && console.log(++r.step, "returning from", e);
}
function YV(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "CINDEX[]", t), e.push(e[e.length - t]);
}
function XV(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "MINDEX[]", t), e.push(e.splice(e.length - t, 1)[0]);
}
function JV(r) {
  if (r.env !== "fpgm")
    throw new Error("FDEF not allowed here");
  var e = r.stack, t = r.prog, n = r.ip, i = e.pop(), a = n;
  for (exports.DEBUG && console.log(r.step, "FDEF[]", i); t[++n] !== 45; )
    ;
  r.ip = n, r.funcs[i] = t.slice(a + 1, n);
}
function KE(r, e) {
  var t = e.stack.pop(), n = e.z0[t], i = e.fv, a = e.pv;
  exports.DEBUG && console.log(e.step, "MDAP[" + r + "]", t);
  var s = a.distance(n, Xp);
  r && (s = e.round(s)), i.setRelative(n, Xp, s, a), i.touch(n), e.rp0 = e.rp1 = t;
}
function ZE(r, e) {
  var t = e.z2, n = t.length - 2, i, a, s;
  exports.DEBUG && console.log(e.step, "IUP[" + r.axis + "]");
  for (var o = 0; o < n; o++)
    i = t[o], !r.touched(i) && (a = i.prevTouched(r), a !== i && (s = i.nextTouched(r), a === s && r.setRelative(i, i, r.distance(a, a, !1, !0), r, !0), r.interpolate(i, a, s, r)));
}
function e2(r, e) {
  for (var t = e.stack, n = r ? e.rp1 : e.rp2, i = (r ? e.z0 : e.z1)[n], a = e.fv, s = e.pv, o = e.loop, l = e.z2; o--; ) {
    var u = t.pop(), c = l[u], h = s.distance(i, i, !1, !0);
    a.setRelative(c, c, h, s), a.touch(c), exports.DEBUG && console.log(
      e.step,
      (e.loop > 1 ? "loop " + (e.loop - o) + ": " : "") + "SHP[" + (r ? "rp1" : "rp2") + "]",
      u
    );
  }
  e.loop = 1;
}
function t2(r, e) {
  var t = e.stack, n = r ? e.rp1 : e.rp2, i = (r ? e.z0 : e.z1)[n], a = e.fv, s = e.pv, o = t.pop(), l = e.z2[e.contours[o]], u = l;
  exports.DEBUG && console.log(e.step, "SHC[" + r + "]", o);
  var c = s.distance(i, i, !1, !0);
  do
    u !== i && a.setRelative(u, u, c, s), u = u.nextPointOnContour;
  while (u !== l);
}
function r2(r, e) {
  var t = e.stack, n = r ? e.rp1 : e.rp2, i = (r ? e.z0 : e.z1)[n], a = e.fv, s = e.pv, o = t.pop();
  exports.DEBUG && console.log(e.step, "SHZ[" + r + "]", o);
  var l;
  switch (o) {
    case 0:
      l = e.tZone;
      break;
    case 1:
      l = e.gZone;
      break;
    default:
      throw new Error("Invalid zone");
  }
  for (var u, c = s.distance(i, i, !1, !0), h = l.length - 2, f = 0; f < h; f++)
    u = l[f], a.setRelative(u, u, c, s);
}
function KV(r) {
  for (var e = r.stack, t = r.loop, n = r.fv, i = e.pop() / 64, a = r.z2; t--; ) {
    var s = e.pop(), o = a[s];
    exports.DEBUG && console.log(
      r.step,
      (r.loop > 1 ? "loop " + (r.loop - t) + ": " : "") + "SHPIX[]",
      s,
      i
    ), n.setRelative(o, o, i), n.touch(o);
  }
  r.loop = 1;
}
function ZV(r) {
  for (var e = r.stack, t = r.rp1, n = r.rp2, i = r.loop, a = r.z0[t], s = r.z1[n], o = r.fv, l = r.dpv, u = r.z2; i--; ) {
    var c = e.pop(), h = u[c];
    exports.DEBUG && console.log(
      r.step,
      (r.loop > 1 ? "loop " + (r.loop - i) + ": " : "") + "IP[]",
      c,
      t,
      "<->",
      n
    ), o.interpolate(h, a, s, l), o.touch(h);
  }
  r.loop = 1;
}
function n2(r, e) {
  var t = e.stack, n = t.pop() / 64, i = t.pop(), a = e.z1[i], s = e.z0[e.rp0], o = e.fv, l = e.pv;
  o.setRelative(a, s, n, l), o.touch(a), exports.DEBUG && console.log(e.step, "MSIRP[" + r + "]", n, i), e.rp1 = e.rp0, e.rp2 = i, r && (e.rp0 = i);
}
function e$(r) {
  for (var e = r.stack, t = r.rp0, n = r.z0[t], i = r.loop, a = r.fv, s = r.pv, o = r.z1; i--; ) {
    var l = e.pop(), u = o[l];
    exports.DEBUG && console.log(
      r.step,
      (r.loop > 1 ? "loop " + (r.loop - i) + ": " : "") + "ALIGNRP[]",
      l
    ), a.setRelative(u, n, 0, s), a.touch(u);
  }
  r.loop = 1;
}
function t$(r) {
  exports.DEBUG && console.log(r.step, "RTDG[]"), r.round = yV;
}
function i2(r, e) {
  var t = e.stack, n = t.pop(), i = t.pop(), a = e.z0[i], s = e.fv, o = e.pv, l = e.cvt[n];
  exports.DEBUG && console.log(
    e.step,
    "MIAP[" + r + "]",
    n,
    "(",
    l,
    ")",
    i
  );
  var u = o.distance(a, Xp);
  r && (Math.abs(u - l) < e.cvCutIn && (u = l), u = e.round(u)), s.setRelative(a, Xp, u, o), e.zp0 === 0 && (a.xo = a.x, a.yo = a.y), s.touch(a), e.rp0 = e.rp1 = i;
}
function r$(r) {
  var e = r.prog, t = r.ip, n = r.stack, i = e[++t];
  exports.DEBUG && console.log(r.step, "NPUSHB[]", i);
  for (var a = 0; a < i; a++)
    n.push(e[++t]);
  r.ip = t;
}
function n$(r) {
  var e = r.ip, t = r.prog, n = r.stack, i = t[++e];
  exports.DEBUG && console.log(r.step, "NPUSHW[]", i);
  for (var a = 0; a < i; a++) {
    var s = t[++e] << 8 | t[++e];
    s & 32768 && (s = -((s ^ 65535) + 1)), n.push(s);
  }
  r.ip = e;
}
function i$(r) {
  var e = r.stack, t = r.store;
  t || (t = r.store = []);
  var n = e.pop(), i = e.pop();
  exports.DEBUG && console.log(r.step, "WS", n, i), t[i] = n;
}
function a$(r) {
  var e = r.stack, t = r.store, n = e.pop();
  exports.DEBUG && console.log(r.step, "RS", n);
  var i = t && t[n] || 0;
  e.push(i);
}
function s$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "WCVTP", t, n), r.cvt[n] = t / 64;
}
function o$(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "RCVT", t), e.push(r.cvt[t] * 64);
}
function a2(r, e) {
  var t = e.stack, n = t.pop(), i = e.z2[n];
  exports.DEBUG && console.log(e.step, "GC[" + r + "]", n), t.push(e.dpv.distance(i, Xp, r, !1) * 64);
}
function s2(r, e) {
  var t = e.stack, n = t.pop(), i = t.pop(), a = e.z1[n], s = e.z0[i], o = e.dpv.distance(s, a, r, r);
  exports.DEBUG && console.log(e.step, "MD[" + r + "]", n, i, "->", o), e.stack.push(Math.round(o * 64));
}
function l$(r) {
  exports.DEBUG && console.log(r.step, "MPPEM[]"), r.stack.push(r.ppem);
}
function u$(r) {
  exports.DEBUG && console.log(r.step, "FLIPON[]"), r.autoFlip = !0;
}
function c$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "LT[]", t, n), e.push(n < t ? 1 : 0);
}
function f$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "LTEQ[]", t, n), e.push(n <= t ? 1 : 0);
}
function d$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "GT[]", t, n), e.push(n > t ? 1 : 0);
}
function h$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "GTEQ[]", t, n), e.push(n >= t ? 1 : 0);
}
function p$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "EQ[]", t, n), e.push(t === n ? 1 : 0);
}
function g$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "NEQ[]", t, n), e.push(t !== n ? 1 : 0);
}
function m$(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "ODD[]", t), e.push(Math.trunc(t) % 2 ? 1 : 0);
}
function v$(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "EVEN[]", t), e.push(Math.trunc(t) % 2 ? 0 : 1);
}
function y$(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "IF[]", e), e || (fD(r, !0), exports.DEBUG && console.log(r.step, "EIF[]"));
}
function A$(r) {
  exports.DEBUG && console.log(r.step, "EIF[]");
}
function w$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "AND[]", t, n), e.push(t && n ? 1 : 0);
}
function x$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "OR[]", t, n), e.push(t || n ? 1 : 0);
}
function b$(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "NOT[]", t), e.push(t ? 0 : 1);
}
function hy(r, e) {
  var t = e.stack, n = t.pop(), i = e.fv, a = e.pv, s = e.ppem, o = e.deltaBase + (r - 1) * 16, l = e.deltaShift, u = e.z0;
  exports.DEBUG && console.log(e.step, "DELTAP[" + r + "]", n, t);
  for (var c = 0; c < n; c++) {
    var h = t.pop(), f = t.pop(), p = o + ((f & 240) >> 4);
    if (p === s) {
      var m = (f & 15) - 8;
      m >= 0 && m++, exports.DEBUG && console.log(e.step, "DELTAPFIX", h, "by", m * l);
      var A = u[h];
      i.setRelative(A, A, m * l, a);
    }
  }
}
function C$(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "SDB[]", t), r.deltaBase = t;
}
function S$(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "SDS[]", t), r.deltaShift = Math.pow(0.5, t);
}
function E$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "ADD[]", t, n), e.push(n + t);
}
function k$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "SUB[]", t, n), e.push(n - t);
}
function T$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "DIV[]", t, n), e.push(n * 64 / t);
}
function F$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "MUL[]", t, n), e.push(n * t / 64);
}
function I$(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "ABS[]", t), e.push(Math.abs(t));
}
function P$(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "NEG[]", t), e.push(-t);
}
function D$(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "FLOOR[]", t), e.push(Math.floor(t / 64) * 64);
}
function R$(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "CEILING[]", t), e.push(Math.ceil(t / 64) * 64);
}
function Kg(r, e) {
  var t = e.stack, n = t.pop();
  exports.DEBUG && console.log(e.step, "ROUND[]"), t.push(e.round(n / 64) * 64);
}
function O$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "WCVTF[]", t, n), r.cvt[n] = t * r.ppem / r.font.unitsPerEm;
}
function py(r, e) {
  var t = e.stack, n = t.pop(), i = e.ppem, a = e.deltaBase + (r - 1) * 16, s = e.deltaShift;
  exports.DEBUG && console.log(e.step, "DELTAC[" + r + "]", n, t);
  for (var o = 0; o < n; o++) {
    var l = t.pop(), u = t.pop(), c = a + ((u & 240) >> 4);
    if (c === i) {
      var h = (u & 15) - 8;
      h >= 0 && h++;
      var f = h * s;
      exports.DEBUG && console.log(e.step, "DELTACFIX", l, "by", f), e.cvt[l] += f;
    }
  }
}
function B$(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "SROUND[]", e), r.round = cD;
  var t;
  switch (e & 192) {
    case 0:
      t = 0.5;
      break;
    case 64:
      t = 1;
      break;
    case 128:
      t = 2;
      break;
    default:
      throw new Error("invalid SROUND value");
  }
  switch (r.srPeriod = t, e & 48) {
    case 0:
      r.srPhase = 0;
      break;
    case 16:
      r.srPhase = 0.25 * t;
      break;
    case 32:
      r.srPhase = 0.5 * t;
      break;
    case 48:
      r.srPhase = 0.75 * t;
      break;
    default:
      throw new Error("invalid SROUND value");
  }
  e &= 15, e === 0 ? r.srThreshold = 0 : r.srThreshold = (e / 8 - 0.5) * t;
}
function _$(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "S45ROUND[]", e), r.round = cD;
  var t;
  switch (e & 192) {
    case 0:
      t = Math.sqrt(2) / 2;
      break;
    case 64:
      t = Math.sqrt(2);
      break;
    case 128:
      t = 2 * Math.sqrt(2);
      break;
    default:
      throw new Error("invalid S45ROUND value");
  }
  switch (r.srPeriod = t, e & 48) {
    case 0:
      r.srPhase = 0;
      break;
    case 16:
      r.srPhase = 0.25 * t;
      break;
    case 32:
      r.srPhase = 0.5 * t;
      break;
    case 48:
      r.srPhase = 0.75 * t;
      break;
    default:
      throw new Error("invalid S45ROUND value");
  }
  e &= 15, e === 0 ? r.srThreshold = 0 : r.srThreshold = (e / 8 - 0.5) * t;
}
function M$(r) {
  exports.DEBUG && console.log(r.step, "ROFF[]"), r.round = vV;
}
function N$(r) {
  exports.DEBUG && console.log(r.step, "RUTG[]"), r.round = wV;
}
function L$(r) {
  exports.DEBUG && console.log(r.step, "RDTG[]"), r.round = xV;
}
function U$(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "SCANCTRL[]", e);
}
function o2(r, e) {
  var t = e.stack, n = t.pop(), i = t.pop(), a = e.z2[n], s = e.z1[i];
  exports.DEBUG && console.log(e.step, "SDPVTL[" + r + "]", n, i);
  var o, l;
  r ? (o = a.y - s.y, l = s.x - a.x) : (o = s.x - a.x, l = s.y - a.y), e.dpv = Ag(o, l);
}
function V$(r) {
  var e = r.stack, t = e.pop(), n = 0;
  exports.DEBUG && console.log(r.step, "GETINFO[]", t), t & 1 && (n = 35), t & 32 && (n |= 4096), e.push(n);
}
function $$(r) {
  var e = r.stack, t = e.pop(), n = e.pop(), i = e.pop();
  exports.DEBUG && console.log(r.step, "ROLL[]"), e.push(n), e.push(t), e.push(i);
}
function z$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "MAX[]", t, n), e.push(Math.max(n, t));
}
function G$(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "MIN[]", t, n), e.push(Math.min(n, t));
}
function H$(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "SCANTYPE[]", e);
}
function W$(r) {
  var e = r.stack.pop(), t = r.stack.pop();
  switch (exports.DEBUG && console.log(r.step, "INSTCTRL[]", e, t), e) {
    case 1:
      r.inhibitGridFit = !!t;
      return;
    case 2:
      r.ignoreCvt = !!t;
      return;
    default:
      throw new Error("invalid INSTCTRL[] selector");
  }
}
function sc(r, e) {
  var t = e.stack, n = e.prog, i = e.ip;
  exports.DEBUG && console.log(e.step, "PUSHB[" + r + "]");
  for (var a = 0; a < r; a++)
    t.push(n[++i]);
  e.ip = i;
}
function oc(r, e) {
  var t = e.ip, n = e.prog, i = e.stack;
  exports.DEBUG && console.log(e.ip, "PUSHW[" + r + "]");
  for (var a = 0; a < r; a++) {
    var s = n[++t] << 8 | n[++t];
    s & 32768 && (s = -((s ^ 65535) + 1)), i.push(s);
  }
  e.ip = t;
}
function Lt(r, e, t, n, i, a) {
  var s = a.stack, o = r && s.pop(), l = s.pop(), u = a.rp0, c = a.z0[u], h = a.z1[l], f = a.minDis, p = a.fv, m = a.dpv, A, w, x, E;
  w = A = m.distance(h, c, !0, !0), x = w >= 0 ? 1 : -1, w = Math.abs(w), r && (E = a.cvt[o], n && Math.abs(w - E) < a.cvCutIn && (w = E)), t && w < f && (w = f), n && (w = a.round(w)), p.setRelative(h, c, x * w, m), p.touch(h), exports.DEBUG && console.log(
    a.step,
    (r ? "MIRP[" : "MDRP[") + (e ? "M" : "m") + (t ? ">" : "_") + (n ? "R" : "_") + (i === 0 ? "Gr" : i === 1 ? "Bl" : i === 2 ? "Wh" : "") + "]",
    r ? o + "(" + a.cvt[o] + "," + E + ")" : "",
    l,
    "(d =",
    A,
    "->",
    x * w,
    ")"
  ), a.rp1 = a.rp0, a.rp2 = l, e && (a.rp0 = l);
}
sD = [
  /* 0x00 */
  qE.bind(void 0, bu),
  /* 0x01 */
  qE.bind(void 0, Rl),
  /* 0x02 */
  QE.bind(void 0, bu),
  /* 0x03 */
  QE.bind(void 0, Rl),
  /* 0x04 */
  YE.bind(void 0, bu),
  /* 0x05 */
  YE.bind(void 0, Rl),
  /* 0x06 */
  XE.bind(void 0, 0),
  /* 0x07 */
  XE.bind(void 0, 1),
  /* 0x08 */
  JE.bind(void 0, 0),
  /* 0x09 */
  JE.bind(void 0, 1),
  /* 0x0A */
  CV,
  /* 0x0B */
  SV,
  /* 0x0C */
  EV,
  /* 0x0D */
  kV,
  /* 0x0E */
  TV,
  /* 0x0F */
  FV,
  /* 0x10 */
  IV,
  /* 0x11 */
  PV,
  /* 0x12 */
  DV,
  /* 0x13 */
  RV,
  /* 0x14 */
  OV,
  /* 0x15 */
  BV,
  /* 0x16 */
  _V,
  /* 0x17 */
  MV,
  /* 0x18 */
  NV,
  /* 0x19 */
  LV,
  /* 0x1A */
  UV,
  /* 0x1B */
  VV,
  /* 0x1C */
  $V,
  /* 0x1D */
  zV,
  /* 0x1E */
  void 0,
  // TODO SSWCI
  /* 0x1F */
  void 0,
  // TODO SSW
  /* 0x20 */
  GV,
  /* 0x21 */
  dy,
  /* 0x22 */
  HV,
  /* 0x23 */
  WV,
  /* 0x24 */
  jV,
  /* 0x25 */
  YV,
  /* 0x26 */
  XV,
  /* 0x27 */
  void 0,
  // TODO ALIGNPTS
  /* 0x28 */
  void 0,
  /* 0x29 */
  void 0,
  // TODO UTP
  /* 0x2A */
  qV,
  /* 0x2B */
  QV,
  /* 0x2C */
  JV,
  /* 0x2D */
  void 0,
  // ENDF (eaten by FDEF)
  /* 0x2E */
  KE.bind(void 0, 0),
  /* 0x2F */
  KE.bind(void 0, 1),
  /* 0x30 */
  ZE.bind(void 0, bu),
  /* 0x31 */
  ZE.bind(void 0, Rl),
  /* 0x32 */
  e2.bind(void 0, 0),
  /* 0x33 */
  e2.bind(void 0, 1),
  /* 0x34 */
  t2.bind(void 0, 0),
  /* 0x35 */
  t2.bind(void 0, 1),
  /* 0x36 */
  r2.bind(void 0, 0),
  /* 0x37 */
  r2.bind(void 0, 1),
  /* 0x38 */
  KV,
  /* 0x39 */
  ZV,
  /* 0x3A */
  n2.bind(void 0, 0),
  /* 0x3B */
  n2.bind(void 0, 1),
  /* 0x3C */
  e$,
  /* 0x3D */
  t$,
  /* 0x3E */
  i2.bind(void 0, 0),
  /* 0x3F */
  i2.bind(void 0, 1),
  /* 0x40 */
  r$,
  /* 0x41 */
  n$,
  /* 0x42 */
  i$,
  /* 0x43 */
  a$,
  /* 0x44 */
  s$,
  /* 0x45 */
  o$,
  /* 0x46 */
  a2.bind(void 0, 0),
  /* 0x47 */
  a2.bind(void 0, 1),
  /* 0x48 */
  void 0,
  // TODO SCFS
  /* 0x49 */
  s2.bind(void 0, 0),
  /* 0x4A */
  s2.bind(void 0, 1),
  /* 0x4B */
  l$,
  /* 0x4C */
  void 0,
  // TODO MPS
  /* 0x4D */
  u$,
  /* 0x4E */
  void 0,
  // TODO FLIPOFF
  /* 0x4F */
  void 0,
  // TODO DEBUG
  /* 0x50 */
  c$,
  /* 0x51 */
  f$,
  /* 0x52 */
  d$,
  /* 0x53 */
  h$,
  /* 0x54 */
  p$,
  /* 0x55 */
  g$,
  /* 0x56 */
  m$,
  /* 0x57 */
  v$,
  /* 0x58 */
  y$,
  /* 0x59 */
  A$,
  /* 0x5A */
  w$,
  /* 0x5B */
  x$,
  /* 0x5C */
  b$,
  /* 0x5D */
  hy.bind(void 0, 1),
  /* 0x5E */
  C$,
  /* 0x5F */
  S$,
  /* 0x60 */
  E$,
  /* 0x61 */
  k$,
  /* 0x62 */
  T$,
  /* 0x63 */
  F$,
  /* 0x64 */
  I$,
  /* 0x65 */
  P$,
  /* 0x66 */
  D$,
  /* 0x67 */
  R$,
  /* 0x68 */
  Kg.bind(void 0, 0),
  /* 0x69 */
  Kg.bind(void 0, 1),
  /* 0x6A */
  Kg.bind(void 0, 2),
  /* 0x6B */
  Kg.bind(void 0, 3),
  /* 0x6C */
  void 0,
  // TODO NROUND[ab]
  /* 0x6D */
  void 0,
  // TODO NROUND[ab]
  /* 0x6E */
  void 0,
  // TODO NROUND[ab]
  /* 0x6F */
  void 0,
  // TODO NROUND[ab]
  /* 0x70 */
  O$,
  /* 0x71 */
  hy.bind(void 0, 2),
  /* 0x72 */
  hy.bind(void 0, 3),
  /* 0x73 */
  py.bind(void 0, 1),
  /* 0x74 */
  py.bind(void 0, 2),
  /* 0x75 */
  py.bind(void 0, 3),
  /* 0x76 */
  B$,
  /* 0x77 */
  _$,
  /* 0x78 */
  void 0,
  // TODO JROT[]
  /* 0x79 */
  void 0,
  // TODO JROF[]
  /* 0x7A */
  M$,
  /* 0x7B */
  void 0,
  /* 0x7C */
  N$,
  /* 0x7D */
  L$,
  /* 0x7E */
  dy,
  // actually SANGW, supposed to do only a pop though
  /* 0x7F */
  dy,
  // actually AA, supposed to do only a pop though
  /* 0x80 */
  void 0,
  // TODO FLIPPT
  /* 0x81 */
  void 0,
  // TODO FLIPRGON
  /* 0x82 */
  void 0,
  // TODO FLIPRGOFF
  /* 0x83 */
  void 0,
  /* 0x84 */
  void 0,
  /* 0x85 */
  U$,
  /* 0x86 */
  o2.bind(void 0, 0),
  /* 0x87 */
  o2.bind(void 0, 1),
  /* 0x88 */
  V$,
  /* 0x89 */
  void 0,
  // TODO IDEF
  /* 0x8A */
  $$,
  /* 0x8B */
  z$,
  /* 0x8C */
  G$,
  /* 0x8D */
  H$,
  /* 0x8E */
  W$,
  /* 0x8F */
  void 0,
  /* 0x90 */
  void 0,
  /* 0x91 */
  void 0,
  /* 0x92 */
  void 0,
  /* 0x93 */
  void 0,
  /* 0x94 */
  void 0,
  /* 0x95 */
  void 0,
  /* 0x96 */
  void 0,
  /* 0x97 */
  void 0,
  /* 0x98 */
  void 0,
  /* 0x99 */
  void 0,
  /* 0x9A */
  void 0,
  /* 0x9B */
  void 0,
  /* 0x9C */
  void 0,
  /* 0x9D */
  void 0,
  /* 0x9E */
  void 0,
  /* 0x9F */
  void 0,
  /* 0xA0 */
  void 0,
  /* 0xA1 */
  void 0,
  /* 0xA2 */
  void 0,
  /* 0xA3 */
  void 0,
  /* 0xA4 */
  void 0,
  /* 0xA5 */
  void 0,
  /* 0xA6 */
  void 0,
  /* 0xA7 */
  void 0,
  /* 0xA8 */
  void 0,
  /* 0xA9 */
  void 0,
  /* 0xAA */
  void 0,
  /* 0xAB */
  void 0,
  /* 0xAC */
  void 0,
  /* 0xAD */
  void 0,
  /* 0xAE */
  void 0,
  /* 0xAF */
  void 0,
  /* 0xB0 */
  sc.bind(void 0, 1),
  /* 0xB1 */
  sc.bind(void 0, 2),
  /* 0xB2 */
  sc.bind(void 0, 3),
  /* 0xB3 */
  sc.bind(void 0, 4),
  /* 0xB4 */
  sc.bind(void 0, 5),
  /* 0xB5 */
  sc.bind(void 0, 6),
  /* 0xB6 */
  sc.bind(void 0, 7),
  /* 0xB7 */
  sc.bind(void 0, 8),
  /* 0xB8 */
  oc.bind(void 0, 1),
  /* 0xB9 */
  oc.bind(void 0, 2),
  /* 0xBA */
  oc.bind(void 0, 3),
  /* 0xBB */
  oc.bind(void 0, 4),
  /* 0xBC */
  oc.bind(void 0, 5),
  /* 0xBD */
  oc.bind(void 0, 6),
  /* 0xBE */
  oc.bind(void 0, 7),
  /* 0xBF */
  oc.bind(void 0, 8),
  /* 0xC0 */
  Lt.bind(void 0, 0, 0, 0, 0, 0),
  /* 0xC1 */
  Lt.bind(void 0, 0, 0, 0, 0, 1),
  /* 0xC2 */
  Lt.bind(void 0, 0, 0, 0, 0, 2),
  /* 0xC3 */
  Lt.bind(void 0, 0, 0, 0, 0, 3),
  /* 0xC4 */
  Lt.bind(void 0, 0, 0, 0, 1, 0),
  /* 0xC5 */
  Lt.bind(void 0, 0, 0, 0, 1, 1),
  /* 0xC6 */
  Lt.bind(void 0, 0, 0, 0, 1, 2),
  /* 0xC7 */
  Lt.bind(void 0, 0, 0, 0, 1, 3),
  /* 0xC8 */
  Lt.bind(void 0, 0, 0, 1, 0, 0),
  /* 0xC9 */
  Lt.bind(void 0, 0, 0, 1, 0, 1),
  /* 0xCA */
  Lt.bind(void 0, 0, 0, 1, 0, 2),
  /* 0xCB */
  Lt.bind(void 0, 0, 0, 1, 0, 3),
  /* 0xCC */
  Lt.bind(void 0, 0, 0, 1, 1, 0),
  /* 0xCD */
  Lt.bind(void 0, 0, 0, 1, 1, 1),
  /* 0xCE */
  Lt.bind(void 0, 0, 0, 1, 1, 2),
  /* 0xCF */
  Lt.bind(void 0, 0, 0, 1, 1, 3),
  /* 0xD0 */
  Lt.bind(void 0, 0, 1, 0, 0, 0),
  /* 0xD1 */
  Lt.bind(void 0, 0, 1, 0, 0, 1),
  /* 0xD2 */
  Lt.bind(void 0, 0, 1, 0, 0, 2),
  /* 0xD3 */
  Lt.bind(void 0, 0, 1, 0, 0, 3),
  /* 0xD4 */
  Lt.bind(void 0, 0, 1, 0, 1, 0),
  /* 0xD5 */
  Lt.bind(void 0, 0, 1, 0, 1, 1),
  /* 0xD6 */
  Lt.bind(void 0, 0, 1, 0, 1, 2),
  /* 0xD7 */
  Lt.bind(void 0, 0, 1, 0, 1, 3),
  /* 0xD8 */
  Lt.bind(void 0, 0, 1, 1, 0, 0),
  /* 0xD9 */
  Lt.bind(void 0, 0, 1, 1, 0, 1),
  /* 0xDA */
  Lt.bind(void 0, 0, 1, 1, 0, 2),
  /* 0xDB */
  Lt.bind(void 0, 0, 1, 1, 0, 3),
  /* 0xDC */
  Lt.bind(void 0, 0, 1, 1, 1, 0),
  /* 0xDD */
  Lt.bind(void 0, 0, 1, 1, 1, 1),
  /* 0xDE */
  Lt.bind(void 0, 0, 1, 1, 1, 2),
  /* 0xDF */
  Lt.bind(void 0, 0, 1, 1, 1, 3),
  /* 0xE0 */
  Lt.bind(void 0, 1, 0, 0, 0, 0),
  /* 0xE1 */
  Lt.bind(void 0, 1, 0, 0, 0, 1),
  /* 0xE2 */
  Lt.bind(void 0, 1, 0, 0, 0, 2),
  /* 0xE3 */
  Lt.bind(void 0, 1, 0, 0, 0, 3),
  /* 0xE4 */
  Lt.bind(void 0, 1, 0, 0, 1, 0),
  /* 0xE5 */
  Lt.bind(void 0, 1, 0, 0, 1, 1),
  /* 0xE6 */
  Lt.bind(void 0, 1, 0, 0, 1, 2),
  /* 0xE7 */
  Lt.bind(void 0, 1, 0, 0, 1, 3),
  /* 0xE8 */
  Lt.bind(void 0, 1, 0, 1, 0, 0),
  /* 0xE9 */
  Lt.bind(void 0, 1, 0, 1, 0, 1),
  /* 0xEA */
  Lt.bind(void 0, 1, 0, 1, 0, 2),
  /* 0xEB */
  Lt.bind(void 0, 1, 0, 1, 0, 3),
  /* 0xEC */
  Lt.bind(void 0, 1, 0, 1, 1, 0),
  /* 0xED */
  Lt.bind(void 0, 1, 0, 1, 1, 1),
  /* 0xEE */
  Lt.bind(void 0, 1, 0, 1, 1, 2),
  /* 0xEF */
  Lt.bind(void 0, 1, 0, 1, 1, 3),
  /* 0xF0 */
  Lt.bind(void 0, 1, 1, 0, 0, 0),
  /* 0xF1 */
  Lt.bind(void 0, 1, 1, 0, 0, 1),
  /* 0xF2 */
  Lt.bind(void 0, 1, 1, 0, 0, 2),
  /* 0xF3 */
  Lt.bind(void 0, 1, 1, 0, 0, 3),
  /* 0xF4 */
  Lt.bind(void 0, 1, 1, 0, 1, 0),
  /* 0xF5 */
  Lt.bind(void 0, 1, 1, 0, 1, 1),
  /* 0xF6 */
  Lt.bind(void 0, 1, 1, 0, 1, 2),
  /* 0xF7 */
  Lt.bind(void 0, 1, 1, 0, 1, 3),
  /* 0xF8 */
  Lt.bind(void 0, 1, 1, 1, 0, 0),
  /* 0xF9 */
  Lt.bind(void 0, 1, 1, 1, 0, 1),
  /* 0xFA */
  Lt.bind(void 0, 1, 1, 1, 0, 2),
  /* 0xFB */
  Lt.bind(void 0, 1, 1, 1, 0, 3),
  /* 0xFC */
  Lt.bind(void 0, 1, 1, 1, 1, 0),
  /* 0xFD */
  Lt.bind(void 0, 1, 1, 1, 1, 1),
  /* 0xFE */
  Lt.bind(void 0, 1, 1, 1, 1, 2),
  /* 0xFF */
  Lt.bind(void 0, 1, 1, 1, 1, 3)
];
function sh(r) {
  this.char = r, this.state = {}, this.activeState = null;
}
function ix(r, e, t) {
  this.contextName = t, this.startIndex = r, this.endOffset = e;
}
function j$(r, e, t) {
  this.contextName = r, this.openRange = null, this.ranges = [], this.checkStart = e, this.checkEnd = t;
}
function Yo(r, e) {
  this.context = r, this.index = e, this.length = r.length, this.current = r[e], this.backtrack = r.slice(0, e), this.lookahead = r.slice(e + 1);
}
function q0(r) {
  this.eventId = r, this.subscribers = [];
}
function q$(r) {
  var e = this, t = [
    "start",
    "end",
    "next",
    "newToken",
    "contextStart",
    "contextEnd",
    "insertToken",
    "removeToken",
    "removeRange",
    "replaceToken",
    "replaceRange",
    "composeRUD",
    "updateContextsRanges"
  ];
  t.forEach(function(i) {
    Object.defineProperty(e.events, i, {
      value: new q0(i)
    });
  }), r && t.forEach(function(i) {
    var a = r[i];
    typeof a == "function" && e.events[i].subscribe(a);
  });
  var n = [
    "insertToken",
    "removeToken",
    "removeRange",
    "replaceToken",
    "replaceRange",
    "composeRUD"
  ];
  n.forEach(function(i) {
    e.events[i].subscribe(
      e.updateContextsRanges
    );
  });
}
function Gi(r) {
  this.tokens = [], this.registeredContexts = {}, this.contextCheckers = [], this.events = {}, this.registeredModifiers = [], q$.call(this, r);
}
sh.prototype.setState = function(r, e) {
  return this.state[r] = e, this.activeState = { key: r, value: this.state[r] }, this.activeState;
};
sh.prototype.getState = function(r) {
  return this.state[r] || null;
};
Gi.prototype.inboundIndex = function(r) {
  return r >= 0 && r < this.tokens.length;
};
Gi.prototype.composeRUD = function(r) {
  var e = this, t = !0, n = r.map(function(a) {
    return e[a[0]].apply(e, a.slice(1).concat(t));
  }), i = function(a) {
    return typeof a == "object" && a.hasOwnProperty("FAIL");
  };
  if (n.every(i))
    return {
      FAIL: "composeRUD: one or more operations hasn't completed successfully",
      report: n.filter(i)
    };
  this.dispatch("composeRUD", [n.filter(function(a) {
    return !i(a);
  })]);
};
Gi.prototype.replaceRange = function(r, e, t, n) {
  e = e !== null ? e : this.tokens.length;
  var i = t.every(function(s) {
    return s instanceof sh;
  });
  if (!isNaN(r) && this.inboundIndex(r) && i) {
    var a = this.tokens.splice.apply(
      this.tokens,
      [r, e].concat(t)
    );
    return n || this.dispatch("replaceToken", [r, e, t]), [a, t];
  } else
    return { FAIL: "replaceRange: invalid tokens or startIndex." };
};
Gi.prototype.replaceToken = function(r, e, t) {
  if (!isNaN(r) && this.inboundIndex(r) && e instanceof sh) {
    var n = this.tokens.splice(r, 1, e);
    return t || this.dispatch("replaceToken", [r, e]), [n[0], e];
  } else
    return { FAIL: "replaceToken: invalid token or index." };
};
Gi.prototype.removeRange = function(r, e, t) {
  e = isNaN(e) ? this.tokens.length : e;
  var n = this.tokens.splice(r, e);
  return t || this.dispatch("removeRange", [n, r, e]), n;
};
Gi.prototype.removeToken = function(r, e) {
  if (!isNaN(r) && this.inboundIndex(r)) {
    var t = this.tokens.splice(r, 1);
    return e || this.dispatch("removeToken", [t, r]), t;
  } else
    return { FAIL: "removeToken: invalid token index." };
};
Gi.prototype.insertToken = function(r, e, t) {
  var n = r.every(
    function(i) {
      return i instanceof sh;
    }
  );
  return n ? (this.tokens.splice.apply(
    this.tokens,
    [e, 0].concat(r)
  ), t || this.dispatch("insertToken", [r, e]), r) : { FAIL: "insertToken: invalid token(s)." };
};
Gi.prototype.registerModifier = function(r, e, t) {
  this.events.newToken.subscribe(function(n, i) {
    var a = [n, i], s = e === null || e.apply(this, a) === !0, o = [n, i];
    if (s) {
      var l = t.apply(this, o);
      n.setState(r, l);
    }
  }), this.registeredModifiers.push(r);
};
q0.prototype.subscribe = function(r) {
  return typeof r == "function" ? this.subscribers.push(r) - 1 : { FAIL: "invalid '" + this.eventId + "' event handler" };
};
q0.prototype.unsubscribe = function(r) {
  this.subscribers.splice(r, 1);
};
Yo.prototype.setCurrentIndex = function(r) {
  this.index = r, this.current = this.context[r], this.backtrack = this.context.slice(0, r), this.lookahead = this.context.slice(r + 1);
};
Yo.prototype.get = function(r) {
  switch (!0) {
    case r === 0:
      return this.current;
    case (r < 0 && Math.abs(r) <= this.backtrack.length):
      return this.backtrack.slice(r)[0];
    case (r > 0 && r <= this.lookahead.length):
      return this.lookahead[r - 1];
    default:
      return null;
  }
};
Gi.prototype.rangeToText = function(r) {
  if (r instanceof ix)
    return this.getRangeTokens(r).map(function(e) {
      return e.char;
    }).join("");
};
Gi.prototype.getText = function() {
  return this.tokens.map(function(r) {
    return r.char;
  }).join("");
};
Gi.prototype.getContext = function(r) {
  var e = this.registeredContexts[r];
  return e || null;
};
Gi.prototype.on = function(r, e) {
  var t = this.events[r];
  return t ? t.subscribe(e) : null;
};
Gi.prototype.dispatch = function(r, e) {
  var t = this, n = this.events[r];
  n instanceof q0 && n.subscribers.forEach(function(i) {
    i.apply(t, e || []);
  });
};
Gi.prototype.registerContextChecker = function(r, e, t) {
  if (this.getContext(r))
    return {
      FAIL: "context name '" + r + "' is already registered."
    };
  if (typeof e != "function")
    return {
      FAIL: "missing context start check."
    };
  if (typeof t != "function")
    return {
      FAIL: "missing context end check."
    };
  var n = new j$(
    r,
    e,
    t
  );
  return this.registeredContexts[r] = n, this.contextCheckers.push(n), n;
};
Gi.prototype.getRangeTokens = function(r) {
  var e = r.startIndex + r.endOffset;
  return [].concat(
    this.tokens.slice(r.startIndex, e)
  );
};
Gi.prototype.getContextRanges = function(r) {
  var e = this.getContext(r);
  return e ? e.ranges : { FAIL: "context checker '" + r + "' is not registered." };
};
Gi.prototype.resetContextsRanges = function() {
  var r = this.registeredContexts;
  for (var e in r)
    if (r.hasOwnProperty(e)) {
      var t = r[e];
      t.ranges = [];
    }
};
Gi.prototype.updateContextsRanges = function() {
  this.resetContextsRanges();
  for (var r = this.tokens.map(function(n) {
    return n.char;
  }), e = 0; e < r.length; e++) {
    var t = new Yo(r, e);
    this.runContextCheck(t);
  }
  this.dispatch("updateContextsRanges", [this.registeredContexts]);
};
Gi.prototype.setEndOffset = function(r, e) {
  var t = this.getContext(e).openRange.startIndex, n = new ix(t, r, e), i = this.getContext(e).ranges;
  return n.rangeId = e + "." + i.length, i.push(n), this.getContext(e).openRange = null, n;
};
Gi.prototype.runContextCheck = function(r) {
  var e = this, t = r.index;
  this.contextCheckers.forEach(function(n) {
    var i = n.contextName, a = e.getContext(i).openRange;
    if (!a && n.checkStart(r) && (a = new ix(t, null, i), e.getContext(i).openRange = a, e.dispatch("contextStart", [i, t])), a && n.checkEnd(r)) {
      var s = t - a.startIndex + 1, o = e.setEndOffset(s, i);
      e.dispatch("contextEnd", [i, o]);
    }
  });
};
Gi.prototype.tokenize = function(r) {
  this.tokens = [], this.resetContextsRanges();
  var e = Array.from(r);
  this.dispatch("start");
  for (var t = 0; t < e.length; t++) {
    var n = e[t], i = new Yo(e, t);
    this.dispatch("next", [i]), this.runContextCheck(i);
    var a = new sh(n);
    this.tokens.push(a), this.dispatch("newToken", [a, i]);
  }
  return this.dispatch("end", [this.tokens]), this.tokens;
};
function Sc(r) {
  return /[\u0600-\u065F\u066A-\u06D2\u06FA-\u06FF]/.test(r);
}
function dD(r) {
  return /[\u0630\u0690\u0621\u0631\u0661\u0671\u0622\u0632\u0672\u0692\u06C2\u0623\u0673\u0693\u06C3\u0624\u0694\u06C4\u0625\u0675\u0695\u06C5\u06E5\u0676\u0696\u06C6\u0627\u0677\u0697\u06C7\u0648\u0688\u0698\u06C8\u0689\u0699\u06C9\u068A\u06CA\u066B\u068B\u06CB\u068C\u068D\u06CD\u06FD\u068E\u06EE\u06FE\u062F\u068F\u06CF\u06EF]/.test(r);
}
function Bc(r) {
  return /[\u0600-\u0605\u060C-\u060E\u0610-\u061B\u061E\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED]/.test(r);
}
function Xm(r) {
  return /[A-z]/.test(r);
}
function Q$(r) {
  return /\s/.test(r);
}
function Ks(r) {
  this.font = r, this.features = {};
}
function Tf(r) {
  this.id = r.id, this.tag = r.tag, this.substitution = r.substitution;
}
function wg(r, e) {
  if (!r)
    return -1;
  switch (e.format) {
    case 1:
      return e.glyphs.indexOf(r);
    case 2:
      for (var t = e.ranges, n = 0; n < t.length; n++) {
        var i = t[n];
        if (r >= i.start && r <= i.end) {
          var a = r - i.start;
          return i.index + a;
        }
      }
      break;
    default:
      return -1;
  }
  return -1;
}
function Y$(r, e) {
  var t = wg(r, e.coverage);
  return t === -1 ? null : r + e.deltaGlyphId;
}
function X$(r, e) {
  var t = wg(r, e.coverage);
  return t === -1 ? null : e.substitute[t];
}
function gy(r, e) {
  for (var t = [], n = 0; n < r.length; n++) {
    var i = r[n], a = e.current;
    a = Array.isArray(a) ? a[0] : a;
    var s = wg(a, i);
    s !== -1 && t.push(s);
  }
  return t.length !== r.length ? -1 : t;
}
function J$(r, e) {
  var t = e.inputCoverage.length + e.lookaheadCoverage.length + e.backtrackCoverage.length;
  if (r.context.length < t)
    return [];
  var n = gy(
    e.inputCoverage,
    r
  );
  if (n === -1)
    return [];
  var i = e.inputCoverage.length - 1;
  if (r.lookahead.length < e.lookaheadCoverage.length)
    return [];
  for (var a = r.lookahead.slice(i); a.length && Bc(a[0].char); )
    a.shift();
  var s = new Yo(a, 0), o = gy(
    e.lookaheadCoverage,
    s
  ), l = [].concat(r.backtrack);
  for (l.reverse(); l.length && Bc(l[0].char); )
    l.shift();
  if (l.length < e.backtrackCoverage.length)
    return [];
  var u = new Yo(l, 0), c = gy(
    e.backtrackCoverage,
    u
  ), h = n.length === e.inputCoverage.length && o.length === e.lookaheadCoverage.length && c.length === e.backtrackCoverage.length, f = [];
  if (h)
    for (var p = 0; p < e.lookupRecords.length; p++)
      for (var m = e.lookupRecords[p], A = m.lookupListIndex, w = this.getLookupByIndex(A), x = 0; x < w.subtables.length; x++) {
        var E = w.subtables[x], T = this.getLookupMethod(w, E), D = this.getSubstitutionType(w, E);
        if (D === "12")
          for (var F = 0; F < n.length; F++) {
            var _ = r.get(F), L = T(_);
            L && f.push(L);
          }
      }
  return f;
}
function K$(r, e) {
  var t = r.current, n = wg(t, e.coverage);
  if (n === -1)
    return null;
  for (var i, a = e.ligatureSets[n], s = 0; s < a.length; s++) {
    i = a[s];
    for (var o = 0; o < i.components.length; o++) {
      var l = r.lookahead[o], u = i.components[o];
      if (l !== u)
        break;
      if (o === i.components.length - 1)
        return i;
    }
  }
  return null;
}
function Z$(r, e) {
  var t = wg(r, e.coverage);
  return t === -1 ? null : e.sequences[t];
}
Ks.prototype.getDefaultScriptFeaturesIndexes = function() {
  for (var r = this.font.tables.gsub.scripts, e = 0; e < r.length; e++) {
    var t = r[e];
    if (t.tag === "DFLT")
      return t.script.defaultLangSys.featureIndexes;
  }
  return [];
};
Ks.prototype.getScriptFeaturesIndexes = function(r) {
  var e = this.font.tables;
  if (!e.gsub)
    return [];
  if (!r)
    return this.getDefaultScriptFeaturesIndexes();
  for (var t = this.font.tables.gsub.scripts, n = 0; n < t.length; n++) {
    var i = t[n];
    if (i.tag === r && i.script.defaultLangSys)
      return i.script.defaultLangSys.featureIndexes;
    var a = i.langSysRecords;
    if (a)
      for (var s = 0; s < a.length; s++) {
        var o = a[s];
        if (o.tag === r) {
          var l = o.langSys;
          return l.featureIndexes;
        }
      }
  }
  return this.getDefaultScriptFeaturesIndexes();
};
Ks.prototype.mapTagsToFeatures = function(r, e) {
  for (var t = {}, n = 0; n < r.length; n++) {
    var i = r[n].tag, a = r[n].feature;
    t[i] = a;
  }
  this.features[e].tags = t;
};
Ks.prototype.getScriptFeatures = function(r) {
  var e = this.features[r];
  if (this.features.hasOwnProperty(r))
    return e;
  var t = this.getScriptFeaturesIndexes(r);
  if (!t)
    return null;
  var n = this.font.tables.gsub;
  return e = t.map(function(i) {
    return n.features[i];
  }), this.features[r] = e, this.mapTagsToFeatures(e, r), e;
};
Ks.prototype.getSubstitutionType = function(r, e) {
  var t = r.lookupType.toString(), n = e.substFormat.toString();
  return t + n;
};
Ks.prototype.getLookupMethod = function(r, e) {
  var t = this, n = this.getSubstitutionType(r, e);
  switch (n) {
    case "11":
      return function(i) {
        return Y$.apply(
          t,
          [i, e]
        );
      };
    case "12":
      return function(i) {
        return X$.apply(
          t,
          [i, e]
        );
      };
    case "63":
      return function(i) {
        return J$.apply(
          t,
          [i, e]
        );
      };
    case "41":
      return function(i) {
        return K$.apply(
          t,
          [i, e]
        );
      };
    case "21":
      return function(i) {
        return Z$.apply(
          t,
          [i, e]
        );
      };
    default:
      throw new Error(
        "lookupType: " + r.lookupType + " - substFormat: " + e.substFormat + " is not yet supported"
      );
  }
};
Ks.prototype.lookupFeature = function(r) {
  var e = r.contextParams, t = e.index, n = this.getFeature({
    tag: r.tag,
    script: r.script
  });
  if (!n)
    return new Error(
      "font '" + this.font.names.fullName.en + "' doesn't support feature '" + r.tag + "' for script '" + r.script + "'."
    );
  for (var i = this.getFeatureLookups(n), a = [].concat(e.context), s = 0; s < i.length; s++)
    for (var o = i[s], l = this.getLookupSubtables(o), u = 0; u < l.length; u++) {
      var c = l[u], h = this.getSubstitutionType(o, c), f = this.getLookupMethod(o, c), p = void 0;
      switch (h) {
        case "11":
          p = f(e.current), p && a.splice(t, 1, new Tf({
            id: 11,
            tag: r.tag,
            substitution: p
          }));
          break;
        case "12":
          p = f(e.current), p && a.splice(t, 1, new Tf({
            id: 12,
            tag: r.tag,
            substitution: p
          }));
          break;
        case "63":
          p = f(e), Array.isArray(p) && p.length && a.splice(t, 1, new Tf({
            id: 63,
            tag: r.tag,
            substitution: p
          }));
          break;
        case "41":
          p = f(e), p && a.splice(t, 1, new Tf({
            id: 41,
            tag: r.tag,
            substitution: p
          }));
          break;
        case "21":
          p = f(e.current), p && a.splice(t, 1, new Tf({
            id: 21,
            tag: r.tag,
            substitution: p
          }));
          break;
      }
      e = new Yo(a, t), !(Array.isArray(p) && !p.length) && (p = null);
    }
  return a.length ? a : null;
};
Ks.prototype.supports = function(r) {
  if (!r.script)
    return !1;
  this.getScriptFeatures(r.script);
  var e = this.features.hasOwnProperty(r.script);
  if (!r.tag)
    return e;
  var t = this.features[r.script].some(function(n) {
    return n.tag === r.tag;
  });
  return e && t;
};
Ks.prototype.getLookupSubtables = function(r) {
  return r.subtables || null;
};
Ks.prototype.getLookupByIndex = function(r) {
  var e = this.font.tables.gsub.lookups;
  return e[r] || null;
};
Ks.prototype.getFeatureLookups = function(r) {
  return r.lookupListIndexes.map(this.getLookupByIndex.bind(this));
};
Ks.prototype.getFeature = function(e) {
  if (!this.font)
    return { FAIL: "No font was found" };
  this.features.hasOwnProperty(e.script) || this.getScriptFeatures(e.script);
  var t = this.features[e.script];
  return t ? t.tags[e.tag] ? this.features[e.script].tags[e.tag] : null : { FAIL: "No feature for script " + e.script };
};
function ez(r) {
  var e = r.current, t = r.get(-1);
  return (
    // ? arabic first char
    t === null && Sc(e) || // ? arabic char preceded with a non arabic char
    !Sc(t) && Sc(e)
  );
}
function tz(r) {
  var e = r.get(1);
  return (
    // ? last arabic char
    e === null || // ? next char is not arabic
    !Sc(e)
  );
}
var rz = {
  startCheck: ez,
  endCheck: tz
};
function nz(r) {
  var e = r.current, t = r.get(-1);
  return (
    // ? an arabic char preceded with a non arabic char
    (Sc(e) || Bc(e)) && !Sc(t)
  );
}
function iz(r) {
  var e = r.get(1);
  switch (!0) {
    case e === null:
      return !0;
    case (!Sc(e) && !Bc(e)):
      var t = Q$(e);
      if (!t)
        return !0;
      if (t) {
        var n = !1;
        if (n = r.lookahead.some(
          function(i) {
            return Sc(i) || Bc(i);
          }
        ), !n)
          return !0;
      }
      break;
    default:
      return !1;
  }
}
var az = {
  startCheck: nz,
  endCheck: iz
};
function sz(r, e, t) {
  e[t].setState(r.tag, r.substitution);
}
function oz(r, e, t) {
  e[t].setState(r.tag, r.substitution);
}
function lz(r, e, t) {
  r.substitution.forEach(function(n, i) {
    var a = e[t + i];
    a.setState(r.tag, n);
  });
}
function uz(r, e, t) {
  var n = e[t];
  n.setState(r.tag, r.substitution.ligGlyph);
  for (var i = r.substitution.components.length, a = 0; a < i; a++)
    n = e[t + a + 1], n.setState("deleted", !0);
}
var l2 = {
  11: sz,
  12: oz,
  63: lz,
  41: uz
};
function ax(r, e, t) {
  r instanceof Tf && l2[r.id] && l2[r.id](r, e, t);
}
function cz(r) {
  for (var e = [].concat(r.backtrack), t = e.length - 1; t >= 0; t--) {
    var n = e[t], i = dD(n), a = Bc(n);
    if (!i && !a)
      return !0;
    if (i)
      return !1;
  }
  return !1;
}
function fz(r) {
  if (dD(r.current))
    return !1;
  for (var e = 0; e < r.lookahead.length; e++) {
    var t = r.lookahead[e], n = Bc(t);
    if (!n)
      return !0;
  }
  return !1;
}
function dz(r) {
  var e = this, t = "arab", n = this.featuresTags[t], i = this.tokenizer.getRangeTokens(r);
  if (i.length !== 1) {
    var a = new Yo(
      i.map(
        function(o) {
          return o.getState("glyphIndex");
        }
      ),
      0
    ), s = new Yo(
      i.map(
        function(o) {
          return o.char;
        }
      ),
      0
    );
    i.forEach(function(o, l) {
      if (!Bc(o.char)) {
        a.setCurrentIndex(l), s.setCurrentIndex(l);
        var u = 0;
        cz(s) && (u |= 1), fz(s) && (u |= 2);
        var c;
        switch (u) {
          case 1:
            c = "fina";
            break;
          case 2:
            c = "init";
            break;
          case 3:
            c = "medi";
            break;
        }
        if (n.indexOf(c) !== -1) {
          var h = e.query.lookupFeature({
            tag: c,
            script: t,
            contextParams: a
          });
          if (h instanceof Error)
            return console.info(h.message);
          h.forEach(function(f, p) {
            f instanceof Tf && (ax(f, i, p), a.context[p] = f.substitution);
          });
        }
      }
    });
  }
}
function u2(r, e) {
  var t = r.map(function(n) {
    return n.activeState.value;
  });
  return new Yo(t, 0);
}
function hz(r) {
  var e = this, t = "arab", n = this.tokenizer.getRangeTokens(r), i = u2(n);
  i.context.forEach(function(a, s) {
    i.setCurrentIndex(s);
    var o = e.query.lookupFeature({
      tag: "rlig",
      script: t,
      contextParams: i
    });
    o.length && (o.forEach(
      function(l) {
        return ax(l, n, s);
      }
    ), i = u2(n));
  });
}
function pz(r) {
  var e = r.current, t = r.get(-1);
  return (
    // ? latin first char
    t === null && Xm(e) || // ? latin char preceded with a non latin char
    !Xm(t) && Xm(e)
  );
}
function gz(r) {
  var e = r.get(1);
  return (
    // ? last latin char
    e === null || // ? next char is not latin
    !Xm(e)
  );
}
var mz = {
  startCheck: pz,
  endCheck: gz
};
function c2(r, e) {
  var t = r.map(function(n) {
    return n.activeState.value;
  });
  return new Yo(t, 0);
}
function vz(r) {
  var e = this, t = "latn", n = this.tokenizer.getRangeTokens(r), i = c2(n);
  i.context.forEach(function(a, s) {
    i.setCurrentIndex(s);
    var o = e.query.lookupFeature({
      tag: "liga",
      script: t,
      contextParams: i
    });
    o.length && (o.forEach(
      function(l) {
        return ax(l, n, s);
      }
    ), i = c2(n));
  });
}
function tl(r) {
  this.baseDir = r || "ltr", this.tokenizer = new Gi(), this.featuresTags = {};
}
tl.prototype.setText = function(r) {
  this.text = r;
};
tl.prototype.contextChecks = {
  latinWordCheck: mz,
  arabicWordCheck: rz,
  arabicSentenceCheck: az
};
function my(r) {
  var e = this.contextChecks[r + "Check"];
  return this.tokenizer.registerContextChecker(
    r,
    e.startCheck,
    e.endCheck
  );
}
function yz() {
  return my.call(this, "latinWord"), my.call(this, "arabicWord"), my.call(this, "arabicSentence"), this.tokenizer.tokenize(this.text);
}
function Az() {
  var r = this, e = this.tokenizer.getContextRanges("arabicSentence");
  e.forEach(function(t) {
    var n = r.tokenizer.getRangeTokens(t);
    r.tokenizer.replaceRange(
      t.startIndex,
      t.endOffset,
      n.reverse()
    );
  });
}
tl.prototype.registerFeatures = function(r, e) {
  var t = this, n = e.filter(
    function(i) {
      return t.query.supports({ script: r, tag: i });
    }
  );
  this.featuresTags.hasOwnProperty(r) ? this.featuresTags[r] = this.featuresTags[r].concat(n) : this.featuresTags[r] = n;
};
tl.prototype.applyFeatures = function(r, e) {
  if (!r)
    throw new Error(
      "No valid font was provided to apply features"
    );
  this.query || (this.query = new Ks(r));
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    this.query.supports({ script: n.script }) && this.registerFeatures(n.script, n.tags);
  }
};
tl.prototype.registerModifier = function(r, e, t) {
  this.tokenizer.registerModifier(r, e, t);
};
function sx() {
  if (this.tokenizer.registeredModifiers.indexOf("glyphIndex") === -1)
    throw new Error(
      "glyphIndex modifier is required to apply arabic presentation features."
    );
}
function wz() {
  var r = this, e = "arab";
  if (this.featuresTags.hasOwnProperty(e)) {
    sx.call(this);
    var t = this.tokenizer.getContextRanges("arabicWord");
    t.forEach(function(n) {
      dz.call(r, n);
    });
  }
}
function xz() {
  var r = this, e = "arab";
  if (this.featuresTags.hasOwnProperty(e)) {
    var t = this.featuresTags[e];
    if (t.indexOf("rlig") !== -1) {
      sx.call(this);
      var n = this.tokenizer.getContextRanges("arabicWord");
      n.forEach(function(i) {
        hz.call(r, i);
      });
    }
  }
}
function bz() {
  var r = this, e = "latn";
  if (this.featuresTags.hasOwnProperty(e)) {
    var t = this.featuresTags[e];
    if (t.indexOf("liga") !== -1) {
      sx.call(this);
      var n = this.tokenizer.getContextRanges("latinWord");
      n.forEach(function(i) {
        vz.call(r, i);
      });
    }
  }
}
tl.prototype.checkContextReady = function(r) {
  return !!this.tokenizer.getContext(r);
};
tl.prototype.applyFeaturesToContexts = function() {
  this.checkContextReady("arabicWord") && (wz.call(this), xz.call(this)), this.checkContextReady("latinWord") && bz.call(this), this.checkContextReady("arabicSentence") && Az.call(this);
};
tl.prototype.processText = function(r) {
  (!this.text || this.text !== r) && (this.setText(r), yz.call(this), this.applyFeaturesToContexts());
};
tl.prototype.getBidiText = function(r) {
  return this.processText(r), this.tokenizer.getText();
};
tl.prototype.getTextGlyphs = function(r) {
  this.processText(r);
  for (var e = [], t = 0; t < this.tokenizer.tokens.length; t++) {
    var n = this.tokenizer.tokens[t];
    if (!n.state.deleted) {
      var i = n.activeState.value;
      e.push(Array.isArray(i) ? i[0] : i);
    }
  }
  return e;
};
function fi(r) {
  r = r || {}, r.tables = r.tables || {}, r.empty || (qh(r.familyName, "When creating a new Font object, familyName is required."), qh(r.styleName, "When creating a new Font object, styleName is required."), qh(r.unitsPerEm, "When creating a new Font object, unitsPerEm is required."), qh(r.ascender, "When creating a new Font object, ascender is required."), qh(r.descender <= 0, "When creating a new Font object, negative descender value is required."), this.names = {
    fontFamily: { en: r.familyName || " " },
    fontSubfamily: { en: r.styleName || " " },
    fullName: { en: r.fullName || r.familyName + " " + r.styleName },
    // postScriptName may not contain any whitespace
    postScriptName: { en: r.postScriptName || (r.familyName + r.styleName).replace(/\s/g, "") },
    designer: { en: r.designer || " " },
    designerURL: { en: r.designerURL || " " },
    manufacturer: { en: r.manufacturer || " " },
    manufacturerURL: { en: r.manufacturerURL || " " },
    license: { en: r.license || " " },
    licenseURL: { en: r.licenseURL || " " },
    version: { en: r.version || "Version 0.1" },
    description: { en: r.description || " " },
    copyright: { en: r.copyright || " " },
    trademark: { en: r.trademark || " " }
  }, this.unitsPerEm = r.unitsPerEm || 1e3, this.ascender = r.ascender, this.descender = r.descender, this.createdTimestamp = r.createdTimestamp, this.tables = Object.assign(r.tables, {
    os2: Object.assign({
      usWeightClass: r.weightClass || this.usWeightClasses.MEDIUM,
      usWidthClass: r.widthClass || this.usWidthClasses.MEDIUM,
      fsSelection: r.fsSelection || this.fsSelectionValues.REGULAR
    }, r.tables.os2)
  })), this.supported = !0, this.glyphs = new _l.GlyphSet(this, r.glyphs || []), this.encoding = new DP(this), this.position = new vg(this), this.substitution = new Js(this), this.tables = this.tables || {}, this._push = null, this._hmtxTableData = {}, Object.defineProperty(this, "hinting", {
    get: function() {
      if (this._hinting)
        return this._hinting;
      if (this.outlinesFormat === "truetype")
        return this._hinting = new lD(this);
    }
  });
}
fi.prototype.hasChar = function(r) {
  return this.encoding.charToGlyphIndex(r) !== null;
};
fi.prototype.charToGlyphIndex = function(r) {
  return this.encoding.charToGlyphIndex(r);
};
fi.prototype.charToGlyph = function(r) {
  var e = this.charToGlyphIndex(r), t = this.glyphs.get(e);
  return t || (t = this.glyphs.get(0)), t;
};
fi.prototype.updateFeatures = function(r) {
  return this.defaultRenderOptions.features.map(function(e) {
    return e.script === "latn" ? {
      script: "latn",
      tags: e.tags.filter(function(t) {
        return r[t];
      })
    } : e;
  });
};
fi.prototype.stringToGlyphs = function(r, e) {
  var t = this, n = new tl(), i = function(h) {
    return t.charToGlyphIndex(h.char);
  };
  n.registerModifier("glyphIndex", null, i);
  var a = e ? this.updateFeatures(e.features) : this.defaultRenderOptions.features;
  n.applyFeatures(this, a);
  for (var s = n.getTextGlyphs(r), o = s.length, l = new Array(o), u = this.glyphs.get(0), c = 0; c < o; c += 1)
    l[c] = this.glyphs.get(s[c]) || u;
  return l;
};
fi.prototype.nameToGlyphIndex = function(r) {
  return this.glyphNames.nameToGlyphIndex(r);
};
fi.prototype.nameToGlyph = function(r) {
  var e = this.nameToGlyphIndex(r), t = this.glyphs.get(e);
  return t || (t = this.glyphs.get(0)), t;
};
fi.prototype.glyphIndexToName = function(r) {
  return this.glyphNames.glyphIndexToName ? this.glyphNames.glyphIndexToName(r) : "";
};
fi.prototype.getKerningValue = function(r, e) {
  r = r.index || r, e = e.index || e;
  var t = this.position.defaultKerningTables;
  return t ? this.position.getKerningValue(t, r, e) : this.kerningPairs[r + "," + e] || 0;
};
fi.prototype.defaultRenderOptions = {
  kerning: !0,
  features: [
    /**
     * these 4 features are required to render Arabic text properly
     * and shouldn't be turned off when rendering arabic text.
     */
    { script: "arab", tags: ["init", "medi", "fina", "rlig"] },
    { script: "latn", tags: ["liga", "rlig"] }
  ]
};
fi.prototype.forEachGlyph = function(r, e, t, n, i, a) {
  e = e !== void 0 ? e : 0, t = t !== void 0 ? t : 0, n = n !== void 0 ? n : 72, i = Object.assign({}, this.defaultRenderOptions, i);
  var s = 1 / this.unitsPerEm * n, o = this.stringToGlyphs(r, i), l;
  if (i.kerning) {
    var u = i.script || this.position.getDefaultScriptName();
    l = this.position.getKerningTables(u, i.language);
  }
  for (var c = 0; c < o.length; c += 1) {
    var h = o[c];
    if (a.call(this, h, e, t, n, i), h.advanceWidth && (e += h.advanceWidth * s), i.kerning && c < o.length - 1) {
      var f = l ? this.position.getKerningValue(l, h.index, o[c + 1].index) : this.getKerningValue(h, o[c + 1]);
      e += f * s;
    }
    i.letterSpacing ? e += i.letterSpacing * n : i.tracking && (e += i.tracking / 1e3 * n);
  }
  return e;
};
fi.prototype.getPath = function(r, e, t, n, i) {
  var a = new ha();
  return this.forEachGlyph(r, e, t, n, i, function(s, o, l, u) {
    var c = s.getPath(o, l, u, i, this);
    a.extend(c);
  }), a;
};
fi.prototype.getPaths = function(r, e, t, n, i) {
  var a = [];
  return this.forEachGlyph(r, e, t, n, i, function(s, o, l, u) {
    var c = s.getPath(o, l, u, i, this);
    a.push(c);
  }), a;
};
fi.prototype.getAdvanceWidth = function(r, e, t) {
  return this.forEachGlyph(r, 0, 0, e, t, function() {
  });
};
fi.prototype.draw = function(r, e, t, n, i, a) {
  this.getPath(e, t, n, i, a).draw(r);
};
fi.prototype.drawPoints = function(r, e, t, n, i, a) {
  this.forEachGlyph(e, t, n, i, a, function(s, o, l, u) {
    s.drawPoints(r, o, l, u);
  });
};
fi.prototype.drawMetrics = function(r, e, t, n, i, a) {
  this.forEachGlyph(e, t, n, i, a, function(s, o, l, u) {
    s.drawMetrics(r, o, l, u);
  });
};
fi.prototype.getEnglishName = function(r) {
  var e = this.names[r];
  if (e)
    return e.en;
};
fi.prototype.validate = function() {
  var r = this;
  function e(n, i) {
  }
  function t(n) {
    var i = r.getEnglishName(n);
    i && i.trim().length > 0;
  }
  t("fontFamily"), t("weightName"), t("manufacturer"), t("copyright"), t("version"), this.unitsPerEm > 0;
};
fi.prototype.toTables = function() {
  return uV.fontToTable(this);
};
fi.prototype.toBuffer = function() {
  return console.warn("Font.toBuffer is deprecated. Use Font.toArrayBuffer instead."), this.toArrayBuffer();
};
fi.prototype.toArrayBuffer = function() {
  for (var r = this.toTables(), e = r.encode(), t = new ArrayBuffer(e.length), n = new Uint8Array(t), i = 0; i < e.length; i++)
    n[i] = e[i];
  return t;
};
fi.prototype.download = function(r) {
  var e = this.getEnglishName("fontFamily"), t = this.getEnglishName("fontSubfamily");
  r = r || e.replace(/\s/g, "") + "-" + t + ".otf";
  var n = this.toArrayBuffer();
  if (fV())
    if (window.URL = window.URL || window.webkitURL, window.URL) {
      var i = new DataView(n), a = new Blob([i], { type: "font/opentype" }), s = document.createElement("a");
      s.href = window.URL.createObjectURL(a), s.download = r;
      var o = document.createEvent("MouseEvents");
      o.initEvent("click", !0, !1), s.dispatchEvent(o);
    } else
      console.warn("Font file could not be downloaded. Try using a different browser.");
  else {
    var l = require("fs"), u = dV(n);
    l.writeFileSync(r, u);
  }
};
fi.prototype.fsSelectionValues = {
  ITALIC: 1,
  //1
  UNDERSCORE: 2,
  //2
  NEGATIVE: 4,
  //4
  OUTLINED: 8,
  //8
  STRIKEOUT: 16,
  //16
  BOLD: 32,
  //32
  REGULAR: 64,
  //64
  USER_TYPO_METRICS: 128,
  //128
  WWS: 256,
  //256
  OBLIQUE: 512
  //512
};
fi.prototype.usWidthClasses = {
  ULTRA_CONDENSED: 1,
  EXTRA_CONDENSED: 2,
  CONDENSED: 3,
  SEMI_CONDENSED: 4,
  MEDIUM: 5,
  SEMI_EXPANDED: 6,
  EXPANDED: 7,
  EXTRA_EXPANDED: 8,
  ULTRA_EXPANDED: 9
};
fi.prototype.usWeightClasses = {
  THIN: 100,
  EXTRA_LIGHT: 200,
  LIGHT: 300,
  NORMAL: 400,
  MEDIUM: 500,
  SEMI_BOLD: 600,
  BOLD: 700,
  EXTRA_BOLD: 800,
  BLACK: 900
};
function hD(r, e) {
  var t = JSON.stringify(r), n = 256;
  for (var i in e) {
    var a = parseInt(i);
    if (!(!a || a < 256)) {
      if (JSON.stringify(e[i]) === t)
        return a;
      n <= a && (n = a + 1);
    }
  }
  return e[n] = r, n;
}
function Cz(r, e, t) {
  var n = hD(e.name, t);
  return [
    { name: "tag_" + r, type: "TAG", value: e.tag },
    { name: "minValue_" + r, type: "FIXED", value: e.minValue << 16 },
    { name: "defaultValue_" + r, type: "FIXED", value: e.defaultValue << 16 },
    { name: "maxValue_" + r, type: "FIXED", value: e.maxValue << 16 },
    { name: "flags_" + r, type: "USHORT", value: 0 },
    { name: "nameID_" + r, type: "USHORT", value: n }
  ];
}
function Sz(r, e, t) {
  var n = {}, i = new Ut.Parser(r, e);
  return n.tag = i.parseTag(), n.minValue = i.parseFixed(), n.defaultValue = i.parseFixed(), n.maxValue = i.parseFixed(), i.skip("uShort", 1), n.name = t[i.parseUShort()] || {}, n;
}
function Ez(r, e, t, n) {
  for (var i = hD(e.name, n), a = [
    { name: "nameID_" + r, type: "USHORT", value: i },
    { name: "flags_" + r, type: "USHORT", value: 0 }
  ], s = 0; s < t.length; ++s) {
    var o = t[s].tag;
    a.push({
      name: "axis_" + r + " " + o,
      type: "FIXED",
      value: e.coordinates[o] << 16
    });
  }
  return a;
}
function kz(r, e, t, n) {
  var i = {}, a = new Ut.Parser(r, e);
  i.name = n[a.parseUShort()] || {}, a.skip("uShort", 1), i.coordinates = {};
  for (var s = 0; s < t.length; ++s)
    i.coordinates[t[s].tag] = a.parseFixed();
  return i;
}
function Tz(r, e) {
  var t = new Dt.Table("fvar", [
    { name: "version", type: "ULONG", value: 65536 },
    { name: "offsetToData", type: "USHORT", value: 0 },
    { name: "countSizePairs", type: "USHORT", value: 2 },
    { name: "axisCount", type: "USHORT", value: r.axes.length },
    { name: "axisSize", type: "USHORT", value: 20 },
    { name: "instanceCount", type: "USHORT", value: r.instances.length },
    { name: "instanceSize", type: "USHORT", value: 4 + r.axes.length * 4 }
  ]);
  t.offsetToData = t.sizeOf();
  for (var n = 0; n < r.axes.length; n++)
    t.fields = t.fields.concat(Cz(n, r.axes[n], e));
  for (var i = 0; i < r.instances.length; i++)
    t.fields = t.fields.concat(Ez(i, r.instances[i], r.axes, e));
  return t;
}
function Fz(r, e, t) {
  var n = new Ut.Parser(r, e), i = n.parseULong();
  xr.argument(i === 65536, "Unsupported fvar table version.");
  var a = n.parseOffset16();
  n.skip("uShort", 1);
  for (var s = n.parseUShort(), o = n.parseUShort(), l = n.parseUShort(), u = n.parseUShort(), c = [], h = 0; h < s; h++)
    c.push(Sz(r, e + a + h * o, t));
  for (var f = [], p = e + a + s * o, m = 0; m < l; m++)
    f.push(kz(r, p + m * u, c, t));
  return { axes: c, instances: f };
}
var Iz = { make: Tz, parse: Fz }, Pz = function() {
  return {
    coverage: this.parsePointer(Be.coverage),
    attachPoints: this.parseList(Be.pointer(Be.uShortList))
  };
}, Dz = function() {
  var r = this.parseUShort();
  if (xr.argument(
    r === 1 || r === 2 || r === 3,
    "Unsupported CaretValue table version."
  ), r === 1)
    return { coordinate: this.parseShort() };
  if (r === 2)
    return { pointindex: this.parseShort() };
  if (r === 3)
    return { coordinate: this.parseShort() };
}, Rz = function() {
  return this.parseList(Be.pointer(Dz));
}, Oz = function() {
  return {
    coverage: this.parsePointer(Be.coverage),
    ligGlyphs: this.parseList(Be.pointer(Rz))
  };
}, Bz = function() {
  return this.parseUShort(), this.parseList(Be.pointer(Be.coverage));
};
function _z(r, e) {
  e = e || 0;
  var t = new Be(r, e), n = t.parseVersion(1);
  xr.argument(
    n === 1 || n === 1.2 || n === 1.3,
    "Unsupported GDEF table version."
  );
  var i = {
    version: n,
    classDef: t.parsePointer(Be.classDef),
    attachList: t.parsePointer(Pz),
    ligCaretList: t.parsePointer(Oz),
    markAttachClassDef: t.parsePointer(Be.classDef)
  };
  return n >= 1.2 && (i.markGlyphSets = t.parsePointer(Bz)), i;
}
var Mz = { parse: _z }, Xo = new Array(10);
Xo[1] = function() {
  var e = this.offset + this.relativeOffset, t = this.parseUShort();
  if (t === 1)
    return {
      posFormat: 1,
      coverage: this.parsePointer(Be.coverage),
      value: this.parseValueRecord()
    };
  if (t === 2)
    return {
      posFormat: 2,
      coverage: this.parsePointer(Be.coverage),
      values: this.parseValueRecordList()
    };
  xr.assert(!1, "0x" + e.toString(16) + ": GPOS lookup type 1 format must be 1 or 2.");
};
Xo[2] = function() {
  var e = this.offset + this.relativeOffset, t = this.parseUShort();
  xr.assert(t === 1 || t === 2, "0x" + e.toString(16) + ": GPOS lookup type 2 format must be 1 or 2.");
  var n = this.parsePointer(Be.coverage), i = this.parseUShort(), a = this.parseUShort();
  if (t === 1)
    return {
      posFormat: t,
      coverage: n,
      valueFormat1: i,
      valueFormat2: a,
      pairSets: this.parseList(Be.pointer(Be.list(function() {
        return {
          // pairValueRecord
          secondGlyph: this.parseUShort(),
          value1: this.parseValueRecord(i),
          value2: this.parseValueRecord(a)
        };
      })))
    };
  if (t === 2) {
    var s = this.parsePointer(Be.classDef), o = this.parsePointer(Be.classDef), l = this.parseUShort(), u = this.parseUShort();
    return {
      // Class Pair Adjustment
      posFormat: t,
      coverage: n,
      valueFormat1: i,
      valueFormat2: a,
      classDef1: s,
      classDef2: o,
      class1Count: l,
      class2Count: u,
      classRecords: this.parseList(l, Be.list(u, function() {
        return {
          value1: this.parseValueRecord(i),
          value2: this.parseValueRecord(a)
        };
      }))
    };
  }
};
Xo[3] = function() {
  return { error: "GPOS Lookup 3 not supported" };
};
Xo[4] = function() {
  return { error: "GPOS Lookup 4 not supported" };
};
Xo[5] = function() {
  return { error: "GPOS Lookup 5 not supported" };
};
Xo[6] = function() {
  return { error: "GPOS Lookup 6 not supported" };
};
Xo[7] = function() {
  return { error: "GPOS Lookup 7 not supported" };
};
Xo[8] = function() {
  return { error: "GPOS Lookup 8 not supported" };
};
Xo[9] = function() {
  return { error: "GPOS Lookup 9 not supported" };
};
function Nz(r, e) {
  e = e || 0;
  var t = new Be(r, e), n = t.parseVersion(1);
  return xr.argument(n === 1 || n === 1.1, "Unsupported GPOS table version " + n), n === 1 ? {
    version: n,
    scripts: t.parseScriptList(),
    features: t.parseFeatureList(),
    lookups: t.parseLookupList(Xo)
  } : {
    version: n,
    scripts: t.parseScriptList(),
    features: t.parseFeatureList(),
    lookups: t.parseLookupList(Xo),
    variations: t.parseFeatureVariationsList()
  };
}
var Lz = new Array(10);
function Uz(r) {
  return new Dt.Table("GPOS", [
    { name: "version", type: "ULONG", value: 65536 },
    { name: "scripts", type: "TABLE", value: new Dt.ScriptList(r.scripts) },
    { name: "features", type: "TABLE", value: new Dt.FeatureList(r.features) },
    { name: "lookups", type: "TABLE", value: new Dt.LookupList(r.lookups, Lz) }
  ]);
}
var Vz = { parse: Nz, make: Uz };
function $z(r) {
  var e = {};
  r.skip("uShort");
  var t = r.parseUShort();
  xr.argument(t === 0, "Unsupported kern sub-table version."), r.skip("uShort", 2);
  var n = r.parseUShort();
  r.skip("uShort", 3);
  for (var i = 0; i < n; i += 1) {
    var a = r.parseUShort(), s = r.parseUShort(), o = r.parseShort();
    e[a + "," + s] = o;
  }
  return e;
}
function zz(r) {
  var e = {};
  r.skip("uShort");
  var t = r.parseULong();
  t > 1 && console.warn("Only the first kern subtable is supported."), r.skip("uLong");
  var n = r.parseUShort(), i = n & 255;
  if (r.skip("uShort"), i === 0) {
    var a = r.parseUShort();
    r.skip("uShort", 3);
    for (var s = 0; s < a; s += 1) {
      var o = r.parseUShort(), l = r.parseUShort(), u = r.parseShort();
      e[o + "," + l] = u;
    }
  }
  return e;
}
function Gz(r, e) {
  var t = new Ut.Parser(r, e), n = t.parseUShort();
  if (n === 0)
    return $z(t);
  if (n === 1)
    return zz(t);
  throw new Error("Unsupported kern table version (" + n + ").");
}
var Hz = { parse: Gz };
function Wz(r, e, t, n) {
  for (var i = new Ut.Parser(r, e), a = n ? i.parseUShort : i.parseULong, s = [], o = 0; o < t + 1; o += 1) {
    var l = a.call(i);
    n && (l *= 2), s.push(l);
  }
  return s;
}
var jz = { parse: Wz };
function f2(r, e) {
  for (var t = [], n = 12, i = 0; i < e; i += 1) {
    var a = Ut.getTag(r, n), s = Ut.getULong(r, n + 4), o = Ut.getULong(r, n + 8), l = Ut.getULong(r, n + 12);
    t.push({ tag: a, checksum: s, offset: o, length: l, compression: !1 }), n += 16;
  }
  return t;
}
function qz(r, e) {
  for (var t = [], n = 44, i = 0; i < e; i += 1) {
    var a = Ut.getTag(r, n), s = Ut.getULong(r, n + 4), o = Ut.getULong(r, n + 8), l = Ut.getULong(r, n + 12), u = void 0;
    o < l ? u = "WOFF" : u = !1, t.push({
      tag: a,
      offset: s,
      compression: u,
      compressedLength: o,
      length: l
    }), n += 20;
  }
  return t;
}
function Xi(r, e) {
  if (e.compression === "WOFF") {
    var t = new Uint8Array(r.buffer, e.offset + 2, e.compressedLength - 2), n = new Uint8Array(e.length);
    if (VU(t, n), n.byteLength !== e.length)
      throw new Error("Decompression error: " + e.tag + " decompressed length doesn't match recorded length");
    var i = new DataView(n.buffer, 0);
    return { data: i, offset: 0 };
  } else
    return { data: r, offset: e.offset };
}
function V1(r, e) {
  e = e ?? {};
  var t, n, i = new fi({ empty: !0 }), a = new DataView(r, 0), s, o = [], l = Ut.getTag(a, 0);
  if (l === "\0\0\0" || l === "true" || l === "typ1")
    i.outlinesFormat = "truetype", s = Ut.getUShort(a, 4), o = f2(a, s);
  else if (l === "OTTO")
    i.outlinesFormat = "cff", s = Ut.getUShort(a, 4), o = f2(a, s);
  else if (l === "wOFF") {
    var u = Ut.getTag(a, 4);
    if (u === "\0\0\0")
      i.outlinesFormat = "truetype";
    else if (u === "OTTO")
      i.outlinesFormat = "cff";
    else
      throw new Error("Unsupported OpenType flavor " + l);
    s = Ut.getUShort(a, 12), o = qz(a, s);
  } else
    throw new Error("Unsupported OpenType signature " + l);
  for (var c, h, f, p, m, A, w, x, E, T, D, F, _ = 0; _ < s; _ += 1) {
    var L = o[_], Z = void 0;
    switch (L.tag) {
      case "cmap":
        Z = Xi(a, L), i.tables.cmap = PP.parse(Z.data, Z.offset), i.encoding = new RP(i.tables.cmap);
        break;
      case "cvt ":
        Z = Xi(a, L), F = new Ut.Parser(Z.data, Z.offset), i.tables.cvt = F.parseShortList(L.length / 2);
        break;
      case "fvar":
        h = L;
        break;
      case "fpgm":
        Z = Xi(a, L), F = new Ut.Parser(Z.data, Z.offset), i.tables.fpgm = F.parseByteList(L.length);
        break;
      case "head":
        Z = Xi(a, L), i.tables.head = zP.parse(Z.data, Z.offset), i.unitsPerEm = i.tables.head.unitsPerEm, t = i.tables.head.indexToLocFormat;
        break;
      case "hhea":
        Z = Xi(a, L), i.tables.hhea = GP.parse(Z.data, Z.offset), i.ascender = i.tables.hhea.ascender, i.descender = i.tables.hhea.descender, i.numberOfHMetrics = i.tables.hhea.numberOfHMetrics;
        break;
      case "hmtx":
        w = L;
        break;
      case "ltag":
        Z = Xi(a, L), n = WP.parse(Z.data, Z.offset);
        break;
      case "maxp":
        Z = Xi(a, L), i.tables.maxp = jP.parse(Z.data, Z.offset), i.numGlyphs = i.tables.maxp.numGlyphs;
        break;
      case "name":
        T = L;
        break;
      case "OS/2":
        Z = Xi(a, L), i.tables.os2 = L1.parse(Z.data, Z.offset);
        break;
      case "post":
        Z = Xi(a, L), i.tables.post = KP.parse(Z.data, Z.offset), i.glyphNames = new ex(i.tables.post);
        break;
      case "prep":
        Z = Xi(a, L), F = new Ut.Parser(Z.data, Z.offset), i.tables.prep = F.parseByteList(L.length);
        break;
      case "glyf":
        f = L;
        break;
      case "loca":
        E = L;
        break;
      case "CFF ":
        c = L;
        break;
      case "kern":
        x = L;
        break;
      case "GDEF":
        p = L;
        break;
      case "GPOS":
        m = L;
        break;
      case "GSUB":
        A = L;
        break;
      case "meta":
        D = L;
        break;
    }
  }
  var te = Xi(a, T);
  if (i.tables.name = JP.parse(te.data, te.offset, n), i.names = i.tables.name, f && E) {
    var de = t === 0, H = Xi(a, E), j = jz.parse(H.data, H.offset, i.numGlyphs, de), q = Xi(a, f);
    i.glyphs = aD.parse(q.data, q.offset, j, i, e);
  } else if (c) {
    var re = Xi(a, c);
    $P.parse(re.data, re.offset, i, e);
  } else
    throw new Error("Font doesn't contain TrueType or CFF outlines.");
  var ae = Xi(a, w);
  if (HP.parse(i, ae.data, ae.offset, i.numberOfHMetrics, i.numGlyphs, i.glyphs, e), o9(i, e), x) {
    var ye = Xi(a, x);
    i.kerningPairs = Hz.parse(ye.data, ye.offset);
  } else
    i.kerningPairs = {};
  if (p) {
    var Se = Xi(a, p);
    i.tables.gdef = Mz.parse(Se.data, Se.offset);
  }
  if (m) {
    var Xe = Xi(a, m);
    i.tables.gpos = Vz.parse(Xe.data, Xe.offset), i.position.init();
  }
  if (A) {
    var Ve = Xi(a, A);
    i.tables.gsub = ZP.parse(Ve.data, Ve.offset);
  }
  if (h) {
    var He = Xi(a, h);
    i.tables.fvar = Iz.parse(He.data, He.offset, i.names);
  }
  if (D) {
    var le = Xi(a, D);
    i.tables.meta = eD.parse(le.data, le.offset), i.metas = i.tables.meta;
  }
  return i;
}
var kd = function() {
  return kd = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, kd.apply(this, arguments);
}, Qz = "~", Yz = "~~";
function ox(r, e) {
  for (var t = {}, n = {}, i = r.split(Yz), a = !1, s = 0; i.length > s; s++) {
    for (var o = i[s].split(Qz), l = 0; l < o.length; l += 2) {
      var u = o[l], c = o[l + 1], h = "&" + u + ";";
      t[h] = c, a && (t["&" + u] = c), n[c] = h;
    }
    a = !0;
  }
  return e ? { entities: kd(kd({}, t), e.entities), characters: kd(kd({}, n), e.characters) } : { entities: t, characters: n };
}
var vy = {
  xml: /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
  html4: /&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
  html5: /&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g
}, Hd = {};
Hd.xml = ox(`lt~<~gt~>~quot~"~apos~'~amp~&`);
Hd.html4 = ox(`apos~'~OElig~Œ~oelig~œ~Scaron~Š~scaron~š~Yuml~Ÿ~circ~ˆ~tilde~˜~ensp~ ~emsp~ ~thinsp~ ~zwnj~‌~zwj~‍~lrm~‎~rlm~‏~ndash~–~mdash~—~lsquo~‘~rsquo~’~sbquo~‚~ldquo~“~rdquo~”~bdquo~„~dagger~†~Dagger~‡~permil~‰~lsaquo~‹~rsaquo~›~euro~€~fnof~ƒ~Alpha~Α~Beta~Β~Gamma~Γ~Delta~Δ~Epsilon~Ε~Zeta~Ζ~Eta~Η~Theta~Θ~Iota~Ι~Kappa~Κ~Lambda~Λ~Mu~Μ~Nu~Ν~Xi~Ξ~Omicron~Ο~Pi~Π~Rho~Ρ~Sigma~Σ~Tau~Τ~Upsilon~Υ~Phi~Φ~Chi~Χ~Psi~Ψ~Omega~Ω~alpha~α~beta~β~gamma~γ~delta~δ~epsilon~ε~zeta~ζ~eta~η~theta~θ~iota~ι~kappa~κ~lambda~λ~mu~μ~nu~ν~xi~ξ~omicron~ο~pi~π~rho~ρ~sigmaf~ς~sigma~σ~tau~τ~upsilon~υ~phi~φ~chi~χ~psi~ψ~omega~ω~thetasym~ϑ~upsih~ϒ~piv~ϖ~bull~•~hellip~…~prime~′~Prime~″~oline~‾~frasl~⁄~weierp~℘~image~ℑ~real~ℜ~trade~™~alefsym~ℵ~larr~←~uarr~↑~rarr~→~darr~↓~harr~↔~crarr~↵~lArr~⇐~uArr~⇑~rArr~⇒~dArr~⇓~hArr~⇔~forall~∀~part~∂~exist~∃~empty~∅~nabla~∇~isin~∈~notin~∉~ni~∋~prod~∏~sum~∑~minus~−~lowast~∗~radic~√~prop~∝~infin~∞~ang~∠~and~∧~or~∨~cap~∩~cup~∪~int~∫~there4~∴~sim~∼~cong~≅~asymp~≈~ne~≠~equiv~≡~le~≤~ge~≥~sub~⊂~sup~⊃~nsub~⊄~sube~⊆~supe~⊇~oplus~⊕~otimes~⊗~perp~⊥~sdot~⋅~lceil~⌈~rceil~⌉~lfloor~⌊~rfloor~⌋~lang~〈~rang~〉~loz~◊~spades~♠~clubs~♣~hearts~♥~diams~♦~~nbsp~ ~iexcl~¡~cent~¢~pound~£~curren~¤~yen~¥~brvbar~¦~sect~§~uml~¨~copy~©~ordf~ª~laquo~«~not~¬~shy~­~reg~®~macr~¯~deg~°~plusmn~±~sup2~²~sup3~³~acute~´~micro~µ~para~¶~middot~·~cedil~¸~sup1~¹~ordm~º~raquo~»~frac14~¼~frac12~½~frac34~¾~iquest~¿~Agrave~À~Aacute~Á~Acirc~Â~Atilde~Ã~Auml~Ä~Aring~Å~AElig~Æ~Ccedil~Ç~Egrave~È~Eacute~É~Ecirc~Ê~Euml~Ë~Igrave~Ì~Iacute~Í~Icirc~Î~Iuml~Ï~ETH~Ð~Ntilde~Ñ~Ograve~Ò~Oacute~Ó~Ocirc~Ô~Otilde~Õ~Ouml~Ö~times~×~Oslash~Ø~Ugrave~Ù~Uacute~Ú~Ucirc~Û~Uuml~Ü~Yacute~Ý~THORN~Þ~szlig~ß~agrave~à~aacute~á~acirc~â~atilde~ã~auml~ä~aring~å~aelig~æ~ccedil~ç~egrave~è~eacute~é~ecirc~ê~euml~ë~igrave~ì~iacute~í~icirc~î~iuml~ï~eth~ð~ntilde~ñ~ograve~ò~oacute~ó~ocirc~ô~otilde~õ~ouml~ö~divide~÷~oslash~ø~ugrave~ù~uacute~ú~ucirc~û~uuml~ü~yacute~ý~thorn~þ~yuml~ÿ~quot~"~amp~&~lt~<~gt~>`);
Hd.html5 = ox('Abreve~Ă~Acy~А~Afr~𝔄~Amacr~Ā~And~⩓~Aogon~Ą~Aopf~𝔸~ApplyFunction~⁡~Ascr~𝒜~Assign~≔~Backslash~∖~Barv~⫧~Barwed~⌆~Bcy~Б~Because~∵~Bernoullis~ℬ~Bfr~𝔅~Bopf~𝔹~Breve~˘~Bscr~ℬ~Bumpeq~≎~CHcy~Ч~Cacute~Ć~Cap~⋒~CapitalDifferentialD~ⅅ~Cayleys~ℭ~Ccaron~Č~Ccirc~Ĉ~Cconint~∰~Cdot~Ċ~Cedilla~¸~CenterDot~·~Cfr~ℭ~CircleDot~⊙~CircleMinus~⊖~CirclePlus~⊕~CircleTimes~⊗~ClockwiseContourIntegral~∲~CloseCurlyDoubleQuote~”~CloseCurlyQuote~’~Colon~∷~Colone~⩴~Congruent~≡~Conint~∯~ContourIntegral~∮~Copf~ℂ~Coproduct~∐~CounterClockwiseContourIntegral~∳~Cross~⨯~Cscr~𝒞~Cup~⋓~CupCap~≍~DD~ⅅ~DDotrahd~⤑~DJcy~Ђ~DScy~Ѕ~DZcy~Џ~Darr~↡~Dashv~⫤~Dcaron~Ď~Dcy~Д~Del~∇~Dfr~𝔇~DiacriticalAcute~´~DiacriticalDot~˙~DiacriticalDoubleAcute~˝~DiacriticalGrave~`~DiacriticalTilde~˜~Diamond~⋄~DifferentialD~ⅆ~Dopf~𝔻~Dot~¨~DotDot~⃜~DotEqual~≐~DoubleContourIntegral~∯~DoubleDot~¨~DoubleDownArrow~⇓~DoubleLeftArrow~⇐~DoubleLeftRightArrow~⇔~DoubleLeftTee~⫤~DoubleLongLeftArrow~⟸~DoubleLongLeftRightArrow~⟺~DoubleLongRightArrow~⟹~DoubleRightArrow~⇒~DoubleRightTee~⊨~DoubleUpArrow~⇑~DoubleUpDownArrow~⇕~DoubleVerticalBar~∥~DownArrow~↓~DownArrowBar~⤓~DownArrowUpArrow~⇵~DownBreve~̑~DownLeftRightVector~⥐~DownLeftTeeVector~⥞~DownLeftVector~↽~DownLeftVectorBar~⥖~DownRightTeeVector~⥟~DownRightVector~⇁~DownRightVectorBar~⥗~DownTee~⊤~DownTeeArrow~↧~Downarrow~⇓~Dscr~𝒟~Dstrok~Đ~ENG~Ŋ~Ecaron~Ě~Ecy~Э~Edot~Ė~Efr~𝔈~Element~∈~Emacr~Ē~EmptySmallSquare~◻~EmptyVerySmallSquare~▫~Eogon~Ę~Eopf~𝔼~Equal~⩵~EqualTilde~≂~Equilibrium~⇌~Escr~ℰ~Esim~⩳~Exists~∃~ExponentialE~ⅇ~Fcy~Ф~Ffr~𝔉~FilledSmallSquare~◼~FilledVerySmallSquare~▪~Fopf~𝔽~ForAll~∀~Fouriertrf~ℱ~Fscr~ℱ~GJcy~Ѓ~Gammad~Ϝ~Gbreve~Ğ~Gcedil~Ģ~Gcirc~Ĝ~Gcy~Г~Gdot~Ġ~Gfr~𝔊~Gg~⋙~Gopf~𝔾~GreaterEqual~≥~GreaterEqualLess~⋛~GreaterFullEqual~≧~GreaterGreater~⪢~GreaterLess~≷~GreaterSlantEqual~⩾~GreaterTilde~≳~Gscr~𝒢~Gt~≫~HARDcy~Ъ~Hacek~ˇ~Hat~^~Hcirc~Ĥ~Hfr~ℌ~HilbertSpace~ℋ~Hopf~ℍ~HorizontalLine~─~Hscr~ℋ~Hstrok~Ħ~HumpDownHump~≎~HumpEqual~≏~IEcy~Е~IJlig~Ĳ~IOcy~Ё~Icy~И~Idot~İ~Ifr~ℑ~Im~ℑ~Imacr~Ī~ImaginaryI~ⅈ~Implies~⇒~Int~∬~Integral~∫~Intersection~⋂~InvisibleComma~⁣~InvisibleTimes~⁢~Iogon~Į~Iopf~𝕀~Iscr~ℐ~Itilde~Ĩ~Iukcy~І~Jcirc~Ĵ~Jcy~Й~Jfr~𝔍~Jopf~𝕁~Jscr~𝒥~Jsercy~Ј~Jukcy~Є~KHcy~Х~KJcy~Ќ~Kcedil~Ķ~Kcy~К~Kfr~𝔎~Kopf~𝕂~Kscr~𝒦~LJcy~Љ~Lacute~Ĺ~Lang~⟪~Laplacetrf~ℒ~Larr~↞~Lcaron~Ľ~Lcedil~Ļ~Lcy~Л~LeftAngleBracket~⟨~LeftArrow~←~LeftArrowBar~⇤~LeftArrowRightArrow~⇆~LeftCeiling~⌈~LeftDoubleBracket~⟦~LeftDownTeeVector~⥡~LeftDownVector~⇃~LeftDownVectorBar~⥙~LeftFloor~⌊~LeftRightArrow~↔~LeftRightVector~⥎~LeftTee~⊣~LeftTeeArrow~↤~LeftTeeVector~⥚~LeftTriangle~⊲~LeftTriangleBar~⧏~LeftTriangleEqual~⊴~LeftUpDownVector~⥑~LeftUpTeeVector~⥠~LeftUpVector~↿~LeftUpVectorBar~⥘~LeftVector~↼~LeftVectorBar~⥒~Leftarrow~⇐~Leftrightarrow~⇔~LessEqualGreater~⋚~LessFullEqual~≦~LessGreater~≶~LessLess~⪡~LessSlantEqual~⩽~LessTilde~≲~Lfr~𝔏~Ll~⋘~Lleftarrow~⇚~Lmidot~Ŀ~LongLeftArrow~⟵~LongLeftRightArrow~⟷~LongRightArrow~⟶~Longleftarrow~⟸~Longleftrightarrow~⟺~Longrightarrow~⟹~Lopf~𝕃~LowerLeftArrow~↙~LowerRightArrow~↘~Lscr~ℒ~Lsh~↰~Lstrok~Ł~Lt~≪~Map~⤅~Mcy~М~MediumSpace~ ~Mellintrf~ℳ~Mfr~𝔐~MinusPlus~∓~Mopf~𝕄~Mscr~ℳ~NJcy~Њ~Nacute~Ń~Ncaron~Ň~Ncedil~Ņ~Ncy~Н~NegativeMediumSpace~​~NegativeThickSpace~​~NegativeThinSpace~​~NegativeVeryThinSpace~​~NestedGreaterGreater~≫~NestedLessLess~≪~NewLine~\n~Nfr~𝔑~NoBreak~⁠~NonBreakingSpace~ ~Nopf~ℕ~Not~⫬~NotCongruent~≢~NotCupCap~≭~NotDoubleVerticalBar~∦~NotElement~∉~NotEqual~≠~NotEqualTilde~≂̸~NotExists~∄~NotGreater~≯~NotGreaterEqual~≱~NotGreaterFullEqual~≧̸~NotGreaterGreater~≫̸~NotGreaterLess~≹~NotGreaterSlantEqual~⩾̸~NotGreaterTilde~≵~NotHumpDownHump~≎̸~NotHumpEqual~≏̸~NotLeftTriangle~⋪~NotLeftTriangleBar~⧏̸~NotLeftTriangleEqual~⋬~NotLess~≮~NotLessEqual~≰~NotLessGreater~≸~NotLessLess~≪̸~NotLessSlantEqual~⩽̸~NotLessTilde~≴~NotNestedGreaterGreater~⪢̸~NotNestedLessLess~⪡̸~NotPrecedes~⊀~NotPrecedesEqual~⪯̸~NotPrecedesSlantEqual~⋠~NotReverseElement~∌~NotRightTriangle~⋫~NotRightTriangleBar~⧐̸~NotRightTriangleEqual~⋭~NotSquareSubset~⊏̸~NotSquareSubsetEqual~⋢~NotSquareSuperset~⊐̸~NotSquareSupersetEqual~⋣~NotSubset~⊂⃒~NotSubsetEqual~⊈~NotSucceeds~⊁~NotSucceedsEqual~⪰̸~NotSucceedsSlantEqual~⋡~NotSucceedsTilde~≿̸~NotSuperset~⊃⃒~NotSupersetEqual~⊉~NotTilde~≁~NotTildeEqual~≄~NotTildeFullEqual~≇~NotTildeTilde~≉~NotVerticalBar~∤~Nscr~𝒩~Ocy~О~Odblac~Ő~Ofr~𝔒~Omacr~Ō~Oopf~𝕆~OpenCurlyDoubleQuote~“~OpenCurlyQuote~‘~Or~⩔~Oscr~𝒪~Otimes~⨷~OverBar~‾~OverBrace~⏞~OverBracket~⎴~OverParenthesis~⏜~PartialD~∂~Pcy~П~Pfr~𝔓~PlusMinus~±~Poincareplane~ℌ~Popf~ℙ~Pr~⪻~Precedes~≺~PrecedesEqual~⪯~PrecedesSlantEqual~≼~PrecedesTilde~≾~Product~∏~Proportion~∷~Proportional~∝~Pscr~𝒫~Qfr~𝔔~Qopf~ℚ~Qscr~𝒬~RBarr~⤐~Racute~Ŕ~Rang~⟫~Rarr~↠~Rarrtl~⤖~Rcaron~Ř~Rcedil~Ŗ~Rcy~Р~Re~ℜ~ReverseElement~∋~ReverseEquilibrium~⇋~ReverseUpEquilibrium~⥯~Rfr~ℜ~RightAngleBracket~⟩~RightArrow~→~RightArrowBar~⇥~RightArrowLeftArrow~⇄~RightCeiling~⌉~RightDoubleBracket~⟧~RightDownTeeVector~⥝~RightDownVector~⇂~RightDownVectorBar~⥕~RightFloor~⌋~RightTee~⊢~RightTeeArrow~↦~RightTeeVector~⥛~RightTriangle~⊳~RightTriangleBar~⧐~RightTriangleEqual~⊵~RightUpDownVector~⥏~RightUpTeeVector~⥜~RightUpVector~↾~RightUpVectorBar~⥔~RightVector~⇀~RightVectorBar~⥓~Rightarrow~⇒~Ropf~ℝ~RoundImplies~⥰~Rrightarrow~⇛~Rscr~ℛ~Rsh~↱~RuleDelayed~⧴~SHCHcy~Щ~SHcy~Ш~SOFTcy~Ь~Sacute~Ś~Sc~⪼~Scedil~Ş~Scirc~Ŝ~Scy~С~Sfr~𝔖~ShortDownArrow~↓~ShortLeftArrow~←~ShortRightArrow~→~ShortUpArrow~↑~SmallCircle~∘~Sopf~𝕊~Sqrt~√~Square~□~SquareIntersection~⊓~SquareSubset~⊏~SquareSubsetEqual~⊑~SquareSuperset~⊐~SquareSupersetEqual~⊒~SquareUnion~⊔~Sscr~𝒮~Star~⋆~Sub~⋐~Subset~⋐~SubsetEqual~⊆~Succeeds~≻~SucceedsEqual~⪰~SucceedsSlantEqual~≽~SucceedsTilde~≿~SuchThat~∋~Sum~∑~Sup~⋑~Superset~⊃~SupersetEqual~⊇~Supset~⋑~TRADE~™~TSHcy~Ћ~TScy~Ц~Tab~	~Tcaron~Ť~Tcedil~Ţ~Tcy~Т~Tfr~𝔗~Therefore~∴~ThickSpace~  ~ThinSpace~ ~Tilde~∼~TildeEqual~≃~TildeFullEqual~≅~TildeTilde~≈~Topf~𝕋~TripleDot~⃛~Tscr~𝒯~Tstrok~Ŧ~Uarr~↟~Uarrocir~⥉~Ubrcy~Ў~Ubreve~Ŭ~Ucy~У~Udblac~Ű~Ufr~𝔘~Umacr~Ū~UnderBar~_~UnderBrace~⏟~UnderBracket~⎵~UnderParenthesis~⏝~Union~⋃~UnionPlus~⊎~Uogon~Ų~Uopf~𝕌~UpArrow~↑~UpArrowBar~⤒~UpArrowDownArrow~⇅~UpDownArrow~↕~UpEquilibrium~⥮~UpTee~⊥~UpTeeArrow~↥~Uparrow~⇑~Updownarrow~⇕~UpperLeftArrow~↖~UpperRightArrow~↗~Upsi~ϒ~Uring~Ů~Uscr~𝒰~Utilde~Ũ~VDash~⊫~Vbar~⫫~Vcy~В~Vdash~⊩~Vdashl~⫦~Vee~⋁~Verbar~‖~Vert~‖~VerticalBar~∣~VerticalLine~|~VerticalSeparator~❘~VerticalTilde~≀~VeryThinSpace~ ~Vfr~𝔙~Vopf~𝕍~Vscr~𝒱~Vvdash~⊪~Wcirc~Ŵ~Wedge~⋀~Wfr~𝔚~Wopf~𝕎~Wscr~𝒲~Xfr~𝔛~Xopf~𝕏~Xscr~𝒳~YAcy~Я~YIcy~Ї~YUcy~Ю~Ycirc~Ŷ~Ycy~Ы~Yfr~𝔜~Yopf~𝕐~Yscr~𝒴~ZHcy~Ж~Zacute~Ź~Zcaron~Ž~Zcy~З~Zdot~Ż~ZeroWidthSpace~​~Zfr~ℨ~Zopf~ℤ~Zscr~𝒵~abreve~ă~ac~∾~acE~∾̳~acd~∿~acy~а~af~⁡~afr~𝔞~aleph~ℵ~amacr~ā~amalg~⨿~andand~⩕~andd~⩜~andslope~⩘~andv~⩚~ange~⦤~angle~∠~angmsd~∡~angmsdaa~⦨~angmsdab~⦩~angmsdac~⦪~angmsdad~⦫~angmsdae~⦬~angmsdaf~⦭~angmsdag~⦮~angmsdah~⦯~angrt~∟~angrtvb~⊾~angrtvbd~⦝~angsph~∢~angst~Å~angzarr~⍼~aogon~ą~aopf~𝕒~ap~≈~apE~⩰~apacir~⩯~ape~≊~apid~≋~approx~≈~approxeq~≊~ascr~𝒶~ast~*~asympeq~≍~awconint~∳~awint~⨑~bNot~⫭~backcong~≌~backepsilon~϶~backprime~‵~backsim~∽~backsimeq~⋍~barvee~⊽~barwed~⌅~barwedge~⌅~bbrk~⎵~bbrktbrk~⎶~bcong~≌~bcy~б~becaus~∵~because~∵~bemptyv~⦰~bepsi~϶~bernou~ℬ~beth~ℶ~between~≬~bfr~𝔟~bigcap~⋂~bigcirc~◯~bigcup~⋃~bigodot~⨀~bigoplus~⨁~bigotimes~⨂~bigsqcup~⨆~bigstar~★~bigtriangledown~▽~bigtriangleup~△~biguplus~⨄~bigvee~⋁~bigwedge~⋀~bkarow~⤍~blacklozenge~⧫~blacksquare~▪~blacktriangle~▴~blacktriangledown~▾~blacktriangleleft~◂~blacktriangleright~▸~blank~␣~blk12~▒~blk14~░~blk34~▓~block~█~bne~=⃥~bnequiv~≡⃥~bnot~⌐~bopf~𝕓~bot~⊥~bottom~⊥~bowtie~⋈~boxDL~╗~boxDR~╔~boxDl~╖~boxDr~╓~boxH~═~boxHD~╦~boxHU~╩~boxHd~╤~boxHu~╧~boxUL~╝~boxUR~╚~boxUl~╜~boxUr~╙~boxV~║~boxVH~╬~boxVL~╣~boxVR~╠~boxVh~╫~boxVl~╢~boxVr~╟~boxbox~⧉~boxdL~╕~boxdR~╒~boxdl~┐~boxdr~┌~boxh~─~boxhD~╥~boxhU~╨~boxhd~┬~boxhu~┴~boxminus~⊟~boxplus~⊞~boxtimes~⊠~boxuL~╛~boxuR~╘~boxul~┘~boxur~└~boxv~│~boxvH~╪~boxvL~╡~boxvR~╞~boxvh~┼~boxvl~┤~boxvr~├~bprime~‵~breve~˘~bscr~𝒷~bsemi~⁏~bsim~∽~bsime~⋍~bsol~\\~bsolb~⧅~bsolhsub~⟈~bullet~•~bump~≎~bumpE~⪮~bumpe~≏~bumpeq~≏~cacute~ć~capand~⩄~capbrcup~⩉~capcap~⩋~capcup~⩇~capdot~⩀~caps~∩︀~caret~⁁~caron~ˇ~ccaps~⩍~ccaron~č~ccirc~ĉ~ccups~⩌~ccupssm~⩐~cdot~ċ~cemptyv~⦲~centerdot~·~cfr~𝔠~chcy~ч~check~✓~checkmark~✓~cir~○~cirE~⧃~circeq~≗~circlearrowleft~↺~circlearrowright~↻~circledR~®~circledS~Ⓢ~circledast~⊛~circledcirc~⊚~circleddash~⊝~cire~≗~cirfnint~⨐~cirmid~⫯~cirscir~⧂~clubsuit~♣~colon~:~colone~≔~coloneq~≔~comma~,~commat~@~comp~∁~compfn~∘~complement~∁~complexes~ℂ~congdot~⩭~conint~∮~copf~𝕔~coprod~∐~copysr~℗~cross~✗~cscr~𝒸~csub~⫏~csube~⫑~csup~⫐~csupe~⫒~ctdot~⋯~cudarrl~⤸~cudarrr~⤵~cuepr~⋞~cuesc~⋟~cularr~↶~cularrp~⤽~cupbrcap~⩈~cupcap~⩆~cupcup~⩊~cupdot~⊍~cupor~⩅~cups~∪︀~curarr~↷~curarrm~⤼~curlyeqprec~⋞~curlyeqsucc~⋟~curlyvee~⋎~curlywedge~⋏~curvearrowleft~↶~curvearrowright~↷~cuvee~⋎~cuwed~⋏~cwconint~∲~cwint~∱~cylcty~⌭~dHar~⥥~daleth~ℸ~dash~‐~dashv~⊣~dbkarow~⤏~dblac~˝~dcaron~ď~dcy~д~dd~ⅆ~ddagger~‡~ddarr~⇊~ddotseq~⩷~demptyv~⦱~dfisht~⥿~dfr~𝔡~dharl~⇃~dharr~⇂~diam~⋄~diamond~⋄~diamondsuit~♦~die~¨~digamma~ϝ~disin~⋲~div~÷~divideontimes~⋇~divonx~⋇~djcy~ђ~dlcorn~⌞~dlcrop~⌍~dollar~$~dopf~𝕕~dot~˙~doteq~≐~doteqdot~≑~dotminus~∸~dotplus~∔~dotsquare~⊡~doublebarwedge~⌆~downarrow~↓~downdownarrows~⇊~downharpoonleft~⇃~downharpoonright~⇂~drbkarow~⤐~drcorn~⌟~drcrop~⌌~dscr~𝒹~dscy~ѕ~dsol~⧶~dstrok~đ~dtdot~⋱~dtri~▿~dtrif~▾~duarr~⇵~duhar~⥯~dwangle~⦦~dzcy~џ~dzigrarr~⟿~eDDot~⩷~eDot~≑~easter~⩮~ecaron~ě~ecir~≖~ecolon~≕~ecy~э~edot~ė~ee~ⅇ~efDot~≒~efr~𝔢~eg~⪚~egs~⪖~egsdot~⪘~el~⪙~elinters~⏧~ell~ℓ~els~⪕~elsdot~⪗~emacr~ē~emptyset~∅~emptyv~∅~emsp13~ ~emsp14~ ~eng~ŋ~eogon~ę~eopf~𝕖~epar~⋕~eparsl~⧣~eplus~⩱~epsi~ε~epsiv~ϵ~eqcirc~≖~eqcolon~≕~eqsim~≂~eqslantgtr~⪖~eqslantless~⪕~equals~=~equest~≟~equivDD~⩸~eqvparsl~⧥~erDot~≓~erarr~⥱~escr~ℯ~esdot~≐~esim~≂~excl~!~expectation~ℰ~exponentiale~ⅇ~fallingdotseq~≒~fcy~ф~female~♀~ffilig~ﬃ~fflig~ﬀ~ffllig~ﬄ~ffr~𝔣~filig~ﬁ~fjlig~fj~flat~♭~fllig~ﬂ~fltns~▱~fopf~𝕗~fork~⋔~forkv~⫙~fpartint~⨍~frac13~⅓~frac15~⅕~frac16~⅙~frac18~⅛~frac23~⅔~frac25~⅖~frac35~⅗~frac38~⅜~frac45~⅘~frac56~⅚~frac58~⅝~frac78~⅞~frown~⌢~fscr~𝒻~gE~≧~gEl~⪌~gacute~ǵ~gammad~ϝ~gap~⪆~gbreve~ğ~gcirc~ĝ~gcy~г~gdot~ġ~gel~⋛~geq~≥~geqq~≧~geqslant~⩾~ges~⩾~gescc~⪩~gesdot~⪀~gesdoto~⪂~gesdotol~⪄~gesl~⋛︀~gesles~⪔~gfr~𝔤~gg~≫~ggg~⋙~gimel~ℷ~gjcy~ѓ~gl~≷~glE~⪒~gla~⪥~glj~⪤~gnE~≩~gnap~⪊~gnapprox~⪊~gne~⪈~gneq~⪈~gneqq~≩~gnsim~⋧~gopf~𝕘~grave~`~gscr~ℊ~gsim~≳~gsime~⪎~gsiml~⪐~gtcc~⪧~gtcir~⩺~gtdot~⋗~gtlPar~⦕~gtquest~⩼~gtrapprox~⪆~gtrarr~⥸~gtrdot~⋗~gtreqless~⋛~gtreqqless~⪌~gtrless~≷~gtrsim~≳~gvertneqq~≩︀~gvnE~≩︀~hairsp~ ~half~½~hamilt~ℋ~hardcy~ъ~harrcir~⥈~harrw~↭~hbar~ℏ~hcirc~ĥ~heartsuit~♥~hercon~⊹~hfr~𝔥~hksearow~⤥~hkswarow~⤦~hoarr~⇿~homtht~∻~hookleftarrow~↩~hookrightarrow~↪~hopf~𝕙~horbar~―~hscr~𝒽~hslash~ℏ~hstrok~ħ~hybull~⁃~hyphen~‐~ic~⁣~icy~и~iecy~е~iff~⇔~ifr~𝔦~ii~ⅈ~iiiint~⨌~iiint~∭~iinfin~⧜~iiota~℩~ijlig~ĳ~imacr~ī~imagline~ℐ~imagpart~ℑ~imath~ı~imof~⊷~imped~Ƶ~in~∈~incare~℅~infintie~⧝~inodot~ı~intcal~⊺~integers~ℤ~intercal~⊺~intlarhk~⨗~intprod~⨼~iocy~ё~iogon~į~iopf~𝕚~iprod~⨼~iscr~𝒾~isinE~⋹~isindot~⋵~isins~⋴~isinsv~⋳~isinv~∈~it~⁢~itilde~ĩ~iukcy~і~jcirc~ĵ~jcy~й~jfr~𝔧~jmath~ȷ~jopf~𝕛~jscr~𝒿~jsercy~ј~jukcy~є~kappav~ϰ~kcedil~ķ~kcy~к~kfr~𝔨~kgreen~ĸ~khcy~х~kjcy~ќ~kopf~𝕜~kscr~𝓀~lAarr~⇚~lAtail~⤛~lBarr~⤎~lE~≦~lEg~⪋~lHar~⥢~lacute~ĺ~laemptyv~⦴~lagran~ℒ~langd~⦑~langle~⟨~lap~⪅~larrb~⇤~larrbfs~⤟~larrfs~⤝~larrhk~↩~larrlp~↫~larrpl~⤹~larrsim~⥳~larrtl~↢~lat~⪫~latail~⤙~late~⪭~lates~⪭︀~lbarr~⤌~lbbrk~❲~lbrace~{~lbrack~[~lbrke~⦋~lbrksld~⦏~lbrkslu~⦍~lcaron~ľ~lcedil~ļ~lcub~{~lcy~л~ldca~⤶~ldquor~„~ldrdhar~⥧~ldrushar~⥋~ldsh~↲~leftarrow~←~leftarrowtail~↢~leftharpoondown~↽~leftharpoonup~↼~leftleftarrows~⇇~leftrightarrow~↔~leftrightarrows~⇆~leftrightharpoons~⇋~leftrightsquigarrow~↭~leftthreetimes~⋋~leg~⋚~leq~≤~leqq~≦~leqslant~⩽~les~⩽~lescc~⪨~lesdot~⩿~lesdoto~⪁~lesdotor~⪃~lesg~⋚︀~lesges~⪓~lessapprox~⪅~lessdot~⋖~lesseqgtr~⋚~lesseqqgtr~⪋~lessgtr~≶~lesssim~≲~lfisht~⥼~lfr~𝔩~lg~≶~lgE~⪑~lhard~↽~lharu~↼~lharul~⥪~lhblk~▄~ljcy~љ~ll~≪~llarr~⇇~llcorner~⌞~llhard~⥫~lltri~◺~lmidot~ŀ~lmoust~⎰~lmoustache~⎰~lnE~≨~lnap~⪉~lnapprox~⪉~lne~⪇~lneq~⪇~lneqq~≨~lnsim~⋦~loang~⟬~loarr~⇽~lobrk~⟦~longleftarrow~⟵~longleftrightarrow~⟷~longmapsto~⟼~longrightarrow~⟶~looparrowleft~↫~looparrowright~↬~lopar~⦅~lopf~𝕝~loplus~⨭~lotimes~⨴~lowbar~_~lozenge~◊~lozf~⧫~lpar~(~lparlt~⦓~lrarr~⇆~lrcorner~⌟~lrhar~⇋~lrhard~⥭~lrtri~⊿~lscr~𝓁~lsh~↰~lsim~≲~lsime~⪍~lsimg~⪏~lsqb~[~lsquor~‚~lstrok~ł~ltcc~⪦~ltcir~⩹~ltdot~⋖~lthree~⋋~ltimes~⋉~ltlarr~⥶~ltquest~⩻~ltrPar~⦖~ltri~◃~ltrie~⊴~ltrif~◂~lurdshar~⥊~luruhar~⥦~lvertneqq~≨︀~lvnE~≨︀~mDDot~∺~male~♂~malt~✠~maltese~✠~map~↦~mapsto~↦~mapstodown~↧~mapstoleft~↤~mapstoup~↥~marker~▮~mcomma~⨩~mcy~м~measuredangle~∡~mfr~𝔪~mho~℧~mid~∣~midast~*~midcir~⫰~minusb~⊟~minusd~∸~minusdu~⨪~mlcp~⫛~mldr~…~mnplus~∓~models~⊧~mopf~𝕞~mp~∓~mscr~𝓂~mstpos~∾~multimap~⊸~mumap~⊸~nGg~⋙̸~nGt~≫⃒~nGtv~≫̸~nLeftarrow~⇍~nLeftrightarrow~⇎~nLl~⋘̸~nLt~≪⃒~nLtv~≪̸~nRightarrow~⇏~nVDash~⊯~nVdash~⊮~nacute~ń~nang~∠⃒~nap~≉~napE~⩰̸~napid~≋̸~napos~ŉ~napprox~≉~natur~♮~natural~♮~naturals~ℕ~nbump~≎̸~nbumpe~≏̸~ncap~⩃~ncaron~ň~ncedil~ņ~ncong~≇~ncongdot~⩭̸~ncup~⩂~ncy~н~neArr~⇗~nearhk~⤤~nearr~↗~nearrow~↗~nedot~≐̸~nequiv~≢~nesear~⤨~nesim~≂̸~nexist~∄~nexists~∄~nfr~𝔫~ngE~≧̸~nge~≱~ngeq~≱~ngeqq~≧̸~ngeqslant~⩾̸~nges~⩾̸~ngsim~≵~ngt~≯~ngtr~≯~nhArr~⇎~nharr~↮~nhpar~⫲~nis~⋼~nisd~⋺~niv~∋~njcy~њ~nlArr~⇍~nlE~≦̸~nlarr~↚~nldr~‥~nle~≰~nleftarrow~↚~nleftrightarrow~↮~nleq~≰~nleqq~≦̸~nleqslant~⩽̸~nles~⩽̸~nless~≮~nlsim~≴~nlt~≮~nltri~⋪~nltrie~⋬~nmid~∤~nopf~𝕟~notinE~⋹̸~notindot~⋵̸~notinva~∉~notinvb~⋷~notinvc~⋶~notni~∌~notniva~∌~notnivb~⋾~notnivc~⋽~npar~∦~nparallel~∦~nparsl~⫽⃥~npart~∂̸~npolint~⨔~npr~⊀~nprcue~⋠~npre~⪯̸~nprec~⊀~npreceq~⪯̸~nrArr~⇏~nrarr~↛~nrarrc~⤳̸~nrarrw~↝̸~nrightarrow~↛~nrtri~⋫~nrtrie~⋭~nsc~⊁~nsccue~⋡~nsce~⪰̸~nscr~𝓃~nshortmid~∤~nshortparallel~∦~nsim~≁~nsime~≄~nsimeq~≄~nsmid~∤~nspar~∦~nsqsube~⋢~nsqsupe~⋣~nsubE~⫅̸~nsube~⊈~nsubset~⊂⃒~nsubseteq~⊈~nsubseteqq~⫅̸~nsucc~⊁~nsucceq~⪰̸~nsup~⊅~nsupE~⫆̸~nsupe~⊉~nsupset~⊃⃒~nsupseteq~⊉~nsupseteqq~⫆̸~ntgl~≹~ntlg~≸~ntriangleleft~⋪~ntrianglelefteq~⋬~ntriangleright~⋫~ntrianglerighteq~⋭~num~#~numero~№~numsp~ ~nvDash~⊭~nvHarr~⤄~nvap~≍⃒~nvdash~⊬~nvge~≥⃒~nvgt~>⃒~nvinfin~⧞~nvlArr~⤂~nvle~≤⃒~nvlt~<⃒~nvltrie~⊴⃒~nvrArr~⤃~nvrtrie~⊵⃒~nvsim~∼⃒~nwArr~⇖~nwarhk~⤣~nwarr~↖~nwarrow~↖~nwnear~⤧~oS~Ⓢ~oast~⊛~ocir~⊚~ocy~о~odash~⊝~odblac~ő~odiv~⨸~odot~⊙~odsold~⦼~ofcir~⦿~ofr~𝔬~ogon~˛~ogt~⧁~ohbar~⦵~ohm~Ω~oint~∮~olarr~↺~olcir~⦾~olcross~⦻~olt~⧀~omacr~ō~omid~⦶~ominus~⊖~oopf~𝕠~opar~⦷~operp~⦹~orarr~↻~ord~⩝~order~ℴ~orderof~ℴ~origof~⊶~oror~⩖~orslope~⩗~orv~⩛~oscr~ℴ~osol~⊘~otimesas~⨶~ovbar~⌽~par~∥~parallel~∥~parsim~⫳~parsl~⫽~pcy~п~percnt~%~period~.~pertenk~‱~pfr~𝔭~phiv~ϕ~phmmat~ℳ~phone~☎~pitchfork~⋔~planck~ℏ~planckh~ℎ~plankv~ℏ~plus~+~plusacir~⨣~plusb~⊞~pluscir~⨢~plusdo~∔~plusdu~⨥~pluse~⩲~plussim~⨦~plustwo~⨧~pm~±~pointint~⨕~popf~𝕡~pr~≺~prE~⪳~prap~⪷~prcue~≼~pre~⪯~prec~≺~precapprox~⪷~preccurlyeq~≼~preceq~⪯~precnapprox~⪹~precneqq~⪵~precnsim~⋨~precsim~≾~primes~ℙ~prnE~⪵~prnap~⪹~prnsim~⋨~profalar~⌮~profline~⌒~profsurf~⌓~propto~∝~prsim~≾~prurel~⊰~pscr~𝓅~puncsp~ ~qfr~𝔮~qint~⨌~qopf~𝕢~qprime~⁗~qscr~𝓆~quaternions~ℍ~quatint~⨖~quest~?~questeq~≟~rAarr~⇛~rAtail~⤜~rBarr~⤏~rHar~⥤~race~∽̱~racute~ŕ~raemptyv~⦳~rangd~⦒~range~⦥~rangle~⟩~rarrap~⥵~rarrb~⇥~rarrbfs~⤠~rarrc~⤳~rarrfs~⤞~rarrhk~↪~rarrlp~↬~rarrpl~⥅~rarrsim~⥴~rarrtl~↣~rarrw~↝~ratail~⤚~ratio~∶~rationals~ℚ~rbarr~⤍~rbbrk~❳~rbrace~}~rbrack~]~rbrke~⦌~rbrksld~⦎~rbrkslu~⦐~rcaron~ř~rcedil~ŗ~rcub~}~rcy~р~rdca~⤷~rdldhar~⥩~rdquor~”~rdsh~↳~realine~ℛ~realpart~ℜ~reals~ℝ~rect~▭~rfisht~⥽~rfr~𝔯~rhard~⇁~rharu~⇀~rharul~⥬~rhov~ϱ~rightarrow~→~rightarrowtail~↣~rightharpoondown~⇁~rightharpoonup~⇀~rightleftarrows~⇄~rightleftharpoons~⇌~rightrightarrows~⇉~rightsquigarrow~↝~rightthreetimes~⋌~ring~˚~risingdotseq~≓~rlarr~⇄~rlhar~⇌~rmoust~⎱~rmoustache~⎱~rnmid~⫮~roang~⟭~roarr~⇾~robrk~⟧~ropar~⦆~ropf~𝕣~roplus~⨮~rotimes~⨵~rpar~)~rpargt~⦔~rppolint~⨒~rrarr~⇉~rscr~𝓇~rsh~↱~rsqb~]~rsquor~’~rthree~⋌~rtimes~⋊~rtri~▹~rtrie~⊵~rtrif~▸~rtriltri~⧎~ruluhar~⥨~rx~℞~sacute~ś~sc~≻~scE~⪴~scap~⪸~sccue~≽~sce~⪰~scedil~ş~scirc~ŝ~scnE~⪶~scnap~⪺~scnsim~⋩~scpolint~⨓~scsim~≿~scy~с~sdotb~⊡~sdote~⩦~seArr~⇘~searhk~⤥~searr~↘~searrow~↘~semi~;~seswar~⤩~setminus~∖~setmn~∖~sext~✶~sfr~𝔰~sfrown~⌢~sharp~♯~shchcy~щ~shcy~ш~shortmid~∣~shortparallel~∥~sigmav~ς~simdot~⩪~sime~≃~simeq~≃~simg~⪞~simgE~⪠~siml~⪝~simlE~⪟~simne~≆~simplus~⨤~simrarr~⥲~slarr~←~smallsetminus~∖~smashp~⨳~smeparsl~⧤~smid~∣~smile~⌣~smt~⪪~smte~⪬~smtes~⪬︀~softcy~ь~sol~/~solb~⧄~solbar~⌿~sopf~𝕤~spadesuit~♠~spar~∥~sqcap~⊓~sqcaps~⊓︀~sqcup~⊔~sqcups~⊔︀~sqsub~⊏~sqsube~⊑~sqsubset~⊏~sqsubseteq~⊑~sqsup~⊐~sqsupe~⊒~sqsupset~⊐~sqsupseteq~⊒~squ~□~square~□~squarf~▪~squf~▪~srarr~→~sscr~𝓈~ssetmn~∖~ssmile~⌣~sstarf~⋆~star~☆~starf~★~straightepsilon~ϵ~straightphi~ϕ~strns~¯~subE~⫅~subdot~⪽~subedot~⫃~submult~⫁~subnE~⫋~subne~⊊~subplus~⪿~subrarr~⥹~subset~⊂~subseteq~⊆~subseteqq~⫅~subsetneq~⊊~subsetneqq~⫋~subsim~⫇~subsub~⫕~subsup~⫓~succ~≻~succapprox~⪸~succcurlyeq~≽~succeq~⪰~succnapprox~⪺~succneqq~⪶~succnsim~⋩~succsim~≿~sung~♪~supE~⫆~supdot~⪾~supdsub~⫘~supedot~⫄~suphsol~⟉~suphsub~⫗~suplarr~⥻~supmult~⫂~supnE~⫌~supne~⊋~supplus~⫀~supset~⊃~supseteq~⊇~supseteqq~⫆~supsetneq~⊋~supsetneqq~⫌~supsim~⫈~supsub~⫔~supsup~⫖~swArr~⇙~swarhk~⤦~swarr~↙~swarrow~↙~swnwar~⤪~target~⌖~tbrk~⎴~tcaron~ť~tcedil~ţ~tcy~т~tdot~⃛~telrec~⌕~tfr~𝔱~therefore~∴~thetav~ϑ~thickapprox~≈~thicksim~∼~thkap~≈~thksim~∼~timesb~⊠~timesbar~⨱~timesd~⨰~tint~∭~toea~⤨~top~⊤~topbot~⌶~topcir~⫱~topf~𝕥~topfork~⫚~tosa~⤩~tprime~‴~triangle~▵~triangledown~▿~triangleleft~◃~trianglelefteq~⊴~triangleq~≜~triangleright~▹~trianglerighteq~⊵~tridot~◬~trie~≜~triminus~⨺~triplus~⨹~trisb~⧍~tritime~⨻~trpezium~⏢~tscr~𝓉~tscy~ц~tshcy~ћ~tstrok~ŧ~twixt~≬~twoheadleftarrow~↞~twoheadrightarrow~↠~uHar~⥣~ubrcy~ў~ubreve~ŭ~ucy~у~udarr~⇅~udblac~ű~udhar~⥮~ufisht~⥾~ufr~𝔲~uharl~↿~uharr~↾~uhblk~▀~ulcorn~⌜~ulcorner~⌜~ulcrop~⌏~ultri~◸~umacr~ū~uogon~ų~uopf~𝕦~uparrow~↑~updownarrow~↕~upharpoonleft~↿~upharpoonright~↾~uplus~⊎~upsi~υ~upuparrows~⇈~urcorn~⌝~urcorner~⌝~urcrop~⌎~uring~ů~urtri~◹~uscr~𝓊~utdot~⋰~utilde~ũ~utri~▵~utrif~▴~uuarr~⇈~uwangle~⦧~vArr~⇕~vBar~⫨~vBarv~⫩~vDash~⊨~vangrt~⦜~varepsilon~ϵ~varkappa~ϰ~varnothing~∅~varphi~ϕ~varpi~ϖ~varpropto~∝~varr~↕~varrho~ϱ~varsigma~ς~varsubsetneq~⊊︀~varsubsetneqq~⫋︀~varsupsetneq~⊋︀~varsupsetneqq~⫌︀~vartheta~ϑ~vartriangleleft~⊲~vartriangleright~⊳~vcy~в~vdash~⊢~vee~∨~veebar~⊻~veeeq~≚~vellip~⋮~verbar~|~vert~|~vfr~𝔳~vltri~⊲~vnsub~⊂⃒~vnsup~⊃⃒~vopf~𝕧~vprop~∝~vrtri~⊳~vscr~𝓋~vsubnE~⫋︀~vsubne~⊊︀~vsupnE~⫌︀~vsupne~⊋︀~vzigzag~⦚~wcirc~ŵ~wedbar~⩟~wedge~∧~wedgeq~≙~wfr~𝔴~wopf~𝕨~wp~℘~wr~≀~wreath~≀~wscr~𝓌~xcap~⋂~xcirc~◯~xcup~⋃~xdtri~▽~xfr~𝔵~xhArr~⟺~xharr~⟷~xlArr~⟸~xlarr~⟵~xmap~⟼~xnis~⋻~xodot~⨀~xopf~𝕩~xoplus~⨁~xotime~⨂~xrArr~⟹~xrarr~⟶~xscr~𝓍~xsqcup~⨆~xuplus~⨄~xutri~△~xvee~⋁~xwedge~⋀~yacy~я~ycirc~ŷ~ycy~ы~yfr~𝔶~yicy~ї~yopf~𝕪~yscr~𝓎~yucy~ю~zacute~ź~zcaron~ž~zcy~з~zdot~ż~zeetrf~ℨ~zfr~𝔷~zhcy~ж~zigrarr~⇝~zopf~𝕫~zscr~𝓏~~AMP~&~COPY~©~GT~>~LT~<~QUOT~"~REG~®', Hd.html4);
var Xz = {
  0: 65533,
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, Jz = String.fromCodePoint || function(r) {
  return String.fromCharCode(Math.floor((r - 65536) / 1024) + 55296, (r - 65536) % 1024 + 56320);
}, Wd = function() {
  return Wd = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Wd.apply(this, arguments);
}, Kz = Wd(Wd({}, Hd), { all: Hd.html5 }), Zz = {
  scope: "body",
  level: "all"
}, yy = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g, Ay = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g, d2 = {
  xml: {
    strict: yy,
    attribute: Ay,
    body: vy.xml
  },
  html4: {
    strict: yy,
    attribute: Ay,
    body: vy.html4
  },
  html5: {
    strict: yy,
    attribute: Ay,
    body: vy.html5
  }
}, eG = Wd(Wd({}, d2), { all: d2.html5 }), pD = String.fromCharCode, tG = pD(65533);
function rG(r, e, t, n) {
  var i = r, a = r[r.length - 1];
  if (t && a === "=")
    i = r;
  else if (n && a !== ";")
    i = r;
  else {
    var s = e[r];
    if (s)
      i = s;
    else if (r[0] === "&" && r[1] === "#") {
      var o = r[2], l = o == "x" || o == "X" ? parseInt(r.substr(3), 16) : parseInt(r.substr(2));
      i = l >= 1114111 ? tG : l > 65535 ? Jz(l) : pD(Xz[l] || l);
    }
  }
  return i;
}
function nG(r, e) {
  var t = Zz, n = t.level, i = n === void 0 ? "all" : n, a = t.scope, s = a === void 0 ? i === "xml" ? "strict" : "body" : a;
  if (!r)
    return "";
  var o = eG[i][s], l = Kz[i].entities, u = s === "attribute", c = s === "strict";
  return r.replace(o, function(h) {
    return rG(h, l, u, c);
  });
}
const gD = /* @__PURE__ */ new Map();
class iG {
  constructor(e) {
    this.font = e, this.glyphsFromText = /* @__PURE__ */ new Map(), this.kerningValues = /* @__PURE__ */ new Map(), this.height = this.calculateApproximateHeight();
  }
  getFont() {
    return this.font;
  }
  getGlyphs(e) {
    const t = this.glyphsFromText.get(e);
    if (t)
      return t;
    const n = this.font.stringToGlyphs(e);
    return this.glyphsFromText.set(e, n), n;
  }
  /**
   * @returns The approximate height of any text line based on all main characters of the alphabet.
   */
  getApproximateHeight() {
    return this.height;
  }
  /**
   * Computes the exact height of a line of text.
   * @param text
   * @returns
   */
  getExactHeight(e) {
    const t = this.font.stringToGlyphs(e);
    let n = 0, i = 0;
    return t.forEach((a) => {
      const s = a.getMetrics();
      n = Math.max(n, s.yMax), i = Math.min(i, s.yMin);
    }), n - i;
  }
  getKerningValue(e, t) {
    if (!e.name || !t.name) return;
    let n = this.kerningValues.get(e.name);
    n || (n = /* @__PURE__ */ new Map(), this.kerningValues.set(e.name, n));
    let i = n.get(t.name);
    return i || (i = this.font.getKerningValue(e, t), n.set(t.name, i)), i;
  }
  calculateApproximateHeight() {
    const t = this.font.stringToGlyphs("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789");
    let n = 0, i = 0;
    return t.forEach((a) => {
      const s = a.getMetrics();
      n = Math.max(n, s.yMax), i = Math.min(i, s.yMin);
    }), n - i;
  }
}
const aG = (r) => r.substring(0, 5).toLowerCase().trim() === "data:", wy = /* @__PURE__ */ new Map(), oh = async (r) => {
  if (wy.has(r))
    return wy.get(r);
  const t = (async () => {
    try {
      return _c(r).getFont();
    } catch {
      if (aG(r)) {
        const n = bI(r), i = V1(n);
        return $1(r, i), i;
      } else {
        const n = await $0(r, !0), i = V1(n);
        return $1(r, i), await FN(i, r), i;
      }
    }
  })();
  return wy.set(r, t), t;
}, sG = (r) => {
  const e = bI(r), t = V1(e);
  return $1(r, t), t;
}, _c = (r) => {
  const e = gD.get(r);
  if (e)
    return e;
  throw new Error("Font metrics unavailable for font");
}, $1 = (r, e) => {
  const t = new iG(e);
  return gD.set(r, t), t;
}, Jre = async (r) => {
  const e = Pu(), t = e.parseFromString(r, "image/svg+xml"), n = t.firstElementChild, i = /* @__PURE__ */ new Map();
  n.querySelectorAll("style").forEach((c) => {
    FI(c.innerHTML).stylesheet?.rules.forEach((f) => {
      if (f.type === zn.fontFace && f.declarations) {
        const p = f.declarations.find(
          (w) => w.property === "font-family"
        )?.value, A = f.declarations.find((w) => w.property === "src")?.value?.match(/'(https.*?)'/)?.[1];
        p && A && i.set(p, A);
      }
    });
  });
  const s = t.querySelectorAll("tspan");
  for (let c = 0; c < s.length; c++) {
    const h = s.item(c), f = h.closest("text"), p = h.closest("g"), m = f.getAttribute("font-family"), A = await oh(i.get(m)), w = nG(h.innerHTML), x = f.getAttribute("fill"), E = f.getAttribute("stroke"), T = f.getAttribute("stroke-width"), D = A.getPath(w, 0, 0, parseInt(f.getAttribute("font-size") ?? "72")), F = D.getBoundingBox().x2 - D.getBoundingBox().x1;
    let _ = 0;
    const L = h.getAttribute("text-anchor");
    L === "middle" ? _ = F / 2 : L === "end" && (_ = F);
    const Z = A.getPath(
      w,
      parseFloat(h.getAttribute("x") ?? "0") - _,
      parseFloat(h.getAttribute("y") ?? "0"),
      parseInt(f.getAttribute("font-size") ?? "72")
    );
    Z.fill = x, Z.stroke = E, Z.strokeWidth = parseFloat(T ?? "0");
    const te = Z.toSVG(2), H = e.parseFromString(te, "image/svg+xml").firstElementChild;
    p.appendChild(H);
  }
  return t.querySelectorAll("text").forEach((c) => c.remove()), $f().serializeToString(n);
}, b0 = (r, e, t, n) => Math.max(cG(r.join(`
`), t, n), e), h2 = (r, e, t, n, i, a) => {
  const s = (a || yD) * i.getApproximateHeight(), o = e.split(`
`);
  try {
    const l = o.flatMap((c) => Jm(c, r.width, n, i)), u = l.flatMap((c) => c.lines);
    return {
      lines: u,
      requiredHeight: l.flatMap((c) => c.lines).length * (n * s),
      fontSize: t,
      requiredWidth: b0(u, r.width, n, i)
    };
  } catch {
    const u = e.split("");
    return {
      lines: u,
      requiredHeight: u.length * (n * s),
      fontSize: t,
      requiredWidth: b0(u, r.width, n, i)
    };
  }
}, Jm = (r, e, t, n) => {
  const i = wc(r, t, n);
  if (i <= e)
    return { lines: [r], width: i };
  if (!(r.indexOf(" ") > -1)) {
    if (r.length <= 1)
      throw new Error(`Character ${r} is wider than region`);
    const c = Math.floor(r.length / 2), h = Jm(r.slice(0, c), e, t, n), f = Jm(r.slice(c), e, t, n);
    return { lines: [...h.lines, ...f.lines], width: Math.max(h.width, f.width) };
  }
  const s = r.split(" "), o = [];
  let l = -1 / 0, u = 0;
  for (; u < s.length; ) {
    const c = s[u];
    if (wc(c, t, n) > e) {
      const h = Jm(c, e, t, n);
      o.push(...h.lines), l = Math.max(l, h.width), u++;
    } else {
      const h = [c];
      l = Math.max(l, wc(c, t, n));
      let f = u + 1, p = !0;
      for (; f < s.length && p; ) {
        const m = s[f], A = wc(`${h.join(" ")} ${m}`, t, n);
        A <= e ? (h.push(m), l = Math.max(l, A), f++) : p = !1;
      }
      o.push(h.join(" ")), u = f;
    }
  }
  if (l < 0)
    throw new Error(`No max width calculated for text: ${o}.`);
  return { lines: o, width: l };
}, oG = (r, e, t, n, i, a) => {
  const s = (a ?? yD) * e.getApproximateHeight(), o = 1 / t.unitsPerEm, l = mD(r, o, e), u = r.length * s * o, c = n / l, h = i / u;
  return Math.min(h, c);
}, lG = (r, e, t, n) => {
  const i = _c(e.fontData.assetUrl), a = i.getFont(), s = e.fontSize / a.unitsPerEm;
  if (!t)
    return h2(
      e,
      r,
      e.fontSize,
      s,
      i,
      n
    );
  let o;
  if (e.text ? o = e.text.split(`
`) : o = e.input?.split(`
`) ?? [""], t.input === r && e.width === t.width && e.height === t.height && e.lineHeight === t.lineHeight)
    return {
      lines: o,
      requiredHeight: e.height,
      requiredWidth: b0(o, e.width, s, i),
      fontSize: e.fontSize
    };
  const l = e.width !== t.width != (e.height !== t.height);
  return e.lineHeight === t.lineHeight && !l && t.input === r ? {
    lines: o,
    requiredHeight: e.height,
    requiredWidth: b0(o, e.width, s, i),
    fontSize: oG(o, i, a, e.width, e.height, n)
  } : h2(
    e,
    r,
    e.fontSize,
    s,
    i,
    n
  );
}, uG = (r, e, t, n, i) => {
  const s = _c(e.assetUrl).getFont();
  let o = { ...r };
  const l = { ...r }, u = mD(n, t / s.unitsPerEm, _c(e.assetUrl));
  return u && u < o.width && (l.width = u, i === "left" ? (l.left += Math.sin(o.rotation * Math.PI / 360) * (o.width - u), l.top += Math.sin(o.rotation * Math.PI / 180) * (u - o.width) / 2) : i === "right" ? l.left += o.width - u : l.left += (o.width - u) / 2, n && fG(n, n).every(([c, h]) => c === h) && (o = l)), o;
}, xy = 1, wc = (r, e, t) => {
  let n = 0;
  const i = t.getGlyphs(r);
  return i.forEach((a, s) => {
    if (a.advanceWidth && (n += a.advanceWidth), s < i.length - 1) {
      const o = t.getKerningValue(a, i[s + 1]);
      n += o || 0;
    }
  }), n *= e, n;
}, cG = (r, e, t) => {
  let n = 0;
  const i = t.getGlyphs(r);
  return i.forEach((a, s) => {
    if (a.advanceWidth && (n = Math.max(n, a.advanceWidth)), s < i.length - 1) {
      const o = t.getKerningValue(a, i[s + 1]);
      n = Math.max(n, o || 0);
    }
  }), n *= e, n;
}, mD = (r, e, t) => {
  let n = 0;
  return r.forEach((i) => {
    n = Math.max(n, wc(i, e, t));
  }), n;
}, p2 = {
  stripControlCharacters: !0,
  vertical: !1,
  uppercase: !1
}, C0 = (r, e = p2) => {
  const t = { ...p2, ...e };
  let n = r || "";
  return t.stripControlCharacters && (n = n.replace(/^(?![\u000A\u000D])[\u0000-\u001F\u007F-\u009F]/g, "")), t.uppercase && (n = n.toUpperCase()), t.vertical && (n = n.split("").join(`
`)), n;
}, fG = (r, e) => r.map((t, n) => [t, e[n]]), dG = (r = "center", e = !1) => e ? "center" : r, vD = (r) => r === "left" ? "start" : r === "right" ? "end" : "middle", xg = (r, e, t) => r.fontData ? {
  ...r,
  ...(() => {
    if (r.algorithm === eh.Traditional) {
      const i = lG(e, r, t, r.lineHeight);
      return {
        text: i.lines.join(`
`),
        height: i.requiredHeight,
        width: i.requiredWidth,
        fontSize: i.fontSize,
        input: e
      };
    } else
      return {
        text: e
      };
  })()
} : r, yD = 1.1;
var Zg = { exports: {} }, em = { exports: {} }, Ho = {}, Es = {}, g2;
function Is() {
  if (g2) return Es;
  g2 = 1, Es.__esModule = !0, Es.extend = i, Es.indexOf = l, Es.escapeExpression = u, Es.isEmpty = c, Es.createFrame = h, Es.blockParams = f, Es.appendContextPath = p;
  var r = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;",
    "=": "&#x3D;"
  }, e = /[&<>"'`=]/g, t = /[&<>"'`=]/;
  function n(m) {
    return r[m];
  }
  function i(m) {
    for (var A = 1; A < arguments.length; A++)
      for (var w in arguments[A])
        Object.prototype.hasOwnProperty.call(arguments[A], w) && (m[w] = arguments[A][w]);
    return m;
  }
  var a = Object.prototype.toString;
  Es.toString = a;
  var s = function(A) {
    return typeof A == "function";
  };
  s(/x/) && (Es.isFunction = s = function(m) {
    return typeof m == "function" && a.call(m) === "[object Function]";
  }), Es.isFunction = s;
  var o = Array.isArray || function(m) {
    return m && typeof m == "object" ? a.call(m) === "[object Array]" : !1;
  };
  Es.isArray = o;
  function l(m, A) {
    for (var w = 0, x = m.length; w < x; w++)
      if (m[w] === A)
        return w;
    return -1;
  }
  function u(m) {
    if (typeof m != "string") {
      if (m && m.toHTML)
        return m.toHTML();
      if (m == null)
        return "";
      if (!m)
        return m + "";
      m = "" + m;
    }
    return t.test(m) ? m.replace(e, n) : m;
  }
  function c(m) {
    return !m && m !== 0 ? !0 : !!(o(m) && m.length === 0);
  }
  function h(m) {
    var A = i({}, m);
    return A._parent = m, A;
  }
  function f(m, A) {
    return m.path = A, m;
  }
  function p(m, A) {
    return (m ? m + "." : "") + A;
  }
  return Es;
}
var tm = { exports: {} }, m2;
function So() {
  return m2 || (m2 = 1, (function(r, e) {
    e.__esModule = !0;
    var t = ["description", "fileName", "lineNumber", "endLineNumber", "message", "name", "number", "stack"];
    function n(i, a) {
      var s = a && a.loc, o = void 0, l = void 0, u = void 0, c = void 0;
      s && (o = s.start.line, l = s.end.line, u = s.start.column, c = s.end.column, i += " - " + o + ":" + u);
      for (var h = Error.prototype.constructor.call(this, i), f = 0; f < t.length; f++)
        this[t[f]] = h[t[f]];
      Error.captureStackTrace && Error.captureStackTrace(this, n);
      try {
        s && (this.lineNumber = o, this.endLineNumber = l, Object.defineProperty ? (Object.defineProperty(this, "column", {
          value: u,
          enumerable: !0
        }), Object.defineProperty(this, "endColumn", {
          value: c,
          enumerable: !0
        })) : (this.column = u, this.endColumn = c));
      } catch {
      }
    }
    n.prototype = new Error(), e.default = n, r.exports = e.default;
  })(tm, tm.exports)), tm.exports;
}
var Qh = {}, rm = { exports: {} }, v2;
function hG() {
  return v2 || (v2 = 1, (function(r, e) {
    e.__esModule = !0;
    var t = Is();
    e.default = function(n) {
      n.registerHelper("blockHelperMissing", function(i, a) {
        var s = a.inverse, o = a.fn;
        if (i === !0)
          return o(this);
        if (i === !1 || i == null)
          return s(this);
        if (t.isArray(i))
          return i.length > 0 ? (a.ids && (a.ids = [a.name]), n.helpers.each(i, a)) : s(this);
        if (a.data && a.ids) {
          var l = t.createFrame(a.data);
          l.contextPath = t.appendContextPath(a.data.contextPath, a.name), a = { data: l };
        }
        return o(i, a);
      });
    }, r.exports = e.default;
  })(rm, rm.exports)), rm.exports;
}
var nm = { exports: {} }, y2;
function pG() {
  return y2 || (y2 = 1, (function(r, e) {
    e.__esModule = !0;
    function t(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var n = Is(), i = So(), a = t(i);
    e.default = function(s) {
      s.registerHelper("each", function(o, l) {
        if (!l)
          throw new a.default("Must pass iterator to #each");
        var u = l.fn, c = l.inverse, h = 0, f = "", p = void 0, m = void 0;
        l.data && l.ids && (m = n.appendContextPath(l.data.contextPath, l.ids[0]) + "."), n.isFunction(o) && (o = o.call(this)), l.data && (p = n.createFrame(l.data));
        function A(D, F, _) {
          p && (p.key = D, p.index = F, p.first = F === 0, p.last = !!_, m && (p.contextPath = m + D)), f = f + u(o[D], {
            data: p,
            blockParams: n.blockParams([o[D], D], [m + D, null])
          });
        }
        if (o && typeof o == "object")
          if (n.isArray(o))
            for (var w = o.length; h < w; h++)
              h in o && A(h, h, h === o.length - 1);
          else if (typeof Symbol == "function" && o[Symbol.iterator]) {
            for (var x = [], E = o[Symbol.iterator](), T = E.next(); !T.done; T = E.next())
              x.push(T.value);
            o = x;
            for (var w = o.length; h < w; h++)
              A(h, h, h === o.length - 1);
          } else
            (function() {
              var D = void 0;
              Object.keys(o).forEach(function(F) {
                D !== void 0 && A(D, h - 1), D = F, h++;
              }), D !== void 0 && A(D, h - 1, !0);
            })();
        return h === 0 && (f = c(this)), f;
      });
    }, r.exports = e.default;
  })(nm, nm.exports)), nm.exports;
}
var im = { exports: {} }, A2;
function gG() {
  return A2 || (A2 = 1, (function(r, e) {
    e.__esModule = !0;
    function t(a) {
      return a && a.__esModule ? a : { default: a };
    }
    var n = So(), i = t(n);
    e.default = function(a) {
      a.registerHelper("helperMissing", function() {
        if (arguments.length !== 1)
          throw new i.default('Missing helper: "' + arguments[arguments.length - 1].name + '"');
      });
    }, r.exports = e.default;
  })(im, im.exports)), im.exports;
}
var am = { exports: {} }, w2;
function mG() {
  return w2 || (w2 = 1, (function(r, e) {
    e.__esModule = !0;
    function t(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var n = Is(), i = So(), a = t(i);
    e.default = function(s) {
      s.registerHelper("if", function(o, l) {
        if (arguments.length != 2)
          throw new a.default("#if requires exactly one argument");
        return n.isFunction(o) && (o = o.call(this)), !l.hash.includeZero && !o || n.isEmpty(o) ? l.inverse(this) : l.fn(this);
      }), s.registerHelper("unless", function(o, l) {
        if (arguments.length != 2)
          throw new a.default("#unless requires exactly one argument");
        return s.helpers.if.call(this, o, {
          fn: l.inverse,
          inverse: l.fn,
          hash: l.hash
        });
      });
    }, r.exports = e.default;
  })(am, am.exports)), am.exports;
}
var sm = { exports: {} }, x2;
function vG() {
  return x2 || (x2 = 1, (function(r, e) {
    e.__esModule = !0, e.default = function(t) {
      t.registerHelper("log", function() {
        for (var n = [void 0], i = arguments[arguments.length - 1], a = 0; a < arguments.length - 1; a++)
          n.push(arguments[a]);
        var s = 1;
        i.hash.level != null ? s = i.hash.level : i.data && i.data.level != null && (s = i.data.level), n[0] = s, t.log.apply(t, n);
      });
    }, r.exports = e.default;
  })(sm, sm.exports)), sm.exports;
}
var om = { exports: {} }, b2;
function yG() {
  return b2 || (b2 = 1, (function(r, e) {
    e.__esModule = !0, e.default = function(t) {
      t.registerHelper("lookup", function(n, i, a) {
        return n && a.lookupProperty(n, i);
      });
    }, r.exports = e.default;
  })(om, om.exports)), om.exports;
}
var lm = { exports: {} }, C2;
function AG() {
  return C2 || (C2 = 1, (function(r, e) {
    e.__esModule = !0;
    function t(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var n = Is(), i = So(), a = t(i);
    e.default = function(s) {
      s.registerHelper("with", function(o, l) {
        if (arguments.length != 2)
          throw new a.default("#with requires exactly one argument");
        n.isFunction(o) && (o = o.call(this));
        var u = l.fn;
        if (n.isEmpty(o))
          return l.inverse(this);
        var c = l.data;
        return l.data && l.ids && (c = n.createFrame(l.data), c.contextPath = n.appendContextPath(l.data.contextPath, l.ids[0])), u(o, {
          data: c,
          blockParams: n.blockParams([o], [c && c.contextPath])
        });
      });
    }, r.exports = e.default;
  })(lm, lm.exports)), lm.exports;
}
var S2;
function AD() {
  if (S2) return Qh;
  S2 = 1, Qh.__esModule = !0, Qh.registerDefaultHelpers = A, Qh.moveHelperToHooks = w;
  function r(x) {
    return x && x.__esModule ? x : { default: x };
  }
  var e = hG(), t = r(e), n = pG(), i = r(n), a = gG(), s = r(a), o = mG(), l = r(o), u = vG(), c = r(u), h = yG(), f = r(h), p = AG(), m = r(p);
  function A(x) {
    t.default(x), i.default(x), s.default(x), l.default(x), c.default(x), f.default(x), m.default(x);
  }
  function w(x, E, T) {
    x.helpers[E] && (x.hooks[E] = x.helpers[E], T || (x.helpers[E] = void 0));
  }
  return Qh;
}
var um = {}, cm = { exports: {} }, E2;
function wG() {
  return E2 || (E2 = 1, (function(r, e) {
    e.__esModule = !0;
    var t = Is();
    e.default = function(n) {
      n.registerDecorator("inline", function(i, a, s, o) {
        var l = i;
        return a.partials || (a.partials = {}, l = function(u, c) {
          var h = s.partials;
          s.partials = t.extend({}, h, a.partials);
          var f = i(u, c);
          return s.partials = h, f;
        }), a.partials[o.args[0]] = o.fn, l;
      });
    }, r.exports = e.default;
  })(cm, cm.exports)), cm.exports;
}
var k2;
function xG() {
  if (k2) return um;
  k2 = 1, um.__esModule = !0, um.registerDefaultDecorators = n;
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var e = wG(), t = r(e);
  function n(i) {
    t.default(i);
  }
  return um;
}
var fm = { exports: {} }, T2;
function wD() {
  return T2 || (T2 = 1, (function(r, e) {
    e.__esModule = !0;
    var t = Is(), n = {
      methodMap: ["debug", "info", "warn", "error"],
      level: "info",
      // Maps a given level value to the `methodMap` indexes above.
      lookupLevel: function(a) {
        if (typeof a == "string") {
          var s = t.indexOf(n.methodMap, a.toLowerCase());
          s >= 0 ? a = s : a = parseInt(a, 10);
        }
        return a;
      },
      // Can be overridden in the host environment
      log: function(a) {
        if (a = n.lookupLevel(a), typeof console < "u" && n.lookupLevel(n.level) <= a) {
          var s = n.methodMap[a];
          console[s] || (s = "log");
          for (var o = arguments.length, l = Array(o > 1 ? o - 1 : 0), u = 1; u < o; u++)
            l[u - 1] = arguments[u];
          console[s].apply(console, l);
        }
      }
    };
    e.default = n, r.exports = e.default;
  })(fm, fm.exports)), fm.exports;
}
var pd = {}, F2;
function xD() {
  if (F2) return pd;
  F2 = 1, pd.__esModule = !0, pd.createProtoAccessControl = a, pd.resultIsAllowed = s, pd.resetLoggedProperties = u;
  function r(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var e = Is(), t = wD(), n = r(t), i = /* @__PURE__ */ Object.create(null);
  function a(c) {
    var h = /* @__PURE__ */ Object.create(null);
    h.__proto__ = !1, e.extend(h, c.allowedProtoProperties);
    var f = /* @__PURE__ */ Object.create(null);
    return f.constructor = !1, f.__defineGetter__ = !1, f.__defineSetter__ = !1, f.__lookupGetter__ = !1, f.__lookupSetter__ = !1, e.extend(f, c.allowedProtoMethods), {
      properties: {
        whitelist: h,
        defaultValue: c.allowProtoPropertiesByDefault
      },
      methods: {
        whitelist: f,
        defaultValue: c.allowProtoMethodsByDefault
      }
    };
  }
  function s(c, h, f) {
    return o(typeof c == "function" ? h.methods : h.properties, f);
  }
  function o(c, h) {
    return c.whitelist[h] !== void 0 ? c.whitelist[h] === !0 : c.defaultValue !== void 0 ? c.defaultValue : (l(h), !1);
  }
  function l(c) {
    i[c] !== !0 && (i[c] = !0, n.default.log("error", 'Handlebars: Access has been denied to resolve the property "' + c + `" because it is not an "own property" of its parent.
You can add a runtime option to disable the check or this warning:
See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details`));
  }
  function u() {
    Object.keys(i).forEach(function(c) {
      delete i[c];
    });
  }
  return pd;
}
var I2;
function lx() {
  if (I2) return Ho;
  I2 = 1, Ho.__esModule = !0, Ho.HandlebarsEnvironment = m;
  function r(w) {
    return w && w.__esModule ? w : { default: w };
  }
  var e = Is(), t = So(), n = r(t), i = AD(), a = xG(), s = wD(), o = r(s), l = xD(), u = "4.7.9";
  Ho.VERSION = u;
  var c = 8;
  Ho.COMPILER_REVISION = c;
  var h = 7;
  Ho.LAST_COMPATIBLE_COMPILER_REVISION = h;
  var f = {
    1: "<= 1.0.rc.2",
    // 1.0.rc.2 is actually rev2 but doesn't report it
    2: "== 1.0.0-rc.3",
    3: "== 1.0.0-rc.4",
    4: "== 1.x.x",
    5: "== 2.0.0-alpha.x",
    6: ">= 2.0.0-beta.1",
    7: ">= 4.0.0 <4.3.0",
    8: ">= 4.3.0"
  };
  Ho.REVISION_CHANGES = f;
  var p = "[object Object]";
  function m(w, x, E) {
    this.helpers = w || {}, this.partials = x || {}, this.decorators = E || {}, i.registerDefaultHelpers(this), a.registerDefaultDecorators(this);
  }
  m.prototype = {
    constructor: m,
    logger: o.default,
    log: o.default.log,
    registerHelper: function(x, E) {
      if (e.toString.call(x) === p) {
        if (E)
          throw new n.default("Arg not supported with multiple helpers");
        e.extend(this.helpers, x);
      } else
        this.helpers[x] = E;
    },
    unregisterHelper: function(x) {
      delete this.helpers[x];
    },
    registerPartial: function(x, E) {
      if (e.toString.call(x) === p)
        e.extend(this.partials, x);
      else {
        if (typeof E > "u")
          throw new n.default('Attempting to register a partial called "' + x + '" as undefined');
        this.partials[x] = E;
      }
    },
    unregisterPartial: function(x) {
      delete this.partials[x];
    },
    registerDecorator: function(x, E) {
      if (e.toString.call(x) === p) {
        if (E)
          throw new n.default("Arg not supported with multiple decorators");
        e.extend(this.decorators, x);
      } else
        this.decorators[x] = E;
    },
    unregisterDecorator: function(x) {
      delete this.decorators[x];
    },
    /**
     * Reset the memory of illegal property accesses that have already been logged.
     * @deprecated should only be used in handlebars test-cases
     */
    resetLoggedPropertyAccesses: function() {
      l.resetLoggedProperties();
    }
  };
  var A = o.default.log;
  return Ho.log = A, Ho.createFrame = e.createFrame, Ho.logger = o.default, Ho;
}
var dm = { exports: {} }, P2;
function bG() {
  return P2 || (P2 = 1, (function(r, e) {
    e.__esModule = !0;
    function t(n) {
      this.string = n;
    }
    t.prototype.toString = t.prototype.toHTML = function() {
      return "" + this.string;
    }, e.default = t, r.exports = e.default;
  })(dm, dm.exports)), dm.exports;
}
var Au = {}, hm = {}, D2;
function CG() {
  if (D2) return hm;
  D2 = 1, hm.__esModule = !0, hm.wrapHelper = r;
  function r(e, t) {
    if (typeof e != "function")
      return e;
    var n = function() {
      var a = arguments[arguments.length - 1];
      return arguments[arguments.length - 1] = t(a), e.apply(this, arguments);
    };
    return n;
  }
  return hm;
}
var R2;
function SG() {
  if (R2) return Au;
  R2 = 1, Au.__esModule = !0, Au.checkRevision = c, Au.template = h, Au.wrapProgram = f, Au.resolvePartial = p, Au.invokePartial = m, Au.noop = A;
  function r(F) {
    return F && F.__esModule ? F : { default: F };
  }
  function e(F) {
    if (F && F.__esModule)
      return F;
    var _ = {};
    if (F != null)
      for (var L in F)
        Object.prototype.hasOwnProperty.call(F, L) && (_[L] = F[L]);
    return _.default = F, _;
  }
  var t = Is(), n = e(t), i = So(), a = r(i), s = lx(), o = AD(), l = CG(), u = xD();
  function c(F) {
    var _ = F && F[0] || 1, L = s.COMPILER_REVISION;
    if (!(_ >= s.LAST_COMPATIBLE_COMPILER_REVISION && _ <= s.COMPILER_REVISION))
      if (_ < s.LAST_COMPATIBLE_COMPILER_REVISION) {
        var Z = s.REVISION_CHANGES[L], te = s.REVISION_CHANGES[_];
        throw new a.default("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + Z + ") or downgrade your runtime to an older version (" + te + ").");
      } else
        throw new a.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + F[1] + ").");
  }
  function h(F, _) {
    if (!_)
      throw new a.default("No environment passed to template");
    if (!F || !F.main)
      throw new a.default("Unknown template object: " + typeof F);
    F.main.decorator = F.main_d, _.VM.checkRevision(F.compiler);
    var L = F.compiler && F.compiler[0] === 7;
    function Z(H, j, q) {
      q.hash && (j = n.extend({}, j, q.hash), q.ids && (q.ids[0] = !0)), H = _.VM.resolvePartial.call(this, H, j, q), q.hooks = this.hooks, q.protoAccessControl = this.protoAccessControl;
      var re = _.VM.invokePartial.call(this, H, j, q);
      if (re == null && _.compile && (q.partials[q.name] = _.compile(H, F.compilerOptions, _), re = q.partials[q.name](j, q)), re != null) {
        if (q.indent) {
          for (var ae = re.split(`
`), ye = 0, Se = ae.length; ye < Se && !(!ae[ye] && ye + 1 === Se); ye++)
            ae[ye] = q.indent + ae[ye];
          re = ae.join(`
`);
        }
        return re;
      } else
        throw new a.default("The partial " + q.name + " could not be compiled when running in runtime-only mode");
    }
    var te = {
      strict: function(j, q, re) {
        if (!j || !(q in j))
          throw new a.default('"' + q + '" not defined in ' + j, {
            loc: re
          });
        return te.lookupProperty(j, q);
      },
      lookupProperty: function(j, q) {
        var re = j[q];
        if (re == null || Object.prototype.hasOwnProperty.call(j, q) || u.resultIsAllowed(re, te.protoAccessControl, q))
          return re;
      },
      lookup: function(j, q) {
        for (var re = j.length, ae = 0; ae < re; ae++) {
          var ye = j[ae] && te.lookupProperty(j[ae], q);
          if (ye != null)
            return ye;
        }
      },
      lambda: function(j, q) {
        return typeof j == "function" ? j.call(q) : j;
      },
      escapeExpression: n.escapeExpression,
      invokePartial: Z,
      fn: function(j) {
        var q = F[j];
        return q.decorator = F[j + "_d"], q;
      },
      programs: [],
      program: function(j, q, re, ae, ye) {
        var Se = this.programs[j], Xe = this.fn(j);
        return q || ye || ae || re ? Se = f(this, j, Xe, q, re, ae, ye) : Se || (Se = this.programs[j] = f(this, j, Xe)), Se;
      },
      data: function(j, q) {
        for (; j && q--; )
          j = j._parent;
        return j;
      },
      mergeIfNeeded: function(j, q) {
        var re = j || q;
        return j && q && j !== q && (re = n.extend({}, q, j)), re;
      },
      // An empty object to use as replacement for null-contexts
      nullContext: Object.seal({}),
      noop: _.VM.noop,
      compilerInfo: F.compiler
    };
    function de(H) {
      var j = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1], q = j.data;
      de._setup(j), !j.partial && F.useData && (q = x(H, q));
      var re = void 0, ae = F.useBlockParams ? [] : void 0;
      F.useDepths && (j.depths ? re = H != j.depths[0] ? [H].concat(j.depths) : j.depths : re = [H]);
      function ye(Se) {
        return "" + F.main(te, Se, te.helpers, te.partials, q, ae, re);
      }
      return ye = E(F.main, ye, te, j.depths || [], q, ae), ye(H, j);
    }
    return de.isTop = !0, de._setup = function(H) {
      if (H.partial)
        te.protoAccessControl = H.protoAccessControl, te.helpers = H.helpers, te.partials = H.partials, te.decorators = H.decorators, te.hooks = H.hooks;
      else {
        var j = {};
        T(j, _.helpers, te), T(j, H.helpers, te), te.helpers = j, F.usePartial && (te.partials = te.mergeIfNeeded(H.partials, _.partials)), (F.usePartial || F.useDecorators) && (te.decorators = n.extend({}, _.decorators, H.decorators)), te.hooks = {}, te.protoAccessControl = u.createProtoAccessControl(H);
        var q = H.allowCallsToHelperMissing || L;
        o.moveHelperToHooks(te, "helperMissing", q), o.moveHelperToHooks(te, "blockHelperMissing", q);
      }
    }, de._child = function(H, j, q, re) {
      if (F.useBlockParams && !q)
        throw new a.default("must pass block params");
      if (F.useDepths && !re)
        throw new a.default("must pass parent depths");
      return f(te, H, F[H], j, 0, q, re);
    }, de;
  }
  function f(F, _, L, Z, te, de, H) {
    function j(q) {
      var re = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1], ae = H;
      return H && q != H[0] && !(q === F.nullContext && H[0] === null) && (ae = [q].concat(H)), L(F, q, F.helpers, F.partials, re.data || Z, de && [re.blockParams].concat(de), ae);
    }
    return j = E(L, j, F, H, Z, de), j.program = _, j.depth = H ? H.length : 0, j.blockParams = te || 0, j;
  }
  function p(F, _, L) {
    return F ? !F.call && !L.name && (L.name = F, F = w(L.partials, F)) : L.name === "@partial-block" ? F = w(L.data, "partial-block") : F = w(L.partials, L.name), F;
  }
  function m(F, _, L) {
    var Z = w(L.data, "partial-block");
    L.partial = !0, L.ids && (L.data.contextPath = L.ids[0] || L.data.contextPath);
    var te = void 0;
    if (L.fn && L.fn !== A && (function() {
      L.data = s.createFrame(L.data);
      var de = L.fn;
      te = L.data["partial-block"] = function(j) {
        var q = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
        return q.data = s.createFrame(q.data), q.data["partial-block"] = Z, de(j, q);
      }, de.partials && (L.partials = n.extend({}, L.partials, de.partials));
    })(), F === void 0 && te && (F = te), F === void 0)
      throw new a.default("The partial " + L.name + " could not be found");
    if (F instanceof Function)
      return F(_, L);
  }
  function A() {
    return "";
  }
  function w(F, _) {
    if (F && Object.prototype.hasOwnProperty.call(F, _))
      return F[_];
  }
  function x(F, _) {
    return (!_ || !("root" in _)) && (_ = _ ? s.createFrame(_) : {}, _.root = F), _;
  }
  function E(F, _, L, Z, te, de) {
    if (F.decorator) {
      var H = {};
      _ = F.decorator(_, H, L, Z && Z[0], te, de, Z), n.extend(_, H);
    }
    return _;
  }
  function T(F, _, L) {
    _ && Object.keys(_).forEach(function(Z) {
      var te = _[Z];
      F[Z] = D(te, L);
    });
  }
  function D(F, _) {
    var L = _.lookupProperty;
    return l.wrapHelper(F, function(Z) {
      return Z.lookupProperty = L, Z;
    });
  }
  return Au;
}
var pm = { exports: {} }, O2;
function bD() {
  return O2 || (O2 = 1, (function(r, e) {
    e.__esModule = !0, e.default = function(t) {
      (function() {
        typeof globalThis != "object" && (Object.prototype.__defineGetter__("__magic__", function() {
          return this;
        }), __magic__.globalThis = __magic__, delete Object.prototype.__magic__);
      })();
      var n = globalThis.Handlebars;
      t.noConflict = function() {
        return globalThis.Handlebars === t && (globalThis.Handlebars = n), t;
      };
    }, r.exports = e.default;
  })(pm, pm.exports)), pm.exports;
}
var B2;
function EG() {
  return B2 || (B2 = 1, (function(r, e) {
    e.__esModule = !0;
    function t(E) {
      return E && E.__esModule ? E : { default: E };
    }
    function n(E) {
      if (E && E.__esModule)
        return E;
      var T = {};
      if (E != null)
        for (var D in E)
          Object.prototype.hasOwnProperty.call(E, D) && (T[D] = E[D]);
      return T.default = E, T;
    }
    var i = lx(), a = n(i), s = bG(), o = t(s), l = So(), u = t(l), c = Is(), h = n(c), f = SG(), p = n(f), m = bD(), A = t(m);
    function w() {
      var E = new a.HandlebarsEnvironment();
      return h.extend(E, a), E.SafeString = o.default, E.Exception = u.default, E.Utils = h, E.escapeExpression = h.escapeExpression, E.VM = p, E.template = function(T) {
        return p.template(T, E);
      }, E;
    }
    var x = w();
    x.create = w, A.default(x), x.default = x, e.default = x, r.exports = e.default;
  })(em, em.exports)), em.exports;
}
var gm = { exports: {} }, _2;
function CD() {
  return _2 || (_2 = 1, (function(r, e) {
    e.__esModule = !0;
    var t = {
      // Public API used to evaluate derived attributes regarding AST nodes
      helpers: {
        // a mustache is definitely a helper if:
        // * it is an eligible helper, and
        // * it has at least one parameter or hash segment
        helperExpression: function(i) {
          return i.type === "SubExpression" || (i.type === "MustacheStatement" || i.type === "BlockStatement") && !!(i.params && i.params.length || i.hash);
        },
        scopedId: function(i) {
          return /^\.|this\b/.test(i.original);
        },
        // an ID is simple if it only has one part, and that part is not
        // `..` or `this`.
        simpleId: function(i) {
          return i.parts.length === 1 && !t.helpers.scopedId(i) && !i.depth;
        }
      }
    };
    e.default = t, r.exports = e.default;
  })(gm, gm.exports)), gm.exports;
}
var gd = {}, mm = { exports: {} }, M2;
function kG() {
  return M2 || (M2 = 1, (function(r, e) {
    e.__esModule = !0;
    var t = (function() {
      var n = {
        trace: function() {
        },
        yy: {},
        symbols_: { error: 2, root: 3, program: 4, EOF: 5, program_repetition0: 6, statement: 7, mustache: 8, block: 9, rawBlock: 10, partial: 11, partialBlock: 12, content: 13, COMMENT: 14, CONTENT: 15, openRawBlock: 16, rawBlock_repetition0: 17, END_RAW_BLOCK: 18, OPEN_RAW_BLOCK: 19, helperName: 20, openRawBlock_repetition0: 21, openRawBlock_option0: 22, CLOSE_RAW_BLOCK: 23, openBlock: 24, block_option0: 25, closeBlock: 26, openInverse: 27, block_option1: 28, OPEN_BLOCK: 29, openBlock_repetition0: 30, openBlock_option0: 31, openBlock_option1: 32, CLOSE: 33, OPEN_INVERSE: 34, openInverse_repetition0: 35, openInverse_option0: 36, openInverse_option1: 37, openInverseChain: 38, OPEN_INVERSE_CHAIN: 39, openInverseChain_repetition0: 40, openInverseChain_option0: 41, openInverseChain_option1: 42, inverseAndProgram: 43, INVERSE: 44, inverseChain: 45, inverseChain_option0: 46, OPEN_ENDBLOCK: 47, OPEN: 48, mustache_repetition0: 49, mustache_option0: 50, OPEN_UNESCAPED: 51, mustache_repetition1: 52, mustache_option1: 53, CLOSE_UNESCAPED: 54, OPEN_PARTIAL: 55, partialName: 56, partial_repetition0: 57, partial_option0: 58, openPartialBlock: 59, OPEN_PARTIAL_BLOCK: 60, openPartialBlock_repetition0: 61, openPartialBlock_option0: 62, param: 63, sexpr: 64, OPEN_SEXPR: 65, sexpr_repetition0: 66, sexpr_option0: 67, CLOSE_SEXPR: 68, hash: 69, hash_repetition_plus0: 70, hashSegment: 71, ID: 72, EQUALS: 73, blockParams: 74, OPEN_BLOCK_PARAMS: 75, blockParams_repetition_plus0: 76, CLOSE_BLOCK_PARAMS: 77, path: 78, dataName: 79, STRING: 80, NUMBER: 81, BOOLEAN: 82, UNDEFINED: 83, NULL: 84, DATA: 85, pathSegments: 86, SEP: 87, $accept: 0, $end: 1 },
        terminals_: { 2: "error", 5: "EOF", 14: "COMMENT", 15: "CONTENT", 18: "END_RAW_BLOCK", 19: "OPEN_RAW_BLOCK", 23: "CLOSE_RAW_BLOCK", 29: "OPEN_BLOCK", 33: "CLOSE", 34: "OPEN_INVERSE", 39: "OPEN_INVERSE_CHAIN", 44: "INVERSE", 47: "OPEN_ENDBLOCK", 48: "OPEN", 51: "OPEN_UNESCAPED", 54: "CLOSE_UNESCAPED", 55: "OPEN_PARTIAL", 60: "OPEN_PARTIAL_BLOCK", 65: "OPEN_SEXPR", 68: "CLOSE_SEXPR", 72: "ID", 73: "EQUALS", 75: "OPEN_BLOCK_PARAMS", 77: "CLOSE_BLOCK_PARAMS", 80: "STRING", 81: "NUMBER", 82: "BOOLEAN", 83: "UNDEFINED", 84: "NULL", 85: "DATA", 87: "SEP" },
        productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 0], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
        performAction: function(o, l, u, c, h, f, p) {
          var m = f.length - 1;
          switch (h) {
            case 1:
              return f[m - 1];
            case 2:
              this.$ = c.prepareProgram(f[m]);
              break;
            case 3:
              this.$ = f[m];
              break;
            case 4:
              this.$ = f[m];
              break;
            case 5:
              this.$ = f[m];
              break;
            case 6:
              this.$ = f[m];
              break;
            case 7:
              this.$ = f[m];
              break;
            case 8:
              this.$ = f[m];
              break;
            case 9:
              this.$ = {
                type: "CommentStatement",
                value: c.stripComment(f[m]),
                strip: c.stripFlags(f[m], f[m]),
                loc: c.locInfo(this._$)
              };
              break;
            case 10:
              this.$ = {
                type: "ContentStatement",
                original: f[m],
                value: f[m],
                loc: c.locInfo(this._$)
              };
              break;
            case 11:
              this.$ = c.prepareRawBlock(f[m - 2], f[m - 1], f[m], this._$);
              break;
            case 12:
              this.$ = { path: f[m - 3], params: f[m - 2], hash: f[m - 1] };
              break;
            case 13:
              this.$ = c.prepareBlock(f[m - 3], f[m - 2], f[m - 1], f[m], !1, this._$);
              break;
            case 14:
              this.$ = c.prepareBlock(f[m - 3], f[m - 2], f[m - 1], f[m], !0, this._$);
              break;
            case 15:
              this.$ = { open: f[m - 5], path: f[m - 4], params: f[m - 3], hash: f[m - 2], blockParams: f[m - 1], strip: c.stripFlags(f[m - 5], f[m]) };
              break;
            case 16:
              this.$ = { path: f[m - 4], params: f[m - 3], hash: f[m - 2], blockParams: f[m - 1], strip: c.stripFlags(f[m - 5], f[m]) };
              break;
            case 17:
              this.$ = { path: f[m - 4], params: f[m - 3], hash: f[m - 2], blockParams: f[m - 1], strip: c.stripFlags(f[m - 5], f[m]) };
              break;
            case 18:
              this.$ = { strip: c.stripFlags(f[m - 1], f[m - 1]), program: f[m] };
              break;
            case 19:
              var A = c.prepareBlock(f[m - 2], f[m - 1], f[m], f[m], !1, this._$), w = c.prepareProgram([A], f[m - 1].loc);
              w.chained = !0, this.$ = { strip: f[m - 2].strip, program: w, chain: !0 };
              break;
            case 20:
              this.$ = f[m];
              break;
            case 21:
              this.$ = { path: f[m - 1], strip: c.stripFlags(f[m - 2], f[m]) };
              break;
            case 22:
              this.$ = c.prepareMustache(f[m - 3], f[m - 2], f[m - 1], f[m - 4], c.stripFlags(f[m - 4], f[m]), this._$);
              break;
            case 23:
              this.$ = c.prepareMustache(f[m - 3], f[m - 2], f[m - 1], f[m - 4], c.stripFlags(f[m - 4], f[m]), this._$);
              break;
            case 24:
              this.$ = {
                type: "PartialStatement",
                name: f[m - 3],
                params: f[m - 2],
                hash: f[m - 1],
                indent: "",
                strip: c.stripFlags(f[m - 4], f[m]),
                loc: c.locInfo(this._$)
              };
              break;
            case 25:
              this.$ = c.preparePartialBlock(f[m - 2], f[m - 1], f[m], this._$);
              break;
            case 26:
              this.$ = { path: f[m - 3], params: f[m - 2], hash: f[m - 1], strip: c.stripFlags(f[m - 4], f[m]) };
              break;
            case 27:
              this.$ = f[m];
              break;
            case 28:
              this.$ = f[m];
              break;
            case 29:
              this.$ = {
                type: "SubExpression",
                path: f[m - 3],
                params: f[m - 2],
                hash: f[m - 1],
                loc: c.locInfo(this._$)
              };
              break;
            case 30:
              this.$ = { type: "Hash", pairs: f[m], loc: c.locInfo(this._$) };
              break;
            case 31:
              this.$ = { type: "HashPair", key: c.id(f[m - 2]), value: f[m], loc: c.locInfo(this._$) };
              break;
            case 32:
              this.$ = c.id(f[m - 1]);
              break;
            case 33:
              this.$ = f[m];
              break;
            case 34:
              this.$ = f[m];
              break;
            case 35:
              this.$ = { type: "StringLiteral", value: f[m], original: f[m], loc: c.locInfo(this._$) };
              break;
            case 36:
              this.$ = { type: "NumberLiteral", value: Number(f[m]), original: Number(f[m]), loc: c.locInfo(this._$) };
              break;
            case 37:
              this.$ = { type: "BooleanLiteral", value: f[m] === "true", original: f[m] === "true", loc: c.locInfo(this._$) };
              break;
            case 38:
              this.$ = { type: "UndefinedLiteral", original: void 0, value: void 0, loc: c.locInfo(this._$) };
              break;
            case 39:
              this.$ = { type: "NullLiteral", original: null, value: null, loc: c.locInfo(this._$) };
              break;
            case 40:
              this.$ = f[m];
              break;
            case 41:
              this.$ = f[m];
              break;
            case 42:
              this.$ = c.preparePath(!0, f[m], this._$);
              break;
            case 43:
              this.$ = c.preparePath(!1, f[m], this._$);
              break;
            case 44:
              f[m - 2].push({ part: c.id(f[m]), original: f[m], separator: f[m - 1] }), this.$ = f[m - 2];
              break;
            case 45:
              this.$ = [{ part: c.id(f[m]), original: f[m] }];
              break;
            case 46:
              this.$ = [];
              break;
            case 47:
              f[m - 1].push(f[m]);
              break;
            case 48:
              this.$ = [];
              break;
            case 49:
              f[m - 1].push(f[m]);
              break;
            case 50:
              this.$ = [];
              break;
            case 51:
              f[m - 1].push(f[m]);
              break;
            case 58:
              this.$ = [];
              break;
            case 59:
              f[m - 1].push(f[m]);
              break;
            case 64:
              this.$ = [];
              break;
            case 65:
              f[m - 1].push(f[m]);
              break;
            case 70:
              this.$ = [];
              break;
            case 71:
              f[m - 1].push(f[m]);
              break;
            case 78:
              this.$ = [];
              break;
            case 79:
              f[m - 1].push(f[m]);
              break;
            case 82:
              this.$ = [];
              break;
            case 83:
              f[m - 1].push(f[m]);
              break;
            case 86:
              this.$ = [];
              break;
            case 87:
              f[m - 1].push(f[m]);
              break;
            case 90:
              this.$ = [];
              break;
            case 91:
              f[m - 1].push(f[m]);
              break;
            case 94:
              this.$ = [];
              break;
            case 95:
              f[m - 1].push(f[m]);
              break;
            case 98:
              this.$ = [f[m]];
              break;
            case 99:
              f[m - 1].push(f[m]);
              break;
            case 100:
              this.$ = [f[m]];
              break;
            case 101:
              f[m - 1].push(f[m]);
              break;
          }
        },
        table: [{ 3: 1, 4: 2, 5: [2, 46], 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 1: [3] }, { 5: [1, 4] }, { 5: [2, 2], 7: 5, 8: 6, 9: 7, 10: 8, 11: 9, 12: 10, 13: 11, 14: [1, 12], 15: [1, 20], 16: 17, 19: [1, 23], 24: 15, 27: 16, 29: [1, 21], 34: [1, 22], 39: [2, 2], 44: [2, 2], 47: [2, 2], 48: [1, 13], 51: [1, 14], 55: [1, 18], 59: 19, 60: [1, 24] }, { 1: [2, 1] }, { 5: [2, 47], 14: [2, 47], 15: [2, 47], 19: [2, 47], 29: [2, 47], 34: [2, 47], 39: [2, 47], 44: [2, 47], 47: [2, 47], 48: [2, 47], 51: [2, 47], 55: [2, 47], 60: [2, 47] }, { 5: [2, 3], 14: [2, 3], 15: [2, 3], 19: [2, 3], 29: [2, 3], 34: [2, 3], 39: [2, 3], 44: [2, 3], 47: [2, 3], 48: [2, 3], 51: [2, 3], 55: [2, 3], 60: [2, 3] }, { 5: [2, 4], 14: [2, 4], 15: [2, 4], 19: [2, 4], 29: [2, 4], 34: [2, 4], 39: [2, 4], 44: [2, 4], 47: [2, 4], 48: [2, 4], 51: [2, 4], 55: [2, 4], 60: [2, 4] }, { 5: [2, 5], 14: [2, 5], 15: [2, 5], 19: [2, 5], 29: [2, 5], 34: [2, 5], 39: [2, 5], 44: [2, 5], 47: [2, 5], 48: [2, 5], 51: [2, 5], 55: [2, 5], 60: [2, 5] }, { 5: [2, 6], 14: [2, 6], 15: [2, 6], 19: [2, 6], 29: [2, 6], 34: [2, 6], 39: [2, 6], 44: [2, 6], 47: [2, 6], 48: [2, 6], 51: [2, 6], 55: [2, 6], 60: [2, 6] }, { 5: [2, 7], 14: [2, 7], 15: [2, 7], 19: [2, 7], 29: [2, 7], 34: [2, 7], 39: [2, 7], 44: [2, 7], 47: [2, 7], 48: [2, 7], 51: [2, 7], 55: [2, 7], 60: [2, 7] }, { 5: [2, 8], 14: [2, 8], 15: [2, 8], 19: [2, 8], 29: [2, 8], 34: [2, 8], 39: [2, 8], 44: [2, 8], 47: [2, 8], 48: [2, 8], 51: [2, 8], 55: [2, 8], 60: [2, 8] }, { 5: [2, 9], 14: [2, 9], 15: [2, 9], 19: [2, 9], 29: [2, 9], 34: [2, 9], 39: [2, 9], 44: [2, 9], 47: [2, 9], 48: [2, 9], 51: [2, 9], 55: [2, 9], 60: [2, 9] }, { 20: 25, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 36, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 37, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 4: 38, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 15: [2, 48], 17: 39, 18: [2, 48] }, { 20: 41, 56: 40, 64: 42, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 44, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 5: [2, 10], 14: [2, 10], 15: [2, 10], 18: [2, 10], 19: [2, 10], 29: [2, 10], 34: [2, 10], 39: [2, 10], 44: [2, 10], 47: [2, 10], 48: [2, 10], 51: [2, 10], 55: [2, 10], 60: [2, 10] }, { 20: 45, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 46, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 47, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 41, 56: 48, 64: 42, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [2, 78], 49: 49, 65: [2, 78], 72: [2, 78], 80: [2, 78], 81: [2, 78], 82: [2, 78], 83: [2, 78], 84: [2, 78], 85: [2, 78] }, { 23: [2, 33], 33: [2, 33], 54: [2, 33], 65: [2, 33], 68: [2, 33], 72: [2, 33], 75: [2, 33], 80: [2, 33], 81: [2, 33], 82: [2, 33], 83: [2, 33], 84: [2, 33], 85: [2, 33] }, { 23: [2, 34], 33: [2, 34], 54: [2, 34], 65: [2, 34], 68: [2, 34], 72: [2, 34], 75: [2, 34], 80: [2, 34], 81: [2, 34], 82: [2, 34], 83: [2, 34], 84: [2, 34], 85: [2, 34] }, { 23: [2, 35], 33: [2, 35], 54: [2, 35], 65: [2, 35], 68: [2, 35], 72: [2, 35], 75: [2, 35], 80: [2, 35], 81: [2, 35], 82: [2, 35], 83: [2, 35], 84: [2, 35], 85: [2, 35] }, { 23: [2, 36], 33: [2, 36], 54: [2, 36], 65: [2, 36], 68: [2, 36], 72: [2, 36], 75: [2, 36], 80: [2, 36], 81: [2, 36], 82: [2, 36], 83: [2, 36], 84: [2, 36], 85: [2, 36] }, { 23: [2, 37], 33: [2, 37], 54: [2, 37], 65: [2, 37], 68: [2, 37], 72: [2, 37], 75: [2, 37], 80: [2, 37], 81: [2, 37], 82: [2, 37], 83: [2, 37], 84: [2, 37], 85: [2, 37] }, { 23: [2, 38], 33: [2, 38], 54: [2, 38], 65: [2, 38], 68: [2, 38], 72: [2, 38], 75: [2, 38], 80: [2, 38], 81: [2, 38], 82: [2, 38], 83: [2, 38], 84: [2, 38], 85: [2, 38] }, { 23: [2, 39], 33: [2, 39], 54: [2, 39], 65: [2, 39], 68: [2, 39], 72: [2, 39], 75: [2, 39], 80: [2, 39], 81: [2, 39], 82: [2, 39], 83: [2, 39], 84: [2, 39], 85: [2, 39] }, { 23: [2, 43], 33: [2, 43], 54: [2, 43], 65: [2, 43], 68: [2, 43], 72: [2, 43], 75: [2, 43], 80: [2, 43], 81: [2, 43], 82: [2, 43], 83: [2, 43], 84: [2, 43], 85: [2, 43], 87: [1, 50] }, { 72: [1, 35], 86: 51 }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 52: 52, 54: [2, 82], 65: [2, 82], 72: [2, 82], 80: [2, 82], 81: [2, 82], 82: [2, 82], 83: [2, 82], 84: [2, 82], 85: [2, 82] }, { 25: 53, 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 54, 47: [2, 54] }, { 28: 59, 43: 60, 44: [1, 58], 47: [2, 56] }, { 13: 62, 15: [1, 20], 18: [1, 61] }, { 33: [2, 86], 57: 63, 65: [2, 86], 72: [2, 86], 80: [2, 86], 81: [2, 86], 82: [2, 86], 83: [2, 86], 84: [2, 86], 85: [2, 86] }, { 33: [2, 40], 65: [2, 40], 72: [2, 40], 80: [2, 40], 81: [2, 40], 82: [2, 40], 83: [2, 40], 84: [2, 40], 85: [2, 40] }, { 33: [2, 41], 65: [2, 41], 72: [2, 41], 80: [2, 41], 81: [2, 41], 82: [2, 41], 83: [2, 41], 84: [2, 41], 85: [2, 41] }, { 20: 64, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 65, 47: [1, 66] }, { 30: 67, 33: [2, 58], 65: [2, 58], 72: [2, 58], 75: [2, 58], 80: [2, 58], 81: [2, 58], 82: [2, 58], 83: [2, 58], 84: [2, 58], 85: [2, 58] }, { 33: [2, 64], 35: 68, 65: [2, 64], 72: [2, 64], 75: [2, 64], 80: [2, 64], 81: [2, 64], 82: [2, 64], 83: [2, 64], 84: [2, 64], 85: [2, 64] }, { 21: 69, 23: [2, 50], 65: [2, 50], 72: [2, 50], 80: [2, 50], 81: [2, 50], 82: [2, 50], 83: [2, 50], 84: [2, 50], 85: [2, 50] }, { 33: [2, 90], 61: 70, 65: [2, 90], 72: [2, 90], 80: [2, 90], 81: [2, 90], 82: [2, 90], 83: [2, 90], 84: [2, 90], 85: [2, 90] }, { 20: 74, 33: [2, 80], 50: 71, 63: 72, 64: 75, 65: [1, 43], 69: 73, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 72: [1, 79] }, { 23: [2, 42], 33: [2, 42], 54: [2, 42], 65: [2, 42], 68: [2, 42], 72: [2, 42], 75: [2, 42], 80: [2, 42], 81: [2, 42], 82: [2, 42], 83: [2, 42], 84: [2, 42], 85: [2, 42], 87: [1, 50] }, { 20: 74, 53: 80, 54: [2, 84], 63: 81, 64: 75, 65: [1, 43], 69: 82, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 83, 47: [1, 66] }, { 47: [2, 55] }, { 4: 84, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 47: [2, 20] }, { 20: 85, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 86, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 26: 87, 47: [1, 66] }, { 47: [2, 57] }, { 5: [2, 11], 14: [2, 11], 15: [2, 11], 19: [2, 11], 29: [2, 11], 34: [2, 11], 39: [2, 11], 44: [2, 11], 47: [2, 11], 48: [2, 11], 51: [2, 11], 55: [2, 11], 60: [2, 11] }, { 15: [2, 49], 18: [2, 49] }, { 20: 74, 33: [2, 88], 58: 88, 63: 89, 64: 75, 65: [1, 43], 69: 90, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 65: [2, 94], 66: 91, 68: [2, 94], 72: [2, 94], 80: [2, 94], 81: [2, 94], 82: [2, 94], 83: [2, 94], 84: [2, 94], 85: [2, 94] }, { 5: [2, 25], 14: [2, 25], 15: [2, 25], 19: [2, 25], 29: [2, 25], 34: [2, 25], 39: [2, 25], 44: [2, 25], 47: [2, 25], 48: [2, 25], 51: [2, 25], 55: [2, 25], 60: [2, 25] }, { 20: 92, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 31: 93, 33: [2, 60], 63: 94, 64: 75, 65: [1, 43], 69: 95, 70: 76, 71: 77, 72: [1, 78], 75: [2, 60], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 33: [2, 66], 36: 96, 63: 97, 64: 75, 65: [1, 43], 69: 98, 70: 76, 71: 77, 72: [1, 78], 75: [2, 66], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 22: 99, 23: [2, 52], 63: 100, 64: 75, 65: [1, 43], 69: 101, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 33: [2, 92], 62: 102, 63: 103, 64: 75, 65: [1, 43], 69: 104, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 105] }, { 33: [2, 79], 65: [2, 79], 72: [2, 79], 80: [2, 79], 81: [2, 79], 82: [2, 79], 83: [2, 79], 84: [2, 79], 85: [2, 79] }, { 33: [2, 81] }, { 23: [2, 27], 33: [2, 27], 54: [2, 27], 65: [2, 27], 68: [2, 27], 72: [2, 27], 75: [2, 27], 80: [2, 27], 81: [2, 27], 82: [2, 27], 83: [2, 27], 84: [2, 27], 85: [2, 27] }, { 23: [2, 28], 33: [2, 28], 54: [2, 28], 65: [2, 28], 68: [2, 28], 72: [2, 28], 75: [2, 28], 80: [2, 28], 81: [2, 28], 82: [2, 28], 83: [2, 28], 84: [2, 28], 85: [2, 28] }, { 23: [2, 30], 33: [2, 30], 54: [2, 30], 68: [2, 30], 71: 106, 72: [1, 107], 75: [2, 30] }, { 23: [2, 98], 33: [2, 98], 54: [2, 98], 68: [2, 98], 72: [2, 98], 75: [2, 98] }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 73: [1, 108], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 23: [2, 44], 33: [2, 44], 54: [2, 44], 65: [2, 44], 68: [2, 44], 72: [2, 44], 75: [2, 44], 80: [2, 44], 81: [2, 44], 82: [2, 44], 83: [2, 44], 84: [2, 44], 85: [2, 44], 87: [2, 44] }, { 54: [1, 109] }, { 54: [2, 83], 65: [2, 83], 72: [2, 83], 80: [2, 83], 81: [2, 83], 82: [2, 83], 83: [2, 83], 84: [2, 83], 85: [2, 83] }, { 54: [2, 85] }, { 5: [2, 13], 14: [2, 13], 15: [2, 13], 19: [2, 13], 29: [2, 13], 34: [2, 13], 39: [2, 13], 44: [2, 13], 47: [2, 13], 48: [2, 13], 51: [2, 13], 55: [2, 13], 60: [2, 13] }, { 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 111, 46: 110, 47: [2, 76] }, { 33: [2, 70], 40: 112, 65: [2, 70], 72: [2, 70], 75: [2, 70], 80: [2, 70], 81: [2, 70], 82: [2, 70], 83: [2, 70], 84: [2, 70], 85: [2, 70] }, { 47: [2, 18] }, { 5: [2, 14], 14: [2, 14], 15: [2, 14], 19: [2, 14], 29: [2, 14], 34: [2, 14], 39: [2, 14], 44: [2, 14], 47: [2, 14], 48: [2, 14], 51: [2, 14], 55: [2, 14], 60: [2, 14] }, { 33: [1, 113] }, { 33: [2, 87], 65: [2, 87], 72: [2, 87], 80: [2, 87], 81: [2, 87], 82: [2, 87], 83: [2, 87], 84: [2, 87], 85: [2, 87] }, { 33: [2, 89] }, { 20: 74, 63: 115, 64: 75, 65: [1, 43], 67: 114, 68: [2, 96], 69: 116, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 117] }, { 32: 118, 33: [2, 62], 74: 119, 75: [1, 120] }, { 33: [2, 59], 65: [2, 59], 72: [2, 59], 75: [2, 59], 80: [2, 59], 81: [2, 59], 82: [2, 59], 83: [2, 59], 84: [2, 59], 85: [2, 59] }, { 33: [2, 61], 75: [2, 61] }, { 33: [2, 68], 37: 121, 74: 122, 75: [1, 120] }, { 33: [2, 65], 65: [2, 65], 72: [2, 65], 75: [2, 65], 80: [2, 65], 81: [2, 65], 82: [2, 65], 83: [2, 65], 84: [2, 65], 85: [2, 65] }, { 33: [2, 67], 75: [2, 67] }, { 23: [1, 123] }, { 23: [2, 51], 65: [2, 51], 72: [2, 51], 80: [2, 51], 81: [2, 51], 82: [2, 51], 83: [2, 51], 84: [2, 51], 85: [2, 51] }, { 23: [2, 53] }, { 33: [1, 124] }, { 33: [2, 91], 65: [2, 91], 72: [2, 91], 80: [2, 91], 81: [2, 91], 82: [2, 91], 83: [2, 91], 84: [2, 91], 85: [2, 91] }, { 33: [2, 93] }, { 5: [2, 22], 14: [2, 22], 15: [2, 22], 19: [2, 22], 29: [2, 22], 34: [2, 22], 39: [2, 22], 44: [2, 22], 47: [2, 22], 48: [2, 22], 51: [2, 22], 55: [2, 22], 60: [2, 22] }, { 23: [2, 99], 33: [2, 99], 54: [2, 99], 68: [2, 99], 72: [2, 99], 75: [2, 99] }, { 73: [1, 108] }, { 20: 74, 63: 125, 64: 75, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 23], 14: [2, 23], 15: [2, 23], 19: [2, 23], 29: [2, 23], 34: [2, 23], 39: [2, 23], 44: [2, 23], 47: [2, 23], 48: [2, 23], 51: [2, 23], 55: [2, 23], 60: [2, 23] }, { 47: [2, 19] }, { 47: [2, 77] }, { 20: 74, 33: [2, 72], 41: 126, 63: 127, 64: 75, 65: [1, 43], 69: 128, 70: 76, 71: 77, 72: [1, 78], 75: [2, 72], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 24], 14: [2, 24], 15: [2, 24], 19: [2, 24], 29: [2, 24], 34: [2, 24], 39: [2, 24], 44: [2, 24], 47: [2, 24], 48: [2, 24], 51: [2, 24], 55: [2, 24], 60: [2, 24] }, { 68: [1, 129] }, { 65: [2, 95], 68: [2, 95], 72: [2, 95], 80: [2, 95], 81: [2, 95], 82: [2, 95], 83: [2, 95], 84: [2, 95], 85: [2, 95] }, { 68: [2, 97] }, { 5: [2, 21], 14: [2, 21], 15: [2, 21], 19: [2, 21], 29: [2, 21], 34: [2, 21], 39: [2, 21], 44: [2, 21], 47: [2, 21], 48: [2, 21], 51: [2, 21], 55: [2, 21], 60: [2, 21] }, { 33: [1, 130] }, { 33: [2, 63] }, { 72: [1, 132], 76: 131 }, { 33: [1, 133] }, { 33: [2, 69] }, { 15: [2, 12], 18: [2, 12] }, { 14: [2, 26], 15: [2, 26], 19: [2, 26], 29: [2, 26], 34: [2, 26], 47: [2, 26], 48: [2, 26], 51: [2, 26], 55: [2, 26], 60: [2, 26] }, { 23: [2, 31], 33: [2, 31], 54: [2, 31], 68: [2, 31], 72: [2, 31], 75: [2, 31] }, { 33: [2, 74], 42: 134, 74: 135, 75: [1, 120] }, { 33: [2, 71], 65: [2, 71], 72: [2, 71], 75: [2, 71], 80: [2, 71], 81: [2, 71], 82: [2, 71], 83: [2, 71], 84: [2, 71], 85: [2, 71] }, { 33: [2, 73], 75: [2, 73] }, { 23: [2, 29], 33: [2, 29], 54: [2, 29], 65: [2, 29], 68: [2, 29], 72: [2, 29], 75: [2, 29], 80: [2, 29], 81: [2, 29], 82: [2, 29], 83: [2, 29], 84: [2, 29], 85: [2, 29] }, { 14: [2, 15], 15: [2, 15], 19: [2, 15], 29: [2, 15], 34: [2, 15], 39: [2, 15], 44: [2, 15], 47: [2, 15], 48: [2, 15], 51: [2, 15], 55: [2, 15], 60: [2, 15] }, { 72: [1, 137], 77: [1, 136] }, { 72: [2, 100], 77: [2, 100] }, { 14: [2, 16], 15: [2, 16], 19: [2, 16], 29: [2, 16], 34: [2, 16], 44: [2, 16], 47: [2, 16], 48: [2, 16], 51: [2, 16], 55: [2, 16], 60: [2, 16] }, { 33: [1, 138] }, { 33: [2, 75] }, { 33: [2, 32] }, { 72: [2, 101], 77: [2, 101] }, { 14: [2, 17], 15: [2, 17], 19: [2, 17], 29: [2, 17], 34: [2, 17], 39: [2, 17], 44: [2, 17], 47: [2, 17], 48: [2, 17], 51: [2, 17], 55: [2, 17], 60: [2, 17] }],
        defaultActions: { 4: [2, 1], 54: [2, 55], 56: [2, 20], 60: [2, 57], 73: [2, 81], 82: [2, 85], 86: [2, 18], 90: [2, 89], 101: [2, 53], 104: [2, 93], 110: [2, 19], 111: [2, 77], 116: [2, 97], 119: [2, 63], 122: [2, 69], 135: [2, 75], 136: [2, 32] },
        parseError: function(o, l) {
          throw new Error(o);
        },
        parse: function(o) {
          var l = this, u = [0], c = [null], h = [], f = this.table, p = "", m = 0, A = 0;
          this.lexer.setInput(o), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, this.yy.parser = this, typeof this.lexer.yylloc > "u" && (this.lexer.yylloc = {});
          var w = this.lexer.yylloc;
          h.push(w);
          var x = this.lexer.options && this.lexer.options.ranges;
          typeof this.yy.parseError == "function" && (this.parseError = this.yy.parseError);
          function E() {
            var q;
            return q = l.lexer.lex() || 1, typeof q != "number" && (q = l.symbols_[q] || q), q;
          }
          for (var T, D, F, _, L = {}, Z, te, de, H; ; ) {
            if (D = u[u.length - 1], this.defaultActions[D] ? F = this.defaultActions[D] : ((T === null || typeof T > "u") && (T = E()), F = f[D] && f[D][T]), typeof F > "u" || !F.length || !F[0]) {
              var j = "";
              {
                H = [];
                for (Z in f[D]) this.terminals_[Z] && Z > 2 && H.push("'" + this.terminals_[Z] + "'");
                this.lexer.showPosition ? j = "Parse error on line " + (m + 1) + `:
` + this.lexer.showPosition() + `
Expecting ` + H.join(", ") + ", got '" + (this.terminals_[T] || T) + "'" : j = "Parse error on line " + (m + 1) + ": Unexpected " + (T == 1 ? "end of input" : "'" + (this.terminals_[T] || T) + "'"), this.parseError(j, { text: this.lexer.match, token: this.terminals_[T] || T, line: this.lexer.yylineno, loc: w, expected: H });
              }
            }
            if (F[0] instanceof Array && F.length > 1)
              throw new Error("Parse Error: multiple actions possible at state: " + D + ", token: " + T);
            switch (F[0]) {
              case 1:
                u.push(T), c.push(this.lexer.yytext), h.push(this.lexer.yylloc), u.push(F[1]), T = null, A = this.lexer.yyleng, p = this.lexer.yytext, m = this.lexer.yylineno, w = this.lexer.yylloc;
                break;
              case 2:
                if (te = this.productions_[F[1]][1], L.$ = c[c.length - te], L._$ = { first_line: h[h.length - (te || 1)].first_line, last_line: h[h.length - 1].last_line, first_column: h[h.length - (te || 1)].first_column, last_column: h[h.length - 1].last_column }, x && (L._$.range = [h[h.length - (te || 1)].range[0], h[h.length - 1].range[1]]), _ = this.performAction.call(L, p, A, m, this.yy, F[1], c, h), typeof _ < "u")
                  return _;
                te && (u = u.slice(0, -1 * te * 2), c = c.slice(0, -1 * te), h = h.slice(0, -1 * te)), u.push(this.productions_[F[1]][0]), c.push(L.$), h.push(L._$), de = f[u[u.length - 2]][u[u.length - 1]], u.push(de);
                break;
              case 3:
                return !0;
            }
          }
          return !0;
        }
      }, i = (function() {
        var s = {
          EOF: 1,
          parseError: function(l, u) {
            if (this.yy.parser)
              this.yy.parser.parseError(l, u);
            else
              throw new Error(l);
          },
          setInput: function(l) {
            return this._input = l, this._more = this._less = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
          },
          input: function() {
            var l = this._input[0];
            this.yytext += l, this.yyleng++, this.offset++, this.match += l, this.matched += l;
            var u = l.match(/(?:\r\n?|\n).*/g);
            return u ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), l;
          },
          unput: function(l) {
            var u = l.length, c = l.split(/(?:\r\n?|\n)/g);
            this._input = l + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - u - 1), this.offset -= u;
            var h = this.match.split(/(?:\r\n?|\n)/g);
            this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), c.length - 1 && (this.yylineno -= c.length - 1);
            var f = this.yylloc.range;
            return this.yylloc = {
              first_line: this.yylloc.first_line,
              last_line: this.yylineno + 1,
              first_column: this.yylloc.first_column,
              last_column: c ? (c.length === h.length ? this.yylloc.first_column : 0) + h[h.length - c.length].length - c[0].length : this.yylloc.first_column - u
            }, this.options.ranges && (this.yylloc.range = [f[0], f[0] + this.yyleng - u]), this;
          },
          more: function() {
            return this._more = !0, this;
          },
          less: function(l) {
            this.unput(this.match.slice(l));
          },
          pastInput: function() {
            var l = this.matched.substr(0, this.matched.length - this.match.length);
            return (l.length > 20 ? "..." : "") + l.substr(-20).replace(/\n/g, "");
          },
          upcomingInput: function() {
            var l = this.match;
            return l.length < 20 && (l += this._input.substr(0, 20 - l.length)), (l.substr(0, 20) + (l.length > 20 ? "..." : "")).replace(/\n/g, "");
          },
          showPosition: function() {
            var l = this.pastInput(), u = new Array(l.length + 1).join("-");
            return l + this.upcomingInput() + `
` + u + "^";
          },
          next: function() {
            if (this.done)
              return this.EOF;
            this._input || (this.done = !0);
            var l, u, c, h, f;
            this._more || (this.yytext = "", this.match = "");
            for (var p = this._currentRules(), m = 0; m < p.length && (c = this._input.match(this.rules[p[m]]), !(c && (!u || c[0].length > u[0].length) && (u = c, h = m, !this.options.flex))); m++)
              ;
            return u ? (f = u[0].match(/(?:\r\n?|\n).*/g), f && (this.yylineno += f.length), this.yylloc = {
              first_line: this.yylloc.last_line,
              last_line: this.yylineno + 1,
              first_column: this.yylloc.last_column,
              last_column: f ? f[f.length - 1].length - f[f.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + u[0].length
            }, this.yytext += u[0], this.match += u[0], this.matches = u, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._input = this._input.slice(u[0].length), this.matched += u[0], l = this.performAction.call(this, this.yy, this, p[h], this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), l || void 0) : this._input === "" ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + `. Unrecognized text.
` + this.showPosition(), { text: "", token: null, line: this.yylineno });
          },
          lex: function() {
            var l = this.next();
            return typeof l < "u" ? l : this.lex();
          },
          begin: function(l) {
            this.conditionStack.push(l);
          },
          popState: function() {
            return this.conditionStack.pop();
          },
          _currentRules: function() {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
          },
          topState: function() {
            return this.conditionStack[this.conditionStack.length - 2];
          },
          pushState: function(l) {
            this.begin(l);
          }
        };
        return s.options = {}, s.performAction = function(l, u, c, h) {
          function f(p, m) {
            return u.yytext = u.yytext.substring(p, u.yyleng - m + p);
          }
          switch (c) {
            case 0:
              if (u.yytext.slice(-2) === "\\\\" ? (f(0, 1), this.begin("mu")) : u.yytext.slice(-1) === "\\" ? (f(0, 1), this.begin("emu")) : this.begin("mu"), u.yytext) return 15;
              break;
            case 1:
              return 15;
            case 2:
              return this.popState(), 15;
            case 3:
              return this.begin("raw"), 15;
            case 4:
              return this.popState(), this.conditionStack[this.conditionStack.length - 1] === "raw" ? 15 : (f(5, 9), "END_RAW_BLOCK");
            case 5:
              return 15;
            case 6:
              return this.popState(), 14;
            case 7:
              return 65;
            case 8:
              return 68;
            case 9:
              return 19;
            case 10:
              return this.popState(), this.begin("raw"), 23;
            case 11:
              return 55;
            case 12:
              return 60;
            case 13:
              return 29;
            case 14:
              return 47;
            case 15:
              return this.popState(), 44;
            case 16:
              return this.popState(), 44;
            case 17:
              return 34;
            case 18:
              return 39;
            case 19:
              return 51;
            case 20:
              return 48;
            case 21:
              this.unput(u.yytext), this.popState(), this.begin("com");
              break;
            case 22:
              return this.popState(), 14;
            case 23:
              return 48;
            case 24:
              return 73;
            case 25:
              return 72;
            case 26:
              return 72;
            case 27:
              return 87;
            case 28:
              break;
            case 29:
              return this.popState(), 54;
            case 30:
              return this.popState(), 33;
            case 31:
              return u.yytext = f(1, 2).replace(/\\"/g, '"'), 80;
            case 32:
              return u.yytext = f(1, 2).replace(/\\'/g, "'"), 80;
            case 33:
              return 85;
            case 34:
              return 82;
            case 35:
              return 82;
            case 36:
              return 83;
            case 37:
              return 84;
            case 38:
              return 81;
            case 39:
              return 75;
            case 40:
              return 77;
            case 41:
              return 72;
            case 42:
              return u.yytext = u.yytext.replace(/\\([\\\]])/g, "$1"), 72;
            case 43:
              return "INVALID";
            case 44:
              return 5;
          }
        }, s.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^\/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]+?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/], s.conditions = { mu: { rules: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44], inclusive: !1 }, emu: { rules: [2], inclusive: !1 }, com: { rules: [6], inclusive: !1 }, raw: { rules: [3, 4, 5], inclusive: !1 }, INITIAL: { rules: [0, 1, 44], inclusive: !0 } }, s;
      })();
      n.lexer = i;
      function a() {
        this.yy = {};
      }
      return a.prototype = n, n.Parser = a, new a();
    })();
    e.default = t, r.exports = e.default;
  })(mm, mm.exports)), mm.exports;
}
var vm = { exports: {} }, ym = { exports: {} }, N2;
function SD() {
  return N2 || (N2 = 1, (function(r, e) {
    e.__esModule = !0;
    function t(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var n = So(), i = t(n);
    function a() {
      this.parents = [];
    }
    a.prototype = {
      constructor: a,
      mutating: !1,
      // Visits a given value. If mutating, will replace the value if necessary.
      acceptKey: function(c, h) {
        var f = this.accept(c[h]);
        if (this.mutating) {
          if (f && !a.prototype[f.type])
            throw new i.default('Unexpected node type "' + f.type + '" found when accepting ' + h + " on " + c.type);
          c[h] = f;
        }
      },
      // Performs an accept operation with added sanity check to ensure
      // required keys are not removed.
      acceptRequired: function(c, h) {
        if (this.acceptKey(c, h), !c[h])
          throw new i.default(c.type + " requires " + h);
      },
      // Traverses a given array. If mutating, empty respnses will be removed
      // for child elements.
      acceptArray: function(c) {
        for (var h = 0, f = c.length; h < f; h++)
          this.acceptKey(c, h), c[h] || (c.splice(h, 1), h--, f--);
      },
      accept: function(c) {
        if (c) {
          if (!this[c.type])
            throw new i.default("Unknown type: " + c.type, c);
          this.current && this.parents.unshift(this.current), this.current = c;
          var h = this[c.type](c);
          if (this.current = this.parents.shift(), !this.mutating || h)
            return h;
          if (h !== !1)
            return c;
        }
      },
      Program: function(c) {
        this.acceptArray(c.body);
      },
      MustacheStatement: s,
      Decorator: s,
      BlockStatement: o,
      DecoratorBlock: o,
      PartialStatement: l,
      PartialBlockStatement: function(c) {
        l.call(this, c), this.acceptKey(c, "program");
      },
      ContentStatement: function() {
      },
      CommentStatement: function() {
      },
      SubExpression: s,
      PathExpression: function() {
      },
      StringLiteral: function() {
      },
      NumberLiteral: function() {
      },
      BooleanLiteral: function() {
      },
      UndefinedLiteral: function() {
      },
      NullLiteral: function() {
      },
      Hash: function(c) {
        this.acceptArray(c.pairs);
      },
      HashPair: function(c) {
        this.acceptRequired(c, "value");
      }
    };
    function s(u) {
      this.acceptRequired(u, "path"), this.acceptArray(u.params), this.acceptKey(u, "hash");
    }
    function o(u) {
      s.call(this, u), this.acceptKey(u, "program"), this.acceptKey(u, "inverse");
    }
    function l(u) {
      this.acceptRequired(u, "name"), this.acceptArray(u.params), this.acceptKey(u, "hash");
    }
    e.default = a, r.exports = e.default;
  })(ym, ym.exports)), ym.exports;
}
var L2;
function TG() {
  return L2 || (L2 = 1, (function(r, e) {
    e.__esModule = !0;
    function t(c) {
      return c && c.__esModule ? c : { default: c };
    }
    var n = SD(), i = t(n);
    function a() {
      var c = arguments.length <= 0 || arguments[0] === void 0 ? {} : arguments[0];
      this.options = c;
    }
    a.prototype = new i.default(), a.prototype.Program = function(c) {
      var h = !this.options.ignoreStandalone, f = !this.isRootSeen;
      this.isRootSeen = !0;
      for (var p = c.body, m = 0, A = p.length; m < A; m++) {
        var w = p[m], x = this.accept(w);
        if (x) {
          var E = s(p, m, f), T = o(p, m, f), D = x.openStandalone && E, F = x.closeStandalone && T, _ = x.inlineStandalone && E && T;
          x.close && l(p, m, !0), x.open && u(p, m, !0), h && _ && (l(p, m), u(p, m) && w.type === "PartialStatement" && (w.indent = /([ \t]+$)/.exec(p[m - 1].original)[1])), h && D && (l((w.program || w.inverse).body), u(p, m)), h && F && (l(p, m), u((w.inverse || w.program).body));
        }
      }
      return c;
    }, a.prototype.BlockStatement = a.prototype.DecoratorBlock = a.prototype.PartialBlockStatement = function(c) {
      this.accept(c.program), this.accept(c.inverse);
      var h = c.program || c.inverse, f = c.program && c.inverse, p = f, m = f;
      if (f && f.chained)
        for (p = f.body[0].program; m.chained; )
          m = m.body[m.body.length - 1].program;
      var A = {
        open: c.openStrip.open,
        close: c.closeStrip.close,
        // Determine the standalone candiacy. Basically flag our content as being possibly standalone
        // so our parent can determine if we actually are standalone
        openStandalone: o(h.body),
        closeStandalone: s((p || h).body)
      };
      if (c.openStrip.close && l(h.body, null, !0), f) {
        var w = c.inverseStrip;
        w.open && u(h.body, null, !0), w.close && l(p.body, null, !0), c.closeStrip.open && u(m.body, null, !0), !this.options.ignoreStandalone && s(h.body) && o(p.body) && (u(h.body), l(p.body));
      } else c.closeStrip.open && u(h.body, null, !0);
      return A;
    }, a.prototype.Decorator = a.prototype.MustacheStatement = function(c) {
      return c.strip;
    }, a.prototype.PartialStatement = a.prototype.CommentStatement = function(c) {
      var h = c.strip || {};
      return {
        inlineStandalone: !0,
        open: h.open,
        close: h.close
      };
    };
    function s(c, h, f) {
      h === void 0 && (h = c.length);
      var p = c[h - 1], m = c[h - 2];
      if (!p)
        return f;
      if (p.type === "ContentStatement")
        return (m || !f ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(p.original);
    }
    function o(c, h, f) {
      h === void 0 && (h = -1);
      var p = c[h + 1], m = c[h + 2];
      if (!p)
        return f;
      if (p.type === "ContentStatement")
        return (m || !f ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(p.original);
    }
    function l(c, h, f) {
      var p = c[h == null ? 0 : h + 1];
      if (!(!p || p.type !== "ContentStatement" || !f && p.rightStripped)) {
        var m = p.value;
        p.value = p.value.replace(f ? /^\s+/ : /^[ \t]*\r?\n?/, ""), p.rightStripped = p.value !== m;
      }
    }
    function u(c, h, f) {
      var p = c[h == null ? c.length - 1 : h - 1];
      if (!(!p || p.type !== "ContentStatement" || !f && p.leftStripped)) {
        var m = p.value;
        return p.value = p.value.replace(f ? /\s+$/ : /[ \t]+$/, ""), p.leftStripped = p.value !== m, p.leftStripped;
      }
    }
    e.default = a, r.exports = e.default;
  })(vm, vm.exports)), vm.exports;
}
var js = {}, U2;
function FG() {
  if (U2) return js;
  U2 = 1, js.__esModule = !0, js.SourceLocation = i, js.id = a, js.stripFlags = s, js.stripComment = o, js.preparePath = l, js.prepareMustache = u, js.prepareRawBlock = c, js.prepareBlock = h, js.prepareProgram = f, js.preparePartialBlock = p;
  function r(m) {
    return m && m.__esModule ? m : { default: m };
  }
  var e = So(), t = r(e);
  function n(m, A) {
    if (A = A.path ? A.path.original : A, m.path.original !== A) {
      var w = { loc: m.path.loc };
      throw new t.default(m.path.original + " doesn't match " + A, w);
    }
  }
  function i(m, A) {
    this.source = m, this.start = {
      line: A.first_line,
      column: A.first_column
    }, this.end = {
      line: A.last_line,
      column: A.last_column
    };
  }
  function a(m) {
    return /^\[.*\]$/.test(m) ? m.substring(1, m.length - 1) : m;
  }
  function s(m, A) {
    return {
      open: m.charAt(2) === "~",
      close: A.charAt(A.length - 3) === "~"
    };
  }
  function o(m) {
    return m.replace(/^\{\{~?!-?-?/, "").replace(/-?-?~?\}\}$/, "");
  }
  function l(m, A, w) {
    w = this.locInfo(w);
    for (var x = m ? "@" : "", E = [], T = 0, D = 0, F = A.length; D < F; D++) {
      var _ = A[D].part, L = A[D].original !== _;
      if (x += (A[D].separator || "") + _, !L && (_ === ".." || _ === "." || _ === "this")) {
        if (E.length > 0)
          throw new t.default("Invalid path: " + x, { loc: w });
        _ === ".." && T++;
      } else
        E.push(_);
    }
    return {
      type: "PathExpression",
      data: m,
      depth: T,
      parts: E,
      original: x,
      loc: w
    };
  }
  function u(m, A, w, x, E, T) {
    var D = x.charAt(3) || x.charAt(2), F = D !== "{" && D !== "&", _ = /\*/.test(x);
    return {
      type: _ ? "Decorator" : "MustacheStatement",
      path: m,
      params: A,
      hash: w,
      escaped: F,
      strip: E,
      loc: this.locInfo(T)
    };
  }
  function c(m, A, w, x) {
    n(m, w), x = this.locInfo(x);
    var E = {
      type: "Program",
      body: A,
      strip: {},
      loc: x
    };
    return {
      type: "BlockStatement",
      path: m.path,
      params: m.params,
      hash: m.hash,
      program: E,
      openStrip: {},
      inverseStrip: {},
      closeStrip: {},
      loc: x
    };
  }
  function h(m, A, w, x, E, T) {
    x && x.path && n(m, x);
    var D = /\*/.test(m.open);
    A.blockParams = m.blockParams;
    var F = void 0, _ = void 0;
    if (w) {
      if (D)
        throw new t.default("Unexpected inverse block on decorator", w);
      w.chain && (w.program.body[0].closeStrip = x.strip), _ = w.strip, F = w.program;
    }
    return E && (E = F, F = A, A = E), {
      type: D ? "DecoratorBlock" : "BlockStatement",
      path: m.path,
      params: m.params,
      hash: m.hash,
      program: A,
      inverse: F,
      openStrip: m.strip,
      inverseStrip: _,
      closeStrip: x && x.strip,
      loc: this.locInfo(T)
    };
  }
  function f(m, A) {
    if (!A && m.length) {
      var w = m[0].loc, x = m[m.length - 1].loc;
      w && x && (A = {
        source: w.source,
        start: {
          line: w.start.line,
          column: w.start.column
        },
        end: {
          line: x.end.line,
          column: x.end.column
        }
      });
    }
    return {
      type: "Program",
      body: m,
      strip: {},
      loc: A
    };
  }
  function p(m, A, w, x) {
    return n(m, w), {
      type: "PartialBlockStatement",
      name: m.path,
      params: m.params,
      hash: m.hash,
      program: A,
      openStrip: m.strip,
      closeStrip: w && w.strip,
      loc: this.locInfo(x)
    };
  }
  return js;
}
var V2;
function IG() {
  if (V2) return gd;
  V2 = 1, gd.__esModule = !0, gd.parseWithoutProcessing = f, gd.parse = p;
  function r(x) {
    if (x && x.__esModule)
      return x;
    var E = {};
    if (x != null)
      for (var T in x)
        Object.prototype.hasOwnProperty.call(x, T) && (E[T] = x[T]);
    return E.default = x, E;
  }
  function e(x) {
    return x && x.__esModule ? x : { default: x };
  }
  var t = kG(), n = e(t), i = TG(), a = e(i), s = FG(), o = r(s), l = So(), u = e(l), c = Is();
  gd.parser = n.default;
  var h = {};
  c.extend(h, o);
  function f(x, E) {
    if (x.type === "Program")
      return m(x), x;
    n.default.yy = h, h.locInfo = function(D) {
      return new h.SourceLocation(E && E.srcName, D);
    };
    var T = n.default.parse(x);
    return T;
  }
  function p(x, E) {
    var T = f(x, E), D = new a.default(E);
    return D.accept(T);
  }
  function m(x) {
    A(x);
  }
  function A(x) {
    if (x != null) {
      if (Array.isArray(x)) {
        x.forEach(A);
        return;
      }
      if (typeof x == "object") {
        if (x.type === "PathExpression") {
          if (!w(x.depth))
            throw new u.default("Invalid AST: PathExpression.depth must be an integer");
          if (!Array.isArray(x.parts))
            throw new u.default("Invalid AST: PathExpression.parts must be an array");
          for (var E = 0; E < x.parts.length; E++)
            if (typeof x.parts[E] != "string")
              throw new u.default("Invalid AST: PathExpression.parts must only contain strings");
        } else if (x.type === "NumberLiteral") {
          if (typeof x.value != "number" || !isFinite(x.value))
            throw new u.default("Invalid AST: NumberLiteral.value must be a number");
        } else if (x.type === "BooleanLiteral" && typeof x.value != "boolean")
          throw new u.default("Invalid AST: BooleanLiteral.value must be a boolean");
        Object.keys(x).forEach(function(T) {
          T !== "loc" && A(x[T]);
        });
      }
    }
  }
  function w(x) {
    return typeof x == "number" && isFinite(x) && Math.floor(x) === x && x >= 0;
  }
  return gd;
}
var md = {}, $2;
function PG() {
  if ($2) return md;
  $2 = 1, md.__esModule = !0, md.Compiler = o, md.precompile = l, md.compile = u;
  function r(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var e = So(), t = r(e), n = Is(), i = CD(), a = r(i), s = [].slice;
  function o() {
  }
  o.prototype = {
    compiler: o,
    equals: function(p) {
      var m = this.opcodes.length;
      if (p.opcodes.length !== m)
        return !1;
      for (var A = 0; A < m; A++) {
        var w = this.opcodes[A], x = p.opcodes[A];
        if (w.opcode !== x.opcode || !c(w.args, x.args))
          return !1;
      }
      m = this.children.length;
      for (var A = 0; A < m; A++)
        if (!this.children[A].equals(p.children[A]))
          return !1;
      return !0;
    },
    guid: 0,
    compile: function(p, m) {
      return this.sourceNode = [], this.opcodes = [], this.children = [], this.options = m, this.stringParams = m.stringParams, this.trackIds = m.trackIds, m.blockParams = m.blockParams || [], m.knownHelpers = n.extend(/* @__PURE__ */ Object.create(null), {
        helperMissing: !0,
        blockHelperMissing: !0,
        each: !0,
        if: !0,
        unless: !0,
        with: !0,
        log: !0,
        lookup: !0
      }, m.knownHelpers), this.accept(p);
    },
    compileProgram: function(p) {
      var m = new this.compiler(), A = m.compile(p, this.options), w = this.guid++;
      return this.usePartial = this.usePartial || A.usePartial, this.children[w] = A, this.useDepths = this.useDepths || A.useDepths, w;
    },
    accept: function(p) {
      if (!this[p.type])
        throw new t.default("Unknown type: " + p.type, p);
      this.sourceNode.unshift(p);
      var m = this[p.type](p);
      return this.sourceNode.shift(), m;
    },
    Program: function(p) {
      this.options.blockParams.unshift(p.blockParams);
      for (var m = p.body, A = m.length, w = 0; w < A; w++)
        this.accept(m[w]);
      return this.options.blockParams.shift(), this.isSimple = A === 1, this.blockParams = p.blockParams ? p.blockParams.length : 0, this;
    },
    BlockStatement: function(p) {
      h(p);
      var m = p.program, A = p.inverse;
      m = m && this.compileProgram(m), A = A && this.compileProgram(A);
      var w = this.classifySexpr(p);
      w === "helper" ? this.helperSexpr(p, m, A) : w === "simple" ? (this.simpleSexpr(p), this.opcode("pushProgram", m), this.opcode("pushProgram", A), this.opcode("emptyHash"), this.opcode("blockValue", p.path.original)) : (this.ambiguousSexpr(p, m, A), this.opcode("pushProgram", m), this.opcode("pushProgram", A), this.opcode("emptyHash"), this.opcode("ambiguousBlockValue")), this.opcode("append");
    },
    DecoratorBlock: function(p) {
      var m = p.program && this.compileProgram(p.program), A = this.setupFullMustacheParams(p, m, void 0), w = p.path;
      this.useDecorators = !0, this.opcode("registerDecorator", A.length, w.original);
    },
    PartialStatement: function(p) {
      this.usePartial = !0;
      var m = p.program;
      m && (m = this.compileProgram(p.program));
      var A = p.params;
      if (A.length > 1)
        throw new t.default("Unsupported number of partial arguments: " + A.length, p);
      A.length || (this.options.explicitPartialContext ? this.opcode("pushLiteral", "undefined") : A.push({ type: "PathExpression", parts: [], depth: 0 }));
      var w = p.name.original, x = p.name.type === "SubExpression";
      x && this.accept(p.name), this.setupFullMustacheParams(p, m, void 0, !0);
      var E = p.indent || "";
      this.options.preventIndent && E && (this.opcode("appendContent", E), E = ""), this.opcode("invokePartial", x, w, E), this.opcode("append");
    },
    PartialBlockStatement: function(p) {
      this.PartialStatement(p);
    },
    MustacheStatement: function(p) {
      this.SubExpression(p), p.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append");
    },
    Decorator: function(p) {
      this.DecoratorBlock(p);
    },
    ContentStatement: function(p) {
      p.value && this.opcode("appendContent", p.value);
    },
    CommentStatement: function() {
    },
    SubExpression: function(p) {
      h(p);
      var m = this.classifySexpr(p);
      m === "simple" ? this.simpleSexpr(p) : m === "helper" ? this.helperSexpr(p) : this.ambiguousSexpr(p);
    },
    ambiguousSexpr: function(p, m, A) {
      var w = p.path, x = w.parts[0], E = m != null || A != null;
      this.opcode("getContext", w.depth), this.opcode("pushProgram", m), this.opcode("pushProgram", A), w.strict = !0, this.accept(w), this.opcode("invokeAmbiguous", x, E);
    },
    simpleSexpr: function(p) {
      var m = p.path;
      m.strict = !0, this.accept(m), this.opcode("resolvePossibleLambda");
    },
    helperSexpr: function(p, m, A) {
      var w = this.setupFullMustacheParams(p, m, A), x = p.path, E = x.parts[0];
      if (this.options.knownHelpers[E])
        this.opcode("invokeKnownHelper", w.length, E);
      else {
        if (this.options.knownHelpersOnly)
          throw new t.default("You specified knownHelpersOnly, but used the unknown helper " + E, p);
        x.strict = !0, x.falsy = !0, this.accept(x), this.opcode("invokeHelper", w.length, x.original, a.default.helpers.simpleId(x));
      }
    },
    PathExpression: function(p) {
      this.addDepth(p.depth), this.opcode("getContext", p.depth);
      var m = p.parts[0], A = a.default.helpers.scopedId(p), w = !p.depth && !A && this.blockParamIndex(m);
      w ? this.opcode("lookupBlockParam", w, p.parts) : m ? p.data ? (this.options.data = !0, this.opcode("lookupData", p.depth, p.parts, p.strict)) : this.opcode("lookupOnContext", p.parts, p.falsy, p.strict, A) : this.opcode("pushContext");
    },
    StringLiteral: function(p) {
      this.opcode("pushString", p.value);
    },
    NumberLiteral: function(p) {
      this.opcode("pushLiteral", p.value);
    },
    BooleanLiteral: function(p) {
      this.opcode("pushLiteral", p.value);
    },
    UndefinedLiteral: function() {
      this.opcode("pushLiteral", "undefined");
    },
    NullLiteral: function() {
      this.opcode("pushLiteral", "null");
    },
    Hash: function(p) {
      var m = p.pairs, A = 0, w = m.length;
      for (this.opcode("pushHash"); A < w; A++)
        this.pushParam(m[A].value);
      for (; A--; )
        this.opcode("assignToHash", m[A].key);
      this.opcode("popHash");
    },
    // HELPERS
    opcode: function(p) {
      this.opcodes.push({
        opcode: p,
        args: s.call(arguments, 1),
        loc: this.sourceNode[0].loc
      });
    },
    addDepth: function(p) {
      p && (this.useDepths = !0);
    },
    classifySexpr: function(p) {
      var m = a.default.helpers.simpleId(p.path), A = m && !!this.blockParamIndex(p.path.parts[0]), w = !A && a.default.helpers.helperExpression(p), x = !A && (w || m);
      if (x && !w) {
        var E = p.path.parts[0], T = this.options;
        T.knownHelpers[E] ? w = !0 : T.knownHelpersOnly && (x = !1);
      }
      return w ? "helper" : x ? "ambiguous" : "simple";
    },
    pushParams: function(p) {
      for (var m = 0, A = p.length; m < A; m++)
        this.pushParam(p[m]);
    },
    pushParam: function(p) {
      var m = p.value != null ? p.value : p.original || "";
      if (this.stringParams)
        m.replace && (m = m.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")), p.depth && this.addDepth(p.depth), this.opcode("getContext", p.depth || 0), this.opcode("pushStringParam", m, p.type), p.type === "SubExpression" && this.accept(p);
      else {
        if (this.trackIds) {
          var A = void 0;
          if (p.parts && !a.default.helpers.scopedId(p) && !p.depth && (A = this.blockParamIndex(p.parts[0])), A) {
            var w = p.parts.slice(1).join(".");
            this.opcode("pushId", "BlockParam", A, w);
          } else
            m = p.original || m, m.replace && (m = m.replace(/^this(?:\.|$)/, "").replace(/^\.\//, "").replace(/^\.$/, "")), this.opcode("pushId", p.type, m);
        }
        this.accept(p);
      }
    },
    setupFullMustacheParams: function(p, m, A, w) {
      var x = p.params;
      return this.pushParams(x), this.opcode("pushProgram", m), this.opcode("pushProgram", A), p.hash ? this.accept(p.hash) : this.opcode("emptyHash", w), x;
    },
    blockParamIndex: function(p) {
      for (var m = 0, A = this.options.blockParams.length; m < A; m++) {
        var w = this.options.blockParams[m], x = w && n.indexOf(w, p);
        if (w && x >= 0)
          return [m, x];
      }
    }
  };
  function l(f, p, m) {
    if (f == null || typeof f != "string" && f.type !== "Program")
      throw new t.default("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + f);
    p = p || {}, "data" in p || (p.data = !0), p.compat && (p.useDepths = !0);
    var A = m.parse(f, p), w = new m.Compiler().compile(A, p);
    return new m.JavaScriptCompiler().compile(w, p);
  }
  function u(f, p, m) {
    if (p === void 0 && (p = {}), f == null || typeof f != "string" && f.type !== "Program")
      throw new t.default("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + f);
    p = n.extend({}, p), "data" in p || (p.data = !0), p.compat && (p.useDepths = !0);
    var A = void 0;
    function w() {
      var E = m.parse(f, p), T = new m.Compiler().compile(E, p), D = new m.JavaScriptCompiler().compile(T, p, void 0, !0);
      return m.template(D);
    }
    function x(E, T) {
      return A || (A = w()), A.call(this, E, T);
    }
    return x._setup = function(E) {
      return A || (A = w()), A._setup(E);
    }, x._child = function(E, T, D, F) {
      return A || (A = w()), A._child(E, T, D, F);
    }, x;
  }
  function c(f, p) {
    if (f === p)
      return !0;
    if (n.isArray(f) && n.isArray(p) && f.length === p.length) {
      for (var m = 0; m < f.length; m++)
        if (!c(f[m], p[m]))
          return !1;
      return !0;
    }
  }
  function h(f) {
    if (!f.path.parts) {
      var p = f.path;
      f.path = {
        type: "PathExpression",
        data: !1,
        depth: 0,
        parts: [p.original + ""],
        original: p.original + "",
        loc: p.loc
      };
    }
  }
  return md;
}
var Am = { exports: {} }, wm = { exports: {} }, Yh = {}, by = {}, xm = {}, bm = {}, z2;
function DG() {
  if (z2) return bm;
  z2 = 1;
  var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
  return bm.encode = function(e) {
    if (0 <= e && e < r.length)
      return r[e];
    throw new TypeError("Must be between 0 and 63: " + e);
  }, bm.decode = function(e) {
    var t = 65, n = 90, i = 97, a = 122, s = 48, o = 57, l = 43, u = 47, c = 26, h = 52;
    return t <= e && e <= n ? e - t : i <= e && e <= a ? e - i + c : s <= e && e <= o ? e - s + h : e == l ? 62 : e == u ? 63 : -1;
  }, bm;
}
var G2;
function ED() {
  if (G2) return xm;
  G2 = 1;
  var r = DG(), e = 5, t = 1 << e, n = t - 1, i = t;
  function a(o) {
    return o < 0 ? (-o << 1) + 1 : (o << 1) + 0;
  }
  function s(o) {
    var l = (o & 1) === 1, u = o >> 1;
    return l ? -u : u;
  }
  return xm.encode = function(l) {
    var u = "", c, h = a(l);
    do
      c = h & n, h >>>= e, h > 0 && (c |= i), u += r.encode(c);
    while (h > 0);
    return u;
  }, xm.decode = function(l, u, c) {
    var h = l.length, f = 0, p = 0, m, A;
    do {
      if (u >= h)
        throw new Error("Expected more digits in base 64 VLQ value.");
      if (A = r.decode(l.charCodeAt(u++)), A === -1)
        throw new Error("Invalid base64 digit: " + l.charAt(u - 1));
      m = !!(A & i), A &= n, f = f + (A << p), p += e;
    } while (m);
    c.value = s(f), c.rest = u;
  }, xm;
}
var Cy = {}, H2;
function bg() {
  return H2 || (H2 = 1, (function(r) {
    function e(D, F, _) {
      if (F in D)
        return D[F];
      if (arguments.length === 3)
        return _;
      throw new Error('"' + F + '" is a required argument.');
    }
    r.getArg = e;
    var t = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/, n = /^data:.+\,.+$/;
    function i(D) {
      var F = D.match(t);
      return F ? {
        scheme: F[1],
        auth: F[2],
        host: F[3],
        port: F[4],
        path: F[5]
      } : null;
    }
    r.urlParse = i;
    function a(D) {
      var F = "";
      return D.scheme && (F += D.scheme + ":"), F += "//", D.auth && (F += D.auth + "@"), D.host && (F += D.host), D.port && (F += ":" + D.port), D.path && (F += D.path), F;
    }
    r.urlGenerate = a;
    function s(D) {
      var F = D, _ = i(D);
      if (_) {
        if (!_.path)
          return D;
        F = _.path;
      }
      for (var L = r.isAbsolute(F), Z = F.split(/\/+/), te, de = 0, H = Z.length - 1; H >= 0; H--)
        te = Z[H], te === "." ? Z.splice(H, 1) : te === ".." ? de++ : de > 0 && (te === "" ? (Z.splice(H + 1, de), de = 0) : (Z.splice(H, 2), de--));
      return F = Z.join("/"), F === "" && (F = L ? "/" : "."), _ ? (_.path = F, a(_)) : F;
    }
    r.normalize = s;
    function o(D, F) {
      D === "" && (D = "."), F === "" && (F = ".");
      var _ = i(F), L = i(D);
      if (L && (D = L.path || "/"), _ && !_.scheme)
        return L && (_.scheme = L.scheme), a(_);
      if (_ || F.match(n))
        return F;
      if (L && !L.host && !L.path)
        return L.host = F, a(L);
      var Z = F.charAt(0) === "/" ? F : s(D.replace(/\/+$/, "") + "/" + F);
      return L ? (L.path = Z, a(L)) : Z;
    }
    r.join = o, r.isAbsolute = function(D) {
      return D.charAt(0) === "/" || t.test(D);
    };
    function l(D, F) {
      D === "" && (D = "."), D = D.replace(/\/$/, "");
      for (var _ = 0; F.indexOf(D + "/") !== 0; ) {
        var L = D.lastIndexOf("/");
        if (L < 0 || (D = D.slice(0, L), D.match(/^([^\/]+:\/)?\/*$/)))
          return F;
        ++_;
      }
      return Array(_ + 1).join("../") + F.substr(D.length + 1);
    }
    r.relative = l;
    var u = (function() {
      var D = /* @__PURE__ */ Object.create(null);
      return !("__proto__" in D);
    })();
    function c(D) {
      return D;
    }
    function h(D) {
      return p(D) ? "$" + D : D;
    }
    r.toSetString = u ? c : h;
    function f(D) {
      return p(D) ? D.slice(1) : D;
    }
    r.fromSetString = u ? c : f;
    function p(D) {
      if (!D)
        return !1;
      var F = D.length;
      if (F < 9 || D.charCodeAt(F - 1) !== 95 || D.charCodeAt(F - 2) !== 95 || D.charCodeAt(F - 3) !== 111 || D.charCodeAt(F - 4) !== 116 || D.charCodeAt(F - 5) !== 111 || D.charCodeAt(F - 6) !== 114 || D.charCodeAt(F - 7) !== 112 || D.charCodeAt(F - 8) !== 95 || D.charCodeAt(F - 9) !== 95)
        return !1;
      for (var _ = F - 10; _ >= 0; _--)
        if (D.charCodeAt(_) !== 36)
          return !1;
      return !0;
    }
    function m(D, F, _) {
      var L = w(D.source, F.source);
      return L !== 0 || (L = D.originalLine - F.originalLine, L !== 0) || (L = D.originalColumn - F.originalColumn, L !== 0 || _) || (L = D.generatedColumn - F.generatedColumn, L !== 0) || (L = D.generatedLine - F.generatedLine, L !== 0) ? L : w(D.name, F.name);
    }
    r.compareByOriginalPositions = m;
    function A(D, F, _) {
      var L = D.generatedLine - F.generatedLine;
      return L !== 0 || (L = D.generatedColumn - F.generatedColumn, L !== 0 || _) || (L = w(D.source, F.source), L !== 0) || (L = D.originalLine - F.originalLine, L !== 0) || (L = D.originalColumn - F.originalColumn, L !== 0) ? L : w(D.name, F.name);
    }
    r.compareByGeneratedPositionsDeflated = A;
    function w(D, F) {
      return D === F ? 0 : D === null ? 1 : F === null ? -1 : D > F ? 1 : -1;
    }
    function x(D, F) {
      var _ = D.generatedLine - F.generatedLine;
      return _ !== 0 || (_ = D.generatedColumn - F.generatedColumn, _ !== 0) || (_ = w(D.source, F.source), _ !== 0) || (_ = D.originalLine - F.originalLine, _ !== 0) || (_ = D.originalColumn - F.originalColumn, _ !== 0) ? _ : w(D.name, F.name);
    }
    r.compareByGeneratedPositionsInflated = x;
    function E(D) {
      return JSON.parse(D.replace(/^\)]}'[^\n]*\n/, ""));
    }
    r.parseSourceMapInput = E;
    function T(D, F, _) {
      if (F = F || "", D && (D[D.length - 1] !== "/" && F[0] !== "/" && (D += "/"), F = D + F), _) {
        var L = i(_);
        if (!L)
          throw new Error("sourceMapURL could not be parsed");
        if (L.path) {
          var Z = L.path.lastIndexOf("/");
          Z >= 0 && (L.path = L.path.substring(0, Z + 1));
        }
        F = o(a(L), F);
      }
      return s(F);
    }
    r.computeSourceURL = T;
  })(Cy)), Cy;
}
var Sy = {}, W2;
function kD() {
  if (W2) return Sy;
  W2 = 1;
  var r = bg(), e = Object.prototype.hasOwnProperty, t = typeof Map < "u";
  function n() {
    this._array = [], this._set = t ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
  }
  return n.fromArray = function(a, s) {
    for (var o = new n(), l = 0, u = a.length; l < u; l++)
      o.add(a[l], s);
    return o;
  }, n.prototype.size = function() {
    return t ? this._set.size : Object.getOwnPropertyNames(this._set).length;
  }, n.prototype.add = function(a, s) {
    var o = t ? a : r.toSetString(a), l = t ? this.has(a) : e.call(this._set, o), u = this._array.length;
    (!l || s) && this._array.push(a), l || (t ? this._set.set(a, u) : this._set[o] = u);
  }, n.prototype.has = function(a) {
    if (t)
      return this._set.has(a);
    var s = r.toSetString(a);
    return e.call(this._set, s);
  }, n.prototype.indexOf = function(a) {
    if (t) {
      var s = this._set.get(a);
      if (s >= 0)
        return s;
    } else {
      var o = r.toSetString(a);
      if (e.call(this._set, o))
        return this._set[o];
    }
    throw new Error('"' + a + '" is not in the set.');
  }, n.prototype.at = function(a) {
    if (a >= 0 && a < this._array.length)
      return this._array[a];
    throw new Error("No element indexed by " + a);
  }, n.prototype.toArray = function() {
    return this._array.slice();
  }, Sy.ArraySet = n, Sy;
}
var Ey = {}, j2;
function RG() {
  if (j2) return Ey;
  j2 = 1;
  var r = bg();
  function e(n, i) {
    var a = n.generatedLine, s = i.generatedLine, o = n.generatedColumn, l = i.generatedColumn;
    return s > a || s == a && l >= o || r.compareByGeneratedPositionsInflated(n, i) <= 0;
  }
  function t() {
    this._array = [], this._sorted = !0, this._last = { generatedLine: -1, generatedColumn: 0 };
  }
  return t.prototype.unsortedForEach = function(i, a) {
    this._array.forEach(i, a);
  }, t.prototype.add = function(i) {
    e(this._last, i) ? (this._last = i, this._array.push(i)) : (this._sorted = !1, this._array.push(i));
  }, t.prototype.toArray = function() {
    return this._sorted || (this._array.sort(r.compareByGeneratedPositionsInflated), this._sorted = !0), this._array;
  }, Ey.MappingList = t, Ey;
}
var q2;
function TD() {
  if (q2) return by;
  q2 = 1;
  var r = ED(), e = bg(), t = kD().ArraySet, n = RG().MappingList;
  function i(a) {
    a || (a = {}), this._file = e.getArg(a, "file", null), this._sourceRoot = e.getArg(a, "sourceRoot", null), this._skipValidation = e.getArg(a, "skipValidation", !1), this._sources = new t(), this._names = new t(), this._mappings = new n(), this._sourcesContents = null;
  }
  return i.prototype._version = 3, i.fromSourceMap = function(s) {
    var o = s.sourceRoot, l = new i({
      file: s.file,
      sourceRoot: o
    });
    return s.eachMapping(function(u) {
      var c = {
        generated: {
          line: u.generatedLine,
          column: u.generatedColumn
        }
      };
      u.source != null && (c.source = u.source, o != null && (c.source = e.relative(o, c.source)), c.original = {
        line: u.originalLine,
        column: u.originalColumn
      }, u.name != null && (c.name = u.name)), l.addMapping(c);
    }), s.sources.forEach(function(u) {
      var c = u;
      o !== null && (c = e.relative(o, u)), l._sources.has(c) || l._sources.add(c);
      var h = s.sourceContentFor(u);
      h != null && l.setSourceContent(u, h);
    }), l;
  }, i.prototype.addMapping = function(s) {
    var o = e.getArg(s, "generated"), l = e.getArg(s, "original", null), u = e.getArg(s, "source", null), c = e.getArg(s, "name", null);
    this._skipValidation || this._validateMapping(o, l, u, c), u != null && (u = String(u), this._sources.has(u) || this._sources.add(u)), c != null && (c = String(c), this._names.has(c) || this._names.add(c)), this._mappings.add({
      generatedLine: o.line,
      generatedColumn: o.column,
      originalLine: l != null && l.line,
      originalColumn: l != null && l.column,
      source: u,
      name: c
    });
  }, i.prototype.setSourceContent = function(s, o) {
    var l = s;
    this._sourceRoot != null && (l = e.relative(this._sourceRoot, l)), o != null ? (this._sourcesContents || (this._sourcesContents = /* @__PURE__ */ Object.create(null)), this._sourcesContents[e.toSetString(l)] = o) : this._sourcesContents && (delete this._sourcesContents[e.toSetString(l)], Object.keys(this._sourcesContents).length === 0 && (this._sourcesContents = null));
  }, i.prototype.applySourceMap = function(s, o, l) {
    var u = o;
    if (o == null) {
      if (s.file == null)
        throw new Error(
          `SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's "file" property. Both were omitted.`
        );
      u = s.file;
    }
    var c = this._sourceRoot;
    c != null && (u = e.relative(c, u));
    var h = new t(), f = new t();
    this._mappings.unsortedForEach(function(p) {
      if (p.source === u && p.originalLine != null) {
        var m = s.originalPositionFor({
          line: p.originalLine,
          column: p.originalColumn
        });
        m.source != null && (p.source = m.source, l != null && (p.source = e.join(l, p.source)), c != null && (p.source = e.relative(c, p.source)), p.originalLine = m.line, p.originalColumn = m.column, m.name != null && (p.name = m.name));
      }
      var A = p.source;
      A != null && !h.has(A) && h.add(A);
      var w = p.name;
      w != null && !f.has(w) && f.add(w);
    }, this), this._sources = h, this._names = f, s.sources.forEach(function(p) {
      var m = s.sourceContentFor(p);
      m != null && (l != null && (p = e.join(l, p)), c != null && (p = e.relative(c, p)), this.setSourceContent(p, m));
    }, this);
  }, i.prototype._validateMapping = function(s, o, l, u) {
    if (o && typeof o.line != "number" && typeof o.column != "number")
      throw new Error(
        "original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values."
      );
    if (!(s && "line" in s && "column" in s && s.line > 0 && s.column >= 0 && !o && !l && !u)) {
      if (s && "line" in s && "column" in s && o && "line" in o && "column" in o && s.line > 0 && s.column >= 0 && o.line > 0 && o.column >= 0 && l)
        return;
      throw new Error("Invalid mapping: " + JSON.stringify({
        generated: s,
        source: l,
        original: o,
        name: u
      }));
    }
  }, i.prototype._serializeMappings = function() {
    for (var s = 0, o = 1, l = 0, u = 0, c = 0, h = 0, f = "", p, m, A, w, x = this._mappings.toArray(), E = 0, T = x.length; E < T; E++) {
      if (m = x[E], p = "", m.generatedLine !== o)
        for (s = 0; m.generatedLine !== o; )
          p += ";", o++;
      else if (E > 0) {
        if (!e.compareByGeneratedPositionsInflated(m, x[E - 1]))
          continue;
        p += ",";
      }
      p += r.encode(m.generatedColumn - s), s = m.generatedColumn, m.source != null && (w = this._sources.indexOf(m.source), p += r.encode(w - h), h = w, p += r.encode(m.originalLine - 1 - u), u = m.originalLine - 1, p += r.encode(m.originalColumn - l), l = m.originalColumn, m.name != null && (A = this._names.indexOf(m.name), p += r.encode(A - c), c = A)), f += p;
    }
    return f;
  }, i.prototype._generateSourcesContent = function(s, o) {
    return s.map(function(l) {
      if (!this._sourcesContents)
        return null;
      o != null && (l = e.relative(o, l));
      var u = e.toSetString(l);
      return Object.prototype.hasOwnProperty.call(this._sourcesContents, u) ? this._sourcesContents[u] : null;
    }, this);
  }, i.prototype.toJSON = function() {
    var s = {
      version: this._version,
      sources: this._sources.toArray(),
      names: this._names.toArray(),
      mappings: this._serializeMappings()
    };
    return this._file != null && (s.file = this._file), this._sourceRoot != null && (s.sourceRoot = this._sourceRoot), this._sourcesContents && (s.sourcesContent = this._generateSourcesContent(s.sources, s.sourceRoot)), s;
  }, i.prototype.toString = function() {
    return JSON.stringify(this.toJSON());
  }, by.SourceMapGenerator = i, by;
}
var Xh = {}, ky = {}, Q2;
function OG() {
  return Q2 || (Q2 = 1, (function(r) {
    r.GREATEST_LOWER_BOUND = 1, r.LEAST_UPPER_BOUND = 2;
    function e(t, n, i, a, s, o) {
      var l = Math.floor((n - t) / 2) + t, u = s(i, a[l], !0);
      return u === 0 ? l : u > 0 ? n - l > 1 ? e(l, n, i, a, s, o) : o == r.LEAST_UPPER_BOUND ? n < a.length ? n : -1 : l : l - t > 1 ? e(t, l, i, a, s, o) : o == r.LEAST_UPPER_BOUND ? l : t < 0 ? -1 : t;
    }
    r.search = function(n, i, a, s) {
      if (i.length === 0)
        return -1;
      var o = e(
        -1,
        i.length,
        n,
        i,
        a,
        s || r.GREATEST_LOWER_BOUND
      );
      if (o < 0)
        return -1;
      for (; o - 1 >= 0 && a(i[o], i[o - 1], !0) === 0; )
        --o;
      return o;
    };
  })(ky)), ky;
}
var Ty = {}, Y2;
function BG() {
  if (Y2) return Ty;
  Y2 = 1;
  function r(n, i, a) {
    var s = n[i];
    n[i] = n[a], n[a] = s;
  }
  function e(n, i) {
    return Math.round(n + Math.random() * (i - n));
  }
  function t(n, i, a, s) {
    if (a < s) {
      var o = e(a, s), l = a - 1;
      r(n, o, s);
      for (var u = n[s], c = a; c < s; c++)
        i(n[c], u) <= 0 && (l += 1, r(n, l, c));
      r(n, l + 1, c);
      var h = l + 1;
      t(n, i, a, h - 1), t(n, i, h + 1, s);
    }
  }
  return Ty.quickSort = function(n, i) {
    t(n, i, 0, n.length - 1);
  }, Ty;
}
var X2;
function _G() {
  if (X2) return Xh;
  X2 = 1;
  var r = bg(), e = OG(), t = kD().ArraySet, n = ED(), i = BG().quickSort;
  function a(u, c) {
    var h = u;
    return typeof u == "string" && (h = r.parseSourceMapInput(u)), h.sections != null ? new l(h, c) : new s(h, c);
  }
  a.fromSourceMap = function(u, c) {
    return s.fromSourceMap(u, c);
  }, a.prototype._version = 3, a.prototype.__generatedMappings = null, Object.defineProperty(a.prototype, "_generatedMappings", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.__generatedMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__generatedMappings;
    }
  }), a.prototype.__originalMappings = null, Object.defineProperty(a.prototype, "_originalMappings", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.__originalMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__originalMappings;
    }
  }), a.prototype._charIsMappingSeparator = function(c, h) {
    var f = c.charAt(h);
    return f === ";" || f === ",";
  }, a.prototype._parseMappings = function(c, h) {
    throw new Error("Subclasses must implement _parseMappings");
  }, a.GENERATED_ORDER = 1, a.ORIGINAL_ORDER = 2, a.GREATEST_LOWER_BOUND = 1, a.LEAST_UPPER_BOUND = 2, a.prototype.eachMapping = function(c, h, f) {
    var p = h || null, m = f || a.GENERATED_ORDER, A;
    switch (m) {
      case a.GENERATED_ORDER:
        A = this._generatedMappings;
        break;
      case a.ORIGINAL_ORDER:
        A = this._originalMappings;
        break;
      default:
        throw new Error("Unknown order of iteration.");
    }
    var w = this.sourceRoot;
    A.map(function(x) {
      var E = x.source === null ? null : this._sources.at(x.source);
      return E = r.computeSourceURL(w, E, this._sourceMapURL), {
        source: E,
        generatedLine: x.generatedLine,
        generatedColumn: x.generatedColumn,
        originalLine: x.originalLine,
        originalColumn: x.originalColumn,
        name: x.name === null ? null : this._names.at(x.name)
      };
    }, this).forEach(c, p);
  }, a.prototype.allGeneratedPositionsFor = function(c) {
    var h = r.getArg(c, "line"), f = {
      source: r.getArg(c, "source"),
      originalLine: h,
      originalColumn: r.getArg(c, "column", 0)
    };
    if (f.source = this._findSourceIndex(f.source), f.source < 0)
      return [];
    var p = [], m = this._findMapping(
      f,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      r.compareByOriginalPositions,
      e.LEAST_UPPER_BOUND
    );
    if (m >= 0) {
      var A = this._originalMappings[m];
      if (c.column === void 0)
        for (var w = A.originalLine; A && A.originalLine === w; )
          p.push({
            line: r.getArg(A, "generatedLine", null),
            column: r.getArg(A, "generatedColumn", null),
            lastColumn: r.getArg(A, "lastGeneratedColumn", null)
          }), A = this._originalMappings[++m];
      else
        for (var x = A.originalColumn; A && A.originalLine === h && A.originalColumn == x; )
          p.push({
            line: r.getArg(A, "generatedLine", null),
            column: r.getArg(A, "generatedColumn", null),
            lastColumn: r.getArg(A, "lastGeneratedColumn", null)
          }), A = this._originalMappings[++m];
    }
    return p;
  }, Xh.SourceMapConsumer = a;
  function s(u, c) {
    var h = u;
    typeof u == "string" && (h = r.parseSourceMapInput(u));
    var f = r.getArg(h, "version"), p = r.getArg(h, "sources"), m = r.getArg(h, "names", []), A = r.getArg(h, "sourceRoot", null), w = r.getArg(h, "sourcesContent", null), x = r.getArg(h, "mappings"), E = r.getArg(h, "file", null);
    if (f != this._version)
      throw new Error("Unsupported version: " + f);
    A && (A = r.normalize(A)), p = p.map(String).map(r.normalize).map(function(T) {
      return A && r.isAbsolute(A) && r.isAbsolute(T) ? r.relative(A, T) : T;
    }), this._names = t.fromArray(m.map(String), !0), this._sources = t.fromArray(p, !0), this._absoluteSources = this._sources.toArray().map(function(T) {
      return r.computeSourceURL(A, T, c);
    }), this.sourceRoot = A, this.sourcesContent = w, this._mappings = x, this._sourceMapURL = c, this.file = E;
  }
  s.prototype = Object.create(a.prototype), s.prototype.consumer = a, s.prototype._findSourceIndex = function(u) {
    var c = u;
    if (this.sourceRoot != null && (c = r.relative(this.sourceRoot, c)), this._sources.has(c))
      return this._sources.indexOf(c);
    var h;
    for (h = 0; h < this._absoluteSources.length; ++h)
      if (this._absoluteSources[h] == u)
        return h;
    return -1;
  }, s.fromSourceMap = function(c, h) {
    var f = Object.create(s.prototype), p = f._names = t.fromArray(c._names.toArray(), !0), m = f._sources = t.fromArray(c._sources.toArray(), !0);
    f.sourceRoot = c._sourceRoot, f.sourcesContent = c._generateSourcesContent(
      f._sources.toArray(),
      f.sourceRoot
    ), f.file = c._file, f._sourceMapURL = h, f._absoluteSources = f._sources.toArray().map(function(_) {
      return r.computeSourceURL(f.sourceRoot, _, h);
    });
    for (var A = c._mappings.toArray().slice(), w = f.__generatedMappings = [], x = f.__originalMappings = [], E = 0, T = A.length; E < T; E++) {
      var D = A[E], F = new o();
      F.generatedLine = D.generatedLine, F.generatedColumn = D.generatedColumn, D.source && (F.source = m.indexOf(D.source), F.originalLine = D.originalLine, F.originalColumn = D.originalColumn, D.name && (F.name = p.indexOf(D.name)), x.push(F)), w.push(F);
    }
    return i(f.__originalMappings, r.compareByOriginalPositions), f;
  }, s.prototype._version = 3, Object.defineProperty(s.prototype, "sources", {
    get: function() {
      return this._absoluteSources.slice();
    }
  });
  function o() {
    this.generatedLine = 0, this.generatedColumn = 0, this.source = null, this.originalLine = null, this.originalColumn = null, this.name = null;
  }
  s.prototype._parseMappings = function(c, h) {
    for (var f = 1, p = 0, m = 0, A = 0, w = 0, x = 0, E = c.length, T = 0, D = {}, F = {}, _ = [], L = [], Z, te, de, H, j; T < E; )
      if (c.charAt(T) === ";")
        f++, T++, p = 0;
      else if (c.charAt(T) === ",")
        T++;
      else {
        for (Z = new o(), Z.generatedLine = f, H = T; H < E && !this._charIsMappingSeparator(c, H); H++)
          ;
        if (te = c.slice(T, H), de = D[te], de)
          T += te.length;
        else {
          for (de = []; T < H; )
            n.decode(c, T, F), j = F.value, T = F.rest, de.push(j);
          if (de.length === 2)
            throw new Error("Found a source, but no line and column");
          if (de.length === 3)
            throw new Error("Found a source and line, but no column");
          D[te] = de;
        }
        Z.generatedColumn = p + de[0], p = Z.generatedColumn, de.length > 1 && (Z.source = w + de[1], w += de[1], Z.originalLine = m + de[2], m = Z.originalLine, Z.originalLine += 1, Z.originalColumn = A + de[3], A = Z.originalColumn, de.length > 4 && (Z.name = x + de[4], x += de[4])), L.push(Z), typeof Z.originalLine == "number" && _.push(Z);
      }
    i(L, r.compareByGeneratedPositionsDeflated), this.__generatedMappings = L, i(_, r.compareByOriginalPositions), this.__originalMappings = _;
  }, s.prototype._findMapping = function(c, h, f, p, m, A) {
    if (c[f] <= 0)
      throw new TypeError("Line must be greater than or equal to 1, got " + c[f]);
    if (c[p] < 0)
      throw new TypeError("Column must be greater than or equal to 0, got " + c[p]);
    return e.search(c, h, m, A);
  }, s.prototype.computeColumnSpans = function() {
    for (var c = 0; c < this._generatedMappings.length; ++c) {
      var h = this._generatedMappings[c];
      if (c + 1 < this._generatedMappings.length) {
        var f = this._generatedMappings[c + 1];
        if (h.generatedLine === f.generatedLine) {
          h.lastGeneratedColumn = f.generatedColumn - 1;
          continue;
        }
      }
      h.lastGeneratedColumn = 1 / 0;
    }
  }, s.prototype.originalPositionFor = function(c) {
    var h = {
      generatedLine: r.getArg(c, "line"),
      generatedColumn: r.getArg(c, "column")
    }, f = this._findMapping(
      h,
      this._generatedMappings,
      "generatedLine",
      "generatedColumn",
      r.compareByGeneratedPositionsDeflated,
      r.getArg(c, "bias", a.GREATEST_LOWER_BOUND)
    );
    if (f >= 0) {
      var p = this._generatedMappings[f];
      if (p.generatedLine === h.generatedLine) {
        var m = r.getArg(p, "source", null);
        m !== null && (m = this._sources.at(m), m = r.computeSourceURL(this.sourceRoot, m, this._sourceMapURL));
        var A = r.getArg(p, "name", null);
        return A !== null && (A = this._names.at(A)), {
          source: m,
          line: r.getArg(p, "originalLine", null),
          column: r.getArg(p, "originalColumn", null),
          name: A
        };
      }
    }
    return {
      source: null,
      line: null,
      column: null,
      name: null
    };
  }, s.prototype.hasContentsOfAllSources = function() {
    return this.sourcesContent ? this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(c) {
      return c == null;
    }) : !1;
  }, s.prototype.sourceContentFor = function(c, h) {
    if (!this.sourcesContent)
      return null;
    var f = this._findSourceIndex(c);
    if (f >= 0)
      return this.sourcesContent[f];
    var p = c;
    this.sourceRoot != null && (p = r.relative(this.sourceRoot, p));
    var m;
    if (this.sourceRoot != null && (m = r.urlParse(this.sourceRoot))) {
      var A = p.replace(/^file:\/\//, "");
      if (m.scheme == "file" && this._sources.has(A))
        return this.sourcesContent[this._sources.indexOf(A)];
      if ((!m.path || m.path == "/") && this._sources.has("/" + p))
        return this.sourcesContent[this._sources.indexOf("/" + p)];
    }
    if (h)
      return null;
    throw new Error('"' + p + '" is not in the SourceMap.');
  }, s.prototype.generatedPositionFor = function(c) {
    var h = r.getArg(c, "source");
    if (h = this._findSourceIndex(h), h < 0)
      return {
        line: null,
        column: null,
        lastColumn: null
      };
    var f = {
      source: h,
      originalLine: r.getArg(c, "line"),
      originalColumn: r.getArg(c, "column")
    }, p = this._findMapping(
      f,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      r.compareByOriginalPositions,
      r.getArg(c, "bias", a.GREATEST_LOWER_BOUND)
    );
    if (p >= 0) {
      var m = this._originalMappings[p];
      if (m.source === f.source)
        return {
          line: r.getArg(m, "generatedLine", null),
          column: r.getArg(m, "generatedColumn", null),
          lastColumn: r.getArg(m, "lastGeneratedColumn", null)
        };
    }
    return {
      line: null,
      column: null,
      lastColumn: null
    };
  }, Xh.BasicSourceMapConsumer = s;
  function l(u, c) {
    var h = u;
    typeof u == "string" && (h = r.parseSourceMapInput(u));
    var f = r.getArg(h, "version"), p = r.getArg(h, "sections");
    if (f != this._version)
      throw new Error("Unsupported version: " + f);
    this._sources = new t(), this._names = new t();
    var m = {
      line: -1,
      column: 0
    };
    this._sections = p.map(function(A) {
      if (A.url)
        throw new Error("Support for url field in sections not implemented.");
      var w = r.getArg(A, "offset"), x = r.getArg(w, "line"), E = r.getArg(w, "column");
      if (x < m.line || x === m.line && E < m.column)
        throw new Error("Section offsets must be ordered and non-overlapping.");
      return m = w, {
        generatedOffset: {
          // The offset fields are 0-based, but we use 1-based indices when
          // encoding/decoding from VLQ.
          generatedLine: x + 1,
          generatedColumn: E + 1
        },
        consumer: new a(r.getArg(A, "map"), c)
      };
    });
  }
  return l.prototype = Object.create(a.prototype), l.prototype.constructor = a, l.prototype._version = 3, Object.defineProperty(l.prototype, "sources", {
    get: function() {
      for (var u = [], c = 0; c < this._sections.length; c++)
        for (var h = 0; h < this._sections[c].consumer.sources.length; h++)
          u.push(this._sections[c].consumer.sources[h]);
      return u;
    }
  }), l.prototype.originalPositionFor = function(c) {
    var h = {
      generatedLine: r.getArg(c, "line"),
      generatedColumn: r.getArg(c, "column")
    }, f = e.search(
      h,
      this._sections,
      function(m, A) {
        var w = m.generatedLine - A.generatedOffset.generatedLine;
        return w || m.generatedColumn - A.generatedOffset.generatedColumn;
      }
    ), p = this._sections[f];
    return p ? p.consumer.originalPositionFor({
      line: h.generatedLine - (p.generatedOffset.generatedLine - 1),
      column: h.generatedColumn - (p.generatedOffset.generatedLine === h.generatedLine ? p.generatedOffset.generatedColumn - 1 : 0),
      bias: c.bias
    }) : {
      source: null,
      line: null,
      column: null,
      name: null
    };
  }, l.prototype.hasContentsOfAllSources = function() {
    return this._sections.every(function(c) {
      return c.consumer.hasContentsOfAllSources();
    });
  }, l.prototype.sourceContentFor = function(c, h) {
    for (var f = 0; f < this._sections.length; f++) {
      var p = this._sections[f], m = p.consumer.sourceContentFor(c, !0);
      if (m)
        return m;
    }
    if (h)
      return null;
    throw new Error('"' + c + '" is not in the SourceMap.');
  }, l.prototype.generatedPositionFor = function(c) {
    for (var h = 0; h < this._sections.length; h++) {
      var f = this._sections[h];
      if (f.consumer._findSourceIndex(r.getArg(c, "source")) !== -1) {
        var p = f.consumer.generatedPositionFor(c);
        if (p) {
          var m = {
            line: p.line + (f.generatedOffset.generatedLine - 1),
            column: p.column + (f.generatedOffset.generatedLine === p.line ? f.generatedOffset.generatedColumn - 1 : 0)
          };
          return m;
        }
      }
    }
    return {
      line: null,
      column: null
    };
  }, l.prototype._parseMappings = function(c, h) {
    this.__generatedMappings = [], this.__originalMappings = [];
    for (var f = 0; f < this._sections.length; f++)
      for (var p = this._sections[f], m = p.consumer._generatedMappings, A = 0; A < m.length; A++) {
        var w = m[A], x = p.consumer._sources.at(w.source);
        x = r.computeSourceURL(p.consumer.sourceRoot, x, this._sourceMapURL), this._sources.add(x), x = this._sources.indexOf(x);
        var E = null;
        w.name && (E = p.consumer._names.at(w.name), this._names.add(E), E = this._names.indexOf(E));
        var T = {
          source: x,
          generatedLine: w.generatedLine + (p.generatedOffset.generatedLine - 1),
          generatedColumn: w.generatedColumn + (p.generatedOffset.generatedLine === w.generatedLine ? p.generatedOffset.generatedColumn - 1 : 0),
          originalLine: w.originalLine,
          originalColumn: w.originalColumn,
          name: E
        };
        this.__generatedMappings.push(T), typeof T.originalLine == "number" && this.__originalMappings.push(T);
      }
    i(this.__generatedMappings, r.compareByGeneratedPositionsDeflated), i(this.__originalMappings, r.compareByOriginalPositions);
  }, Xh.IndexedSourceMapConsumer = l, Xh;
}
var Fy = {}, J2;
function MG() {
  if (J2) return Fy;
  J2 = 1;
  var r = TD().SourceMapGenerator, e = bg(), t = /(\r?\n)/, n = 10, i = "$$$isSourceNode$$$";
  function a(s, o, l, u, c) {
    this.children = [], this.sourceContents = {}, this.line = s ?? null, this.column = o ?? null, this.source = l ?? null, this.name = c ?? null, this[i] = !0, u != null && this.add(u);
  }
  return a.fromStringWithSourceMap = function(o, l, u) {
    var c = new a(), h = o.split(t), f = 0, p = function() {
      var E = D(), T = D() || "";
      return E + T;
      function D() {
        return f < h.length ? h[f++] : void 0;
      }
    }, m = 1, A = 0, w = null;
    return l.eachMapping(function(E) {
      if (w !== null)
        if (m < E.generatedLine)
          x(w, p()), m++, A = 0;
        else {
          var T = h[f] || "", D = T.substr(0, E.generatedColumn - A);
          h[f] = T.substr(E.generatedColumn - A), A = E.generatedColumn, x(w, D), w = E;
          return;
        }
      for (; m < E.generatedLine; )
        c.add(p()), m++;
      if (A < E.generatedColumn) {
        var T = h[f] || "";
        c.add(T.substr(0, E.generatedColumn)), h[f] = T.substr(E.generatedColumn), A = E.generatedColumn;
      }
      w = E;
    }, this), f < h.length && (w && x(w, p()), c.add(h.splice(f).join(""))), l.sources.forEach(function(E) {
      var T = l.sourceContentFor(E);
      T != null && (u != null && (E = e.join(u, E)), c.setSourceContent(E, T));
    }), c;
    function x(E, T) {
      if (E === null || E.source === void 0)
        c.add(T);
      else {
        var D = u ? e.join(u, E.source) : E.source;
        c.add(new a(
          E.originalLine,
          E.originalColumn,
          D,
          T,
          E.name
        ));
      }
    }
  }, a.prototype.add = function(o) {
    if (Array.isArray(o))
      o.forEach(function(l) {
        this.add(l);
      }, this);
    else if (o[i] || typeof o == "string")
      o && this.children.push(o);
    else
      throw new TypeError(
        "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + o
      );
    return this;
  }, a.prototype.prepend = function(o) {
    if (Array.isArray(o))
      for (var l = o.length - 1; l >= 0; l--)
        this.prepend(o[l]);
    else if (o[i] || typeof o == "string")
      this.children.unshift(o);
    else
      throw new TypeError(
        "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + o
      );
    return this;
  }, a.prototype.walk = function(o) {
    for (var l, u = 0, c = this.children.length; u < c; u++)
      l = this.children[u], l[i] ? l.walk(o) : l !== "" && o(l, {
        source: this.source,
        line: this.line,
        column: this.column,
        name: this.name
      });
  }, a.prototype.join = function(o) {
    var l, u, c = this.children.length;
    if (c > 0) {
      for (l = [], u = 0; u < c - 1; u++)
        l.push(this.children[u]), l.push(o);
      l.push(this.children[u]), this.children = l;
    }
    return this;
  }, a.prototype.replaceRight = function(o, l) {
    var u = this.children[this.children.length - 1];
    return u[i] ? u.replaceRight(o, l) : typeof u == "string" ? this.children[this.children.length - 1] = u.replace(o, l) : this.children.push("".replace(o, l)), this;
  }, a.prototype.setSourceContent = function(o, l) {
    this.sourceContents[e.toSetString(o)] = l;
  }, a.prototype.walkSourceContents = function(o) {
    for (var l = 0, u = this.children.length; l < u; l++)
      this.children[l][i] && this.children[l].walkSourceContents(o);
    for (var c = Object.keys(this.sourceContents), l = 0, u = c.length; l < u; l++)
      o(e.fromSetString(c[l]), this.sourceContents[c[l]]);
  }, a.prototype.toString = function() {
    var o = "";
    return this.walk(function(l) {
      o += l;
    }), o;
  }, a.prototype.toStringWithSourceMap = function(o) {
    var l = {
      code: "",
      line: 1,
      column: 0
    }, u = new r(o), c = !1, h = null, f = null, p = null, m = null;
    return this.walk(function(A, w) {
      l.code += A, w.source !== null && w.line !== null && w.column !== null ? ((h !== w.source || f !== w.line || p !== w.column || m !== w.name) && u.addMapping({
        source: w.source,
        original: {
          line: w.line,
          column: w.column
        },
        generated: {
          line: l.line,
          column: l.column
        },
        name: w.name
      }), h = w.source, f = w.line, p = w.column, m = w.name, c = !0) : c && (u.addMapping({
        generated: {
          line: l.line,
          column: l.column
        }
      }), h = null, c = !1);
      for (var x = 0, E = A.length; x < E; x++)
        A.charCodeAt(x) === n ? (l.line++, l.column = 0, x + 1 === E ? (h = null, c = !1) : c && u.addMapping({
          source: w.source,
          original: {
            line: w.line,
            column: w.column
          },
          generated: {
            line: l.line,
            column: l.column
          },
          name: w.name
        })) : l.column++;
    }), this.walkSourceContents(function(A, w) {
      u.setSourceContent(A, w);
    }), { code: l.code, map: u };
  }, Fy.SourceNode = a, Fy;
}
var K2;
function NG() {
  return K2 || (K2 = 1, Yh.SourceMapGenerator = TD().SourceMapGenerator, Yh.SourceMapConsumer = _G().SourceMapConsumer, Yh.SourceNode = MG().SourceNode), Yh;
}
var Z2;
function LG() {
  return Z2 || (Z2 = 1, (function(r, e) {
    e.__esModule = !0;
    var t = Is(), n = void 0;
    try {
      var i = NG();
      n = i.SourceNode;
    } catch {
    }
    n || (n = function(o, l, u, c) {
      this.src = "", c && this.add(c);
    }, n.prototype = {
      add: function(l) {
        t.isArray(l) && (l = l.join("")), this.src += l;
      },
      prepend: function(l) {
        t.isArray(l) && (l = l.join("")), this.src = l + this.src;
      },
      toStringWithSourceMap: function() {
        return { code: this.toString() };
      },
      toString: function() {
        return this.src;
      }
    });
    function a(o, l, u) {
      if (t.isArray(o)) {
        for (var c = [], h = 0, f = o.length; h < f; h++)
          c.push(l.wrap(o[h], u));
        return c;
      } else if (typeof o == "boolean" || typeof o == "number")
        return o + "";
      return o;
    }
    function s(o) {
      this.srcFile = o, this.source = [];
    }
    s.prototype = {
      isEmpty: function() {
        return !this.source.length;
      },
      prepend: function(l, u) {
        this.source.unshift(this.wrap(l, u));
      },
      push: function(l, u) {
        this.source.push(this.wrap(l, u));
      },
      merge: function() {
        var l = this.empty();
        return this.each(function(u) {
          l.add(["  ", u, `
`]);
        }), l;
      },
      each: function(l) {
        for (var u = 0, c = this.source.length; u < c; u++)
          l(this.source[u]);
      },
      empty: function() {
        var l = this.currentLocation || { start: {} };
        return new n(l.start.line, l.start.column, this.srcFile);
      },
      wrap: function(l) {
        var u = arguments.length <= 1 || arguments[1] === void 0 ? this.currentLocation || { start: {} } : arguments[1];
        return l instanceof n ? l : (l = a(l, this, u), new n(u.start.line, u.start.column, this.srcFile, l));
      },
      functionCall: function(l, u, c) {
        return c = this.generateList(c), this.wrap([l, u ? "." + u + "(" : "(", c, ")"]);
      },
      quotedString: function(l) {
        return '"' + (l + "").replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029") + '"';
      },
      objectLiteral: function(l) {
        var u = this, c = [];
        Object.keys(l).forEach(function(f) {
          var p = a(l[f], u);
          p !== "undefined" && c.push([u.quotedString(f), ":", p]);
        });
        var h = this.generateList(c);
        return h.prepend("{"), h.add("}"), h;
      },
      generateList: function(l) {
        for (var u = this.empty(), c = 0, h = l.length; c < h; c++)
          c && u.add(","), u.add(a(l[c], this));
        return u;
      },
      generateArray: function(l) {
        var u = this.generateList(l);
        return u.prepend("["), u.add("]"), u;
      }
    }, e.default = s, r.exports = e.default;
  })(wm, wm.exports)), wm.exports;
}
var ek;
function UG() {
  return ek || (ek = 1, (function(r, e) {
    e.__esModule = !0;
    function t(f) {
      return f && f.__esModule ? f : { default: f };
    }
    var n = lx(), i = So(), a = t(i), s = Is(), o = LG(), l = t(o);
    function u(f) {
      this.value = f;
    }
    function c() {
    }
    c.prototype = {
      // PUBLIC API: You can override these methods in a subclass to provide
      // alternative compiled forms for name lookup and buffering semantics
      nameLookup: function(p, m) {
        return this.internalNameLookup(p, m);
      },
      depthedLookup: function(p) {
        return [this.aliasable("container.lookup"), "(depths, ", JSON.stringify(p), ")"];
      },
      compilerInfo: function() {
        var p = n.COMPILER_REVISION, m = n.REVISION_CHANGES[p];
        return [p, m];
      },
      appendToBuffer: function(p, m, A) {
        return s.isArray(p) || (p = [p]), p = this.source.wrap(p, m), this.environment.isSimple ? ["return ", p, ";"] : A ? ["buffer += ", p, ";"] : (p.appendToBuffer = !0, p);
      },
      initializeBuffer: function() {
        return this.quotedString("");
      },
      // END PUBLIC API
      internalNameLookup: function(p, m) {
        return this.lookupPropertyFunctionIsUsed = !0, ["lookupProperty(", p, ",", JSON.stringify(m), ")"];
      },
      lookupPropertyFunctionIsUsed: !1,
      compile: function(p, m, A, w) {
        this.environment = p, this.options = m, this.stringParams = this.options.stringParams, this.trackIds = this.options.trackIds, this.precompile = !w, this.name = this.environment.name, this.isChild = !!A, this.context = A || {
          decorators: [],
          programs: [],
          environments: []
        }, this.preamble(), this.stackSlot = 0, this.stackVars = [], this.aliases = {}, this.registers = { list: [] }, this.hashes = [], this.compileStack = [], this.inlineStack = [], this.blockParams = [], this.compileChildren(p, m), this.useDepths = this.useDepths || p.useDepths || p.useDecorators || this.options.compat, this.useBlockParams = this.useBlockParams || p.useBlockParams;
        var x = p.opcodes, E = void 0, T = void 0, D = void 0, F = void 0;
        for (D = 0, F = x.length; D < F; D++)
          E = x[D], this.source.currentLocation = E.loc, T = T || E.loc, this[E.opcode].apply(this, E.args);
        if (this.source.currentLocation = T, this.pushSource(""), this.stackSlot || this.inlineStack.length || this.compileStack.length)
          throw new a.default("Compile completed with content left on stack");
        this.decorators.isEmpty() ? this.decorators = void 0 : (this.useDecorators = !0, this.decorators.prepend(["var decorators = container.decorators, ", this.lookupPropertyFunctionVarDeclaration(), `;
`]), this.decorators.push("return fn;"), w ? this.decorators = Function.apply(this, ["fn", "props", "container", "depth0", "data", "blockParams", "depths", this.decorators.merge()]) : (this.decorators.prepend(`function(fn, props, container, depth0, data, blockParams, depths) {
`), this.decorators.push(`}
`), this.decorators = this.decorators.merge()));
        var _ = this.createFunctionContext(w);
        if (this.isChild)
          return _;
        var L = {
          compiler: this.compilerInfo(),
          main: _
        };
        this.decorators && (L.main_d = this.decorators, L.useDecorators = !0);
        var Z = this.context, te = Z.programs, de = Z.decorators;
        for (D = 0, F = te.length; D < F; D++)
          L[D] = te[D], de[D] && (L[D + "_d"] = de[D], L.useDecorators = !0);
        return this.environment.usePartial && (L.usePartial = !0), this.options.data && (L.useData = !0), this.useDepths && (L.useDepths = !0), this.useBlockParams && (L.useBlockParams = !0), this.options.compat && (L.compat = !0), w ? L.compilerOptions = this.options : (L.compiler = JSON.stringify(L.compiler), this.source.currentLocation = { start: { line: 1, column: 0 } }, L = this.objectLiteral(L), m.srcName ? (L = L.toStringWithSourceMap({ file: m.destName }), L.map = L.map && L.map.toString()) : L = L.toString()), L;
      },
      preamble: function() {
        this.lastContext = 0, this.source = new l.default(this.options.srcName), this.decorators = new l.default(this.options.srcName);
      },
      createFunctionContext: function(p) {
        var m = this, A = "", w = this.stackVars.concat(this.registers.list);
        w.length > 0 && (A += ", " + w.join(", "));
        var x = 0;
        Object.keys(this.aliases).forEach(function(D) {
          var F = m.aliases[D];
          F.children && F.referenceCount > 1 && (A += ", alias" + ++x + "=" + D, F.children[0] = "alias" + x);
        }), this.lookupPropertyFunctionIsUsed && (A += ", " + this.lookupPropertyFunctionVarDeclaration());
        var E = ["container", "depth0", "helpers", "partials", "data"];
        (this.useBlockParams || this.useDepths) && E.push("blockParams"), this.useDepths && E.push("depths");
        var T = this.mergeSource(A);
        return p ? (E.push(T), Function.apply(this, E)) : this.source.wrap(["function(", E.join(","), `) {
  `, T, "}"]);
      },
      mergeSource: function(p) {
        var m = this.environment.isSimple, A = !this.forceBuffer, w = void 0, x = void 0, E = void 0, T = void 0;
        return this.source.each(function(D) {
          D.appendToBuffer ? (E ? D.prepend("  + ") : E = D, T = D) : (E && (x ? E.prepend("buffer += ") : w = !0, T.add(";"), E = T = void 0), x = !0, m || (A = !1));
        }), A ? E ? (E.prepend("return "), T.add(";")) : x || this.source.push('return "";') : (p += ", buffer = " + (w ? "" : this.initializeBuffer()), E ? (E.prepend("return buffer + "), T.add(";")) : this.source.push("return buffer;")), p && this.source.prepend("var " + p.substring(2) + (w ? "" : `;
`)), this.source.merge();
      },
      lookupPropertyFunctionVarDeclaration: function() {
        return `
      lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }
    `.trim();
      },
      // [blockValue]
      //
      // On stack, before: hash, inverse, program, value
      // On stack, after: return value of blockHelperMissing
      //
      // The purpose of this opcode is to take a block of the form
      // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
      // replace it on the stack with the result of properly
      // invoking blockHelperMissing.
      blockValue: function(p) {
        var m = this.aliasable("container.hooks.blockHelperMissing"), A = [this.contextName(0)];
        this.setupHelperArgs(p, 0, A);
        var w = this.popStack();
        A.splice(1, 0, w), this.push(this.source.functionCall(m, "call", A));
      },
      // [ambiguousBlockValue]
      //
      // On stack, before: hash, inverse, program, value
      // Compiler value, before: lastHelper=value of last found helper, if any
      // On stack, after, if no lastHelper: same as [blockValue]
      // On stack, after, if lastHelper: value
      ambiguousBlockValue: function() {
        var p = this.aliasable("container.hooks.blockHelperMissing"), m = [this.contextName(0)];
        this.setupHelperArgs("", 0, m, !0), this.flushInline();
        var A = this.topStack();
        m.splice(1, 0, A), this.pushSource(["if (!", this.lastHelper, ") { ", A, " = ", this.source.functionCall(p, "call", m), "}"]);
      },
      // [appendContent]
      //
      // On stack, before: ...
      // On stack, after: ...
      //
      // Appends the string value of `content` to the current buffer
      appendContent: function(p) {
        this.pendingContent ? p = this.pendingContent + p : this.pendingLocation = this.source.currentLocation, this.pendingContent = p;
      },
      // [append]
      //
      // On stack, before: value, ...
      // On stack, after: ...
      //
      // Coerces `value` to a String and appends it to the current buffer.
      //
      // If `value` is truthy, or 0, it is coerced into a string and appended
      // Otherwise, the empty string is appended
      append: function() {
        if (this.isInline())
          this.replaceStack(function(m) {
            return [" != null ? ", m, ' : ""'];
          }), this.pushSource(this.appendToBuffer(this.popStack()));
        else {
          var p = this.popStack();
          this.pushSource(["if (", p, " != null) { ", this.appendToBuffer(p, void 0, !0), " }"]), this.environment.isSimple && this.pushSource(["else { ", this.appendToBuffer("''", void 0, !0), " }"]);
        }
      },
      // [appendEscaped]
      //
      // On stack, before: value, ...
      // On stack, after: ...
      //
      // Escape `value` and append it to the buffer
      appendEscaped: function() {
        this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"), "(", this.popStack(), ")"]));
      },
      // [getContext]
      //
      // On stack, before: ...
      // On stack, after: ...
      // Compiler value, after: lastContext=depth
      //
      // Set the value of the `lastContext` compiler value to the depth
      getContext: function(p) {
        this.lastContext = p;
      },
      // [pushContext]
      //
      // On stack, before: ...
      // On stack, after: currentContext, ...
      //
      // Pushes the value of the current context onto the stack.
      pushContext: function() {
        this.pushStackLiteral(this.contextName(this.lastContext));
      },
      // [lookupOnContext]
      //
      // On stack, before: ...
      // On stack, after: currentContext[name], ...
      //
      // Looks up the value of `name` on the current context and pushes
      // it onto the stack.
      lookupOnContext: function(p, m, A, w) {
        var x = 0;
        !w && this.options.compat && !this.lastContext ? this.push(this.depthedLookup(p[x++])) : this.pushContext(), this.resolvePath("context", p, x, m, A);
      },
      // [lookupBlockParam]
      //
      // On stack, before: ...
      // On stack, after: blockParam[name], ...
      //
      // Looks up the value of `parts` on the given block param and pushes
      // it onto the stack.
      lookupBlockParam: function(p, m) {
        this.useBlockParams = !0, this.push(["blockParams[", p[0], "][", p[1], "]"]), this.resolvePath("context", m, 1);
      },
      // [lookupData]
      //
      // On stack, before: ...
      // On stack, after: data, ...
      //
      // Push the data lookup operator
      lookupData: function(p, m, A) {
        p ? this.pushStackLiteral("container.data(data, " + p + ")") : this.pushStackLiteral("data"), this.resolvePath("data", m, 0, !0, A);
      },
      resolvePath: function(p, m, A, w, x) {
        var E = this;
        if (this.options.strict || this.options.assumeObjects) {
          this.push(h(this.options.strict && x, this, m, A, p));
          return;
        }
        for (var T = m.length, D = function(_) {
          E.replaceStack(function(L) {
            var Z = E.nameLookup(L, m[_], p);
            return w ? [" && ", Z] : [" != null ? ", Z, " : ", L];
          });
        }, F = A; F < T; F++)
          D(F);
      },
      // [resolvePossibleLambda]
      //
      // On stack, before: value, ...
      // On stack, after: resolved value, ...
      //
      // If the `value` is a lambda, replace it on the stack by
      // the return value of the lambda
      resolvePossibleLambda: function() {
        this.push([this.aliasable("container.lambda"), "(", this.popStack(), ", ", this.contextName(0), ")"]);
      },
      // [pushStringParam]
      //
      // On stack, before: ...
      // On stack, after: string, currentContext, ...
      //
      // This opcode is designed for use in string mode, which
      // provides the string value of a parameter along with its
      // depth rather than resolving it immediately.
      pushStringParam: function(p, m) {
        this.pushContext(), this.pushString(m), m !== "SubExpression" && (typeof p == "string" ? this.pushString(p) : this.pushStackLiteral(p));
      },
      emptyHash: function(p) {
        this.trackIds && this.push("{}"), this.stringParams && (this.push("{}"), this.push("{}")), this.pushStackLiteral(p ? "undefined" : "{}");
      },
      pushHash: function() {
        this.hash && this.hashes.push(this.hash), this.hash = { values: {}, types: [], contexts: [], ids: [] };
      },
      popHash: function() {
        var p = this.hash;
        this.hash = this.hashes.pop(), this.trackIds && this.push(this.objectLiteral(p.ids)), this.stringParams && (this.push(this.objectLiteral(p.contexts)), this.push(this.objectLiteral(p.types))), this.push(this.objectLiteral(p.values));
      },
      // [pushString]
      //
      // On stack, before: ...
      // On stack, after: quotedString(string), ...
      //
      // Push a quoted version of `string` onto the stack
      pushString: function(p) {
        this.pushStackLiteral(this.quotedString(p));
      },
      // [pushLiteral]
      //
      // On stack, before: ...
      // On stack, after: value, ...
      //
      // Pushes a value onto the stack. This operation prevents
      // the compiler from creating a temporary variable to hold
      // it.
      pushLiteral: function(p) {
        this.pushStackLiteral(p);
      },
      // [pushProgram]
      //
      // On stack, before: ...
      // On stack, after: program(guid), ...
      //
      // Push a program expression onto the stack. This takes
      // a compile-time guid and converts it into a runtime-accessible
      // expression.
      pushProgram: function(p) {
        p != null ? this.pushStackLiteral(this.programExpression(p)) : this.pushStackLiteral(null);
      },
      // [registerDecorator]
      //
      // On stack, before: hash, program, params..., ...
      // On stack, after: ...
      //
      // Pops off the decorator's parameters, invokes the decorator,
      // and inserts the decorator into the decorators list.
      registerDecorator: function(p, m) {
        var A = this.nameLookup("decorators", m, "decorator"), w = this.setupHelperArgs(m, p);
        this.decorators.push(["var decorator = ", A, ";"]), this.decorators.push(['if (typeof decorator !== "function") { throw new Error(', this.quotedString('Missing decorator: "' + m + '"'), "); }"]), this.decorators.push(["fn = ", this.decorators.functionCall("decorator", "", ["fn", "props", "container", w]), " || fn;"]);
      },
      // [invokeHelper]
      //
      // On stack, before: hash, inverse, program, params..., ...
      // On stack, after: result of helper invocation
      //
      // Pops off the helper's parameters, invokes the helper,
      // and pushes the helper's return value onto the stack.
      //
      // If the helper is not found, `helperMissing` is called.
      invokeHelper: function(p, m, A) {
        var w = this.popStack(), x = this.setupHelper(p, m), E = [];
        A && E.push(x.name), E.push(w), this.options.strict || E.push(this.aliasable("container.hooks.helperMissing"));
        var T = ["(", this.itemsSeparatedBy(E, "||"), ")"], D = this.source.functionCall(T, "call", x.callParams);
        this.push(D);
      },
      itemsSeparatedBy: function(p, m) {
        var A = [];
        A.push(p[0]);
        for (var w = 1; w < p.length; w++)
          A.push(m, p[w]);
        return A;
      },
      // [invokeKnownHelper]
      //
      // On stack, before: hash, inverse, program, params..., ...
      // On stack, after: result of helper invocation
      //
      // This operation is used when the helper is known to exist,
      // so a `helperMissing` fallback is not required.
      invokeKnownHelper: function(p, m) {
        var A = this.setupHelper(p, m);
        this.push(this.source.functionCall(A.name, "call", A.callParams));
      },
      // [invokeAmbiguous]
      //
      // On stack, before: hash, inverse, program, params..., ...
      // On stack, after: result of disambiguation
      //
      // This operation is used when an expression like `{{foo}}`
      // is provided, but we don't know at compile-time whether it
      // is a helper or a path.
      //
      // This operation emits more code than the other options,
      // and can be avoided by passing the `knownHelpers` and
      // `knownHelpersOnly` flags at compile-time.
      invokeAmbiguous: function(p, m) {
        this.useRegister("helper");
        var A = this.popStack();
        this.emptyHash();
        var w = this.setupHelper(0, p, m), x = this.lastHelper = this.nameLookup("helpers", p, "helper"), E = ["(", "(helper = ", x, " || ", A, ")"];
        this.options.strict || (E[0] = "(helper = ", E.push(" != null ? helper : ", this.aliasable("container.hooks.helperMissing"))), this.push(["(", E, w.paramsInit ? ["),(", w.paramsInit] : [], "),", "(typeof helper === ", this.aliasable('"function"'), " ? ", this.source.functionCall("helper", "call", w.callParams), " : helper))"]);
      },
      // [invokePartial]
      //
      // On stack, before: context, ...
      // On stack after: result of partial invocation
      //
      // This operation pops off a context, invokes a partial with that context,
      // and pushes the result of the invocation back.
      invokePartial: function(p, m, A) {
        var w = [], x = this.setupParams(m, 1, w);
        p && (m = this.popStack(), delete x.name), A && (x.indent = JSON.stringify(A)), x.helpers = "helpers", x.partials = "partials", x.decorators = "container.decorators", p ? w.unshift(m) : w.unshift(this.nameLookup("partials", m, "partial")), this.options.compat && (x.depths = "depths"), x = this.objectLiteral(x), w.push(x), this.push(this.source.functionCall("container.invokePartial", "", w));
      },
      // [assignToHash]
      //
      // On stack, before: value, ..., hash, ...
      // On stack, after: ..., hash, ...
      //
      // Pops a value off the stack and assigns it to the current hash
      assignToHash: function(p) {
        var m = this.popStack(), A = void 0, w = void 0, x = void 0;
        this.trackIds && (x = this.popStack()), this.stringParams && (w = this.popStack(), A = this.popStack());
        var E = this.hash;
        A && (E.contexts[p] = A), w && (E.types[p] = w), x && (E.ids[p] = x), E.values[p] = m;
      },
      pushId: function(p, m, A) {
        p === "BlockParam" ? this.pushStackLiteral("blockParams[" + m[0] + "].path[" + m[1] + "]" + (A ? " + " + JSON.stringify("." + A) : "")) : p === "PathExpression" ? this.pushString(m) : p === "SubExpression" ? this.pushStackLiteral("true") : this.pushStackLiteral("null");
      },
      // HELPERS
      compiler: c,
      compileChildren: function(p, m) {
        for (var A = p.children, w = void 0, x = void 0, E = 0, T = A.length; E < T; E++) {
          w = A[E], x = new this.compiler();
          var D = this.matchExistingProgram(w);
          if (D == null) {
            var F = this.context.programs.push("") - 1;
            w.index = F, w.name = "program" + F, this.context.programs[F] = x.compile(w, m, this.context, !this.precompile), this.context.decorators[F] = x.decorators, this.context.environments[F] = w, this.useDepths = this.useDepths || x.useDepths, this.useBlockParams = this.useBlockParams || x.useBlockParams, w.useDepths = this.useDepths, w.useBlockParams = this.useBlockParams;
          } else
            w.index = D.index, w.name = "program" + D.index, this.useDepths = this.useDepths || D.useDepths, this.useBlockParams = this.useBlockParams || D.useBlockParams;
        }
      },
      matchExistingProgram: function(p) {
        for (var m = 0, A = this.context.environments.length; m < A; m++) {
          var w = this.context.environments[m];
          if (w && w.equals(p))
            return w;
        }
      },
      programExpression: function(p) {
        var m = this.environment.children[p], A = [m.index, "data", m.blockParams];
        return (this.useBlockParams || this.useDepths) && A.push("blockParams"), this.useDepths && A.push("depths"), "container.program(" + A.join(", ") + ")";
      },
      useRegister: function(p) {
        this.registers[p] || (this.registers[p] = !0, this.registers.list.push(p));
      },
      push: function(p) {
        return p instanceof u || (p = this.source.wrap(p)), this.inlineStack.push(p), p;
      },
      pushStackLiteral: function(p) {
        this.push(new u(p));
      },
      pushSource: function(p) {
        this.pendingContent && (this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation)), this.pendingContent = void 0), p && this.source.push(p);
      },
      replaceStack: function(p) {
        var m = ["("], A = void 0, w = void 0, x = void 0;
        if (!this.isInline())
          throw new a.default("replaceStack on non-inline");
        var E = this.popStack(!0);
        if (E instanceof u)
          A = [E.value], m = ["(", A], x = !0;
        else {
          w = !0;
          var T = this.incrStack();
          m = ["((", this.push(T), " = ", E, ")"], A = this.topStack();
        }
        var D = p.call(this, A);
        x || this.popStack(), w && this.stackSlot--, this.push(m.concat(D, ")"));
      },
      incrStack: function() {
        return this.stackSlot++, this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot), this.topStackName();
      },
      topStackName: function() {
        return "stack" + this.stackSlot;
      },
      flushInline: function() {
        var p = this.inlineStack;
        this.inlineStack = [];
        for (var m = 0, A = p.length; m < A; m++) {
          var w = p[m];
          if (w instanceof u)
            this.compileStack.push(w);
          else {
            var x = this.incrStack();
            this.pushSource([x, " = ", w, ";"]), this.compileStack.push(x);
          }
        }
      },
      isInline: function() {
        return this.inlineStack.length;
      },
      popStack: function(p) {
        var m = this.isInline(), A = (m ? this.inlineStack : this.compileStack).pop();
        if (!p && A instanceof u)
          return A.value;
        if (!m) {
          if (!this.stackSlot)
            throw new a.default("Invalid stack pop");
          this.stackSlot--;
        }
        return A;
      },
      topStack: function() {
        var p = this.isInline() ? this.inlineStack : this.compileStack, m = p[p.length - 1];
        return m instanceof u ? m.value : m;
      },
      contextName: function(p) {
        return this.useDepths && p ? "depths[" + p + "]" : "depth" + p;
      },
      quotedString: function(p) {
        return this.source.quotedString(p);
      },
      objectLiteral: function(p) {
        return this.source.objectLiteral(p);
      },
      aliasable: function(p) {
        var m = this.aliases[p];
        return m ? (m.referenceCount++, m) : (m = this.aliases[p] = this.source.wrap(p), m.aliasable = !0, m.referenceCount = 1, m);
      },
      setupHelper: function(p, m, A) {
        var w = [], x = this.setupHelperArgs(m, p, w, A), E = this.nameLookup("helpers", m, "helper"), T = this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : (container.nullContext || {})");
        return {
          params: w,
          paramsInit: x,
          name: E,
          callParams: [T].concat(w)
        };
      },
      setupParams: function(p, m, A) {
        var w = {}, x = [], E = [], T = [], D = !A, F = void 0;
        D && (A = []), w.name = this.quotedString(p), w.hash = this.popStack(), this.trackIds && (w.hashIds = this.popStack()), this.stringParams && (w.hashTypes = this.popStack(), w.hashContexts = this.popStack());
        var _ = this.popStack(), L = this.popStack();
        (L || _) && (w.fn = L || "container.noop", w.inverse = _ || "container.noop");
        for (var Z = m; Z--; )
          F = this.popStack(), A[Z] = F, this.trackIds && (T[Z] = this.popStack()), this.stringParams && (E[Z] = this.popStack(), x[Z] = this.popStack());
        return D && (w.args = this.source.generateArray(A)), this.trackIds && (w.ids = this.source.generateArray(T)), this.stringParams && (w.types = this.source.generateArray(E), w.contexts = this.source.generateArray(x)), this.options.data && (w.data = "data"), this.useBlockParams && (w.blockParams = "blockParams"), w;
      },
      setupHelperArgs: function(p, m, A, w) {
        var x = this.setupParams(p, m, A);
        return x.loc = JSON.stringify(this.source.currentLocation), x = this.objectLiteral(x), w ? (this.useRegister("options"), A.push("options"), ["options=", x]) : A ? (A.push(x), "") : x;
      }
    }, (function() {
      for (var f = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" "), p = c.RESERVED_WORDS = {}, m = 0, A = f.length; m < A; m++)
        p[f[m]] = !0;
    })(), c.isValidJavaScriptVariableName = function(f) {
      return !c.RESERVED_WORDS[f] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(f);
    };
    function h(f, p, m, A, w) {
      var x = p.popStack(), E = m.length;
      f && E--;
      for (var T = A; T < E; T++)
        x = p.nameLookup(x, m[T], w);
      return f ? [p.aliasable("container.strict"), "(", x, ", ", p.quotedString(m[E]), ", ", JSON.stringify(p.source.currentLocation), " )"] : x;
    }
    e.default = c, r.exports = e.default;
  })(Am, Am.exports)), Am.exports;
}
var tk;
function VG() {
  return tk || (tk = 1, (function(r, e) {
    e.__esModule = !0;
    function t(E) {
      return E && E.__esModule ? E : { default: E };
    }
    var n = EG(), i = t(n), a = CD(), s = t(a), o = IG(), l = PG(), u = UG(), c = t(u), h = SD(), f = t(h), p = bD(), m = t(p), A = i.default.create;
    function w() {
      var E = A();
      return E.compile = function(T, D) {
        return l.compile(T, D, E);
      }, E.precompile = function(T, D) {
        return l.precompile(T, D, E);
      }, E.AST = s.default, E.Compiler = l.Compiler, E.JavaScriptCompiler = c.default, E.Parser = o.parser, E.parse = o.parse, E.parseWithoutProcessing = o.parseWithoutProcessing, E;
    }
    var x = w();
    x.create = w, m.default(x), x.Visitor = f.default, x.default = x, e.default = x, r.exports = e.default;
  })(Zg, Zg.exports)), Zg.exports;
}
var $G = VG();
const zG = /* @__PURE__ */ Iu($G);
function Od(r, e) {
  return FD(r, e.getTemplatingContext());
}
function FD(r, e) {
  try {
    r = zG.compile(r)(e);
  } catch (t) {
    console.error("failed to render templated text", t);
  }
  return r;
}
const GG = (r) => {
  const t = (r.rotation || 0) * Math.PI / 180, n = Math.cos(t), i = -Math.sin(t), a = `text-path-${r.id}`, s = `text-fill-${r.id}`, o = r.x + (r.curved ? 0 : r.width / 2), l = r.y + (r.curved ? 0 : r.height / 2), u = FD(r.text || "", r._renderingConfiguration?.templatingContext), c = u.split(`
`), h = r.strokeColor?.browserValue && r.strokeThickness ? r.strokeColor?.browserValue : void 0, f = r.strokeColor?.browserValue && r.strokeThickness ? r.strokeThickness : void 0;
  if (r.curved && !r.paths || !r.fontData)
    return null;
  const p = () => r.textFillImage ? `url("#${s}")` : r._renderingConfiguration?.spotColors && r.fillSpotColorDefinition ? `${r.fill} ${MI(r.fillSpotColorDefinition)}` : r.fill;
  return /* @__PURE__ */ $t.jsxs($t.Fragment, { children: [
    /* @__PURE__ */ $t.jsxs("defs", { children: [
      r.textFillImage && /* @__PURE__ */ $t.jsx(
        "pattern",
        {
          id: s,
          patternUnits: "userSpaceOnUse",
          width: r.textFillImage.scale * r.textFillImage.width,
          height: r.textFillImage.scale * r.textFillImage.height,
          x: 0,
          y: 0,
          children: /* @__PURE__ */ $t.jsx(
            "image",
            {
              href: r.textFillImage.src,
              xlinkHref: r.textFillImage.src,
              width: r.textFillImage.scale * r.textFillImage.width,
              height: r.textFillImage.scale * r.textFillImage.height
            }
          )
        }
      ),
      /* @__PURE__ */ $t.jsx(
        "style",
        {
          type: "text/css",
          dangerouslySetInnerHTML: {
            __html: `
                        @font-face {
                            font-family: '${r.fontData.name}';
                            src: url('${r.fontData.assetUrl}') format('truetype');
                        }
                        `
          }
        }
      ),
      r.curved && r.paths ? /* @__PURE__ */ $t.jsx("path", { id: a, d: r.paths[0] }) : void 0
    ] }),
    r._renderingConfiguration?.debug ? /* @__PURE__ */ $t.jsx("rect", { stroke: "blue", fill: "none", x: r.x, y: r.y, width: r.width, height: r.height }) : void 0,
    /* @__PURE__ */ $t.jsx("g", { mask: r.stepName ? void 0 : r.mask, children: /* @__PURE__ */ $t.jsx("g", { transform: `matrix(${n}, ${-i}, ${i}, ${n}, ${o}, ${l})`, children: /* @__PURE__ */ $t.jsx(
      "text",
      {
        xmlSpace: "preserve",
        fontFamily: `'${r.fontData.name}'`,
        fontSize: r.fontSize,
        fontStyle: "normal",
        fontWeight: "normal",
        fill: p(),
        style: {
          whiteSpace: "pre",
          userSelect: "none"
        },
        stroke: h,
        strokeWidth: f,
        children: r.curved ? /* @__PURE__ */ $t.jsx(WG, { text: u, curvedPathId: a, align: r.align }) : c.map((m, A) => /* @__PURE__ */ $t.jsx(
          HG,
          {
            align: r.vertical ? "center" : r.align,
            fontSize: r.fontSize,
            thisLineIdx: A,
            amountLines: c.length,
            text: m,
            textboxHeight: r.height,
            textboxWidth: r.width,
            lineHeight: r.lineHeight,
            vertical: r.vertical,
            verticalAlign: r.verticalAlign,
            fontData: r.fontData
          },
          A
        ))
      }
    ) }) })
  ] });
}, HG = (r) => {
  const e = () => {
    if (r.lineHeight !== void 0)
      return r.lineHeight * r.fontSize;
    const i = _c(r.fontData.assetUrl), a = i.getFont(), s = r.fontSize / a.unitsPerEm;
    return i.getApproximateHeight() * s;
  }, t = () => r.align === "left" ? -r.textboxWidth / 2 : r.align === "right" ? r.textboxWidth / 2 : 0, n = () => {
    const i = e(), a = r.textboxHeight / 2;
    if (r.verticalAlign === "top")
      return -a + r.fontSize * 3 / 4 + r.thisLineIdx * i;
    if (r.verticalAlign === "bottom") {
      const o = r.amountLines - 1 - r.thisLineIdx;
      return a - r.fontSize / 4 - o * i;
    }
    const s = (r.amountLines - 1) / 2;
    return (r.thisLineIdx - s) * i + r.fontSize / 4;
  };
  return /* @__PURE__ */ $t.jsx("tspan", { textAnchor: vD(r.align), x: t(), y: `${n()}px`, children: r.text });
}, WG = (r) => {
  const e = `#${r.curvedPathId}`, t = () => r.align === "left" ? "0%" : r.align === "right" ? "100%" : "50%";
  return /* @__PURE__ */ $t.jsx(
    "textPath",
    {
      startOffset: t(),
      textAnchor: vD(r.align),
      href: e,
      xlinkHref: e,
      children: r.text
    }
  );
}, jG = (r) => {
  if (r.cachedObjectURL && !r._renderingConfiguration?.omitCachedFields)
    return /* @__PURE__ */ $t.jsx(
      wP,
      {
        id: r.id,
        src: r.cachedObjectURL,
        x: r.x,
        y: r.y,
        width: r.width,
        height: r.height,
        rotation: r.rotation,
        preserveAspectRatio: "none",
        immutable: r.immutable,
        mask: r.stepName ? void 0 : r.mask
      }
    );
  const e = r.rotation || 0, t = Oc(e), n = Math.cos(t), i = -Math.sin(t), a = `
    matrix(1, 0, 0, 1, ${r.x}, ${r.y})
    matrix(1, 0, 0, 1, ${r.width / 2}, ${r.height / 2})
    matrix(${n}, ${-i}, ${i}, ${n}, 0, 0)
    matrix(1, 0, 0, 1, ${-r.width / 2}, ${-r.height / 2})
    `;
  if (!r.svg)
    throw new Error(
      `Illustration element ${r.id} (stepName ${r.stepName}) lacked svg from src ${r.src} at render time.`
    );
  return /* @__PURE__ */ $t.jsx("g", { mask: r.stepName ? void 0 : r.mask, children: /* @__PURE__ */ $t.jsx(
    "g",
    {
      transform: a,
      dangerouslySetInnerHTML: {
        __html: Uw(
          r.svg,
          r.width,
          r.height,
          r.colors,
          r._renderingConfiguration?.spotColors
        )
      }
    }
  ) });
};
class qG {
  constructor() {
    this.id = nn(), this.stateCallbacks = [], this.prevCommands = [], this.nextCommands = [];
  }
  registerStateCallback(e) {
    this.stateCallbacks.push(e);
  }
  unregisterStateCallback(e) {
    this.stateCallbacks.filter((t) => t !== e);
  }
  getState() {
    return this.state;
  }
  runStateCallbacks() {
    this.stateCallbacks.forEach((e) => e());
  }
  apply(e, t) {
    if (!this.state)
      throw new Error(`State not initialized for cc ${this.id}!`);
    this.state = this.commandReducer(this.state, e), this.runStateCallbacks(), this.nextCommands = [], t || this.prevCommands.push(e);
  }
  undo() {
    if (!this.state)
      return;
    const e = this.prevCommands.pop();
    if (!e)
      return;
    const t = e.undo();
    this.state = { ...this.state, transaction: t }, this.nextCommands.push(e), this.runStateCallbacks();
  }
  redo() {
    if (!this.state)
      return;
    const e = this.nextCommands.pop();
    e && (this.state = this.commandReducer(this.state, e), this.runStateCallbacks(), this.prevCommands.push(e));
  }
  /**
   * Find all commands in history with the given sequence ID,
   * discard all but the last and overwrite its oldState.
   */
  flattenSequence(e, t) {
    const i = this.prevCommands.filter((a) => a.sequenceId === e).pop();
    i && (this.prevCommands = this.prevCommands.filter((a) => a.sequenceId !== e), i?.overrideOldState(t), this.prevCommands.push(i));
  }
  getLayoutById(e) {
    if (!this.state)
      throw new Error(`State not initialized for cc ${this.id}!`);
    const t = this.state.transaction?.layouts?.[e], n = t?.layout;
    if (!n)
      throw new Error(`No layout: ${e}`);
    const i = [...t?.elements || []];
    return this.getLayoutDataWithState(n, i);
  }
  getAllLayouts() {
    if (!this.state)
      throw new Error(`State not initialized for cc ${this.id}!`);
    const e = [...Object.keys(this.state.transaction?.layouts)];
    return [...new Set(e)].map((n) => this.getLayoutById(n));
  }
  getLayoutDataWithState(e, t) {
    return {
      layoutState: {
        layout: e,
        elements: t
      },
      Component: AP,
      getComponentWithProps: (n) => ux(e, t, n)
    };
  }
  initialize(e, t) {
    if (t) {
      this.state = {
        transaction: t
      };
      return;
    }
    let n = {
      serializableWorkflow: { steps: [] },
      layouts: {}
    };
    e.forEach((i) => {
      n = new OD(i).apply(n);
    }), this.runStateCallbacks(), this.state = {
      transaction: n
    };
  }
  /**
   * Updates the layout structure without losing canvas state.
   * Migrates existing layout states to new panel configurations.
   */
  updateLayouts(e) {
    if (!this.state)
      throw new Error(`State not initialized for cc ${this.id}!`);
    const t = this.state.transaction, n = new Map(e.map((a) => [a.panelId, a.id])), i = {};
    for (const [a, s] of Object.entries(t.layouts)) {
      const o = s.layout.panelId, l = n.get(o);
      if (l) {
        const u = e.find((c) => c.id === l);
        i[l] = {
          ...s,
          layout: {
            ...s.layout,
            ...u,
            id: l
          }
        };
      } else
        console.warn(`Panel ${o} removed, layout state discarded`);
    }
    this.state = {
      ...this.state,
      transaction: {
        ...t,
        layouts: i
      }
    }, this.runStateCallbacks();
  }
  commandReducer(e, t) {
    const n = e.transaction || { layouts: {}, serializableWorkflow: { steps: [] } };
    return { ...e, transaction: t.apply(n) };
  }
}
const ID = (r) => r.type === Mr.Image ? /* @__PURE__ */ $t.jsx(wP, { ...r }, r.id) : r.type === Mr.Frame ? /* @__PURE__ */ $t.jsx(RU, { ...r }, r.id) : r.type === Mr.Illustration ? /* @__PURE__ */ $t.jsx(jG, { ...r }, r.id) : r.type === Mr.Textbox ? /* @__PURE__ */ $t.jsx(GG, { ...r }, r.id) : r.type === Mr.Group ? /* @__PURE__ */ $t.jsx(xP, { ...r }, r.id) : null, ux = (r, e, t) => {
  const n = t.renderingConfiguration, i = n?.removeExcludedElements ? e.filter((a) => !a.excludeFromExport) : e;
  return /* @__PURE__ */ $t.jsx(
    AP,
    {
      preserveAspectRatio: void 0,
      elements: i,
      backgroundColor: r.transparentBackground ? void 0 : t.backgroundColor ? t.backgroundColor : "white",
      width: t.width || r.width,
      height: t.height || r.height,
      viewBox: n?.region ? {
        x: n.region.left,
        y: n.region.top,
        width: n.region.width,
        height: n.region.height
      } : {
        x: 0,
        y: 0,
        width: r.width,
        height: r.height
      },
      configuration: n,
      outlineArea: t.outlineArea,
      maxHeight: t.maxHeight,
      maxWidth: t.maxWidth,
      position: t.position,
      borderRadius: t.borderRadius,
      outlineColor: t.outlineColor
    }
  );
};
function cx(r) {
  return r.sort((e, t) => {
    const n = e.layer || 0, i = t.layer || 0;
    if (n < i) return -1;
    if (n > i) return 1;
    const a = e.layerIndex || 0, s = t.layerIndex || 0;
    return a < s ? -1 : a > s ? 1 : 0;
  });
}
var Jh = {}, Kh = {}, rk;
function QG() {
  if (rk) return Kh;
  rk = 1, Object.defineProperty(Kh, "__esModule", { value: !0 }), Kh.makeDataUriToBuffer = void 0;
  const r = (e) => (t) => {
    if (t = String(t), !/^data:/i.test(t))
      throw new TypeError('`uri` does not appear to be a Data URI (must begin with "data:")');
    t = t.replace(/\r?\n/g, "");
    const n = t.indexOf(",");
    if (n === -1 || n <= 4)
      throw new TypeError("malformed data: URI");
    const i = t.substring(5, n).split(";");
    let a = "", s = !1;
    const o = i[0] || "text/plain";
    let l = o;
    for (let h = 1; h < i.length; h++)
      i[h] === "base64" ? s = !0 : i[h] && (l += `;${i[h]}`, i[h].indexOf("charset=") === 0 && (a = i[h].substring(8)));
    !i[0] && !a.length && (l += ";charset=US-ASCII", a = "US-ASCII");
    const u = unescape(t.substring(n + 1)), c = s ? e.base64ToArrayBuffer(u) : e.stringToBuffer(u);
    return {
      type: o,
      typeFull: l,
      charset: a,
      buffer: c
    };
  };
  return Kh.makeDataUriToBuffer = r, Kh;
}
var nk;
function YG() {
  if (nk) return Jh;
  nk = 1, Object.defineProperty(Jh, "__esModule", { value: !0 }), Jh.dataUriToBuffer = void 0;
  const r = QG();
  function e(n) {
    const i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = [];
    for (let l = 0; l < n.length; l += 4) {
      const u = i.indexOf(n.charAt(l)), c = i.indexOf(n.charAt(l + 1)), h = n.charAt(l + 2) === "=" ? 0 : i.indexOf(n.charAt(l + 2)), f = n.charAt(l + 3) === "=" ? 0 : i.indexOf(n.charAt(l + 3)), p = u << 2 | c >> 4, m = (c & 15) << 4 | h >> 2, A = (h & 3) << 6 | f;
      a.push(p), n.charAt(l + 2) !== "=" && a.push(m), n.charAt(l + 3) !== "=" && a.push(A);
    }
    const s = new ArrayBuffer(a.length);
    return new Uint8Array(s).set(a), s;
  }
  function t(n) {
    const i = new ArrayBuffer(n.length), a = new Uint8Array(i);
    for (let s = 0; s < n.length; s++)
      a[s] = n.charCodeAt(s);
    return i;
  }
  return Jh.dataUriToBuffer = (0, r.makeDataUriToBuffer)({ stringToBuffer: t, base64ToArrayBuffer: e }), Jh;
}
var XG = YG();
const gc = /* @__PURE__ */ new Map(), wp = /* @__PURE__ */ new Map(), Iy = /* @__PURE__ */ new Map(), PD = async (r, e) => {
  if (!e) {
    if (!r) throw new Error("No region or src supplied. Cannot construct frame!");
    return z1(r);
  }
  return xo(e);
}, z1 = (r) => {
  const e = r.width, t = r.height;
  return `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${e} ${t}'>
        <path id="target-path" d='M0 0 h ${e} v ${t} h ${-e} Z' />
    </svg>
    `;
}, JG = async (r, e) => {
  if (!e)
    return;
  const t = await Pt.getDefaultVariant(e, r.frameVariantId);
  if (!t)
    throw new Error(`No variant with ID: ${r.frameVariantId}`);
  if (!t.asset)
    throw new Error(`No asset for variant with ID: ${r.frameVariantId}`);
  return t;
}, Q0 = async (r) => {
  if (Iy.has(r))
    return Iy.get(r);
  const t = (async () => {
    if (wp.has(r))
      return wp.get(r);
    await new Promise((f) => setTimeout(f, 0));
    const i = Pu().parseFromString(r, "image/svg+xml"), a = i.querySelector("svg");
    if (!a)
      throw new Error("Malformed frame SVG: <svg> tag not found");
    const s = a.getAttribute("viewBox");
    if (!s)
      throw new Error("SVG missing viewBox.");
    const o = s.split(" "), l = parseFloat(o[3]) || 1, u = parseFloat(o[2]) || 1, c = i.getElementById("target-path"), h = i.getElementsByClassName("st0").item(0);
    if (c) {
      const f = c.getAttribute("d");
      if (!f)
        throw new Error("Malformed frame SVG: 'd' attribute not found on target element");
      const p = {
        path: f,
        width: u,
        height: l
      };
      return wp.set(f, p), p;
    }
    if (h) {
      const f = h.getAttribute("d");
      if (!f)
        throw new Error("Malformed frame SVG: 'd' attribute not found on target element");
      const p = {
        path: f,
        width: u,
        height: l
      };
      return wp.set(f, p), p;
    }
    throw new Error("Malformed frame SVG");
  })();
  return Iy.set(r, t), t;
}, fx = (r, e, t, n) => {
  const i = e.width / e.height, a = r.width / r.height;
  let s;
  n ? a > i ? s = e.height / r.height : s = e.width / r.width : a > i ? s = e.width / r.width : s = e.height / r.height, t?.scale !== void 0 && (s *= t?.scale);
  const o = e.width / 2, l = e.height / 2, u = o - r.width / 2 * s, c = t?.left || u, h = l - r.height / 2 * s, f = t?.top || h;
  return {
    x: c,
    y: f,
    zoom: s,
    rotation: 0
  };
}, G1 = async (r) => {
  if (gc.has(r))
    return gc.get(r);
  if (r.startsWith("data:image/svg+xml")) {
    const t = XG.dataUriToBuffer(r), n = new TextDecoder().decode(t.buffer), i = DD(n), a = {
      src: r,
      width: i.width,
      height: i.height,
      aspect: i.width / i.height
    };
    return gc.set(r, a), a;
  }
  if ((r.split(".").pop()?.toLowerCase() ?? "") === "svg") {
    const t = await dx(r), n = t.width, i = t.height, a = {
      src: r,
      width: n,
      height: i,
      aspect: n / i
    };
    return gc.set(r, a), a;
  } else {
    const t = await $0(r, !0), n = await G0(t), i = {
      src: r,
      width: n.width,
      height: n.height,
      aspect: n.width / n.height
    };
    return gc.set(r, i), i;
  }
}, dx = async (r) => {
  const e = await xo(r);
  return DD(e);
}, ik = (r) => r.endsWith("mm") ? Number(r.replace("mm", "")) * 3.7795275591 : r.endsWith("px") ? Number(r.replace("px", "")) : Number(r), DD = (r) => {
  const n = Pu().parseFromString(r, "image/svg+xml").querySelector("svg");
  if (!n)
    throw new Error("No svg tag found, this svg must be malformed!");
  const i = n.getAttribute("viewBox"), a = n.getAttribute("width"), s = n.getAttribute("height"), o = s && a ? [0, 0, ik(a), ik(s)] : i?.split(" ").map((l) => Number(l));
  if (!o)
    throw new Error("No viewbox or width/height values detected on SVG file!");
  return {
    width: o[2],
    height: o[3]
  };
}, Zh = (r, e) => {
  const t = r.layoutState.elements.filter((i) => i.layer === e), n = Math.max(...t.map((i) => i.layerIndex).filter((i) => i !== void 0));
  return Math.max(n, 0) + 1;
}, RD = async (r) => new Promise((e) => {
  xo(r).then((t) => {
    e(t);
  }).catch((t) => console.error(t));
}), Py = /* @__PURE__ */ new Map(), Jp = async (r) => {
  if (Py.has(r))
    return Py.get(r);
  const e = async (i) => new Promise((a, s) => {
    try {
      if (!(!!URL && !!URL.createObjectURL)) throw new Error("Environment incapable of generating ObjectURL");
      i.toBlob((l) => {
        if (!l)
          throw i.width === 0 || i.height === 0 ? new Error(`Canvas dimensions are invalid (${i.width},${i.height})`) : i.width * i.height >= 268435456 ? new Error(`Canvas dimensions exceed device limit (${i.width},${i.height})`) : new Error("Couldn't generate object URL for Illustration, the blob was undefined!");
        a(URL.createObjectURL(l));
      });
    } catch (o) {
      s(o);
    }
  }), n = (async () => {
    const s = Pu().parseFromString(r, "image/svg+xml").firstElementChild;
    if (!s)
      throw new Error("Failed to read SVG");
    const l = $f().serializeToString(s), u = Pc(), c = u.getContext("2d"), h = await vc.from(c, l, {
      anonymousCrossOrigin: !0,
      ignoreDimensions: !1,
      createCanvas: Pc,
      createImage: cg,
      DOMParser: Dw(),
      fetch: Ll
    }), f = s.getAttribute("width"), p = s.getAttribute("height"), m = 2048;
    if (p && f) {
      const A = parseFloat(p), x = parseFloat(f) / A;
      x > 1 ? h.resize(m, m / x) : h.resize(m * x, m);
    } else
      h.resize(m, m);
    return await h.render(), await e(u);
  })();
  return Py.set(r, n), n;
}, ep = async (r, e, t, n) => {
  const i = r.layoutState.layout.useEditableArea && r.layoutState.layout.editableArea || {
    width: r.layoutState.layout.width,
    height: r.layoutState.layout.height,
    x: 0,
    y: 0
  }, a = i.width < i.height ? i.width : i.height, s = r.layoutState.layout.useEditableArea ? a / 1.3 : a / 2, o = {
    top: i.y + i.height / 2 - s / 2,
    left: i.x + i.width / 2 - s / 2,
    width: s,
    height: s,
    rotation: 0,
    panelId: r.layoutState.layout.panelId
  };
  if (t && e === Mr.Illustration) {
    const l = await Nl(await RD(t)), f = Pu().parseFromString(l.svg, "image/svg+xml").firstElementChild.getAttribute("viewBox");
    if (!f) throw new Error("SVG missing viewBox.");
    const p = o.height, m = f.split(" "), A = parseFloat(m[2]) || 1, w = parseFloat(m[3]) || 1, x = A / w;
    o.height = o.width / x, o.top += (p - o.height) / 2;
  }
  if (t && e === Mr.Image) {
    const l = o.height, u = await $0(t), c = await G0(u), h = c.width / c.height;
    o.height = o.width / h, o.top += (l - o.height) / 2;
  }
  if (t && e === Mr.Textbox && n?.text && n?.fontScale) {
    await oh(t);
    const l = _c(t), u = wc(n.text, n?.fontScale, l);
    o.width = Math.min(u, i.width * 0.85), o.left = i.x + i.width / 2 - o.width / 2;
  }
  return o;
};
class Kre {
  static async getFrame(e, t) {
    const n = await PD(t.region, t.src), i = await Q0(n), a = t.region || await ep(e, Mr.Frame);
    return {
      id: nn(),
      x: a.left,
      y: a.top,
      width: a.width,
      height: a.height,
      layer: a.layer || 0,
      layerIndex: a.layerIndex || Zh(e, a.layer || 0),
      rotation: a.rotation,
      scaleX: a.width / i.width,
      scaleY: a.height / i.height,
      path: i.path,
      dataWidth: i.width,
      dataHeight: i.height,
      type: Mr.Frame,
      disablePlaceholder: t.configuration.disablePlaceholder,
      focalBlur: t.configuration.focalBlur,
      focalBlurStrength: t.configuration.focalBlurStrength,
      focalBlurRadius: t.configuration.focalBlurRadius,
      forceImageCover: t.configuration.forceImageCover,
      pattern: void 0,
      immutable: a.immutable
    };
  }
  static async getImage(e, t) {
    const n = t.region || await ep(e, Mr.Image, t.src);
    return {
      id: nn(),
      src: t.src,
      type: Mr.Image,
      y: n.top,
      x: n.left,
      rotation: n.rotation,
      width: n.width,
      height: n.height,
      layer: n.layer || 0,
      layerIndex: n.layerIndex || Zh(e, n.layer || 0),
      immutable: n.immutable,
      preserveAspectRatio: "none"
    };
  }
  static async getTextbox(e, t) {
    const { configuration: n, fontSrc: i, designInputStep: a } = t, s = await oh(i), o = {
      assetUrl: i,
      name: s.names.fullName.en
    }, l = a?.text || n.defaultText || "", u = n.replaceableText ? n.replaceableText.replace("{{}}", l) : l, c = C0(u, {
      vertical: n.vertical,
      uppercase: n.uppercase
    }), h = t.region || await ep(e, Mr.Textbox, i, {
      text: c,
      fontScale: n.size ? n.size / s.unitsPerEm : void 0
    }), f = xg(
      {
        id: nn(),
        type: Mr.Textbox,
        x: h.left,
        y: h.top,
        width: h.width,
        height: h.height,
        align: dG(n.textAlign, n.vertical),
        curved: n.curved,
        fill: a?.color || n.colour || "#000000",
        fontData: o,
        layer: h.layer || 0,
        layerIndex: h.layerIndex || Zh(e, h.layer || 0),
        paths: n.paths,
        rotation: h.rotation,
        vertical: n.vertical,
        verticalAlign: n.verticalAlign || "middle",
        algorithm: eh.Traditional,
        fontSize: n.size || Math.max(Math.round(h.height * 0.025), 1),
        text: c,
        input: l
      },
      c
    ), p = uG(
      { ...h, height: f.height },
      o,
      f.fontSize,
      f?.text?.split(`
`) || [],
      f.align
    );
    return {
      ...f,
      x: p.left,
      y: p.top + (h.height - p.height) / 2,
      width: p.width,
      height: p.height
    };
  }
  static async getShape(e, t) {
    const n = `
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xmlSpace="preserve"
                        preserveAspectRatio="none"
                        version="1.1"
                        width="1"
                        height="1"
                        viewBox="0 0 1 1"
                    >
                        <rect
                            x="0"
                            y="0"
                            width="1"
                            height="1"
                            class="spiff-fill-shape"
                            fill="${t.color}"
                        />
                    </svg>
                `, i = {};
    i["spiff-fill-shape"] = { browserValue: t.color };
    const a = t.region?.item || await ep(e, Mr.Illustration), s = nn();
    return {
      stepRegion: t.region?.item,
      stepRegionIndex: t.region?.index,
      colors: i,
      id: s,
      svg: n,
      type: Mr.Illustration,
      y: a.top,
      x: a.left,
      rotation: a.rotation,
      width: a.width,
      height: a.height,
      layer: a.layer || 0,
      layerIndex: a.layerIndex || Zh(e, a.layer || 0),
      immutable: a.immutable
    };
  }
  static async getIllustration(e, t) {
    const n = t.region?.item || await ep(e, Mr.Illustration, t.src), i = await Nl(await RD(t.src)), a = await Jp(i.svg), s = nn();
    return {
      cachedObjectURL: a,
      stepRegion: t.region?.item,
      stepRegionIndex: t.region?.index,
      colors: i.colors,
      id: s,
      src: t.src,
      svg: i.svg,
      type: Mr.Illustration,
      y: n.top,
      x: n.left,
      rotation: n.rotation,
      width: n.width,
      height: n.height,
      layer: n.layer || 0,
      layerIndex: n.layerIndex || Zh(e, n.layer || 0),
      immutable: n.immutable
    };
  }
}
class Ki extends Error {
  constructor() {
    super("Element not found!"), Object.setPrototypeOf(this, Ki.prototype);
  }
}
const zi = (r, e) => Qa(r, e).elements.find((i) => i.id === r), Qa = (r, e) => {
  const t = Object.values(e).find((n) => n.elements.some((i) => i.id === r));
  if (!t)
    throw new Ki();
  return t;
}, Ps = (r, e) => {
  const t = [...e.elements.filter((i) => i.id !== r.id), r], n = cx(t);
  return {
    layout: e.layout,
    elements: n,
    modificationID: nn()
  };
}, ak = async (r) => {
  const e = [...Object.keys(r.layouts)], t = [...new Set(e)];
  for (let n = 0; n < t.length; n++) {
    const i = t[n], a = r.layouts[i];
    await Promise.all(
      a.elements.map(async (s) => {
        if (s.type === "illustration") {
          const o = s;
          if (o.src && !o.svg) {
            const l = await xo(o.src), u = await Nl(l);
            o.svg = Uw(
              u.svg,
              o.width,
              o.height,
              o.colors
            );
          }
        } else if (s.type === "frame") {
          const o = s;
          if (o.pattern?.colors && o.pattern?.src) {
            const l = await xo(o.pattern?.src), u = await Nl(l);
            o.pattern.svg = u.svg;
          }
        }
        isNaN(s.x) && (s.x = 0), isNaN(s.y) && (s.y = 0), isNaN(s.width) && (s.width = 0), isNaN(s.height) && (s.height = 0), isNaN(s.rotation) && (s.rotation = 0);
      })
    );
  }
  for (const n in r.layouts) {
    const i = r.layouts[n].elements.filter(
      (s) => s.type === Mr.Illustration
    );
    for (let s = 0; s < i.length; ++s) {
      const o = i[s];
      if (o.src && o.svg)
        try {
          o.cachedObjectURL = await Jp(o.svg);
        } catch (l) {
          console.log(l);
        }
    }
    const a = r.layouts[n].elements.filter(
      (s) => s.type === Mr.Textbox
    );
    for (let s = 0; s < a.length; ++s) {
      const o = a[s];
      o.fontData?.assetUrl && await oh(o.fontData.assetUrl);
    }
  }
};
class Pi {
  undo() {
    if (!this.oldState)
      throw new Error("Cannot undo.");
    return this.oldState;
  }
  overrideOldState(e) {
    this.oldState = e;
  }
}
class sk extends Pi {
  constructor(e) {
    super(), this.serializableWorkflow = e;
  }
  apply(e) {
    return this.oldState = e, {
      ...e,
      serializableWorkflow: this.serializableWorkflow
    };
  }
}
class Zre extends Pi {
  constructor(e, t, n) {
    super(), this.id = e, this.x = t, this.y = n;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = {
      ...t,
      x: this.x,
      y: this.y
    }, i = Qa(t.id, Object.values(e.layouts)), a = Ps(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class ene extends Pi {
  constructor(e, t) {
    super(), this.id = e, this.angle = t;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = {
      ...t,
      rotation: this.angle
    }, i = Qa(t.id, Object.values(e.layouts)), a = Ps(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class tne extends Pi {
  constructor(e, t, n) {
    super(), this.id = e, this.width = Math.abs(t), this.height = Math.abs(n);
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    let n = {
      ...t,
      width: this.width,
      height: this.height
    };
    if (t.type === "frame") {
      const s = n;
      s.scaleX = s.scaleX * this.width / t.width, s.scaleY = s.scaleY * this.height / t.height;
    } else if (t.type === "textbox") {
      const s = n, o = (!s.algorithm || s.algorithm === eh.Autosize ? s.text : s.input) ?? "";
      n = xg(s, o, t);
    }
    const i = Qa(t.id, Object.values(e.layouts)), a = Ps(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class Ii extends Pi {
  constructor(e) {
    super(), this.commands = e;
  }
  apply(e) {
    return this.oldState = e, this.commands.reduce((t, n) => n.apply(t), e);
  }
}
class OD extends Pi {
  constructor(e) {
    super(), this.layout = e;
  }
  apply(e) {
    return this.oldState = e, {
      ...e,
      layouts: {
        ...e.layouts,
        [this.layout.id]: {
          elements: [],
          layout: { ...this.layout },
          modificationID: nn()
        }
      }
    };
  }
}
class pa extends Pi {
  /**
   * @param initialParams The initial parameters to be set on this new object
   * @param callback An optional callback function to be notified when the object has been instantiated
   * @param layout
   */
  constructor(e, t) {
    super(), this.element = e, this.layout = t;
  }
  apply(e) {
    this.oldState = e, e.layouts[this.layout.id] || (e.layouts[this.layout.id] = { layout: this.layout, elements: [], modificationID: "" });
    const t = e.layouts[this.layout.id].elements;
    if (t.find((o) => o.id === this.element.id))
      throw new Error(
        `Failed to apply new ${this.element.type} element because ID ${this.element.id} already taken`
      );
    if (this.element.productOverlay || t.length === 0) {
      const o = [...t, this.element];
      return this.element.layerIndex === void 0 && (this.element.layerIndex = this.assignIndex(this.element, o)), {
        ...e,
        layouts: {
          ...e.layouts,
          [this.layout.id]: {
            ...e.layouts[this.layout.id],
            elements: o,
            modificationID: nn()
          }
        }
      };
    }
    const i = t[t.length - 1], a = i.productOverlay ? i : null;
    a && t.pop();
    let s;
    if (this.element.layerIndex !== null && this.element.layerIndex !== void 0)
      s = [...t, this.element].sort((o, l) => o.layerIndex !== void 0 && l.layerIndex !== void 0 ? o.layerIndex - l.layerIndex : 0);
    else {
      const o = this.assignIndex(this.element, t);
      this.element.layerIndex = o !== void 0 ? o : 0, s = [...t, this.element];
    }
    return a && s.push(a), {
      ...e,
      layouts: {
        ...e.layouts,
        [this.layout.id]: {
          ...e.layouts[this.layout.id],
          elements: s,
          modificationID: nn()
        }
      }
    };
  }
  // Calculate layer index for an element that doesn't have an explicit index.
  assignIndex(e, t) {
    if (t.length === 0)
      return 0;
    const n = t.filter((i) => (i.layer || 0) === (e.layer || 0)).sort((i, a) => (i.layerIndex || 0) - (a.layerIndex || 0))[t.length - 1]?.layerIndex;
    return n !== void 0 ? n + 1 : 0;
  }
}
class Lf extends Pi {
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    this.oldState = e;
    let t = !1;
    const n = Object.values(e.layouts).map((a) => (a.elements.filter((o) => o.id !== this.id).length !== a.elements.length && (t = !0), {
      ...a,
      elements: a.elements.filter((o) => o.id !== this.id),
      modificationID: nn()
    }));
    t || console.log(`Failed to delete element ${this.id}`);
    const i = {};
    return n.forEach((a) => {
      i[a.layout.id] = a;
    }), {
      ...e,
      layouts: i
    };
  }
}
class ok extends Pi {
  constructor(e, t, n) {
    super(), this.id = e, this.color = t, this.textFillSpotColor = n;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = {
      ...t,
      fill: this.color,
      fillSpotColorDefinition: this.textFillSpotColor,
      textFillImage: void 0
    }, i = Qa(t.id, Object.values(e.layouts)), a = Ps(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class Dy extends Pi {
  constructor(e, t) {
    super(), this.id = e, this.imageFill = t;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = {
      ...t,
      textFillImage: this.imageFill
    }, i = Qa(t.id, Object.values(e.layouts)), a = Ps(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class KG extends Pi {
  constructor(e, t) {
    super(), this.id = e, this.size = t;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = {
      ...t,
      fontSize: this.size
    }, i = Qa(t.id, Object.values(e.layouts)), a = (!t.algorithm || t.algorithm === eh.Autosize ? t.text : t.input) ?? "", s = Ps(xg(n, a), i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: s
      }
    };
  }
}
class lk extends Pi {
  constructor(e, t) {
    super(), this.id = e, this.fontData = t;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = {
      ...t,
      fontData: this.fontData
    }, i = Qa(t.id, Object.values(e.layouts)), a = (!t.algorithm || t.algorithm === eh.Autosize ? t.text : t.input) ?? "", s = Ps(xg(n, a), i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: s
      }
    };
  }
}
class ZG extends Pi {
  constructor(e, t) {
    super(), this.id = e, this.align = t;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = {
      ...t,
      align: this.align
    }, i = Qa(t.id, Object.values(e.layouts)), a = Ps(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class eH extends Pi {
  constructor(e, t, n) {
    super(), this.id = e, this.imageData = t, this.offsets = n;
  }
  apply(e) {
    this.oldState = e;
    const t = Qa(this.id, Object.values(e.layouts)), n = t.elements.findIndex((o) => o.id === this.id), i = t.elements[n].pattern, a = [...t.elements];
    a.splice(n, 1, {
      ...t.elements[n],
      pattern: {
        ...i,
        src: this.imageData.src,
        x: this.offsets.x,
        y: this.offsets.y,
        width: this.imageData.width,
        height: this.imageData.height,
        scaleX: this.offsets.zoom,
        scaleY: this.offsets.zoom,
        rotation: this.offsets.rotation ?? i?.rotation ?? 0,
        svg: this.imageData.svg,
        colors: this.imageData.colors
      }
    });
    const s = {
      ...t,
      elements: a,
      modificationID: nn()
    };
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [t.layout.id]: s
      }
    };
  }
}
class tH extends Pi {
  constructor(e, t, n, i, a) {
    super(), this.id = e, this.useThreshold = t, this.invertThreshold = n, this.threshold = i, this.thresholdSaturation = a;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = {
      ...t,
      useThreshold: this.useThreshold,
      invertThreshold: this.invertThreshold,
      threshold: this.threshold,
      thresholdSaturation: this.thresholdSaturation
    }, i = Qa(t.id, Object.values(e.layouts)), a = Ps(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class rne extends Pi {
  constructor(e, t) {
    super(), this.id = e, this.src = t;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = {
      ...t,
      src: this.src
    }, i = Qa(t.id, Object.values(e.layouts)), a = Ps(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class rH extends Pi {
  constructor(e, t) {
    super(), this.id = e, this.text = t;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = Qa(t.id, Object.values(e.layouts)), i = Ps(xg(t, this.text, t), n);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: i
      }
    };
  }
}
class Ry extends Pi {
  constructor(e, t, n) {
    super(), this.id = e, this.strokeColor = t, this.strokeThickness = n;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = {
      ...t,
      strokeColor: this.strokeColor,
      strokeThickness: this.strokeThickness
    }, i = Qa(t.id, Object.values(e.layouts)), a = Ps(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class H1 extends Pi {
  constructor(e, t, n) {
    super(), this.id = e, this.className = t, this.fill = n;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = t.colors || {}, i = n[this.className];
    typeof this.fill == "string" ? n[this.className] = {
      browserValue: this.fill,
      spotColor: i?.spotColor,
      pmsValue: i?.pmsValue
    } : n[this.className] = {
      browserValue: this.fill.browserValue,
      spotColor: i?.spotColor,
      pmsValue: this.fill.pmsValue
    };
    const a = {
      ...t,
      colors: n
    }, s = Qa(t.id, Object.values(e.layouts)), o = Ps(a, s);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [s.layout.id]: o
      }
    };
  }
}
class nH extends Pi {
  constructor(e, t, n) {
    super(), this.id = e, this.svgBody = t, this.objectURL = n;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = {
      ...t,
      svg: this.svgBody,
      cachedObjectURL: this.objectURL
    }, i = Qa(t.id, Object.values(e.layouts)), a = Ps(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class nne extends Pi {
  /**
   * @param id The targeted element to bring to the front.
   */
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    if (this.oldState = e, !zi(this.id, Object.values(e.layouts)).id)
      throw new Ki();
    const n = Object.values(e.layouts).find((s) => s.elements.find((o) => o.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    const i = n.elements.findIndex((s) => s.id === this.id);
    n.elements.push(n.elements.splice(i, 1)[0]);
    const a = [...n.elements];
    return a.forEach((s, o) => s.layerIndex = o), {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: {
          ...e.layouts[n.layout.id],
          elements: a,
          modificationID: nn()
        }
      }
    };
  }
}
class ine extends Pi {
  /**
   * @param id The targeted element to bring to the back.
   */
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    this.oldState = e;
    const t = zi(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Ki();
    const n = Object.values(e.layouts).find((o) => o.elements.find((l) => l.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    const i = n.elements.findIndex((o) => o.id === this.id);
    n.elements.splice(i, 1), n.elements.unshift(t);
    const a = [...n.elements], s = a.splice(i, 1)[0];
    return a.splice(i, 0, s), a.forEach((o, l) => o.layerIndex = l), {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: {
          ...e.layouts[n.layout.id],
          elements: a,
          modificationID: nn()
        }
      }
    };
  }
}
class ane extends Pi {
  /**
   * @param id The targeted element to bring to the front.
   */
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    if (this.oldState = e, !zi(this.id, Object.values(e.layouts)).id)
      throw new Ki();
    const n = Object.values(e.layouts).find((l) => l.elements.find((u) => u.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    const i = n.elements.findIndex((l) => l.id === this.id), a = i + 1, s = [...n.elements], o = s.splice(i, 1)[0];
    return s.splice(a, 0, o), s.forEach((l, u) => l.layerIndex = u), {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: {
          ...e.layouts[n.layout.id],
          elements: s,
          modificationID: nn()
        }
      }
    };
  }
}
class sne extends Pi {
  /**
   * @param id The targeted element to bring to the front.
   */
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    if (this.oldState = e, !zi(this.id, Object.values(e.layouts)).id)
      throw new Ki();
    const n = Object.values(e.layouts).find((l) => l.elements.find((u) => u.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    const i = n.elements.findIndex((l) => l.id === this.id), a = i - 1, s = [...n.elements], o = s.splice(i, 1)[0];
    return s.splice(a, 0, o), s.forEach((l, u) => l.layerIndex = u), {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: {
          ...e.layouts[n.layout.id],
          elements: s,
          modificationID: nn()
        }
      }
    };
  }
}
class uk {
  constructor(e, t, n) {
    this.processRegion = async (i) => {
      const a = this.layouts.find((l) => l.panelId === i.panelId);
      if (!a)
        throw new La(i);
      let s = "";
      if (this.configuration.type === gt.ProductOverlay) {
        let l = "";
        if (this.product?.overlayImageUrl && (l = this.product.overlayImageUrl), s = l, !l)
          throw new Cu(this.configuration, "Couldn't find an asset for product overlay step");
      }
      const o = this.evaluateAssetType();
      if (o === Mr.Image) {
        const l = this.configuration.type === gt.SilentIllustration ? this.configuration.data.asset?.fileLink : this.product?.overlayImageUrl;
        if (!l)
          throw new Error("Undefined raster silent step source");
        const u = {
          stepName: this.configuration.stepName,
          id: nn(),
          src: l,
          type: o,
          y: i.top,
          x: i.left,
          width: i.width,
          height: i.height,
          layer: i.layer,
          layerIndex: i.layerIndex,
          immutable: i.immutable,
          productOverlay: this.configuration.type === gt.ProductOverlay ? !0 : void 0,
          rotation: i.rotation,
          excludeFromExport: this.configuration.data.excludeFromPrint,
          preserveAspectRatio: "none"
        };
        return {
          regionElement: {
            id: u.id,
            region: i
          },
          command: new pa(u, a)
        };
      } else {
        const l = this.configuration.type === gt.SilentIllustration ? this.configuration.data.asset?.fileLink : s, c = await Nl(await (async () => new Promise((f, p) => {
          if (!l) {
            p("Undefined vector silent step source");
            return;
          }
          xo(l, !0).then((m) => {
            f(m);
          }).catch((m) => console.error(m));
        }))()), h = {
          stepName: this.configuration.stepName,
          id: nn(),
          cachedObjectURL: await Jp(c.svg),
          src: l,
          svg: c.svg,
          colors: c.colors,
          type: o,
          y: i.top,
          x: i.left,
          width: i.width,
          height: i.height,
          layer: i.layer,
          layerIndex: i.layerIndex,
          rotation: i.rotation,
          immutable: i.immutable,
          productOverlay: this.configuration.type === gt.ProductOverlay ? !0 : void 0,
          excludeFromExport: this.configuration.data.excludeFromPrint
        };
        return {
          regionElement: {
            id: h.id,
            region: i
          },
          command: new pa(h, a)
        };
      }
    }, this.configuration = e, this.layouts = t, this.product = n || void 0;
  }
  async trigger() {
    if (!this.configuration.data.regions)
      throw new Cu(this.configuration, "Missing regions.");
    if (this.configuration.type === gt.SilentIllustration) {
      const e = this.configuration.data.regions.map(this.processRegion);
      return Promise.all(e);
    } else return this.configuration.type === gt.ProductOverlay ? Promise.all(
      this.configuration.data.regions.map((e) => {
        if (!this.layouts.find((n) => e.panelId === n.panelId))
          throw new La(e);
        return this.processRegion(e);
      })
    ) : Promise.reject("Unknown silent step. This is a bug");
  }
  evaluateAssetType() {
    const e = this.configuration.type === gt.ProductOverlay && this.product?.overlayImageUrl ? this.product.overlayImageUrl.toLowerCase() : this.configuration.data.asset?.fileLink?.toLowerCase().split("?")[0], t = e ? Dc(e) : void 0;
    return e?.startsWith("data:image/png") || t === "jpeg" || t === "jpg" || t === "png" ? Mr.Image : (t === "svg" || e?.startsWith("image/svg+xml"), Mr.Illustration);
  }
}
var vd = {}, Oy, ck;
function iH() {
  return ck || (ck = 1, Oy = function() {
    return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
  }), Oy;
}
var By = {}, lc = {}, fk;
function Hf() {
  if (fk) return lc;
  fk = 1;
  let r;
  const e = [
    0,
    // Not used
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
  ];
  return lc.getSymbolSize = function(n) {
    if (!n) throw new Error('"version" cannot be null or undefined');
    if (n < 1 || n > 40) throw new Error('"version" should be in range from 1 to 40');
    return n * 4 + 17;
  }, lc.getSymbolTotalCodewords = function(n) {
    return e[n];
  }, lc.getBCHDigit = function(t) {
    let n = 0;
    for (; t !== 0; )
      n++, t >>>= 1;
    return n;
  }, lc.setToSJISFunction = function(n) {
    if (typeof n != "function")
      throw new Error('"toSJISFunc" is not a valid function.');
    r = n;
  }, lc.isKanjiModeEnabled = function() {
    return typeof r < "u";
  }, lc.toSJIS = function(n) {
    return r(n);
  }, lc;
}
var _y = {}, dk;
function hx() {
  return dk || (dk = 1, (function(r) {
    r.L = { bit: 1 }, r.M = { bit: 0 }, r.Q = { bit: 3 }, r.H = { bit: 2 };
    function e(t) {
      if (typeof t != "string")
        throw new Error("Param is not a string");
      switch (t.toLowerCase()) {
        case "l":
        case "low":
          return r.L;
        case "m":
        case "medium":
          return r.M;
        case "q":
        case "quartile":
          return r.Q;
        case "h":
        case "high":
          return r.H;
        default:
          throw new Error("Unknown EC Level: " + t);
      }
    }
    r.isValid = function(n) {
      return n && typeof n.bit < "u" && n.bit >= 0 && n.bit < 4;
    }, r.from = function(n, i) {
      if (r.isValid(n))
        return n;
      try {
        return e(n);
      } catch {
        return i;
      }
    };
  })(_y)), _y;
}
var My, hk;
function aH() {
  if (hk) return My;
  hk = 1;
  function r() {
    this.buffer = [], this.length = 0;
  }
  return r.prototype = {
    get: function(e) {
      const t = Math.floor(e / 8);
      return (this.buffer[t] >>> 7 - e % 8 & 1) === 1;
    },
    put: function(e, t) {
      for (let n = 0; n < t; n++)
        this.putBit((e >>> t - n - 1 & 1) === 1);
    },
    getLengthInBits: function() {
      return this.length;
    },
    putBit: function(e) {
      const t = Math.floor(this.length / 8);
      this.buffer.length <= t && this.buffer.push(0), e && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
    }
  }, My = r, My;
}
var Ny, pk;
function sH() {
  if (pk) return Ny;
  pk = 1;
  function r(e) {
    if (!e || e < 1)
      throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = e, this.data = new Uint8Array(e * e), this.reservedBit = new Uint8Array(e * e);
  }
  return r.prototype.set = function(e, t, n, i) {
    const a = e * this.size + t;
    this.data[a] = n, i && (this.reservedBit[a] = !0);
  }, r.prototype.get = function(e, t) {
    return this.data[e * this.size + t];
  }, r.prototype.xor = function(e, t, n) {
    this.data[e * this.size + t] ^= n;
  }, r.prototype.isReserved = function(e, t) {
    return this.reservedBit[e * this.size + t];
  }, Ny = r, Ny;
}
var Ly = {}, gk;
function oH() {
  return gk || (gk = 1, (function(r) {
    const e = Hf().getSymbolSize;
    r.getRowColCoords = function(n) {
      if (n === 1) return [];
      const i = Math.floor(n / 7) + 2, a = e(n), s = a === 145 ? 26 : Math.ceil((a - 13) / (2 * i - 2)) * 2, o = [a - 7];
      for (let l = 1; l < i - 1; l++)
        o[l] = o[l - 1] - s;
      return o.push(6), o.reverse();
    }, r.getPositions = function(n) {
      const i = [], a = r.getRowColCoords(n), s = a.length;
      for (let o = 0; o < s; o++)
        for (let l = 0; l < s; l++)
          o === 0 && l === 0 || // top-left
          o === 0 && l === s - 1 || // bottom-left
          o === s - 1 && l === 0 || i.push([a[o], a[l]]);
      return i;
    };
  })(Ly)), Ly;
}
var Uy = {}, mk;
function lH() {
  if (mk) return Uy;
  mk = 1;
  const r = Hf().getSymbolSize, e = 7;
  return Uy.getPositions = function(n) {
    const i = r(n);
    return [
      // top-left
      [0, 0],
      // top-right
      [i - e, 0],
      // bottom-left
      [0, i - e]
    ];
  }, Uy;
}
var Vy = {}, vk;
function uH() {
  return vk || (vk = 1, (function(r) {
    r.Patterns = {
      PATTERN000: 0,
      PATTERN001: 1,
      PATTERN010: 2,
      PATTERN011: 3,
      PATTERN100: 4,
      PATTERN101: 5,
      PATTERN110: 6,
      PATTERN111: 7
    };
    const e = {
      N1: 3,
      N2: 3,
      N3: 40,
      N4: 10
    };
    r.isValid = function(i) {
      return i != null && i !== "" && !isNaN(i) && i >= 0 && i <= 7;
    }, r.from = function(i) {
      return r.isValid(i) ? parseInt(i, 10) : void 0;
    }, r.getPenaltyN1 = function(i) {
      const a = i.size;
      let s = 0, o = 0, l = 0, u = null, c = null;
      for (let h = 0; h < a; h++) {
        o = l = 0, u = c = null;
        for (let f = 0; f < a; f++) {
          let p = i.get(h, f);
          p === u ? o++ : (o >= 5 && (s += e.N1 + (o - 5)), u = p, o = 1), p = i.get(f, h), p === c ? l++ : (l >= 5 && (s += e.N1 + (l - 5)), c = p, l = 1);
        }
        o >= 5 && (s += e.N1 + (o - 5)), l >= 5 && (s += e.N1 + (l - 5));
      }
      return s;
    }, r.getPenaltyN2 = function(i) {
      const a = i.size;
      let s = 0;
      for (let o = 0; o < a - 1; o++)
        for (let l = 0; l < a - 1; l++) {
          const u = i.get(o, l) + i.get(o, l + 1) + i.get(o + 1, l) + i.get(o + 1, l + 1);
          (u === 4 || u === 0) && s++;
        }
      return s * e.N2;
    }, r.getPenaltyN3 = function(i) {
      const a = i.size;
      let s = 0, o = 0, l = 0;
      for (let u = 0; u < a; u++) {
        o = l = 0;
        for (let c = 0; c < a; c++)
          o = o << 1 & 2047 | i.get(u, c), c >= 10 && (o === 1488 || o === 93) && s++, l = l << 1 & 2047 | i.get(c, u), c >= 10 && (l === 1488 || l === 93) && s++;
      }
      return s * e.N3;
    }, r.getPenaltyN4 = function(i) {
      let a = 0;
      const s = i.data.length;
      for (let l = 0; l < s; l++) a += i.data[l];
      return Math.abs(Math.ceil(a * 100 / s / 5) - 10) * e.N4;
    };
    function t(n, i, a) {
      switch (n) {
        case r.Patterns.PATTERN000:
          return (i + a) % 2 === 0;
        case r.Patterns.PATTERN001:
          return i % 2 === 0;
        case r.Patterns.PATTERN010:
          return a % 3 === 0;
        case r.Patterns.PATTERN011:
          return (i + a) % 3 === 0;
        case r.Patterns.PATTERN100:
          return (Math.floor(i / 2) + Math.floor(a / 3)) % 2 === 0;
        case r.Patterns.PATTERN101:
          return i * a % 2 + i * a % 3 === 0;
        case r.Patterns.PATTERN110:
          return (i * a % 2 + i * a % 3) % 2 === 0;
        case r.Patterns.PATTERN111:
          return (i * a % 3 + (i + a) % 2) % 2 === 0;
        default:
          throw new Error("bad maskPattern:" + n);
      }
    }
    r.applyMask = function(i, a) {
      const s = a.size;
      for (let o = 0; o < s; o++)
        for (let l = 0; l < s; l++)
          a.isReserved(l, o) || a.xor(l, o, t(i, l, o));
    }, r.getBestMask = function(i, a) {
      const s = Object.keys(r.Patterns).length;
      let o = 0, l = 1 / 0;
      for (let u = 0; u < s; u++) {
        a(u), r.applyMask(u, i);
        const c = r.getPenaltyN1(i) + r.getPenaltyN2(i) + r.getPenaltyN3(i) + r.getPenaltyN4(i);
        r.applyMask(u, i), c < l && (l = c, o = u);
      }
      return o;
    };
  })(Vy)), Vy;
}
var Cm = {}, yk;
function BD() {
  if (yk) return Cm;
  yk = 1;
  const r = hx(), e = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
  ], t = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
  ];
  return Cm.getBlocksCount = function(i, a) {
    switch (a) {
      case r.L:
        return e[(i - 1) * 4 + 0];
      case r.M:
        return e[(i - 1) * 4 + 1];
      case r.Q:
        return e[(i - 1) * 4 + 2];
      case r.H:
        return e[(i - 1) * 4 + 3];
      default:
        return;
    }
  }, Cm.getTotalCodewordsCount = function(i, a) {
    switch (a) {
      case r.L:
        return t[(i - 1) * 4 + 0];
      case r.M:
        return t[(i - 1) * 4 + 1];
      case r.Q:
        return t[(i - 1) * 4 + 2];
      case r.H:
        return t[(i - 1) * 4 + 3];
      default:
        return;
    }
  }, Cm;
}
var $y = {}, tp = {}, Ak;
function cH() {
  if (Ak) return tp;
  Ak = 1;
  const r = new Uint8Array(512), e = new Uint8Array(256);
  return (function() {
    let n = 1;
    for (let i = 0; i < 255; i++)
      r[i] = n, e[n] = i, n <<= 1, n & 256 && (n ^= 285);
    for (let i = 255; i < 512; i++)
      r[i] = r[i - 255];
  })(), tp.log = function(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return e[n];
  }, tp.exp = function(n) {
    return r[n];
  }, tp.mul = function(n, i) {
    return n === 0 || i === 0 ? 0 : r[e[n] + e[i]];
  }, tp;
}
var wk;
function fH() {
  return wk || (wk = 1, (function(r) {
    const e = cH();
    r.mul = function(n, i) {
      const a = new Uint8Array(n.length + i.length - 1);
      for (let s = 0; s < n.length; s++)
        for (let o = 0; o < i.length; o++)
          a[s + o] ^= e.mul(n[s], i[o]);
      return a;
    }, r.mod = function(n, i) {
      let a = new Uint8Array(n);
      for (; a.length - i.length >= 0; ) {
        const s = a[0];
        for (let l = 0; l < i.length; l++)
          a[l] ^= e.mul(i[l], s);
        let o = 0;
        for (; o < a.length && a[o] === 0; ) o++;
        a = a.slice(o);
      }
      return a;
    }, r.generateECPolynomial = function(n) {
      let i = new Uint8Array([1]);
      for (let a = 0; a < n; a++)
        i = r.mul(i, new Uint8Array([1, e.exp(a)]));
      return i;
    };
  })($y)), $y;
}
var zy, xk;
function dH() {
  if (xk) return zy;
  xk = 1;
  const r = fH();
  function e(t) {
    this.genPoly = void 0, this.degree = t, this.degree && this.initialize(this.degree);
  }
  return e.prototype.initialize = function(n) {
    this.degree = n, this.genPoly = r.generateECPolynomial(this.degree);
  }, e.prototype.encode = function(n) {
    if (!this.genPoly)
      throw new Error("Encoder not initialized");
    const i = new Uint8Array(n.length + this.degree);
    i.set(n);
    const a = r.mod(i, this.genPoly), s = this.degree - a.length;
    if (s > 0) {
      const o = new Uint8Array(this.degree);
      return o.set(a, s), o;
    }
    return a;
  }, zy = e, zy;
}
var Gy = {}, Hy = {}, Wy = {}, bk;
function _D() {
  return bk || (bk = 1, Wy.isValid = function(e) {
    return !isNaN(e) && e >= 1 && e <= 40;
  }), Wy;
}
var Cl = {}, Ck;
function MD() {
  if (Ck) return Cl;
  Ck = 1;
  const r = "[0-9]+", e = "[A-Z $%*+\\-./:]+";
  let t = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
  t = t.replace(/u/g, "\\u");
  const n = "(?:(?![A-Z0-9 $%*+\\-./:]|" + t + `)(?:.|[\r
]))+`;
  Cl.KANJI = new RegExp(t, "g"), Cl.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g"), Cl.BYTE = new RegExp(n, "g"), Cl.NUMERIC = new RegExp(r, "g"), Cl.ALPHANUMERIC = new RegExp(e, "g");
  const i = new RegExp("^" + t + "$"), a = new RegExp("^" + r + "$"), s = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
  return Cl.testKanji = function(l) {
    return i.test(l);
  }, Cl.testNumeric = function(l) {
    return a.test(l);
  }, Cl.testAlphanumeric = function(l) {
    return s.test(l);
  }, Cl;
}
var Sk;
function Wf() {
  return Sk || (Sk = 1, (function(r) {
    const e = _D(), t = MD();
    r.NUMERIC = {
      id: "Numeric",
      bit: 1,
      ccBits: [10, 12, 14]
    }, r.ALPHANUMERIC = {
      id: "Alphanumeric",
      bit: 2,
      ccBits: [9, 11, 13]
    }, r.BYTE = {
      id: "Byte",
      bit: 4,
      ccBits: [8, 16, 16]
    }, r.KANJI = {
      id: "Kanji",
      bit: 8,
      ccBits: [8, 10, 12]
    }, r.MIXED = {
      bit: -1
    }, r.getCharCountIndicator = function(a, s) {
      if (!a.ccBits) throw new Error("Invalid mode: " + a);
      if (!e.isValid(s))
        throw new Error("Invalid version: " + s);
      return s >= 1 && s < 10 ? a.ccBits[0] : s < 27 ? a.ccBits[1] : a.ccBits[2];
    }, r.getBestModeForData = function(a) {
      return t.testNumeric(a) ? r.NUMERIC : t.testAlphanumeric(a) ? r.ALPHANUMERIC : t.testKanji(a) ? r.KANJI : r.BYTE;
    }, r.toString = function(a) {
      if (a && a.id) return a.id;
      throw new Error("Invalid mode");
    }, r.isValid = function(a) {
      return a && a.bit && a.ccBits;
    };
    function n(i) {
      if (typeof i != "string")
        throw new Error("Param is not a string");
      switch (i.toLowerCase()) {
        case "numeric":
          return r.NUMERIC;
        case "alphanumeric":
          return r.ALPHANUMERIC;
        case "kanji":
          return r.KANJI;
        case "byte":
          return r.BYTE;
        default:
          throw new Error("Unknown mode: " + i);
      }
    }
    r.from = function(a, s) {
      if (r.isValid(a))
        return a;
      try {
        return n(a);
      } catch {
        return s;
      }
    };
  })(Hy)), Hy;
}
var Ek;
function hH() {
  return Ek || (Ek = 1, (function(r) {
    const e = Hf(), t = BD(), n = hx(), i = Wf(), a = _D(), s = 7973, o = e.getBCHDigit(s);
    function l(f, p, m) {
      for (let A = 1; A <= 40; A++)
        if (p <= r.getCapacity(A, m, f))
          return A;
    }
    function u(f, p) {
      return i.getCharCountIndicator(f, p) + 4;
    }
    function c(f, p) {
      let m = 0;
      return f.forEach(function(A) {
        const w = u(A.mode, p);
        m += w + A.getBitsLength();
      }), m;
    }
    function h(f, p) {
      for (let m = 1; m <= 40; m++)
        if (c(f, m) <= r.getCapacity(m, p, i.MIXED))
          return m;
    }
    r.from = function(p, m) {
      return a.isValid(p) ? parseInt(p, 10) : m;
    }, r.getCapacity = function(p, m, A) {
      if (!a.isValid(p))
        throw new Error("Invalid QR Code version");
      typeof A > "u" && (A = i.BYTE);
      const w = e.getSymbolTotalCodewords(p), x = t.getTotalCodewordsCount(p, m), E = (w - x) * 8;
      if (A === i.MIXED) return E;
      const T = E - u(A, p);
      switch (A) {
        case i.NUMERIC:
          return Math.floor(T / 10 * 3);
        case i.ALPHANUMERIC:
          return Math.floor(T / 11 * 2);
        case i.KANJI:
          return Math.floor(T / 13);
        case i.BYTE:
        default:
          return Math.floor(T / 8);
      }
    }, r.getBestVersionForData = function(p, m) {
      let A;
      const w = n.from(m, n.M);
      if (Array.isArray(p)) {
        if (p.length > 1)
          return h(p, w);
        if (p.length === 0)
          return 1;
        A = p[0];
      } else
        A = p;
      return l(A.mode, A.getLength(), w);
    }, r.getEncodedBits = function(p) {
      if (!a.isValid(p) || p < 7)
        throw new Error("Invalid QR Code version");
      let m = p << 12;
      for (; e.getBCHDigit(m) - o >= 0; )
        m ^= s << e.getBCHDigit(m) - o;
      return p << 12 | m;
    };
  })(Gy)), Gy;
}
var jy = {}, kk;
function pH() {
  if (kk) return jy;
  kk = 1;
  const r = Hf(), e = 1335, t = 21522, n = r.getBCHDigit(e);
  return jy.getEncodedBits = function(a, s) {
    const o = a.bit << 3 | s;
    let l = o << 10;
    for (; r.getBCHDigit(l) - n >= 0; )
      l ^= e << r.getBCHDigit(l) - n;
    return (o << 10 | l) ^ t;
  }, jy;
}
var qy = {}, Qy, Tk;
function gH() {
  if (Tk) return Qy;
  Tk = 1;
  const r = Wf();
  function e(t) {
    this.mode = r.NUMERIC, this.data = t.toString();
  }
  return e.getBitsLength = function(n) {
    return 10 * Math.floor(n / 3) + (n % 3 ? n % 3 * 3 + 1 : 0);
  }, e.prototype.getLength = function() {
    return this.data.length;
  }, e.prototype.getBitsLength = function() {
    return e.getBitsLength(this.data.length);
  }, e.prototype.write = function(n) {
    let i, a, s;
    for (i = 0; i + 3 <= this.data.length; i += 3)
      a = this.data.substr(i, 3), s = parseInt(a, 10), n.put(s, 10);
    const o = this.data.length - i;
    o > 0 && (a = this.data.substr(i), s = parseInt(a, 10), n.put(s, o * 3 + 1));
  }, Qy = e, Qy;
}
var Yy, Fk;
function mH() {
  if (Fk) return Yy;
  Fk = 1;
  const r = Wf(), e = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
  ];
  function t(n) {
    this.mode = r.ALPHANUMERIC, this.data = n;
  }
  return t.getBitsLength = function(i) {
    return 11 * Math.floor(i / 2) + 6 * (i % 2);
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(i) {
    let a;
    for (a = 0; a + 2 <= this.data.length; a += 2) {
      let s = e.indexOf(this.data[a]) * 45;
      s += e.indexOf(this.data[a + 1]), i.put(s, 11);
    }
    this.data.length % 2 && i.put(e.indexOf(this.data[a]), 6);
  }, Yy = t, Yy;
}
var Xy, Ik;
function vH() {
  if (Ik) return Xy;
  Ik = 1;
  const r = Wf();
  function e(t) {
    this.mode = r.BYTE, typeof t == "string" ? this.data = new TextEncoder().encode(t) : this.data = new Uint8Array(t);
  }
  return e.getBitsLength = function(n) {
    return n * 8;
  }, e.prototype.getLength = function() {
    return this.data.length;
  }, e.prototype.getBitsLength = function() {
    return e.getBitsLength(this.data.length);
  }, e.prototype.write = function(t) {
    for (let n = 0, i = this.data.length; n < i; n++)
      t.put(this.data[n], 8);
  }, Xy = e, Xy;
}
var Jy, Pk;
function yH() {
  if (Pk) return Jy;
  Pk = 1;
  const r = Wf(), e = Hf();
  function t(n) {
    this.mode = r.KANJI, this.data = n;
  }
  return t.getBitsLength = function(i) {
    return i * 13;
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(n) {
    let i;
    for (i = 0; i < this.data.length; i++) {
      let a = e.toSJIS(this.data[i]);
      if (a >= 33088 && a <= 40956)
        a -= 33088;
      else if (a >= 57408 && a <= 60351)
        a -= 49472;
      else
        throw new Error(
          "Invalid SJIS character: " + this.data[i] + `
Make sure your charset is UTF-8`
        );
      a = (a >>> 8 & 255) * 192 + (a & 255), n.put(a, 13);
    }
  }, Jy = t, Jy;
}
var Ky = { exports: {} }, Dk;
function AH() {
  return Dk || (Dk = 1, (function(r) {
    var e = {
      single_source_shortest_paths: function(t, n, i) {
        var a = {}, s = {};
        s[n] = 0;
        var o = e.PriorityQueue.make();
        o.push(n, 0);
        for (var l, u, c, h, f, p, m, A, w; !o.empty(); ) {
          l = o.pop(), u = l.value, h = l.cost, f = t[u] || {};
          for (c in f)
            f.hasOwnProperty(c) && (p = f[c], m = h + p, A = s[c], w = typeof s[c] > "u", (w || A > m) && (s[c] = m, o.push(c, m), a[c] = u));
        }
        if (typeof i < "u" && typeof s[i] > "u") {
          var x = ["Could not find a path from ", n, " to ", i, "."].join("");
          throw new Error(x);
        }
        return a;
      },
      extract_shortest_path_from_predecessor_list: function(t, n) {
        for (var i = [], a = n; a; )
          i.push(a), t[a], a = t[a];
        return i.reverse(), i;
      },
      find_path: function(t, n, i) {
        var a = e.single_source_shortest_paths(t, n, i);
        return e.extract_shortest_path_from_predecessor_list(
          a,
          i
        );
      },
      /**
       * A very naive priority queue implementation.
       */
      PriorityQueue: {
        make: function(t) {
          var n = e.PriorityQueue, i = {}, a;
          t = t || {};
          for (a in n)
            n.hasOwnProperty(a) && (i[a] = n[a]);
          return i.queue = [], i.sorter = t.sorter || n.default_sorter, i;
        },
        default_sorter: function(t, n) {
          return t.cost - n.cost;
        },
        /**
         * Add a new item to the queue and ensure the highest priority element
         * is at the front of the queue.
         */
        push: function(t, n) {
          var i = { value: t, cost: n };
          this.queue.push(i), this.queue.sort(this.sorter);
        },
        /**
         * Return the highest priority element in the queue.
         */
        pop: function() {
          return this.queue.shift();
        },
        empty: function() {
          return this.queue.length === 0;
        }
      }
    };
    r.exports = e;
  })(Ky)), Ky.exports;
}
var Rk;
function wH() {
  return Rk || (Rk = 1, (function(r) {
    const e = Wf(), t = gH(), n = mH(), i = vH(), a = yH(), s = MD(), o = Hf(), l = AH();
    function u(x) {
      return unescape(encodeURIComponent(x)).length;
    }
    function c(x, E, T) {
      const D = [];
      let F;
      for (; (F = x.exec(T)) !== null; )
        D.push({
          data: F[0],
          index: F.index,
          mode: E,
          length: F[0].length
        });
      return D;
    }
    function h(x) {
      const E = c(s.NUMERIC, e.NUMERIC, x), T = c(s.ALPHANUMERIC, e.ALPHANUMERIC, x);
      let D, F;
      return o.isKanjiModeEnabled() ? (D = c(s.BYTE, e.BYTE, x), F = c(s.KANJI, e.KANJI, x)) : (D = c(s.BYTE_KANJI, e.BYTE, x), F = []), E.concat(T, D, F).sort(function(L, Z) {
        return L.index - Z.index;
      }).map(function(L) {
        return {
          data: L.data,
          mode: L.mode,
          length: L.length
        };
      });
    }
    function f(x, E) {
      switch (E) {
        case e.NUMERIC:
          return t.getBitsLength(x);
        case e.ALPHANUMERIC:
          return n.getBitsLength(x);
        case e.KANJI:
          return a.getBitsLength(x);
        case e.BYTE:
          return i.getBitsLength(x);
      }
    }
    function p(x) {
      return x.reduce(function(E, T) {
        const D = E.length - 1 >= 0 ? E[E.length - 1] : null;
        return D && D.mode === T.mode ? (E[E.length - 1].data += T.data, E) : (E.push(T), E);
      }, []);
    }
    function m(x) {
      const E = [];
      for (let T = 0; T < x.length; T++) {
        const D = x[T];
        switch (D.mode) {
          case e.NUMERIC:
            E.push([
              D,
              { data: D.data, mode: e.ALPHANUMERIC, length: D.length },
              { data: D.data, mode: e.BYTE, length: D.length }
            ]);
            break;
          case e.ALPHANUMERIC:
            E.push([
              D,
              { data: D.data, mode: e.BYTE, length: D.length }
            ]);
            break;
          case e.KANJI:
            E.push([
              D,
              { data: D.data, mode: e.BYTE, length: u(D.data) }
            ]);
            break;
          case e.BYTE:
            E.push([
              { data: D.data, mode: e.BYTE, length: u(D.data) }
            ]);
        }
      }
      return E;
    }
    function A(x, E) {
      const T = {}, D = { start: {} };
      let F = ["start"];
      for (let _ = 0; _ < x.length; _++) {
        const L = x[_], Z = [];
        for (let te = 0; te < L.length; te++) {
          const de = L[te], H = "" + _ + te;
          Z.push(H), T[H] = { node: de, lastCount: 0 }, D[H] = {};
          for (let j = 0; j < F.length; j++) {
            const q = F[j];
            T[q] && T[q].node.mode === de.mode ? (D[q][H] = f(T[q].lastCount + de.length, de.mode) - f(T[q].lastCount, de.mode), T[q].lastCount += de.length) : (T[q] && (T[q].lastCount = de.length), D[q][H] = f(de.length, de.mode) + 4 + e.getCharCountIndicator(de.mode, E));
          }
        }
        F = Z;
      }
      for (let _ = 0; _ < F.length; _++)
        D[F[_]].end = 0;
      return { map: D, table: T };
    }
    function w(x, E) {
      let T;
      const D = e.getBestModeForData(x);
      if (T = e.from(E, D), T !== e.BYTE && T.bit < D.bit)
        throw new Error('"' + x + '" cannot be encoded with mode ' + e.toString(T) + `.
 Suggested mode is: ` + e.toString(D));
      switch (T === e.KANJI && !o.isKanjiModeEnabled() && (T = e.BYTE), T) {
        case e.NUMERIC:
          return new t(x);
        case e.ALPHANUMERIC:
          return new n(x);
        case e.KANJI:
          return new a(x);
        case e.BYTE:
          return new i(x);
      }
    }
    r.fromArray = function(E) {
      return E.reduce(function(T, D) {
        return typeof D == "string" ? T.push(w(D, null)) : D.data && T.push(w(D.data, D.mode)), T;
      }, []);
    }, r.fromString = function(E, T) {
      const D = h(E, o.isKanjiModeEnabled()), F = m(D), _ = A(F, T), L = l.find_path(_.map, "start", "end"), Z = [];
      for (let te = 1; te < L.length - 1; te++)
        Z.push(_.table[L[te]].node);
      return r.fromArray(p(Z));
    }, r.rawSplit = function(E) {
      return r.fromArray(
        h(E, o.isKanjiModeEnabled())
      );
    };
  })(qy)), qy;
}
var Ok;
function xH() {
  if (Ok) return By;
  Ok = 1;
  const r = Hf(), e = hx(), t = aH(), n = sH(), i = oH(), a = lH(), s = uH(), o = BD(), l = dH(), u = hH(), c = pH(), h = Wf(), f = wH();
  function p(_, L) {
    const Z = _.size, te = a.getPositions(L);
    for (let de = 0; de < te.length; de++) {
      const H = te[de][0], j = te[de][1];
      for (let q = -1; q <= 7; q++)
        if (!(H + q <= -1 || Z <= H + q))
          for (let re = -1; re <= 7; re++)
            j + re <= -1 || Z <= j + re || (q >= 0 && q <= 6 && (re === 0 || re === 6) || re >= 0 && re <= 6 && (q === 0 || q === 6) || q >= 2 && q <= 4 && re >= 2 && re <= 4 ? _.set(H + q, j + re, !0, !0) : _.set(H + q, j + re, !1, !0));
    }
  }
  function m(_) {
    const L = _.size;
    for (let Z = 8; Z < L - 8; Z++) {
      const te = Z % 2 === 0;
      _.set(Z, 6, te, !0), _.set(6, Z, te, !0);
    }
  }
  function A(_, L) {
    const Z = i.getPositions(L);
    for (let te = 0; te < Z.length; te++) {
      const de = Z[te][0], H = Z[te][1];
      for (let j = -2; j <= 2; j++)
        for (let q = -2; q <= 2; q++)
          j === -2 || j === 2 || q === -2 || q === 2 || j === 0 && q === 0 ? _.set(de + j, H + q, !0, !0) : _.set(de + j, H + q, !1, !0);
    }
  }
  function w(_, L) {
    const Z = _.size, te = u.getEncodedBits(L);
    let de, H, j;
    for (let q = 0; q < 18; q++)
      de = Math.floor(q / 3), H = q % 3 + Z - 8 - 3, j = (te >> q & 1) === 1, _.set(de, H, j, !0), _.set(H, de, j, !0);
  }
  function x(_, L, Z) {
    const te = _.size, de = c.getEncodedBits(L, Z);
    let H, j;
    for (H = 0; H < 15; H++)
      j = (de >> H & 1) === 1, H < 6 ? _.set(H, 8, j, !0) : H < 8 ? _.set(H + 1, 8, j, !0) : _.set(te - 15 + H, 8, j, !0), H < 8 ? _.set(8, te - H - 1, j, !0) : H < 9 ? _.set(8, 15 - H - 1 + 1, j, !0) : _.set(8, 15 - H - 1, j, !0);
    _.set(te - 8, 8, 1, !0);
  }
  function E(_, L) {
    const Z = _.size;
    let te = -1, de = Z - 1, H = 7, j = 0;
    for (let q = Z - 1; q > 0; q -= 2)
      for (q === 6 && q--; ; ) {
        for (let re = 0; re < 2; re++)
          if (!_.isReserved(de, q - re)) {
            let ae = !1;
            j < L.length && (ae = (L[j] >>> H & 1) === 1), _.set(de, q - re, ae), H--, H === -1 && (j++, H = 7);
          }
        if (de += te, de < 0 || Z <= de) {
          de -= te, te = -te;
          break;
        }
      }
  }
  function T(_, L, Z) {
    const te = new t();
    Z.forEach(function(re) {
      te.put(re.mode.bit, 4), te.put(re.getLength(), h.getCharCountIndicator(re.mode, _)), re.write(te);
    });
    const de = r.getSymbolTotalCodewords(_), H = o.getTotalCodewordsCount(_, L), j = (de - H) * 8;
    for (te.getLengthInBits() + 4 <= j && te.put(0, 4); te.getLengthInBits() % 8 !== 0; )
      te.putBit(0);
    const q = (j - te.getLengthInBits()) / 8;
    for (let re = 0; re < q; re++)
      te.put(re % 2 ? 17 : 236, 8);
    return D(te, _, L);
  }
  function D(_, L, Z) {
    const te = r.getSymbolTotalCodewords(L), de = o.getTotalCodewordsCount(L, Z), H = te - de, j = o.getBlocksCount(L, Z), q = te % j, re = j - q, ae = Math.floor(te / j), ye = Math.floor(H / j), Se = ye + 1, Xe = ae - ye, Ve = new l(Xe);
    let He = 0;
    const le = new Array(j), ve = new Array(j);
    let it = 0;
    const mt = new Uint8Array(_.buffer);
    for (let rt = 0; rt < j; rt++) {
      const Rt = rt < re ? ye : Se;
      le[rt] = mt.slice(He, He + Rt), ve[rt] = Ve.encode(le[rt]), He += Rt, it = Math.max(it, Rt);
    }
    const qe = new Uint8Array(te);
    let at = 0, st, lt;
    for (st = 0; st < it; st++)
      for (lt = 0; lt < j; lt++)
        st < le[lt].length && (qe[at++] = le[lt][st]);
    for (st = 0; st < Xe; st++)
      for (lt = 0; lt < j; lt++)
        qe[at++] = ve[lt][st];
    return qe;
  }
  function F(_, L, Z, te) {
    let de;
    if (Array.isArray(_))
      de = f.fromArray(_);
    else if (typeof _ == "string") {
      let ae = L;
      if (!ae) {
        const ye = f.rawSplit(_);
        ae = u.getBestVersionForData(ye, Z);
      }
      de = f.fromString(_, ae || 40);
    } else
      throw new Error("Invalid data");
    const H = u.getBestVersionForData(de, Z);
    if (!H)
      throw new Error("The amount of data is too big to be stored in a QR Code");
    if (!L)
      L = H;
    else if (L < H)
      throw new Error(
        `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + H + `.
`
      );
    const j = T(L, Z, de), q = r.getSymbolSize(L), re = new n(q);
    return p(re, L), m(re), A(re, L), x(re, Z, 0), L >= 7 && w(re, L), E(re, j), isNaN(te) && (te = s.getBestMask(
      re,
      x.bind(null, re, Z)
    )), s.applyMask(te, re), x(re, Z, te), {
      modules: re,
      version: L,
      errorCorrectionLevel: Z,
      maskPattern: te,
      segments: de
    };
  }
  return By.create = function(L, Z) {
    if (typeof L > "u" || L === "")
      throw new Error("No input text");
    let te = e.M, de, H;
    return typeof Z < "u" && (te = e.from(Z.errorCorrectionLevel, e.M), de = u.from(Z.version), H = s.from(Z.maskPattern), Z.toSJISFunc && r.setToSJISFunction(Z.toSJISFunc)), F(L, de, te, H);
  }, By;
}
var Zy = {}, eA = {}, Bk;
function ND() {
  return Bk || (Bk = 1, (function(r) {
    function e(t) {
      if (typeof t == "number" && (t = t.toString()), typeof t != "string")
        throw new Error("Color should be defined as hex string");
      let n = t.slice().replace("#", "").split("");
      if (n.length < 3 || n.length === 5 || n.length > 8)
        throw new Error("Invalid hex color: " + t);
      (n.length === 3 || n.length === 4) && (n = Array.prototype.concat.apply([], n.map(function(a) {
        return [a, a];
      }))), n.length === 6 && n.push("F", "F");
      const i = parseInt(n.join(""), 16);
      return {
        r: i >> 24 & 255,
        g: i >> 16 & 255,
        b: i >> 8 & 255,
        a: i & 255,
        hex: "#" + n.slice(0, 6).join("")
      };
    }
    r.getOptions = function(n) {
      n || (n = {}), n.color || (n.color = {});
      const i = typeof n.margin > "u" || n.margin === null || n.margin < 0 ? 4 : n.margin, a = n.width && n.width >= 21 ? n.width : void 0, s = n.scale || 4;
      return {
        width: a,
        scale: a ? 4 : s,
        margin: i,
        color: {
          dark: e(n.color.dark || "#000000ff"),
          light: e(n.color.light || "#ffffffff")
        },
        type: n.type,
        rendererOpts: n.rendererOpts || {}
      };
    }, r.getScale = function(n, i) {
      return i.width && i.width >= n + i.margin * 2 ? i.width / (n + i.margin * 2) : i.scale;
    }, r.getImageWidth = function(n, i) {
      const a = r.getScale(n, i);
      return Math.floor((n + i.margin * 2) * a);
    }, r.qrToImageData = function(n, i, a) {
      const s = i.modules.size, o = i.modules.data, l = r.getScale(s, a), u = Math.floor((s + a.margin * 2) * l), c = a.margin * l, h = [a.color.light, a.color.dark];
      for (let f = 0; f < u; f++)
        for (let p = 0; p < u; p++) {
          let m = (f * u + p) * 4, A = a.color.light;
          if (f >= c && p >= c && f < u - c && p < u - c) {
            const w = Math.floor((f - c) / l), x = Math.floor((p - c) / l);
            A = h[o[w * s + x] ? 1 : 0];
          }
          n[m++] = A.r, n[m++] = A.g, n[m++] = A.b, n[m] = A.a;
        }
    };
  })(eA)), eA;
}
var _k;
function bH() {
  return _k || (_k = 1, (function(r) {
    const e = ND();
    function t(i, a, s) {
      i.clearRect(0, 0, a.width, a.height), a.style || (a.style = {}), a.height = s, a.width = s, a.style.height = s + "px", a.style.width = s + "px";
    }
    function n() {
      try {
        return document.createElement("canvas");
      } catch {
        throw new Error("You need to specify a canvas element");
      }
    }
    r.render = function(a, s, o) {
      let l = o, u = s;
      typeof l > "u" && (!s || !s.getContext) && (l = s, s = void 0), s || (u = n()), l = e.getOptions(l);
      const c = e.getImageWidth(a.modules.size, l), h = u.getContext("2d"), f = h.createImageData(c, c);
      return e.qrToImageData(f.data, a, l), t(h, u, c), h.putImageData(f, 0, 0), u;
    }, r.renderToDataURL = function(a, s, o) {
      let l = o;
      typeof l > "u" && (!s || !s.getContext) && (l = s, s = void 0), l || (l = {});
      const u = r.render(a, s, l), c = l.type || "image/png", h = l.rendererOpts || {};
      return u.toDataURL(c, h.quality);
    };
  })(Zy)), Zy;
}
var tA = {}, Mk;
function CH() {
  if (Mk) return tA;
  Mk = 1;
  const r = ND();
  function e(i, a) {
    const s = i.a / 255, o = a + '="' + i.hex + '"';
    return s < 1 ? o + " " + a + '-opacity="' + s.toFixed(2).slice(1) + '"' : o;
  }
  function t(i, a, s) {
    let o = i + a;
    return typeof s < "u" && (o += " " + s), o;
  }
  function n(i, a, s) {
    let o = "", l = 0, u = !1, c = 0;
    for (let h = 0; h < i.length; h++) {
      const f = Math.floor(h % a), p = Math.floor(h / a);
      !f && !u && (u = !0), i[h] ? (c++, h > 0 && f > 0 && i[h - 1] || (o += u ? t("M", f + s, 0.5 + p + s) : t("m", l, 0), l = 0, u = !1), f + 1 < a && i[h + 1] || (o += t("h", c), c = 0)) : l++;
    }
    return o;
  }
  return tA.render = function(a, s, o) {
    const l = r.getOptions(s), u = a.modules.size, c = a.modules.data, h = u + l.margin * 2, f = l.color.light.a ? "<path " + e(l.color.light, "fill") + ' d="M0 0h' + h + "v" + h + 'H0z"/>' : "", p = "<path " + e(l.color.dark, "stroke") + ' d="' + n(c, u, l.margin) + '"/>', m = 'viewBox="0 0 ' + h + " " + h + '"', w = '<svg xmlns="http://www.w3.org/2000/svg" ' + (l.width ? 'width="' + l.width + '" height="' + l.width + '" ' : "") + m + ' shape-rendering="crispEdges">' + f + p + `</svg>
`;
    return typeof o == "function" && o(null, w), w;
  }, tA;
}
var Nk;
function SH() {
  if (Nk) return vd;
  Nk = 1;
  const r = iH(), e = xH(), t = bH(), n = CH();
  function i(a, s, o, l, u) {
    const c = [].slice.call(arguments, 1), h = c.length, f = typeof c[h - 1] == "function";
    if (!f && !r())
      throw new Error("Callback required as last argument");
    if (f) {
      if (h < 2)
        throw new Error("Too few arguments provided");
      h === 2 ? (u = o, o = s, s = l = void 0) : h === 3 && (s.getContext && typeof u > "u" ? (u = l, l = void 0) : (u = l, l = o, o = s, s = void 0));
    } else {
      if (h < 1)
        throw new Error("Too few arguments provided");
      return h === 1 ? (o = s, s = l = void 0) : h === 2 && !s.getContext && (l = o, o = s, s = void 0), new Promise(function(p, m) {
        try {
          const A = e.create(o, l);
          p(a(A, s, l));
        } catch (A) {
          m(A);
        }
      });
    }
    try {
      const p = e.create(o, l);
      u(null, a(p, s, l));
    } catch (p) {
      u(p);
    }
  }
  return vd.create = e.create, vd.toCanvas = i.bind(null, t.render), vd.toDataURL = i.bind(null, t.renderToDataURL), vd.toString = i.bind(null, function(a, s, o) {
    return n.render(a, o);
  }), vd;
}
var LD = SH();
const EH = async (r) => {
  const e = `${Cc.getServicesApiUrl()}/shortener`;
  try {
    return (await (await Ll(e, {
      method: "POST",
      body: JSON.stringify({ longUrl: r }),
      headers: {
        "Content-Type": "application/json"
      }
    })).json()).shortUrl;
  } catch (t) {
    throw console.error(t), new rh("Failed to shorten URL, see console.");
  }
};
class UD {
  async poll() {
    try {
      if (await this.predicate()) {
        this.onSuccess(), this.pollingId > -1 && window.clearInterval(this.pollingId);
        return;
      }
    } catch {
    }
    this.attempts += 1, this.attempts < this.maxAttempts ? this.pollingId = window.setTimeout(this.poll.bind(this), this.interval) : this.onFailure();
  }
  /**
   * Constructs a new polling service.
   * @param predicate An async function that returns true when polling has returned a successful result.
   * @param onSuccess The callback to be called when polling has returned a successful result.
   * @param onFailure The callback to be called when polling has returned a failed result.
   * @param interval The number of milliseconds to wait between each poll.
   * @param maxAttempts The maximum amount of times to check the condition.
   */
  constructor(e, t, n, i = 3e3, a = 10) {
    this.onSuccess = t, this.onFailure = n, this.predicate = e, this.attempts = 0, this.pollingId = -1, this.interval = i, this.maxAttempts = a, this.poll();
  }
}
class kH {
  async init(e, t, n) {
    return n && await this.reload(e, t, n), null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), l = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName).map((u) => ({
      id: u.id,
      region: u.stepRegion,
      regionIndex: u.stepRegionIndex
    }));
    await t.setSelectionsAndElements(e.stepName, [], l, async () => {
      const u = i?.storage?.videoShortUrl, c = i?.storage?.videoUrl;
      t.updateStorage(e.stepName, {
        videoShortUrl: u,
        videoUrl: c
      });
    });
  }
  async regenerateQRCode(e, t, n, i) {
    const a = async () => {
      const c = (await h0([t]))[0], h = c?.versions?.find((f) => f.name === "mpeg4")?.link;
      return { asset: c, link: h };
    }, s = await new Promise((c, h) => {
      new UD(
        async () => !!(await a()).link,
        async () => {
          const f = await a();
          if (!f.link || !f.link)
            throw new th(f.asset);
          c({
            rel: "mpeg4",
            href: f.link
          });
        },
        () => {
          h("Poller timed out with 40 attempts @ 3 second interval");
        },
        3e3,
        40
      );
    });
    e.forEach((c) => n.getCommandDispatcher()(new Lf(c.id)));
    let o;
    if (!i.data.baseUrl || i.data.baseUrl.trim() === "")
      o = s.href;
    else {
      const c = i.data.baseUrl.slice(0, 4) === "http" ? "" : "https://", h = new URL(c + i.data.baseUrl);
      h.searchParams.append("video", btoa(JSON.stringify([s]))), h.pathname = h.pathname + (h.pathname.slice(-1) === "/" ? "" : "/");
      const f = h.toString();
      if (f.length >= 2e3)
        throw new rh("Cannot create QR code, URL too long.");
      o = await EH(f);
    }
    if (!i.data || !i.data.regions)
      throw new Cu(i, "Missing regions.");
    const l = await this.regionElements(i), u = await this.command(o, l, n, i.stepName);
    return u && (u.command && n.getCommandDispatcher()(u.command), u.followup && await u.followup()), await n.setSelectionsAndElements(i.stepName, [], l, async () => {
      n.updateStorage(i.stepName, {
        videoShortUrl: o,
        videoUrl: s.href
      });
    }), o;
  }
  async regionElements(e) {
    const t = (n, i) => ({ id: nn(), region: n, regionIndex: i });
    return e.data.regions.map(t);
  }
  async command(e, t, n, i) {
    const a = n.getLayouts(), o = `data:image/svg+xml;base64,${btoa(await LD.toString(e, { type: "svg" }))}`, l = t.map((u) => {
      const c = u.region, h = a.find((f) => f.panelId === c?.panelId);
      if (!h && c)
        throw new La(c);
      if (h && !c)
        throw new Error("Region not found");
      if (!h || !c)
        throw new Error("Neither a region or layout found!");
      return new pa(
        {
          stepRegion: c,
          stepRegionIndex: u.regionIndex,
          stepName: i,
          id: u.id,
          src: o,
          type: Mr.Image,
          y: c.top,
          x: c.left,
          width: c.width,
          height: c.height,
          rotation: 0
        },
        h
      );
    });
    return { command: new Ii(l), followup: async () => {
    } };
  }
}
const VD = new kH();
function W1(r) {
  const e = r.versions?.find((n) => n.name === "svg");
  if (e?.link)
    return e.link;
  const t = r.fileLink;
  if (t)
    return t;
  throw new th(r);
}
class TH {
  constructor() {
    this.frameSourceSvg = async (e, t) => {
      if (!e)
        return z1(t);
      const n = e.asset;
      if (!n)
        throw new _f(e);
      const i = n.fileLink;
      if (i)
        return xo(i, !0);
      throw new th(n);
    };
  }
  async init(e, t, n) {
    const i = n?.serializableWorkflow.steps.find(
      (l) => l.stepName === e.stepName
    );
    if (i?.storage && Object.keys(i.storage).length !== 0 || i?.selectedVariants && i.selectedVariants.length !== 0)
      return await this.reload(e, t, n), null;
    e.mandatory && t.setMandatoryFulfilled(e.stepName, !1), t.markStepsAsInitialised([e.stepName]);
    let a;
    const s = t.getWorkflowExperience().getBundle();
    if (s && e.globalPropertyAspectConfigurations) {
      const l = s.getGlobalPropertyStateManager(), u = e.globalPropertyAspectConfigurations[0];
      if (u) {
        const c = l.getAspectStorage(
          u.aspectName
        );
        c && c.originalAssetKey && (a = (await Si.getLocalOrFromServer(c.originalAssetKey)).fileLink);
      }
    }
    const o = await Pt.getOptionForStep(e);
    if (o) {
      const l = await Pt.getDefaultVariant(o, e.overrideDefaultVariantId);
      if (l)
        return this.selectVariantCommand(
          e,
          l,
          [],
          t,
          void 0,
          a || e.data.placeholderImageUrl
        );
      if (o.variants && o.variants?.length !== 0) return null;
    }
    return this.selectVariantCommand(
      e,
      void 0,
      [],
      t,
      void 0,
      a || e.data.placeholderImageUrl
    );
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), l = Object.values(n.layouts).map((c) => c.elements).flat().filter((c) => c.stepName === e.stepName).map((c) => ({
      id: c.id,
      region: c.stepRegion,
      regionIndex: c.stepRegionIndex
    })), u = await Pt.getOptionForStep(e);
    if (!u || (u.variants || []).length === 0) {
      const c = e.data.regions.map((h) => z1(h));
      t.updateStorage(e.stepName, {
        currentFrameSources: c
      });
    }
    if (i) {
      const c = async () => {
        const h = i.storage?.colors, f = i.storage?.framePatternSrc, p = i.storage?.frameOffsetsList;
        if (t.updateMetadata(e.stepName, {
          frameOffsetsList: p,
          framePatternSrc: f
        }), f) {
          const m = t.getWorkflowExperience().getStepById(e.stepName)?.frameService;
          if (!m) throw new Error("Frame service unavailable, cannot load pattern!");
          await this.loadPatternFromString(f, m, !0, h), t.updateMetadata(e.stepName, { image: f }), t.updateStorage(e.stepName, {
            framePatternSrc: f
          }), this.validateColorCount(e, t);
        }
        if (p?.some((m) => m.zoom)) {
          const m = t.getWorkflowExperience().getStepById(e.stepName)?.frameService;
          if (!m) throw new Error("Frame service unavailable, cannot load pattern!");
          m.updateOffsets(p);
        }
        t.setMandatoryFulfilled(e.stepName, !0);
      };
      if (i.selectedVariants && i.selectedVariants.length > 0) {
        const h = i.selectedVariants[0].id;
        if (u && h) {
          const f = u.variants?.find((p) => p.id === h);
          f && await t.setSelectionsAndElements(
            e.stepName,
            [f],
            l,
            async () => {
              const p = await Promise.all(
                e.data.regions.map((m) => this.frameSourceSvg(f, m))
              );
              t.updateStorage(e.stepName, { currentFrameSources: p }), await c();
            }
          );
        }
      } else
        await t.setSelectionsAndElements(e.stepName, [], l, c);
    }
  }
  async availableColors(e, t) {
    return (await Pt.ensureFullOption(e.data.colorOption))?.variants?.map((i) => ({
      fill: i.color,
      stroke: i.color,
      variant: i,
      pmsValue: i.name
    })) ?? [];
  }
  selectImage(e, t, n, i = !0) {
    const a = W1(t), s = n.getStepStorage(e.stepName)?.framePatternSrc;
    if (s && s === a)
      return Promise.resolve();
    n.setEditedStatus(e.stepName, !0);
    const o = t.fileLink || "", l = Dc(o);
    return l === "pdf" || l === "eps" || l === "ai" ? new Promise((u) => {
      n.addPoller(
        new UD(
          async () => {
            const h = (await Si.getFromServer(t.key || "")).versions?.find((p) => p.name === "svg");
            return h ? (await Ll(h.link)).status === 200 : !1;
          },
          () => {
            Si.getLocalOrFromServer(t.key || "").then((c) => {
              this.loadPatternFromAsset(c, e, n, i).then(
                u
              );
            });
          },
          () => {
            throw new rh("Failed to resolve transcoded PDF");
          }
        )
      );
    }) : this.loadPatternFromAsset(t, e, n, i);
  }
  async selectVariant(e, t, n, i, a) {
    const s = await this.selectVariantCommand(
      e,
      t,
      n,
      i,
      a
    );
    s && (s.command && i.getCommandDispatcher()(s.command), s.followup && await s.followup());
  }
  getCreateElementCommand(e, t, n, i, a) {
    return new pa(
      {
        id: e,
        type: Mr.Frame,
        x: t.left,
        y: t.top,
        width: t.width,
        height: t.height,
        layer: t.layer,
        layerIndex: t.layerIndex,
        rotation: t.rotation,
        scaleX: t.width / a.frameData.width,
        scaleY: t.height / a.frameData.height,
        path: a.frameData.path,
        dataWidth: a.frameData.width,
        dataHeight: a.frameData.height,
        stepRegion: t,
        stepRegionIndex: n,
        stepName: a.stepName,
        disablePlaceholder: a.disablePlaceholder,
        pattern: a.pattern,
        immutable: t.immutable
      },
      i
    );
  }
  async loadPatternFromString(e, t, n = !0, i = void 0, a) {
    if (Dc(e) === "svg") {
      const l = await dx(e), u = l.width, c = l.height, h = await xo(e);
      if (a) {
        const m = h.match(/<(image|linearGradient|radialGradient)(\s|>|\/>)/gim);
        if (m && m.length > 0)
          throw new Error(
            "Vector files may not include images or gradients when a color limit is specified."
          );
      }
      const f = await Nl(h), p = {
        src: e,
        width: u,
        height: c,
        aspect: u / c,
        svg: f.svg,
        colors: i ?? f.colors
      };
      gc.set(e, p), t.setPatternData(p, n);
    } else {
      const l = await $0(e, !0), u = await G0(l), c = {
        src: e,
        width: u.width,
        height: u.height,
        aspect: u.width / u.height,
        svg: void 0,
        colors: void 0
      };
      gc.set(e, c), t.setPatternData(c, n);
    }
  }
  async changeColors(e, t, n) {
    const i = t.getWorkflowExperience().getStepById(e.stepName)?.frameService;
    if (!i || !i.getImageData()?.svg) {
      console.warn("changeColors was called without an SVG being assigned to a frame step");
      return;
    }
    const a = await this.calculateColorMetadata(i, e, n);
    t.updateMetadata(e.stepName, { colors: a.metadataColors }), t.updateStorage(e.stepName, {
      colors: a.storageColors
    }), i.setPatternData(
      {
        ...i.getImageData(),
        colors: a.newColors
      },
      !1
    ), this.validateColorCount(e, t);
  }
  getUniqueColorCount(e, t) {
    const n = t.getWorkflowExperience().getStepById(e.stepName)?.frameService;
    if (!n) return 0;
    const i = n.getImageData()?.colors ?? {}, a = [];
    for (const s in i) {
      const o = i[s];
      if (o.pmsValue) {
        const l = o.pmsValue.trim().toLocaleLowerCase();
        a.includes(l) || a.push(l);
      } else if (o.browserValue) {
        const l = Y8(o.browserValue);
        a.includes(l) || a.push(l);
      }
    }
    return a.length;
  }
  async calculateColorMetadata(e, t, n) {
    if (!e.getImageData()?.svg)
      return {
        newColors: void 0,
        metadataColors: void 0,
        storageColors: void 0
      };
    const i = { ...e.getImageData().colors ?? {} }, a = {};
    Object.entries(i).forEach(([l, u]) => {
      const c = { browserValue: u.browserValue };
      a[l] = c;
    });
    for (const [l, u] of n.entries())
      i[l] = { browserValue: u.browserValue, pmsValue: u.pmsValue }, a[l] = u;
    let s = Array.from(Object.values(i)).map((l) => l.browserValue);
    const o = await Pt.ensureFullOption(t.data.colorOption);
    return o && o.variants?.forEach((l) => {
      s = s.map((u) => u.toLowerCase() === l.color?.toLowerCase() ? l.name : u);
    }), {
      newColors: i,
      metadataColors: s,
      storageColors: a
    };
  }
  validateColorCount(e, t) {
    const n = e.data.colorPickerEnabled ? e.data.maxColors ?? 0 : 0;
    t.setStepError(
      e.stepName,
      "colors",
      n > 0 && this.getUniqueColorCount(e, t) > n ? "workflow.steps.frame.tooManyColors" : void 0
    );
  }
  async selectVariantCommand(e, t, n, i, a, s) {
    const o = i.getWorkflowExperience().getStepById(e.stepName)?.frameService;
    if (!o) throw new Error("Frame service unavailable, cannot load pattern!");
    const l = await Promise.all(
      e.data.regions.map((p) => this.frameSourceSvg(t, p))
    );
    a && a(!0);
    const u = e.data.initialZoomLevel, c = await Promise.all(
      e.data.regions.map(async (p, m) => {
        const A = await Q0(l[m]), w = o.getImageData(), x = n.map((L) => new Lf(L.id)), E = w ? fx(
          w,
          A,
          u && !e.data.forceImageCover ? { scale: u } : void 0,
          e.data.forceImageCover
        ) : void 0, T = w ? {
          id: nn(),
          src: w.src,
          x: E?.x || 0,
          y: E?.y || 0,
          width: w.width,
          height: w.height,
          scaleX: E?.zoom || 1,
          scaleY: E?.zoom || 1,
          rotation: 0
        } : void 0, D = nn(), _ = i.getLayouts().find((L) => L.panelId === p.panelId);
        if (!_)
          throw new La(p);
        return {
          command: this.getCreateElementCommand(D, p, m, _, {
            frameData: A,
            pattern: T,
            disablePlaceholder: e.data.disablePlaceholder,
            stepName: e.stepName
          }),
          regionEl: {
            id: D,
            region: p,
            regionIndex: m
          },
          removeExistingCommands: x
        };
      })
    ), h = c.map((p) => p.command), f = c.map((p) => p.removeExistingCommands).flat();
    return {
      command: new Ii([...h, ...f]),
      followup: async () => {
        a && a(!1), await i.setSelectionsAndElements(
          e.stepName,
          t ? [t] : [],
          [...c.map((p) => p.regionEl)],
          async () => {
            if (i.updateStorage(e.stepName, { currentFrameSources: l }), s) {
              const p = i.getWorkflowExperience().getStepById(e.stepName)?.frameService;
              if (!p) throw new Error("Frame service unavailable, cannot load pattern!");
              await this.loadPatternFromString(s, p, !0);
            }
          }
        );
      }
    };
  }
  async loadPatternFromAsset(e, t, n, i) {
    const a = W1(e), s = n.markUpdatePending(), o = n.getWorkflowExperience().getStepById(t.stepName)?.frameService;
    if (!o)
      throw n.markUpdateCompleted(s), new Error("Frame service unavailable, cannot load pattern!");
    try {
      await this.loadPatternFromString(
        a,
        o,
        i,
        void 0,
        t.data.colorPickerEnabled && !!t.data.maxColors && t.data.maxColors > 0
      );
    } catch (u) {
      throw n.markUpdateCompleted(s), u;
    }
    const l = await this.calculateColorMetadata(
      o,
      t,
      new Map(Object.entries(o.getImageData()?.colors ?? {}))
    );
    n.updateMetadata(t.stepName, { image: a, colors: l.metadataColors }), n.updateStorage(t.stepName, {
      framePatternSrc: a,
      colors: l.storageColors
    }), n.markUpdateCompleted(s), n.setMandatoryFulfilled(t.stepName, !0), n.setInformationResults(
      n.getInformationResults().filter((u) => u.stepID === t.stepName)
    ), this.validateColorCount(t, n);
  }
}
const Sf = new TH();
class FH {
  async getIllustrationBody(e) {
    return new Promise((t) => {
      xo(e, !0).then((n) => {
        t(n);
      }).catch((n) => console.error(n));
    });
  }
  getCreateElementCommand(e, t, n, i, a) {
    return new pa(
      {
        stepRegion: t,
        stepRegionIndex: n,
        stepName: a.stepName,
        colors: a.svg.colors,
        id: e,
        src: a.src,
        svg: a.svg.svg,
        cachedObjectURL: a.objectURL,
        type: Mr.Illustration,
        y: t.top,
        x: t.left,
        rotation: t.rotation,
        width: t.width,
        height: t.height,
        layer: t.layer,
        layerIndex: t.layerIndex,
        immutable: t.immutable
      },
      i
    );
  }
  getColors(e, t) {
    const n = t.getRegionElements(e.stepName) || [];
    if (n.length === 0) return [];
    try {
      return zi(
        n[0].id,
        t.getAllLayoutData()
      ).colors;
    } catch {
      return [];
    }
  }
  async init(e, t, n) {
    const i = await Pt.getOptionForStep(e);
    if (!i)
      throw new Cu(e, "No option configured for illustration step.");
    if (n)
      return await this.reload(e, t, n);
    {
      const a = await Pt.getDefaultVariant(i, e.overrideDefaultVariantId);
      if (a)
        return await this.selectVariantCommand(e, a, [], t);
    }
    return null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), o = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName), l = await Pt.getOptionForStep(e);
    if (i?.selectedVariants) {
      const u = i.selectedVariants[0].id;
      if (l && u) {
        const c = l.variants?.find((h) => h.id === u);
        if (c) {
          const h = o.map((f) => ({
            id: f.id,
            region: f.stepRegion,
            regionIndex: f.stepRegionIndex
          }));
          await t.setSelectionsAndElements(
            e.stepName,
            [c],
            h,
            async () => {
              t.updateMetadata(e.stepName, {
                colors: i.storage?.colors
              });
            }
          );
        }
      } else throw new Error("Required illustration variant no longer available");
    }
    return null;
  }
  async availableColors(e, t) {
    const n = await Pt.ensureFullOption(e.data.colorOption);
    return n ? n ? n.variants?.map((i) => ({
      fill: i.color,
      stroke: i.color,
      variant: i,
      pmsValue: i.name
    })) : [] : [];
  }
  async changeColorsCommand(e, t, n, i, a) {
    const s = {};
    for (const [c, h] of a.entries())
      typeof h == "string" ? s[c] = {
        browserValue: h,
        spotColor: void 0,
        pmsValue: void 0
      } : s[c] = {
        browserValue: h.browserValue,
        spotColor: h.spotColor,
        pmsValue: h.pmsValue
      };
    const o = Uw(e, t, n, s), l = await Jp(o), u = [];
    for (const c of i) {
      for (const [h, f] of a.entries())
        u.push(new H1(c, h, f));
      u.push(new nH(c, o, l));
    }
    return new Ii(u);
  }
  async changeColors(e, t, n, i) {
    if (t.length === 0)
      return;
    const a = zi(
      t[0].id,
      n.getCommandContext().getAllLayouts().map((f) => f.layoutState)
    ), s = { ...a.colors }, o = {};
    Object.entries(s).forEach(([f, p]) => {
      const m = { browserValue: p.browserValue, pmsValue: p.pmsValue }, A = p.spotColor;
      A && (m.spotColor = { profileName: A.profileName, namedColor: A.namedColor }), o[f] = m;
    });
    for (const [f, p] of i.entries()) {
      const m = typeof p == "string" ? p : p.browserValue, A = typeof p == "string" ? void 0 : p.pmsValue;
      f === "" ? Object.keys(s).forEach((w) => {
        s[w] = { browserValue: m, spotColor: s[w]?.spotColor, pmsValue: A }, o[w] = { browserValue: m };
      }) : (s[f] = { browserValue: m, spotColor: s[f]?.spotColor, pmsValue: A }, o[f] = { browserValue: m });
    }
    let l = Array.from(Object.values(s)).map((f) => f.browserValue);
    const u = await Pt.ensureFullOption(e.data.colorOption);
    u && u.variants?.forEach((f) => {
      l = l.map((p) => p.toLowerCase() === f.color?.toLowerCase() ? f.name : p);
    }), n.updateMetadata(e.stepName, { colors: l });
    const c = /* @__PURE__ */ new Map();
    if (Object.entries(s).forEach(([f, p]) => {
      c.set(f, p);
    }), !a.svg)
      throw new Error("Colors changed before SVG loaded. This should never happen!");
    const h = await this.changeColorsCommand(
      a.svg,
      a.width,
      a.height,
      t.map((f) => f.id),
      c
    );
    n.updateStorage(e.stepName, {
      colors: o
    }), n.getCommandDispatcher()(h);
  }
  async selectVariant(e, t, n, i, a) {
    i(!0);
    try {
      const s = await this.selectVariantCommand(e, t, n, a);
      s && (s.command && a.getCommandDispatcher()(s.command), s.followup && await s.followup());
    } finally {
      i(!1);
    }
  }
  async selectVariantCommand(e, t, n, i) {
    if (!e.data || !e.data.regions)
      throw new Cu(e, "Missing regions.");
    const a = t.asset;
    if (!a)
      throw new _f(t);
    const s = a.fileLink;
    if (!s)
      throw new th(a);
    e.mandatory && i.setMandatoryFulfilled(e.stepName, !1);
    const o = n.map((w) => new Lf(w.id)), l = await Nl(await this.getIllustrationBody(s)), u = await Jp(l.svg), c = (w, x) => {
      const E = i.getLayouts().find((D) => D.panelId === w.panelId);
      if (!E)
        throw new La(w);
      const T = nn();
      return {
        regionElement: { id: T, region: w, regionIndex: x },
        command: this.getCreateElementCommand(T, w, x, E, {
          stepName: e.stepName,
          src: s,
          objectURL: u,
          svg: l
        })
      };
    }, h = e.data.regions.map(c), f = h.map((w) => w.command), p = [...o, ...f];
    let m = Array.from(Object.values(l.colors)).map((w) => w.browserValue);
    const A = await Pt.ensureFullOption(e.data.colorOption);
    return A && A.variants?.forEach((w) => {
      m = m.map((x) => x.toLowerCase() === w.color?.toLowerCase() ? w.name : x);
    }), i.updateMetadata(e.stepName, { colors: m }), {
      command: new Ii(p),
      followup: async () => {
        const w = h.map((E) => E.regionElement);
        await i.setSelectionsAndElements(e.stepName, [t], w);
        const x = a.assetConfiguration?.defaultColorVariants || [];
        if (x.length !== 0) {
          const E = {};
          (a.assetConfiguration?.channelNumbers || []).forEach((D) => {
            const F = x.find((_) => _.channelNumber === D.number);
            F && (E[`${D.id.replace(/\W/g, "")}`] = { browserValue: F?.variant?.color || "" });
          }), await this.changeColors(
            e,
            w,
            i,
            new Map(Object.entries(E))
          );
        }
        if (e.data.colorPickerEnabled) {
          const E = await this.availableColors(e, i) || [], T = Object.keys(l.colors), D = E.length === 1 && T.length === 1;
          if (D) {
            const F = E[0], _ = T[0];
            await this.changeColors(
              e,
              w,
              i,
              /* @__PURE__ */ new Map([[_, F.variant.color]])
            );
          }
          !D && x.length === 0 && await this.changeColors(e, w, i, /* @__PURE__ */ new Map());
        }
      }
    };
  }
}
const Km = new FH();
class IH {
  async init(e, t, n) {
    const i = await Pt.getOptionForStep(e);
    if (!i)
      throw new c0(e);
    if (n)
      await this.reload(e, t, n);
    else {
      const a = await Pt.getDefaultVariant(i, e.overrideDefaultVariantId);
      if (a)
        return await this.selectVariantLambda(e, a, t, () => {
        });
    }
    return null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), o = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName), l = await Pt.getOptionForStep(e);
    if (!l) throw new c0(e);
    if (i?.selectedVariants) {
      const u = i.selectedVariants[0].id;
      if (u) {
        const c = l.variants?.find((h) => h.id === u);
        if (c) {
          const h = c.material, f = o.map((p) => ({
            id: p.id,
            region: p.stepRegion,
            regionIndex: p.stepRegionIndex
          }));
          await t.setSelectionsAndElements(
            e.stepName,
            [c],
            f,
            async () => {
              const p = t.getModelContainer();
              if (p) {
                const m = e.data.targetMaterials.map((A) => p.applyMaterialVariant(
                  A,
                  l.id || "",
                  h || {}
                ));
                Promise.all(m);
              }
            }
          );
        }
      }
    }
  }
  async selectVariant(e, t, n, i) {
    const a = await this.selectVariantLambda(e, t, n, i);
    a && (a.command && n.getCommandDispatcher()(a.command), a.followup && await a.followup());
  }
  async selectVariantLambda(e, t, n, i) {
    const a = n.getModelContainer();
    i(!0);
    const s = t.material;
    if (!s)
      throw i(!1), new _f(t);
    return {
      command: void 0,
      followup: async () => {
        await n.setSelectionsAndElements(e.stepName, [t], [], async () => {
          try {
            a && e.data.targetMaterials.forEach((o) => {
              e.option && a.applyMaterialVariant(o, e.option.id || "", s);
            });
          } finally {
            i(!1);
          }
        });
      }
    };
  }
}
const $D = new IH();
class PH {
  async init(e, t, n) {
    const i = await Pt.getOptionForStep(e);
    if (!i) throw new c0(e);
    if (n)
      await this.reload(e, t, n);
    else {
      const a = await Pt.getDefaultVariant(i, e.overrideDefaultVariantId);
      if (a)
        return await this.selectVariantLambda(e, a, t, () => {
        });
    }
    return null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), o = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName), l = await Pt.getOptionForStep(e);
    if (i?.selectedVariants) {
      const u = i.selectedVariants[0].id;
      if (l && u) {
        const c = l.variants?.find((h) => h.id === u);
        if (c) {
          const h = o.map((f) => ({
            id: f.id,
            region: f.stepRegion,
            regionIndex: f.stepRegionIndex
          }));
          await t.setSelectionsAndElements(
            e.stepName,
            [c],
            h,
            async () => {
              const f = t.getModelContainer();
              if (f && e.option) {
                const p = c.asset?.fileLink;
                if (!p) throw new _f(c);
                await f.applyModelVariant(
                  e.stepName || "",
                  {
                    model: p,
                    contextService: t.getLayoutPreviewService()
                  },
                  e.data.replaceProductModel || !1
                );
              }
            }
          );
        }
      }
    }
  }
  async selectVariant(e, t, n, i) {
    const a = await this.selectVariantLambda(e, t, n, i);
    a && (a.command && n.getCommandDispatcher()(a.command), a.followup && await a.followup());
  }
  async selectVariantLambda(e, t, n, i) {
    i(!0);
    const a = t.asset?.fileLink;
    if (!a)
      throw new _f(t);
    return {
      command: void 0,
      followup: async () => {
        await n.setSelectionsAndElements(e.stepName, [t], [], async () => {
          try {
            const s = n.getModelContainer();
            s && await s.applyModelVariant(
              e.stepName,
              {
                model: a,
                contextService: n.getLayoutPreviewService()
              },
              e.data.replaceProductModel || !1
            );
          } finally {
            i(!1);
          }
        });
      }
    };
  }
}
const zD = new PH();
var rp = {}, np = {}, ip = {}, Lk;
function DH() {
  return Lk || (Lk = 1, Object.defineProperty(ip, "__esModule", { value: !0 }), ip.extendedPictographic = /^[\u00A9\u00AE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9-\u21AA\u231A-\u231B\u2328\u2388\u23CF\u23E9-\u23EC\u23ED-\u23EE\u23EF\u23F0\u23F1-\u23F2\u23F3\u23F8-\u23FA\u24C2\u25AA-\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2601\u2602-\u2603\u2604\u2605\u2607-\u260D\u260E\u260F-\u2610\u2611\u2612\u2614-\u2615\u2616-\u2617\u2618\u2619-\u261C\u261D\u261E-\u261F\u2620\u2621\u2622-\u2623\u2624-\u2625\u2626\u2627-\u2629\u262A\u262B-\u262D\u262E\u262F\u2630-\u2637\u2638-\u2639\u263A\u263B-\u263F\u2640\u2641\u2642\u2643-\u2647\u2648-\u2653\u2654-\u265E\u265F\u2660\u2661-\u2662\u2663\u2664\u2665-\u2666\u2667\u2668\u2669-\u267A\u267B\u267C-\u267D\u267E\u267F\u2680-\u2685\u2690-\u2691\u2692\u2693\u2694\u2695\u2696-\u2697\u2698\u2699\u269A\u269B-\u269C\u269D-\u269F\u26A0-\u26A1\u26A2-\u26A6\u26A7\u26A8-\u26A9\u26AA-\u26AB\u26AC-\u26AF\u26B0-\u26B1\u26B2-\u26BC\u26BD-\u26BE\u26BF-\u26C3\u26C4-\u26C5\u26C6-\u26C7\u26C8\u26C9-\u26CD\u26CE\u26CF\u26D0\u26D1\u26D2\u26D3\u26D4\u26D5-\u26E8\u26E9\u26EA\u26EB-\u26EF\u26F0-\u26F1\u26F2-\u26F3\u26F4\u26F5\u26F6\u26F7-\u26F9\u26FA\u26FB-\u26FC\u26FD\u26FE-\u2701\u2702\u2703-\u2704\u2705\u2708-\u270C\u270D\u270E\u270F\u2710-\u2711\u2712\u2714\u2716\u271D\u2721\u2728\u2733-\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2765-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934-\u2935\u2B05-\u2B07\u2B1B-\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299\u{01F000}-\u{01F003}\u{01F004}\u{01F005}-\u{01F0CE}\u{01F0CF}\u{01F0D0}-\u{01F0FF}\u{01F10D}-\u{01F10F}\u{01F12F}\u{01F16C}-\u{01F16F}\u{01F170}-\u{01F171}\u{01F17E}-\u{01F17F}\u{01F18E}\u{01F191}-\u{01F19A}\u{01F1AD}-\u{01F1E5}\u{01F201}-\u{01F202}\u{01F203}-\u{01F20F}\u{01F21A}\u{01F22F}\u{01F232}-\u{01F23A}\u{01F23C}-\u{01F23F}\u{01F249}-\u{01F24F}\u{01F250}-\u{01F251}\u{01F252}-\u{01F2FF}\u{01F300}-\u{01F30C}\u{01F30D}-\u{01F30E}\u{01F30F}\u{01F310}\u{01F311}\u{01F312}\u{01F313}-\u{01F315}\u{01F316}-\u{01F318}\u{01F319}\u{01F31A}\u{01F31B}\u{01F31C}\u{01F31D}-\u{01F31E}\u{01F31F}-\u{01F320}\u{01F321}\u{01F322}-\u{01F323}\u{01F324}-\u{01F32C}\u{01F32D}-\u{01F32F}\u{01F330}-\u{01F331}\u{01F332}-\u{01F333}\u{01F334}-\u{01F335}\u{01F336}\u{01F337}-\u{01F34A}\u{01F34B}\u{01F34C}-\u{01F34F}\u{01F350}\u{01F351}-\u{01F37B}\u{01F37C}\u{01F37D}\u{01F37E}-\u{01F37F}\u{01F380}-\u{01F393}\u{01F394}-\u{01F395}\u{01F396}-\u{01F397}\u{01F398}\u{01F399}-\u{01F39B}\u{01F39C}-\u{01F39D}\u{01F39E}-\u{01F39F}\u{01F3A0}-\u{01F3C4}\u{01F3C5}\u{01F3C6}\u{01F3C7}\u{01F3C8}\u{01F3C9}\u{01F3CA}\u{01F3CB}-\u{01F3CE}\u{01F3CF}-\u{01F3D3}\u{01F3D4}-\u{01F3DF}\u{01F3E0}-\u{01F3E3}\u{01F3E4}\u{01F3E5}-\u{01F3F0}\u{01F3F1}-\u{01F3F2}\u{01F3F3}\u{01F3F4}\u{01F3F5}\u{01F3F6}\u{01F3F7}\u{01F3F8}-\u{01F3FA}\u{01F400}-\u{01F407}\u{01F408}\u{01F409}-\u{01F40B}\u{01F40C}-\u{01F40E}\u{01F40F}-\u{01F410}\u{01F411}-\u{01F412}\u{01F413}\u{01F414}\u{01F415}\u{01F416}\u{01F417}-\u{01F429}\u{01F42A}\u{01F42B}-\u{01F43E}\u{01F43F}\u{01F440}\u{01F441}\u{01F442}-\u{01F464}\u{01F465}\u{01F466}-\u{01F46B}\u{01F46C}-\u{01F46D}\u{01F46E}-\u{01F4AC}\u{01F4AD}\u{01F4AE}-\u{01F4B5}\u{01F4B6}-\u{01F4B7}\u{01F4B8}-\u{01F4EB}\u{01F4EC}-\u{01F4ED}\u{01F4EE}\u{01F4EF}\u{01F4F0}-\u{01F4F4}\u{01F4F5}\u{01F4F6}-\u{01F4F7}\u{01F4F8}\u{01F4F9}-\u{01F4FC}\u{01F4FD}\u{01F4FE}\u{01F4FF}-\u{01F502}\u{01F503}\u{01F504}-\u{01F507}\u{01F508}\u{01F509}\u{01F50A}-\u{01F514}\u{01F515}\u{01F516}-\u{01F52B}\u{01F52C}-\u{01F52D}\u{01F52E}-\u{01F53D}\u{01F546}-\u{01F548}\u{01F549}-\u{01F54A}\u{01F54B}-\u{01F54E}\u{01F54F}\u{01F550}-\u{01F55B}\u{01F55C}-\u{01F567}\u{01F568}-\u{01F56E}\u{01F56F}-\u{01F570}\u{01F571}-\u{01F572}\u{01F573}-\u{01F579}\u{01F57A}\u{01F57B}-\u{01F586}\u{01F587}\u{01F588}-\u{01F589}\u{01F58A}-\u{01F58D}\u{01F58E}-\u{01F58F}\u{01F590}\u{01F591}-\u{01F594}\u{01F595}-\u{01F596}\u{01F597}-\u{01F5A3}\u{01F5A4}\u{01F5A5}\u{01F5A6}-\u{01F5A7}\u{01F5A8}\u{01F5A9}-\u{01F5B0}\u{01F5B1}-\u{01F5B2}\u{01F5B3}-\u{01F5BB}\u{01F5BC}\u{01F5BD}-\u{01F5C1}\u{01F5C2}-\u{01F5C4}\u{01F5C5}-\u{01F5D0}\u{01F5D1}-\u{01F5D3}\u{01F5D4}-\u{01F5DB}\u{01F5DC}-\u{01F5DE}\u{01F5DF}-\u{01F5E0}\u{01F5E1}\u{01F5E2}\u{01F5E3}\u{01F5E4}-\u{01F5E7}\u{01F5E8}\u{01F5E9}-\u{01F5EE}\u{01F5EF}\u{01F5F0}-\u{01F5F2}\u{01F5F3}\u{01F5F4}-\u{01F5F9}\u{01F5FA}\u{01F5FB}-\u{01F5FF}\u{01F600}\u{01F601}-\u{01F606}\u{01F607}-\u{01F608}\u{01F609}-\u{01F60D}\u{01F60E}\u{01F60F}\u{01F610}\u{01F611}\u{01F612}-\u{01F614}\u{01F615}\u{01F616}\u{01F617}\u{01F618}\u{01F619}\u{01F61A}\u{01F61B}\u{01F61C}-\u{01F61E}\u{01F61F}\u{01F620}-\u{01F625}\u{01F626}-\u{01F627}\u{01F628}-\u{01F62B}\u{01F62C}\u{01F62D}\u{01F62E}-\u{01F62F}\u{01F630}-\u{01F633}\u{01F634}\u{01F635}\u{01F636}\u{01F637}-\u{01F640}\u{01F641}-\u{01F644}\u{01F645}-\u{01F64F}\u{01F680}\u{01F681}-\u{01F682}\u{01F683}-\u{01F685}\u{01F686}\u{01F687}\u{01F688}\u{01F689}\u{01F68A}-\u{01F68B}\u{01F68C}\u{01F68D}\u{01F68E}\u{01F68F}\u{01F690}\u{01F691}-\u{01F693}\u{01F694}\u{01F695}\u{01F696}\u{01F697}\u{01F698}\u{01F699}-\u{01F69A}\u{01F69B}-\u{01F6A1}\u{01F6A2}\u{01F6A3}\u{01F6A4}-\u{01F6A5}\u{01F6A6}\u{01F6A7}-\u{01F6AD}\u{01F6AE}-\u{01F6B1}\u{01F6B2}\u{01F6B3}-\u{01F6B5}\u{01F6B6}\u{01F6B7}-\u{01F6B8}\u{01F6B9}-\u{01F6BE}\u{01F6BF}\u{01F6C0}\u{01F6C1}-\u{01F6C5}\u{01F6C6}-\u{01F6CA}\u{01F6CB}\u{01F6CC}\u{01F6CD}-\u{01F6CF}\u{01F6D0}\u{01F6D1}-\u{01F6D2}\u{01F6D3}-\u{01F6D4}\u{01F6D5}\u{01F6D6}-\u{01F6D7}\u{01F6D8}-\u{01F6DF}\u{01F6E0}-\u{01F6E5}\u{01F6E6}-\u{01F6E8}\u{01F6E9}\u{01F6EA}\u{01F6EB}-\u{01F6EC}\u{01F6ED}-\u{01F6EF}\u{01F6F0}\u{01F6F1}-\u{01F6F2}\u{01F6F3}\u{01F6F4}-\u{01F6F6}\u{01F6F7}-\u{01F6F8}\u{01F6F9}\u{01F6FA}\u{01F6FB}-\u{01F6FC}\u{01F6FD}-\u{01F6FF}\u{01F774}-\u{01F77F}\u{01F7D5}-\u{01F7DF}\u{01F7E0}-\u{01F7EB}\u{01F7EC}-\u{01F7FF}\u{01F80C}-\u{01F80F}\u{01F848}-\u{01F84F}\u{01F85A}-\u{01F85F}\u{01F888}-\u{01F88F}\u{01F8AE}-\u{01F8FF}\u{01F90C}\u{01F90D}-\u{01F90F}\u{01F910}-\u{01F918}\u{01F919}-\u{01F91E}\u{01F91F}\u{01F920}-\u{01F927}\u{01F928}-\u{01F92F}\u{01F930}\u{01F931}-\u{01F932}\u{01F933}-\u{01F93A}\u{01F93C}-\u{01F93E}\u{01F93F}\u{01F940}-\u{01F945}\u{01F947}-\u{01F94B}\u{01F94C}\u{01F94D}-\u{01F94F}\u{01F950}-\u{01F95E}\u{01F95F}-\u{01F96B}\u{01F96C}-\u{01F970}\u{01F971}\u{01F972}\u{01F973}-\u{01F976}\u{01F977}-\u{01F978}\u{01F979}\u{01F97A}\u{01F97B}\u{01F97C}-\u{01F97F}\u{01F980}-\u{01F984}\u{01F985}-\u{01F991}\u{01F992}-\u{01F997}\u{01F998}-\u{01F9A2}\u{01F9A3}-\u{01F9A4}\u{01F9A5}-\u{01F9AA}\u{01F9AB}-\u{01F9AD}\u{01F9AE}-\u{01F9AF}\u{01F9B0}-\u{01F9B9}\u{01F9BA}-\u{01F9BF}\u{01F9C0}\u{01F9C1}-\u{01F9C2}\u{01F9C3}-\u{01F9CA}\u{01F9CB}\u{01F9CC}\u{01F9CD}-\u{01F9CF}\u{01F9D0}-\u{01F9E6}\u{01F9E7}-\u{01F9FF}\u{01FA00}-\u{01FA6F}\u{01FA70}-\u{01FA73}\u{01FA74}\u{01FA75}-\u{01FA77}\u{01FA78}-\u{01FA7A}\u{01FA7B}-\u{01FA7F}\u{01FA80}-\u{01FA82}\u{01FA83}-\u{01FA86}\u{01FA87}-\u{01FA8F}\u{01FA90}-\u{01FA95}\u{01FA96}-\u{01FAA8}\u{01FAA9}-\u{01FAAF}\u{01FAB0}-\u{01FAB6}\u{01FAB7}-\u{01FABF}\u{01FAC0}-\u{01FAC2}\u{01FAC3}-\u{01FACF}\u{01FAD0}-\u{01FAD6}\u{01FAD7}-\u{01FAFF}\u{01FC00}-\u{01FFFD}]/u, ip.WORD_BREAK_PROPERTY = [
    [
      /*start*/
      0,
      0
      /* Other */
    ],
    [
      /*start*/
      10,
      1
      /* LF */
    ],
    [
      /*start*/
      11,
      2
      /* Newline */
    ],
    [
      /*start*/
      13,
      3
      /* CR */
    ],
    [
      /*start*/
      14,
      0
      /* Other */
    ],
    [
      /*start*/
      32,
      4
      /* WSegSpace */
    ],
    [
      /*start*/
      33,
      0
      /* Other */
    ],
    [
      /*start*/
      34,
      5
      /* Double_Quote */
    ],
    [
      /*start*/
      35,
      0
      /* Other */
    ],
    [
      /*start*/
      39,
      6
      /* Single_Quote */
    ],
    [
      /*start*/
      40,
      0
      /* Other */
    ],
    [
      /*start*/
      44,
      7
      /* MidNum */
    ],
    [
      /*start*/
      45,
      0
      /* Other */
    ],
    [
      /*start*/
      46,
      8
      /* MidNumLet */
    ],
    [
      /*start*/
      47,
      0
      /* Other */
    ],
    [
      /*start*/
      48,
      9
      /* Numeric */
    ],
    [
      /*start*/
      58,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      59,
      7
      /* MidNum */
    ],
    [
      /*start*/
      60,
      0
      /* Other */
    ],
    [
      /*start*/
      65,
      11
      /* ALetter */
    ],
    [
      /*start*/
      91,
      0
      /* Other */
    ],
    [
      /*start*/
      95,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      96,
      0
      /* Other */
    ],
    [
      /*start*/
      97,
      11
      /* ALetter */
    ],
    [
      /*start*/
      123,
      0
      /* Other */
    ],
    [
      /*start*/
      133,
      2
      /* Newline */
    ],
    [
      /*start*/
      134,
      0
      /* Other */
    ],
    [
      /*start*/
      170,
      11
      /* ALetter */
    ],
    [
      /*start*/
      171,
      0
      /* Other */
    ],
    [
      /*start*/
      173,
      13
      /* Format */
    ],
    [
      /*start*/
      174,
      0
      /* Other */
    ],
    [
      /*start*/
      181,
      11
      /* ALetter */
    ],
    [
      /*start*/
      182,
      0
      /* Other */
    ],
    [
      /*start*/
      183,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      184,
      0
      /* Other */
    ],
    [
      /*start*/
      186,
      11
      /* ALetter */
    ],
    [
      /*start*/
      187,
      0
      /* Other */
    ],
    [
      /*start*/
      192,
      11
      /* ALetter */
    ],
    [
      /*start*/
      215,
      0
      /* Other */
    ],
    [
      /*start*/
      216,
      11
      /* ALetter */
    ],
    [
      /*start*/
      247,
      0
      /* Other */
    ],
    [
      /*start*/
      248,
      11
      /* ALetter */
    ],
    [
      /*start*/
      728,
      0
      /* Other */
    ],
    [
      /*start*/
      734,
      11
      /* ALetter */
    ],
    [
      /*start*/
      768,
      14
      /* Extend */
    ],
    [
      /*start*/
      880,
      11
      /* ALetter */
    ],
    [
      /*start*/
      885,
      0
      /* Other */
    ],
    [
      /*start*/
      886,
      11
      /* ALetter */
    ],
    [
      /*start*/
      888,
      0
      /* Other */
    ],
    [
      /*start*/
      890,
      11
      /* ALetter */
    ],
    [
      /*start*/
      894,
      7
      /* MidNum */
    ],
    [
      /*start*/
      895,
      11
      /* ALetter */
    ],
    [
      /*start*/
      896,
      0
      /* Other */
    ],
    [
      /*start*/
      902,
      11
      /* ALetter */
    ],
    [
      /*start*/
      903,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      904,
      11
      /* ALetter */
    ],
    [
      /*start*/
      907,
      0
      /* Other */
    ],
    [
      /*start*/
      908,
      11
      /* ALetter */
    ],
    [
      /*start*/
      909,
      0
      /* Other */
    ],
    [
      /*start*/
      910,
      11
      /* ALetter */
    ],
    [
      /*start*/
      930,
      0
      /* Other */
    ],
    [
      /*start*/
      931,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1014,
      0
      /* Other */
    ],
    [
      /*start*/
      1015,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1154,
      0
      /* Other */
    ],
    [
      /*start*/
      1155,
      14
      /* Extend */
    ],
    [
      /*start*/
      1162,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1328,
      0
      /* Other */
    ],
    [
      /*start*/
      1329,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1367,
      0
      /* Other */
    ],
    [
      /*start*/
      1369,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1373,
      0
      /* Other */
    ],
    [
      /*start*/
      1374,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1375,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      1376,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1417,
      7
      /* MidNum */
    ],
    [
      /*start*/
      1418,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1419,
      0
      /* Other */
    ],
    [
      /*start*/
      1425,
      14
      /* Extend */
    ],
    [
      /*start*/
      1470,
      0
      /* Other */
    ],
    [
      /*start*/
      1471,
      14
      /* Extend */
    ],
    [
      /*start*/
      1472,
      0
      /* Other */
    ],
    [
      /*start*/
      1473,
      14
      /* Extend */
    ],
    [
      /*start*/
      1475,
      0
      /* Other */
    ],
    [
      /*start*/
      1476,
      14
      /* Extend */
    ],
    [
      /*start*/
      1478,
      0
      /* Other */
    ],
    [
      /*start*/
      1479,
      14
      /* Extend */
    ],
    [
      /*start*/
      1480,
      0
      /* Other */
    ],
    [
      /*start*/
      1488,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      1515,
      0
      /* Other */
    ],
    [
      /*start*/
      1519,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      1523,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1524,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      1525,
      0
      /* Other */
    ],
    [
      /*start*/
      1536,
      13
      /* Format */
    ],
    [
      /*start*/
      1542,
      0
      /* Other */
    ],
    [
      /*start*/
      1548,
      7
      /* MidNum */
    ],
    [
      /*start*/
      1550,
      0
      /* Other */
    ],
    [
      /*start*/
      1552,
      14
      /* Extend */
    ],
    [
      /*start*/
      1563,
      0
      /* Other */
    ],
    [
      /*start*/
      1564,
      13
      /* Format */
    ],
    [
      /*start*/
      1565,
      0
      /* Other */
    ],
    [
      /*start*/
      1568,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1611,
      14
      /* Extend */
    ],
    [
      /*start*/
      1632,
      9
      /* Numeric */
    ],
    [
      /*start*/
      1642,
      0
      /* Other */
    ],
    [
      /*start*/
      1643,
      9
      /* Numeric */
    ],
    [
      /*start*/
      1644,
      7
      /* MidNum */
    ],
    [
      /*start*/
      1645,
      0
      /* Other */
    ],
    [
      /*start*/
      1646,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1648,
      14
      /* Extend */
    ],
    [
      /*start*/
      1649,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1748,
      0
      /* Other */
    ],
    [
      /*start*/
      1749,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1750,
      14
      /* Extend */
    ],
    [
      /*start*/
      1757,
      13
      /* Format */
    ],
    [
      /*start*/
      1758,
      0
      /* Other */
    ],
    [
      /*start*/
      1759,
      14
      /* Extend */
    ],
    [
      /*start*/
      1765,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1767,
      14
      /* Extend */
    ],
    [
      /*start*/
      1769,
      0
      /* Other */
    ],
    [
      /*start*/
      1770,
      14
      /* Extend */
    ],
    [
      /*start*/
      1774,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1776,
      9
      /* Numeric */
    ],
    [
      /*start*/
      1786,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1789,
      0
      /* Other */
    ],
    [
      /*start*/
      1791,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1792,
      0
      /* Other */
    ],
    [
      /*start*/
      1807,
      13
      /* Format */
    ],
    [
      /*start*/
      1808,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1809,
      14
      /* Extend */
    ],
    [
      /*start*/
      1810,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1840,
      14
      /* Extend */
    ],
    [
      /*start*/
      1867,
      0
      /* Other */
    ],
    [
      /*start*/
      1869,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1958,
      14
      /* Extend */
    ],
    [
      /*start*/
      1969,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1970,
      0
      /* Other */
    ],
    [
      /*start*/
      1984,
      9
      /* Numeric */
    ],
    [
      /*start*/
      1994,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2027,
      14
      /* Extend */
    ],
    [
      /*start*/
      2036,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2038,
      0
      /* Other */
    ],
    [
      /*start*/
      2040,
      7
      /* MidNum */
    ],
    [
      /*start*/
      2041,
      0
      /* Other */
    ],
    [
      /*start*/
      2042,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2043,
      0
      /* Other */
    ],
    [
      /*start*/
      2045,
      14
      /* Extend */
    ],
    [
      /*start*/
      2046,
      0
      /* Other */
    ],
    [
      /*start*/
      2048,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2070,
      14
      /* Extend */
    ],
    [
      /*start*/
      2074,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2075,
      14
      /* Extend */
    ],
    [
      /*start*/
      2084,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2085,
      14
      /* Extend */
    ],
    [
      /*start*/
      2088,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2089,
      14
      /* Extend */
    ],
    [
      /*start*/
      2094,
      0
      /* Other */
    ],
    [
      /*start*/
      2112,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2137,
      14
      /* Extend */
    ],
    [
      /*start*/
      2140,
      0
      /* Other */
    ],
    [
      /*start*/
      2144,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2155,
      0
      /* Other */
    ],
    [
      /*start*/
      2208,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2229,
      0
      /* Other */
    ],
    [
      /*start*/
      2230,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2248,
      0
      /* Other */
    ],
    [
      /*start*/
      2259,
      14
      /* Extend */
    ],
    [
      /*start*/
      2274,
      13
      /* Format */
    ],
    [
      /*start*/
      2275,
      14
      /* Extend */
    ],
    [
      /*start*/
      2308,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2362,
      14
      /* Extend */
    ],
    [
      /*start*/
      2365,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2366,
      14
      /* Extend */
    ],
    [
      /*start*/
      2384,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2385,
      14
      /* Extend */
    ],
    [
      /*start*/
      2392,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2402,
      14
      /* Extend */
    ],
    [
      /*start*/
      2404,
      0
      /* Other */
    ],
    [
      /*start*/
      2406,
      9
      /* Numeric */
    ],
    [
      /*start*/
      2416,
      0
      /* Other */
    ],
    [
      /*start*/
      2417,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2433,
      14
      /* Extend */
    ],
    [
      /*start*/
      2436,
      0
      /* Other */
    ],
    [
      /*start*/
      2437,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2445,
      0
      /* Other */
    ],
    [
      /*start*/
      2447,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2449,
      0
      /* Other */
    ],
    [
      /*start*/
      2451,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2473,
      0
      /* Other */
    ],
    [
      /*start*/
      2474,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2481,
      0
      /* Other */
    ],
    [
      /*start*/
      2482,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2483,
      0
      /* Other */
    ],
    [
      /*start*/
      2486,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2490,
      0
      /* Other */
    ],
    [
      /*start*/
      2492,
      14
      /* Extend */
    ],
    [
      /*start*/
      2493,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2494,
      14
      /* Extend */
    ],
    [
      /*start*/
      2501,
      0
      /* Other */
    ],
    [
      /*start*/
      2503,
      14
      /* Extend */
    ],
    [
      /*start*/
      2505,
      0
      /* Other */
    ],
    [
      /*start*/
      2507,
      14
      /* Extend */
    ],
    [
      /*start*/
      2510,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2511,
      0
      /* Other */
    ],
    [
      /*start*/
      2519,
      14
      /* Extend */
    ],
    [
      /*start*/
      2520,
      0
      /* Other */
    ],
    [
      /*start*/
      2524,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2526,
      0
      /* Other */
    ],
    [
      /*start*/
      2527,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2530,
      14
      /* Extend */
    ],
    [
      /*start*/
      2532,
      0
      /* Other */
    ],
    [
      /*start*/
      2534,
      9
      /* Numeric */
    ],
    [
      /*start*/
      2544,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2546,
      0
      /* Other */
    ],
    [
      /*start*/
      2556,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2557,
      0
      /* Other */
    ],
    [
      /*start*/
      2558,
      14
      /* Extend */
    ],
    [
      /*start*/
      2559,
      0
      /* Other */
    ],
    [
      /*start*/
      2561,
      14
      /* Extend */
    ],
    [
      /*start*/
      2564,
      0
      /* Other */
    ],
    [
      /*start*/
      2565,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2571,
      0
      /* Other */
    ],
    [
      /*start*/
      2575,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2577,
      0
      /* Other */
    ],
    [
      /*start*/
      2579,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2601,
      0
      /* Other */
    ],
    [
      /*start*/
      2602,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2609,
      0
      /* Other */
    ],
    [
      /*start*/
      2610,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2612,
      0
      /* Other */
    ],
    [
      /*start*/
      2613,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2615,
      0
      /* Other */
    ],
    [
      /*start*/
      2616,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2618,
      0
      /* Other */
    ],
    [
      /*start*/
      2620,
      14
      /* Extend */
    ],
    [
      /*start*/
      2621,
      0
      /* Other */
    ],
    [
      /*start*/
      2622,
      14
      /* Extend */
    ],
    [
      /*start*/
      2627,
      0
      /* Other */
    ],
    [
      /*start*/
      2631,
      14
      /* Extend */
    ],
    [
      /*start*/
      2633,
      0
      /* Other */
    ],
    [
      /*start*/
      2635,
      14
      /* Extend */
    ],
    [
      /*start*/
      2638,
      0
      /* Other */
    ],
    [
      /*start*/
      2641,
      14
      /* Extend */
    ],
    [
      /*start*/
      2642,
      0
      /* Other */
    ],
    [
      /*start*/
      2649,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2653,
      0
      /* Other */
    ],
    [
      /*start*/
      2654,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2655,
      0
      /* Other */
    ],
    [
      /*start*/
      2662,
      9
      /* Numeric */
    ],
    [
      /*start*/
      2672,
      14
      /* Extend */
    ],
    [
      /*start*/
      2674,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2677,
      14
      /* Extend */
    ],
    [
      /*start*/
      2678,
      0
      /* Other */
    ],
    [
      /*start*/
      2689,
      14
      /* Extend */
    ],
    [
      /*start*/
      2692,
      0
      /* Other */
    ],
    [
      /*start*/
      2693,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2702,
      0
      /* Other */
    ],
    [
      /*start*/
      2703,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2706,
      0
      /* Other */
    ],
    [
      /*start*/
      2707,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2729,
      0
      /* Other */
    ],
    [
      /*start*/
      2730,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2737,
      0
      /* Other */
    ],
    [
      /*start*/
      2738,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2740,
      0
      /* Other */
    ],
    [
      /*start*/
      2741,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2746,
      0
      /* Other */
    ],
    [
      /*start*/
      2748,
      14
      /* Extend */
    ],
    [
      /*start*/
      2749,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2750,
      14
      /* Extend */
    ],
    [
      /*start*/
      2758,
      0
      /* Other */
    ],
    [
      /*start*/
      2759,
      14
      /* Extend */
    ],
    [
      /*start*/
      2762,
      0
      /* Other */
    ],
    [
      /*start*/
      2763,
      14
      /* Extend */
    ],
    [
      /*start*/
      2766,
      0
      /* Other */
    ],
    [
      /*start*/
      2768,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2769,
      0
      /* Other */
    ],
    [
      /*start*/
      2784,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2786,
      14
      /* Extend */
    ],
    [
      /*start*/
      2788,
      0
      /* Other */
    ],
    [
      /*start*/
      2790,
      9
      /* Numeric */
    ],
    [
      /*start*/
      2800,
      0
      /* Other */
    ],
    [
      /*start*/
      2809,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2810,
      14
      /* Extend */
    ],
    [
      /*start*/
      2816,
      0
      /* Other */
    ],
    [
      /*start*/
      2817,
      14
      /* Extend */
    ],
    [
      /*start*/
      2820,
      0
      /* Other */
    ],
    [
      /*start*/
      2821,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2829,
      0
      /* Other */
    ],
    [
      /*start*/
      2831,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2833,
      0
      /* Other */
    ],
    [
      /*start*/
      2835,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2857,
      0
      /* Other */
    ],
    [
      /*start*/
      2858,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2865,
      0
      /* Other */
    ],
    [
      /*start*/
      2866,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2868,
      0
      /* Other */
    ],
    [
      /*start*/
      2869,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2874,
      0
      /* Other */
    ],
    [
      /*start*/
      2876,
      14
      /* Extend */
    ],
    [
      /*start*/
      2877,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2878,
      14
      /* Extend */
    ],
    [
      /*start*/
      2885,
      0
      /* Other */
    ],
    [
      /*start*/
      2887,
      14
      /* Extend */
    ],
    [
      /*start*/
      2889,
      0
      /* Other */
    ],
    [
      /*start*/
      2891,
      14
      /* Extend */
    ],
    [
      /*start*/
      2894,
      0
      /* Other */
    ],
    [
      /*start*/
      2901,
      14
      /* Extend */
    ],
    [
      /*start*/
      2904,
      0
      /* Other */
    ],
    [
      /*start*/
      2908,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2910,
      0
      /* Other */
    ],
    [
      /*start*/
      2911,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2914,
      14
      /* Extend */
    ],
    [
      /*start*/
      2916,
      0
      /* Other */
    ],
    [
      /*start*/
      2918,
      9
      /* Numeric */
    ],
    [
      /*start*/
      2928,
      0
      /* Other */
    ],
    [
      /*start*/
      2929,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2930,
      0
      /* Other */
    ],
    [
      /*start*/
      2946,
      14
      /* Extend */
    ],
    [
      /*start*/
      2947,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2948,
      0
      /* Other */
    ],
    [
      /*start*/
      2949,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2955,
      0
      /* Other */
    ],
    [
      /*start*/
      2958,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2961,
      0
      /* Other */
    ],
    [
      /*start*/
      2962,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2966,
      0
      /* Other */
    ],
    [
      /*start*/
      2969,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2971,
      0
      /* Other */
    ],
    [
      /*start*/
      2972,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2973,
      0
      /* Other */
    ],
    [
      /*start*/
      2974,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2976,
      0
      /* Other */
    ],
    [
      /*start*/
      2979,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2981,
      0
      /* Other */
    ],
    [
      /*start*/
      2984,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2987,
      0
      /* Other */
    ],
    [
      /*start*/
      2990,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3002,
      0
      /* Other */
    ],
    [
      /*start*/
      3006,
      14
      /* Extend */
    ],
    [
      /*start*/
      3011,
      0
      /* Other */
    ],
    [
      /*start*/
      3014,
      14
      /* Extend */
    ],
    [
      /*start*/
      3017,
      0
      /* Other */
    ],
    [
      /*start*/
      3018,
      14
      /* Extend */
    ],
    [
      /*start*/
      3022,
      0
      /* Other */
    ],
    [
      /*start*/
      3024,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3025,
      0
      /* Other */
    ],
    [
      /*start*/
      3031,
      14
      /* Extend */
    ],
    [
      /*start*/
      3032,
      0
      /* Other */
    ],
    [
      /*start*/
      3046,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3056,
      0
      /* Other */
    ],
    [
      /*start*/
      3072,
      14
      /* Extend */
    ],
    [
      /*start*/
      3077,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3085,
      0
      /* Other */
    ],
    [
      /*start*/
      3086,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3089,
      0
      /* Other */
    ],
    [
      /*start*/
      3090,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3113,
      0
      /* Other */
    ],
    [
      /*start*/
      3114,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3130,
      0
      /* Other */
    ],
    [
      /*start*/
      3133,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3134,
      14
      /* Extend */
    ],
    [
      /*start*/
      3141,
      0
      /* Other */
    ],
    [
      /*start*/
      3142,
      14
      /* Extend */
    ],
    [
      /*start*/
      3145,
      0
      /* Other */
    ],
    [
      /*start*/
      3146,
      14
      /* Extend */
    ],
    [
      /*start*/
      3150,
      0
      /* Other */
    ],
    [
      /*start*/
      3157,
      14
      /* Extend */
    ],
    [
      /*start*/
      3159,
      0
      /* Other */
    ],
    [
      /*start*/
      3160,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3163,
      0
      /* Other */
    ],
    [
      /*start*/
      3168,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3170,
      14
      /* Extend */
    ],
    [
      /*start*/
      3172,
      0
      /* Other */
    ],
    [
      /*start*/
      3174,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3184,
      0
      /* Other */
    ],
    [
      /*start*/
      3200,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3201,
      14
      /* Extend */
    ],
    [
      /*start*/
      3204,
      0
      /* Other */
    ],
    [
      /*start*/
      3205,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3213,
      0
      /* Other */
    ],
    [
      /*start*/
      3214,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3217,
      0
      /* Other */
    ],
    [
      /*start*/
      3218,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3241,
      0
      /* Other */
    ],
    [
      /*start*/
      3242,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3252,
      0
      /* Other */
    ],
    [
      /*start*/
      3253,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3258,
      0
      /* Other */
    ],
    [
      /*start*/
      3260,
      14
      /* Extend */
    ],
    [
      /*start*/
      3261,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3262,
      14
      /* Extend */
    ],
    [
      /*start*/
      3269,
      0
      /* Other */
    ],
    [
      /*start*/
      3270,
      14
      /* Extend */
    ],
    [
      /*start*/
      3273,
      0
      /* Other */
    ],
    [
      /*start*/
      3274,
      14
      /* Extend */
    ],
    [
      /*start*/
      3278,
      0
      /* Other */
    ],
    [
      /*start*/
      3285,
      14
      /* Extend */
    ],
    [
      /*start*/
      3287,
      0
      /* Other */
    ],
    [
      /*start*/
      3294,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3295,
      0
      /* Other */
    ],
    [
      /*start*/
      3296,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3298,
      14
      /* Extend */
    ],
    [
      /*start*/
      3300,
      0
      /* Other */
    ],
    [
      /*start*/
      3302,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3312,
      0
      /* Other */
    ],
    [
      /*start*/
      3313,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3315,
      0
      /* Other */
    ],
    [
      /*start*/
      3328,
      14
      /* Extend */
    ],
    [
      /*start*/
      3332,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3341,
      0
      /* Other */
    ],
    [
      /*start*/
      3342,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3345,
      0
      /* Other */
    ],
    [
      /*start*/
      3346,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3387,
      14
      /* Extend */
    ],
    [
      /*start*/
      3389,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3390,
      14
      /* Extend */
    ],
    [
      /*start*/
      3397,
      0
      /* Other */
    ],
    [
      /*start*/
      3398,
      14
      /* Extend */
    ],
    [
      /*start*/
      3401,
      0
      /* Other */
    ],
    [
      /*start*/
      3402,
      14
      /* Extend */
    ],
    [
      /*start*/
      3406,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3407,
      0
      /* Other */
    ],
    [
      /*start*/
      3412,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3415,
      14
      /* Extend */
    ],
    [
      /*start*/
      3416,
      0
      /* Other */
    ],
    [
      /*start*/
      3423,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3426,
      14
      /* Extend */
    ],
    [
      /*start*/
      3428,
      0
      /* Other */
    ],
    [
      /*start*/
      3430,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3440,
      0
      /* Other */
    ],
    [
      /*start*/
      3450,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3456,
      0
      /* Other */
    ],
    [
      /*start*/
      3457,
      14
      /* Extend */
    ],
    [
      /*start*/
      3460,
      0
      /* Other */
    ],
    [
      /*start*/
      3461,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3479,
      0
      /* Other */
    ],
    [
      /*start*/
      3482,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3506,
      0
      /* Other */
    ],
    [
      /*start*/
      3507,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3516,
      0
      /* Other */
    ],
    [
      /*start*/
      3517,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3518,
      0
      /* Other */
    ],
    [
      /*start*/
      3520,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3527,
      0
      /* Other */
    ],
    [
      /*start*/
      3530,
      14
      /* Extend */
    ],
    [
      /*start*/
      3531,
      0
      /* Other */
    ],
    [
      /*start*/
      3535,
      14
      /* Extend */
    ],
    [
      /*start*/
      3541,
      0
      /* Other */
    ],
    [
      /*start*/
      3542,
      14
      /* Extend */
    ],
    [
      /*start*/
      3543,
      0
      /* Other */
    ],
    [
      /*start*/
      3544,
      14
      /* Extend */
    ],
    [
      /*start*/
      3552,
      0
      /* Other */
    ],
    [
      /*start*/
      3558,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3568,
      0
      /* Other */
    ],
    [
      /*start*/
      3570,
      14
      /* Extend */
    ],
    [
      /*start*/
      3572,
      0
      /* Other */
    ],
    [
      /*start*/
      3633,
      14
      /* Extend */
    ],
    [
      /*start*/
      3634,
      0
      /* Other */
    ],
    [
      /*start*/
      3636,
      14
      /* Extend */
    ],
    [
      /*start*/
      3643,
      0
      /* Other */
    ],
    [
      /*start*/
      3655,
      14
      /* Extend */
    ],
    [
      /*start*/
      3663,
      0
      /* Other */
    ],
    [
      /*start*/
      3664,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3674,
      0
      /* Other */
    ],
    [
      /*start*/
      3761,
      14
      /* Extend */
    ],
    [
      /*start*/
      3762,
      0
      /* Other */
    ],
    [
      /*start*/
      3764,
      14
      /* Extend */
    ],
    [
      /*start*/
      3773,
      0
      /* Other */
    ],
    [
      /*start*/
      3784,
      14
      /* Extend */
    ],
    [
      /*start*/
      3790,
      0
      /* Other */
    ],
    [
      /*start*/
      3792,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3802,
      0
      /* Other */
    ],
    [
      /*start*/
      3840,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3841,
      0
      /* Other */
    ],
    [
      /*start*/
      3864,
      14
      /* Extend */
    ],
    [
      /*start*/
      3866,
      0
      /* Other */
    ],
    [
      /*start*/
      3872,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3882,
      0
      /* Other */
    ],
    [
      /*start*/
      3893,
      14
      /* Extend */
    ],
    [
      /*start*/
      3894,
      0
      /* Other */
    ],
    [
      /*start*/
      3895,
      14
      /* Extend */
    ],
    [
      /*start*/
      3896,
      0
      /* Other */
    ],
    [
      /*start*/
      3897,
      14
      /* Extend */
    ],
    [
      /*start*/
      3898,
      0
      /* Other */
    ],
    [
      /*start*/
      3902,
      14
      /* Extend */
    ],
    [
      /*start*/
      3904,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3912,
      0
      /* Other */
    ],
    [
      /*start*/
      3913,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3949,
      0
      /* Other */
    ],
    [
      /*start*/
      3953,
      14
      /* Extend */
    ],
    [
      /*start*/
      3973,
      0
      /* Other */
    ],
    [
      /*start*/
      3974,
      14
      /* Extend */
    ],
    [
      /*start*/
      3976,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3981,
      14
      /* Extend */
    ],
    [
      /*start*/
      3992,
      0
      /* Other */
    ],
    [
      /*start*/
      3993,
      14
      /* Extend */
    ],
    [
      /*start*/
      4029,
      0
      /* Other */
    ],
    [
      /*start*/
      4038,
      14
      /* Extend */
    ],
    [
      /*start*/
      4039,
      0
      /* Other */
    ],
    [
      /*start*/
      4139,
      14
      /* Extend */
    ],
    [
      /*start*/
      4159,
      0
      /* Other */
    ],
    [
      /*start*/
      4160,
      9
      /* Numeric */
    ],
    [
      /*start*/
      4170,
      0
      /* Other */
    ],
    [
      /*start*/
      4182,
      14
      /* Extend */
    ],
    [
      /*start*/
      4186,
      0
      /* Other */
    ],
    [
      /*start*/
      4190,
      14
      /* Extend */
    ],
    [
      /*start*/
      4193,
      0
      /* Other */
    ],
    [
      /*start*/
      4194,
      14
      /* Extend */
    ],
    [
      /*start*/
      4197,
      0
      /* Other */
    ],
    [
      /*start*/
      4199,
      14
      /* Extend */
    ],
    [
      /*start*/
      4206,
      0
      /* Other */
    ],
    [
      /*start*/
      4209,
      14
      /* Extend */
    ],
    [
      /*start*/
      4213,
      0
      /* Other */
    ],
    [
      /*start*/
      4226,
      14
      /* Extend */
    ],
    [
      /*start*/
      4238,
      0
      /* Other */
    ],
    [
      /*start*/
      4239,
      14
      /* Extend */
    ],
    [
      /*start*/
      4240,
      9
      /* Numeric */
    ],
    [
      /*start*/
      4250,
      14
      /* Extend */
    ],
    [
      /*start*/
      4254,
      0
      /* Other */
    ],
    [
      /*start*/
      4256,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4294,
      0
      /* Other */
    ],
    [
      /*start*/
      4295,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4296,
      0
      /* Other */
    ],
    [
      /*start*/
      4301,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4302,
      0
      /* Other */
    ],
    [
      /*start*/
      4304,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4347,
      0
      /* Other */
    ],
    [
      /*start*/
      4348,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4681,
      0
      /* Other */
    ],
    [
      /*start*/
      4682,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4686,
      0
      /* Other */
    ],
    [
      /*start*/
      4688,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4695,
      0
      /* Other */
    ],
    [
      /*start*/
      4696,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4697,
      0
      /* Other */
    ],
    [
      /*start*/
      4698,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4702,
      0
      /* Other */
    ],
    [
      /*start*/
      4704,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4745,
      0
      /* Other */
    ],
    [
      /*start*/
      4746,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4750,
      0
      /* Other */
    ],
    [
      /*start*/
      4752,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4785,
      0
      /* Other */
    ],
    [
      /*start*/
      4786,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4790,
      0
      /* Other */
    ],
    [
      /*start*/
      4792,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4799,
      0
      /* Other */
    ],
    [
      /*start*/
      4800,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4801,
      0
      /* Other */
    ],
    [
      /*start*/
      4802,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4806,
      0
      /* Other */
    ],
    [
      /*start*/
      4808,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4823,
      0
      /* Other */
    ],
    [
      /*start*/
      4824,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4881,
      0
      /* Other */
    ],
    [
      /*start*/
      4882,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4886,
      0
      /* Other */
    ],
    [
      /*start*/
      4888,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4955,
      0
      /* Other */
    ],
    [
      /*start*/
      4957,
      14
      /* Extend */
    ],
    [
      /*start*/
      4960,
      0
      /* Other */
    ],
    [
      /*start*/
      4992,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5008,
      0
      /* Other */
    ],
    [
      /*start*/
      5024,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5110,
      0
      /* Other */
    ],
    [
      /*start*/
      5112,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5118,
      0
      /* Other */
    ],
    [
      /*start*/
      5121,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5741,
      0
      /* Other */
    ],
    [
      /*start*/
      5743,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5760,
      4
      /* WSegSpace */
    ],
    [
      /*start*/
      5761,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5787,
      0
      /* Other */
    ],
    [
      /*start*/
      5792,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5867,
      0
      /* Other */
    ],
    [
      /*start*/
      5870,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5881,
      0
      /* Other */
    ],
    [
      /*start*/
      5888,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5901,
      0
      /* Other */
    ],
    [
      /*start*/
      5902,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5906,
      14
      /* Extend */
    ],
    [
      /*start*/
      5909,
      0
      /* Other */
    ],
    [
      /*start*/
      5920,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5938,
      14
      /* Extend */
    ],
    [
      /*start*/
      5941,
      0
      /* Other */
    ],
    [
      /*start*/
      5952,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5970,
      14
      /* Extend */
    ],
    [
      /*start*/
      5972,
      0
      /* Other */
    ],
    [
      /*start*/
      5984,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5997,
      0
      /* Other */
    ],
    [
      /*start*/
      5998,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6001,
      0
      /* Other */
    ],
    [
      /*start*/
      6002,
      14
      /* Extend */
    ],
    [
      /*start*/
      6004,
      0
      /* Other */
    ],
    [
      /*start*/
      6068,
      14
      /* Extend */
    ],
    [
      /*start*/
      6100,
      0
      /* Other */
    ],
    [
      /*start*/
      6109,
      14
      /* Extend */
    ],
    [
      /*start*/
      6110,
      0
      /* Other */
    ],
    [
      /*start*/
      6112,
      9
      /* Numeric */
    ],
    [
      /*start*/
      6122,
      0
      /* Other */
    ],
    [
      /*start*/
      6155,
      14
      /* Extend */
    ],
    [
      /*start*/
      6158,
      13
      /* Format */
    ],
    [
      /*start*/
      6159,
      0
      /* Other */
    ],
    [
      /*start*/
      6160,
      9
      /* Numeric */
    ],
    [
      /*start*/
      6170,
      0
      /* Other */
    ],
    [
      /*start*/
      6176,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6265,
      0
      /* Other */
    ],
    [
      /*start*/
      6272,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6277,
      14
      /* Extend */
    ],
    [
      /*start*/
      6279,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6313,
      14
      /* Extend */
    ],
    [
      /*start*/
      6314,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6315,
      0
      /* Other */
    ],
    [
      /*start*/
      6320,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6390,
      0
      /* Other */
    ],
    [
      /*start*/
      6400,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6431,
      0
      /* Other */
    ],
    [
      /*start*/
      6432,
      14
      /* Extend */
    ],
    [
      /*start*/
      6444,
      0
      /* Other */
    ],
    [
      /*start*/
      6448,
      14
      /* Extend */
    ],
    [
      /*start*/
      6460,
      0
      /* Other */
    ],
    [
      /*start*/
      6470,
      9
      /* Numeric */
    ],
    [
      /*start*/
      6480,
      0
      /* Other */
    ],
    [
      /*start*/
      6608,
      9
      /* Numeric */
    ],
    [
      /*start*/
      6618,
      0
      /* Other */
    ],
    [
      /*start*/
      6656,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6679,
      14
      /* Extend */
    ],
    [
      /*start*/
      6684,
      0
      /* Other */
    ],
    [
      /*start*/
      6741,
      14
      /* Extend */
    ],
    [
      /*start*/
      6751,
      0
      /* Other */
    ],
    [
      /*start*/
      6752,
      14
      /* Extend */
    ],
    [
      /*start*/
      6781,
      0
      /* Other */
    ],
    [
      /*start*/
      6783,
      14
      /* Extend */
    ],
    [
      /*start*/
      6784,
      9
      /* Numeric */
    ],
    [
      /*start*/
      6794,
      0
      /* Other */
    ],
    [
      /*start*/
      6800,
      9
      /* Numeric */
    ],
    [
      /*start*/
      6810,
      0
      /* Other */
    ],
    [
      /*start*/
      6832,
      14
      /* Extend */
    ],
    [
      /*start*/
      6849,
      0
      /* Other */
    ],
    [
      /*start*/
      6912,
      14
      /* Extend */
    ],
    [
      /*start*/
      6917,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6964,
      14
      /* Extend */
    ],
    [
      /*start*/
      6981,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6988,
      0
      /* Other */
    ],
    [
      /*start*/
      6992,
      9
      /* Numeric */
    ],
    [
      /*start*/
      7002,
      0
      /* Other */
    ],
    [
      /*start*/
      7019,
      14
      /* Extend */
    ],
    [
      /*start*/
      7028,
      0
      /* Other */
    ],
    [
      /*start*/
      7040,
      14
      /* Extend */
    ],
    [
      /*start*/
      7043,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7073,
      14
      /* Extend */
    ],
    [
      /*start*/
      7086,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7088,
      9
      /* Numeric */
    ],
    [
      /*start*/
      7098,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7142,
      14
      /* Extend */
    ],
    [
      /*start*/
      7156,
      0
      /* Other */
    ],
    [
      /*start*/
      7168,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7204,
      14
      /* Extend */
    ],
    [
      /*start*/
      7224,
      0
      /* Other */
    ],
    [
      /*start*/
      7232,
      9
      /* Numeric */
    ],
    [
      /*start*/
      7242,
      0
      /* Other */
    ],
    [
      /*start*/
      7245,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7248,
      9
      /* Numeric */
    ],
    [
      /*start*/
      7258,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7294,
      0
      /* Other */
    ],
    [
      /*start*/
      7296,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7305,
      0
      /* Other */
    ],
    [
      /*start*/
      7312,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7355,
      0
      /* Other */
    ],
    [
      /*start*/
      7357,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7360,
      0
      /* Other */
    ],
    [
      /*start*/
      7376,
      14
      /* Extend */
    ],
    [
      /*start*/
      7379,
      0
      /* Other */
    ],
    [
      /*start*/
      7380,
      14
      /* Extend */
    ],
    [
      /*start*/
      7401,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7405,
      14
      /* Extend */
    ],
    [
      /*start*/
      7406,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7412,
      14
      /* Extend */
    ],
    [
      /*start*/
      7413,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7415,
      14
      /* Extend */
    ],
    [
      /*start*/
      7418,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7419,
      0
      /* Other */
    ],
    [
      /*start*/
      7424,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7616,
      14
      /* Extend */
    ],
    [
      /*start*/
      7674,
      0
      /* Other */
    ],
    [
      /*start*/
      7675,
      14
      /* Extend */
    ],
    [
      /*start*/
      7680,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7958,
      0
      /* Other */
    ],
    [
      /*start*/
      7960,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7966,
      0
      /* Other */
    ],
    [
      /*start*/
      7968,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8006,
      0
      /* Other */
    ],
    [
      /*start*/
      8008,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8014,
      0
      /* Other */
    ],
    [
      /*start*/
      8016,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8024,
      0
      /* Other */
    ],
    [
      /*start*/
      8025,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8026,
      0
      /* Other */
    ],
    [
      /*start*/
      8027,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8028,
      0
      /* Other */
    ],
    [
      /*start*/
      8029,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8030,
      0
      /* Other */
    ],
    [
      /*start*/
      8031,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8062,
      0
      /* Other */
    ],
    [
      /*start*/
      8064,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8117,
      0
      /* Other */
    ],
    [
      /*start*/
      8118,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8125,
      0
      /* Other */
    ],
    [
      /*start*/
      8126,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8127,
      0
      /* Other */
    ],
    [
      /*start*/
      8130,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8133,
      0
      /* Other */
    ],
    [
      /*start*/
      8134,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8141,
      0
      /* Other */
    ],
    [
      /*start*/
      8144,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8148,
      0
      /* Other */
    ],
    [
      /*start*/
      8150,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8156,
      0
      /* Other */
    ],
    [
      /*start*/
      8160,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8173,
      0
      /* Other */
    ],
    [
      /*start*/
      8178,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8181,
      0
      /* Other */
    ],
    [
      /*start*/
      8182,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8189,
      0
      /* Other */
    ],
    [
      /*start*/
      8192,
      4
      /* WSegSpace */
    ],
    [
      /*start*/
      8199,
      0
      /* Other */
    ],
    [
      /*start*/
      8200,
      4
      /* WSegSpace */
    ],
    [
      /*start*/
      8203,
      0
      /* Other */
    ],
    [
      /*start*/
      8204,
      14
      /* Extend */
    ],
    [
      /*start*/
      8205,
      16
      /* ZWJ */
    ],
    [
      /*start*/
      8206,
      13
      /* Format */
    ],
    [
      /*start*/
      8208,
      0
      /* Other */
    ],
    [
      /*start*/
      8216,
      8
      /* MidNumLet */
    ],
    [
      /*start*/
      8218,
      0
      /* Other */
    ],
    [
      /*start*/
      8228,
      8
      /* MidNumLet */
    ],
    [
      /*start*/
      8229,
      0
      /* Other */
    ],
    [
      /*start*/
      8231,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      8232,
      2
      /* Newline */
    ],
    [
      /*start*/
      8234,
      13
      /* Format */
    ],
    [
      /*start*/
      8239,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      8240,
      0
      /* Other */
    ],
    [
      /*start*/
      8255,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      8257,
      0
      /* Other */
    ],
    [
      /*start*/
      8260,
      7
      /* MidNum */
    ],
    [
      /*start*/
      8261,
      0
      /* Other */
    ],
    [
      /*start*/
      8276,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      8277,
      0
      /* Other */
    ],
    [
      /*start*/
      8287,
      4
      /* WSegSpace */
    ],
    [
      /*start*/
      8288,
      13
      /* Format */
    ],
    [
      /*start*/
      8293,
      0
      /* Other */
    ],
    [
      /*start*/
      8294,
      13
      /* Format */
    ],
    [
      /*start*/
      8304,
      0
      /* Other */
    ],
    [
      /*start*/
      8305,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8306,
      0
      /* Other */
    ],
    [
      /*start*/
      8319,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8320,
      0
      /* Other */
    ],
    [
      /*start*/
      8336,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8349,
      0
      /* Other */
    ],
    [
      /*start*/
      8400,
      14
      /* Extend */
    ],
    [
      /*start*/
      8433,
      0
      /* Other */
    ],
    [
      /*start*/
      8450,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8451,
      0
      /* Other */
    ],
    [
      /*start*/
      8455,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8456,
      0
      /* Other */
    ],
    [
      /*start*/
      8458,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8468,
      0
      /* Other */
    ],
    [
      /*start*/
      8469,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8470,
      0
      /* Other */
    ],
    [
      /*start*/
      8473,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8478,
      0
      /* Other */
    ],
    [
      /*start*/
      8484,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8485,
      0
      /* Other */
    ],
    [
      /*start*/
      8486,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8487,
      0
      /* Other */
    ],
    [
      /*start*/
      8488,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8489,
      0
      /* Other */
    ],
    [
      /*start*/
      8490,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8494,
      0
      /* Other */
    ],
    [
      /*start*/
      8495,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8506,
      0
      /* Other */
    ],
    [
      /*start*/
      8508,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8512,
      0
      /* Other */
    ],
    [
      /*start*/
      8517,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8522,
      0
      /* Other */
    ],
    [
      /*start*/
      8526,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8527,
      0
      /* Other */
    ],
    [
      /*start*/
      8544,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8585,
      0
      /* Other */
    ],
    [
      /*start*/
      9398,
      11
      /* ALetter */
    ],
    [
      /*start*/
      9450,
      0
      /* Other */
    ],
    [
      /*start*/
      11264,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11311,
      0
      /* Other */
    ],
    [
      /*start*/
      11312,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11359,
      0
      /* Other */
    ],
    [
      /*start*/
      11360,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11493,
      0
      /* Other */
    ],
    [
      /*start*/
      11499,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11503,
      14
      /* Extend */
    ],
    [
      /*start*/
      11506,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11508,
      0
      /* Other */
    ],
    [
      /*start*/
      11520,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11558,
      0
      /* Other */
    ],
    [
      /*start*/
      11559,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11560,
      0
      /* Other */
    ],
    [
      /*start*/
      11565,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11566,
      0
      /* Other */
    ],
    [
      /*start*/
      11568,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11624,
      0
      /* Other */
    ],
    [
      /*start*/
      11631,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11632,
      0
      /* Other */
    ],
    [
      /*start*/
      11647,
      14
      /* Extend */
    ],
    [
      /*start*/
      11648,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11671,
      0
      /* Other */
    ],
    [
      /*start*/
      11680,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11687,
      0
      /* Other */
    ],
    [
      /*start*/
      11688,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11695,
      0
      /* Other */
    ],
    [
      /*start*/
      11696,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11703,
      0
      /* Other */
    ],
    [
      /*start*/
      11704,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11711,
      0
      /* Other */
    ],
    [
      /*start*/
      11712,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11719,
      0
      /* Other */
    ],
    [
      /*start*/
      11720,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11727,
      0
      /* Other */
    ],
    [
      /*start*/
      11728,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11735,
      0
      /* Other */
    ],
    [
      /*start*/
      11736,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11743,
      0
      /* Other */
    ],
    [
      /*start*/
      11744,
      14
      /* Extend */
    ],
    [
      /*start*/
      11776,
      0
      /* Other */
    ],
    [
      /*start*/
      11823,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11824,
      0
      /* Other */
    ],
    [
      /*start*/
      12288,
      4
      /* WSegSpace */
    ],
    [
      /*start*/
      12289,
      0
      /* Other */
    ],
    [
      /*start*/
      12293,
      11
      /* ALetter */
    ],
    [
      /*start*/
      12294,
      0
      /* Other */
    ],
    [
      /*start*/
      12330,
      14
      /* Extend */
    ],
    [
      /*start*/
      12336,
      0
      /* Other */
    ],
    [
      /*start*/
      12337,
      17
      /* Katakana */
    ],
    [
      /*start*/
      12342,
      0
      /* Other */
    ],
    [
      /*start*/
      12347,
      11
      /* ALetter */
    ],
    [
      /*start*/
      12349,
      0
      /* Other */
    ],
    [
      /*start*/
      12441,
      14
      /* Extend */
    ],
    [
      /*start*/
      12443,
      17
      /* Katakana */
    ],
    [
      /*start*/
      12445,
      0
      /* Other */
    ],
    [
      /*start*/
      12448,
      17
      /* Katakana */
    ],
    [
      /*start*/
      12539,
      0
      /* Other */
    ],
    [
      /*start*/
      12540,
      17
      /* Katakana */
    ],
    [
      /*start*/
      12544,
      0
      /* Other */
    ],
    [
      /*start*/
      12549,
      11
      /* ALetter */
    ],
    [
      /*start*/
      12592,
      0
      /* Other */
    ],
    [
      /*start*/
      12593,
      11
      /* ALetter */
    ],
    [
      /*start*/
      12687,
      0
      /* Other */
    ],
    [
      /*start*/
      12704,
      11
      /* ALetter */
    ],
    [
      /*start*/
      12736,
      0
      /* Other */
    ],
    [
      /*start*/
      12784,
      17
      /* Katakana */
    ],
    [
      /*start*/
      12800,
      0
      /* Other */
    ],
    [
      /*start*/
      13008,
      17
      /* Katakana */
    ],
    [
      /*start*/
      13055,
      0
      /* Other */
    ],
    [
      /*start*/
      13056,
      17
      /* Katakana */
    ],
    [
      /*start*/
      13144,
      0
      /* Other */
    ],
    [
      /*start*/
      40960,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42125,
      0
      /* Other */
    ],
    [
      /*start*/
      42192,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42238,
      0
      /* Other */
    ],
    [
      /*start*/
      42240,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42509,
      0
      /* Other */
    ],
    [
      /*start*/
      42512,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42528,
      9
      /* Numeric */
    ],
    [
      /*start*/
      42538,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42540,
      0
      /* Other */
    ],
    [
      /*start*/
      42560,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42607,
      14
      /* Extend */
    ],
    [
      /*start*/
      42611,
      0
      /* Other */
    ],
    [
      /*start*/
      42612,
      14
      /* Extend */
    ],
    [
      /*start*/
      42622,
      0
      /* Other */
    ],
    [
      /*start*/
      42623,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42654,
      14
      /* Extend */
    ],
    [
      /*start*/
      42656,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42736,
      14
      /* Extend */
    ],
    [
      /*start*/
      42738,
      0
      /* Other */
    ],
    [
      /*start*/
      42760,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42944,
      0
      /* Other */
    ],
    [
      /*start*/
      42946,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42955,
      0
      /* Other */
    ],
    [
      /*start*/
      42997,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43010,
      14
      /* Extend */
    ],
    [
      /*start*/
      43011,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43014,
      14
      /* Extend */
    ],
    [
      /*start*/
      43015,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43019,
      14
      /* Extend */
    ],
    [
      /*start*/
      43020,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43043,
      14
      /* Extend */
    ],
    [
      /*start*/
      43048,
      0
      /* Other */
    ],
    [
      /*start*/
      43052,
      14
      /* Extend */
    ],
    [
      /*start*/
      43053,
      0
      /* Other */
    ],
    [
      /*start*/
      43072,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43124,
      0
      /* Other */
    ],
    [
      /*start*/
      43136,
      14
      /* Extend */
    ],
    [
      /*start*/
      43138,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43188,
      14
      /* Extend */
    ],
    [
      /*start*/
      43206,
      0
      /* Other */
    ],
    [
      /*start*/
      43216,
      9
      /* Numeric */
    ],
    [
      /*start*/
      43226,
      0
      /* Other */
    ],
    [
      /*start*/
      43232,
      14
      /* Extend */
    ],
    [
      /*start*/
      43250,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43256,
      0
      /* Other */
    ],
    [
      /*start*/
      43259,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43260,
      0
      /* Other */
    ],
    [
      /*start*/
      43261,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43263,
      14
      /* Extend */
    ],
    [
      /*start*/
      43264,
      9
      /* Numeric */
    ],
    [
      /*start*/
      43274,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43302,
      14
      /* Extend */
    ],
    [
      /*start*/
      43310,
      0
      /* Other */
    ],
    [
      /*start*/
      43312,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43335,
      14
      /* Extend */
    ],
    [
      /*start*/
      43348,
      0
      /* Other */
    ],
    [
      /*start*/
      43360,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43389,
      0
      /* Other */
    ],
    [
      /*start*/
      43392,
      14
      /* Extend */
    ],
    [
      /*start*/
      43396,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43443,
      14
      /* Extend */
    ],
    [
      /*start*/
      43457,
      0
      /* Other */
    ],
    [
      /*start*/
      43471,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43472,
      9
      /* Numeric */
    ],
    [
      /*start*/
      43482,
      0
      /* Other */
    ],
    [
      /*start*/
      43493,
      14
      /* Extend */
    ],
    [
      /*start*/
      43494,
      0
      /* Other */
    ],
    [
      /*start*/
      43504,
      9
      /* Numeric */
    ],
    [
      /*start*/
      43514,
      0
      /* Other */
    ],
    [
      /*start*/
      43520,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43561,
      14
      /* Extend */
    ],
    [
      /*start*/
      43575,
      0
      /* Other */
    ],
    [
      /*start*/
      43584,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43587,
      14
      /* Extend */
    ],
    [
      /*start*/
      43588,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43596,
      14
      /* Extend */
    ],
    [
      /*start*/
      43598,
      0
      /* Other */
    ],
    [
      /*start*/
      43600,
      9
      /* Numeric */
    ],
    [
      /*start*/
      43610,
      0
      /* Other */
    ],
    [
      /*start*/
      43643,
      14
      /* Extend */
    ],
    [
      /*start*/
      43646,
      0
      /* Other */
    ],
    [
      /*start*/
      43696,
      14
      /* Extend */
    ],
    [
      /*start*/
      43697,
      0
      /* Other */
    ],
    [
      /*start*/
      43698,
      14
      /* Extend */
    ],
    [
      /*start*/
      43701,
      0
      /* Other */
    ],
    [
      /*start*/
      43703,
      14
      /* Extend */
    ],
    [
      /*start*/
      43705,
      0
      /* Other */
    ],
    [
      /*start*/
      43710,
      14
      /* Extend */
    ],
    [
      /*start*/
      43712,
      0
      /* Other */
    ],
    [
      /*start*/
      43713,
      14
      /* Extend */
    ],
    [
      /*start*/
      43714,
      0
      /* Other */
    ],
    [
      /*start*/
      43744,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43755,
      14
      /* Extend */
    ],
    [
      /*start*/
      43760,
      0
      /* Other */
    ],
    [
      /*start*/
      43762,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43765,
      14
      /* Extend */
    ],
    [
      /*start*/
      43767,
      0
      /* Other */
    ],
    [
      /*start*/
      43777,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43783,
      0
      /* Other */
    ],
    [
      /*start*/
      43785,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43791,
      0
      /* Other */
    ],
    [
      /*start*/
      43793,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43799,
      0
      /* Other */
    ],
    [
      /*start*/
      43808,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43815,
      0
      /* Other */
    ],
    [
      /*start*/
      43816,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43823,
      0
      /* Other */
    ],
    [
      /*start*/
      43824,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43882,
      0
      /* Other */
    ],
    [
      /*start*/
      43888,
      11
      /* ALetter */
    ],
    [
      /*start*/
      44003,
      14
      /* Extend */
    ],
    [
      /*start*/
      44011,
      0
      /* Other */
    ],
    [
      /*start*/
      44012,
      14
      /* Extend */
    ],
    [
      /*start*/
      44014,
      0
      /* Other */
    ],
    [
      /*start*/
      44016,
      9
      /* Numeric */
    ],
    [
      /*start*/
      44026,
      0
      /* Other */
    ],
    [
      /*start*/
      44032,
      11
      /* ALetter */
    ],
    [
      /*start*/
      55204,
      0
      /* Other */
    ],
    [
      /*start*/
      55216,
      11
      /* ALetter */
    ],
    [
      /*start*/
      55239,
      0
      /* Other */
    ],
    [
      /*start*/
      55243,
      11
      /* ALetter */
    ],
    [
      /*start*/
      55292,
      0
      /* Other */
    ],
    [
      /*start*/
      64256,
      11
      /* ALetter */
    ],
    [
      /*start*/
      64263,
      0
      /* Other */
    ],
    [
      /*start*/
      64275,
      11
      /* ALetter */
    ],
    [
      /*start*/
      64280,
      0
      /* Other */
    ],
    [
      /*start*/
      64285,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64286,
      14
      /* Extend */
    ],
    [
      /*start*/
      64287,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64297,
      0
      /* Other */
    ],
    [
      /*start*/
      64298,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64311,
      0
      /* Other */
    ],
    [
      /*start*/
      64312,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64317,
      0
      /* Other */
    ],
    [
      /*start*/
      64318,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64319,
      0
      /* Other */
    ],
    [
      /*start*/
      64320,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64322,
      0
      /* Other */
    ],
    [
      /*start*/
      64323,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64325,
      0
      /* Other */
    ],
    [
      /*start*/
      64326,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64336,
      11
      /* ALetter */
    ],
    [
      /*start*/
      64434,
      0
      /* Other */
    ],
    [
      /*start*/
      64467,
      11
      /* ALetter */
    ],
    [
      /*start*/
      64830,
      0
      /* Other */
    ],
    [
      /*start*/
      64848,
      11
      /* ALetter */
    ],
    [
      /*start*/
      64912,
      0
      /* Other */
    ],
    [
      /*start*/
      64914,
      11
      /* ALetter */
    ],
    [
      /*start*/
      64968,
      0
      /* Other */
    ],
    [
      /*start*/
      65008,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65020,
      0
      /* Other */
    ],
    [
      /*start*/
      65024,
      14
      /* Extend */
    ],
    [
      /*start*/
      65040,
      7
      /* MidNum */
    ],
    [
      /*start*/
      65041,
      0
      /* Other */
    ],
    [
      /*start*/
      65043,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      65044,
      7
      /* MidNum */
    ],
    [
      /*start*/
      65045,
      0
      /* Other */
    ],
    [
      /*start*/
      65056,
      14
      /* Extend */
    ],
    [
      /*start*/
      65072,
      0
      /* Other */
    ],
    [
      /*start*/
      65075,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      65077,
      0
      /* Other */
    ],
    [
      /*start*/
      65101,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      65104,
      7
      /* MidNum */
    ],
    [
      /*start*/
      65105,
      0
      /* Other */
    ],
    [
      /*start*/
      65106,
      8
      /* MidNumLet */
    ],
    [
      /*start*/
      65107,
      0
      /* Other */
    ],
    [
      /*start*/
      65108,
      7
      /* MidNum */
    ],
    [
      /*start*/
      65109,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      65110,
      0
      /* Other */
    ],
    [
      /*start*/
      65136,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65141,
      0
      /* Other */
    ],
    [
      /*start*/
      65142,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65277,
      0
      /* Other */
    ],
    [
      /*start*/
      65279,
      13
      /* Format */
    ],
    [
      /*start*/
      65280,
      0
      /* Other */
    ],
    [
      /*start*/
      65287,
      8
      /* MidNumLet */
    ],
    [
      /*start*/
      65288,
      0
      /* Other */
    ],
    [
      /*start*/
      65292,
      7
      /* MidNum */
    ],
    [
      /*start*/
      65293,
      0
      /* Other */
    ],
    [
      /*start*/
      65294,
      8
      /* MidNumLet */
    ],
    [
      /*start*/
      65295,
      0
      /* Other */
    ],
    [
      /*start*/
      65296,
      9
      /* Numeric */
    ],
    [
      /*start*/
      65306,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      65307,
      7
      /* MidNum */
    ],
    [
      /*start*/
      65308,
      0
      /* Other */
    ],
    [
      /*start*/
      65313,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65339,
      0
      /* Other */
    ],
    [
      /*start*/
      65343,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      65344,
      0
      /* Other */
    ],
    [
      /*start*/
      65345,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65371,
      0
      /* Other */
    ],
    [
      /*start*/
      65382,
      17
      /* Katakana */
    ],
    [
      /*start*/
      65438,
      14
      /* Extend */
    ],
    [
      /*start*/
      65440,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65471,
      0
      /* Other */
    ],
    [
      /*start*/
      65474,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65480,
      0
      /* Other */
    ],
    [
      /*start*/
      65482,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65488,
      0
      /* Other */
    ],
    [
      /*start*/
      65490,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65496,
      0
      /* Other */
    ],
    [
      /*start*/
      65498,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65501,
      0
      /* Other */
    ],
    [
      /*start*/
      65529,
      13
      /* Format */
    ],
    [
      /*start*/
      65532,
      0
      /* Other */
    ],
    [
      /*start*/
      65536,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65548,
      0
      /* Other */
    ],
    [
      /*start*/
      65549,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65575,
      0
      /* Other */
    ],
    [
      /*start*/
      65576,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65595,
      0
      /* Other */
    ],
    [
      /*start*/
      65596,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65598,
      0
      /* Other */
    ],
    [
      /*start*/
      65599,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65614,
      0
      /* Other */
    ],
    [
      /*start*/
      65616,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65630,
      0
      /* Other */
    ],
    [
      /*start*/
      65664,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65787,
      0
      /* Other */
    ],
    [
      /*start*/
      65856,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65909,
      0
      /* Other */
    ],
    [
      /*start*/
      66045,
      14
      /* Extend */
    ],
    [
      /*start*/
      66046,
      0
      /* Other */
    ],
    [
      /*start*/
      66176,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66205,
      0
      /* Other */
    ],
    [
      /*start*/
      66208,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66257,
      0
      /* Other */
    ],
    [
      /*start*/
      66272,
      14
      /* Extend */
    ],
    [
      /*start*/
      66273,
      0
      /* Other */
    ],
    [
      /*start*/
      66304,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66336,
      0
      /* Other */
    ],
    [
      /*start*/
      66349,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66379,
      0
      /* Other */
    ],
    [
      /*start*/
      66384,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66422,
      14
      /* Extend */
    ],
    [
      /*start*/
      66427,
      0
      /* Other */
    ],
    [
      /*start*/
      66432,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66462,
      0
      /* Other */
    ],
    [
      /*start*/
      66464,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66500,
      0
      /* Other */
    ],
    [
      /*start*/
      66504,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66512,
      0
      /* Other */
    ],
    [
      /*start*/
      66513,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66518,
      0
      /* Other */
    ],
    [
      /*start*/
      66560,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66718,
      0
      /* Other */
    ],
    [
      /*start*/
      66720,
      9
      /* Numeric */
    ],
    [
      /*start*/
      66730,
      0
      /* Other */
    ],
    [
      /*start*/
      66736,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66772,
      0
      /* Other */
    ],
    [
      /*start*/
      66776,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66812,
      0
      /* Other */
    ],
    [
      /*start*/
      66816,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66856,
      0
      /* Other */
    ],
    [
      /*start*/
      66864,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66916,
      0
      /* Other */
    ],
    [
      /*start*/
      67072,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67383,
      0
      /* Other */
    ],
    [
      /*start*/
      67392,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67414,
      0
      /* Other */
    ],
    [
      /*start*/
      67424,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67432,
      0
      /* Other */
    ],
    [
      /*start*/
      67584,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67590,
      0
      /* Other */
    ],
    [
      /*start*/
      67592,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67593,
      0
      /* Other */
    ],
    [
      /*start*/
      67594,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67638,
      0
      /* Other */
    ],
    [
      /*start*/
      67639,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67641,
      0
      /* Other */
    ],
    [
      /*start*/
      67644,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67645,
      0
      /* Other */
    ],
    [
      /*start*/
      67647,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67670,
      0
      /* Other */
    ],
    [
      /*start*/
      67680,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67703,
      0
      /* Other */
    ],
    [
      /*start*/
      67712,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67743,
      0
      /* Other */
    ],
    [
      /*start*/
      67808,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67827,
      0
      /* Other */
    ],
    [
      /*start*/
      67828,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67830,
      0
      /* Other */
    ],
    [
      /*start*/
      67840,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67862,
      0
      /* Other */
    ],
    [
      /*start*/
      67872,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67898,
      0
      /* Other */
    ],
    [
      /*start*/
      67968,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68024,
      0
      /* Other */
    ],
    [
      /*start*/
      68030,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68032,
      0
      /* Other */
    ],
    [
      /*start*/
      68096,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68097,
      14
      /* Extend */
    ],
    [
      /*start*/
      68100,
      0
      /* Other */
    ],
    [
      /*start*/
      68101,
      14
      /* Extend */
    ],
    [
      /*start*/
      68103,
      0
      /* Other */
    ],
    [
      /*start*/
      68108,
      14
      /* Extend */
    ],
    [
      /*start*/
      68112,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68116,
      0
      /* Other */
    ],
    [
      /*start*/
      68117,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68120,
      0
      /* Other */
    ],
    [
      /*start*/
      68121,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68150,
      0
      /* Other */
    ],
    [
      /*start*/
      68152,
      14
      /* Extend */
    ],
    [
      /*start*/
      68155,
      0
      /* Other */
    ],
    [
      /*start*/
      68159,
      14
      /* Extend */
    ],
    [
      /*start*/
      68160,
      0
      /* Other */
    ],
    [
      /*start*/
      68192,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68221,
      0
      /* Other */
    ],
    [
      /*start*/
      68224,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68253,
      0
      /* Other */
    ],
    [
      /*start*/
      68288,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68296,
      0
      /* Other */
    ],
    [
      /*start*/
      68297,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68325,
      14
      /* Extend */
    ],
    [
      /*start*/
      68327,
      0
      /* Other */
    ],
    [
      /*start*/
      68352,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68406,
      0
      /* Other */
    ],
    [
      /*start*/
      68416,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68438,
      0
      /* Other */
    ],
    [
      /*start*/
      68448,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68467,
      0
      /* Other */
    ],
    [
      /*start*/
      68480,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68498,
      0
      /* Other */
    ],
    [
      /*start*/
      68608,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68681,
      0
      /* Other */
    ],
    [
      /*start*/
      68736,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68787,
      0
      /* Other */
    ],
    [
      /*start*/
      68800,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68851,
      0
      /* Other */
    ],
    [
      /*start*/
      68864,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68900,
      14
      /* Extend */
    ],
    [
      /*start*/
      68904,
      0
      /* Other */
    ],
    [
      /*start*/
      68912,
      9
      /* Numeric */
    ],
    [
      /*start*/
      68922,
      0
      /* Other */
    ],
    [
      /*start*/
      69248,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69290,
      0
      /* Other */
    ],
    [
      /*start*/
      69291,
      14
      /* Extend */
    ],
    [
      /*start*/
      69293,
      0
      /* Other */
    ],
    [
      /*start*/
      69296,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69298,
      0
      /* Other */
    ],
    [
      /*start*/
      69376,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69405,
      0
      /* Other */
    ],
    [
      /*start*/
      69415,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69416,
      0
      /* Other */
    ],
    [
      /*start*/
      69424,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69446,
      14
      /* Extend */
    ],
    [
      /*start*/
      69457,
      0
      /* Other */
    ],
    [
      /*start*/
      69552,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69573,
      0
      /* Other */
    ],
    [
      /*start*/
      69600,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69623,
      0
      /* Other */
    ],
    [
      /*start*/
      69632,
      14
      /* Extend */
    ],
    [
      /*start*/
      69635,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69688,
      14
      /* Extend */
    ],
    [
      /*start*/
      69703,
      0
      /* Other */
    ],
    [
      /*start*/
      69734,
      9
      /* Numeric */
    ],
    [
      /*start*/
      69744,
      0
      /* Other */
    ],
    [
      /*start*/
      69759,
      14
      /* Extend */
    ],
    [
      /*start*/
      69763,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69808,
      14
      /* Extend */
    ],
    [
      /*start*/
      69819,
      0
      /* Other */
    ],
    [
      /*start*/
      69821,
      13
      /* Format */
    ],
    [
      /*start*/
      69822,
      0
      /* Other */
    ],
    [
      /*start*/
      69837,
      13
      /* Format */
    ],
    [
      /*start*/
      69838,
      0
      /* Other */
    ],
    [
      /*start*/
      69840,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69865,
      0
      /* Other */
    ],
    [
      /*start*/
      69872,
      9
      /* Numeric */
    ],
    [
      /*start*/
      69882,
      0
      /* Other */
    ],
    [
      /*start*/
      69888,
      14
      /* Extend */
    ],
    [
      /*start*/
      69891,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69927,
      14
      /* Extend */
    ],
    [
      /*start*/
      69941,
      0
      /* Other */
    ],
    [
      /*start*/
      69942,
      9
      /* Numeric */
    ],
    [
      /*start*/
      69952,
      0
      /* Other */
    ],
    [
      /*start*/
      69956,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69957,
      14
      /* Extend */
    ],
    [
      /*start*/
      69959,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69960,
      0
      /* Other */
    ],
    [
      /*start*/
      69968,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70003,
      14
      /* Extend */
    ],
    [
      /*start*/
      70004,
      0
      /* Other */
    ],
    [
      /*start*/
      70006,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70007,
      0
      /* Other */
    ],
    [
      /*start*/
      70016,
      14
      /* Extend */
    ],
    [
      /*start*/
      70019,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70067,
      14
      /* Extend */
    ],
    [
      /*start*/
      70081,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70085,
      0
      /* Other */
    ],
    [
      /*start*/
      70089,
      14
      /* Extend */
    ],
    [
      /*start*/
      70093,
      0
      /* Other */
    ],
    [
      /*start*/
      70094,
      14
      /* Extend */
    ],
    [
      /*start*/
      70096,
      9
      /* Numeric */
    ],
    [
      /*start*/
      70106,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70107,
      0
      /* Other */
    ],
    [
      /*start*/
      70108,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70109,
      0
      /* Other */
    ],
    [
      /*start*/
      70144,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70162,
      0
      /* Other */
    ],
    [
      /*start*/
      70163,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70188,
      14
      /* Extend */
    ],
    [
      /*start*/
      70200,
      0
      /* Other */
    ],
    [
      /*start*/
      70206,
      14
      /* Extend */
    ],
    [
      /*start*/
      70207,
      0
      /* Other */
    ],
    [
      /*start*/
      70272,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70279,
      0
      /* Other */
    ],
    [
      /*start*/
      70280,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70281,
      0
      /* Other */
    ],
    [
      /*start*/
      70282,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70286,
      0
      /* Other */
    ],
    [
      /*start*/
      70287,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70302,
      0
      /* Other */
    ],
    [
      /*start*/
      70303,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70313,
      0
      /* Other */
    ],
    [
      /*start*/
      70320,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70367,
      14
      /* Extend */
    ],
    [
      /*start*/
      70379,
      0
      /* Other */
    ],
    [
      /*start*/
      70384,
      9
      /* Numeric */
    ],
    [
      /*start*/
      70394,
      0
      /* Other */
    ],
    [
      /*start*/
      70400,
      14
      /* Extend */
    ],
    [
      /*start*/
      70404,
      0
      /* Other */
    ],
    [
      /*start*/
      70405,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70413,
      0
      /* Other */
    ],
    [
      /*start*/
      70415,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70417,
      0
      /* Other */
    ],
    [
      /*start*/
      70419,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70441,
      0
      /* Other */
    ],
    [
      /*start*/
      70442,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70449,
      0
      /* Other */
    ],
    [
      /*start*/
      70450,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70452,
      0
      /* Other */
    ],
    [
      /*start*/
      70453,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70458,
      0
      /* Other */
    ],
    [
      /*start*/
      70459,
      14
      /* Extend */
    ],
    [
      /*start*/
      70461,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70462,
      14
      /* Extend */
    ],
    [
      /*start*/
      70469,
      0
      /* Other */
    ],
    [
      /*start*/
      70471,
      14
      /* Extend */
    ],
    [
      /*start*/
      70473,
      0
      /* Other */
    ],
    [
      /*start*/
      70475,
      14
      /* Extend */
    ],
    [
      /*start*/
      70478,
      0
      /* Other */
    ],
    [
      /*start*/
      70480,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70481,
      0
      /* Other */
    ],
    [
      /*start*/
      70487,
      14
      /* Extend */
    ],
    [
      /*start*/
      70488,
      0
      /* Other */
    ],
    [
      /*start*/
      70493,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70498,
      14
      /* Extend */
    ],
    [
      /*start*/
      70500,
      0
      /* Other */
    ],
    [
      /*start*/
      70502,
      14
      /* Extend */
    ],
    [
      /*start*/
      70509,
      0
      /* Other */
    ],
    [
      /*start*/
      70512,
      14
      /* Extend */
    ],
    [
      /*start*/
      70517,
      0
      /* Other */
    ],
    [
      /*start*/
      70656,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70709,
      14
      /* Extend */
    ],
    [
      /*start*/
      70727,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70731,
      0
      /* Other */
    ],
    [
      /*start*/
      70736,
      9
      /* Numeric */
    ],
    [
      /*start*/
      70746,
      0
      /* Other */
    ],
    [
      /*start*/
      70750,
      14
      /* Extend */
    ],
    [
      /*start*/
      70751,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70754,
      0
      /* Other */
    ],
    [
      /*start*/
      70784,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70832,
      14
      /* Extend */
    ],
    [
      /*start*/
      70852,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70854,
      0
      /* Other */
    ],
    [
      /*start*/
      70855,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70856,
      0
      /* Other */
    ],
    [
      /*start*/
      70864,
      9
      /* Numeric */
    ],
    [
      /*start*/
      70874,
      0
      /* Other */
    ],
    [
      /*start*/
      71040,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71087,
      14
      /* Extend */
    ],
    [
      /*start*/
      71094,
      0
      /* Other */
    ],
    [
      /*start*/
      71096,
      14
      /* Extend */
    ],
    [
      /*start*/
      71105,
      0
      /* Other */
    ],
    [
      /*start*/
      71128,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71132,
      14
      /* Extend */
    ],
    [
      /*start*/
      71134,
      0
      /* Other */
    ],
    [
      /*start*/
      71168,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71216,
      14
      /* Extend */
    ],
    [
      /*start*/
      71233,
      0
      /* Other */
    ],
    [
      /*start*/
      71236,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71237,
      0
      /* Other */
    ],
    [
      /*start*/
      71248,
      9
      /* Numeric */
    ],
    [
      /*start*/
      71258,
      0
      /* Other */
    ],
    [
      /*start*/
      71296,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71339,
      14
      /* Extend */
    ],
    [
      /*start*/
      71352,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71353,
      0
      /* Other */
    ],
    [
      /*start*/
      71360,
      9
      /* Numeric */
    ],
    [
      /*start*/
      71370,
      0
      /* Other */
    ],
    [
      /*start*/
      71453,
      14
      /* Extend */
    ],
    [
      /*start*/
      71468,
      0
      /* Other */
    ],
    [
      /*start*/
      71472,
      9
      /* Numeric */
    ],
    [
      /*start*/
      71482,
      0
      /* Other */
    ],
    [
      /*start*/
      71680,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71724,
      14
      /* Extend */
    ],
    [
      /*start*/
      71739,
      0
      /* Other */
    ],
    [
      /*start*/
      71840,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71904,
      9
      /* Numeric */
    ],
    [
      /*start*/
      71914,
      0
      /* Other */
    ],
    [
      /*start*/
      71935,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71943,
      0
      /* Other */
    ],
    [
      /*start*/
      71945,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71946,
      0
      /* Other */
    ],
    [
      /*start*/
      71948,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71956,
      0
      /* Other */
    ],
    [
      /*start*/
      71957,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71959,
      0
      /* Other */
    ],
    [
      /*start*/
      71960,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71984,
      14
      /* Extend */
    ],
    [
      /*start*/
      71990,
      0
      /* Other */
    ],
    [
      /*start*/
      71991,
      14
      /* Extend */
    ],
    [
      /*start*/
      71993,
      0
      /* Other */
    ],
    [
      /*start*/
      71995,
      14
      /* Extend */
    ],
    [
      /*start*/
      71999,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72e3,
      14
      /* Extend */
    ],
    [
      /*start*/
      72001,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72002,
      14
      /* Extend */
    ],
    [
      /*start*/
      72004,
      0
      /* Other */
    ],
    [
      /*start*/
      72016,
      9
      /* Numeric */
    ],
    [
      /*start*/
      72026,
      0
      /* Other */
    ],
    [
      /*start*/
      72096,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72104,
      0
      /* Other */
    ],
    [
      /*start*/
      72106,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72145,
      14
      /* Extend */
    ],
    [
      /*start*/
      72152,
      0
      /* Other */
    ],
    [
      /*start*/
      72154,
      14
      /* Extend */
    ],
    [
      /*start*/
      72161,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72162,
      0
      /* Other */
    ],
    [
      /*start*/
      72163,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72164,
      14
      /* Extend */
    ],
    [
      /*start*/
      72165,
      0
      /* Other */
    ],
    [
      /*start*/
      72192,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72193,
      14
      /* Extend */
    ],
    [
      /*start*/
      72203,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72243,
      14
      /* Extend */
    ],
    [
      /*start*/
      72250,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72251,
      14
      /* Extend */
    ],
    [
      /*start*/
      72255,
      0
      /* Other */
    ],
    [
      /*start*/
      72263,
      14
      /* Extend */
    ],
    [
      /*start*/
      72264,
      0
      /* Other */
    ],
    [
      /*start*/
      72272,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72273,
      14
      /* Extend */
    ],
    [
      /*start*/
      72284,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72330,
      14
      /* Extend */
    ],
    [
      /*start*/
      72346,
      0
      /* Other */
    ],
    [
      /*start*/
      72349,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72350,
      0
      /* Other */
    ],
    [
      /*start*/
      72384,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72441,
      0
      /* Other */
    ],
    [
      /*start*/
      72704,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72713,
      0
      /* Other */
    ],
    [
      /*start*/
      72714,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72751,
      14
      /* Extend */
    ],
    [
      /*start*/
      72759,
      0
      /* Other */
    ],
    [
      /*start*/
      72760,
      14
      /* Extend */
    ],
    [
      /*start*/
      72768,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72769,
      0
      /* Other */
    ],
    [
      /*start*/
      72784,
      9
      /* Numeric */
    ],
    [
      /*start*/
      72794,
      0
      /* Other */
    ],
    [
      /*start*/
      72818,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72848,
      0
      /* Other */
    ],
    [
      /*start*/
      72850,
      14
      /* Extend */
    ],
    [
      /*start*/
      72872,
      0
      /* Other */
    ],
    [
      /*start*/
      72873,
      14
      /* Extend */
    ],
    [
      /*start*/
      72887,
      0
      /* Other */
    ],
    [
      /*start*/
      72960,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72967,
      0
      /* Other */
    ],
    [
      /*start*/
      72968,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72970,
      0
      /* Other */
    ],
    [
      /*start*/
      72971,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73009,
      14
      /* Extend */
    ],
    [
      /*start*/
      73015,
      0
      /* Other */
    ],
    [
      /*start*/
      73018,
      14
      /* Extend */
    ],
    [
      /*start*/
      73019,
      0
      /* Other */
    ],
    [
      /*start*/
      73020,
      14
      /* Extend */
    ],
    [
      /*start*/
      73022,
      0
      /* Other */
    ],
    [
      /*start*/
      73023,
      14
      /* Extend */
    ],
    [
      /*start*/
      73030,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73031,
      14
      /* Extend */
    ],
    [
      /*start*/
      73032,
      0
      /* Other */
    ],
    [
      /*start*/
      73040,
      9
      /* Numeric */
    ],
    [
      /*start*/
      73050,
      0
      /* Other */
    ],
    [
      /*start*/
      73056,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73062,
      0
      /* Other */
    ],
    [
      /*start*/
      73063,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73065,
      0
      /* Other */
    ],
    [
      /*start*/
      73066,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73098,
      14
      /* Extend */
    ],
    [
      /*start*/
      73103,
      0
      /* Other */
    ],
    [
      /*start*/
      73104,
      14
      /* Extend */
    ],
    [
      /*start*/
      73106,
      0
      /* Other */
    ],
    [
      /*start*/
      73107,
      14
      /* Extend */
    ],
    [
      /*start*/
      73112,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73113,
      0
      /* Other */
    ],
    [
      /*start*/
      73120,
      9
      /* Numeric */
    ],
    [
      /*start*/
      73130,
      0
      /* Other */
    ],
    [
      /*start*/
      73440,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73459,
      14
      /* Extend */
    ],
    [
      /*start*/
      73463,
      0
      /* Other */
    ],
    [
      /*start*/
      73648,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73649,
      0
      /* Other */
    ],
    [
      /*start*/
      73728,
      11
      /* ALetter */
    ],
    [
      /*start*/
      74650,
      0
      /* Other */
    ],
    [
      /*start*/
      74752,
      11
      /* ALetter */
    ],
    [
      /*start*/
      74863,
      0
      /* Other */
    ],
    [
      /*start*/
      74880,
      11
      /* ALetter */
    ],
    [
      /*start*/
      75076,
      0
      /* Other */
    ],
    [
      /*start*/
      77824,
      11
      /* ALetter */
    ],
    [
      /*start*/
      78895,
      0
      /* Other */
    ],
    [
      /*start*/
      78896,
      13
      /* Format */
    ],
    [
      /*start*/
      78905,
      0
      /* Other */
    ],
    [
      /*start*/
      82944,
      11
      /* ALetter */
    ],
    [
      /*start*/
      83527,
      0
      /* Other */
    ],
    [
      /*start*/
      92160,
      11
      /* ALetter */
    ],
    [
      /*start*/
      92729,
      0
      /* Other */
    ],
    [
      /*start*/
      92736,
      11
      /* ALetter */
    ],
    [
      /*start*/
      92767,
      0
      /* Other */
    ],
    [
      /*start*/
      92768,
      9
      /* Numeric */
    ],
    [
      /*start*/
      92778,
      0
      /* Other */
    ],
    [
      /*start*/
      92880,
      11
      /* ALetter */
    ],
    [
      /*start*/
      92910,
      0
      /* Other */
    ],
    [
      /*start*/
      92912,
      14
      /* Extend */
    ],
    [
      /*start*/
      92917,
      0
      /* Other */
    ],
    [
      /*start*/
      92928,
      11
      /* ALetter */
    ],
    [
      /*start*/
      92976,
      14
      /* Extend */
    ],
    [
      /*start*/
      92983,
      0
      /* Other */
    ],
    [
      /*start*/
      92992,
      11
      /* ALetter */
    ],
    [
      /*start*/
      92996,
      0
      /* Other */
    ],
    [
      /*start*/
      93008,
      9
      /* Numeric */
    ],
    [
      /*start*/
      93018,
      0
      /* Other */
    ],
    [
      /*start*/
      93027,
      11
      /* ALetter */
    ],
    [
      /*start*/
      93048,
      0
      /* Other */
    ],
    [
      /*start*/
      93053,
      11
      /* ALetter */
    ],
    [
      /*start*/
      93072,
      0
      /* Other */
    ],
    [
      /*start*/
      93760,
      11
      /* ALetter */
    ],
    [
      /*start*/
      93824,
      0
      /* Other */
    ],
    [
      /*start*/
      93952,
      11
      /* ALetter */
    ],
    [
      /*start*/
      94027,
      0
      /* Other */
    ],
    [
      /*start*/
      94031,
      14
      /* Extend */
    ],
    [
      /*start*/
      94032,
      11
      /* ALetter */
    ],
    [
      /*start*/
      94033,
      14
      /* Extend */
    ],
    [
      /*start*/
      94088,
      0
      /* Other */
    ],
    [
      /*start*/
      94095,
      14
      /* Extend */
    ],
    [
      /*start*/
      94099,
      11
      /* ALetter */
    ],
    [
      /*start*/
      94112,
      0
      /* Other */
    ],
    [
      /*start*/
      94176,
      11
      /* ALetter */
    ],
    [
      /*start*/
      94178,
      0
      /* Other */
    ],
    [
      /*start*/
      94179,
      11
      /* ALetter */
    ],
    [
      /*start*/
      94180,
      14
      /* Extend */
    ],
    [
      /*start*/
      94181,
      0
      /* Other */
    ],
    [
      /*start*/
      94192,
      14
      /* Extend */
    ],
    [
      /*start*/
      94194,
      0
      /* Other */
    ],
    [
      /*start*/
      110592,
      17
      /* Katakana */
    ],
    [
      /*start*/
      110593,
      0
      /* Other */
    ],
    [
      /*start*/
      110948,
      17
      /* Katakana */
    ],
    [
      /*start*/
      110952,
      0
      /* Other */
    ],
    [
      /*start*/
      113664,
      11
      /* ALetter */
    ],
    [
      /*start*/
      113771,
      0
      /* Other */
    ],
    [
      /*start*/
      113776,
      11
      /* ALetter */
    ],
    [
      /*start*/
      113789,
      0
      /* Other */
    ],
    [
      /*start*/
      113792,
      11
      /* ALetter */
    ],
    [
      /*start*/
      113801,
      0
      /* Other */
    ],
    [
      /*start*/
      113808,
      11
      /* ALetter */
    ],
    [
      /*start*/
      113818,
      0
      /* Other */
    ],
    [
      /*start*/
      113821,
      14
      /* Extend */
    ],
    [
      /*start*/
      113823,
      0
      /* Other */
    ],
    [
      /*start*/
      113824,
      13
      /* Format */
    ],
    [
      /*start*/
      113828,
      0
      /* Other */
    ],
    [
      /*start*/
      119141,
      14
      /* Extend */
    ],
    [
      /*start*/
      119146,
      0
      /* Other */
    ],
    [
      /*start*/
      119149,
      14
      /* Extend */
    ],
    [
      /*start*/
      119155,
      13
      /* Format */
    ],
    [
      /*start*/
      119163,
      14
      /* Extend */
    ],
    [
      /*start*/
      119171,
      0
      /* Other */
    ],
    [
      /*start*/
      119173,
      14
      /* Extend */
    ],
    [
      /*start*/
      119180,
      0
      /* Other */
    ],
    [
      /*start*/
      119210,
      14
      /* Extend */
    ],
    [
      /*start*/
      119214,
      0
      /* Other */
    ],
    [
      /*start*/
      119362,
      14
      /* Extend */
    ],
    [
      /*start*/
      119365,
      0
      /* Other */
    ],
    [
      /*start*/
      119808,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119893,
      0
      /* Other */
    ],
    [
      /*start*/
      119894,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119965,
      0
      /* Other */
    ],
    [
      /*start*/
      119966,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119968,
      0
      /* Other */
    ],
    [
      /*start*/
      119970,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119971,
      0
      /* Other */
    ],
    [
      /*start*/
      119973,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119975,
      0
      /* Other */
    ],
    [
      /*start*/
      119977,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119981,
      0
      /* Other */
    ],
    [
      /*start*/
      119982,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119994,
      0
      /* Other */
    ],
    [
      /*start*/
      119995,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119996,
      0
      /* Other */
    ],
    [
      /*start*/
      119997,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120004,
      0
      /* Other */
    ],
    [
      /*start*/
      120005,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120070,
      0
      /* Other */
    ],
    [
      /*start*/
      120071,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120075,
      0
      /* Other */
    ],
    [
      /*start*/
      120077,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120085,
      0
      /* Other */
    ],
    [
      /*start*/
      120086,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120093,
      0
      /* Other */
    ],
    [
      /*start*/
      120094,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120122,
      0
      /* Other */
    ],
    [
      /*start*/
      120123,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120127,
      0
      /* Other */
    ],
    [
      /*start*/
      120128,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120133,
      0
      /* Other */
    ],
    [
      /*start*/
      120134,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120135,
      0
      /* Other */
    ],
    [
      /*start*/
      120138,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120145,
      0
      /* Other */
    ],
    [
      /*start*/
      120146,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120486,
      0
      /* Other */
    ],
    [
      /*start*/
      120488,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120513,
      0
      /* Other */
    ],
    [
      /*start*/
      120514,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120539,
      0
      /* Other */
    ],
    [
      /*start*/
      120540,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120571,
      0
      /* Other */
    ],
    [
      /*start*/
      120572,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120597,
      0
      /* Other */
    ],
    [
      /*start*/
      120598,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120629,
      0
      /* Other */
    ],
    [
      /*start*/
      120630,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120655,
      0
      /* Other */
    ],
    [
      /*start*/
      120656,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120687,
      0
      /* Other */
    ],
    [
      /*start*/
      120688,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120713,
      0
      /* Other */
    ],
    [
      /*start*/
      120714,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120745,
      0
      /* Other */
    ],
    [
      /*start*/
      120746,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120771,
      0
      /* Other */
    ],
    [
      /*start*/
      120772,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120780,
      0
      /* Other */
    ],
    [
      /*start*/
      120782,
      9
      /* Numeric */
    ],
    [
      /*start*/
      120832,
      0
      /* Other */
    ],
    [
      /*start*/
      121344,
      14
      /* Extend */
    ],
    [
      /*start*/
      121399,
      0
      /* Other */
    ],
    [
      /*start*/
      121403,
      14
      /* Extend */
    ],
    [
      /*start*/
      121453,
      0
      /* Other */
    ],
    [
      /*start*/
      121461,
      14
      /* Extend */
    ],
    [
      /*start*/
      121462,
      0
      /* Other */
    ],
    [
      /*start*/
      121476,
      14
      /* Extend */
    ],
    [
      /*start*/
      121477,
      0
      /* Other */
    ],
    [
      /*start*/
      121499,
      14
      /* Extend */
    ],
    [
      /*start*/
      121504,
      0
      /* Other */
    ],
    [
      /*start*/
      121505,
      14
      /* Extend */
    ],
    [
      /*start*/
      121520,
      0
      /* Other */
    ],
    [
      /*start*/
      122880,
      14
      /* Extend */
    ],
    [
      /*start*/
      122887,
      0
      /* Other */
    ],
    [
      /*start*/
      122888,
      14
      /* Extend */
    ],
    [
      /*start*/
      122905,
      0
      /* Other */
    ],
    [
      /*start*/
      122907,
      14
      /* Extend */
    ],
    [
      /*start*/
      122914,
      0
      /* Other */
    ],
    [
      /*start*/
      122915,
      14
      /* Extend */
    ],
    [
      /*start*/
      122917,
      0
      /* Other */
    ],
    [
      /*start*/
      122918,
      14
      /* Extend */
    ],
    [
      /*start*/
      122923,
      0
      /* Other */
    ],
    [
      /*start*/
      123136,
      11
      /* ALetter */
    ],
    [
      /*start*/
      123181,
      0
      /* Other */
    ],
    [
      /*start*/
      123184,
      14
      /* Extend */
    ],
    [
      /*start*/
      123191,
      11
      /* ALetter */
    ],
    [
      /*start*/
      123198,
      0
      /* Other */
    ],
    [
      /*start*/
      123200,
      9
      /* Numeric */
    ],
    [
      /*start*/
      123210,
      0
      /* Other */
    ],
    [
      /*start*/
      123214,
      11
      /* ALetter */
    ],
    [
      /*start*/
      123215,
      0
      /* Other */
    ],
    [
      /*start*/
      123584,
      11
      /* ALetter */
    ],
    [
      /*start*/
      123628,
      14
      /* Extend */
    ],
    [
      /*start*/
      123632,
      9
      /* Numeric */
    ],
    [
      /*start*/
      123642,
      0
      /* Other */
    ],
    [
      /*start*/
      124928,
      11
      /* ALetter */
    ],
    [
      /*start*/
      125125,
      0
      /* Other */
    ],
    [
      /*start*/
      125136,
      14
      /* Extend */
    ],
    [
      /*start*/
      125143,
      0
      /* Other */
    ],
    [
      /*start*/
      125184,
      11
      /* ALetter */
    ],
    [
      /*start*/
      125252,
      14
      /* Extend */
    ],
    [
      /*start*/
      125259,
      11
      /* ALetter */
    ],
    [
      /*start*/
      125260,
      0
      /* Other */
    ],
    [
      /*start*/
      125264,
      9
      /* Numeric */
    ],
    [
      /*start*/
      125274,
      0
      /* Other */
    ],
    [
      /*start*/
      126464,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126468,
      0
      /* Other */
    ],
    [
      /*start*/
      126469,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126496,
      0
      /* Other */
    ],
    [
      /*start*/
      126497,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126499,
      0
      /* Other */
    ],
    [
      /*start*/
      126500,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126501,
      0
      /* Other */
    ],
    [
      /*start*/
      126503,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126504,
      0
      /* Other */
    ],
    [
      /*start*/
      126505,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126515,
      0
      /* Other */
    ],
    [
      /*start*/
      126516,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126520,
      0
      /* Other */
    ],
    [
      /*start*/
      126521,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126522,
      0
      /* Other */
    ],
    [
      /*start*/
      126523,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126524,
      0
      /* Other */
    ],
    [
      /*start*/
      126530,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126531,
      0
      /* Other */
    ],
    [
      /*start*/
      126535,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126536,
      0
      /* Other */
    ],
    [
      /*start*/
      126537,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126538,
      0
      /* Other */
    ],
    [
      /*start*/
      126539,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126540,
      0
      /* Other */
    ],
    [
      /*start*/
      126541,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126544,
      0
      /* Other */
    ],
    [
      /*start*/
      126545,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126547,
      0
      /* Other */
    ],
    [
      /*start*/
      126548,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126549,
      0
      /* Other */
    ],
    [
      /*start*/
      126551,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126552,
      0
      /* Other */
    ],
    [
      /*start*/
      126553,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126554,
      0
      /* Other */
    ],
    [
      /*start*/
      126555,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126556,
      0
      /* Other */
    ],
    [
      /*start*/
      126557,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126558,
      0
      /* Other */
    ],
    [
      /*start*/
      126559,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126560,
      0
      /* Other */
    ],
    [
      /*start*/
      126561,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126563,
      0
      /* Other */
    ],
    [
      /*start*/
      126564,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126565,
      0
      /* Other */
    ],
    [
      /*start*/
      126567,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126571,
      0
      /* Other */
    ],
    [
      /*start*/
      126572,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126579,
      0
      /* Other */
    ],
    [
      /*start*/
      126580,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126584,
      0
      /* Other */
    ],
    [
      /*start*/
      126585,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126589,
      0
      /* Other */
    ],
    [
      /*start*/
      126590,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126591,
      0
      /* Other */
    ],
    [
      /*start*/
      126592,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126602,
      0
      /* Other */
    ],
    [
      /*start*/
      126603,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126620,
      0
      /* Other */
    ],
    [
      /*start*/
      126625,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126628,
      0
      /* Other */
    ],
    [
      /*start*/
      126629,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126634,
      0
      /* Other */
    ],
    [
      /*start*/
      126635,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126652,
      0
      /* Other */
    ],
    [
      /*start*/
      127280,
      11
      /* ALetter */
    ],
    [
      /*start*/
      127306,
      0
      /* Other */
    ],
    [
      /*start*/
      127312,
      11
      /* ALetter */
    ],
    [
      /*start*/
      127338,
      0
      /* Other */
    ],
    [
      /*start*/
      127344,
      11
      /* ALetter */
    ],
    [
      /*start*/
      127370,
      0
      /* Other */
    ],
    [
      /*start*/
      127462,
      18
      /* Regional_Indicator */
    ],
    [
      /*start*/
      127488,
      0
      /* Other */
    ],
    [
      /*start*/
      127995,
      14
      /* Extend */
    ],
    [
      /*start*/
      128e3,
      0
      /* Other */
    ],
    [
      /*start*/
      130032,
      9
      /* Numeric */
    ],
    [
      /*start*/
      130042,
      0
      /* Other */
    ],
    [
      /*start*/
      917505,
      13
      /* Format */
    ],
    [
      /*start*/
      917506,
      0
      /* Other */
    ],
    [
      /*start*/
      917536,
      14
      /* Extend */
    ],
    [
      /*start*/
      917632,
      0
      /* Other */
    ],
    [
      /*start*/
      917760,
      14
      /* Extend */
    ],
    [
      /*start*/
      918e3,
      0
      /* Other */
    ]
  ]), ip;
}
var Uk;
function RH() {
  if (Uk) return np;
  Uk = 1;
  Object.defineProperty(np, "__esModule", { value: !0 });
  const r = DH();
  function* e(a) {
    if (a.length === 0)
      return;
    let s, o = 0, l, u = 19, c = 19, h = m(0), f = 0;
    do {
      if (s = o, o = p(o), [l, u, c, h] = [u, c, h, m(o)], u === 19) {
        yield s;
        continue;
      }
      if (c === 20) {
        yield s;
        break;
      }
      if (!(u === 3 && c === 1)) {
        if (u === 2 || u == 3 || u === 1) {
          yield s;
          continue;
        }
        if (c === 2 || c === 3 || c === 1) {
          yield s;
          continue;
        }
        if (u === 0 && (c === 14 || c === 13) && h === 16) {
          for (let E = 0; E < 2; E++)
            [s, o] = [o, p(o)];
          [u, c, h] = [h, m(s), m(o)];
        }
        if (!(u === 16 && A(s)) && !(u === 4 && c == 4)) {
          for (; c === 13 || c === 14 || c === 16; )
            [s, o] = [o, p(o)], [c, h] = [h, m(o)];
          if (c === 20) {
            yield s;
            break;
          }
          for (; h === 13 || h === 14 || h === 16; )
            o = p(o), h = m(o);
          if (!(w(u) && w(c)) && !(w(u) && w(h) && (c === 10 || x(c))) && !(w(l) && w(c) && (u === 10 || x(u))) && !(u === 15 && c === 6) && !(u === 15 && c === 5 && h === 15) && !(l === 15 && u === 5 && c === 15) && !(u === 9 && c === 9) && !(w(u) && c === 9) && !(u === 9 && w(c)) && !(l === 9 && c === 9 && (u === 7 || x(u))) && !(u === 9 && h === 9 && (c === 7 || x(c))) && !(u === 17 && c === 17) && !((w(u) || u === 9 || u === 17 || u === 12) && c === 12) && !((w(c) || c === 9 || c === 17) && u === 12)) {
            if (c === 18) {
              if (f += 1, f % 2 == 1)
                continue;
            } else
              f = 0;
            yield s;
          }
        }
      }
    } while (s < a.length);
    function p(E) {
      return E >= a.length ? a.length : t(a[E]) ? E + 2 : E + 1;
    }
    function m(E) {
      return E < 0 ? 19 : E >= a.length ? 20 : t(a[E]) ? n(a[E] + a[E + 1]) : n(a[E]);
    }
    function A(E) {
      return r.extendedPictographic.test(a.substring(E, E + 2));
    }
    function w(E) {
      return E === 11 || E === 15;
    }
    function x(E) {
      return E === 8 || E === 6;
    }
  }
  np.findBoundaries = e;
  function t(a) {
    let s = a.charCodeAt(0);
    return s >= 55296 && s <= 56319;
  }
  function n(a) {
    let s = a.codePointAt(0);
    return i(s, 0, r.WORD_BREAK_PROPERTY.length - 1);
  }
  np.property = n;
  function i(a, s, o) {
    if (o < s)
      return 0;
    let l = s + ~~((o - s) / 2), u = r.WORD_BREAK_PROPERTY[l], c = r.WORD_BREAK_PROPERTY[l + 1], h = c ? c[
      0
      /* Start */
    ] : 1 / 0;
    return a < u[
      0
      /* Start */
    ] ? i(a, s, l - 1) : a >= h ? i(a, l + 1, o) : u[
      1
      /* Value */
    ];
  }
  return np;
}
var Vk;
function OH() {
  if (Vk) return rp;
  Vk = 1;
  Object.defineProperty(rp, "__esModule", { value: !0 });
  const r = RH();
  function e(a) {
    return Array.from(t(a)).map((o) => o.text).filter(i);
  }
  rp.split = e;
  function* t(a) {
    let s = Array.from(r.findBoundaries(a));
    if (s.length != 0)
      for (let o = 0; o < s.length - 1; o++) {
        let l = s[o], u = s[o + 1];
        yield new n(a, l, u);
      }
  }
  rp.findSpans = t;
  class n {
    constructor(s, o, l) {
      this._source = s, this.start = o, this.end = l;
    }
    get text() {
      return this._source.substring(this.start, this.end);
    }
    get length() {
      return this.end - this.start;
    }
  }
  function i(a) {
    return !Array.from(a).map(r.property).every((s) => s === 3 || s === 1 || s === 2 || s === 4);
  }
  return rp;
}
var j1 = OH();
class BH {
  async init(e, t, n) {
    if (n)
      await this.reload(e, t, n);
    else
      return t.updateMetadata(e.stepName, { text: "" }), this.changeTextCommand(e, "", t, () => {
      });
    return null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), l = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName).map((u) => ({
      id: u.id,
      region: u.stepRegion,
      regionIndex: u.stepRegionIndex
    }));
    await t.setSelectionsAndElements(e.stepName, [], l, async () => {
      t.updateStorage(e.stepName, { text: i?.storage?.text }), t.setMandatoryFulfilled(e.stepName, i?.storage?.text !== "");
    });
  }
  async changeText(e, t, n, i) {
    const a = await this.changeTextCommand(e, t, n, i);
    a && (a.command && n.getCommandDispatcher()(a.command), a.followup && await a.followup());
  }
  async changeTextCommand(e, t, n, i) {
    const a = n.getRegionElements(e.stepName), s = n.getStepSpecificServices(e.stepName)?.module;
    if (!s)
      return console.error("Missing module."), null;
    const o = n.getWorkflowExperience().getProfanityList(), l = this.validateInput(e, t, o, i);
    if (l.errorData)
      return n.setMandatoryFulfilled(e.stepName, !1), l.errorData.blockedProfanity ? console.error("Blocked profanity.") : l.errorData.hitCharacterLimit ? console.error("Too many characters.") : l.errorData.unsupportedCharacters && console.error("Unsupported characters."), null;
    if (n.setMandatoryFulfilled(e.stepName, t !== ""), !e.data || !e.data.regions || e.data.regions.length <= 0)
      return console.error("Missing configuration."), null;
    n.updateStorage(e.stepName, { text: t }), n.updateMetadata(e.stepName, { text: t });
    const u = (c, h, f, p) => {
      const m = p || nn(), w = n.getLayouts().find((E) => E.panelId === h.panelId);
      if (!w)
        return console.error(`Can not find layout for region: ${h.panelId}`), null;
      const x = [];
      return p && x.push(new Lf(m)), x.push(
        new pa(
          {
            stepRegion: h,
            stepRegionIndex: f,
            stepName: e.stepName,
            colors: {},
            id: m,
            svg: c,
            type: Mr.Illustration,
            y: h.top,
            x: h.left,
            rotation: h.rotation,
            width: h.width,
            height: h.height,
            layer: h.layer,
            layerIndex: h.layerIndex,
            immutable: h.immutable
          },
          w
        )
      ), {
        id: m,
        region: h,
        command: new Ii(x)
      };
    };
    if (a.length > 0) {
      const h = a.map((f) => {
        if (!f.region)
          return null;
        const p = s.svgPrint(t, f.region);
        return u(
          p,
          f.region,
          f.regionIndex,
          f.id
        );
      }).filter((f) => !!f).filter((f) => !!f).map((f) => f && f.command);
      return {
        command: new Ii(h),
        followup: async () => {
        }
      };
    } else {
      const c = e.data.regions.map(
        (f, p) => u(s.svgPrint(t, f), f, p)
      ), h = c.filter((f) => !!f).map((f) => f && f.command);
      return {
        command: new Ii(h),
        followup: async () => {
          const f = c.filter((p) => p).map((p) => p && { id: p.id, region: p.region });
          await n.setSelectionsAndElements(
            e.stepName,
            [],
            f
          );
        }
      };
    }
  }
  validateInput(e, t, n, i) {
    if (e.data && e.data.maxLength) {
      const s = e.data.maxLength;
      if (t.length > s)
        return i("Too many characters."), { input: t, helperData: {}, errorData: { hitCharacterLimit: !0 } };
    }
    if (!/^$|^[a-zA-Z0-9 ]+$/.test(t))
      return i("Unsupported characters."), { input: t, helperData: {}, errorData: { unsupportedCharacters: !0 } };
    const a = j1.split(t.toLowerCase());
    for (const s of a)
      for (const o in n) {
        const l = n[o].toLowerCase().replace(/\s/g, "");
        if (s === l)
          return i("Blocked profanity."), { input: t, helperData: {}, errorData: { blockedProfanity: !0 } };
      }
    return i(""), { input: t, helperData: {} };
  }
}
const GD = new BH();
class _H {
  async init(e, t, n) {
    const i = await Pt.getOptionForStep(e);
    if (!i)
      throw new Cu(e, "Missing option for picture step");
    if (n)
      await this.reload(e, t, n);
    else {
      const a = await Pt.getDefaultVariant(i, e.overrideDefaultVariantId);
      if (a)
        return t.markStepsAsInitialised([e.stepName]), this.selectVariantCommand(e, a, t, () => {
        });
    }
    return t.markStepsAsInitialised([e.stepName]), null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), o = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName), l = await Pt.getOptionForStep(e);
    if (i?.selectedVariants) {
      const u = i.selectedVariants[0].id;
      if (l && u) {
        const c = l.variants?.find((h) => h.id === u);
        if (c) {
          const h = o.map((f) => ({
            id: f.id,
            region: f.stepRegion,
            regionIndex: f.stepRegionIndex
          }));
          await t.setSelectionsAndElements(e.stepName, [c], h);
        }
      }
    }
  }
  async selectVariant(e, t, n, i) {
    const a = await this.selectVariantCommand(e, t, n, i);
    a && (a.command && n.getCommandDispatcher()(a.command), a.followup && await a.followup());
  }
  async selectVariantCommand(e, t, n, i) {
    const a = t.asset;
    if (!a)
      throw new _f(t);
    const s = a?.fileLink;
    if (!s)
      return console.error("No URL for picture!"), null;
    i(!0), e.mandatory && n.setMandatoryFulfilled(e.stepName, !1);
    const l = n.getRegionElements(e.stepName).map((h) => new Lf(h.id)), u = (h, f) => {
      const m = n.getLayouts().find((w) => w.panelId === h.panelId);
      if (!m)
        throw new La(h);
      const A = nn();
      return {
        regionElement: { id: A, region: h, regionIndex: f },
        command: new pa(
          {
            stepName: e.stepName,
            stepRegion: h,
            stepRegionIndex: f,
            id: A,
            src: s,
            type: Mr.Image,
            y: h.top,
            x: h.left,
            rotation: h.rotation,
            width: h.width,
            height: h.height,
            layer: h.layer,
            layerIndex: h.layerIndex,
            immutable: h.immutable,
            preserveAspectRatio: "none"
          },
          m
        )
      };
    }, c = e.data.regions.map(u);
    return {
      command: new Ii([...l, ...c.map((h) => h.command)]),
      followup: async () => {
        await n.setSelectionsAndElements(
          e.stepName,
          [t],
          c.map((h) => h.regionElement),
          async () => {
            i(!1);
          }
        );
      }
    };
  }
}
const HD = new _H();
class MH {
  async init(e, t, n) {
    const i = await Pt.getOptionForStep(e);
    if (!i)
      throw new Cu(e, "Missing option for question step");
    if (n)
      await this.reload(e, t, n);
    else {
      const a = await Pt.getDefaultVariant(i, e.overrideDefaultVariantId);
      if (a)
        return this.selectVariantLambda(e, a.id || "", t);
    }
    return null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), a = await Pt.getOptionForStep(e);
    if (i?.selectedVariants) {
      const s = i.selectedVariants[0].id;
      if (a && s) {
        const o = a.variants?.find((l) => l.id === s);
        o && await t.setSelectionsAndElements(e.stepName, [o], []);
      }
    }
  }
  async selectVariant(e, t, n) {
    const i = await this.selectVariantLambda(e, t, n);
    i && (i.command && n.getCommandDispatcher()(i.command), i.followup && await i.followup());
  }
  async selectVariantLambda(e, t, n) {
    const i = await Pt.getOptionForStep(e);
    if (!i)
      throw new Cu(e, "Missing option for question step");
    const a = i.variants;
    if (!a)
      throw new Cu(e, "Option for question step is missing variants");
    const s = a.length > 1 ? a.find((o) => o.id === t) : a[0];
    if (!s)
      throw new Error(
        `Failed to find selected variant ${t} in option ${i.id} of step ${e.stepName} (${e.stepTitle})`
      );
    return {
      command: void 0,
      followup: async () => {
        await n.setSelectionsAndElements(e.stepName, [s], []);
      }
    };
  }
}
const WD = new MH();
class NH {
  constructor() {
    this.shapeFillId = "spiff-fill-shape";
  }
  // Get the step's options.
  async availableColours(e) {
    const t = await Pt.getOptionForStep(e);
    return t ? t.variants?.map((n) => ({
      fill: n.color,
      stroke: n.color,
      variant: n
    })) || [] : [];
  }
  setCustomColor(e, t, n) {
    const i = n.getLayouts(), s = (n.getRegionElements(t.stepName) || []).map((o) => {
      const l = o.region;
      if (!i.find((c) => c.panelId === l?.panelId)) throw new La(l);
      return new H1(o.id, this.shapeFillId, e);
    }).filter((o) => !!o);
    n.getCommandDispatcher()(new Ii(s)), n.updateStorage(t.stepName, { colour: e });
  }
  async init(e, t, n) {
    const i = await Pt.getOptionForStep(e);
    if (!i)
      throw new c0(e);
    if (n)
      await this.reload(e, t, n);
    else {
      const a = await Pt.getDefaultVariant(i, e.overrideDefaultVariantId);
      return a ? this.selectVariantCommand(
        e,
        {
          fill: a.color,
          stroke: a.color,
          variant: a
        },
        [],
        t
      ) : null;
    }
    return null;
  }
  async selectVariant(e, t, n, i) {
    const a = await this.selectVariantCommand(e, t, n, i);
    a && (a.command && i.getCommandDispatcher()(a.command), a.followup && await a.followup());
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), o = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName), l = await Pt.getOptionForStep(e);
    if (i?.selectedVariants) {
      const u = i.selectedVariants[0].id;
      if (l && u) {
        const c = l.variants?.find((h) => h.id === u);
        if (c) {
          const h = o.map((f) => ({
            id: f.id,
            region: f.stepRegion,
            regionIndex: f.stepRegionIndex
          }));
          await t.setSelectionsAndElements(
            e.stepName,
            [c],
            h,
            async () => {
              t.updateStorage(e.stepName, {
                colour: i?.storage?.colour || ""
              });
            }
          );
        }
      }
    }
  }
  async selectVariantCommand(e, t, n, i) {
    const a = i.getLayouts(), s = i.getStepStorage(e.stepName)?.colour, o = () => {
      if (t.variant?.color === "#custom") return s || "#FFFFFF";
      if (t.variant?.color) return t.variant.color;
      throw new Error("Failed to resolve color for shape step.");
    };
    if (n.length > 0) {
      const l = (c) => {
        const h = c.region;
        if (!a.find((m) => m.panelId === h?.panelId))
          throw new La(h);
        const p = o();
        return new H1(c.id, this.shapeFillId, p);
      }, u = n.map(l).filter((c) => !!c);
      return {
        command: new Ii(u),
        followup: async () => {
          await i.setSelectionsAndElements(
            e.stepName,
            t.variant ? [t.variant] : [],
            n
          ), i.updateStorage(e.stepName, { colour: o() });
        }
      };
    } else {
      const l = (f, p) => {
        const m = a.find((T) => T.panelId === f.panelId);
        if (!m)
          throw new La(f);
        const A = o(), w = `
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xmlSpace="preserve"
                        preserveAspectRatio="none"
                        version="1.1"
                        width="1"
                        height="1"
                        viewBox="0 0 1 1"
                    >
                        <rect
                            x="0"
                            y="0"
                            width="1"
                            height="1"
                            class="${this.shapeFillId}"
                            fill="${A}"
                        />
                    </svg>
                `, x = {};
        x[this.shapeFillId] = { browserValue: A };
        const E = nn();
        return {
          id: E,
          region: f,
          command: new pa(
            {
              stepRegion: f,
              stepRegionIndex: p,
              stepName: e.stepName,
              colors: x,
              id: E,
              svg: w,
              type: Mr.Illustration,
              y: f.top,
              x: f.left,
              rotation: f.rotation,
              width: f.width,
              height: f.height,
              layer: f.layer,
              layerIndex: f.layerIndex,
              immutable: f.immutable,
              excludeFromExport: e.data.excludeFromPrint
            },
            m
          )
        };
      }, u = e.data.regions.map(l), c = u.filter((f) => !!f).map((f) => f?.command), h = u.filter((f) => !!f).map((f, p) => ({ id: f.id, region: f.region, regionIndex: p }));
      return {
        command: new Ii(c),
        followup: async () => {
          await i.setSelectionsAndElements(
            e.stepName,
            t.variant ? [t.variant] : [],
            h,
            async () => {
              i.updateStorage(e.stepName, { colour: o() });
            }
          );
        }
      };
    }
  }
}
const xp = new NH();
class LH {
  constructor() {
    this.latestToast = null, this.toastType = null, this.toastCallbacks = [];
  }
  addToastCallback(e) {
    e({
      toastMessage: this.latestToast,
      toastType: this.toastType
    }), this.toastCallbacks.push(e);
  }
  removeToastCallback(e) {
    this.toastCallbacks = this.toastCallbacks.filter((t) => t !== e);
  }
  setLatestToast(e, t) {
    this.latestToast = e, this.toastType = t, this.onToastChange();
  }
  onToastChange() {
    this.toastCallbacks.forEach(
      (e) => e({
        toastMessage: this.latestToast,
        toastType: this.toastType
      })
    );
  }
}
const UH = new LH(), rA = (r, e, t, n, i) => {
  if (e.some((c) => c == null))
    throw new Error(`Failed to autosize lines: ${e.join(", ")}`);
  let a = e.map((c) => c.split(`
`)).flat(), s = a.length, o = a.map((c) => wc(c, n, i));
  const l = i.getApproximateHeight() * n;
  let u = !0;
  for (; u; ) {
    if (l + (s - 1) * t > r.height)
      return [null, null];
    const h = Math.max(...o);
    if (h <= r.width)
      return [a, h];
    const f = o.reduce((w, x, E, T) => x > T[w] ? E : w, 0), p = a[f];
    let m = !1, A = p.length;
    for (; !m && A > -1; ) {
      A = p.lastIndexOf(" ", A - 1);
      const w = [p.slice(0, A), p.slice(A + 1)], x = w.map((T) => wc(T, n, i));
      x[0] <= r.width && (a = [...a.slice(0, f), ...w, ...a.slice(f + 1)], o = [
        ...o.slice(0, f),
        ...x,
        ...o.slice(f + 1)
      ], s += 1, m = !0);
    }
    m || (u = !1);
  }
  return [null, null];
}, Zm = (r, e, t, n, i) => {
  let a, s;
  const o = _c(e.assetUrl), l = o.getFont();
  if (i.size) {
    const f = r / l.unitsPerEm;
    return [a, s] = rA(t, n, r, f, o), [i.size, a, s];
  }
  const u = 6;
  let c = u - xy;
  if (n.length > 0) {
    let f = n, p = 0;
    for (; (!i.maxSize || c <= i.maxSize) && f; )
      c += xy, p = c / l.unitsPerEm, [f, s] = rA(t, n, c, p, o);
  }
  c > u && (c -= xy), i.minSize && c < i.minSize && (c = i.minSize);
  const h = c / l.unitsPerEm;
  return [a, s] = rA(t, n, c, h, o), [c, a, s];
}, nA = 30;
class S0 extends Error {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, new.target.prototype), this.name = S0.name;
  }
}
const VH = ["‘", "’", "“", "”", `
`];
class E0 extends Error {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, new.target.prototype), this.name = E0.name;
  }
}
class $H {
  constructor() {
    this.cachedColors = /* @__PURE__ */ new Map(), this.cachedStrokeColors = /* @__PURE__ */ new Map(), this.filterUnsupportedCharacters = (e, t) => {
      let n = e.replace(
        /(\r\n|\r|(\u2665|\u00a9|\u00ae|[\u2000-\u2017]|[\u201E-\u3300]]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]))/gm,
        ""
      );
      const i = [], a = t ? _c(t.assetUrl) : void 0;
      if (a) {
        const s = n.split("").filter((l) => !VH.includes(l)).join(""), o = s.split("").map((l) => a.getFont().charToGlyph(l));
        for (let l = 0; l < o.length; l++)
          o[l].name === ".notdef" && i.push(String.fromCharCode(s.charCodeAt(l)));
      }
      for (let s = 0; s < i.length; s++)
        n = n.replaceAll(i[s], "");
      return n;
    }, this.textAlign = (e) => e.vertical ? "center" : e.textAlign || "center", this.getErrorsForText = (e, t, n, i) => {
      let a;
      n.data && n.data.maxLength && t.length > n.data.maxLength && (a || (a = {}), a.hitCharacterLimit = !0);
      const s = i.getWorkflowExperience().getProfanityList(), o = j1.split(e.toLowerCase());
      for (const u of o)
        for (const c in s) {
          const h = s[c].toLowerCase().replace(/\s/g, "");
          if (u === h) {
            a || (a = {}), a.blockedProfanity = !0;
            break;
          }
        }
      return !n.data.allowNewlines && (e.includes(`
`) || e.includes("\r")) && (a || (a = {}), a.illegalMultipleLines = !0), a;
    };
  }
  async init(e, t, n) {
    const i = await Pt.getOptionForStep(e);
    if (!i)
      return null;
    if (n)
      await this.reload(e, t, n);
    else {
      const a = await this.getDefaultImageFillVariant(
        e.data,
        e.overrideDefaultVariantId
      ), s = a?.asset?.fileLink, o = s ? await G1(s) : void 0, l = o ? {
        src: o.src,
        height: o.height,
        width: o.width,
        scale: e.data.imageFillScale || 1
      } : void 0, u = await this.getDefaultStrokeColorVariant(
        e.data,
        e.overrideDefaultVariantId
      ), c = e.data.strokeEnabled && u?.color ? {
        browserValue: u.color,
        pmsValue: u.name
      } : void 0;
      let h = e.data.defaultText || "";
      const f = t.getWorkflowExperience().getBundle();
      if (f && e.globalPropertyAspectConfigurations) {
        const E = f.getGlobalPropertyConfiguration()?.aspects?.find(
          (T) => T.type === Ji.Text && e.globalPropertyAspectConfigurations?.map((D) => D.aspectName).includes(T.name)
        );
        if (E) {
          const D = f.getGlobalPropertyStateManager().getAspect(E.name);
          D && (h = D);
        }
      }
      const p = await this.getDefaultColorVariant(
        e.data,
        e.overrideDefaultVariantId
      ), m = await this.getDefaultColor(e.data, e.overrideDefaultVariantId), A = p?.color || m;
      t.updateStorage(e.stepName, {
        text: h,
        inputText: e.data.defaultText || "",
        color: A,
        fillImage: l,
        strokeColor: c
      }), t.updateMetadata(e.stepName, {
        text: h,
        color: (await this.getDefaultColorVariant(e.data, e.overrideDefaultVariantId))?.name || await this.getDefaultColor(e.data, e.overrideDefaultVariantId),
        fillImage: a?.name,
        strokeColor: e.data.strokeEnabled ? u?.color : void 0
      });
      const w = await Pt.getDefaultVariant(i, e.overrideDefaultVariantId);
      if (w)
        return this.selectVariantCommand(
          e,
          w,
          { text: h },
          [],
          t,
          () => {
          },
          () => {
          },
          l,
          c
        );
    }
    return null;
  }
  findLayoutElements(e, t) {
    return e.getRegionElements(t.stepName).map((a) => {
      try {
        return zi(a.id, e.getAllLayoutData());
      } catch {
        return null;
      }
    }).filter((a) => !!a);
  }
  /**
   * Get the colors that can be used for a given text step.
   * @param stepData The text step to get colors for.
   * @returns A list of color objects containing fill, stroke and variant if available.
   */
  async availableFillColors(e) {
    const t = this.cachedColors.get(e.stepName);
    if (t)
      return t;
    const n = await Pt.ensureFullOption(e.data.colorOption);
    if (n) {
      const i = n.variants?.map((a) => ({
        fill: a.color,
        stroke: a.color,
        variant: a
      })) || [];
      return this.cachedColors.set(e.stepName, i), i;
    }
    return [];
  }
  changeAlignment(e, t, n, i) {
    if (!e.data || !e.data.regions)
      return;
    const a = i.getCommandDispatcher();
    for (const s of n) {
      const o = new ZG(s.id, t);
      a(o);
    }
  }
  async changeFillColor(e, t, n, i) {
    if (!e.data || !e.data.regions)
      return;
    const a = i.getCommandDispatcher();
    t.variant ? i.updateMetadata(e.stepName, { color: t.variant.name }) : i.updateMetadata(e.stepName, { color: t.fill });
    const s = await Pt.ensureFullOption(e.data.colorOption), o = s ? this.createTextFillSpotColor(s, t.variant) : void 0;
    s ? i.updateStorage(e.stepName, {
      color: t.fill,
      colorProfileAssetKey: s.colorProfile?.key
    }) : i.updateStorage(e.stepName, {
      color: t.fill
    });
    for (const l of n) {
      if (!t.fill)
        throw new Error("Fill not set on new color selection!");
      const u = new ok(l.id, t.fill, o);
      a(u);
    }
  }
  applyCustomFillColor(e, t, n, i) {
    if (!e.data || !e.data.regions)
      return;
    const a = i.getCommandDispatcher();
    i.updateStorage(e.stepName, { customColor: t });
    for (const s of n) {
      const o = new ok(s.id, t);
      a(o);
    }
  }
  async availableFillImages(e) {
    const t = await Pt.ensureFullOption(e.data.imageFillOption);
    if (t) {
      const n = t.variants?.map((i) => i.asset?.fileLink)?.filter((i) => !!i) || [];
      return Promise.all(
        n.map(async (i) => {
          const a = await G1(i);
          return {
            src: i,
            width: a.width,
            height: a.height,
            scale: e.data.imageFillScale || 1
          };
        })
      );
    }
    return Promise.resolve([]);
  }
  async changeFillImage(e, t, n, i) {
    if (!e.data || !e.data.regions)
      return;
    const a = i.getCommandDispatcher(), o = (await Pt.getOptionForStep(e))?.variants?.find((l) => l.asset?.fileLink === t.src);
    i.updateMetadata(e.stepName, { fillImage: o?.name }), i.updateStorage(e.stepName, {
      fillImage: t
    });
    for (const l of n) {
      const u = new Dy(l.id, t);
      a(u);
    }
  }
  /**
   * Get the colors that can be used for a given text step's stroke.
   * @param stepData The text step to get colors for.
   * @returns A list of color objects containing fill, stroke and variant if available.
   */
  async availableStrokeColors(e) {
    const t = this.cachedStrokeColors.get(e.stepName);
    if (t)
      return t;
    const n = await Pt.ensureFullOption(e.data.strokeOption);
    if (n) {
      const i = n.variants?.map((a) => ({
        fill: a.color,
        stroke: a.color,
        variant: a
      })) || [];
      return this.cachedStrokeColors.set(e.stepName, i), i;
    }
    return [];
  }
  async changeStrokeColor(e, t, n, i) {
    if (!e.data || !e.data.regions)
      return;
    const a = i.getCommandDispatcher();
    t?.variant ? i.updateMetadata(e.stepName, { strokeColor: t.variant.name }) : i.updateMetadata(e.stepName, { strokeColor: t?.fill });
    const s = t ? {
      browserValue: t.fill,
      pmsValue: t.pmsValue
    } : void 0;
    i.updateStorage(e.stepName, {
      strokeColor: s
    });
    for (const o of n) {
      const l = new Ry(o.id, s, e.data?.strokeThickness);
      a(l);
    }
  }
  getProcessedInput(e, t, n) {
    const i = n ? e : this.injectReplaceableText(e, t);
    return C0(i, {
      vertical: t.vertical,
      uppercase: t.uppercase
    });
  }
  updateInputText(e, t, n, i) {
    const a = i.getStepStorage(n.stepName), s = Od(e, i), o = this.getProcessedInput(s, n.data, a?.customiseAllText ?? !1), l = {
      command: void 0,
      helperData: {},
      errorData: this.getErrorsForText(e, o, n, i)
    };
    if (l.errorData)
      return l;
    l.helperData.charactersRemaining = n.data.maxLength - o.length;
    const u = [], c = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Map();
    for (const f of t) {
      if (!f.fontData) throw new si("Failed to resolve font data for text.");
      const [p, m] = Zm(
        f.fontSize,
        f.fontData,
        { left: f.x, top: f.y, width: f.width, height: f.height, rotation: f.rotation },
        [o],
        { size: n.data.size, minSize: n.data.minSize, maxSize: n.data.maxSize }
      );
      c.set(f.id, p), h.set(f.id, m);
      const A = n.data.curved ? o : (m || []).join(`
`);
      u.push(this.generateTextChangeCommandsForRegion(p, n.data, f.id, A));
    }
    return !n.data.curved && t.length > 0 && !Array.from(h.values()).every((p) => p) ? (l.errorData || (l.errorData = {}), l.errorData.doesNotFit = !0, l) : (i.updateStorage(n.stepName, { text: e }), i.updateMetadata(n.stepName, {
      text: o
    }), (a?.defaultCleared || !n.data.deleteDefaultOnFocus) && o.trim() !== "" && i.setMandatoryFulfilled(n.stepName, !0), l.command = new Ii(u), l);
  }
  async selectVariant(e, t, n, i, a) {
    const s = await this.selectVariantCommand(
      e,
      t,
      n.getStepStorage(e.stepName) || {},
      n.getRegionElements(e.stepName),
      n,
      i,
      a
    );
    s && (s.command && n.getCommandDispatcher()(s.command), s.followup && await s.followup());
  }
  createTextFillSpotColor(e, t) {
    const n = e.colorProfile;
    if (n) {
      const i = (n.name || "").replace(/\s/g, "-"), a = i.lastIndexOf("/"), o = i.slice(a + 1).slice(0, -4);
      if (!t.namedColor) throw new Error("variant named color not set!");
      return {
        profileName: o,
        namedColor: t.namedColor
      };
    }
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), o = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName), l = await Pt.getOptionForStep(e);
    if (i?.selectedVariants) {
      const u = i.selectedVariants[0].id;
      if (l && u) {
        const c = l.variants?.find((h) => h.id === u);
        if (c) {
          const h = await this.fontDataFromVariant(c), f = o.map((w) => ({
            id: w.id,
            region: w.stepRegion,
            regionIndex: w.stepRegionIndex
          })), p = i.storage?.color;
          let m = i.storage?.text;
          const A = t.getWorkflowExperience().getBundle();
          if (A && e.globalPropertyAspectConfigurations) {
            const x = A.getGlobalPropertyConfiguration()?.aspects?.find(
              (E) => E.type === Ji.Text && e.globalPropertyAspectConfigurations?.map((T) => T.aspectName).includes(E.name)
            );
            if (x) {
              const T = A.getGlobalPropertyStateManager().getAspect(x.name);
              T && (m = T);
            }
          }
          if (await t.setSelectionsAndElements(
            e.stepName,
            [c],
            f,
            async () => {
              t.updateMetadata(e.stepName, { color: p, text: m }), t.updateStorage(e.stepName, { text: m, inputText: m });
              const w = o.map((E) => new lk(E.id, h)), x = new Ii(w);
              t.getCommandDispatcher()(x);
            }
          ), o.length === 0 && l) {
            const w = await Pt.getDefaultVariant(
              l,
              e.overrideDefaultVariantId
            );
            if (w) {
              const x = await this.selectVariantCommand(
                e,
                w,
                { text: m },
                [],
                t,
                () => {
                },
                () => {
                }
              );
              x?.command && t.getCommandDispatcher()(x.command);
            }
          } else {
            const { command: w } = ca.updateInputText(
              m || "",
              o,
              e,
              t
            );
            w && t.getCommandDispatcher()(w);
          }
        }
      }
    } else {
      const u = t.getWorkflowExperience().getBundle();
      if (u && e.globalPropertyAspectConfigurations) {
        const h = u.getGlobalPropertyConfiguration()?.aspects?.find(
          (f) => f.type === Ji.Text && e.globalPropertyAspectConfigurations?.map((p) => p.aspectName).includes(f.name)
        );
        if (h) {
          const p = u.getGlobalPropertyStateManager().getAspect(h.name);
          if (p)
            if (o.length === 0 && l) {
              const m = await Pt.getDefaultVariant(
                l,
                e.overrideDefaultVariantId
              );
              if (m) {
                const A = await this.selectVariantCommand(
                  e,
                  m,
                  { text: p },
                  [],
                  t,
                  () => {
                  },
                  () => {
                  }
                );
                A?.command && t.getCommandDispatcher()(A.command);
              }
            } else {
              const { command: m } = ca.updateInputText(
                p,
                o,
                e,
                t
              );
              m && t.getCommandDispatcher()(m);
            }
        }
      }
    }
  }
  async getDefaultColorVariant(e, t) {
    const n = e.colorOption;
    if (n)
      return Pt.getDefaultVariant(n, t);
  }
  async getDefaultColor(e, t) {
    const n = e.colorOption;
    return n ? (await Pt.getDefaultVariant(n, t))?.color : void 0;
  }
  async getDefaultImageFillVariant(e, t) {
    const n = e.imageFillOption;
    if (n)
      return Pt.getDefaultVariant(n, t);
  }
  async getDefaultStrokeColorVariant(e, t) {
    const n = e.strokeOption;
    if (n)
      return Pt.getDefaultVariant(n, t);
  }
  async fontDataFromVariant(e) {
    const t = e.asset;
    if (!t)
      throw new _f(e);
    const n = t.fileLink;
    if (!n)
      throw new th(t);
    const i = await oh(n);
    return {
      assetUrl: n,
      name: i.names.fullName.en
    };
  }
  async selectVariantCommand(e, t, n, i, a, s, o, l, u) {
    const c = a.markUpdatePending(), h = await this.fontDataFromVariant(t);
    let f = !0;
    const p = (m) => {
      s(m), m && (f = !1);
    };
    if (i.length > 0) {
      const m = i.map((x) => new lk(x.id, h));
      if (l) {
        const x = i.map((E) => new Dy(E.id, l));
        m.push(...x);
      }
      if (u) {
        const x = i.map((E) => new Ry(E.id, u, e.data.strokeThickness));
        m.push(...x);
      }
      const A = await this.changeInputTextWithRegion(
        e,
        e.data.size || nA,
        h,
        n.text || "",
        n,
        a,
        n?.customiseAllText ?? !1,
        p,
        o
      );
      A && m.push(A);
      const w = new Ii(m);
      return f ? {
        command: w,
        followup: async () => {
          a.markUpdateCompleted(c), await a.setSelectionsAndElements(e.stepName, [t], i);
        }
      } : null;
    } else {
      const m = await this.createTextboxRegions(
        e.stepName,
        t,
        e.data,
        h,
        n,
        a,
        e.overrideDefaultVariantId
      ), A = await this.changeInputTextWithRegion(
        e,
        e.data.size || nA,
        h,
        m[0]?.newElement.input || n.text || e.data.defaultText || "",
        n,
        a,
        n?.customiseAllText ?? !1,
        p,
        o
      ), w = m.flatMap((E) => E.commands);
      if (l) {
        const E = m.map(
          (T) => new Dy(T.regionElement.id, l)
        );
        w.push(...E);
      }
      if (u) {
        const E = m.map(
          (T) => new Ry(T.newElement.id, u, e.data.strokeThickness)
        );
        w.push(...E);
      }
      A && w.push(A);
      const x = new Ii(w);
      return f ? {
        command: x,
        followup: async () => {
          a.markUpdateCompleted(c);
        }
      } : null;
    }
  }
  /**
   * When a text step specifies replaceable text, the text input by the user will replace
   * a specific token within a larger string of text specified in the step configuration. Otherwise
   * this function will just return the text it's given when the feature is disabled.
   */
  injectReplaceableText(e, t) {
    return t.replaceableText ? t.replaceableText.replace("{{}}", e) : e;
  }
  async createTextboxRegions(e, t, n, i, a, s, o) {
    if (!n || !n.regions)
      throw new Error("Step data not supplied");
    const l = a.text || n.defaultText || "", u = Od(l, s), c = this.getProcessedInput(u, n, !1), h = async (p, m) => {
      const w = s.getLayouts().find((E) => E.panelId === p.panelId), x = nn();
      try {
        if (!w)
          throw new E0("Failed to find layout for region: " + p.panelId);
        const E = await Pt.ensureFullOption(n.colorOption);
        let T;
        if (E && E.variants) {
          const re = await Pt.getDefaultVariant(E);
          re && (T = this.createTextFillSpotColor(E, re), s.updateStorage(e, {
            colorProfileAssetKey: E.colorProfile?.key
          }));
        }
        const D = await this.getDefaultColor(n, o), F = D || "#000000", _ = {
          stepRegion: p,
          stepRegionIndex: m,
          stepName: e,
          align: this.textAlign(n),
          fill: a.color ? a.color : F,
          fontSize: n.size || nA,
          fontData: i,
          id: x,
          layer: p.layer,
          layerIndex: p.layerIndex,
          rotation: p.rotation,
          text: c,
          input: l,
          type: Mr.Textbox,
          vertical: n.vertical,
          x: p.left,
          y: p.top,
          height: p.height,
          width: p.width,
          immutable: p.immutable,
          verticalAlign: n.verticalAlign || "middle",
          curved: n.curved,
          paths: n.paths,
          fillSpotColorDefinition: T
        }, L = [], Z = /* @__PURE__ */ new Map(), te = /* @__PURE__ */ new Map();
        if (!_.fontData) throw new si("Failed to resolve font data for text.");
        const [de, H] = Zm(
          _.fontSize,
          _.fontData,
          {
            left: _.x,
            top: _.y,
            width: _.width,
            height: _.height,
            rotation: _.rotation,
            panelId: ""
          },
          [c],
          { size: n.size, minSize: n.minSize, maxSize: n.maxSize }
        );
        Z.set(_.id, de), te.set(_.id, H);
        const j = n.curved || n.vertical ? c : (H || []).join(`
`);
        L.push(
          this.generateTextChangeCommandsForRegion(de, n, _.id, j)
        );
        const q = new pa(_, w);
        return {
          regionElement: { id: x, region: p, regionIndex: m },
          commands: [q, ...L],
          newElement: _,
          fontData: i
        };
      } catch (E) {
        throw console.log(E), new S0("Error adding font to region");
      }
    }, f = await Promise.all(n.regions.map(h)).catch((p) => {
      throw p instanceof S0 ? (UH.setLatestToast("Failed to load font.", J0.Error), p) : p instanceof E0 ? p : new Error(p);
    });
    return await s.setSelectionsAndElements(
      e,
      [t],
      f.map((p) => p.regionElement),
      async () => {
        s.updateMetadata(e, {
          text: l
        }), s.updateStorage(e, {
          text: l
        });
      }
    ), f;
  }
  generateTextChangeCommandsForRegion(e, t, n, i) {
    const a = [], s = new rH(n, i);
    if (a.push(s), !t.size) {
      const l = new KG(n, e);
      a.push(l);
    }
    return new Ii(a);
  }
  /**
   * @deprecated
   */
  async changeInputTextWithRegion(e, t, n, i, a, s, o, l, u, c) {
    const h = (i || "").replace(/^(?![\u000A\u000D])[\u0000-\u001F\u007F-\u009F]/g, ""), f = Od(h, s), p = this.getProcessedInput(f, e.data, o), m = s.getRegionElements(e.stepName), A = /* @__PURE__ */ new Map(), w = /* @__PURE__ */ new Map();
    for (const F of m)
      if (F.region) {
        const [_, L] = Zm(
          t,
          n,
          F.region,
          [p],
          { size: e.data.size, minSize: e.data.minSize, maxSize: e.data.maxSize }
        );
        A.set(F.id, _), w.set(F.id, L);
      }
    const E = (() => {
      if (e.data && e.data.maxLength && p.length > e.data.maxLength)
        return c && c(!0), { info: "0" };
      const F = s.getWorkflowExperience().getProfanityList(), _ = j1.split(p.toLowerCase());
      for (const L of _)
        for (const Z in F) {
          const te = F[Z].toLowerCase().replace(/\s/g, "");
          if (L === te) {
            const H = "Blocked profanity.";
            return l(H), { error: H };
          }
        }
      if (!e.data.vertical && !e.data.allowNewlines && (p.includes(`
`) || p.includes("\r"))) {
        const L = "Text may not span multiple lines.";
        return l(L), { error: L };
      }
      if (!e.data.curved && !Array.from(w.values()).every((Z) => Z)) {
        const Z = "Text does not fit.";
        return l(Z), { error: Z };
      }
      return l(void 0), { info: (e.data.maxLength - p.length).toString() };
    })();
    if (E.error) {
      u(E.error);
      return;
    }
    if (u(`${E.info} characters remaining` || ""), c)
      return;
    s.updateStorage(e.stepName, { text: h }), s.updateMetadata(e.stepName, {
      text: this.injectReplaceableText(h, e.data)
    }), (a.defaultCleared || !e.data.deleteDefaultOnFocus) && h.trim() !== "" && s.setMandatoryFulfilled(e.stepName, !0);
    const T = [];
    for (const F of m) {
      const _ = e.data.curved ? p : (w.get(F.id) || []).join(`
`);
      T.push(
        this.generateTextChangeCommandsForRegion(
          A.get(F.id) || 1,
          e.data,
          F.id,
          _
        )
      );
    }
    return new Ii(T);
  }
}
const ca = new $H();
class zH {
}
const GH = "data:application/octet-stream;base64,AAEAAAAPAIAAAwBwRkZUTYdHeHoAAElcAAAAHEdERUYAJwBUAAAe2AAAAB5HUE9TkNtcVAAAHygAACoyR1NVQrj/uP4AAB74AAAAME9TLzJoWmUcAAABeAAAAGBjbWFwtkIacAAAAxAAAAJWZ2FzcP//AAMAAB7QAAAACGdseWY27KOUAAAGCAAAFcRoZWFkFPal0gAAAPwAAAA2aGhlYQU0Ar0AAAE0AAAAJGhtdHiADw6qAAAB2AAAAThsb2Nh5CzfJAAABWgAAACebWF4cACVAEwAAAFYAAAAIG5hbWXeIPPyAAAbzAAAAiJwb3N0ABeZTwAAHfAAAADdAAEAAAABAAAZ9vREXw889QALA+gAAAAA2ZexNAAAAADZl7E0ADL/yQJ2ArwAAAAIAAIAAAAAAAAAAQAAArz/wwAAAqsAAAAAAnYAAQAAAAAAAAAAAAAAAAAAAE4AAQAAAE4ASQAFAAAAAAACAAAAAQABAAAAQAAAAAAAAAAEAbsBkAAFAAACigK7AAAAjAKKArsAAAHfADEBAgAAAAAAAAAAAAAAAAAAAAcAAAAAAAAAAAAAAABYWFhYAEAACgCtArz/wwAAAqkANgAAAAMAAAAAAmQCZAAAACAAAgIPADIAAAAAAU0AAAAAAAAAAAAAALQAAAD3ADUCfQA1AcoANQKrADUCDQA1AX4ANQHYADUBNQA1AcgANQHUADUB8AA1AeEANQHpADUBqQA1AdAANQHpADUCqgA1Af8ANQGaADUB3wA1AbgANQFtADUBbQA1AekANQG8ADUA1QA1AYcANQHBADUBUAA1AhsANQHBADUB4QA1AZYANQH0ADUBxQA1AcUAMgGJADUBwwA1Ad0ANQJ1ADUB9wA1AcoANQF6ADUB3AA1Af8ANQGaADUB3wA1AbgANQFtADUBbQA1AekANQG8ADUA1QA1AYcANQHBADUBUAA1AhsANQHBADUB4QA1AZYANQH0ADUBxQA1AcUAMgGJADUBwwA1Ad0ANQJ1ADUB9wA1AcoANQF6ADUAtAAAAAAAAAAAAAMAAAADAAAAHAABAAAAAAFQAAMAAQAAABwABAE0AAAALgAgAAQADgAAAAoADQAhACYAKgA5AFoAXgB6AKAArQDFAM8A1gDdAOUA7wD2AP0A/wF4//8AAAAAAAoADQAgACMAKgAwAEAAXgBhAKAArQDAAMcA0QDYAOAA5wDxAPgA/wF4//8AAf/5//f/5f/k/+H/3P/W/9P/0f+s/6AAAAAAAAAAAAAAAAAAAAAA/0v+twABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYAIAAwADoARABOAF4AaAAAAAAAAAAXABcAFwAXABcAFwAZABsAGwAbABsAHwAfAB8AHwAkACUAJQAlACUAJQAlACsAKwArACsALwAyADIAMgAyADIAMgA0ADYANgA2ADYAOgA6ADoAOgA/AEAAQABAAEAAQABAAEYARgBGAEYASgAAAQYAAAEAAAAAAAAAAQIDAAAEAAAAAAAAAAAAAAAAAAAAAQAABQYABwgJCgAAAAsAAAAAAAwNDg8QERITFBUAAAAAAAAWFxgZGhscHR4fICEiIyQlJicoKSorLC0uLzAAAAAxAAAyMzQ1Njc4OTo7PD0+P0BBQkNERUZHSElKSwAAAAAAFxcZGyQlKzIyMjIyMjQ2NjY2Ojo6Oj9AQEBAQEZGRkYAAAAAAAAAAAAAAAAAAAAlAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAABMFxclAAAAAAAAAAAAAEovAAAAAAAAAAAAAAAXGxcbGx8fHx8lJQAlKysrAAAAAAAAAAAAAAAAAAAAACgAKAAoACgAKAAoADwAbgC0AQgBbgGQAcYB1AIGAkYCYAKSAtAC4gMoA2ADyAPgBBoEUAR4BI4EogTWBOoE9gUiBToFSAViBXoFqgXWBjAGWgaaBqwG2AbqBwYHIAc2B0wHXgd2B7AH5ggOCCQIOAhsCIAIjAi4CNAI3gj4CRAJQAlsCcYJ8AowCkIKbgqACpwKtgrMCuIK4griAAAABQAyAAAB3QK8AAMABgAJAAwADwAAEyERIRsCCwEREwMhAxMRMgGr/lUcubrGtMG5AXKttQK8/UQCqP7LATX+tgEs/acBGP7MAUn+0QJdAAACADUABQDCAmoAAwAHAAATESMRExUjNcGLi4sCaf5mAZr+KY2NAAAAAgA1AAACSAJkABsAHwAAJQcjNyMHIzcjNzM3IzczNzMHMzczBzMHIwczByc3IwcBthdrFkoXbBdeDl8KYA9fFWwVShVtFWoPagpqDscJSgqqqqqqqmxHbJqamppsR2xsR0cAAAEANf/JAZUCqgAwAAABFR4BByM0LgEjIgYVFBYXHgMVFA4BBxUjNS4BNTMUFjMyNjU0LgInJjU0Njc1ARwwPAF3CBQOExcsPCEwFgkZNyhnPkGDGRQTGBElHBprRzQCqkQNV0INGBIdFB8hGw4tMCkUJkU7EENDCmk8GiUgFBIeGA4LKXpKVxBEAAAABQA1/+8CdgJrAAwAGAAcACkAOAAAEzQ2MzIeARUUBiMiJjcVFBYzMjY1NCYiBiUDIxMDNTQ+ATMyFhQGIyImNxUUHgEzMjY1NC4BIyIGNk02JD0jTTc2TVEeFBUeHiodAWjhVeEtIz0kN01ONjZOUQ4YDRUeDhcOFR4B1j5XKEUoPldXPgEXISEYGCEhcf2dAmP+JgEoRChXfFdWPwEPGhAiGBAbDyIAAwA1AAAB2AJnACQAOQBIAAAlFwcnDgEjIiY1ND4CNyY1NDYzMhYVFA4IBxc3MyciBhUUHgQXPgU1NCYjAxY+ATcnDgUVFBYBmT8qQgdUMk1cDyETFDVTNzdPAwUJBw0HDgUMATUabPULGQQFCgUKAQENBAsEBBYNAQ8bEQRRAQ4ECwUEIbFNZEERMGJKHzMqEhFDQD9ZVjsLFxITDRAJDgULAUFBtRgSBw4LDwcOAQEQBg8LDwcPGf58AQsOB2IBDQUOCg8IGyQAAAAAAQA1ATwBSQJtABEAABMHNxcHFwcnFyM3Byc3JzcXJ+YXVSVnZyhTGE0WUShnZyVWGAJselJLJSVOVXp7Vk4nI0tReQACADUAAAGjAmQAFwAmAAA3NTQ+AzMyHgMdARQOAiMiLgI3FRQeATMyPQE0IyIOAjYZJzIvFxQtMicaIjc9Hh09OiR8CBsXOTkSGAsF4KQxTzEhDQwhMFAypDtaMhkYMlvjrBUkH1isVxEeGgABADUAAAEAAmEABQAAMxEjNTMRhE7KAd6D/Z8AAQA1AAMBkwJmACEAADc1Njc+AzU0JiMiByM+Ajc+AzMyFhUUBgcGBzMVOi5WFxkaCx0XMQJ2AQINDQ4qLCIQTlkjLkAargN3L1kYHCcoFyIhXhsgNxccJxIHbU04WDRHHYEAAAEANQAAAZ8CZAAtAAATNjc2MzIWFRQOAwcWFRQGIyImJyYnMxYXMjY1NC4DKwE1MzI1NCYjIgdDAjktP0RVCw0VCwlca0otVRYVBn4KLhobCg8UDQcsFT0RESQCAaxgMCdfQRcoGBcIBiVpTWwrKCRENgElHRAYCwcCbzsVHjMAAgA1//8BuwJjAAoADQAAITUjNRMzETMVIxUnMzUBDdfadDY20WJrcgGF/oN6a+XAAAAAAAEANf//AawCYwAgAAABFSMHNjMyHgIVFA4CIyIuASczFjMyNjU0JiMiBycTAX+uCxsnKUIlExYrSy8zUS8HfRYjGygkHy4SZSoCYoBSEic+QyEkSkIqL00xJi8hHy80HwFTAAACADUAAAG0AmIAFgAoAAABMhYVFAYjIiYnJjU0PwEzBw4BBzAyNgMyPgE1NC4EIyIGFRQeAQEaO19vTy9QGCksepBYAw4CCA0kEx8TBAgLDxQLHSUVHQGvbF9kgConOV1LVdqUBRYFAv7XFCYXChMSEAwHLyEaJxIAAAAAAQA1//8BdAJjAAYAABMhFQMjEyM2AT6sibS9AmJ3/hUB3wAAAwA1AAABmwJkABkAJAAuAAATNTQ2MhYVFA4BBxYVFA4BIi4BNTQ3LgMXFRQWMjY1NCYiBjcVFBYyNjQmIgZCVqBWFBAMPC1RaFEtPAkLEgpwHjAdHTAeCRskGxskGwG/AUJhYkIeMxINJGU5WjMzWjllJAkNHSbhARgqKhkaKirTARcfHy8fHwAAAAACADUAAAG0AmQAFgAkAAA/AT4BNyYOASMiJjU0NjMyFhcWFRQPARM1NC4BIyIGFRQWMzI2fVgDDQQBCA0EO15uTy9QGCoteSsVHhAcKCUfHiUBlAQWBgEBAWxfZIAqJzldTFXaAYkBGiYSLiIgMi4AAgA1/8wCdQJtADgASAAAAQcGBwYzMjY1NCYjIgYHBh4DFxY3FQYnLgQ3ND4CMzIWFRQGIyInBicuATU0NjMyFhc3BzY1NC4CJyYGHQEUFjc2AfscBAIBFhYmbFVhdgcBBhwtVThNX01cQGlGMBUBLExzQniZWjs3FB07NT1PQBwoBwgqCQIHEg0gKCAUIQG2ux0NGVo8Wm2Laxg2RTcpBAUfWxsCASlBVlsvQHpfOqF8XZBBNwEBWkRIcyAWKMkaIgcQGBEBAz8rAyYjAQIAAAIANQAAAcgCZQAHAAoAADcHIxMzEyMvAge8GG6bYJdvGhknK3JyAmT9nHJz1tYAAAMANQABAWQCaAAPABoAJQAANxEzMhcWFRQHFhUUBw4BIwMzMjc2NTQnJisBFxUzMjc2NTQnJiM2lEAiJC9DJhszNx0mEgkQEAgUJQExFAsVFAoWAgJlKShQUygka1cuIhMBfAYLIB4LBuNwCA4mIgwGAAAAAQA1AAABqQJnACUAACUzDgEjIi4CNTQ+AjMyHgMXIy4DIyIOARUUFjMyPgIBSWAQX0cxSiwWFStLMSM7KB4QA2AFDhQfER4pEi8qFCEUCulrfjNXbD47alk0HzJAPR0SISATNEwsSWcXJxkAAgA1AAABgwJlAA8AGAAAMxEzMh4DFxYVFA4CIwMRMzI1NCcmIzZ/EhcsICYOJBUtTzUiKF4TFzMCZAEMFi4hT29BbFcwAdr+r6dDLjkAAAABADUAAAE3AmUACwAAEyEVIxUzFSMVMxUhNgEBlpGSlv8AAmR4cHmKeQAAAAEANQAAATcCZQAJAAAzESEVIxUzFSMRNgEBmJOTAmR5b3r+/gAAAAABADUAAAG3AmYAIQAAARUmBw4CFRQeAjMyNzY3IzUzFgcGIyIuATU0NjMyFhcBQBQ3FygbEBkgESEWGQVr0wUTMH89WCpiX0haEAGbAUgCASNPOC1FKhUaHDlpZkOyVYlXiaZvWwAAAAEANQAAAYYCZQALAAAzIxEzFTM1MxEjNSOcZmaDZ2eDAmTm5v2c9QABADUAAACgAmUAAwAAMxEzETZpAmT9nAABADUAAAFRAmUAGgAAAREUBwYHBiMiLgMnJjUzFBYVFjMyNzY1EQFQDQ8fJi4IESsgIAUCcQEEGxUHBAJk/pZkLCscIwIRHkEsFxcCDAQzGxAhAZEAAAAAAQA1//8BiwJmAAoAABcRMxETMwMTIwMRNmdzbISTfnABAmb+7AEU/s/+zAEJ/vYAAQA1AAABGgJlAAUAADMRMxEzFTZpewJk/iaKAAEANQAAAeUCZQAMAAAzIxEzGwEzESMTAyMDlmCLTEuMYARZRVgCZP52AYr9nAHK/jYBygABADUAAAGMAmUACQAAGwEDMxEjAxMjEZ2NAWNikwJjAmT+lAFs/ZwBaf6XAmQAAAACADUAAAGsAmUADAAfAAATNDYzMhYVFA4BIyImNxQWMzI+BDU0LgIjIg4BNmRWUWs0VDRWZGgqKg8aEQ0IAwgSIhceJw4BLKGXmJpfjUaelUtjDxohKCcUHzo1IDVKAAACADUAAAFgAmYAEAAbAAATMzIeARcWFRQGBw4BKwEVIxMVMzI3NjU0JyYjNoEjMRoMLhcSFjEtKGRkJRoNGBkOHAJlCxMPO2cvWRkdGMAB3ZMJEi8uEQoAAwA1//8BvwJmABsALgA8AAAlFwYiLgInDgIjIi4BNTQ+ATMyFhUUBx4CAyIOBAc2MzIXFhc2NTQuAQMeAzsBMjcmJyYjIgG9AQINGRgcChMsFBM+VycmWD1Uah0GDQzAERwSDQcCARgVKCIbHQkbLGgGFRUTBgYWDhEOGSAPenkBAggSDRMTAlaGU1GIXK5/ZUkIBwEBZxIgHScLCBEoHzQeLTJOKP7/HCgQCQwiFSMAAAAAAgA1//8BjwJmAA0AGgAAJRcjJxUjETMXFhcWFRQnNjU0LgInKwEVMzIBDYF+cGpqOi4UW4QYCxARBQY1Lhb7++vqAmQBBQosgohEFyoVHg4IAZkAAQAyAAABjwJnACsAADczFBY3NjU0JicuAycmPgEzMhYXIy4DIyIGFRQWFx4BFRQOAiMiJjZ2JBIyJjwRICobAQE0TSs5WQp0AQMJEg0RHCdBQTEUJkQsXFbFKx8BBDgWIB4JFyg7ITlVKFRbCwwTCh0UFSIkJEc2JUE3IGkAAAABADUAAAFTAmUABwAAMxEjNSEVIxGLVQEdVQHseHj+FAAAAAABADUAAAGNAmUAGgAAEzMRFBceATI2NzY1ETMRFA4BBwYjIiYnLgE1NmsIBR8qHgUIagcQDjBUIk0ZGQwCZP6WLhsSGBYQFzUBa/6WM0MvFEEcJCZISwAAAQA1AAABpwJlAAYAADMDMxsBMwO2gGdQUWmAAmT+UwGt/ZwAAQA1AAACQAJkAAwAADMDMxsBMxsBMwMjCwGfaWk4PFA8OGhrWz4+AmP+cwGN/nEBj/2dAYz+dAABADUAAAHBAmUACwAAMxMDMxc3MwMTIycHNop6c0NCcnmJc1VRAUYBHq6u/t/+vdnZAAAAAQA1AAABlAJlAAkAADczAzMXNzMDFSOsAXdvQUFtd3HrAXn29v6H6wAAAAABADUAAAFDAmYACQAAAQMzFSE1EyM1IQFDiIj+85OTAQ0B5v6kimcBdYkAAAEANQFFAaYCagAGAAAbATMTIycHNnx3fYE4NwFFAST+3LOzAAIANQAAAcgCZQAHAAoAADcHIxMzEyMvAge8GG6bYJdvGhknK3JyAmT9nHJz1tYAAAMANQABAWQCaAAPABoAJQAANxEzMhcWFRQHFhUUBw4BIwMzMjc2NTQnJisBFxUzMjc2NTQnJiM2lEAiJC9DJhszNx0mEgkQEAgUJQExFAsVFAoWAgJlKShQUygka1cuIhMBfAYLIB4LBuNwCA4mIgwGAAAAAQA1AAABqQJnACUAACUzDgEjIi4CNTQ+AjMyHgMXIy4DIyIOARUUFjMyPgIBSWAQX0cxSiwWFStLMSM7KB4QA2AFDhQfER4pEi8qFCEUCulrfjNXbD47alk0HzJAPR0SISATNEwsSWcXJxkAAgA1AAABgwJlAA8AGAAAMxEzMh4DFxYVFA4CIwMRMzI1NCcmIzZ/EhcsICYOJBUtTzUiKF4TFzMCZAEMFi4hT29BbFcwAdr+r6dDLjkAAAABADUAAAE3AmUACwAAEyEVIxUzFSMVMxUhNgEBlpGSlv8AAmR4cHmKeQAAAAEANQAAATcCZQAJAAAzESEVIxUzFSMRNgEBmJOTAmR5b3r+/gAAAAABADUAAAG3AmYAIQAAARUmBw4CFRQeAjMyNzY3IzUzFgcGIyIuATU0NjMyFhcBQBQ3FygbEBkgESEWGQVr0wUTMH89WCpiX0haEAGbAUgCASNPOC1FKhUaHDlpZkOyVYlXiaZvWwAAAAEANQAAAYYCZQALAAAzIxEzFTM1MxEjNSOcZmaDZ2eDAmTm5v2c9QABADUAAACgAmUAAwAAMxEzETZpAmT9nAABADUAAAFRAmUAGgAAAREUBwYHBiMiLgMnJjUzFBYVFjMyNzY1EQFQDQ8fJi4IESsgIAUCcQEEGxUHBAJk/pZkLCscIwIRHkEsFxcCDAQzGxAhAZEAAAAAAQA1//8BiwJmAAoAABcRMxETMwMTIwMRNmdzbISTfnABAmb+7AEU/s/+zAEJ/vYAAQA1AAABGgJlAAUAADMRMxEzFTZpewJk/iaKAAEANQAAAeUCZQAMAAAzIxEzGwEzESMTAyMDlmCLTEuMYARZRVgCZP52AYr9nAHK/jYBygABADUAAAGMAmUACQAAGwEDMxEjAxMjEZ2NAWNikwJjAmT+lAFs/ZwBaf6XAmQAAAACADUAAAGsAmUADAAfAAATNDYzMhYVFA4BIyImNxQWMzI+BDU0LgIjIg4BNmRWUWs0VDRWZGgqKg8aEQ0IAwgSIhceJw4BLKGXmJpfjUaelUtjDxohKCcUHzo1IDVKAAACADUAAAFgAmYAEAAbAAATMzIeARcWFRQGBw4BKwEVIxMVMzI3NjU0JyYjNoEjMRoMLhcSFjEtKGRkJRoNGBkOHAJlCxMPO2cvWRkdGMAB3ZMJEi8uEQoAAwA1//8BvwJmABsALgA8AAAlFwYiLgInDgIjIi4BNTQ+ATMyFhUUBx4CAyIOBAc2MzIXFhc2NTQuAQMeAzsBMjcmJyYjIgG9AQINGRgcChMsFBM+VycmWD1Uah0GDQzAERwSDQcCARgVKCIbHQkbLGgGFRUTBgYWDhEOGSAPenkBAggSDRMTAlaGU1GIXK5/ZUkIBwEBZxIgHScLCBEoHzQeLTJOKP7/HCgQCQwiFSMAAAAAAgA1//8BjwJmAA0AGgAAJRcjJxUjETMXFhcWFRQnNjU0LgInKwEVMzIBDYF+cGpqOi4UW4QYCxARBQY1Lhb7++vqAmQBBQosgohEFyoVHg4IAZkAAQAyAAABjwJnACsAADczFBY3NjU0JicuAycmPgEzMhYXIy4DIyIGFRQWFx4BFRQOAiMiJjZ2JBIyJjwRICobAQE0TSs5WQp0AQMJEg0RHCdBQTEUJkQsXFbFKx8BBDgWIB4JFyg7ITlVKFRbCwwTCh0UFSIkJEc2JUE3IGkAAAABADUAAAFTAmUABwAAMxEjNSEVIxGLVQEdVQHseHj+FAAAAAABADUAAAGNAmUAGgAAEzMRFBceATI2NzY1ETMRFA4BBwYjIiYnLgE1NmsIBR8qHgUIagcQDjBUIk0ZGQwCZP6WLhsSGBYQFzUBa/6WM0MvFEEcJCZISwAAAQA1AAABpwJlAAYAADMDMxsBMwO2gGdQUWmAAmT+UwGt/ZwAAQA1AAACQAJkAAwAADMDMxsBMxsBMwMjCwGfaWk4PFA8OGhrWz4+AmP+cwGN/nEBj/2dAYz+dAABADUAAAHBAmUACwAAMxMDMxc3MwMTIycHNop6c0NCcnmJc1VRAUYBHq6u/t/+vdnZAAAAAQA1AAABlAJlAAkAADczAzMXNzMDFSOsAXdvQUFtd3HrAXn29v6H6wAAAAABADUAAAFDAmYACQAAAQMzFSE1EyM1IQFDiIj+85OTAQ0B5v6kimcBdYkAAAAAEADGAAEAAAAAAAEACAASAAEAAAAAAAIABwArAAEAAAAAAAMAFQBfAAEAAAAAAAQACACHAAEAAAAAAAUAIgDWAAEAAAAAAAYADwEZAAEAAAAAABAACAE7AAEAAAAAABEABwFUAAMAAQQJAAEAEAAAAAMAAQQJAAIADgAbAAMAAQQJAAMAKgAzAAMAAQQJAAQAEAB1AAMAAQQJAAUARACQAAMAAQQJAAYAHgD5AAMAAQQJABAAEAEpAAMAAQQJABEADgFEAFYAZQBnAGUAbQBpAHQAZQAAVmVnZW1pdGUAAFIAZQBnAHUAbABhAHIAAFJlZ3VsYXIAADEALgAwADAAMgA7AFYAZQBnAGUAbQBpAHQAZQBSAGUAZwB1AGwAYQByAAAxLjAwMjtWZWdlbWl0ZVJlZ3VsYXIAAFYAZQBnAGUAbQBpAHQAZQAAVmVnZW1pdGUAAFYAZQByAHMAaQBvAG4AIAAxAC4AMAAwADIAOwBGAG8AbgB0AHMAZQBsAGYAIABNAGEAawBlAHIAIAAzAC4AMwAuADAAAFZlcnNpb24gMS4wMDI7Rm9udHNlbGYgTWFrZXIgMy4zLjAAAFYAZQBnAGUAbQBpAHQAZQBSAGUAZwB1AGwAYQByAABWZWdlbWl0ZVJlZ3VsYXIAAFYAZQBnAGUAbQBpAHQAZQAAVmVnZW1pdGUAAFIAZQBnAHUAbABhAHIAAFJlZ3VsYXIAAAAAAgAAAAAAAP+DADIAAAAAAAAAAAAAAAAAAAAAAAAAAABOAAAAAQACAQIBAwADAAQABgAHAAgACQANABMAFAAVABYAFwAYABkAGgAbABwAIwAkACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0AQQBEAEUARgBHAEgASQBKAEsATABNAE4ATwBQAFEAUgBTAFQAVQBWAFcAWABZAFoAWwBcAF0ArAEECWNvbnRyb2xMRgljb250cm9sQ1IKc29mdGh5cGhlbgAAAAAAAAH//wACAAEAAAAMAAAAFgAAAAIAAQABAE0AAQAEAAAAAgAAAAAAAQAAAAoALAAuAAJERkxUAA5sYXRuABgABAAAAAD//wAAAAQAAAAA//8AAAAAAAAAAQAAAAoAMAA+AAJERkxUAA5sYXRuABoABAAAAAD//wABAAAABAAAAAD//wABAAAAAWtlcm4ACAAAAAEAAAABAAQAAgAAAAEACAABKd4ABAAAAEYAlgEwAd4CjAM2A+AEegUsBWYGDAa+B3AIHgjQCYIKNAriC4gMAgx0DOYNZA3mDlQOyg88D54QEBCGEQARchHsEmIS1BOWFAwUghTwFWIV1BaiFxQXkhgEGMYZdBomGtQbfhwYHL4dYB3+HpgfPh/oIJYhPCHmIpQjRiPsJJolSCXuJpQnQifoKJIpRAAmAAn/8QAK//sADP/7AA3/+wAO//sAD//7ABD/+wAR//sAEv/7ABP/+wAU//sAFf/xABb/8QAZ//sAHf/2AB7/+wAf//sAIP/xACH/+wAi//sAI//7ACT/+wAl//EAJv/2ACf/8QAo//sAKf/2ACr/+wAr//sALP/sAC3/7AAu/+IAL//dADD/9gAx/+wAMv/7ADP/+wA0//YAKwAG//EACP/nAAn/4gAK/9MAC//iAAz/9gAN/+IADv/sAA//4gAQ/9gAEf/iABL/1QAT//EAFP/nABX/8QAW/9gAMf/TADL/pgAz//MANP/nADX/8QA2//EAN//7ADj/7gA5//YAOv/7ADv/2AA8//EAPf/2AD7/9gA///EAQP/sAEH/+wBC/+wAQ//xAET/7ABF/+wARv/2AEf/3QBI/90ASf/EAEr/zgBL//YAKwAG//YAB//2AAn/3QAL/+wADP/sAA3/8QAO//YAD//sABD/8QAR/+wAEv/iABP/5wAU/+wAFf/dABb/7AAX/78AMf/YADL/sAAz/+IANP/iADX/8QA2/+cAN//xADj/3QA5/+wAOv/2ADv/4gA8//EAPf/xAD7/8QA///YAQP/YAEH/9gBC/+cAQ//sAET/7ABF/+wARv/xAEf/zgBI/9MASf/OAEr/zgBL/+wAKgAG//YAB//iAAj/4gAK/+IADP/dAA3/ugAO/+IAD//iABD/5wAR/+IAEv/dABP/yQAU/90AFf+mABb/0wAx/5gAMv/YADP/4gA0/9MANf/xADb/7AA3/+wAOP/iADn/7AA6//EAO//dADz/5wA9/+wAPv/sAD//5wBA/9gAQf/sAEL/zgBD/+wARP/YAEX/tQBG/90AR/+hAEj/oQBJ/8QASv+DAEv/7AAqAAb/8QAH/90ACP/YAAn/oQAL/8kADP/iAA3/sAAO/+cAD//YABD/4gAR/90AEv/bABP/4gAU/+IAFf/TABb/5wAg/+QAMf/nADL/3AAz//QANP/rADX/9AA2//IAN//4ADj/8AA5//QAOv/1ADv/7AA8/+oAPf/7AD7/9wA///IAQP/tAEH/+wBC/+IAQ//2AET/4wBF/7YARv/vAEf/pgBK/6MAS//yACYAB//TAAj/8QAK/84ADP/dAA3/9gAO//EAD//dABD/pgAR/8kAEv+6ABP/7AAU/90AFf/OADH/xAAy/5IAM//sADT/3QA1/+cANv/xADf/9gA4/90AO/9WADz/5wA9//EAPv/sAD//5wBA/84AQf/dAEL/0wBD/+cARP/nAEX/5wBG/+cAR//dAEj/2ABJ/7oASv/JAEv/4gAsAAb/+wAH//sACP/xAAn/zgAK/+cAC//dAAz/9gAN/9gADv/tAA//7AAQ/+kAEf/rABL/3QAT/90AFP/hABX/3QAW/90AMf/nADL/vwAz/+cANP/nADX/8QA2//EAN//sADj/5wA5//YAOv/2ADv/4gA8//EAPf/2AD7/+wA///sAQP/2AEH/+wBC/+wAQ//7AET/7ABF/9MARv/7AEf/yQBI/84ASf+wAEr/xABL/+cADgAG//sACf/xAAv/7AAN//sADv/7AA8AAAAR//EAEv/0ABP/9gAU//EAFf/xABb/7AAx//YAQP/2ACkABv/7AAf/9gAI//sACf/iAAr/5wAL/+wADP/vAA3/3QAO//sAD//qABD/8QAR/+wAEv/nABP/8QAU/+cAFf/iABb/7AAx/+cAMv/vADP//AA0/+cANf/7ADb//gA4//EAOf/8ADr//AA7/+kAPP/6AD3//QA+//4AP//7AEL/6gBD//0ARP/2AEX/7ABG//EAR//YAEj/4gBJ/+wASv/LAEv//AAsAAb/+wAH//EACP/2AAn/0wAK/+IAC//JAAz/5wAN/90ADv/iAA//7AAQ/+cAEf/sABL/3QAT/9MAFP/iABX/zgAW/+cAMf/YADL/xAAz/+wANP/dADX/6AA2//EAN//xADj/4wA5//EAOv/2ADv/7AA8/+wAPf/sAD7/9gA//+wAQP/iAEH/8QBC/90AQ//nAET/5wBF/8QARv/mAEf/xABI/8kASf+1AEr/rQBL/+IALAAG//sAB//7AAj/9gAJ/9MACv/2AAv/ugAM/+kADf/dAA7/9gAP/+wAEP/2ABH/8AAS//EAE//2ABT/5wAV/9gAFv/sADH/vwAy/9UAM//eADT/3wA1//EANv/xADf/9gA4/+IAOf/xADr/9gA7/+wAPP/xAD3/9gA+//EAP//2AED/2ABB//EAQv/nAEP/9gBE/+cARf/TAEb/8QBH/9gASP/YAEn/xgBK/78AS//xACsABv/7AAf/9gAI/+wACf/TAAr/5wAL/90ADP/lAA3/zgAO/90AD//dABD/7AAR/+IAEv/iABP/2AAU/+IAFf/JABb/5wAx/90AMv/EADP/6wA0/+EANf/wADb/8AA4/9wAOf/dADr/7AA7/9gAPP/sAD3/5wA+/+wAP//iAED/0wBB/+IAQv/YAEP/4gBE/84ARf/JAEb/4gBH/8kASP/OAEn/vwBK/8kAS//TACwABv/7AAf/3wAI/+cACf+wAAr/4wAL/8kADP/dAA3/xwAO/+cAD//dABD/7AAR/+cAEv/iABP/yQAU/9cAFf+/ABb/4gAa/+kAMf/YADL/uwAz/+EANP/dADb/6wA3//MAOP/lADn/8QA6//IAO//eADz/5wA9/+4APv/zAD//8ABA/+IAQf/2AEL/6gBD//YARP/kAEX/zABG/+8AR/+0AEj/uwBJ/64ASv+vAEv/5QAsAAb/+wAH/90ACP/nAAn/4gAK/9MAC//nAAz/3QAN//YADv/eAA//3QAQ/7AAEf/OABL/sAAT//sAFP/dABX/0wAW/9MAMf/iADL/iAAz//YANP/OADX/9gA2//EAN//xADj/0wA5//YAOv/zADv/gAA8//EAPf/7AD7/+wA///YAQP/OAEH/7gBC/84AQ//2AET/2ABF//sARv/2AEf/5wBI/+cASf/TAEr/4gBL/+wALAAG//sAB//2AAj/8QAJ/9gACv/nAAv/3QAM/+IADf/dAA7/4gAP/+IAEP/nABH/5wAS/9gAE//YABT/3QAV/84AFv/sADH/5wAy/78AM//nADT/2AA1/+cANv/nADf/7AA4/90AOf/sADr/7AA7/+cAPP/sAD3/8QA+/+wAP//xAED/4gBB//EAQv/dAEP/5wBE/+IARf/YAEb/5wBH/78ASP/HAEn/sABK/7UAS//dACsABv/xAAf/8QAI/+IACf/dAAr/0wAL/+IADP/iAA3/3QAO/+cAD//dABD/zgAR/9MAEv/EABP/0wAU/84AFv/dADH/4gAy/6EAM//jADT/3QA1/+wANv/sADf/5wA4/90AOf/nADr/8QA7/78APP/xAD3/9gA+/+wAP//nAED/3QBB/+cAQv/nAEP/5wBE/+IARf/OAEb/3QBH/8QASP/JAEn/lwBK/7oAS//YACkABv/sAAf/0wAI/90ACf/OAAr/3QAM/90ADf/EAA7/5wAP/9gAEP/YABH/3QAS/9MAE//YABT/4gAV/90AMf/sADL/wAAz/+8ANP/kADX/6wA2//AAN//2ADj/5AA5//EAOv/uADv/1gA8//QAPf/2AD7/8QA///AAQP/dAEH/7ABD/+gARP/YAEX/1QBG/+wAR/+3AEj/wwBJ/7UASv+wAEv/5gAeAAf/zgAi/+4AI//5ACT/7wAy/9AAM//pADT/sQA1/+sANv/nADf/5gA4/7oAOf/vADr/9wA7/9AAPP/sAD3/6wA+/+YAP//sAED/uwBB/+kAQv+7AEP/5ABE/9QARf+6AEb/0ABH/34ASP+SAEn/zQBK/5sAS//nABwAF//RACT//wAy/9EAM//uADT/5wA1/+8ANv/3ADf/7gA4/+gAOf/3ADr/+wA7/9oAPP/vAD3/9wA+/+4AP//vAED/4QBB//cAQv/nAEP/7wBE/+4ARf/QAEb/9wBH/8EASP/MAEn/wwBK/7sAS//nABwAF//QABv/+QAy/8EAM//zADT/6wA1//sANv/zADf/+wA4/+8AOf/zADr//gA7/+EAPP/vAD3/9wA+//kAP//3AED/4gBB//kAQv/jAEP/8wBE/+YARf/VAEb/+QBH/84ASP/JAEn/twBK/8EAS//rAB8ABv/7ABL/3wAX/8kAJf/5ACv/7wAy/7oAM//zADT/6wA1/+8ANv/uADf/8wA4/+oAOf/vADr/7wA7/9QAPP/5AD3//gA+//EAP//vAED/4wBB//MAQv/mAEP/7gBE/+cARf/XAEb/6wBH/8kASP/JAEn/twBK/7cAS//nACAABv/7ACQAAgAl/+8AJ//5AC3//gAv//4AMv/oADP//QA0/+sANf/7ADb/+gA3//sAOP/jADn/9wA6//oAO//kADz//wA9//0APv/+AD8AAABA/+gAQf/7AEL/6ABD//sARP/sAEX/8QBG//sAR//qAEj/6wBJ/+cASv/qAEv/+QAbAAb/+wAl/+8AMv+5ADP/+wA0/+8ANf/7ADb/+wA3//0AOP/vADn/+wA6AAAAO/+7ADz//gA9//4APv/7AED/7ABB//4AQv/nAEP/+QBE//kARf/7AEb/+QBH//MASP/rAEn/4gBK/+8AS//7AB0ABv/2ABf/zgAl/+8AMv+3ADP/9wA0/+sANf/3ADb/8QA3//kAOP/uADn/8wA6//sAO//YADz/8wA9/+4APv/3AD//8wBA/+MAQf/3AEL/6QBD/+8ARP/nAEX/1ABG/+8AR//JAEj/zABJ/6YASv/JAEv/3AAcAAb/+wAX//MAJf/7ADL/6wAz//4ANP/uADX/+wA2//4AN//+ADj/8wA5//0AOv/+ADv/7gA8//4APf/+AD7/+wA///4AQP/uAEL/9wBD//4ARP/+AEX/+QBG//4AR//uAEj/9wBJ/+4ASv/zAEv//gAYAAb/+wAx//YAMv/rADP//wA0//MANf//ADYAAQA3//8AOP/zADv/6AA8//4APf/+AD4AAQBA/+4AQf//AEL/8wBD//4ARP/4AEX//QBH/+wASP/3AEn/7ABK//EASwABABwABv/2ABf/4QAy/8oAM//9ADT/+QA1//4ANv/7ADf//gA4//MAOf/+ADr//wA7/+EAPP/7AD3//gA+//4AP//+AED/7wBB//4AQv/zAEP//gBE//sARf/7AEb//gBH/+8ASP/5AEn/2gBK//oAS//+AB0ABv/nABf/5wAx/7AAMv/hADP/7gA0/7QANf/rADb/5wA3/+4AOP+sADn/6wA6//kAO/+3ADz/6gA9/+8APv/nAD//5wBA/6wAQf/uAEL/rgBD/+cARP+8AEX/3ABG/9oAR//cAEj/0QBJ/9oASv/RAEv/7wAeAAb/9gAX//cAI//9ADH/vwAy/+4AM//5ADT/2gA1//4ANv/3ADf/+wA4/9oAOf/3ADr/+wA7/+cAPP/7AD3/+QA+//cAP//5AED/1ABB//sAQv/cAEP/9wBE/+8ARf/JAEb/6wBH/8QASP++AEn/5wBK/8EAS//+ABwAF//7ADH/7AAy/+QAM//+ADT/7gA1//4ANgAAADf//QA4//cAOf/7ADr//gA7/+4APP/+AD3//gA+//0AP//7AED/7wBB//4AQv/uAEP//gBE//cARf/7AEb/+QBH/+gASP/vAEn/6wBK/+gAS//+AB4ABv/7ABf/8wAa//4AHf/3ACX/9wAq//4AMf/2ADL/5AAz//0ANP/zADX/+wA2//4AN//+ADj/+QA7/+4APf/+AD7/+wA///4AQP/2AEH/+gBC/+4AQ//7AET/+QBF//sARv/+AEf/8wBI/+8ASf/zAEr/6wBL//4AHQAG//EAJP/3ADH/7AAy/7sAM//sADT/4wA1/+8ANv/vADf/9wA4/+QAOf/qADr/9wA7/98APP/vAD3/9wA+/+sAP//uAED/4wBB/+4AQv/mAEP/7wBE/+IARf/VAEb/7gBH/8MASP/GAEn/uwBK/7oAS//fABwABv/sACT//gAy/54AM//rADT/6gA1//EANv/rADf/9wA4/+MAOf/oADr/9wA7/64APP/sAD3/8QA+/+wAP//sAED/4QBB//MAQv/oAEP/5ABE/9gARf/kAEb/7gBH/9EASP/QAEn/uwBK/8QAS//zADAAF//3ABj//wAZ/+kAGv//ABv//QAc//4AHf/pAB7/+wAf//8AIP/iACH//gAi//8AI//+ACT//wAl/+IAJ//uACj//gAp/+cAKv/hACv/+QAs/8MALf/QAC7/5AAv/8wAMP//ADL/4QAz//4ANP/jADX/9wA3//kAOP/fADn/9wA7/+IAPP/5AD3/+gA+//EAP//6AED/2gBB/+8AQv/aAET/7wBF/9cARv/qAEf/xgBI/7sASf/qAEr/tABL//sAHQAG/+cAF//oACT/+gAy/+IAM//xADT/zAA1/+8ANv/sADf/+gA4/8wAOf/3ADr/8wA7/8kAPP/uAD3/7wA+/+wAP//rAED/yQBB//cAQv/MAEP/+ABE/9QARf/KAEb/2gBH/8EASP/EAEn/4gBK/7cAS//vAB0ABv/xABv/+QAl/+4AMv+8ADP/7wA0/9wANf/zADb/6AA3//cAOP/hADn/5gA6//MAO//aADz/6QA9//MAPv/pAD//6wBA/+MAQf/3AEL/2gBD/+kARP/rAEX/1ABG/+kAR//JAEj/zABJ/7QASv+7AEv/5wAbAAb/9gAy/6YAM//9ADT/0wA1//oANv/+ADf//QA4/9UAOf/3ADr//wA7/7kAPP/6AD3//gA+//sAP//7AED/0ABB//oAQv/XAEP/+QBE/+IARf/zAEb/9wBH/+8ASP/vAEn/6gBK/+cAS//6ABwABv/7ACQAAgAy/9UAM//7ADT/7wA1//cANv/9ADf//wA4/+4AOf/7ADr//wA7/+sAPP/+AD3//gA+//0AP//6AED/7gBB//sAQv/sAEP/+wBE/+8ARf/7AEb//QBH/+8ASP/qAEn/3wBK//gAS//+ABwABv/nABf/lQAy/4IAM//3ADT/wQA1/+kANv/nADf/+gA4/8QAOf/oADr/6wA7/5UAPP/uAD3/+wA+//cAP//vAED/wQBB/+8AQv/DAEP/5wBE/84ARf/uAEb/7gBH/+kASP/pAEn/zgBK/+4AS//7ADMABv/sABf/owAY//kAGf/XABr//gAb//4AHP/5AB3/0AAe//gAIP+tACH/8wAi//4AJP/+ACX/0AAm//kAJ//MACj//gAp/9oAKv/+ACv//gAs/+MALf/zAC7/3AAv//cAMP/7ADL/jwAz/+oANP/CADX/7wA2/+oAN//3ADj/xgA5/+sAOv/6ADv/qgA8/+sAPf/7AD7/7wA//+8AQP++AEH/7gBC/8MAQ//qAET/1QBF/+sARv/pAEf/6ABI/+cASf/iAEr/2gBL/+4AHAAG/+cAF//hADL/1AAz/+sANP+wADX/6wA2/+QAN//jADj/qgA5/+cAOv/jADv/ugA8/+cAPf/vAD7/2gA//+kAQP+uAEH/7wBC/64AQ//kAET/uwBF/9oARv/aAEf/zABI/84ASf/TAEr/zQBL/+sAHwAG/+IAF/+lACP//gAk//sAL//uADL/hwAz/+8ANP+sADX/+AA2/9wAN//6ADj/uQA5/+4AOv/vADv/hAA8/+gAPf/pAD7/5wA//+YAQP+wAEH/6QBC/7oAQ//vAET/zgBF/+gARv/oAEf/2gBI/+YASf/QAEr/4gBL/+kAHAAG//sAF//+ADL/5wAz//sANP/kADX/+wA2//8AN//7ADj/4QA5//4AOv//ADv/6wA8//sAPf/+AD7//gA///sAQP/hAEH/+wBC/9oAQ//+AET/7wBF//sARv/6AEf/6QBI//kASf/rAEr/6QBL//sAMAAG/+wAB//YAAj/3QAJ/9MACv+/AAv/yQAM/+IADf/YAA7/7AAP/9MAEP/JABH/5wAS/+IAE//OABT/4gAV/+wAFv/nACD/WwAh/+wAIv/xACP/8QAk//YAJf/xADL/oQAz/+wANP/nADX/7AA2//sAN//2ADj/9gA5//sAO/+PADz/7AA9//YAPv/sAD//8QBA/+IAQf/nAEL/7ABD/+IARP/JAEX/zgBG/+cAR/+/AEj/xABJ/5IASv+/AEv/4gArAAb/9gAI/8QACf+cAAr/zAAL/5QADP+6AA3/xAAO/+oAD//BABD/zgAR/78AEv+7ABP/2AAU/78AFf+mABcAAgAk/+cAMf+mADL/2AAz/+cANP+7ADX/5gA2//MAN//zADj/sQA5/+oAOv/rADz/6AA9/+gAPv/mAD//5wBA/7oAQf/4AEL/twBD/+gARP/OAEX/sQBG/88AR/+EAEj/lwBJ/9AASv+NAEv/9wAsAAb/9gAH/+oACP/nAAn/xAAK/+gAC//TAAz/3QAN/9gADv/lAA//5wAQ/+IAEf/aABL/3AAT/9MAFP/bABX/xAAk//EAMf/YADL/zQAz/+wANP/kADX/9wA2//MAN//9ADj/4wA5//cAOv/3ADv/5gA8//4APf/9AD7/7gA//+4AQP/kAEH/+QBC/+YAQ//vAET/6QBF/9oARv/vAEf/zgBI/88ASf/QAEr/uQBL//kAKwAG//YAB//qAAj/7AAJ/9gACv/uAAv/4gAM/+IADf/dAA7/9AAP/+IAEP/eABH/5gAS/+IAE//TABT/3QAV/90AJP/2ADH/7AAy/74AM//uADT/3wA1//oANv/xADj/5wA5/+8AOv/5ADv/2AA8/+0APf/9AD7/8wA///EAQP/rAEH/+ABC/+QAQ//3AET/5gBF/9AARv/zAEf/xgBI/80ASf++AEr/twBL/+gAKgAH//EACP/xAAn/0wAK/+YAC//YAAz/5wAN/9gADv/oAA//5wAQ/+IAEf/iABP/2AAU/90AFf/dACT/+wAx/+wAMv+7ADP/9wA0/+QANf/rADb/5wA3//EAOP/kADn/+QA6//YAO//aADz/9wA9//4APv/uAD//8QBA/+cAQf/vAEL/4wBD/+sARP/cAEX/0ABG/+sAR//CAEj/xABJ/7QASv+6AEv/6AAmAAf/9gAI//EACf/sAAr/9gAM/+cADv/6AA//8QAQ//EAEf/vABL/4QAT//EAFP/iABX/5wAy/+kAM//9ADT/5wA1//sANv/9ADf//gA4/+sAOf/+ADoAAQA7/+gAPP/9AD3/9wA+//0AP//9AED/6wBBAAEAQv/pAEP/+QBE/+wARgACAEf/6QBI/+8ASf/nAEr/6wBL//sAKQAH//sACP/xAAn/5wAK/+4AC//2AAz/4gAN//sADv/1AA//8QAQ/90AEf/kABL/4gAT/+wAFP/YABX/3QAx//YAMv+5ADP/+AA0/+MANf/3ADb/+AA3//kAOP/iADn/+gA6//0AO//OADz//QA9//4APv/5AD///ABA/+YAQv/jAEP/9wBE/+YARf/vAEb//gBH/+cASP/vAEn/0QBK/+YAS//9ACgAB//2AAj/4gAJ/90ACv/sAAv/4gAM/+gADf/iAA7/9QAP/+gAEP/dABH/4AAS/+YAE//OABT/4gAV/90AJP/7ADH/9gAy/8EAM//vADT/3wA2//QAN//4ADj/4wA5/+kAOv/6ADv/0QA8/+YAPf/zAD7/6QA///EAQP/qAEL/3ABD/+gARP/fAEb/+ABH/7sASP+7AEn/rwBK/68AS//jACcACP/xAAn/7AAK//gADP/2AA7/9wAP//YAEP/xABH/5wAS/+cAE//xABT/7AAV/+UAMf/2ADL/6AAz//kANP/qADX/+wA2//oAN//7ADj/6wA5//cAOv//ADv/4wA8//sAPf/+AD7/+wA///oAQP/sAEH/+gBC/+MAQ//5AET/7wBF/+oARv/7AEf/4wBI/+wASf/jAEr/6gBL//4AJgAH//sACP/7AAn/5wAK//oADP/2AA7/9gAP//YAEP/xABH/8QAS//IAE//xABT/5wAV//EAMv/nADP/+wA0//EANf/9ADb//gA3//4AOP/uADn/+wA6//4AO//oAD0AAAA+//sAP//+AED/7wBB//4AQv/qAEP//wBE//EARf/3AEb/+wBH/+YASP/3AEn/2gBK/+QAS//7ACkAB//2AAj/9gAJ/90ACv/yAAz/8QAO//EAD//wABD/6gAR/+wAEv/mABP/9AAU/+wAFf/rABf/zgAx//YAMv/OADP/7wA0/+oANf/5ADb//gA3//0AOP/oADn/+QA6//0AO//YADz//gA9//8APv/6AD//+QBA/+4AQf/5AEL/4wBD//gARP/qAEX/+QBG//oAR//pAEj/6QBJ/9UASv/rAEv/+gAqAAf/sgAI/8kACf+wAAr/ugAL/7UADP+1AA3/3QAO/+QAD/+6ABD/sgAR/7UAEv+xABP/4gAU/6sAFf+mADH/lwAy/9oAM//jADT/qwA1/+IANv/iADf/4wA4/5oAOf/XADr/7gA7/7QAPP/kAD3/6wA+/+4AP//mAED/rQBB/+8AQv+qAEP/6gBE/74ARf/XAEb/2gBH/9AASP/SAEn/1QBK/80AS//qACsAB//nAAj/8QAJ/6YACv/sAAv/nAAM/90ADf+6AA7/9gAP/+IAEP/sABH/3QAS/9oAE//sABT/3QAV/8QAJP/+ADH/pgAy/+sAM//vADT/ygA1//0ANv/zADf/+wA4/9MAOf/vADr/+wA7/9gAPP/3AD3/9wA+//EAP//7AED/1QBB//cAQv/PAEP/8wBE/+YARf+7AEb/5wBH/7UASP/JAEn/2gBK/6UAS//zACkAB//2AAn/7AAK//kAC//sAAz/9gAO//oAD//2ABD/7AAR/+cAEv/vABP/9gAU//EAFf/sABcAAQAx/+YAMv/pADP/+QA0/+oANf/zADb/+wA3//oAOP/nADn/9wA6//4AO//uADz/+QA9//oAPv/7AD//+QBA/+8AQf/3AEL/6QBD//oARP/sAEX/8wBG//gAR//pAEj/6QBJ/+MASv/nAEv//QAqAAf/9gAI//sACf/sAAr/9wAL/+wADP/7AA7/+gAP//EAEP/2ABH/7AAS//EAE//2ABT/9gAV/+QAFwABADH/8QAy/+kAM//3ADT/6QA1//kANv/5ADf/+QA4/+8AOf/6ADr//gA7/+8APP/7AD3/+gA+//oAP//4AED/7wBB//sAQv/rAEP//QBE/+8ARf/3AEb/+gBH/+4ASP/rAEn/4QBK/+wAS//5ACsAB//xAAj/4gAJ/9gACv/sAAv/2AAM//YADf/iAA7/8QAP/90AEP/iABH/0wAS/+IAE//JABT/4gAV/94AJP/7ADH/3QAy/7QAM//pADT/4QA1/+wANv/vADf/6gA4/+IAOf/qADr/+gA7/9oAPP/pAD3/6wA+/+wAP//pAED/4QBB/+sAQv/cAEP/6wBE/+IARf/JAEb/7gBH/7wASP/BAEn/pgBK/7UAS//kACwAB//iAAj/5wAJ/+IACv/OAAv/2AAM/+cADf/nAA7/8AAP/90AEP+6ABH/xAAS/9cAE//XABT/2AAV/9gAG//3ACT/+wAx/+IAMv+gADP/6QA0/+MANf/mADb/7wA3/+sAOP/aADn/6AA6//YAO/+xADz/6wA9/+4APv/oAD//7wBA/9oAQf/oAEL/1wBD/+MARP/aAEX/2ABG/+cAR//PAEj/yQBJ/7kASv/BAEv/6AApAAf/8QAI/+wACf/OAAr/6gAL/84ADP/nAA3/2AAO//YAD//fABD/4gAR/9gAEv/lABP/5wAU/+IAFf/YADH/4gAy/+cAM//3ADT/2gA1//gANv/5ADf/+wA4/9wAOf/3ADr//gA7/+MAPP/3AD3//QA+//cAP//3AED/1QBC/9UAQ//9AET/6QBF/+EARv/pAEf/ugBI/8QASf/aAEr/wgBL//sAKwAH/8kACP/YAAn/xAAK/9MAC/+/AAz/yQAN/9gADv/nAA//xAAQ/7oAEf+1ABL/wQAT/9gAFP+6ABX/vwAk//sAMf+/ADL/2gAz/+gANP/KADX/6QA2/+kAN//oADj/xgA5/+QAOv/nADv/uQA8/+wAPf/uAD7/6QA//+cAQP/GAEH/7ABC/8kAQ//mAET/2ABF/84ARv/VAEf/wQBI/7wASf/GAEr/tABL/+8AKwAH//EACP/2AAn/yQAK/+oAC//TAAz/3QAN/+cADv/sAA//4gAQ/+IAEf/YABL/3wAT/90AFP/dABX/2AAk//sAMf/nADL/xgAz//MANP/iADX/7wA2/+4AN//3ADj/4wA5/+kAOv/vADv/1wA8/+4APf/zAD7/6gA//+0AQP/kAEH/9wBC/98AQ//qAET/5wBF/9AARv/vAEf/yQBI/9AASf/PAEr/xABL/+8AKQAH/+cACP/sAAn/5wAK/+kAC//dAAz/2AAO/+wAD//XABD/qwAR/8kAEv/AABP/9gAU/9MAFf/OADH/2AAy/7AAM//5ADT/2gA1//0ANv/6ADf//gA4/98AOf/3ADr//QA7/8YAPP/7AD3//gA+//gAP//4AED/1QBB//0AQv/VAEP/+ABE/+MARf/zAEb/+QBH/+4ASP/zAEn/4gBK/+cAS//zACkACP/2AAn/5wAK//QAC//sAAz/+wAN//4ADv/2AA//5QAQ/+wAEf/nABL/8wAT//EAFP/nABX/3QAx/+QAMv/KADP/+QA0/+wANf/6ADb/+gA3//sAOP/vADn/+gA6AAAAO//hADz//wA9//0APv/5AD///gBA/+wAQf/7AEL/7ABD//sARP/vAEX/9wBG//sAR//zAEj/6gBJ/+EASv/jAEv/+wArAAf/zgAI/84ACf/YAAr/ygAL/9gADP/JAA3/+wAO/9kAD//JABD/ogAR/7oAEv+5ABP/5wAU/8QAFf+9ACT/+wAx/7oAMv+FADP/+wA0/7sANf/qADb/6wA3/+wAOP++ADn/5gA6/+8AO/+iADz/6AA9/+oAPv/sAD//7wBA/8MAQf/mAEL/uwBD/+YARP/KAEX/6QBG/+8AR//jAEj/3wBJ/9MASv/hAEv/6wApAAf/zgAI/84ACf/TAAv/2AAM/84ADv/eAA//xAAQ/7AAEf/TABL/sQAT/+wAFP/FABX/yQAk//sAMf/JADL/lQAz//MANP/BADX/+QA2//MAN//3ADj/xgA5//sAOv/3ADv/pQA8/+8APf/+AD7/7gA//+oAQP/DAEH/7gBC/8QAQ//vAET/0ABF/+4ARv/uAEf/6QBI/+QASf/aAEr/5gBL//cAKgAH/8QACP/OAAn/pgAL/7oADP+rAA3/3QAO/+cAD/+5ABD/twAR/8QAEv+zABP/0wAU/7AAFf+cACT/+wAx/6EAMv/aADP/4wA0/7cANf/4ADb/4wA3//0AOP+3ADn/7gA6/+8AO/+7ADz/7gA9//EAPv/jAD//6ABA/7oAQf/zAEL/uQBD/+sARP/OAEX/3wBG/+EAR//aAEj/2ABJ/9gASv/MAEv/7gAsAAf/yQAI/84ACf/JAAr/wgAL/8kADP/JAA3//gAO/8kAD/+6ABD/jQAR/7oAEv+gABP/4gAU/7UAFf+6AB7/8QAk//sAMf+1ADL/lwAz/+8ANP+7ADX/5gA2/+4AN//uADj/uQA5/+gAOv/3ADv/hAA8/+8APf/sAD7/7AA//+oAQP+6AEH/7ABC/7kAQ//pAET/ygBF/+8ARv/vAEf/6ABI/+kASf/fAEr/5ABL//EAJgAH//YACf/iAAr/7AAL/+cADP/iAA3//wAO//UAD//nABD/7AAR/+IAEv/gABP/7AAU/90AFf/TADH/4gAy/+sAM//+ADT/6AA1//4ANgAEADf//wA4/9wAOf/6ADv/5gA8//8APf//AD///QBA/+MAQf//AEMAAABE/+8ARf/4AEb/+wBH//cASP/rAEn/6QBK/+kAS//9AAIAAQAGAEsAAAAAAAAAAQAAAADUGBYRAAAAANmXsTQAAAAA2ZexNA==", Ao = (r) => kN("http://www.w3.org/2000/svg", r), HH = (r, e) => {
  const t = Ao("rect");
  return t.setAttribute("height", `${r}`), t.setAttribute("width", `${e}`), t;
}, WH = (r, e, t, n) => {
  const i = zg("filter");
  i.setAttribute("id", n), i.setAttribute("height", "200%"), i.setAttribute("width", "200%"), i.setAttribute("x", "-50%"), i.setAttribute("y", "-50%");
  const a = zg("feOffset");
  i.appendChild(a), a.setAttribute("result", "offOut"), a.setAttribute("in", "SourceAlpha"), a.setAttribute("dx", `${r}`), a.setAttribute("dy", `${e}`);
  const s = zg("feGaussianBlur");
  i.appendChild(s), s.setAttribute("result", "blurOut"), s.setAttribute("in", "offOut"), s.setAttribute("stdDeviation", `${t}`);
  const o = zg("feBlend");
  return i.appendChild(o), o.setAttribute("in", "SourceGraphic"), o.setAttribute("in2", "blurOut"), o.setAttribute("mode", "normal"), i;
}, jH = (r) => {
  let e = r;
  return e = e.replace(/feoffset/gi, "feOffset"), e = e.replace(/fegaussianblur/gi, "feGaussianBlur"), e = e.replace(/feblend/gi, "feBlend"), e = e.replace(/lineargradient/gi, "linearGradient"), e = e.replace(/stddeviation/gi, "stdDeviation"), e;
};
function qH(r, e, t, n, i, a) {
  const s = i, o = a, l = {
    x: e[0],
    y: e[1],
    width: e[2] - e[0],
    height: e[3] - e[1]
  };
  if (l.width <= 0)
    return;
  const u = QH(
    l.height,
    l.width,
    t * s,
    n * o
  ), c = (n - u * l.width) / 2 - u * l.x, h = (t - u * l.height) / 2 - u * l.y;
  r.setAttribute("transform", `translate(${c} ${h}) scale(${u} ${u})`);
}
function QH(r, e, t, n) {
  const i = t / r, a = n / e;
  return i > 1 && a > 1 ? Math.min(i, a) : i > 1 && a < 1 ? a : i < 1 && a > 1 ? i : Math.min(i, a);
}
const $k = {
  m: ["x", "y"],
  z: [],
  l: ["x", "y"],
  h: ["x"],
  v: ["y"],
  c: ["x1", "y1", "x2", "y2", "x", "y"],
  s: ["x2", "y2", "x", "y"],
  q: ["x1", "y1", "x", "y"],
  t: ["x", "y"],
  a: ["rx", "ry", "xRotation", "largeArc", "sweep", "x", "y"]
};
class YH {
  constructor(e) {
    const t = Array.from(e.querySelectorAll("path"));
    this.paths = t.map((n) => {
      const i = n.getAttribute("d") || "", a = this.parsePath(i);
      return { pathElement: n, pathData: a };
    });
  }
  transform(e) {
    for (const t of this.paths)
      t.pathData = this.runTransformer(t.pathData, e);
    this.update();
  }
  encodePath(e) {
    let t = "";
    const i = (a) => {
      const s = [], o = a.relative ? a.type : a.type.toUpperCase();
      let l = t !== o;
      const u = $k[a.type];
      l && (s.push(o), t = o);
      for (const c of u) {
        const h = a[c];
        let f;
        switch (typeof h) {
          case "boolean":
            f = h | 0;
            break;
          case "number":
            f = (h * 100 | 0) / 100;
            break;
          default:
            throw new Ed("Failed to encode path.");
        }
        l || s.push(" "), s.push(f), l = !1;
      }
      return s.join("");
    };
    return e.map(i).join("");
  }
  parsePath(e) {
    const t = /([mzlhvcsqta])([^mzlhvcsqta]*)/gi, n = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi, i = [];
    let a;
    for (t.lastIndex = 0; a = t.exec(e); ) {
      const s = a[1].toLowerCase(), o = (a[2].match(n) || []).map(parseFloat), l = s === a[1], u = $k[s];
      if (o.length < u.length)
        throw new Ed(
          `Path type "${s}" given ${o.length} arguments, expected ${u.length}.`
        );
      if (u.length > 0) {
        if (o.length % u.length !== 0)
          throw new Ed(
            `Path type "${s}" given ${o.length} arguments, not divisible by ${u.length}`
          );
        for (let c = 0; c < o.length / u.length; c++) {
          const h = { type: s, relative: l };
          for (let f = 0; f < u.length; f++)
            h[u[f]] = o[c * u.length + f];
          i.push(h);
        }
      } else
        i.push({ type: s, relative: l });
    }
    return i;
  }
  runTransformer(e, t) {
    const n = [
      ["x1", "y1"],
      ["x2", "y2"],
      ["x", "y"]
    ], i = (a) => {
      for (let s = 0; s < n.length; s++) {
        const [o, l] = n[s];
        if (o in a && l in a) {
          const u = [a[o], a[l]], c = t(u);
          if (c.length < 2)
            throw new Ed("Transformer must return at least 2 points.");
          a[o] = c[0], a[l] = c[1];
        }
      }
      return a;
    };
    return this.transformPath(e, i);
  }
  transformPath(e, t) {
    const n = [];
    for (let i = 0; i < e.length; i++) {
      const a = JSON.parse(JSON.stringify(e[i])), s = t(a);
      Array.isArray(s) ? n.push(...s) : s && n.push(s);
    }
    return n;
  }
  update() {
    for (const { pathElement: e, pathData: t } of this.paths) {
      const n = this.encodePath(t);
      e.setAttribute("d", n);
    }
  }
}
var e0 = { exports: {} }, iA, zk;
function XH() {
  if (zk) return iA;
  zk = 1;
  var r = { a: 7, c: 6, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, z: 0 }, e = [
    5760,
    6158,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8239,
    8287,
    12288,
    65279
  ];
  function t(p) {
    return p === 10 || p === 13 || p === 8232 || p === 8233 || // Line terminators
    // White spaces
    p === 32 || p === 9 || p === 11 || p === 12 || p === 160 || p >= 5760 && e.indexOf(p) >= 0;
  }
  function n(p) {
    switch (p | 32) {
      case 109:
      case 122:
      case 108:
      case 104:
      case 118:
      case 99:
      case 115:
      case 113:
      case 116:
      case 97:
      case 114:
        return !0;
    }
    return !1;
  }
  function i(p) {
    return (p | 32) === 97;
  }
  function a(p) {
    return p >= 48 && p <= 57;
  }
  function s(p) {
    return p >= 48 && p <= 57 || /* 0..9 */
    p === 43 || /* + */
    p === 45 || /* - */
    p === 46;
  }
  function o(p) {
    this.index = 0, this.path = p, this.max = p.length, this.result = [], this.param = 0, this.err = "", this.segmentStart = 0, this.data = [];
  }
  function l(p) {
    for (; p.index < p.max && t(p.path.charCodeAt(p.index)); )
      p.index++;
  }
  function u(p) {
    var m = p.path.charCodeAt(p.index);
    if (m === 48) {
      p.param = 0, p.index++;
      return;
    }
    if (m === 49) {
      p.param = 1, p.index++;
      return;
    }
    p.err = "SvgPath: arc flag can be 0 or 1 only (at pos " + p.index + ")";
  }
  function c(p) {
    var m = p.index, A = m, w = p.max, x = !1, E = !1, T = !1, D = !1, F;
    if (A >= w) {
      p.err = "SvgPath: missed param (at pos " + A + ")";
      return;
    }
    if (F = p.path.charCodeAt(A), (F === 43 || F === 45) && (A++, F = A < w ? p.path.charCodeAt(A) : 0), !a(F) && F !== 46) {
      p.err = "SvgPath: param should start with 0..9 or `.` (at pos " + A + ")";
      return;
    }
    if (F !== 46) {
      if (x = F === 48, A++, F = A < w ? p.path.charCodeAt(A) : 0, x && A < w && F && a(F)) {
        p.err = "SvgPath: numbers started with `0` such as `09` are illegal (at pos " + m + ")";
        return;
      }
      for (; A < w && a(p.path.charCodeAt(A)); )
        A++, E = !0;
      F = A < w ? p.path.charCodeAt(A) : 0;
    }
    if (F === 46) {
      for (D = !0, A++; a(p.path.charCodeAt(A)); )
        A++, T = !0;
      F = A < w ? p.path.charCodeAt(A) : 0;
    }
    if (F === 101 || F === 69) {
      if (D && !E && !T) {
        p.err = "SvgPath: invalid float exponent (at pos " + A + ")";
        return;
      }
      if (A++, F = A < w ? p.path.charCodeAt(A) : 0, (F === 43 || F === 45) && A++, A < w && a(p.path.charCodeAt(A)))
        for (; A < w && a(p.path.charCodeAt(A)); )
          A++;
      else {
        p.err = "SvgPath: invalid float exponent (at pos " + A + ")";
        return;
      }
    }
    p.index = A, p.param = parseFloat(p.path.slice(m, A)) + 0;
  }
  function h(p) {
    var m, A;
    m = p.path[p.segmentStart], A = m.toLowerCase();
    var w = p.data;
    if (A === "m" && w.length > 2 && (p.result.push([m, w[0], w[1]]), w = w.slice(2), A = "l", m = m === "m" ? "l" : "L"), A === "r")
      p.result.push([m].concat(w));
    else
      for (; w.length >= r[A] && (p.result.push([m].concat(w.splice(0, r[A]))), !!r[A]); )
        ;
  }
  function f(p) {
    var m = p.max, A, w, x, E, T;
    if (p.segmentStart = p.index, A = p.path.charCodeAt(p.index), w = i(A), !n(A)) {
      p.err = "SvgPath: bad command " + p.path[p.index] + " (at pos " + p.index + ")";
      return;
    }
    if (E = r[p.path[p.index].toLowerCase()], p.index++, l(p), p.data = [], !E) {
      h(p);
      return;
    }
    for (x = !1; ; ) {
      for (T = E; T > 0; T--) {
        if (w && (T === 3 || T === 4) ? u(p) : c(p), p.err.length) {
          h(p);
          return;
        }
        p.data.push(p.param), l(p), x = !1, p.index < m && p.path.charCodeAt(p.index) === 44 && (p.index++, l(p), x = !0);
      }
      if (!x && (p.index >= p.max || !s(p.path.charCodeAt(p.index))))
        break;
    }
    h(p);
  }
  return iA = function(m) {
    var A = new o(m), w = A.max;
    for (l(A); A.index < w && !A.err.length; )
      f(A);
    return A.result.length && ("mM".indexOf(A.result[0][0]) < 0 ? (A.err = "SvgPath: string should start with `M` or `m`", A.result = []) : A.result[0][0] = "M"), {
      err: A.err,
      segments: A.result
    };
  }, iA;
}
var aA, Gk;
function jD() {
  if (Gk) return aA;
  Gk = 1;
  function r(t, n) {
    return [
      t[0] * n[0] + t[2] * n[1],
      t[1] * n[0] + t[3] * n[1],
      t[0] * n[2] + t[2] * n[3],
      t[1] * n[2] + t[3] * n[3],
      t[0] * n[4] + t[2] * n[5] + t[4],
      t[1] * n[4] + t[3] * n[5] + t[5]
    ];
  }
  function e() {
    if (!(this instanceof e))
      return new e();
    this.queue = [], this.cache = null;
  }
  return e.prototype.matrix = function(t) {
    return t[0] === 1 && t[1] === 0 && t[2] === 0 && t[3] === 1 && t[4] === 0 && t[5] === 0 ? this : (this.cache = null, this.queue.push(t), this);
  }, e.prototype.translate = function(t, n) {
    return (t !== 0 || n !== 0) && (this.cache = null, this.queue.push([1, 0, 0, 1, t, n])), this;
  }, e.prototype.scale = function(t, n) {
    return (t !== 1 || n !== 1) && (this.cache = null, this.queue.push([t, 0, 0, n, 0, 0])), this;
  }, e.prototype.rotate = function(t, n, i) {
    var a, s, o;
    return t !== 0 && (this.translate(n, i), a = t * Math.PI / 180, s = Math.cos(a), o = Math.sin(a), this.queue.push([s, o, -o, s, 0, 0]), this.cache = null, this.translate(-n, -i)), this;
  }, e.prototype.skewX = function(t) {
    return t !== 0 && (this.cache = null, this.queue.push([1, 0, Math.tan(t * Math.PI / 180), 1, 0, 0])), this;
  }, e.prototype.skewY = function(t) {
    return t !== 0 && (this.cache = null, this.queue.push([1, Math.tan(t * Math.PI / 180), 0, 1, 0, 0])), this;
  }, e.prototype.toArray = function() {
    if (this.cache)
      return this.cache;
    if (!this.queue.length)
      return this.cache = [1, 0, 0, 1, 0, 0], this.cache;
    if (this.cache = this.queue[0], this.queue.length === 1)
      return this.cache;
    for (var t = 1; t < this.queue.length; t++)
      this.cache = r(this.cache, this.queue[t]);
    return this.cache;
  }, e.prototype.calc = function(t, n, i) {
    var a;
    return this.queue.length ? (this.cache || (this.cache = this.toArray()), a = this.cache, [
      t * a[0] + n * a[2] + (i ? 0 : a[4]),
      t * a[1] + n * a[3] + (i ? 0 : a[5])
    ]) : [t, n];
  }, aA = e, aA;
}
var sA, Hk;
function JH() {
  if (Hk) return sA;
  Hk = 1;
  var r = jD(), e = {
    matrix: !0,
    scale: !0,
    rotate: !0,
    translate: !0,
    skewX: !0,
    skewY: !0
  }, t = /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/, n = /[\s,]+/;
  return sA = function(a) {
    var s = new r(), o, l;
    return a.split(t).forEach(function(u) {
      if (u.length) {
        if (typeof e[u] < "u") {
          o = u;
          return;
        }
        switch (l = u.split(n).map(function(c) {
          return +c || 0;
        }), o) {
          case "matrix":
            l.length === 6 && s.matrix(l);
            return;
          case "scale":
            l.length === 1 ? s.scale(l[0], l[0]) : l.length === 2 && s.scale(l[0], l[1]);
            return;
          case "rotate":
            l.length === 1 ? s.rotate(l[0], 0, 0) : l.length === 3 && s.rotate(l[0], l[1], l[2]);
            return;
          case "translate":
            l.length === 1 ? s.translate(l[0], 0) : l.length === 2 && s.translate(l[0], l[1]);
            return;
          case "skewX":
            l.length === 1 && s.skewX(l[0]);
            return;
          case "skewY":
            l.length === 1 && s.skewY(l[0]);
            return;
        }
      }
    }), s;
  }, sA;
}
var oA, Wk;
function KH() {
  if (Wk) return oA;
  Wk = 1;
  var r = Math.PI * 2;
  function e(i, a, s, o) {
    var l = i * o - a * s < 0 ? -1 : 1, u = i * s + a * o;
    return u > 1 && (u = 1), u < -1 && (u = -1), l * Math.acos(u);
  }
  function t(i, a, s, o, l, u, c, h, f, p) {
    var m = p * (i - s) / 2 + f * (a - o) / 2, A = -f * (i - s) / 2 + p * (a - o) / 2, w = c * c, x = h * h, E = m * m, T = A * A, D = w * x - w * T - x * E;
    D < 0 && (D = 0), D /= w * T + x * E, D = Math.sqrt(D) * (l === u ? -1 : 1);
    var F = D * c / h * A, _ = D * -h / c * m, L = p * F - f * _ + (i + s) / 2, Z = f * F + p * _ + (a + o) / 2, te = (m - F) / c, de = (A - _) / h, H = (-m - F) / c, j = (-A - _) / h, q = e(1, 0, te, de), re = e(te, de, H, j);
    return u === 0 && re > 0 && (re -= r), u === 1 && re < 0 && (re += r), [L, Z, q, re];
  }
  function n(i, a) {
    var s = 1.3333333333333333 * Math.tan(a / 4), o = Math.cos(i), l = Math.sin(i), u = Math.cos(i + a), c = Math.sin(i + a);
    return [o, l, o - l * s, l + o * s, u + c * s, c - u * s, u, c];
  }
  return oA = function(a, s, o, l, u, c, h, f, p) {
    var m = Math.sin(p * r / 360), A = Math.cos(p * r / 360), w = A * (a - o) / 2 + m * (s - l) / 2, x = -m * (a - o) / 2 + A * (s - l) / 2;
    if (w === 0 && x === 0)
      return [];
    if (h === 0 || f === 0)
      return [];
    h = Math.abs(h), f = Math.abs(f);
    var E = w * w / (h * h) + x * x / (f * f);
    E > 1 && (h *= Math.sqrt(E), f *= Math.sqrt(E));
    var T = t(a, s, o, l, u, c, h, f, m, A), D = [], F = T[2], _ = T[3], L = Math.max(Math.ceil(Math.abs(_) / (r / 4)), 1);
    _ /= L;
    for (var Z = 0; Z < L; Z++)
      D.push(n(F, _)), F += _;
    return D.map(function(te) {
      for (var de = 0; de < te.length; de += 2) {
        var H = te[de + 0], j = te[de + 1];
        H *= h, j *= f;
        var q = A * H - m * j, re = m * H + A * j;
        te[de + 0] = q + T[0], te[de + 1] = re + T[1];
      }
      return te;
    });
  }, oA;
}
var lA, jk;
function ZH() {
  if (jk) return lA;
  jk = 1;
  var r = 1e-10, e = Math.PI / 180;
  function t(n, i, a) {
    if (!(this instanceof t))
      return new t(n, i, a);
    this.rx = n, this.ry = i, this.ax = a;
  }
  return t.prototype.transform = function(n) {
    var i = Math.cos(this.ax * e), a = Math.sin(this.ax * e), s = [
      this.rx * (n[0] * i + n[2] * a),
      this.rx * (n[1] * i + n[3] * a),
      this.ry * (-n[0] * a + n[2] * i),
      this.ry * (-n[1] * a + n[3] * i)
    ], o = s[0] * s[0] + s[2] * s[2], l = s[1] * s[1] + s[3] * s[3], u = ((s[0] - s[3]) * (s[0] - s[3]) + (s[2] + s[1]) * (s[2] + s[1])) * ((s[0] + s[3]) * (s[0] + s[3]) + (s[2] - s[1]) * (s[2] - s[1])), c = (o + l) / 2;
    if (u < r * c)
      return this.rx = this.ry = Math.sqrt(c), this.ax = 0, this;
    var h = s[0] * s[1] + s[2] * s[3];
    u = Math.sqrt(u);
    var f = c + u / 2, p = c - u / 2;
    return this.ax = Math.abs(h) < r && Math.abs(f - l) < r ? 90 : Math.atan(
      Math.abs(h) > Math.abs(f - l) ? (f - o) / h : h / (f - l)
    ) * 180 / Math.PI, this.ax >= 0 ? (this.rx = Math.sqrt(f), this.ry = Math.sqrt(p)) : (this.ax += 90, this.rx = Math.sqrt(p), this.ry = Math.sqrt(f)), this;
  }, t.prototype.isDegenerate = function() {
    return this.rx < r * this.ry || this.ry < r * this.rx;
  }, lA = t, lA;
}
var uA, qk;
function eW() {
  if (qk) return uA;
  qk = 1;
  var r = XH(), e = JH(), t = jD(), n = KH(), i = ZH();
  function a(s) {
    if (!(this instanceof a))
      return new a(s);
    var o = r(s);
    this.segments = o.segments, this.err = o.err, this.__stack = [];
  }
  return a.from = function(s) {
    if (typeof s == "string") return new a(s);
    if (s instanceof a) {
      var o = new a("");
      return o.err = s.err, o.segments = s.segments.map(function(l) {
        return l.slice();
      }), o.__stack = s.__stack.map(function(l) {
        return t().matrix(l.toArray());
      }), o;
    }
    throw new Error("SvgPath.from: invalid param type " + s);
  }, a.prototype.__matrix = function(s) {
    var o = this, l;
    s.queue.length && this.iterate(function(u, c, h, f) {
      var p, m, A, w;
      switch (u[0]) {
        // Process 'assymetric' commands separately
        case "v":
          p = s.calc(0, u[1], !0), m = p[0] === 0 ? ["v", p[1]] : ["l", p[0], p[1]];
          break;
        case "V":
          p = s.calc(h, u[1], !1), m = p[0] === s.calc(h, f, !1)[0] ? ["V", p[1]] : ["L", p[0], p[1]];
          break;
        case "h":
          p = s.calc(u[1], 0, !0), m = p[1] === 0 ? ["h", p[0]] : ["l", p[0], p[1]];
          break;
        case "H":
          p = s.calc(u[1], f, !1), m = p[1] === s.calc(h, f, !1)[1] ? ["H", p[0]] : ["L", p[0], p[1]];
          break;
        case "a":
        case "A":
          var x = s.toArray(), E = i(u[1], u[2], u[3]).transform(x);
          if (x[0] * x[3] - x[1] * x[2] < 0 && (u[5] = u[5] ? "0" : "1"), p = s.calc(u[6], u[7], u[0] === "a"), u[0] === "A" && u[6] === h && u[7] === f || u[0] === "a" && u[6] === 0 && u[7] === 0) {
            m = [u[0] === "a" ? "l" : "L", p[0], p[1]];
            break;
          }
          E.isDegenerate() ? m = [u[0] === "a" ? "l" : "L", p[0], p[1]] : m = [u[0], E.rx, E.ry, E.ax, u[4], u[5], p[0], p[1]];
          break;
        case "m":
          w = c > 0, p = s.calc(u[1], u[2], w), m = ["m", p[0], p[1]];
          break;
        default:
          for (A = u[0], m = [A], w = A.toLowerCase() === A, l = 1; l < u.length; l += 2)
            p = s.calc(u[l], u[l + 1], w), m.push(p[0], p[1]);
      }
      o.segments[c] = m;
    }, !0);
  }, a.prototype.__evaluateStack = function() {
    var s, o;
    if (this.__stack.length) {
      if (this.__stack.length === 1) {
        this.__matrix(this.__stack[0]), this.__stack = [];
        return;
      }
      for (s = t(), o = this.__stack.length; --o >= 0; )
        s.matrix(this.__stack[o].toArray());
      this.__matrix(s), this.__stack = [];
    }
  }, a.prototype.toString = function() {
    var s = "", o = "", l = !1;
    this.__evaluateStack();
    for (var u = 0, c = this.segments.length; u < c; u++) {
      var h = this.segments[u], f = h[0];
      f !== o || f === "m" || f === "M" ? (f === "m" && o === "z" && (s += " "), s += f, l = !1) : l = !0;
      for (var p = 1; p < h.length; p++) {
        var m = h[p];
        p === 1 ? l && m >= 0 && (s += " ") : m >= 0 && (s += " "), s += m;
      }
      o = f;
    }
    return s;
  }, a.prototype.translate = function(s, o) {
    return this.__stack.push(t().translate(s, o || 0)), this;
  }, a.prototype.scale = function(s, o) {
    return this.__stack.push(t().scale(s, !o && o !== 0 ? s : o)), this;
  }, a.prototype.rotate = function(s, o, l) {
    return this.__stack.push(t().rotate(s, o || 0, l || 0)), this;
  }, a.prototype.skewX = function(s) {
    return this.__stack.push(t().skewX(s)), this;
  }, a.prototype.skewY = function(s) {
    return this.__stack.push(t().skewY(s)), this;
  }, a.prototype.matrix = function(s) {
    return this.__stack.push(t().matrix(s)), this;
  }, a.prototype.transform = function(s) {
    return s.trim() ? (this.__stack.push(e(s)), this) : this;
  }, a.prototype.round = function(s) {
    var o = 0, l = 0, u = 0, c = 0, h;
    return s = s || 0, this.__evaluateStack(), this.segments.forEach(function(f) {
      var p = f[0].toLowerCase() === f[0];
      switch (f[0]) {
        case "H":
        case "h":
          p && (f[1] += u), u = f[1] - f[1].toFixed(s), f[1] = +f[1].toFixed(s);
          return;
        case "V":
        case "v":
          p && (f[1] += c), c = f[1] - f[1].toFixed(s), f[1] = +f[1].toFixed(s);
          return;
        case "Z":
        case "z":
          u = o, c = l;
          return;
        case "M":
        case "m":
          p && (f[1] += u, f[2] += c), u = f[1] - f[1].toFixed(s), c = f[2] - f[2].toFixed(s), o = u, l = c, f[1] = +f[1].toFixed(s), f[2] = +f[2].toFixed(s);
          return;
        case "A":
        case "a":
          p && (f[6] += u, f[7] += c), u = f[6] - f[6].toFixed(s), c = f[7] - f[7].toFixed(s), f[1] = +f[1].toFixed(s), f[2] = +f[2].toFixed(s), f[3] = +f[3].toFixed(s + 2), f[6] = +f[6].toFixed(s), f[7] = +f[7].toFixed(s);
          return;
        default:
          h = f.length, p && (f[h - 2] += u, f[h - 1] += c), u = f[h - 2] - f[h - 2].toFixed(s), c = f[h - 1] - f[h - 1].toFixed(s), f.forEach(function(m, A) {
            A && (f[A] = +f[A].toFixed(s));
          });
          return;
      }
    }), this;
  }, a.prototype.iterate = function(s, o) {
    var l = this.segments, u = {}, c = !1, h = 0, f = 0, p = 0, m = 0, A, w, x;
    if (o || this.__evaluateStack(), l.forEach(function(E, T) {
      var D = s(E, T, h, f);
      Array.isArray(D) && (u[T] = D, c = !0);
      var F = E[0] === E[0].toLowerCase();
      switch (E[0]) {
        case "m":
        case "M":
          h = E[1] + (F ? h : 0), f = E[2] + (F ? f : 0), p = h, m = f;
          return;
        case "h":
        case "H":
          h = E[1] + (F ? h : 0);
          return;
        case "v":
        case "V":
          f = E[1] + (F ? f : 0);
          return;
        case "z":
        case "Z":
          h = p, f = m;
          return;
        default:
          h = E[E.length - 2] + (F ? h : 0), f = E[E.length - 1] + (F ? f : 0);
      }
    }), !c)
      return this;
    for (x = [], A = 0; A < l.length; A++)
      if (typeof u[A] < "u")
        for (w = 0; w < u[A].length; w++)
          x.push(u[A][w]);
      else
        x.push(l[A]);
    return this.segments = x, this;
  }, a.prototype.abs = function() {
    return this.iterate(function(s, o, l, u) {
      var c = s[0], h = c.toUpperCase(), f;
      if (c !== h)
        switch (s[0] = h, c) {
          case "v":
            s[1] += u;
            return;
          case "a":
            s[6] += l, s[7] += u;
            return;
          default:
            for (f = 1; f < s.length; f++)
              s[f] += f % 2 ? l : u;
        }
    }, !0), this;
  }, a.prototype.rel = function() {
    return this.iterate(function(s, o, l, u) {
      var c = s[0], h = c.toLowerCase(), f;
      if (c !== h && !(o === 0 && c === "M"))
        switch (s[0] = h, c) {
          case "V":
            s[1] -= u;
            return;
          case "A":
            s[6] -= l, s[7] -= u;
            return;
          default:
            for (f = 1; f < s.length; f++)
              s[f] -= f % 2 ? l : u;
        }
    }, !0), this;
  }, a.prototype.unarc = function() {
    return this.iterate(function(s, o, l, u) {
      var c, h, f, p = [], m = s[0];
      return m !== "A" && m !== "a" ? null : (m === "a" ? (h = l + s[6], f = u + s[7]) : (h = s[6], f = s[7]), c = n(l, u, h, f, s[4], s[5], s[1], s[2], s[3]), c.length === 0 ? [[s[0] === "a" ? "l" : "L", s[6], s[7]]] : (c.forEach(function(A) {
        p.push(["C", A[2], A[3], A[4], A[5], A[6], A[7]]);
      }), p));
    }), this;
  }, a.prototype.unshort = function() {
    var s = this.segments, o, l, u, c, h;
    return this.iterate(function(f, p, m, A) {
      var w = f[0], x = w.toUpperCase(), E;
      p && (x === "T" ? (E = w === "t", u = s[p - 1], u[0] === "Q" ? (o = u[1] - m, l = u[2] - A) : u[0] === "q" ? (o = u[1] - u[3], l = u[2] - u[4]) : (o = 0, l = 0), c = -o, h = -l, E || (c += m, h += A), s[p] = [
        E ? "q" : "Q",
        c,
        h,
        f[1],
        f[2]
      ]) : x === "S" && (E = w === "s", u = s[p - 1], u[0] === "C" ? (o = u[3] - m, l = u[4] - A) : u[0] === "c" ? (o = u[3] - u[5], l = u[4] - u[6]) : (o = 0, l = 0), c = -o, h = -l, E || (c += m, h += A), s[p] = [
        E ? "c" : "C",
        c,
        h,
        f[1],
        f[2],
        f[3],
        f[4]
      ]));
    }), this;
  }, uA = a, uA;
}
var cA, Qk;
function tW() {
  return Qk || (Qk = 1, cA = eW()), cA;
}
var rW = e0.exports, Yk;
function nW() {
  if (Yk) return e0.exports;
  Yk = 1, Object.defineProperty(rW, "__esModule", { value: !0 });
  var r = tW(), e = 1e-8;
  function t(a) {
    var s = Math.min(a[0], a[2]), o = Math.max(a[0], a[2]);
    if (a[1] >= a[0] ? a[2] >= a[1] : a[2] <= a[1])
      return [s, o];
    var l = (a[0] * a[2] - a[1] * a[1]) / (a[0] - 2 * a[1] + a[2]);
    return l < s ? [l, o] : [s, l];
  }
  function n(a) {
    var s = a[0] - 3 * a[1] + 3 * a[2] - a[3];
    if (Math.abs(s) < e)
      return a[0] === a[3] && a[0] === a[1] ? [a[0], a[3]] : t([
        a[0],
        -0.5 * a[0] + 1.5 * a[1],
        a[0] - 3 * a[1] + 3 * a[2]
      ]);
    var o = -a[0] * a[2] + a[0] * a[3] - a[1] * a[2] - a[1] * a[3] + a[1] * a[1] + a[2] * a[2];
    if (o <= 0)
      return [Math.min(a[0], a[3]), Math.max(a[0], a[3])];
    for (var l = Math.sqrt(o), u = Math.min(a[0], a[3]), c = Math.max(a[0], a[3]), h = a[0] - 2 * a[1] + a[2], f = (h + l) / s, p = 1; p <= 2; f = (h - l) / s, p++)
      if (f > 0 && f < 1) {
        var m = a[0] * (1 - f) * (1 - f) * (1 - f) + a[1] * 3 * (1 - f) * (1 - f) * f + a[2] * 3 * (1 - f) * f * f + a[3] * f * f * f;
        m < u && (u = m), m > c && (c = m);
      }
    return [u, c];
  }
  function i(a) {
    var s = [1 / 0, 1 / 0], o = [-1 / 0, -1 / 0];
    return r(a).abs().unarc().unshort().iterate(function(l, u, c, h) {
      switch (l[0]) {
        // The next cases are ordered based on simple-icons data
        case "M": {
          s[0] > l[1] && (s[0] = l[1]), s[1] > l[2] && (s[1] = l[2]), o[0] < l[1] && (o[0] = l[1]), o[1] < l[2] && (o[1] = l[2]);
          break;
        }
        case "H": {
          s[0] > l[1] && (s[0] = l[1]), o[0] < l[1] && (o[0] = l[1]);
          break;
        }
        case "V": {
          s[1] > l[1] && (s[1] = l[1]), o[1] < l[1] && (o[1] = l[1]);
          break;
        }
        case "L": {
          s[0] > l[1] && (s[0] = l[1]), s[1] > l[2] && (s[1] = l[2]), o[0] < l[1] && (o[0] = l[1]), o[1] < l[2] && (o[1] = l[2]);
          break;
        }
        case "C": {
          var f = n([c, l[1], l[3], l[5]]);
          s[0] > f[0] && (s[0] = f[0]), o[0] < f[1] && (o[0] = f[1]);
          var p = n([h, l[2], l[4], l[6]]);
          s[1] > p[0] && (s[1] = p[0]), o[1] < p[1] && (o[1] = p[1]);
          break;
        }
        case "Q": {
          var m = t([c, l[1], l[3]]);
          s[0] > m[0] && (s[0] = m[0]), o[0] < m[1] && (o[0] = m[1]);
          var A = t([h, l[2], l[4]]);
          s[1] > A[0] && (s[1] = A[0]), o[1] < A[1] && (o[1] = A[1]);
          break;
        }
      }
    }, !0), [s[0], s[1], o[0], o[1]];
  }
  return e0.exports = i, e0.exports;
}
var iW = nW();
const aW = /* @__PURE__ */ Iu(iW);
class sW extends zH {
  constructor() {
    super(...arguments), this.moduleName = "Vegemite";
  }
  svgPreview(e, t) {
    return this.svgElement(e, t);
  }
  svgPrint(e, t) {
    return this.svgElement(e, t);
  }
  svgElement(e, t) {
    const n = sG(GH), a = e !== "" ? ((T) => T.charAt(0).toUpperCase() + T.substr(1).toLowerCase())(e) : "", s = n.getPath(a, 0, 72, 72), o = s.toSVG(2), l = s.getBoundingBox(), u = l.x2 - l.x1, c = s.toPathData(3), h = () => {
      const T = Ao("g");
      T.classList.add("module-text-group");
      const D = Ao("defs");
      T.appendChild(D), D.appendChild(WH(0, 2, 2, "shadow"));
      const F = Ao("path");
      F.setAttribute("d", c), F.setAttribute("stroke", "black"), F.setAttribute("stroke-width", "3"), D.appendChild(F);
      const _ = Ao("g");
      _.classList.add("module-layer0"), T.appendChild(_), _.setAttribute("filter", "url(#shadow)"), _.innerHTML = F.outerHTML;
      const L = Ao("g");
      L.classList.add("module-layer1"), T.appendChild(L), L.setAttribute("stroke-width", "3"), L.setAttribute("stroke", "rgb(45,41,38)"), L.setAttribute("fill", "rgb(45,41,38)"), L.setAttribute("transform", "translate(0.5,0)"), L.innerHTML = o;
      const Z = Ao("g");
      Z.classList.add("module-layer2"), T.appendChild(Z), Z.setAttribute("fill", "rgb(255,209,0)"), Z.setAttribute("transform", "translate(1,-0.1)"), Z.innerHTML = o;
      const te = Ao("g");
      return te.classList.add("module-layer3"), T.appendChild(te), te.setAttribute("fill", "white"), te.innerHTML = o, new YH(T).transform(([H, j]) => [H, j + (u / 2 - H) ** 2 / (u * 6)]), T;
    }, f = Ao("g");
    f.classList.add("module-root");
    const p = Ao("defs");
    f.appendChild(p);
    const m = Ao("g");
    m.classList.add("module-bounds"), f.appendChild(m);
    const A = HH(t.height, t.width);
    A.setAttribute("opacity", "0"), m.appendChild(A);
    const w = Ao("g");
    w.classList.add("module-text-enclosure"), f.appendChild(w);
    const x = h();
    w.appendChild(x);
    const E = aW(c);
    return qH(w, E, t.height, t.width, 0.35, 0.65), jH(f.outerHTML);
  }
}
async function qD(r) {
  if (r === "Vegemite")
    return new sW();
  throw new si(`Failed to resolve Module, Module ${r} not found`);
}
const oW = (r) => {
  const e = r.fileLink;
  if (!e) return !1;
  const t = Dc(e);
  return t === "pdf" || t === "eps" || t === "ai";
}, QD = async (r) => {
  try {
    const e = await Ll(r);
    if (e.status !== 200)
      return !1;
    const t = e.headers.get("content-type");
    if (!(t?.includes("image/svg+xml") || t?.includes("svg"))) {
      const i = await e.text();
      return i.trim().startsWith("<svg") || i.includes("<?xml");
    }
    return !0;
  } catch (e) {
    return console.warn(`[validateSvgUrl] Failed to validate SVG URL ${r}:`, e), !1;
  }
}, lW = async (r, e = 3e3, t = 10) => {
  console.log(`[waitForSvgVersion] Waiting for SVG version of asset ${r}`);
  for (let n = 0; n < t; n++) {
    n > 0 && await new Promise((i) => setTimeout(i, e));
    try {
      const i = await Si.getFromServer(r), a = i.versions?.find((s) => s.name === "svg");
      if (a?.link) {
        if (await QD(a.link))
          return console.log(
            `[waitForSvgVersion] SVG version ready for asset ${r} after ${n + 1} attempt(s)`
          ), i;
        console.warn(
          `[waitForSvgVersion] SVG link returned non-SVG content (attempt ${n + 1}/${t}).`,
          { link: a.link }
        );
      }
    } catch (i) {
      console.warn(`[waitForSvgVersion] Attempt ${n + 1} failed for asset ${r}:`, i);
    }
  }
  throw new rh(
    `Failed to resolve SVG version for asset ${r} after ${t} attempts`
  );
}, uW = async (r) => {
  const e = r.fileLink;
  if (!e)
    throw new th(r);
  if (!oW(r))
    return e;
  console.log("[getAssetSource] Asset requires SVG version.", {
    assetKey: r.key,
    fileLink: e,
    extension: Dc(e)
  });
  const t = r.versions?.find((a) => a.name === "svg");
  if (t?.link) {
    if (console.log("[getAssetSource] Found existing SVG version, validating...", { link: t.link }), await QD(t.link))
      return console.log("[getAssetSource] Using validated existing SVG version.", { link: t.link }), t.link;
    console.log(
      "[getAssetSource] Existing SVG version is not ready yet (returned non-SVG content), waiting for transcoding...",
      { assetKey: r.key }
    );
  } else
    console.log("[getAssetSource] SVG version not found, waiting for transcoding...", { assetKey: r.key });
  const i = (await lW(r.key || "")).versions?.find((a) => a.name === "svg");
  if (!i?.link)
    throw new rh(`SVG version not available for asset ${r.key}`);
  return i.link;
}, cW = [
  "altGlyph",
  "circle",
  "ellipse",
  "path",
  "polygon",
  "polyline",
  "rect",
  "text",
  "textPath",
  "tref",
  "tspan"
], fW = async (r, e, t) => {
  console.log(`[handleDigitalContentStep] Start for step "${e.name}".`, {
    stepName: t.stepName,
    layoutCount: r.length,
    regionCount: t.data.regions.length
  });
  const n = e.data, i = t.data.baseUrl, a = n.assetUrl.replace("localhost", "localstack");
  console.log("[handleDigitalContentStep] Resolved video source.", { baseUrl: i, videoSource: a });
  let s;
  if (!i || i.trim() === "")
    s = a;
  else {
    const h = i.slice(0, 4) === "http" ? "" : "https://", f = new URL(h + i);
    f.searchParams.append("video", US(JSON.stringify([{ href: a }]))), f.pathname = f.pathname + (f.pathname.slice(-1) === "/" ? "" : "/"), s = f.toString();
  }
  console.log("[handleDigitalContentStep] Generating QR code.", { finalUrl: s });
  const l = `data:image/svg+xml;base64,${US(await LD.toString(s, { type: "svg" }))}`, u = (h) => {
    const f = r.find((m) => m.panelId === h.panelId);
    if (!f)
      throw console.error(`[handleDigitalContentStep] No layout for panel ${h.panelId}.`), new La(h);
    const p = nn();
    return console.log(`[handleDigitalContentStep] Creating image element ${p}.`, {
      panelId: h.panelId
    }), new pa(
      {
        id: p,
        src: l,
        type: Mr.Image,
        y: h.top,
        x: h.left,
        width: h.width,
        height: h.height,
        rotation: 0
      },
      f
    );
  }, c = t.data.regions;
  try {
    const h = c.map(u);
    return console.log(`[handleDigitalContentStep] Done with ${h.length} command(s).`), h;
  } catch (h) {
    return console.error(`[handleDigitalContentStep] Failed for step "${e.name}".`, h), [];
  }
}, dW = async (r, e, t, n) => {
  console.log(`[handleFrameStep] Start for step "${t.name}".`, {
    stepName: n.stepName,
    stepType: n.type,
    layoutCount: r.length,
    regionCount: n.data.regions.length
  });
  const i = t.data;
  let a = i.assetUrl;
  const s = Dc(a);
  if (s === "pdf" || s === "eps" || s === "ai") {
    console.log("[handleFrameStep] Pattern image requires SVG version.", { src: a, extension: s });
    const l = Si.keyFromURL(a);
    if (l) {
      const u = await Si.getLocalOrFromServer(l);
      if (!u)
        throw new Error(`Failed to fetch asset ${l}`);
      a = await uW(u), console.log("[handleFrameStep] Using SVG version for pattern.", { svgSrc: a });
    }
  }
  console.log("[handleFrameStep] Fetching pattern image data.", { src: a });
  const o = await G1(a);
  console.log("[handleFrameStep] Pattern image data loaded.", {
    width: o.width,
    height: o.height,
    colorCount: Object.keys(o.colors || {}).length
  });
  try {
    const l = await JG(i, n.option);
    console.log("[handleFrameStep] Resolved variant.", {
      variantId: l?.id,
      assetLink: l?.asset?.fileLink
    }), l && (e[n.stepName] = { selectedVariants: [l] });
    const u = async (h) => {
      console.log(`[handleFrameStep] Building frame for panel ${h.panelId}.`);
      const f = await PD(h, l?.asset?.fileLink), p = await Q0(f), m = nn(), A = r.find((E) => E.panelId === h.panelId);
      if (!A)
        throw console.error(`[handleFrameStep] No layout for panel ${h.panelId}.`), new La(h);
      const w = fx(
        o,
        p,
        {
          scale: i.scale,
          left: i.x,
          top: i.y
        },
        n.data.forceImageCover
      );
      console.log(`[handleFrameStep] Creating frame element ${m}.`, {
        panelId: h.panelId,
        offsets: w,
        forceImageCover: n.data.forceImageCover
      });
      const x = e[n.stepName] || {};
      return e[n.stepName] = {
        ...x,
        framePatternAsset: { fileLink: o.src },
        currentFrameSources: [...x.currentFrameSources ?? [], f],
        frameOffsetsList: [...x.frameOffsetsList ?? [], w]
        // Frame pattern data not relevant here.
      }, new pa(
        {
          id: m,
          path: p.path,
          type: Mr.Frame,
          forceImageCover: n.data.forceImageCover,
          x: h.left,
          y: h.top,
          width: h.width,
          height: h.height,
          layer: h.layer,
          layerIndex: h.layerIndex,
          rotation: h.rotation,
          scaleX: h.width / p.width,
          scaleY: h.height / p.height,
          pattern: {
            id: `${m}-pattern`,
            src: o.src,
            x: w.x,
            y: w.y,
            width: o.width,
            height: o.height,
            rotation: 0,
            scaleX: w.zoom,
            scaleY: w.zoom,
            svg: o.svg,
            colors: o.colors
          }
        },
        A
      );
    }, c = await Promise.all(n.data.regions.map((h) => u(h)));
    return console.log(`[handleFrameStep] Done with ${c.length} command(s).`), c;
  } catch (l) {
    return console.error(`[handleFrameStep] Failed for step "${t.name}".`, l), [];
  }
}, hW = async (r, e, t, n) => {
  console.log(`[handleIllustrationStep] Start for step "${t.name}".`, {
    stepName: n.stepName,
    layoutCount: r.length,
    regionCount: n.data.regions.length
  });
  const i = t.data, a = await Pt.getOptionForStep(n);
  if (!a)
    return console.error(`[handleIllustrationStep] No option for step ${n.stepName}.`), [];
  const s = a.variants?.find((F) => F.id === i.illustrationVariantId) || await Pt.getDefaultVariant(a, n.overrideDefaultVariantId);
  if (!s)
    return console.error(`[handleIllustrationStep] No variant with ID: ${i.illustrationVariantId}`), [];
  if (!s.asset)
    return console.error(
      `[handleIllustrationStep] No asset for variant with ID: ${i.illustrationVariantId}`
    ), [];
  console.log("[handleIllustrationStep] Resolved variant.", { optionId: a.id, variantId: s.id }), e[n.stepName] = { selectedVariants: [s] };
  const o = s.asset?.fileLink;
  if (!o)
    return console.error(
      `[handleIllustrationStep] No asset link for variant with ID: ${i.illustrationVariantId}`
    ), [];
  console.log("[handleIllustrationStep] Fetching illustration asset.", { link: o });
  const l = await xo(o, !0), u = /<svg.*?<\/svg>/s, c = l.match(u) || [], h = c?.length > 0 ? c[0] : "", m = Pu().parseFromString(h, "image/svg+xml").firstElementChild;
  if (!m)
    return console.error("[handleIllustrationStep] Failed to read SVG.", { link: o, bodyLength: l.length }), [];
  Mw(m);
  const A = {};
  Mf(m, (F) => {
    cW.includes(F.tagName) && !F.attributes.getNamedItem("fill") && F.setAttribute("fill", "#000000");
    const _ = F.attributes.getNamedItem("fill");
    if (_ && _.value !== "none") {
      const Z = _.value, de = `spiff-fill-${Z.replace(/\W/g, "")}`;
      F.classList.add(de), A[de] = { browserValue: Z };
    }
    const L = F.attributes.getNamedItem("stroke");
    if (L && L.value !== "none") {
      const Z = L.value, de = `spiff-stroke-${Z.replace(/\W/g, "")}`;
      F.classList.add(de), A[de] = { browserValue: Z };
    }
  });
  const x = $f().serializeToString(m);
  console.log("[handleIllustrationStep] Annotated SVG colors.", {
    classNames: Object.keys(A)
  });
  const E = i.colors;
  if (E) {
    console.log("[handleIllustrationStep] Applying replacement colors.", E);
    for (const [F, _] of Object.entries(A))
      for (const L of Object.keys(E))
        if (_.browserValue === L) {
          A[F] = { browserValue: E[L] };
          break;
        }
  }
  const T = (F) => {
    const _ = r.find((Z) => Z.panelId === F.panelId);
    if (!_)
      throw console.error(`[handleIllustrationStep] No layout for panel ${F.panelId}.`), new La(F);
    const L = nn();
    return console.log(`[handleIllustrationStep] Creating illustration element ${L}.`, {
      panelId: F.panelId
    }), new pa(
      {
        colors: A,
        id: L,
        svg: x,
        type: Mr.Illustration,
        y: F.top,
        x: F.left,
        rotation: F.rotation,
        width: F.width,
        height: F.height,
        layer: F.layer,
        layerIndex: F.layerIndex,
        immutable: F.immutable
      },
      _
    );
  }, D = n.data.regions;
  try {
    const F = D.map(T);
    return console.log(`[handleIllustrationStep] Done with ${F.length} command(s).`), F;
  } catch (F) {
    return console.error(`[handleIllustrationStep] Failed for step "${t.name}".`, F), [];
  }
}, pW = async (r, e, t) => {
  console.log(`[handleModuleStep] Start for step "${e.name}".`, {
    stepName: t.stepName,
    module: t.data.module,
    layoutCount: r.length,
    regionCount: t.data.regions.length
  });
  const n = await qD(t.data.module), i = e.data;
  console.log("[handleModuleStep] Module resolved.", { text: i.text });
  const a = (o, l) => {
    const u = r.find((h) => h.panelId === l.panelId);
    if (!u)
      throw console.error(`[handleModuleStep] No layout for panel ${l.panelId}.`), new La(l);
    const c = nn();
    return console.log(`[handleModuleStep] Creating illustration element ${c}.`, {
      panelId: l.panelId,
      svgLength: o.length
    }), new pa(
      {
        colors: {},
        id: c,
        svg: o,
        type: Mr.Illustration,
        y: l.top,
        x: l.left,
        rotation: l.rotation,
        width: l.width,
        height: l.height,
        layer: l.layer,
        layerIndex: l.layerIndex
      },
      u
    );
  }, s = t.data.regions;
  try {
    const o = s.map(
      (l) => a(n.svgPrint(i.text, l), l)
    );
    return console.log(`[handleModuleStep] Done with ${o.length} command(s).`), o;
  } catch (o) {
    return console.error(`[handleModuleStep] Failed for step "${e.name}".`, o), [];
  }
}, gW = async (r, e, t, n) => {
  console.log(`[handlePictureStep] Start for step "${t.name}".`, {
    stepName: n.stepName,
    layoutCount: r.length,
    regionCount: n.data.regions.length
  });
  const i = t.data, a = await Pt.getOptionForStep(n);
  if (!a)
    return console.error(`[handlePictureStep] No option for step ${n.stepName}.`), [];
  const s = a.variants?.find((c) => c.id === i.pictureVariantId) || await Pt.getDefaultVariant(a, n.overrideDefaultVariantId);
  if (!s)
    return console.error(`[handlePictureStep] No variant with ID: ${i.pictureVariantId}`), [];
  if (!s.asset)
    return console.error(`[handlePictureStep] No asset for variant with ID: ${i.pictureVariantId}`), [];
  console.log("[handlePictureStep] Resolved variant.", { optionId: a.id, variantId: s.id }), e[n.stepName] = { selectedVariants: [s] };
  const o = s.asset?.fileLink;
  if (!o)
    return console.error(`[handlePictureStep] No asset link for variant with ID: ${i.pictureVariantId}`), [];
  const l = (c) => {
    const h = r.find((p) => p.panelId === c.panelId);
    if (!h)
      throw console.error(`[handlePictureStep] No layout for panel ${c.panelId}.`), new La(c);
    const f = nn();
    return console.log(`[handlePictureStep] Creating image element ${f}.`, {
      panelId: c.panelId,
      src: o
    }), new pa(
      {
        id: f,
        src: o,
        type: Mr.Image,
        y: c.top,
        x: c.left,
        rotation: c.rotation,
        width: c.width,
        height: c.height,
        layer: c.layer,
        layerIndex: c.layerIndex,
        immutable: c.immutable,
        preserveAspectRatio: "none"
      },
      h
    );
  }, u = n.data.regions;
  try {
    const c = u.map(l);
    return console.log(`[handlePictureStep] Done with ${c.length} command(s).`), c;
  } catch (c) {
    return console.error(`[handlePictureStep] Failed for step "${t.name}".`, c), [];
  }
}, mW = async (r, e, t, n) => {
  console.log(`[handleShapeStep] Start for step "${t.name}".`, {
    stepName: n.stepName,
    layoutCount: r.length,
    regionCount: n.data.regions.length
  });
  const i = t.data, a = await Pt.getOptionForStep(n);
  if (!a)
    return console.error(`[handleShapeStep] No option for step ${n.stepName}.`), [];
  const s = a.variants?.find((u) => u.id === i.colorVariantId) || await Pt.getDefaultVariant(a, n.overrideDefaultVariantId);
  if (!s)
    return console.error(`[handleShapeStep] No variant with ID: ${i.colorVariantId}`), [];
  console.log("[handleShapeStep] Resolved variant.", {
    optionId: a.id,
    variantId: s.id,
    color: s.color
  }), e[n.stepName] = { selectedVariants: [s] };
  const o = (u) => {
    const c = r.find((A) => A.panelId === u.panelId);
    if (!c)
      throw console.error(`[handleShapeStep] No layout for panel ${u.panelId}.`), new La(u);
    const h = `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
            preserveAspectRatio="none"
            version="1.1"
            width="1"
            height="1"
            viewBox="0 0 1 1"
        >
            <rect
                x="0"
                y="0"
                width="1"
                height="1"
                class="spiff-fill-shape"
                fill="${s?.color}"
            />
        </svg>
        `, f = { browserValue: s.color || "#000000" }, p = { "spiff-fill-shape": f }, m = nn();
    return console.log(`[handleShapeStep] Creating shape element ${m}.`, {
      panelId: u.panelId,
      fill: f.browserValue
    }), new pa(
      {
        colors: p,
        id: m,
        svg: h,
        type: Mr.Illustration,
        y: u.top,
        x: u.left,
        rotation: u.rotation,
        width: u.width,
        height: u.height,
        layer: u.layer,
        layerIndex: u.layerIndex,
        immutable: u.immutable
      },
      c
    );
  }, l = n.data.regions;
  try {
    const u = l.map(o);
    return console.log(`[handleShapeStep] Done with ${u.length} command(s).`), u;
  } catch (u) {
    return console.error(`[handleShapeStep] Failed for step "${t.name}".`, u), [];
  }
}, vW = async (r, e, t) => {
  console.log(`[handleSilentStep] Start for step "${e.stepName}".`, {
    stepType: e.type,
    layoutCount: r.length,
    regionCount: e.data.regions.length,
    productOverlayImageUrl: t
  });
  const n = [], a = e.type === gt.ProductOverlay ? t || e.data.asset?.fileLink || "" : e.data.asset?.fileLink || "", o = (() => {
    const u = Dc(a);
    return u === "jpeg" || u === "jpg" || u === "png" ? Mr.Image : Mr.Illustration;
  })(), l = e.data.regions;
  if (console.log("[handleSilentStep] Resolved asset.", { assetSource: a, assetType: o }), o === "image")
    try {
      l.forEach((u) => {
        const c = r.find((p) => p.panelId === u.panelId);
        if (!c)
          throw console.error(`[handleSilentStep] No layout for panel ${u.panelId}.`), new La(u);
        const h = nn();
        console.log(`[handleSilentStep] Creating image element ${h}.`, {
          panelId: u.panelId,
          excludeFromExport: e.data.excludeFromPrint
        });
        const f = {
          id: h,
          src: a,
          type: o,
          y: u.top,
          x: u.left,
          width: u.width,
          height: u.height,
          layer: u.layer,
          layerIndex: u.layerIndex,
          productOverlay: e.type === gt.ProductOverlay ? !0 : void 0,
          scaleX: 1,
          scaleY: 1,
          rotation: u.rotation,
          excludeFromExport: e.data.excludeFromPrint,
          preserveAspectRatio: "none"
        };
        n.push(new pa(f, c));
      });
    } catch (u) {
      console.error(`[handleSilentStep] Failed for step "${e.stepName}".`, u);
    }
  else {
    console.log("[handleSilentStep] Fetching SVG asset.", { assetSource: a });
    const u = await xo(a, !0), c = (h) => {
      const f = /<svg.*?<\/svg>/s, p = h.match(f) || [], m = p?.length > 0 ? p[0] : "", x = Pu().parseFromString(m, "image/svg+xml").firstElementChild;
      if (!x)
        throw console.error("[handleSilentStep] Failed to read SVG.", {
          assetSource: a,
          bodyLength: h.length
        }), new Ed("Failed to read SVG.");
      return Mw(x), $f().serializeToString(x);
    };
    l.forEach((h) => {
      const f = r.find((A) => A.panelId === h.panelId);
      if (!f)
        throw console.error(`[handleSilentStep] No layout for panel ${h.panelId}.`), new La(h);
      const p = nn();
      console.log(`[handleSilentStep] Creating illustration element ${p}.`, {
        panelId: h.panelId,
        excludeFromExport: e.data.excludeFromPrint
      });
      const m = {
        id: p,
        src: a,
        asset_key: a,
        svg: c(u),
        colors: {},
        type: o,
        y: h.top,
        x: h.left,
        width: h.width,
        height: h.height,
        layer: h.layer,
        layerIndex: h.layerIndex,
        scaleX: 1,
        scaleY: 1,
        rotation: h.rotation,
        productOverlay: e.type === gt.ProductOverlay ? !0 : void 0,
        excludeFromExport: e.data.excludeFromPrint
      };
      n.push(new pa(m, f));
    });
  }
  return console.log(`[handleSilentStep] Done with ${n.length} command(s).`), n;
}, yW = async (r, e, t, n) => {
  console.log(`[handleTextStep] Start for step "${t.name}".`, {
    stepName: n.stepName,
    layoutCount: r.length,
    regionCount: n.data.regions.length
  });
  const i = [], a = t.data, s = 30, o = (T) => T.vertical ? "center" : T.textAlign || "center", l = async () => {
    const T = await Pt.getOptionForStep(n);
    if (!T) {
      console.warn(`[handleTextStep] No font option for step ${n.stepName}.`);
      return;
    }
    const D = T.variants?.find((_) => _.id === a.fontVariantId) || await Pt.getDefaultVariant(T, n.overrideDefaultVariantId);
    if (!D) {
      console.warn(`[handleTextStep] No font variant with ID: ${a.fontVariantId}`);
      return;
    }
    if (!D.asset) {
      console.warn(`[handleTextStep] No asset for font variant with ID: ${D.id}`);
      return;
    }
    console.log("[handleTextStep] Resolved font variant.", { optionId: T.id, variantId: D.id }), e[n.stepName] = {
      ...e[n.stepName] ?? {},
      selectedVariants: [D]
    };
    const F = D.asset.fileLink;
    if (!F) {
      console.warn(`[handleTextStep] No asset link for font variant with ID: ${D.id}`);
      return;
    }
    return F;
  }, c = await (async () => {
    const T = await l();
    if (!T) {
      console.warn("[handleTextStep] No font URL; falling back to default sizing.");
      return;
    }
    console.log("[handleTextStep] Loading font.", { fontUrl: T });
    const D = await oh(T), F = {
      assetUrl: T,
      name: D.names.fullName.en
    };
    return console.log("[handleTextStep] Font loaded.", { name: F.name }), F;
  })(), h = (n.data.replaceableText ? n.data.replaceableText.replace("{{}}", a.text) : a.text) || "", f = C0(h, {
    vertical: n.data.vertical,
    uppercase: n.data.uppercase
  });
  console.log("[handleTextStep] Text resolved.", {
    replaceableText: n.data.replaceableText,
    inputText: a.text,
    text: f,
    vertical: n.data.vertical,
    uppercase: n.data.uppercase
  });
  const p = async (T) => {
    const D = T.colorOption;
    return D ? (await Pt.getDefaultVariant(D))?.color : void 0;
  }, m = a.color || await p(n.data);
  console.log("[handleTextStep] Colour resolved.", { inputColor: a.color, defaultColor: m });
  const w = await (async (T) => {
    const D = T.strokeOption;
    if (!T.strokeEnabled || !D) return;
    const F = await Pt.getDefaultVariant(D, n.overrideDefaultVariantId);
    if (!F?.color) {
      console.warn(`[handleTextStep] No default stroke variant colour for step ${n.stepName}.`);
      return;
    }
    return {
      browserValue: F.color,
      pmsValue: F.name
    };
  })(n.data);
  console.log("[handleTextStep] Stroke resolved.", {
    strokeEnabled: n.data.strokeEnabled,
    strokeColor: w,
    strokeThickness: n.data.strokeThickness
  });
  const x = a.color || m || "#000000";
  e[n.stepName] = {
    ...e[n.stepName] ?? {},
    inputText: a.text,
    text: f,
    color: x,
    strokeColor: w
    // Fill image not supported
  };
  const E = n.data.regions;
  for (const T of E) {
    const D = r.find((_) => _.panelId === T.panelId);
    if (!D) {
      console.warn(`[handleTextStep] No layout for panel ${T.panelId}; skipping region.`);
      continue;
    }
    const F = {
      stepName: t.name,
      id: nn(),
      align: o(n.data),
      curved: n.data.curved,
      fill: x,
      fontData: c,
      fontSize: n.data.size || s,
      height: T.height,
      layer: T.layer,
      layerIndex: T.layerIndex,
      paths: n.data.paths,
      rotation: T.rotation,
      strokeColor: w,
      strokeThickness: w ? n.data.strokeThickness : void 0,
      text: f,
      type: Mr.Textbox,
      vertical: n.data.vertical,
      verticalAlign: n.data.verticalAlign || "middle",
      width: T.width,
      x: T.left,
      y: T.top
    };
    if (c) {
      const [_, L] = Zm(
        n.data.size || s,
        c,
        T,
        [
          C0(f, {
            vertical: n.data.vertical,
            uppercase: n.data.uppercase
          })
        ],
        {
          size: n.data.size,
          minSize: n.data.minSize,
          maxSize: n.data.maxSize
        }
      );
      console.log(`[handleTextStep] Creating autosized textbox element ${F.id}.`, {
        panelId: T.panelId,
        requestedFontSize: n.data.size || s,
        correctFontSize: _,
        lineCount: (L || []).length
      }), i.push(
        new pa(
          {
            ...F,
            fontSize: _,
            text: F.curved ? F.text : (L || []).join(`
`)
          },
          D
        )
      );
    } else
      console.log(`[handleTextStep] Creating textbox element ${F.id} without font data.`, {
        panelId: T.panelId,
        fontSize: F.fontSize
      }), i.push(new pa(F, D));
  }
  return console.log(`[handleTextStep] Done with ${i.length} command(s).`), i;
}, AW = async (r, e, t) => {
  const n = e.data?.transactionIds;
  n && (r[t.stepName] = {
    transactionIds: n
  });
}, wW = async (r, e, t) => {
  console.log(`[handleQuestionStep] Start for step "${e.name}".`, {
    stepName: t.stepName
  });
  const n = e.data, i = await Pt.getOptionForStep(t);
  if (!i) {
    console.error(`[handleQuestionStep] No option for step ${t.stepName}.`);
    return;
  }
  const a = [n.questionVariantId], s = i.variants?.filter((o) => a.includes(o.id || "")) || [];
  if (s.length === 0) {
    console.warn(`[handleQuestionStep] No variants selected for step ${t.stepName}.`);
    return;
  }
  console.log(`[handleQuestionStep] Resolved ${s.length} selected variant(s).`, {
    variantIds: s.map((o) => o.id),
    variantNames: s.map((o) => o.name)
  }), r[t.stepName] = {
    selectedVariants: s
  }, console.log(`[handleQuestionStep] Done for step "${e.name}".`);
}, xW = async (r, e, t, n, i) => {
  console.log("[generateCommands] Start.", {
    workflowId: e.id,
    designInputStepCount: r.length,
    designInputStepNames: r.map((s) => s.name),
    workflowStepCount: e.steps.length,
    layoutCount: t.length,
    layoutPanelIds: t.map((s) => s.panelId),
    productOverlayImageUrl: n
  });
  const a = [];
  i = i ?? {};
  for (const s of r) {
    const o = e.steps.find((u) => u.stepName === s.name);
    if (!o) {
      console.warn(`[generateCommands] No workflow step matching design input step "${s.name}"; skipping.`);
      continue;
    }
    const l = a.length;
    switch (console.log(`[generateCommands] Handling step "${s.name}" of type ${o.type}.`), o.type) {
      case gt.DigitalContent:
        a.push(
          ...await fW(t, s, o)
        );
        break;
      case gt.Frame:
      case gt.Photo:
        a.push(
          ...await dW(t, i, s, o)
        );
        break;
      case gt.Illustration:
        a.push(
          ...await hW(
            t,
            i,
            s,
            o
          )
        );
        break;
      case gt.Module:
        a.push(...await pW(t, s, o));
        break;
      case gt.Picture:
        a.push(
          ...await gW(t, i, s, o)
        );
        break;
      case gt.Shape:
        a.push(
          ...await mW(t, i, s, o)
        );
        break;
      case gt.Text:
        a.push(
          ...await yW(t, i, s, o)
        );
        break;
      case gt.Product:
        await AW(i, s, o);
        break;
      case gt.Question:
        await wW(i, s, o);
        break;
      default:
        console.warn(
          `[generateCommands] Unhandled step type ${o.type} for step "${s.name}"; no commands generated.`
        );
        break;
    }
    console.log(
      `[generateCommands] Step "${s.name}" produced ${a.length - l} command(s). Running total: ${a.length}.`
    );
  }
  console.log("[generateCommands] Renderable steps done.", {
    commandCount: a.length,
    stepSelections: Object.fromEntries(
      Object.entries(i).map(([s, o]) => [
        s,
        JSON.stringify(o)
      ])
    )
  });
  for (const s of e.steps) {
    if (s.type !== gt.SilentIllustration && s.type !== gt.ProductOverlay)
      continue;
    if (!await yc(s, i)) {
      console.log(
        `[generateCommands] Silent step "${s.stepName}" conditions not satisfied; skipping.`
      );
      continue;
    }
    const o = a.length;
    console.log(`[generateCommands] Handling silent step "${s.stepName}" of type ${s.type}.`), a.push(
      ...await vW(t, s, n)
    ), console.log(
      `[generateCommands] Silent step "${s.stepName}" produced ${a.length - o} command(s). Running total: ${a.length}.`
    );
  }
  return console.log(`[generateCommands] Done with ${a.length} command(s).`), a;
}, Xk = ["prepare", "rasterize"], YD = () => typeof performance < "u" ? performance.now() : Date.now(), bW = (r, e, t) => {
  try {
    performance.measure?.(`spiff:layout-render:${r}`, { start: e, duration: t });
  } catch {
  }
}, Jk = () => YD(), Kk = (r, e) => {
  const t = YD() - e;
  return bW(r, e, t), t;
}, CW = (r, e) => {
  const t = Xk.reduce((i, a) => i + e[a], 0), n = Xk.map((i) => `${i}: ${e[i].toFixed(2)}ms`).join(" | ");
  console.debug(`[layout-render] ${r} - ${n} | total: ${t.toFixed(2)}ms`);
};
class SW {
  constructor(e) {
    this.handleCompleteRender = null;
    const t = /* @__PURE__ */ new Map();
    e.forEach(
      (n) => t.set(
        n.id,
        new Zk(
          n.id,
          n.name,
          this,
          { width: n.width, height: n.height },
          this.getWorkflowManager.bind(this),
          n
        )
      )
    ), this.layouts = t;
  }
  setCompleteRenderCallback(e) {
    this.handleCompleteRender = e, e(Array.from(this.layouts.values()));
  }
  onCompleteRender() {
    this.handleCompleteRender && this.handleCompleteRender(Array.from(this.layouts.values()));
  }
  getAll() {
    return this.layouts;
  }
  setWorkflowManager(e) {
    this.workflowManager = e;
  }
  getWorkflowManager() {
    return this.workflowManager;
  }
  /**
   * Updates the layout structure in the preview service.
   * Re-maps internal bridges to new layout IDs while preserving state.
   */
  updateLayouts(e) {
    const t = new Map(this.layouts), n = /* @__PURE__ */ new Map();
    for (const i of e) {
      const a = Array.from(t.values()).find(
        (s) => s.getLayout()?.panelId === i.panelId
      );
      if (a)
        a.updateLayout(i), n.set(i.id, a);
      else {
        const s = new Zk(
          i.id,
          i.name,
          this,
          { width: i.width, height: i.height },
          this.getWorkflowManager.bind(this),
          i
        );
        n.set(i.id, s);
      }
    }
    this.layouts = n;
  }
}
const EW = () => new Promise((r, e) => {
  try {
    const n = Pc().getContext("webgl2");
    r(!!n);
  } catch {
    r(!1);
  }
}), kW = EW();
class Zk {
  constructor(e, t, n, i, a, s) {
    this.hasSetStaticContext = !1, this.interactiveDirty = !1, this.staticCtxDirty = !1, this.lastRequestedRenderArguments = void 0, this.lastCompletedStaticRender = void 0, this.renderQueue = new Yw(2), this.id = e, this.name = t, this.service = n, this.panelSize = i, this.getWorkflowManager = a, this.layout = s;
  }
  getID() {
    return this.id;
  }
  getName() {
    return this.name;
  }
  getPanelSize() {
    return this.panelSize;
  }
  getLayout() {
    return this.layout;
  }
  /**
   * Updates the layout for this bridge, preserving rendering state.
   */
  updateLayout(e) {
    this.layout = e, this.name = e.name, this.panelSize = { width: e.width, height: e.height }, this.setStaticContextDirty(!0);
  }
  getStaticContext() {
    return this.textureCtx;
  }
  /**
   * Register canvas to be rendered to.
   */
  setStaticContext(e) {
    this.textureCtx = e, this.lastRequestedRenderArguments && this.render(this.lastRequestedRenderArguments);
  }
  getStaticContextDirty() {
    return this.staticCtxDirty;
  }
  setStaticContextDirty(e) {
    this.staticCtxDirty = e;
  }
  getInteractiveCanvasDirty() {
    return this.interactiveDirty;
  }
  setInteractiveCanvasDirty(e) {
    this.interactiveDirty = e;
  }
  markLastCompletedStaticRender() {
    this.lastCompletedStaticRender = Date.now(), this.service.onCompleteRender();
  }
  /**
   * Returns a timestamp for the last time that this canvas rendered to its dynamic texture in the
   * form of Date.now(). If this panel has never rendered undefined will be returned.
   */
  getLastCompletedStaticRender() {
    return this.lastCompletedStaticRender;
  }
  /**
   * Re-renders using the last known render arguments, at whatever dimensions the current
   * static context's canvas has. Useful when a consumer resizes the canvas (e.g. for a
   * change in zoom or device pixel ratio) and needs a freshly rasterized frame without a
   * design state change having occurred. No-op if nothing has been rendered yet.
   */
  requestRerender() {
    this.lastRequestedRenderArguments && this.render(this.lastRequestedRenderArguments);
  }
  /**
   * Actions to perform when a static render event is fired for this canvas.
   */
  async render(e) {
    const t = Su(e);
    this.lastRequestedRenderArguments = t;
    const n = this.getStaticContext();
    if (!n) {
      this.markLastCompletedStaticRender(), this.setStaticContextDirty(!1);
      return;
    }
    this.renderQueue.enqueue(
      new TW(
        this.getID(),
        n,
        await kW,
        () => {
          this.markLastCompletedStaticRender(), this.setStaticContextDirty(!0);
        },
        t,
        this.getWorkflowManager
      )
    );
  }
}
class TW extends Qw {
  constructor(e, t, n, i, a, s) {
    super(), this.layoutId = e, this.ctx = t, this.nonPOTSupport = n, this.onRender = i, this.layouts = a, this.getWorkflowManager = s;
  }
  /**
   * Render the internally stored layout to the canvas.
   * NOTE: This function is performance critical code. Please throughly test any changes to
   * ensure performance isn't lost and that rendering behavior is preserved when modifying this logic.
   * The aim is to have this code rendering in less than 16.66ms (60fps) on modern hardware. This is
   * a loose target but should be kept in mind when making changes.
   */
  async execute() {
    const e = this.layouts.find((p) => p.layoutState.layout.id === this.layoutId);
    if (!e)
      return;
    const t = e.layoutState.elements || [], n = e.layoutState.layout.width, i = e.layoutState.layout.height, { width: a, height: s } = FW(n, i, this.nonPOTSupport), o = this.getWorkflowManager?.()?.getTemplatingContext(), l = {};
    let u = Jk();
    const c = ux(e.layoutState.layout, t, {
      renderingConfiguration: {
        purpose: Hp.ThreeD,
        templatingContext: o
      }
    }), h = xI(c), f = await vc.from(this.ctx, h, {
      anonymousCrossOrigin: !0,
      ignoreDimensions: !this.nonPOTSupport,
      ignoreAnimation: !0,
      ignoreClear: !0,
      ignoreMouse: !0,
      enableRedraw: !1,
      createCanvas: Pc,
      createImage: cg,
      DOMParser: Dw(),
      fetch
    });
    l.prepare = Kk("prepare", u), u = Jk(), f.resize(a, s), await f.render(), l.rasterize = Kk("rasterize", u), CW(this.layoutId, l), this.onRender();
  }
}
function FW(r, e, t) {
  const n = r === 1 || e === 1 ? { width: 1, height: 1 } : IW(), i = n.width, a = n.height;
  let s, o;
  if (t) {
    const l = i / a;
    r / e < l ? (s = i, o = e * (i / r)) : (s = r * (a / e), o = a);
    const c = RW({ width: s, height: o });
    s = c.width, o = c.height;
  } else
    s = n.width, o = n.height;
  return { width: s, height: o };
}
function IW() {
  return PW() || !DW() ? {
    width: 1024,
    height: 1024
  } : {
    width: 2048,
    height: 2048
  };
}
function PW() {
  return window.innerWidth <= 480;
}
function DW() {
  return navigator.userAgent.includes("SamsungBrowser") ? !1 : !!window.Worker && !!window.OffscreenCanvas;
}
function RW(r, e = 4096) {
  const t = e / r.width, n = e / r.height, i = Math.min(t, n);
  return i > 1 ? r : { width: r.width * i, height: r.height * i };
}
const one = (r, e) => {
  const t = [];
  return r.forEach((n) => {
    const i = e.steps.find((a) => a.stepName === n.stepName);
    i?.type === gt.Text && n.stepAspectType === "Text" && t.push({
      name: i.stepName,
      data: {
        text: n.value
      }
    });
  }), t;
}, lne = async (r, e, t, n) => {
  let i = {
    serializableWorkflow: { steps: [] },
    layouts: {}
  };
  i = new Ii(t.map((l) => new OD(l))).apply(i);
  const s = await xW(r, e, t, n);
  return new Ii(s).apply(i);
}, Cg = Oe`
    fragment GlobalPropertyStateAspectFields on GlobalPropertyStateAspect {
        name
        value
        type
        channel
        hidden
        storage {
            ... on GlobalPropertyStateColorOptionStorage {
                customColor
            }
            ... on GlobalPropertyStateFileUploadStorage {
                originalAssetKey
                backgroundRemovedAssetKey
                useOriginalAsset
                colors {
                    key
                    browserValue
                    pmsValue
                }
            }
        }
    }
`, OW = Oe`
    ${Cg}
    mutation CreateGlobalPropertyState($bundleId: String!) {
        globalPropertyStateCreate(bundleId: $bundleId) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
    }
`, BW = Oe`
    ${Cg}
    mutation UpdateGlobalPropertyState($id: String!, $aspects: [GlobalPropertyStateAspectInput]!) {
        globalPropertyStateUpdate(id: $id, aspects: $aspects) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
    }
`, _W = Oe`
    ${Cg}
    query GetGlobalPropertyState($bundleId: String!) {
        globalPropertyState(bundleId: $bundleId) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
    }
`, une = async (r) => (await et.getShadowGraphqlClient().query({
  query: _W,
  fetchPolicy: "cache-first",
  errorPolicy: "all",
  variables: {
    bundleId: r
  }
})).data.globalPropertyState, MW = Oe`
    fragment WorkflowProductFields on WorkflowProduct {
        id
        index
        friendlyName
        isPresent
        workflowName
        imageUrl
        panelPreviews {
            panelId
            imageUrl
            region {
                width
                height
                top
                left
                rotation
            }
        }
    }
`, NW = (r) => Oe`
    ${MW}
    ${fg}
    fragment ProductFields on Product {
        id
        basePrice
        enabled
        imageUrl
        minimumOrderQuantity
        integrationProducts {
            id
            externalProductId
            externalVariantId
            additionalExternalProductId
            additionalExternalVariantId
            additionalIntegrationProduct {
                ...AdditionalIntegrationProductFields
            }
            integration {
                id
                enabled
                externalIntegrationId
                type
                isCurrent
            }
        }
        modelUrl
        name
        description
        overlayImageUrl
        preloadImageUrl
        sku
        skuCode
        workflows${r ? "(filters: $productWorkflowFilters)" : ""} {
            ...WorkflowProductFields
        }
        productTags {
            id
            name
        }
        productImages {
            id
            precedence
            asset {
                key
                fileLink
                name
                type
            }
        }
    }
`, px = (r) => Oe`
    ${NW(r)}
    fragment ProductCollectionProductFields on ProductCollectionProduct {
        id
        productId
        workflowId
        product {
            ...ProductFields
        }
        workflows {
            workflowProduct {
                ...WorkflowProductFields
            }
        }
    }
`, Y0 = Oe`
    fragment GlobalPropertyConfigurationFields on GlobalPropertyConfiguration {
        id
        name
        aspects {
            name
            type
            title
            description
            entityId
            mandatory
            silent
            conditions {
                targetAspectName
                action
                requiredVariantSelections
            }
            conditionMode
            data {
                fileUpload {
                    colorPickerEnabled
                    pmsPickerEnabled
                    colorOptionId
                }
                text {
                    templatingEnabled
                }
            }
        }
    }
`, LW = Oe`
    ${Y0}
    query GetGlobalPropertyConfigurations($ids: [String!]!) {
        globalPropertyConfigurations(ids: $ids) {
            ...GlobalPropertyConfigurationFields
        }
    }
`, XD = Oe`
    ${Y0}
    fragment BundleActivationFields on Activation {
        id
        globalPropertyConfiguration {
            ...GlobalPropertyConfigurationFields
        }
    }
`, X0 = (r, e = !1) => Oe`
    ${r ? px(e) : ""}
    ${Y0}
    fragment ProductCollectionFields on ProductCollection {
        id
        name
        description
        dispatchStartDate
        dispatchEndDate
        total
        productCollectionCustomers {
            id
            customer {
                id
            }
        }
        image {
            key
            name
            fileLink
        }
        globalPropertyConfiguration {
            ...GlobalPropertyConfigurationFields
        }
        ${r ? "productCollectionProducts { ...ProductCollectionProductFields }" : ""}
    }
`, JD = Oe`
    fragment BundleBaseFields on Bundle {
        id
        dispatchDate
        purchaseOrder
        createdAt
        updatedAt
        name
        completed
        template
        templateLocked
        templateStatus
        test
        transactionsCount
        productsCount
        totalPriceSubunits
        quoteId
        orderId
        externalOrderId
        internalOrderId
        workflowViewerLink
        workflowViewerAmendLink
    }
`, UW = (r) => Oe`
    ${Cg}
    ${X0(r)}
    ${XD}
    ${JD}
    query GetBundle($id: String!) {
        globalPropertyState(bundleId: $id) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
        bundles(ids: [$id]) {
            ...BundleBaseFields
            bundleStateData
            metadata {
                key
                value
            }
            partner {
                id
            }
            activation {
                ...BundleActivationFields
            }
            productCollection {
                ...ProductCollectionFields
            }
            globalPropertyConfiguration {
                ...GlobalPropertyConfigurationFields
            }
            transactionIds
            bundleShareActions {
                id
                title
                type
                stakeholderType
                precedence
                url
            }
        }
    }
`, eT = Oe`
    query GetBundleStakeholders($id: String!) {
        bundles(ids: [$id]) {
            id
            dispatchDate
            purchaseOrder
            completed
            workflowViewerLink
            workflowViewerAmendLink
            currentBundleStakeholder {
                id
                authorizationStatus
                authorizationDate
                authorizationNote
                customer {
                    id
                    emailAddress
                    firstName
                    lastName
                    phoneNumber
                    partner {
                        id
                    }
                }
                type
            }
            bundleStakeholders {
                id
                authorizationStatus
                authorizationDate
                authorizationNote
                customer {
                    id
                    emailAddress
                    firstName
                    lastName
                    phoneNumber
                    partner {
                        id
                    }
                }
                type
            }
        }
    }
`, VW = Oe`
    query GetBundlesForCustomer($id: String!) {
        customers(ids: [$id]) {
            bundleStakeholders {
                id
                authorizationStatus
                authorizationDate
                authorizationNote
                type
                bundle {
                    id
                    dispatchDate
                    purchaseOrder
                    completed
                    workflowViewerLink
                    workflowViewerAmendLink
                    name
                    createdAt
                    metadata {
                        key
                        value
                    }
                    partner {
                        id
                    }
                }
            }
        }
    }
`, tT = Oe`
    ${px(!1)}
    query GetProductCollectionProducts($id: String!, $productIds: [String!]) {
        productCollections(ids: [$id]) {
            id
            productCollectionProducts(productIds: $productIds) {
                ...ProductCollectionProductFields
            }
        }
    }
`, $W = Oe`
    query GetProductCollectionForFilteredProducts(
        $id: String!
        $productFilters: ProductCollectionProductFilterInput
        $productWorkflowFilters: MetafieldFilterListInput
        $tags: ProductCollectionProductTagFilterInput
        $sortKey: ProductCollectionProductSortKey
        $sortDescending: Boolean
        $quickSearch: String
    ) {
        productCollections(ids: [$id]) {
            id
            productCollectionProductsFeed(
                filters: $productFilters
                workflowFilters: $productWorkflowFilters
                tags: $tags
                sortKey: $sortKey
                sortDescending: $sortDescending
                quickSearch: $quickSearch
            ) {
                items {
                    id
                    product {
                        id
                    }
                }
            }
        }
    }
`, zW = Oe`
    ${px(!0)}
    query GetProductCollectionForProductsFeed(
        $id: String!
        $limit: Int
        $offset: Int
        $productFilters: ProductCollectionProductFilterInput
        $productWorkflowFilters: MetafieldFilterListInput
        $tags: ProductCollectionProductTagFilterInput
        $sortKey: ProductCollectionProductSortKey
        $sortDescending: Boolean
        $quickSearch: String
    ) {
        productCollections(ids: [$id]) {
            id
            productCollectionProductsFeed(
                filters: $productFilters
                workflowFilters: $productWorkflowFilters
                tags: $tags
                limit: $limit
                offset: $offset
                sortKey: $sortKey
                sortDescending: $sortDescending
                quickSearch: $quickSearch
            ) {
                items {
                    ...ProductCollectionProductFields
                }
                total
            }
        }
    }
`, GW = (r) => Oe`
    ${X0(r)}
    ${XD}
    mutation CreateBundle(
        $collectionId: String
        $initialMetadata: [MetadataInput!]
        $marketplaceThemeInstallId: String
        $marketplaceThemeInstallConfigurationId: String
        $activationId: String
        $test: Boolean
    ) {
        bundleCreate(
            collectionId: $collectionId
            metadata: $initialMetadata
            marketplaceThemeInstallId: $marketplaceThemeInstallId
            marketplaceThemeInstallConfigurationId: $marketplaceThemeInstallConfigurationId
            activationId: $activationId
            test: $test
        ) {
            id
            bundleOwnerId
            test
            metadata {
                key
                value
            }
            name
            partner {
                id
            }
            activation {
                ...BundleActivationFields
            }
            productCollection {
                ...ProductCollectionFields
            }
        }
    }
`, HW = () => Oe`
    mutation DuplicateBundle(
        $id: String!
        $template: Boolean
        $marketplaceThemeInstallId: String
        $marketplaceThemeInstallConfigurationId: String
        $duplicateTransactions: Boolean
        $test: Boolean
    ) {
        bundleDuplicate(
            id: $id
            template: $template
            marketplaceThemeInstallId: $marketplaceThemeInstallId
            marketplaceThemeInstallConfigurationId: $marketplaceThemeInstallConfigurationId
            duplicateTransactions: $duplicateTransactions
            test: $test
        ) {
            id
            bundleOwnerId
            test
            partner {
                id
            }
        }
    }
`, Sm = Oe`
    mutation UpdateBundle(
        $id: String!
        $name: String
        $metadata: [MetadataInput!]
        $bundleStateData: String
        $dispatchDate: String
        $purchaseOrder: String
    ) {
        bundleUpdate(
            id: $id
            name: $name
            metadata: $metadata
            bundleStateData: $bundleStateData
            dispatchDate: $dispatchDate
            purchaseOrder: $purchaseOrder
        ) {
            id
        }
    }
`, WW = Oe`
    mutation BundleAddTransaction($id: String!, $transactionId: String!) {
        bundleAddTransaction(id: $id, transactionId: $transactionId) {
            id
        }
    }
`, jW = Oe`
    mutation BundleAddTransactions($id: String!, $transactionIds: [String!]!, $transactionOwnerIds: [String!]) {
        bundleAddTransactions(id: $id, transactionIds: $transactionIds, transactionOwnerIds: $transactionOwnerIds) {
            id
        }
    }
`, qW = Oe`
    mutation BundleRemoveTransaction(
        $id: String!
        $transactionId: String!
        $name: String
        $metadata: [MetadataInput!]
        $bundleStateData: String
    ) {
        bundleRemoveTransaction(id: $id, transactionId: $transactionId) {
            id
        }
        bundleUpdate(id: $id, name: $name, metadata: $metadata, bundleStateData: $bundleStateData) {
            id
        }
    }
`, QW = Oe`
    mutation BundleRemoveTransactions(
        $id: String!
        $transactionIds: [String!]!
        $name: String
        $metadata: [MetadataInput!]
        $bundleStateData: String
    ) {
        bundleRemoveTransactions(id: $id, transactionIds: $transactionIds) {
            id
        }
        bundleUpdate(id: $id, name: $name, metadata: $metadata, bundleStateData: $bundleStateData) {
            id
        }
    }
`, YW = Oe`
    mutation BundleAddStakeholder($id: String!, $details: CustomerDetailsInput!, $type: String!) {
        bundleAddStakeholder(id: $id, details: $details, type: $type) {
            id
            bundleStakeholders {
                id
                customer {
                    id
                    emailAddress
                    firstName
                    lastName
                    phoneNumber
                    partner {
                        id
                    }
                }
                type
            }
        }
    }
`, XW = Oe`
    mutation BundleAddStakeholder($id: String!, $emailAddress: String!) {
        bundleRemoveStakeholder(id: $id, emailAddress: $emailAddress) {
            id
        }
    }
`, JW = Oe`
    mutation BundleUpdateStakeholders($id: String!, $input: [BundleStakeholderInput!]!) {
        bundleUpdateStakeholders(id: $id, input: $input) {
            id
            bundleStakeholders {
                id
                customer {
                    id
                    emailAddress
                    firstName
                    lastName
                    phoneNumber
                    partner {
                        id
                    }
                }
                type
            }
        }
    }
`, KW = Oe`
    mutation BundleUpdateTransactionOrder($id: String!, $transactionIds: [String!]!) {
        bundleUpdateTransactionOrder(id: $id, transactionIds: $transactionIds) {
            id
        }
    }
`, ZW = (r) => Oe`
    ${X0(r)}
    mutation BundleAssignProductCollection($id: String!, $productCollectionId: String!) {
        bundleAssignProductCollection(id: $id, collectionId: $productCollectionId) {
            id
            productCollection {
                ...ProductCollectionFields
            }
        }
    }
`, ej = Oe`
    mutation AssignGlobalPropertyConfiguration($bundleId: String!, $globalPropertyConfigurationId: String!) {
        bundleUpdate(id: $bundleId, globalPropertyConfigurationId: $globalPropertyConfigurationId) {
            id
        }
    }
`, tj = (r) => Oe`
    ${JD}
    query CustomerBundlesFeed($id: String!, $limit: Int!, $offset: Int!, $template: Boolean, $templateStatus: BundleTemplateStatus, $ordered: Boolean) {
        customerBundlesFeed(id: $id, limit: $limit, offset: $offset, template: $template, templateStatus: $templateStatus, ordered: $ordered) {
            items {
                ...BundleBaseFields
                activation {
                    id
                    globalPropertyConfiguration {
                        id
                    }
                }
                productCollection {
                    id
                    name
                    description
                    dispatchStartDate
                    dispatchEndDate
                    image {
                        key
                        name
                        fileLink
                    }
                    globalPropertyConfiguration {
                        id
                    }
                }
                ${r ? "metadata { key, value }" : ""}
            }
            total
        }
    }
`, rj = Oe`
    mutation FinalizeUpdateBundle($bundleId: String!) {
        bundleFinalizeUpdate(bundleId: $bundleId)
    }
`, nj = Oe`
    mutation ApproveBundle($id: String!, $note: String, $stakeholderId: String) {
        bundleApprove(id: $id, note: $note, stakeholderId: $stakeholderId)
    }
`, ij = Oe`
    mutation RejectBundle($id: String!, $note: String, $stakeholderId: String) {
        bundleReject(id: $id, note: $note, stakeholderId: $stakeholderId)
    }
`, aj = Oe`
    mutation ApproveTransaction($id: String!, $note: String) {
        transactionApprove(id: $id, note: $note)
    }
`, sj = Oe`
    mutation RejectTransaction($id: String!, $note: String) {
        transactionReject(id: $id, note: $note)
    }
`, oj = Oe`
    mutation CreateRecipient(
        $firstName: String
        $lastName: String
        $address: String
        $suburb: String
        $state: String
        $email: String
        $postalCode: String
        $country: String
        $mobile: String
        $company: String
        $apartment: String
        $customField1: String
        $customField2: String
        $customField3: String
        $customField4: String
        $customField5: String
        $conversionConfigurationId: String
    ) {
        recipientCreate(
            firstName: $firstName
            lastName: $lastName
            address: $address
            suburb: $suburb
            state: $state
            email: $email
            postalCode: $postalCode
            country: $country
            mobile: $mobile
            company: $company
            apartment: $apartment
            customField1: $customField1
            customField2: $customField2
            customField3: $customField3
            customField4: $customField4
            customField5: $customField5
            conversionConfigurationId: $conversionConfigurationId
        ) {
            id
        }
    }
`, lj = Oe`
    mutation UpdateRecipient(
        $id: String!
        $firstName: String
        $lastName: String
        $address: String
        $suburb: String
        $state: String
        $email: String
        $postalCode: String
        $country: String
        $mobile: String
        $company: String
        $apartment: String
        $customField1: String
        $customField2: String
        $customField3: String
        $customField4: String
        $customField5: String
        $conversionConfigurationId: String
        $prevalidated: Boolean
    ) {
        recipientUpdate(
            id: $id
            firstName: $firstName
            lastName: $lastName
            address: $address
            suburb: $suburb
            state: $state
            email: $email
            postalCode: $postalCode
            country: $country
            mobile: $mobile
            company: $company
            apartment: $apartment
            customField1: $customField1
            customField2: $customField2
            customField3: $customField3
            customField4: $customField4
            customField5: $customField5
            conversionConfigurationId: $conversionConfigurationId
            prevalidated: $prevalidated
        ) {
            id
        }
    }
`, uj = Oe`
    mutation AtttachRecipient($id: String!, $recipientId: String!) {
        transactionAttachRecipient(id: $id, recipientId: $recipientId) {
            id
        }
    }
`, cj = Oe`
    mutation DeleteBundle($id: String!) {
        bundleDelete(id: $id)
    }
`, fj = Oe`
    query FindBundleForTransactions($ids: [String!]!) {
        transactions(ids: $ids) {
            id
            bundle {
                id
            }
        }
    }
`, cne = Oe`
    mutation EmailBundleShareLink($bundleId: String!, $email: String!, $firstName: String, $lastName: String) {
        bundleEmailSharePageLink(bundleId: $bundleId, email: $email, firstName: $firstName, lastName: $lastName) {
            id
        }
    }
`, dj = (r, e) => e && typeof e == "object" && !Array.isArray(e) ? Object.keys(e).sort().reduce((t, n) => (t[n] = e[n], t), {}) : e, hj = (r) => {
  for (const e of Object.values(r.layouts).map((t) => t.elements).flat())
    e.type === "illustration" && (delete e.cachedObjectURL, e.src && delete e.svg), e.type === "frame" && delete e.pattern?.svg;
  return KD(r, "__typename"), r;
}, KD = (r, e) => {
  if (!(typeof r != "object" || r === null))
    for (const t in r)
      t === e ? delete r[t] : KD(r[t], e);
};
var J0 = /* @__PURE__ */ ((r) => (r.Error = "Error", r.Warning = "Warning", r.Info = "Info", r))(J0 || {});
const pj = 1e3;
class rT extends Qw {
  constructor(e) {
    super(), this.update = e;
  }
  async execute() {
    await this.update(), await new Promise((e) => {
      window.setTimeout(() => {
        e();
      }, pj);
    });
  }
}
const gj = (r) => r.sort((e, t) => e.index - t.index).map((e) => ({
  id: nn(),
  panelId: e.name,
  name: e.name,
  title: e.title,
  index: e.index,
  createdAt: /* @__PURE__ */ new Date(),
  updatedAt: /* @__PURE__ */ new Date(),
  transparentBackground: e.transparentBackground,
  height: e.height,
  width: e.width,
  previewRegion: e.previewRegion,
  useEditableArea: e.useEditableArea,
  editableArea: e.editableArea
})), nT = (r, e) => {
  const t = r.workflowState, n = t ? JSON.parse(t) : void 0;
  return n ? Object.values(n.layouts).map((i) => i.layout) : gj(e.panels);
}, Np = class Np {
  constructor(e, t, n, i, a, s = !1, o, l = !1, u = !1, c = !1) {
    this.workflowStatePromiseQueue = new Yw(1), this.initialized = !1, this.readOnly = !1, this.isReloadedTransaction = !1, this.singleVariantsRenderable = !1, this.stepTags = {}, this.setWorkflow = async (f) => {
      this.confirmedDesign = !1, this.editedSteps = {}, this.informationResults = [], this.mandatorySteps = {}, this.pendingUpdates = [], this.selectionCost = 0, this.stepSpecificServices = {}, this.pollers = [], this.allScenes = [], this.stepElements = {}, this.stepInitialised = {}, this.stepMetadata = {}, this.stepSelections = {}, this.storage = {}, this.validationErrors = { steps: /* @__PURE__ */ new Map() }, this.currentAdjustingStepId = "", this.reloadedState ? this.layouts = Object.values(this.reloadedState.layouts || {}).map((m) => m.layout) : f ? this.layouts = nT(this.experience.getTransaction(), f) : this.layouts = [], this.commandContext.initialize(this.layouts, this.reloadedState), this.renderableContextService = new SW(this.layouts), this.renderableContextService.setWorkflowManager(this), f.steps.forEach((m) => {
        this.stepTags[m.stepName] = m.tags ?? [];
      });
      const p = this.previewService;
      this.ejectFromPreviewService(), this.initializationPromise = this.initializeDefaultWorkflowState(f), this.initializationPromise.then(() => {
        this.initialized = !0;
      }), this.initializationPromise.catch((m) => {
        throw this.initialized = !1, new Error(m);
      }), this.initializationPromise.finally(
        () => this.commandContext.registerStateCallback(() => {
          this.updateStateWithServer(), this.debouncedRenderLayouts();
        })
      ), p && await this.injectIntoPreviewService(p, !0);
    }, this.renderLayouts = () => {
      const f = this.getLayoutPreviewService()?.getAll();
      if (!f) return;
      const p = this.getCommandContext().getAllLayouts();
      for (const [, m] of f)
        m.render(p);
    }, this.debouncedRenderLayouts = W0(() => this.renderLayouts(), 150), this.experience = e, this.client = t, this.updateTransaction = n, this.graphQlClient = i, this.reloadedState = a, this.readOnly = s, this.singleVariantsRenderable = u, this.commandContext = new qG(), this.confirmCallbacks = [], this.editedCallbacks = [], this.elementsCallbacks = [], this.informationResultCallbacks = [], this.initCallbacks = [], this.mandatoryCallbacks = [], this.makingAdjustmentsCallback = [], this.metadataCallbacks = [], this.selectionCallbacks = [], this.stepSpecificStorageCallbacks = {}, this.storageCallbacks = [], this.validationCallbacks = [], this.recipientCallbacks = [], this.modelContainer = o, this.confirmedDesign = !1, this.editedSteps = {}, this.informationResults = [], this.mandatorySteps = {}, this.pendingUpdates = [], this.selectionCost = 0, this.stepSpecificServices = {}, this.pollers = [], this.allScenes = [], this.stepElements = {}, this.stepInitialised = {}, this.stepMetadata = {}, this.stepSelections = {}, this.storage = {}, this.validationErrors = { steps: /* @__PURE__ */ new Map() }, this.currentAdjustingStepId = "", this.isReloadedTransaction = l, c && (this.workflowStatePromiseQueue.enabled = !1);
    const h = this.experience.getWorkflow();
    h && this.setWorkflow(h);
  }
  async updateWorkflowConfiguration(e) {
    e.panels && await this.updatePanels(e.panels), e.steps && await this.updateSteps(e.steps), this.allScenes = sy(this.getWorkflowExperience().getWorkflow()), await this.ensureStepsAreLoaded(), this.renderLayouts(), await this.onSelectionChange();
  }
  async updatePanels(e) {
    const t = this.experience.getWorkflow();
    let n = [...t.panels];
    if (e.removed && (n = n.filter((o) => !e.removed.includes(o.name))), e.changed)
      for (const o of e.changed) {
        const l = n.findIndex((u) => u.name === o.name);
        l >= 0 && (n[l] = o);
      }
    if (e.added)
      for (const { item: o, index: l } of e.added)
        n.splice(l, 0, o);
    const i = new Map(this.layouts.map((o) => [o.panelId, o])), a = nT(this.experience.getTransaction(), {
      ...t,
      panels: n
    }), s = /* @__PURE__ */ new Map();
    for (const o of a) {
      const l = i.get(o.panelId);
      l ? s.set(l.id, {
        ...l,
        ...o,
        id: l.id
      }) : s.set(o.id, o);
    }
    this.layouts = Array.from(s.values()), this.commandContext.updateLayouts(this.layouts), this.renderableContextService && this.renderableContextService.updateLayouts(this.layouts);
  }
  async updateSteps(e) {
    if (e.removed)
      for (const t of e.removed)
        this.clearStepState(t);
    if (e.changed)
      for (const t of e.changed)
        this.clearStepState(t.stepName);
  }
  clearStepState(e) {
    const t = this.stepElements[e];
    if (t && t.length > 0) {
      const n = t.map((i) => new Lf(i.id));
      n.length > 0 && this.commandContext.apply(new Ii(n), !0);
    }
    delete this.stepSelections[e], delete this.stepMetadata[e], delete this.storage[e], delete this.stepElements[e], delete this.stepInitialised[e], delete this.stepSpecificServices[e], delete this.mandatorySteps[e], this.validationErrors.steps.delete(e);
  }
  getTemplatingContext() {
    const e = this.experience.getTransaction().recipient, t = { recipient: e };
    return this.recipientConversionConfiguration?.requestedDataItems?.forEach((n) => {
      const i = n.uniqueIdentifier ?? n.title ?? "";
      n.type === zm.FirstName ? t[i] = e?.firstName : n.type === zm.LastName ? t[i] = e?.lastName : n.type === zm.Custom && (n.customFieldIndex === 1 ? t[i] = e?.customField1 : n.customFieldIndex === 2 ? t[i] = e?.customField2 : n.customFieldIndex === 3 ? t[i] = e?.customField3 : n.customFieldIndex === 4 ? t[i] = e?.customField4 : n.customFieldIndex === 5 && (t[i] = e?.customField5), n.option && (t[i] = n.option.variants?.find((a) => a.id === t[i])?.name));
    }), t;
  }
  async updateRecipient(e, t, n, i, a, s, o, l, u, c, h, f, p, m, A, w, x, E) {
    const T = this.experience.getTransaction();
    if (T.recipient?.id)
      this.experience.getTransaction().recipient = {
        id: T.recipient.id,
        firstName: e ?? T.recipient.firstName,
        lastName: t ?? T.recipient.lastName,
        address: n ?? T.recipient.address,
        suburb: i ?? T.recipient.suburb,
        state: a ?? T.recipient.state,
        email: s ?? T.recipient.email,
        postalCode: o ?? T.recipient.postalCode,
        country: l ?? T.recipient.country,
        mobile: u ?? T.recipient.mobile,
        company: c ?? T.recipient.company,
        apartment: h ?? T.recipient.apartment,
        customField1: f ?? T.recipient.customField1,
        customField2: p ?? T.recipient.customField2,
        customField3: m ?? T.recipient.customField3,
        customField4: A ?? T.recipient.customField4,
        customField5: w ?? T.recipient.customField5,
        conversionConfigurationId: x || T.recipient.conversionConfigurationId
      }, this.experience.callEvent(Y1.RecipientChanged), await this.graphQlClient().mutate({
        mutation: lj,
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        variables: {
          id: T.recipient.id,
          firstName: e || T.recipient.firstName,
          lastName: t || T.recipient.lastName,
          address: n || T.recipient.address,
          suburb: i || T.recipient.suburb,
          state: a || T.recipient.state,
          email: s || T.recipient.email,
          postalCode: o || T.recipient.postalCode,
          country: l || T.recipient.country,
          mobile: u || T.recipient.mobile,
          company: c || T.recipient.company,
          apartment: h || T.recipient.apartment,
          customField1: f || T.recipient.customField1,
          customField2: p || T.recipient.customField2,
          customField3: m || T.recipient.customField3,
          customField4: A || T.recipient.customField4,
          customField5: w || T.recipient.customField5,
          conversionConfigurationId: x || T.recipient.conversionConfigurationId,
          prevalidated: E
        }
      });
    else {
      const D = await this.graphQlClient().mutate({
        mutation: oj,
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        variables: {
          firstName: e,
          lastName: t,
          address: n,
          suburb: i,
          state: a,
          email: s,
          postalCode: o,
          country: l,
          mobile: u,
          company: c,
          apartment: h,
          customField1: f,
          customField2: p,
          customField3: m,
          customField4: A,
          customField5: w,
          conversionConfigurationId: x
        }
      });
      T.recipient = {
        id: D?.data?.recipientCreate?.id,
        firstName: e,
        lastName: t,
        address: n,
        suburb: i,
        state: a,
        email: s,
        postalCode: o,
        country: l,
        mobile: u,
        company: c,
        apartment: h,
        customField1: f,
        customField2: p,
        customField3: m,
        customField4: A,
        customField5: w,
        conversionConfigurationId: x
      }, this.experience.callEvent(Y1.RecipientChanged), await this.graphQlClient().mutate({
        mutation: uj,
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        variables: {
          id: this.experience.getTransaction().id,
          recipientId: D.data?.recipientCreate?.id
        },
        context: {
          transactionOwnerId: this.experience.getTransaction().transactionOwnerId
        }
      });
    }
    await this.fetchConversionConfiguration(), this.recipientCallbacks.forEach((D) => D(this.experience.getTransaction().recipient));
  }
  async fetchConversionConfiguration() {
    const e = this.experience.getTransaction().recipient;
    if (e?.conversionConfigurationId && !this.recipientConversionConfiguration) {
      const t = Np.configurationPromiseMap.get(
        e.conversionConfigurationId
      );
      if (t)
        this.recipientConversionConfiguration = await t;
      else {
        const i = (async () => (await this.graphQlClient().query({
          query: kL,
          errorPolicy: "all",
          fetchPolicy: "no-cache",
          variables: {
            id: e.conversionConfigurationId
          }
        })).data.conversionConfiguration)();
        Np.configurationPromiseMap.set(e.conversionConfigurationId, i), this.recipientConversionConfiguration = await i;
      }
    }
  }
  async initializeDefaultWorkflowState(e) {
    const t = () => {
      const c = e.finalizeStepConfig;
      if (!c) return;
      const h = c.lookAtAnimation, f = c.modelAnimation;
      h && this.previewService?.executeCameraAnimation(h), f && this.modelContainer?.executeAnimation(f);
    };
    this.reloadedState && this.reloadedState.serializableWorkflow.steps.forEach((c) => {
      this.storage[c.stepName] = c.storage || {};
    });
    const n = await this.getInitialOptionIds(
      this.reloadedState?.serializableWorkflow?.steps.reduce((c, h) => (h.selectedVariants?.length && (c[h.stepName] = {
        selectedVariants: h.selectedVariants.map((f) => ({ id: f.id }))
      }), c), {})
    ), i = Pt.getOptions(Array.from(n)), a = this.fetchConversionConfiguration();
    await Promise.all([i, a]), this.allScenes = sy(e);
    const o = (await kl(this.allScenes, this.stepSelections)).map((c) => c.silentSteps).flat(), { stepElements: l, commands: u } = await this.stepElementsForIntroducedSilentSteps(o, !!this.reloadedState);
    this.commandContext.apply(new Ii(u), !0), this.stepElements = { ...this.stepElements, ...l }, await this.ensureStepsAreLoaded(), this.isReloadedTransaction || this.updateStateWithServer(), this.renderLayouts(), this.reloadedState && t();
  }
  getWorkflowExperience() {
    return this.experience;
  }
  getClient() {
    return this.client;
  }
  setWorkflowStateSyncEnabled(e) {
    this.workflowStatePromiseQueue.enabled = e;
  }
  getInitializationPromise() {
    return this.initializationPromise;
  }
  isInitialized() {
    return this.initialized;
  }
  async getInitialOptionIds(e) {
    const t = /* @__PURE__ */ new Set(), n = this.experience.getWorkflow();
    if (!n)
      return t;
    const i = sy(n), a = { ...e };
    let s = -1;
    for (; ; ) {
      const u = (await kl(i, a)).flatMap((c) => c.renderableSteps);
      if (u.length === s)
        break;
      s = u.length;
      for (const c of u) {
        if (a[c.stepName])
          continue;
        const h = c.option?.defaultVariant?.id;
        h && (a[c.stepName] = {
          selectedVariants: [{ id: h }]
        });
      }
    }
    return (await kl(i, a)).flatMap((l) => l.renderableSteps).forEach((l) => {
      l.option?.id && !l.option?.variants && t.add(l.option.id);
    }), t;
  }
  addConfirmCallback(e) {
    e(this.confirmedDesign), this.confirmCallbacks.push(e);
  }
  addEditedCallback(e) {
    e(this.editedSteps), this.editedCallbacks.push(e);
  }
  addElementsCallback(e) {
    e(this.stepElements), this.elementsCallbacks.push(e);
  }
  addInformationResultCallback(e) {
    e(this.informationResults), this.informationResultCallbacks.push(e);
  }
  addInitCallback(e) {
    e(this.stepInitialised), this.initCallbacks.push(e);
  }
  addMandatoryCallback(e) {
    e(this.mandatorySteps), this.mandatoryCallbacks.push(e);
  }
  addMetadataCallback(e) {
    e(this.stepMetadata), this.metadataCallbacks.push(e);
  }
  async addSelectionCallback(e) {
    e({
      selectionCost: this.selectionCost,
      selections: this.stepSelections,
      traversableScenes: await this.traversableScenes()
    }), this.selectionCallbacks.push(e);
  }
  addStepSpecificStorageCallback(e, t) {
    Object.keys(this.storage).includes(t) || (this.storage[t] = {}), e(this.storage[t]), Object.keys(this.stepSpecificStorageCallbacks).includes(t) || (this.stepSpecificStorageCallbacks[t] = []), this.stepSpecificStorageCallbacks[t].push(e);
  }
  /**
   * @deprecated Any call to this causes all renderable steps to re-render even if they don't care about change.
   */
  addStorageCallback(e) {
    e(this.storage), this.storageCallbacks.push(e);
  }
  addMakingAdjustmentsCallback(e) {
    e(this.currentAdjustingStepId), this.makingAdjustmentsCallback.push(e);
  }
  addPoller(e) {
    this.pollers.push(e);
  }
  addValidationCallback(e) {
    this.validationCallbacks.push(e), e(this.validationErrors);
  }
  addRecipientCallback(e) {
    this.recipientCallbacks.push(e), e(this.experience.getTransaction().recipient);
  }
  removeRecipientCallback(e) {
    this.recipientCallbacks = this.recipientCallbacks.filter((t) => t !== e);
  }
  getLayouts() {
    return this.layouts;
  }
  getAllLayoutData() {
    return this.commandContext.getAllLayouts().map((e) => e.layoutState);
  }
  getLayoutPreviewService() {
    return this.renderableContextService;
  }
  getInformationResults() {
    return this.informationResults;
  }
  getPreviewService() {
    return this.previewService;
  }
  getCommandContext() {
    return this.commandContext;
  }
  getRegionElements(e) {
    return this.stepElements[e] || [];
  }
  getStepSpecificServices(e) {
    return this.stepSpecificServices[e];
  }
  getTransactionCustomer() {
    return this.ownerCustomer;
  }
  setTransactionCustomer(e) {
    this.ownerCustomer = e;
  }
  setTransactionCustomerDetails(e) {
    this.ownerCustomer = { ...this.ownerCustomer, emailAddress: e.email };
  }
  getModelContainer() {
    return this.modelContainer;
  }
  setModelContainer(e) {
    (!e || this.previewService && this.previewService.getAllModels().includes(e)) && (this.modelContainer = e, e && e.metadata && e.metadata instanceof Map && this.modelContainer.metadata.set("workflowManager", this));
  }
  getCommandDispatcher() {
    return (e) => this.commandContext.apply(e, !this.initialized);
  }
  getWorkflowSelections() {
    const e = {};
    return this.experience.getWorkflow()?.steps.forEach((t) => {
      const n = this.stepSelections[t.stepName];
      n && n.selectedVariants && n.selectedVariants.length > 0 && (e[t.stepName] = {
        selections: n.selectedVariants
      });
    }), e;
  }
  getStepSelections() {
    return this.stepSelections;
  }
  markStepsAsInitialised(e) {
    const t = { ...this.stepInitialised };
    e.forEach((n) => {
      t[n] = !0;
    }), this.stepInitialised = t, this.onInitChange();
  }
  getUpdatesPending() {
    return this.pendingUpdates.length > 0;
  }
  markUpdateCompleted(e) {
    this.pendingUpdates = this.pendingUpdates.filter((t) => t !== e);
  }
  markUpdatePending() {
    const e = nn();
    return this.pendingUpdates = [...this.pendingUpdates, e], e;
  }
  setEditedStatus(e, t) {
    this.editedSteps = { ...this.editedSteps, [e]: t }, this.onEditedChange();
  }
  setInformationResults(e) {
    this.informationResults = [...e], this.onInformationResultChange();
  }
  setCurrentAdjustingStepId(e) {
    this.currentAdjustingStepId = e, this.onMakingAdjustmentsChange();
  }
  setMandatoryFulfilled(e, t) {
    this.mandatorySteps[e] !== t && (this.mandatorySteps = { ...this.mandatorySteps, [e]: t }, this.onMandatoryChange());
  }
  async getMandatoryUnfulfilledSteps() {
    return (await kl(this.allScenes, this.stepSelections)).flatMap((a) => a.renderableSteps).filter((a) => a.mandatory).filter((a) => !this.mandatorySteps[a.stepName]).map((a) => a.stepName);
  }
  setStepError(e, t, n) {
    let i = !1;
    if (!this.validationErrors.steps.has(e) && n)
      i = !0, this.validationErrors.steps.set(e, /* @__PURE__ */ new Map([[t, n]]));
    else if (this.validationErrors.steps.has(e)) {
      const a = this.validationErrors.steps.get(e);
      n && n !== a.get(t) ? (i = !0, a.set(t, n)) : n || (i = !0, a.delete(t), a.size === 0 && this.validationErrors.steps.delete(e));
    }
    i && this.onValidationChange();
  }
  getStepErrors(e) {
    return this.validationErrors.steps.get(e);
  }
  getValidationErrors() {
    return this.validationErrors;
  }
  toggleDesignConfirmed() {
    this.confirmedDesign = !this.confirmedDesign, this.onConfirmChange();
  }
  toggleMakingAdjustmentsCallback(e) {
    e(this.mandatorySteps), this.mandatoryCallbacks.push(e);
  }
  async injectIntoPreviewService(e, t) {
    if (this.modelContainer)
      throw new Error("You must eject from the preview service before injecting again.");
    this.previewService = e;
    const n = this.experience.getProduct();
    if (!n?.modelUrl || !this.previewService) return;
    const i = e.loadModel(
      {
        model: n.modelUrl,
        contextService: this.getLayoutPreviewService()
      },
      { refocusCamera: t }
    );
    this.setModelContainer(i);
    const s = (await kl(this.allScenes, this.stepSelections)).filter((l) => l).map((l) => l.renderableSteps).flat().filter((l) => l.type === gt.Model || l.type === gt.Material), o = [];
    i.beginModelVariantBatch?.();
    try {
      s.forEach((l) => {
        if (!l.option?.id) {
          console.error(`Failed to read option id from step: ${l.stepName}`);
          return;
        }
        const u = this.stepSelections[l.stepName]?.selectedVariants || [];
        if (u.length === 0) return;
        const c = u[0];
        if (l.type === gt.Model) {
          if (!this.modelContainer)
            throw new si(
              "We should always have a model container when injecting a preview!"
            );
          const h = c.asset?.fileLink;
          if (!h) {
            console.error(
              `Failed to read model url from variant: ${c.id} for step: ${l.stepName}`
            );
            return;
          }
          const f = l.data;
          o.push(
            this.modelContainer.applyModelVariant(
              l.stepName,
              {
                model: h,
                contextService: this.getLayoutPreviewService()
              },
              f.replaceProductModel || !1
            )
          );
        } else {
          const h = c.material;
          if (!h) {
            console.error(`Failed to read material from variant: ${c.id} for step: ${l.stepName}`);
            return;
          }
          l.data.targetMaterials.forEach((p) => {
            if (!this.modelContainer)
              throw new si(
                "We should always have a model container when injecting a preview!"
              );
            this.modelContainer.applyMaterialVariant(p, l.option.id, h);
          });
        }
      }), await Promise.allSettled(o);
    } finally {
      i.endModelVariantBatch?.();
    }
    await i.getInitializationPromise(), this.renderLayouts();
  }
  ejectFromPreviewService() {
    if (this.modelContainer) {
      if (!this.modelContainer.dispose)
        throw new Error("This feature is not supported in the current preview service.");
      this.modelContainer.dispose(), this.modelContainer = void 0;
    }
    this.previewService = void 0;
  }
  updateStorage(e, t) {
    const n = {
      ...this.storage,
      [e]: { ...this.storage[e], ...t }
    };
    if (!g0(n, this.storage)) {
      this.storage = n;
      const i = new sk(this.constructSerializableWorkflow());
      this.commandContext.apply(i, !0), this.onStepSpecificStorageChange(e), this.onStorageChange();
    }
  }
  constructSerializableWorkflow() {
    const e = [];
    return this.allScenes.forEach((t) => {
      t.renderableSteps.forEach((n) => {
        const i = { stepName: n.stepName };
        i.storage = this.storage[n.stepName], i.selectedVariants = this.stepSelections[n.stepName]?.selectedVariants?.map(
          (a) => ({ id: a.id, priceModifier: a.priceModifier })
        ), e.push(i);
      });
    }), { steps: e };
  }
  updateStateWithServer() {
    if (this.readOnly) return;
    const e = this.serialize();
    this.workflowStatePromiseQueue.enqueue(
      new rT(async () => {
        await new Promise((t) => {
          setTimeout(() => {
            t();
          }, 1);
        }), await this.updateTransaction({
          variables: {
            id: this.experience.getTransaction().id,
            workflowState: e
          }
        });
      })
    );
  }
  async updateStateWithServerImmediate() {
    if (this.readOnly) return;
    const e = this.serialize();
    return new rT(async () => {
      await this.updateTransaction({
        variables: {
          id: this.experience.getTransaction().id,
          workflowState: e
        }
      });
    }).execute();
  }
  serialize() {
    const e = this.getCommandContext().getState();
    if (!e)
      throw new si("Attempted to serialize state before it was initialized.");
    const t = Su(e.transaction), n = hj(t);
    return JSON.stringify(n, dj, void 0);
  }
  async getStateHash() {
    const e = this.getCommandContext().getState(), n = Object.values(e?.transaction.layouts || {}).map((s) => s.modificationID ?? "").sort().join(""), a = new TextEncoder().encode(n);
    if (typeof window < "u" && window.crypto && window.crypto.subtle && window.crypto.subtle.digest) {
      const s = await window.crypto.subtle.digest("SHA-256", a);
      return Array.from(new Uint8Array(s)).map((u) => u.toString(16).padStart(2, "0")).join("");
    }
    try {
      return (await import("crypto")).createHash("sha256").update(n, "utf8").digest("hex");
    } catch {
      throw new Error("Unable to compute SHA-256 hash: no suitable crypto implementation available.");
    }
  }
  async outstandingRequestsPromise() {
    return this.workflowStatePromiseQueue.finalize();
  }
  updateMetadata(e, t) {
    this.stepMetadata = {
      ...this.stepMetadata,
      [e]: { ...this.stepMetadata[e], ...t }
    }, this.onMetadataChange();
  }
  removeElements(e) {
    const t = (n, i) => Object.keys(n).reduce((a, s) => {
      const o = [...n[s] || []];
      return i.forEach((l) => {
        const u = o.findIndex((c) => c.id === l.id);
        u > -1 && o.splice(u, 1);
      }), a[s] = o, a;
    }, {});
    this.stepElements = t(this.stepElements, e);
  }
  async getInvalidCanvasRegions() {
    let e = [];
    for (const t of this.experience.getWorkflow()?.steps || [])
      if (!await yc(t, this.stepSelections) && this.stepElements[t.stepName])
        for (const n of this.stepElements[t.stepName])
          e.push(n);
    return e;
  }
  async getInvalidModelVariants() {
    let e = [];
    for (const t of this.experience.getWorkflow()?.steps || [])
      t.type === gt.Model && !await yc(t, this.stepSelections) && e.push(t.stepName);
    return e;
  }
  /**
   * @deprecated This function is only relevant for silent steps that are introduced by a selection. Steps now expose a silent flag that should allow any step to achieve the same behavior without needing special handling. We should remove this function once all silent steps have been migrated to use the new flag and logic.
   */
  async stepElementsForIntroducedSilentSteps(e, t) {
    const n = this.experience.getProduct();
    if (!n)
      return Promise.resolve({ stepElements: {}, commands: [] });
    const i = async (u, c, h) => {
      if (u.type === gt.SilentIllustration) {
        const f = await new uk(u, c).trigger();
        return { step: u, results: f };
      } else if (u.type === gt.ProductOverlay) {
        const f = await new uk(
          u,
          c,
          h
        ).trigger();
        return { step: u, results: f };
      }
      return Promise.reject("Unknown silent step. This is a bug");
    }, a = e.filter(
      (u) => !this.stepInitialised[u.stepName]
    ), s = {
      stepElements: {},
      commands: []
    }, o = [];
    for (const u of a)
      this.markStepsAsInitialised([u.stepName]), t || o.push(i(u, this.layouts, n));
    const l = await Promise.all(o);
    for (const u of l)
      s.stepElements[u.step.stepName] = u.results.map((c) => c.regionElement), s.commands = [...s.commands, ...u.results.map((c) => c.command)];
    return s;
  }
  getStepStorage(e) {
    return this.storage[e];
  }
  getMetadata(e) {
    return this.stepMetadata[e];
  }
  getWorkflowMetadata() {
    return this.stepMetadata;
  }
  getStepTags(e) {
    return this.stepTags[e] || [];
  }
  /**
   * @deprecated Simply run serializedSteps.find((step) => step.stepName === stepName) instead.
   */
  getSerializedStep(e, t) {
    return t.find((n) => n.stepName === e);
  }
  async updateTransactionShareActions() {
    const e = await this.client.getShareActionsForTransaction(this.experience.getTransaction().id);
    this.experience.getTransaction().transactionShareActions = e;
  }
  async updateTransactionStakeholders() {
    const e = await et.getShadowGraphqlClient().query({
      query: RL,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.experience.getTransaction().id
      }
    });
    !e?.data?.transactions || e.data.transactions.length !== 1 ? (this.experience.getTransaction().currentStakeholder = void 0, this.experience.getTransaction().stakeholders = void 0) : (this.experience.getTransaction().stakeholders = e.data.transactions[0].stakeholders, this.experience.getTransaction().currentStakeholder = e.data.transactions[0].currentStakeholder);
  }
  async approveTransaction(e) {
    await et.getShadowGraphqlClient().mutate({
      mutation: aj,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.experience.getTransaction().id,
        note: e
      }
    });
  }
  async rejectTransaction(e) {
    await et.getShadowGraphqlClient().mutate({
      mutation: sj,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.experience.getTransaction().id,
        note: e
      }
    });
  }
  async reset() {
    this.stepElements = {}, this.stepInitialised = {}, this.stepMetadata = {}, this.stepSelections = {}, this.storage = {}, await this.ensureStepsAreLoaded();
  }
  async setSelectionsAndElements(e, t, n, i) {
    const a = this.modelContainer;
    a?.beginModelVariantBatch?.();
    try {
      await this.applySelectionsAndElements(e, t, n, i);
    } finally {
      a?.endModelVariantBatch?.();
    }
  }
  async applySelectionsAndElements(e, t, n, i) {
    const a = this.experience.getWorkflow();
    if (!a) throw new Error("Attempted to set selections when no workflow is set!");
    const s = this.stepSelections;
    this.stepSelections = {
      ...this.stepSelections,
      [e]: { selectedVariants: t }
    };
    for (const _ of a.steps)
      await yc(_, this.stepSelections) || (this.stepInitialised[_.stepName] = !1, delete this.stepMetadata[_.stepName], delete this.stepSelections[_.stepName], delete this.storage[_.stepName]);
    const o = this.allScenes, l = await kl(o, s), u = await kl(o, this.stepSelections), c = l.map((_) => _.silentSteps).flat(), f = u.map((_) => _.silentSteps).flat().filter(
      (_) => !c.some((L) => L.stepName === _.stepName)
    );
    for (const _ of c)
      await yc(_, this.stepSelections) || (this.stepInitialised[_.stepName] = !1);
    const p = await this.getInvalidCanvasRegions(), { stepElements: m, commands: A } = await this.stepElementsForIntroducedSilentSteps(f, !1);
    this.stepElements = {
      ...this.stepElements,
      ...m,
      [e]: n
    }, this.removeElements(p);
    const w = a.steps.find((_) => _.stepName === e);
    w?.type === gt.Frame && this.getWorkflowExperience().getStepById(w.stepName)?.frameService?.setTargetElements(n.map((L) => L.id));
    const x = p.map((_) => new Lf(_.id)), E = new sk(this.constructSerializableWorkflow()), T = [...A, ...x, E];
    T.length > 0 && this.commandContext.apply(new Ii(T), !0), await this.ensureStepsAreLoaded(), this.selectionCost = Object.values(this.stepSelections).reduce((_, L) => _ + L.selectedVariants.map((Z) => Z.priceModifier || 0).reduce((Z, te) => Z + te, 0), 0), this.onElementsChange();
    const D = await this.getInvalidModelVariants(), F = this.modelContainer;
    if (F) {
      const _ = D.map(
        (L) => F.applyModelVariant(
          L,
          {
            contextService: this.getLayoutPreviewService()
          },
          !1
        )
      );
      await Promise.all(_);
    }
    await this.onSelectionChange(), await this.reapplyMaterialSteps(), w?.type !== gt.Frame && w?.type !== gt.Text && this.setMandatoryFulfilled(e, !0), i && await i();
  }
  /**
   * Ensures all steps for active scenes are initialized and loads them in parallel.
   *
   * This method:
   * 1. Identifies active scenes and their renderable steps
   * 2. Initializes uninitialized steps by invoking the appropriate step service based on step type
   * 3. Executes all initialization commands as a batch and processes followup actions
   * 4. Recursively handles any followup conditions that may trigger additional step loading
   * 5. Notifies listeners of initialization changes
   *
   * @throws {Error} If any step initialization fails during the settlement of promises
   */
  async ensureStepsAreLoaded() {
    const t = (await kl(this.allScenes, this.stepSelections)).map((l) => l.renderableSteps), n = [], i = t.flat();
    for (const l of i)
      if (!this.stepInitialised[l.stepName])
        switch (this.stepInitialised[l.stepName] = !0, l.type) {
          case gt.DigitalContent:
            n.push(
              VD.init(
                l,
                this,
                this.reloadedState
              )
            );
            break;
          case gt.Frame:
            n.push(Sf.init(l, this, this.reloadedState));
            break;
          case gt.Illustration:
            n.push(
              Km.init(l, this, this.reloadedState)
            );
            break;
          case gt.Material:
            n.push(
              $D.init(l, this, this.reloadedState)
            );
            break;
          case gt.Model:
            n.push(zD.init(l, this, this.reloadedState));
            break;
          case gt.Module:
            this.stepSpecificServices[l.stepName] = {
              module: await qD(l.data.module)
            }, n.push(
              GD.init(l, this, this.reloadedState)
            );
            break;
          case gt.Picture:
            n.push(
              HD.init(l, this, this.reloadedState)
            );
            break;
          case gt.Question:
            n.push(
              WD.init(l, this, this.reloadedState)
            );
            break;
          case gt.Shape:
            n.push(xp.init(l, this, this.reloadedState));
            break;
          case gt.Text:
            n.push(ca.init(l, this, this.reloadedState));
            break;
        }
    const a = (await Promise.allSettled(n)).map((l) => {
      if (l.status === "rejected")
        throw new Error(`Step initialization failed: ${l.reason}`);
      return l.value;
    }), s = a.flatMap((l) => l?.command ? [l.command] : []), o = a.flatMap((l) => l?.followup ? [l.followup] : []);
    s && s.length > 0 && this.commandContext.apply(new Ii(s), !0);
    for (const l of o) await l();
    o.length > 0 && await this.ensureStepsAreLoaded(), this.onInitChange();
  }
  onConfirmChange() {
    this.confirmCallbacks.forEach((e) => e(this.confirmedDesign));
  }
  onEditedChange() {
    this.editedCallbacks.forEach((e) => e(this.editedSteps));
  }
  onElementsChange() {
    this.elementsCallbacks.forEach((e) => e(this.stepElements));
  }
  onInformationResultChange() {
    this.informationResultCallbacks.forEach((e) => e(this.informationResults));
  }
  onInitChange() {
    this.initCallbacks.forEach((e) => e(this.stepInitialised));
  }
  onMakingAdjustmentsChange() {
    this.makingAdjustmentsCallback.forEach((e) => {
      e(this.currentAdjustingStepId);
    });
  }
  onMandatoryChange() {
    this.mandatoryCallbacks.forEach((e) => e(this.mandatorySteps));
  }
  onMetadataChange() {
    this.metadataCallbacks.forEach((e) => {
      e(this.stepMetadata);
    });
  }
  async onSelectionChange() {
    const e = await this.traversableScenes();
    for (const t of this.selectionCallbacks)
      t({
        selectionCost: this.selectionCost,
        selections: this.stepSelections,
        traversableScenes: e
      });
  }
  onStepSpecificStorageChange(e) {
    Object.keys(this.stepSpecificStorageCallbacks).includes(e) || (this.stepSpecificStorageCallbacks[e] = []), this.stepSpecificStorageCallbacks[e].forEach((t) => t(this.storage[e]));
  }
  onStorageChange() {
    this.storageCallbacks.forEach((e) => e(this.storage));
  }
  onValidationChange() {
    this.validationCallbacks.forEach((e) => e(this.validationErrors));
  }
  traversableScenes() {
    return xU(this.allScenes, this.stepSelections, this.singleVariantsRenderable);
  }
  async reapplyMaterialSteps() {
    if (!this.modelContainer) return;
    const t = (await kl(this.allScenes, this.stepSelections)).flatMap((n) => n.renderableSteps).filter((n) => n.type === gt.Material);
    for (const n of t) {
      const i = this.stepSelections[n.stepName]?.selectedVariants;
      if (!i || i.length === 0) continue;
      const s = i[0].material;
      if (!s || !n.option?.id) continue;
      n.data.targetMaterials.forEach((l) => {
        this.modelContainer?.applyMaterialVariant(l, n.option.id, s);
      });
    }
  }
};
Np.configurationPromiseMap = /* @__PURE__ */ new Map();
let q1 = Np;
class Dl {
  constructor(e) {
    this.variantData = e;
  }
  getType() {
    return this.variantData.asset?.type;
  }
  /**
   * @returns The unique identifier for the variant.
   */
  getId() {
    return this.variantData.id;
  }
  /**
   * @returns The configured name of the variant. Generally a human readable value.
   */
  getName() {
    return this.variantData.name;
  }
  /**
   * @returns The price modifier for this variant. This is the amount that will be added to the base price of the product.
   */
  getPriceFormatted(e, t) {
    return this.variantData.priceModifier.toLocaleString(e || "en-US", {
      style: "currency",
      currency: "USD",
      ...t
    });
  }
  /**
   * @returns The price modifier for this variant. This is the amount that will be added to the base price of the product.
   *          Presented in subunits of the currency of the option. For example, if the option is configured to use USD, the price modifier will be in cents.
   */
  getPrice() {
    return this.variantData.priceModifier;
  }
  /**
   * @returns The URL for the base asset resource configured on this variant
   */
  getAsset() {
    return this.variantData.asset?.fileLink;
  }
  /**
   * @returns The URL for the base asset resource configured on this variant
   */
  getAssetResource() {
    return this.variantData.asset;
  }
  /**
   * @returns The URL for a thumbnail resource configured on this variant.
   */
  getThumbnail(e = 256, t) {
    const n = this.variantData.thumbnail;
    if (!(!n || !n.fileLink))
      return $w(n, e, "webp", t);
  }
  /**
   * @returns When this variant is configured to have a color, this will return the hex value for that color.
   */
  getColor() {
    return this.variantData.color;
  }
  /**
   * @returns True when the variant is the default for its containing option. False otherwise.
   */
  isDefault() {
    return !!this.variantData.default;
  }
  /**
   * @returns The underlying variant resource. Generally not needed but made available just in case.
   */
  getResource() {
    return this.variantData;
  }
  /**
   * @returns True when the variant is enabled. False otherwise.
   */
  isEnabled() {
    return this.variantData.enabled;
  }
  /**
   * @returns The category for grouping variants in an option.
   */
  getCategory() {
    return this.variantData.category;
  }
  /**
   * @returns The product associated with this variant.
   */
  getProduct() {
    return this.variantData.product;
  }
}
const Lp = class Lp {
  constructor(e, t, n) {
    this.manager = e, this.step = t, this.tags = n;
  }
  /**
   * Set the current update state of this step. All step handles pointing to this step will
   * see this value.
   * @param value The new value
   */
  setUpdateState(e) {
    Lp.updateState.set(
      `${this.step.stepName}-${this.manager.getWorkflowExperience().getTransaction().id}`,
      e
    );
  }
  /**
   * @returns Gets the current update state of this step. All step handles for this step will see this value.
   */
  getUpdateState() {
    return !!Lp.updateState.get(
      `${this.step.stepName}-${this.manager.getWorkflowExperience().getTransaction().id}`
    );
  }
  /**
   * Gets the currently selected variant, or undefined if no variant is selected.
   */
  getCurrentVariant() {
    const n = this.manager.getWorkflowSelections()[this.step.stepName]?.selections[0];
    if (n)
      return new Dl(n);
  }
  /**
   * @returns A list of valid variants for this step. Does not include disabled variants.
   */
  async getAvailableVariants() {
    return (await this.getAllVariants()).filter((t) => t.isEnabled()) || [];
  }
  /**
   * @returns A list of all variants for this step, including disabled ones.
   */
  async getAllVariants() {
    if (!this.step.option?.id) return [];
    if (this.step.option.variants)
      return (this.step.option.variants || []).map((t) => new Dl(t)) || [];
    const e = await Pt.getOption(this.step.option?.id);
    if (!e) throw new Error("Option not found, cannot fetch variants.");
    return (e.variants || []).map((t) => new Dl(t)) || [];
  }
  /**
   * @returns A unique identifier for this step within the workflow.
   */
  getId() {
    return this.step.stepName;
  }
  /**
   * @returns The name of the step
   */
  getName() {
    return this.step.stepTitle;
  }
  /**
   * @returns A message that can accompany the step name in UI components. Used to describe the purpose of the step in more detail.
   */
  getHelpText() {
    return this.step.helpText;
  }
  /**
   * @returns The type of the step handle.
   */
  getType() {
    return this.step.type;
  }
  /**
   * @returns The underlying data for this step. Favor using the step handle methods instead of this.
   */
  getRaw() {
    return this.step;
  }
  /**
   * @returns Returns all of the tags that are present on this step.
   */
  getTags() {
    return this.tags;
  }
  /**
   * @param tag The tag to check for.
   * @returns True if the step has the specified tag, false otherwise.
   */
  hasTag(e) {
    return this.tags.includes(e) || !1;
  }
  /**
   * @returns True if the step is required to be filled by the customer. False otherwise.
   */
  getMandatory() {
    return this.step.mandatory || !1;
  }
  /**
   * @param type The AspectType to fetch the value for.
   * @returns A boolean indicating whether this step should override Global Properties.
   * Only relevant when the Workflow Experience is associated with a Bundle that is using Global Properties,
   * and when this step is associated with one or more Global Property Aspects.
   */
  getOverrideGlobalPropertyConfiguration(e) {
    return (this.manager.getStepStorage(this.step.stepName)?.overrideGlobalConfigurations ?? {})[e.toString()] ?? !1;
  }
  /**
   * Sets whether or not this step should override Global Properties.
   * Only relevant when the Workflow Experience is associated with a Bundle that is using Global Properties,
   * and when this step is associated with one or more Global Property Aspects.
   * @param type The AspectType to override.
   */
  setOverrideGlobalPropertyConfiguration(e, t) {
    const n = this.manager.getStepStorage(this.step.stepName)?.overrideGlobalConfigurations ?? {};
    this.manager.updateStorage(this.step.stepName, {
      overrideGlobalConfigurations: { ...n, [e.toString()]: t }
    });
  }
  /**
   * Retrieves the identifiers of all of the configured aspects for the specified Global Property Configuration.
   * @param configurationId The ID of the Global Property Configuration. You can usually find this with `bundle.getGlobalPropertyConfiguration()?.id`
   * @returns An array of strings matching the keys of all the Global Property Aspects in the Configuration that this step is configured to use.
   */
  getGlobalPropertyAspects(e) {
    return this.step.globalPropertyAspectConfigurations?.filter((t) => t.globalPropertyConfigurationId === e && t.aspectName).map((t) => t.aspectName) ?? [];
  }
  /**
   * Fires any configured animations on the 3D preview for this step.
   * This includes camera & model animations. If the preview is unavailable
   * this function will do nothing.
   */
  executeAnimations(e) {
    const t = this.manager.getPreviewService(), n = this.manager.getModelContainer(), i = this.step.data.modelAnimation, a = this.step.data.lookAtAnimation;
    t ? a && t.executeCameraAnimation(a) : console.warn("No preview service available, cannot execute camera animations."), n ? i && n.executeAnimation(i, e) : console.warn("No model container available, cannot execute model animations.");
  }
};
Lp.updateState = /* @__PURE__ */ new Map();
let Fs = Lp;
class mj extends Fs {
  constructor(e, t, n) {
    super(e, t, n);
  }
  /**
   * Allows for select a vector from the available vectors configured on this steps base option.
   * @param variant The new vector variant to use for this step.
   * @returns A promise that can be awaited to know when the new vector asset has been updated on the design.
   */
  async selectVariant(e) {
    if (!this.getUpdateState() && this.getCurrentVariant() !== e)
      return Km.selectVariant(
        this.step,
        e.getResource(),
        this.manager.getRegionElements(this.step.stepName) || [],
        (t) => this.setUpdateState(t),
        this.manager
      );
  }
  /**
   * Get the colors that are in the illustration.
   * @returns A list of color definitions that are currently applied to the illustration.
   */
  getColors() {
    const e = this.manager.getRegionElements(this.step.stepName) || [];
    if (e.length === 0) return;
    let t;
    try {
      t = zi(e[0].id, this.manager.getAllLayoutData());
    } catch {
      return;
    }
    const n = t.colors, a = this.getCurrentVariant()?.getAssetResource()?.assetConfiguration, s = a?.defaultColorVariants || [];
    if (s.length !== 0) {
      const o = {};
      return s.forEach((l) => {
        const u = a.channelNumbers.find((c) => c.number === l.channelNumber);
        if (u) {
          const c = u.id.replace(/\W/g, "");
          o[l.channelNumber] = { browserValue: n[c]?.browserValue || "" };
        }
      }), o;
    }
    try {
      return n;
    } catch (o) {
      console.error(o);
    }
  }
  /**
   * Set color for the illustration.
   */
  setColor(e, t, n) {
    const i = /* @__PURE__ */ new Map(), s = this.getCurrentVariant()?.getAssetResource()?.assetConfiguration;
    return (s?.defaultColorVariants || []).length !== 0 ? s.channelNumbers.forEach((l) => {
      if (l.number.toString() === e) {
        const u = l.id.replace(/\W/g, "");
        n ? i.set(u, { browserValue: t, pmsValue: n }) : i.set(u, t);
      }
    }) : n ? i.set(e, { browserValue: t, pmsValue: n }) : i.set(e, t), Km.changeColors(
      this.step,
      this.manager.getRegionElements(this.step.stepName),
      this.manager,
      i
    );
  }
  async getColorOption() {
    return await Pt.ensureFullOption(this.step.data.colorOption);
  }
  getAvailableColors() {
    return this.step.data.colorPickerEnabled ? Km.availableColors(this.step, this.manager) : Promise.resolve([]);
  }
  isColorPickerEnabled() {
    return this.step.data.colorPickerEnabled ?? !1;
  }
  isPMSPickerEnabled() {
    return this.step.data.pmsPickerEnabled ?? !1;
  }
  isVariantSearchEnabled() {
    return this.step.data.enableVariantSearch ?? !1;
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
class vj extends Fs {
  constructor(e, t, n) {
    super(e, t, n);
  }
  selectVariant(e) {
    return $D.selectVariant(
      this.step,
      e.getResource(),
      this.manager,
      (t) => this.setUpdateState(t)
    );
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
class yj extends Fs {
  constructor(e, t, n) {
    super(e, t, n);
  }
  selectVariant(e) {
    return zD.selectVariant(
      this.step,
      e.getResource(),
      this.manager,
      (t) => this.setUpdateState(t)
    );
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
class Aj extends Fs {
  constructor(e, t, n) {
    super(e, t, n);
  }
  /**
   * Allows the user to select an image variant from the available variants configured on this steps base option.
   * @param variant The new image variant to use.
   * @returns A promise that can be awaited to ensure the new image asset has been updated on the design.
   */
  selectVariant(e) {
    return HD.selectVariant(
      this.step,
      e.getResource(),
      this.manager,
      (t) => this.setUpdateState(t)
    );
  }
  isVariantSearchEnabled() {
    return this.step.data.enableVariantSearch ?? !1;
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
class wj extends Fs {
  constructor(e, t, n) {
    super(e, t, n);
  }
  async selectVariant(e) {
    if (!e.getId())
      throw new Error("Unable to select variant with a null ID");
    await WD.selectVariant(this.step, e.getId(), this.manager);
  }
  /**
   * The way that this step expects to be rendered.
   */
  async getDisplayType() {
    return this.step.data.displayType ? this.step.data.displayType : (await Pt.getOptionForStep(this.step))?.displayType;
  }
}
class xj extends Fs {
  constructor(e, t, n) {
    super(e, t, n);
  }
  selectVariant(e) {
    const t = e.getResource();
    return xp.selectVariant(
      this.step,
      {
        fill: t.color,
        stroke: t.color,
        variant: t
      },
      this.manager.getRegionElements(this.step.stepName) || [],
      this.manager
    );
  }
  /**
   * Sets the color of the shape.
   * @param color The color option to use.
   * @returns A promise resolving when the color has changed in the design.
   * @deprecated The shape step can now pass through colors returned by getColors via selectVariant. Please swap setColor for selectVariant.
   */
  setColor(e) {
    return xp.selectVariant(
      this.step,
      e,
      this.manager.getRegionElements(this.step.stepName) || [],
      this.manager
    );
  }
  /**
   * Get available colors for the shape.
   * @returns A list of color definitions that are currently applied to the illustration.
   */
  getColors() {
    return xp.availableColours(this.step);
  }
  /**
   * Allows for setting a custom color when the custom variant is selected. Will
   * throw when a non-custom variant is selected.
   */
  setCustomColor(e) {
    return this.getCurrentVariant()?.getColor() !== "#custom" && console.warn(
      `setting custom color for step ${this.step.stepName} but color is ${this.getCurrentVariant()?.getColor()}`
    ), xp.setCustomColor(e, this.step, this.manager);
  }
  getCustomColor() {
    this.getCurrentVariant()?.getColor() !== "#custom" && console.warn(
      `setting custom color for step ${this.step.stepName} but color is ${this.getCurrentVariant()?.getColor()}`
    );
    const e = this.manager.getStepStorage(this.step.stepName)?.colour;
    if (!e)
      throw new Error(
        `Color not available on step ${this.step.stepName}. Set a default on the workflow to fix this.`
      );
    return e;
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
class bj extends Fs {
  constructor(e, t, n) {
    super(e, t, n);
  }
  /**
   * Allows for select a font from the available fonts configured on this steps base option.
   * @param variant The font variant to use.
   */
  async selectVariant(e) {
    await ca.selectVariant(
      this.step,
      e.getResource(),
      this.manager,
      (t) => {
        if (t)
          this.manager.setInformationResults([
            ...this.manager.getInformationResults(),
            {
              message: t,
              messageType: J0.Error,
              stepID: this.step.stepName
            }
          ]);
        else {
          const n = this.manager.getInformationResults().filter((i) => i.stepID !== this.step.stepName);
          this.manager.setInformationResults(n);
        }
      },
      () => {
      }
    );
  }
  /**
   * @returns A list of colors that can be used to fill the text.
   */
  async getAvailableFillColors() {
    return this.step.data.colorPickerEnabled ? ca.availableFillColors(this.step) : [];
  }
  /**
   * Changes the fill of text related to this step to the new fill value.
   * @param fill A new fill value to use.
   */
  async setFillColor(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    await ca.changeFillColor(this.step, e, t, this.manager);
  }
  /**
   * Gets the color currently applied to the element.
   */
  getFillColor() {
    return this.manager.getStepStorage(this.step.stepName)?.color || "#000000";
  }
  getAvailableFillImages() {
    return ca.availableFillImages(this.step);
  }
  async setFillImage(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    await ca.changeFillImage(this.step, e, t, this.manager);
  }
  getFillImage() {
    return this.manager.getStepStorage(this.step.stepName)?.fillImage;
  }
  getAlignment() {
    return ca.findLayoutElements(this.manager, this.step)?.[0].align;
  }
  setAlignment(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    ca.changeAlignment(this.step, e, t, this.manager);
  }
  /**
   * When true & the step has replaceable text configured the user will be
   * abled to edit the entire text string including the non-replaceable text.
   * @param shouldCustomizeAll When true the user can configure the entire text string.
   */
  setFullTextCustomization(e) {
    const t = this.manager.getStepStorage(this.step.stepName)?.inputText || "", n = this.step.data.replaceableText !== void 0 ? this.step.data.replaceableText.replace("{{}}", t) : t, i = e ? n : this.step.data.defaultText;
    return this.manager.updateStorage(this.step.stepName, {
      customiseAllText: e,
      text: i,
      defaultCleared: !1
    }), this.setText(i);
  }
  /**
   * Changes the text value of text related to this step to a new value.
   * @param userInput Input from the user.
   */
  setText(e) {
    const t = {
      input: e,
      helperData: {}
    }, n = ca.findLayoutElements(this.manager, this.step), i = ca.filterUnsupportedCharacters(e, n[0]?.fontData), a = Od(i, this.manager).length, s = !!this.step.data && !!this.step.data.maxLength && a > this.step.data.maxLength;
    s || (t.input = i);
    const o = n.length <= 0, l = o ? { inputText: i, text: i } : { inputText: i };
    this.manager.updateStorage(this.step.stepName, l);
    const u = this.manager.getStepStorage(this.step.stepName), c = ca.getProcessedInput(
      i,
      this.step.data,
      u?.customiseAllText ?? !1
    );
    if (o)
      s || this.manager.updateMetadata(this.step.stepName, {
        text: c
      });
    else {
      const { command: h, errorData: f, helperData: p } = ca.updateInputText(
        i,
        n,
        this.step,
        this.manager
      );
      h && this.manager.getCommandDispatcher()(h), t.helperData = p, t.errorData = f, !s && !f && this.manager.updateMetadata(this.step.stepName, {
        text: c
      });
    }
    return t;
  }
  /**
   * Gets the text currently applied to the elements of this step.
   */
  getText() {
    const e = this.step.data.defaultText, t = this.manager.getStepStorage(this.step.stepName);
    return e && t?.defaultCleared !== void 0 && !t?.defaultCleared ? e : this.manager.getStepStorage(this.step.stepName)?.text || "";
  }
  isReplaceable() {
    return this.step.data.userCanReplaceText;
  }
  /**
   * @returns True if the step allows new lines in the text input.
   */
  newLinesSupported() {
    return this.step.data.allowNewlines || !1;
  }
  /**
   * Inform the step that now is the time to
   * clear default text if it should do so.
   * Returns a text change rwsult if a clear occurred.
   */
  clearDefaultTextIfNecessary() {
    if (!this.manager.getStepStorage(this.step.stepName)?.defaultCleared && this.step.data.deleteDefaultOnFocus) {
      const t = this.setText("");
      this.manager.updateStorage(this.step.stepName, { defaultCleared: !0, inputText: "" });
      const n = ca.findLayoutElements(this.manager, this.step);
      return ca.updateInputText("", n, this.step, this.manager), t;
    }
  }
  hasColorPicker() {
    return this.step.data.colorPickerEnabled;
  }
  getRegions() {
    return this.step.data.regions;
  }
  /**
   * Return the maximum characters allowed for
   * this step, or undefined if there is no limit.
   */
  getCharacterLimit() {
    return this.step.data.maxLength;
  }
  /**
   * Return the remaining amount of characters that
   * the user is allowed to add, or undefined if there is no limit.
   */
  getCharactersRemaining() {
    const e = this.step.data.maxLength;
    if (e === void 0)
      return;
    const t = Od(this.getText(), this.manager);
    return e - t.length;
  }
  setCustomColor(e) {
    this.getFillColor() !== "#custom" && console.warn(`setting custom color for text step ${this.step.stepName} but current fill is not #custom`);
    const t = this.manager.getRegionElements(this.step.stepName);
    ca.applyCustomFillColor(this.step, e, t, this.manager);
  }
  getCustomColor() {
    return this.manager.getStepStorage(this.step.stepName)?.customColor || "#000000";
  }
  /**
   * @returns A list of colors that can be used for the text's outline.
   */
  async getAvailableStrokeColors() {
    return this.step.data.strokeEnabled ? ca.availableStrokeColors(this.step) : [];
  }
  getStrokeColor() {
    return this.manager.getStepStorage(this.step.stepName)?.strokeColor?.browserValue || "#000000";
  }
  /**
   * Changes the stroke of text related to this step to the new stroke value.
   * @param stroke A new stroke value to use.
   */
  async setStrokeColor(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    await ca.changeStrokeColor(this.step, e, t, this.manager);
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
class Cj extends Fs {
  constructor(e, t, n) {
    super(e, t, n);
  }
  async selectVariant() {
  }
  /**
   * The way that this step expects to be rendered.
   */
  getContent() {
    return this.step.data.content;
  }
}
class Sj extends Fs {
  constructor(e, t, n) {
    super(e, t, n);
  }
  async selectVariant() {
  }
  /**
   * Returns a preview URL used to show the generated QR code in your UI.
   */
  getPreviewURL() {
    return this.manager.getStepStorage(this.step.stepName)?.videoUrl || "";
  }
  /**
   * Turns an asset into a QR code that can be used to access the content.
   * @param asset The asset to use for the QR code.
   * @returns The final URL string for the QR code.
   */
  async selectVideo(e) {
    return VD.regenerateQRCode(
      this.manager.getRegionElements(this.step.stepName),
      e.key,
      this.manager,
      this.step
    );
  }
}
class Ej extends Fs {
  constructor(e, t, n) {
    super(e, t, n);
  }
  async selectVariant() {
    console.info("Text Modules don't support variants.");
  }
  /**
   * Return the remaining amount of characters that
   * the user is allowed to add, or undefined if there is no limit.
   */
  getCharactersRemaining() {
    const e = this.step.data.maxLength;
    if (e === void 0)
      return;
    const t = Od(this.getText(), this.manager);
    return e - t.length;
  }
  /**
   * Return the maximum characters allowed for
   * this step, or undefined if there is no limit.
   */
  getCharacterLimit() {
    return this.step.data.maxLength;
  }
  getText() {
    return this.manager.getStepStorage(this.step.stepName)?.text || "";
  }
  setText(e) {
    GD.changeText(this.step, e, this.manager, (t) => {
      if (t) {
        const n = [
          ...this.manager.getInformationResults(),
          {
            message: t,
            messageType: J0.Error,
            stepID: this.step.stepName
          }
        ];
        this.manager.setInformationResults(n);
      } else {
        const n = this.manager.getInformationResults().filter((i) => i.stepID !== this.step.stepName);
        this.manager.setInformationResults(n);
      }
    });
  }
}
class kj extends Fs {
  constructor(e, t, n) {
    super(e, t, n);
  }
  async selectVariant() {
  }
  async getAvailableVariants() {
    const e = await super.getAvailableVariants();
    if (!this.cachedProductIds) {
      this.cachedProductIds = /* @__PURE__ */ new Set();
      for (const t of e) {
        const n = t.getProduct();
        n?.id && this.cachedProductIds.add(n.id);
      }
    }
    return e;
  }
  /**
   * Whether a product's variant has an associated workflow (is personalisable).
   */
  isPersonalisable(e) {
    const t = e.getProduct();
    return !!t?.workflows && t.workflows.length > 0;
  }
  async addProduct(e) {
    const t = this.manager.getWorkflowExperience().getBundle();
    if (!t)
      throw new Error("Product step requires bundle context");
    const n = e.getProduct();
    if (!n)
      throw new Error("Variant has no product. Ensure the option query includes the product field on variants.");
    if (!this.isPersonalisable(e)) {
      await this.incrementNonPersonalisable(e);
      return;
    }
    const i = this.manager.getWorkflowExperience().getTransaction(), a = i.integrationProduct?.integration?.id;
    let s;
    if (a && n.integrationProducts && (s = n.integrationProducts.find(
      (f) => f.integration?.id === a
    )?.id), !s)
      throw new Error("No integration product found for bundle context");
    const o = this.manager.getClient(), l = n?.workflows || [];
    let u;
    if (l.length === 1)
      u = l[0].id;
    else if (l.length > 1) {
      const h = this.step.data.workflows, f = l.find((p) => h.includes(p.id));
      if (f)
        u = f.id;
      else
        throw new Error("Multiple workflows available but none match step configuration");
    }
    const c = await o.getWorkflowExperience({
      type: "integration",
      integrationProductId: s,
      workflowId: u,
      parentTransactionId: i.id
    });
    await t.addWorkflowExperience(c);
  }
  /**
   * For non-personalisable products: if a transaction already exists for this product,
   * increment its quantity. Otherwise create a new transaction with quantity 1.
   */
  async incrementNonPersonalisable(e) {
    const t = this.manager.getWorkflowExperience().getBundle();
    if (!t) return;
    const n = e.getProduct(), i = this.findExperienceForProduct(n.id);
    if (i) {
      const c = i.getTransaction().quantity || 1;
      await i.setQuantity(c + 1);
      return;
    }
    const a = this.manager.getWorkflowExperience().getTransaction(), s = a.integrationProduct?.integration?.id;
    let o;
    if (s && n.integrationProducts && (o = n.integrationProducts.find(
      (h) => h.integration?.id === s
    )?.id), !o)
      throw new Error("No integration product found for bundle context");
    const u = await this.manager.getClient().getWorkflowExperience({
      type: "integration",
      integrationProductId: o,
      parentTransactionId: a.id
    });
    await t.addWorkflowExperience(u);
  }
  async removeProduct(e) {
    const t = this.manager.getWorkflowExperience().getBundle();
    if (!t)
      throw new Error("Product step requires bundle context");
    const i = t.getWorkflowExperiences().find((o) => o.getTransaction().id === e);
    if (!i)
      throw new Error("Transaction is not a child of this product step");
    const a = i.getTransaction(), s = a.quantity || 1;
    if (s > 1) {
      await i.setQuantity(s - 1);
      return;
    }
    await t.removeWorkflowExperienceByTransaction(a);
  }
  /**
   * Whether category filtering is enabled.
   */
  isCategoryFilterEnabled() {
    return this.step.data.categoryFilterEnabled ?? !1;
  }
  /**
   * Whether search bar is enabled.
   */
  isSearchBarEnabled() {
    return this.step.data.searchBarEnabled ?? !1;
  }
  /**
   * Get minimum number of products required.
   */
  getMin() {
    return this.step.data.min;
  }
  /**
   * Get maximum number of products allowed.
   */
  getMax() {
    return this.step.data.max;
  }
  /**
   * Get pricing configuration.
   */
  getPricing() {
    return this.step.data.pricing;
  }
  /**
   * Get associated workflow IDs.
   */
  getWorkflows() {
    return this.step.data.workflows || [];
  }
  /**
   * Get child transactions that belong to this step specifically.
   * Filters by parent transaction AND by products available in this step's option.
   */
  getChildTransactions() {
    const e = this.manager.getWorkflowExperience().getBundle();
    if (!e)
      return [];
    const t = this.manager.getWorkflowExperience().getTransaction().id, n = e.getWorkflowExperiences(), i = this.getStepProductIds();
    return n.map((a) => a.getTransaction()).filter((a) => a.parentTransaction?.id !== t || i.size === 0 ? !1 : a.product?.id ? i.has(a.product.id) : !1);
  }
  /**
   * Get the set of product IDs that belong to this step's option.
   * Uses cached data from getAvailableVariants() which has full product info.
   */
  getStepProductIds() {
    if (this.cachedProductIds && this.cachedProductIds.size > 0)
      return this.cachedProductIds;
    const e = this.step.option?.variants || [], t = /* @__PURE__ */ new Set();
    for (const n of e)
      n.product?.id && t.add(n.product.id);
    return t;
  }
  /**
   * Get locked add-ons configured on this product step.
   */
  getLockedAddOns() {
    return this.step.data.lockedAddOns || [];
  }
  /**
   * Find an existing WorkflowExperience for a given product ID within this step's children.
   */
  findExperienceForProduct(e) {
    const t = this.manager.getWorkflowExperience().getBundle();
    if (!t) return;
    const n = this.manager.getWorkflowExperience().getTransaction().id, i = this.getStepProductIds();
    return t.getWorkflowExperiences().find((a) => {
      const s = a.getTransaction();
      return s.parentTransaction?.id !== n || i.size > 0 && !i.has(e) ? !1 : s.product?.id === e;
    });
  }
}
class Em {
  static get(e, t) {
    switch (t.type) {
      case gt.DigitalContent:
        return new Sj(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      case gt.Information:
        return new Cj(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      case gt.Question:
        return new wj(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      case gt.Text:
        return new bj(e, t, e.getStepTags(t.stepName));
      case gt.Illustration:
        return new mj(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      case gt.Picture:
        return new Aj(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      case gt.Shape:
        return new xj(e, t, e.getStepTags(t.stepName));
      case gt.Material:
        return new vj(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      case gt.Model:
        return new yj(e, t, e.getStepTags(t.stepName));
      case gt.Frame:
        return new Zte(e, t, e.getStepTags(t.stepName));
      case gt.Module:
        return new Ej(e, t, e.getStepTags(t.stepName));
      case gt.Product:
        return new kj(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      default:
        throw new si(`Step type ${t.type} not yet supported in Core SDK`);
    }
  }
}
var fA, iT;
function Tj() {
  if (iT) return fA;
  iT = 1;
  var r = 1 / 0, e = 9007199254740991, t = 17976931348623157e292, n = NaN, i = "[object Function]", a = "[object GeneratorFunction]", s = "[object Symbol]", o = /^\s+|\s+$/g, l = /^[-+]0x[0-9a-f]+$/i, u = /^0b[01]+$/i, c = /^0o[0-7]+$/i, h = /^(?:0|[1-9]\d*)$/, f = parseInt, p = Object.prototype, m = p.toString, A = Math.ceil, w = Math.max;
  function x(ae, ye, Se) {
    var Xe = -1, Ve = ae.length;
    ye < 0 && (ye = -ye > Ve ? 0 : Ve + ye), Se = Se > Ve ? Ve : Se, Se < 0 && (Se += Ve), Ve = ye > Se ? 0 : Se - ye >>> 0, ye >>>= 0;
    for (var He = Array(Ve); ++Xe < Ve; )
      He[Xe] = ae[Xe + ye];
    return He;
  }
  function E(ae, ye) {
    return ye = ye ?? e, !!ye && (typeof ae == "number" || h.test(ae)) && ae > -1 && ae % 1 == 0 && ae < ye;
  }
  function T(ae, ye, Se) {
    if (!te(Se))
      return !1;
    var Xe = typeof ye;
    return (Xe == "number" ? _(Se) && E(ye, Se.length) : Xe == "string" && ye in Se) ? F(Se[ye], ae) : !1;
  }
  function D(ae, ye, Se) {
    (Se ? T(ae, ye, Se) : ye === void 0) ? ye = 1 : ye = w(q(ye), 0);
    var Xe = ae ? ae.length : 0;
    if (!Xe || ye < 1)
      return [];
    for (var Ve = 0, He = 0, le = Array(A(Xe / ye)); Ve < Xe; )
      le[He++] = x(ae, Ve, Ve += ye);
    return le;
  }
  function F(ae, ye) {
    return ae === ye || ae !== ae && ye !== ye;
  }
  function _(ae) {
    return ae != null && Z(ae.length) && !L(ae);
  }
  function L(ae) {
    var ye = te(ae) ? m.call(ae) : "";
    return ye == i || ye == a;
  }
  function Z(ae) {
    return typeof ae == "number" && ae > -1 && ae % 1 == 0 && ae <= e;
  }
  function te(ae) {
    var ye = typeof ae;
    return !!ae && (ye == "object" || ye == "function");
  }
  function de(ae) {
    return !!ae && typeof ae == "object";
  }
  function H(ae) {
    return typeof ae == "symbol" || de(ae) && m.call(ae) == s;
  }
  function j(ae) {
    if (!ae)
      return ae === 0 ? ae : 0;
    if (ae = re(ae), ae === r || ae === -r) {
      var ye = ae < 0 ? -1 : 1;
      return ye * t;
    }
    return ae === ae ? ae : 0;
  }
  function q(ae) {
    var ye = j(ae), Se = ye % 1;
    return ye === ye ? Se ? ye - Se : ye : 0;
  }
  function re(ae) {
    if (typeof ae == "number")
      return ae;
    if (H(ae))
      return n;
    if (te(ae)) {
      var ye = typeof ae.valueOf == "function" ? ae.valueOf() : ae;
      ae = te(ye) ? ye + "" : ye;
    }
    if (typeof ae != "string")
      return ae === 0 ? ae : +ae;
    ae = ae.replace(o, "");
    var Se = u.test(ae);
    return Se || c.test(ae) ? f(ae.slice(2), Se ? 2 : 8) : l.test(ae) ? n : +ae;
  }
  return fA = D, fA;
}
var Fj = Tj();
const Q1 = /* @__PURE__ */ Iu(Fj), Ij = Oe`
    fragment CreateDesignTransaction on Transaction {
        id
        designName
        externalCartProductId
        externalCartProductVariantId
        externalDesignProductId
        externalDesignProductVariantId
        lastSyncedAt
        quantity
        previewImageLink
        priceModifierTotal
        workflowViewerLink
        workflowViewerReadOnlyLink
        integrationProduct {
            id
            additionalExternalProductId
            additionalExternalVariantId
        }
        designExternalVariants {
            id
            externalProductId
            externalProductVariantId
        }
    }
`, Pj = Oe`
    ${Ij}
    mutation CreateDesigns($inputs: [DesignCreateInput]!) {
        designCreateMany(inputs: $inputs) {
            id
            sku
            transaction {
                ...CreateDesignTransaction
            }
            processExecution {
                id
            }
        }
    }
`;
function k0(r) {
  const e = JSON.parse(atob(r.split(".")[1])).exp;
  return Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3) >= e;
}
const Dj = async (r, e) => {
  const t = {};
  try {
    if (e) {
      const i = await e.loggedInBearerToken();
      t.Authorization = `Bearer ${i}`;
    } else
      throw new Error();
  } catch {
    const s = Object.entries(localStorage).find(([l, u]) => l.startsWith("CognitoIdentityServiceProvider") && l.endsWith("idToken"))?.[0] || "", o = localStorage.getItem(s);
    o && !k0(o) && (t.Authorization = `Bearer ${o}`);
  }
  return await e.getBetaEnabled() && (t["X-Spiff-Beta"] = "true"), (await et.getShadowGraphqlClient().mutate({
    mutation: Pj,
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    variables: {
      inputs: r.map((i) => ({
        name: i.name,
        layouts: i.layouts,
        workflowId: i.workflowId,
        transactionId: i.transactionId,
        previewImage: i.previewImage,
        useThreeDimPreview: i.useThreeDimPreview,
        metadata: i.metadata,
        selectedVariants: i.selectedVariants
      }))
    },
    context: {
      headers: t
    }
  })).data?.designCreateMany;
}, aT = (r, e, t) => {
  const n = (a) => {
    const s = {};
    if (a.type === "Frame") {
      const o = r[a.stepName], l = a.data;
      if (!o || !o.image || l.hideImageInCart && t)
        return s;
      s[`${a.stepTitle} image`] = o.image;
    }
    if (a.type === "Illustration") {
      const o = r[a.stepName], l = a.data;
      if (!o || l.hideColorsInCart && t || !o.colors)
        return s;
      if (o.colors.length > 0) {
        const u = o.colors.join(", ").toUpperCase();
        s[`${a.stepTitle} colors`] = u;
      }
    }
    if (a.type === "Module") {
      const o = r[a.stepName], l = a.data;
      if (!o || o.text === void 0 || o.text === null || l.hideTextInCart && t)
        return s;
      s[`${a.stepTitle} text`] = o.text;
    }
    if (a.type === "Text") {
      const o = r[a.stepName];
      if (!o)
        return s;
      const l = a.data;
      (!l.hideTextInCart || !t && o.text !== void 0 && o.text !== null) && (s[`${a.stepTitle} text`] = o.text), o.color && (!l.hideColorInCart || !t) && (s[`${a.stepTitle} color`] = o.color), o.strokeColor && (!l.hideStrokeInCart || !t) && (s[`${a.stepTitle} stroke`] = o.strokeColor);
    }
    return s;
  }, i = {};
  return e.steps.forEach((a) => {
    Object.assign(i, n(a));
  }), i;
}, Rj = (r, e, t, n) => {
  const i = {};
  let a = {};
  n && (a = n);
  const o = e.steps.map((l) => l.stepTitle).filter((l, u, c) => c.indexOf(l) == u);
  for (const l of o) {
    if (Object.keys(r).includes(l)) {
      const u = r[l], c = e.steps.find((h) => h.stepTitle === l);
      i[`${c?.stepTitle} selection`] = {
        value: u[0].name,
        priceModifier: u[0].priceModifier
      };
    }
    for (const u of Object.keys(a))
      [`${l} color`, `${l} colors`, `${l} text`, `${l} image`].includes(u) && (i[u] = {
        value: a[u],
        priceModifier: 0
      });
  }
  return i;
}, Oj = (r, e, t, n, i, a, s, o) => {
  const l = e.basePrice || 0, u = r.priceModifierTotal || 0, c = Rj(n, t, void 0, a), f = (hn.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(r.id), p = {
    additionalExternalProductId: r.integrationProduct?.additionalExternalProductId,
    additionalExternalVariantId: r.integrationProduct?.additionalExternalVariantId,
    baseCost: l,
    designExternalVariants: r.designExternalVariants,
    designProductId: r.externalDesignProductId,
    designProductVariantId: r.externalDesignProductVariantId,
    event: "onComplete",
    exportedData: c,
    externalCartProductId: r.externalCartProductId,
    externalCartProductVariantId: r.externalCartProductVariantId,
    lineItemImageUrl: s || "",
    optionsCost: u,
    processExecutionId: o,
    quantity: r.quantity,
    transactionId: r.id,
    transactionOwnerId: f,
    weight: e.weight,
    workflowViewerLink: r.workflowViewerLink || "",
    workflowViewerReadOnlyLink: r.workflowViewerReadOnlyLink || ""
  };
  return a && (p.metadata = a), n && (p.selectedVariants = n), i && (p.sku = i), p;
}, Bj = (r) => {
  const e = r.integrationProductId || r.integrationProduct?.id, t = r.integrationProduct;
  if (t?.externalProductId && t?.externalVariantId)
    return t;
  if (e && r.product?.integrationProducts) {
    const n = r.product.integrationProducts.find((i) => i.id === e);
    if (n)
      return { ...t, ...n };
  }
  return t;
}, ZD = (r) => {
  const e = Bj(r);
  return {
    id: r.id,
    externalProductId: r.externalCartProductId || r.externalDesignProductId || e?.externalProductId || e?.additionalExternalProductId,
    externalProductVariantId: r.externalCartProductVariantId || r.externalDesignProductVariantId || e?.externalVariantId || e?.additionalExternalVariantId
  };
}, _j = async (r) => {
  const e = [
    ...new Set(
      r.filter((i) => {
        const a = ZD(i);
        return !a.externalProductId || !a.externalProductVariantId;
      }).map((i) => i.integrationProductId || i.integrationProduct?.id).filter((i) => !!i)
    )
  ];
  if (e.length === 0)
    return;
  const t = await fO(e), n = new Map(t.map((i) => [i.id, i]));
  for (const i of r) {
    const a = i.integrationProductId || i.integrationProduct?.id;
    if (!a)
      continue;
    const s = n.get(a);
    s && (i.integrationProduct = { ...i.integrationProduct, ...s }, s.product && (i.product = { ...i.product, ...s.product }));
  }
}, Mj = (r, e) => {
  for (const t of e) {
    const n = t.parentTransaction?.id;
    if (!n)
      continue;
    const i = r.get(n);
    if (!i)
      throw new Error(
        `SpiffCommerce - Unable to attach product-step extra to parent - parent message not found: ${n}`
      );
    const a = t.quantity || 1, s = ZD(t);
    if (!s.externalProductId || !s.externalProductVariantId)
      throw new Error(
        `SpiffCommerce - Product-step extra is missing external product identifiers (transaction: ${t.id})`
      );
    const o = i.designExternalVariants || [];
    i.designExternalVariants = [
      ...o,
      ...Array.from({ length: a }, () => ({ ...s }))
    ];
  }
}, Nj = async (r, e, t, n, i, a, s, o, l, u) => {
  u && (console.warn("State mismatch detected. Uploading known state explicitly"), console.warn("State Object:", JSON.stringify(n())), await r.updateStateWithServerImmediate(n), console.log("Server state is undefined @ Workflow completion"));
  const c = r.getPreviewService(), h = e?.finalizeStepConfig?.lookAtAnimation, f = c && e.showModelOnFinishStep && !!h, p = l && aT(l, e, !0), m = l && aT(l, e, !1), A = async (_) => {
    const L = {};
    let Z = 0;
    if (Object.keys(a).length > 0)
      for (const te of Object.keys(a)) {
        const de = a[te], H = e.steps.find((j) => j.stepName === te);
        for (let j = 0; j < de.selections.length; ++j) {
          const q = de.selections[j];
          if (H) {
            const re = await Pt.getOptionForStep(H);
            if (!_ || re && (re.variants || []).length > 1 && !H.data.hideSelectionInCart && !H.data.hideSelectionsInCart) {
              const ae = H.stepTitle;
              L[ae] ? L[ae].push({
                id: q.id || "",
                name: q.name,
                priceModifier: q.priceModifier
              }) : L[ae] = [
                {
                  id: q.id || "",
                  name: q.name,
                  priceModifier: q.priceModifier
                }
              ];
            }
          }
          Z += q.priceModifier;
        }
      }
    return [L, Z];
  }, [w] = await A(!0), x = Object.fromEntries(
    Object.keys(w).map((_) => [_, w[_].map((L) => L.id)])
  ), [E] = await A(!1), T = Object.fromEntries(
    Object.keys(E).map((_) => [
      _,
      E[_].map((L) => L.id)
    ])
  );
  let D = await o(f, i.id);
  if (D) {
    const _ = await (await Ll(D)).blob();
    D = (await Si.uploadAsset(
      { name: `${i.id}-preview-image.png`, blob: _ },
      u0.Image,
      !0,
      !1
    )).fileLink;
  }
  return {
    designDetails: (() => {
      const _ = {
        name: s,
        layouts: t.map((L) => ({
          index: L.index,
          panelId: L.panelId
        })),
        workflowId: e.id,
        transactionId: i.id,
        useThreeDimPreview: !!f,
        previewImage: D
      };
      if (m) {
        const L = [];
        for (const [Z, te] of Object.entries(m))
          L.push({ key: Z, value: te });
        _.metadata = L;
      }
      if (x) {
        const L = [];
        for (const [Z, te] of Object.entries(T))
          L.push({ key: Z, ids: te });
        _.selectedVariants = L;
      }
      return _;
    })(),
    cartSelectionsWithPrices: w,
    cartMetadata: p
  };
}, eR = async (r, e) => {
  await Promise.all(
    r.map(async (o) => {
      await o.workflowManager.outstandingRequestsPromise();
    })
  );
  const n = await (async () => {
    const o = et.getShadowGraphqlClient(), l = await Promise.all(
      r.map(async (f) => ({
        id: f.transaction.id,
        hash: await f.workflowManager.getStateHash()
      }))
    ), c = Q1(l, 100), h = [];
    for (const f of c) {
      const p = await o.query({
        query: IL,
        variables: {
          transactions: f
        },
        fetchPolicy: "no-cache",
        errorPolicy: "all"
      });
      if (p.errors && p.errors.length > 0)
        return l.map((m) => m.id);
      h.push(...p.data?.transactionConfirmWorkflowStates ?? []);
    }
    return h;
  })(), i = await Promise.all(
    r.map(async (o) => await Nj(
      o.workflowManager,
      o.workflow,
      o.layouts,
      o.getReducerState,
      o.transaction,
      o.workflowSelections,
      o.designName,
      e ?? (() => Promise.resolve(void 0)),
      o.workflowMetadata,
      n.includes(o.transaction.id)
    ))
  ), a = r[0].workflowManager.getClient(), s = await Dj(
    i.map((o) => o.designDetails),
    a
  );
  if (!s)
    throw new Error("Failed to create designs");
  return s.map((o, l) => {
    const u = r[l], c = i[l], h = o.transaction;
    return Oj(
      h,
      u.product,
      u.workflow,
      c.cartSelectionsWithPrices,
      o.sku,
      c.cartMetadata,
      h.previewImageLink,
      o.processExecution?.id
    );
  });
};
class Lj {
  constructor() {
    this.localPersistenceKey = "designTransactions", this.storageMethod = "Local", this.designSavedListeners = [];
  }
  /**
   * @param func The function to call when a design is saved.
   */
  attachSaveListener(e) {
    this.designSavedListeners.push(e);
  }
  /**
   * @param func The function to remove from the list of listeners.
   */
  detachSaveListener(e) {
    this.designSavedListeners = this.designSavedListeners.filter((t) => t !== e);
  }
  /**
   * Gets the currently persisted designs.
   */
  async getSavedDesigns() {
    if (this.storageMethod === "Local") {
      const e = hn.get(this.localPersistenceKey);
      return e ? JSON.parse(e) : [];
    }
    throw new si("Unexpected storage method requested");
  }
  /**
   * Search for a transaction that has been saved.
   * @param transactionId The id to search for.
   * @returns The transaction for the given id provided it has been saved. undefined if it doesn't exist.
   */
  async getSavedDesignByTransaction(e) {
    return (await this.getSavedDesigns()).find((n) => n.transactionId === e);
  }
  /**
   * Saves a design to storage.
   * @param design The design to save.
   */
  async addDesign(e) {
    const n = (await this.getSavedDesigns()).filter((i) => i.transactionId !== e.transactionId);
    n.unshift(e), await this.setDesigns(n), this.designSavedListeners.forEach((i) => i(e));
  }
  /**
   * Change the user's name of the given saved design.
   */
  async renameDesign(e, t) {
    const n = await this.getSavedDesigns(), i = n.find((a) => a.transactionId === e);
    if (!i)
      throw new Error(`No saved design for transaction ${e}.`);
    i.title = t, await this.setDesigns(n);
  }
  /**
   * Removes a given design from storage.
   * @param transactionId
   */
  async removeDesign(e) {
    const t = await this.getSavedDesigns();
    await this.setDesigns(t.filter((n) => n.transactionId !== e));
  }
  async setDesigns(e) {
    if (this.storageMethod === "Local") {
      hn.set(this.localPersistenceKey, JSON.stringify(e));
      return;
    }
    throw new si("Unexpected storage method requested");
  }
}
const dA = new Lj(), Uj = Oe`
    mutation AddTransactionStakeholder($id: String!, $type: String!, $details: CustomerDetailsInput!) {
        transactionAddStakeholder(id: $id, details: $details, type: $type) {
            id
            stakeholders {
                id
                type
                customer {
                    id
                    emailAddress
                }
            }
        }
    }
`, Vj = Oe`
    mutation AddStakeholderToAllTransactions($ids: [String!]!, $type: String!, $details: CustomerDetailsInput!) {
        transactionsAddStakeholder(ids: $ids, details: $details, type: $type) {
            id
            stakeholders {
                id
                type
                customer {
                    id
                    emailAddress
                }
            }
        }
    }
`, $j = Oe`
    mutation AddAddressToTransaction(
        $transactionId: String!
        $streetAddress: String
        $apartment: String
        $city: String
        $country: String
        $state: String
        $postCode: String
    ) {
        addressAttachToTransaction(
            transactionId: $transactionId
            streetAddress: $streetAddress
            apartment: $apartment
            city: $city
            country: $country
            state: $state
            postCode: $postCode
        ) {
            id
        }
    }
`, zj = Oe`
    mutation AddOrganizationToTransaction($transactionId: String!, $organizationName: String!) {
        organizationAttachToTransaction(transactionId: $transactionId, organizationName: $organizationName) {
            id
        }
    }
`, sT = Oe`
    ${fg}
    ${dg}
    mutation TransactionUpdateIntegrationProduct($id: String!, $integrationProductId: String) {
        transactionUpdateIntegrationProduct(id: $id, integrationProductId: $integrationProductId) {
            id
            integrationProduct {
                id
                externalProductId
                externalVariantId
                additionalExternalProductId
                additionalExternalVariantId
            }
            product {
                id
                basePrice
                enabled
                minimumOrderQuantity
                name
                description
                partner {
                    id
                    name
                    currencyCode
                    customerDetailsPromptMarkdown
                }
                productImages {
                    id
                    precedence
                    asset {
                        key
                        fileLink
                        name
                        type
                    }
                }
                integrationProducts {
                    id
                    integration {
                        id
                        type
                    }
                    externalProductId
                    externalVariantId
                    additionalExternalProductId
                    additionalExternalVariantId
                    additionalIntegrationProduct {
                        ...AdditionalIntegrationProductFields
                    }
                }
                profanities {
                    id
                    word
                }
                sku
                skuCode
                weight
                workflows {
                    id
                    friendlyName
                    isPresent
                    workflowName
                    imageUrl
                    panelPreviews {
                        panelId
                        imageUrl
                        region {
                            width
                            height
                            top
                            left
                            rotation
                        }
                    }
                }
                imageUrl
                modelUrl
                overlayImageUrl
                preloadImageUrl
                promptForCustomerDetails
                conversionConfiguration {
                    ...ConversionConfigurationFields
                }
                productTags {
                    id
                    name
                }
                priceBreaks {
                    id
                    minQty
                    percentage
                }
            }
        }
    }
`;
var Y1 = /* @__PURE__ */ ((r) => (r.PriceBreakChanged = "PriceBreakChanged", r.ProductChanged = "ProductChanged", r.QuantityChanged = "QuantityChanged", r.RecipientChanged = "RecipientChanged", r.SelectionChanged = "SelectionChanged", r.WorkflowConfigurationChanged = "WorkflowConfigurationChanged", r))(Y1 || {});
class tR {
  constructor(e, t) {
    this.cachedStepHandles = /* @__PURE__ */ new Map(), this.profanityList = [], this.currentPriceBreak = 1, this.renderableScenes = [], this.renderableSceneCallbacks = [], this.eventCallbacks = /* @__PURE__ */ new Map(), this.debouncedSavedDesignUpdate = W0(async () => {
      await dA.getSavedDesignByTransaction(this.getTransaction().id) && this.save();
    }, 2500), this.getCanvasObjectURLAsync = async (n) => new Promise((i, a) => {
      try {
        n.toBlob((s) => {
          if (s) {
            const o = URL.createObjectURL(s);
            i(o);
          }
        });
      } catch (s) {
        a(s);
      }
    }), this.client = e, this.transaction = t.transaction, this.workflow = t.workflow, this.profanityList = this.transaction.product?.profanities?.map((n) => n.word) || [], this.isReadOnly = t.transaction.isOrdered || !!t.readOnly, this.graphQlClient = t.graphQlClient, this.workflowManager = new q1(
      this,
      e,
      (n) => {
        try {
          this.debouncedSavedDesignUpdate();
        } catch {
          console.error("Failed to update saved design details.");
        }
        return t.stateMutationFunc(n);
      },
      t.graphQlClient,
      t.reloadedState,
      t.readOnly,
      t.modelContainer,
      t.isReloadedTransaction,
      t.singleVariantsRenderable,
      t.delayWorkflowStateSync
    ), this.workflowManager.addSelectionCallback((n) => {
      const i = n.traversableScenes.map((a) => {
        const s = a.renderableSteps.map((o) => o.stepName);
        return {
          id: a.name,
          title: a.title,
          renderableSteps: s,
          workflowScene: a
        };
      });
      this.renderableScenes = i, this.renderableSceneCallbacks.forEach((a) => a(i)), this.callEvent(
        "SelectionChanged"
        /* SelectionChanged */
      );
    }), this.currentPriceBreak = this.priceBreakToBeApplied();
  }
  getTransaction() {
    return this.transaction;
  }
  getProduct() {
    return this.transaction.product;
  }
  getProfanityList() {
    return this.profanityList;
  }
  async setProduct(e) {
    this.workflow = void 0;
    const t = await this.graphQlClient().mutate({
      mutation: sT,
      variables: {
        id: this.getTransaction().id,
        integrationProductId: e
      }
    }), n = t.data?.transactionUpdateIntegrationProduct.product;
    if (!n)
      throw new si("Failed to set product. No product returned from server.");
    if (!this.bundle)
      throw new si("Cannot set product on experience that is not part of a bundle.");
    this.transaction.product = {
      ...this.transaction.product,
      ...t.data?.transactionUpdateIntegrationProduct.product
    }, this.transaction.integrationProduct = {
      ...this.transaction.integrationProduct,
      ...t.data?.transactionUpdateIntegrationProduct.integrationProduct
    }, this.transaction.workflowState = void 0, this.currentPriceBreak = this.priceBreakToBeApplied(), this.callEvent(
      "ProductChanged"
      /* ProductChanged */
    );
    const i = (await this.bundle.getProductCollection().fetchProducts()).find(
      (a) => a.getId() === n.id
    );
    try {
      const a = i?.getDefaultWorkflow();
      if (a) {
        const s = await cO(a.getId());
        await this.setWorkflow(s), console.log("Setting Product - Workflow set to default for product.");
      }
    } catch {
      console.log("Setting Product - No default workflow available, must be set manually.");
    }
  }
  async clearProduct() {
    if (!this.bundle)
      throw new si("Cannot clear product on experience that is not part of a bundle.");
    this.workflow = void 0, this.transaction.workflowState = void 0, this.transaction.product = void 0, this.transaction.integrationProduct = void 0, this.currentPriceBreak = this.priceBreakToBeApplied(), this.callEvent(
      "ProductChanged"
      /* ProductChanged */
    ), await this.graphQlClient().mutate({
      mutation: sT,
      variables: {
        id: this.getTransaction().id
      }
    });
  }
  getWorkflow() {
    return this.workflow;
  }
  async setWorkflow(e) {
    return this.workflow = e, await this.graphQlClient().mutate({
      mutation: EL,
      variables: {
        id: this.getTransaction().id,
        workflowId: e.id
      }
    }), this.workflowManager.setWorkflow(e);
  }
  async updateWorkflowConfiguration(e) {
    if (!this.workflow)
      throw new Error("No workflow set");
    e.steps && this.cachedStepHandles.clear();
    const t = this.applyWorkflowChanges(this.workflow, e);
    this.workflow = t, await this.workflowManager.updateWorkflowConfiguration(e), this.callEvent(
      "WorkflowConfigurationChanged"
      /* WorkflowConfigurationChanged */
    );
  }
  applyWorkflowChanges(e, t) {
    let n = { ...e };
    if (t.panels) {
      let i = [...e.panels];
      if (t.panels.removed && (i = i.filter((a) => !t.panels.removed.includes(a.name))), t.panels.changed)
        for (const a of t.panels.changed) {
          const s = i.findIndex((o) => o.name === a.name);
          s >= 0 && (i[s] = a);
        }
      if (t.panels.added)
        for (const { item: a, index: s } of t.panels.added)
          i.splice(s, 0, a);
      n.panels = i;
    }
    if (t.steps) {
      let i = [...e.steps];
      if (t.steps.removed && (i = i.filter((a) => !t.steps.removed.includes(a.stepName))), t.steps.changed)
        for (const a of t.steps.changed) {
          const s = i.findIndex((o) => o.stepName === a.stepName);
          s >= 0 && (i[s] = a);
        }
      if (t.steps.added)
        for (const { item: a, index: s } of t.steps.added)
          i.splice(s, 0, a);
      n.steps = i;
    }
    if (t.stepGroups) {
      let i = [...e.stepGroups];
      if (t.stepGroups.removed && (i = i.filter((a) => a.id && !t.stepGroups.removed.includes(a.id))), t.stepGroups.changed)
        for (const a of t.stepGroups.changed) {
          const s = a.id || a.name, o = i.findIndex((l) => l.id === s);
          o >= 0 && (i[o] = a);
        }
      if (t.stepGroups.added)
        for (const { item: a, index: s } of t.stepGroups.added)
          i.splice(s, 0, a);
      n.stepGroups = i;
    }
    return n;
  }
  async attachAddress(e, t, n, i, a, s) {
    await this.graphQlClient().mutate({
      mutation: $j,
      variables: {
        transactionId: this.getTransaction().id,
        streetAddress: e || void 0,
        apartment: t || void 0,
        city: n || void 0,
        country: i || void 0,
        state: a || void 0,
        postCode: s || void 0
      }
    });
  }
  async attachOrganization(e) {
    await this.graphQlClient().mutate({
      mutation: zj,
      variables: {
        transactionId: this.getTransaction().id,
        organizationName: e
      }
    });
  }
  getBundle() {
    return this.bundle;
  }
  setBundle(e) {
    this.bundle = e;
  }
  getClient() {
    return this.client;
  }
  getIsReadOnly() {
    return this.isReadOnly;
  }
  getCommandContext() {
    return this.workflowManager.getCommandContext();
  }
  getWorkflowManager() {
    return this.workflowManager;
  }
  async createPreviewImage(e, t) {
    const n = this.getWorkflow(), i = n?.finalizeStepConfig?.lookAtAnimation;
    if (!n)
      throw new Error("Failed to generate cart preview image! No workflow is set.");
    if (e) {
      if (!i)
        throw new Error("Failed to generate cart preview image! No camera orientation configured.");
      return await this.workflowManager.getPreviewService()?.renderSceneScreenshot(t ?? 512, i) || "";
    }
    let a = 2048;
    t && t <= 2048 && (a = t);
    const s = Pc(a, a), o = this.workflowManager.getCommandContext().getAllLayouts(), l = n.defaultPreviewPanelIndex || 0, u = n.panels[l], c = o.find((T) => T.layoutState?.layout.panelId === u?.name) || o[0], h = c.layoutState.layout.previewRegion ? {
      x: c.layoutState.layout.previewRegion.left,
      y: c.layoutState.layout.previewRegion.top,
      width: c.layoutState.layout.previewRegion.width,
      height: c.layoutState.layout.previewRegion.height
    } : {
      x: 0,
      y: 0,
      width: c.layoutState.layout.width,
      height: c.layoutState.layout.height
    }, f = this.workflowManager.getCommandContext().getLayoutById(c.layoutState.layout.id), p = s.getContext("2d");
    if (!p)
      throw new rh("Failed to obtain 2D context for preview image creation");
    const m = this.workflowManager.getTemplatingContext(), A = ux(f.layoutState.layout, f.layoutState.elements, {
      renderingConfiguration: {
        purpose: Hp.Print,
        region: { left: h.x, top: h.y, width: h.width, height: h.height },
        templatingContext: m
      }
    }), w = xI(A);
    await (await vc.from(p, w, {
      anonymousCrossOrigin: !0,
      ignoreDimensions: !1,
      createCanvas: Pc,
      createImage: cg,
      DOMParser: Dw(),
      fetch
    })).render();
    const E = await this.getCanvasObjectURLAsync(s);
    return s.toDataURL(E);
  }
  getStepById(e) {
    const t = this.getWorkflow()?.steps.find((a) => a.stepName === e);
    if (!t || !this.stepHasHandle(t)) return;
    const n = this.cachedStepHandles.get(t.stepName);
    if (n)
      return n;
    const i = Em.get(this.getWorkflowManager(), t);
    return this.cachedStepHandles.set(t.stepName, i), i;
  }
  getSteps() {
    return this.getScenes().flatMap((e) => this.getStepsByScene(e));
  }
  async getStepsConditionallyActive() {
    const e = this.getScenes();
    return (await Promise.all(
      e.map(async (n) => {
        const i = this.getStepsByScene(n), a = await Promise.all(
          i.map(
            (s) => yc(s.getRaw(), this.getWorkflowManager().getStepSelections())
          )
        );
        return i.filter((s, o) => a[o]);
      })
    )).flat();
  }
  getScenes() {
    return (this.getWorkflow()?.stepGroups || []).map((t) => ({
      id: t.id,
      name: t.name,
      stepIds: t.stepNames
    }));
  }
  getSelectionPriceSubunits(e) {
    const t = this.getWorkflowManager().getWorkflowSelections();
    let n = 0;
    return Object.values(t).forEach((i) => {
      n += i.selections.reduce((a, s) => a + (s.priceModifier || 0), 0);
    }), this.getPriceSubUnitsAfterPriceBreaks(n, e);
  }
  getBasePriceSubunits(e, t) {
    const n = this.getPriceSubUnitsAfterPriceBreaks(this.getProduct()?.basePrice || 0, t);
    if (e) {
      const i = this.getAdditionalProductPriceSubunits(t) || 0;
      return n + i;
    }
    return n;
  }
  getAdditionalProductPriceSubunits(e) {
    const t = this.getTransaction().integrationProduct;
    if (t?.additionalIntegrationProduct?.product) {
      const n = t.additionalIntegrationProduct.product.basePrice || 0;
      return this.getPriceSubUnitsAfterPriceBreaks(n, e);
    }
  }
  getTotalPriceSubunits(e) {
    return this.getBasePriceSubunits(!1, e) + this.getSelectionPriceSubunits(e);
  }
  getPriceSubUnitsAfterPriceBreaks(e, t) {
    const n = t ? 1 : this.priceBreakToBeApplied(), i = e * n;
    return Math.ceil(i);
  }
  priceBreakToBeApplied() {
    const e = (this.getProduct()?.priceBreaks || []).sort((i, a) => -(i.minQty - a.minQty)), n = [...this.getMatchingExperiencesFromBundle(), this].reduce((i, a) => i + a.getQuantity(), 0);
    for (const i of e)
      if (i.minQty <= n)
        return i.percentage;
    return 1;
  }
  checkForPriceBreakChanges() {
    const e = this.priceBreakToBeApplied();
    this.currentPriceBreak !== e && (this.updatePriceBreak(e), this.getMatchingExperiencesFromBundle().forEach(
      (t) => t.updatePriceBreak(e)
    ));
  }
  getMatchingExperiencesFromBundle() {
    return (this.bundle?.getWorkflowExperiences() || []).filter((e) => {
      const t = e.getTransaction().id, n = this.getTransaction().id, i = e.getProduct()?.id, a = this.getProduct()?.id;
      return t !== n && i === a;
    });
  }
  updatePriceBreak(e) {
    this.currentPriceBreak = e, this.callEvent(
      "PriceBreakChanged"
      /* PriceBreakChanged */
    );
  }
  async copySelectionsViaGlobalConfiguration(e, t, n) {
    const i = await e.getGlobalProperties(), a = n?.map((u) => u.getId()), s = this.getSteps().filter((u) => a === void 0 || a.includes(u.getId())), o = t.getSteps(), l = (u) => i.find((c) => c.getRawProperty().name === u.aspectName);
    s.forEach((u) => {
      const c = /* @__PURE__ */ new Set(), h = u.getRaw().globalPropertyAspectConfigurations;
      h !== void 0 && (h.forEach((f) => c.add(JSON.stringify(f))), o.forEach((f) => {
        const p = f.getRaw().globalPropertyAspectConfigurations;
        p !== void 0 && p.forEach((m) => {
          const A = l(m), w = c.has(JSON.stringify(m));
          if (w && A?.getType() === "Option") {
            const x = f.getCurrentVariant();
            if (!x) return;
            u.selectVariant(x), c.delete(JSON.stringify(m));
          } else if (w && A?.getType() === "Text") {
            const x = f.getText();
            u.setText(x), c.delete(JSON.stringify(m));
          }
        });
      }));
    });
  }
  getStepByName(e) {
    const t = this.getWorkflow()?.steps.find((n) => n.stepTitle === e);
    if (!(!t || !this.stepHasHandle(t)))
      return Em.get(this.getWorkflowManager(), t);
  }
  getStepsByType(e) {
    return this.getWorkflow()?.steps.filter((t) => t.type === e).map((t) => Em.get(this.getWorkflowManager(), t)) || [];
  }
  getStepsByScene(e) {
    const t = this.getWorkflow();
    if (!t?.stepGroups.find((i) => i.name === e.name))
      throw new Error(
        "Given scene is not present on workflow! Be careful when persisting scenes that you only use them with the relevant workflow."
      );
    return e.stepIds.map((i) => t.steps.find((a) => a.stepName === i)).filter((i) => !!i && this.stepHasHandle(i)).map((i) => Em.get(this.getWorkflowManager(), i));
  }
  async attachCustomerDetails(e) {
    return this.assignCustomerDetails({ emailAddress: e.email });
  }
  async assignCustomerDetails(e) {
    const n = (await this.graphQlClient().mutate({
      mutation: Uj,
      variables: {
        id: this.getTransaction().id,
        details: e,
        type: "Owner"
      }
    })).data?.transactionAddStakeholder?.stakeholders?.find(
      (i) => i.customer?.emailAddress === e.emailAddress
    );
    n?.customer && this.assignCustomerInternal(n.customer);
  }
  assignCustomerInternal(e) {
    this.getWorkflowManager().setTransactionCustomer(e);
    const t = hn.getMap("transactionCustomerIds") || /* @__PURE__ */ new Map();
    t.set(this.getTransaction().id, e.id), hn.setMap("transactionCustomerIds", t);
  }
  attachRenderableSceneListener(e) {
    this.renderableSceneCallbacks.push(e), e(this.renderableScenes);
  }
  detachRenderableSceneListener(e) {
    this.renderableSceneCallbacks = this.renderableSceneCallbacks.filter((t) => t !== e);
  }
  async save(e) {
    const t = this.getProduct(), n = this.getWorkflow(), i = this.getCommandContext().getState();
    if (!t) throw new si("Product undefined!");
    if (!n) throw new si("Workflow undefined!");
    if (!i) throw new si("State undefined!");
    const s = {
      title: await (async () => {
        if (e) return e;
        const o = this.getTransaction().id, u = (await dA.getSavedDesigns()).find((c) => c.transactionId === o)?.title;
        return u || "My design";
      })(),
      thumbnail: await this.createPreviewImage(!1, 256),
      transactionId: this.getTransaction().id,
      productId: t.id,
      integrationProductId: this.getTransaction().integrationProduct.id,
      workflowName: n.name,
      workflowId: n.id,
      lastEdited: /* @__PURE__ */ new Date()
    };
    return await dA.addDesign(s), s;
  }
  async copy() {
    const e = Su(this.getCommandContext().getState());
    if (!e) throw new si("Internal state is undefined! Cannot copy experience!");
    const t = JSON.stringify(e.transaction), n = this.getWorkflow();
    if (!n) throw new si("Workflow is undefined! Cannot copy experience!");
    const i = this.getTransaction().integrationProduct?.id;
    if (!i) throw new si("Integration product id is undefined!");
    return await this.getClient().getWorkflowExperience({
      type: "integration",
      integrationProductId: i,
      workflowId: n.id,
      workflowState: t
    });
  }
  async onDesignFinished(e = !0) {
    const t = this.getTransaction(), n = this.getProduct(), i = this.getWorkflow();
    if (!n)
      throw new si("Product undefined! Cannot finish an experience without a product.");
    if (!i)
      throw new si("Workflow undefined! Cannot finish an experience without a workflow.");
    if (t.isOrdered)
      return {
        event: "",
        exportedData: {},
        lineItemImageUrl: "",
        optionsCost: 0,
        transactionId: t.id,
        workflowViewerLink: "",
        workflowViewerReadOnlyLink: ""
      };
    const a = await eR(
      [
        {
          workflowManager: this.workflowManager,
          workflow: i,
          layouts: this.workflowManager.getLayouts(),
          getReducerState: () => this.workflowManager.getCommandContext().getState(),
          // Handle case where undefined (create a default state)
          product: n,
          transaction: t,
          workflowSelections: this.workflowManager.getWorkflowSelections(),
          workflowMetadata: this.workflowManager.getWorkflowMetadata(),
          designName: i.name
        }
      ],
      (s) => e ? this.createPreviewImage(s, 1024) : Promise.resolve(void 0)
    );
    return t.completed && await this.graphQlClient().mutate({
      mutation: OL,
      variables: {
        transactionId: t.id
      }
    }), a[0];
  }
  /**
   * @param step The step to test against.
   * @returns Returns true when a valid handle is implemented for a given step type. Certain steps don't support handles, such as silent illustrations.
   */
  stepHasHandle(e) {
    return e.type !== gt.SilentIllustration && e.type !== gt.ProductOverlay;
  }
  async getExportedStepData() {
    const e = this.getWorkflow(), t = this.getWorkflowManager().getWorkflowMetadata(), n = this.getWorkflowManager().getWorkflowSelections(), i = [];
    for (const a of e?.steps || []) {
      const s = a.stepName, o = t[s], l = n[s]?.selections[0], u = {
        stepId: s,
        title: a.stepTitle,
        properties: []
      };
      if (l && await Hj(a, n) && u.properties.push({
        type: "selection",
        value: l.name,
        priceModifier: l.priceModifier
      }), !o) {
        i.push(u);
        continue;
      }
      switch (a.type) {
        case gt.Frame:
          {
            const c = a.data, h = o;
            h.image && c.displayImageOnFinishStep && u.properties.push({
              type: "image",
              value: h.image,
              priceModifier: 0
            });
          }
          break;
        case gt.Illustration:
          {
            const c = a.data, h = o;
            if (h && h.colors && h.colors.length > 0 && c.displayColorsOnFinishStep) {
              const f = h.colors.join(", ").toUpperCase();
              u.properties.push({
                type: "color",
                value: f,
                priceModifier: 0
              });
            }
          }
          break;
        case gt.Module:
          {
            const c = a.data, h = o;
            h && h.text && c.displayTextOnFinishStep && u.properties.push({
              type: "text",
              value: h.text,
              priceModifier: 0
            });
          }
          break;
        case gt.Text: {
          const c = a.data, h = o;
          h && h.text && c.displayTextOnFinishStep && u.properties.push({
            type: "text",
            value: h.text,
            priceModifier: 0
          }), h && h.color && c.displayColorOnFinishStep && u.properties.push({
            type: "color",
            value: h.color,
            priceModifier: 0
          });
        }
      }
      i.push(u);
    }
    return i.filter((a) => a.properties && a.properties.length > 0);
  }
  getQuantity() {
    return this.getTransaction().quantity || 1;
  }
  async setQuantity(e) {
    if (e < 1)
      throw new RangeError("WorkflowExperience quantity must be greater than zero.");
    if (this.isReadOnly)
      throw new Error("Cannot update quantity on a read-only WorkflowExperience");
    this.getTransaction().quantity = e, this.callEvent(
      "QuantityChanged"
      /* QuantityChanged */
    ), this.checkForPriceBreakChanges();
    const t = this.getTransaction();
    await this.graphQlClient().mutate({
      mutation: SL,
      variables: {
        id: t.id,
        quantity: e
      }
    });
  }
  addEventListener(e, t) {
    const n = this.eventCallbacks.get(e) || [];
    n.push(t), this.eventCallbacks.set(e, n);
  }
  removeEventListener(e, t) {
    const n = this.eventCallbacks.get(e) || [];
    this.eventCallbacks.set(
      e,
      n.filter((i) => i !== t)
    );
  }
  callEvent(e) {
    (this.eventCallbacks.get(e) || []).forEach((t) => t(this));
  }
}
const Gj = (r) => {
  if ([
    gt.Question,
    gt.Frame,
    gt.Illustration,
    gt.Material,
    gt.Model,
    gt.Picture,
    gt.Shape,
    gt.Text
  ].includes(r.type)) {
    const t = r.data;
    return !!t.displaySelectionOnFinishStep || !!t.displaySelectionsOnFinishStep;
  }
  return !1;
}, Hj = async (r, e) => {
  if (!Gj(r)) return !1;
  const t = await Pt.getOptionForStep(r);
  if (t && (t.variants || []).length > 1) {
    const n = e[r.stepName];
    return !!(n && n.selections.length > 0);
  }
  return !1;
};
class rR {
  constructor(e) {
    this.handleCache = {}, this.owner = e;
  }
  /**
   * Gets a handle for the given global property. Fetches from cache if available.
   * @param property The property to get a handle for.
   * @returns A promise resolving to the handle.
   */
  async getHandle(e) {
    if (this.handleCache[e.name]) return this.handleCache[e.name];
    const t = await this.createHandle(e);
    return this.handleCache[e.name] = t, t;
  }
  /**
   * Gets a list of handles for all global properties. Fetches from cache if available.
   * @returns A promise resolving to the handles.
   */
  async getHandles() {
    if (!this.owner.getGlobalPropertyConfiguration()) return [];
    await this.owner.getGlobalPropertyStateManager().getInitializationPromise();
    const e = this.owner.getGlobalPropertyConfiguration();
    return e ? Promise.all(e.aspects.map((t) => this.getHandle(t))) : [];
  }
  /**
   * Applies the global state to all handles, if the state is set.
   * @param handles The handles to apply the state to.
   * @param state
   * @returns
   */
  applyConditionsFromState(e, t) {
    return t ? e.filter((n) => this.aspectConditionsSatisfied(n.getRawProperty(), t)) : e;
  }
  aspectConditionsSatisfied(e, t) {
    return !e.conditions || e.conditions.length === 0 ? !0 : (e.conditionMode === gI.AND ? Array.prototype.every.bind(e.conditions) : Array.prototype.some.bind(e.conditions))((i) => {
      const a = t.aspects.find((s) => s.name === i.targetAspectName);
      return a ? i.requiredVariantSelections.some((s) => s === a.value) : !1;
    });
  }
  async createHandle(e) {
    switch (e.type) {
      case Ji.FileUpload:
        return new Wj(this.owner, e).initialize();
      case Ji.ColorOption:
        return new oT(
          this.owner,
          e,
          e.entityId ? await Pt.getOption(e.entityId) : void 0
        );
      case Ji.Option: {
        const t = e.entityId ? await Pt.getOption(e.entityId) : void 0;
        return t?.type === "Color" ? new oT(this.owner, e, t) : new nR(this.owner, e, t);
      }
      case Ji.Text:
        return new jj(this.owner, e);
      default:
        throw new Error("Unhandled Global Property Aspect Type");
    }
  }
}
class gx {
  constructor(e, t) {
    this.owner = e, this.property = t;
  }
  /**
   * @returns The name of the global property. This is the key used to store the property in the state.
   */
  getName() {
    return this.property.name;
  }
  /**
   * @returns A human-friendly title.
   */
  getTitle() {
    return this.property.title;
  }
  /**
   * @returns A human-friendly description.
   */
  getDescription() {
    return this.property.description;
  }
  /**
   * @returns The type of the global property. Use this to determine how to render the property.
   */
  getType() {
    return this.property.type;
  }
  /**
   * @returns The underlying property data object.
   */
  getRawProperty() {
    return this.property;
  }
  /**
   * @returns Whether this aspect has been marked as required to be completed before the user can continue.
   */
  isMandatory() {
    return !!this.property.mandatory;
  }
  /**
   * @returns Whether this aspect has been marked as `completed` for mandatory checks. Note that this function always returns `true` if the aspect has not been marked as mandatory.
   */
  isMandatoryFulfilled() {
    return !this.property.mandatory || !!this.owner.getGlobalPropertyStateManager().getAspectMandatoryFulfilled(this.property.name);
  }
  /**
   * @returns Whether this aspect has been marked as silent and therefore should not be displayed to the user.
   */
  isSilent() {
    return !!this.property.silent || this.owner.getGlobalPropertyStateManager().getAspectHidden(this.property.name);
  }
  /**
   * Returns all steps that share this property.
   * @param targetExperiences Optionally filter the steps to only those in the given experiences.
   */
  async getSharedSteps(e) {
    const t = e ?? this.owner.getWorkflowExperiences();
    return (await Promise.all(t.map((a) => a.getStepsConditionallyActive()))).map(
      (a) => a.filter((s) => s.getOverrideGlobalPropertyConfiguration(this.property.type) ? !1 : s.getRaw().globalPropertyAspectConfigurations?.some(
        (o) => o.globalPropertyConfigurationId === this.owner.getGlobalPropertyConfiguration()?.id && o.aspectName === this.property.name
      ))
    ).flat();
  }
  getStateValue() {
    return this.owner.getGlobalPropertyStateManager().getAspect(this.property.name);
  }
}
class Wj extends gx {
  constructor(e, t) {
    super(e, t);
  }
  async initialize() {
    return this.property.data?.fileUpload?.colorOptionId && (this.colorOption = await Pt.getOption(this.property.data?.fileUpload?.colorOptionId)), await this.loadImageData(), this;
  }
  async loadImageData() {
    const e = await this.getImage();
    if (e?.fileLink)
      if (Dc(e.fileLink) === "svg") {
        const t = await xo(e?.fileLink), n = await dx(e?.fileLink), i = n.width, a = n.height, s = await Nl(t);
        this.owner.getGlobalPropertyStateManager().getAspectStorage(this.property.name)?.colors?.forEach((u) => {
          s.colors[u.key] = {
            browserValue: u.browserValue,
            pmsValue: u.pmsValue
          };
        });
        const l = {
          src: e?.fileLink,
          width: i,
          height: a,
          aspect: i / a,
          svg: s.svg,
          colors: s.colors
        };
        gc.set(e?.fileLink, l), this.imageData = l;
      } else
        this.imageData = void 0;
  }
  /**
   * Select an image to be used for all shared steps.
   * @param asset The asset to use.
   * @returns A promise resolving when all affected steps have been updated.
   */
  async selectImage(e) {
    const t = this.owner.getGlobalPropertyStateManager();
    await Promise.all([
      t.setAspect(
        this.property.name,
        e.key,
        {
          ...t.getAspectStorage(this.property.name) || {},
          originalAssetKey: e.key,
          backgroundRemovedAssetKey: void 0,
          vectorizedAssetKey: void 0,
          useOriginalAsset: void 0
        },
        void 0
      ),
      this.applyImageSelection(e),
      this.loadImageData()
    ]);
  }
  async canUseAdvancedImageManipulation() {
    return this.owner.getClient().canUseAddon(Fw.AdvancedImageManipulation);
  }
  /**
   * Removes the background from an image, stores it in the state, and returns the new asset.
   * @param applyNewAsset Optionally applies the new asset to all shared steps. Default: `true`.
   * @returns A promise that resolves with the newly generated Asset.
   */
  async removeBackgroundFromImage(e = !0) {
    if (!await this.canUseAdvancedImageManipulation())
      throw new Error(
        "The current Integration does not have access to the Advanced Image Manipulation addon. Please call canUseAdvancedImageManipulation to ensure you disable this feature when appropriate."
      );
    const t = await this.getOriginalImage();
    if (!t)
      throw new Error("You must supply an image selection before attempting to remove the background.");
    const n = this.owner.getGlobalPropertyStateManager(), i = await Si.removeBackgroundFromAsset(t), s = {
      ...n.getAspectStorage(this.property.name),
      backgroundRemovedAssetKey: i.key,
      useOriginalAsset: !e
    }, l = [e ? n.setAspect(this.property.name, i.key, s) : n.setAspectStorage(this.property.name, s)];
    return e && (l.push(this.applyImageSelection(i, void 0, !1, !1)), l.push(this.loadImageData())), await Promise.all(l), this.updateSharedStepStorage(s), i;
  }
  /**
   * Vectorizes the current image selection, stores it in the state, and returns the new asset.
   * Note: This is a more expensive operation than raster background removal, so should only be used when necessary (e.g., for large images or when the user needs a transparent background for printing).
   * @param applyNewAsset Optionally applies the new asset to all shared steps. Default: `true`.
   * @returns A promise that resolves with the newly generated Asset.
   */
  async vectorizeImage(e = !0) {
    if (!await this.canUseAdvancedImageManipulation())
      throw new Error(
        "The current Integration does not have access to the Advanced Image Manipulation addon. Please call canUseAdvancedImageManipulation to ensure you disable this feature when appropriate."
      );
    const t = await this.getOriginalImage();
    if (!t)
      throw new Error("You must supply an image selection before attempting to vectorize the image.");
    const n = this.owner.getGlobalPropertyStateManager(), i = await Si.vectorizeAsset(t), s = {
      ...n.getAspectStorage(this.property.name),
      vectorizedAssetKey: i.key,
      useOriginalAsset: !e
    }, l = [e ? n.setAspect(this.property.name, i.key, s) : n.setAspectStorage(this.property.name, s)];
    return e && (l.push(this.applyImageSelection(i, void 0, !1, !1)), l.push(this.loadImageData())), await Promise.all(l), this.updateSharedStepStorage(s), i;
  }
  /**
   * Returns `true` if the state has an image assigned, otherwise `false`.
   */
  hasImage() {
    return !!this.getStateValue();
  }
  /**
   * Retrieves the current image selection, if one exists.
   * @returns A promise that resolves with an `Asset` object if one is assigned to the state, otherwise `undefined`.
   */
  async getImage() {
    const e = this.getStateValue();
    if (e)
      return Si.getLocalOrFromServer(e);
  }
  async getImageWithColors() {
    return await this.loadImageData(), this.imageData?.svg ? Iw(Vw(this.imageData.svg, this.imageData.colors ?? {}, !1)) : this.imageData?.src;
  }
  /**
   * Retrieves the original, unmodified image selection, if one exists.
   * @returns A promise that resolves with an `Asset` object if one is assigned to the state, otherwise `undefined`.
   */
  async getOriginalImage() {
    const e = this.owner.getGlobalPropertyStateManager().getAspectStorage(this.property.name);
    if (e?.originalAssetKey)
      return Si.getLocalOrFromServer(e.originalAssetKey);
  }
  /**
   * Retrieves the version of the image selection that has the background removed, if one exists.
   * @returns A promise that resolves with an `Asset` object if one is assigned to the state, otherwise `undefined`.
   */
  async getBackgroundRemovedImage() {
    const e = this.owner.getGlobalPropertyStateManager().getAspectStorage(this.property.name);
    if (e?.backgroundRemovedAssetKey)
      return Si.getLocalOrFromServer(e.backgroundRemovedAssetKey);
  }
  getUseOriginalImage() {
    return this.owner.getGlobalPropertyStateManager().getAspectStorage(this.property.name)?.useOriginalAsset ?? !1;
  }
  async setUseOriginalImage(e) {
    const t = await this.getOriginalImage();
    if (!t)
      throw new Error("You must select an image before calling setUseOriginalImage");
    const n = this.owner.getGlobalPropertyStateManager(), i = n.getAspectStorage(this.property.name);
    if (i?.useOriginalAsset === e)
      return;
    const a = {
      ...i,
      useOriginalAsset: e
    }, s = e ? i?.originalAssetKey : i?.backgroundRemovedAssetKey, o = [n.setAspect(this.property.name, s || "", a)];
    if (e)
      o.push(this.applyImageSelection(t, void 0, !1, !1));
    else {
      const l = async () => {
        const u = await this.getBackgroundRemovedImage();
        if (!u)
          throw new Error(
            "You must call removeBackgroundFromImage before attempting to use that version of the image."
          );
        this.applyImageSelection(u, void 0, !1, !1);
      };
      o.push(l());
    }
    o.push(this.loadImageData()), await Promise.all(o), this.updateSharedStepStorage(a);
  }
  async applyGlobalState(e) {
    const t = this.getStateValue();
    if (!t) return;
    const n = await Si.getLocalOrFromServer(t);
    if (!n) return;
    await this.applyImageSelection(n, e, !1, !0);
    const i = this.owner.getGlobalPropertyStateManager().getAspectStorage(this.property.name);
    if (i) {
      if (this.updateSharedStepStorage({ ...i }), i.colors) {
        const a = new Map(
          i.colors.map((s) => [s.key, { browserValue: s.browserValue, pmsValue: s.pmsValue }]) ?? []
        );
        await Promise.all(
          (await this.getSharedSteps(e)).map(async (s) => {
            await s.changeColors(a);
          })
        );
      }
    } else
      this.updateSharedStepStorage({ originalAssetKey: t }), await this.owner.getGlobalPropertyStateManager().setAspectStorage(this.property.name, { originalAssetKey: t });
  }
  getAvailableColors() {
    return this.property.data?.fileUpload?.colorPickerEnabled ? this.colorOption?.variants?.map((e) => ({
      fill: e.color,
      stroke: e.color,
      variant: e,
      pmsValue: e.name
    })) ?? [] : [];
  }
  getCurrentColors() {
    return this.imageData?.colors;
  }
  isColorPickerEnabled() {
    return this.property.data?.fileUpload?.colorPickerEnabled ?? !1;
  }
  isPmsPickerEnabled() {
    return this.property.data?.fileUpload?.pmsPickerEnabled ?? !1;
  }
  async getOriginalColors() {
    return this.imageData?.svg ? (await Nl(this.imageData.svg)).colors : void 0;
  }
  async changeColors(e) {
    if (!this.imageData?.svg)
      return;
    const t = this.getSharedSteps(), n = new Map(Object.entries(e));
    await Promise.all(
      (await t).map(async (a) => {
        await a.changeColors(n);
      })
    );
    const i = this.owner.getGlobalPropertyStateManager().getAspectStorage(this.property.name);
    await Promise.all([
      this.owner.getGlobalPropertyStateManager().setAspectStorage(this.property.name, {
        ...i,
        colors: Object.entries(e).map(([a, s]) => ({
          key: a,
          browserValue: s.browserValue,
          pmsValue: s.pmsValue
        }))
      }),
      await this.loadImageData()
    ]);
  }
  async applyImageSelection(e, t, n = !0, i = !0) {
    const s = (await this.getSharedSteps(t)).map((o) => {
      const l = o;
      if (l.getFrameService())
        return l.selectImage(e, n, i);
    });
    await Promise.all(s);
  }
  updateSharedStepStorage(e) {
    this.owner.getWorkflowExperiences().forEach(
      (n) => n.getSteps().forEach((i) => {
        if (i.getOverrideGlobalPropertyConfiguration(this.property.type))
          return;
        i.getRaw().globalPropertyAspectConfigurations?.some(
          (s) => s.globalPropertyConfigurationId === this.owner.getGlobalPropertyConfiguration()?.id && s.aspectName === this.property.name
        ) && n.getWorkflowManager().updateStorage(i.getId(), {
          framePatternData: {
            originalAssetKey: e.originalAssetKey,
            backgroundRemovedAssetKey: e.backgroundRemovedAssetKey,
            useOriginalAsset: e.useOriginalAsset
          }
        });
      })
    );
  }
}
class jj extends gx {
  constructor(e, t) {
    super(e, t);
  }
  /**
   * If this returns false, you should not display any templating tools.
   * Note: Templates will currently still be rendered, regardless of what this function returns.
   */
  isTemplatingEnabled() {
    return this.property.data?.text?.templatingEnabled || !1;
  }
  /**
   * Gets the current text
   */
  getText() {
    const e = this.getStateValue();
    return e || "";
  }
  /**
   * Set the text.
   */
  async setText(e) {
    await Promise.all([
      this.owner.getGlobalPropertyStateManager().setAspect(this.property.name, e, void 0, void 0),
      this.applyTextSelection(e)
    ]);
  }
  async applyGlobalState(e) {
    const t = this.getStateValue();
    if (!t) return Promise.resolve();
    await this.applyTextSelection(t, e);
  }
  async applyTextSelection(e, t) {
    const i = (await this.getSharedSteps(t)).map((a) => {
      a.setText(e);
    });
    await Promise.all(i);
  }
}
class nR extends gx {
  constructor(e, t, n) {
    super(e, t), this.optionResource = n;
  }
  /**
   * Ensures the option resource has its variants loaded. If the option was loaded
   * with minimal fields (e.g., lazy loading), this will re-fetch the full option.
   */
  async ensureOptionLoaded() {
    if (this.optionResource?.variants) return this.optionResource;
    if (!this.property.entityId) return this.optionResource;
    const e = await Pt.getOption(this.property.entityId);
    return e && (this.optionResource = e), this.optionResource;
  }
  /**
   * If the option has a default variant, select it.
   */
  async initDefaultVariant() {
    await this.ensureOptionLoaded();
    const e = this.optionResource?.variants?.find(
      (t) => t.id === this.optionResource?.defaultVariant?.id
    );
    e && await this.selectVariant(new Dl(e));
  }
  /**
   * Gets the currently selected variant, or undefined if no variant is selected.
   */
  getCurrentVariant() {
    if (!this.optionResource) return;
    const e = this.getStateValue();
    if (e) {
      const t = this.optionResource.variants?.find((n) => n.id === e);
      return t ? new Dl(t) : void 0;
    } else {
      const t = this.optionResource.variants?.find(
        (n) => n.id === this.optionResource?.defaultVariant?.id
      );
      return t ? new Dl(t) : void 0;
    }
  }
  /**
   * @returns A list of valid variants for this step. Does not include disabled variants.
   */
  async getAvailableVariants() {
    return await this.ensureOptionLoaded(), (this.optionResource?.variants?.filter((t) => t.enabled) || []).map((t) => new Dl(t));
  }
  /**
   * @returns A list of all variants for this step, including disabled ones.
   */
  async getAllVariants() {
    return await this.ensureOptionLoaded(), (this.optionResource?.variants || []).map((t) => new Dl(t));
  }
  /**
   * Select a given variant on the option for all shared steps.
   * @param variant The variant to select.
   */
  async selectVariant(e, t) {
    await this.applyVariantSelection(e), await this.owner.getGlobalPropertyStateManager().setAspect(this.property.name, e.getId(), void 0, t);
  }
  async applyGlobalState(e) {
    const t = this.getStateValue();
    if (!t) return;
    await this.ensureOptionLoaded();
    const n = this.optionResource?.variants?.find((i) => i.id === t);
    if (n)
      return this.applyVariantSelection(new Dl(n), e);
  }
  async applyVariantSelection(e, t) {
    const i = (await this.getSharedSteps(t)).map((a) => a.selectVariant(e));
    await Promise.all(i);
  }
}
class oT extends nR {
  constructor(e, t, n) {
    super(e, t, n);
  }
  /**
   * Select a given variant on the option for all shared steps.
   * @param variant The variant to select.
   */
  async selectVariant(e, t) {
    await this.owner.getGlobalPropertyStateManager().setAspect(this.property.name, e.getId(), void 0, t), await this.applyColorVariant(e, void 0, t);
  }
  async applyGlobalState(e) {
    const t = this.getStateValue();
    if (!t) return;
    await this.ensureOptionLoaded();
    const n = this.optionResource?.variants?.find((a) => a.id === t);
    if (!n) return;
    await this.applyColorVariant(new Dl(n), e);
    const i = this.owner.getGlobalPropertyStateManager().getAspectStorage(this.property.name)?.customColor;
    i && await this.setCustomColor(i);
  }
  async applyColorVariant(e, t, n) {
    const a = (await this.getSharedSteps(t)).map((s) => {
      switch (s.getType()) {
        case gt.Shape:
          return s.selectVariant(e);
        case gt.Text:
          return s.setFillColor({
            fill: e.getColor(),
            stroke: e.getColor(),
            variant: e.getResource()
          });
        case gt.Illustration:
          return s.setColor(n?.toString() || "", e.getColor() || "");
      }
    });
    await Promise.all(a);
  }
  /**
   * Sets a custom color on the global state.
   */
  async setCustomColor(e) {
    const t = this.getCurrentVariant()?.getColor();
    t && t.toLowerCase() === "#custom" && (await this.getSharedSteps()).forEach((i) => i.setCustomColor(e)), this.owner.getGlobalPropertyStateManager().setAspectStorage(this.property.name, { customColor: e });
  }
  /**
   * Gets the custom color used by the global state.
   */
  getCustomColor() {
    return this.owner.getGlobalPropertyStateManager().getAspectStorage(this.property.name)?.customColor || this.getCurrentVariant()?.getColor() || "#ffffff";
  }
}
const qj = (r, e, t) => {
  const n = r.getWorkflowExperiences(), i = r.getGlobalPropertyConfiguration();
  return i ? n.flatMap((s) => s.getSteps()).filter((s) => s.getGlobalPropertyAspects(i.id).includes(e) && s.getType() === t) : [];
}, Qj = (r, e) => {
  const n = qj(r, e, gt.Illustration).map((i) => {
    if (!i.getCurrentVariant()?.getAssetResource()?.assetConfiguration)
      return 0;
    const s = i.getColors();
    return s ? Object.getOwnPropertyNames(s).length : 0;
  });
  return Math.max(...n);
};
var bp = { exports: {} };
bp.exports;
var lT;
function Yj() {
  return lT || (lT = 1, (function(r, e) {
    var t = 200, n = "Expected a function", i = "__lodash_hash_undefined__", a = 500, s = 1, o = 2, l = 4, u = 800, c = 16, h = 9007199254740991, f = "[object Arguments]", p = "[object Array]", m = "[object AsyncFunction]", A = "[object Boolean]", w = "[object Date]", x = "[object Error]", E = "[object Function]", T = "[object GeneratorFunction]", D = "[object Map]", F = "[object Number]", _ = "[object Null]", L = "[object Object]", Z = "[object Promise]", te = "[object Proxy]", de = "[object RegExp]", H = "[object Set]", j = "[object String]", q = "[object Symbol]", re = "[object Undefined]", ae = "[object WeakMap]", ye = "[object ArrayBuffer]", Se = "[object DataView]", Xe = "[object Float32Array]", Ve = "[object Float64Array]", He = "[object Int8Array]", le = "[object Int16Array]", ve = "[object Int32Array]", it = "[object Uint8Array]", mt = "[object Uint8ClampedArray]", qe = "[object Uint16Array]", at = "[object Uint32Array]", st = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, lt = /^\w*$/, rt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Rt = /[\\^$.*+?()[\]{}|]/g, Fr = /\\(\\)?/g, an = /\w*$/, ar = /^\[object .+?Constructor\]$/, Ir = /^(?:0|[1-9]\d*)$/, kt = {};
    kt[Xe] = kt[Ve] = kt[He] = kt[le] = kt[ve] = kt[it] = kt[mt] = kt[qe] = kt[at] = !0, kt[f] = kt[p] = kt[ye] = kt[A] = kt[Se] = kt[w] = kt[x] = kt[E] = kt[D] = kt[F] = kt[L] = kt[de] = kt[H] = kt[j] = kt[ae] = !1;
    var wt = {};
    wt[f] = wt[p] = wt[ye] = wt[Se] = wt[A] = wt[w] = wt[Xe] = wt[Ve] = wt[He] = wt[le] = wt[ve] = wt[D] = wt[F] = wt[L] = wt[de] = wt[H] = wt[j] = wt[q] = wt[it] = wt[mt] = wt[qe] = wt[at] = !0, wt[x] = wt[E] = wt[ae] = !1;
    var Mn = typeof Ni == "object" && Ni && Ni.Object === Object && Ni, kr = typeof self == "object" && self && self.Object === Object && self, Gr = Mn || kr || Function("return this")(), Pr = e && !e.nodeType && e, Cr = Pr && !0 && r && !r.nodeType && r, qt = Cr && Cr.exports === Pr, lr = qt && Mn.process, It = (function() {
      try {
        var z = Cr && Cr.require && Cr.require("util").types;
        return z || lr && lr.binding && lr.binding("util");
      } catch {
      }
    })(), Zr = It && It.isMap, Cn = It && It.isSet, Sn = It && It.isTypedArray;
    function vr(z, ce, me) {
      switch (me.length) {
        case 0:
          return z.call(ce);
        case 1:
          return z.call(ce, me[0]);
        case 2:
          return z.call(ce, me[0], me[1]);
        case 3:
          return z.call(ce, me[0], me[1], me[2]);
      }
      return z.apply(ce, me);
    }
    function ln(z, ce) {
      for (var me = -1, tt = z == null ? 0 : z.length; ++me < tt && ce(z[me], me, z) !== !1; )
        ;
      return z;
    }
    function en(z, ce) {
      for (var me = -1, tt = z == null ? 0 : z.length, _t = 0, nr = []; ++me < tt; ) {
        var On = z[me];
        ce(On, me, z) && (nr[_t++] = On);
      }
      return nr;
    }
    function Fn(z, ce) {
      for (var me = -1, tt = z == null ? 0 : z.length, _t = Array(tt); ++me < tt; )
        _t[me] = ce(z[me], me, z);
      return _t;
    }
    function gn(z, ce) {
      for (var me = -1, tt = ce.length, _t = z.length; ++me < tt; )
        z[_t + me] = ce[me];
      return z;
    }
    function Gn(z, ce) {
      for (var me = -1, tt = Array(z); ++me < z; )
        tt[me] = ce(me);
      return tt;
    }
    function Hn(z) {
      return function(ce) {
        return z(ce);
      };
    }
    function tn(z, ce) {
      return z?.[ce];
    }
    function mn(z, ce) {
      return function(me) {
        return z(ce(me));
      };
    }
    var In = Array.prototype, vn = Function.prototype, fr = Object.prototype, Or = Gr["__core-js_shared__"], sn = vn.toString, yt = fr.hasOwnProperty, yn = (function() {
      var z = /[^.]+$/.exec(Or && Or.keys && Or.keys.IE_PROTO || "");
      return z ? "Symbol(src)_1." + z : "";
    })(), Nn = fr.toString, Me = sn.call(Object), M = RegExp(
      "^" + sn.call(yt).replace(Rt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), W = qt ? Gr.Buffer : void 0, se = Gr.Symbol, we = Gr.Uint8Array;
    W && W.allocUnsafe;
    var $e = mn(Object.getPrototypeOf, Object), ut = fr.propertyIsEnumerable, Mt = In.splice, Zt = se ? se.isConcatSpreadable : void 0, rr = se ? se.toStringTag : void 0, Br = (function() {
      try {
        var z = or(Object, "defineProperty");
        return z({}, "", {}), z;
      } catch {
      }
    })(), sr = Object.getOwnPropertySymbols, ue = W ? W.isBuffer : void 0, ze = Math.max, ct = Date.now, ft = or(Gr, "DataView"), Vt = or(Gr, "Map"), Ot = or(Gr, "Promise"), Qt = or(Gr, "Set"), zt = or(Gr, "WeakMap"), Hr = or(Object, "create"), Tr = Vr(ft), Nr = Vr(Vt), dr = Vr(Ot), vi = Vr(Qt), Xn = Vr(zt), Yr = se ? se.prototype : void 0, Wr = Yr ? Yr.valueOf : void 0, oi = Yr ? Yr.toString : void 0;
    function An(z) {
      var ce = -1, me = z == null ? 0 : z.length;
      for (this.clear(); ++ce < me; ) {
        var tt = z[ce];
        this.set(tt[0], tt[1]);
      }
    }
    function Di() {
      this.__data__ = Hr ? Hr(null) : {}, this.size = 0;
    }
    function ni(z) {
      var ce = this.has(z) && delete this.__data__[z];
      return this.size -= ce ? 1 : 0, ce;
    }
    function En(z) {
      var ce = this.__data__;
      if (Hr) {
        var me = ce[z];
        return me === i ? void 0 : me;
      }
      return yt.call(ce, z) ? ce[z] : void 0;
    }
    function ii(z) {
      var ce = this.__data__;
      return Hr ? ce[z] !== void 0 : yt.call(ce, z);
    }
    function Jn(z, ce) {
      var me = this.__data__;
      return this.size += this.has(z) ? 0 : 1, me[z] = Hr && ce === void 0 ? i : ce, this;
    }
    An.prototype.clear = Di, An.prototype.delete = ni, An.prototype.get = En, An.prototype.has = ii, An.prototype.set = Jn;
    function Un(z) {
      var ce = -1, me = z == null ? 0 : z.length;
      for (this.clear(); ++ce < me; ) {
        var tt = z[ce];
        this.set(tt[0], tt[1]);
      }
    }
    function Li() {
      this.__data__ = [], this.size = 0;
    }
    function Hi(z) {
      var ce = this.__data__, me = yr(ce, z);
      if (me < 0)
        return !1;
      var tt = ce.length - 1;
      return me == tt ? ce.pop() : Mt.call(ce, me, 1), --this.size, !0;
    }
    function ai(z) {
      var ce = this.__data__, me = yr(ce, z);
      return me < 0 ? void 0 : ce[me][1];
    }
    function Kn(z) {
      return yr(this.__data__, z) > -1;
    }
    function Vn(z, ce) {
      var me = this.__data__, tt = yr(me, z);
      return tt < 0 ? (++this.size, me.push([z, ce])) : me[tt][1] = ce, this;
    }
    Un.prototype.clear = Li, Un.prototype.delete = Hi, Un.prototype.get = ai, Un.prototype.has = Kn, Un.prototype.set = Vn;
    function Pn(z) {
      var ce = -1, me = z == null ? 0 : z.length;
      for (this.clear(); ++ce < me; ) {
        var tt = z[ce];
        this.set(tt[0], tt[1]);
      }
    }
    function kn() {
      this.size = 0, this.__data__ = {
        hash: new An(),
        map: new (Vt || Un)(),
        string: new An()
      };
    }
    function $n(z) {
      var ce = hr(this, z).delete(z);
      return this.size -= ce ? 1 : 0, ce;
    }
    function I(z) {
      return hr(this, z).get(z);
    }
    function U(z) {
      return hr(this, z).has(z);
    }
    function Y(z, ce) {
      var me = hr(this, z), tt = me.size;
      return me.set(z, ce), this.size += me.size == tt ? 0 : 1, this;
    }
    Pn.prototype.clear = kn, Pn.prototype.delete = $n, Pn.prototype.get = I, Pn.prototype.has = U, Pn.prototype.set = Y;
    function ne(z) {
      var ce = this.__data__ = new Un(z);
      this.size = ce.size;
    }
    function Ee() {
      this.__data__ = new Un(), this.size = 0;
    }
    function be(z) {
      var ce = this.__data__, me = ce.delete(z);
      return this.size = ce.size, me;
    }
    function _e(z) {
      return this.__data__.get(z);
    }
    function Ye(z) {
      return this.__data__.has(z);
    }
    function vt(z, ce) {
      var me = this.__data__;
      if (me instanceof Un) {
        var tt = me.__data__;
        if (!Vt || tt.length < t - 1)
          return tt.push([z, ce]), this.size = ++me.size, this;
        me = this.__data__ = new Pn(tt);
      }
      return me.set(z, ce), this.size = me.size, this;
    }
    ne.prototype.clear = Ee, ne.prototype.delete = be, ne.prototype.get = _e, ne.prototype.has = Ye, ne.prototype.set = vt;
    function Et(z, ce) {
      var me = ga(z), tt = !me && Eo(z), _t = !me && !tt && eo(z), nr = !me && !tt && !_t && Pe(z), On = me || tt || _t || nr, ei = On ? Gn(z.length, String) : [], Wi = ei.length;
      for (var Va in z)
        On && // Safari 9 has enumerable `arguments.length` in strict mode.
        (Va == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        _t && (Va == "offset" || Va == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        nr && (Va == "buffer" || Va == "byteLength" || Va == "byteOffset") || // Skip index properties.
        dt(Va, Wi)) || ei.push(Va);
      return ei;
    }
    function pt(z, ce, me) {
      var tt = z[ce];
      (!(yt.call(z, ce) && Ds(tt, me)) || me === void 0 && !(ce in z)) && jr(z, ce, me);
    }
    function yr(z, ce) {
      for (var me = z.length; me--; )
        if (Ds(z[me][0], ce))
          return me;
      return -1;
    }
    function jr(z, ce, me) {
      ce == "__proto__" && Br ? Br(z, ce, {
        configurable: !0,
        enumerable: !0,
        value: me,
        writable: !0
      }) : z[ce] = me;
    }
    function Dn(z, ce, me, tt, _t, nr) {
      var On;
      if (me && (On = _t ? me(z, tt, _t, nr) : me(z)), On !== void 0)
        return On;
      if (!cs(z))
        return z;
      var ei = ga(z);
      if (ei)
        On = Ie(z);
      else {
        var Wi = xe(z), Va = Wi == E || Wi == T;
        if (eo(z))
          return Ui(z);
        if (Wi == L || Wi == f || Va && !_t)
          On = {};
        else {
          if (!wt[Wi])
            return _t ? z : {};
          On = We(z, Wi);
        }
      }
      nr || (nr = new ne());
      var rl = nr.get(z);
      if (rl)
        return rl;
      nr.set(z, On), Q(z) ? z.forEach(function(Ia) {
        On.add(Dn(Ia, ce, me, Ia, z, nr));
      }) : P(z) && z.forEach(function(Ia, Rs) {
        On.set(Rs, Dn(Ia, ce, me, Rs, z, nr));
      });
      var Ul = Tt, $a = ei ? void 0 : Ul(z);
      return ln($a || z, function(Ia, Rs) {
        $a && (Rs = Ia, Ia = z[Rs]), pt(On, Rs, Dn(Ia, ce, me, Rs, z, nr));
      }), On;
    }
    function Wn(z, ce, me, tt, _t) {
      var nr = -1, On = z.length;
      for (me || (me = ot), _t || (_t = []); ++nr < On; ) {
        var ei = z[nr];
        me(ei) ? gn(_t, ei) : _t[_t.length] = ei;
      }
      return _t;
    }
    function Ri(z, ce) {
      ce = li(ce, z);
      for (var me = 0, tt = ce.length; z != null && me < tt; )
        z = z[Ta(ce[me++])];
      return me && me == tt ? z : void 0;
    }
    function yi(z, ce, me) {
      var tt = ce(z);
      return ga(z) ? tt : gn(tt, me(z));
    }
    function Zn(z) {
      return z == null ? z === void 0 ? re : _ : rr && rr in Object(z) ? xn(z) : Rn(z);
    }
    function wn(z) {
      return Fa(z) && Zn(z) == f;
    }
    function Oi(z) {
      return Fa(z) && xe(z) == D;
    }
    function Ai(z) {
      if (!cs(z) || Ur(z))
        return !1;
      var ce = us(z) ? M : ar;
      return ce.test(Vr(z));
    }
    function di(z) {
      return Fa(z) && xe(z) == H;
    }
    function ka(z) {
      return Fa(z) && Ua(z.length) && !!kt[Zn(z)];
    }
    function oa(z) {
      if (!cs(z))
        return Ar(z);
      var ce = qr(z), me = [];
      for (var tt in z)
        tt == "constructor" && (ce || !yt.call(z, tt)) || me.push(tt);
      return me;
    }
    var la = Br ? function(z, ce) {
      return Br(z, "toString", {
        configurable: !0,
        enumerable: !1,
        value: Xt(ce),
        writable: !0
      });
    } : Wt;
    function wi(z, ce, me) {
      var tt = -1, _t = z.length;
      ce < 0 && (ce = -ce > _t ? 0 : _t + ce), me = me > _t ? _t : me, me < 0 && (me += _t), _t = ce > me ? 0 : me - ce >>> 0, ce >>>= 0;
      for (var nr = Array(_t); ++tt < _t; )
        nr[tt] = z[tt + ce];
      return nr;
    }
    function Zi(z) {
      if (typeof z == "string")
        return z;
      if (ga(z))
        return Fn(z, Zi) + "";
      if (ie(z))
        return oi ? oi.call(z) : "";
      var ce = z + "";
      return ce == "0" && 1 / z == -1 / 0 ? "-0" : ce;
    }
    function Ei(z, ce) {
      ce = li(ce, z);
      var me = -1, tt = ce.length;
      if (!tt)
        return !0;
      for (; ++me < tt; ) {
        var _t = Ta(ce[me]);
        if (_t === "__proto__" && !yt.call(z, "__proto__") || (_t === "constructor" || _t === "prototype") && me < tt - 1)
          return !1;
      }
      var nr = Ya(z, ce);
      return nr == null || delete nr[Ta(os(ce))];
    }
    function li(z, ce) {
      return ga(z) ? z : Nt(z, ce) ? [z] : pi(ke(z));
    }
    function Ui(z, ce) {
      return z.slice();
    }
    function _r(z) {
      var ce = new z.constructor(z.byteLength);
      return new we(ce).set(new we(z)), ce;
    }
    function hi(z, ce) {
      var me = _r(z.buffer);
      return new z.constructor(me, z.byteOffset, z.byteLength);
    }
    function Lr(z) {
      var ce = new z.constructor(z.source, an.exec(z));
      return ce.lastIndex = z.lastIndex, ce;
    }
    function R(z) {
      return Wr ? Object(Wr.call(z)) : {};
    }
    function X(z, ce) {
      var me = _r(z.buffer);
      return new z.constructor(me, z.byteOffset, z.length);
    }
    function pe(z, ce, me, tt) {
      var _t = !me;
      me || (me = {});
      for (var nr = -1, On = ce.length; ++nr < On; ) {
        var ei = ce[nr], Wi = void 0;
        Wi === void 0 && (Wi = z[ei]), _t ? jr(me, ei, Wi) : pt(me, ei, Wi);
      }
      return me;
    }
    function Re(z) {
      return V(z) ? void 0 : z;
    }
    function Bt(z) {
      return Xa(Jr(z, void 0, ua), z + "");
    }
    function Tt(z) {
      return yi(z, Le, oe);
    }
    function hr(z, ce) {
      var me = z.__data__;
      return Yt(ce) ? me[typeof ce == "string" ? "string" : "hash"] : me.map;
    }
    function or(z, ce) {
      var me = tn(z, ce);
      return Ai(me) ? me : void 0;
    }
    function xn(z) {
      var ce = yt.call(z, rr), me = z[rr];
      try {
        z[rr] = void 0;
        var tt = !0;
      } catch {
      }
      var _t = Nn.call(z);
      return tt && (ce ? z[rr] = me : delete z[rr]), _t;
    }
    var N = sr ? function(z) {
      return z == null ? [] : (z = Object(z), en(sr(z), function(ce) {
        return ut.call(z, ce);
      }));
    } : ur, oe = sr ? function(z) {
      for (var ce = []; z; )
        gn(ce, N(z)), z = $e(z);
      return ce;
    } : ur, xe = Zn;
    (ft && xe(new ft(new ArrayBuffer(1))) != Se || Vt && xe(new Vt()) != D || Ot && xe(Ot.resolve()) != Z || Qt && xe(new Qt()) != H || zt && xe(new zt()) != ae) && (xe = function(z) {
      var ce = Zn(z), me = ce == L ? z.constructor : void 0, tt = me ? Vr(me) : "";
      if (tt)
        switch (tt) {
          case Tr:
            return Se;
          case Nr:
            return D;
          case dr:
            return Z;
          case vi:
            return H;
          case Xn:
            return ae;
        }
      return ce;
    });
    function Ie(z) {
      var ce = z.length, me = new z.constructor(ce);
      return ce && typeof z[0] == "string" && yt.call(z, "index") && (me.index = z.index, me.input = z.input), me;
    }
    function We(z, ce, me) {
      var tt = z.constructor;
      switch (ce) {
        case ye:
          return _r(z);
        case A:
        case w:
          return new tt(+z);
        case Se:
          return hi(z);
        case Xe:
        case Ve:
        case He:
        case le:
        case ve:
        case it:
        case mt:
        case qe:
        case at:
          return X(z);
        case D:
          return new tt();
        case F:
        case j:
          return new tt(z);
        case de:
          return Lr(z);
        case H:
          return new tt();
        case q:
          return R(z);
      }
    }
    function ot(z) {
      return ga(z) || Eo(z) || !!(Zt && z && z[Zt]);
    }
    function dt(z, ce) {
      var me = typeof z;
      return ce = ce ?? h, !!ce && (me == "number" || me != "symbol" && Ir.test(z)) && z > -1 && z % 1 == 0 && z < ce;
    }
    function Nt(z, ce) {
      if (ga(z))
        return !1;
      var me = typeof z;
      return me == "number" || me == "symbol" || me == "boolean" || z == null || ie(z) ? !0 : lt.test(z) || !st.test(z) || ce != null && z in Object(ce);
    }
    function Yt(z) {
      var ce = typeof z;
      return ce == "string" || ce == "number" || ce == "symbol" || ce == "boolean" ? z !== "__proto__" : z === null;
    }
    function Ur(z) {
      return !!yn && yn in z;
    }
    function qr(z) {
      var ce = z && z.constructor, me = typeof ce == "function" && ce.prototype || fr;
      return z === me;
    }
    function Dr(z) {
      var ce = ls(z, function(tt) {
        return me.size === a && me.clear(), tt;
      }), me = ce.cache;
      return ce;
    }
    function Ar(z) {
      var ce = [];
      if (z != null)
        for (var me in Object(z))
          ce.push(me);
      return ce;
    }
    function Rn(z) {
      return Nn.call(z);
    }
    function Jr(z, ce, me) {
      return ce = ze(ce === void 0 ? z.length - 1 : ce, 0), function() {
        for (var tt = arguments, _t = -1, nr = ze(tt.length - ce, 0), On = Array(nr); ++_t < nr; )
          On[_t] = tt[ce + _t];
        _t = -1;
        for (var ei = Array(ce + 1); ++_t < ce; )
          ei[_t] = tt[_t];
        return ei[ce] = me(On), vr(z, this, ei);
      };
    }
    function Ya(z, ce) {
      return ce.length < 2 ? z : Ri(z, wi(ce, 0, -1));
    }
    var Xa = Vi(la);
    function Vi(z) {
      var ce = 0, me = 0;
      return function() {
        var tt = ct(), _t = c - (tt - me);
        if (me = tt, _t > 0) {
          if (++ce >= u)
            return arguments[0];
        } else
          ce = 0;
        return z.apply(void 0, arguments);
      };
    }
    var pi = Dr(function(z) {
      var ce = [];
      return z.charCodeAt(0) === 46 && ce.push(""), z.replace(rt, function(me, tt, _t, nr) {
        ce.push(_t ? nr.replace(Fr, "$1") : tt || me);
      }), ce;
    });
    function Ta(z) {
      if (typeof z == "string" || ie(z))
        return z;
      var ce = z + "";
      return ce == "0" && 1 / z == -1 / 0 ? "-0" : ce;
    }
    function Vr(z) {
      if (z != null) {
        try {
          return sn.call(z);
        } catch {
        }
        try {
          return z + "";
        } catch {
        }
      }
      return "";
    }
    function ua(z) {
      var ce = z == null ? 0 : z.length;
      return ce ? Wn(z) : [];
    }
    function os(z) {
      var ce = z == null ? 0 : z.length;
      return ce ? z[ce - 1] : void 0;
    }
    function ls(z, ce) {
      if (typeof z != "function" || ce != null && typeof ce != "function")
        throw new TypeError(n);
      var me = function() {
        var tt = arguments, _t = ce ? ce.apply(this, tt) : tt[0], nr = me.cache;
        if (nr.has(_t))
          return nr.get(_t);
        var On = z.apply(this, tt);
        return me.cache = nr.set(_t, On) || nr, On;
      };
      return me.cache = new (ls.Cache || Pn)(), me;
    }
    ls.Cache = Pn;
    function Ds(z, ce) {
      return z === ce || z !== z && ce !== ce;
    }
    var Eo = wn(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? wn : function(z) {
      return Fa(z) && yt.call(z, "callee") && !ut.call(z, "callee");
    }, ga = Array.isArray;
    function Zs(z) {
      return z != null && Ua(z.length) && !us(z);
    }
    var eo = ue || un;
    function us(z) {
      if (!cs(z))
        return !1;
      var ce = Zn(z);
      return ce == E || ce == T || ce == m || ce == te;
    }
    function Ua(z) {
      return typeof z == "number" && z > -1 && z % 1 == 0 && z <= h;
    }
    function cs(z) {
      var ce = typeof z;
      return z != null && (ce == "object" || ce == "function");
    }
    function Fa(z) {
      return z != null && typeof z == "object";
    }
    var P = Zr ? Hn(Zr) : Oi;
    function V(z) {
      if (!Fa(z) || Zn(z) != L)
        return !1;
      var ce = $e(z);
      if (ce === null)
        return !0;
      var me = yt.call(ce, "constructor") && ce.constructor;
      return typeof me == "function" && me instanceof me && sn.call(me) == Me;
    }
    var Q = Cn ? Hn(Cn) : di;
    function ie(z) {
      return typeof z == "symbol" || Fa(z) && Zn(z) == q;
    }
    var Pe = Sn ? Hn(Sn) : ka;
    function ke(z) {
      return z == null ? "" : Zi(z);
    }
    function Le(z) {
      return Zs(z) ? Et(z) : oa(z);
    }
    var nt = Bt(function(z, ce) {
      var me = {};
      if (z == null)
        return me;
      var tt = !1;
      ce = Fn(ce, function(nr) {
        return nr = li(nr, z), tt || (tt = nr.length > 1), nr;
      }), pe(z, Tt(z), me), tt && (me = Dn(me, s | o | l, Re));
      for (var _t = ce.length; _t--; )
        Ei(me, ce[_t]);
      return me;
    });
    function Xt(z) {
      return function() {
        return z;
      };
    }
    function Wt(z) {
      return z;
    }
    function ur() {
      return [];
    }
    function un() {
      return !1;
    }
    r.exports = nt;
  })(bp, bp.exports)), bp.exports;
}
var Xj = Yj();
const Jj = /* @__PURE__ */ Iu(Xj);
function X1(r, e) {
  function t(n) {
    if (typeof n > "u" || !Array.isArray(n) && !Zj(n))
      return n;
    if (Array.isArray(n))
      return X1(n, e);
    let i = {};
    for (const [a, s] of Object.entries(n))
      i[a] = Kj(s) ? s : X1(s, e);
    return Jj(i, e);
  }
  return Array.isArray(r) ? r.map(t) : t(r);
}
function Kj(r) {
  return r == null;
}
function Zj(r) {
  return typeof r == "object" && !Array.isArray(r) && r !== null;
}
function uT(r, e) {
  return r == null && e == null ? !0 : r === e;
}
function iR(r) {
  const e = /* @__PURE__ */ new Map();
  return r?.aspects?.forEach((t) => {
    t.value !== "" && e.set(t.name, !0);
  }), e;
}
class eq extends Qw {
  constructor(e) {
    super(), this.update = e;
  }
  async execute() {
    await this.update(), await new Promise((e) => {
      window.setTimeout(() => {
        e();
      }, 1e3);
    });
  }
}
function hA(r) {
  return X1(r, ["__typename"]);
}
function aR(r) {
  return r.map((e) => {
    let t = e.type && e.storage ? {} : void 0;
    if (t)
      switch (e.type) {
        case Ji.FileUpload: {
          t.fileUpload = e.storage;
          break;
        }
        case Ji.ColorOption:
        case Ji.Option: {
          t.option = e.storage;
          break;
        }
      }
    return {
      name: e.name,
      value: e.value,
      type: e.type,
      storage: t,
      channel: e.channel,
      hidden: e.hidden
    };
  });
}
class sR {
  constructor(e, t, n, i, a) {
    this.stateUpdateQueue = new Yw(1), this.mandatoryFulfilledAspects = /* @__PURE__ */ new Map(), this.submitUpdatesToServer = !0, this.bundleId = e, this.bundleOwnerId = t, this.configuration = n, this.bundleOptions = a;
    const s = a?.existingGlobalPropertyState;
    this.initPromise = s ? Promise.resolve(s).then(() => {
      console.log("Setting global property state to existing state."), this.globalPropertyState = hA(s), this.recalculateMandatoryStates();
    }) : this.createGlobalPropertyState().then((o) => {
      console.log("Setting global property state to new state."), this.globalPropertyState = hA(o), this.recalculateMandatoryStates();
    }), this.onGlobalPropertyStateChange = i;
  }
  /** Used internally by the GlobalPropertyTemplateEditor */
  disableServerUpdates() {
    this.submitUpdatesToServer = !1;
  }
  async clearAspects(e) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    const t = this.globalPropertyState.aspects;
    this.globalPropertyState.aspects = t.filter((n) => !e.includes(n.name));
  }
  recalculateMandatoryStates() {
    this.mandatoryFulfilledAspects = iR(this.globalPropertyState);
  }
  setBundleOptions(e) {
    this.bundleOptions = e;
  }
  getBundleOptions() {
    return this.bundleOptions;
  }
  setConfiguration(e) {
    this.configuration = e;
  }
  getInitializationPromise() {
    return this.initPromise;
  }
  getGlobalPropertyState() {
    return this.globalPropertyState;
  }
  async setGlobalPropertyState(e) {
    this.globalPropertyState || await this.initPromise;
    const t = Su(this.globalPropertyState);
    this.globalPropertyState = { ...hA(e), id: t.id }, this.recalculateMandatoryStates(), this.queueGlobalPropertyStateUpdate(), await this.onGlobalPropertyStateChange(t, this.globalPropertyState);
  }
  getAspectMandatoryFulfilled(e) {
    return this.mandatoryFulfilledAspects.get(e);
  }
  getAspectHidden(e) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    return !!this.globalPropertyState.aspects.find((t) => t.name === e)?.hidden;
  }
  getAspect(e, t) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    const n = this.globalPropertyState.aspects.find((i) => i.name === e && uT(i.channel, t));
    if (n)
      return n.value;
  }
  getAspectStorage(e, t) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    return this.globalPropertyState.aspects.find((n) => n.name === e && uT(n.channel, t))?.storage;
  }
  async setAspect(e, t, n, i, a) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    if (!this.configuration)
      throw new Error("Global property configuration not linked to the state manager.");
    const s = this.configuration.aspects.find((u) => u.name === e);
    if (!s) {
      console.warn(`Failed to find configuration aspect with name: ${e}`);
      return;
    }
    this.mandatoryFulfilledAspects.set(e, t !== "");
    const o = Su(this.globalPropertyState), l = this.globalPropertyState.aspects.filter((u) => u.name === e);
    if (l.length > 0)
      if (i) {
        const u = l.find((c) => c.channel === i);
        if (u)
          u.value = t, u.type = s.type, u.channel = i, u.hidden = a ?? u.hidden, n !== void 0 && (u.storage = n !== null ? n : void 0);
        else {
          let c;
          if (i === 1) {
            const h = this.globalPropertyState.aspects.findIndex(
              (f) => !f.channel && f.name === e
            );
            h && h > 0 && (c = this.globalPropertyState.aspects.splice(h, 1)[0].hidden);
          }
          this.globalPropertyState.aspects.push({
            name: e,
            value: t,
            type: s.type,
            storage: n !== null ? n : void 0,
            channel: i,
            hidden: a ?? c
          });
        }
      } else {
        const u = l[0];
        u.value = t, u.type = s.type, u.hidden = a ?? u.hidden, n !== void 0 && (u.storage = n !== null ? n : void 0);
      }
    else
      this.globalPropertyState.aspects.push({
        name: e,
        value: t,
        type: s.type,
        storage: n !== null ? n : void 0,
        channel: i,
        hidden: a
      });
    g0(o, this.globalPropertyState) || (this.queueGlobalPropertyStateUpdate(), await this.onGlobalPropertyStateChange(o, this.globalPropertyState));
  }
  async setAspectStorage(e, t, n) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    if (!this.configuration)
      throw new Error("Global property configuration not linked to the state manager.");
    const i = this.configuration.aspects.find((o) => o.name === e);
    if (!i) {
      console.warn(`Failed to find configuration aspect with name: ${e}`);
      return;
    }
    const a = Su(this.globalPropertyState), s = this.globalPropertyState.aspects.filter((o) => o.name === e);
    if (s.length > 0)
      if (n) {
        const o = s.find((l) => l.channel === n);
        o && (o.storage = t !== null ? t : void 0, o.type = i.type);
      } else {
        const o = s[0];
        o.storage = t !== null ? t : void 0, o.type = i.type;
      }
    else
      this.globalPropertyState.aspects.push({
        name: e,
        value: "",
        type: i.type,
        storage: t !== null ? t : void 0,
        channel: n
      });
    g0(a, this.globalPropertyState) || (this.queueGlobalPropertyStateUpdate(), await this.onGlobalPropertyStateChange(a, this.globalPropertyState));
  }
  queueGlobalPropertyStateUpdate() {
    this.stateUpdateQueue.enqueue(
      new eq(async () => {
        await this.updateGlobalPropertyState();
      })
    );
  }
  async updateGlobalPropertyState() {
    if (!this.submitUpdatesToServer)
      return;
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    if (!(await et.getShadowGraphqlClient().mutate({
      mutation: BW,
      variables: {
        id: this.globalPropertyState.id,
        aspects: aR(this.globalPropertyState.aspects)
      },
      context: {
        headers: {
          bundleOwnerId: this.bundleOwnerId,
          ...this.bundleOptions?.additionalHeaders
        }
      }
    })).data?.globalPropertyStateUpdate)
      throw new Error("Unable to update global property state");
  }
  async createGlobalPropertyState() {
    const e = await et.getShadowGraphqlClient().mutate({
      mutation: OW,
      variables: {
        bundleId: this.bundleId
      },
      context: {
        headers: {
          bundleOwnerId: this.bundleOwnerId,
          ...this.bundleOptions?.additionalHeaders
        }
      }
    });
    if (e.data?.globalPropertyStateCreate && e.data.globalPropertyStateCreate.id)
      return e.data.globalPropertyStateCreate;
    throw new Error(`Unable to create global property state for bundle: ${this.bundleId}`);
  }
}
class tq {
  constructor(e) {
    this.setState(e || '{"transactions": []}');
  }
  setState(e) {
    e && (this.state = JSON.parse(e));
  }
  getState() {
    return this.state;
  }
  removeStateForTransaction(e) {
    if (!this.state || !this.state.transactions)
      return;
    const t = this.state.transactions.findIndex((n) => n.transactionId === e);
    t !== -1 && this.state.transactions.splice(t, 1);
  }
  getSerializedState() {
    if (this.state)
      return this.deleteFieldNameFromObjectRecursive(this.state, "__typename"), JSON.stringify(this.state);
  }
  deleteFieldNameFromObjectRecursive(e, t) {
    if (!(typeof e != "object" || e === null))
      for (const n in e)
        n === t ? delete e[n] : this.deleteFieldNameFromObjectRecursive(e[n], t);
  }
}
const rq = Oe`
    query GetManyMetafields($entityIds: [String!]!) {
        metafieldsMany(entityIds: $entityIds) {
            id
            value
            metafieldConfiguration {
                id
                metafieldType
                name
            }
        }
    }
`;
class nq {
  constructor() {
    this.internalMap = /* @__PURE__ */ new Map();
  }
  /**
   * Given a specific entity, request the given keys for that entity.
   * This will first check if the keys are already present in the internal map, and if not, it will fetch them from the server.
   * @param entityId The entity to check.
   * @param keys The keys to look for.
   * @returns Returns map of keys and values for the given entity. Missing keys will not be present. Use map.has() to check if a key was present.
   */
  async requestKeysForEntity(e, t) {
    const n = /* @__PURE__ */ new Map();
    return await this.ensureIdsArePresent([e]), t.forEach((i) => {
      const a = this.requestKeyForEntityIfAvailable(e, i);
      a && n.set(i, a);
    }), n;
  }
  async ensureIdsArePresent(e) {
    if (e.every((n) => this.internalMap.has(n))) return;
    const t = await et.getShadowGraphqlClient().query({
      query: rq,
      errorPolicy: "all",
      variables: {
        entityIds: e.filter((n) => !this.internalMap.has(n))
      }
    });
    e.forEach((n, i) => {
      const a = t.data.metafieldsMany[i];
      this.internalMap.set(
        n,
        a.map((s) => ({
          key: s.metafieldConfiguration.name,
          value: s.value,
          metafieldConfigurationId: s.metafieldConfiguration.id,
          metafieldType: s.metafieldConfiguration.metafieldType
        }))
      );
    });
  }
  /**
   * Returns a metafield for this product if available. Fetching from the server if not available locally.
   * @param entityId The entity to request a field for.
   * @param key The field name to request
   * @returns A promise resolving to the field if available or undefined if not.
   */
  async requestKeyForEntity(e, t) {
    if (!this.internalMap.has(e))
      return;
    let n = this.internalMap.get(e);
    const i = n.find((a) => a.key === t);
    return i || (await this.ensureIdsArePresent([e]), n = this.internalMap.get(e)), i ? JSON.parse(i.value) : void 0;
  }
  /**
   * Returns a metafield for this product if available. Checks locally only, use ensureIdsArePresent to fetch first from the server.
   * @param entityId The entity to request a field for.
   * @param key The field name to request
   * @returns A promise resolving to the field if available or undefined if not.
   */
  requestKeyForEntityIfAvailable(e, t) {
    if (!this.internalMap.has(e))
      return;
    const i = this.internalMap.get(e).find((a) => a.key === t);
    if (i)
      return JSON.parse(i.value);
  }
  /*
   * Returns a metafield for this product if available. Checks locally only, use ensureIdsArePresent to fetch first from the server.
   * The metafield value in the returned value will need to be parsed to be used.
   * Uses the metafield configuration ID as opposed to the metafield name.
   */
  requestIfAvailable(e, t) {
    return this.internalMap.has(e) ? this.internalMap.get(e).find((a) => a.metafieldConfigurationId === t) : void 0;
  }
}
const J1 = new nq();
var iq = /* @__PURE__ */ ((r) => (r.Default = "Default", r.Name = "Name", r.Price = "Price", r))(iq || {});
class oR {
  constructor(e) {
    this.fullFetched = !1, this.collection = e;
    const t = this.collection.productCollectionProducts;
    t && t.length >= this.collection.total && (this.fullFetched = !0);
  }
  /**
   * The ID of the product collection.
   */
  getId() {
    return this.collection.id;
  }
  /**
   * The name of the collection.
   */
  getName() {
    return this.collection.name;
  }
  /**
   * The description of the collection.
   */
  getDescription() {
    return this.collection.description || "";
  }
  /**
   * The start date of the dispatch.
   * @returns The start date of the dispatch or undefined if not set.
   */
  getDispatchStartDate() {
    if (this.collection.dispatchStartDate)
      return new Date(this.collection.dispatchStartDate);
  }
  /**
   * The end date of the dispatch.
   * @returns The end date of the dispatch or undefined if not set.
   */
  getDispatchEndDate() {
    if (this.collection.dispatchEndDate)
      return new Date(this.collection.dispatchEndDate);
  }
  /**
   * The image of the collection.
   */
  getImage() {
    return this.collection.image;
  }
  /**
   * A list of products in this collections with useful helpers for interacting with them.
   */
  getProducts() {
    if (!this.collection.productCollectionProducts)
      throw new Error("Failed to find products on collection. Ensure you fetch them first!");
    return this.collection.productCollectionProducts.filter((e) => !!e.product).map((e) => new ap(e));
  }
  /**
   * A list of products in this collections with useful helpers for interacting with them.
   */
  async fetchProducts(e) {
    if (this.fullFetched)
      return (this.collection.productCollectionProducts ?? []).filter((i) => !!i.product).map((i) => new ap(i));
    const t = await et.getShadowGraphqlClient().query({
      query: tT,
      variables: {
        id: this.getId(),
        productIds: e
      },
      errorPolicy: "all"
    }), n = this.collection.productCollectionProducts || [];
    return this.collection.productCollectionProducts = [
      ...n,
      ...t.data.productCollections[0].productCollectionProducts?.filter(
        (i) => !n.some((a) => i.id === a.id)
      ) || []
    ], this.collection.productCollectionProducts.length >= this.collection.total && (this.fullFetched = !0), this.collection.productCollectionProducts.filter((i) => !!i.product && (!e || e.includes(i.product.id))).map((i) => new ap(i));
  }
  /**
   * Fetches a paginated feed of products.
   * @param offset The zero-based start index.
   * @param limit The maximum number of products to return.
   * @param productFilters Optional product metafields to filter the products by.
   * @param tags Optional object of tag filters to apply.
   * @param sortKey Optional field of the products to sort by.
   * @param sortDescending Optional boolean to indicate if the sort should be in descending order.
   * @param quickSearch Optional string to filter products by name.
   * @param workflowFilters Optional workflow metafields to filter the products and their workflows by.
   * @returns
   */
  async fetchProductsFeed(e, t, n, i, a, s, o, l) {
    const u = {
      id: this.getId(),
      productFilters: n ? {
        link: "And",
        metafields: n
      } : void 0,
      productWorkflowFilters: l ? {
        link: "And",
        metafields: l
      } : void 0,
      tags: i ? {
        include: i.include ?? [],
        exclude: i.exclude ?? []
      } : void 0,
      sortKey: a,
      sortDescending: s,
      quickSearch: o
    };
    if (this.fullFetched) {
      const p = await et.getShadowGraphqlClient().query({
        query: $W,
        errorPolicy: "all",
        variables: u
      });
      if (!p.data?.productCollections || p.data?.productCollections.length === 0)
        throw new Error("Failed to filter product collection products.");
      const m = this.getProducts(), A = /* @__PURE__ */ new Map();
      for (const x of m)
        A.set(x.getId(), x);
      const w = p.data.productCollections[0].productCollectionProductsFeed.items.map((x) => A.get(x.product.id)).filter((x) => !!x);
      return {
        total: w.length,
        items: w.slice(e, e + t)
      };
    }
    const c = new AbortController(), { signal: h } = c, f = et.getShadowGraphqlClient().watchQuery({
      query: zW,
      variables: { ...u, limit: t, offset: e },
      errorPolicy: "all",
      fetchPolicy: "cache-first",
      returnPartialData: !0,
      context: {
        fetchOptions: {
          signal: h
        }
      }
    });
    return new Promise((p) => {
      let m = !1;
      const A = f.subscribe({
        next(w) {
          if (m || w.partial && (!w.data.productCollections || w.data.productCollections.length === 0 || !w.data.productCollections[0].productCollectionProductsFeed?.items || w.data.productCollections[0].productCollectionProductsFeed?.items.length === 0))
            return;
          c.abort(), m = !0, A.unsubscribe();
          const x = w.data.productCollections?.[0].productCollectionProductsFeed?.items.filter((E) => !!E.product).map((E) => new ap(Su(E))) || [];
          p({
            items: x,
            // Clone items because it could be cached data (immutable)
            total: w.data.productCollections?.[0].productCollectionProductsFeed?.total ?? 0
          });
        },
        error() {
          m || (m = !0, A.unsubscribe(), p({ items: [], total: 0 }));
        }
      });
    });
  }
  /**
   * Fetches the CollectionProducts which are linked to the provided Spiff Products.
   * @param productIds The IDs of the Spiff Product to locate.
   */
  async fetchProductsById(e) {
    const t = await et.getShadowGraphqlClient().query({
      query: tT,
      variables: {
        collectionId: this.collection.id,
        productIds: e
      },
      errorPolicy: "all"
    });
    if (t.data?.productCollection?.productCollectionProducts)
      return t.data.productCollection.productCollectionProducts.map((n) => new ap(n));
  }
  /**
   * The raw collection resource. This is generally not needed and should be avoided.
   */
  getResource() {
    return this.collection;
  }
}
class ap {
  constructor(e) {
    this.product = e.product, this.collectionProductResource = e;
  }
  /**
   * The ID of the product in SpiffCommerce.
   * @returns
   */
  getId() {
    return this.product.id;
  }
  /**
   * The name of the product. Human readable.
   */
  getName() {
    return this.product.name;
  }
  /**
   * A helper function for getting integrations
   * @param type The type of integration you want.
   * @param externalId An external integration ID to further filter by. Otherwise we return the first encountered.
   * @returns The integration if found. Throws an error if not found as this data is typically a neccesity.
   */
  getIntegrationByType(e, t) {
    const i = (this.product.integrationProducts || []).find((a) => {
      const s = a.integration?.type, o = a.integration?.type === e, l = t ? a.integration?.externalIntegrationId === t : !0;
      return s && o && l;
    });
    if (!i)
      throw new Error(
        "Failed to find requested integration type on product. This is generally due to a configuration error"
      );
    return i;
  }
  getCurrentIntegration() {
    const t = (this.product.integrationProducts || []).find((n) => n.integration?.isCurrent);
    if (!t)
      throw new Error(
        `Product: ${this.collectionProductResource.id} is not linked to this current integration. This is generally due to a configuration error.`
      );
    return t;
  }
  /**
   * A helper function for pulling the default workflow.
   */
  getDefaultWorkflow() {
    const e = this.product.workflows;
    if (e === void 0)
      throw new mc(
        "Called getDefaultWorkflow() before fetching collection products. Use collection.fetchProducts() first to ensure the data is available."
      );
    if (e.length === 0)
      throw new mc(
        "Called getDefaultWorkflow() but no workflows on requested product. Ensure at least 1 workflow is assigned to this product."
      );
    const t = this.collectionProductResource.workflowId;
    if (t) {
      const n = e.find((i) => i.workflowName === t);
      if (n) return new Ff(n);
    }
    if (this.collectionProductResource.workflows) {
      if (this.collectionProductResource.workflows.length === 1)
        return new Ff(this.collectionProductResource.workflows[0].workflowProduct);
    } else if (e.length === 1)
      return new Ff(e[0]);
    throw new mc(
      "Called getDefaultWorkflow() but no default workflow is configured for the requested product. Multiple workflows exist so we can't assume!"
    );
  }
  /**
   * @returns All workflows associated with this Product.
   */
  getAllWorkflows() {
    if ((this.product.workflows || []).length === 0)
      throw new mc(
        "No workflows on configured product. Ensure at least 1 workflow is assigned to this product."
      );
    return this.collectionProductResource.workflows && this.collectionProductResource.workflows.length > 0 ? this.collectionProductResource.workflows.map((t) => new Ff(t.workflowProduct)) : this.product.workflows.sort((t, n) => (t.index ?? 0) - (n.index ?? 0)).map((t) => new Ff(t));
  }
  /**
   * A list of all integrations this product is connected to.
   */
  getIntegrations() {
    return this.product.integrationProducts || [];
  }
  /**
   * The raw product resource. This is generally not needed and should be avoided.
   */
  getResource() {
    return this.product;
  }
  /**
   * Gets the base price of the product. Optionally include additional product pricing.
   * @param includeAdditionalProduct Optionally include additional product pricing. You must provide at least one of the fields on this object.
   * @returns
   */
  getBasePrice(e) {
    const t = this.product.basePrice || 0;
    if (!e) return t;
    if (!e.integrationType && !e.externalId && !e.integrationId)
      throw new Error(
        "You must provide at least one of the following fields on the includeAdditionalProduct object: integrationType, externalId, integrationId"
      );
    let n;
    return e.integrationId ? n = this.product.integrationProducts?.find(
      (i) => i.integration?.id === e.integrationId
    ) : e.externalId ? n = this.product.integrationProducts?.find(
      (i) => i.integration?.externalIntegrationId === e.externalId
    ) : n = this.product.integrationProducts?.find(
      (i) => i.integration?.type === e.integrationType
    ), n?.additionalIntegrationProduct?.product ? t + (n.additionalIntegrationProduct.product.basePrice || 0) : t;
  }
  /**
   * Requests a set of metafields for this product. Metafields that are not available locally will be fetched from the server.
   * @param keys The set of metafield keys to request.
   * @returns A map of metafield key to value. Any unavailable keys will not be present in the map. use map.has() to check if a key is present.
   */
  async requestMetafields(e) {
    return J1.requestKeysForEntity(this.product.id, e);
  }
}
class Ff {
  constructor(e) {
    this.workflow = e;
  }
  /**
   * @returns The ID of this workflow, to be used when starting an experience.
   */
  getId() {
    return this.workflow.workflowName;
  }
  /**
   * @returns The name of the workflow.
   */
  getName() {
    return this.workflow.friendlyName;
  }
  /**
   * An image to be used to display this workflow in a UI to the customer.
   * @returns A resource URL.
   */
  getThumbnail(e = 128, t) {
    const n = this.workflow?.imageUrl, i = window?.devicePixelRatio || 1;
    if (n)
      return $w(n, e * i, "webp", t);
  }
}
const aq = Oe`
    ${X0(!1)}
    query GetProductCollections($ids: [String!]!) {
        productCollections(ids: $ids) {
            ...ProductCollectionFields
        }
    }
`, fne = async (r) => (await et.getShadowGraphqlClient().query({
  query: aq,
  errorPolicy: "all",
  variables: {
    ids: r
  }
})).data?.productCollections?.map((t) => new oR(t));
class lR {
  constructor() {
    this.listeners = {};
  }
  // Add a listener for a specific event type
  on(e, t) {
    this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push(t);
  }
  // Remove a listener for a specific event type
  off(e, t) {
    this.listeners[e] && (this.listeners[e] = this.listeners[e].filter((n) => n !== t));
  }
  // Emit an event with the given payload
  emit(e, t) {
    if (this.listeners[e])
      for (const n of this.listeners[e])
        n(t);
  }
  // Clear all listeners for a specific event or all events
  clear(e) {
    if (e)
      delete this.listeners[e];
    else
      for (const t in this.listeners)
        delete this.listeners[t];
  }
}
function sq(r) {
  return new tR({}, {
    stateMutationFunc: (() => Promise.resolve()),
    transaction: { id: "local-transaction", product: { modelUrl: r.modelUrl } },
    graphQlClient: {},
    workflow: r.workflow,
    reloadedState: r.reloadedState
  });
}
var Cp = { exports: {} };
var oq = Cp.exports, cT;
function lq() {
  return cT || (cT = 1, (function(r, e) {
    (function() {
      var t, n = "4.18.1", i = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", o = "Invalid `variable` option passed into `_.template`", l = "Invalid `imports` option passed into `_.template`", u = "__lodash_hash_undefined__", c = 500, h = "__lodash_placeholder__", f = 1, p = 2, m = 4, A = 1, w = 2, x = 1, E = 2, T = 4, D = 8, F = 16, _ = 32, L = 64, Z = 128, te = 256, de = 512, H = 30, j = "...", q = 800, re = 16, ae = 1, ye = 2, Se = 3, Xe = 1 / 0, Ve = 9007199254740991, He = 17976931348623157e292, le = NaN, ve = 4294967295, it = ve - 1, mt = ve >>> 1, qe = [
        ["ary", Z],
        ["bind", x],
        ["bindKey", E],
        ["curry", D],
        ["curryRight", F],
        ["flip", de],
        ["partial", _],
        ["partialRight", L],
        ["rearg", te]
      ], at = "[object Arguments]", st = "[object Array]", lt = "[object AsyncFunction]", rt = "[object Boolean]", Rt = "[object Date]", Fr = "[object DOMException]", an = "[object Error]", ar = "[object Function]", Ir = "[object GeneratorFunction]", kt = "[object Map]", wt = "[object Number]", Mn = "[object Null]", kr = "[object Object]", Gr = "[object Promise]", Pr = "[object Proxy]", Cr = "[object RegExp]", qt = "[object Set]", lr = "[object String]", It = "[object Symbol]", Zr = "[object Undefined]", Cn = "[object WeakMap]", Sn = "[object WeakSet]", vr = "[object ArrayBuffer]", ln = "[object DataView]", en = "[object Float32Array]", Fn = "[object Float64Array]", gn = "[object Int8Array]", Gn = "[object Int16Array]", Hn = "[object Int32Array]", tn = "[object Uint8Array]", mn = "[object Uint8ClampedArray]", In = "[object Uint16Array]", vn = "[object Uint32Array]", fr = /\b__p \+= '';/g, Or = /\b(__p \+=) '' \+/g, sn = /(__e\(.*?\)|\b__t\)) \+\n'';/g, yt = /&(?:amp|lt|gt|quot|#39);/g, yn = /[&<>"']/g, Nn = RegExp(yt.source), Me = RegExp(yn.source), M = /<%-([\s\S]+?)%>/g, W = /<%([\s\S]+?)%>/g, se = /<%=([\s\S]+?)%>/g, we = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $e = /^\w*$/, ut = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Mt = /[\\^$.*+?()[\]{}|]/g, Zt = RegExp(Mt.source), rr = /^\s+/, Br = /\s/, sr = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ue = /\{\n\/\* \[wrapped with (.+)\] \*/, ze = /,? & /, ct = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ft = /[()=,{}\[\]\/\s]/, Vt = /\\(\\)?/g, Ot = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Qt = /\w*$/, zt = /^[-+]0x[0-9a-f]+$/i, Hr = /^0b[01]+$/i, Tr = /^\[object .+?Constructor\]$/, Nr = /^0o[0-7]+$/i, dr = /^(?:0|[1-9]\d*)$/, vi = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Xn = /($^)/, Yr = /['\n\r\u2028\u2029\\]/g, Wr = "\\ud800-\\udfff", oi = "\\u0300-\\u036f", An = "\\ufe20-\\ufe2f", Di = "\\u20d0-\\u20ff", ni = oi + An + Di, En = "\\u2700-\\u27bf", ii = "a-z\\xdf-\\xf6\\xf8-\\xff", Jn = "\\xac\\xb1\\xd7\\xf7", Un = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Li = "\\u2000-\\u206f", Hi = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ai = "A-Z\\xc0-\\xd6\\xd8-\\xde", Kn = "\\ufe0e\\ufe0f", Vn = Jn + Un + Li + Hi, Pn = "['’]", kn = "[" + Wr + "]", $n = "[" + Vn + "]", I = "[" + ni + "]", U = "\\d+", Y = "[" + En + "]", ne = "[" + ii + "]", Ee = "[^" + Wr + Vn + U + En + ii + ai + "]", be = "\\ud83c[\\udffb-\\udfff]", _e = "(?:" + I + "|" + be + ")", Ye = "[^" + Wr + "]", vt = "(?:\\ud83c[\\udde6-\\uddff]){2}", Et = "[\\ud800-\\udbff][\\udc00-\\udfff]", pt = "[" + ai + "]", yr = "\\u200d", jr = "(?:" + ne + "|" + Ee + ")", Dn = "(?:" + pt + "|" + Ee + ")", Wn = "(?:" + Pn + "(?:d|ll|m|re|s|t|ve))?", Ri = "(?:" + Pn + "(?:D|LL|M|RE|S|T|VE))?", yi = _e + "?", Zn = "[" + Kn + "]?", wn = "(?:" + yr + "(?:" + [Ye, vt, Et].join("|") + ")" + Zn + yi + ")*", Oi = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ai = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", di = Zn + yi + wn, ka = "(?:" + [Y, vt, Et].join("|") + ")" + di, oa = "(?:" + [Ye + I + "?", I, vt, Et, kn].join("|") + ")", la = RegExp(Pn, "g"), wi = RegExp(I, "g"), Zi = RegExp(be + "(?=" + be + ")|" + oa + di, "g"), Ei = RegExp([
        pt + "?" + ne + "+" + Wn + "(?=" + [$n, pt, "$"].join("|") + ")",
        Dn + "+" + Ri + "(?=" + [$n, pt + jr, "$"].join("|") + ")",
        pt + "?" + jr + "+" + Wn,
        pt + "+" + Ri,
        Ai,
        Oi,
        U,
        ka
      ].join("|"), "g"), li = RegExp("[" + yr + Wr + ni + Kn + "]"), Ui = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, _r = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], hi = -1, Lr = {};
      Lr[en] = Lr[Fn] = Lr[gn] = Lr[Gn] = Lr[Hn] = Lr[tn] = Lr[mn] = Lr[In] = Lr[vn] = !0, Lr[at] = Lr[st] = Lr[vr] = Lr[rt] = Lr[ln] = Lr[Rt] = Lr[an] = Lr[ar] = Lr[kt] = Lr[wt] = Lr[kr] = Lr[Cr] = Lr[qt] = Lr[lr] = Lr[Cn] = !1;
      var R = {};
      R[at] = R[st] = R[vr] = R[ln] = R[rt] = R[Rt] = R[en] = R[Fn] = R[gn] = R[Gn] = R[Hn] = R[kt] = R[wt] = R[kr] = R[Cr] = R[qt] = R[lr] = R[It] = R[tn] = R[mn] = R[In] = R[vn] = !0, R[an] = R[ar] = R[Cn] = !1;
      var X = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, pe = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Re = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, Bt = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Tt = parseFloat, hr = parseInt, or = typeof Ni == "object" && Ni && Ni.Object === Object && Ni, xn = typeof self == "object" && self && self.Object === Object && self, N = or || xn || Function("return this")(), oe = e && !e.nodeType && e, xe = oe && !0 && r && !r.nodeType && r, Ie = xe && xe.exports === oe, We = Ie && or.process, ot = (function() {
        try {
          var Ae = xe && xe.require && xe.require("util").types;
          return Ae || We && We.binding && We.binding("util");
        } catch {
        }
      })(), dt = ot && ot.isArrayBuffer, Nt = ot && ot.isDate, Yt = ot && ot.isMap, Ur = ot && ot.isRegExp, qr = ot && ot.isSet, Dr = ot && ot.isTypedArray;
      function Ar(Ae, Ne, De) {
        switch (De.length) {
          case 0:
            return Ae.call(Ne);
          case 1:
            return Ae.call(Ne, De[0]);
          case 2:
            return Ae.call(Ne, De[0], De[1]);
          case 3:
            return Ae.call(Ne, De[0], De[1], De[2]);
        }
        return Ae.apply(Ne, De);
      }
      function Rn(Ae, Ne, De, xt) {
        for (var pr = -1, cn = Ae == null ? 0 : Ae.length; ++pr < cn; ) {
          var xi = Ae[pr];
          Ne(xt, xi, De(xi), Ae);
        }
        return xt;
      }
      function Jr(Ae, Ne) {
        for (var De = -1, xt = Ae == null ? 0 : Ae.length; ++De < xt && Ne(Ae[De], De, Ae) !== !1; )
          ;
        return Ae;
      }
      function Ya(Ae, Ne) {
        for (var De = Ae == null ? 0 : Ae.length; De-- && Ne(Ae[De], De, Ae) !== !1; )
          ;
        return Ae;
      }
      function Xa(Ae, Ne) {
        for (var De = -1, xt = Ae == null ? 0 : Ae.length; ++De < xt; )
          if (!Ne(Ae[De], De, Ae))
            return !1;
        return !0;
      }
      function Vi(Ae, Ne) {
        for (var De = -1, xt = Ae == null ? 0 : Ae.length, pr = 0, cn = []; ++De < xt; ) {
          var xi = Ae[De];
          Ne(xi, De, Ae) && (cn[pr++] = xi);
        }
        return cn;
      }
      function pi(Ae, Ne) {
        var De = Ae == null ? 0 : Ae.length;
        return !!De && Ua(Ae, Ne, 0) > -1;
      }
      function Ta(Ae, Ne, De) {
        for (var xt = -1, pr = Ae == null ? 0 : Ae.length; ++xt < pr; )
          if (De(Ne, Ae[xt]))
            return !0;
        return !1;
      }
      function Vr(Ae, Ne) {
        for (var De = -1, xt = Ae == null ? 0 : Ae.length, pr = Array(xt); ++De < xt; )
          pr[De] = Ne(Ae[De], De, Ae);
        return pr;
      }
      function ua(Ae, Ne) {
        for (var De = -1, xt = Ne.length, pr = Ae.length; ++De < xt; )
          Ae[pr + De] = Ne[De];
        return Ae;
      }
      function os(Ae, Ne, De, xt) {
        var pr = -1, cn = Ae == null ? 0 : Ae.length;
        for (xt && cn && (De = Ae[++pr]); ++pr < cn; )
          De = Ne(De, Ae[pr], pr, Ae);
        return De;
      }
      function ls(Ae, Ne, De, xt) {
        var pr = Ae == null ? 0 : Ae.length;
        for (xt && pr && (De = Ae[--pr]); pr--; )
          De = Ne(De, Ae[pr], pr, Ae);
        return De;
      }
      function Ds(Ae, Ne) {
        for (var De = -1, xt = Ae == null ? 0 : Ae.length; ++De < xt; )
          if (Ne(Ae[De], De, Ae))
            return !0;
        return !1;
      }
      var Eo = V("length");
      function ga(Ae) {
        return Ae.split("");
      }
      function Zs(Ae) {
        return Ae.match(ct) || [];
      }
      function eo(Ae, Ne, De) {
        var xt;
        return De(Ae, function(pr, cn, xi) {
          if (Ne(pr, cn, xi))
            return xt = cn, !1;
        }), xt;
      }
      function us(Ae, Ne, De, xt) {
        for (var pr = Ae.length, cn = De + (xt ? 1 : -1); xt ? cn-- : ++cn < pr; )
          if (Ne(Ae[cn], cn, Ae))
            return cn;
        return -1;
      }
      function Ua(Ae, Ne, De) {
        return Ne === Ne ? uh(Ae, Ne, De) : us(Ae, Fa, De);
      }
      function cs(Ae, Ne, De, xt) {
        for (var pr = De - 1, cn = Ae.length; ++pr < cn; )
          if (xt(Ae[pr], Ne))
            return pr;
        return -1;
      }
      function Fa(Ae) {
        return Ae !== Ae;
      }
      function P(Ae, Ne) {
        var De = Ae == null ? 0 : Ae.length;
        return De ? ke(Ae, Ne) / De : le;
      }
      function V(Ae) {
        return function(Ne) {
          return Ne == null ? t : Ne[Ae];
        };
      }
      function Q(Ae) {
        return function(Ne) {
          return Ae == null ? t : Ae[Ne];
        };
      }
      function ie(Ae, Ne, De, xt, pr) {
        return pr(Ae, function(cn, xi, Tn) {
          De = xt ? (xt = !1, cn) : Ne(De, cn, xi, Tn);
        }), De;
      }
      function Pe(Ae, Ne) {
        var De = Ae.length;
        for (Ae.sort(Ne); De--; )
          Ae[De] = Ae[De].value;
        return Ae;
      }
      function ke(Ae, Ne) {
        for (var De, xt = -1, pr = Ae.length; ++xt < pr; ) {
          var cn = Ne(Ae[xt]);
          cn !== t && (De = De === t ? cn : De + cn);
        }
        return De;
      }
      function Le(Ae, Ne) {
        for (var De = -1, xt = Array(Ae); ++De < Ae; )
          xt[De] = Ne(De);
        return xt;
      }
      function nt(Ae, Ne) {
        return Vr(Ne, function(De) {
          return [De, Ae[De]];
        });
      }
      function Xt(Ae) {
        return Ae && Ae.slice(0, Vc(Ae) + 1).replace(rr, "");
      }
      function Wt(Ae) {
        return function(Ne) {
          return Ae(Ne);
        };
      }
      function ur(Ae, Ne) {
        return Vr(Ne, function(De) {
          return Ae[De];
        });
      }
      function un(Ae, Ne) {
        return Ae.has(Ne);
      }
      function z(Ae, Ne) {
        for (var De = -1, xt = Ae.length; ++De < xt && Ua(Ne, Ae[De], 0) > -1; )
          ;
        return De;
      }
      function ce(Ae, Ne) {
        for (var De = Ae.length; De-- && Ua(Ne, Ae[De], 0) > -1; )
          ;
        return De;
      }
      function me(Ae, Ne) {
        for (var De = Ae.length, xt = 0; De--; )
          Ae[De] === Ne && ++xt;
        return xt;
      }
      var tt = Q(X), _t = Q(pe);
      function nr(Ae) {
        return "\\" + Bt[Ae];
      }
      function On(Ae, Ne) {
        return Ae == null ? t : Ae[Ne];
      }
      function ei(Ae) {
        return li.test(Ae);
      }
      function Wi(Ae) {
        return Ui.test(Ae);
      }
      function Va(Ae) {
        for (var Ne, De = []; !(Ne = Ae.next()).done; )
          De.push(Ne.value);
        return De;
      }
      function rl(Ae) {
        var Ne = -1, De = Array(Ae.size);
        return Ae.forEach(function(xt, pr) {
          De[++Ne] = [pr, xt];
        }), De;
      }
      function Ul(Ae, Ne) {
        return function(De) {
          return Ae(Ne(De));
        };
      }
      function $a(Ae, Ne) {
        for (var De = -1, xt = Ae.length, pr = 0, cn = []; ++De < xt; ) {
          var xi = Ae[De];
          (xi === Ne || xi === h) && (Ae[De] = h, cn[pr++] = De);
        }
        return cn;
      }
      function Ia(Ae) {
        var Ne = -1, De = Array(Ae.size);
        return Ae.forEach(function(xt) {
          De[++Ne] = xt;
        }), De;
      }
      function Rs(Ae) {
        var Ne = -1, De = Array(Ae.size);
        return Ae.forEach(function(xt) {
          De[++Ne] = [xt, xt];
        }), De;
      }
      function uh(Ae, Ne, De) {
        for (var xt = De - 1, pr = Ae.length; ++xt < pr; )
          if (Ae[xt] === Ne)
            return xt;
        return -1;
      }
      function ch(Ae, Ne, De) {
        for (var xt = De + 1; xt--; )
          if (Ae[xt] === Ne)
            return xt;
        return xt;
      }
      function Bi(Ae) {
        return ei(Ae) ? Pa(Ae) : Eo(Ae);
      }
      function Ja(Ae) {
        return ei(Ae) ? jf(Ae) : ga(Ae);
      }
      function Vc(Ae) {
        for (var Ne = Ae.length; Ne-- && Br.test(Ae.charAt(Ne)); )
          ;
        return Ne;
      }
      var Du = Q(Re);
      function Pa(Ae) {
        for (var Ne = Zi.lastIndex = 0; Zi.test(Ae); )
          ++Ne;
        return Ne;
      }
      function jf(Ae) {
        return Ae.match(Zi) || [];
      }
      function Ru(Ae) {
        return Ae.match(Ei) || [];
      }
      var Ou = (function Ae(Ne) {
        Ne = Ne == null ? N : Os.defaults(N.Object(), Ne, Os.pick(N, _r));
        var De = Ne.Array, xt = Ne.Date, pr = Ne.Error, cn = Ne.Function, xi = Ne.Math, Tn = Ne.Object, Bu = Ne.RegExp, fh = Ne.String, za = Ne.TypeError, _u = De.prototype, $c = cn.prototype, Bn = Tn.prototype, to = Ne["__core-js_shared__"], Vl = $c.toString, pn = Bn.hasOwnProperty, ti = 0, ko = (function() {
          var d = /[^.]+$/.exec(to && to.keys && to.keys.IE_PROTO || "");
          return d ? "Symbol(src)_1." + d : "";
        })(), nl = Bn.toString, zc = Vl.call(Tn), Gc = N._, Hc = Bu(
          "^" + Vl.call(pn).replace(Mt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), $l = Ie ? Ne.Buffer : t, Bs = Ne.Symbol, To = Ne.Uint8Array, zl = $l ? $l.allocUnsafe : t, ro = Ul(Tn.getPrototypeOf, Tn), Mu = Tn.create, Fo = Bn.propertyIsEnumerable, il = _u.splice, no = Bs ? Bs.isConcatSpreadable : t, Io = Bs ? Bs.iterator : t, Ka = Bs ? Bs.toStringTag : t, Nu = (function() {
          try {
            var d = pf(Tn, "defineProperty");
            return d({}, "", {}), d;
          } catch {
          }
        })(), Gl = Ne.clearTimeout !== N.clearTimeout && Ne.clearTimeout, qf = xt && xt.now !== N.Date.now && xt.now, Wc = Ne.setTimeout !== N.setTimeout && Ne.setTimeout, Po = xi.ceil, Do = xi.floor, al = Tn.getOwnPropertySymbols, Hl = $l ? $l.isBuffer : t, sl = Ne.isFinite, Qf = _u.join, Ro = Ul(Tn.keys, Tn), gi = xi.max, ui = xi.min, jc = xt.now, Oo = Ne.parseInt, Wl = xi.random, io = _u.reverse, ol = pf(Ne, "DataView"), ao = pf(Ne, "Map"), Bo = pf(Ne, "Promise"), fs = pf(Ne, "Set"), ll = pf(Ne, "WeakMap"), ul = pf(Tn, "create"), jl = ll && new ll(), Da = {}, qc = gf(ol), dh = gf(ao), Yf = gf(Bo), cl = gf(fs), ql = gf(ll), fl = Bs ? Bs.prototype : t, so = fl ? fl.valueOf : t, Ql = fl ? fl.toString : t;
        function J(d) {
          if ($i(d) && !zr(d) && !(d instanceof $r)) {
            if (d instanceof ea)
              return d;
            if (pn.call(d, "__wrapped__"))
              return Xb(d);
          }
          return new ea(d);
        }
        var Za = /* @__PURE__ */ (function() {
          function d() {
          }
          return function(v) {
            if (!Mi(v))
              return {};
            if (Mu)
              return Mu(v);
            d.prototype = v;
            var S = new d();
            return d.prototype = t, S;
          };
        })();
        function oo() {
        }
        function ea(d, v) {
          this.__wrapped__ = d, this.__actions__ = [], this.__chain__ = !!v, this.__index__ = 0, this.__values__ = t;
        }
        J.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: M,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: W,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: se,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: J
          }
        }, J.prototype = oo.prototype, J.prototype.constructor = J, ea.prototype = Za(oo.prototype), ea.prototype.constructor = ea;
        function $r(d) {
          this.__wrapped__ = d, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ve, this.__views__ = [];
        }
        function Yl() {
          var d = new $r(this.__wrapped__);
          return d.__actions__ = ra(this.__actions__), d.__dir__ = this.__dir__, d.__filtered__ = this.__filtered__, d.__iteratees__ = ra(this.__iteratees__), d.__takeCount__ = this.__takeCount__, d.__views__ = ra(this.__views__), d;
        }
        function Lu() {
          if (this.__filtered__) {
            var d = new $r(this);
            d.__dir__ = -1, d.__filtered__ = !0;
          } else
            d = this.clone(), d.__dir__ *= -1;
          return d;
        }
        function Uu() {
          var d = this.__wrapped__.value(), v = this.__dir__, S = zr(d), O = v < 0, G = S ? d.length : 0, ee = AO(0, G, this.__views__), he = ee.start, ge = ee.end, Ce = ge - he, je = O ? ge : he - 1, Qe = this.__iteratees__, Ke = Qe.length, Ct = 0, Ht = ui(Ce, this.__takeCount__);
          if (!S || !O && G == Ce && Ht == Ce)
            return ta(d, this.__actions__);
          var mr = [];
          e:
            for (; Ce-- && Ct < Ht; ) {
              je += v;
              for (var Kr = -1, cr = d[je]; ++Kr < Ke; ) {
                var dn = Qe[Kr], bn = dn.iteratee, Hs = dn.type, is = bn(cr);
                if (Hs == ye)
                  cr = is;
                else if (!is) {
                  if (Hs == ae)
                    continue e;
                  break e;
                }
              }
              mr[Ct++] = cr;
            }
          return mr;
        }
        $r.prototype = Za(oo.prototype), $r.prototype.constructor = $r;
        function _s(d) {
          var v = -1, S = d == null ? 0 : d.length;
          for (this.clear(); ++v < S; ) {
            var O = d[v];
            this.set(O[0], O[1]);
          }
        }
        function Xf() {
          this.__data__ = ul ? ul(null) : {}, this.size = 0;
        }
        function Jf(d) {
          var v = this.has(d) && delete this.__data__[d];
          return this.size -= v ? 1 : 0, v;
        }
        function Kf(d) {
          var v = this.__data__;
          if (ul) {
            var S = v[d];
            return S === u ? t : S;
          }
          return pn.call(v, d) ? v[d] : t;
        }
        function hh(d) {
          var v = this.__data__;
          return ul ? v[d] !== t : pn.call(v, d);
        }
        function Zf(d, v) {
          var S = this.__data__;
          return this.size += this.has(d) ? 0 : 1, S[d] = ul && v === t ? u : v, this;
        }
        _s.prototype.clear = Xf, _s.prototype.delete = Jf, _s.prototype.get = Kf, _s.prototype.has = hh, _s.prototype.set = Zf;
        function Ms(d) {
          var v = -1, S = d == null ? 0 : d.length;
          for (this.clear(); ++v < S; ) {
            var O = d[v];
            this.set(O[0], O[1]);
          }
        }
        function ph() {
          this.__data__ = [], this.size = 0;
        }
        function Qc(d) {
          var v = this.__data__, S = hs(v, d);
          if (S < 0)
            return !1;
          var O = v.length - 1;
          return S == O ? v.pop() : il.call(v, S, 1), --this.size, !0;
        }
        function Xl(d) {
          var v = this.__data__, S = hs(v, d);
          return S < 0 ? t : v[S][1];
        }
        function gh(d) {
          return hs(this.__data__, d) > -1;
        }
        function mh(d, v) {
          var S = this.__data__, O = hs(S, d);
          return O < 0 ? (++this.size, S.push([d, v])) : S[O][1] = v, this;
        }
        Ms.prototype.clear = ph, Ms.prototype.delete = Qc, Ms.prototype.get = Xl, Ms.prototype.has = gh, Ms.prototype.set = mh;
        function es(d) {
          var v = -1, S = d == null ? 0 : d.length;
          for (this.clear(); ++v < S; ) {
            var O = d[v];
            this.set(O[0], O[1]);
          }
        }
        function Vu() {
          this.size = 0, this.__data__ = {
            hash: new _s(),
            map: new (ao || Ms)(),
            string: new _s()
          };
        }
        function vh(d) {
          var v = kg(this, d).delete(d);
          return this.size -= v ? 1 : 0, v;
        }
        function yh(d) {
          return kg(this, d).get(d);
        }
        function Ah(d) {
          return kg(this, d).has(d);
        }
        function Ns(d, v) {
          var S = kg(this, d), O = S.size;
          return S.set(d, v), this.size += S.size == O ? 0 : 1, this;
        }
        es.prototype.clear = Vu, es.prototype.delete = vh, es.prototype.get = yh, es.prototype.has = Ah, es.prototype.set = Ns;
        function Ls(d) {
          var v = -1, S = d == null ? 0 : d.length;
          for (this.__data__ = new es(); ++v < S; )
            this.add(d[v]);
        }
        function $u(d) {
          return this.__data__.set(d, u), this;
        }
        function jn(d) {
          return this.__data__.has(d);
        }
        Ls.prototype.add = Ls.prototype.push = $u, Ls.prototype.has = jn;
        function ci(d) {
          var v = this.__data__ = new Ms(d);
          this.size = v.size;
        }
        function dl() {
          this.__data__ = new Ms(), this.size = 0;
        }
        function _o(d) {
          var v = this.__data__, S = v.delete(d);
          return this.size = v.size, S;
        }
        function fn(d) {
          return this.__data__.get(d);
        }
        function lo(d) {
          return this.__data__.has(d);
        }
        function zu(d, v) {
          var S = this.__data__;
          if (S instanceof Ms) {
            var O = S.__data__;
            if (!ao || O.length < i - 1)
              return O.push([d, v]), this.size = ++S.size, this;
            S = this.__data__ = new es(O);
          }
          return S.set(d, v), this.size = S.size, this;
        }
        ci.prototype.clear = dl, ci.prototype.delete = _o, ci.prototype.get = fn, ci.prototype.has = lo, ci.prototype.set = zu;
        function ma(d, v) {
          var S = zr(d), O = !S && mf(d), G = !S && !O && ic(d), ee = !S && !O && !G && cd(d), he = S || O || G || ee, ge = he ? Le(d.length, fh) : [], Ce = ge.length;
          for (var je in d)
            (v || pn.call(d, je)) && !(he && // Safari 9 has enumerable `arguments.length` in strict mode.
            (je == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            G && (je == "offset" || je == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            ee && (je == "buffer" || je == "byteLength" || je == "byteOffset") || // Skip index properties.
            hu(je, Ce))) && ge.push(je);
          return ge;
        }
        function va(d) {
          var v = d.length;
          return v ? d[su(0, v - 1)] : t;
        }
        function ds(d, v) {
          return Tg(ra(d), gs(v, 0, d.length));
        }
        function wh(d) {
          return Tg(ra(d));
        }
        function Ra(d, v, S) {
          (S !== t && !Vo(d[v], S) || S === t && !(v in d)) && ps(d, v, S);
        }
        function Ga(d, v, S) {
          var O = d[v];
          (!(pn.call(d, v) && Vo(O, S)) || S === t && !(v in d)) && ps(d, v, S);
        }
        function hs(d, v) {
          for (var S = d.length; S--; )
            if (Vo(d[S][0], v))
              return S;
          return -1;
        }
        function xh(d, v, S, O) {
          return Us(d, function(G, ee, he) {
            v(O, G, S(G), he);
          }), O;
        }
        function Gu(d, v) {
          return d && rs(v, wa(v), d);
        }
        function Jl(d, v) {
          return d && rs(v, Cs(v), d);
        }
        function ps(d, v, S) {
          v == "__proto__" && Nu ? Nu(d, v, {
            configurable: !0,
            enumerable: !0,
            value: S,
            writable: !0
          }) : d[v] = S;
        }
        function Yc(d, v) {
          for (var S = -1, O = v.length, G = De(O), ee = d == null; ++S < O; )
            G[S] = ee ? t : wv(d, v[S]);
          return G;
        }
        function gs(d, v, S) {
          return d === d && (S !== t && (d = d <= S ? d : S), v !== t && (d = d >= v ? d : v)), d;
        }
        function ya(d, v, S, O, G, ee) {
          var he, ge = v & f, Ce = v & p, je = v & m;
          if (S && (he = G ? S(d, O, G, ee) : S(d)), he !== t)
            return he;
          if (!Mi(d))
            return d;
          var Qe = zr(d);
          if (Qe) {
            if (he = xO(d), !ge)
              return ra(d, he);
          } else {
            var Ke = Wa(d), Ct = Ke == ar || Ke == Ir;
            if (ic(d))
              return xl(d, ge);
            if (Ke == kr || Ke == at || Ct && !G) {
              if (he = Ce || Ct ? {} : $b(d), !ge)
                return Ce ? ld(d, Jl(he, d)) : Ih(d, Gu(he, d));
            } else {
              if (!R[Ke])
                return G ? d : {};
              he = bO(d, Ke, ge);
            }
          }
          ee || (ee = new ci());
          var Ht = ee.get(d);
          if (Ht)
            return Ht;
          ee.set(d, he), mC(d) ? d.forEach(function(cr) {
            he.add(ya(cr, v, S, cr, d, ee));
          }) : pC(d) && d.forEach(function(cr, dn) {
            he.set(dn, ya(cr, v, S, dn, d, ee));
          });
          var mr = je ? Ce ? av : iv : Ce ? Cs : wa, Kr = Qe ? t : mr(d);
          return Jr(Kr || d, function(cr, dn) {
            Kr && (dn = cr, cr = d[dn]), Ga(he, dn, ya(cr, v, S, dn, d, ee));
          }), he;
        }
        function ed(d) {
          var v = wa(d);
          return function(S) {
            return Xc(S, d, v);
          };
        }
        function Xc(d, v, S) {
          var O = S.length;
          if (d == null)
            return !O;
          for (d = Tn(d); O--; ) {
            var G = S[O], ee = v[G], he = d[G];
            if (he === t && !(G in d) || !ee(he))
              return !1;
          }
          return !0;
        }
        function Hu(d, v, S) {
          if (typeof d != "function")
            throw new za(s);
          return Rh(function() {
            d.apply(t, S);
          }, v);
        }
        function Kl(d, v, S, O) {
          var G = -1, ee = pi, he = !0, ge = d.length, Ce = [], je = v.length;
          if (!ge)
            return Ce;
          S && (v = Vr(v, Wt(S))), O ? (ee = Ta, he = !1) : v.length >= i && (ee = un, he = !1, v = new Ls(v));
          e:
            for (; ++G < ge; ) {
              var Qe = d[G], Ke = S == null ? Qe : S(Qe);
              if (Qe = O || Qe !== 0 ? Qe : 0, he && Ke === Ke) {
                for (var Ct = je; Ct--; )
                  if (v[Ct] === Ke)
                    continue e;
                Ce.push(Qe);
              } else ee(v, Ke, O) || Ce.push(Qe);
            }
          return Ce;
        }
        var Us = g(ts), Jc = g(eu, !0);
        function bh(d, v) {
          var S = !0;
          return Us(d, function(O, G, ee) {
            return S = !!v(O, G, ee), S;
          }), S;
        }
        function Wu(d, v, S) {
          for (var O = -1, G = d.length; ++O < G; ) {
            var ee = d[O], he = v(ee);
            if (he != null && (ge === t ? he === he && !Gs(he) : S(he, ge)))
              var ge = he, Ce = ee;
          }
          return Ce;
        }
        function Ch(d, v, S, O) {
          var G = d.length;
          for (S = Xr(S), S < 0 && (S = -S > G ? 0 : G + S), O = O === t || O > G ? G : Xr(O), O < 0 && (O += G), O = S > O ? 0 : yC(O); S < O; )
            d[S++] = v;
          return d;
        }
        function td(d, v) {
          var S = [];
          return Us(d, function(O, G, ee) {
            v(O, G, ee) && S.push(O);
          }), S;
        }
        function ji(d, v, S, O, G) {
          var ee = -1, he = d.length;
          for (S || (S = SO), G || (G = []); ++ee < he; ) {
            var ge = d[ee];
            v > 0 && S(ge) ? v > 1 ? ji(ge, v - 1, S, O, G) : ua(G, ge) : O || (G[G.length] = ge);
          }
          return G;
        }
        var Kc = y(), Zl = y(!0);
        function ts(d, v) {
          return d && Kc(d, v, wa);
        }
        function eu(d, v) {
          return d && Zl(d, v, wa);
        }
        function tu(d, v) {
          return Vi(v, function(S) {
            return pu(d[S]);
          });
        }
        function ms(d, v) {
          v = zs(v, d);
          for (var S = 0, O = v.length; d != null && S < O; )
            d = d[Uo(v[S++])];
          return S && S == O ? d : t;
        }
        function ru(d, v, S) {
          var O = v(d);
          return zr(d) ? O : ua(O, S(d));
        }
        function _i(d) {
          return d == null ? d === t ? Zr : Mn : Ka && Ka in Tn(d) ? yO(d) : DO(d);
        }
        function hl(d, v) {
          return d > v;
        }
        function pl(d, v) {
          return d != null && pn.call(d, v);
        }
        function ju(d, v) {
          return d != null && v in Tn(d);
        }
        function qu(d, v, S) {
          return d >= ui(v, S) && d < gi(v, S);
        }
        function gl(d, v, S) {
          for (var O = S ? Ta : pi, G = d[0].length, ee = d.length, he = ee, ge = De(ee), Ce = 1 / 0, je = []; he--; ) {
            var Qe = d[he];
            he && v && (Qe = Vr(Qe, Wt(v))), Ce = ui(Qe.length, Ce), ge[he] = !S && (v || G >= 120 && Qe.length >= 120) ? new Ls(he && Qe) : t;
          }
          Qe = d[0];
          var Ke = -1, Ct = ge[0];
          e:
            for (; ++Ke < G && je.length < Ce; ) {
              var Ht = Qe[Ke], mr = v ? v(Ht) : Ht;
              if (Ht = S || Ht !== 0 ? Ht : 0, !(Ct ? un(Ct, mr) : O(je, mr, S))) {
                for (he = ee; --he; ) {
                  var Kr = ge[he];
                  if (!(Kr ? un(Kr, mr) : O(d[he], mr, S)))
                    continue e;
                }
                Ct && Ct.push(mr), je.push(Ht);
              }
            }
          return je;
        }
        function ml(d, v, S, O) {
          return ts(d, function(G, ee, he) {
            v(O, S(G), ee, he);
          }), O;
        }
        function Mo(d, v, S) {
          v = zs(v, d), d = Wb(d, v);
          var O = d == null ? d : d[Uo(vo(v))];
          return O == null ? t : Ar(O, d, S);
        }
        function uo(d) {
          return $i(d) && _i(d) == at;
        }
        function rd(d) {
          return $i(d) && _i(d) == vr;
        }
        function Sh(d) {
          return $i(d) && _i(d) == Rt;
        }
        function vs(d, v, S, O, G) {
          return d === v ? !0 : d == null || v == null || !$i(d) && !$i(v) ? d !== d && v !== v : vl(d, v, S, O, vs, G);
        }
        function vl(d, v, S, O, G, ee) {
          var he = zr(d), ge = zr(v), Ce = he ? st : Wa(d), je = ge ? st : Wa(v);
          Ce = Ce == at ? kr : Ce, je = je == at ? kr : je;
          var Qe = Ce == kr, Ke = je == kr, Ct = Ce == je;
          if (Ct && ic(d)) {
            if (!ic(v))
              return !1;
            he = !0, Qe = !1;
          }
          if (Ct && !Qe)
            return ee || (ee = new ci()), he || cd(d) ? Lb(d, v, S, O, G, ee) : mO(d, v, Ce, S, O, G, ee);
          if (!(S & A)) {
            var Ht = Qe && pn.call(d, "__wrapped__"), mr = Ke && pn.call(v, "__wrapped__");
            if (Ht || mr) {
              var Kr = Ht ? d.value() : d, cr = mr ? v.value() : v;
              return ee || (ee = new ci()), G(Kr, cr, S, O, ee);
            }
          }
          return Ct ? (ee || (ee = new ci()), vO(d, v, S, O, G, ee)) : !1;
        }
        function Eh(d) {
          return $i(d) && Wa(d) == kt;
        }
        function Zc(d, v, S, O) {
          var G = S.length, ee = G, he = !O;
          if (d == null)
            return !ee;
          for (d = Tn(d); G--; ) {
            var ge = S[G];
            if (he && ge[2] ? ge[1] !== d[ge[0]] : !(ge[0] in d))
              return !1;
          }
          for (; ++G < ee; ) {
            ge = S[G];
            var Ce = ge[0], je = d[Ce], Qe = ge[1];
            if (he && ge[2]) {
              if (je === t && !(Ce in d))
                return !1;
            } else {
              var Ke = new ci();
              if (O)
                var Ct = O(je, Qe, Ce, d, v, Ke);
              if (!(Ct === t ? vs(Qe, je, A | w, O, Ke) : Ct))
                return !1;
            }
          }
          return !0;
        }
        function co(d) {
          if (!Mi(d) || kO(d))
            return !1;
          var v = pu(d) ? Hc : Tr;
          return v.test(gf(d));
        }
        function Qu(d) {
          return $i(d) && _i(d) == Cr;
        }
        function Vs(d) {
          return $i(d) && Wa(d) == qt;
        }
        function ef(d) {
          return $i(d) && Og(d.length) && !!Lr[_i(d)];
        }
        function fo(d) {
          return typeof d == "function" ? d : d == null ? Ss : typeof d == "object" ? zr(d) ? yl(d[0], d[1]) : nu(d) : PC(d);
        }
        function No(d) {
          if (!Dh(d))
            return Ro(d);
          var v = [];
          for (var S in Tn(d))
            pn.call(d, S) && S != "constructor" && v.push(S);
          return v;
        }
        function $s(d) {
          if (!Mi(d))
            return PO(d);
          var v = Dh(d), S = [];
          for (var O in d)
            O == "constructor" && (v || !pn.call(d, O)) || S.push(O);
          return S;
        }
        function Ha(d, v) {
          return d < v;
        }
        function ys(d, v) {
          var S = -1, O = bs(d) ? De(d.length) : [];
          return Us(d, function(G, ee, he) {
            O[++S] = v(G, ee, he);
          }), O;
        }
        function nu(d) {
          var v = ov(d);
          return v.length == 1 && v[0][2] ? Gb(v[0][0], v[0][1]) : function(S) {
            return S === d || Zc(S, d, v);
          };
        }
        function yl(d, v) {
          return uv(d) && zb(v) ? Gb(Uo(d), v) : function(S) {
            var O = wv(S, d);
            return O === t && O === v ? xv(S, d) : vs(v, O, A | w);
          };
        }
        function Aa(d, v, S, O, G) {
          d !== v && Kc(v, function(ee, he) {
            if (G || (G = new ci()), Mi(ee))
              iu(d, v, he, S, Aa, O, G);
            else {
              var ge = O ? O(fv(d, he), ee, he + "", d, v, G) : t;
              ge === t && (ge = ee), Ra(d, he, ge);
            }
          }, Cs);
        }
        function iu(d, v, S, O, G, ee, he) {
          var ge = fv(d, S), Ce = fv(v, S), je = he.get(Ce);
          if (je) {
            Ra(d, S, je);
            return;
          }
          var Qe = ee ? ee(ge, Ce, S + "", d, v, he) : t, Ke = Qe === t;
          if (Ke) {
            var Ct = zr(Ce), Ht = !Ct && ic(Ce), mr = !Ct && !Ht && cd(Ce);
            Qe = Ce, Ct || Ht || mr ? zr(ge) ? Qe = ge : Qi(ge) ? Qe = ra(ge) : Ht ? (Ke = !1, Qe = xl(Ce, !0)) : mr ? (Ke = !1, Qe = df(Ce, !0)) : Qe = [] : Oh(Ce) || mf(Ce) ? (Qe = ge, mf(ge) ? Qe = AC(ge) : (!Mi(ge) || pu(ge)) && (Qe = $b(Ce))) : Ke = !1;
          }
          Ke && (he.set(Ce, Qe), G(Qe, Ce, O, ee, he), he.delete(Ce)), Ra(d, S, Qe);
        }
        function Yu(d, v) {
          var S = d.length;
          if (S)
            return v += v < 0 ? S : 0, hu(v, S) ? d[v] : t;
        }
        function Al(d, v, S) {
          v.length ? v = Vr(v, function(ee) {
            return zr(ee) ? function(he) {
              return ms(he, ee.length === 1 ? ee[0] : ee);
            } : ee;
          }) : v = [Ss];
          var O = -1;
          v = Vr(v, Wt(gr()));
          var G = ys(d, function(ee, he, ge) {
            var Ce = Vr(v, function(je) {
              return je(ee);
            });
            return { criteria: Ce, index: ++O, value: ee };
          });
          return Pe(G, function(ee, he) {
            return sd(ee, he, S);
          });
        }
        function au(d, v) {
          return tf(d, v, function(S, O) {
            return xv(d, O);
          });
        }
        function tf(d, v, S) {
          for (var O = -1, G = v.length, ee = {}; ++O < G; ) {
            var he = v[O], ge = ms(d, he);
            S(ge, he) && Lo(ee, zs(he, d), ge);
          }
          return ee;
        }
        function kh(d) {
          return function(v) {
            return ms(v, d);
          };
        }
        function Xu(d, v, S, O) {
          var G = O ? cs : Ua, ee = -1, he = v.length, ge = d;
          for (d === v && (v = ra(v)), S && (ge = Vr(d, Wt(S))); ++ee < he; )
            for (var Ce = 0, je = v[ee], Qe = S ? S(je) : je; (Ce = G(ge, Qe, Ce, O)) > -1; )
              ge !== d && il.call(ge, Ce, 1), il.call(d, Ce, 1);
          return d;
        }
        function wl(d, v) {
          for (var S = d ? v.length : 0, O = S - 1; S--; ) {
            var G = v[S];
            if (S == O || G !== ee) {
              var ee = G;
              hu(G) ? il.call(d, G, 1) : of(d, G);
            }
          }
          return d;
        }
        function su(d, v) {
          return d + Do(Wl() * (v - d + 1));
        }
        function nd(d, v, S, O) {
          for (var G = -1, ee = gi(Po((v - d) / (S || 1)), 0), he = De(ee); ee--; )
            he[O ? ee : ++G] = d, d += S;
          return he;
        }
        function ou(d, v) {
          var S = "";
          if (!d || v < 1 || v > Ve)
            return S;
          do
            v % 2 && (S += d), v = Do(v / 2), v && (d += d);
          while (v);
          return S;
        }
        function Sr(d, v) {
          return dv(Hb(d, v, Ss), d + "");
        }
        function rf(d) {
          return va(fd(d));
        }
        function nf(d, v) {
          var S = fd(d);
          return Tg(S, gs(v, 0, S.length));
        }
        function Lo(d, v, S, O) {
          if (!Mi(d))
            return d;
          v = zs(v, d);
          for (var G = -1, ee = v.length, he = ee - 1, ge = d; ge != null && ++G < ee; ) {
            var Ce = Uo(v[G]), je = S;
            if (Ce === "__proto__" || Ce === "constructor" || Ce === "prototype")
              return d;
            if (G != he) {
              var Qe = ge[Ce];
              je = O ? O(Qe, Ce, ge) : t, je === t && (je = Mi(Qe) ? Qe : hu(v[G + 1]) ? [] : {});
            }
            Ga(ge, Ce, je), ge = ge[Ce];
          }
          return d;
        }
        var af = jl ? function(d, v) {
          return jl.set(d, v), d;
        } : Ss, id = Nu ? function(d, v) {
          return Nu(d, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Cv(v),
            writable: !0
          });
        } : Ss;
        function sf(d) {
          return Tg(fd(d));
        }
        function Oa(d, v, S) {
          var O = -1, G = d.length;
          v < 0 && (v = -v > G ? 0 : G + v), S = S > G ? G : S, S < 0 && (S += G), G = v > S ? 0 : S - v >>> 0, v >>>= 0;
          for (var ee = De(G); ++O < G; )
            ee[O] = d[O + v];
          return ee;
        }
        function Th(d, v) {
          var S;
          return Us(d, function(O, G, ee) {
            return S = v(O, G, ee), !S;
          }), !!S;
        }
        function Ju(d, v, S) {
          var O = 0, G = d == null ? O : d.length;
          if (typeof v == "number" && v === v && G <= mt) {
            for (; O < G; ) {
              var ee = O + G >>> 1, he = d[ee];
              he !== null && !Gs(he) && (S ? he <= v : he < v) ? O = ee + 1 : G = ee;
            }
            return G;
          }
          return Ku(d, v, Ss, S);
        }
        function Ku(d, v, S, O) {
          var G = 0, ee = d == null ? 0 : d.length;
          if (ee === 0)
            return 0;
          v = S(v);
          for (var he = v !== v, ge = v === null, Ce = Gs(v), je = v === t; G < ee; ) {
            var Qe = Do((G + ee) / 2), Ke = S(d[Qe]), Ct = Ke !== t, Ht = Ke === null, mr = Ke === Ke, Kr = Gs(Ke);
            if (he)
              var cr = O || mr;
            else je ? cr = mr && (O || Ct) : ge ? cr = mr && Ct && (O || !Ht) : Ce ? cr = mr && Ct && !Ht && (O || !Kr) : Ht || Kr ? cr = !1 : cr = O ? Ke <= v : Ke < v;
            cr ? G = Qe + 1 : ee = Qe;
          }
          return ui(ee, it);
        }
        function ad(d, v) {
          for (var S = -1, O = d.length, G = 0, ee = []; ++S < O; ) {
            var he = d[S], ge = v ? v(he) : he;
            if (!S || !Vo(ge, Ce)) {
              var Ce = ge;
              ee[G++] = he === 0 ? 0 : he;
            }
          }
          return ee;
        }
        function Zu(d) {
          return typeof d == "number" ? d : Gs(d) ? le : +d;
        }
        function Ba(d) {
          if (typeof d == "string")
            return d;
          if (zr(d))
            return Vr(d, Ba) + "";
          if (Gs(d))
            return Ql ? Ql.call(d) : "";
          var v = d + "";
          return v == "0" && 1 / d == -Xe ? "-0" : v;
        }
        function ki(d, v, S) {
          var O = -1, G = pi, ee = d.length, he = !0, ge = [], Ce = ge;
          if (S)
            he = !1, G = Ta;
          else if (ee >= i) {
            var je = v ? null : Ph(d);
            if (je)
              return Ia(je);
            he = !1, G = un, Ce = new Ls();
          } else
            Ce = v ? [] : ge;
          e:
            for (; ++O < ee; ) {
              var Qe = d[O], Ke = v ? v(Qe) : Qe;
              if (Qe = S || Qe !== 0 ? Qe : 0, he && Ke === Ke) {
                for (var Ct = Ce.length; Ct--; )
                  if (Ce[Ct] === Ke)
                    continue e;
                v && Ce.push(Ke), ge.push(Qe);
              } else G(Ce, Ke, S) || (Ce !== ge && Ce.push(Ke), ge.push(Qe));
            }
          return ge;
        }
        function of(d, v) {
          v = zs(v, d);
          var S = -1, O = v.length;
          if (!O)
            return !0;
          for (; ++S < O; ) {
            var G = Uo(v[S]);
            if (G === "__proto__" && !pn.call(d, "__proto__") || (G === "constructor" || G === "prototype") && S < O - 1)
              return !1;
          }
          var ee = Wb(d, v);
          return ee == null || delete ee[Uo(vo(v))];
        }
        function lu(d, v, S, O) {
          return Lo(d, v, S(ms(d, v)), O);
        }
        function ec(d, v, S, O) {
          for (var G = d.length, ee = O ? G : -1; (O ? ee-- : ++ee < G) && v(d[ee], ee, d); )
            ;
          return S ? Oa(d, O ? 0 : ee, O ? ee + 1 : G) : Oa(d, O ? ee + 1 : 0, O ? G : ee);
        }
        function ta(d, v) {
          var S = d;
          return S instanceof $r && (S = S.value()), os(v, function(O, G) {
            return G.func.apply(G.thisArg, ua([O], G.args));
          }, S);
        }
        function lf(d, v, S) {
          var O = d.length;
          if (O < 2)
            return O ? ki(d[0]) : [];
          for (var G = -1, ee = De(O); ++G < O; )
            for (var he = d[G], ge = -1; ++ge < O; )
              ge != G && (ee[G] = Kl(ee[G] || he, d[ge], v, S));
          return ki(ji(ee, 1), v, S);
        }
        function uf(d, v, S) {
          for (var O = -1, G = d.length, ee = v.length, he = {}; ++O < G; ) {
            var ge = O < ee ? v[O] : t;
            S(he, d[O], ge);
          }
          return he;
        }
        function tc(d) {
          return Qi(d) ? d : [];
        }
        function ho(d) {
          return typeof d == "function" ? d : Ss;
        }
        function zs(d, v) {
          return zr(d) ? d : uv(d, v) ? [d] : Yb(qn(d));
        }
        var Fh = Sr;
        function As(d, v, S) {
          var O = d.length;
          return S = S === t ? O : S, !v && S >= O ? d : Oa(d, v, S);
        }
        var po = Gl || function(d) {
          return N.clearTimeout(d);
        };
        function xl(d, v) {
          if (v)
            return d.slice();
          var S = d.length, O = zl ? zl(S) : new d.constructor(S);
          return d.copy(O), O;
        }
        function cf(d) {
          var v = new d.constructor(d.byteLength);
          return new To(v).set(new To(d)), v;
        }
        function ff(d, v) {
          var S = v ? cf(d.buffer) : d.buffer;
          return new d.constructor(S, d.byteOffset, d.byteLength);
        }
        function uu(d) {
          var v = new d.constructor(d.source, Qt.exec(d));
          return v.lastIndex = d.lastIndex, v;
        }
        function rc(d) {
          return so ? Tn(so.call(d)) : {};
        }
        function df(d, v) {
          var S = v ? cf(d.buffer) : d.buffer;
          return new d.constructor(S, d.byteOffset, d.length);
        }
        function cu(d, v) {
          if (d !== v) {
            var S = d !== t, O = d === null, G = d === d, ee = Gs(d), he = v !== t, ge = v === null, Ce = v === v, je = Gs(v);
            if (!ge && !je && !ee && d > v || ee && he && Ce && !ge && !je || O && he && Ce || !S && Ce || !G)
              return 1;
            if (!O && !ee && !je && d < v || je && S && G && !O && !ee || ge && S && G || !he && G || !Ce)
              return -1;
          }
          return 0;
        }
        function sd(d, v, S) {
          for (var O = -1, G = d.criteria, ee = v.criteria, he = G.length, ge = S.length; ++O < he; ) {
            var Ce = cu(G[O], ee[O]);
            if (Ce) {
              if (O >= ge)
                return Ce;
              var je = S[O];
              return Ce * (je == "desc" ? -1 : 1);
            }
          }
          return d.index - v.index;
        }
        function od(d, v, S, O) {
          for (var G = -1, ee = d.length, he = S.length, ge = -1, Ce = v.length, je = gi(ee - he, 0), Qe = De(Ce + je), Ke = !O; ++ge < Ce; )
            Qe[ge] = v[ge];
          for (; ++G < he; )
            (Ke || G < ee) && (Qe[S[G]] = d[G]);
          for (; je--; )
            Qe[ge++] = d[G++];
          return Qe;
        }
        function hf(d, v, S, O) {
          for (var G = -1, ee = d.length, he = -1, ge = S.length, Ce = -1, je = v.length, Qe = gi(ee - ge, 0), Ke = De(Qe + je), Ct = !O; ++G < Qe; )
            Ke[G] = d[G];
          for (var Ht = G; ++Ce < je; )
            Ke[Ht + Ce] = v[Ce];
          for (; ++he < ge; )
            (Ct || G < ee) && (Ke[Ht + S[he]] = d[G++]);
          return Ke;
        }
        function ra(d, v) {
          var S = -1, O = d.length;
          for (v || (v = De(O)); ++S < O; )
            v[S] = d[S];
          return v;
        }
        function rs(d, v, S, O) {
          var G = !S;
          S || (S = {});
          for (var ee = -1, he = v.length; ++ee < he; ) {
            var ge = v[ee], Ce = O ? O(S[ge], d[ge], ge, S, d) : t;
            Ce === t && (Ce = d[ge]), G ? ps(S, ge, Ce) : Ga(S, ge, Ce);
          }
          return S;
        }
        function Ih(d, v) {
          return rs(d, lv(d), v);
        }
        function ld(d, v) {
          return rs(d, Ub(d), v);
        }
        function nc(d, v) {
          return function(S, O) {
            var G = zr(S) ? Rn : xh, ee = v ? v() : {};
            return G(S, d, gr(O, 2), ee);
          };
        }
        function b(d) {
          return Sr(function(v, S) {
            var O = -1, G = S.length, ee = G > 1 ? S[G - 1] : t, he = G > 2 ? S[2] : t;
            for (ee = d.length > 3 && typeof ee == "function" ? (G--, ee) : t, he && ns(S[0], S[1], he) && (ee = G < 3 ? t : ee, G = 1), v = Tn(v); ++O < G; ) {
              var ge = S[O];
              ge && d(v, ge, O, ee);
            }
            return v;
          });
        }
        function g(d, v) {
          return function(S, O) {
            if (S == null)
              return S;
            if (!bs(S))
              return d(S, O);
            for (var G = S.length, ee = v ? G : -1, he = Tn(S); (v ? ee-- : ++ee < G) && O(he[ee], ee, he) !== !1; )
              ;
            return S;
          };
        }
        function y(d) {
          return function(v, S, O) {
            for (var G = -1, ee = Tn(v), he = O(v), ge = he.length; ge--; ) {
              var Ce = he[d ? ge : ++G];
              if (S(ee[Ce], Ce, ee) === !1)
                break;
            }
            return v;
          };
        }
        function C(d, v, S) {
          var O = v & x, G = $(d);
          function ee() {
            var he = this && this !== N && this instanceof ee ? G : d;
            return he.apply(O ? S : this, arguments);
          }
          return ee;
        }
        function k(d) {
          return function(v) {
            v = qn(v);
            var S = ei(v) ? Ja(v) : t, O = S ? S[0] : v.charAt(0), G = S ? As(S, 1).join("") : v.slice(1);
            return O[d]() + G;
          };
        }
        function B(d) {
          return function(v) {
            return os(FC(TC(v).replace(la, "")), d, "");
          };
        }
        function $(d) {
          return function() {
            var v = arguments;
            switch (v.length) {
              case 0:
                return new d();
              case 1:
                return new d(v[0]);
              case 2:
                return new d(v[0], v[1]);
              case 3:
                return new d(v[0], v[1], v[2]);
              case 4:
                return new d(v[0], v[1], v[2], v[3]);
              case 5:
                return new d(v[0], v[1], v[2], v[3], v[4]);
              case 6:
                return new d(v[0], v[1], v[2], v[3], v[4], v[5]);
              case 7:
                return new d(v[0], v[1], v[2], v[3], v[4], v[5], v[6]);
            }
            var S = Za(d.prototype), O = d.apply(S, v);
            return Mi(O) ? O : S;
          };
        }
        function K(d, v, S) {
          var O = $(d);
          function G() {
            for (var ee = arguments.length, he = De(ee), ge = ee, Ce = ud(G); ge--; )
              he[ge] = arguments[ge];
            var je = ee < 3 && he[0] !== Ce && he[ee - 1] !== Ce ? [] : $a(he, Ce);
            if (ee -= je.length, ee < S)
              return xs(
                d,
                v,
                Ue,
                G.placeholder,
                t,
                he,
                je,
                t,
                t,
                S - ee
              );
            var Qe = this && this !== N && this instanceof G ? O : d;
            return Ar(Qe, this, he);
          }
          return G;
        }
        function fe(d) {
          return function(v, S, O) {
            var G = Tn(v);
            if (!bs(v)) {
              var ee = gr(S, 3);
              v = wa(v), S = function(ge) {
                return ee(G[ge], ge, G);
              };
            }
            var he = d(v, S, O);
            return he > -1 ? G[ee ? v[he] : he] : t;
          };
        }
        function Te(d) {
          return du(function(v) {
            var S = v.length, O = S, G = ea.prototype.thru;
            for (d && v.reverse(); O--; ) {
              var ee = v[O];
              if (typeof ee != "function")
                throw new za(s);
              if (G && !he && Eg(ee) == "wrapper")
                var he = new ea([], !0);
            }
            for (O = he ? O : S; ++O < S; ) {
              ee = v[O];
              var ge = Eg(ee), Ce = ge == "wrapper" ? sv(ee) : t;
              Ce && cv(Ce[0]) && Ce[1] == (Z | D | _ | te) && !Ce[4].length && Ce[9] == 1 ? he = he[Eg(Ce[0])].apply(he, Ce[3]) : he = ee.length == 1 && cv(ee) ? he[ge]() : he.thru(ee);
            }
            return function() {
              var je = arguments, Qe = je[0];
              if (he && je.length == 1 && zr(Qe))
                return he.plant(Qe).value();
              for (var Ke = 0, Ct = S ? v[Ke].apply(this, je) : Qe; ++Ke < S; )
                Ct = v[Ke].call(this, Ct);
              return Ct;
            };
          });
        }
        function Ue(d, v, S, O, G, ee, he, ge, Ce, je) {
          var Qe = v & Z, Ke = v & x, Ct = v & E, Ht = v & (D | F), mr = v & de, Kr = Ct ? t : $(d);
          function cr() {
            for (var dn = arguments.length, bn = De(dn), Hs = dn; Hs--; )
              bn[Hs] = arguments[Hs];
            if (Ht)
              var is = ud(cr), Ws = me(bn, is);
            if (O && (bn = od(bn, O, G, Ht)), ee && (bn = hf(bn, ee, he, Ht)), dn -= Ws, Ht && dn < je) {
              var Yi = $a(bn, is);
              return xs(
                d,
                v,
                Ue,
                cr.placeholder,
                S,
                bn,
                Yi,
                ge,
                Ce,
                je - dn
              );
            }
            var $o = Ke ? S : this, mu = Ct ? $o[d] : d;
            return dn = bn.length, ge ? bn = RO(bn, ge) : mr && dn > 1 && bn.reverse(), Qe && Ce < dn && (bn.length = Ce), this && this !== N && this instanceof cr && (mu = Kr || $(mu)), mu.apply($o, bn);
          }
          return cr;
        }
        function Je(d, v) {
          return function(S, O) {
            return ml(S, d, v(O), {});
          };
        }
        function ht(d, v) {
          return function(S, O) {
            var G;
            if (S === t && O === t)
              return v;
            if (S !== t && (G = S), O !== t) {
              if (G === t)
                return O;
              typeof S == "string" || typeof O == "string" ? (S = Ba(S), O = Ba(O)) : (S = Zu(S), O = Zu(O)), G = d(S, O);
            }
            return G;
          };
        }
        function ir(d) {
          return du(function(v) {
            return v = Vr(v, Wt(gr())), Sr(function(S) {
              var O = this;
              return d(v, function(G) {
                return Ar(G, O, S);
              });
            });
          });
        }
        function rn(d, v) {
          v = v === t ? " " : Ba(v);
          var S = v.length;
          if (S < 2)
            return S ? ou(v, d) : v;
          var O = ou(v, Po(d / Bi(v)));
          return ei(v) ? As(Ja(O), 0, d).join("") : O.slice(0, d);
        }
        function qi(d, v, S, O) {
          var G = v & x, ee = $(d);
          function he() {
            for (var ge = -1, Ce = arguments.length, je = -1, Qe = O.length, Ke = De(Qe + Ce), Ct = this && this !== N && this instanceof he ? ee : d; ++je < Qe; )
              Ke[je] = O[je];
            for (; Ce--; )
              Ke[je++] = arguments[++ge];
            return Ar(Ct, G ? S : this, Ke);
          }
          return he;
        }
        function go(d) {
          return function(v, S, O) {
            return O && typeof O != "number" && ns(v, S, O) && (S = O = t), v = gu(v), S === t ? (S = v, v = 0) : S = gu(S), O = O === t ? v < S ? 1 : -1 : gu(O), nd(v, S, O, d);
          };
        }
        function ws(d) {
          return function(v, S) {
            return typeof v == "string" && typeof S == "string" || (v = yo(v), S = yo(S)), d(v, S);
          };
        }
        function xs(d, v, S, O, G, ee, he, ge, Ce, je) {
          var Qe = v & D, Ke = Qe ? he : t, Ct = Qe ? t : he, Ht = Qe ? ee : t, mr = Qe ? t : ee;
          v |= Qe ? _ : L, v &= ~(Qe ? L : _), v & T || (v &= -4);
          var Kr = [
            d,
            v,
            G,
            Ht,
            Ke,
            mr,
            Ct,
            ge,
            Ce,
            je
          ], cr = S.apply(t, Kr);
          return cv(d) && jb(cr, Kr), cr.placeholder = O, qb(cr, d, v);
        }
        function mo(d) {
          var v = xi[d];
          return function(S, O) {
            if (S = yo(S), O = O == null ? 0 : ui(Xr(O), 292), O && sl(S)) {
              var G = (qn(S) + "e").split("e"), ee = v(G[0] + "e" + (+G[1] + O));
              return G = (qn(ee) + "e").split("e"), +(G[0] + "e" + (+G[1] - O));
            }
            return v(S);
          };
        }
        var Ph = fs && 1 / Ia(new fs([, -0]))[1] == Xe ? function(d) {
          return new fs(d);
        } : kv;
        function Sg(d) {
          return function(v) {
            var S = Wa(v);
            return S == kt ? rl(v) : S == qt ? Rs(v) : nt(v, d(v));
          };
        }
        function fu(d, v, S, O, G, ee, he, ge) {
          var Ce = v & E;
          if (!Ce && typeof d != "function")
            throw new za(s);
          var je = O ? O.length : 0;
          if (je || (v &= -97, O = G = t), he = he === t ? he : gi(Xr(he), 0), ge = ge === t ? ge : Xr(ge), je -= G ? G.length : 0, v & L) {
            var Qe = O, Ke = G;
            O = G = t;
          }
          var Ct = Ce ? t : sv(d), Ht = [
            d,
            v,
            S,
            O,
            G,
            Qe,
            Ke,
            ee,
            he,
            ge
          ];
          if (Ct && IO(Ht, Ct), d = Ht[0], v = Ht[1], S = Ht[2], O = Ht[3], G = Ht[4], ge = Ht[9] = Ht[9] === t ? Ce ? 0 : d.length : gi(Ht[9] - je, 0), !ge && v & (D | F) && (v &= -25), !v || v == x)
            var mr = C(d, v, S);
          else v == D || v == F ? mr = K(d, v, ge) : (v == _ || v == (x | _)) && !G.length ? mr = qi(d, v, S, O) : mr = Ue.apply(t, Ht);
          var Kr = Ct ? af : jb;
          return qb(Kr(mr, Ht), d, v);
        }
        function Mb(d, v, S, O) {
          return d === t || Vo(d, Bn[S]) && !pn.call(O, S) ? v : d;
        }
        function Nb(d, v, S, O, G, ee) {
          return Mi(d) && Mi(v) && (ee.set(v, d), Aa(d, v, t, Nb, ee), ee.delete(v)), d;
        }
        function gO(d) {
          return Oh(d) ? t : d;
        }
        function Lb(d, v, S, O, G, ee) {
          var he = S & A, ge = d.length, Ce = v.length;
          if (ge != Ce && !(he && Ce > ge))
            return !1;
          var je = ee.get(d), Qe = ee.get(v);
          if (je && Qe)
            return je == v && Qe == d;
          var Ke = -1, Ct = !0, Ht = S & w ? new Ls() : t;
          for (ee.set(d, v), ee.set(v, d); ++Ke < ge; ) {
            var mr = d[Ke], Kr = v[Ke];
            if (O)
              var cr = he ? O(Kr, mr, Ke, v, d, ee) : O(mr, Kr, Ke, d, v, ee);
            if (cr !== t) {
              if (cr)
                continue;
              Ct = !1;
              break;
            }
            if (Ht) {
              if (!Ds(v, function(dn, bn) {
                if (!un(Ht, bn) && (mr === dn || G(mr, dn, S, O, ee)))
                  return Ht.push(bn);
              })) {
                Ct = !1;
                break;
              }
            } else if (!(mr === Kr || G(mr, Kr, S, O, ee))) {
              Ct = !1;
              break;
            }
          }
          return ee.delete(d), ee.delete(v), Ct;
        }
        function mO(d, v, S, O, G, ee, he) {
          switch (S) {
            case ln:
              if (d.byteLength != v.byteLength || d.byteOffset != v.byteOffset)
                return !1;
              d = d.buffer, v = v.buffer;
            case vr:
              return !(d.byteLength != v.byteLength || !ee(new To(d), new To(v)));
            case rt:
            case Rt:
            case wt:
              return Vo(+d, +v);
            case an:
              return d.name == v.name && d.message == v.message;
            case Cr:
            case lr:
              return d == v + "";
            case kt:
              var ge = rl;
            case qt:
              var Ce = O & A;
              if (ge || (ge = Ia), d.size != v.size && !Ce)
                return !1;
              var je = he.get(d);
              if (je)
                return je == v;
              O |= w, he.set(d, v);
              var Qe = Lb(ge(d), ge(v), O, G, ee, he);
              return he.delete(d), Qe;
            case It:
              if (so)
                return so.call(d) == so.call(v);
          }
          return !1;
        }
        function vO(d, v, S, O, G, ee) {
          var he = S & A, ge = iv(d), Ce = ge.length, je = iv(v), Qe = je.length;
          if (Ce != Qe && !he)
            return !1;
          for (var Ke = Ce; Ke--; ) {
            var Ct = ge[Ke];
            if (!(he ? Ct in v : pn.call(v, Ct)))
              return !1;
          }
          var Ht = ee.get(d), mr = ee.get(v);
          if (Ht && mr)
            return Ht == v && mr == d;
          var Kr = !0;
          ee.set(d, v), ee.set(v, d);
          for (var cr = he; ++Ke < Ce; ) {
            Ct = ge[Ke];
            var dn = d[Ct], bn = v[Ct];
            if (O)
              var Hs = he ? O(bn, dn, Ct, v, d, ee) : O(dn, bn, Ct, d, v, ee);
            if (!(Hs === t ? dn === bn || G(dn, bn, S, O, ee) : Hs)) {
              Kr = !1;
              break;
            }
            cr || (cr = Ct == "constructor");
          }
          if (Kr && !cr) {
            var is = d.constructor, Ws = v.constructor;
            is != Ws && "constructor" in d && "constructor" in v && !(typeof is == "function" && is instanceof is && typeof Ws == "function" && Ws instanceof Ws) && (Kr = !1);
          }
          return ee.delete(d), ee.delete(v), Kr;
        }
        function du(d) {
          return dv(Hb(d, t, Zb), d + "");
        }
        function iv(d) {
          return ru(d, wa, lv);
        }
        function av(d) {
          return ru(d, Cs, Ub);
        }
        var sv = jl ? function(d) {
          return jl.get(d);
        } : kv;
        function Eg(d) {
          for (var v = d.name + "", S = Da[v], O = pn.call(Da, v) ? S.length : 0; O--; ) {
            var G = S[O], ee = G.func;
            if (ee == null || ee == d)
              return G.name;
          }
          return v;
        }
        function ud(d) {
          var v = pn.call(J, "placeholder") ? J : d;
          return v.placeholder;
        }
        function gr() {
          var d = J.iteratee || Sv;
          return d = d === Sv ? fo : d, arguments.length ? d(arguments[0], arguments[1]) : d;
        }
        function kg(d, v) {
          var S = d.__data__;
          return EO(v) ? S[typeof v == "string" ? "string" : "hash"] : S.map;
        }
        function ov(d) {
          for (var v = wa(d), S = v.length; S--; ) {
            var O = v[S], G = d[O];
            v[S] = [O, G, zb(G)];
          }
          return v;
        }
        function pf(d, v) {
          var S = On(d, v);
          return co(S) ? S : t;
        }
        function yO(d) {
          var v = pn.call(d, Ka), S = d[Ka];
          try {
            d[Ka] = t;
            var O = !0;
          } catch {
          }
          var G = nl.call(d);
          return O && (v ? d[Ka] = S : delete d[Ka]), G;
        }
        var lv = al ? function(d) {
          return d == null ? [] : (d = Tn(d), Vi(al(d), function(v) {
            return Fo.call(d, v);
          }));
        } : Tv, Ub = al ? function(d) {
          for (var v = []; d; )
            ua(v, lv(d)), d = ro(d);
          return v;
        } : Tv, Wa = _i;
        (ol && Wa(new ol(new ArrayBuffer(1))) != ln || ao && Wa(new ao()) != kt || Bo && Wa(Bo.resolve()) != Gr || fs && Wa(new fs()) != qt || ll && Wa(new ll()) != Cn) && (Wa = function(d) {
          var v = _i(d), S = v == kr ? d.constructor : t, O = S ? gf(S) : "";
          if (O)
            switch (O) {
              case qc:
                return ln;
              case dh:
                return kt;
              case Yf:
                return Gr;
              case cl:
                return qt;
              case ql:
                return Cn;
            }
          return v;
        });
        function AO(d, v, S) {
          for (var O = -1, G = S.length; ++O < G; ) {
            var ee = S[O], he = ee.size;
            switch (ee.type) {
              case "drop":
                d += he;
                break;
              case "dropRight":
                v -= he;
                break;
              case "take":
                v = ui(v, d + he);
                break;
              case "takeRight":
                d = gi(d, v - he);
                break;
            }
          }
          return { start: d, end: v };
        }
        function wO(d) {
          var v = d.match(ue);
          return v ? v[1].split(ze) : [];
        }
        function Vb(d, v, S) {
          v = zs(v, d);
          for (var O = -1, G = v.length, ee = !1; ++O < G; ) {
            var he = Uo(v[O]);
            if (!(ee = d != null && S(d, he)))
              break;
            d = d[he];
          }
          return ee || ++O != G ? ee : (G = d == null ? 0 : d.length, !!G && Og(G) && hu(he, G) && (zr(d) || mf(d)));
        }
        function xO(d) {
          var v = d.length, S = new d.constructor(v);
          return v && typeof d[0] == "string" && pn.call(d, "index") && (S.index = d.index, S.input = d.input), S;
        }
        function $b(d) {
          return typeof d.constructor == "function" && !Dh(d) ? Za(ro(d)) : {};
        }
        function bO(d, v, S) {
          var O = d.constructor;
          switch (v) {
            case vr:
              return cf(d);
            case rt:
            case Rt:
              return new O(+d);
            case ln:
              return ff(d, S);
            case en:
            case Fn:
            case gn:
            case Gn:
            case Hn:
            case tn:
            case mn:
            case In:
            case vn:
              return df(d, S);
            case kt:
              return new O();
            case wt:
            case lr:
              return new O(d);
            case Cr:
              return uu(d);
            case qt:
              return new O();
            case It:
              return rc(d);
          }
        }
        function CO(d, v) {
          var S = v.length;
          if (!S)
            return d;
          var O = S - 1;
          return v[O] = (S > 1 ? "& " : "") + v[O], v = v.join(S > 2 ? ", " : " "), d.replace(sr, `{
/* [wrapped with ` + v + `] */
`);
        }
        function SO(d) {
          return zr(d) || mf(d) || !!(no && d && d[no]);
        }
        function hu(d, v) {
          var S = typeof d;
          return v = v ?? Ve, !!v && (S == "number" || S != "symbol" && dr.test(d)) && d > -1 && d % 1 == 0 && d < v;
        }
        function ns(d, v, S) {
          if (!Mi(S))
            return !1;
          var O = typeof v;
          return (O == "number" ? bs(S) && hu(v, S.length) : O == "string" && v in S) ? Vo(S[v], d) : !1;
        }
        function uv(d, v) {
          if (zr(d))
            return !1;
          var S = typeof d;
          return S == "number" || S == "symbol" || S == "boolean" || d == null || Gs(d) ? !0 : $e.test(d) || !we.test(d) || v != null && d in Tn(v);
        }
        function EO(d) {
          var v = typeof d;
          return v == "string" || v == "number" || v == "symbol" || v == "boolean" ? d !== "__proto__" : d === null;
        }
        function cv(d) {
          var v = Eg(d), S = J[v];
          if (typeof S != "function" || !(v in $r.prototype))
            return !1;
          if (d === S)
            return !0;
          var O = sv(S);
          return !!O && d === O[0];
        }
        function kO(d) {
          return !!ko && ko in d;
        }
        var TO = to ? pu : Fv;
        function Dh(d) {
          var v = d && d.constructor, S = typeof v == "function" && v.prototype || Bn;
          return d === S;
        }
        function zb(d) {
          return d === d && !Mi(d);
        }
        function Gb(d, v) {
          return function(S) {
            return S == null ? !1 : S[d] === v && (v !== t || d in Tn(S));
          };
        }
        function FO(d) {
          var v = Dg(d, function(O) {
            return S.size === c && S.clear(), O;
          }), S = v.cache;
          return v;
        }
        function IO(d, v) {
          var S = d[1], O = v[1], G = S | O, ee = G < (x | E | Z), he = O == Z && S == D || O == Z && S == te && d[7].length <= v[8] || O == (Z | te) && v[7].length <= v[8] && S == D;
          if (!(ee || he))
            return d;
          O & x && (d[2] = v[2], G |= S & x ? 0 : T);
          var ge = v[3];
          if (ge) {
            var Ce = d[3];
            d[3] = Ce ? od(Ce, ge, v[4]) : ge, d[4] = Ce ? $a(d[3], h) : v[4];
          }
          return ge = v[5], ge && (Ce = d[5], d[5] = Ce ? hf(Ce, ge, v[6]) : ge, d[6] = Ce ? $a(d[5], h) : v[6]), ge = v[7], ge && (d[7] = ge), O & Z && (d[8] = d[8] == null ? v[8] : ui(d[8], v[8])), d[9] == null && (d[9] = v[9]), d[0] = v[0], d[1] = G, d;
        }
        function PO(d) {
          var v = [];
          if (d != null)
            for (var S in Tn(d))
              v.push(S);
          return v;
        }
        function DO(d) {
          return nl.call(d);
        }
        function Hb(d, v, S) {
          return v = gi(v === t ? d.length - 1 : v, 0), function() {
            for (var O = arguments, G = -1, ee = gi(O.length - v, 0), he = De(ee); ++G < ee; )
              he[G] = O[v + G];
            G = -1;
            for (var ge = De(v + 1); ++G < v; )
              ge[G] = O[G];
            return ge[v] = S(he), Ar(d, this, ge);
          };
        }
        function Wb(d, v) {
          return v.length < 2 ? d : ms(d, Oa(v, 0, -1));
        }
        function RO(d, v) {
          for (var S = d.length, O = ui(v.length, S), G = ra(d); O--; ) {
            var ee = v[O];
            d[O] = hu(ee, S) ? G[ee] : t;
          }
          return d;
        }
        function fv(d, v) {
          if (!(v === "constructor" && typeof d[v] == "function") && v != "__proto__")
            return d[v];
        }
        var jb = Qb(af), Rh = Wc || function(d, v) {
          return N.setTimeout(d, v);
        }, dv = Qb(id);
        function qb(d, v, S) {
          var O = v + "";
          return dv(d, CO(O, OO(wO(O), S)));
        }
        function Qb(d) {
          var v = 0, S = 0;
          return function() {
            var O = jc(), G = re - (O - S);
            if (S = O, G > 0) {
              if (++v >= q)
                return arguments[0];
            } else
              v = 0;
            return d.apply(t, arguments);
          };
        }
        function Tg(d, v) {
          var S = -1, O = d.length, G = O - 1;
          for (v = v === t ? O : v; ++S < v; ) {
            var ee = su(S, G), he = d[ee];
            d[ee] = d[S], d[S] = he;
          }
          return d.length = v, d;
        }
        var Yb = FO(function(d) {
          var v = [];
          return d.charCodeAt(0) === 46 && v.push(""), d.replace(ut, function(S, O, G, ee) {
            v.push(G ? ee.replace(Vt, "$1") : O || S);
          }), v;
        });
        function Uo(d) {
          if (typeof d == "string" || Gs(d))
            return d;
          var v = d + "";
          return v == "0" && 1 / d == -Xe ? "-0" : v;
        }
        function gf(d) {
          if (d != null) {
            try {
              return Vl.call(d);
            } catch {
            }
            try {
              return d + "";
            } catch {
            }
          }
          return "";
        }
        function OO(d, v) {
          return Jr(qe, function(S) {
            var O = "_." + S[0];
            v & S[1] && !pi(d, O) && d.push(O);
          }), d.sort();
        }
        function Xb(d) {
          if (d instanceof $r)
            return d.clone();
          var v = new ea(d.__wrapped__, d.__chain__);
          return v.__actions__ = ra(d.__actions__), v.__index__ = d.__index__, v.__values__ = d.__values__, v;
        }
        function BO(d, v, S) {
          (S ? ns(d, v, S) : v === t) ? v = 1 : v = gi(Xr(v), 0);
          var O = d == null ? 0 : d.length;
          if (!O || v < 1)
            return [];
          for (var G = 0, ee = 0, he = De(Po(O / v)); G < O; )
            he[ee++] = Oa(d, G, G += v);
          return he;
        }
        function _O(d) {
          for (var v = -1, S = d == null ? 0 : d.length, O = 0, G = []; ++v < S; ) {
            var ee = d[v];
            ee && (G[O++] = ee);
          }
          return G;
        }
        function MO() {
          var d = arguments.length;
          if (!d)
            return [];
          for (var v = De(d - 1), S = arguments[0], O = d; O--; )
            v[O - 1] = arguments[O];
          return ua(zr(S) ? ra(S) : [S], ji(v, 1));
        }
        var NO = Sr(function(d, v) {
          return Qi(d) ? Kl(d, ji(v, 1, Qi, !0)) : [];
        }), LO = Sr(function(d, v) {
          var S = vo(v);
          return Qi(S) && (S = t), Qi(d) ? Kl(d, ji(v, 1, Qi, !0), gr(S, 2)) : [];
        }), UO = Sr(function(d, v) {
          var S = vo(v);
          return Qi(S) && (S = t), Qi(d) ? Kl(d, ji(v, 1, Qi, !0), t, S) : [];
        });
        function VO(d, v, S) {
          var O = d == null ? 0 : d.length;
          return O ? (v = S || v === t ? 1 : Xr(v), Oa(d, v < 0 ? 0 : v, O)) : [];
        }
        function $O(d, v, S) {
          var O = d == null ? 0 : d.length;
          return O ? (v = S || v === t ? 1 : Xr(v), v = O - v, Oa(d, 0, v < 0 ? 0 : v)) : [];
        }
        function zO(d, v) {
          return d && d.length ? ec(d, gr(v, 3), !0, !0) : [];
        }
        function GO(d, v) {
          return d && d.length ? ec(d, gr(v, 3), !0) : [];
        }
        function HO(d, v, S, O) {
          var G = d == null ? 0 : d.length;
          return G ? (S && typeof S != "number" && ns(d, v, S) && (S = 0, O = G), Ch(d, v, S, O)) : [];
        }
        function Jb(d, v, S) {
          var O = d == null ? 0 : d.length;
          if (!O)
            return -1;
          var G = S == null ? 0 : Xr(S);
          return G < 0 && (G = gi(O + G, 0)), us(d, gr(v, 3), G);
        }
        function Kb(d, v, S) {
          var O = d == null ? 0 : d.length;
          if (!O)
            return -1;
          var G = O - 1;
          return S !== t && (G = Xr(S), G = S < 0 ? gi(O + G, 0) : ui(G, O - 1)), us(d, gr(v, 3), G, !0);
        }
        function Zb(d) {
          var v = d == null ? 0 : d.length;
          return v ? ji(d, 1) : [];
        }
        function WO(d) {
          var v = d == null ? 0 : d.length;
          return v ? ji(d, Xe) : [];
        }
        function jO(d, v) {
          var S = d == null ? 0 : d.length;
          return S ? (v = v === t ? 1 : Xr(v), ji(d, v)) : [];
        }
        function qO(d) {
          for (var v = -1, S = d == null ? 0 : d.length, O = {}; ++v < S; ) {
            var G = d[v];
            ps(O, G[0], G[1]);
          }
          return O;
        }
        function eC(d) {
          return d && d.length ? d[0] : t;
        }
        function QO(d, v, S) {
          var O = d == null ? 0 : d.length;
          if (!O)
            return -1;
          var G = S == null ? 0 : Xr(S);
          return G < 0 && (G = gi(O + G, 0)), Ua(d, v, G);
        }
        function YO(d) {
          var v = d == null ? 0 : d.length;
          return v ? Oa(d, 0, -1) : [];
        }
        var XO = Sr(function(d) {
          var v = Vr(d, tc);
          return v.length && v[0] === d[0] ? gl(v) : [];
        }), JO = Sr(function(d) {
          var v = vo(d), S = Vr(d, tc);
          return v === vo(S) ? v = t : S.pop(), S.length && S[0] === d[0] ? gl(S, gr(v, 2)) : [];
        }), KO = Sr(function(d) {
          var v = vo(d), S = Vr(d, tc);
          return v = typeof v == "function" ? v : t, v && S.pop(), S.length && S[0] === d[0] ? gl(S, t, v) : [];
        });
        function ZO(d, v) {
          return d == null ? "" : Qf.call(d, v);
        }
        function vo(d) {
          var v = d == null ? 0 : d.length;
          return v ? d[v - 1] : t;
        }
        function e4(d, v, S) {
          var O = d == null ? 0 : d.length;
          if (!O)
            return -1;
          var G = O;
          return S !== t && (G = Xr(S), G = G < 0 ? gi(O + G, 0) : ui(G, O - 1)), v === v ? ch(d, v, G) : us(d, Fa, G, !0);
        }
        function t4(d, v) {
          return d && d.length ? Yu(d, Xr(v)) : t;
        }
        var r4 = Sr(tC);
        function tC(d, v) {
          return d && d.length && v && v.length ? Xu(d, v) : d;
        }
        function n4(d, v, S) {
          return d && d.length && v && v.length ? Xu(d, v, gr(S, 2)) : d;
        }
        function i4(d, v, S) {
          return d && d.length && v && v.length ? Xu(d, v, t, S) : d;
        }
        var a4 = du(function(d, v) {
          var S = d == null ? 0 : d.length, O = Yc(d, v);
          return wl(d, Vr(v, function(G) {
            return hu(G, S) ? +G : G;
          }).sort(cu)), O;
        });
        function s4(d, v) {
          var S = [];
          if (!(d && d.length))
            return S;
          var O = -1, G = [], ee = d.length;
          for (v = gr(v, 3); ++O < ee; ) {
            var he = d[O];
            v(he, O, d) && (S.push(he), G.push(O));
          }
          return wl(d, G), S;
        }
        function hv(d) {
          return d == null ? d : io.call(d);
        }
        function o4(d, v, S) {
          var O = d == null ? 0 : d.length;
          return O ? (S && typeof S != "number" && ns(d, v, S) ? (v = 0, S = O) : (v = v == null ? 0 : Xr(v), S = S === t ? O : Xr(S)), Oa(d, v, S)) : [];
        }
        function l4(d, v) {
          return Ju(d, v);
        }
        function u4(d, v, S) {
          return Ku(d, v, gr(S, 2));
        }
        function c4(d, v) {
          var S = d == null ? 0 : d.length;
          if (S) {
            var O = Ju(d, v);
            if (O < S && Vo(d[O], v))
              return O;
          }
          return -1;
        }
        function f4(d, v) {
          return Ju(d, v, !0);
        }
        function d4(d, v, S) {
          return Ku(d, v, gr(S, 2), !0);
        }
        function h4(d, v) {
          var S = d == null ? 0 : d.length;
          if (S) {
            var O = Ju(d, v, !0) - 1;
            if (Vo(d[O], v))
              return O;
          }
          return -1;
        }
        function p4(d) {
          return d && d.length ? ad(d) : [];
        }
        function g4(d, v) {
          return d && d.length ? ad(d, gr(v, 2)) : [];
        }
        function m4(d) {
          var v = d == null ? 0 : d.length;
          return v ? Oa(d, 1, v) : [];
        }
        function v4(d, v, S) {
          return d && d.length ? (v = S || v === t ? 1 : Xr(v), Oa(d, 0, v < 0 ? 0 : v)) : [];
        }
        function y4(d, v, S) {
          var O = d == null ? 0 : d.length;
          return O ? (v = S || v === t ? 1 : Xr(v), v = O - v, Oa(d, v < 0 ? 0 : v, O)) : [];
        }
        function A4(d, v) {
          return d && d.length ? ec(d, gr(v, 3), !1, !0) : [];
        }
        function w4(d, v) {
          return d && d.length ? ec(d, gr(v, 3)) : [];
        }
        var x4 = Sr(function(d) {
          return ki(ji(d, 1, Qi, !0));
        }), b4 = Sr(function(d) {
          var v = vo(d);
          return Qi(v) && (v = t), ki(ji(d, 1, Qi, !0), gr(v, 2));
        }), C4 = Sr(function(d) {
          var v = vo(d);
          return v = typeof v == "function" ? v : t, ki(ji(d, 1, Qi, !0), t, v);
        });
        function S4(d) {
          return d && d.length ? ki(d) : [];
        }
        function E4(d, v) {
          return d && d.length ? ki(d, gr(v, 2)) : [];
        }
        function k4(d, v) {
          return v = typeof v == "function" ? v : t, d && d.length ? ki(d, t, v) : [];
        }
        function pv(d) {
          if (!(d && d.length))
            return [];
          var v = 0;
          return d = Vi(d, function(S) {
            if (Qi(S))
              return v = gi(S.length, v), !0;
          }), Le(v, function(S) {
            return Vr(d, V(S));
          });
        }
        function rC(d, v) {
          if (!(d && d.length))
            return [];
          var S = pv(d);
          return v == null ? S : Vr(S, function(O) {
            return Ar(v, t, O);
          });
        }
        var T4 = Sr(function(d, v) {
          return Qi(d) ? Kl(d, v) : [];
        }), F4 = Sr(function(d) {
          return lf(Vi(d, Qi));
        }), I4 = Sr(function(d) {
          var v = vo(d);
          return Qi(v) && (v = t), lf(Vi(d, Qi), gr(v, 2));
        }), P4 = Sr(function(d) {
          var v = vo(d);
          return v = typeof v == "function" ? v : t, lf(Vi(d, Qi), t, v);
        }), D4 = Sr(pv);
        function R4(d, v) {
          return uf(d || [], v || [], Ga);
        }
        function O4(d, v) {
          return uf(d || [], v || [], Lo);
        }
        var B4 = Sr(function(d) {
          var v = d.length, S = v > 1 ? d[v - 1] : t;
          return S = typeof S == "function" ? (d.pop(), S) : t, rC(d, S);
        });
        function nC(d) {
          var v = J(d);
          return v.__chain__ = !0, v;
        }
        function _4(d, v) {
          return v(d), d;
        }
        function Fg(d, v) {
          return v(d);
        }
        var M4 = du(function(d) {
          var v = d.length, S = v ? d[0] : 0, O = this.__wrapped__, G = function(ee) {
            return Yc(ee, d);
          };
          return v > 1 || this.__actions__.length || !(O instanceof $r) || !hu(S) ? this.thru(G) : (O = O.slice(S, +S + (v ? 1 : 0)), O.__actions__.push({
            func: Fg,
            args: [G],
            thisArg: t
          }), new ea(O, this.__chain__).thru(function(ee) {
            return v && !ee.length && ee.push(t), ee;
          }));
        });
        function N4() {
          return nC(this);
        }
        function L4() {
          return new ea(this.value(), this.__chain__);
        }
        function U4() {
          this.__values__ === t && (this.__values__ = vC(this.value()));
          var d = this.__index__ >= this.__values__.length, v = d ? t : this.__values__[this.__index__++];
          return { done: d, value: v };
        }
        function V4() {
          return this;
        }
        function $4(d) {
          for (var v, S = this; S instanceof oo; ) {
            var O = Xb(S);
            O.__index__ = 0, O.__values__ = t, v ? G.__wrapped__ = O : v = O;
            var G = O;
            S = S.__wrapped__;
          }
          return G.__wrapped__ = d, v;
        }
        function z4() {
          var d = this.__wrapped__;
          if (d instanceof $r) {
            var v = d;
            return this.__actions__.length && (v = new $r(this)), v = v.reverse(), v.__actions__.push({
              func: Fg,
              args: [hv],
              thisArg: t
            }), new ea(v, this.__chain__);
          }
          return this.thru(hv);
        }
        function G4() {
          return ta(this.__wrapped__, this.__actions__);
        }
        var H4 = nc(function(d, v, S) {
          pn.call(d, S) ? ++d[S] : ps(d, S, 1);
        });
        function W4(d, v, S) {
          var O = zr(d) ? Xa : bh;
          return S && ns(d, v, S) && (v = t), O(d, gr(v, 3));
        }
        function j4(d, v) {
          var S = zr(d) ? Vi : td;
          return S(d, gr(v, 3));
        }
        var q4 = fe(Jb), Q4 = fe(Kb);
        function Y4(d, v) {
          return ji(Ig(d, v), 1);
        }
        function X4(d, v) {
          return ji(Ig(d, v), Xe);
        }
        function J4(d, v, S) {
          return S = S === t ? 1 : Xr(S), ji(Ig(d, v), S);
        }
        function iC(d, v) {
          var S = zr(d) ? Jr : Us;
          return S(d, gr(v, 3));
        }
        function aC(d, v) {
          var S = zr(d) ? Ya : Jc;
          return S(d, gr(v, 3));
        }
        var K4 = nc(function(d, v, S) {
          pn.call(d, S) ? d[S].push(v) : ps(d, S, [v]);
        });
        function Z4(d, v, S, O) {
          d = bs(d) ? d : fd(d), S = S && !O ? Xr(S) : 0;
          var G = d.length;
          return S < 0 && (S = gi(G + S, 0)), Bg(d) ? S <= G && d.indexOf(v, S) > -1 : !!G && Ua(d, v, S) > -1;
        }
        var eB = Sr(function(d, v, S) {
          var O = -1, G = typeof v == "function", ee = bs(d) ? De(d.length) : [];
          return Us(d, function(he) {
            ee[++O] = G ? Ar(v, he, S) : Mo(he, v, S);
          }), ee;
        }), tB = nc(function(d, v, S) {
          ps(d, S, v);
        });
        function Ig(d, v) {
          var S = zr(d) ? Vr : ys;
          return S(d, gr(v, 3));
        }
        function rB(d, v, S, O) {
          return d == null ? [] : (zr(v) || (v = v == null ? [] : [v]), S = O ? t : S, zr(S) || (S = S == null ? [] : [S]), Al(d, v, S));
        }
        var nB = nc(function(d, v, S) {
          d[S ? 0 : 1].push(v);
        }, function() {
          return [[], []];
        });
        function iB(d, v, S) {
          var O = zr(d) ? os : ie, G = arguments.length < 3;
          return O(d, gr(v, 4), S, G, Us);
        }
        function aB(d, v, S) {
          var O = zr(d) ? ls : ie, G = arguments.length < 3;
          return O(d, gr(v, 4), S, G, Jc);
        }
        function sB(d, v) {
          var S = zr(d) ? Vi : td;
          return S(d, Rg(gr(v, 3)));
        }
        function oB(d) {
          var v = zr(d) ? va : rf;
          return v(d);
        }
        function lB(d, v, S) {
          (S ? ns(d, v, S) : v === t) ? v = 1 : v = Xr(v);
          var O = zr(d) ? ds : nf;
          return O(d, v);
        }
        function uB(d) {
          var v = zr(d) ? wh : sf;
          return v(d);
        }
        function cB(d) {
          if (d == null)
            return 0;
          if (bs(d))
            return Bg(d) ? Bi(d) : d.length;
          var v = Wa(d);
          return v == kt || v == qt ? d.size : No(d).length;
        }
        function fB(d, v, S) {
          var O = zr(d) ? Ds : Th;
          return S && ns(d, v, S) && (v = t), O(d, gr(v, 3));
        }
        var dB = Sr(function(d, v) {
          if (d == null)
            return [];
          var S = v.length;
          return S > 1 && ns(d, v[0], v[1]) ? v = [] : S > 2 && ns(v[0], v[1], v[2]) && (v = [v[0]]), Al(d, ji(v, 1), []);
        }), Pg = qf || function() {
          return N.Date.now();
        };
        function hB(d, v) {
          if (typeof v != "function")
            throw new za(s);
          return d = Xr(d), function() {
            if (--d < 1)
              return v.apply(this, arguments);
          };
        }
        function sC(d, v, S) {
          return v = S ? t : v, v = d && v == null ? d.length : v, fu(d, Z, t, t, t, t, v);
        }
        function oC(d, v) {
          var S;
          if (typeof v != "function")
            throw new za(s);
          return d = Xr(d), function() {
            return --d > 0 && (S = v.apply(this, arguments)), d <= 1 && (v = t), S;
          };
        }
        var gv = Sr(function(d, v, S) {
          var O = x;
          if (S.length) {
            var G = $a(S, ud(gv));
            O |= _;
          }
          return fu(d, O, v, S, G);
        }), lC = Sr(function(d, v, S) {
          var O = x | E;
          if (S.length) {
            var G = $a(S, ud(lC));
            O |= _;
          }
          return fu(v, O, d, S, G);
        });
        function uC(d, v, S) {
          v = S ? t : v;
          var O = fu(d, D, t, t, t, t, t, v);
          return O.placeholder = uC.placeholder, O;
        }
        function cC(d, v, S) {
          v = S ? t : v;
          var O = fu(d, F, t, t, t, t, t, v);
          return O.placeholder = cC.placeholder, O;
        }
        function fC(d, v, S) {
          var O, G, ee, he, ge, Ce, je = 0, Qe = !1, Ke = !1, Ct = !0;
          if (typeof d != "function")
            throw new za(s);
          v = yo(v) || 0, Mi(S) && (Qe = !!S.leading, Ke = "maxWait" in S, ee = Ke ? gi(yo(S.maxWait) || 0, v) : ee, Ct = "trailing" in S ? !!S.trailing : Ct);
          function Ht(Yi) {
            var $o = O, mu = G;
            return O = G = t, je = Yi, he = d.apply(mu, $o), he;
          }
          function mr(Yi) {
            return je = Yi, ge = Rh(dn, v), Qe ? Ht(Yi) : he;
          }
          function Kr(Yi) {
            var $o = Yi - Ce, mu = Yi - je, DC = v - $o;
            return Ke ? ui(DC, ee - mu) : DC;
          }
          function cr(Yi) {
            var $o = Yi - Ce, mu = Yi - je;
            return Ce === t || $o >= v || $o < 0 || Ke && mu >= ee;
          }
          function dn() {
            var Yi = Pg();
            if (cr(Yi))
              return bn(Yi);
            ge = Rh(dn, Kr(Yi));
          }
          function bn(Yi) {
            return ge = t, Ct && O ? Ht(Yi) : (O = G = t, he);
          }
          function Hs() {
            ge !== t && po(ge), je = 0, O = Ce = G = ge = t;
          }
          function is() {
            return ge === t ? he : bn(Pg());
          }
          function Ws() {
            var Yi = Pg(), $o = cr(Yi);
            if (O = arguments, G = this, Ce = Yi, $o) {
              if (ge === t)
                return mr(Ce);
              if (Ke)
                return po(ge), ge = Rh(dn, v), Ht(Ce);
            }
            return ge === t && (ge = Rh(dn, v)), he;
          }
          return Ws.cancel = Hs, Ws.flush = is, Ws;
        }
        var pB = Sr(function(d, v) {
          return Hu(d, 1, v);
        }), gB = Sr(function(d, v, S) {
          return Hu(d, yo(v) || 0, S);
        });
        function mB(d) {
          return fu(d, de);
        }
        function Dg(d, v) {
          if (typeof d != "function" || v != null && typeof v != "function")
            throw new za(s);
          var S = function() {
            var O = arguments, G = v ? v.apply(this, O) : O[0], ee = S.cache;
            if (ee.has(G))
              return ee.get(G);
            var he = d.apply(this, O);
            return S.cache = ee.set(G, he) || ee, he;
          };
          return S.cache = new (Dg.Cache || es)(), S;
        }
        Dg.Cache = es;
        function Rg(d) {
          if (typeof d != "function")
            throw new za(s);
          return function() {
            var v = arguments;
            switch (v.length) {
              case 0:
                return !d.call(this);
              case 1:
                return !d.call(this, v[0]);
              case 2:
                return !d.call(this, v[0], v[1]);
              case 3:
                return !d.call(this, v[0], v[1], v[2]);
            }
            return !d.apply(this, v);
          };
        }
        function vB(d) {
          return oC(2, d);
        }
        var yB = Fh(function(d, v) {
          v = v.length == 1 && zr(v[0]) ? Vr(v[0], Wt(gr())) : Vr(ji(v, 1), Wt(gr()));
          var S = v.length;
          return Sr(function(O) {
            for (var G = -1, ee = ui(O.length, S); ++G < ee; )
              O[G] = v[G].call(this, O[G]);
            return Ar(d, this, O);
          });
        }), mv = Sr(function(d, v) {
          var S = $a(v, ud(mv));
          return fu(d, _, t, v, S);
        }), dC = Sr(function(d, v) {
          var S = $a(v, ud(dC));
          return fu(d, L, t, v, S);
        }), AB = du(function(d, v) {
          return fu(d, te, t, t, t, v);
        });
        function wB(d, v) {
          if (typeof d != "function")
            throw new za(s);
          return v = v === t ? v : Xr(v), Sr(d, v);
        }
        function xB(d, v) {
          if (typeof d != "function")
            throw new za(s);
          return v = v == null ? 0 : gi(Xr(v), 0), Sr(function(S) {
            var O = S[v], G = As(S, 0, v);
            return O && ua(G, O), Ar(d, this, G);
          });
        }
        function bB(d, v, S) {
          var O = !0, G = !0;
          if (typeof d != "function")
            throw new za(s);
          return Mi(S) && (O = "leading" in S ? !!S.leading : O, G = "trailing" in S ? !!S.trailing : G), fC(d, v, {
            leading: O,
            maxWait: v,
            trailing: G
          });
        }
        function CB(d) {
          return sC(d, 1);
        }
        function SB(d, v) {
          return mv(ho(v), d);
        }
        function EB() {
          if (!arguments.length)
            return [];
          var d = arguments[0];
          return zr(d) ? d : [d];
        }
        function kB(d) {
          return ya(d, m);
        }
        function TB(d, v) {
          return v = typeof v == "function" ? v : t, ya(d, m, v);
        }
        function FB(d) {
          return ya(d, f | m);
        }
        function IB(d, v) {
          return v = typeof v == "function" ? v : t, ya(d, f | m, v);
        }
        function PB(d, v) {
          return v == null || Xc(d, v, wa(v));
        }
        function Vo(d, v) {
          return d === v || d !== d && v !== v;
        }
        var DB = ws(hl), RB = ws(function(d, v) {
          return d >= v;
        }), mf = uo(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? uo : function(d) {
          return $i(d) && pn.call(d, "callee") && !Fo.call(d, "callee");
        }, zr = De.isArray, OB = dt ? Wt(dt) : rd;
        function bs(d) {
          return d != null && Og(d.length) && !pu(d);
        }
        function Qi(d) {
          return $i(d) && bs(d);
        }
        function BB(d) {
          return d === !0 || d === !1 || $i(d) && _i(d) == rt;
        }
        var ic = Hl || Fv, _B = Nt ? Wt(Nt) : Sh;
        function MB(d) {
          return $i(d) && d.nodeType === 1 && !Oh(d);
        }
        function NB(d) {
          if (d == null)
            return !0;
          if (bs(d) && (zr(d) || typeof d == "string" || typeof d.splice == "function" || ic(d) || cd(d) || mf(d)))
            return !d.length;
          var v = Wa(d);
          if (v == kt || v == qt)
            return !d.size;
          if (Dh(d))
            return !No(d).length;
          for (var S in d)
            if (pn.call(d, S))
              return !1;
          return !0;
        }
        function LB(d, v) {
          return vs(d, v);
        }
        function UB(d, v, S) {
          S = typeof S == "function" ? S : t;
          var O = S ? S(d, v) : t;
          return O === t ? vs(d, v, t, S) : !!O;
        }
        function vv(d) {
          if (!$i(d))
            return !1;
          var v = _i(d);
          return v == an || v == Fr || typeof d.message == "string" && typeof d.name == "string" && !Oh(d);
        }
        function VB(d) {
          return typeof d == "number" && sl(d);
        }
        function pu(d) {
          if (!Mi(d))
            return !1;
          var v = _i(d);
          return v == ar || v == Ir || v == lt || v == Pr;
        }
        function hC(d) {
          return typeof d == "number" && d == Xr(d);
        }
        function Og(d) {
          return typeof d == "number" && d > -1 && d % 1 == 0 && d <= Ve;
        }
        function Mi(d) {
          var v = typeof d;
          return d != null && (v == "object" || v == "function");
        }
        function $i(d) {
          return d != null && typeof d == "object";
        }
        var pC = Yt ? Wt(Yt) : Eh;
        function $B(d, v) {
          return d === v || Zc(d, v, ov(v));
        }
        function zB(d, v, S) {
          return S = typeof S == "function" ? S : t, Zc(d, v, ov(v), S);
        }
        function GB(d) {
          return gC(d) && d != +d;
        }
        function HB(d) {
          if (TO(d))
            throw new pr(a);
          return co(d);
        }
        function WB(d) {
          return d === null;
        }
        function jB(d) {
          return d == null;
        }
        function gC(d) {
          return typeof d == "number" || $i(d) && _i(d) == wt;
        }
        function Oh(d) {
          if (!$i(d) || _i(d) != kr)
            return !1;
          var v = ro(d);
          if (v === null)
            return !0;
          var S = pn.call(v, "constructor") && v.constructor;
          return typeof S == "function" && S instanceof S && Vl.call(S) == zc;
        }
        var yv = Ur ? Wt(Ur) : Qu;
        function qB(d) {
          return hC(d) && d >= -Ve && d <= Ve;
        }
        var mC = qr ? Wt(qr) : Vs;
        function Bg(d) {
          return typeof d == "string" || !zr(d) && $i(d) && _i(d) == lr;
        }
        function Gs(d) {
          return typeof d == "symbol" || $i(d) && _i(d) == It;
        }
        var cd = Dr ? Wt(Dr) : ef;
        function QB(d) {
          return d === t;
        }
        function YB(d) {
          return $i(d) && Wa(d) == Cn;
        }
        function XB(d) {
          return $i(d) && _i(d) == Sn;
        }
        var JB = ws(Ha), KB = ws(function(d, v) {
          return d <= v;
        });
        function vC(d) {
          if (!d)
            return [];
          if (bs(d))
            return Bg(d) ? Ja(d) : ra(d);
          if (Io && d[Io])
            return Va(d[Io]());
          var v = Wa(d), S = v == kt ? rl : v == qt ? Ia : fd;
          return S(d);
        }
        function gu(d) {
          if (!d)
            return d === 0 ? d : 0;
          if (d = yo(d), d === Xe || d === -Xe) {
            var v = d < 0 ? -1 : 1;
            return v * He;
          }
          return d === d ? d : 0;
        }
        function Xr(d) {
          var v = gu(d), S = v % 1;
          return v === v ? S ? v - S : v : 0;
        }
        function yC(d) {
          return d ? gs(Xr(d), 0, ve) : 0;
        }
        function yo(d) {
          if (typeof d == "number")
            return d;
          if (Gs(d))
            return le;
          if (Mi(d)) {
            var v = typeof d.valueOf == "function" ? d.valueOf() : d;
            d = Mi(v) ? v + "" : v;
          }
          if (typeof d != "string")
            return d === 0 ? d : +d;
          d = Xt(d);
          var S = Hr.test(d);
          return S || Nr.test(d) ? hr(d.slice(2), S ? 2 : 8) : zt.test(d) ? le : +d;
        }
        function AC(d) {
          return rs(d, Cs(d));
        }
        function ZB(d) {
          return d ? gs(Xr(d), -Ve, Ve) : d === 0 ? d : 0;
        }
        function qn(d) {
          return d == null ? "" : Ba(d);
        }
        var e3 = b(function(d, v) {
          if (Dh(v) || bs(v)) {
            rs(v, wa(v), d);
            return;
          }
          for (var S in v)
            pn.call(v, S) && Ga(d, S, v[S]);
        }), wC = b(function(d, v) {
          rs(v, Cs(v), d);
        }), xC = b(function(d, v, S, O) {
          rs(v, Cs(v), d, O);
        }), Av = b(function(d, v, S, O) {
          rs(v, wa(v), d, O);
        }), t3 = du(Yc);
        function r3(d, v) {
          var S = Za(d);
          return v == null ? S : Gu(S, v);
        }
        var n3 = Sr(function(d, v) {
          d = Tn(d);
          var S = -1, O = v.length, G = O > 2 ? v[2] : t;
          for (G && ns(v[0], v[1], G) && (O = 1); ++S < O; )
            for (var ee = v[S], he = Cs(ee), ge = -1, Ce = he.length; ++ge < Ce; ) {
              var je = he[ge], Qe = d[je];
              (Qe === t || Vo(Qe, Bn[je]) && !pn.call(d, je)) && (d[je] = ee[je]);
            }
          return d;
        }), i3 = Sr(function(d) {
          return d.push(t, Nb), Ar(bC, t, d);
        });
        function a3(d, v) {
          return eo(d, gr(v, 3), ts);
        }
        function s3(d, v) {
          return eo(d, gr(v, 3), eu);
        }
        function o3(d, v) {
          return d == null ? d : Kc(d, gr(v, 3), Cs);
        }
        function l3(d, v) {
          return d == null ? d : Zl(d, gr(v, 3), Cs);
        }
        function u3(d, v) {
          return d && ts(d, gr(v, 3));
        }
        function c3(d, v) {
          return d && eu(d, gr(v, 3));
        }
        function f3(d) {
          return d == null ? [] : tu(d, wa(d));
        }
        function d3(d) {
          return d == null ? [] : tu(d, Cs(d));
        }
        function wv(d, v, S) {
          var O = d == null ? t : ms(d, v);
          return O === t ? S : O;
        }
        function h3(d, v) {
          return d != null && Vb(d, v, pl);
        }
        function xv(d, v) {
          return d != null && Vb(d, v, ju);
        }
        var p3 = Je(function(d, v, S) {
          v != null && typeof v.toString != "function" && (v = nl.call(v)), d[v] = S;
        }, Cv(Ss)), g3 = Je(function(d, v, S) {
          v != null && typeof v.toString != "function" && (v = nl.call(v)), pn.call(d, v) ? d[v].push(S) : d[v] = [S];
        }, gr), m3 = Sr(Mo);
        function wa(d) {
          return bs(d) ? ma(d) : No(d);
        }
        function Cs(d) {
          return bs(d) ? ma(d, !0) : $s(d);
        }
        function v3(d, v) {
          var S = {};
          return v = gr(v, 3), ts(d, function(O, G, ee) {
            ps(S, v(O, G, ee), O);
          }), S;
        }
        function y3(d, v) {
          var S = {};
          return v = gr(v, 3), ts(d, function(O, G, ee) {
            ps(S, G, v(O, G, ee));
          }), S;
        }
        var A3 = b(function(d, v, S) {
          Aa(d, v, S);
        }), bC = b(function(d, v, S, O) {
          Aa(d, v, S, O);
        }), w3 = du(function(d, v) {
          var S = {};
          if (d == null)
            return S;
          var O = !1;
          v = Vr(v, function(ee) {
            return ee = zs(ee, d), O || (O = ee.length > 1), ee;
          }), rs(d, av(d), S), O && (S = ya(S, f | p | m, gO));
          for (var G = v.length; G--; )
            of(S, v[G]);
          return S;
        });
        function x3(d, v) {
          return CC(d, Rg(gr(v)));
        }
        var b3 = du(function(d, v) {
          return d == null ? {} : au(d, v);
        });
        function CC(d, v) {
          if (d == null)
            return {};
          var S = Vr(av(d), function(O) {
            return [O];
          });
          return v = gr(v), tf(d, S, function(O, G) {
            return v(O, G[0]);
          });
        }
        function C3(d, v, S) {
          v = zs(v, d);
          var O = -1, G = v.length;
          for (G || (G = 1, d = t); ++O < G; ) {
            var ee = d == null ? t : d[Uo(v[O])];
            ee === t && (O = G, ee = S), d = pu(ee) ? ee.call(d) : ee;
          }
          return d;
        }
        function S3(d, v, S) {
          return d == null ? d : Lo(d, v, S);
        }
        function E3(d, v, S, O) {
          return O = typeof O == "function" ? O : t, d == null ? d : Lo(d, v, S, O);
        }
        var SC = Sg(wa), EC = Sg(Cs);
        function k3(d, v, S) {
          var O = zr(d), G = O || ic(d) || cd(d);
          if (v = gr(v, 4), S == null) {
            var ee = d && d.constructor;
            G ? S = O ? new ee() : [] : Mi(d) ? S = pu(ee) ? Za(ro(d)) : {} : S = {};
          }
          return (G ? Jr : ts)(d, function(he, ge, Ce) {
            return v(S, he, ge, Ce);
          }), S;
        }
        function T3(d, v) {
          return d == null ? !0 : of(d, v);
        }
        function F3(d, v, S) {
          return d == null ? d : lu(d, v, ho(S));
        }
        function I3(d, v, S, O) {
          return O = typeof O == "function" ? O : t, d == null ? d : lu(d, v, ho(S), O);
        }
        function fd(d) {
          return d == null ? [] : ur(d, wa(d));
        }
        function P3(d) {
          return d == null ? [] : ur(d, Cs(d));
        }
        function D3(d, v, S) {
          return S === t && (S = v, v = t), S !== t && (S = yo(S), S = S === S ? S : 0), v !== t && (v = yo(v), v = v === v ? v : 0), gs(yo(d), v, S);
        }
        function R3(d, v, S) {
          return v = gu(v), S === t ? (S = v, v = 0) : S = gu(S), d = yo(d), qu(d, v, S);
        }
        function O3(d, v, S) {
          if (S && typeof S != "boolean" && ns(d, v, S) && (v = S = t), S === t && (typeof v == "boolean" ? (S = v, v = t) : typeof d == "boolean" && (S = d, d = t)), d === t && v === t ? (d = 0, v = 1) : (d = gu(d), v === t ? (v = d, d = 0) : v = gu(v)), d > v) {
            var O = d;
            d = v, v = O;
          }
          if (S || d % 1 || v % 1) {
            var G = Wl();
            return ui(d + G * (v - d + Tt("1e-" + ((G + "").length - 1))), v);
          }
          return su(d, v);
        }
        var B3 = B(function(d, v, S) {
          return v = v.toLowerCase(), d + (S ? kC(v) : v);
        });
        function kC(d) {
          return bv(qn(d).toLowerCase());
        }
        function TC(d) {
          return d = qn(d), d && d.replace(vi, tt).replace(wi, "");
        }
        function _3(d, v, S) {
          d = qn(d), v = Ba(v);
          var O = d.length;
          S = S === t ? O : gs(Xr(S), 0, O);
          var G = S;
          return S -= v.length, S >= 0 && d.slice(S, G) == v;
        }
        function M3(d) {
          return d = qn(d), d && Me.test(d) ? d.replace(yn, _t) : d;
        }
        function N3(d) {
          return d = qn(d), d && Zt.test(d) ? d.replace(Mt, "\\$&") : d;
        }
        var L3 = B(function(d, v, S) {
          return d + (S ? "-" : "") + v.toLowerCase();
        }), U3 = B(function(d, v, S) {
          return d + (S ? " " : "") + v.toLowerCase();
        }), V3 = k("toLowerCase");
        function $3(d, v, S) {
          d = qn(d), v = Xr(v);
          var O = v ? Bi(d) : 0;
          if (!v || O >= v)
            return d;
          var G = (v - O) / 2;
          return rn(Do(G), S) + d + rn(Po(G), S);
        }
        function z3(d, v, S) {
          d = qn(d), v = Xr(v);
          var O = v ? Bi(d) : 0;
          return v && O < v ? d + rn(v - O, S) : d;
        }
        function G3(d, v, S) {
          d = qn(d), v = Xr(v);
          var O = v ? Bi(d) : 0;
          return v && O < v ? rn(v - O, S) + d : d;
        }
        function H3(d, v, S) {
          return S || v == null ? v = 0 : v && (v = +v), Oo(qn(d).replace(rr, ""), v || 0);
        }
        function W3(d, v, S) {
          return (S ? ns(d, v, S) : v === t) ? v = 1 : v = Xr(v), ou(qn(d), v);
        }
        function j3() {
          var d = arguments, v = qn(d[0]);
          return d.length < 3 ? v : v.replace(d[1], d[2]);
        }
        var q3 = B(function(d, v, S) {
          return d + (S ? "_" : "") + v.toLowerCase();
        });
        function Q3(d, v, S) {
          return S && typeof S != "number" && ns(d, v, S) && (v = S = t), S = S === t ? ve : S >>> 0, S ? (d = qn(d), d && (typeof v == "string" || v != null && !yv(v)) && (v = Ba(v), !v && ei(d)) ? As(Ja(d), 0, S) : d.split(v, S)) : [];
        }
        var Y3 = B(function(d, v, S) {
          return d + (S ? " " : "") + bv(v);
        });
        function X3(d, v, S) {
          return d = qn(d), S = S == null ? 0 : gs(Xr(S), 0, d.length), v = Ba(v), d.slice(S, S + v.length) == v;
        }
        function J3(d, v, S) {
          var O = J.templateSettings;
          S && ns(d, v, S) && (v = t), d = qn(d), v = Av({}, v, O, Mb);
          var G = Av({}, v.imports, O.imports, Mb), ee = wa(G), he = ur(G, ee);
          Jr(ee, function(cr) {
            if (ft.test(cr))
              throw new pr(l);
          });
          var ge, Ce, je = 0, Qe = v.interpolate || Xn, Ke = "__p += '", Ct = Bu(
            (v.escape || Xn).source + "|" + Qe.source + "|" + (Qe === se ? Ot : Xn).source + "|" + (v.evaluate || Xn).source + "|$",
            "g"
          ), Ht = "//# sourceURL=" + (pn.call(v, "sourceURL") ? (v.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++hi + "]") + `
`;
          d.replace(Ct, function(cr, dn, bn, Hs, is, Ws) {
            return bn || (bn = Hs), Ke += d.slice(je, Ws).replace(Yr, nr), dn && (ge = !0, Ke += `' +
__e(` + dn + `) +
'`), is && (Ce = !0, Ke += `';
` + is + `;
__p += '`), bn && (Ke += `' +
((__t = (` + bn + `)) == null ? '' : __t) +
'`), je = Ws + cr.length, cr;
          }), Ke += `';
`;
          var mr = pn.call(v, "variable") && v.variable;
          if (!mr)
            Ke = `with (obj) {
` + Ke + `
}
`;
          else if (ft.test(mr))
            throw new pr(o);
          Ke = (Ce ? Ke.replace(fr, "") : Ke).replace(Or, "$1").replace(sn, "$1;"), Ke = "function(" + (mr || "obj") + `) {
` + (mr ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ge ? ", __e = _.escape" : "") + (Ce ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ke + `return __p
}`;
          var Kr = IC(function() {
            return cn(ee, Ht + "return " + Ke).apply(t, he);
          });
          if (Kr.source = Ke, vv(Kr))
            throw Kr;
          return Kr;
        }
        function K3(d) {
          return qn(d).toLowerCase();
        }
        function Z3(d) {
          return qn(d).toUpperCase();
        }
        function e_(d, v, S) {
          if (d = qn(d), d && (S || v === t))
            return Xt(d);
          if (!d || !(v = Ba(v)))
            return d;
          var O = Ja(d), G = Ja(v), ee = z(O, G), he = ce(O, G) + 1;
          return As(O, ee, he).join("");
        }
        function t_(d, v, S) {
          if (d = qn(d), d && (S || v === t))
            return d.slice(0, Vc(d) + 1);
          if (!d || !(v = Ba(v)))
            return d;
          var O = Ja(d), G = ce(O, Ja(v)) + 1;
          return As(O, 0, G).join("");
        }
        function r_(d, v, S) {
          if (d = qn(d), d && (S || v === t))
            return d.replace(rr, "");
          if (!d || !(v = Ba(v)))
            return d;
          var O = Ja(d), G = z(O, Ja(v));
          return As(O, G).join("");
        }
        function n_(d, v) {
          var S = H, O = j;
          if (Mi(v)) {
            var G = "separator" in v ? v.separator : G;
            S = "length" in v ? Xr(v.length) : S, O = "omission" in v ? Ba(v.omission) : O;
          }
          d = qn(d);
          var ee = d.length;
          if (ei(d)) {
            var he = Ja(d);
            ee = he.length;
          }
          if (S >= ee)
            return d;
          var ge = S - Bi(O);
          if (ge < 1)
            return O;
          var Ce = he ? As(he, 0, ge).join("") : d.slice(0, ge);
          if (G === t)
            return Ce + O;
          if (he && (ge += Ce.length - ge), yv(G)) {
            if (d.slice(ge).search(G)) {
              var je, Qe = Ce;
              for (G.global || (G = Bu(G.source, qn(Qt.exec(G)) + "g")), G.lastIndex = 0; je = G.exec(Qe); )
                var Ke = je.index;
              Ce = Ce.slice(0, Ke === t ? ge : Ke);
            }
          } else if (d.indexOf(Ba(G), ge) != ge) {
            var Ct = Ce.lastIndexOf(G);
            Ct > -1 && (Ce = Ce.slice(0, Ct));
          }
          return Ce + O;
        }
        function i_(d) {
          return d = qn(d), d && Nn.test(d) ? d.replace(yt, Du) : d;
        }
        var a_ = B(function(d, v, S) {
          return d + (S ? " " : "") + v.toUpperCase();
        }), bv = k("toUpperCase");
        function FC(d, v, S) {
          return d = qn(d), v = S ? t : v, v === t ? Wi(d) ? Ru(d) : Zs(d) : d.match(v) || [];
        }
        var IC = Sr(function(d, v) {
          try {
            return Ar(d, t, v);
          } catch (S) {
            return vv(S) ? S : new pr(S);
          }
        }), s_ = du(function(d, v) {
          return Jr(v, function(S) {
            S = Uo(S), ps(d, S, gv(d[S], d));
          }), d;
        });
        function o_(d) {
          var v = d == null ? 0 : d.length, S = gr();
          return d = v ? Vr(d, function(O) {
            if (typeof O[1] != "function")
              throw new za(s);
            return [S(O[0]), O[1]];
          }) : [], Sr(function(O) {
            for (var G = -1; ++G < v; ) {
              var ee = d[G];
              if (Ar(ee[0], this, O))
                return Ar(ee[1], this, O);
            }
          });
        }
        function l_(d) {
          return ed(ya(d, f));
        }
        function Cv(d) {
          return function() {
            return d;
          };
        }
        function u_(d, v) {
          return d == null || d !== d ? v : d;
        }
        var c_ = Te(), f_ = Te(!0);
        function Ss(d) {
          return d;
        }
        function Sv(d) {
          return fo(typeof d == "function" ? d : ya(d, f));
        }
        function d_(d) {
          return nu(ya(d, f));
        }
        function h_(d, v) {
          return yl(d, ya(v, f));
        }
        var p_ = Sr(function(d, v) {
          return function(S) {
            return Mo(S, d, v);
          };
        }), g_ = Sr(function(d, v) {
          return function(S) {
            return Mo(d, S, v);
          };
        });
        function Ev(d, v, S) {
          var O = wa(v), G = tu(v, O);
          S == null && !(Mi(v) && (G.length || !O.length)) && (S = v, v = d, d = this, G = tu(v, wa(v)));
          var ee = !(Mi(S) && "chain" in S) || !!S.chain, he = pu(d);
          return Jr(G, function(ge) {
            var Ce = v[ge];
            d[ge] = Ce, he && (d.prototype[ge] = function() {
              var je = this.__chain__;
              if (ee || je) {
                var Qe = d(this.__wrapped__), Ke = Qe.__actions__ = ra(this.__actions__);
                return Ke.push({ func: Ce, args: arguments, thisArg: d }), Qe.__chain__ = je, Qe;
              }
              return Ce.apply(d, ua([this.value()], arguments));
            });
          }), d;
        }
        function m_() {
          return N._ === this && (N._ = Gc), this;
        }
        function kv() {
        }
        function v_(d) {
          return d = Xr(d), Sr(function(v) {
            return Yu(v, d);
          });
        }
        var y_ = ir(Vr), A_ = ir(Xa), w_ = ir(Ds);
        function PC(d) {
          return uv(d) ? V(Uo(d)) : kh(d);
        }
        function x_(d) {
          return function(v) {
            return d == null ? t : ms(d, v);
          };
        }
        var b_ = go(), C_ = go(!0);
        function Tv() {
          return [];
        }
        function Fv() {
          return !1;
        }
        function S_() {
          return {};
        }
        function E_() {
          return "";
        }
        function k_() {
          return !0;
        }
        function T_(d, v) {
          if (d = Xr(d), d < 1 || d > Ve)
            return [];
          var S = ve, O = ui(d, ve);
          v = gr(v), d -= ve;
          for (var G = Le(O, v); ++S < d; )
            v(S);
          return G;
        }
        function F_(d) {
          return zr(d) ? Vr(d, Uo) : Gs(d) ? [d] : ra(Yb(qn(d)));
        }
        function I_(d) {
          var v = ++ti;
          return qn(d) + v;
        }
        var P_ = ht(function(d, v) {
          return d + v;
        }, 0), D_ = mo("ceil"), R_ = ht(function(d, v) {
          return d / v;
        }, 1), O_ = mo("floor");
        function B_(d) {
          return d && d.length ? Wu(d, Ss, hl) : t;
        }
        function __(d, v) {
          return d && d.length ? Wu(d, gr(v, 2), hl) : t;
        }
        function M_(d) {
          return P(d, Ss);
        }
        function N_(d, v) {
          return P(d, gr(v, 2));
        }
        function L_(d) {
          return d && d.length ? Wu(d, Ss, Ha) : t;
        }
        function U_(d, v) {
          return d && d.length ? Wu(d, gr(v, 2), Ha) : t;
        }
        var V_ = ht(function(d, v) {
          return d * v;
        }, 1), $_ = mo("round"), z_ = ht(function(d, v) {
          return d - v;
        }, 0);
        function G_(d) {
          return d && d.length ? ke(d, Ss) : 0;
        }
        function H_(d, v) {
          return d && d.length ? ke(d, gr(v, 2)) : 0;
        }
        return J.after = hB, J.ary = sC, J.assign = e3, J.assignIn = wC, J.assignInWith = xC, J.assignWith = Av, J.at = t3, J.before = oC, J.bind = gv, J.bindAll = s_, J.bindKey = lC, J.castArray = EB, J.chain = nC, J.chunk = BO, J.compact = _O, J.concat = MO, J.cond = o_, J.conforms = l_, J.constant = Cv, J.countBy = H4, J.create = r3, J.curry = uC, J.curryRight = cC, J.debounce = fC, J.defaults = n3, J.defaultsDeep = i3, J.defer = pB, J.delay = gB, J.difference = NO, J.differenceBy = LO, J.differenceWith = UO, J.drop = VO, J.dropRight = $O, J.dropRightWhile = zO, J.dropWhile = GO, J.fill = HO, J.filter = j4, J.flatMap = Y4, J.flatMapDeep = X4, J.flatMapDepth = J4, J.flatten = Zb, J.flattenDeep = WO, J.flattenDepth = jO, J.flip = mB, J.flow = c_, J.flowRight = f_, J.fromPairs = qO, J.functions = f3, J.functionsIn = d3, J.groupBy = K4, J.initial = YO, J.intersection = XO, J.intersectionBy = JO, J.intersectionWith = KO, J.invert = p3, J.invertBy = g3, J.invokeMap = eB, J.iteratee = Sv, J.keyBy = tB, J.keys = wa, J.keysIn = Cs, J.map = Ig, J.mapKeys = v3, J.mapValues = y3, J.matches = d_, J.matchesProperty = h_, J.memoize = Dg, J.merge = A3, J.mergeWith = bC, J.method = p_, J.methodOf = g_, J.mixin = Ev, J.negate = Rg, J.nthArg = v_, J.omit = w3, J.omitBy = x3, J.once = vB, J.orderBy = rB, J.over = y_, J.overArgs = yB, J.overEvery = A_, J.overSome = w_, J.partial = mv, J.partialRight = dC, J.partition = nB, J.pick = b3, J.pickBy = CC, J.property = PC, J.propertyOf = x_, J.pull = r4, J.pullAll = tC, J.pullAllBy = n4, J.pullAllWith = i4, J.pullAt = a4, J.range = b_, J.rangeRight = C_, J.rearg = AB, J.reject = sB, J.remove = s4, J.rest = wB, J.reverse = hv, J.sampleSize = lB, J.set = S3, J.setWith = E3, J.shuffle = uB, J.slice = o4, J.sortBy = dB, J.sortedUniq = p4, J.sortedUniqBy = g4, J.split = Q3, J.spread = xB, J.tail = m4, J.take = v4, J.takeRight = y4, J.takeRightWhile = A4, J.takeWhile = w4, J.tap = _4, J.throttle = bB, J.thru = Fg, J.toArray = vC, J.toPairs = SC, J.toPairsIn = EC, J.toPath = F_, J.toPlainObject = AC, J.transform = k3, J.unary = CB, J.union = x4, J.unionBy = b4, J.unionWith = C4, J.uniq = S4, J.uniqBy = E4, J.uniqWith = k4, J.unset = T3, J.unzip = pv, J.unzipWith = rC, J.update = F3, J.updateWith = I3, J.values = fd, J.valuesIn = P3, J.without = T4, J.words = FC, J.wrap = SB, J.xor = F4, J.xorBy = I4, J.xorWith = P4, J.zip = D4, J.zipObject = R4, J.zipObjectDeep = O4, J.zipWith = B4, J.entries = SC, J.entriesIn = EC, J.extend = wC, J.extendWith = xC, Ev(J, J), J.add = P_, J.attempt = IC, J.camelCase = B3, J.capitalize = kC, J.ceil = D_, J.clamp = D3, J.clone = kB, J.cloneDeep = FB, J.cloneDeepWith = IB, J.cloneWith = TB, J.conformsTo = PB, J.deburr = TC, J.defaultTo = u_, J.divide = R_, J.endsWith = _3, J.eq = Vo, J.escape = M3, J.escapeRegExp = N3, J.every = W4, J.find = q4, J.findIndex = Jb, J.findKey = a3, J.findLast = Q4, J.findLastIndex = Kb, J.findLastKey = s3, J.floor = O_, J.forEach = iC, J.forEachRight = aC, J.forIn = o3, J.forInRight = l3, J.forOwn = u3, J.forOwnRight = c3, J.get = wv, J.gt = DB, J.gte = RB, J.has = h3, J.hasIn = xv, J.head = eC, J.identity = Ss, J.includes = Z4, J.indexOf = QO, J.inRange = R3, J.invoke = m3, J.isArguments = mf, J.isArray = zr, J.isArrayBuffer = OB, J.isArrayLike = bs, J.isArrayLikeObject = Qi, J.isBoolean = BB, J.isBuffer = ic, J.isDate = _B, J.isElement = MB, J.isEmpty = NB, J.isEqual = LB, J.isEqualWith = UB, J.isError = vv, J.isFinite = VB, J.isFunction = pu, J.isInteger = hC, J.isLength = Og, J.isMap = pC, J.isMatch = $B, J.isMatchWith = zB, J.isNaN = GB, J.isNative = HB, J.isNil = jB, J.isNull = WB, J.isNumber = gC, J.isObject = Mi, J.isObjectLike = $i, J.isPlainObject = Oh, J.isRegExp = yv, J.isSafeInteger = qB, J.isSet = mC, J.isString = Bg, J.isSymbol = Gs, J.isTypedArray = cd, J.isUndefined = QB, J.isWeakMap = YB, J.isWeakSet = XB, J.join = ZO, J.kebabCase = L3, J.last = vo, J.lastIndexOf = e4, J.lowerCase = U3, J.lowerFirst = V3, J.lt = JB, J.lte = KB, J.max = B_, J.maxBy = __, J.mean = M_, J.meanBy = N_, J.min = L_, J.minBy = U_, J.stubArray = Tv, J.stubFalse = Fv, J.stubObject = S_, J.stubString = E_, J.stubTrue = k_, J.multiply = V_, J.nth = t4, J.noConflict = m_, J.noop = kv, J.now = Pg, J.pad = $3, J.padEnd = z3, J.padStart = G3, J.parseInt = H3, J.random = O3, J.reduce = iB, J.reduceRight = aB, J.repeat = W3, J.replace = j3, J.result = C3, J.round = $_, J.runInContext = Ae, J.sample = oB, J.size = cB, J.snakeCase = q3, J.some = fB, J.sortedIndex = l4, J.sortedIndexBy = u4, J.sortedIndexOf = c4, J.sortedLastIndex = f4, J.sortedLastIndexBy = d4, J.sortedLastIndexOf = h4, J.startCase = Y3, J.startsWith = X3, J.subtract = z_, J.sum = G_, J.sumBy = H_, J.template = J3, J.times = T_, J.toFinite = gu, J.toInteger = Xr, J.toLength = yC, J.toLower = K3, J.toNumber = yo, J.toSafeInteger = ZB, J.toString = qn, J.toUpper = Z3, J.trim = e_, J.trimEnd = t_, J.trimStart = r_, J.truncate = n_, J.unescape = i_, J.uniqueId = I_, J.upperCase = a_, J.upperFirst = bv, J.each = iC, J.eachRight = aC, J.first = eC, Ev(J, (function() {
          var d = {};
          return ts(J, function(v, S) {
            pn.call(J.prototype, S) || (d[S] = v);
          }), d;
        })(), { chain: !1 }), J.VERSION = n, Jr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(d) {
          J[d].placeholder = J;
        }), Jr(["drop", "take"], function(d, v) {
          $r.prototype[d] = function(S) {
            S = S === t ? 1 : gi(Xr(S), 0);
            var O = this.__filtered__ && !v ? new $r(this) : this.clone();
            return O.__filtered__ ? O.__takeCount__ = ui(S, O.__takeCount__) : O.__views__.push({
              size: ui(S, ve),
              type: d + (O.__dir__ < 0 ? "Right" : "")
            }), O;
          }, $r.prototype[d + "Right"] = function(S) {
            return this.reverse()[d](S).reverse();
          };
        }), Jr(["filter", "map", "takeWhile"], function(d, v) {
          var S = v + 1, O = S == ae || S == Se;
          $r.prototype[d] = function(G) {
            var ee = this.clone();
            return ee.__iteratees__.push({
              iteratee: gr(G, 3),
              type: S
            }), ee.__filtered__ = ee.__filtered__ || O, ee;
          };
        }), Jr(["head", "last"], function(d, v) {
          var S = "take" + (v ? "Right" : "");
          $r.prototype[d] = function() {
            return this[S](1).value()[0];
          };
        }), Jr(["initial", "tail"], function(d, v) {
          var S = "drop" + (v ? "" : "Right");
          $r.prototype[d] = function() {
            return this.__filtered__ ? new $r(this) : this[S](1);
          };
        }), $r.prototype.compact = function() {
          return this.filter(Ss);
        }, $r.prototype.find = function(d) {
          return this.filter(d).head();
        }, $r.prototype.findLast = function(d) {
          return this.reverse().find(d);
        }, $r.prototype.invokeMap = Sr(function(d, v) {
          return typeof d == "function" ? new $r(this) : this.map(function(S) {
            return Mo(S, d, v);
          });
        }), $r.prototype.reject = function(d) {
          return this.filter(Rg(gr(d)));
        }, $r.prototype.slice = function(d, v) {
          d = Xr(d);
          var S = this;
          return S.__filtered__ && (d > 0 || v < 0) ? new $r(S) : (d < 0 ? S = S.takeRight(-d) : d && (S = S.drop(d)), v !== t && (v = Xr(v), S = v < 0 ? S.dropRight(-v) : S.take(v - d)), S);
        }, $r.prototype.takeRightWhile = function(d) {
          return this.reverse().takeWhile(d).reverse();
        }, $r.prototype.toArray = function() {
          return this.take(ve);
        }, ts($r.prototype, function(d, v) {
          var S = /^(?:filter|find|map|reject)|While$/.test(v), O = /^(?:head|last)$/.test(v), G = J[O ? "take" + (v == "last" ? "Right" : "") : v], ee = O || /^find/.test(v);
          G && (J.prototype[v] = function() {
            var he = this.__wrapped__, ge = O ? [1] : arguments, Ce = he instanceof $r, je = ge[0], Qe = Ce || zr(he), Ke = function(dn) {
              var bn = G.apply(J, ua([dn], ge));
              return O && Ct ? bn[0] : bn;
            };
            Qe && S && typeof je == "function" && je.length != 1 && (Ce = Qe = !1);
            var Ct = this.__chain__, Ht = !!this.__actions__.length, mr = ee && !Ct, Kr = Ce && !Ht;
            if (!ee && Qe) {
              he = Kr ? he : new $r(this);
              var cr = d.apply(he, ge);
              return cr.__actions__.push({ func: Fg, args: [Ke], thisArg: t }), new ea(cr, Ct);
            }
            return mr && Kr ? d.apply(this, ge) : (cr = this.thru(Ke), mr ? O ? cr.value()[0] : cr.value() : cr);
          });
        }), Jr(["pop", "push", "shift", "sort", "splice", "unshift"], function(d) {
          var v = _u[d], S = /^(?:push|sort|unshift)$/.test(d) ? "tap" : "thru", O = /^(?:pop|shift)$/.test(d);
          J.prototype[d] = function() {
            var G = arguments;
            if (O && !this.__chain__) {
              var ee = this.value();
              return v.apply(zr(ee) ? ee : [], G);
            }
            return this[S](function(he) {
              return v.apply(zr(he) ? he : [], G);
            });
          };
        }), ts($r.prototype, function(d, v) {
          var S = J[v];
          if (S) {
            var O = S.name + "";
            pn.call(Da, O) || (Da[O] = []), Da[O].push({ name: v, func: S });
          }
        }), Da[Ue(t, E).name] = [{
          name: "wrapper",
          func: t
        }], $r.prototype.clone = Yl, $r.prototype.reverse = Lu, $r.prototype.value = Uu, J.prototype.at = M4, J.prototype.chain = N4, J.prototype.commit = L4, J.prototype.next = U4, J.prototype.plant = $4, J.prototype.reverse = z4, J.prototype.toJSON = J.prototype.valueOf = J.prototype.value = G4, J.prototype.first = J.prototype.head, Io && (J.prototype[Io] = V4), J;
      }), Os = Ou();
      xe ? ((xe.exports = Os)._ = Os, oe._ = Os) : N._ = Os;
    }).call(oq);
  })(Cp, Cp.exports)), Cp.exports;
}
var uq = lq();
class uR {
  constructor(e, t) {
    this.globalPropertyHandleService = e, this.callbacks = t;
  }
  async onGlobalPropertiesChanged(e, t) {
    if (this.callbacks.shouldSkipUpdate?.())
      return;
    const n = await this.globalPropertyHandleService.getHandles(), i = this.globalPropertyHandleService.applyConditionsFromState(n, e), a = this.globalPropertyHandleService.applyConditionsFromState(n, t);
    this.checkConditionalHandlesChanged(i, a), this.checkMandatoryHandlesChanged(e, a);
    const s = this.callbacks.getGlobalPropertyStateManager();
    let o = [];
    for (const h of n)
      a.find((f) => f.getName() == h.getName()) || (o = [...o, h.getName()]);
    await s.clearAspects(o);
    const l = a.map((h) => {
      if (h.getType() === Ji.ColorOption || h.getType() === Ji.Option) {
        const f = h;
        if (!t.aspects.find((m) => m.name === f.getName()))
          return f.initDefaultVariant();
      }
    });
    await Promise.all(l), await Promise.all(a.map((h) => h.applyGlobalState()));
    const u = s.getGlobalPropertyState(), c = this.globalPropertyHandleService.applyConditionsFromState(n, u);
    uq.isEqual(a.sort(), c.sort()) || (this.checkConditionalHandlesChanged(a, c), this.checkMandatoryHandlesChanged(u, c), await this.onGlobalPropertiesChanged(t, u));
  }
  checkConditionalHandlesChanged(e, t) {
    (() => {
      if (e.length !== t.length) return !0;
      for (let a = 0; a < e.length; a++)
        if (e[a].getName() !== t[a].getName()) return !0;
      return !1;
    })() && this.callbacks.fireEvent("conditional-global-properties-changed", {
      globalProperties: t
    });
  }
  checkMandatoryHandlesChanged(e, t) {
    const n = [], i = [], a = [], s = iR(e);
    t.forEach((o) => {
      if (o.isMandatory()) {
        const l = o.isMandatoryFulfilled();
        l ? i.push(o) : a.push(o);
        const u = s.get(o.getName());
        (u === void 0 || u !== l) && n.push(o);
      }
    }), this.callbacks.fireEvent("global-properties-mandatory-changed", {
      changed: n,
      completed: i,
      remaining: a
    });
  }
}
const cR = Oe`
    ${Cg}
    ${Y0}
    fragment GlobalPropertyTemplateFields on GlobalPropertyTemplate {
        id
        name
        globalPropertyConfiguration {
            ...GlobalPropertyConfigurationFields
        }
        aspectValues {
            ...GlobalPropertyStateAspectFields
        }
        createdAt
        updatedAt
        locked
    }
`, cq = Oe`
    ${cR}
    query GlobalPropertyTemplatesFeed(
        $limit: Int!
        $offset: Int!
        $customerId: String!
        $globalPropertyConfigurationId: String
    ) {
        globalPropertyTemplatesFeed(
            limit: $limit
            offset: $offset
            customerId: $customerId
            globalPropertyConfigurationId: $globalPropertyConfigurationId
        ) {
            items {
                ...GlobalPropertyTemplateFields
            }
            total
        }
    }
`, fq = Oe`
    ${cR}
    mutation CreateGlobalPropertyTemplate(
        $globalPropertyConfigurationId: String!
        $name: String
        $customerId: String
        $aspects: [GlobalPropertyStateAspectInput!]!
    ) {
        globalPropertyTemplateCreate(
            globalPropertyConfigurationId: $globalPropertyConfigurationId
            customerId: $customerId
            aspects: $aspects
        ) {
            ...GlobalPropertyTemplateFields
        }
    }
`, dq = Oe`
    mutation UpdateGlobalPropertyTemplate(
        $id: String!
        $name: String
        $aspectValues: [GlobalPropertyStateAspectInput]
    ) {
        globalPropertyTemplateUpdate(id: $id, name: $name, aspectValues: $aspectValues) {
            id
        }
    }
`, hq = Oe`
    mutation DeleteGlobalPropertyTemplate($id: String!) {
        globalPropertyTemplateDelete(id: id)
    }
`;
function dne(r, e) {
  return new mx(r, e);
}
class mx {
  constructor(e, t) {
    this.resource = e, this.client = t;
  }
  getId() {
    return this.resource.id;
  }
  getName() {
    return this.resource.name;
  }
  async setName(e) {
    this.resource.name = e, await this.update({ name: e });
  }
  getCreatedDate() {
    return new Date(this.resource.createdAt);
  }
  getUpdatedDate() {
    return new Date(this.resource.updatedAt);
  }
  getGlobalPropertyConfiguration() {
    return this.resource.globalPropertyConfiguration;
  }
  getAspects() {
    return this.resource.aspectValues ? Su(this.resource.aspectValues) : [];
  }
  getLocked() {
    return this.resource.locked;
  }
  async applyToBundle(e) {
    const n = (await et.getShadowGraphqlClient().query({
      query: LW,
      variables: {
        ids: [this.resource.globalPropertyConfiguration.id]
      }
    })).data.globalPropertyConfigurations[0];
    await e.setGlobalPropertyConfiguration(n), await e.applyGlobalPropertyState({
      aspects: this.resource.aspectValues ?? []
    });
  }
  async updateFromBundle(e) {
    const t = e.getGlobalPropertyStateManager().getGlobalPropertyState();
    t && await this.updateFromState(t);
  }
  async updateFromState(e) {
    this.resource.aspectValues = e.aspects, await this.update({ aspectValues: e.aspects });
  }
  /** Updates for null/undefined values on this entity are ignored by the server. */
  async update(e) {
    e.aspectValues && (e.aspectValues = aR(e.aspectValues)), await et.getShadowGraphqlClient().mutate({
      mutation: dq,
      variables: {
        ...e,
        id: this.resource.id
      }
    });
  }
  async delete() {
    await et.getShadowGraphqlClient().mutate({
      mutation: hq,
      variables: {
        id: this.resource.id
      }
    });
  }
  getEditor(e) {
    return this.templateEditor ? e !== void 0 && this.templateEditor.setAutoUpdateEnabled(e) : this.templateEditor = new pq(this, this.client, e ?? !0), this.templateEditor;
  }
}
class pq {
  constructor(e, t, n) {
    this.template = e, this.client = t, this.autoUpdate = n, this.eventEmitter = new lR(), this.workflowExperiences = /* @__PURE__ */ new Map(), this.previewService = void 0, this.selectedHandle = void 0, this.debouncedSave = W0(() => this.save(), 500), this.globalPropertyHandleService = new rR(this), this.globalPropertyChangeHandler = new uR(this.globalPropertyHandleService, {
      getGlobalPropertyStateManager: () => this.getGlobalPropertyStateManager(),
      fireEvent: (i, a) => this.eventEmitter.emit(i, a)
    }), this.globalPropertyStateManager = new sR(
      "",
      // Not required
      void 0,
      // Not required
      e.getGlobalPropertyConfiguration(),
      async (i, a) => {
        await this.globalPropertyChangeHandler.onGlobalPropertiesChanged(i, a), this.autoUpdate && this.debouncedSave();
      },
      {
        // Provide the existing state.
        // Required otherwise the manager would attempt to create a new state on the server.
        existingGlobalPropertyState: { id: "", aspects: e.getAspects() }
      }
    ), this.globalPropertyStateManager.disableServerUpdates();
  }
  // GlobalPropertyStateOwner interface
  getGlobalPropertyStateManager() {
    return this.globalPropertyStateManager;
  }
  getGlobalPropertyConfiguration() {
    return this.template.getGlobalPropertyConfiguration();
  }
  getWorkflowExperiences() {
    return Array.from(this.workflowExperiences.values());
  }
  getClient() {
    return this.client;
  }
  // end GlobalPropertyStateOwner interface
  setAutoUpdateEnabled(e) {
    this.autoUpdate = e;
  }
  async getGlobalProperties() {
    return this.globalPropertyHandleService.applyConditionsFromState(
      await this.globalPropertyHandleService.getHandles(),
      this.getGlobalPropertyStateManager().getGlobalPropertyState()
    );
  }
  async save() {
    const e = this.getGlobalPropertyStateManager().getGlobalPropertyState();
    if (!e)
      throw new Error("GlobalPropertyTemplateEditor has no Global Property State");
    await this.template.updateFromState(e);
  }
  async setPreviewService(e) {
    this.previewService = e, this.selectedHandle && this.previewService && await this.selectProduct(this.selectedHandle);
  }
  async loadProduct(e, t) {
    const n = nn(), i = await cO(t), a = sq({
      workflow: i,
      modelUrl: e.modelUrl
    });
    this.workflowExperiences.set(n, a), await a.getWorkflowManager().getInitializationPromise();
    const s = await this.getGlobalProperties();
    for (const o of s)
      await o.applyGlobalState([a]);
    return this.selectedHandle || await this.selectProduct(n), n;
  }
  async unloadProduct(e) {
    const t = this.workflowExperiences.get(e);
    if (!t)
      throw new Error(
        `Editor for Global Property Template ${this.template.getId()} does not have the workflow handle ${e}`
      );
    if (this.selectedHandle && this.previewService && t.getWorkflowManager().ejectFromPreviewService(), this.workflowExperiences.size > 1 && this.selectedHandle) {
      let n, i = !1;
      for (const [a, s] of this.workflowExperiences.entries()) {
        if (a === this.selectedHandle) {
          if (n)
            break;
          i = !0;
          continue;
        }
        if (n = a, i)
          break;
      }
      n ? await this.selectProduct(n) : this.selectedHandle = n;
    } else
      this.selectedHandle = void 0;
    this.workflowExperiences.delete(e);
  }
  async selectProduct(e) {
    const t = this.workflowExperiences.get(e);
    if (!t)
      throw new Error(
        `Editor for Global Property Template ${this.template.getId()} does not have the workflow handle ${e}`
      );
    this.selectedHandle = e, this.previewService && await t.getWorkflowManager().injectIntoPreviewService(this.previewService);
  }
  getProductExperience(e) {
    const t = this.workflowExperiences.get(e);
    if (!t)
      throw new Error(
        `Editor for Global Property Template ${this.template.getId()} does not have the workflow handle ${e}`
      );
    return t;
  }
  addEventListener(e, t) {
    this.eventEmitter.on(e, t);
  }
  removeEventListener(e, t) {
    this.eventEmitter.off(e, t);
  }
}
const gq = Oe`
    mutation AddAddressToBundle(
        $bundleId: String!
        $streetAddress: String
        $apartment: String
        $city: String
        $country: String
        $state: String
        $postCode: String
    ) {
        addressAttachToBundle(
            bundleId: $bundleId
            streetAddress: $streetAddress
            apartment: $apartment
            city: $city
            country: $country
            state: $state
            postCode: $postCode
        ) {
            id
        }
    }
`, mq = Oe`
    mutation AddOrganizationToBundle($bundleId: String!, $organizationName: String!) {
        organizationAttachToBundle(bundleId: $bundleId, organizationName: $organizationName) {
            id
        }
    }
`, vq = Oe`
    mutation GenerateQuoteId($id: String!) {
        bundleGenerateQuoteId(id: $id) {
            id
            quoteId
        }
    }
`;
class fT {
  constructor(e, t, n, i, a, s, o) {
    this.workflowExperiences = [], this.eventEmitter = new lR(), this.updatesLocked = !1, this.client = e, this.id = t.id, this.name = t.name || "", this.dispatchDate = t.dispatchDate, this.purchaseOrder = t.purchaseOrder, this.template = t.template || !1, this.test = t.test || !1, this.quoteId = t.quoteId, this.shareActions = t.bundleShareActions, this.workflowViewerLink = t.workflowViewerLink, this.workflowViewerAmendLink = t.workflowViewerAmendLink, this.ownerId = a, this.metadata = new Map(t.metadata?.map((l) => [l.key, l.value]) || []), this.completed = t.completed ?? !1, this.productCollection = t.productCollection, this.activation = t.activation, this.bundleStateManager = new tq(t.bundleStateData), this.originalGlobalPropertyConfiguration = t.globalPropertyConfiguration, this.globalPropertyStateManager = new sR(
      this.id,
      this.ownerId,
      this.getGlobalPropertyConfiguration(),
      this.onGlobalPropertiesChanged.bind(this),
      s
    ), this.globalPropertyHandleService = new rR(this), this.globalPropertyChangeHandler = new uR(this.globalPropertyHandleService, {
      getGlobalPropertyStateManager: () => this.getGlobalPropertyStateManager(),
      fireEvent: (l, u) => this.fireEvent(l, u),
      shouldSkipUpdate: () => this.updatesLocked
    }), this.setPreviewService(n), this.initializationPromise = (async () => {
      if (!s?.readonly) {
        const l = this.bundleStateManager.getState();
        if (l.integrationProductIds && l.integrationProductIds.length > 0) {
          const u = await et.getShadowGraphqlClient().query({
            query: HI,
            variables: {
              ids: l.integrationProductIds
            },
            errorPolicy: "all",
            fetchPolicy: "no-cache"
          });
          if (u.errors)
            throw new Error(`Failed to fetch integration products for Bundle ${t.id}`);
          const c = u.data.integrationProducts?.filter((f) => !!f.product?.id && l.integrationProductIds.includes(f.id)).map((f) => f.product.id);
          l.integrationProductIds = [], l.productIds = Array.from(/* @__PURE__ */ new Set([...l.productIds || [], ...c || []]));
          const h = JSON.stringify(l);
          this.bundleStateManager.setState(h), await et.getShadowGraphqlClient().mutate({
            mutation: Sm,
            variables: {
              id: this.id,
              bundleStateData: h
            },
            context: {
              bundleOwnerId: a
            }
          });
        }
      }
      return Promise.all([
        this.loadExistingWorkflowExperiences(
          t.transactionIds || [],
          {
            ...i,
            bundleOwnerId: a
          },
          o
        ),
        this.globalPropertyStateManager.getInitializationPromise()
      ]).then(
        () => new Promise((l, u) => {
          if (s?.readonly) {
            l([]);
            return;
          }
          console.log("Setting default global variants."), this.initializeUninitializedHandles().then(l).catch(u);
        })
      );
    })(), this.initializationPromise.catch((l) => {
      console.error(`Bundle initialization failed: ${l}`);
    }), this.initializationPromise.then(() => {
      this.getGlobalProperties().then((l) => this.checkMandatoryHandlesChanged(void 0, l));
    });
  }
  async initializeUninitializedHandles() {
    const e = this.globalPropertyStateManager.getGlobalPropertyState();
    if (!e)
      return console.log("Attempted to set global default variant before state was initialized."), [];
    const n = (await this.globalPropertyHandleService.getHandles()).map(async (i) => {
      if (i.getType() === Ji.ColorOption || i.getType() === Ji.Option) {
        const a = i;
        if (!e.aspects.find((o) => o.name === a.getName()))
          try {
            return await a.initDefaultVariant();
          } catch (o) {
            console.error(`Failed to initialize default global variant - ${o}`);
          }
      }
    });
    return Promise.all(n);
  }
  getProductIds() {
    return this.bundleStateManager.getState()?.productIds;
  }
  async addProductId(e) {
    const t = this.bundleStateManager.getState();
    if (t) {
      if (!t.productIds)
        t.productIds = [];
      else if (t.productIds.some((i) => i === e)) {
        this.fireEvent("bundle-products-added", {
          productIds: t.productIds,
          added: []
        });
        return;
      }
      t.productIds = [...t.productIds, e];
      const n = JSON.stringify(t);
      this.bundleStateManager.setState(n), this.fireEvent("bundle-products-added", {
        productIds: t.productIds,
        added: [e]
      }), await et.getShadowGraphqlClient().mutate({
        mutation: Sm,
        variables: {
          id: this.id,
          bundleStateData: n
        },
        context: {
          bundleOwnerId: this.ownerId
        }
      });
    }
  }
  async removeProductIds(e) {
    const t = this.bundleStateManager.getState();
    if (t) {
      const n = e.filter((a) => (t.productIds ?? []).includes(a));
      if (n.length === 0)
        return;
      t.productIds = (t.productIds ?? []).filter((a) => !n.includes(a));
      const i = JSON.stringify(t);
      this.bundleStateManager.setState(i), this.fireEvent("bundle-products-removed", {
        productIds: t.productIds,
        removed: n
        // Technically might not include all of these, but that's not important.
      }), await et.getShadowGraphqlClient().mutate({
        mutation: Sm,
        variables: {
          id: this.id,
          bundleStateData: i
        },
        context: {
          bundleOwnerId: this.ownerId
        }
      });
    }
  }
  getTemplate() {
    return this.template;
  }
  getTest() {
    return this.test;
  }
  async generateQuoteId() {
    const t = (await et.getShadowGraphqlClient().mutate({
      mutation: vq,
      variables: {
        id: this.id
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    })).data?.bundleGenerateQuoteId?.quoteId;
    return this.quoteId = t, t || "";
  }
  async attachAddress(e, t, n, i, a, s) {
    await et.getShadowGraphqlClient().mutate({
      mutation: gq,
      variables: {
        bundleId: this.id,
        streetAddress: e || void 0,
        apartment: t || void 0,
        city: n || void 0,
        country: i || void 0,
        state: a || void 0,
        postCode: s || void 0
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
  }
  async attachOrganization(e) {
    await et.getShadowGraphqlClient().mutate({
      mutation: mq,
      variables: {
        bundleId: this.id,
        organizationName: e
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
  }
  setBundleOptions(e) {
    this.globalPropertyStateManager.setBundleOptions(e);
  }
  getInitializationPromise() {
    return this.initializationPromise;
  }
  addEventListener(e, t) {
    this.eventEmitter.on(e, t);
  }
  removeEventListener(e, t) {
    this.eventEmitter.off(e, t);
  }
  getClient() {
    return this.client;
  }
  getId() {
    return this.id;
  }
  getName() {
    return this.name;
  }
  getQuoteId() {
    return this.quoteId;
  }
  setName(e) {
    return this.name = e, this.updateBundle();
  }
  getDispatchDate() {
    return this.dispatchDate;
  }
  setDispatchDate(e) {
    return this.dispatchDate = e, this.updateBundle();
  }
  getPurchaseOrder() {
    return this.purchaseOrder;
  }
  setPurchaseOrder(e) {
    return this.purchaseOrder = e, this.updateBundle();
  }
  getMetadata() {
    return new Map(this.metadata);
  }
  setMetadata(e) {
    return this.metadata = new Map(e), this.updateBundle();
  }
  setNameAndMetadata(e, t) {
    return this.name = e, this.metadata = new Map(t), this.updateBundle();
  }
  hasGlobalProperties() {
    return !!this.getGlobalPropertyConfiguration();
  }
  getGlobalPropertyConfiguration() {
    return this.getDefaultGlobalPropertyConfiguration();
  }
  /**
   * Fetches the default global property configuration to use.
   * The order of preference is:
   * - Manually overridden configuration (typically via a template).
   * - Original configuration (if this Bundle is a reloaded Bundle).
   * - Activation's linked configuration.
   * - Product Collection's linked configuration.
   */
  getDefaultGlobalPropertyConfiguration() {
    return this.originalGlobalPropertyConfiguration ?? this.activation?.globalPropertyConfiguration ?? this.productCollection?.globalPropertyConfiguration;
  }
  async setGlobalPropertyConfiguration(e) {
    await et.getShadowGraphqlClient().mutate({
      mutation: ej,
      variables: {
        bundleId: this.id,
        globalPropertyConfigurationId: e.id
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    }), this.overrideGlobalPropertyConfiguration = e, this.globalPropertyStateManager.setConfiguration(e);
  }
  async getGlobalProperties() {
    return this.globalPropertyHandleService.applyConditionsFromState(
      await this.globalPropertyHandleService.getHandles(),
      this.getGlobalPropertyStateManager().getGlobalPropertyState()
    );
  }
  async applyGlobalPropertyState(e) {
    this.updatesLocked = !0;
    const t = await this.globalPropertyHandleService.getHandles();
    try {
      for (const n of e.aspects) {
        const i = n?.name;
        await this.getGlobalPropertyStateManager().setAspect(
          i,
          n.value,
          void 0,
          void 0,
          n.hidden
        );
      }
      for (const n of e.aspects) {
        const i = n?.name, a = t.find((s) => s.getName() === i);
        if (a)
          switch (n.type) {
            case Ji.FileUpload: {
              const s = a, o = await h0([n.value]);
              o.length > 0 && await s.selectImage(o[0]);
              const l = n.storage?.colors;
              if (l) {
                const u = Object.fromEntries(
                  l.map((c) => [
                    c.key,
                    { browserValue: c.browserValue, pmsValue: c.pmsValue }
                  ]) ?? []
                );
                await s.changeColors(u);
              }
              break;
            }
            case Ji.ColorOption: {
              const s = a, l = (await s.getAllVariants()).find((c) => c.getId() === n.value), u = n.storage ? n.storage : void 0;
              l && await s.selectVariant(l), u?.customColor && s.setCustomColor(u.customColor);
              break;
            }
            case Ji.Option: {
              const s = a, l = (await s.getAllVariants()).find((u) => u.getId() === n.value);
              l && await s.selectVariant(l);
              break;
            }
            case Ji.Text: {
              await a.setText(n.value);
              break;
            }
          }
      }
    } finally {
      this.updatesLocked = !1, this.onGlobalPropertiesChanged(void 0, this.globalPropertyStateManager.getGlobalPropertyState());
    }
  }
  getGlobalPropertyStateManager() {
    return this.globalPropertyStateManager;
  }
  async getGlobalPropertyTotalSubunits() {
    return (await this.globalPropertyHandleService.getHandles()).filter((n) => n.getType() === Ji.Option).map((n) => n.getCurrentVariant()?.getPrice() || 0).reduce((n, i) => n + i, 0);
  }
  getTotalSubunits() {
    return this.workflowExperiences.map((e) => e.getTotalPriceSubunits()).reduce((e, t) => e + t, 0);
  }
  getProductCollection() {
    return this.productCollection ? new oR(this.productCollection) : void 0;
  }
  async initializeAdditionalRequiredColorChannels(e) {
    for (const t of e.getStepsByType(gt.Illustration)) {
      const n = t.getGlobalPropertyAspects(this.getGlobalPropertyConfiguration()?.id || "");
      for (const i of n) {
        const a = this.getGlobalPropertyConfiguration()?.aspects.find(
          (s) => s.name === i
        );
        if (a && a.type === Ji.ColorOption) {
          const s = t.getCurrentVariant()?.getAssetResource(), o = s?.assetConfiguration?.channelNumbers || [], l = s?.assetConfiguration?.defaultColorVariants || [], u = Qj(this, i), c = [...new Set(o.map((f) => f.number))];
          if (c.length > u)
            for (const f of c) {
              const p = this.getGlobalPropertyStateManager(), m = l.find((A) => A.channelNumber === f);
              m && await p.setAspect(i, m.variant.id || "", void 0, m.channelNumber);
            }
        }
      }
    }
  }
  async addWorkflowExperience(e) {
    await this.initializeAdditionalRequiredColorChannels(e), e.setBundle(this), await this.appendWorkflowExperience(e), await this.injectExperienceIntoPreviewService(e), await e.getWorkflowManager().getInitializationPromise();
    const t = await this.getGlobalProperties();
    for (const n of t)
      await n.applyGlobalState([e]);
    this.fireEvent("workflow-experience-added", {
      workflowExperiences: [e]
    });
  }
  async addWorkflowExperiences(e) {
    for (const o of e)
      await this.initializeAdditionalRequiredColorChannels(o);
    const t = e.map((o) => o.getTransaction().id), n = t.map(
      (o) => this.workflowExperiences.find((l) => l.getTransaction().id === o)
    );
    if (n.some((o) => !!o))
      throw new Error(
        "Unable to add transaction to bundle - Already Exists: " + n.filter((o) => !!o).map((o) => o?.getTransaction().id).join(", ")
      );
    const i = hn.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map(), a = t.map((o) => i.get(o));
    await et.getShadowGraphqlClient().mutate({
      mutation: jW,
      variables: {
        id: this.id,
        transactionIds: t,
        transactionOwnerIds: a
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    }), this.workflowExperiences.push(...e);
    const s = async () => {
      for (const l of e)
        l.setBundle(this), await this.injectExperienceIntoPreviewService(l);
      await Promise.all(e.map((l) => l.getWorkflowManager().getInitializationPromise()));
      const o = await this.getGlobalProperties();
      for (const l of o)
        await l.applyGlobalState(e);
    };
    await Promise.all([this.updateTransactionOrder(), s()]), await this.initializeUninitializedHandles(), this.workflowExperiences.forEach((o) => o.checkForPriceBreakChanges()), this.fireEvent("workflow-experience-added", {
      workflowExperiences: this.workflowExperiences
    });
  }
  async appendWorkflowExperience(e, t = !0) {
    const n = e.getTransaction().id;
    if (this.workflowExperiences.find((o) => o.getTransaction().id === n)) throw new Error("Unable to add transaction to bundle - Already Exists!");
    const s = (hn.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(n);
    await et.getShadowGraphqlClient().mutate({
      mutation: WW,
      variables: {
        id: this.id,
        transactionId: n
      },
      context: {
        bundleOwnerId: this.ownerId,
        transactionOwnerId: s
      }
    }), t && (this.workflowExperiences.push(e), this.workflowExperiences.forEach((o) => o.checkForPriceBreakChanges()));
  }
  async removeWorkflowExperience(e) {
    const t = this.workflowExperiences.indexOf(e);
    await this.removeTransaction(t, this.workflowExperiences[t].getTransaction()), this.fireEvent("workflow-experience-removed", {
      workflowExperiences: [e]
    });
  }
  async removeWorkflowExperiences(e) {
    await this.removeTransactions(e.map((t) => t.getTransaction()));
  }
  async removeWorkflowExperienceByTransaction(e) {
    const t = this.workflowExperiences.findIndex((n) => n.getTransaction().id === e.id);
    await this.removeTransaction(t, e);
  }
  async removeWorkflowExperiencesByTransactions(e) {
    await this.removeTransactions(e);
  }
  async removeTransaction(e, t, n = !0) {
    if (e > -1) {
      const i = this.workflowExperiences.find((a) => a.getTransaction().id === t.id);
      if (i.setBundle(void 0), this.previewService && i.getWorkflowManager().ejectFromPreviewService(), this.bundleStateManager.removeStateForTransaction(t.id), await et.getShadowGraphqlClient().mutate({
        mutation: qW,
        variables: {
          id: this.id,
          transactionId: t.id,
          name: this.name,
          metadata: Array.from(this.metadata.entries()).map(([a, s]) => ({ key: a, value: s })),
          bundleStateData: this.bundleStateManager.getSerializedState()
        },
        context: {
          bundleOwnerId: this.ownerId
        }
      }), n) {
        const a = this.workflowExperiences.splice(e, 1);
        this.workflowExperiences.forEach((s) => s.checkForPriceBreakChanges()), i.checkForPriceBreakChanges(), await this.updateTransactionOrder(), this.fireEvent("workflow-experience-removed", {
          workflowExperiences: a
        });
      }
    } else
      throw new Error("Unable to remove workflow experience from bundle - Not Found! - " + t.id);
  }
  async removeTransactions(e) {
    const t = e.map(
      (i) => this.workflowExperiences.findIndex((a) => a.getTransaction().id === i.id)
    );
    if (t.some((i) => i === -1))
      throw new Error(
        "Unable to remove workflow experience from bundle - The following aren't included in the bundle: " + e.filter((i, a) => t[a] === -1).map((i) => i.id).join(", ")
      );
    const n = e.map(
      (i) => this.workflowExperiences.splice(
        this.workflowExperiences.findIndex((a) => a.getTransaction().id === i.id),
        1
      )[0]
    );
    n.forEach((i) => i.setBundle(void 0)), [...this.workflowExperiences, ...n].forEach(
      (i) => i.checkForPriceBreakChanges()
    ), this.previewService && n.forEach((i) => i.getWorkflowManager().ejectFromPreviewService()), e.forEach((i) => this.bundleStateManager.removeStateForTransaction(i.id)), await et.getShadowGraphqlClient().mutate({
      mutation: QW,
      variables: {
        id: this.id,
        transactionIds: e.map((i) => i.id),
        name: this.name,
        metadata: Array.from(this.metadata.entries()).map(([i, a]) => ({ key: i, value: a })),
        bundleStateData: this.bundleStateManager.getSerializedState()
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    }), this.fireEvent("workflow-experience-removed", {
      workflowExperiences: n
    }), await this.updateTransactionOrder();
  }
  async insertWorkflowExperience(e, t) {
    await this.appendWorkflowExperience(e, !1), this.workflowExperiences.splice(t, 0, e), await Promise.all([
      this.updateTransactionOrder(),
      (async () => {
        await this.injectExperienceIntoPreviewService(e);
        const n = await this.getGlobalProperties();
        await Promise.all(n.map((i) => i.applyGlobalState([e])));
      })()
    ]);
  }
  async replaceWorkflowExperience(e, t) {
    if (e < 0 || e >= this.workflowExperiences.length)
      throw new Error("Unable to replace workflow experience in bundle - Index out of range!");
    const n = this.workflowExperiences[e];
    if (n.getTransaction().id === t.getTransaction().id)
      throw new Error("Unable to replace workflow experience in bundle - Same transaction!");
    await Promise.all([
      this.removeTransaction(e, n.getTransaction(), !1),
      this.appendWorkflowExperience(t, !1)
    ]), this.workflowExperiences[e] = t, await Promise.all([
      this.updateTransactionOrder(),
      (async () => {
        await this.injectExperienceIntoPreviewService(t);
        const i = await this.getGlobalProperties();
        await Promise.all(i.map((a) => a.applyGlobalState([t])));
      })()
    ]);
  }
  async swapWorkflowExperiences(e, t) {
    if (e < 0 || e >= this.workflowExperiences.length || t < 0 || t >= this.workflowExperiences.length)
      throw new Error("Unable to swap workflow experiences in bundle - Index out of range!");
    if (e === t) return;
    const n = this.workflowExperiences[e];
    this.workflowExperiences[e] = this.workflowExperiences[t], this.workflowExperiences[t] = n, await this.updateTransactionOrder();
  }
  getWorkflowExperiences() {
    return [...this.workflowExperiences];
  }
  getTopLevelWorkflowExperiences() {
    return this.workflowExperiences.filter((e) => !e.getTransaction().parentTransaction);
  }
  getChildWorkflowExperiences(e) {
    return this.workflowExperiences.filter(
      (t) => t.getTransaction().parentTransaction?.id === e
    );
  }
  async sortWorkflowExperiences(e) {
    this.workflowExperiences = this.workflowExperiences.sort(e), await this.updateTransactionOrder();
  }
  getWorkflowExperienceCount() {
    return this.workflowExperiences.length;
  }
  async addStakeholder(e, t) {
    const n = await et.getShadowGraphqlClient().mutate({
      mutation: YW,
      variables: {
        id: this.id,
        details: e,
        type: t || mI.Owner
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (!n.data?.bundleAddStakeholder) throw new Error("Bundle not found!");
    const i = n.data.bundleAddStakeholder.bundleStakeholders || [];
    this.storeStakeholderCustomers(i);
  }
  async removeStakeholder(e) {
    if (!(await et.getShadowGraphqlClient().mutate({
      mutation: XW,
      variables: {
        id: this.id,
        emailAddress: e
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    })).data?.bundleRemoveStakeholder) throw new Error("Bundle not found!");
  }
  async updateStakeholders(e) {
    const t = await et.getShadowGraphqlClient().mutate({
      mutation: JW,
      variables: {
        id: this.id,
        input: e
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (!t.data?.bundleUpdateStakeholders) throw new Error("Bundle not found!");
    const n = t.data.bundleUpdateStakeholders.bundleStakeholders || [];
    this.storeStakeholderCustomers(n);
  }
  async getAllStakeholders() {
    const e = await et.getShadowGraphqlClient().query({
      query: eT,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.id
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (!e.data.bundles || e.data.bundles.length === 0) throw new Error("Bundle not found!");
    const t = e.data.bundles[0].bundleStakeholders || [];
    return this.storeStakeholderCustomers(t), t;
  }
  async getCurrentStakeholder() {
    const e = await et.getShadowGraphqlClient().query({
      query: eT,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.id
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (!e.data.bundles || e.data.bundles.length === 0) throw new Error("Bundle not found!");
    return e.data.bundles[0].currentBundleStakeholder;
  }
  storeStakeholderCustomers(e) {
    e.forEach((t) => {
      t.customer && this.client.storeCustomer(t.customer);
    });
  }
  async finish(e, t) {
    this.completed && await et.getShadowGraphqlClient().mutate({
      mutation: rj,
      variables: {
        bundleId: this.id
      }
    });
    const n = this.workflowExperiences.filter((o) => !!o.getWorkflow()), i = this.workflowExperiences.filter((o) => !o.getWorkflow() && !!o.getTransaction().parentTransaction?.id).map((o) => o.getTransaction()), a = await eR(
      n.map((o) => {
        const l = o.getWorkflow();
        if (!l) throw new Error("Unable to create designs - Workflow not found!");
        const u = o.getProduct();
        if (!u) throw new Error("Unable to create designs - Product not found!");
        return {
          workflowManager: o.getWorkflowManager(),
          workflow: l,
          layouts: o.getWorkflowManager().getLayouts(),
          getReducerState: () => o.getCommandContext().getState(),
          product: u,
          transaction: o.getTransaction(),
          workflowSelections: o.getWorkflowManager().getWorkflowSelections(),
          designName: l.name,
          workflowMetadata: o.getWorkflowManager().getWorkflowMetadata()
        };
      }),
      t ? (o, l) => {
        const u = n.find(
          (c) => c.getTransaction().id === l
        );
        return u ? t(u, o) : (console.warn(
          "SpiffCommerce - Bundle create design - Unable to find experience for transaction: " + l
        ), Promise.resolve(void 0));
      } : void 0
    ), s = /* @__PURE__ */ new Map();
    return n.forEach((o, l) => {
      s.set(o.getTransaction().id, a[l]);
    }), await _j(i), Mj(s, i), {
      bundleId: this.id,
      name: this.getName(),
      dispatchDate: this.getDispatchDate() || "",
      purchaseOrder: this.getPurchaseOrder() || "",
      collectionId: this.getProductCollection()?.getId() || "",
      collectionName: this.getProductCollection()?.getName() || "",
      items: a,
      bundleOwnerId: this.ownerId
    };
  }
  async placeOrder() {
    const e = this.workflowExperiences.map((t) => ({
      transactionId: t.getTransaction().id,
      amountToOrder: t.getTransaction().quantity || 1
    }));
    return await this.getClient().placeOrder(e);
  }
  getPreviewService() {
    return this.previewService;
  }
  async setPreviewService(e) {
    if (this.workflowExperiences && this.workflowExperiences.length > 0 && (this.workflowExperiences.forEach((t) => t.getWorkflowManager().ejectFromPreviewService()), e))
      for (const t of this.workflowExperiences)
        await this.injectExperienceIntoPreviewService(t);
    e && e.registerModelLoadEventListener && e.registerModelLoadEventListener(this.onModelLoadEvent.bind(this)), this.previewService && this.previewService !== e && this.previewService.unregisterModelLoadEventListener && this.previewService.unregisterModelLoadEventListener(this.onModelLoadEvent.bind(this)), this.previewService = e;
  }
  async assignProductCollection(e) {
    const t = await et.getShadowGraphqlClient().mutate({
      mutation: ZW(
        this.globalPropertyStateManager.getBundleOptions()?.eagerFetchProducts ?? !1
      ),
      variables: {
        id: this.id,
        productCollectionId: e ?? ""
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (t.data?.bundleAssignProductCollection.productCollection) {
      this.productCollection = t.data.bundleAssignProductCollection.productCollection;
      const n = this.getGlobalPropertyConfiguration();
      this.globalPropertyStateManager.setConfiguration(n), await this.globalPropertyHandleService.getHandles(), await this.clearOldProducts(this.workflowExperiences);
    }
  }
  onModelLoadEvent(e) {
    e.eventType === "unload" || !e.modelContainer || (e.modelContainer.registerMaterialSelectedCallback(() => this.onModelSelectedEvent(e.modelContainer, !0)), e.modelContainer.registerMaterialDeselectedCallback(() => this.onModelSelectedEvent(e.modelContainer, !1)));
  }
  onModelSelectedEvent(e, t) {
    if (e && e.metadata && e.metadata instanceof Map && e.metadata.has("workflowManager")) {
      const i = e.metadata.get("workflowManager").getWorkflowExperience().getTransaction(), a = this.workflowExperiences.find((s) => s.getTransaction().id === i.id);
      a && this.fireEvent(t ? "workflow-experience-hover-enter" : "workflow-experience-hover-exit", {
        workflowExperience: a
      });
    }
  }
  async injectExperienceIntoPreviewService(e) {
    this.previewService && await e.getWorkflowManager().injectIntoPreviewService(this.previewService);
  }
  async loadExistingWorkflowExperiences(e, t, n) {
    let i = [];
    if (e.length > 0 && (i = await this.client.getWorkflowExperiences(
      e.map((a) => ({
        type: "transaction",
        transactionId: a
      })),
      t,
      void 0,
      n
    ), i.forEach((a) => a.setBundle(this)), i.forEach((a) => a.checkForPriceBreakChanges()), this.workflowExperiences = i, this.previewService))
      for (const a of i)
        await this.injectExperienceIntoPreviewService(a);
    await this.clearOldProducts(i);
  }
  // Remove products from bundle that aren't in the collection.
  async clearOldProducts(e) {
    if (!this.globalPropertyStateManager.getBundleOptions()?.readonly) {
      const t = this.getProductIds() || [], n = this.getProductCollection();
      if (n && t.length > 0) {
        await n.fetchProducts();
        const i = n.getProducts(), a = [], s = [];
        for (const l of t)
          if (!i.find((c) => c.getId() === l)) {
            for (const c of e)
              c.getProduct()?.id === l && s.push(c);
            a.push(l);
          }
        const o = [];
        a.length > 0 && o.push(this.removeProductIds(a)), s.length > 0 && o.push(Promise.all(s.map((l) => l.clearProduct()))), o.length > 0 && await Promise.all(o);
      }
    }
  }
  async updateBundle() {
    if (!(await et.getShadowGraphqlClient().mutate({
      mutation: Sm,
      variables: {
        id: this.id,
        name: this.name,
        metadata: Array.from(this.metadata.entries()).map(([t, n]) => ({ key: t, value: n })),
        bundleStateData: this.bundleStateManager.getSerializedState(),
        dispatchDate: this.dispatchDate,
        purchaseOrder: this.purchaseOrder
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    })).data?.bundleUpdate) throw new Error("Bundle not found!");
  }
  async updateTransactionOrder() {
    await et.getShadowGraphqlClient().mutate({
      mutation: KW,
      variables: {
        id: this.id,
        transactionIds: this.workflowExperiences.map((e) => e.getTransaction().id)
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
  }
  async onGlobalPropertiesChanged(e, t) {
    return this.globalPropertyChangeHandler.onGlobalPropertiesChanged(e, t);
  }
  checkConditionalHandlesChanged(e, t) {
    return this.globalPropertyChangeHandler.checkConditionalHandlesChanged(e, t);
  }
  checkMandatoryHandlesChanged(e, t) {
    return this.globalPropertyChangeHandler.checkMandatoryHandlesChanged(e, t);
  }
  fireEvent(e, t) {
    this.eventEmitter.emit(e, t);
  }
  getShareActions() {
    return this.shareActions;
  }
  getWorkflowViewerLink() {
    return this.workflowViewerLink;
  }
  getWorkflowViewerAmendLink() {
    return this.workflowViewerAmendLink;
  }
  async approve(e, t) {
    await et.getShadowGraphqlClient().mutate({
      mutation: nj,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.id,
        note: e,
        stakeholderId: t
      }
    });
  }
  async reject(e, t) {
    await et.getShadowGraphqlClient().mutate({
      mutation: ij,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.id,
        note: e,
        stakeholderId: t
      }
    });
  }
  getQuoteCompleteMessage() {
    return {
      bundleId: this.id,
      bundleOwnerId: this.ownerId,
      quoteId: this.quoteId || ""
    };
  }
  async convertToTemplate(e) {
    if (!this.client.getCustomer())
      throw new Error("Cannot convert Bundle to a Template: no customer present.");
    const n = this.getGlobalPropertyConfiguration();
    if (!n)
      throw new Error(
        "Cannot convert Bundle to a Template: no Global Property Configuration assigned to this Bundle."
      );
    const i = this.globalPropertyStateManager.getGlobalPropertyState();
    if (!i)
      throw new Error("Cannot convert Bundle to a Template: no Global Property state present.");
    const a = await et.getShadowGraphqlClient().mutate({
      mutation: fq,
      variables: {
        name: e,
        aspects: i.aspects,
        globalPropertyConfigurationId: n.id
      }
    });
    if (!a.data)
      throw new Error("Failed to create new Template");
    return new mx(a.data.globalPropertyTemplateCreate, this.getClient());
  }
}
const yq = Oe`
    mutation processFlowCreate($processFlowId: String!, $inputs: [String]!) {
        processExecutionCreate(processFlowId: $processFlowId, inputs: $inputs) {
            id
        }
    }
`;
class Aq {
  /**
   *
   * @param id
   * @param inputs
   * @param options
   * @returns
   */
  async execute(e, t, n) {
    const a = (await et.getShadowGraphqlClient().mutate({
      mutation: yq,
      variables: {
        processFlowId: e,
        inputs: [...t.map((h) => h.getValueForTransmission())]
      },
      fetchPolicy: "no-cache"
    })).data?.processExecutionCreate?.id;
    if (!a) throw new Error("Failed to create process execution.");
    function s(h) {
      return new Promise((f) => {
        setTimeout(f, h);
      });
    }
    let o = !1, l = 0, u, c;
    for (; !o; ) {
      u = await et.getShadowGraphqlClient().query({
        query: Oe`
                    query getProcessFlowExecution($ids: [String]!) {
                        processExecutions(ids: $ids) {
                            id
                            completedAt
                            failedAt
                            nodes {
                                id
                                type
                                artifacts
                            }
                        }
                    }
                `,
        variables: {
          ids: [a]
        },
        fetchPolicy: "no-cache"
      });
      const h = u.data?.processExecutions[0];
      if (!u || !h) throw new Error("Failed to retrieve server response for execution.");
      if (h.failedAt)
        throw new Error(
          "Execution has failed to complete. See Automation > FLows in Flight on partner account on SpiffCommerce Hub."
        );
      if (h.completedAt) {
        o = !0, c = new wq(h);
        break;
      }
      l += 1;
      const f = n?.repeats ? n?.repeats : 5;
      if (l >= f) throw new Error("Maximum wait time exceeded for execution result.");
      await s(n?.sleepTime ? Math.max(n.sleepTime, 500) : 2e3);
    }
    if (!c) throw new Error("Failed to retrieve server response for execution.");
    return Promise.resolve(c);
  }
}
class wq {
  constructor(e) {
    this.execution = e;
  }
  /**
   * @returns The raw response from the server.
   */
  getRaw() {
    return this.execution;
  }
  /**
   * @returns The nodes contained within the execution.
   */
  getNodes() {
    return this.execution.nodes.map((e) => new km(e));
  }
  /**
   * @param type The type of node to return.
   * @returns A list of nodes matching the requested type.
   */
  getNodesByType(e) {
    return this.execution.nodes.filter((t) => t.type === e).map((t) => new km(t));
  }
  /**
   * @returns A list of input nodes that exist in this execution.
   */
  getInputs() {
    return this.execution.nodes.filter(
      (e) => e.type === "StartTerminal"
      /* StartTerminal */
    ).map((e) => new km(e));
  }
  /**
   * @returns A list of out put nodes that exist in this execution.
   */
  getOutputs() {
    return this.execution.nodes.filter(
      (e) => e.type === "EndTerminal"
      /* EndTerminal */
    ).map((e) => new km(e));
  }
  /**
   * @returns A date object representing the point in time this execution completed.
   */
  getCompletedAt() {
    if (this.execution.completedAt)
      return new Date(this.execution.completedAt);
  }
  /**
   * @returns A date object representing the point in time this execution failed.
   */
  getFailedAt() {
    if (this.execution.failedAt)
      return new Date(this.execution.failedAt);
  }
}
class km {
  constructor(e) {
    this.node = e;
  }
  getId() {
    return this.node.id;
  }
  getType() {
    return this.node.type;
  }
  getArtifacts() {
    return new Map(Object.entries(JSON.parse(this.node.artifacts).value));
  }
  getArtifactByName(e) {
    return this.getArtifacts().get(e);
  }
}
class vx {
  constructor(e) {
    this.value = e;
  }
  getRaw() {
    return this.value;
  }
  getValueForTransmission() {
    const e = this.value;
    return e.startsWith("[") ? JSON.stringify(JSON.parse(e)) : e;
  }
}
var xq = /* @__PURE__ */ ((r) => (r.Transaction = "Transaction", r.Bundle = "Bundle", r.Product = "Product", r.Variant = "Variant", r.Option = "Option", r.LineItem = "LineItem", r.Asset = "Asset", r))(xq || {});
class hne extends vx {
  constructor(e) {
    super(`"${e}"`);
  }
}
class fR extends vx {
  constructor(e, t) {
    if (t !== "Asset" && !fR.validUUID(e))
      throw new Error("Invalid ID, must be a valid v4 UUID. https://www.uuidgenerator.net/");
    super(`{"isSpiffObject": true, "id": "${e}", "type": "${t}"}`);
  }
  static validUUID(e) {
    return e.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
  }
}
class pne extends vx {
  constructor(e) {
    super(`[${e.map((t) => t.getRaw()).join(",")}]`);
  }
}
class dT {
  constructor(e) {
    this.integrationProduct = e;
  }
  getId() {
    return this.integrationProduct.id;
  }
  getResource() {
    return this.integrationProduct;
  }
  getBasePrice() {
    if (!this.integrationProduct.product)
      throw new Error("IntegrationProductResource does not have a product");
    const e = this.integrationProduct.product.basePrice || 0, t = this.integrationProduct?.additionalIntegrationProduct;
    if (!t) return e;
    if (t && !t.product)
      throw new Error("An additional integration product was found, but it does not have a product");
    return e + (t.product.basePrice || 0);
  }
  getDefaultWorkflow() {
    if (!this.integrationProduct.product)
      throw new Error("IntegrationProductResource does not have a product");
    const e = this.integrationProduct.product.workflows || [];
    if (e.length === 0)
      throw new Error(
        "No workflows found on product. This is generally due to a configuration error. Please confirm at least one workflow is configured for this product."
      );
    return new Ff(e[0]);
  }
  getAllWorkflows() {
    if (!this.integrationProduct.product)
      throw new Error("IntegrationProductResource does not have a product");
    const e = this.integrationProduct.product.workflows || [];
    if (e.length === 0)
      throw new Error(
        "No workflows found on product. This is generally due to a configuration error. Please confirm at least one workflow is configured for this product."
      );
    return e.sort((t, n) => (t.index ?? 0) - (n.index ?? 0)).map((t) => new Ff(t));
  }
}
const pA = Oe`
    query GetCustomer($emailAddress: String!) {
        customer(emailAddress: $emailAddress) {
            id
            emailAddress
            defaultTemplateBundleId
            hasBundleTemplates
            partner {
                id
            }
            productCollectionCustomers {
                id
                customer {
                    id
                }
                productCollection {
                    id
                }
            }
        }
    }
`, bq = Oe`
    mutation CustomerCreate($details: CustomerDetailsInput!) {
        customerCreate(details: $details) {
            id
            emailAddress
            partner {
                id
            }
        }
    }
`;
Oe`
    mutation CustomerAuthenticate($loginToken: String!) {
        customerAuthenticate(loginToken: $loginToken) {
            id
            emailAddress
            stakeholders {
                id
                type
                transaction {
                    id
                }
            }
            bundleStakeholders {
                id
                authorizationStatus
                authorizationDate
                authorizationNote
                type
                bundle {
                    id
                    transactions {
                        id
                    }
                }
            }
            partner {
                id
            }
            productCollectionCustomers {
                id
                customer {
                    id
                }
                productCollection {
                    id
                }
            }
        }
    }
`;
const Cq = Oe`
    mutation CustomerGenerateVerificationCode($emailAddress: String!) {
        customerGenerateVerificationCode(emailAddress: $emailAddress)
    }
`, Sq = Oe`
    mutation CustomerVerifyCode($emailAddress: String!, $verificationCode: String!) {
        customerVerifyCode(emailAddress: $emailAddress, verificationCode: $verificationCode) {
            id
            emailAddress
            loginToken
            partner {
                id
            }
            stakeholders {
                id
                type
                transaction {
                    id
                }
            }
            bundleStakeholders {
                id
                authorizationStatus
                authorizationDate
                authorizationNote
                type
                bundle {
                    id
                    transactions {
                        id
                    }
                }
            }
            productCollectionCustomers {
                id
                customer {
                    id
                }
                productCollection {
                    id
                }
            }
        }
    }
`, Eq = Oe`
    query CustomerMetafields($id: String!) {
        metafields(entityId: $id) {
            id
            createdAt
            updatedAt
            entityId
            value
            metafieldConfiguration {
                id
                createdAt
                updatedAt
                entityType
                metafieldType
                name
            }
        }
    }
`;
class kq {
  constructor(e, t = et.getShadowGraphqlClient.bind(et)) {
    this.options = e, this.client = t;
  }
  query(e) {
    const t = this.options?.onQuery ? this.options?.onQuery(e) : {};
    return this.client().query({
      ...t,
      ...e,
      context: {
        ...t.context ?? {},
        ...e.context ?? {}
      }
    });
  }
  mutate(e) {
    const t = this.options?.onMutate ? this.options?.onMutate(e) : {};
    return this.client().mutate({
      ...t,
      ...e,
      context: {
        ...t.context ?? {},
        ...e.context ?? {}
      }
    });
  }
}
function Tq(r, e, t) {
  return r.$source || (r.$source = {}), r.$source[e] = t, r;
}
const Fq = (r) => r?.body instanceof ReadableStream, xf = (r, e) => {
  const t = [];
  if (r && t.push(r), e)
    for (const n of e)
      t.push(n);
  return t;
}, uc = (r, e) => `${r || "anonymous"}${e && e.length > 0 ? ` (a.k.a. ${e.join(",")})` : ""}`, T0 = () => {
  let r = [], e = [], t = !1;
  const n = /* @__PURE__ */ new Set(), i = (h) => h.sort((f, p) => hT[p.step] - hT[f.step] || pT[p.priority || "normal"] - pT[f.priority || "normal"]), a = (h) => {
    let f = !1;
    const p = (m) => {
      const A = xf(m.name, m.aliases);
      if (A.includes(h)) {
        f = !0;
        for (const w of A)
          n.delete(w);
        return !1;
      }
      return !0;
    };
    return r = r.filter(p), e = e.filter(p), f;
  }, s = (h) => {
    let f = !1;
    const p = (m) => {
      if (m.middleware === h) {
        f = !0;
        for (const A of xf(m.name, m.aliases))
          n.delete(A);
        return !1;
      }
      return !0;
    };
    return r = r.filter(p), e = e.filter(p), f;
  }, o = (h) => (r.forEach((f) => {
    h.add(f.middleware, { ...f });
  }), e.forEach((f) => {
    h.addRelativeTo(f.middleware, { ...f });
  }), h.identifyOnResolve?.(c.identifyOnResolve()), h), l = (h) => {
    const f = [];
    return h.before.forEach((p) => {
      p.before.length === 0 && p.after.length === 0 ? f.push(p) : f.push(...l(p));
    }), f.push(h), h.after.reverse().forEach((p) => {
      p.before.length === 0 && p.after.length === 0 ? f.push(p) : f.push(...l(p));
    }), f;
  }, u = (h = !1) => {
    const f = [], p = [], m = {};
    return r.forEach((w) => {
      const x = {
        ...w,
        before: [],
        after: []
      };
      for (const E of xf(x.name, x.aliases))
        m[E] = x;
      f.push(x);
    }), e.forEach((w) => {
      const x = {
        ...w,
        before: [],
        after: []
      };
      for (const E of xf(x.name, x.aliases))
        m[E] = x;
      p.push(x);
    }), p.forEach((w) => {
      if (w.toMiddleware) {
        const x = m[w.toMiddleware];
        if (x === void 0) {
          if (h)
            return;
          throw new Error(`${w.toMiddleware} is not found when adding ${uc(w.name, w.aliases)} middleware ${w.relation} ${w.toMiddleware}`);
        }
        w.relation === "after" && x.after.push(w), w.relation === "before" && x.before.push(w);
      }
    }), i(f).map(l).reduce((w, x) => (w.push(...x), w), []);
  }, c = {
    add: (h, f = {}) => {
      const { name: p, override: m, aliases: A } = f, w = {
        step: "initialize",
        priority: "normal",
        middleware: h,
        ...f
      }, x = xf(p, A);
      if (x.length > 0) {
        if (x.some((E) => n.has(E))) {
          if (!m)
            throw new Error(`Duplicate middleware name '${uc(p, A)}'`);
          for (const E of x) {
            const T = r.findIndex((F) => F.name === E || F.aliases?.some((_) => _ === E));
            if (T === -1)
              continue;
            const D = r[T];
            if (D.step !== w.step || w.priority !== D.priority)
              throw new Error(`"${uc(D.name, D.aliases)}" middleware with ${D.priority} priority in ${D.step} step cannot be overridden by "${uc(p, A)}" middleware with ${w.priority} priority in ${w.step} step.`);
            r.splice(T, 1);
          }
        }
        for (const E of x)
          n.add(E);
      }
      r.push(w);
    },
    addRelativeTo: (h, f) => {
      const { name: p, override: m, aliases: A } = f, w = {
        middleware: h,
        ...f
      }, x = xf(p, A);
      if (x.length > 0) {
        if (x.some((E) => n.has(E))) {
          if (!m)
            throw new Error(`Duplicate middleware name '${uc(p, A)}'`);
          for (const E of x) {
            const T = e.findIndex((F) => F.name === E || F.aliases?.some((_) => _ === E));
            if (T === -1)
              continue;
            const D = e[T];
            if (D.toMiddleware !== w.toMiddleware || D.relation !== w.relation)
              throw new Error(`"${uc(D.name, D.aliases)}" middleware ${D.relation} "${D.toMiddleware}" middleware cannot be overridden by "${uc(p, A)}" middleware ${w.relation} "${w.toMiddleware}" middleware.`);
            e.splice(T, 1);
          }
        }
        for (const E of x)
          n.add(E);
      }
      e.push(w);
    },
    clone: () => o(T0()),
    use: (h) => {
      h.applyToStack(c);
    },
    remove: (h) => typeof h == "string" ? a(h) : s(h),
    removeByTag: (h) => {
      let f = !1;
      const p = (m) => {
        const { tags: A, name: w, aliases: x } = m;
        if (A && A.includes(h)) {
          const E = xf(w, x);
          for (const T of E)
            n.delete(T);
          return f = !0, !1;
        }
        return !0;
      };
      return r = r.filter(p), e = e.filter(p), f;
    },
    concat: (h) => {
      const f = o(T0());
      return f.use(h), f.identifyOnResolve(t || f.identifyOnResolve() || (h.identifyOnResolve?.() ?? !1)), f;
    },
    applyToStack: o,
    identify: () => u(!0).map((h) => {
      const f = h.step ?? h.relation + " " + h.toMiddleware;
      return uc(h.name, h.aliases) + " - " + f;
    }),
    identifyOnResolve(h) {
      return typeof h == "boolean" && (t = h), t;
    },
    resolve: (h, f) => {
      for (const p of u().map((m) => m.middleware).reverse())
        h = p(h, f);
      return t && console.log(c.identify()), h;
    }
  };
  return c;
}, hT = {
  initialize: 5,
  serialize: 4,
  build: 3,
  finalizeRequest: 2,
  deserialize: 1
}, pT = {
  high: 3,
  normal: 2,
  low: 1
};
var Kp;
(function(r) {
  r.HTTP = "http", r.HTTPS = "https";
})(Kp || (Kp = {}));
var Zp;
(function(r) {
  r.MD5 = "md5", r.CRC32 = "crc32", r.CRC32C = "crc32c", r.SHA1 = "sha1", r.SHA256 = "sha256";
})(Zp || (Zp = {}));
const K1 = "__smithy_context", lh = (r) => r[K1] || (r[K1] = {});
class Xs {
  method;
  protocol;
  hostname;
  port;
  path;
  query;
  headers;
  username;
  password;
  fragment;
  body;
  constructor(e) {
    this.method = e.method || "GET", this.hostname = e.hostname || "localhost", this.port = e.port, this.query = e.query || {}, this.headers = e.headers || {}, this.body = e.body, this.protocol = e.protocol ? e.protocol.slice(-1) !== ":" ? `${e.protocol}:` : e.protocol : "https:", this.path = e.path ? e.path.charAt(0) !== "/" ? `/${e.path}` : e.path : "/", this.username = e.username, this.password = e.password, this.fragment = e.fragment;
  }
  static clone(e) {
    const t = new Xs({
      ...e,
      headers: { ...e.headers }
    });
    return t.query && (t.query = Iq(t.query)), t;
  }
  static isInstance(e) {
    if (!e)
      return !1;
    const t = e;
    return "method" in t && "protocol" in t && "hostname" in t && "path" in t && typeof t.query == "object" && typeof t.headers == "object";
  }
  clone() {
    return Xs.clone(this);
  }
}
function Iq(r) {
  return Object.keys(r).reduce((e, t) => {
    const n = r[t];
    return {
      ...e,
      [t]: Array.isArray(n) ? [...n] : n
    };
  }, {});
}
class jd {
  statusCode;
  reason;
  headers;
  body;
  constructor(e) {
    this.statusCode = e.statusCode, this.reason = e.reason, this.headers = e.headers || {}, this.body = e.body;
  }
  static isInstance(e) {
    if (!e)
      return !1;
    const t = e;
    return typeof t.statusCode == "number" && typeof t.headers == "object";
  }
}
const Pq = new RegExp("^(?!.*-$)(?!-)[a-zA-Z0-9-]{1,63}$"), K0 = (r, e = !1) => {
  if (!e)
    return Pq.test(r);
  const t = r.split(".");
  for (const n of t)
    if (!K0(n))
      return !1;
  return !0;
}, ku = (r) => {
  if (typeof r == "function")
    return r;
  const e = Promise.resolve(r);
  return () => e;
};
function Dq(r) {
  const e = {};
  if (r = r.replace(/^\?/, ""), r)
    for (const t of r.split("&")) {
      let [n, i = null] = t.split("=");
      n = decodeURIComponent(n), i && (i = decodeURIComponent(i)), n in e ? Array.isArray(e[n]) ? e[n].push(i) : e[n] = [e[n], i] : e[n] = i;
    }
  return e;
}
const F0 = (r) => {
  if (typeof r == "string")
    return F0(new URL(r));
  const { hostname: e, pathname: t, port: n, protocol: i, search: a } = r;
  let s;
  return a && (s = Dq(a)), {
    hostname: e,
    port: n ? parseInt(n) : void 0,
    protocol: i,
    path: t,
    query: s
  };
}, yx = (r) => {
  if (typeof r == "object") {
    if ("url" in r) {
      const e = F0(r.url);
      if (r.headers) {
        e.headers = {};
        for (const t in r.headers)
          e.headers[t.toLowerCase()] = r.headers[t].join(", ");
      }
      return e;
    }
    return r;
  }
  return F0(r);
}, Rq = (r) => () => Promise.reject(r);
class Oq {
  config;
  middlewareStack = T0();
  initConfig;
  handlers;
  constructor(e) {
    this.config = e;
    const { protocol: t, protocolSettings: n } = e;
    n && typeof t == "function" && (e.protocol = new t(n));
  }
  send(e, t, n) {
    const i = typeof t != "function" ? t : void 0, a = typeof t == "function" ? t : n, s = i === void 0 && this.config.cacheMiddleware === !0;
    let o;
    if (s) {
      this.handlers || (this.handlers = /* @__PURE__ */ new WeakMap());
      const l = this.handlers;
      l.has(e.constructor) ? o = l.get(e.constructor) : (o = e.resolveMiddleware(this.middlewareStack, this.config, i), l.set(e.constructor, o));
    } else
      delete this.handlers, o = e.resolveMiddleware(this.middlewareStack, this.config, i);
    if (a)
      o(e).then((l) => a(null, l.output), (l) => a(l)).catch(() => {
      });
    else
      return o(e).then((l) => l.output);
  }
  destroy() {
    this.config?.requestHandler?.destroy?.(), delete this.handlers;
  }
}
const t0 = (r) => typeof r == "function" ? r() : r, dR = (r, e, t, n, i) => ({
  name: e,
  namespace: r,
  traits: t,
  input: n,
  output: i
}), Bq = (r) => (e, t) => async (n) => {
  const { response: i } = await e(n), { operationSchema: a } = lh(t), [, s, o, l, u, c] = a ?? [];
  try {
    const h = await r.protocol.deserializeResponse(dR(s, o, l, u, c), {
      ...r,
      ...t
    }, i);
    return {
      response: i,
      output: h
    };
  } catch (h) {
    if (Object.defineProperty(h, "$response", {
      value: i,
      enumerable: !1,
      writable: !1,
      configurable: !1
    }), !("$metadata" in h)) {
      const f = "Deserialization error: to see the raw response, inspect the hidden field {error}.$response on this object.";
      try {
        h.message += `
  ` + f;
      } catch {
        !t.logger || t.logger?.constructor?.name === "NoOpLogger" ? console.warn(f) : t.logger?.warn?.(f);
      }
      typeof h.$responseBodyText < "u" && h.$response && (h.$response.body = h.$responseBodyText);
      try {
        if (jd.isInstance(i)) {
          const { headers: p = {}, statusCode: m } = i, A = Object.entries(p);
          h.$metadata = {
            httpStatusCode: m,
            requestId: gA(/^x-[\w-]+-request-?id$/, A),
            extendedRequestId: gA(/^x-[\w-]+-id-2$/, A),
            cfId: gA(/^x-[\w-]+-cf-id$/, A)
          };
        }
      } catch {
      }
    }
    throw h;
  }
}, gA = (r, e) => (e.find(([t]) => t.match(r)) || [void 0, void 0])[1], _q = (r) => (e, t) => async (n) => {
  const { operationSchema: i } = lh(t), [, a, s, o, l, u] = i ?? [], c = t.endpointV2 ? async () => yx(t.endpointV2) : r.endpoint, h = await r.protocol.serializeRequest(dR(a, s, o, l, u), n.input, {
    ...r,
    ...t,
    endpoint: c
  });
  return e({
    ...n,
    request: h
  });
}, Mq = {
  name: "deserializerMiddleware",
  step: "deserialize",
  tags: ["DESERIALIZER"],
  override: !0
}, Nq = {
  name: "serializerMiddleware",
  step: "serialize",
  tags: ["SERIALIZER"],
  override: !0
};
function Lq(r) {
  return {
    applyToStack: (e) => {
      e.add(_q(r), Nq), e.add(Bq(r), Mq), r.protocol.setSerdeContext(r);
    }
  };
}
const mA = [];
function Sp(r) {
  if (typeof r == "object")
    return r;
  if (r = r | 0, mA[r])
    return mA[r];
  const e = {};
  let t = 0;
  for (const n of [
    "httpLabel",
    "idempotent",
    "idempotencyToken",
    "sensitive",
    "httpPayload",
    "httpResponseCode",
    "httpQueryParams"
  ])
    (r >> t++ & 1) === 1 && (e[n] = 1);
  return mA[r] = e;
}
const sp = {
  it: /* @__PURE__ */ Symbol.for("@smithy/nor-struct-it"),
  ns: /* @__PURE__ */ Symbol.for("@smithy/ns")
}, vA = [], yA = {};
class Ca {
  ref;
  memberName;
  static symbol = /* @__PURE__ */ Symbol.for("@smithy/nor");
  symbol = Ca.symbol;
  name;
  schema;
  _isMemberSchema;
  traits;
  memberTraits;
  normalizedTraits;
  constructor(e, t) {
    this.ref = e, this.memberName = t;
    const n = [];
    let i = e, a = e;
    for (this._isMemberSchema = !1; AA(i); )
      n.push(i[1]), i = i[0], a = t0(i), this._isMemberSchema = !0;
    if (n.length > 0) {
      this.memberTraits = {};
      for (let s = n.length - 1; s >= 0; --s) {
        const o = n[s];
        Object.assign(this.memberTraits, Sp(o));
      }
    } else
      this.memberTraits = 0;
    if (a instanceof Ca) {
      const s = this.memberTraits;
      Object.assign(this, a), this.memberTraits = Object.assign({}, s, a.getMemberTraits(), this.getMemberTraits()), this.normalizedTraits = void 0, this.memberName = t ?? a.memberName;
      return;
    }
    if (this.schema = t0(a), Uq(this.schema) ? (this.name = `${this.schema[1]}#${this.schema[2]}`, this.traits = this.schema[3]) : (this.name = this.memberName ?? String(a), this.traits = 0), this._isMemberSchema && !t)
      throw new Error(`@smithy/core/schema - NormalizedSchema member init ${this.getName(!0)} missing member name.`);
  }
  static [Symbol.hasInstance](e) {
    const t = this.prototype.isPrototypeOf(e);
    return !t && typeof e == "object" && e !== null ? e.symbol === this.symbol : t;
  }
  static of(e) {
    const t = typeof e == "function" || typeof e == "object" && e !== null;
    if (typeof e == "number") {
      if (vA[e])
        return vA[e];
    } else if (typeof e == "string") {
      if (yA[e])
        return yA[e];
    } else if (t && e[sp.ns])
      return e[sp.ns];
    const n = t0(e);
    if (n instanceof Ca)
      return n;
    if (AA(n)) {
      const [a, s] = n;
      if (a instanceof Ca)
        return Object.assign(a.getMergedTraits(), Sp(s)), a;
      throw new Error(`@smithy/core/schema - may not init unwrapped member schema=${JSON.stringify(e, null, 2)}.`);
    }
    const i = new Ca(n);
    return t ? e[sp.ns] = i : typeof n == "string" ? yA[n] = i : typeof n == "number" ? vA[n] = i : i;
  }
  getSchema() {
    const e = this.schema;
    return Array.isArray(e) && e[0] === 0 ? e[4] : e;
  }
  getName(e = !1) {
    const { name: t } = this;
    return !e && t && t.includes("#") ? t.split("#")[1] : t || void 0;
  }
  getMemberName() {
    return this.memberName;
  }
  isMemberSchema() {
    return this._isMemberSchema;
  }
  isListSchema() {
    const e = this.getSchema();
    return typeof e == "number" ? e >= 64 && e < 128 : e[0] === 1;
  }
  isMapSchema() {
    const e = this.getSchema();
    return typeof e == "number" ? e >= 128 && e <= 255 : e[0] === 2;
  }
  isStructSchema() {
    const e = this.getSchema();
    if (typeof e != "object")
      return !1;
    const t = e[0];
    return t === 3 || t === -3 || t === 4;
  }
  isUnionSchema() {
    const e = this.getSchema();
    return typeof e != "object" ? !1 : e[0] === 4;
  }
  isBlobSchema() {
    const e = this.getSchema();
    return e === 21 || e === 42;
  }
  isTimestampSchema() {
    const e = this.getSchema();
    return typeof e == "number" && e >= 4 && e <= 7;
  }
  isUnitSchema() {
    return this.getSchema() === "unit";
  }
  isDocumentSchema() {
    return this.getSchema() === 15;
  }
  isStringSchema() {
    return this.getSchema() === 0;
  }
  isBooleanSchema() {
    return this.getSchema() === 2;
  }
  isNumericSchema() {
    return this.getSchema() === 1;
  }
  isBigIntegerSchema() {
    return this.getSchema() === 17;
  }
  isBigDecimalSchema() {
    return this.getSchema() === 19;
  }
  isStreaming() {
    const { streaming: e } = this.getMergedTraits();
    return !!e || this.getSchema() === 42;
  }
  isIdempotencyToken() {
    return !!this.getMergedTraits().idempotencyToken;
  }
  getMergedTraits() {
    return this.normalizedTraits ?? (this.normalizedTraits = {
      ...this.getOwnTraits(),
      ...this.getMemberTraits()
    });
  }
  getMemberTraits() {
    return Sp(this.memberTraits);
  }
  getOwnTraits() {
    return Sp(this.traits);
  }
  getKeySchema() {
    const [e, t] = [this.isDocumentSchema(), this.isMapSchema()];
    if (!e && !t)
      throw new Error(`@smithy/core/schema - cannot get key for non-map: ${this.getName(!0)}`);
    const n = this.getSchema(), i = e ? 15 : n[4] ?? 0;
    return op([i, 0], "key");
  }
  getValueSchema() {
    const e = this.getSchema(), [t, n, i] = [this.isDocumentSchema(), this.isMapSchema(), this.isListSchema()], a = typeof e == "number" ? 63 & e : e && typeof e == "object" && (n || i) ? e[3 + e[0]] : t ? 15 : void 0;
    if (a != null)
      return op([a, 0], n ? "value" : "member");
    throw new Error(`@smithy/core/schema - ${this.getName(!0)} has no value member.`);
  }
  getMemberSchema(e) {
    const t = this.getSchema();
    if (this.isStructSchema() && t[4].includes(e)) {
      const n = t[4].indexOf(e), i = t[5][n];
      return op(AA(i) ? i : [i, 0], e);
    }
    if (this.isDocumentSchema())
      return op([15, 0], e);
    throw new Error(`@smithy/core/schema - ${this.getName(!0)} has no member=${e}.`);
  }
  getMemberSchemas() {
    const e = {};
    try {
      for (const [t, n] of this.structIterator())
        e[t] = n;
    } catch {
    }
    return e;
  }
  getEventStreamMember() {
    if (this.isStructSchema()) {
      for (const [e, t] of this.structIterator())
        if (t.isStreaming() && t.isStructSchema())
          return e;
    }
    return "";
  }
  *structIterator() {
    if (this.isUnitSchema())
      return;
    if (!this.isStructSchema())
      throw new Error("@smithy/core/schema - cannot iterate non-struct schema.");
    const e = this.getSchema(), t = e[4].length;
    let n = e[sp.it];
    if (n && t === n.length) {
      yield* n;
      return;
    }
    n = Array(t);
    for (let i = 0; i < t; ++i) {
      const a = e[4][i], s = op([e[5][i], 0], a);
      yield n[i] = [a, s];
    }
    e[sp.it] = n;
  }
}
function op(r, e) {
  if (r instanceof Ca)
    return Object.assign(r, {
      memberName: e,
      _isMemberSchema: !0
    });
  const t = Ca;
  return new t(r, e);
}
const AA = (r) => Array.isArray(r) && r.length === 2, Uq = (r) => Array.isArray(r) && r.length >= 5;
class qs {
  namespace;
  schemas;
  exceptions;
  static registries = /* @__PURE__ */ new Map();
  constructor(e, t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map()) {
    this.namespace = e, this.schemas = t, this.exceptions = n;
  }
  static for(e) {
    return qs.registries.has(e) || qs.registries.set(e, new qs(e)), qs.registries.get(e);
  }
  copyFrom(e) {
    const { schemas: t, exceptions: n } = this;
    for (const [i, a] of e.schemas)
      t.has(i) || t.set(i, a);
    for (const [i, a] of e.exceptions)
      n.has(i) || n.set(i, a);
  }
  register(e, t) {
    const n = this.normalizeShapeId(e);
    for (const i of [this, qs.for(n.split("#")[0])])
      i.schemas.set(n, t);
  }
  getSchema(e) {
    const t = this.normalizeShapeId(e);
    if (!this.schemas.has(t)) {
      if (!e.includes("#")) {
        const n = "#" + e, i = [];
        for (const [a, s] of this.schemas.entries())
          a.endsWith(n) && i.push(s);
        if (i.length === 1)
          return i[0];
      }
      throw new Error(`@smithy/core/schema - schema not found for ${t}`);
    }
    return this.schemas.get(t);
  }
  registerError(e, t) {
    const n = e, i = n[1];
    for (const a of [this, qs.for(i)])
      a.schemas.set(i + "#" + n[2], n), a.exceptions.set(n, t);
  }
  getErrorCtor(e) {
    const t = e;
    return this.exceptions.has(t) ? this.exceptions.get(t) : qs.for(t[1]).exceptions.get(t);
  }
  getBaseException() {
    for (const e of this.exceptions.keys())
      if (Array.isArray(e)) {
        const [, t, n] = e, i = t + "#" + n;
        if (i.startsWith("smithy.ts.sdk.synthetic.") && i.endsWith("ServiceException"))
          return e;
      }
  }
  find(e) {
    for (const t of this.schemas.values())
      if (e(t))
        return t;
  }
  clear() {
    this.schemas.clear(), this.exceptions.clear();
  }
  normalizeShapeId(e) {
    return e.includes("#") ? e : this.namespace + "#" + e;
  }
}
const wA = "***SensitiveInformation***";
function Z1(r, e) {
  if (e == null)
    return e;
  const t = Ca.of(r);
  if (t.getMergedTraits().sensitive)
    return wA;
  if (t.isListSchema()) {
    if (!!t.getValueSchema().getMergedTraits().sensitive)
      return wA;
  } else if (t.isMapSchema()) {
    if (!!t.getKeySchema().getMergedTraits().sensitive || !!t.getValueSchema().getMergedTraits().sensitive)
      return wA;
  } else if (t.isStructSchema() && typeof e == "object") {
    const n = e, i = {};
    for (const [a, s] of t.structIterator())
      n[a] != null && (i[a] = Z1(s, n[a]));
    return i;
  }
  return e;
}
class Ax {
  middlewareStack = T0();
  schema;
  static classBuilder() {
    return new Vq();
  }
  resolveMiddlewareWithContext(e, t, n, { middlewareFn: i, clientName: a, commandName: s, inputFilterSensitiveLog: o, outputFilterSensitiveLog: l, smithyContext: u, additionalContext: c, CommandCtor: h }) {
    for (const x of i.bind(this)(h, e, t, n))
      this.middlewareStack.use(x);
    const f = e.concat(this.middlewareStack), { logger: p } = t, m = {
      logger: p,
      clientName: a,
      commandName: s,
      inputFilterSensitiveLog: o,
      outputFilterSensitiveLog: l,
      [K1]: {
        commandInstance: this,
        ...u
      },
      ...c
    }, { requestHandler: A } = t;
    let w = n ?? {};
    return u.eventStream && (w = {
      isEventStream: !0,
      ...w
    }), f.resolve((x) => A.handle(x.request, w), m);
  }
}
class Vq {
  _init = () => {
  };
  _ep = {};
  _middlewareFn = () => [];
  _commandName = "";
  _clientName = "";
  _additionalContext = {};
  _smithyContext = {};
  _inputFilterSensitiveLog = void 0;
  _outputFilterSensitiveLog = void 0;
  _serializer = null;
  _deserializer = null;
  _operationSchema;
  init(e) {
    this._init = e;
  }
  ep(e) {
    return this._ep = e, this;
  }
  m(e) {
    return this._middlewareFn = e, this;
  }
  s(e, t, n = {}) {
    return this._smithyContext = {
      service: e,
      operation: t,
      ...n
    }, this;
  }
  c(e = {}) {
    return this._additionalContext = e, this;
  }
  n(e, t) {
    return this._clientName = e, this._commandName = t, this;
  }
  f(e = (n) => n, t = (n) => n) {
    return this._inputFilterSensitiveLog = e, this._outputFilterSensitiveLog = t, this;
  }
  ser(e) {
    return this._serializer = e, this;
  }
  de(e) {
    return this._deserializer = e, this;
  }
  sc(e) {
    return this._operationSchema = e, this._smithyContext.operationSchema = e, this;
  }
  build() {
    const e = this;
    let t;
    return t = class extends Ax {
      input;
      static getEndpointParameterInstructions() {
        return e._ep;
      }
      constructor(...[n]) {
        super(), this.input = n ?? {}, e._init(this), this.schema = e._operationSchema;
      }
      resolveMiddleware(n, i, a) {
        const s = e._operationSchema, o = s?.[4] ?? s?.input, l = s?.[5] ?? s?.output;
        return this.resolveMiddlewareWithContext(n, i, a, {
          CommandCtor: t,
          middlewareFn: e._middlewareFn,
          clientName: e._clientName,
          commandName: e._commandName,
          inputFilterSensitiveLog: e._inputFilterSensitiveLog ?? (s ? Z1.bind(null, o) : (u) => u),
          outputFilterSensitiveLog: e._outputFilterSensitiveLog ?? (s ? Z1.bind(null, l) : (u) => u),
          smithyContext: e._smithyContext,
          additionalContext: e._additionalContext
        });
      }
      serialize = e._serializer;
      deserialize = e._deserializer;
    };
  }
}
class Td extends Error {
  $fault;
  $response;
  $retryable;
  $metadata;
  constructor(e) {
    super(e.message), Object.setPrototypeOf(this, Object.getPrototypeOf(this).constructor.prototype), this.name = e.name, this.$fault = e.$fault, this.$metadata = e.$metadata;
  }
  static isInstance(e) {
    if (!e)
      return !1;
    const t = e;
    return Td.prototype.isPrototypeOf(t) || !!t.$fault && !!t.$metadata && (t.$fault === "client" || t.$fault === "server");
  }
  static [Symbol.hasInstance](e) {
    if (!e)
      return !1;
    const t = e;
    return this === Td ? Td.isInstance(e) : Td.isInstance(e) ? t.name && this.name ? this.prototype.isPrototypeOf(e) || t.name === this.name : this.prototype.isPrototypeOf(e) : !1;
  }
}
const gT = (r, e = {}) => {
  Object.entries(e).filter(([, n]) => n !== void 0).forEach(([n, i]) => {
    (r[n] == null || r[n] === "") && (r[n] = i);
  });
  const t = r.message || r.Message || "UnknownError";
  return r.message = t, delete r.Message, r;
}, $q = (r) => {
  switch (r) {
    case "standard":
      return {
        retryMode: "standard",
        connectionTimeout: 3100
      };
    case "in-region":
      return {
        retryMode: "standard",
        connectionTimeout: 1100
      };
    case "cross-region":
      return {
        retryMode: "standard",
        connectionTimeout: 3100
      };
    case "mobile":
      return {
        retryMode: "standard",
        connectionTimeout: 3e4
      };
    default:
      return {};
  }
}, hR = Object.values(Zp), zq = (r) => {
  const e = [];
  for (const t in Zp) {
    const n = Zp[t];
    r[n] !== void 0 && e.push({
      algorithmId: () => n,
      checksumConstructor: () => r[n]
    });
  }
  for (const [t, n] of Object.entries(r.checksumAlgorithms ?? {}))
    e.push({
      algorithmId: () => t,
      checksumConstructor: () => n
    });
  return {
    addChecksumAlgorithm(t) {
      r.checksumAlgorithms = r.checksumAlgorithms ?? {};
      const n = t.algorithmId(), i = t.checksumConstructor();
      hR.includes(n) ? r.checksumAlgorithms[n.toUpperCase()] = i : r.checksumAlgorithms[n] = i, e.push(t);
    },
    checksumAlgorithms() {
      return e;
    }
  };
}, Gq = (r) => {
  const e = {};
  return r.checksumAlgorithms().forEach((t) => {
    const n = t.algorithmId();
    hR.includes(n) && (e[n] = t.checksumConstructor());
  }), e;
}, Hq = (r) => ({
  setRetryStrategy(e) {
    r.retryStrategy = e;
  },
  retryStrategy() {
    return r.retryStrategy;
  }
}), Wq = (r) => {
  const e = {};
  return e.retryStrategy = r.retryStrategy(), e;
}, jq = (r) => Object.assign(zq(r), Hq(r)), qq = (r) => Object.assign(Gq(r), Wq(r));
class pR {
  trace() {
  }
  debug() {
  }
  info() {
  }
  warn() {
  }
  error() {
  }
}
const gR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", mT = Object.entries(gR).reduce((r, [e, t]) => (r[t] = Number(e), r), {}), Qq = gR.split(""), Bd = 6, Rp = 8, Yq = 63, Z0 = (r) => {
  let e = r.length / 4 * 3;
  r.slice(-2) === "==" ? e -= 2 : r.slice(-1) === "=" && e--;
  const t = new ArrayBuffer(e), n = new DataView(t);
  for (let i = 0; i < r.length; i += 4) {
    let a = 0, s = 0;
    for (let u = i, c = i + 3; u <= c; u++)
      if (r[u] !== "=") {
        if (!(r[u] in mT))
          throw new TypeError(`Invalid character ${r[u]} in base64 string.`);
        a |= mT[r[u]] << (c - u) * Bd, s += Bd;
      } else
        a >>= Bd;
    const o = i / 4 * 3;
    a >>= s % Rp;
    const l = Math.floor(s / Rp);
    for (let u = 0; u < l; u++) {
      const c = (l - u - 1) * Rp;
      n.setUint8(o + u, (a & 255 << c) >> c);
    }
  }
  return new Uint8Array(t);
}, qd = (r) => new TextEncoder().encode(r);
function I0(r) {
  let e;
  typeof r == "string" ? e = qd(r) : e = r;
  const t = typeof e == "object" && typeof e.length == "number", n = typeof e == "object" && typeof e.byteOffset == "number" && typeof e.byteLength == "number";
  if (!t && !n)
    throw new Error("@smithy/util-base64: toBase64 encoder function only accepts string | Uint8Array.");
  let i = "";
  for (let a = 0; a < e.length; a += 3) {
    let s = 0, o = 0;
    for (let u = a, c = Math.min(a + 3, e.length); u < c; u++)
      s |= e[u] << (c - u - 1) * Rp, o += Rp;
    const l = Math.ceil(o / Bd);
    s <<= l * Bd - o;
    for (let u = 1; u <= l; u++) {
      const c = (l - u) * Bd;
      i += Qq[(s & Yq << c) >> c];
    }
    i += "==".slice(0, 4 - l);
  }
  return i;
}
function Xq(r, e, t, n) {
  return class r0 extends Uint8Array {
    static fromString(a, s = "utf-8") {
      if (typeof a == "string")
        return s === "base64" ? r0.mutate(n(a)) : r0.mutate(e(a));
      throw new Error(`Unsupported conversion from ${typeof a} to Uint8ArrayBlobAdapter.`);
    }
    static mutate(a) {
      return Object.setPrototypeOf(a, r0.prototype), a;
    }
    transformToString(a = "utf-8") {
      return a === "base64" ? t(this) : r(this);
    }
  };
}
const wx = (r) => {
  if (typeof r == "string")
    return r;
  if (typeof r != "object" || typeof r.byteOffset != "number" || typeof r.byteLength != "number")
    throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
  return new TextDecoder("utf-8").decode(r);
}, ja = Array.from({ length: 256 }, (r, e) => e.toString(16).padStart(2, "0"));
function Jq(r) {
  return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? () => crypto.randomUUID() : () => {
    const e = new Uint8Array(16);
    return r(e), e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128, ja[e[0]] + ja[e[1]] + ja[e[2]] + ja[e[3]] + "-" + ja[e[4]] + ja[e[5]] + "-" + ja[e[6]] + ja[e[7]] + "-" + ja[e[8]] + ja[e[9]] + "-" + ja[e[10]] + ja[e[11]] + ja[e[12]] + ja[e[13]] + ja[e[14]] + ja[e[15]];
  };
}
const ew = (r) => {
  if (r != null) {
    if (typeof r == "string") {
      const e = parseFloat(r);
      if (!Number.isNaN(e))
        return String(e) !== String(r) && sQ.warn(aQ(`Expected number but observed string: ${r}`)), e;
    }
    if (typeof r == "number")
      return r;
    throw new TypeError(`Expected number, got ${typeof r}: ${r}`);
  }
}, Kq = Math.ceil(2 ** 127 * (2 - 2 ** -23)), vT = (r) => {
  const e = ew(r);
  if (e !== void 0 && !Number.isNaN(e) && e !== 1 / 0 && e !== -1 / 0 && Math.abs(e) > Kq)
    throw new TypeError(`Expected 32-bit float, got ${r}`);
  return e;
}, Zq = (r) => {
  if (r != null) {
    if (Number.isInteger(r) && !Number.isNaN(r))
      return r;
    throw new TypeError(`Expected integer, got ${typeof r}: ${r}`);
  }
}, yT = (r) => mR(r, 16), AT = (r) => mR(r, 8), mR = (r, e) => {
  const t = Zq(r);
  if (t !== void 0 && eQ(t, e) !== t)
    throw new TypeError(`Expected ${e}-bit integer, got ${r}`);
  return t;
}, eQ = (r, e) => {
  switch (e) {
    case 32:
      return Int32Array.of(r)[0];
    case 16:
      return Int16Array.of(r)[0];
    case 8:
      return Int8Array.of(r)[0];
  }
}, tQ = (r) => ew(typeof r == "string" ? ev(r) : r), rQ = (r) => vT(typeof r == "string" ? ev(r) : r), nQ = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g, ev = (r) => {
  const e = r.match(nQ);
  if (e === null || e[0].length !== r.length)
    throw new TypeError("Expected real number, got implicit NaN");
  return parseFloat(r);
}, P0 = (r) => yT(typeof r == "string" ? ev(r) : r), iQ = (r) => AT(typeof r == "string" ? ev(r) : r), aQ = (r) => String(new TypeError(r).stack || r).split(`
`).slice(0, 5).filter((e) => !e.includes("stackTraceWarning")).join(`
`), sQ = {
  warn: console.warn
}, oQ = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], xx = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function lQ(r) {
  const e = r.getUTCFullYear(), t = r.getUTCMonth(), n = r.getUTCDay(), i = r.getUTCDate(), a = r.getUTCHours(), s = r.getUTCMinutes(), o = r.getUTCSeconds(), l = i < 10 ? `0${i}` : `${i}`, u = a < 10 ? `0${a}` : `${a}`, c = s < 10 ? `0${s}` : `${s}`, h = o < 10 ? `0${o}` : `${o}`;
  return `${oQ[n]}, ${l} ${xx[t]} ${e} ${u}:${c}:${h} GMT`;
}
const uQ = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?(([-+]\d{2}\:\d{2})|[zZ])$/), cQ = (r) => {
  if (r == null)
    return;
  if (typeof r != "string")
    throw new TypeError("RFC-3339 date-times must be expressed as strings");
  const e = uQ.exec(r);
  if (!e)
    throw new TypeError("Invalid RFC-3339 date-time value");
  const [t, n, i, a, s, o, l, u, c] = e, h = P0(eg(n)), f = Ec(i, "month", 1, 12), p = Ec(a, "day", 1, 31), m = n0(h, f, p, { hours: s, minutes: o, seconds: l, fractionalMilliseconds: u });
  return c.toUpperCase() != "Z" && m.setTime(m.getTime() - bQ(c)), m;
}, fQ = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/), dQ = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/), hQ = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/), vR = (r) => {
  if (r == null)
    return;
  if (typeof r != "string")
    throw new TypeError("RFC-7231 date-times must be expressed as strings");
  let e = fQ.exec(r);
  if (e) {
    const [t, n, i, a, s, o, l, u] = e;
    return n0(P0(eg(a)), xA(i), Ec(n, "day", 1, 31), { hours: s, minutes: o, seconds: l, fractionalMilliseconds: u });
  }
  if (e = dQ.exec(r), e) {
    const [t, n, i, a, s, o, l, u] = e;
    return vQ(n0(gQ(a), xA(i), Ec(n, "day", 1, 31), {
      hours: s,
      minutes: o,
      seconds: l,
      fractionalMilliseconds: u
    }));
  }
  if (e = hQ.exec(r), e) {
    const [t, n, i, a, s, o, l, u] = e;
    return n0(P0(eg(u)), xA(n), Ec(i.trimLeft(), "day", 1, 31), { hours: a, minutes: s, seconds: o, fractionalMilliseconds: l });
  }
  throw new TypeError("Invalid RFC-7231 date-time value");
}, pQ = (r) => {
  if (r == null)
    return;
  let e;
  if (typeof r == "number")
    e = r;
  else if (typeof r == "string")
    e = tQ(r);
  else if (typeof r == "object" && r.tag === 1)
    e = r.value;
  else
    throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
  if (Number.isNaN(e) || e === 1 / 0 || e === -1 / 0)
    throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
  return new Date(Math.round(e * 1e3));
}, n0 = (r, e, t, n) => {
  const i = e - 1;
  return AQ(r, i, t), new Date(Date.UTC(r, i, t, Ec(n.hours, "hour", 0, 23), Ec(n.minutes, "minute", 0, 59), Ec(n.seconds, "seconds", 0, 60), xQ(n.fractionalMilliseconds)));
}, gQ = (r) => {
  const e = (/* @__PURE__ */ new Date()).getUTCFullYear(), t = Math.floor(e / 100) * 100 + P0(eg(r));
  return t < e ? t + 100 : t;
}, mQ = 50 * 365 * 24 * 60 * 60 * 1e3, vQ = (r) => r.getTime() - (/* @__PURE__ */ new Date()).getTime() > mQ ? new Date(Date.UTC(r.getUTCFullYear() - 100, r.getUTCMonth(), r.getUTCDate(), r.getUTCHours(), r.getUTCMinutes(), r.getUTCSeconds(), r.getUTCMilliseconds())) : r, xA = (r) => {
  const e = xx.indexOf(r);
  if (e < 0)
    throw new TypeError(`Invalid month: ${r}`);
  return e + 1;
}, yQ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], AQ = (r, e, t) => {
  let n = yQ[e];
  if (e === 1 && wQ(r) && (n = 29), t > n)
    throw new TypeError(`Invalid day for ${xx[e]} in ${r}: ${t}`);
}, wQ = (r) => r % 4 === 0 && (r % 100 !== 0 || r % 400 === 0), Ec = (r, e, t, n) => {
  const i = iQ(eg(r));
  if (i < t || i > n)
    throw new TypeError(`${e} must be between ${t} and ${n}, inclusive`);
  return i;
}, xQ = (r) => r == null ? 0 : rQ("0." + r) * 1e3, bQ = (r) => {
  const e = r[0];
  let t = 1;
  if (e == "+")
    t = 1;
  else if (e == "-")
    t = -1;
  else
    throw new TypeError(`Offset direction, ${e}, must be "+" or "-"`);
  const n = Number(r.substring(1, 3)), i = Number(r.substring(4, 6));
  return t * (n * 60 + i) * 60 * 1e3;
}, eg = (r) => {
  let e = 0;
  for (; e < r.length - 1 && r.charAt(e) === "0"; )
    e++;
  return e === 0 ? r : r.slice(e);
}, xc = function(e) {
  return Object.assign(new String(e), {
    deserializeJSON() {
      return JSON.parse(String(e));
    },
    toString() {
      return String(e);
    },
    toJSON() {
      return String(e);
    }
  });
};
xc.from = (r) => r && typeof r == "object" && (r instanceof xc || "deserializeJSON" in r) ? r : typeof r == "string" || Object.getPrototypeOf(r) === String.prototype ? xc(String(r)) : xc(JSON.stringify(r));
xc.fromObject = xc.from;
const wT = /^-?\d*(\.\d+)?$/;
class Ol {
  string;
  type;
  constructor(e, t) {
    if (this.string = e, this.type = t, !wT.test(e))
      throw new Error('@smithy/core/serde - NumericValue must only contain [0-9], at most one decimal point ".", and an optional negation prefix "-".');
  }
  toString() {
    return this.string;
  }
  static [Symbol.hasInstance](e) {
    if (!e || typeof e != "object")
      return !1;
    const t = e;
    return Ol.prototype.isPrototypeOf(e) || t.type === "bigDecimal" && wT.test(t.string);
  }
}
const yR = {}, tw = {};
for (let r = 0; r < 256; r++) {
  let e = r.toString(16).toLowerCase();
  e.length === 1 && (e = `0${e}`), yR[r] = e, tw[e] = r;
}
function CQ(r) {
  if (r.length % 2 !== 0)
    throw new Error("Hex encoded strings must have an even number length");
  const e = new Uint8Array(r.length / 2);
  for (let t = 0; t < r.length; t += 2) {
    const n = r.slice(t, t + 2).toLowerCase();
    if (n in tw)
      e[t / 2] = tw[n];
    else
      throw new Error(`Cannot decode unrecognized sequence ${n} as hexadecimal`);
  }
  return e;
}
function Rf(r) {
  let e = "";
  for (let t = 0; t < r.byteLength; t++)
    e += yR[r[t]];
  return e;
}
const xT = typeof TextEncoder == "function" ? new TextEncoder() : null, SQ = (r) => {
  if (typeof r == "string") {
    if (xT)
      return xT.encode(r).byteLength;
    let e = r.length;
    for (let t = e - 1; t >= 0; t--) {
      const n = r.charCodeAt(t);
      n > 127 && n <= 2047 ? e++ : n > 2047 && n <= 65535 && (e += 2), n >= 56320 && n <= 57343 && t--;
    }
    return e;
  } else {
    if (typeof r.byteLength == "number")
      return r.byteLength;
    if (typeof r.size == "number")
      return r.size;
  }
  throw new Error(`Body Length computation failed for ${r}`);
}, tg = (r) => typeof r == "string" ? qd(r) : ArrayBuffer.isView(r) ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(r), EQ = (r) => typeof ArrayBuffer == "function" && r instanceof ArrayBuffer || Object.prototype.toString.call(r) === "[object ArrayBuffer]", AR = async (r) => {
}, kQ = async (r) => {
  const e = r?.Bucket || "";
  if (typeof r.Bucket == "string" && (r.Bucket = e.replace(/#/g, encodeURIComponent("#")).replace(/\?/g, encodeURIComponent("?"))), DQ(e)) {
    if (r.ForcePathStyle === !0)
      throw new Error("Path-style addressing cannot be used with ARN buckets");
  } else (!PQ(e) || e.indexOf(".") !== -1 && !String(r.Endpoint).startsWith("http:") || e.toLowerCase() !== e || e.length < 3) && (r.ForcePathStyle = !0);
  return r.DisableMultiRegionAccessPoints && (r.disableMultiRegionAccessPoints = !0, r.DisableMRAP = !0), r;
}, TQ = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/, FQ = /(\d+\.){3}\d+/, IQ = /\.\./, PQ = (r) => TQ.test(r) && !FQ.test(r) && !IQ.test(r), DQ = (r) => {
  const [e, t, n, , , i] = r.split(":"), a = e === "arn" && r.split(":").length >= 6, s = !!(a && t && n && i);
  if (a && !s)
    throw new Error(`Invalid ARN: ${r} was an invalid ARN.`);
  return s;
}, RQ = (r, e, t, n = !1) => {
  const i = async () => {
    let a;
    return n ? a = t.clientContextParams?.[r] ?? t[r] ?? t[e] : a = t[r] ?? t[e], typeof a == "function" ? a() : a;
  };
  return r === "credentialScope" || e === "CredentialScope" ? async () => {
    const a = typeof t.credentials == "function" ? await t.credentials() : t.credentials;
    return a?.credentialScope ?? a?.CredentialScope;
  } : r === "accountId" || e === "AccountId" ? async () => {
    const a = typeof t.credentials == "function" ? await t.credentials() : t.credentials;
    return a?.accountId ?? a?.AccountId;
  } : r === "endpoint" || e === "endpoint" ? async () => {
    if (t.isCustomEndpoint === !1)
      return;
    const a = await i();
    if (a && typeof a == "object") {
      if ("url" in a)
        return a.url.href;
      if ("hostname" in a) {
        const { protocol: s, hostname: o, port: l, path: u } = a;
        return `${s}//${o}${l ? ":" + l : ""}${u}`;
      }
    }
    return a;
  } : i;
};
function OQ(r) {
  return async (e, t, n, i) => {
    if (!n.isCustomEndpoint) {
      let o;
      n.serviceConfiguredEndpoint ? o = await n.serviceConfiguredEndpoint() : o = await r(n.serviceId), o && (n.endpoint = () => Promise.resolve(yx(o)), n.isCustomEndpoint = !0);
    }
    const a = await BQ(e, t, n);
    if (typeof n.endpointProvider != "function")
      throw new Error("config.endpointProvider is not set.");
    const s = n.endpointProvider(a, i);
    if (n.isCustomEndpoint && n.endpoint) {
      const o = await n.endpoint();
      if (o?.headers) {
        s.headers ??= {};
        for (const [l, u] of Object.entries(o.headers))
          s.headers[l] = Array.isArray(u) ? u : [u];
      }
    }
    return s;
  };
}
const BQ = async (r, e, t) => {
  const n = {}, i = e?.getEndpointParameterInstructions?.() || {};
  for (const [a, s] of Object.entries(i))
    switch (s.type) {
      case "staticContextParams":
        n[a] = s.value;
        break;
      case "contextParams":
        n[a] = r[s.name];
        break;
      case "clientContextParams":
      case "builtInParams":
        n[a] = await RQ(s.name, a, t, s.type !== "builtInParams")();
        break;
      case "operationContextParams":
        n[a] = s.get(r);
        break;
      default:
        throw new Error("Unrecognized endpoint parameter instruction: " + JSON.stringify(s));
    }
  return Object.keys(i).length === 0 && Object.assign(n, t), String(t.serviceId).toLowerCase() === "s3" && await kQ(n), n;
};
function _Q(r, e, t) {
  r.__smithy_context ? r.__smithy_context.features || (r.__smithy_context.features = {}) : r.__smithy_context = { features: {} }, r.__smithy_context.features[e] = t;
}
function MQ(r) {
  const e = OQ(r);
  return ({ config: t, instructions: n }) => (i, a) => async (s) => {
    t.isCustomEndpoint && _Q(a, "ENDPOINT_OVERRIDE", "N");
    const o = await e(s.input, {
      getEndpointParameterInstructions() {
        return n;
      }
    }, { ...t }, a);
    a.endpointV2 = o, a.authSchemes = o.properties?.authSchemes;
    const l = a.authSchemes?.[0];
    if (l) {
      a.signing_region = l.signingRegion, a.signing_service = l.signingName;
      const c = lh(a)?.selectedHttpAuthScheme?.httpAuthOption;
      c && (c.signingProperties = Object.assign(c.signingProperties || {}, {
        signing_region: l.signingRegion,
        signingRegion: l.signingRegion,
        signing_service: l.signingName,
        signingName: l.signingName,
        signingRegionSet: l.signingRegionSet
      }, l.properties));
    }
    return i({
      ...s
    });
  };
}
const NQ = {
  name: "serializerMiddleware"
}, LQ = {
  step: "serialize",
  tags: ["ENDPOINT_PARAMETERS", "ENDPOINT_V2", "ENDPOINT"],
  name: "endpointV2Middleware",
  override: !0,
  relation: "before",
  toMiddleware: NQ.name
};
function UQ(r) {
  const e = MQ(r);
  return (t, n) => ({
    applyToStack: (i) => {
      i.addRelativeTo(e({
        config: t,
        instructions: n
      }), LQ);
    }
  });
}
function VQ(r) {
  return (e) => {
    const t = e.tls ?? !0, { endpoint: n, useDualstackEndpoint: i, useFipsEndpoint: a } = e, s = n != null ? async () => yx(await ku(n)()) : void 0, l = Object.assign(e, {
      endpoint: s,
      tls: t,
      isCustomEndpoint: !!n,
      useDualstackEndpoint: ku(i ?? !1),
      useFipsEndpoint: ku(a ?? !1)
    });
    let u;
    return l.serviceConfiguredEndpoint = async () => (e.serviceId && !u && (u = r(e.serviceId)), u), l;
  };
}
class bx {
  nodes;
  root;
  conditions;
  results;
  constructor(e, t, n, i) {
    this.nodes = e, this.root = t, this.conditions = n, this.results = i;
  }
  static from(e, t, n, i) {
    return new bx(e, t, n, i);
  }
}
class $Q {
  capacity;
  data = /* @__PURE__ */ new Map();
  parameters = [];
  constructor({ size: e, params: t }) {
    this.capacity = e ?? 50, t && (this.parameters = t);
  }
  get(e, t) {
    const n = this.hash(e);
    if (n === !1)
      return t();
    if (!this.data.has(n)) {
      if (this.data.size > this.capacity + 10) {
        const i = this.data.keys();
        let a = 0;
        for (; ; ) {
          const { value: s, done: o } = i.next();
          if (this.data.delete(s), o || ++a > 10)
            break;
        }
      }
      this.data.set(n, t());
    }
    return this.data.get(n);
  }
  size() {
    return this.data.size;
  }
  hash(e) {
    let t = "";
    const { parameters: n } = this;
    if (n.length === 0)
      return !1;
    for (const i of n) {
      const a = String(e[i] ?? "");
      if (a.includes("|;"))
        return !1;
      t += a + "|;";
    }
    return t;
  }
}
class Jo extends Error {
  constructor(e) {
    super(e), this.name = "EndpointError";
  }
}
const zQ = "endpoints";
function D0(r) {
  return typeof r != "object" || r == null ? r : "ref" in r ? `$${D0(r.ref)}` : "fn" in r ? `${r.fn}(${(r.argv || []).map(D0).join(", ")})` : JSON.stringify(r, null, 2);
}
const Cx = {}, GQ = (r, e) => r === e;
function HQ(...r) {
  for (const e of r)
    if (e != null)
      return e;
}
const WQ = (r) => {
  const e = r.split("."), t = [];
  for (const n of e) {
    const i = n.indexOf("[");
    if (i !== -1) {
      if (n.indexOf("]") !== n.length - 1)
        throw new Jo(`Path: '${r}' does not end with ']'`);
      const a = n.slice(i + 1, -1);
      if (Number.isNaN(parseInt(a)))
        throw new Jo(`Invalid array index: '${a}' in path: '${r}'`);
      i !== 0 && t.push(n.slice(0, i)), t.push(a);
    } else
      t.push(n);
  }
  return t;
}, wR = (r, e) => WQ(e).reduce((t, n) => {
  if (typeof t != "object")
    throw new Jo(`Index '${n}' in '${e}' not found in '${JSON.stringify(r)}'`);
  if (Array.isArray(t)) {
    const i = parseInt(n);
    return t[i < 0 ? t.length + i : i];
  }
  return t[n];
}, r), jQ = (r) => r != null;
function qQ(r, e, t) {
  return r ? e : t;
}
const QQ = (r) => !r, YQ = new RegExp("^(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}$"), xR = (r) => YQ.test(r) || r.startsWith("[") && r.endsWith("]"), bA = {
  [Kp.HTTP]: 80,
  [Kp.HTTPS]: 443
}, XQ = (r) => {
  const e = (() => {
    try {
      if (r instanceof URL)
        return r;
      if (typeof r == "object" && "hostname" in r) {
        const { hostname: f, port: p, protocol: m = "", path: A = "", query: w = {} } = r, x = new URL(`${m}//${f}${p ? `:${p}` : ""}${A}`);
        return x.search = Object.entries(w).map(([E, T]) => `${E}=${T}`).join("&"), x;
      }
      return new URL(r);
    } catch {
      return null;
    }
  })();
  if (!e)
    return console.error(`Unable to parse ${JSON.stringify(r)} as a whatwg URL.`), null;
  const t = e.href, { host: n, hostname: i, pathname: a, protocol: s, search: o } = e;
  if (o)
    return null;
  const l = s.slice(0, -1);
  if (!Object.values(Kp).includes(l))
    return null;
  const u = xR(i), c = t.includes(`${n}:${bA[l]}`) || typeof r == "string" && r.includes(`${n}:${bA[l]}`), h = `${n}${c ? `:${bA[l]}` : ""}`;
  return {
    scheme: l,
    authority: h,
    path: a,
    normalizedPath: a.endsWith("/") ? a : `${a}/`,
    isIp: u
  };
};
function JQ(r, e, t) {
  if (t === 1)
    return [r];
  if (r === "")
    return [""];
  const n = r.split(e);
  return t === 0 ? n : n.slice(0, t - 1).concat(n.slice(1).join(e));
}
const KQ = (r, e) => r === e, ZQ = (r, e, t, n) => r == null || e >= t || r.length < t || /[^\u0000-\u007f]/.test(r) ? null : n ? r.substring(r.length - t, r.length - e) : r.substring(e, t), eY = (r) => encodeURIComponent(r).replace(/[!*'()]/g, (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`), tY = {
  booleanEquals: GQ,
  coalesce: HQ,
  getAttr: wR,
  isSet: jQ,
  isValidHostLabel: K0,
  ite: qQ,
  not: QQ,
  parseURL: XQ,
  split: JQ,
  stringEquals: KQ,
  substring: ZQ,
  uriEncode: eY
}, bR = (r, e) => {
  const t = [], { referenceRecord: n, endpointParams: i } = e;
  let a = 0;
  for (; a < r.length; ) {
    const s = r.indexOf("{", a);
    if (s === -1) {
      t.push(r.slice(a));
      break;
    }
    t.push(r.slice(a, s));
    const o = r.indexOf("}", s);
    if (o === -1) {
      t.push(r.slice(s));
      break;
    }
    r[s + 1] === "{" && r[o + 1] === "}" && (t.push(r.slice(s + 1, o)), a = o + 2);
    const l = r.substring(s + 1, o);
    if (l.includes("#")) {
      const [u, c] = l.split("#");
      t.push(wR(n[u] ?? i[u], c));
    } else
      t.push(n[l] ?? i[l]);
    a = o + 1;
  }
  return t.join("");
}, rY = ({ ref: r }, e) => e.referenceRecord[r] ?? e.endpointParams[r], tv = (r, e, t) => {
  if (typeof r == "string")
    return bR(r, t);
  if (r.fn)
    return SR.callFunction(r, t);
  if (r.ref)
    return rY(r, t);
  throw new Jo(`'${e}': ${String(r)} is not a string, function or reference.`);
}, CR = ({ fn: r, argv: e }, t) => {
  const n = Array(e.length);
  for (let s = 0; s < n.length; ++s) {
    const o = e[s];
    typeof o == "boolean" || typeof o == "number" ? n[s] = o : n[s] = SR.evaluateExpression(o, "arg", t);
  }
  const i = r.indexOf(".");
  if (i !== -1) {
    const o = Cx[r.slice(0, i)]?.[r.slice(i + 1)];
    if (typeof o == "function")
      return o(...n);
  }
  const a = tY[r];
  if (typeof a == "function")
    return a(...n);
  throw new Error(`function ${r} not loaded in endpointFunctions.`);
}, SR = {
  evaluateExpression: tv,
  callFunction: CR
}, nY = (r, e) => {
  const { assign: t } = r;
  if (t && t in e.referenceRecord)
    throw new Jo(`'${t}' is already defined in Reference Record.`);
  const n = CR(r, e);
  e.logger?.debug?.(`${zQ} evaluateCondition: ${D0(r)} = ${D0(n)}`);
  const i = n === "" ? !0 : !!n;
  return t != null ? { result: i, toAssign: { name: t, value: n } } : { result: i };
}, iY = (r, e) => Object.entries(r ?? {}).reduce((t, [n, i]) => (t[n] = i.map((a) => {
  const s = tv(a, "Header value entry", e);
  if (typeof s != "string")
    throw new Jo(`Header '${n}' value '${s}' is not a string`);
  return s;
}), t), {}), ER = (r, e) => Object.entries(r).reduce((t, [n, i]) => (t[n] = TR.getEndpointProperty(i, e), t), {}), kR = (r, e) => {
  if (Array.isArray(r))
    return r.map((t) => kR(t, e));
  switch (typeof r) {
    case "string":
      return bR(r, e);
    case "object":
      if (r === null)
        throw new Jo(`Unexpected endpoint property: ${r}`);
      return TR.getEndpointProperties(r, e);
    case "boolean":
      return r;
    default:
      throw new Jo(`Unexpected endpoint property type: ${typeof r}`);
  }
}, TR = {
  getEndpointProperty: kR,
  getEndpointProperties: ER
}, aY = (r, e) => {
  const t = tv(r, "Endpoint URL", e);
  if (typeof t == "string")
    try {
      return new URL(t);
    } catch (n) {
      throw console.error(`Failed to construct URL with ${t}`, n), n;
    }
  throw new Jo(`Endpoint URL must be a string, got ${typeof t}`);
}, CA = 1e8, sY = (r, e) => {
  const { nodes: t, root: n, results: i, conditions: a } = r;
  let s = n;
  const o = {}, l = {
    referenceRecord: o,
    endpointParams: e.endpointParams,
    logger: e.logger
  };
  for (; s !== 1 && s !== -1 && s < CA; ) {
    const u = 3 * (Math.abs(s) - 1), [c, h, f] = [t[u], t[u + 1], t[u + 2]], [p, m, A] = a[c], w = nY({ fn: p, assign: A, argv: m }, l);
    if (w.toAssign) {
      const { name: x, value: E } = w.toAssign;
      o[x] = E;
    }
    s = s >= 0 === w.result ? h : f;
  }
  if (s >= CA) {
    const u = i[s - CA];
    if (u[0] === -1) {
      const [, p] = u;
      throw new Jo(tv(p, "Error", l));
    }
    const [c, h, f] = u;
    return {
      url: aY(c, l),
      properties: ER(h, l),
      headers: iY(f ?? {}, l)
    };
  }
  throw new Jo("No matching endpoint.");
}, oY = VQ(AR), FR = UQ(AR);
class SA extends Xq(wx, qd, I0, Z0) {
}
const lY = (r) => crypto.getRandomValues(r), IR = Jq(lY), uY = IR, rw = async (r = new Uint8Array(), e) => {
  if (r instanceof Uint8Array)
    return SA.mutate(r);
  if (!r)
    return SA.mutate(new Uint8Array());
  const t = e.streamCollector(r);
  return SA.mutate(await t);
};
class cY {
  serdeContext;
  setSerdeContext(e) {
    this.serdeContext = e;
  }
}
class fY extends cY {
  options;
  compositeErrorRegistry;
  constructor(e) {
    super(), this.options = e, this.compositeErrorRegistry = qs.for(e.defaultNamespace);
    for (const t of e.errorTypeRegistries ?? [])
      this.compositeErrorRegistry.copyFrom(t);
  }
  getRequestType() {
    return Xs;
  }
  getResponseType() {
    return jd;
  }
  setSerdeContext(e) {
    this.serdeContext = e, this.serializer.setSerdeContext(e), this.deserializer.setSerdeContext(e), this.getPayloadCodec() && this.getPayloadCodec().setSerdeContext(e);
  }
  updateServiceEndpoint(e, t) {
    if ("url" in t) {
      e.protocol = t.url.protocol, e.hostname = t.url.hostname, e.port = t.url.port ? Number(t.url.port) : void 0, e.path = t.url.pathname, e.fragment = t.url.hash || void 0, e.username = t.url.username || void 0, e.password = t.url.password || void 0, e.query || (e.query = {});
      for (const [n, i] of t.url.searchParams.entries())
        e.query[n] = i;
      if (t.headers)
        for (const n in t.headers)
          e.headers[n] = t.headers[n].join(", ");
      return e;
    } else {
      if (e.protocol = t.protocol, e.hostname = t.hostname, e.port = t.port ? Number(t.port) : void 0, e.path = t.path, e.query = {
        ...t.query
      }, t.headers)
        for (const n in t.headers)
          e.headers[n] = t.headers[n];
      return e;
    }
  }
  setHostPrefix(e, t, n) {
    if (this.serdeContext?.disableHostPrefix)
      return;
    const i = Ca.of(t.input), a = Sp(t.traits ?? {});
    if (a.endpoint) {
      let s = a.endpoint?.[0];
      if (typeof s == "string") {
        for (const [o, l] of i.structIterator()) {
          if (!l.getMergedTraits().hostLabel)
            continue;
          const u = n[o];
          if (typeof u != "string")
            throw new Error(`@smithy/core/schema - ${o} in input must be a string as hostLabel.`);
          s = s.replace(`{${o}}`, u);
        }
        e.hostname = s + e.hostname;
      }
    }
  }
  deserializeMetadata(e) {
    return {
      httpStatusCode: e.statusCode,
      requestId: e.headers["x-amzn-requestid"] ?? e.headers["x-amzn-request-id"] ?? e.headers["x-amz-request-id"],
      extendedRequestId: e.headers["x-amz-id-2"],
      cfId: e.headers["x-amz-cf-id"]
    };
  }
  async serializeEventStream({ eventStream: e, requestSchema: t, initialRequest: n }) {
    return (await this.loadEventStreamCapability()).serializeEventStream({
      eventStream: e,
      requestSchema: t,
      initialRequest: n
    });
  }
  async deserializeEventStream({ response: e, responseSchema: t, initialResponseContainer: n }) {
    return (await this.loadEventStreamCapability()).deserializeEventStream({
      response: e,
      responseSchema: t,
      initialResponseContainer: n
    });
  }
  async loadEventStreamCapability() {
    const { EventStreamSerde: e, eventStreamSerdeProvider: t } = await import("./index.browser-m17Pcqxi.js"), n = this.resolveEventStreamMarshaller(t);
    return new e({
      marshaller: n,
      serializer: this.serializer,
      deserializer: this.deserializer,
      serdeContext: this.serdeContext,
      defaultContentType: this.getDefaultContentType()
    });
  }
  resolveEventStreamMarshaller(e) {
    const t = this.serdeContext;
    return t.eventStreamMarshaller ? t.eventStreamMarshaller : e(this.serdeContext);
  }
  getDefaultContentType() {
    throw new Error(`@smithy/core/protocols - ${this.constructor.name} getDefaultContentType() implementation missing.`);
  }
  async deserializeHttpMessage(e, t, n, i, a) {
    return [];
  }
  getEventStreamMarshaller() {
    const e = this.serdeContext;
    if (!e.eventStreamMarshaller)
      throw new Error("@smithy/core - HttpProtocol: eventStreamMarshaller missing in serdeContext.");
    return e.eventStreamMarshaller;
  }
}
class dY extends fY {
  async serializeRequest(e, t, n) {
    const i = this.serializer, a = {}, s = {}, o = await n.endpoint(), l = Ca.of(e?.input), u = l.getSchema();
    let c;
    const h = t && typeof t == "object" ? t : {}, f = new Xs({
      protocol: "",
      hostname: "",
      port: void 0,
      path: "/",
      fragment: void 0,
      query: a,
      headers: s,
      body: void 0
    });
    if (o && (this.updateServiceEndpoint(f, o), this.setHostPrefix(f, e, h)), h) {
      const p = l.getEventStreamMember();
      if (p) {
        if (h[p]) {
          const m = {};
          for (const [A, w] of l.structIterator())
            A !== p && h[A] && (i.write(w, h[A]), m[A] = i.flush());
          c = await this.serializeEventStream({
            eventStream: h[p],
            requestSchema: l,
            initialRequest: m
          });
        }
      } else
        i.write(u, h), c = i.flush();
    }
    return f.headers = Object.assign(f.headers, s), f.query = a, f.body = c, f.method = "POST", f;
  }
  async deserializeResponse(e, t, n) {
    const i = this.deserializer, a = Ca.of(e.output), s = {};
    if (n.statusCode >= 300) {
      const l = await rw(n.body, t);
      throw l.byteLength > 0 && Object.assign(s, await i.read(15, l)), await this.handleError(e, t, n, s, this.deserializeMetadata(n)), new Error("@smithy/core/protocols - RPC Protocol error handler failed to throw.");
    }
    for (const l in n.headers) {
      const u = n.headers[l];
      delete n.headers[l], n.headers[l.toLowerCase()] = u;
    }
    const o = a.getEventStreamMember();
    if (o)
      s[o] = await this.deserializeEventStream({
        response: n,
        responseSchema: a,
        initialResponseContainer: s
      });
    else {
      const l = await rw(n.body, t);
      l.byteLength > 0 && Object.assign(s, await i.read(a, l));
    }
    return s.$metadata = this.deserializeMetadata(n), s;
  }
}
function PR(r, e) {
  if (e.timestampFormat.useTrait && r.isTimestampSchema() && (r.getSchema() === 5 || r.getSchema() === 6 || r.getSchema() === 7))
    return r.getSchema();
  const { httpLabel: t, httpPrefixHeaders: n, httpHeader: i, httpQuery: a } = r.getMergedTraits();
  return (e.httpBindings ? typeof n == "string" || i ? 6 : a || t ? 5 : void 0 : void 0) ?? e.timestampFormat.default;
}
const hY = (r) => ({
  setHttpHandler(e) {
    r.httpHandler = e;
  },
  httpHandler() {
    return r.httpHandler;
  },
  updateHttpClientConfig(e, t) {
    r.httpHandler?.updateHttpClientConfig(e, t);
  },
  httpHandlerConfigs() {
    return r.httpHandler.httpHandlerConfigs();
  }
}), pY = (r) => ({
  httpHandler: r.httpHandler()
}), bT = "content-length";
function gY(r) {
  return (e) => async (t) => {
    const n = t.request;
    if (Xs.isInstance(n)) {
      const { body: i, headers: a } = n;
      if (i && Object.keys(a).map((s) => s.toLowerCase()).indexOf(bT) === -1)
        try {
          const s = r(i);
          n.headers = {
            ...n.headers,
            [bT]: String(s)
          };
        } catch {
        }
    }
    return e({
      ...t,
      request: n
    });
  };
}
const mY = {
  step: "build",
  tags: ["SET_CONTENT_LENGTH", "CONTENT_LENGTH"],
  name: "contentLengthMiddleware",
  override: !0
}, vY = (r) => ({
  applyToStack: (e) => {
    e.add(gY(r.bodyLengthChecker), mY);
  }
}), Of = (r) => encodeURIComponent(r).replace(/[!'()*]/g, yY), yY = (r) => `%${r.charCodeAt(0).toString(16).toUpperCase()}`;
function AY(r) {
  const e = [];
  for (let t of Object.keys(r).sort()) {
    const n = r[t];
    if (t = Of(t), Array.isArray(n))
      for (let i = 0, a = n.length; i < a; i++)
        e.push(`${t}=${Of(n[i])}`);
    else {
      let i = t;
      (n || typeof n == "string") && (i += `=${Of(n)}`), e.push(i);
    }
  }
  return e.join("&");
}
const wY = [
  "BandwidthLimitExceeded",
  "EC2ThrottledException",
  "LimitExceededException",
  "PriorRequestNotComplete",
  "ProvisionedThroughputExceededException",
  "RequestLimitExceeded",
  "RequestThrottled",
  "RequestThrottledException",
  "SlowDown",
  "ThrottledException",
  "Throttling",
  "ThrottlingException",
  "TooManyRequestsException",
  "TransactionInProgressException"
], xY = ["TimeoutError", "RequestTimeout", "RequestTimeoutException"], bY = [500, 502, 503, 504], CY = ["ECONNRESET", "ECONNREFUSED", "EPIPE", "ETIMEDOUT"], SY = ["EHOSTUNREACH", "ENETUNREACH", "ENOTFOUND", "EAI_AGAIN"], EY = (r) => r?.$retryable !== void 0, kY = (r) => r.$metadata?.clockSkewCorrected, TY = (r) => {
  const e = /* @__PURE__ */ new Set([
    "Failed to fetch",
    "NetworkError when attempting to fetch resource",
    "The Internet connection appears to be offline",
    "Load failed",
    "Network request failed"
  ]);
  return r && r instanceof TypeError ? e.has(r.message) : !1;
}, DR = (r) => r.$metadata?.httpStatusCode === 429 || wY.includes(r.name) || r.$retryable?.throttling == !0, Sx = (r, e = 0) => EY(r) || kY(r) || r.name === "InvalidSignatureException" && r.message?.includes("Signature expired") || xY.includes(r.name) || CY.includes(r?.code || "") || SY.includes(r?.code || "") || bY.includes(r.$metadata?.httpStatusCode || 0) || TY(r) || IY(r) || r.cause !== void 0 && e <= 10 && Sx(r.cause, e + 1), FY = (r) => {
  if (r.$metadata?.httpStatusCode !== void 0) {
    const e = r.$metadata.httpStatusCode;
    return 500 <= e && e <= 599 && !Sx(r);
  }
  return !1;
};
function IY(r) {
  return r.code === "ERR_HTTP2_STREAM_ERROR" && r.message.includes("NGHTTP2_REFUSED_STREAM");
}
const RR = 20 * 1e3, CT = 500, PY = 1, DY = "amz-sdk-invocation-id", RY = "amz-sdk-request";
function OY(r, e) {
  if (jd.isInstance(r))
    for (const t of Object.keys(r.headers)) {
      const n = t.toLowerCase();
      if (n === "retry-after") {
        const i = r.headers[t];
        let a = NaN;
        if (i.endsWith("GMT"))
          try {
            a = (vR(i).getTime() - Date.now()) / 1e3;
          } catch (s) {
            e?.trace?.("Failed to parse retry-after header"), e?.trace?.(s);
          }
        else i.match(/ GMT, ((\d+)|(\d+\.\d+))$/) ? a = Number(i.match(/ GMT, ([\d.]+)$/)?.[1]) : i.match(/^((\d+)|(\d+\.\d+))$/) ? a = Number(i) : Date.parse(i) >= Date.now() && (a = (Date.parse(i) - Date.now()) / 1e3);
        return isNaN(a) ? void 0 : new Date(Date.now() + a * 1e3);
      } else if (n === "x-amz-retry-after") {
        const i = r.headers[t], a = Number(i);
        if (isNaN(a)) {
          e?.trace?.(`Failed to parse x-amz-retry-after=${i}`);
          return;
        }
        return new Date(Date.now() + a);
      }
    }
}
const BY = (r) => r instanceof Error ? r : r instanceof Object ? Object.assign(new Error(), r) : typeof r == "string" ? new Error(r) : new Error(`AWS SDK error wrapper for ${r}`);
function _Y(r) {
  return (e) => (t, n) => async (i) => {
    let a = await e.retryStrategy();
    const s = await e.maxAttempts();
    if (NY(a)) {
      a = a;
      let o = await a.acquireInitialRetryToken((n.partition_id ?? "") + (n.__retryLongPoll ? ":longpoll" : "")), l = new Error(), u = 0, c = 0;
      const { request: h } = i, f = Xs.isInstance(h);
      for (f && (h.headers[DY] = IR()); ; )
        try {
          f && (h.headers[RY] = `attempt=${u + 1}; max=${s}`);
          const { response: p, output: m } = await t(i);
          return a.recordSuccess(o), m.$metadata.attempts = u + 1, m.$metadata.totalRetryDelay = c, { response: p, output: m };
        } catch (p) {
          const m = LY(p, e.logger);
          if (l = BY(p), f && r(h))
            throw (n.logger instanceof pR ? console : n.logger)?.warn("An error was encountered in a non-retryable streaming request."), l;
          try {
            o = await a.refreshRetryTokenForRetry(o, m);
          } catch {
            throw l.$metadata || (l.$metadata = {}), l.$metadata.attempts = u + 1, l.$metadata.totalRetryDelay = c, l;
          }
          u = o.getRetryCount();
          const A = o.getRetryDelay();
          c += (o?.$retryLog?.acquisitionDelay ?? 0) + A, A > 0 && await MY(A);
        }
    } else
      return a = a, a?.mode && (n.userAgent = [...n.userAgent || [], ["cfg/retry-mode", a.mode]]), a.retry(t, i);
  };
}
const MY = (r) => new Promise((e) => setTimeout(e, r)), NY = (r) => typeof r.acquireInitialRetryToken < "u" && typeof r.refreshRetryTokenForRetry < "u" && typeof r.recordSuccess < "u", LY = (r, e) => {
  const t = {
    error: r,
    errorType: UY(r)
  }, n = OY(r.$response, e);
  return n && (t.retryAfterHint = n), t;
}, UY = (r) => DR(r) ? "THROTTLING" : Sx(r) ? "TRANSIENT" : FY(r) ? "SERVER_ERROR" : "CLIENT_ERROR", VY = {
  name: "retryMiddleware",
  tags: ["RETRY"],
  step: "finalizeRequest",
  priority: "high",
  override: !0
};
function $Y(r) {
  const e = _Y(r);
  return (t) => ({
    applyToStack: (n) => {
      n.add(e(t), VY);
    }
  });
}
class Ex {
  static setTimeoutFn = (e, t) => setTimeout(e, t);
  beta;
  minCapacity;
  minFillRate;
  scaleConstant;
  smooth;
  enabled = !1;
  availableTokens = 0;
  lastMaxRate = 0;
  measuredTxRate = 0;
  requestCount = 0;
  fillRate;
  lastThrottleTime;
  lastTimestamp = 0;
  lastTxRateBucket;
  maxCapacity;
  timeWindow = 0;
  constructor(e) {
    this.beta = e?.beta ?? 0.7, this.minCapacity = e?.minCapacity ?? 1, this.minFillRate = e?.minFillRate ?? 0.5, this.scaleConstant = e?.scaleConstant ?? 0.4, this.smooth = e?.smooth ?? 0.8, this.lastThrottleTime = this.getCurrentTimeInSeconds(), this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds()), this.fillRate = this.minFillRate, this.maxCapacity = this.minCapacity;
  }
  async getSendToken() {
    return this.acquireTokenBucket(1);
  }
  updateClientSendingRate(e) {
    let t;
    this.updateMeasuredRate();
    const n = e;
    if (n?.errorType === "THROTTLING" || DR(n?.error ?? e)) {
      const s = this.enabled ? Math.min(this.measuredTxRate, this.fillRate) : this.measuredTxRate;
      this.lastMaxRate = s, this.calculateTimeWindow(), this.lastThrottleTime = this.getCurrentTimeInSeconds(), t = this.cubicThrottle(s), this.enableTokenBucket();
    } else
      this.calculateTimeWindow(), t = this.cubicSuccess(this.getCurrentTimeInSeconds());
    const a = Math.min(t, 2 * this.measuredTxRate);
    this.updateTokenBucketRate(a);
  }
  getCurrentTimeInSeconds() {
    return Date.now() / 1e3;
  }
  async acquireTokenBucket(e) {
    if (this.enabled) {
      for (this.refillTokenBucket(); e > this.availableTokens; ) {
        const t = (e - this.availableTokens) / this.fillRate * 1e3;
        await new Promise((n) => Ex.setTimeoutFn(n, t)), this.refillTokenBucket();
      }
      this.availableTokens = this.availableTokens - e;
    }
  }
  refillTokenBucket() {
    const e = this.getCurrentTimeInSeconds();
    if (!this.lastTimestamp) {
      this.lastTimestamp = e;
      return;
    }
    const t = (e - this.lastTimestamp) * this.fillRate;
    this.availableTokens = Math.min(this.maxCapacity, this.availableTokens + t), this.lastTimestamp = e;
  }
  calculateTimeWindow() {
    this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
  }
  cubicThrottle(e) {
    return this.getPrecise(e * this.beta);
  }
  cubicSuccess(e) {
    return this.getPrecise(this.scaleConstant * Math.pow(e - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
  }
  enableTokenBucket() {
    this.enabled = !0;
  }
  updateTokenBucketRate(e) {
    this.refillTokenBucket(), this.fillRate = Math.max(e, this.minFillRate), this.maxCapacity = Math.max(e, this.minCapacity), this.availableTokens = Math.min(this.availableTokens, this.maxCapacity);
  }
  updateMeasuredRate() {
    const e = this.getCurrentTimeInSeconds(), t = Math.floor(e * 2) / 2;
    if (this.requestCount++, t > this.lastTxRateBucket) {
      const n = this.requestCount / (t - this.lastTxRateBucket);
      this.measuredTxRate = this.getPrecise(n * this.smooth + this.measuredTxRate * (1 - this.smooth)), this.requestCount = 0, this.lastTxRateBucket = t;
    }
  }
  getPrecise(e) {
    return parseFloat(e.toFixed(8));
  }
}
class Na {
  static v2026 = typeof process < "u" && process.env?.SMITHY_NEW_RETRIES_2026 === "true";
  static delay() {
    return Na.v2026 ? 50 : 100;
  }
  static throttlingDelay() {
    return Na.v2026 ? 1e3 : 500;
  }
  static cost() {
    return Na.v2026 ? 14 : 5;
  }
  static throttlingCost() {
    return Na.v2026 ? 5 : 10;
  }
  static modifiedCostType() {
    return Na.v2026 ? "THROTTLING" : "TRANSIENT";
  }
}
class zY {
  x = Na.delay();
  computeNextBackoffDelay(e) {
    const i = Math.random() * Math.min(this.x * 2 ** e, RR);
    return Math.floor(i);
  }
  setDelayBase(e) {
    this.x = e;
  }
}
class ST {
  delay;
  count;
  cost;
  longPoll;
  $retryLog = {
    acquisitionDelay: 0
  };
  constructor(e, t, n, i) {
    this.delay = e, this.count = t, this.cost = n, this.longPoll = i;
  }
  getRetryCount() {
    return this.count;
  }
  getRetryDelay() {
    return Math.min(RR, this.delay);
  }
  getRetryCost() {
    return this.cost;
  }
  isLongPoll() {
    return this.longPoll;
  }
}
var Mc;
(function(r) {
  r.STANDARD = "standard", r.ADAPTIVE = "adaptive";
})(Mc || (Mc = {}));
const Op = 3, GY = Mc.STANDARD, Tm = {
  incompatible: 1,
  attempts: 2,
  capacity: 3
};
class nw {
  mode = Mc.STANDARD;
  retryBackoffStrategy;
  capacity = CT;
  maxAttemptsProvider;
  baseDelay;
  constructor(e) {
    typeof e == "number" ? this.maxAttemptsProvider = async () => e : typeof e == "function" ? this.maxAttemptsProvider = e : e && typeof e == "object" && (this.maxAttemptsProvider = async () => e.maxAttempts, this.baseDelay = e.baseDelay, this.retryBackoffStrategy = e.backoff), this.maxAttemptsProvider ??= async () => Op, this.baseDelay ??= Na.delay(), this.retryBackoffStrategy ??= new zY();
  }
  async acquireInitialRetryToken(e) {
    return new ST(Na.delay(), 0, void 0, Na.v2026 && e.includes(":longpoll"));
  }
  async refreshRetryTokenForRetry(e, t) {
    const n = await this.getMaxAttempts(), i = this.retryCode(e, t, n), a = i === 0, s = e.isLongPoll?.();
    if (a || s) {
      const o = t.errorType;
      this.retryBackoffStrategy.setDelayBase(o === "THROTTLING" ? Na.throttlingDelay() : this.baseDelay);
      const l = this.retryBackoffStrategy.computeNextBackoffDelay(e.getRetryCount());
      let u = l;
      if (t.retryAfterHint instanceof Date && (u = Math.max(l, Math.min(t.retryAfterHint.getTime() - Date.now(), l + 5e3))), a) {
        const c = this.getCapacityCost(o);
        this.capacity -= c;
        const h = new ST(0, e.getRetryCount() + 1, c, e.isLongPoll?.() ?? !1);
        return await new Promise((f) => setTimeout(f, u)), h.$retryLog.acquisitionDelay = u, h;
      } else {
        const c = Na.v2026 && i === Tm.capacity && s ? u : 0;
        c > 0 && await new Promise((h) => setTimeout(h, c));
      }
    }
    throw new Error("No retry token available");
  }
  recordSuccess(e) {
    this.capacity = Math.min(CT, this.capacity + (e.getRetryCost() ?? PY));
  }
  getCapacity() {
    return this.capacity;
  }
  async maxAttempts() {
    return this.maxAttemptsProvider();
  }
  async getMaxAttempts() {
    try {
      return await this.maxAttemptsProvider();
    } catch {
      return console.warn(`Max attempts provider could not resolve. Using default of ${Op}`), Op;
    }
  }
  retryCode(e, t, n) {
    const i = e.getRetryCount() + 1, a = this.isRetryableError(t.errorType) ? 0 : Tm.incompatible, s = i < n ? 0 : Tm.attempts, o = this.capacity >= this.getCapacityCost(t.errorType) ? 0 : Tm.capacity;
    return a || s || o;
  }
  getCapacityCost(e) {
    return e === Na.modifiedCostType() ? Na.throttlingCost() : Na.cost();
  }
  isRetryableError(e) {
    return e === "THROTTLING" || e === "TRANSIENT";
  }
}
class HY {
  mode = Mc.ADAPTIVE;
  rateLimiter;
  standardRetryStrategy;
  constructor(e, t) {
    const { rateLimiter: n } = t ?? {};
    this.rateLimiter = n ?? new Ex(), this.standardRetryStrategy = t ? new nw({
      maxAttempts: typeof e == "number" ? e : 3,
      ...t
    }) : new nw(e);
  }
  async acquireInitialRetryToken(e) {
    const t = await this.standardRetryStrategy.acquireInitialRetryToken(e);
    return await this.rateLimiter.getSendToken(), t;
  }
  async refreshRetryTokenForRetry(e, t) {
    this.rateLimiter.updateClientSendingRate(t);
    const n = await this.standardRetryStrategy.refreshRetryTokenForRetry(e, t);
    return await this.rateLimiter.getSendToken(), n;
  }
  recordSuccess(e) {
    this.rateLimiter.updateClientSendingRate({}), this.standardRetryStrategy.recordSuccess(e);
  }
  async maxAttemptsProvider() {
    return this.standardRetryStrategy.maxAttempts();
  }
}
const WY = (r, e) => {
  const { retryStrategy: t, retryMode: n } = r, { defaultMaxAttempts: i = Op, defaultBaseDelay: a = Na.delay() } = {}, s = ku(r.maxAttempts ?? i);
  let o = t ? Promise.resolve(t) : void 0;
  const l = async () => {
    const u = await s();
    return await ku(n)() === Mc.ADAPTIVE ? new HY(s, {
      maxAttempts: u,
      baseDelay: a
    }) : new nw({
      maxAttempts: u,
      baseDelay: a
    });
  };
  return Object.assign(r, {
    maxAttempts: s,
    retryStrategy: () => o ??= l()
  });
}, jY = $Y(Fq);
Na.v2026 ||= typeof process == "object" && process.env?.AWS_NEW_RETRIES_2026 === "true";
function wu(r, e, t) {
  r.__aws_sdk_context ? r.__aws_sdk_context.features || (r.__aws_sdk_context.features = {}) : r.__aws_sdk_context = {
    features: {}
  }, r.__aws_sdk_context.features[e] = t;
}
const qY = (r) => (e) => async (t) => {
  if (!Xs.isInstance(t.request))
    return e(t);
  const { request: n } = t, { handlerProtocol: i = "" } = r.requestHandler.metadata || {};
  if (i.indexOf("h2") >= 0 && !n.headers[":authority"])
    delete n.headers.host, n.headers[":authority"] = n.hostname + (n.port ? ":" + n.port : "");
  else if (!n.headers.host) {
    let a = n.hostname;
    n.port != null && (a += `:${n.port}`), n.headers.host = a;
  }
  return e(t);
}, QY = {
  name: "hostHeaderMiddleware",
  step: "build",
  priority: "low",
  tags: ["HOST"],
  override: !0
}, YY = (r) => ({
  applyToStack: (e) => {
    e.add(qY(r), QY);
  }
}), XY = () => (r, e) => async (t) => {
  try {
    const n = await r(t), { clientName: i, commandName: a, logger: s, dynamoDbDocumentClientOptions: o = {} } = e, { overrideInputFilterSensitiveLog: l, overrideOutputFilterSensitiveLog: u } = o, c = l ?? e.inputFilterSensitiveLog, h = u ?? e.outputFilterSensitiveLog, { $metadata: f, ...p } = n.output;
    return s?.info?.({
      clientName: i,
      commandName: a,
      input: c(t.input),
      output: h(p),
      metadata: f
    }), n;
  } catch (n) {
    const { clientName: i, commandName: a, logger: s, dynamoDbDocumentClientOptions: o = {} } = e, { overrideInputFilterSensitiveLog: l } = o, u = l ?? e.inputFilterSensitiveLog;
    throw s?.error?.({
      clientName: i,
      commandName: a,
      input: u(t.input),
      error: n,
      metadata: n.$metadata
    }), n;
  }
}, JY = {
  name: "loggerMiddleware",
  tags: ["LOGGER"],
  step: "initialize",
  override: !0
}, KY = (r) => ({
  applyToStack: (e) => {
    e.add(XY(), JY);
  }
}), ZY = (r) => ({
  applyToStack: (e) => {
  }
}), eX = (r, e) => {
  if (!e || e.length === 0)
    return r;
  const t = [];
  for (const n of e)
    for (const i of r)
      i.schemeId.split("#")[1] === n && t.push(i);
  for (const n of r)
    t.find(({ schemeId: i }) => i === n.schemeId) || t.push(n);
  return t;
};
function tX(r) {
  const e = /* @__PURE__ */ new Map();
  for (const t of r)
    e.set(t.schemeId, t);
  return e;
}
const rX = (r, e) => (t, n) => async (i) => {
  const a = r.httpAuthSchemeProvider(await e.httpAuthSchemeParametersProvider(r, n, i.input)), s = r.authSchemePreference ? await r.authSchemePreference() : [], o = eX(a, s), l = tX(r.httpAuthSchemes), u = lh(n), c = [];
  for (const h of o) {
    const f = l.get(h.schemeId);
    if (!f) {
      c.push(`HttpAuthScheme \`${h.schemeId}\` was not enabled for this service.`);
      continue;
    }
    const p = f.identityProvider(await e.identityProviderConfigProvider(r));
    if (!p) {
      c.push(`HttpAuthScheme \`${h.schemeId}\` did not have an IdentityProvider configured.`);
      continue;
    }
    const { identityProperties: m = {}, signingProperties: A = {} } = h.propertiesExtractor?.(r, n) || {};
    h.identityProperties = Object.assign(h.identityProperties || {}, m), h.signingProperties = Object.assign(h.signingProperties || {}, A), u.selectedHttpAuthScheme = {
      httpAuthOption: h,
      identity: await p(h.identityProperties),
      signer: f.signer
    };
    break;
  }
  if (!u.selectedHttpAuthScheme)
    throw new Error(c.join(`
`));
  return t(i);
}, nX = {
  step: "serialize",
  tags: ["HTTP_AUTH_SCHEME"],
  name: "httpAuthSchemeMiddleware",
  override: !0,
  relation: "before",
  toMiddleware: "endpointV2Middleware"
}, iX = (r, { httpAuthSchemeParametersProvider: e, identityProviderConfigProvider: t }) => ({
  applyToStack: (n) => {
    n.addRelativeTo(rX(r, {
      httpAuthSchemeParametersProvider: e,
      identityProviderConfigProvider: t
    }), nX);
  }
}), aX = (r) => (e) => {
  throw e;
}, sX = (r, e) => {
}, oX = (r) => (e, t) => async (n) => {
  if (!Xs.isInstance(n.request))
    return e(n);
  const a = lh(t).selectedHttpAuthScheme;
  if (!a)
    throw new Error("No HttpAuthScheme was selected: unable to sign request");
  const { httpAuthOption: { signingProperties: s = {} }, identity: o, signer: l } = a, u = await e({
    ...n,
    request: await l.sign(n.request, o, s)
  }).catch((l.errorHandler || aX)(s));
  return (l.successHandler || sX)(u.response, s), u;
}, lX = {
  step: "finalizeRequest",
  tags: ["HTTP_SIGNING"],
  name: "httpSigningMiddleware",
  aliases: ["apiKeyMiddleware", "tokenMiddleware", "awsAuthMiddleware"],
  override: !0,
  relation: "after",
  toMiddleware: "retryMiddleware"
}, uX = (r) => ({
  applyToStack: (e) => {
    e.addRelativeTo(oX(), lX);
  }
}), Bp = (r) => {
  if (typeof r == "function")
    return r;
  const e = Promise.resolve(r);
  return () => e;
};
class cX {
  authSchemes = /* @__PURE__ */ new Map();
  constructor(e) {
    for (const t in e) {
      const n = e[t];
      n !== void 0 && this.authSchemes.set(t, n);
    }
  }
  getIdentityProvider(e) {
    return this.authSchemes.get(e);
  }
}
class fX {
  async sign(e, t, n) {
    return e;
  }
}
const dX = (r) => function(t) {
  return OR(t) && t.expiration.getTime() - Date.now() < r;
}, hX = 3e5, pX = dX(hX), OR = (r) => r.expiration !== void 0, gX = (r, e, t) => {
  if (r === void 0)
    return;
  const n = typeof r != "function" ? async () => Promise.resolve(r) : r;
  let i, a, s, o = !1;
  const l = async (u) => {
    a || (a = n(u));
    try {
      i = await a, s = !0, o = !1;
    } finally {
      a = void 0;
    }
    return i;
  };
  return e === void 0 ? async (u) => ((!s || u?.forceRefresh) && (i = await l(u)), i) : async (u) => ((!s || u?.forceRefresh) && (i = await l(u)), o ? i : t(i) ? (e(i) && await l(u), i) : (o = !0, i));
}, mX = void 0;
function vX(r) {
  return r === void 0 ? !0 : typeof r == "string" && r.length <= 50;
}
function yX(r) {
  const e = Bp(r.userAgentAppId ?? mX), { customUserAgent: t } = r;
  return Object.assign(r, {
    customUserAgent: typeof t == "string" ? [[t]] : t,
    userAgentAppId: async () => {
      const n = await e();
      if (!vX(n)) {
        const i = r.logger?.constructor?.name === "NoOpLogger" || !r.logger ? console : r.logger;
        typeof n != "string" ? i?.warn("userAgentAppId must be a string or undefined.") : n.length > 50 && i?.warn("The provided userAgentAppId exceeds the maximum length of 50 characters.");
      }
      return n;
    }
  });
}
const AX = {
  partitions: [
    {
      id: "aws",
      outputs: {
        dnsSuffix: "amazonaws.com",
        dualStackDnsSuffix: "api.aws",
        implicitGlobalRegion: "us-east-1",
        name: "aws",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^(us|eu|ap|sa|ca|me|af|il|mx)\\-\\w+\\-\\d+$",
      regions: {
        "af-south-1": {
          description: "Africa (Cape Town)"
        },
        "ap-east-1": {
          description: "Asia Pacific (Hong Kong)"
        },
        "ap-east-2": {
          description: "Asia Pacific (Taipei)"
        },
        "ap-northeast-1": {
          description: "Asia Pacific (Tokyo)"
        },
        "ap-northeast-2": {
          description: "Asia Pacific (Seoul)"
        },
        "ap-northeast-3": {
          description: "Asia Pacific (Osaka)"
        },
        "ap-south-1": {
          description: "Asia Pacific (Mumbai)"
        },
        "ap-south-2": {
          description: "Asia Pacific (Hyderabad)"
        },
        "ap-southeast-1": {
          description: "Asia Pacific (Singapore)"
        },
        "ap-southeast-2": {
          description: "Asia Pacific (Sydney)"
        },
        "ap-southeast-3": {
          description: "Asia Pacific (Jakarta)"
        },
        "ap-southeast-4": {
          description: "Asia Pacific (Melbourne)"
        },
        "ap-southeast-5": {
          description: "Asia Pacific (Malaysia)"
        },
        "ap-southeast-6": {
          description: "Asia Pacific (New Zealand)"
        },
        "ap-southeast-7": {
          description: "Asia Pacific (Thailand)"
        },
        "aws-global": {
          description: "aws global region"
        },
        "ca-central-1": {
          description: "Canada (Central)"
        },
        "ca-west-1": {
          description: "Canada West (Calgary)"
        },
        "eu-central-1": {
          description: "Europe (Frankfurt)"
        },
        "eu-central-2": {
          description: "Europe (Zurich)"
        },
        "eu-north-1": {
          description: "Europe (Stockholm)"
        },
        "eu-south-1": {
          description: "Europe (Milan)"
        },
        "eu-south-2": {
          description: "Europe (Spain)"
        },
        "eu-west-1": {
          description: "Europe (Ireland)"
        },
        "eu-west-2": {
          description: "Europe (London)"
        },
        "eu-west-3": {
          description: "Europe (Paris)"
        },
        "il-central-1": {
          description: "Israel (Tel Aviv)"
        },
        "me-central-1": {
          description: "Middle East (UAE)"
        },
        "me-south-1": {
          description: "Middle East (Bahrain)"
        },
        "mx-central-1": {
          description: "Mexico (Central)"
        },
        "sa-east-1": {
          description: "South America (Sao Paulo)"
        },
        "us-east-1": {
          description: "US East (N. Virginia)"
        },
        "us-east-2": {
          description: "US East (Ohio)"
        },
        "us-west-1": {
          description: "US West (N. California)"
        },
        "us-west-2": {
          description: "US West (Oregon)"
        }
      }
    },
    {
      id: "aws-cn",
      outputs: {
        dnsSuffix: "amazonaws.com.cn",
        dualStackDnsSuffix: "api.amazonwebservices.com.cn",
        implicitGlobalRegion: "cn-northwest-1",
        name: "aws-cn",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^cn\\-\\w+\\-\\d+$",
      regions: {
        "aws-cn-global": {
          description: "aws-cn global region"
        },
        "cn-north-1": {
          description: "China (Beijing)"
        },
        "cn-northwest-1": {
          description: "China (Ningxia)"
        }
      }
    },
    {
      id: "aws-eusc",
      outputs: {
        dnsSuffix: "amazonaws.eu",
        dualStackDnsSuffix: "api.amazonwebservices.eu",
        implicitGlobalRegion: "eusc-de-east-1",
        name: "aws-eusc",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^eusc\\-(de)\\-\\w+\\-\\d+$",
      regions: {
        "eusc-de-east-1": {
          description: "AWS European Sovereign Cloud (Germany)"
        }
      }
    },
    {
      id: "aws-iso",
      outputs: {
        dnsSuffix: "c2s.ic.gov",
        dualStackDnsSuffix: "api.aws.ic.gov",
        implicitGlobalRegion: "us-iso-east-1",
        name: "aws-iso",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
      regions: {
        "aws-iso-global": {
          description: "aws-iso global region"
        },
        "us-iso-east-1": {
          description: "US ISO East"
        },
        "us-iso-west-1": {
          description: "US ISO WEST"
        }
      }
    },
    {
      id: "aws-iso-b",
      outputs: {
        dnsSuffix: "sc2s.sgov.gov",
        dualStackDnsSuffix: "api.aws.scloud",
        implicitGlobalRegion: "us-isob-east-1",
        name: "aws-iso-b",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
      regions: {
        "aws-iso-b-global": {
          description: "aws-iso-b global region"
        },
        "us-isob-east-1": {
          description: "US ISOB East (Ohio)"
        },
        "us-isob-west-1": {
          description: "US ISOB West"
        }
      }
    },
    {
      id: "aws-iso-e",
      outputs: {
        dnsSuffix: "cloud.adc-e.uk",
        dualStackDnsSuffix: "api.cloud-aws.adc-e.uk",
        implicitGlobalRegion: "eu-isoe-west-1",
        name: "aws-iso-e",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^eu\\-isoe\\-\\w+\\-\\d+$",
      regions: {
        "aws-iso-e-global": {
          description: "aws-iso-e global region"
        },
        "eu-isoe-west-1": {
          description: "EU ISOE West"
        }
      }
    },
    {
      id: "aws-iso-f",
      outputs: {
        dnsSuffix: "csp.hci.ic.gov",
        dualStackDnsSuffix: "api.aws.hci.ic.gov",
        implicitGlobalRegion: "us-isof-south-1",
        name: "aws-iso-f",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^us\\-isof\\-\\w+\\-\\d+$",
      regions: {
        "aws-iso-f-global": {
          description: "aws-iso-f global region"
        },
        "us-isof-east-1": {
          description: "US ISOF EAST"
        },
        "us-isof-south-1": {
          description: "US ISOF SOUTH"
        }
      }
    },
    {
      id: "aws-us-gov",
      outputs: {
        dnsSuffix: "amazonaws.com",
        dualStackDnsSuffix: "api.aws",
        implicitGlobalRegion: "us-gov-west-1",
        name: "aws-us-gov",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
      regions: {
        "aws-us-gov-global": {
          description: "aws-us-gov global region"
        },
        "us-gov-east-1": {
          description: "AWS GovCloud (US-East)"
        },
        "us-gov-west-1": {
          description: "AWS GovCloud (US-West)"
        }
      }
    }
  ]
};
let wX = AX;
const xX = (r) => {
  const { partitions: e } = wX;
  for (const n of e) {
    const { regions: i, outputs: a } = n;
    for (const [s, o] of Object.entries(i))
      if (s === r)
        return {
          ...a,
          ...o
        };
  }
  for (const n of e) {
    const { regionRegex: i, outputs: a } = n;
    if (new RegExp(i).test(r))
      return {
        ...a
      };
  }
  const t = e.find((n) => n.id === "aws");
  if (!t)
    throw new Error("Provided region was not found in the partition array or regex, and default partition with id 'aws' doesn't exist.");
  return {
    ...t.outputs
  };
}, bX = /\d{12}\.ddb/;
async function CX(r, e, t) {
  if (t.request?.headers?.["smithy-protocol"] === "rpc-v2-cbor" && wu(r, "PROTOCOL_RPC_V2_CBOR", "M"), typeof e.retryStrategy == "function") {
    const a = await e.retryStrategy();
    if (typeof a.mode == "string")
      switch (a.mode) {
        case Mc.ADAPTIVE:
          wu(r, "RETRY_MODE_ADAPTIVE", "F");
          break;
        case Mc.STANDARD:
          wu(r, "RETRY_MODE_STANDARD", "E");
          break;
      }
  }
  if (typeof e.accountIdEndpointMode == "function") {
    const a = r.endpointV2;
    switch (String(a?.url?.hostname).match(bX) && wu(r, "ACCOUNT_ID_ENDPOINT", "O"), await e.accountIdEndpointMode?.()) {
      case "disabled":
        wu(r, "ACCOUNT_ID_MODE_DISABLED", "Q");
        break;
      case "preferred":
        wu(r, "ACCOUNT_ID_MODE_PREFERRED", "P");
        break;
      case "required":
        wu(r, "ACCOUNT_ID_MODE_REQUIRED", "R");
        break;
    }
  }
  const i = r.__smithy_context?.selectedHttpAuthScheme?.identity;
  if (i?.$source) {
    const a = i;
    a.accountId && wu(r, "RESOLVED_ACCOUNT_ID", "T");
    for (const [s, o] of Object.entries(a.$source ?? {}))
      wu(r, s, o);
  }
}
const ET = "user-agent", EA = "x-amz-user-agent", kT = " ", kA = "/", SX = /[^!$%&'*+\-.^_`|~\w]/g, EX = /[^!$%&'*+\-.^_`|~\w#]/g, TT = "-", kX = 1024;
function TX(r) {
  let e = "";
  for (const t in r) {
    const n = r[t];
    if (e.length + n.length + 1 <= kX) {
      e.length ? e += "," + n : e += n;
      continue;
    }
    break;
  }
  return e;
}
const FX = (r) => (e, t) => async (n) => {
  const { request: i } = n;
  if (!Xs.isInstance(i))
    return e(n);
  const { headers: a } = i, s = t?.userAgent?.map(Fm) || [], o = (await r.defaultUserAgentProvider()).map(Fm);
  await CX(t, r, n);
  const l = t;
  o.push(`m/${TX(Object.assign({}, t.__smithy_context?.features, l.__aws_sdk_context?.features))}`);
  const u = r?.customUserAgent?.map(Fm) || [], c = await r.userAgentAppId();
  c && o.push(Fm(["app", `${c}`]));
  const h = [].concat([...o, ...s, ...u]).join(kT), f = [
    ...o.filter((p) => p.startsWith("aws-sdk-")),
    ...u
  ].join(kT);
  return r.runtime !== "browser" ? (f && (a[EA] = a[EA] ? `${a[ET]} ${f}` : f), a[ET] = h) : a[EA] = h, e({
    ...n,
    request: i
  });
}, Fm = (r) => {
  const e = r[0].split(kA).map((s) => s.replace(SX, TT)).join(kA), t = r[1]?.replace(EX, TT), n = e.indexOf(kA), i = e.substring(0, n);
  let a = e.substring(n + 1);
  return i === "api" && (a = a.toLowerCase()), [i, a, t].filter((s) => s && s.length > 0).reduce((s, o, l) => {
    switch (l) {
      case 0:
        return o;
      case 1:
        return `${s}/${o}`;
      default:
        return `${s}#${o}`;
    }
  }, "");
}, IX = {
  name: "getUserAgentMiddleware",
  step: "build",
  priority: "low",
  tags: ["SET_USER_AGENT", "USER_AGENT"],
  override: !0
}, PX = (r) => ({
  applyToStack: (e) => {
    e.add(FX(r), IX);
  }
}), DX = ({ serviceId: r, clientVersion: e }) => async (t) => {
  const n = typeof window < "u" ? window.navigator : void 0, i = n?.userAgent ?? "", a = n?.userAgentData?.platform ?? FT.os(i) ?? "other", s = void 0, o = n?.userAgentData?.brands ?? [], l = o[o.length - 1], u = l?.brand ?? FT.browser(i) ?? "unknown", c = l?.version ?? "unknown", h = [
    ["aws-sdk-js", e],
    ["ua", "2.1"],
    [`os/${a}`, s],
    ["lang/js"],
    ["md/browser", `${u}_${c}`]
  ];
  r && h.push([`api/${r}`, e]);
  const f = await t?.userAgentAppId?.();
  return f && h.push([`app/${f}`]), h;
}, FT = {
  os(r) {
    if (/iPhone|iPad|iPod/.test(r))
      return "iOS";
    if (/Macintosh|Mac OS X/.test(r))
      return "macOS";
    if (/Windows NT/.test(r))
      return "Windows";
    if (/Android/.test(r))
      return "Android";
    if (/Linux/.test(r))
      return "Linux";
  },
  browser(r) {
    if (/EdgiOS|EdgA|Edg\//.test(r))
      return "Microsoft Edge";
    if (/Firefox\//.test(r))
      return "Firefox";
    if (/Chrome\//.test(r))
      return "Chrome";
    if (/Safari\//.test(r))
      return "Safari";
  }
}, BR = (r, e = !1) => {
  if (e) {
    for (const t of r.split("."))
      if (!BR(t))
        return !1;
    return !0;
  }
  return !(!K0(r) || r.length < 3 || r.length > 63 || r !== r.toLowerCase() || xR(r));
}, IT = ":", RX = "/", OX = (r) => {
  const e = r.split(IT);
  if (e.length < 6)
    return null;
  const [t, n, i, a, s, ...o] = e;
  if (t !== "arn" || n === "" || i === "" || o.join(IT) === "")
    return null;
  const l = o.map((u) => u.split(RX)).flat();
  return {
    partition: n,
    service: i,
    region: a,
    accountId: s,
    resourceId: l
  };
}, _R = {
  isVirtualHostableS3Bucket: BR,
  parseArn: OX,
  partition: xX
};
Cx.aws = _R;
const BX = (r, e, t) => {
  let n, i, a, s = !1;
  const o = async () => {
    i || (i = r());
    try {
      n = await i, a = !0, s = !1;
    } finally {
      i = void 0;
    }
    return n;
  };
  return async (l) => ((!a || l?.forceRefresh) && (n = await o()), n);
}, PT = /* @__PURE__ */ new Set(), _X = (r, e = K0) => {
  if (!PT.has(r) && !e(r))
    if (r === "*")
      console.warn('@smithy/config-resolver WARN - Please use the caller region instead of "*". See "sigv4a" in https://github.com/aws/aws-sdk-js-v3/blob/main/supplemental-docs/CLIENTS.md.');
    else
      throw new Error(`Region not accepted: region="${r}" is not a valid hostname component.`);
  else
    PT.add(r);
}, MR = (r) => typeof r == "string" && (r.startsWith("fips-") || r.endsWith("-fips")), MX = (r) => MR(r) ? ["fips-aws-global", "aws-fips"].includes(r) ? "us-east-1" : r.replace(/fips-(dkr-|prod-)?|-fips/, "") : r, NX = (r) => {
  const { region: e, useFipsEndpoint: t } = r;
  if (!e)
    throw new Error("Region is missing");
  return Object.assign(r, {
    region: async () => {
      const n = typeof e == "function" ? await e() : e, i = MX(n);
      return _X(i), i;
    },
    useFipsEndpoint: async () => {
      const n = typeof e == "string" ? e : await e();
      return MR(n) ? !0 : typeof t != "function" ? Promise.resolve(!!t) : t();
    }
  });
}, LX = ["in-region", "cross-region", "mobile", "standard", "legacy"], UX = ({ defaultsMode: r } = {}) => BX(async () => {
  const e = typeof r == "function" ? await r() : r;
  switch (e?.toLowerCase()) {
    case "auto":
      return Promise.resolve(VX() ? "mobile" : "standard");
    case "mobile":
    case "in-region":
    case "cross-region":
    case "standard":
    case "legacy":
      return Promise.resolve(e?.toLocaleLowerCase());
    case void 0:
      return Promise.resolve("legacy");
    default:
      throw new Error(`Invalid parameter for "defaultsMode", expect ${LX.join(", ")}, got ${e}`);
  }
}), VX = () => {
  const r = window?.navigator;
  if (r?.connection) {
    const { effectiveType: e, rtt: t, downlink: n } = r?.connection;
    if (typeof e == "string" && e !== "4g" || Number(t) > 100 || Number(n) < 10)
      return !0;
  }
  return r?.userAgentData?.mobile || typeof r?.maxTouchPoints == "number" && r?.maxTouchPoints > 1;
}, $X = !1, zX = !1, GX = (r) => ({
  setRegion(e) {
    r.region = e;
  },
  region() {
    return r.region;
  }
}), HX = (r) => ({
  region: r.region()
}), DT = (r) => jd.isInstance(r) ? r.headers?.date ?? r.headers?.Date : void 0, NR = (r) => new Date(Date.now() + r), WX = (r, e) => Math.abs(NR(e).getTime() - r) >= 3e5, RT = (r, e) => {
  const t = Date.parse(r);
  return WX(t, e) ? t - Date.now() : e;
}, _p = (r, e) => {
  if (!e)
    throw new Error(`Property \`${r}\` is not resolved for AWS SDK SigV4Auth`);
  return e;
}, jX = async (r) => {
  const e = _p("context", r.context), t = _p("config", r.config), n = e.endpointV2?.properties?.authSchemes?.[0], a = await _p("signer", t.signer)(n), s = r?.signingRegion, o = r?.signingRegionSet, l = r?.signingName;
  return {
    config: t,
    signer: a,
    signingRegion: s,
    signingRegionSet: o,
    signingName: l
  };
};
class qX {
  async sign(e, t, n) {
    if (!Xs.isInstance(e))
      throw new Error("The request is not an instance of `HttpRequest` and cannot be signed");
    const i = await jX(n), { config: a, signer: s } = i;
    let { signingRegion: o, signingName: l } = i;
    const u = n.context;
    if (u?.authSchemes?.length ?? !1) {
      const [h, f] = u.authSchemes;
      h?.name === "sigv4a" && f?.name === "sigv4" && (o = f?.signingRegion ?? o, l = f?.signingName ?? l);
    }
    return n._preRequestSystemClockOffset = a.systemClockOffset, await s.sign(e, {
      signingDate: NR(a.systemClockOffset),
      signingRegion: o,
      signingService: l
    });
  }
  errorHandler(e) {
    return (t) => {
      const n = t, i = n.ServerTime ?? DT(n.$response);
      if (i) {
        const a = _p("config", e.config), s = e._preRequestSystemClockOffset, o = RT(i, a.systemClockOffset);
        (o !== a.systemClockOffset || s !== void 0 && s !== o) && n.$metadata && (a.systemClockOffset = o, n.$metadata.clockSkewCorrected = !0);
      }
      throw t;
    };
  }
  successHandler(e, t) {
    const n = DT(e);
    if (n) {
      const i = _p("config", t.config);
      i.systemClockOffset = RT(n, i.systemClockOffset);
    }
  }
}
class QX {
  format(e) {
    const t = [];
    for (const a of Object.keys(e)) {
      const s = qd(a);
      t.push(Uint8Array.from([s.byteLength]), s, this.formatHeaderValue(e[a]));
    }
    const n = new Uint8Array(t.reduce((a, s) => a + s.byteLength, 0));
    let i = 0;
    for (const a of t)
      n.set(a, i), i += a.byteLength;
    return n;
  }
  formatHeaderValue(e) {
    switch (e.type) {
      case "boolean":
        return Uint8Array.from([e.value ? 0 : 1]);
      case "byte":
        return Uint8Array.from([2, e.value]);
      case "short":
        const t = new DataView(new ArrayBuffer(3));
        return t.setUint8(0, 3), t.setInt16(1, e.value, !1), new Uint8Array(t.buffer);
      case "integer":
        const n = new DataView(new ArrayBuffer(5));
        return n.setUint8(0, 4), n.setInt32(1, e.value, !1), new Uint8Array(n.buffer);
      case "long":
        const i = new Uint8Array(9);
        return i[0] = 5, i.set(e.value.bytes, 1), i;
      case "binary":
        const a = new DataView(new ArrayBuffer(3 + e.value.byteLength));
        a.setUint8(0, 6), a.setUint16(1, e.value.byteLength, !1);
        const s = new Uint8Array(a.buffer);
        return s.set(e.value, 3), s;
      case "string":
        const o = qd(e.value), l = new DataView(new ArrayBuffer(3 + o.byteLength));
        l.setUint8(0, 7), l.setUint16(1, o.byteLength, !1);
        const u = new Uint8Array(l.buffer);
        return u.set(o, 3), u;
      case "timestamp":
        const c = new Uint8Array(9);
        return c[0] = 8, c.set(kx.fromNumber(e.value.valueOf()).bytes, 1), c;
      case "uuid":
        if (!YX.test(e.value))
          throw new Error(`Invalid UUID received: ${e.value}`);
        const h = new Uint8Array(17);
        return h[0] = 9, h.set(CQ(e.value.replace(/\-/g, "")), 1), h;
    }
  }
}
var OT;
(function(r) {
  r[r.boolTrue = 0] = "boolTrue", r[r.boolFalse = 1] = "boolFalse", r[r.byte = 2] = "byte", r[r.short = 3] = "short", r[r.integer = 4] = "integer", r[r.long = 5] = "long", r[r.byteArray = 6] = "byteArray", r[r.string = 7] = "string", r[r.timestamp = 8] = "timestamp", r[r.uuid = 9] = "uuid";
})(OT || (OT = {}));
const YX = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;
class kx {
  bytes;
  constructor(e) {
    if (this.bytes = e, e.byteLength !== 8)
      throw new Error("Int64 buffers must be exactly 8 bytes");
  }
  static fromNumber(e) {
    if (e > 9223372036854776e3 || e < -9223372036854776e3)
      throw new Error(`${e} is too large (or, if negative, too small) to represent as an Int64`);
    const t = new Uint8Array(8);
    for (let n = 7, i = Math.abs(Math.round(e)); n > -1 && i > 0; n--, i /= 256)
      t[n] = i;
    return e < 0 && BT(t), new kx(t);
  }
  valueOf() {
    const e = this.bytes.slice(0), t = e[0] & 128;
    return t && BT(e), parseInt(Rf(e), 16) * (t ? -1 : 1);
  }
  toString() {
    return String(this.valueOf());
  }
}
function BT(r) {
  for (let e = 0; e < 8; e++)
    r[e] ^= 255;
  for (let e = 7; e > -1 && (r[e]++, r[e] === 0); e--)
    ;
}
const XX = "X-Amz-Algorithm", JX = "X-Amz-Credential", LR = "X-Amz-Date", KX = "X-Amz-SignedHeaders", ZX = "X-Amz-Expires", UR = "X-Amz-Signature", VR = "X-Amz-Security-Token", $R = "authorization", zR = LR.toLowerCase(), eJ = "date", tJ = [$R, zR, eJ], rJ = UR.toLowerCase(), iw = "x-amz-content-sha256", nJ = VR.toLowerCase(), iJ = {
  authorization: !0,
  "cache-control": !0,
  connection: !0,
  expect: !0,
  from: !0,
  "keep-alive": !0,
  "max-forwards": !0,
  pragma: !0,
  referer: !0,
  te: !0,
  trailer: !0,
  "transfer-encoding": !0,
  upgrade: !0,
  "user-agent": !0,
  "x-amzn-trace-id": !0
}, aJ = /^proxy-/, sJ = /^sec-/, TA = "AWS4-HMAC-SHA256", oJ = "AWS4-HMAC-SHA256-PAYLOAD", lJ = "UNSIGNED-PAYLOAD", uJ = 50, GR = "aws4_request", cJ = 3600 * 24 * 7, fJ = ({ query: r = {} }) => {
  const e = [], t = {};
  for (const n of Object.keys(r)) {
    if (n.toLowerCase() === rJ)
      continue;
    const i = Of(n);
    e.push(i);
    const a = r[n];
    typeof a == "string" ? t[i] = `${i}=${Of(a)}` : Array.isArray(a) && (t[i] = a.slice(0).reduce((s, o) => s.concat([`${i}=${Of(o)}`]), []).sort().join("&"));
  }
  return e.sort().map((n) => t[n]).filter((n) => n).join("&");
}, dJ = (r) => hJ(r).toISOString().replace(/\.\d{3}Z$/, "Z"), hJ = (r) => typeof r == "number" ? new Date(r * 1e3) : typeof r == "string" ? Number(r) ? new Date(Number(r) * 1e3) : new Date(r) : r;
class pJ {
  service;
  regionProvider;
  credentialProvider;
  sha256;
  uriEscapePath;
  applyChecksum;
  constructor({ applyChecksum: e, credentials: t, region: n, service: i, sha256: a, uriEscapePath: s = !0 }) {
    this.service = i, this.sha256 = a, this.uriEscapePath = s, this.applyChecksum = typeof e == "boolean" ? e : !0, this.regionProvider = ku(n), this.credentialProvider = ku(t);
  }
  createCanonicalRequest(e, t, n) {
    const i = Object.keys(t).sort();
    return `${e.method}
${this.getCanonicalPath(e)}
${fJ(e)}
${i.map((a) => `${a}:${t[a]}`).join(`
`)}

${i.join(";")}
${n}`;
  }
  async createStringToSign(e, t, n, i) {
    const a = new this.sha256();
    a.update(tg(n));
    const s = await a.digest();
    return `${i}
${e}
${t}
${Rf(s)}`;
  }
  getCanonicalPath({ path: e }) {
    if (this.uriEscapePath) {
      const t = [];
      for (const a of e.split("/"))
        a?.length !== 0 && a !== "." && (a === ".." ? t.pop() : t.push(a));
      const n = `${e?.startsWith("/") ? "/" : ""}${t.join("/")}${t.length > 0 && e?.endsWith("/") ? "/" : ""}`;
      return Of(n).replace(/%2F/g, "/");
    }
    return e;
  }
  validateResolvedCredentials(e) {
    if (typeof e != "object" || typeof e.accessKeyId != "string" || typeof e.secretAccessKey != "string")
      throw new Error("Resolved credential object is not valid");
  }
  formatDate(e) {
    const t = dJ(e).replace(/[\-:]/g, "");
    return {
      longDate: t,
      shortDate: t.slice(0, 8)
    };
  }
  getCanonicalHeaderList(e) {
    return Object.keys(e).sort().join(";");
  }
}
const Im = {}, FA = [], IA = (r, e, t) => `${r}/${e}/${t}/${GR}`, gJ = async (r, e, t, n, i) => {
  const a = await _T(r, e.secretAccessKey, e.accessKeyId), s = `${t}:${n}:${i}:${Rf(a)}:${e.sessionToken}`;
  if (s in Im)
    return Im[s];
  for (FA.push(s); FA.length > uJ; )
    delete Im[FA.shift()];
  let o = `AWS4${e.secretAccessKey}`;
  for (const l of [t, n, i, GR])
    o = await _T(r, o, l);
  return Im[s] = o;
}, _T = (r, e, t) => {
  const n = new r(e);
  return n.update(tg(t)), n.digest();
}, MT = ({ headers: r }, e, t) => {
  const n = {};
  for (const i of Object.keys(r).sort()) {
    if (r[i] == null)
      continue;
    const a = i.toLowerCase();
    (a in iJ || e?.has(a) || aJ.test(a) || sJ.test(a)) && (!t || t && !t.has(a)) || (n[a] = r[i].trim().replace(/\s+/g, " "));
  }
  return n;
}, PA = async ({ headers: r, body: e }, t) => {
  for (const n of Object.keys(r))
    if (n.toLowerCase() === iw)
      return r[n];
  if (e == null)
    return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
  if (typeof e == "string" || ArrayBuffer.isView(e) || EQ(e)) {
    const n = new t();
    return n.update(tg(e)), Rf(await n.digest());
  }
  return lJ;
}, mJ = (r, e) => {
  r = r.toLowerCase();
  for (const t of Object.keys(e))
    if (r === t.toLowerCase())
      return !0;
  return !1;
}, vJ = (r, e = {}) => {
  const { headers: t, query: n = {} } = Xs.clone(r);
  for (const i of Object.keys(t)) {
    const a = i.toLowerCase();
    (a.slice(0, 6) === "x-amz-" && !e.unhoistableHeaders?.has(a) || e.hoistableHeaders?.has(a)) && (n[i] = t[i], delete t[i]);
  }
  return {
    ...r,
    headers: t,
    query: n
  };
}, NT = (r) => {
  r = Xs.clone(r);
  for (const e of Object.keys(r.headers))
    tJ.indexOf(e.toLowerCase()) > -1 && delete r.headers[e];
  return r;
};
class LT extends pJ {
  headerFormatter = new QX();
  constructor({ applyChecksum: e, credentials: t, region: n, service: i, sha256: a, uriEscapePath: s = !0 }) {
    super({
      applyChecksum: e,
      credentials: t,
      region: n,
      service: i,
      sha256: a,
      uriEscapePath: s
    });
  }
  async presign(e, t = {}) {
    const { signingDate: n = /* @__PURE__ */ new Date(), expiresIn: i = 3600, unsignableHeaders: a, unhoistableHeaders: s, signableHeaders: o, hoistableHeaders: l, signingRegion: u, signingService: c } = t, h = await this.credentialProvider();
    this.validateResolvedCredentials(h);
    const f = u ?? await this.regionProvider(), { longDate: p, shortDate: m } = this.formatDate(n);
    if (i > cJ)
      return Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future");
    const A = IA(m, f, c ?? this.service), w = vJ(NT(e), { unhoistableHeaders: s, hoistableHeaders: l });
    h.sessionToken && (w.query[VR] = h.sessionToken), w.query[XX] = TA, w.query[JX] = `${h.accessKeyId}/${A}`, w.query[LR] = p, w.query[ZX] = i.toString(10);
    const x = MT(w, a, o);
    return w.query[KX] = this.getCanonicalHeaderList(x), w.query[UR] = await this.getSignature(p, A, this.getSigningKey(h, f, m, c), this.createCanonicalRequest(w, x, await PA(e, this.sha256))), w;
  }
  async sign(e, t) {
    return typeof e == "string" ? this.signString(e, t) : e.headers && e.payload ? this.signEvent(e, t) : e.message ? this.signMessage(e, t) : this.signRequest(e, t);
  }
  async signEvent({ headers: e, payload: t }, { signingDate: n = /* @__PURE__ */ new Date(), priorSignature: i, signingRegion: a, signingService: s, eventStreamCredentials: o }) {
    const l = a ?? await this.regionProvider(), { shortDate: u, longDate: c } = this.formatDate(n), h = IA(u, l, s ?? this.service), f = await PA({ headers: {}, body: t }, this.sha256), p = new this.sha256();
    p.update(e);
    const m = Rf(await p.digest()), A = [
      oJ,
      c,
      h,
      i,
      m,
      f
    ].join(`
`);
    return this.signString(A, {
      signingDate: n,
      signingRegion: l,
      signingService: s,
      eventStreamCredentials: o
    });
  }
  async signMessage(e, { signingDate: t = /* @__PURE__ */ new Date(), signingRegion: n, signingService: i, eventStreamCredentials: a }) {
    return this.signEvent({
      headers: this.headerFormatter.format(e.message.headers),
      payload: e.message.body
    }, {
      signingDate: t,
      signingRegion: n,
      signingService: i,
      priorSignature: e.priorSignature,
      eventStreamCredentials: a
    }).then((o) => ({ message: e.message, signature: o }));
  }
  async signString(e, { signingDate: t = /* @__PURE__ */ new Date(), signingRegion: n, signingService: i, eventStreamCredentials: a } = {}) {
    const s = a ?? await this.credentialProvider();
    this.validateResolvedCredentials(s);
    const o = n ?? await this.regionProvider(), { shortDate: l } = this.formatDate(t), u = new this.sha256(await this.getSigningKey(s, o, l, i));
    return u.update(tg(e)), Rf(await u.digest());
  }
  async signRequest(e, { signingDate: t = /* @__PURE__ */ new Date(), signableHeaders: n, unsignableHeaders: i, signingRegion: a, signingService: s } = {}) {
    const o = await this.credentialProvider();
    this.validateResolvedCredentials(o);
    const l = a ?? await this.regionProvider(), u = NT(e), { longDate: c, shortDate: h } = this.formatDate(t), f = IA(h, l, s ?? this.service);
    u.headers[zR] = c, o.sessionToken && (u.headers[nJ] = o.sessionToken);
    const p = await PA(u, this.sha256);
    !mJ(iw, u.headers) && this.applyChecksum && (u.headers[iw] = p);
    const m = MT(u, i, n), A = await this.getSignature(c, f, this.getSigningKey(o, l, h, s), this.createCanonicalRequest(u, m, p));
    return u.headers[$R] = `${TA} Credential=${o.accessKeyId}/${f}, SignedHeaders=${this.getCanonicalHeaderList(m)}, Signature=${A}`, u;
  }
  async getSignature(e, t, n, i) {
    const a = await this.createStringToSign(e, t, i, TA), s = new this.sha256(await n);
    return s.update(tg(a)), Rf(await s.digest());
  }
  getSigningKey(e, t, n, i) {
    return gJ(this.sha256, e, n, t, i || this.service);
  }
}
const yJ = (r) => {
  let e = r.credentials, t = !!r.credentials, n;
  Object.defineProperty(r, "credentials", {
    set(u) {
      u && u !== e && u !== n && (t = !0), e = u;
      const c = AJ(r, {
        credentials: e,
        credentialDefaultProvider: r.credentialDefaultProvider
      }), h = wJ(r, c);
      if (t && !h.attributed) {
        const f = typeof e == "object" && e !== null;
        n = async (p) => {
          const A = await h(p);
          return f && (!A.$source || Object.keys(A.$source).length === 0) ? Tq(A, "CREDENTIALS_CODE", "e") : A;
        }, n.memoized = h.memoized, n.configBound = h.configBound, n.attributed = !0;
      } else
        n = h;
    },
    get() {
      return n;
    },
    enumerable: !0,
    configurable: !0
  }), r.credentials = e;
  const { signingEscapePath: i = !0, systemClockOffset: a = r.systemClockOffset || 0, sha256: s } = r;
  let o;
  return r.signer ? o = Bp(r.signer) : r.regionInfoProvider ? o = () => Bp(r.region)().then(async (u) => [
    await r.regionInfoProvider(u, {
      useFipsEndpoint: await r.useFipsEndpoint(),
      useDualstackEndpoint: await r.useDualstackEndpoint()
    }) || {},
    u
  ]).then(([u, c]) => {
    const { signingRegion: h, signingService: f } = u;
    r.signingRegion = r.signingRegion || h || c, r.signingName = r.signingName || f || r.serviceId;
    const p = {
      ...r,
      credentials: r.credentials,
      region: r.signingRegion,
      service: r.signingName,
      sha256: s,
      uriEscapePath: i
    }, m = r.signerConstructor || LT;
    return new m(p);
  }) : o = async (u) => {
    u = Object.assign({}, {
      name: "sigv4",
      signingName: r.signingName || r.defaultSigningName,
      signingRegion: await Bp(r.region)(),
      properties: {}
    }, u);
    const c = u.signingRegion, h = u.signingName;
    r.signingRegion = r.signingRegion || c, r.signingName = r.signingName || h || r.serviceId;
    const f = {
      ...r,
      credentials: r.credentials,
      region: r.signingRegion,
      service: r.signingName,
      sha256: s,
      uriEscapePath: i
    }, p = r.signerConstructor || LT;
    return new p(f);
  }, Object.assign(r, {
    systemClockOffset: a,
    signingEscapePath: i,
    signer: o
  });
};
function AJ(r, { credentials: e, credentialDefaultProvider: t }) {
  let n;
  return e ? e?.memoized ? n = e : n = gX(e, pX, OR) : t ? n = Bp(t(Object.assign({}, r, {
    parentClientConfig: r
  }))) : n = async () => {
    throw new Error("@aws-sdk/core::resolveAwsSdkSigV4Config - `credentials` not provided and no credentialDefaultProvider was configured.");
  }, n.memoized = !0, n;
}
function wJ(r, e) {
  if (e.configBound)
    return e;
  const t = async (n) => e({ ...n, callerClientConfig: r });
  return t.memoized = e.memoized, t.configBound = !0, t;
}
const xJ = async (r, e, t) => ({
  operation: lh(e).operation,
  region: await ku(r.region)() || (() => {
    throw new Error("expected `region` to be configured for `aws.auth#sigv4`");
  })()
});
function bJ(r) {
  return {
    schemeId: "aws.auth#sigv4",
    signingProperties: {
      name: "cognito-idp",
      region: r.region
    },
    propertiesExtractor: (e, t) => ({
      signingProperties: {
        config: e,
        context: t
      }
    })
  };
}
function Ln(r) {
  return {
    schemeId: "smithy.api#noAuth"
  };
}
const CJ = (r) => {
  const e = [];
  switch (r.operation) {
    case "AssociateSoftwareToken": {
      e.push(Ln());
      break;
    }
    case "ChangePassword": {
      e.push(Ln());
      break;
    }
    case "CompleteWebAuthnRegistration": {
      e.push(Ln());
      break;
    }
    case "ConfirmDevice": {
      e.push(Ln());
      break;
    }
    case "ConfirmForgotPassword": {
      e.push(Ln());
      break;
    }
    case "ConfirmSignUp": {
      e.push(Ln());
      break;
    }
    case "DeleteUser": {
      e.push(Ln());
      break;
    }
    case "DeleteUserAttributes": {
      e.push(Ln());
      break;
    }
    case "DeleteWebAuthnCredential": {
      e.push(Ln());
      break;
    }
    case "ForgetDevice": {
      e.push(Ln());
      break;
    }
    case "ForgotPassword": {
      e.push(Ln());
      break;
    }
    case "GetDevice": {
      e.push(Ln());
      break;
    }
    case "GetTokensFromRefreshToken": {
      e.push(Ln());
      break;
    }
    case "GetUser": {
      e.push(Ln());
      break;
    }
    case "GetUserAttributeVerificationCode": {
      e.push(Ln());
      break;
    }
    case "GetUserAuthFactors": {
      e.push(Ln());
      break;
    }
    case "GlobalSignOut": {
      e.push(Ln());
      break;
    }
    case "InitiateAuth": {
      e.push(Ln());
      break;
    }
    case "ListDevices": {
      e.push(Ln());
      break;
    }
    case "ListWebAuthnCredentials": {
      e.push(Ln());
      break;
    }
    case "ResendConfirmationCode": {
      e.push(Ln());
      break;
    }
    case "RespondToAuthChallenge": {
      e.push(Ln());
      break;
    }
    case "RevokeToken": {
      e.push(Ln());
      break;
    }
    case "SetUserMFAPreference": {
      e.push(Ln());
      break;
    }
    case "SetUserSettings": {
      e.push(Ln());
      break;
    }
    case "SignUp": {
      e.push(Ln());
      break;
    }
    case "StartWebAuthnRegistration": {
      e.push(Ln());
      break;
    }
    case "UpdateAuthEventFeedback": {
      e.push(Ln());
      break;
    }
    case "UpdateDeviceStatus": {
      e.push(Ln());
      break;
    }
    case "UpdateUserAttributes": {
      e.push(Ln());
      break;
    }
    case "VerifySoftwareToken": {
      e.push(Ln());
      break;
    }
    case "VerifyUserAttribute": {
      e.push(Ln());
      break;
    }
    default:
      e.push(bJ(r));
  }
  return e;
}, SJ = (r) => {
  const e = yJ(r);
  return Object.assign(e, {
    authSchemePreference: ku(r.authSchemePreference ?? [])
  });
}, EJ = (r) => Object.assign(r, {
  useDualstackEndpoint: r.useDualstackEndpoint ?? !1,
  useFipsEndpoint: r.useFipsEndpoint ?? !1,
  defaultSigningName: "cognito-idp"
}), HR = {
  UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
  Endpoint: { type: "builtInParams", name: "endpoint" },
  Region: { type: "builtInParams", name: "region" },
  UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" }
}, kJ = "3.1075.0", TJ = {
  version: kJ
}, FJ = (r) => new TextEncoder().encode(r);
var IJ = typeof Buffer < "u" && Buffer.from ? function(r) {
  return Buffer.from(r, "utf8");
} : FJ;
function rg(r) {
  return r instanceof Uint8Array ? r : typeof r == "string" ? IJ(r) : ArrayBuffer.isView(r) ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(r);
}
function aw(r) {
  return typeof r == "string" ? r.length === 0 : r.byteLength === 0;
}
var WR = { name: "SHA-256" }, UT = {
  name: "HMAC",
  hash: WR
}, PJ = new Uint8Array([
  227,
  176,
  196,
  66,
  152,
  252,
  28,
  20,
  154,
  251,
  244,
  200,
  153,
  111,
  185,
  36,
  39,
  174,
  65,
  228,
  100,
  155,
  147,
  76,
  164,
  149,
  153,
  27,
  120,
  82,
  184,
  85
]);
const DJ = {};
function i0() {
  return typeof window < "u" ? window : typeof self < "u" ? self : DJ;
}
var RJ = (
  /** @class */
  (function() {
    function r(e) {
      this.toHash = new Uint8Array(0), this.secret = e, this.reset();
    }
    return r.prototype.update = function(e) {
      if (!aw(e)) {
        var t = rg(e), n = new Uint8Array(this.toHash.byteLength + t.byteLength);
        n.set(this.toHash, 0), n.set(t, this.toHash.byteLength), this.toHash = n;
      }
    }, r.prototype.digest = function() {
      var e = this;
      return this.key ? this.key.then(function(t) {
        return i0().crypto.subtle.sign(UT, t, e.toHash).then(function(n) {
          return new Uint8Array(n);
        });
      }) : aw(this.toHash) ? Promise.resolve(PJ) : Promise.resolve().then(function() {
        return i0().crypto.subtle.digest(WR, e.toHash);
      }).then(function(t) {
        return Promise.resolve(new Uint8Array(t));
      });
    }, r.prototype.reset = function() {
      var e = this;
      this.toHash = new Uint8Array(0), this.secret && this.secret !== void 0 && (this.key = new Promise(function(t, n) {
        i0().crypto.subtle.importKey("raw", rg(e.secret), UT, !1, ["sign"]).then(t, n);
      }), this.key.catch(function() {
      }));
    }, r;
  })()
), wo = 64, OJ = 32, BJ = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), _J = [
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
], MJ = Math.pow(2, 53) - 1, a0 = (
  /** @class */
  (function() {
    function r() {
      this.state = Int32Array.from(_J), this.temp = new Int32Array(64), this.buffer = new Uint8Array(64), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1;
    }
    return r.prototype.update = function(e) {
      if (this.finished)
        throw new Error("Attempted to update an already finished hash.");
      var t = 0, n = e.byteLength;
      if (this.bytesHashed += n, this.bytesHashed * 8 > MJ)
        throw new Error("Cannot hash more than 2^53 - 1 bits");
      for (; n > 0; )
        this.buffer[this.bufferLength++] = e[t++], n--, this.bufferLength === wo && (this.hashBuffer(), this.bufferLength = 0);
    }, r.prototype.digest = function() {
      if (!this.finished) {
        var e = this.bytesHashed * 8, t = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), n = this.bufferLength;
        if (t.setUint8(this.bufferLength++, 128), n % wo >= wo - 8) {
          for (var i = this.bufferLength; i < wo; i++)
            t.setUint8(i, 0);
          this.hashBuffer(), this.bufferLength = 0;
        }
        for (var i = this.bufferLength; i < wo - 8; i++)
          t.setUint8(i, 0);
        t.setUint32(wo - 8, Math.floor(e / 4294967296), !0), t.setUint32(wo - 4, e), this.hashBuffer(), this.finished = !0;
      }
      for (var a = new Uint8Array(OJ), i = 0; i < 8; i++)
        a[i * 4] = this.state[i] >>> 24 & 255, a[i * 4 + 1] = this.state[i] >>> 16 & 255, a[i * 4 + 2] = this.state[i] >>> 8 & 255, a[i * 4 + 3] = this.state[i] >>> 0 & 255;
      return a;
    }, r.prototype.hashBuffer = function() {
      for (var e = this, t = e.buffer, n = e.state, i = n[0], a = n[1], s = n[2], o = n[3], l = n[4], u = n[5], c = n[6], h = n[7], f = 0; f < wo; f++) {
        if (f < 16)
          this.temp[f] = (t[f * 4] & 255) << 24 | (t[f * 4 + 1] & 255) << 16 | (t[f * 4 + 2] & 255) << 8 | t[f * 4 + 3] & 255;
        else {
          var p = this.temp[f - 2], m = (p >>> 17 | p << 15) ^ (p >>> 19 | p << 13) ^ p >>> 10;
          p = this.temp[f - 15];
          var A = (p >>> 7 | p << 25) ^ (p >>> 18 | p << 14) ^ p >>> 3;
          this.temp[f] = (m + this.temp[f - 7] | 0) + (A + this.temp[f - 16] | 0);
        }
        var w = (((l >>> 6 | l << 26) ^ (l >>> 11 | l << 21) ^ (l >>> 25 | l << 7)) + (l & u ^ ~l & c) | 0) + (h + (BJ[f] + this.temp[f] | 0) | 0) | 0, x = ((i >>> 2 | i << 30) ^ (i >>> 13 | i << 19) ^ (i >>> 22 | i << 10)) + (i & a ^ i & s ^ a & s) | 0;
        h = c, c = u, u = l, l = o + w | 0, o = s, s = a, a = i, i = w + x | 0;
      }
      n[0] += i, n[1] += a, n[2] += s, n[3] += o, n[4] += l, n[5] += u, n[6] += c, n[7] += h;
    }, r;
  })()
), NJ = (
  /** @class */
  (function() {
    function r(e) {
      this.secret = e, this.hash = new a0(), this.reset();
    }
    return r.prototype.update = function(e) {
      if (!(aw(e) || this.error))
        try {
          this.hash.update(rg(e));
        } catch (t) {
          this.error = t;
        }
    }, r.prototype.digestSync = function() {
      if (this.error)
        throw this.error;
      return this.outer ? (this.outer.finished || this.outer.update(this.hash.digest()), this.outer.digest()) : this.hash.digest();
    }, r.prototype.digest = function() {
      return Il(this, void 0, void 0, function() {
        return Pl(this, function(e) {
          return [2, this.digestSync()];
        });
      });
    }, r.prototype.reset = function() {
      if (this.hash = new a0(), this.secret) {
        this.outer = new a0();
        var e = LJ(this.secret), t = new Uint8Array(wo);
        t.set(e);
        for (var n = 0; n < wo; n++)
          e[n] ^= 54, t[n] ^= 92;
        this.hash.update(e), this.outer.update(t);
        for (var n = 0; n < e.byteLength; n++)
          e[n] = 0;
      }
    }, r;
  })()
);
function LJ(r) {
  var e = rg(r);
  if (e.byteLength > wo) {
    var t = new a0();
    t.update(e), e = t.digest();
  }
  var n = new Uint8Array(wo);
  return n.set(e), n;
}
var UJ = [
  "decrypt",
  "digest",
  "encrypt",
  "exportKey",
  "generateKey",
  "importKey",
  "sign",
  "verify"
];
function VJ(r) {
  if ($J(r) && typeof r.crypto.subtle == "object") {
    var e = r.crypto.subtle;
    return zJ(e);
  }
  return !1;
}
function $J(r) {
  if (typeof r == "object" && typeof r.crypto == "object") {
    var e = r.crypto.getRandomValues;
    return typeof e == "function";
  }
  return !1;
}
function zJ(r) {
  return r && UJ.every(function(e) {
    return typeof r[e] == "function";
  });
}
var GJ = (
  /** @class */
  (function() {
    function r(e) {
      VJ(i0()) ? this.hash = new RJ(e) : this.hash = new NJ(e);
    }
    return r.prototype.update = function(e, t) {
      this.hash.update(rg(e));
    }, r.prototype.digest = function() {
      return this.hash.digest();
    }, r.prototype.reset = function() {
      this.hash.reset();
    }, r;
  })()
);
function VT(r, e) {
  return new Request(r, e);
}
function HJ(r = 0) {
  return new Promise((e, t) => {
    r && setTimeout(() => {
      const n = new Error(`Request did not complete within ${r} ms`);
      n.name = "TimeoutError", t(n);
    }, r);
  });
}
const DA = {
  supported: void 0
};
class Tx {
  config;
  configProvider;
  static create(e) {
    return typeof e?.handle == "function" ? e : new Tx(e);
  }
  constructor(e) {
    typeof e == "function" ? this.configProvider = e().then((t) => t || {}) : (this.config = e ?? {}, this.configProvider = Promise.resolve(this.config)), DA.supported === void 0 && (DA.supported = typeof Request < "u" && "keepalive" in VT("https://[::1]"));
  }
  destroy() {
  }
  async handle(e, { abortSignal: t, requestTimeout: n } = {}) {
    this.config || (this.config = await this.configProvider);
    const i = n ?? this.config.requestTimeout, a = this.config.keepAlive === !0, s = this.config.credentials;
    if (t?.aborted) {
      const E = $T(t);
      return Promise.reject(E);
    }
    let o = e.path;
    const l = AY(e.query || {});
    l && (o += `?${l}`), e.fragment && (o += `#${e.fragment}`);
    let u = "";
    if (e.username != null || e.password != null) {
      const E = e.username ?? "", T = e.password ?? "";
      u = `${E}:${T}@`;
    }
    const { port: c, method: h } = e, f = `${e.protocol}//${u}${e.hostname}${c ? `:${c}` : ""}${o}`, p = h === "GET" || h === "HEAD" ? void 0 : e.body, m = {
      body: p,
      headers: new Headers(e.headers),
      method: h,
      credentials: s
    };
    this.config?.cache && (m.cache = this.config.cache), p && (m.duplex = "half"), typeof AbortController < "u" && (m.signal = t), DA.supported && (m.keepalive = a), typeof this.config.requestInit == "function" && Object.assign(m, this.config.requestInit(e));
    let A = () => {
    };
    const w = VT(f, m), x = [
      fetch(w).then((E) => {
        const T = E.headers, D = {};
        for (const _ of T.entries())
          D[_[0]] = _[1];
        return E.body != null ? {
          response: new jd({
            headers: D,
            reason: E.statusText,
            statusCode: E.status,
            body: E.body
          })
        } : E.blob().then((_) => ({
          response: new jd({
            headers: D,
            reason: E.statusText,
            statusCode: E.status,
            body: _
          })
        }));
      }),
      HJ(i)
    ];
    return t && x.push(new Promise((E, T) => {
      const D = () => {
        const F = $T(t);
        T(F);
      };
      if (typeof t.addEventListener == "function") {
        const F = t;
        F.addEventListener("abort", D, { once: !0 }), A = () => F.removeEventListener("abort", D);
      } else
        t.onabort = D;
    })), Promise.race(x).finally(A);
  }
  updateHttpClientConfig(e, t) {
    this.config = void 0, this.configProvider = this.configProvider.then((n) => (n[e] = t, n));
  }
  httpHandlerConfigs() {
    return this.config ?? {};
  }
}
function $T(r) {
  const e = r && typeof r == "object" && "reason" in r ? r.reason : void 0;
  if (e) {
    if (e instanceof Error) {
      const i = new Error("Request aborted");
      return i.name = "AbortError", i.cause = e, i;
    }
    const n = new Error(String(e));
    return n.name = "AbortError", n;
  }
  const t = new Error("Request aborted");
  return t.name = "AbortError", t;
}
const WJ = async (r) => typeof Blob == "function" && r instanceof Blob || r.constructor?.name === "Blob" ? Blob.prototype.arrayBuffer !== void 0 ? new Uint8Array(await r.arrayBuffer()) : jJ(r) : qJ(r);
async function jJ(r) {
  const e = await QJ(r), t = Z0(e);
  return new Uint8Array(t);
}
async function qJ(r) {
  const e = [], t = r.getReader();
  let n = !1, i = 0;
  for (; !n; ) {
    const { done: o, value: l } = await t.read();
    l && (e.push(l), i += l.length), n = o;
  }
  const a = new Uint8Array(i);
  let s = 0;
  for (const o of e)
    a.set(o, s), s += o.length;
  return a;
}
function QJ(r) {
  return new Promise((e, t) => {
    const n = new FileReader();
    n.onloadend = () => {
      if (n.readyState !== 2)
        return t(new Error("Reader aborted too early"));
      const i = n.result ?? "", a = i.indexOf(","), s = a > -1 ? a + 1 : i.length;
      e(i.substring(s));
    }, n.onabort = () => t(new Error("Read aborted")), n.onerror = () => t(n.error), n.readAsDataURL(r);
  });
}
class YJ {
  queryCompat;
  errorRegistry;
  constructor(e = !1) {
    this.queryCompat = e;
  }
  resolveRestContentType(e, t) {
    const n = t.getMemberSchemas(), i = Object.values(n).find((a) => !!a.getMergedTraits().httpPayload);
    if (i) {
      const a = i.getMergedTraits().mediaType;
      return a || (i.isStringSchema() ? "text/plain" : i.isBlobSchema() ? "application/octet-stream" : e);
    } else if (!t.isUnitSchema() && Object.values(n).find((s) => {
      const { httpQuery: o, httpQueryParams: l, httpHeader: u, httpLabel: c, httpPrefixHeaders: h } = s.getMergedTraits();
      return !o && !l && !u && !c && h === void 0;
    }))
      return e;
  }
  async getErrorSchemaOrThrowBaseException(e, t, n, i, a, s) {
    let o = e;
    e.includes("#") && ([, o] = e.split("#"));
    const l = {
      $metadata: a,
      $fault: n.statusCode < 500 ? "client" : "server"
    };
    if (!this.errorRegistry)
      throw new Error("@aws-sdk/core/protocols - error handler not initialized.");
    try {
      return { errorSchema: s?.(this.errorRegistry, o) ?? this.errorRegistry.getSchema(e), errorMetadata: l };
    } catch {
      i.message = i.message ?? i.Message ?? "UnknownError";
      const c = this.errorRegistry, h = c.getBaseException();
      if (h) {
        const m = c.getErrorCtor(h) ?? Error;
        throw this.decorateServiceException(Object.assign(new m({ name: o }), l), i);
      }
      const f = i, p = f?.message ?? f?.Message ?? f?.Error?.Message ?? f?.Error?.message;
      throw this.decorateServiceException(Object.assign(new Error(p), {
        name: o
      }, l), i);
    }
  }
  compose(e, t, n) {
    let i = n;
    t.includes("#") && ([i] = t.split("#"));
    const a = qs.for(i), s = qs.for("smithy.ts.sdk.synthetic." + n);
    e.copyFrom(a), e.copyFrom(s), this.errorRegistry = e;
  }
  decorateServiceException(e, t = {}) {
    if (this.queryCompat) {
      const n = e.Message ?? t.Message, i = gT(e, t);
      n && (i.message = n);
      const a = i.Error ?? {};
      a.Type = i.Error?.Type, a.Code = i.Error?.Code, a.Message = i.Error?.message ?? i.Error?.Message ?? n, i.Error = a;
      const s = i.$metadata.requestId;
      return s && (i.RequestId = s), i;
    }
    return gT(e, t);
  }
  setQueryCompatError(e, t) {
    const n = t.headers?.["x-amzn-query-error"];
    if (e !== void 0 && n != null) {
      const [i, a] = n.split(";"), s = Object.keys(e), o = {
        Code: i,
        Type: a
      };
      e.Code = i, e.Type = a;
      for (let l = 0; l < s.length; l++) {
        const u = s[l];
        o[u === "message" ? "Message" : u] = e[u];
      }
      delete o.__type, e.Error = o;
    }
  }
  queryCompatOutput(e, t) {
    e.Error && (t.Error = e.Error), e.Type && (t.Type = e.Type), e.Code && (t.Code = e.Code);
  }
  findQueryCompatibleError(e, t) {
    try {
      return e.getSchema(t);
    } catch {
      return e.find((i) => Ca.of(i).getMergedTraits().awsQueryError?.[0] === t);
    }
  }
}
class Fx {
  serdeContext;
  setSerdeContext(e) {
    this.serdeContext = e;
  }
}
class XJ {
  from;
  to;
  keys;
  constructor(e, t) {
    this.from = e, this.to = t;
    const n = Object.keys(this.from), i = new Set(n);
    i.delete("__type"), this.keys = i;
  }
  mark(e) {
    this.keys.delete(e);
  }
  hasUnknown() {
    return this.keys.size === 1 && Object.keys(this.to).length === 0;
  }
  writeUnknown() {
    if (this.hasUnknown()) {
      const e = this.keys.values().next().value, t = this.from[e];
      this.to.$unknown = [e, t];
    }
  }
}
function JJ(r, e, t) {
  if (t?.source) {
    const n = t.source;
    if (typeof e == "number" && (e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER || n !== String(e)))
      return n.includes(".") ? new Ol(n, "bigDecimal") : BigInt(n);
  }
  return e;
}
const KJ = (r, e) => rw(r, e).then((t) => (e?.utf8Encoder ?? wx)(t)), ZJ = (r, e) => KJ(r, e).then((t) => {
  if (t.length)
    try {
      return JSON.parse(t);
    } catch (n) {
      throw n?.name === "SyntaxError" && Object.defineProperty(n, "$responseBodyText", {
        value: t
      }), n;
    }
  return {};
}), zT = (r, e) => Object.keys(r).find((t) => t.toLowerCase() === e.toLowerCase()), RA = (r) => {
  let e = r;
  return typeof e == "number" && (e = e.toString()), e.indexOf(",") >= 0 && (e = e.split(",")[0]), e.indexOf(":") >= 0 && (e = e.split(":")[0]), e.indexOf("#") >= 0 && (e = e.split("#")[1]), e;
}, eK = (r, e, t = !1) => tK(r, e, t ? ["code", "header", "type"] : ["type", "code", "header"]), tK = ({ headers: r }, e, t) => {
  for (; t.length > 0; )
    switch (t.shift()) {
      case "header":
        const i = zT(r ?? {}, "x-amzn-errortype");
        if (i !== void 0)
          return RA(r[i]);
        break;
      case "code":
        const a = zT(e ?? {}, "code");
        if (a && e[a] !== void 0)
          return RA(e[a]);
        break;
      case "type":
        if (e?.__type !== void 0)
          return RA(e.__type);
        break;
    }
};
class rK extends Fx {
  settings;
  constructor(e) {
    super(), this.settings = e;
  }
  async read(e, t) {
    return this._read(e, typeof t == "string" ? JSON.parse(t, JJ) : await ZJ(t, this.serdeContext));
  }
  readObject(e, t) {
    return this._read(e, t);
  }
  _read(e, t) {
    const n = t !== null && typeof t == "object", i = Ca.of(e);
    if (n) {
      if (i.isStructSchema()) {
        const s = t, o = i.isUnionSchema(), l = {};
        let u;
        const { jsonName: c } = this.settings;
        c && (u = {});
        let h;
        o && (h = new XJ(s, l));
        for (const [f, p] of i.structIterator()) {
          let m = f;
          c && (m = p.getMergedTraits().jsonName ?? m, u[m] = f), o && h.mark(m), s[m] != null && (l[f] = this._read(p, s[m]));
        }
        if (o)
          h.writeUnknown();
        else if (typeof s.__type == "string")
          for (const f in s) {
            const p = s[f], m = c ? u[f] ?? f : f;
            m in l || (l[m] = p);
          }
        return l;
      }
      if (Array.isArray(t) && i.isListSchema()) {
        const s = i.getValueSchema(), o = [];
        for (const l of t)
          o.push(this._read(s, l));
        return o;
      }
      if (i.isMapSchema()) {
        const s = i.getValueSchema(), o = {};
        for (const l in t)
          o[l] = this._read(s, t[l]);
        return o;
      }
    }
    if (i.isBlobSchema() && typeof t == "string")
      return Z0(t);
    const a = i.getMergedTraits().mediaType;
    if (i.isStringSchema() && typeof t == "string" && a)
      return a === "application/json" || a.endsWith("+json") ? xc.from(t) : t;
    if (i.isTimestampSchema() && t != null)
      switch (PR(i, this.settings)) {
        case 5:
          return cQ(t);
        case 6:
          return vR(t);
        case 7:
          return pQ(t);
        default:
          return console.warn("Missing timestamp format, parsing value with Date constructor:", t), new Date(t);
      }
    if (i.isBigIntegerSchema() && (typeof t == "number" || typeof t == "string"))
      return BigInt(t);
    if (i.isBigDecimalSchema() && t != null) {
      if (t instanceof Ol)
        return t;
      const s = t;
      return s.type === "bigDecimal" && "string" in s ? new Ol(s.string, s.type) : new Ol(String(t), "bigDecimal");
    }
    if (i.isNumericSchema() && typeof t == "string") {
      switch (t) {
        case "Infinity":
          return 1 / 0;
        case "-Infinity":
          return -1 / 0;
        case "NaN":
          return NaN;
      }
      return t;
    }
    if (i.isDocumentSchema())
      if (n) {
        const s = Array.isArray(t) ? [] : {};
        for (const o in t) {
          const l = t[o];
          l instanceof Ol ? s[o] = l : s[o] = this._read(i, l);
        }
        return s;
      } else
        return structuredClone(t);
    return t;
  }
}
const GT = "Ν";
class nK {
  values = /* @__PURE__ */ new Map();
  counter = 0;
  stage = 0;
  createReplacer() {
    if (this.stage === 1)
      throw new Error("@aws-sdk/core/protocols - JsonReplacer already created.");
    if (this.stage === 2)
      throw new Error("@aws-sdk/core/protocols - JsonReplacer exhausted.");
    return this.stage = 1, (e, t) => {
      if (t instanceof Ol) {
        const n = `${GT + "nv" + this.counter++}_` + t.string;
        return this.values.set(`"${n}"`, t.string), n;
      }
      if (typeof t == "bigint") {
        const n = t.toString(), i = `${GT + "b" + this.counter++}_` + n;
        return this.values.set(`"${i}"`, n), i;
      }
      return t;
    };
  }
  replaceInJson(e) {
    if (this.stage === 0)
      throw new Error("@aws-sdk/core/protocols - JsonReplacer not created yet.");
    if (this.stage === 2)
      throw new Error("@aws-sdk/core/protocols - JsonReplacer exhausted.");
    if (this.stage = 2, this.counter === 0)
      return e;
    for (const [t, n] of this.values)
      e = e.replace(t, n);
    return e;
  }
}
class iK extends Fx {
  settings;
  buffer;
  useReplacer = !1;
  rootSchema;
  constructor(e) {
    super(), this.settings = e;
  }
  write(e, t) {
    this.rootSchema = Ca.of(e), this.buffer = this._write(this.rootSchema, t);
  }
  flush() {
    const { rootSchema: e, useReplacer: t } = this;
    if (this.rootSchema = void 0, this.useReplacer = !1, e?.isStructSchema() || e?.isDocumentSchema()) {
      if (!t)
        return JSON.stringify(this.buffer);
      const n = new nK();
      return n.replaceInJson(JSON.stringify(this.buffer, n.createReplacer(), 0));
    }
    return this.buffer;
  }
  writeDiscriminatedDocument(e, t) {
    this.write(e, t), typeof this.buffer == "object" && (this.buffer.__type = Ca.of(e).getName(!0));
  }
  _write(e, t, n) {
    const i = t !== null && typeof t == "object", a = Ca.of(e);
    if (i) {
      if (a.isStructSchema()) {
        const s = t, o = {}, { jsonName: l } = this.settings;
        let u;
        l && (u = {});
        let c = 0;
        for (const [h, f] of a.structIterator()) {
          const p = this._write(f, s[h], a);
          if (p !== void 0) {
            let m = h;
            l && (m = f.getMergedTraits().jsonName ?? h, u[h] = m), o[m] = p, c++;
          }
        }
        if (a.isUnionSchema() && c === 0) {
          const { $unknown: h } = s;
          if (Array.isArray(h)) {
            const [f, p] = h;
            o[f] = this._write(15, p);
          }
        } else if (typeof s.__type == "string")
          for (const h in s) {
            const f = s[h], p = l ? u[h] ?? h : h;
            p in o || (o[p] = this._write(15, f));
          }
        return o;
      }
      if (Array.isArray(t) && a.isListSchema()) {
        const s = a.getValueSchema(), o = [], l = !!a.getMergedTraits().sparse;
        for (const u of t)
          (l || u != null) && o.push(this._write(s, u));
        return o;
      }
      if (a.isMapSchema()) {
        const s = a.getValueSchema(), o = {}, l = !!a.getMergedTraits().sparse;
        for (const u in t) {
          const c = t[u];
          (l || c != null) && (o[u] = this._write(s, c));
        }
        return o;
      }
      if (t instanceof Uint8Array && (a.isBlobSchema() || a.isDocumentSchema()))
        return a === this.rootSchema ? t : (this.serdeContext?.base64Encoder ?? I0)(t);
      if (t instanceof Date && (a.isTimestampSchema() || a.isDocumentSchema()))
        switch (PR(a, this.settings)) {
          case 5:
            return t.toISOString().replace(".000Z", "Z");
          case 6:
            return lQ(t);
          case 7:
            return t.getTime() / 1e3;
          default:
            return console.warn("Missing timestamp format, using epoch seconds", t), t.getTime() / 1e3;
        }
      t instanceof Ol && (this.useReplacer = !0);
    }
    if (!(t === null && n?.isStructSchema())) {
      if (a.isStringSchema()) {
        if (typeof t > "u" && a.isIdempotencyToken())
          return uY();
        const s = a.getMergedTraits().mediaType;
        return t != null && s && (s === "application/json" || s.endsWith("+json")) ? xc.from(t) : t;
      }
      if (typeof t == "number" && a.isNumericSchema())
        return Math.abs(t) === 1 / 0 || isNaN(t) ? String(t) : t;
      if (typeof t == "string" && a.isBlobSchema())
        return a === this.rootSchema ? t : (this.serdeContext?.base64Encoder ?? I0)(t);
      if (typeof t == "bigint" && (this.useReplacer = !0), a.isDocumentSchema())
        if (i) {
          const s = Array.isArray(t) ? [] : {};
          for (const o in t) {
            const l = t[o];
            l instanceof Ol ? (this.useReplacer = !0, s[o] = l) : s[o] = this._write(a, l);
          }
          return s;
        } else
          return structuredClone(t);
      return t;
    }
  }
}
class aK extends Fx {
  settings;
  constructor(e) {
    super(), this.settings = e;
  }
  createSerializer() {
    const e = new iK(this.settings);
    return e.setSerdeContext(this.serdeContext), e;
  }
  createDeserializer() {
    const e = new rK(this.settings);
    return e.setSerdeContext(this.serdeContext), e;
  }
}
class sK extends dY {
  serializer;
  deserializer;
  serviceTarget;
  codec;
  mixin;
  awsQueryCompatible;
  constructor({ defaultNamespace: e, errorTypeRegistries: t, serviceTarget: n, awsQueryCompatible: i, jsonCodec: a }) {
    super({
      defaultNamespace: e,
      errorTypeRegistries: t
    }), this.serviceTarget = n, this.codec = a ?? new aK({
      timestampFormat: {
        useTrait: !0,
        default: 7
      },
      jsonName: !1
    }), this.serializer = this.codec.createSerializer(), this.deserializer = this.codec.createDeserializer(), this.awsQueryCompatible = !!i, this.mixin = new YJ(this.awsQueryCompatible);
  }
  async serializeRequest(e, t, n) {
    const i = await super.serializeRequest(e, t, n);
    return i.path.endsWith("/") || (i.path += "/"), i.headers["content-type"] = `application/x-amz-json-${this.getJsonRpcVersion()}`, i.headers["x-amz-target"] = `${this.serviceTarget}.${e.name}`, this.awsQueryCompatible && (i.headers["x-amzn-query-mode"] = "true"), (t0(e.input) === "unit" || !i.body) && (i.body = "{}"), i;
  }
  getPayloadCodec() {
    return this.codec;
  }
  async handleError(e, t, n, i, a) {
    const { awsQueryCompatible: s } = this;
    s && this.mixin.setQueryCompatError(i, n);
    const o = eK(n, i, s) ?? "Unknown";
    this.mixin.compose(this.compositeErrorRegistry, o, this.options.defaultNamespace);
    const { errorSchema: l, errorMetadata: u } = await this.mixin.getErrorSchemaOrThrowBaseException(o, this.options.defaultNamespace, n, i, a, s ? this.mixin.findQueryCompatibleError : void 0), c = Ca.of(l), h = i.message ?? i.Message ?? "UnknownError", f = this.compositeErrorRegistry.getErrorCtor(l) ?? Error, p = new f({}), m = {}, A = this.codec.createDeserializer();
    for (const [w, x] of c.structIterator())
      i[w] != null && (m[w] = A.readObject(x, i[w]));
    throw s && this.mixin.queryCompatOutput(i, m), this.mixin.decorateServiceException(Object.assign(p, u, {
      $fault: c.getMergedTraits().error,
      message: h
    }, m), i);
  }
}
class oK extends sK {
  constructor({ defaultNamespace: e, errorTypeRegistries: t, serviceTarget: n, awsQueryCompatible: i, jsonCodec: a }) {
    super({
      defaultNamespace: e,
      errorTypeRegistries: t,
      serviceTarget: n,
      awsQueryCompatible: i,
      jsonCodec: a
    });
  }
  getShapeId() {
    return "aws.protocols#awsJson1_1";
  }
  getJsonRpcVersion() {
    return "1.1";
  }
  getDefaultContentType() {
    return "application/x-amz-json-1.1";
  }
}
const ng = "ref", bf = -1, Pm = !0, HT = "isSet", jR = "PartitionResult", Dm = "booleanEquals", OA = "getAttr", lp = "stringEquals", WT = { [ng]: "Endpoint" }, BA = { [ng]: jR }, Ep = { [ng]: "Region" }, Sl = {}, jT = [Ep], qT = {
  conditions: [
    [HT, [WT]],
    [HT, jT],
    ["aws.partition", jT, jR],
    [Dm, [{ [ng]: "UseFIPS" }, Pm]],
    [Dm, [{ fn: OA, argv: [BA, "supportsFIPS"] }, Pm]],
    [Dm, [{ [ng]: "UseDualStack" }, Pm]],
    [Dm, [{ fn: OA, argv: [BA, "supportsDualStack"] }, Pm]],
    [lp, [{ fn: OA, argv: [BA, "name"] }, "aws"]],
    [lp, [Ep, "us-east-1"]],
    [lp, [Ep, "us-east-2"]],
    [lp, [Ep, "us-west-1"]],
    [lp, [Ep, "us-west-2"]]
  ],
  results: [
    [bf],
    [bf, "Invalid Configuration: FIPS and custom endpoint are not supported"],
    [bf, "Invalid Configuration: Dualstack and custom endpoint are not supported"],
    [WT, Sl],
    ["https://cognito-idp-fips.us-east-1.amazonaws.com", Sl],
    ["https://cognito-idp-fips.us-east-2.amazonaws.com", Sl],
    ["https://cognito-idp-fips.us-west-1.amazonaws.com", Sl],
    ["https://cognito-idp-fips.us-west-2.amazonaws.com", Sl],
    ["https://cognito-idp-fips.{Region}.{PartitionResult#dualStackDnsSuffix}", Sl],
    [bf, "FIPS and DualStack are enabled, but this partition does not support one or both"],
    ["https://cognito-idp-fips.{Region}.{PartitionResult#dnsSuffix}", Sl],
    [bf, "FIPS is enabled but this partition does not support FIPS"],
    ["https://cognito-idp.{Region}.amazonaws.com", Sl],
    ["https://cognito-idp.{Region}.{PartitionResult#dualStackDnsSuffix}", Sl],
    [bf, "DualStack is enabled but this partition does not support DualStack"],
    ["https://cognito-idp.{Region}.{PartitionResult#dnsSuffix}", Sl],
    [bf, "Invalid Configuration: Missing Region"]
  ]
}, lK = 2, xa = 1e8, uK = new Int32Array([
  -1,
  1,
  -1,
  0,
  17,
  3,
  1,
  4,
  xa + 16,
  2,
  5,
  xa + 16,
  3,
  9,
  6,
  5,
  7,
  xa + 15,
  6,
  8,
  xa + 14,
  7,
  xa + 12,
  xa + 13,
  4,
  11,
  10,
  5,
  xa + 9,
  xa + 11,
  5,
  12,
  xa + 10,
  6,
  13,
  xa + 9,
  8,
  xa + 4,
  14,
  9,
  xa + 5,
  15,
  10,
  xa + 6,
  16,
  11,
  xa + 7,
  xa + 8,
  3,
  xa + 1,
  18,
  5,
  xa + 2,
  xa + 3
]), cK = bx.from(uK, lK, qT.conditions, qT.results), fK = new $Q({
  size: 50,
  params: ["Endpoint", "Region", "UseDualStack", "UseFIPS"]
}), dK = (r, e = {}) => fK.get(r, () => sY(cK, {
  endpointParams: r,
  logger: e.logger
}));
Cx.aws = _R;
class Gt extends Td {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Gt.prototype);
  }
}
class Ix extends Gt {
  name = "AccessDeniedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "AccessDeniedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Ix.prototype);
  }
}
class Px extends Gt {
  name = "InternalErrorException";
  $fault = "server";
  constructor(e) {
    super({
      name: "InternalErrorException",
      $fault: "server",
      ...e
    }), Object.setPrototypeOf(this, Px.prototype);
  }
}
class Dx extends Gt {
  name = "InvalidParameterException";
  $fault = "client";
  reasonCode;
  constructor(e) {
    super({
      name: "InvalidParameterException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Dx.prototype), this.reasonCode = e.reasonCode;
  }
}
class Rx extends Gt {
  name = "NotAuthorizedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "NotAuthorizedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Rx.prototype);
  }
}
class Ox extends Gt {
  name = "OperationNotEnabledException";
  $fault = "client";
  constructor(e) {
    super({
      name: "OperationNotEnabledException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Ox.prototype);
  }
}
class Bx extends Gt {
  name = "ResourceNotFoundException";
  $fault = "client";
  constructor(e) {
    super({
      name: "ResourceNotFoundException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Bx.prototype);
  }
}
class _x extends Gt {
  name = "TooManyRequestsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "TooManyRequestsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, _x.prototype);
  }
}
class Mx extends Gt {
  name = "UserImportInProgressException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UserImportInProgressException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Mx.prototype);
  }
}
class Nx extends Gt {
  name = "InternalServerException";
  $fault = "server";
  constructor(e) {
    super({
      name: "InternalServerException",
      $fault: "server",
      ...e
    }), Object.setPrototypeOf(this, Nx.prototype);
  }
}
class Lx extends Gt {
  name = "LimitExceededException";
  $fault = "client";
  constructor(e) {
    super({
      name: "LimitExceededException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Lx.prototype);
  }
}
class Ux extends Gt {
  name = "UserNotFoundException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UserNotFoundException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Ux.prototype);
  }
}
class Vx extends Gt {
  name = "InvalidLambdaResponseException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidLambdaResponseException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Vx.prototype);
  }
}
class $x extends Gt {
  name = "TooManyFailedAttemptsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "TooManyFailedAttemptsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, $x.prototype);
  }
}
class zx extends Gt {
  name = "UnexpectedLambdaException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UnexpectedLambdaException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, zx.prototype);
  }
}
class Gx extends Gt {
  name = "UserLambdaValidationException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UserLambdaValidationException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Gx.prototype);
  }
}
class Hx extends Gt {
  name = "CodeDeliveryFailureException";
  $fault = "client";
  constructor(e) {
    super({
      name: "CodeDeliveryFailureException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Hx.prototype);
  }
}
class Wx extends Gt {
  name = "InvalidPasswordException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidPasswordException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Wx.prototype);
  }
}
class jx extends Gt {
  name = "InvalidSmsRoleAccessPolicyException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidSmsRoleAccessPolicyException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, jx.prototype);
  }
}
class qx extends Gt {
  name = "InvalidSmsRoleTrustRelationshipException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidSmsRoleTrustRelationshipException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, qx.prototype);
  }
}
class Qx extends Gt {
  name = "PreconditionNotMetException";
  $fault = "client";
  constructor(e) {
    super({
      name: "PreconditionNotMetException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Qx.prototype);
  }
}
class Yx extends Gt {
  name = "UnsupportedUserStateException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UnsupportedUserStateException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Yx.prototype);
  }
}
class Xx extends Gt {
  name = "UsernameExistsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UsernameExistsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Xx.prototype);
  }
}
class Jx extends Gt {
  name = "AliasExistsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "AliasExistsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Jx.prototype);
  }
}
class Kx extends Gt {
  name = "InvalidUserPoolConfigurationException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidUserPoolConfigurationException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Kx.prototype);
  }
}
class Zx extends Gt {
  name = "InvalidEmailRoleAccessPolicyException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidEmailRoleAccessPolicyException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Zx.prototype);
  }
}
class eb extends Gt {
  name = "MFAMethodNotFoundException";
  $fault = "client";
  constructor(e) {
    super({
      name: "MFAMethodNotFoundException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, eb.prototype);
  }
}
class tb extends Gt {
  name = "PasswordResetRequiredException";
  $fault = "client";
  constructor(e) {
    super({
      name: "PasswordResetRequiredException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, tb.prototype);
  }
}
class rb extends Gt {
  name = "UnsupportedOperationException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UnsupportedOperationException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, rb.prototype);
  }
}
class nb extends Gt {
  name = "UserNotConfirmedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UserNotConfirmedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, nb.prototype);
  }
}
class ib extends Gt {
  name = "UserPoolAddOnNotEnabledException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UserPoolAddOnNotEnabledException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, ib.prototype);
  }
}
class ab extends Gt {
  name = "CodeMismatchException";
  $fault = "client";
  constructor(e) {
    super({
      name: "CodeMismatchException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, ab.prototype);
  }
}
class sb extends Gt {
  name = "ExpiredCodeException";
  $fault = "client";
  constructor(e) {
    super({
      name: "ExpiredCodeException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, sb.prototype);
  }
}
class ob extends Gt {
  name = "PasswordHistoryPolicyViolationException";
  $fault = "client";
  constructor(e) {
    super({
      name: "PasswordHistoryPolicyViolationException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, ob.prototype);
  }
}
class lb extends Gt {
  name = "SoftwareTokenMFANotFoundException";
  $fault = "client";
  constructor(e) {
    super({
      name: "SoftwareTokenMFANotFoundException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, lb.prototype);
  }
}
class ub extends Gt {
  name = "ConcurrentModificationException";
  $fault = "client";
  constructor(e) {
    super({
      name: "ConcurrentModificationException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, ub.prototype);
  }
}
class cb extends Gt {
  name = "ForbiddenException";
  $fault = "client";
  constructor(e) {
    super({
      name: "ForbiddenException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, cb.prototype);
  }
}
class fb extends Gt {
  name = "WebAuthnChallengeNotFoundException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnChallengeNotFoundException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, fb.prototype);
  }
}
class db extends Gt {
  name = "WebAuthnClientMismatchException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnClientMismatchException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, db.prototype);
  }
}
class hb extends Gt {
  name = "WebAuthnCredentialNotSupportedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnCredentialNotSupportedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, hb.prototype);
  }
}
class pb extends Gt {
  name = "WebAuthnNotEnabledException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnNotEnabledException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, pb.prototype);
  }
}
class gb extends Gt {
  name = "WebAuthnOriginNotAllowedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnOriginNotAllowedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, gb.prototype);
  }
}
class mb extends Gt {
  name = "WebAuthnRelyingPartyMismatchException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnRelyingPartyMismatchException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, mb.prototype);
  }
}
class vb extends Gt {
  name = "DeviceKeyExistsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "DeviceKeyExistsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, vb.prototype);
  }
}
class yb extends Gt {
  name = "GroupExistsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "GroupExistsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, yb.prototype);
  }
}
class Ab extends Gt {
  name = "DuplicateProviderException";
  $fault = "client";
  constructor(e) {
    super({
      name: "DuplicateProviderException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Ab.prototype);
  }
}
class wb extends Gt {
  name = "ManagedLoginBrandingExistsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "ManagedLoginBrandingExistsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, wb.prototype);
  }
}
class xb extends Gt {
  name = "TermsExistsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "TermsExistsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, xb.prototype);
  }
}
class bb extends Gt {
  name = "FeatureUnavailableInTierException";
  $fault = "client";
  constructor(e) {
    super({
      name: "FeatureUnavailableInTierException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, bb.prototype);
  }
}
class Cb extends Gt {
  name = "TierChangeNotAllowedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "TierChangeNotAllowedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Cb.prototype);
  }
}
class Sb extends Gt {
  name = "UserPoolTaggingException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UserPoolTaggingException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Sb.prototype);
  }
}
class Eb extends Gt {
  name = "InvalidOAuthFlowException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidOAuthFlowException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Eb.prototype);
  }
}
class kb extends Gt {
  name = "ScopeDoesNotExistException";
  $fault = "client";
  constructor(e) {
    super({
      name: "ScopeDoesNotExistException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, kb.prototype);
  }
}
class Tb extends Gt {
  name = "UnsupportedIdentityProviderException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UnsupportedIdentityProviderException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Tb.prototype);
  }
}
class Fb extends Gt {
  name = "RefreshTokenReuseException";
  $fault = "client";
  constructor(e) {
    super({
      name: "RefreshTokenReuseException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Fb.prototype);
  }
}
class Ib extends Gt {
  name = "UnauthorizedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UnauthorizedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Ib.prototype);
  }
}
class Pb extends Gt {
  name = "UnsupportedTokenTypeException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UnsupportedTokenTypeException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Pb.prototype);
  }
}
class Db extends Gt {
  name = "WebAuthnConfigurationMissingException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnConfigurationMissingException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Db.prototype);
  }
}
class Rb extends Gt {
  name = "EnableSoftwareTokenMFAException";
  $fault = "client";
  constructor(e) {
    super({
      name: "EnableSoftwareTokenMFAException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Rb.prototype);
  }
}
const hK = "AvailableChallenges", pK = "AccessDeniedException", gK = "AliasExistsException", mK = "AnalyticsEndpointId", vK = "AuthFlow", qR = "AnalyticsMetadata", yK = "AnalyticsMetadataType", AK = "AuthParameters", wK = "AuthParametersType", QR = "AuthenticationResult", xK = "AuthenticationResultType", bK = "AccessToken", CK = "CodeDeliveryFailureException", YR = "ClientId", SK = "ClientIdType", XR = "ClientMetadata", EK = "CodeMismatchException", kK = "ConcurrentModificationException", Ob = "ChallengeName", JR = "ChallengeParameters", TK = "ChallengeResponses", FK = "ChallengeResponsesType", IK = "DeviceGroupKey", PK = "DeviceKey", DK = "DeviceKeyExistsException", RK = "DuplicateProviderException", OK = "ExpiredCodeException", BK = "EncodedData", _K = "ExpiresIn", MK = "EnableSoftwareTokenMFAException", NK = "ForbiddenException", LK = "FeatureUnavailableInTierException", UK = "GroupExistsException", VK = "IpAddress", $K = "InitiateAuthRequest", zK = "InitiateAuthResponse", GK = "InitiateAuth", HK = "InternalErrorException", WK = "InvalidEmailRoleAccessPolicyException", jK = "InvalidLambdaResponseException", qK = "InvalidOAuthFlowException", QK = "InvalidParameterException", YK = "InvalidPasswordException", XK = "InternalServerException", JK = "InvalidSmsRoleAccessPolicyException", KK = "InvalidSmsRoleTrustRelationshipException", ZK = "IdToken", eZ = "InvalidUserPoolConfigurationException", tZ = "LimitExceededException", rZ = "MFAMethodNotFoundException", nZ = "ManagedLoginBrandingExistsException", iZ = "NotAuthorizedException", aZ = "NewDeviceMetadata", sZ = "NewDeviceMetadataType", oZ = "OperationNotEnabledException", lZ = "PasswordHistoryPolicyViolationException", uZ = "PreconditionNotMetException", cZ = "PasswordResetRequiredException", fZ = "ResourceNotFoundException", dZ = "RefreshToken", hZ = "RespondToAuthChallenge", pZ = "RespondToAuthChallengeRequest", gZ = "RespondToAuthChallengeResponse", mZ = "RefreshTokenReuseException", rv = "Session", vZ = "ScopeDoesNotExistException", yZ = "SessionType", AZ = "SoftwareTokenMFANotFoundException", wZ = "TierChangeNotAllowedException", xZ = "TermsExistsException", bZ = "TooManyFailedAttemptsException", CZ = "TooManyRequestsException", SZ = "TokenModelType", EZ = "TokenType", kZ = "UserContextDataType", KR = "UserContextData", TZ = "UnauthorizedException", FZ = "UsernameExistsException", IZ = "UserImportInProgressException", PZ = "UnsupportedIdentityProviderException", DZ = "UnexpectedLambdaException", RZ = "UserLambdaValidationException", OZ = "UserNotConfirmedException", BZ = "UserNotFoundException", _Z = "UnsupportedOperationException", MZ = "UserPoolAddOnNotEnabledException", NZ = "UserPoolTaggingException", LZ = "UnsupportedTokenTypeException", UZ = "UnsupportedUserStateException", VZ = "WebAuthnClientMismatchException", $Z = "WebAuthnConfigurationMissingException", zZ = "WebAuthnChallengeNotFoundException", GZ = "WebAuthnCredentialNotSupportedException", HZ = "WebAuthnNotEnabledException", WZ = "WebAuthnOriginNotAllowedException", jZ = "WebAuthnRelyingPartyMismatchException", er = "client", Jt = "error", tr = "httpError", Kt = "message", qZ = "reasonCode", ZR = "smithy.ts.sdk.synthetic.com.amazonaws.cognitoidentityprovider", eO = "server", St = "com.amazonaws.cognitoidentityprovider", tO = qs.for(ZR);
var QZ = [-3, ZR, "CognitoIdentityProviderServiceException", 0, [], []];
tO.registerError(QZ, Gt);
const jt = qs.for(St);
var YZ = [
  -3,
  St,
  pK,
  { [Jt]: er, [tr]: 403 },
  [Kt],
  [0]
];
jt.registerError(YZ, Ix);
var XZ = [
  -3,
  St,
  gK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(XZ, Jx);
var JZ = [
  -3,
  St,
  CK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(JZ, Hx);
var KZ = [
  -3,
  St,
  EK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(KZ, ab);
var ZZ = [
  -3,
  St,
  kK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(ZZ, ub);
var eee = [
  -3,
  St,
  DK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(eee, vb);
var tee = [
  -3,
  St,
  RK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(tee, Ab);
var ree = [
  -3,
  St,
  MK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(ree, Rb);
var nee = [
  -3,
  St,
  OK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(nee, sb);
var iee = [
  -3,
  St,
  LK,
  { [Jt]: er, [tr]: 403 },
  [Kt],
  [0]
];
jt.registerError(iee, bb);
var aee = [
  -3,
  St,
  NK,
  { [Jt]: er, [tr]: 403 },
  [Kt],
  [0]
];
jt.registerError(aee, cb);
var see = [
  -3,
  St,
  UK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(see, yb);
var oee = [
  -3,
  St,
  HK,
  { [Jt]: eO },
  [Kt],
  [0]
];
jt.registerError(oee, Px);
var lee = [
  -3,
  St,
  XK,
  { [Jt]: eO },
  [Kt],
  [0]
];
jt.registerError(lee, Nx);
var uee = [
  -3,
  St,
  WK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(uee, Zx);
var cee = [
  -3,
  St,
  jK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(cee, Vx);
var fee = [
  -3,
  St,
  qK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(fee, Eb);
var dee = [
  -3,
  St,
  QK,
  { [Jt]: er, [tr]: 400 },
  [Kt, qZ],
  [0, 0]
];
jt.registerError(dee, Dx);
var hee = [
  -3,
  St,
  YK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(hee, Wx);
var pee = [
  -3,
  St,
  JK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(pee, jx);
var gee = [
  -3,
  St,
  KK,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(gee, qx);
var mee = [
  -3,
  St,
  eZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(mee, Kx);
var vee = [
  -3,
  St,
  tZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(vee, Lx);
var yee = [
  -3,
  St,
  nZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(yee, wb);
var Aee = [
  -3,
  St,
  rZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Aee, eb);
var wee = [
  -3,
  St,
  iZ,
  { [Jt]: er, [tr]: 403 },
  [Kt],
  [0]
];
jt.registerError(wee, Rx);
var xee = [
  -3,
  St,
  oZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(xee, Ox);
var bee = [
  -3,
  St,
  lZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(bee, ob);
var Cee = [
  -3,
  St,
  cZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Cee, tb);
var See = [
  -3,
  St,
  uZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(See, Qx);
var Eee = [
  -3,
  St,
  mZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Eee, Fb);
var kee = [
  -3,
  St,
  fZ,
  { [Jt]: er, [tr]: 404 },
  [Kt],
  [0]
];
jt.registerError(kee, Bx);
var Tee = [
  -3,
  St,
  vZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Tee, kb);
var Fee = [
  -3,
  St,
  AZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Fee, lb);
var Iee = [
  -3,
  St,
  xZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Iee, xb);
var Pee = [
  -3,
  St,
  wZ,
  { [Jt]: er, [tr]: 403 },
  [Kt],
  [0]
];
jt.registerError(Pee, Cb);
var Dee = [
  -3,
  St,
  bZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Dee, $x);
var Ree = [
  -3,
  St,
  CZ,
  { [Jt]: er, [tr]: 429 },
  [Kt],
  [0]
];
jt.registerError(Ree, _x);
var Oee = [
  -3,
  St,
  TZ,
  { [Jt]: er, [tr]: 401 },
  [Kt],
  [0]
];
jt.registerError(Oee, Ib);
var Bee = [
  -3,
  St,
  DZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Bee, zx);
var _ee = [
  -3,
  St,
  PZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(_ee, Tb);
var Mee = [
  -3,
  St,
  _Z,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Mee, rb);
var Nee = [
  -3,
  St,
  LZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Nee, Pb);
var Lee = [
  -3,
  St,
  UZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Lee, Yx);
var Uee = [
  -3,
  St,
  IZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Uee, Mx);
var Vee = [
  -3,
  St,
  RZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Vee, Gx);
var $ee = [
  -3,
  St,
  FZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError($ee, Xx);
var zee = [
  -3,
  St,
  OZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(zee, nb);
var Gee = [
  -3,
  St,
  BZ,
  { [Jt]: er, [tr]: 404 },
  [Kt],
  [0]
];
jt.registerError(Gee, Ux);
var Hee = [
  -3,
  St,
  MZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Hee, ib);
var Wee = [
  -3,
  St,
  NZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Wee, Sb);
var jee = [
  -3,
  St,
  zZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(jee, fb);
var qee = [
  -3,
  St,
  VZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(qee, db);
var Qee = [
  -3,
  St,
  $Z,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Qee, Db);
var Yee = [
  -3,
  St,
  GZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Yee, hb);
var Xee = [
  -3,
  St,
  HZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Xee, pb);
var Jee = [
  -3,
  St,
  WZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Jee, gb);
var Kee = [
  -3,
  St,
  jZ,
  { [Jt]: er, [tr]: 400 },
  [Kt],
  [0]
];
jt.registerError(Kee, mb);
const Zee = [
  tO,
  jt
];
var rO = [0, St, SK, 8, 0], nv = [0, St, yZ, 8, 0], _A = [0, St, SZ, 8, 0], nO = [
  3,
  St,
  yK,
  0,
  [mK],
  [0]
], iO = [
  3,
  St,
  xK,
  0,
  [bK, _K, EZ, dZ, ZK, aZ],
  [[() => _A, 0], 1, 0, [() => _A, 0], [() => _A, 0], () => rte]
], ete = [
  3,
  St,
  $K,
  0,
  [vK, YR, AK, XR, qR, KR, rv],
  [0, [() => rO, 0], [() => ate, 0], 128, () => nO, [() => aO, 0], [() => nv, 0]],
  2
], tte = [
  3,
  St,
  zK,
  0,
  [Ob, rv, JR, QR, hK],
  [0, [() => nv, 0], 128, [() => iO, 0], 64]
], rte = [
  3,
  St,
  sZ,
  0,
  [PK, IK],
  [0, 0]
], nte = [
  3,
  St,
  pZ,
  0,
  [YR, Ob, rv, TK, qR, KR, XR],
  [[() => rO, 0], 0, [() => nv, 0], [() => ste, 0], () => nO, [() => aO, 0], 128],
  2
], ite = [
  3,
  St,
  gZ,
  0,
  [Ob, rv, JR, QR],
  [0, [() => nv, 0], 128, [() => iO, 0]]
], aO = [
  3,
  St,
  kZ,
  8,
  [VK, BK],
  [0, 0]
], ate = [
  2,
  St,
  wK,
  8,
  0,
  0
], ste = [
  2,
  St,
  FK,
  8,
  0,
  0
], ote = [
  9,
  St,
  GK,
  0,
  () => ete,
  () => tte
], lte = [
  9,
  St,
  hZ,
  0,
  () => nte,
  () => ite
];
const ute = (r) => ({
  apiVersion: "2016-04-18",
  base64Decoder: r?.base64Decoder ?? Z0,
  base64Encoder: r?.base64Encoder ?? I0,
  disableHostPrefix: r?.disableHostPrefix ?? !1,
  endpointProvider: r?.endpointProvider ?? dK,
  extensions: r?.extensions ?? [],
  httpAuthSchemeProvider: r?.httpAuthSchemeProvider ?? CJ,
  httpAuthSchemes: r?.httpAuthSchemes ?? [
    {
      schemeId: "aws.auth#sigv4",
      identityProvider: (e) => e.getIdentityProvider("aws.auth#sigv4"),
      signer: new qX()
    },
    {
      schemeId: "smithy.api#noAuth",
      identityProvider: (e) => e.getIdentityProvider("smithy.api#noAuth") || (async () => ({})),
      signer: new fX()
    }
  ],
  logger: r?.logger ?? new pR(),
  protocol: r?.protocol ?? oK,
  protocolSettings: r?.protocolSettings ?? {
    defaultNamespace: "com.amazonaws.cognitoidentityprovider",
    errorTypeRegistries: Zee,
    xmlNamespace: "http://cognito-idp.amazonaws.com/doc/2016-04-18/",
    version: "2016-04-18",
    serviceTarget: "AWSCognitoIdentityProviderService"
  },
  serviceId: r?.serviceId ?? "Cognito Identity Provider",
  urlParser: r?.urlParser ?? F0,
  utf8Decoder: r?.utf8Decoder ?? qd,
  utf8Encoder: r?.utf8Encoder ?? wx
}), cte = (r) => {
  const e = UX(r), t = () => e().then($q), n = ute(r);
  return {
    ...n,
    ...r,
    runtime: "browser",
    defaultsMode: e,
    bodyLengthChecker: r?.bodyLengthChecker ?? SQ,
    credentialDefaultProvider: r?.credentialDefaultProvider ?? ((i) => () => Promise.reject(new Error("Credential is missing"))),
    defaultUserAgentProvider: r?.defaultUserAgentProvider ?? DX({ serviceId: n.serviceId, clientVersion: TJ.version }),
    maxAttempts: r?.maxAttempts ?? Op,
    region: r?.region ?? Rq("Region is missing"),
    requestHandler: Tx.create(r?.requestHandler ?? t),
    retryMode: r?.retryMode ?? (async () => (await t()).retryMode || GY),
    sha256: r?.sha256 ?? GJ,
    streamCollector: r?.streamCollector ?? WJ,
    useDualstackEndpoint: r?.useDualstackEndpoint ?? (() => Promise.resolve($X)),
    useFipsEndpoint: r?.useFipsEndpoint ?? (() => Promise.resolve(zX))
  };
}, fte = (r) => {
  const e = r.httpAuthSchemes;
  let t = r.httpAuthSchemeProvider, n = r.credentials;
  return {
    setHttpAuthScheme(i) {
      const a = e.findIndex((s) => s.schemeId === i.schemeId);
      a === -1 ? e.push(i) : e.splice(a, 1, i);
    },
    httpAuthSchemes() {
      return e;
    },
    setHttpAuthSchemeProvider(i) {
      t = i;
    },
    httpAuthSchemeProvider() {
      return t;
    },
    setCredentials(i) {
      n = i;
    },
    credentials() {
      return n;
    }
  };
}, dte = (r) => ({
  httpAuthSchemes: r.httpAuthSchemes(),
  httpAuthSchemeProvider: r.httpAuthSchemeProvider(),
  credentials: r.credentials()
}), hte = (r, e) => {
  const t = Object.assign(GX(r), jq(r), hY(r), fte(r));
  return e.forEach((n) => n.configure(t)), Object.assign(r, HX(t), qq(t), pY(t), dte(t));
};
class pte extends Oq {
  config;
  constructor(...[e]) {
    const t = cte(e || {});
    super(t), this.initConfig = t;
    const n = EJ(t), i = yX(n), a = WY(i), s = NX(a), o = s, l = oY(o), u = SJ(l), c = hte(u, e?.extensions || []);
    this.config = c, this.middlewareStack.use(Lq(this.config)), this.middlewareStack.use(PX(this.config)), this.middlewareStack.use(jY(this.config)), this.middlewareStack.use(vY(this.config)), this.middlewareStack.use(YY(this.config)), this.middlewareStack.use(KY(this.config)), this.middlewareStack.use(ZY(this.config)), this.middlewareStack.use(iX(this.config, {
      httpAuthSchemeParametersProvider: xJ,
      identityProviderConfigProvider: async (h) => new cX({
        "aws.auth#sigv4": h.credentials
      })
    })), this.middlewareStack.use(uX(this.config));
  }
  destroy() {
    super.destroy();
  }
}
class QT extends Ax.classBuilder().ep(HR).m(function(e, t, n, i) {
  return [FR(n, e.getEndpointParameterInstructions())];
}).s("AWSCognitoIdentityProviderService", "InitiateAuth", {}).n("CognitoIdentityProviderClient", "InitiateAuthCommand").sc(ote).build() {
}
class gte extends Ax.classBuilder().ep(HR).m(function(e, t, n, i) {
  return [FR(n, e.getEndpointParameterInstructions())];
}).s("AWSCognitoIdentityProviderService", "RespondToAuthChallenge", {}).n("CognitoIdentityProviderClient", "RespondToAuthChallengeCommand").sc(lte).build() {
}
class mte {
  init(e, t, n) {
    this.cognitoClient = new pte({ region: t }), this.spiffRegion = e, this.userPoolClientId = n;
  }
  async generateCode(e) {
    const t = await this.cognitoClient?.send(
      new QT({
        AuthFlow: "CUSTOM_AUTH",
        ClientId: this.userPoolClientId,
        AuthParameters: {
          USERNAME: e
        }
      })
    );
    t?.ChallengeName === "CUSTOM_CHALLENGE" && (this.challengeSession = t.Session);
  }
  async verifyCode(e, t, n) {
    const i = await this.cognitoClient?.send(
      new gte({
        ClientId: this.userPoolClientId,
        ChallengeName: "CUSTOM_CHALLENGE",
        Session: this.challengeSession,
        ChallengeResponses: {
          USERNAME: e,
          ANSWER: t
        },
        ClientMetadata: {
          partnerId: n,
          environment: (this.spiffRegion || "").toLowerCase()
        }
      })
    );
    return i?.ChallengeName === "CUSTOM_CHALLENGE" && (this.challengeSession = i.Session), i;
  }
  async refreshTokens() {
    const e = localStorage.getItem("cognito-tokens");
    if (!e)
      throw new Error("Failed to find existing tokens.");
    const t = JSON.parse(e);
    return await this.cognitoClient?.send(
      new QT({
        AuthFlow: "REFRESH_TOKEN_AUTH",
        ClientId: this.userPoolClientId,
        AuthParameters: {
          REFRESH_TOKEN: t.RefreshToken || ""
        }
      })
    );
  }
}
const up = new mte();
var vte = {
  defaultAmount: 0,
  defaultCurrency: "USD",
  defaultPrecision: 2
}, yte = {
  globalLocale: "en-US",
  globalFormat: "$0,0.00",
  globalRoundingMode: "HALF_EVEN",
  globalFormatRoundingMode: "HALF_AWAY_FROM_ZERO",
  globalExchangeRatesApi: {
    endpoint: void 0,
    headers: void 0,
    propertyPath: void 0
  }
};
function Mp(r) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Mp = function(e) {
    return typeof e;
  } : Mp = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Mp(r);
}
function YT(r) {
  return Ate(r) || wte(r) || xte(r) || bte();
}
function Ate(r) {
  if (Array.isArray(r)) return r;
}
function wte(r) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(r)) return Array.from(r);
}
function xte(r, e) {
  if (r) {
    if (typeof r == "string") return XT(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set") return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return XT(r, e);
  }
}
function XT(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++) n[t] = r[t];
  return n;
}
function bte() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Cte = {
  /**
   * Returns an array of Dinero objects, normalized to the same precision (the highest).
   *
   * @memberof module:Dinero
   * @method
   *
   * @param {Dinero[]} objects - An array of Dinero objects
   *
   * @example
   * // returns an array of Dinero objects
   * // both with a precision of 3
   * // and an amount of 1000
   * Dinero.normalizePrecision([
   *   Dinero({ amount: 100, precision: 2 }),
   *   Dinero({ amount: 1000, precision: 3 })
   * ])
   *
   * @return {Dinero[]}
   */
  normalizePrecision: function(e) {
    var t = e.reduce(function(n, i) {
      return Math.max(n.getPrecision(), i.getPrecision());
    });
    return e.map(function(n) {
      return n.getPrecision() !== t ? n.convertPrecision(t) : n;
    });
  },
  /**
   * Returns the smallest Dinero object from an array of Dinero objects
   *
   * @memberof module:Dinero
   * @method
   *
   * @param {Dinero[]} objects - An array of Dinero objects
   *
   * @example
   * // returns the smallest Dinero object with amount of 500 from an array of Dinero objects with different precisions
   * Dinero.minimum([
   *   Dinero({ amount: 500, precision: 3 }),
   *   Dinero({ amount: 100, precision: 2 })
   * ])
   * @example
   * // returns the smallest Dinero object with amount of 50 from an array of Dinero objects
   * Dinero.minimum([
   *   Dinero({ amount: 50 }),
   *   Dinero({ amount: 100 })
   * ])
   *
   * @return {Dinero[]}
   */
  minimum: function(e) {
    var t = YT(e), n = t[0], i = t.slice(1), a = n;
    return i.forEach(function(s) {
      a = a.lessThan(s) ? a : s;
    }), a;
  },
  /**
   * Returns the biggest Dinero object from an array of Dinero objects
   *
   * @memberof module:Dinero
   * @method
   *
   * @param {Dinero[]} objects - An array of Dinero objects
   *
   * @example
   * // returns the biggest Dinero object with amount of 20, from an array of Dinero objects with different precisions
   * Dinero.maximum([
   *   Dinero({ amount: 20, precision: 2 }),
   *   Dinero({ amount: 150, precision: 3 })
   * ])
   * @example
   * // returns the biggest Dinero object with amount of 100, from an array of Dinero objects
   * Dinero.maximum([
   *   Dinero({ amount: 100 }),
   *   Dinero({ amount: 50 })
   * ])
   *
   * @return {Dinero[]}
   */
  maximum: function(e) {
    var t = YT(e), n = t[0], i = t.slice(1), a = n;
    return i.forEach(function(s) {
      a = a.greaterThan(s) ? a : s;
    }), a;
  }
};
function sO(r) {
  return !isNaN(parseInt(r)) && isFinite(r);
}
function Ste(r) {
  return sO(r) && r <= 100 && r >= 0;
}
function Ete(r) {
  return r.length > 0 && r.every(function(e) {
    return e >= 0;
  }) && r.some(function(e) {
    return e > 0;
  });
}
function JT(r) {
  return r % 2 === 0;
}
function KT(r) {
  return sO(r) && !Number.isInteger(r);
}
function kte() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = r.toString();
  if (e.indexOf("e-") > 0)
    return parseInt(e.split("e-")[1]);
  var t = e.split(".")[1];
  return t ? t.length : 0;
}
function cp(r) {
  return Math.abs(r) % 1 === 0.5;
}
function Tte(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise(function(t, n) {
    var i = Object.assign(new XMLHttpRequest(), {
      onreadystatechange: function() {
        i.readyState === 4 && (i.status >= 200 && i.status < 400 ? t(JSON.parse(i.responseText)) : n(new Error(i.statusText)));
      },
      onerror: function() {
        n(new Error("Network error"));
      }
    });
    i.open("GET", r, !0), Fte(i, e.headers), i.send();
  });
}
function Fte(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  for (var t in e)
    r.setRequestHeader(t, e[t]);
  return r;
}
function kp(r) {
  return typeof r > "u";
}
function oO(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ".", t = {};
  return Object.entries(r).forEach(function(n) {
    if (Mp(n[1]) === "object") {
      var i = oO(n[1]);
      Object.entries(i).forEach(function(a) {
        t[n[0] + e + a[0]] = a[1];
      });
    } else
      t[n[0]] = n[1];
  }), t;
}
function Ite(r) {
  return !!r && (Mp(r) === "object" || typeof r == "function") && typeof r.then == "function";
}
function lO() {
  var r = function(n, i) {
    var a = function(l) {
      return Math.pow(10, kte(l));
    }, s = Math.max(a(n), a(i));
    return Math.round(n * s) * Math.round(i * s) / (s * s);
  }, e = {
    HALF_ODD: function(n) {
      var i = Math.round(n);
      return cp(n) && JT(i) ? i - 1 : i;
    },
    HALF_EVEN: function(n) {
      var i = Math.round(n);
      return cp(n) ? JT(i) ? i : i - 1 : i;
    },
    HALF_UP: function(n) {
      return Math.round(n);
    },
    HALF_DOWN: function(n) {
      return cp(n) ? Math.floor(n) : Math.round(n);
    },
    HALF_TOWARDS_ZERO: function(n) {
      return cp(n) ? Math.sign(n) * Math.floor(Math.abs(n)) : Math.round(n);
    },
    HALF_AWAY_FROM_ZERO: function(n) {
      return cp(n) ? Math.sign(n) * Math.ceil(Math.abs(n)) : Math.round(n);
    },
    DOWN: function(n) {
      return Math.floor(n);
    }
  };
  return {
    /**
     * Returns the sum of two numbers.
     * @ignore
     *
     * @param {Number} a - The first number to add.
     * @param {Number} b - The second number to add.
     *
     * @return {Number}
     */
    add: function(n, i) {
      return n + i;
    },
    /**
     * Returns the difference of two numbers.
     * @ignore
     *
     * @param {Number} a - The first number to subtract.
     * @param {Number} b - The second number to subtract.
     *
     * @return {Number}
     */
    subtract: function(n, i) {
      return n - i;
    },
    /**
     * Returns the product of two numbers.
     * @ignore
     *
     * @param {Number} a - The first number to multiply.
     * @param {Number} b - The second number to multiply.
     *
     * @return {Number}
     */
    multiply: function(n, i) {
      return KT(n) || KT(i) ? r(n, i) : n * i;
    },
    /**
     * Returns the quotient of two numbers.
     * @ignore
     *
     * @param {Number} a - The first number to divide.
     * @param {Number} b - The second number to divide.
     *
     * @return {Number}
     */
    divide: function(n, i) {
      return n / i;
    },
    /**
     * Returns the remainder of two numbers.
     * @ignore
     *
     * @param  {Number} a - The first number to divide.
     * @param  {Number} b - The second number to divide.
     *
     * @return {Number}
     */
    modulo: function(n, i) {
      return n % i;
    },
    /**
     * Returns a rounded number based off a specific rounding mode.
     * @ignore
     *
     * @param {Number} number - The number to round.
     * @param {String} [roundingMode='HALF_EVEN'] - The rounding mode to use.
     *
     * @returns {Number}
     */
    round: function(n) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "HALF_EVEN";
      return e[i](n);
    }
  };
}
var Pte = lO();
function Dte(r) {
  var e = /^(?:(\$|USD)?0(?:(,)0)?(\.)?(0+)?|0(?:(,)0)?(\.)?(0+)?\s?(dollar)?)$/gm.exec(r);
  return {
    /**
     * Returns the matches.
     * @ignore
     *
     * @return {Array}
     */
    getMatches: function() {
      return e !== null ? e.slice(1).filter(function(n) {
        return !kp(n);
      }) : [];
    },
    /**
     * Returns the amount of fraction digits to display.
     * @ignore
     *
     * @return {Number}
     */
    getMinimumFractionDigits: function() {
      var n = function(a) {
        return a === ".";
      };
      return kp(this.getMatches().find(n)) ? 0 : this.getMatches()[Pte.add(this.getMatches().findIndex(n), 1)].split("").length;
    },
    /**
     * Returns the currency display mode.
     * @ignore
     *
     * @return {String}
     */
    getCurrencyDisplay: function() {
      var n = {
        USD: "code",
        dollar: "name",
        $: "symbol"
      };
      return n[this.getMatches().find(function(i) {
        return i === "USD" || i === "dollar" || i === "$";
      })];
    },
    /**
     * Returns the formatting style.
     * @ignore
     *
     * @return {String}
     */
    getStyle: function() {
      return kp(this.getCurrencyDisplay(this.getMatches())) ? "decimal" : "currency";
    },
    /**
     * Returns whether grouping should be used or not.
     * @ignore
     *
     * @return {Boolean}
     */
    getUseGrouping: function() {
      return !kp(this.getMatches().find(function(n) {
        return n === ",";
      }));
    }
  };
}
function Rte(r) {
  var e = function() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", a = arguments.length > 1 ? arguments[1] : void 0;
    for (var s in a)
      i = i.replace("{{".concat(s, "}}"), a[s]);
    return i;
  }, t = function(i, a) {
    return Tte(e(r.endpoint, {
      from: i,
      to: a
    }), {
      headers: r.headers
    });
  };
  return {
    /**
     * Returns the exchange rate.
     * @ignore
     *
     * @param  {String} from - The base currency.
     * @param  {String} to   - The destination currency.
     *
     * @return {Promise}
     */
    getExchangeRate: function(i, a) {
      return (Ite(r.endpoint) ? r.endpoint : t(i, a)).then(function(s) {
        return oO(s)[e(r.propertyPath, {
          from: i,
          to: a
        })];
      });
    }
  };
}
function ig(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Error;
  if (!r) throw new t(e);
}
function Ote(r) {
  ig(Ste(r), "You must provide a numeric value between 0 and 100.", RangeError);
}
function Bte(r) {
  ig(Ete(r), "You must provide a non-empty array of numeric values greater than 0.", TypeError);
}
function MA(r) {
  ig(Number.isInteger(r), "You must provide an integer.", TypeError);
}
var bi = lO(), _te = function r(e) {
  var t = Object.assign({}, {
    amount: r.defaultAmount,
    currency: r.defaultCurrency,
    precision: r.defaultPrecision
  }, e), n = t.amount, i = t.currency, a = t.precision;
  MA(n), MA(a);
  var s = r.globalLocale, o = r.globalFormat, l = r.globalRoundingMode, u = r.globalFormatRoundingMode, c = Object.assign({}, r.globalExchangeRatesApi), h = function(m) {
    var A = Object.assign({}, Object.assign({}, {
      amount: n,
      currency: i,
      precision: a
    }, m), Object.assign({}, {
      locale: this.locale
    }, m));
    return Object.assign(r({
      amount: A.amount,
      currency: A.currency,
      precision: A.precision
    }), {
      locale: A.locale
    });
  }, f = function(m) {
    ig(this.hasSameCurrency(m), "You must provide a Dinero instance with the same currency.", TypeError);
  };
  return {
    /**
     * Returns the amount.
     *
     * @example
     * // returns 500
     * Dinero({ amount: 500 }).getAmount()
     *
     * @return {Number}
     */
    getAmount: function() {
      return n;
    },
    /**
     * Returns the currency.
     *
     * @example
     * // returns 'EUR'
     * Dinero({ currency: 'EUR' }).getCurrency()
     *
     * @return {String}
     */
    getCurrency: function() {
      return i;
    },
    /**
     * Returns the locale.
     *
     * @example
     * // returns 'fr-FR'
     * Dinero().setLocale('fr-FR').getLocale()
     *
     * @return {String}
     */
    getLocale: function() {
      return this.locale || s;
    },
    /**
     * Returns a new Dinero object with an embedded locale.
     *
     * @param {String} newLocale - The new locale as an {@link http://tools.ietf.org/html/rfc5646 BCP 47 language tag}.
     *
     * @example
     * // Returns a Dinero object with locale 'ja-JP'
     * Dinero().setLocale('ja-JP')
     *
     * @return {Dinero}
     */
    setLocale: function(m) {
      return h.call(this, {
        locale: m
      });
    },
    /**
     * Returns the precision.
     *
     * @example
     * // returns 3
     * Dinero({ precision: 3 }).getPrecision()
     *
     * @return {Number}
     */
    getPrecision: function() {
      return a;
    },
    /**
     * Returns a new Dinero object with a new precision and a converted amount.
     *
     * By default, fractional minor currency units are rounded using the **half to even** rule ([banker's rounding](http://wiki.c2.com/?BankersRounding)).
     * This can be necessary when you need to convert objects to a smaller precision.
     *
     * Rounding *can* lead to accuracy issues as you chain many times. Consider a minimal amount of subsequent conversions for safer results.
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * @param {Number} newPrecision - The new precision.
     * @param {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // Returns a Dinero object with precision 3 and amount 1000
     * Dinero({ amount: 100, precision: 2 }).convertPrecision(3)
     *
     * @throws {TypeError} If `newPrecision` is invalid.
     *
     * @return {Dinero}
     */
    convertPrecision: function(m) {
      var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : u;
      MA(m);
      var w = this.getPrecision(), x = m > w, E = x ? bi.multiply : bi.divide, T = x ? [m, w] : [w, m], D = Math.pow(10, bi.subtract.apply(bi, T));
      return h.call(this, {
        amount: bi.round(E(this.getAmount(), D), A),
        precision: m
      });
    },
    /**
     * Returns a new Dinero object that represents the sum of this and an other Dinero object.
     *
     * If Dinero objects have a different `precision`, they will be first converted to the highest.
     *
     * @param {Dinero} addend - The Dinero object to add.
     *
     * @example
     * // returns a Dinero object with amount 600
     * Dinero({ amount: 400 }).add(Dinero({ amount: 200 }))
     * @example
     * // returns a Dinero object with amount 144545 and precision 4
     * Dinero({ amount: 400 }).add(Dinero({ amount: 104545, precision: 4 }))
     *
     * @throws {TypeError} If `addend` has a different currency.
     *
     * @return {Dinero}
     */
    add: function(m) {
      f.call(this, m);
      var A = r.normalizePrecision([this, m]);
      return h.call(this, {
        amount: bi.add(A[0].getAmount(), A[1].getAmount()),
        precision: A[0].getPrecision()
      });
    },
    /**
     * Returns a new Dinero object that represents the difference of this and an other Dinero object.
     *
     * If Dinero objects have a different `precision`, they will be first converted to the highest.
     *
     * @param  {Dinero} subtrahend - The Dinero object to subtract.
     *
     * @example
     * // returns a Dinero object with amount 200
     * Dinero({ amount: 400 }).subtract(Dinero({ amount: 200 }))
     * @example
     * // returns a Dinero object with amount 64545 and precision 4
     * Dinero({ amount: 104545, precision: 4 }).subtract(Dinero({ amount: 400 }))
     *
     * @throws {TypeError} If `subtrahend` has a different currency.
     *
     * @return {Dinero}
     */
    subtract: function(m) {
      f.call(this, m);
      var A = r.normalizePrecision([this, m]);
      return h.call(this, {
        amount: bi.subtract(A[0].getAmount(), A[1].getAmount()),
        precision: A[0].getPrecision()
      });
    },
    /**
     * Returns a new Dinero object that represents the multiplied value by the given factor.
     *
     * By default, fractional minor currency units are rounded using the **half to even** rule ([banker's rounding](http://wiki.c2.com/?BankersRounding)).
     *
     * Rounding *can* lead to accuracy issues as you chain many times. Consider a minimal amount of subsequent calculations for safer results.
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * @param  {Number} multiplier - The factor to multiply by.
     * @param  {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // returns a Dinero object with amount 1600
     * Dinero({ amount: 400 }).multiply(4)
     * @example
     * // returns a Dinero object with amount 800
     * Dinero({ amount: 400 }).multiply(2.001)
     * @example
     * // returns a Dinero object with amount 801
     * Dinero({ amount: 400 }).multiply(2.00125, 'HALF_UP')
     *
     * @return {Dinero}
     */
    multiply: function(m) {
      var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l;
      return h.call(this, {
        amount: bi.round(bi.multiply(this.getAmount(), m), A)
      });
    },
    /**
     * Returns a new Dinero object that represents the divided value by the given factor.
     *
     * By default, fractional minor currency units are rounded using the **half to even** rule ([banker's rounding](http://wiki.c2.com/?BankersRounding)).
     *
     * Rounding *can* lead to accuracy issues as you chain many times. Consider a minimal amount of subsequent calculations for safer results.
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * As rounding is applied, precision may be lost in the process. If you want to accurately split a Dinero object, use {@link module:Dinero~allocate allocate} instead.
     *
     * @param  {Number} divisor - The factor to divide by.
     * @param  {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // returns a Dinero object with amount 100
     * Dinero({ amount: 400 }).divide(4)
     * @example
     * // returns a Dinero object with amount 52
     * Dinero({ amount: 105 }).divide(2)
     * @example
     * // returns a Dinero object with amount 53
     * Dinero({ amount: 105 }).divide(2, 'HALF_UP')
     *
     * @return {Dinero}
     */
    divide: function(m) {
      var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l;
      return h.call(this, {
        amount: bi.round(bi.divide(this.getAmount(), m), A)
      });
    },
    /**
     * Returns a new Dinero object that represents a percentage of this.
     *
     * As rounding is applied, precision may be lost in the process. If you want to accurately split a Dinero object, use {@link module:Dinero~allocate allocate} instead.
     *
     * @param  {Number} percentage - The percentage to extract (between 0 and 100).
     * @param  {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // returns a Dinero object with amount 5000
     * Dinero({ amount: 10000 }).percentage(50)
     * @example
     * // returns a Dinero object with amount 29
     * Dinero({ amount: 57 }).percentage(50, "HALF_ODD")
     *
     * @throws {RangeError} If `percentage` is out of range.
     *
     * @return {Dinero}
     */
    percentage: function(m) {
      var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l;
      return Ote(m), this.multiply(bi.divide(m, 100), A);
    },
    /**
     * Allocates the amount of a Dinero object according to a list of ratios.
     *
     * Sometimes you need to split monetary values but percentages can't cut it without adding or losing pennies.
     * A good example is invoicing: let's say you need to bill $1,000.03 and you want a 50% downpayment.
     * If you use {@link module:Dinero~percentage percentage}, you'll get an accurate Dinero object but the amount won't be billable: you can't split a penny.
     * If you round it, you'll bill a penny extra.
     * With {@link module:Dinero~allocate allocate}, you can split a monetary amount then distribute the remainder as evenly as possible.
     *
     * You can use percentage style or ratio style for `ratios`: `[25, 75]` and `[1, 3]` will do the same thing.
     *
     * Since v1.8.0, you can use zero ratios (such as [0, 50, 50]). If there's a remainder to distribute, zero ratios are skipped and return a Dinero object with amount zero.
     *
     * @param  {Number[]} ratios - The ratios to allocate the money to.
     *
     * @example
     * // returns an array of two Dinero objects
     * // the first one with an amount of 502
     * // the second one with an amount of 501
     * Dinero({ amount: 1003 }).allocate([50, 50])
     * @example
     * // returns an array of two Dinero objects
     * // the first one with an amount of 25
     * // the second one with an amount of 75
     * Dinero({ amount: 100 }).allocate([1, 3])
     * @example
     * // since version 1.8.0
     * // returns an array of three Dinero objects
     * // the first one with an amount of 0
     * // the second one with an amount of 502
     * // the third one with an amount of 501
     * Dinero({ amount: 1003 }).allocate([0, 50, 50])
     *
     * @throws {TypeError} If ratios are invalid.
     *
     * @return {Dinero[]}
     */
    allocate: function(m) {
      var A = this;
      Bte(m);
      for (var w = m.reduce(function(D, F) {
        return bi.add(D, F);
      }), x = this.getAmount(), E = m.map(function(D) {
        var F = Math.floor(bi.divide(bi.multiply(A.getAmount(), D), w));
        return x = bi.subtract(x, F), h.call(A, {
          amount: F
        });
      }), T = 0; x > 0; )
        m[T] > 0 && (E[T] = E[T].add(h.call(this, {
          amount: 1
        })), x = bi.subtract(x, 1)), T += 1;
      return E;
    },
    /**
     * Returns a Promise containing a new Dinero object converted to another currency.
     *
     * You have two options to provide the exchange rates:
     *
     * 1. **Use an exchange rate REST API, and let Dinero handle the fetching and conversion.**
     *   This is a simple option if you have access to an exchange rate REST API and want Dinero to do the rest.
     * 2. **Fetch the exchange rates on your own and provide them directly.**
     *   This is useful if you're fetching your rates from somewhere else (a file, a database), use a different protocol or query language than REST (SOAP, GraphQL) or want to fetch rates once and cache them instead of making new requests every time.
     *
     * **If you want to use a REST API**, you must provide a third-party endpoint yourself. Dinero doesn't come bundled with an exchange rates endpoint.
     *
     * Here are some exchange rate APIs you can use:
     *
     * * [Fixer](https://fixer.io)
     * * [Open Exchange Rates](https://openexchangerates.org)
     * * [Coinbase](https://api.coinbase.com/v2/exchange-rates)
     * * More [foreign](https://github.com/toddmotto/public-apis#currency-exchange) and [crypto](https://github.com/toddmotto/public-apis#cryptocurrency) exchange rate APIs.
     *
     * **If you want to fetch your own rates and provide them directly**, you need to pass a promise that resolves to the exchanges rates.
     *
     * In both cases, you need to specify at least:
     *
     * * a **destination currency**: the currency in which you want to convert your Dinero object. You can specify it with `currency`.
     * * an **endpoint**: the API URL to query exchange rates, with parameters, or a promise that resolves to the exchange rates. You can specify it with `options.endpoint`.
     * * a **property path**: the path to access the wanted rate in your API's JSON response (or the custom promise's payload). For example, with a response of:
     * ```json
     * {
     *     "data": {
     *       "base": "USD",
     *       "destination": "EUR",
     *       "rate": "0.827728919"
     *     }
     * }
     * ```
     * Then the property path is `'data.rate'`. You can specify it with `options.propertyPath`.
     *
     * The base currency (the one of your Dinero object) and the destination currency can be used as "merge tags" with the mustache syntax, respectively `{{from}}` and `{{to}}`.
     * You can use these tags to refer to these values in `options.endpoint` and `options.propertyPath`.
     *
     * For example, if you need to specify the base currency as a query parameter, you can do the following:
     *
     * ```js
     * {
     *   endpoint: 'https://yourexchangerates.api/latest?base={{from}}'
     * }
     * ```
     *
     * @param  {String} currency - The destination currency, expressed as an {@link https://en.wikipedia.org/wiki/ISO_4217#Active_codes ISO 4217 currency code}.
     * @param  {(String|Promise)} options.endpoint - The API endpoint to retrieve exchange rates. You can substitute this with a promise that resolves to the exchanges rates if you already have them.
     * @param  {String} [options.propertyPath='rates.{{to}}'] - The property path to the rate.
     * @param  {Object} [options.headers] - The HTTP headers to provide, if needed.
     * @param  {String} [options.roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // your global API parameters
     * Dinero.globalExchangeRatesApi = { ... }
     *
     * // returns a Promise containing a Dinero object with the destination currency
     * // and the initial amount converted to the new currency.
     * Dinero({ amount: 500 }).convert('EUR')
     * @example
     * // returns a Promise containing a Dinero object,
     * // with specific API parameters and rounding mode for this specific instance.
     * Dinero({ amount: 500 })
     *   .convert('XBT', {
     *     endpoint: 'https://yourexchangerates.api/latest?base={{from}}',
     *     propertyPath: 'data.rates.{{to}}',
     *     headers: {
     *       'user-key': 'xxxxxxxxx'
     *     },
     *     roundingMode: 'HALF_UP'
     *   })
     * @example
     * // usage with exchange rates provided as a custom promise
     * // using the default `propertyPath` format (so it doesn't have to be specified)
     * const rates = {
     *   rates: {
     *     EUR: 0.81162
     *   }
     * }
     *
     * Dinero({ amount: 500 })
     *   .convert('EUR', {
     *     endpoint: new Promise(resolve => resolve(rates))
     *   })
     * @example
     * // usage with Promise.prototype.then and Promise.prototype.catch
     * Dinero({ amount: 500 })
     *   .convert('EUR')
     *   .then(dinero => {
     *     dinero.getCurrency() // returns 'EUR'
     *   })
     *   .catch(err => {
     *     // handle errors
     *   })
     * @example
     * // usage with async/await
     * (async () => {
     *   const price = await Dinero({ amount: 500 }).convert('EUR')
     *   price.getCurrency() // returns 'EUR'
     * })()
     *
     * @return {Promise}
     */
    convert: function(m) {
      var A = this, w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, x = w.endpoint, E = x === void 0 ? c.endpoint : x, T = w.propertyPath, D = T === void 0 ? c.propertyPath || "rates.{{to}}" : T, F = w.headers, _ = F === void 0 ? c.headers : F, L = w.roundingMode, Z = L === void 0 ? l : L, te = Object.assign({}, {
        endpoint: E,
        propertyPath: D,
        headers: _,
        roundingMode: Z
      });
      return Rte(te).getExchangeRate(this.getCurrency(), m).then(function(de) {
        return ig(!kp(de), 'No rate was found for the destination currency "'.concat(m, '".'), TypeError), h.call(A, {
          amount: bi.round(bi.multiply(A.getAmount(), parseFloat(de)), te.roundingMode),
          currency: m
        });
      });
    },
    /**
     * Checks whether the value represented by this object equals to the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 500, currency: 'EUR' }).equalsTo(Dinero({ amount: 500, currency: 'EUR' }))
     * @example
     * // returns false
     * Dinero({ amount: 500, currency: 'EUR' }).equalsTo(Dinero({ amount: 800, currency: 'EUR' }))
     * @example
     * // returns false
     * Dinero({ amount: 500, currency: 'USD' }).equalsTo(Dinero({ amount: 500, currency: 'EUR' }))
     * @example
     * // returns false
     * Dinero({ amount: 500, currency: 'USD' }).equalsTo(Dinero({ amount: 800, currency: 'EUR' }))
     * @example
     * // returns true
     * Dinero({ amount: 1000, currency: 'EUR', precision: 2 }).equalsTo(Dinero({ amount: 10000, currency: 'EUR', precision: 3 }))
     * @example
     * // returns false
     * Dinero({ amount: 10000, currency: 'EUR', precision: 2 }).equalsTo(Dinero({ amount: 10000, currency: 'EUR', precision: 3 }))
     *
     * @return {Boolean}
     */
    equalsTo: function(m) {
      return this.hasSameAmount(m) && this.hasSameCurrency(m);
    },
    /**
     * Checks whether the value represented by this object is less than the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 500 }).lessThan(Dinero({ amount: 800 }))
     * @example
     * // returns false
     * Dinero({ amount: 800 }).lessThan(Dinero({ amount: 500 }))
     * @example
     * // returns true
     * Dinero({ amount: 5000, precision: 3 }).lessThan(Dinero({ amount: 800 }))
     * @example
     * // returns false
     * Dinero({ amount: 800 }).lessThan(Dinero({ amount: 5000, precision: 3 }))
     *
     * @throws {TypeError} If `comparator` has a different currency.
     *
     * @return {Boolean}
     */
    lessThan: function(m) {
      f.call(this, m);
      var A = r.normalizePrecision([this, m]);
      return A[0].getAmount() < A[1].getAmount();
    },
    /**
     * Checks whether the value represented by this object is less than or equal to the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 500 }).lessThanOrEqual(Dinero({ amount: 800 }))
     * @example
     * // returns true
     * Dinero({ amount: 500 }).lessThanOrEqual(Dinero({ amount: 500 }))
     * @example
     * // returns false
     * Dinero({ amount: 500 }).lessThanOrEqual(Dinero({ amount: 300 }))
     * @example
     * // returns true
     * Dinero({ amount: 5000, precision: 3 }).lessThanOrEqual(Dinero({ amount: 800 }))
     * @example
     * // returns true
     * Dinero({ amount: 5000, precision: 3 }).lessThanOrEqual(Dinero({ amount: 500 }))
     * @example
     * // returns false
     * Dinero({ amount: 800 }).lessThanOrEqual(Dinero({ amount: 5000, precision: 3 }))
     *
     * @throws {TypeError} If `comparator` has a different currency.
     *
     * @return {Boolean}
     */
    lessThanOrEqual: function(m) {
      f.call(this, m);
      var A = r.normalizePrecision([this, m]);
      return A[0].getAmount() <= A[1].getAmount();
    },
    /**
     * Checks whether the value represented by this object is greater than the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns false
     * Dinero({ amount: 500 }).greaterThan(Dinero({ amount: 800 }))
     * @example
     * // returns true
     * Dinero({ amount: 800 }).greaterThan(Dinero({ amount: 500 }))
     * @example
     * // returns true
     * Dinero({ amount: 800 }).greaterThan(Dinero({ amount: 5000, precision: 3 }))
     * @example
     * // returns false
     * Dinero({ amount: 5000, precision: 3 }).greaterThan(Dinero({ amount: 800 }))
     *
     * @throws {TypeError} If `comparator` has a different currency.
     *
     * @return {Boolean}
     */
    greaterThan: function(m) {
      f.call(this, m);
      var A = r.normalizePrecision([this, m]);
      return A[0].getAmount() > A[1].getAmount();
    },
    /**
     * Checks whether the value represented by this object is greater than or equal to the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 300 }))
     * @example
     * // returns true
     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 500 }))
     * @example
     * // returns false
     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 800 }))
     * @example
     * // returns true
     * Dinero({ amount: 800 }).greaterThanOrEqual(Dinero({ amount: 5000, precision: 3 }))
     * @example
     * // returns true
     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 5000, precision: 3 }))
     * @example
     * // returns false
     * Dinero({ amount: 5000, precision: 3 }).greaterThanOrEqual(Dinero({ amount: 800 }))
     *
     * @throws {TypeError} If `comparator` has a different currency.
     *
     * @return {Boolean}
     */
    greaterThanOrEqual: function(m) {
      f.call(this, m);
      var A = r.normalizePrecision([this, m]);
      return A[0].getAmount() >= A[1].getAmount();
    },
    /**
     * Checks if the value represented by this object is zero.
     *
     * @example
     * // returns true
     * Dinero({ amount: 0 }).isZero()
     * @example
     * // returns false
     * Dinero({ amount: 100 }).isZero()
     *
     * @return {Boolean}
     */
    isZero: function() {
      return this.getAmount() === 0;
    },
    /**
     * Checks if the value represented by this object is positive.
     *
     * @example
     * // returns false
     * Dinero({ amount: -10 }).isPositive()
     * @example
     * // returns true
     * Dinero({ amount: 10 }).isPositive()
     * @example
     * // returns true
     * Dinero({ amount: 0 }).isPositive()
     *
     * @return {Boolean}
     */
    isPositive: function() {
      return this.getAmount() >= 0;
    },
    /**
     * Checks if the value represented by this object is negative.
     *
     * @example
     * // returns true
     * Dinero({ amount: -10 }).isNegative()
     * @example
     * // returns false
     * Dinero({ amount: 10 }).isNegative()
     * @example
     * // returns false
     * Dinero({ amount: 0 }).isNegative()
     *
     * @return {Boolean}
     */
    isNegative: function() {
      return this.getAmount() < 0;
    },
    /**
     * Checks if this has minor currency units.
     * Deprecates {@link module:Dinero~hasCents hasCents}.
     *
     * @example
     * // returns false
     * Dinero({ amount: 1100 }).hasSubUnits()
     * @example
     * // returns true
     * Dinero({ amount: 1150 }).hasSubUnits()
     *
     * @return {Boolean}
     */
    hasSubUnits: function() {
      return bi.modulo(this.getAmount(), Math.pow(10, a)) !== 0;
    },
    /**
     * Checks if this has minor currency units.
     *
     * @deprecated since version 1.4.0, will be removed in 2.0.0
     * Use {@link module:Dinero~hasSubUnits hasSubUnits} instead.
     *
     * @example
     * // returns false
     * Dinero({ amount: 1100 }).hasCents()
     * @example
     * // returns true
     * Dinero({ amount: 1150 }).hasCents()
     *
     * @return {Boolean}
     */
    hasCents: function() {
      return bi.modulo(this.getAmount(), Math.pow(10, a)) !== 0;
    },
    /**
     * Checks whether the currency represented by this object equals to the other.
     *
     * @param  {Dinero}  comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 2000, currency: 'EUR' }).hasSameCurrency(Dinero({ amount: 1000, currency: 'EUR' }))
     * @example
     * // returns false
     * Dinero({ amount: 1000, currency: 'EUR' }).hasSameCurrency(Dinero({ amount: 1000, currency: 'USD' }))
     *
     * @return {Boolean}
     */
    hasSameCurrency: function(m) {
      return this.getCurrency() === m.getCurrency();
    },
    /**
     * Checks whether the amount represented by this object equals to the other.
     *
     * @param  {Dinero}  comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 1000, currency: 'EUR' }).hasSameAmount(Dinero({ amount: 1000 }))
     * @example
     * // returns false
     * Dinero({ amount: 2000, currency: 'EUR' }).hasSameAmount(Dinero({ amount: 1000, currency: 'EUR' }))
     * @example
     * // returns true
     * Dinero({ amount: 1000, currency: 'EUR', precision: 2 }).hasSameAmount(Dinero({ amount: 10000, precision: 3 }))
     * @example
     * // returns false
     * Dinero({ amount: 10000, currency: 'EUR', precision: 2 }).hasSameAmount(Dinero({ amount: 10000, precision: 3 }))
     *
     * @return {Boolean}
     */
    hasSameAmount: function(m) {
      var A = r.normalizePrecision([this, m]);
      return A[0].getAmount() === A[1].getAmount();
    },
    /**
     * Returns this object formatted as a string.
     *
     * The format is a mask which defines how the output string will be formatted.
     * It defines whether to display a currency, in what format, how many fraction digits to display and whether to use grouping separators.
     * The output is formatted according to the applying locale.
     *
     * Object                       | Format            | String
     * :--------------------------- | :---------------- | :---
     * `Dinero({ amount: 500050 })` | `'$0,0.00'`       | $5,000.50
     * `Dinero({ amount: 500050 })` | `'$0,0'`          | $5,001
     * `Dinero({ amount: 500050 })` | `'$0'`            | $5001
     * `Dinero({ amount: 500050 })` | `'$0.0'`          | $5000.5
     * `Dinero({ amount: 500050 })` | `'USD0,0.0'`      | USD5,000.5
     * `Dinero({ amount: 500050 })` | `'0,0.0 dollar'`  | 5,000.5 dollars
     *
     * Don't try to substitute the `$` sign or the `USD` code with your target currency, nor adapt the format string to the exact format you want.
     * The format is a mask which defines a pattern and returns a valid, localized currency string.
     * If you want to display the object in a custom way, either use {@link module:Dinero~getAmount getAmount}, {@link module:Dinero~toUnit toUnit} or {@link module:Dinero~toRoundedUnit toRoundedUnit} and manipulate the output string as you wish.
     *
     * {@link module:Dinero~toFormat toFormat} wraps around `Number.prototype.toLocaleString`. For that reason, **format will vary depending on how it's implemented in the end user's environment**.
     *
     * You can also use `toLocaleString` directly:
     * `Dinero().toRoundedUnit(digits, roundingMode).toLocaleString(locale, options)`.
     *
     * By default, amounts are rounded using the **half away from zero** rule ([commercial rounding](https://en.wikipedia.org/wiki/Rounding#Round_half_away_from_zero)).
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * @param  {String} [format='$0,0.00'] - The format mask to format to.
     * @param  {String} [roundingMode='HALF_AWAY_FROM_ZERO'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // returns $2,000
     * Dinero({ amount: 200000 }).toFormat('$0,0')
     * @example
     * // returns €50.5
     * Dinero({ amount: 5050, currency: 'EUR' }).toFormat('$0,0.0')
     * @example
     * // returns 100 euros
     * Dinero({ amount: 10000, currency: 'EUR' }).setLocale('fr-FR').toFormat('0,0 dollar')
     * @example
     * // returns 2000
     * Dinero({ amount: 200000, currency: 'EUR' }).toFormat()
     * @example
     * // returns $10
     * Dinero({ amount: 1050 }).toFormat('$0', 'HALF_EVEN')
     *
     * @return {String}
     */
    toFormat: function() {
      var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : o, A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : u, w = Dte(m);
      return this.toRoundedUnit(w.getMinimumFractionDigits(), A).toLocaleString(this.getLocale(), {
        currencyDisplay: w.getCurrencyDisplay(),
        useGrouping: w.getUseGrouping(),
        minimumFractionDigits: w.getMinimumFractionDigits(),
        style: w.getStyle(),
        currency: this.getCurrency()
      });
    },
    /**
     * Returns the amount represented by this object in units.
     *
     * @example
     * // returns 10.5
     * Dinero({ amount: 1050 }).toUnit()
     * @example
     * // returns 10.545
     * Dinero({ amount: 10545, precision: 3 }).toUnit()
     *
     * @return {Number}
     */
    toUnit: function() {
      return bi.divide(this.getAmount(), Math.pow(10, a));
    },
    /**
     * Returns the amount represented by this object in rounded units.
     *
     * By default, the method uses the **half away from zero** rule ([commercial rounding](https://en.wikipedia.org/wiki/Rounding#Round_half_away_from_zero)).
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * @example
     * // returns 10.6
     * Dinero({ amount: 1055 }).toRoundedUnit(1)
     * @example
     * // returns 10
     * Dinero({ amount: 1050 }).toRoundedUnit(0, 'HALF_EVEN')
     *
     * @param  {Number} digits - The number of fraction digits to round to.
     * @param  {String} [roundingMode='HALF_AWAY_FROM_ZERO'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @return {Number}
     */
    toRoundedUnit: function(m) {
      var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : u, w = Math.pow(10, m);
      return bi.divide(bi.round(bi.multiply(this.toUnit(), w), A), w);
    },
    /**
     * Returns the object's data as an object literal.
     *
     * @example
     * // returns { amount: 500, currency: 'EUR', precision: 2 }
     * Dinero({ amount: 500, currency: 'EUR', precision: 2 }).toObject()
     *
     * @return {Object}
     */
    toObject: function() {
      return {
        amount: n,
        currency: i,
        precision: a
      };
    },
    /**
     * Returns the object's data as an object literal.
     *
     * Alias of {@link module:Dinero~toObject toObject}.
     * It is defined so that calling `JSON.stringify` on a Dinero object will automatically extract the relevant data.
     *
     * @example
     * // returns '{"amount":500,"currency":"EUR","precision":2}'
     * JSON.stringify(Dinero({ amount: 500, currency: 'EUR', precision: 2 }))
     *
     * @return {Object}
     */
    toJSON: function() {
      return this.toObject();
    }
  };
}, Mte = Object.assign(_te, vte, yte, Cte), El = {}, NA, ZT;
function Nte() {
  if (ZT) return NA;
  ZT = 1;
  function r(t) {
    return t;
  }
  function e(t, a, s) {
    for (var a = a || r, s = s || t, o = 0, l = t.length; o < l; o += 1)
      if (a.call(s, t[o], o)) return t[o];
  }
  return NA = e, NA;
}
var LA = { exports: {} }, eF;
function Lte() {
  if (eF) return LA.exports;
  eF = 1;
  var r = LA.exports = function(e, t) {
    if (typeof e == "function" || t)
      return r.by(e, t);
    for (var n = {
      object: [],
      function: [],
      string: {},
      number: {},
      boolean: {},
      undefined: {}
    }, i = [], a = 0; a < e.length; a++) {
      var s = e[a], o = s === "__proto__" ? n.objects : n[typeof s] || n.objects;
      Array.isArray(o) ? o.indexOf(s) < 0 && (o.push(s), i.push(s)) : Object.hasOwnProperty.call(o, s) || (o[s] = !0, i.push(s));
    }
    return i;
  };
  return r.by = function(e, t) {
    if (typeof e == "function") {
      var n = t;
      t = e, e = n;
    }
    for (var i = [], a = 0; a < e.length; a++) {
      for (var s = e[a], o = !1, l = 0; l < i.length; l++) {
        var u = i[l];
        if (t.call(i, s, u)) {
          o = !0;
          break;
        }
      }
      o || i.push(s);
    }
    return i;
  }, LA.exports;
}
var UA, tF;
function Ute() {
  return tF || (tF = 1, UA = [
    {
      code: "AED",
      number: "784",
      digits: 2,
      currency: "UAE Dirham",
      countries: [
        "United Arab Emirates (The)"
      ]
    },
    {
      code: "AFN",
      number: "971",
      digits: 2,
      currency: "Afghani",
      countries: [
        "Afghanistan"
      ]
    },
    {
      code: "ALL",
      number: "008",
      digits: 2,
      currency: "Lek",
      countries: [
        "Albania"
      ]
    },
    {
      code: "AMD",
      number: "051",
      digits: 2,
      currency: "Armenian Dram",
      countries: [
        "Armenia"
      ]
    },
    {
      code: "ANG",
      number: "532",
      digits: 2,
      currency: "Netherlands Antillean Guilder",
      countries: [
        "Curaçao",
        "Sint Maarten (Dutch Part)"
      ]
    },
    {
      code: "AOA",
      number: "973",
      digits: 2,
      currency: "Kwanza",
      countries: [
        "Angola"
      ]
    },
    {
      code: "ARS",
      number: "032",
      digits: 2,
      currency: "Argentine Peso",
      countries: [
        "Argentina"
      ]
    },
    {
      code: "AUD",
      number: "036",
      digits: 2,
      currency: "Australian Dollar",
      countries: [
        "Australia",
        "Christmas Island",
        "Cocos (Keeling) Islands (The)",
        "Heard Island and Mcdonald Islands",
        "Kiribati",
        "Nauru",
        "Norfolk Island",
        "Tuvalu"
      ]
    },
    {
      code: "AWG",
      number: "533",
      digits: 2,
      currency: "Aruban Florin",
      countries: [
        "Aruba"
      ]
    },
    {
      code: "AZN",
      number: "944",
      digits: 2,
      currency: "Azerbaijan Manat",
      countries: [
        "Azerbaijan"
      ]
    },
    {
      code: "BAM",
      number: "977",
      digits: 2,
      currency: "Convertible Mark",
      countries: [
        "Bosnia and Herzegovina"
      ]
    },
    {
      code: "BBD",
      number: "052",
      digits: 2,
      currency: "Barbados Dollar",
      countries: [
        "Barbados"
      ]
    },
    {
      code: "BDT",
      number: "050",
      digits: 2,
      currency: "Taka",
      countries: [
        "Bangladesh"
      ]
    },
    {
      code: "BGN",
      number: "975",
      digits: 2,
      currency: "Bulgarian Lev",
      countries: [
        "Bulgaria"
      ]
    },
    {
      code: "BHD",
      number: "048",
      digits: 3,
      currency: "Bahraini Dinar",
      countries: [
        "Bahrain"
      ]
    },
    {
      code: "BIF",
      number: "108",
      digits: 0,
      currency: "Burundi Franc",
      countries: [
        "Burundi"
      ]
    },
    {
      code: "BMD",
      number: "060",
      digits: 2,
      currency: "Bermudian Dollar",
      countries: [
        "Bermuda"
      ]
    },
    {
      code: "BND",
      number: "096",
      digits: 2,
      currency: "Brunei Dollar",
      countries: [
        "Brunei Darussalam"
      ]
    },
    {
      code: "BOB",
      number: "068",
      digits: 2,
      currency: "Boliviano",
      countries: [
        "Bolivia (Plurinational State Of)"
      ]
    },
    {
      code: "BOV",
      number: "984",
      digits: 2,
      currency: "Mvdol",
      countries: [
        "Bolivia (Plurinational State Of)"
      ]
    },
    {
      code: "BRL",
      number: "986",
      digits: 2,
      currency: "Brazilian Real",
      countries: [
        "Brazil"
      ]
    },
    {
      code: "BSD",
      number: "044",
      digits: 2,
      currency: "Bahamian Dollar",
      countries: [
        "Bahamas (The)"
      ]
    },
    {
      code: "BTN",
      number: "064",
      digits: 2,
      currency: "Ngultrum",
      countries: [
        "Bhutan"
      ]
    },
    {
      code: "BWP",
      number: "072",
      digits: 2,
      currency: "Pula",
      countries: [
        "Botswana"
      ]
    },
    {
      code: "BYN",
      number: "933",
      digits: 2,
      currency: "Belarusian Ruble",
      countries: [
        "Belarus"
      ]
    },
    {
      code: "BZD",
      number: "084",
      digits: 2,
      currency: "Belize Dollar",
      countries: [
        "Belize"
      ]
    },
    {
      code: "CAD",
      number: "124",
      digits: 2,
      currency: "Canadian Dollar",
      countries: [
        "Canada"
      ]
    },
    {
      code: "CDF",
      number: "976",
      digits: 2,
      currency: "Congolese Franc",
      countries: [
        "Congo (The Democratic Republic of The)"
      ]
    },
    {
      code: "CHE",
      number: "947",
      digits: 2,
      currency: "WIR Euro",
      countries: [
        "Switzerland"
      ]
    },
    {
      code: "CHF",
      number: "756",
      digits: 2,
      currency: "Swiss Franc",
      countries: [
        "Liechtenstein",
        "Switzerland"
      ]
    },
    {
      code: "CHW",
      number: "948",
      digits: 2,
      currency: "WIR Franc",
      countries: [
        "Switzerland"
      ]
    },
    {
      code: "CLF",
      number: "990",
      digits: 4,
      currency: "Unidad de Fomento",
      countries: [
        "Chile"
      ]
    },
    {
      code: "CLP",
      number: "152",
      digits: 0,
      currency: "Chilean Peso",
      countries: [
        "Chile"
      ]
    },
    {
      code: "CNY",
      number: "156",
      digits: 2,
      currency: "Yuan Renminbi",
      countries: [
        "China"
      ]
    },
    {
      code: "COP",
      number: "170",
      digits: 2,
      currency: "Colombian Peso",
      countries: [
        "Colombia"
      ]
    },
    {
      code: "COU",
      number: "970",
      digits: 2,
      currency: "Unidad de Valor Real",
      countries: [
        "Colombia"
      ]
    },
    {
      code: "CRC",
      number: "188",
      digits: 2,
      currency: "Costa Rican Colon",
      countries: [
        "Costa Rica"
      ]
    },
    {
      code: "CUC",
      number: "931",
      digits: 2,
      currency: "Peso Convertible",
      countries: [
        "Cuba"
      ]
    },
    {
      code: "CUP",
      number: "192",
      digits: 2,
      currency: "Cuban Peso",
      countries: [
        "Cuba"
      ]
    },
    {
      code: "CVE",
      number: "132",
      digits: 2,
      currency: "Cabo Verde Escudo",
      countries: [
        "Cabo Verde"
      ]
    },
    {
      code: "CZK",
      number: "203",
      digits: 2,
      currency: "Czech Koruna",
      countries: [
        "Czechia"
      ]
    },
    {
      code: "DJF",
      number: "262",
      digits: 0,
      currency: "Djibouti Franc",
      countries: [
        "Djibouti"
      ]
    },
    {
      code: "DKK",
      number: "208",
      digits: 2,
      currency: "Danish Krone",
      countries: [
        "Denmark",
        "Faroe Islands (The)",
        "Greenland"
      ]
    },
    {
      code: "DOP",
      number: "214",
      digits: 2,
      currency: "Dominican Peso",
      countries: [
        "Dominican Republic (The)"
      ]
    },
    {
      code: "DZD",
      number: "012",
      digits: 2,
      currency: "Algerian Dinar",
      countries: [
        "Algeria"
      ]
    },
    {
      code: "EGP",
      number: "818",
      digits: 2,
      currency: "Egyptian Pound",
      countries: [
        "Egypt"
      ]
    },
    {
      code: "ERN",
      number: "232",
      digits: 2,
      currency: "Nakfa",
      countries: [
        "Eritrea"
      ]
    },
    {
      code: "ETB",
      number: "230",
      digits: 2,
      currency: "Ethiopian Birr",
      countries: [
        "Ethiopia"
      ]
    },
    {
      code: "EUR",
      number: "978",
      digits: 2,
      currency: "Euro",
      countries: [
        "Åland Islands",
        "Andorra",
        "Austria",
        "Belgium",
        "Croatia",
        "Cyprus",
        "Estonia",
        "European Union",
        "Finland",
        "France",
        "French Guiana",
        "French Southern Territories (The)",
        "Germany",
        "Greece",
        "Guadeloupe",
        "Holy See (The)",
        "Ireland",
        "Italy",
        "Latvia",
        "Lithuania",
        "Luxembourg",
        "Malta",
        "Martinique",
        "Mayotte",
        "Monaco",
        "Montenegro",
        "Netherlands (The)",
        "Portugal",
        "Réunion",
        "Saint Barthélemy",
        "Saint Martin (French Part)",
        "Saint Pierre and Miquelon",
        "San Marino",
        "Slovakia",
        "Slovenia",
        "Spain"
      ]
    },
    {
      code: "FJD",
      number: "242",
      digits: 2,
      currency: "Fiji Dollar",
      countries: [
        "Fiji"
      ]
    },
    {
      code: "FKP",
      number: "238",
      digits: 2,
      currency: "Falkland Islands Pound",
      countries: [
        "Falkland Islands (The) [Malvinas]"
      ]
    },
    {
      code: "GBP",
      number: "826",
      digits: 2,
      currency: "Pound Sterling",
      countries: [
        "Guernsey",
        "Isle of Man",
        "Jersey",
        "United Kingdom of Great Britain and Northern Ireland (The)"
      ]
    },
    {
      code: "GEL",
      number: "981",
      digits: 2,
      currency: "Lari",
      countries: [
        "Georgia"
      ]
    },
    {
      code: "GHS",
      number: "936",
      digits: 2,
      currency: "Ghana Cedi",
      countries: [
        "Ghana"
      ]
    },
    {
      code: "GIP",
      number: "292",
      digits: 2,
      currency: "Gibraltar Pound",
      countries: [
        "Gibraltar"
      ]
    },
    {
      code: "GMD",
      number: "270",
      digits: 2,
      currency: "Dalasi",
      countries: [
        "Gambia (The)"
      ]
    },
    {
      code: "GNF",
      number: "324",
      digits: 0,
      currency: "Guinean Franc",
      countries: [
        "Guinea"
      ]
    },
    {
      code: "GTQ",
      number: "320",
      digits: 2,
      currency: "Quetzal",
      countries: [
        "Guatemala"
      ]
    },
    {
      code: "GYD",
      number: "328",
      digits: 2,
      currency: "Guyana Dollar",
      countries: [
        "Guyana"
      ]
    },
    {
      code: "HKD",
      number: "344",
      digits: 2,
      currency: "Hong Kong Dollar",
      countries: [
        "Hong Kong"
      ]
    },
    {
      code: "HNL",
      number: "340",
      digits: 2,
      currency: "Lempira",
      countries: [
        "Honduras"
      ]
    },
    {
      code: "HTG",
      number: "332",
      digits: 2,
      currency: "Gourde",
      countries: [
        "Haiti"
      ]
    },
    {
      code: "HUF",
      number: "348",
      digits: 2,
      currency: "Forint",
      countries: [
        "Hungary"
      ]
    },
    {
      code: "IDR",
      number: "360",
      digits: 2,
      currency: "Rupiah",
      countries: [
        "Indonesia"
      ]
    },
    {
      code: "ILS",
      number: "376",
      digits: 2,
      currency: "New Israeli Sheqel",
      countries: [
        "Israel"
      ]
    },
    {
      code: "INR",
      number: "356",
      digits: 2,
      currency: "Indian Rupee",
      countries: [
        "Bhutan",
        "India"
      ]
    },
    {
      code: "IQD",
      number: "368",
      digits: 3,
      currency: "Iraqi Dinar",
      countries: [
        "Iraq"
      ]
    },
    {
      code: "IRR",
      number: "364",
      digits: 2,
      currency: "Iranian Rial",
      countries: [
        "Iran (Islamic Republic Of)"
      ]
    },
    {
      code: "ISK",
      number: "352",
      digits: 0,
      currency: "Iceland Krona",
      countries: [
        "Iceland"
      ]
    },
    {
      code: "JMD",
      number: "388",
      digits: 2,
      currency: "Jamaican Dollar",
      countries: [
        "Jamaica"
      ]
    },
    {
      code: "JOD",
      number: "400",
      digits: 3,
      currency: "Jordanian Dinar",
      countries: [
        "Jordan"
      ]
    },
    {
      code: "JPY",
      number: "392",
      digits: 0,
      currency: "Yen",
      countries: [
        "Japan"
      ]
    },
    {
      code: "KES",
      number: "404",
      digits: 2,
      currency: "Kenyan Shilling",
      countries: [
        "Kenya"
      ]
    },
    {
      code: "KGS",
      number: "417",
      digits: 2,
      currency: "Som",
      countries: [
        "Kyrgyzstan"
      ]
    },
    {
      code: "KHR",
      number: "116",
      digits: 2,
      currency: "Riel",
      countries: [
        "Cambodia"
      ]
    },
    {
      code: "KMF",
      number: "174",
      digits: 0,
      currency: "Comorian Franc ",
      countries: [
        "Comoros (The)"
      ]
    },
    {
      code: "KPW",
      number: "408",
      digits: 2,
      currency: "North Korean Won",
      countries: [
        "Korea (The Democratic People’s Republic Of)"
      ]
    },
    {
      code: "KRW",
      number: "410",
      digits: 0,
      currency: "Won",
      countries: [
        "Korea (The Republic Of)"
      ]
    },
    {
      code: "KWD",
      number: "414",
      digits: 3,
      currency: "Kuwaiti Dinar",
      countries: [
        "Kuwait"
      ]
    },
    {
      code: "KYD",
      number: "136",
      digits: 2,
      currency: "Cayman Islands Dollar",
      countries: [
        "Cayman Islands (The)"
      ]
    },
    {
      code: "KZT",
      number: "398",
      digits: 2,
      currency: "Tenge",
      countries: [
        "Kazakhstan"
      ]
    },
    {
      code: "LAK",
      number: "418",
      digits: 2,
      currency: "Lao Kip",
      countries: [
        "Lao People’s Democratic Republic (The)"
      ]
    },
    {
      code: "LBP",
      number: "422",
      digits: 2,
      currency: "Lebanese Pound",
      countries: [
        "Lebanon"
      ]
    },
    {
      code: "LKR",
      number: "144",
      digits: 2,
      currency: "Sri Lanka Rupee",
      countries: [
        "Sri Lanka"
      ]
    },
    {
      code: "LRD",
      number: "430",
      digits: 2,
      currency: "Liberian Dollar",
      countries: [
        "Liberia"
      ]
    },
    {
      code: "LSL",
      number: "426",
      digits: 2,
      currency: "Loti",
      countries: [
        "Lesotho"
      ]
    },
    {
      code: "LYD",
      number: "434",
      digits: 3,
      currency: "Libyan Dinar",
      countries: [
        "Libya"
      ]
    },
    {
      code: "MAD",
      number: "504",
      digits: 2,
      currency: "Moroccan Dirham",
      countries: [
        "Morocco",
        "Western Sahara"
      ]
    },
    {
      code: "MDL",
      number: "498",
      digits: 2,
      currency: "Moldovan Leu",
      countries: [
        "Moldova (The Republic Of)"
      ]
    },
    {
      code: "MGA",
      number: "969",
      digits: 2,
      currency: "Malagasy Ariary",
      countries: [
        "Madagascar"
      ]
    },
    {
      code: "MKD",
      number: "807",
      digits: 2,
      currency: "Denar",
      countries: [
        "North Macedonia"
      ]
    },
    {
      code: "MMK",
      number: "104",
      digits: 2,
      currency: "Kyat",
      countries: [
        "Myanmar"
      ]
    },
    {
      code: "MNT",
      number: "496",
      digits: 2,
      currency: "Tugrik",
      countries: [
        "Mongolia"
      ]
    },
    {
      code: "MOP",
      number: "446",
      digits: 2,
      currency: "Pataca",
      countries: [
        "Macao"
      ]
    },
    {
      code: "MRU",
      number: "929",
      digits: 2,
      currency: "Ouguiya",
      countries: [
        "Mauritania"
      ]
    },
    {
      code: "MUR",
      number: "480",
      digits: 2,
      currency: "Mauritius Rupee",
      countries: [
        "Mauritius"
      ]
    },
    {
      code: "MVR",
      number: "462",
      digits: 2,
      currency: "Rufiyaa",
      countries: [
        "Maldives"
      ]
    },
    {
      code: "MWK",
      number: "454",
      digits: 2,
      currency: "Malawi Kwacha",
      countries: [
        "Malawi"
      ]
    },
    {
      code: "MXN",
      number: "484",
      digits: 2,
      currency: "Mexican Peso",
      countries: [
        "Mexico"
      ]
    },
    {
      code: "MXV",
      number: "979",
      digits: 2,
      currency: "Mexican Unidad de Inversion (UDI)",
      countries: [
        "Mexico"
      ]
    },
    {
      code: "MYR",
      number: "458",
      digits: 2,
      currency: "Malaysian Ringgit",
      countries: [
        "Malaysia"
      ]
    },
    {
      code: "MZN",
      number: "943",
      digits: 2,
      currency: "Mozambique Metical",
      countries: [
        "Mozambique"
      ]
    },
    {
      code: "NAD",
      number: "516",
      digits: 2,
      currency: "Namibia Dollar",
      countries: [
        "Namibia"
      ]
    },
    {
      code: "NGN",
      number: "566",
      digits: 2,
      currency: "Naira",
      countries: [
        "Nigeria"
      ]
    },
    {
      code: "NIO",
      number: "558",
      digits: 2,
      currency: "Cordoba Oro",
      countries: [
        "Nicaragua"
      ]
    },
    {
      code: "NOK",
      number: "578",
      digits: 2,
      currency: "Norwegian Krone",
      countries: [
        "Bouvet Island",
        "Norway",
        "Svalbard and Jan Mayen"
      ]
    },
    {
      code: "NPR",
      number: "524",
      digits: 2,
      currency: "Nepalese Rupee",
      countries: [
        "Nepal"
      ]
    },
    {
      code: "NZD",
      number: "554",
      digits: 2,
      currency: "New Zealand Dollar",
      countries: [
        "Cook Islands (The)",
        "New Zealand",
        "Niue",
        "Pitcairn",
        "Tokelau"
      ]
    },
    {
      code: "OMR",
      number: "512",
      digits: 3,
      currency: "Rial Omani",
      countries: [
        "Oman"
      ]
    },
    {
      code: "PAB",
      number: "590",
      digits: 2,
      currency: "Balboa",
      countries: [
        "Panama"
      ]
    },
    {
      code: "PEN",
      number: "604",
      digits: 2,
      currency: "Sol",
      countries: [
        "Peru"
      ]
    },
    {
      code: "PGK",
      number: "598",
      digits: 2,
      currency: "Kina",
      countries: [
        "Papua New Guinea"
      ]
    },
    {
      code: "PHP",
      number: "608",
      digits: 2,
      currency: "Philippine Peso",
      countries: [
        "Philippines (The)"
      ]
    },
    {
      code: "PKR",
      number: "586",
      digits: 2,
      currency: "Pakistan Rupee",
      countries: [
        "Pakistan"
      ]
    },
    {
      code: "PLN",
      number: "985",
      digits: 2,
      currency: "Zloty",
      countries: [
        "Poland"
      ]
    },
    {
      code: "PYG",
      number: "600",
      digits: 0,
      currency: "Guarani",
      countries: [
        "Paraguay"
      ]
    },
    {
      code: "QAR",
      number: "634",
      digits: 2,
      currency: "Qatari Rial",
      countries: [
        "Qatar"
      ]
    },
    {
      code: "RON",
      number: "946",
      digits: 2,
      currency: "Romanian Leu",
      countries: [
        "Romania"
      ]
    },
    {
      code: "RSD",
      number: "941",
      digits: 2,
      currency: "Serbian Dinar",
      countries: [
        "Serbia"
      ]
    },
    {
      code: "RUB",
      number: "643",
      digits: 2,
      currency: "Russian Ruble",
      countries: [
        "Russian Federation (The)"
      ]
    },
    {
      code: "RWF",
      number: "646",
      digits: 0,
      currency: "Rwanda Franc",
      countries: [
        "Rwanda"
      ]
    },
    {
      code: "SAR",
      number: "682",
      digits: 2,
      currency: "Saudi Riyal",
      countries: [
        "Saudi Arabia"
      ]
    },
    {
      code: "SBD",
      number: "090",
      digits: 2,
      currency: "Solomon Islands Dollar",
      countries: [
        "Solomon Islands"
      ]
    },
    {
      code: "SCR",
      number: "690",
      digits: 2,
      currency: "Seychelles Rupee",
      countries: [
        "Seychelles"
      ]
    },
    {
      code: "SDG",
      number: "938",
      digits: 2,
      currency: "Sudanese Pound",
      countries: [
        "Sudan (The)"
      ]
    },
    {
      code: "SEK",
      number: "752",
      digits: 2,
      currency: "Swedish Krona",
      countries: [
        "Sweden"
      ]
    },
    {
      code: "SGD",
      number: "702",
      digits: 2,
      currency: "Singapore Dollar",
      countries: [
        "Singapore"
      ]
    },
    {
      code: "SHP",
      number: "654",
      digits: 2,
      currency: "Saint Helena Pound",
      countries: [
        "Saint Helena, Ascension and Tristan Da Cunha"
      ]
    },
    {
      code: "SLE",
      number: "925",
      digits: 2,
      currency: "Leone",
      countries: [
        "Sierra Leone"
      ]
    },
    {
      code: "SOS",
      number: "706",
      digits: 2,
      currency: "Somali Shilling",
      countries: [
        "Somalia"
      ]
    },
    {
      code: "SRD",
      number: "968",
      digits: 2,
      currency: "Surinam Dollar",
      countries: [
        "Suriname"
      ]
    },
    {
      code: "SSP",
      number: "728",
      digits: 2,
      currency: "South Sudanese Pound",
      countries: [
        "South Sudan"
      ]
    },
    {
      code: "STN",
      number: "930",
      digits: 2,
      currency: "Dobra",
      countries: [
        "Sao Tome and Principe"
      ]
    },
    {
      code: "SVC",
      number: "222",
      digits: 2,
      currency: "El Salvador Colon",
      countries: [
        "El Salvador"
      ]
    },
    {
      code: "SYP",
      number: "760",
      digits: 2,
      currency: "Syrian Pound",
      countries: [
        "Syrian Arab Republic"
      ]
    },
    {
      code: "SZL",
      number: "748",
      digits: 2,
      currency: "Lilangeni",
      countries: [
        "Eswatini"
      ]
    },
    {
      code: "THB",
      number: "764",
      digits: 2,
      currency: "Baht",
      countries: [
        "Thailand"
      ]
    },
    {
      code: "TJS",
      number: "972",
      digits: 2,
      currency: "Somoni",
      countries: [
        "Tajikistan"
      ]
    },
    {
      code: "TMT",
      number: "934",
      digits: 2,
      currency: "Turkmenistan New Manat",
      countries: [
        "Turkmenistan"
      ]
    },
    {
      code: "TND",
      number: "788",
      digits: 3,
      currency: "Tunisian Dinar",
      countries: [
        "Tunisia"
      ]
    },
    {
      code: "TOP",
      number: "776",
      digits: 2,
      currency: "Pa’anga",
      countries: [
        "Tonga"
      ]
    },
    {
      code: "TRY",
      number: "949",
      digits: 2,
      currency: "Turkish Lira",
      countries: [
        "Türki̇ye"
      ]
    },
    {
      code: "TTD",
      number: "780",
      digits: 2,
      currency: "Trinidad and Tobago Dollar",
      countries: [
        "Trinidad and Tobago"
      ]
    },
    {
      code: "TWD",
      number: "901",
      digits: 2,
      currency: "New Taiwan Dollar",
      countries: [
        "Taiwan (Province of China)"
      ]
    },
    {
      code: "TZS",
      number: "834",
      digits: 2,
      currency: "Tanzanian Shilling",
      countries: [
        "Tanzania, United Republic Of"
      ]
    },
    {
      code: "UAH",
      number: "980",
      digits: 2,
      currency: "Hryvnia",
      countries: [
        "Ukraine"
      ]
    },
    {
      code: "UGX",
      number: "800",
      digits: 0,
      currency: "Uganda Shilling",
      countries: [
        "Uganda"
      ]
    },
    {
      code: "USD",
      number: "840",
      digits: 2,
      currency: "US Dollar",
      countries: [
        "American Samoa",
        "Bonaire, Sint Eustatius and Saba",
        "British Indian Ocean Territory (The)",
        "Ecuador",
        "El Salvador",
        "Guam",
        "Haiti",
        "Marshall Islands (The)",
        "Micronesia (Federated States Of)",
        "Northern Mariana Islands (The)",
        "Palau",
        "Panama",
        "Puerto Rico",
        "Timor-Leste",
        "Turks and Caicos Islands (The)",
        "United States Minor Outlying Islands (The)",
        "United States of America (The)",
        "Virgin Islands (British)",
        "Virgin Islands (u.s.)"
      ]
    },
    {
      code: "USN",
      number: "997",
      digits: 2,
      currency: "US Dollar (Next day)",
      countries: [
        "United States of America (The)"
      ]
    },
    {
      code: "UYI",
      number: "940",
      digits: 0,
      currency: "Uruguay Peso en Unidades Indexadas (UI)",
      countries: [
        "Uruguay"
      ]
    },
    {
      code: "UYU",
      number: "858",
      digits: 2,
      currency: "Peso Uruguayo",
      countries: [
        "Uruguay"
      ]
    },
    {
      code: "UYW",
      number: "927",
      digits: 4,
      currency: "Unidad Previsional",
      countries: [
        "Uruguay"
      ]
    },
    {
      code: "UZS",
      number: "860",
      digits: 2,
      currency: "Uzbekistan Sum",
      countries: [
        "Uzbekistan"
      ]
    },
    {
      code: "VED",
      number: "926",
      digits: 2,
      currency: "Bolívar Soberano",
      countries: [
        "Venezuela (Bolivarian Republic Of)"
      ]
    },
    {
      code: "VES",
      number: "928",
      digits: 2,
      currency: "Bolívar Soberano",
      countries: [
        "Venezuela (Bolivarian Republic Of)"
      ]
    },
    {
      code: "VND",
      number: "704",
      digits: 0,
      currency: "Dong",
      countries: [
        "Viet Nam"
      ]
    },
    {
      code: "VUV",
      number: "548",
      digits: 0,
      currency: "Vatu",
      countries: [
        "Vanuatu"
      ]
    },
    {
      code: "WST",
      number: "882",
      digits: 2,
      currency: "Tala",
      countries: [
        "Samoa"
      ]
    },
    {
      code: "XAF",
      number: "950",
      digits: 0,
      currency: "CFA Franc BEAC",
      countries: [
        "Cameroon",
        "Central African Republic (The)",
        "Chad",
        "Congo (The)",
        "Equatorial Guinea",
        "Gabon"
      ]
    },
    {
      code: "XAG",
      number: "961",
      digits: 0,
      currency: "Silver",
      countries: [
        "Zz11_silver"
      ]
    },
    {
      code: "XAU",
      number: "959",
      digits: 0,
      currency: "Gold",
      countries: [
        "Zz08_gold"
      ]
    },
    {
      code: "XBA",
      number: "955",
      digits: 0,
      currency: "Bond Markets Unit European Composite Unit (EURCO)",
      countries: [
        "Zz01_bond Markets Unit European_eurco"
      ]
    },
    {
      code: "XBB",
      number: "956",
      digits: 0,
      currency: "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
      countries: [
        "Zz02_bond Markets Unit European_emu-6"
      ]
    },
    {
      code: "XBC",
      number: "957",
      digits: 0,
      currency: "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)",
      countries: [
        "Zz03_bond Markets Unit European_eua-9"
      ]
    },
    {
      code: "XBD",
      number: "958",
      digits: 0,
      currency: "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
      countries: [
        "Zz04_bond Markets Unit European_eua-17"
      ]
    },
    {
      code: "XCD",
      number: "951",
      digits: 2,
      currency: "East Caribbean Dollar",
      countries: [
        "Anguilla",
        "Antigua and Barbuda",
        "Dominica",
        "Grenada",
        "Montserrat",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Vincent and the Grenadines"
      ]
    },
    {
      code: "XDR",
      number: "960",
      digits: 0,
      currency: "SDR (Special Drawing Right)",
      countries: [
        "International Monetary Fund (Imf) "
      ]
    },
    {
      code: "XOF",
      number: "952",
      digits: 0,
      currency: "CFA Franc BCEAO",
      countries: [
        "Benin",
        "Burkina Faso",
        "Côte D'ivoire",
        "Guinea-Bissau",
        "Mali",
        "Niger (The)",
        "Senegal",
        "Togo"
      ]
    },
    {
      code: "XPD",
      number: "964",
      digits: 0,
      currency: "Palladium",
      countries: [
        "Zz09_palladium"
      ]
    },
    {
      code: "XPF",
      number: "953",
      digits: 0,
      currency: "CFP Franc",
      countries: [
        "French Polynesia",
        "New Caledonia",
        "Wallis and Futuna"
      ]
    },
    {
      code: "XPT",
      number: "962",
      digits: 0,
      currency: "Platinum",
      countries: [
        "Zz10_platinum"
      ]
    },
    {
      code: "XSU",
      number: "994",
      digits: 0,
      currency: "Sucre",
      countries: [
        'Sistema Unitario De Compensacion Regional De Pagos "Sucre"'
      ]
    },
    {
      code: "XTS",
      number: "963",
      digits: 0,
      currency: "Codes specifically reserved for testing purposes",
      countries: [
        "Zz06_testing_code"
      ]
    },
    {
      code: "XUA",
      number: "965",
      digits: 0,
      currency: "ADB Unit of Account",
      countries: [
        "Member Countries of the African Development Bank Group"
      ]
    },
    {
      code: "XXX",
      number: "999",
      digits: 0,
      currency: "The codes assigned for transactions where no currency is involved",
      countries: [
        "Zz07_no_currency"
      ]
    },
    {
      code: "YER",
      number: "886",
      digits: 2,
      currency: "Yemeni Rial",
      countries: [
        "Yemen"
      ]
    },
    {
      code: "ZAR",
      number: "710",
      digits: 2,
      currency: "Rand",
      countries: [
        "Lesotho",
        "Namibia",
        "South Africa"
      ]
    },
    {
      code: "ZMW",
      number: "967",
      digits: 2,
      currency: "Zambian Kwacha",
      countries: [
        "Zambia"
      ]
    },
    {
      code: "ZWG",
      number: "924",
      digits: 2,
      currency: "Zimbabwe Gold",
      countries: [
        "Zimbabwe"
      ]
    }
  ]), UA;
}
var VA, rF;
function Vte() {
  return rF || (rF = 1, VA = "2024-06-25"), VA;
}
var nF;
function $te() {
  if (nF) return El;
  nF = 1;
  var r = Nte(), e = Lte(), t = Ute(), n = Vte(), i = function(c) {
    return c = c.toUpperCase(), r(t, function(h) {
      return h.code === c;
    });
  }, a = function(c) {
    return c = c.toLowerCase(), t.filter(function(h) {
      return (h.countries.map(function(f) {
        return f.toLowerCase();
      }) || []).indexOf(c) > -1;
    });
  }, s = function(c) {
    return r(t, function(h) {
      return h.number === String(c);
    });
  }, o = function() {
    return t.map(function(c) {
      return c.code;
    });
  }, l = function() {
    var c = t.map(function(h) {
      return h.number;
    });
    return c.filter(function(h) {
      if (h)
        return h;
    });
  }, u = function() {
    var c = t.filter(function(h) {
      return h.countries;
    }).map(function(h) {
      return h.countries;
    });
    return e(Array.prototype.concat.apply([], c));
  };
  return El.code = i, El.country = a, El.number = s, El.codes = o, El.numbers = l, El.countries = u, El.publishDate = n, El.data = t, El;
}
var iF = $te();
class zte {
  /**
   * Returns a formatted string representing a given amount with desired currency.
   * @param currency The currency to represent the amount in.
   * @param amount The amount in minor units to format.
   */
  formatCurrencyForDisplay(e, t) {
    const n = {
      amount: t || 0,
      currency: e,
      precision: this.getPrecisionForCurrency(e)
    };
    return Mte(n).toFormat(this.getSpecialFormat(e));
  }
  /**
   * Get the number of decimal places expected in a currency string.
   * @param currency The currency to determine precision for.
   */
  getPrecisionForCurrency(e) {
    const t = e, n = iF.code(t);
    return n ? n.digits : 2;
  }
  /**
   * Sometimes default formatting will display format in a way that isn't natural
   * for natives of a currency. This function is intended to capture those specific cases and return a format
   * that makes the most sense.
   * @param currency The currency to test for special format.
   */
  getSpecialFormat(e) {
    const t = e;
    if (iF.code(t)?.code === "CLP")
      return "USD0,0";
  }
}
const aF = new zte();
class Gte {
  constructor(e, t, n, i) {
    this.presentmentCurrency = void 0, this.presentmentCurrency = i, this.partnerCurrency = n, this.rateFrom = e, this.rateTo = t;
  }
  /**
   * @returns The currency code for the currency being used for monetary display.
   */
  code() {
    return this.presentmentCurrency ? this.presentmentCurrency : this.partnerCurrency;
  }
  /**
   * @returns true if the conversion is required, false otherwise.
   */
  conversionRequired() {
    return this.presentmentCurrency !== void 0 && this.code() !== this.partnerCurrency;
  }
  /**
   * Converts a monetary value from a workflow in a partner specified currency
   * to the units of the currency being used for display.
   * @param amount The amount in minor units to convert.
   * @returns
   */
  getConvertedSubunits(e) {
    return this.conversionRequired() ? Math.ceil(
      this.subunits(this.units(e, this.partnerCurrency) / this.rateFrom * this.rateTo, this.code())
    ) : e;
  }
  /**
   * Converts a monetary value from the database to the units of its currency.
   */
  units(e, t) {
    return e / Math.pow(10, aF.getPrecisionForCurrency(t));
  }
  /**
   * Converts a monetary value in units to the subunits of its currency.
   */
  subunits(e, t) {
    return e * Math.pow(10, aF.getPrecisionForCurrency(t));
  }
}
const Hte = async (r, e) => {
  const t = LL(e?.assets?.metadata || !1), n = { ids: r }, i = await et.getShadowGraphqlClient().query({
    query: t,
    errorPolicy: "all",
    variables: n,
    context: {
      logRequestHeaders: !0
    }
  });
  if (i.error)
    throw console.log("[getWorkflowsInternal] Response errored."), i.error;
  if (i.errors)
    throw i.errors.forEach((s) => console.error(s)), new Error("Unable to read workflows. Consult GraphQL errors.");
  if (!i.data.workflows || i.data.workflows.length !== r.length)
    throw new Error(`Unable to read workflows: ${i.errors ?? "Length mismatch in response"}`);
  const a = Su(i.data.workflows);
  return a.forEach((s) => {
    s.finalizeStepConfig || (s.finalizeStepConfig = {}), s.finalizeStepConfig.termsMarkdown = s.finalizeStepConfig.termsMarkdown || s.partner.termsMarkdown;
  }), a;
}, Wte = async (r, e) => {
  const n = (await e).find((i) => i.id === r);
  if (!n)
    throw new Error(`Workflow not found: ${r}`);
  return n;
}, uO = async (r, e) => {
  const t = r.map((o) => p0.get({ id: o, options: e })), n = r.filter((o, l) => t[l] === void 0);
  if (n.length === 0)
    return Promise.all(t);
  const i = Hte(n, e), a = n.map(
    (o) => p0.set({ id: o, options: e }, Wte(o, i))
  ), s = t.filter((o) => o !== void 0);
  return await Promise.all(s.concat(a));
}, cO = async (r, e) => (await uO([r], e))[0], fO = async (r) => {
  const e = await et.getShadowGraphqlClient().query({
    query: HI,
    variables: {
      ids: r
    },
    errorPolicy: "all",
    fetchPolicy: "no-cache"
  });
  return e.errors && console.error(e.errors), e.data.integrationProducts || [];
};
class gne {
  constructor(e) {
    this.activeIntegration = void 0, this.updateTransactionState = async (t) => {
      try {
        return et.getShadowGraphqlClient().mutate({
          ...t,
          mutation: CL
        });
      } catch (n) {
        throw console.error(n), new mc("Critical - Unable to synchronize workflow state with server.");
      }
    }, this.options = e, this.options.applicationKey && VN(this.options.applicationKey), console.debug("------------------------"), console.debug("Spiff Commerce Core SDK"), console.debug("Version: 44.13.0"), console.debug(`Application Key Provided: ${!!this.options.applicationKey}`), console.debug("------------------------");
  }
  configure(e) {
    Cc.setHubUrl(e.hubUrl), Cc.setServerUrl(e.serverUrl), Cc.setServicesApiUrl(e.servicesApiUrl), this.marketplaceThemeInstallId = e.marketplaceThemeInstallId, this.marketplaceThemeInstallConfigurationId = e.marketplaceThemeInstallConfigurationId, this.userPoolClientId = e.userPoolClientId, this.userPoolRegion = e.userPoolRegion, this.spiffRegion = e.spiffRegion, e.bearerAuthenticationToken && zN(e.bearerAuthenticationToken), e.partnerId && GN(e.partnerId), this.options.applicationKey && this.getIntegration(), this.spiffRegion && this.userPoolRegion && this.userPoolClientId && up.init(this.spiffRegion, this.userPoolRegion, this.userPoolClientId);
  }
  /**
   * @returns The version of the @spiffcommerce/core package that this client is running.
   */
  getVersion() {
    return "44.13.0";
  }
  /**
   * @returns The asset manager allows for common operations related to assets
   * and the Spiff Commerce platform.
   */
  getAssetManager() {
    return Si;
  }
  /**
   * @returns A promise that resolves with a boolean indicating whether to use beta features.
   */
  async getBetaEnabled() {
    return this.options.enableBetaFeatures ? !0 : (await this.getIntegration()).partner.beta === !0;
  }
  getFlowService() {
    if (!$N()) throw new Error("Application key required to use Flow Service.");
    return new Aq();
  }
  async getCurrencyContext(e) {
    const n = (await this.getIntegration()).partner.currencyCode, a = await et.getShadowGraphqlClient().query({
      query: HL,
      errorPolicy: "all",
      fetchPolicy: "cache-first",
      variables: {
        from: n,
        to: e
      }
    }), { rateFrom: s, rateTo: o } = a.data.currencyConversion;
    return new Gte(s, o, n, e);
  }
  async getIntegration() {
    if (this.activeIntegration)
      return this.activeIntegration;
    if (!this.options.applicationKey)
      throw new Error("Cannot get current Integration without specifying an Application Key.");
    return this.activeIntegration = jte(this.options.applicationKey), this.activeIntegration;
  }
  async canUseAddon(e) {
    try {
      return (await this.getIntegration()).partner.activeAddons?.includes(e) ?? !1;
    } catch (t) {
      return console.error(t), !1;
    }
  }
  clearCustomer() {
    this.customer = void 0;
  }
  clearCustomerForTransaction(e) {
    const t = hn.getMap("transactionCustomerIds");
    t?.has(e) && (t.delete(e), hn.setMap("transactionCustomerIds", t));
  }
  async customerHasBundleTemplates(e) {
    const i = (await et.getShadowGraphqlClient().query({
      query: pA,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        emailAddress: e
      }
    })).data.customer;
    return i.id ? i.hasBundleTemplates ?? !1 : !1;
  }
  getStakeholderTypeForTransaction(e) {
    const t = this.customer?.stakeholders?.find(
      (n) => n.transaction?.id === e
    );
    if (t)
      return t.type;
  }
  async getOrCreateCustomer(e) {
    this.customer = void 0;
    const t = et.getShadowGraphqlClient(), i = (await t.query({
      query: pA,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        emailAddress: e
      }
    })).data.customer;
    if (!i.id) {
      const o = (await t.mutate({
        mutation: bq,
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        variables: {
          details: {
            emailAddress: e
          }
        }
      })).data?.customerCreate;
      if (!o)
        throw new Error("Unable to create customer.");
      return this.storeCustomer(o), this.customer = o, {
        customer: o,
        isAuthenticated: !1
      };
    }
    this.storeCustomer(i);
    const a = await this.reloadLoggedInCustomer();
    return {
      customer: this.customer || i,
      isAuthenticated: a
    };
  }
  getCustomer() {
    return this.customer;
  }
  /**
   * Check if a customer is logged in.
   * If they are, set the customer object.
   * This is how we resume sessions between loads.
   */
  async reloadLoggedInCustomer() {
    const e = localStorage.getItem("last-refreshed-cognito-tokens"), t = localStorage.getItem("cognito-tokens"), n = localStorage.getItem("cognito-email");
    if (!e || !t || !n)
      return !1;
    const i = JSON.parse(t), a = (/* @__PURE__ */ new Date()).getTime() / 1e3;
    if (!i.ExpiresIn || i.ExpiresIn < a - parseInt(e)) {
      const u = await up.refreshTokens();
      if (u?.AuthenticationResult)
        localStorage.setItem("last-refreshed-cognito-tokens", `${(/* @__PURE__ */ new Date()).getTime() / 1e3}`), i.AccessToken = u.AuthenticationResult.AccessToken, localStorage.setItem("cognito-tokens", JSON.stringify(i));
      else
        return this.logOut(), console.error("Failed to refresh tokens."), !1;
    }
    const s = localStorage.getItem("customer-login-token");
    s && Qv(s);
    const l = (await et.getShadowGraphqlClient().query({
      query: pA,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        emailAddress: n
      }
    })).data.customer;
    return l.id ? (this.customer = l, !0) : (console.error("Failed to get customer."), !1);
  }
  /**
   * Generate an email code to allow logging in as a Spiff user.
   */
  async generateVerificationCode(e) {
    await et.getShadowGraphqlClient().mutate({
      mutation: Cq,
      variables: {
        emailAddress: e
      }
    }), await up.generateCode(e);
  }
  /**
   * Verify an email code to log in as a Spiff user.
   * Always returns true if it doesn't throw.
   */
  async verifyCode(e, t) {
    const n = (await this.getIntegration()).partner.id || "", i = await up.verifyCode(e, t, n);
    if (i?.AuthenticationResult) {
      localStorage.setItem("last-refreshed-cognito-tokens", `${(/* @__PURE__ */ new Date()).getTime() / 1e3}`), localStorage.setItem("cognito-tokens", JSON.stringify(i.AuthenticationResult)), localStorage.setItem("cognito-email", e);
      const s = (await et.getShadowGraphqlClient().mutate({
        mutation: Sq,
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        variables: {
          emailAddress: e,
          verificationCode: t
        }
      })).data?.customerVerifyCode;
      if (!s?.id)
        throw new Error("Failed to get customer.");
      return this.customer = s, s.loginToken && (localStorage.setItem("customer-login-token", s.loginToken), Qv(s.loginToken)), !0;
    } else
      throw new Error();
  }
  /**
   * Log out the currently logged-in Spiff user.
   */
  async logOut() {
    localStorage.removeItem("last-refreshed-cognito-tokens"), localStorage.removeItem("cognito-tokens"), localStorage.removeItem("cognito-email"), localStorage.removeItem("customer-login-token"), Qv(""), this.clearCustomer();
  }
  // Get a Cognito bearer token from local storage, attempting to refresh if it's old.
  async loggedInBearerToken() {
    const e = localStorage.getItem("last-refreshed-cognito-tokens"), t = localStorage.getItem("cognito-tokens");
    if (!e || !t)
      throw new Error("No token data in storage.");
    const n = JSON.parse(t), i = (/* @__PURE__ */ new Date()).getTime() / 1e3, a = !n?.AccessToken || k0(n.AccessToken);
    if (!n.ExpiresIn || n.ExpiresIn < i - parseInt(e) || a) {
      const s = await up.refreshTokens();
      if (s?.AuthenticationResult)
        localStorage.setItem("last-refreshed-cognito-tokens", `${(/* @__PURE__ */ new Date()).getTime() / 1e3}`), n.AccessToken = s.AuthenticationResult.AccessToken, localStorage.setItem("cognito-tokens", JSON.stringify(n));
      else
        throw this.logOut(), new Error("Failed to refresh tokens.");
    }
    if (!n.AccessToken)
      throw new Error("No bearer token in storage.");
    return n.AccessToken;
  }
  async getCustomerMetafields() {
    if (!this.customer?.id)
      throw new Error("Customer must be logged in before calling this function.");
    return (await et.getShadowGraphqlClient().query({
      query: Eq,
      variables: {
        id: this.customer.id
      }
    })).data.metafields;
  }
  /**
   * @param collectionId Optional: The id of the product collection that the bundle can use.
   * @param options Optional: Options to configure creating the bundle. Set `test` to mark the new bundle as a test bundle.
   * @returns A bundle to be used for grouping and operating on large amounts of workflow experiences.
   */
  async getNewBundle(e, t, n, i) {
    const s = (await et.getShadowGraphqlClient().mutate({
      mutation: GW(n?.graphql?.productCollection?.eagerFetchProducts || !1),
      variables: {
        collectionId: e,
        initialMetadata: t ? Object.entries(t).map((c, h) => ({ key: c[0], value: c[1] })) : void 0,
        marketplaceThemeInstallId: this.marketplaceThemeInstallId,
        marketplaceThemeInstallConfigurationId: this.marketplaceThemeInstallConfigurationId,
        activationId: i,
        test: n?.test
      },
      fetchPolicy: "no-cache"
    })).data?.bundleCreate;
    if (!s?.id)
      throw new Error("Unable to create bundle");
    const o = hn.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    o.set(s.id, s.partner.id), hn.setMap("bundlePartnerIds", o);
    const l = hn.getMap("bundleOwnerIds") || /* @__PURE__ */ new Map();
    l.set(s.id, s.bundleOwnerId), hn.setMap("bundleOwnerIds", l);
    const u = new fT(this, s, void 0, void 0, s.bundleOwnerId, {
      eagerFetchProducts: n?.graphql?.productCollection?.eagerFetchProducts
    });
    return await u.getInitializationPromise(), u;
  }
  /**
   * Retrieves an existing bundle from the API, by id.
   * @param bundleId The id of the bundle to retrieve.
   * @param previewService Optional: A reference to an existing preview service to use. This can be assigned manually later.
   * @param graphqlOptions Optional: Options to configure loading the bundle.
   * @param options Optional: Options to configure loading the bundle.
   * @returns A bundle to be used for grouping and operating on large amounts of workflow experiences.
   */
  async getExistingBundle(e, t, n, i, a) {
    const o = hn.getMap("bundleOwnerIds")?.get(e), l = {};
    try {
      const m = await this.loggedInBearerToken();
      l.Authorization = `Bearer ${m}`;
    } catch {
      const w = Object.entries(localStorage).find(([E, T]) => E.startsWith("CognitoIdentityServiceProvider") && E.endsWith("idToken"))?.[0] || "", x = localStorage.getItem(w);
      x && !k0(x) && (l.Authorization = `Bearer ${x}`);
    }
    const u = {
      bundleOwnerId: o,
      ...l,
      ...i?.graphql?.additionalHeaders
    }, c = await et.getShadowGraphqlClient().query({
      query: UW(i?.graphql?.productCollection?.eagerFetchProducts || !1),
      variables: {
        id: e
      },
      fetchPolicy: "no-cache",
      context: {
        headers: u
      }
    });
    if (!c.data?.bundles || c.data?.bundles.length === 0 || !c.data?.bundles[0])
      throw new Error(`Unable to find bundle: ${e}`);
    const h = c.data?.bundles[0], f = hn.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    f.set(h.id, h.partner.id), hn.setMap("bundlePartnerIds", f);
    const p = new fT(
      this,
      h,
      t,
      n,
      o,
      {
        additionalHeaders: i?.graphql?.additionalHeaders,
        eagerFetchProducts: i?.graphql?.productCollection?.eagerFetchProducts,
        existingGlobalPropertyState: c.data.globalPropertyState,
        readonly: i?.readonly
      },
      a
    );
    return await p.getInitializationPromise(), p;
  }
  /**
   * @param bundleId The id of the bundle to copy. The current context must have write access to the this bundle in order to duplicate it.
   * @param template Optional: Whether to mark the new bundle as a template. Default is false.
   * @param duplicateTransactions Optional: Whether to also duplicate the original bundle's transactions. Default is true.
   * @param options Optional: Options to configure the duplicate. Set `test` to mark the new bundle as a test bundle; defaults to the source bundle's value.
   * @returns A bundle to be used for grouping and operating on large amounts of workflow experiences.
   */
  async duplicateBundle(e, t, n, i) {
    const s = {
      ...await hO(e),
      ...i?.graphql?.additionalHeaders
    }, l = (await et.getShadowGraphqlClient().mutate({
      mutation: HW(),
      variables: {
        id: e,
        template: t,
        marketplaceThemeInstallId: this.marketplaceThemeInstallId,
        marketplaceThemeInstallConfigurationId: this.marketplaceThemeInstallConfigurationId,
        duplicateTransactions: n,
        test: i?.test
      },
      context: {
        headers: s
      },
      fetchPolicy: "no-cache"
    })).data?.bundleDuplicate;
    if (!l?.id)
      throw new Error("Unable to duplicate bundle");
    const u = hn.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    u.set(l.id, l.partner.id), hn.setMap("bundlePartnerIds", u);
    const c = hn.getMap("bundleOwnerIds") || /* @__PURE__ */ new Map();
    return c.set(l.id, l.bundleOwnerId), hn.setMap("bundleOwnerIds", c), async () => await this.getExistingBundle(l.id, void 0, void 0, {
      graphql: {
        productCollection: {
          eagerFetchProducts: i?.graphql?.productCollection?.eagerFetchProducts || !1
        }
      }
    });
  }
  /**
   * Fetches information about the currently authenticated customer's bundles.
   * NOTE: This does not initialize a bundle for active use.
   * You must call either `getExistingBundle` or `duplicateBundle` to actually interact with a bundle.
   * @param options Options to configure the request.
   * @returns A promise that resolves with an object containing:
   * `items` - The bundles that matched the request.
   * `total` - The total number of bundles on the server that match this query.
   */
  async getBundlesForCustomer(e) {
    if (!this.customer?.id)
      throw new Error("Customer not authenticated.");
    const { includeMetadata: t, ...n } = e;
    return (await et.getShadowGraphqlClient().query({
      query: tj(t ?? !1),
      variables: {
        ...n,
        id: this.customer.id
      },
      fetchPolicy: "no-cache"
    })).data.customerBundlesFeed;
  }
  /**
   * Fetches information about the currently authenticated customer's bundles.
   */
  async getTemplatesForCustomer(e) {
    if (!this.customer?.id)
      throw new Error("Customer not authenticated.");
    const t = await et.getShadowGraphqlClient().query({
      query: cq,
      variables: {
        ...e,
        customerId: this.customer.id
      },
      fetchPolicy: "no-cache"
    });
    return {
      total: t.data.globalPropertyTemplatesFeed.total,
      items: t.data.globalPropertyTemplatesFeed.items.map((n) => new mx(n, this))
    };
  }
  /**
   * Retrieves all existing bundle stakeholders from the API, for the currently authenticated customer.
   * @returns An array of bundle stakeholders.
   */
  async getBundleStakeholders() {
    if (!this.customer)
      throw new Error("Customer not authenticated.");
    const e = await et.getShadowGraphqlClient().query({
      query: VW,
      variables: {
        id: this.customer.id
      },
      fetchPolicy: "no-cache"
    });
    if (!e.data?.customers || e.data.customers.length === 0)
      throw new Error("Unable to find customer.");
    const n = e.data.customers[0].bundleStakeholders || [], i = hn.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    return n.forEach((a) => {
      a.bundle?.id && a.bundle.partner?.id && i.set(a.bundle.id, a.bundle.partner.id);
    }), hn.setMap("bundlePartnerIds", i), n;
  }
  /**
   * Creates a new instance of WorkflowExperience. A high level wrapper for workflows.
   * @param options Options to configure loading the transaction and workflow.
   * @param previewServiceConstructor A function called during initialization. Takes a class implementing ThreeDPreviewService in return.
   * @returns A workflow experience configured as requested.
   */
  async getWorkflowExperience(e, t) {
    if (!e)
      throw new Error("getWorkflowExperience has been called without an options object! This is not supported.");
    const n = await this.getWorkflowExperiences([e], e.graphql), i = n[0], a = i.getWorkflow();
    return t && !a && console.error("No workflow instantiated when trying to create preview service."), t && a && await i.getWorkflowManager().injectIntoPreviewService(t(a)), n[0];
  }
  /**
   * Gets multiple workflow experiences at once.
   * @param optionsArray An array of options to configure loading the transactions and workflows.
   * NOTE: The `previewService` field on the option is currently unsupported in this function, as loading multiple models at once will likely cause performance issues.
   * @param graphqlOptions Options to configure loading the workflows.
   * @returns An array of workflow experiences configured as requested.
   */
  async getWorkflowExperiences(e, t, n, i) {
    if (e.length === 0)
      throw new mc("No options provided!");
    const a = e.map((H, j) => ({ option: H, index: j })), s = a.filter((H) => H.option.type === "transaction"), o = a.filter(
      (H) => H.option.type === "integration" || H.option.type === "external" || H.option.type === "blank"
    ), l = 50, u = Q1(s, l), c = Q1(o, l);
    let h = 0;
    const f = et.getShadowGraphqlClient(), p = async (H) => {
      if (H.length === 0)
        return [];
      const j = H.map((ae) => ae.option.transactionId), q = await f.query({
        query: bL,
        variables: {
          ids: j
        },
        errorPolicy: "all",
        fetchPolicy: "no-cache"
      }), re = q.data.transactions;
      if (h = h + re.length, i && i(h, s.length), re.length !== H.length) {
        const ae = q.errors?.[0]?.message || "Unknown error";
        throw new mc(`Not all transactions were found: ${ae}`);
      }
      return !this.activeIntegration && re[0].integrationProduct?.integration && (this.activeIntegration = Promise.resolve(re[0].integrationProduct.integration)), re.map((ae, ye) => ({
        transaction: ae,
        workflowId: ae.workflowId,
        readOnly: H.find((Se) => Se.option.transactionId === ae.id)?.option.readOnly ?? !1,
        index: H[ye].index
      }));
    }, m = async (H) => {
      if (H.length === 0)
        return [];
      const j = await f.mutate({
        mutation: xL,
        variables: {
          inputs: H.map((re) => ({
            integrationProductId: re.option.type === "integration" ? re.option.integrationProductId : void 0,
            externalIntegrationId: re.option.type === "external" ? re.option.externalIntegrationId : void 0,
            externalProductId: re.option.type === "external" ? re.option.externalProductId : void 0,
            workflowId: re.option.workflowId,
            designName: re.option.designName,
            claim: !0,
            quantity: re.option.quantity,
            recipient: re.option.recipient,
            parentTransactionId: re.option.parentTransactionId
          })),
          marketplaceThemeInstallId: this.marketplaceThemeInstallId,
          marketplaceThemeInstallConfigurationId: this.marketplaceThemeInstallConfigurationId
        },
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        context: this.getCreateTransactionContext(H, t)
      }), q = j.data?.transactionCreateMany;
      if (!q || q.length === 0) {
        const re = j.errors?.[0]?.message || "Unknown error";
        throw new mc(`Failed to create transactions: ${re}`);
      }
      return h = h + q.length, i && i(h, s.length), q.map((re, ae) => ({
        transaction: re,
        workflowId: re.workflowId,
        readOnly: !1,
        index: H[ae].index
      }));
    }, A = (await Promise.all([
      ...u.map(p),
      ...c.map(m)
    ])).flat();
    let w = [
      ...new Set(A.map((H) => H.transaction.integrationProductId))
    ].filter((H) => !!H);
    w = w.filter((H) => !!H);
    let x = [...new Set(A.map((H) => H.workflowId))].filter((H) => !!H);
    x = x.filter((H) => !!H);
    const [E, T] = await Promise.all([
      (async () => w.length > 0 ? await fO(w) : [])(),
      (async () => x.length > 0 ? await uO(x, t) : [])()
    ]), D = new Map(E.map((H) => [H.id, H])), F = new Map(T.map((H) => [H.id, H])), _ = A.map(async (H) => {
      const { transaction: j, workflowId: q, readOnly: re, index: ae } = H, ye = q ? F.get(q) : void 0, Se = e[ae];
      if (j.integrationProductId) {
        const ve = D.get(j.integrationProductId);
        j.integrationProduct = ve, j.product = ve?.product, j.integrationProduct || console.error("failed to find transaction's product");
      }
      const Xe = hn.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map();
      !Xe.get(j.id) && j.transactionOwnerId && (Xe.set(j.id, j.transactionOwnerId), hn.setMap("transactionOwnerIds", Xe));
      const Ve = Xe.get(j.id) || void 0, He = new kq({
        onMutate: () => ({ context: { transactionOwnerId: Ve, bundleOwnerId: t?.bundleOwnerId } }),
        onQuery: () => ({ context: { transactionOwnerId: Ve, bundleOwnerId: t?.bundleOwnerId } })
      }), le = {
        workflow: ye,
        transaction: j,
        singleVariantsRenderable: Se?.workflowConfiguration?.singleVariantsRenderable,
        stateMutationFunc: re ? async () => {
          throw new si("State mutation is forbidden in read only mode!");
        } : async (ve) => this.updateTransactionState({
          ...ve,
          context: { transactionOwnerId: Ve, bundleOwnerId: t?.bundleOwnerId }
        }),
        graphQlClient: () => He,
        readOnly: re,
        isReloadedTransaction: Se.type === "transaction"
      };
      if (Se.type === "transaction" && j.workflowState) {
        const ve = JSON.parse(j.workflowState);
        await ak(ve), le.reloadedState = ve;
      } else if (!re && Se.workflowState) {
        const ve = JSON.parse(Se.workflowState);
        await ak(ve), le.reloadedState = ve;
      }
      return le.delayWorkflowStateSync = !0, { experienceOptions: le, index: ae, options: Se };
    }), Z = (await Promise.all(_)).sort((H, j) => H.index - j.index);
    let te = [], de = [];
    for (const H of Z) {
      const { experienceOptions: j, options: q } = H, re = new tR(this, j);
      await re.getWorkflowManager().getInitializationPromise(), n && n(), q.type !== "transaction" && this.customer && de.push(re), te = [...te, re], re.getWorkflowManager().setWorkflowStateSyncEnabled(!0);
    }
    if (de.length > 0) {
      const H = this.customer.emailAddress, j = de.map((ae) => ae.getTransaction().id), re = (await f.mutate({
        mutation: Vj,
        variables: {
          ids: j,
          details: { emailAddress: H },
          type: "Owner"
        },
        errorPolicy: "all"
      })).data?.transactionsAddStakeholder;
      if (re && re?.length > 0) {
        const ae = re[0].stakeholders?.find((ye) => ye.customer?.emailAddress === H);
        if (ae?.customer)
          for (const ye of de)
            ye.assignCustomerInternal(ae.customer);
      }
    }
    return te;
  }
  getCreateTransactionContext(e, t) {
    const n = e.find((s) => s.option.parentTransactionId)?.option.parentTransactionId;
    if (!n && !t?.bundleOwnerId) return;
    const i = hn.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map(), a = n ? i.get(n) : void 0;
    return {
      ...a ? { transactionOwnerId: a } : {},
      ...t?.bundleOwnerId ? { bundleOwnerId: t.bundleOwnerId } : {}
    };
  }
  storeCustomer(e) {
    const t = hn.getMap("partnerCustomerIds") || /* @__PURE__ */ new Map();
    t.set(e.partner.id, e.id), hn.setMap("partnerCustomerIds", t);
  }
  async getIntegrationProductById(e, t) {
    const a = (await et.getShadowGraphqlClient().query({
      query: PL(t),
      variables: {
        ids: [e]
      },
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    })).data?.integrationProducts;
    if (!a || a.length === 0 || !a[0]?.id)
      throw new Error("Integration product not found.");
    return new dT(a[0]);
  }
  async getIntegrationProductFromExternalIds(e, t, n) {
    const s = (await et.getShadowGraphqlClient().query({
      query: DL(n),
      variables: {
        externalProductId: t,
        externalIntegrationId: e
      },
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    })).data?.integrationProductFromExternalIds;
    if (!s?.id)
      throw new Error("Integration product not found.");
    return new dT(s);
  }
  async getIntegrationProduct(e) {
    return e.type === "integration" ? this.getIntegrationProductById(e.integrationProductId) : this.getIntegrationProductFromExternalIds(e.externalIntegrationId, e.externalProductId);
  }
  async getShareActionsForTransaction(e) {
    const n = (hn.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(e) || void 0, i = await et.getShadowGraphqlClient().query({
      query: FL,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: e
      },
      context: {
        transactionOwnerId: n
      }
    });
    if (!i.data.transactions || i.data.transactions.length !== 1)
      throw new Error(`Failed to fetch share actions for transaction: ${e}`);
    return i.data.transactions[0].transactionShareActions;
  }
  async placeOrder(e) {
    const t = await et.getShadowGraphqlClient().mutate({
      mutation: GL,
      variables: {
        orderItems: e
      }
    });
    if (t.errors)
      throw new Error(t.errors[0].message);
    if (!t.data)
      throw new Error("Failed to create order: No order data in response.");
    return {
      id: t.data.orderCreate.id,
      internalId: t.data.orderCreate.internalId
    };
  }
}
const jte = async (r, e) => (await et.getShadowGraphqlClient().query({
  query: VL,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  context: {
    headers: {
      "x-application-key": r
    },
    skipIntegrationCheck: !0
  },
  variables: {
    themeConfigurationId: e
  }
})).data.currentIntegration, mne = async (r) => {
  const t = await et.getShadowGraphqlClient().query({
    query: TL,
    errorPolicy: "all",
    fetchPolicy: "network-only",
    variables: {
      id: r
    }
  });
  if (t.data.transactions.length !== 0)
    return t.data.transactions[0];
}, vne = async (r, e) => (await et.getShadowGraphqlClient().query({
  query: UL,
  errorPolicy: "all",
  variables: {
    themeConfigurationId: r,
    themeInstallId: e
  }
})).data?.marketplaceThemeInstallConfiguration, yne = async (r) => (await et.getShadowGraphqlClient().query({
  query: zL,
  errorPolicy: "all",
  variables: {
    id: r
  }
})).data?.bundles?.[0]?.marketplaceThemeInstallConfiguration, Ane = async (r) => (await et.getShadowGraphqlClient().query({
  query: $L,
  errorPolicy: "all",
  variables: {
    id: r
  }
})).data?.transactions?.[0]?.marketplaceThemeInstallConfiguration, qte = async (r, e) => (await et.getShadowGraphqlClient().query({
  query: qL(!!e),
  errorPolicy: "all",
  variables: {
    id: r,
    productIds: e
  }
})).data?.activation, wne = async (r) => (await qte(r))?.marketplaceThemeInstallConfiguration;
async function dO() {
  const r = {};
  try {
    const e = await this.loggedInBearerToken();
    r.Authorization = `Bearer ${e}`;
  } catch {
    const n = Object.entries(localStorage).find(([a, s]) => a.startsWith("CognitoIdentityServiceProvider") && a.endsWith("idToken"))?.[0] || "", i = localStorage.getItem(n);
    i && !k0(i) && (r.Authorization = `Bearer ${i}`);
  }
  return r;
}
async function hO(r) {
  const t = hn.getMap("bundleOwnerIds")?.get(r), n = await dO();
  return {
    bundleOwnerId: t,
    ...n
  };
}
async function Qte(r) {
  const t = hn.getMap("transactionOwnerIds")?.get(r), n = await dO();
  return {
    transactionOwnerId: t,
    ...n
  };
}
const xne = async (r) => {
  const e = await hO(r), t = await et.getShadowGraphqlClient().mutate({
    mutation: cj,
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    variables: {
      id: r
    },
    context: {
      headers: e
    }
  });
  if (t.data?.bundleDelete !== r)
    throw new Error(`Failed to delete bundle: ${t.errors}`);
}, bne = async (r) => {
  const e = await Qte(r), t = await et.getShadowGraphqlClient().mutate({
    mutation: fj,
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    variables: {
      ids: [r]
    },
    context: {
      headers: e
    }
  });
  if (!t.data?.transactions || t.data.transactions.length !== 1 || t.data.transactions[0].id !== r)
    throw new Error(`Failed to find transaction to read bundle id: ${JSON.stringify(t.errors)}`);
  return t.data.transactions[0].bundle?.id;
};
function Yte(r, e, t, n) {
  const i = t.width * r.zoom, a = t.height * r.zoom;
  if (n) {
    const s = Math.max(e.width / t.width, e.height / t.height), o = Math.max(s, r.zoom), l = t.width * o, u = t.height * o;
    return {
      ...r,
      x: Rm(r.x, e.width - l, 0),
      y: Rm(r.y, e.height - u, 0),
      zoom: o
    };
  }
  return {
    ...r,
    x: Rm(r.x, -i, e.width),
    y: Rm(r.y, -a, e.height)
  };
}
function Rm(r, e, t) {
  return Math.min(Math.max(r, e), t);
}
class Xte {
  constructor(e, t) {
    this.minZoomScale = [0.03], this.maxZoomScale = [20], this._debouncedUpdateFrameOffsets = W0(this.updateFrameOffsets, 200), this.targetElements = [], this.onFrameDataChangeListeners = [], this.onZoomChangeListeners = [], this.onRotationChangeListeners = [], this.forceImageCover = e, this.initialZoom = t, this.thresholdSettings = {
      useThreshold: !1,
      invertThreshold: !1,
      threshold: 128,
      thresholdSaturation: 0.5
    };
  }
  /**
   * When we want to connect a workflow manager to the state of the image cropper we
   * can pass it to this function. Inside we'll attach any required event listeners.
   * @param workflowManager The workflow manager to attach.
   * @param stepName The specific step we want to attach to within the manager.
   */
  connectWorkflowManager(e, t) {
    t && e.addStepSpecificStorageCallback(async (n) => {
      if (n) {
        const i = n;
        if (i.currentFrameSources) {
          let a = !1;
          for (let s = 0; s < i.currentFrameSources.length; s++) {
            const o = i.currentFrameSources[s], l = await Q0(o), u = this.frameData ? this.frameData[s] : void 0;
            g0(l, u) || (this.frameData || (this.frameData = new Array(i.currentFrameSources.length)), this.frameData[s] = l, a = !0);
          }
          a && (this.onFrameDataChangeListeners.forEach(
            (s) => s(this.frameData)
          ), this.frameData && this.imageData && (this.recalculateOffsets(this.imageData), this.updateOffsets(this.offsets), this.recalculateZoomLimits(this.imageData, this.frameData)));
        }
      }
    }, t), this.workflowManager = e, this.stepName = t;
  }
  /**
   * Sets the elements that should be update when changes are made to
   * the cropper that owns this service.
   * @param targetElements A list of element Ids to track
   */
  setTargetElements(e) {
    this.targetElements = e;
  }
  /**
   * Gets the current calculated frame data
   * @returns A FrameData object or undefined if no frame has been set.
   */
  getFrameData() {
    return this.frameData;
  }
  /**
   * Sets the current frame data. Note:
   * @param paths The paths to lookup in our frame data cache.
   */
  setFrameData(e) {
    if (!e) {
      this.frameData = void 0;
      return;
    }
    e.forEach((t, n) => {
      const i = wp.get(t);
      i && (this.frameData || (this.frameData = new Array(e.length)), this.frameData[n] = i);
    });
  }
  /**
   * Gets the currently set image of the frame..
   * @returns A PatternImageData object, or undefined if no image is set.
   */
  getImageData() {
    return this.imageData;
  }
  /**
   * Helper function to get the src of the image of the frame, since it can be an svg with modified colors.
   * @returns A url (a data url if svg), or undefined if no image is set.
   */
  getImageSrc() {
    if (this.imageData) {
      if (this.imageData.svg) {
        const e = Vw(this.imageData.svg, this.imageData.colors || {}, !1);
        return Iw(e);
      }
      return this.imageData.src;
    }
  }
  /**
   * Gets the current calculated offsets of the pattern within the frame.
   * @returns A FrameOffsets object or undefined if no offsets are defined.
   */
  getOffsets() {
    return this.offsets;
  }
  /**
   * Updates the frame offsets explicitly.
   */
  setOffsets(e) {
    this.offsets = e;
  }
  /**
   * Sets the zoom of the cropper that owns this service.
   * @param zoom The new zoom value, per frame.
   * @param cX The center of zoom on x axis, per frame.
   * @param cY The center of zoom on Y axis, per frame.
   * @param onComplete A function to call when zoom changes have been completed
   */
  setZoom(e, t, n, i) {
    if (this.imageData && this.offsets && this.frameData) {
      (!this.offsets || this.offsets.length !== this.frameData.length) && (this.offsets = new Array(this.frameData.length));
      const a = this.frameData.map((s, o) => {
        const l = (t[o] - this.offsets[o].x) / this.offsets[o].zoom, u = (n[o] - this.offsets[o].y) / this.offsets[o].zoom, c = t[o] - l * e[o], h = n[o] - u * e[o];
        return {
          x: c,
          y: h,
          zoom: this.imageData.width * e[o] / this.imageData.width,
          rotation: this.offsets[o].rotation
        };
      });
      this.updateOffsets(a, i), this.onZoomChangeListeners.forEach((s) => s(e));
    }
  }
  /**
   * Sets the rotation of the pattern within the frame
   * @param rotation The new rotation value in degrees, per frame
   * @param onComplete A function to call when rotation changes have been completed
   */
  setRotation(e, t) {
    if (this.imageData && this.offsets && this.frameData) {
      (!this.offsets || this.offsets.length !== this.frameData.length) && (this.offsets = new Array(this.frameData.length));
      const n = this.frameData.map((i, a) => ({
        ...this.offsets[a],
        rotation: e[a]
      }));
      this.updateOffsets(n, t), this.onRotationChangeListeners.forEach((i) => i(e));
    }
  }
  /**
   * Sets the image currently contained by this frame.
   * @param value The new image as an ImageData property
   * @param [recalculateOffsets=true] Optional: Enable/disable re-calculating of frame offsets. Default: `true`.
   * Note: Will always calculate when offsets have not been calculated.
   */
  setPatternData(e, t = !0) {
    this.imageData = e, e && this.frameData && ((t || !this.offsets) && this.recalculateOffsets(e, t), this.updateOffsets(this.offsets, void 0, !0)), this.imageData && this.frameData && this.recalculateZoomLimits(this.imageData, this.frameData);
  }
  /**
   * Modify the offsets of the frame.
   * @param value The new FrameOffsets objects.
   * @param onComplete A callback, called when the modification is complete
   * @param forceUpdate When true the offsets will be updated even if they haven't changed.
   */
  updateOffsets(e, t, n) {
    const i = this.imageData;
    if (!i || !this.frameData)
      return;
    if (this.frameData.length !== e.length)
      throw new si(
        "Frame data and offsets are not the same length. This is a bug. Please report it."
      );
    if (!this.offsets.some((s, o) => !(e[o].x === s.x && e[o].y === s.y && e[o].zoom === s.zoom && e[o].rotation === s.rotation)) && !n) {
      t && t();
      return;
    }
    (!this.offsets || this.offsets.length !== this.frameData.length) && (this.offsets = new Array(this.frameData.length)), this.frameData.forEach((s, o) => {
      this.offsets[o] = Yte(e[o], s, this.imageData, this.forceImageCover);
    }), this._debouncedUpdateFrameOffsets(
      this.offsets,
      i,
      this.frameData,
      this.thresholdSettings,
      t
    );
  }
  getThresholdSettings() {
    return this.thresholdSettings;
  }
  setThresholdSettings(e) {
    this.thresholdSettings = e, this.imageData && this.frameData && this._debouncedUpdateFrameOffsets(this.offsets, this.imageData, this.frameData, e);
  }
  // Allows users of the frame service to listen to frame data changes.
  onFrameDataChanged(e) {
    e(this.frameData), this.onFrameDataChangeListeners.push(e);
  }
  /**
   * Append a new listener to zoom events on this frame.
   * @param newListener
   */
  onZoom(e) {
    this.onZoomChangeListeners.push(e);
  }
  /**
   * Append a new listener to rotation events on this frame.
   * @param newListener
   */
  onRotation(e) {
    this.onRotationChangeListeners.push(e);
  }
  /**
   * Updates the offsets of the frame
   * @param newOffsets New offset object
   * @param imageData The image data
   * @param frameData The frame data
   * @param targetElements A list of elements that need updating, by ID
   * @param onComplete A callback when the operation is completed.
   */
  updateFrameOffsets(e, t, n, i, a) {
    if (!n || n.length === 0 || n.some((l) => !l))
      throw new si("Frame data not set. This is a bug");
    if (!this.workflowManager) throw new si("No workflow manager set, cannot update offsets.");
    const s = this.workflowManager.getRegionElements(this.stepName || ""), o = this.workflowManager.getCommandDispatcher();
    this.targetElements.forEach((l, u) => {
      let c = s.find((h) => h.id === l)?.regionIndex ?? u;
      c >= e.length && (c = u);
      try {
        o(
          new Ii([
            new eH(l, t, e[c]),
            new tH(
              l,
              i.useThreshold,
              i.invertThreshold,
              i.threshold,
              i.thresholdSaturation
            )
          ])
        );
      } catch {
      }
    }), this.stepName && this.workflowManager.updateStorage(this.stepName, {
      frameOffsetsList: e
    }), a && a();
  }
  /**
   * Determines limitations of zoom based on relative size of image and frame.
   * @param imageData The image to include in calculations
   * @param frameData The frame to include in calculations.
   */
  recalculateZoomLimits(e, t) {
    (this.minZoomScale.length !== t.length || this.maxZoomScale.length !== t.length) && (this.minZoomScale = new Array(t.length), this.maxZoomScale = new Array(t.length)), t.forEach((n, i) => {
      const a = Math.max(n.width / e.width, n.height / e.height);
      this.forceImageCover ? (this.minZoomScale[i] = a, this.maxZoomScale[i] = a * 2.5) : (this.minZoomScale[i] = a / 10, this.maxZoomScale[i] = a * 2.5);
    });
  }
  recalculateOffsets(e, t = !0) {
    this.frameData && ((!this.offsets || this.offsets.length !== this.frameData.length) && (this.offsets = new Array(this.frameData.length)), this.frameData.forEach((n, i) => {
      const a = t ? 0 : this.offsets[i]?.rotation || 0;
      this.offsets[i] = {
        ...fx(
          e,
          n,
          this.initialZoom && !this.forceImageCover ? { scale: this.initialZoom } : void 0,
          this.forceImageCover
        ),
        rotation: a
      };
    }), this._debouncedUpdateFrameOffsets(this.offsets, e, this.frameData, this.thresholdSettings));
  }
}
class Cne {
  traversableScenes() {
    throw new Error("Method not implemented.");
  }
  updateRecipient(e, t, n, i, a, s, o, l, u, c, h, f, p, m, A, w, x) {
    throw new Error("Method not implemented.");
  }
  approveTransaction(e) {
    throw new Error("Method not implemented.");
  }
  rejectTransaction(e) {
    throw new Error("Method not implemented.");
  }
  getClient() {
    return this.client ?? {};
  }
  getWorkflowExperience() {
    return {};
  }
  setClient(e) {
    this.client = e;
  }
  getInitializationPromise() {
    return Promise.resolve();
  }
  async updateWorkflowConfiguration(e) {
    throw new Error("Method not implemented.");
  }
  isInitialized() {
    return !0;
  }
  getInformationResults() {
    return [];
  }
  async reset() {
  }
  updateStateWithServer(e) {
  }
  async outstandingRequestsPromise() {
  }
  async updateStateWithServerImmediate(e) {
  }
  addPoller(e) {
  }
  addConfirmCallback(e) {
  }
  addEditedCallback(e) {
  }
  addElementsCallback(e) {
  }
  addInformationResultCallback(e) {
  }
  addInitCallback(e) {
  }
  addMakingAdjustmentsCallback(e) {
  }
  addMandatoryCallback(e) {
  }
  addMetadataCallback(e) {
  }
  addSelectionCallback(e) {
  }
  addStepSpecificStorageCallback(e, t) {
  }
  addStorageCallback(e) {
  }
  getCommandDispatcher() {
    return (e) => {
    };
  }
  getLayouts() {
    return [];
  }
  getLayoutPreviewService() {
    return {
      getAll: () => /* @__PURE__ */ new Map()
    };
  }
  getPreviewService() {
  }
  getModelContainer() {
  }
  getRegionElements(e) {
    return [];
  }
  getSerializedStep(e, t) {
  }
  getStepSpecificServices(e) {
  }
  getTransaction() {
    return {
      id: ""
    };
  }
  getTransactionCustomer() {
  }
  setTransactionCustomer() {
  }
  setTransactionCustomerDetails() {
  }
  getInitialOptionIds() {
    return new Promise(() => /* @__PURE__ */ new Set());
  }
  getWorkflow() {
    return {
      id: "",
      name: "",
      panels: [],
      steps: [],
      showModelOnFinishStep: !1,
      allowProofDownload: !1,
      introduction: "",
      stepGroups: []
    };
  }
  markStepsAsInitialised(e) {
  }
  markUpdateCompleted(e) {
  }
  markUpdatePending() {
    return "123";
  }
  getWorkflowSelections() {
    return {};
  }
  getStepSelections() {
    return {};
  }
  setCurrentAdjustingStepId(e) {
  }
  setEditedStatus(e, t) {
  }
  setInformationResults(e) {
  }
  setMandatoryFulfilled(e, t) {
  }
  async setSelectionsAndElements(e, t, n) {
  }
  toggleDesignConfirmed() {
  }
  updateMetadata(e, t) {
  }
  async updateStorage(e, t) {
  }
  injectIntoPreviewService(e) {
    return Promise.resolve();
  }
  ejectFromPreviewService() {
  }
  setWorkflowStateSyncEnabled(e) {
  }
  async updateTransactionShareActions() {
  }
  addValidationCallback(e) {
  }
  setStepError(e, t, n) {
  }
  getStepErrors(e) {
  }
  getValidationErrors() {
    return { steps: /* @__PURE__ */ new Map() };
  }
  async updateTransactionStakeholders() {
  }
  getStepTags(e) {
    return [];
  }
}
var Jte = /* @__PURE__ */ ((r) => (r.SelectFrame = "SelectFrame", r.SelectImage = "SelectImage", r.Position = "Position", r))(Jte || {}), Kte = /* @__PURE__ */ ((r) => (r.Original = "original", r.BackgroundRemoved = "backgroundRemoved", r.Optimized = "optimized", r))(Kte || {});
class Zte extends Fs {
  constructor(e, t, n) {
    super(e, t, n);
    const i = t.data;
    this.frameService = new Xte(i.forceImageCover, i.initialZoomLevel), this.frameService.connectWorkflowManager(e, t.stepName);
  }
  selectVariant(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    return Sf.selectVariant(
      this.step,
      e.getResource(),
      t,
      this.manager,
      (n) => this.setUpdateState(n)
    );
  }
  onFrameDataChanged(e) {
    this.frameService && this.frameService.onFrameDataChanged((t) => {
      t && e(t);
    });
  }
  /**
   * Updates the image selection inside the frame.
   * @param asset The asset to use.
   * @param storeAsOriginal Optional: Store this asset as the original, unmodified version of the image. Default: `true`.
   * @param [recalculateOffsets=true] Optional: Recalculates the offsets of the image inside the frame. Default: `true`.
   */
  async selectImage(e, t = !0, n = !0) {
    await Sf.selectImage(this.step, e, this.manager, n), t && this.manager.updateStorage(this.step.stepName, {
      framePatternData: {
        originalAssetKey: e.key,
        backgroundRemovedAssetKey: void 0,
        vectorizedAssetKey: void 0,
        enhancedAssetKey: void 0,
        useOriginalAsset: void 0
      }
    });
  }
  /**
   * Returns `true` if the Advanced Image Manipulation addon is available for the current session.
   */
  async canUseAdvancedImageManipulation() {
    return this.manager.getClient().canUseAddon(Fw.AdvancedImageManipulation);
  }
  /**
   * Returns `true` if the Background Remover is available for the current session and if the associated frame has a user-supplied raster image.
   */
  async canRemoveBackground() {
    return await this.canUseAdvancedImageManipulation() && this.hasOriginalImageSelection() && !!this.frameService?.getImageData()?.src && !this.frameService?.getImageData()?.svg;
  }
  /**
   * Removes the background from an image, stores it in the state, and returns the new asset.
   * @param applyNewAsset Optionally applies the new asset as the current image selection. Default: `true`.
   * @returns A promise that resolves with the newly generated Asset.
   */
  async removeBackgroundFromImageSelection(e = !0) {
    if (!await this.canUseAdvancedImageManipulation())
      throw new Error(
        "The current Integration does not have access to the Background Remover. Please call canUseAdvancedImageManipulation to ensure you disable this feature when appropriate."
      );
    const t = await this.getOriginalImageSelection();
    if (!t)
      throw new Error("You must supply an image selection before attempting to remove the background.");
    const n = await Si.removeBackgroundFromAsset(t);
    e && await Sf.selectImage(this.step, n, this.manager, !1);
    const i = this.getFrameStepStorage()?.framePatternData || {};
    return this.manager.updateStorage(this.step.stepName, {
      framePatternData: {
        ...i,
        backgroundRemovedAssetKey: n.key,
        useOriginalAsset: !e
      }
    }), n;
  }
  /**
   * Takes an asset and vectorizes it, stores the new asset in the state, and returns the new asset.
   * @param asset An optional asset to use for vectorization. If not supplied, the method will attempt to vectorize the current image selection. If there is no current image selection, the method will throw an error.
   * @returns The newly vectorized asset.
   */
  async vectorize(e, t = void 0) {
    const n = e ?? await this.getOriginalImageSelection();
    if (!n)
      throw new Error("You must supply an image selection before attempting to vectorize the image.");
    const i = await Si.vectorizeAsset(n, t);
    await this.selectImage(i, !1);
    const a = this.getFrameStepStorage()?.framePatternData || {};
    return this.manager.updateStorage(this.step.stepName, {
      framePatternData: {
        ...a,
        vectorizedAssetKey: i.key,
        useOriginalAsset: !1
      }
    }), i;
  }
  /**
   * Takes an asset and enhances it using AI, stores the new asset in the state, and returns the new asset.
   * @param asset An optional asset to use for enhancement. If not supplied, the method will attempt to enhance the current image selection. If there is no current image selection, the method will throw an error.
   * @param options Optional enhancement options including quality, dimensions, and AI parameters.
   * @returns The newly enhanced asset.
   */
  async enhanceWithAI(e, t) {
    const n = e ?? await this.getOriginalImageSelection();
    if (!n)
      throw new Error("You must supply an image selection before attempting to enhance the image with AI.");
    const i = await Si.enhanceWithAI(n, t);
    await this.selectImage(i, !1);
    const a = this.getFrameStepStorage()?.framePatternData || {};
    return this.manager.updateStorage(this.step.stepName, {
      framePatternData: {
        originalAssetKey: a.originalAssetKey,
        backgroundRemovedAssetKey: a.backgroundRemovedAssetKey,
        vectorizedAssetKey: a.vectorizedAssetKey,
        enhancedAssetKey: i.key,
        useOriginalAsset: !1
      }
    }), i;
  }
  /**
   * @returns The asset representing the image with its background removed. If there is no such image, returns `undefined`.
   */
  async getBackgroundRemovedImageSelection() {
    const e = this.getFrameStepStorage()?.framePatternData?.backgroundRemovedAssetKey;
    if (e)
      return Si.getLocalOrFromServer(e);
  }
  /**
   * @returns The asset representing the vectorized version of the image. If there is no such image, returns `undefined`.
   */
  async getVectorizedImageSelection() {
    const e = this.getFrameStepStorage()?.framePatternData?.vectorizedAssetKey;
    if (e)
      return Si.getLocalOrFromServer(e);
  }
  /**
   * @returns The asset representing the AI-enhanced version of the image. If there is no such image, returns `undefined`.
   */
  async getEnhancedImageSelection() {
    const e = this.getFrameStepStorage()?.framePatternData?.enhancedAssetKey;
    if (e)
      return Si.getLocalOrFromServer(e);
  }
  /**
   * @returns Returns true when an initial asset upload was received from the user.
   */
  hasOriginalImageSelection() {
    return !!this.getFrameStepStorage()?.framePatternData?.originalAssetKey;
  }
  /**
   * @returns True when a background removed version of the original image exists in the state, regardless of whether it is currently applied as the image selection or not.
   */
  hasBackgroundRemovedImageSelection() {
    return !!this.getFrameStepStorage()?.framePatternData?.backgroundRemovedAssetKey;
  }
  /**
   * @returns True when a vectorized version of the original image exists in the state, regardless of whether it is currently applied as the image selection or not.
   */
  hasVectorizedImageSelection() {
    return !!this.getFrameStepStorage()?.framePatternData?.vectorizedAssetKey;
  }
  /**
   * @returns True when an AI-enhanced version of the original image exists in the state, regardless of whether it is currently applied as the image selection or not.
   */
  hasEnhancedImageSelection() {
    return !!this.getFrameStepStorage()?.framePatternData?.enhancedAssetKey;
  }
  /**
   * Updates the colors on the currently displayed image. Only applicable to an SVG image with identifiable colors or a raster image with the color picker enabled.
   * @returns A promise that resolves when the colors have been updated on the image.
   */
  async changeColors(e) {
    await Sf.changeColors(this.step, this.manager, e);
  }
  /**
   * @returns The PatternImageData for the current frame, which includes information about the image currently in the frame such as whether it's an SVG or raster image, its dimensions, and its colors (if applicable). Returns `undefined` if there is no image currently in the frame or if the frameService is not initialized.
   */
  getImageData() {
    if (this.frameService)
      return this.frameService.getImageData();
  }
  /**
   * @returns The ColorOption associated with this step, which includes information about whether the color picker is enabled and any predefined colors. Returns `undefined` if there is no ColorOption associated with this step.
   */
  async getColorOption() {
    return await Pt.ensureFullOption(this.step.data.colorOption);
  }
  /**
   * @returns A list of available colors for the current image selection, if the color picker is enabled. If the color picker is not enabled, returns an empty array.
   */
  getAvailableColors() {
    return this.step.data.colorPickerEnabled ? Sf.availableColors(this.step, this.manager) : Promise.resolve([]);
  }
  /**
   * @returns True if the color picker is enabled for this step, otherwise false.
   */
  isColorPickerEnabled() {
    return this.step.data.colorPickerEnabled ?? !1;
  }
  /**
   * @returns A mapping of color identifiers to their corresponding ColorDefinition for the original image. Only applicable if the current image is an SVG with identifiable colors. Returns `undefined` if there is no image or if the image is not an SVG with identifiable colors.
   */
  async getOriginalImageColors() {
    const e = this.getImageData();
    return e?.svg ? (await Nl(e.svg)).colors : void 0;
  }
  /**
   * Merges multiple color class IDs into a single unified color. This is useful for consolidating near-identical colors in vectorized SVGs.
   * @param sourceClassIds - Array of color class IDs to merge from (e.g., ["ff0000", "fe0101", "ff0a0a"])
   * @param targetClassId - The color class ID to merge into (e.g., "ff0000")
   * @param targetColor - The color definition for the merged result
   * @throws Error if the current image is not an SVG with colors
   */
  async mergeColors(e, t, n) {
    const i = this.frameService.getImageData();
    if (!i?.svg || !i.colors)
      throw new Error("Cannot merge colors on non-SVG image or image without color information");
    const { svg: a, colors: s } = rL(
      i.svg,
      i.colors,
      e,
      t,
      n
    );
    this.frameService.setPatternData(
      {
        ...i,
        svg: a,
        colors: s
      },
      !1
    ), this.manager.updateStorage(this.step.stepName, {
      colors: s
    });
  }
  /**
   * Unmerges colors by restoring the pre-merge color state and SVG
   * @param sourceClassIds - Original class IDs that were merged
   * @param targetClassId - The class ID they were merged into
   * @param preMergeColors - The color definitions before the merge
   * @param preMergeSvg - The SVG string before the merge
   * @throws Error if the current image is not an SVG with colors
   */
  async unmergeColors(e, t, n, i) {
    const a = this.frameService.getImageData();
    if (!a?.svg || !a.colors)
      throw new Error("Cannot unmerge colors on non-SVG image or image without color information");
    this.frameService.setPatternData(
      {
        ...a,
        svg: i,
        colors: n
      },
      !1
    ), this.manager.updateStorage(this.step.stepName, {
      colors: n
    });
  }
  /**
   * @returns True when vectorizing should be available to the user.
   */
  getShouldVectorize() {
    return this.step.data.shouldVectorize ?? !1;
  }
  /**
   * @returns The maximum number of colors allowed when vectorizing an image. Only applicable if shouldVectorize is true. If not specified, a suitable default will be applied.
   */
  getVectorizeMaxColors() {
    return this.step.data.vectorizeMaxColors;
  }
  /**
   * @returns The minimum number of pixels in either dimension of the image required for optimization pathway to be suggested.
   */
  getMinimumPixelThresholdForOptimization() {
    return this.step.data.vectorizationMinimumPixelThreshold;
  }
  /**
   * @returns The maximum number of colors allowed in the image selection.
   */
  getMaxAllowedColors() {
    return this.step.data.maxColors;
  }
  /**
   * @returns The number of unique colors present in the image. Only applicable to SVG files.
   */
  getUniqueColorCount() {
    return Sf.getUniqueColorCount(this.step, this.manager);
  }
  getCurrentFrameStep(e, t, n, i) {
    return i && i.length > 1 && e === void 0 ? "SelectFrame" : t || n || this.getImageData() ? "Position" : "SelectImage";
  }
  getFrameService() {
    return this.frameService;
  }
  hasOverlayImageKey() {
    return this.step.data.overlayImageKey;
  }
  hasOverlayImageUrl() {
    return this.step.data.overlayImageUrl;
  }
  getWhitelistedExtensions() {
    return [
      ...this.step.data.whitelistedExtensions,
      ...this.step.data.whitelistedExtensions.includes(".jpg") ? [".jpeg"] : []
    ];
  }
  async getOriginalImageSelection() {
    const e = this.getFrameStepStorage()?.framePatternData?.originalAssetKey;
    if (e)
      return Si.getLocalOrFromServer(e);
  }
  /**
   * @returns The current image state being displayed (original, backgroundRemoved, or optimized).
   */
  getCurrentImageState() {
    const e = this.getFrameStepStorage()?.framePatternData;
    return e ? e.vectorizedAssetKey && !e.useOriginalAsset ? "optimized" : e.useOriginalAsset !== !1 ? "original" : "backgroundRemoved" : "original";
  }
  /**
   * Sets the current image state to display one of: original, backgroundRemoved, or optimized.
   * This will switch between the available image versions without creating new ones.
   * @param state The image state to switch to.
   * @throws Error if the requested state is not available (e.g., trying to switch to backgroundRemoved when no background-removed version exists).
   */
  async setImageState(e) {
    const t = this.getFrameStepStorage()?.framePatternData || {};
    let n, i;
    switch (e) {
      case "original":
        if (n = await this.getOriginalImageSelection(), !n)
          throw new Error("No original image available");
        i = !0;
        break;
      case "backgroundRemoved":
        if (n = await this.getBackgroundRemovedImageSelection(), !n)
          throw new Error(
            "No background-removed image available. Call removeBackgroundFromImageSelection first."
          );
        i = !1;
        break;
      case "optimized":
        if (n = await this.getVectorizedImageSelection(), !n)
          throw new Error("No optimized image available. Call vectorize first.");
        i = !1;
        break;
    }
    await this.selectImage(n, !1, !0), this.manager.updateStorage(this.step.stepName, {
      framePatternData: { ...t, useOriginalAsset: i }
    });
  }
  /**
   * @deprecated Use getCurrentImageState() instead. Returns true if displaying original image, false otherwise.
   */
  getUseOriginalImageSelection() {
    return this.getFrameStepStorage()?.framePatternData?.useOriginalAsset ?? !1;
  }
  /**
   * @deprecated Use setImageState() instead. Sets whether to use original (true) or background-removed (false) image.
   */
  async setUseOriginalImageSelection(e) {
    const t = this.getFrameStepStorage()?.framePatternData || {};
    if (t.useOriginalAsset === e)
      return;
    const n = await this.getOriginalImageSelection();
    if (!n)
      throw new Error("You must provide an image selection before calling setUseOriginalImageSelection");
    if (e)
      await this.selectImage(n, !1, !1);
    else {
      const i = await this.getBackgroundRemovedImageSelection();
      if (!i)
        throw new Error(
          "You must call removeBackgroundFromImageSelection before attempting to apply the image."
        );
      await this.selectImage(i, !1, !1);
    }
    this.manager.updateStorage(this.step.stepName, {
      framePatternData: { ...t, useOriginalAsset: e }
    });
  }
  getFrameStepStorage() {
    return this.manager.getStepStorage(this.step.stepName);
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
const ere = Oe`
    query GetLoggedInCustomer($email: String!) {
        customer(emailAddress: $email) {
            id
            defaultTemplateBundleId
        }
    }
`, Bb = Oe`
    query GetCustomerTransactions(
        $id: String!
        $limit: Int!
        $offset: Int!
        $startDate: String
        $endDate: String
        $filters: TransactionFiltersInput
        $quicksearch: String
    ) {
        customerTransactionsFeed(
            id: $id
            limit: $limit
            offset: $offset
            startDate: $startDate
            endDate: $endDate
            filters: $filters
            quicksearch: $quicksearch
        ) {
            items {
                id
                createdAt
                designName
                integrationType
                status
                workflowState
                workflowViewerLink
                workflowViewerReadOnlyLink
                product {
                    minimumOrderQuantity
                    id
                    name
                }
            }
            total
        }
    }
`, tre = Oe`
    mutation SetTransactionDesignName($id: String!, $name: String!) {
        transactionUpdate(id: $id, designName: $name) {
            id
            designName
        }
    }
`, rre = Oe`
    mutation DuplicateTransaction($id: String!, $template: Boolean!) {
        transactionDuplicate(id: $id, template: $template) {
            id
            workflowViewerLink
        }
    }
`, nre = Oe`
    query GetCustomerBundles($id: String!, $limit: Int!, $offset: Int!) {
        customerBundlesFeed(id: $id, limit: $limit, offset: $offset) {
            items {
                id
                workflowViewerLink
                createdAt
                dispatchDate
                purchaseOrder
                name
                ordered
            }
            total
        }
    }
`, ire = Oe`
    query GetTransactionsForBundle($id: String!) {
        bundles(ids: [$id]) {
            id
            transactions {
                id
                createdAt
                designName
                integrationType
                status
                workflowState
                workflowViewerLink
                workflowViewerReadOnlyLink
                parentTransaction {
                    id
                }
                product {
                    minimumOrderQuantity
                    id
                    name
                }
            }
        }
    }
`, are = Oe`
    mutation SetBundleName($id: String!, $name: String!) {
        bundleUpdate(id: $id, name: $name) {
            id
            name
        }
    }
`, sre = Oe`
    mutation DuplicateBundle($id: String!, $template: Boolean!, $test: Boolean) {
        bundleDuplicate(id: $id, template: $template, test: $test) {
            id
            test
            workflowViewerLink
        }
    }
`, ore = Oe`
    query GetBundleTemplates($id: String!, $limit: Int!, $offset: Int!) {
        customerBundlesFeed(id: $id, limit: $limit, offset: $offset, template: true) {
            items {
                id
                workflowViewerLink
                createdAt
                name
                ordered
            }
            total
        }
    }
`, Sne = async (r, e, t) => await et.getShadowGraphqlClient().mutate({
  mutation: are,
  errorPolicy: "all",
  variables: {
    id: r,
    name: e
  },
  context: t
}), Ene = async (r, e) => await et.getShadowGraphqlClient().mutate({
  mutation: tre,
  errorPolicy: "all",
  variables: {
    id: r,
    name: e
  }
}), kne = async (r, e, t) => await et.getShadowGraphqlClient().mutate({
  mutation: sre,
  errorPolicy: "all",
  variables: {
    id: r,
    template: e,
    test: t
  }
}), Tne = async (r, e) => await et.getShadowGraphqlClient().mutate({
  mutation: rre,
  errorPolicy: "all",
  variables: {
    id: r,
    template: e
  }
}), Fne = async (r) => (await et.getShadowGraphqlClient().query({
  query: ere,
  errorPolicy: "all",
  variables: {
    email: r
  }
})).data.customer, Ine = async (r, e, t) => await et.getShadowGraphqlClient().query({
  query: nre,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    id: r,
    offset: t,
    limit: e
  }
}), Pne = async (r, e) => await et.getShadowGraphqlClient().query({
  query: ire,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    id: r
  },
  context: e
}), Dne = async (r, e, t) => (await et.getShadowGraphqlClient().query({
  query: Bb,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    id: r,
    quicksearch: "",
    filters: {
      link: "and",
      status: {
        operator: "isAnyOf",
        values: ["Created", "DesignCompleted", "ExternallyOrdered"]
      },
      template: {
        value: "false"
      }
    },
    offset: t,
    limit: e
  }
}))?.data.customerTransactionsFeed?.items || [], Rne = async (r, e, t) => (await et.getShadowGraphqlClient().query({
  query: Bb,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    id: r,
    quicksearch: "",
    filters: {
      link: "and",
      status: {
        operator: "equals",
        value: "Ordered"
      },
      template: {
        value: "false"
      }
    },
    offset: t,
    limit: e
  }
}))?.data.customerTransactionsFeed?.items || [], One = async (r, e, t) => (await et.getShadowGraphqlClient().query({
  query: Bb,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    id: r,
    quicksearch: "",
    filters: {
      link: "and",
      template: {
        value: "true"
      }
    },
    offset: t,
    limit: e
  }
}))?.data.customerTransactionsFeed?.items || [], Bne = async (r, e, t) => (await et.getShadowGraphqlClient().query({
  query: ore,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    id: r,
    offset: t,
    limit: e
  }
}))?.data.customerBundlesFeed?.items || [], pO = Oe`
    fragment AddressValidationResultFields on AddressValidationResult {
        addressComplete
        address {
            formattedAddress
            regionCode
            postalCode
            administrativeArea
            locality
            sublocality
        }
        components {
            name
            type
            confirmationLevel
            inferred
            spellCorrected
            replaced
            unexpected
        }
        missingComponentTypes
    }
`, _b = Oe`
    ${pO}
    fragment AddressValidationJobFields on AddressValidationJob {
        id
        entityId
        status
        createdAt
        updatedAt
        result {
            ...AddressValidationResultFields
        }
    }
`, lre = Oe`
    ${_b}
    query GetAddressValidationJobs($ids: [String!]!) {
        addressValidationJobs(ids: $ids) {
            ...AddressValidationJobFields
        }
    }
`, ure = Oe`
    ${_b}
    query GetRecipientsWithAddressValidationJobs($ids: [String!]!) {
        recipients(ids: $ids) {
            id
            addressValidationJob {
                ...AddressValidationJobFields
            }
        }
    }
`, cre = Oe`
    ${pO}
    mutation ValidateRecipientAddress($id: String!) {
        recipientValidate(id: $id) {
            ...AddressValidationResultFields
        }
    }
`, fre = Oe`
    ${_b}
    mutation BatchValidateRecipientAddress($ids: [String!]!) {
        recipientValidateBatch(ids: $ids) {
            ...AddressValidationJobFields
        }
    }
`, dre = Oe`
    mutation OverrideRecipientAddress($id: String!) {
        recipientOverrideAddress(id: $id) {
            id
        }
    }
`, hre = Oe`
    mutation SkipRecipientAddress($id: String!) {
        recipientSkipAddress(id: $id) {
            id
        }
    }
`;
var pre = /* @__PURE__ */ ((r) => (r.Confirmed = "Confirmed", r.Plausible = "Plausible", r.Unlikely = "Unlikely", r))(pre || {}), gre = /* @__PURE__ */ ((r) => (r.Created = "Created", r.Processing = "Processing", r.Completed = "Completed", r.Failed = "Failed", r.Cancelled = "Cancelled", r))(gre || {});
const _ne = async (r) => {
  const e = r.map((n) => n.getTransaction().recipient?.id).filter((n) => !!n), t = await et.getShadowGraphqlClient().query({
    query: ure,
    errorPolicy: "all",
    fetchPolicy: "network-only",
    variables: {
      ids: e
    }
  });
  return r.map((n) => {
    const i = n.getTransaction().recipient?.id;
    if (i)
      return t.data?.recipients?.find((a) => a.id === i)?.addressValidationJob;
  });
}, Mne = async (r) => (await et.getShadowGraphqlClient().query({
  query: lre,
  errorPolicy: "all",
  fetchPolicy: "network-only",
  variables: {
    ids: r
  }
})).data?.addressValidationJobs, Nne = async (r) => r.getTransaction().recipient?.id ? (await et.getShadowGraphqlClient().mutate({
  mutation: cre,
  errorPolicy: "all",
  fetchPolicy: "network-only",
  variables: {
    id: r.getTransaction().recipient.id
  }
})).data?.recipientValidate : void 0, Lne = async (r) => {
  const e = r.map((n) => n.getTransaction().recipient?.id).filter((n) => !!n), t = await et.getShadowGraphqlClient().mutate({
    mutation: fre,
    errorPolicy: "all",
    fetchPolicy: "network-only",
    variables: {
      ids: e
    }
  });
  return r.map((n) => {
    const i = n.getTransaction().recipient?.id;
    if (i)
      return t.data?.recipientValidateBatch?.find((a) => a.entityId === i);
  });
}, Une = async (r) => {
  const e = r.getTransaction().recipient?.id;
  if (!e)
    return;
  (await et.getShadowGraphqlClient().mutate({
    mutation: dre,
    errorPolicy: "all",
    fetchPolicy: "network-only",
    variables: {
      id: e
    }
  })).data?.recipientOverrideAddress?.id && (r.getTransaction().addressValidationStatus = Tw.Overridden);
}, Vne = async (r) => {
  const e = r.getTransaction().recipient?.id;
  if (!e)
    return;
  (await et.getShadowGraphqlClient().mutate({
    mutation: hre,
    errorPolicy: "all",
    fetchPolicy: "network-only",
    variables: {
      id: e
    }
  })).data?.recipientSkipAddress?.id && (r.getTransaction().addressValidationStatus = Tw.Skipped);
}, mre = Oe`
    query GetIntegrationProductsForIds($ids: [String!]!) {
        integrationProducts(ids: $ids) {
            id
            product {
                id
                name
            }
        }
    }
`, $ne = async (r) => (await et.getShadowGraphqlClient().query({
  query: mre,
  variables: {
    ids: r
  }
})).data.integrationProducts;
function zne(r) {
  return Object.entries(r).map(([e, t]) => {
    const n = t.selectedVariants?.map((s) => ({
      id: s.id,
      priceModifier: s.priceModifier
    }));
    let i;
    const a = Object.keys(t).length;
    if (n !== void 0 && a > 1 || n === void 0 && a > 0) {
      i = {};
      const s = t;
      i = {
        ...i,
        color: s.color,
        customColor: s.customColor,
        defaultCleared: s.defaultCleared,
        inputText: s.inputText,
        text: s.text,
        customiseAllText: s.customiseAllText
      };
      const o = t;
      i = {
        ...i,
        framePatternSrc: o.framePatternAsset ? W1(o.framePatternAsset) : void 0,
        currentFrameSources: o.currentFrameSources,
        framePatternData: o.framePatternData
      }, i = {
        ...i,
        transactionIds: t.transactionIds
      };
    }
    return {
      stepName: e,
      selectedVariants: n,
      storage: i
    };
  });
}
export {
  Cne as $,
  Fw as A,
  ane as B,
  Pi as C,
  Lf as D,
  ZG as E,
  Wj as F,
  ok as G,
  KG as H,
  lk as I,
  Xte as J,
  Jte as K,
  Zte as L,
  gx as M,
  Ii as N,
  mj as O,
  Kte as P,
  J0 as Q,
  Cj as R,
  dT as S,
  cN as T,
  Kre as U,
  Mr as V,
  La as W,
  Hp as X,
  vj as Y,
  Cu as Z,
  vre as _,
  wx as a,
  Pre as a$,
  yj as a0,
  Ej as a1,
  Zre as a2,
  fR as a3,
  xq as a4,
  nR as a5,
  c0 as a6,
  Ed as a7,
  Aj as a8,
  fN as a9,
  dN as aA,
  rne as aB,
  Dl as aC,
  Y1 as aD,
  tR as aE,
  Qj as aF,
  Ore as aG,
  Rre as aH,
  Dre as aI,
  Si as aJ,
  Y8 as aK,
  cne as aL,
  Xre as aM,
  dne as aN,
  sq as aO,
  qre as aP,
  Ere as aQ,
  xne as aR,
  dA as aS,
  Zm as aT,
  VD as aU,
  Pu as aV,
  kne as aW,
  Tne as aX,
  xo as aY,
  Vre as aZ,
  zi as a_,
  oR as aa,
  iq as ab,
  kj as ac,
  Ff as ad,
  p0 as ae,
  Yw as af,
  wj as ag,
  Qw as ah,
  tne as ai,
  th as aj,
  ene as ak,
  Ma as al,
  sne as am,
  xj as an,
  uN as ao,
  gne as ap,
  mI as aq,
  oN as ar,
  Fs as as,
  gt as at,
  eh as au,
  rH as av,
  jj as aw,
  hne as ax,
  bj as ay,
  si as az,
  qd as b,
  Fre as b$,
  wp as b0,
  Sf as b1,
  nn as b2,
  xW as b3,
  Nl as b4,
  lne as b5,
  qte as b6,
  wne as b7,
  Mne as b8,
  Bre as b9,
  $w as bA,
  zre as bB,
  Dne as bC,
  _ne as bD,
  cO as bE,
  uO as bF,
  et as bG,
  Km as bH,
  $re as bI,
  oh as bJ,
  Ire as bK,
  $D as bL,
  rL as bM,
  J1 as bN,
  Yre as bO,
  zD as bP,
  Vw as bQ,
  GD as bR,
  Sne as bS,
  Ene as bT,
  kW as bU,
  Pt as bV,
  Jre as bW,
  Une as bX,
  gc as bY,
  hn as bZ,
  HD as b_,
  G0 as ba,
  Ure as bb,
  Yte as bc,
  bne as bd,
  yne as be,
  Fne as bf,
  Ine as bg,
  Qre as bh,
  Q0 as bi,
  une as bj,
  jte as bk,
  $ne as bl,
  FW as bm,
  Wre as bn,
  Hre as bo,
  Rne as bp,
  vne as bq,
  Gre as br,
  fne as bs,
  jre as bt,
  ux as bu,
  Bne as bv,
  One as bw,
  mne as bx,
  Ane as by,
  Pne as bz,
  gre as c,
  WD as c0,
  Sre as c1,
  Cre as c2,
  ak as c3,
  W8 as c4,
  qg as c5,
  Mw as c6,
  VN as c7,
  zN as c8,
  kI as c9,
  xp as ca,
  EH as cb,
  Vne as cc,
  Cc as cd,
  one as ce,
  zne as cf,
  XS as cg,
  DD as ch,
  Iw as ci,
  ca as cj,
  UH as ck,
  Nne as cl,
  Lne as cm,
  $f as cn,
  pre as d,
  Tw as e,
  CQ as f,
  pne as g,
  Ji as h,
  _f as i,
  u0 as j,
  ine as k,
  nne as l,
  lN as m,
  ap as n,
  oT as o,
  qG as p,
  zm as q,
  pa as r,
  OD as s,
  Rf as t,
  Gte as u,
  zte as v,
  Sj as w,
  km as x,
  wq as y,
  Aq as z
};
//# sourceMappingURL=index-B_rQ6hFr.js.map
